// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"eTHmp":[function(require,module,exports,__globalThis) {
require("bfd4468d0f1d21fd").register(require("410d4fcdc5344565").getBundleURL('2c9kW'), JSON.parse("[\"2c9kW\",\"scripts.5c699123.js\",\"l8sW4\",\"../fonts/pbf/Flama Book/0-255.pbf\",\"1MVwB\",\"../fonts/pbf/Flama Book/1024-1279.pbf\",\"2w0AR\",\"../fonts/pbf/Flama Book/10240-10495.pbf\",\"hxxWM\",\"../fonts/pbf/Flama Book/10496-10751.pbf\",\"evxUw\",\"../fonts/pbf/Flama Book/10752-11007.pbf\",\"4zFjK\",\"../fonts/pbf/Flama Book/11008-11263.pbf\",\"i9ZfN\",\"../fonts/pbf/Flama Book/11264-11519.pbf\",\"hEJci\",\"../fonts/pbf/Flama Book/11520-11775.pbf\",\"hAhC9\",\"../fonts/pbf/Flama Book/11776-12031.pbf\",\"jXhE4\",\"../fonts/pbf/Flama Book/12032-12287.pbf\",\"5OZUG\",\"../fonts/pbf/Flama Book/12288-12543.pbf\",\"fpySm\",\"../fonts/pbf/Flama Book/12544-12799.pbf\",\"05j6q\",\"../fonts/pbf/Flama Book/1280-1535.pbf\",\"bNYoL\",\"../fonts/pbf/Flama Book/12800-13055.pbf\",\"80IRi\",\"../fonts/pbf/Flama Book/13056-13311.pbf\",\"cYzFb\",\"../fonts/pbf/Flama Book/13312-13567.pbf\",\"76qLJ\",\"../fonts/pbf/Flama Book/13568-13823.pbf\",\"jtal6\",\"../fonts/pbf/Flama Book/13824-14079.pbf\",\"enwGA\",\"../fonts/pbf/Flama Book/14080-14335.pbf\",\"j6aNC\",\"../fonts/pbf/Flama Book/14336-14591.pbf\",\"460sY\",\"../fonts/pbf/Flama Book/14592-14847.pbf\",\"84hUL\",\"../fonts/pbf/Flama Book/14848-15103.pbf\",\"72WG7\",\"../fonts/pbf/Flama Book/15104-15359.pbf\",\"cjks0\",\"../fonts/pbf/Flama Book/1536-1791.pbf\",\"4gNxd\",\"../fonts/pbf/Flama Book/15360-15615.pbf\",\"18Zv2\",\"../fonts/pbf/Flama Book/15616-15871.pbf\",\"67bUX\",\"../fonts/pbf/Flama Book/15872-16127.pbf\",\"1zii4\",\"../fonts/pbf/Flama Book/16128-16383.pbf\",\"5XcL2\",\"../fonts/pbf/Flama Book/16384-16639.pbf\",\"39qbs\",\"../fonts/pbf/Flama Book/16640-16895.pbf\",\"aPrFA\",\"../fonts/pbf/Flama Book/16896-17151.pbf\",\"1hpn2\",\"../fonts/pbf/Flama Book/17152-17407.pbf\",\"48PXD\",\"../fonts/pbf/Flama Book/17408-17663.pbf\",\"7kAn8\",\"../fonts/pbf/Flama Book/17664-17919.pbf\",\"1WpfT\",\"../fonts/pbf/Flama Book/1792-2047.pbf\",\"71b89\",\"../fonts/pbf/Flama Book/17920-18175.pbf\",\"6MFMZ\",\"../fonts/pbf/Flama Book/18176-18431.pbf\",\"k0G7e\",\"../fonts/pbf/Flama Book/18432-18687.pbf\",\"2IdX1\",\"../fonts/pbf/Flama Book/18688-18943.pbf\",\"iu13R\",\"../fonts/pbf/Flama Book/18944-19199.pbf\",\"cvORa\",\"../fonts/pbf/Flama Book/19200-19455.pbf\",\"453Ck\",\"../fonts/pbf/Flama Book/19456-19711.pbf\",\"cp3I0\",\"../fonts/pbf/Flama Book/19712-19967.pbf\",\"5KtjG\",\"../fonts/pbf/Flama Book/19968-20223.pbf\",\"7Ekzd\",\"../fonts/pbf/Flama Book/20224-20479.pbf\",\"bzntl\",\"../fonts/pbf/Flama Book/2048-2303.pbf\",\"drHdu\",\"../fonts/pbf/Flama Book/20480-20735.pbf\",\"4qrDp\",\"../fonts/pbf/Flama Book/20736-20991.pbf\",\"1PsYA\",\"../fonts/pbf/Flama Book/20992-21247.pbf\",\"8MU3x\",\"../fonts/pbf/Flama Book/21248-21503.pbf\",\"1ECaE\",\"../fonts/pbf/Flama Book/21504-21759.pbf\",\"akYow\",\"../fonts/pbf/Flama Book/21760-22015.pbf\",\"7dWLg\",\"../fonts/pbf/Flama Book/22016-22271.pbf\",\"jjEVd\",\"../fonts/pbf/Flama Book/22272-22527.pbf\",\"8GkEV\",\"../fonts/pbf/Flama Book/22528-22783.pbf\",\"54aGR\",\"../fonts/pbf/Flama Book/22784-23039.pbf\",\"5tuPe\",\"../fonts/pbf/Flama Book/2304-2559.pbf\",\"9pxjw\",\"../fonts/pbf/Flama Book/23040-23295.pbf\",\"4VJw8\",\"../fonts/pbf/Flama Book/23296-23551.pbf\",\"gEdav\",\"../fonts/pbf/Flama Book/23552-23807.pbf\",\"ac9lK\",\"../fonts/pbf/Flama Book/23808-24063.pbf\",\"2f6ZT\",\"../fonts/pbf/Flama Book/24064-24319.pbf\",\"kqRsi\",\"../fonts/pbf/Flama Book/24320-24575.pbf\",\"dX5lx\",\"../fonts/pbf/Flama Book/24576-24831.pbf\",\"1Se9w\",\"../fonts/pbf/Flama Book/24832-25087.pbf\",\"lLYS9\",\"../fonts/pbf/Flama Book/25088-25343.pbf\",\"84CcJ\",\"../fonts/pbf/Flama Book/25344-25599.pbf\",\"2KXce\",\"../fonts/pbf/Flama Book/256-511.pbf\",\"kTfkM\",\"../fonts/pbf/Flama Book/2560-2815.pbf\",\"gBaRg\",\"../fonts/pbf/Flama Book/25600-25855.pbf\",\"dC68M\",\"../fonts/pbf/Flama Book/25856-26111.pbf\",\"gaKSy\",\"../fonts/pbf/Flama Book/26112-26367.pbf\",\"hYd5J\",\"../fonts/pbf/Flama Book/26368-26623.pbf\",\"3v3hn\",\"../fonts/pbf/Flama Book/26624-26879.pbf\",\"aZV3P\",\"../fonts/pbf/Flama Book/26880-27135.pbf\",\"hQt00\",\"../fonts/pbf/Flama Book/27136-27391.pbf\",\"75jMH\",\"../fonts/pbf/Flama Book/27392-27647.pbf\",\"a4lik\",\"../fonts/pbf/Flama Book/27648-27903.pbf\",\"fYfQM\",\"../fonts/pbf/Flama Book/27904-28159.pbf\",\"2MW0c\",\"../fonts/pbf/Flama Book/2816-3071.pbf\",\"1oOen\",\"../fonts/pbf/Flama Book/28160-28415.pbf\",\"e3s0o\",\"../fonts/pbf/Flama Book/28416-28671.pbf\",\"ZKtnl\",\"../fonts/pbf/Flama Book/28672-28927.pbf\",\"lgWED\",\"../fonts/pbf/Flama Book/28928-29183.pbf\",\"4pGEo\",\"../fonts/pbf/Flama Book/29184-29439.pbf\",\"uCWeV\",\"../fonts/pbf/Flama Book/29440-29695.pbf\",\"9zu8o\",\"../fonts/pbf/Flama Book/29696-29951.pbf\",\"bOms4\",\"../fonts/pbf/Flama Book/29952-30207.pbf\",\"cwZHy\",\"../fonts/pbf/Flama Book/30208-30463.pbf\",\"ajf5H\",\"../fonts/pbf/Flama Book/30464-30719.pbf\",\"go5P5\",\"../fonts/pbf/Flama Book/3072-3327.pbf\",\"hWYlA\",\"../fonts/pbf/Flama Book/30720-30975.pbf\",\"8WMuX\",\"../fonts/pbf/Flama Book/30976-31231.pbf\",\"22Djq\",\"../fonts/pbf/Flama Book/31232-31487.pbf\",\"QhGfo\",\"../fonts/pbf/Flama Book/31488-31743.pbf\",\"gwoEN\",\"../fonts/pbf/Flama Book/31744-31999.pbf\",\"g66FA\",\"../fonts/pbf/Flama Book/32000-32255.pbf\",\"8dWcr\",\"../fonts/pbf/Flama Book/32256-32511.pbf\",\"9c6xR\",\"../fonts/pbf/Flama Book/32512-32767.pbf\",\"74j7p\",\"../fonts/pbf/Flama Book/32768-33023.pbf\",\"dpQcT\",\"../fonts/pbf/Flama Book/33024-33279.pbf\",\"ctb5x\",\"../fonts/pbf/Flama Book/3328-3583.pbf\",\"9gJ3e\",\"../fonts/pbf/Flama Book/33280-33535.pbf\",\"fhBo8\",\"../fonts/pbf/Flama Book/33536-33791.pbf\",\"6JlbC\",\"../fonts/pbf/Flama Book/33792-34047.pbf\",\"8ImqK\",\"../fonts/pbf/Flama Book/34048-34303.pbf\",\"1vf8A\",\"../fonts/pbf/Flama Book/34304-34559.pbf\",\"gGzmk\",\"../fonts/pbf/Flama Book/34560-34815.pbf\",\"j4oxW\",\"../fonts/pbf/Flama Book/34816-35071.pbf\",\"2TXuD\",\"../fonts/pbf/Flama Book/35072-35327.pbf\",\"hv6iQ\",\"../fonts/pbf/Flama Book/35328-35583.pbf\",\"8H9wb\",\"../fonts/pbf/Flama Book/35584-35839.pbf\",\"50xxP\",\"../fonts/pbf/Flama Book/3584-3839.pbf\",\"hyMZF\",\"../fonts/pbf/Flama Book/35840-36095.pbf\",\"94lq0\",\"../fonts/pbf/Flama Book/36096-36351.pbf\",\"fUil7\",\"../fonts/pbf/Flama Book/36352-36607.pbf\",\"2XbYd\",\"../fonts/pbf/Flama Book/36608-36863.pbf\",\"kP1f1\",\"../fonts/pbf/Flama Book/36864-37119.pbf\",\"e8ll5\",\"../fonts/pbf/Flama Book/37120-37375.pbf\",\"6QwXi\",\"../fonts/pbf/Flama Book/37376-37631.pbf\",\"66Cz5\",\"../fonts/pbf/Flama Book/37632-37887.pbf\",\"iqDdf\",\"../fonts/pbf/Flama Book/37888-38143.pbf\",\"1meDO\",\"../fonts/pbf/Flama Book/38144-38399.pbf\",\"aEeDk\",\"../fonts/pbf/Flama Book/3840-4095.pbf\",\"4uupC\",\"../fonts/pbf/Flama Book/38400-38655.pbf\",\"6zXJ0\",\"../fonts/pbf/Flama Book/38656-38911.pbf\",\"eCiCM\",\"../fonts/pbf/Flama Book/38912-39167.pbf\",\"lO8WQ\",\"../fonts/pbf/Flama Book/39168-39423.pbf\",\"1ihdS\",\"../fonts/pbf/Flama Book/39424-39679.pbf\",\"boIct\",\"../fonts/pbf/Flama Book/39680-39935.pbf\",\"4Wo3P\",\"../fonts/pbf/Flama Book/39936-40191.pbf\",\"bH0QO\",\"../fonts/pbf/Flama Book/40192-40447.pbf\",\"OdzfI\",\"../fonts/pbf/Flama Book/40448-40703.pbf\",\"kWqmX\",\"../fonts/pbf/Flama Book/40704-40959.pbf\",\"lqoxK\",\"../fonts/pbf/Flama Book/4096-4351.pbf\",\"8uU6e\",\"../fonts/pbf/Flama Book/40960-41215.pbf\",\"1my7e\",\"../fonts/pbf/Flama Book/41216-41471.pbf\",\"fUlK5\",\"../fonts/pbf/Flama Book/41472-41727.pbf\",\"iViSr\",\"../fonts/pbf/Flama Book/41728-41983.pbf\",\"cPYR5\",\"../fonts/pbf/Flama Book/41984-42239.pbf\",\"l9GVH\",\"../fonts/pbf/Flama Book/42240-42495.pbf\",\"dzJ3S\",\"../fonts/pbf/Flama Book/42496-42751.pbf\",\"2Mmyd\",\"../fonts/pbf/Flama Book/42752-43007.pbf\",\"gZ6Sy\",\"../fonts/pbf/Flama Book/43008-43263.pbf\",\"5y0hb\",\"../fonts/pbf/Flama Book/43264-43519.pbf\",\"jJiCX\",\"../fonts/pbf/Flama Book/4352-4607.pbf\",\"eeTqt\",\"../fonts/pbf/Flama Book/43520-43775.pbf\",\"i0CN7\",\"../fonts/pbf/Flama Book/43776-44031.pbf\",\"7houn\",\"../fonts/pbf/Flama Book/44032-44287.pbf\",\"jsNSi\",\"../fonts/pbf/Flama Book/44288-44543.pbf\",\"2nnIU\",\"../fonts/pbf/Flama Book/44544-44799.pbf\",\"eW9st\",\"../fonts/pbf/Flama Book/44800-45055.pbf\",\"3UCJu\",\"../fonts/pbf/Flama Book/45056-45311.pbf\",\"dVs9p\",\"../fonts/pbf/Flama Book/45312-45567.pbf\",\"gE3R8\",\"../fonts/pbf/Flama Book/45568-45823.pbf\",\"iyZwB\",\"../fonts/pbf/Flama Book/45824-46079.pbf\",\"aJSWJ\",\"../fonts/pbf/Flama Book/4608-4863.pbf\",\"kq0Fm\",\"../fonts/pbf/Flama Book/46080-46335.pbf\",\"3KVFQ\",\"../fonts/pbf/Flama Book/46336-46591.pbf\",\"fyCTC\",\"../fonts/pbf/Flama Book/46592-46847.pbf\",\"gmehg\",\"../fonts/pbf/Flama Book/46848-47103.pbf\",\"gjYA9\",\"../fonts/pbf/Flama Book/47104-47359.pbf\",\"g3mPF\",\"../fonts/pbf/Flama Book/47360-47615.pbf\",\"bub3w\",\"../fonts/pbf/Flama Book/47616-47871.pbf\",\"kNGMV\",\"../fonts/pbf/Flama Book/47872-48127.pbf\",\"66Mt9\",\"../fonts/pbf/Flama Book/48128-48383.pbf\",\"9uiA7\",\"../fonts/pbf/Flama Book/48384-48639.pbf\",\"1dCbN\",\"../fonts/pbf/Flama Book/4864-5119.pbf\",\"lSeGi\",\"../fonts/pbf/Flama Book/48640-48895.pbf\",\"02md5\",\"../fonts/pbf/Flama Book/48896-49151.pbf\",\"erK3x\",\"../fonts/pbf/Flama Book/49152-49407.pbf\",\"fSH7B\",\"../fonts/pbf/Flama Book/49408-49663.pbf\",\"1eS1B\",\"../fonts/pbf/Flama Book/49664-49919.pbf\",\"cHbwW\",\"../fonts/pbf/Flama Book/49920-50175.pbf\",\"65uCI\",\"../fonts/pbf/Flama Book/50176-50431.pbf\",\"ake0l\",\"../fonts/pbf/Flama Book/50432-50687.pbf\",\"bXaGI\",\"../fonts/pbf/Flama Book/50688-50943.pbf\",\"1B2S6\",\"../fonts/pbf/Flama Book/50944-51199.pbf\",\"3X3ea\",\"../fonts/pbf/Flama Book/512-767.pbf\",\"gNpii\",\"../fonts/pbf/Flama Book/5120-5375.pbf\",\"a18ZV\",\"../fonts/pbf/Flama Book/51200-51455.pbf\",\"7lGWu\",\"../fonts/pbf/Flama Book/51456-51711.pbf\",\"aAmDk\",\"../fonts/pbf/Flama Book/51712-51967.pbf\",\"2EZ0S\",\"../fonts/pbf/Flama Book/51968-52223.pbf\",\"gnWBY\",\"../fonts/pbf/Flama Book/52224-52479.pbf\",\"35I0h\",\"../fonts/pbf/Flama Book/52480-52735.pbf\",\"4ScdK\",\"../fonts/pbf/Flama Book/52736-52991.pbf\",\"cmFRf\",\"../fonts/pbf/Flama Book/52992-53247.pbf\",\"4dXTv\",\"../fonts/pbf/Flama Book/53248-53503.pbf\",\"fydLs\",\"../fonts/pbf/Flama Book/53504-53759.pbf\",\"CkPaq\",\"../fonts/pbf/Flama Book/5376-5631.pbf\",\"cGxfv\",\"../fonts/pbf/Flama Book/53760-54015.pbf\",\"aEpbP\",\"../fonts/pbf/Flama Book/54016-54271.pbf\",\"c6wtF\",\"../fonts/pbf/Flama Book/54272-54527.pbf\",\"2HJFJ\",\"../fonts/pbf/Flama Book/54528-54783.pbf\",\"1z15a\",\"../fonts/pbf/Flama Book/54784-55039.pbf\",\"hAiYL\",\"../fonts/pbf/Flama Book/55040-55295.pbf\",\"i3Z3p\",\"../fonts/pbf/Flama Book/55296-55551.pbf\",\"frjJ1\",\"../fonts/pbf/Flama Book/55552-55807.pbf\",\"3H8tw\",\"../fonts/pbf/Flama Book/55808-56063.pbf\",\"dssRQ\",\"../fonts/pbf/Flama Book/56064-56319.pbf\",\"cR4tx\",\"../fonts/pbf/Flama Book/5632-5887.pbf\",\"iZVOa\",\"../fonts/pbf/Flama Book/56320-56575.pbf\",\"7lqlj\",\"../fonts/pbf/Flama Book/56576-56831.pbf\",\"5nA5u\",\"../fonts/pbf/Flama Book/56832-57087.pbf\",\"5lqnm\",\"../fonts/pbf/Flama Book/57088-57343.pbf\",\"3Omj2\",\"../fonts/pbf/Flama Book/57344-57599.pbf\",\"cOSDM\",\"../fonts/pbf/Flama Book/57600-57855.pbf\",\"10f00\",\"../fonts/pbf/Flama Book/57856-58111.pbf\",\"93MdL\",\"../fonts/pbf/Flama Book/58112-58367.pbf\",\"efohb\",\"../fonts/pbf/Flama Book/58368-58623.pbf\",\"8Q7KZ\",\"../fonts/pbf/Flama Book/58624-58879.pbf\",\"fugnx\",\"../fonts/pbf/Flama Book/5888-6143.pbf\",\"dMSIU\",\"../fonts/pbf/Flama Book/58880-59135.pbf\",\"2stN3\",\"../fonts/pbf/Flama Book/59136-59391.pbf\",\"eTafL\",\"../fonts/pbf/Flama Book/59392-59647.pbf\",\"lMYVe\",\"../fonts/pbf/Flama Book/59648-59903.pbf\",\"61XPe\",\"../fonts/pbf/Flama Book/59904-60159.pbf\",\"7t4x7\",\"../fonts/pbf/Flama Book/60160-60415.pbf\",\"b9SAl\",\"../fonts/pbf/Flama Book/60416-60671.pbf\",\"eQbVL\",\"../fonts/pbf/Flama Book/60672-60927.pbf\",\"k8N0I\",\"../fonts/pbf/Flama Book/60928-61183.pbf\",\"jcwmQ\",\"../fonts/pbf/Flama Book/61184-61439.pbf\",\"aZHuG\",\"../fonts/pbf/Flama Book/6144-6399.pbf\",\"2LQPh\",\"../fonts/pbf/Flama Book/61440-61695.pbf\",\"lgDsA\",\"../fonts/pbf/Flama Book/61696-61951.pbf\",\"8rqh8\",\"../fonts/pbf/Flama Book/61952-62207.pbf\",\"7e11N\",\"../fonts/pbf/Flama Book/62208-62463.pbf\",\"3OUTW\",\"../fonts/pbf/Flama Book/62464-62719.pbf\",\"jx2iS\",\"../fonts/pbf/Flama Book/62720-62975.pbf\",\"4Feci\",\"../fonts/pbf/Flama Book/62976-63231.pbf\",\"kVp6E\",\"../fonts/pbf/Flama Book/63232-63487.pbf\",\"3zOGd\",\"../fonts/pbf/Flama Book/63488-63743.pbf\",\"8PgXV\",\"../fonts/pbf/Flama Book/63744-63999.pbf\",\"7NOQT\",\"../fonts/pbf/Flama Book/6400-6655.pbf\",\"hmE3E\",\"../fonts/pbf/Flama Book/64000-64255.pbf\",\"1gjdZ\",\"../fonts/pbf/Flama Book/64256-64511.pbf\",\"iNRov\",\"../fonts/pbf/Flama Book/64512-64767.pbf\",\"bhqr2\",\"../fonts/pbf/Flama Book/64768-65023.pbf\",\"2FDTX\",\"../fonts/pbf/Flama Book/65024-65279.pbf\",\"2OIZj\",\"../fonts/pbf/Flama Book/65280-65535.pbf\",\"hKbs7\",\"../fonts/pbf/Flama Book/6656-6911.pbf\",\"fPoB2\",\"../fonts/pbf/Flama Book/6912-7167.pbf\",\"7lq8F\",\"../fonts/pbf/Flama Book/7168-7423.pbf\",\"6Yttf\",\"../fonts/pbf/Flama Book/7424-7679.pbf\",\"1j3aO\",\"../fonts/pbf/Flama Book/768-1023.pbf\",\"etLOw\",\"../fonts/pbf/Flama Book/7680-7935.pbf\",\"7U1VB\",\"../fonts/pbf/Flama Book/7936-8191.pbf\",\"hDukS\",\"../fonts/pbf/Flama Book/8192-8447.pbf\",\"duerg\",\"../fonts/pbf/Flama Book/8448-8703.pbf\",\"gSsuS\",\"../fonts/pbf/Flama Book/8704-8959.pbf\",\"7eklg\",\"../fonts/pbf/Flama Book/8960-9215.pbf\",\"ekyIA\",\"../fonts/pbf/Flama Book/9216-9471.pbf\",\"dOQSq\",\"../fonts/pbf/Flama Book/9472-9727.pbf\",\"fVpx4\",\"../fonts/pbf/Flama Book/9728-9983.pbf\",\"9wPHf\",\"../fonts/pbf/Flama Book/9984-10239.pbf\",\"khwan\",\"../fonts/pbf/Flama Medium/0-255.pbf\",\"zeBo0\",\"../fonts/pbf/Flama Medium/1024-1279.pbf\",\"aVihF\",\"../fonts/pbf/Flama Medium/10240-10495.pbf\",\"fiZ11\",\"../fonts/pbf/Flama Medium/10496-10751.pbf\",\"9C0iX\",\"../fonts/pbf/Flama Medium/10752-11007.pbf\",\"aaqt3\",\"../fonts/pbf/Flama Medium/11008-11263.pbf\",\"d2ieP\",\"../fonts/pbf/Flama Medium/11264-11519.pbf\",\"Zs42G\",\"../fonts/pbf/Flama Medium/11520-11775.pbf\",\"g70IW\",\"../fonts/pbf/Flama Medium/11776-12031.pbf\",\"abot2\",\"../fonts/pbf/Flama Medium/12032-12287.pbf\",\"jOZiH\",\"../fonts/pbf/Flama Medium/12288-12543.pbf\",\"fkpJN\",\"../fonts/pbf/Flama Medium/12544-12799.pbf\",\"8f6Ry\",\"../fonts/pbf/Flama Medium/1280-1535.pbf\",\"j1OHm\",\"../fonts/pbf/Flama Medium/12800-13055.pbf\",\"gUEWH\",\"../fonts/pbf/Flama Medium/13056-13311.pbf\",\"3WTsq\",\"../fonts/pbf/Flama Medium/13312-13567.pbf\",\"ljFzt\",\"../fonts/pbf/Flama Medium/13568-13823.pbf\",\"eNSJy\",\"../fonts/pbf/Flama Medium/13824-14079.pbf\",\"aDFwE\",\"../fonts/pbf/Flama Medium/14080-14335.pbf\",\"kUmg2\",\"../fonts/pbf/Flama Medium/14336-14591.pbf\",\"eKYKk\",\"../fonts/pbf/Flama Medium/14592-14847.pbf\",\"ictJ4\",\"../fonts/pbf/Flama Medium/14848-15103.pbf\",\"k9AT4\",\"../fonts/pbf/Flama Medium/15104-15359.pbf\",\"kjX8d\",\"../fonts/pbf/Flama Medium/1536-1791.pbf\",\"dJw7q\",\"../fonts/pbf/Flama Medium/15360-15615.pbf\",\"dcULi\",\"../fonts/pbf/Flama Medium/15616-15871.pbf\",\"GxiYK\",\"../fonts/pbf/Flama Medium/15872-16127.pbf\",\"iNSZ9\",\"../fonts/pbf/Flama Medium/16128-16383.pbf\",\"iTrZo\",\"../fonts/pbf/Flama Medium/16384-16639.pbf\",\"bWu43\",\"../fonts/pbf/Flama Medium/16640-16895.pbf\",\"eGGO9\",\"../fonts/pbf/Flama Medium/16896-17151.pbf\",\"lGLP0\",\"../fonts/pbf/Flama Medium/17152-17407.pbf\",\"7P0SU\",\"../fonts/pbf/Flama Medium/17408-17663.pbf\",\"ln9ff\",\"../fonts/pbf/Flama Medium/17664-17919.pbf\",\"irn9h\",\"../fonts/pbf/Flama Medium/1792-2047.pbf\",\"3KTUk\",\"../fonts/pbf/Flama Medium/17920-18175.pbf\",\"6IjVY\",\"../fonts/pbf/Flama Medium/18176-18431.pbf\",\"5r7vU\",\"../fonts/pbf/Flama Medium/18432-18687.pbf\",\"l8aO4\",\"../fonts/pbf/Flama Medium/18688-18943.pbf\",\"3Kstx\",\"../fonts/pbf/Flama Medium/18944-19199.pbf\",\"jFhJy\",\"../fonts/pbf/Flama Medium/19200-19455.pbf\",\"3NlXq\",\"../fonts/pbf/Flama Medium/19456-19711.pbf\",\"2tGVc\",\"../fonts/pbf/Flama Medium/19712-19967.pbf\",\"cBYs1\",\"../fonts/pbf/Flama Medium/19968-20223.pbf\",\"7EuT6\",\"../fonts/pbf/Flama Medium/20224-20479.pbf\",\"6R4Q0\",\"../fonts/pbf/Flama Medium/2048-2303.pbf\",\"gAc89\",\"../fonts/pbf/Flama Medium/20480-20735.pbf\",\"fg9WO\",\"../fonts/pbf/Flama Medium/20736-20991.pbf\",\"kFB2m\",\"../fonts/pbf/Flama Medium/20992-21247.pbf\",\"fBWdY\",\"../fonts/pbf/Flama Medium/21248-21503.pbf\",\"afWQs\",\"../fonts/pbf/Flama Medium/21504-21759.pbf\",\"iEjKX\",\"../fonts/pbf/Flama Medium/21760-22015.pbf\",\"cD9wz\",\"../fonts/pbf/Flama Medium/22016-22271.pbf\",\"3cn71\",\"../fonts/pbf/Flama Medium/22272-22527.pbf\",\"iz8GZ\",\"../fonts/pbf/Flama Medium/22528-22783.pbf\",\"lAaqc\",\"../fonts/pbf/Flama Medium/22784-23039.pbf\",\"lWMYm\",\"../fonts/pbf/Flama Medium/2304-2559.pbf\",\"b7JxE\",\"../fonts/pbf/Flama Medium/23040-23295.pbf\",\"dB3XM\",\"../fonts/pbf/Flama Medium/23296-23551.pbf\",\"ejTwO\",\"../fonts/pbf/Flama Medium/23552-23807.pbf\",\"fjCZf\",\"../fonts/pbf/Flama Medium/23808-24063.pbf\",\"kWnk1\",\"../fonts/pbf/Flama Medium/24064-24319.pbf\",\"gqExR\",\"../fonts/pbf/Flama Medium/24320-24575.pbf\",\"cpeSc\",\"../fonts/pbf/Flama Medium/24576-24831.pbf\",\"6QxXs\",\"../fonts/pbf/Flama Medium/24832-25087.pbf\",\"aVMB1\",\"../fonts/pbf/Flama Medium/25088-25343.pbf\",\"89Kb4\",\"../fonts/pbf/Flama Medium/25344-25599.pbf\",\"2KLz8\",\"../fonts/pbf/Flama Medium/256-511.pbf\",\"1bVc9\",\"../fonts/pbf/Flama Medium/2560-2815.pbf\",\"1WegY\",\"../fonts/pbf/Flama Medium/25600-25855.pbf\",\"5Tcoc\",\"../fonts/pbf/Flama Medium/25856-26111.pbf\",\"kMIcH\",\"../fonts/pbf/Flama Medium/26112-26367.pbf\",\"6rPkz\",\"../fonts/pbf/Flama Medium/26368-26623.pbf\",\"ho7EQ\",\"../fonts/pbf/Flama Medium/26624-26879.pbf\",\"ky3TE\",\"../fonts/pbf/Flama Medium/26880-27135.pbf\",\"22JtY\",\"../fonts/pbf/Flama Medium/27136-27391.pbf\",\"aZujV\",\"../fonts/pbf/Flama Medium/27392-27647.pbf\",\"iE4RC\",\"../fonts/pbf/Flama Medium/27648-27903.pbf\",\"6jH4U\",\"../fonts/pbf/Flama Medium/27904-28159.pbf\",\"ceOJJ\",\"../fonts/pbf/Flama Medium/2816-3071.pbf\",\"dBpOf\",\"../fonts/pbf/Flama Medium/28160-28415.pbf\",\"kFROS\",\"../fonts/pbf/Flama Medium/28416-28671.pbf\",\"7cLqq\",\"../fonts/pbf/Flama Medium/28672-28927.pbf\",\"8DZcW\",\"../fonts/pbf/Flama Medium/28928-29183.pbf\",\"kgAwI\",\"../fonts/pbf/Flama Medium/29184-29439.pbf\",\"1DD4m\",\"../fonts/pbf/Flama Medium/29440-29695.pbf\",\"7def2\",\"../fonts/pbf/Flama Medium/29696-29951.pbf\",\"9Ratq\",\"../fonts/pbf/Flama Medium/29952-30207.pbf\",\"czvfA\",\"../fonts/pbf/Flama Medium/30208-30463.pbf\",\"kjvaW\",\"../fonts/pbf/Flama Medium/30464-30719.pbf\",\"dHpFO\",\"../fonts/pbf/Flama Medium/3072-3327.pbf\",\"8e8s2\",\"../fonts/pbf/Flama Medium/30720-30975.pbf\",\"7TmVL\",\"../fonts/pbf/Flama Medium/30976-31231.pbf\",\"f8Zzu\",\"../fonts/pbf/Flama Medium/31232-31487.pbf\",\"fC0WI\",\"../fonts/pbf/Flama Medium/31488-31743.pbf\",\"cU8dc\",\"../fonts/pbf/Flama Medium/31744-31999.pbf\",\"28pq0\",\"../fonts/pbf/Flama Medium/32000-32255.pbf\",\"lNZUC\",\"../fonts/pbf/Flama Medium/32256-32511.pbf\",\"1htz1\",\"../fonts/pbf/Flama Medium/32512-32767.pbf\",\"jfHyX\",\"../fonts/pbf/Flama Medium/32768-33023.pbf\",\"gdyO2\",\"../fonts/pbf/Flama Medium/33024-33279.pbf\",\"fu5gi\",\"../fonts/pbf/Flama Medium/3328-3583.pbf\",\"1pJtS\",\"../fonts/pbf/Flama Medium/33280-33535.pbf\",\"lQ6ID\",\"../fonts/pbf/Flama Medium/33536-33791.pbf\",\"9XvV8\",\"../fonts/pbf/Flama Medium/33792-34047.pbf\",\"iK87p\",\"../fonts/pbf/Flama Medium/34048-34303.pbf\",\"lFzB4\",\"../fonts/pbf/Flama Medium/34304-34559.pbf\",\"emTya\",\"../fonts/pbf/Flama Medium/34560-34815.pbf\",\"2SSzg\",\"../fonts/pbf/Flama Medium/34816-35071.pbf\",\"h5Hhh\",\"../fonts/pbf/Flama Medium/35072-35327.pbf\",\"3VsH1\",\"../fonts/pbf/Flama Medium/35328-35583.pbf\",\"dO4yL\",\"../fonts/pbf/Flama Medium/35584-35839.pbf\",\"3lvIg\",\"../fonts/pbf/Flama Medium/3584-3839.pbf\",\"7BOpV\",\"../fonts/pbf/Flama Medium/35840-36095.pbf\",\"2JthK\",\"../fonts/pbf/Flama Medium/36096-36351.pbf\",\"84qGD\",\"../fonts/pbf/Flama Medium/36352-36607.pbf\",\"gpzxF\",\"../fonts/pbf/Flama Medium/36608-36863.pbf\",\"7HzS4\",\"../fonts/pbf/Flama Medium/36864-37119.pbf\",\"iB1zQ\",\"../fonts/pbf/Flama Medium/37120-37375.pbf\",\"esyQQ\",\"../fonts/pbf/Flama Medium/37376-37631.pbf\",\"lBzYD\",\"../fonts/pbf/Flama Medium/37632-37887.pbf\",\"gmUxu\",\"../fonts/pbf/Flama Medium/37888-38143.pbf\",\"5817O\",\"../fonts/pbf/Flama Medium/38144-38399.pbf\",\"cCZUV\",\"../fonts/pbf/Flama Medium/3840-4095.pbf\",\"bO3kS\",\"../fonts/pbf/Flama Medium/38400-38655.pbf\",\"7vJDr\",\"../fonts/pbf/Flama Medium/38656-38911.pbf\",\"izJfQ\",\"../fonts/pbf/Flama Medium/38912-39167.pbf\",\"1rFhg\",\"../fonts/pbf/Flama Medium/39168-39423.pbf\",\"dqJec\",\"../fonts/pbf/Flama Medium/39424-39679.pbf\",\"aTcQ1\",\"../fonts/pbf/Flama Medium/39680-39935.pbf\",\"kIMiw\",\"../fonts/pbf/Flama Medium/39936-40191.pbf\",\"eldHD\",\"../fonts/pbf/Flama Medium/40192-40447.pbf\",\"bllNW\",\"../fonts/pbf/Flama Medium/40448-40703.pbf\",\"e2Ri8\",\"../fonts/pbf/Flama Medium/40704-40959.pbf\",\"h0OVu\",\"../fonts/pbf/Flama Medium/4096-4351.pbf\",\"7xC1r\",\"../fonts/pbf/Flama Medium/40960-41215.pbf\",\"kUElY\",\"../fonts/pbf/Flama Medium/41216-41471.pbf\",\"7lebg\",\"../fonts/pbf/Flama Medium/41472-41727.pbf\",\"ajX4q\",\"../fonts/pbf/Flama Medium/41728-41983.pbf\",\"68Mt6\",\"../fonts/pbf/Flama Medium/41984-42239.pbf\",\"2mEAZ\",\"../fonts/pbf/Flama Medium/42240-42495.pbf\",\"15phW\",\"../fonts/pbf/Flama Medium/42496-42751.pbf\",\"1oBx3\",\"../fonts/pbf/Flama Medium/42752-43007.pbf\",\"9dVZb\",\"../fonts/pbf/Flama Medium/43008-43263.pbf\",\"fiMaV\",\"../fonts/pbf/Flama Medium/43264-43519.pbf\",\"eJUru\",\"../fonts/pbf/Flama Medium/4352-4607.pbf\",\"4A3eR\",\"../fonts/pbf/Flama Medium/43520-43775.pbf\",\"8PvFV\",\"../fonts/pbf/Flama Medium/43776-44031.pbf\",\"lKVJ7\",\"../fonts/pbf/Flama Medium/44032-44287.pbf\",\"ewLRH\",\"../fonts/pbf/Flama Medium/44288-44543.pbf\",\"bp2Ri\",\"../fonts/pbf/Flama Medium/44544-44799.pbf\",\"jv1ik\",\"../fonts/pbf/Flama Medium/44800-45055.pbf\",\"3PM52\",\"../fonts/pbf/Flama Medium/45056-45311.pbf\",\"Kjc2i\",\"../fonts/pbf/Flama Medium/45312-45567.pbf\",\"hcOSL\",\"../fonts/pbf/Flama Medium/45568-45823.pbf\",\"lJV1h\",\"../fonts/pbf/Flama Medium/45824-46079.pbf\",\"hV8ko\",\"../fonts/pbf/Flama Medium/4608-4863.pbf\",\"bpNh4\",\"../fonts/pbf/Flama Medium/46080-46335.pbf\",\"42Su8\",\"../fonts/pbf/Flama Medium/46336-46591.pbf\",\"1HrwG\",\"../fonts/pbf/Flama Medium/46592-46847.pbf\",\"jCQ3g\",\"../fonts/pbf/Flama Medium/46848-47103.pbf\",\"jfdXy\",\"../fonts/pbf/Flama Medium/47104-47359.pbf\",\"hzRcT\",\"../fonts/pbf/Flama Medium/47360-47615.pbf\",\"l3C2M\",\"../fonts/pbf/Flama Medium/47616-47871.pbf\",\"kKhRu\",\"../fonts/pbf/Flama Medium/47872-48127.pbf\",\"cLLXt\",\"../fonts/pbf/Flama Medium/48128-48383.pbf\",\"hUYy0\",\"../fonts/pbf/Flama Medium/48384-48639.pbf\",\"jw9fC\",\"../fonts/pbf/Flama Medium/4864-5119.pbf\",\"1M2Of\",\"../fonts/pbf/Flama Medium/48640-48895.pbf\",\"j4mDW\",\"../fonts/pbf/Flama Medium/48896-49151.pbf\",\"h7msl\",\"../fonts/pbf/Flama Medium/49152-49407.pbf\",\"eqx7r\",\"../fonts/pbf/Flama Medium/49408-49663.pbf\",\"ftPdR\",\"../fonts/pbf/Flama Medium/49664-49919.pbf\",\"1rCUc\",\"../fonts/pbf/Flama Medium/49920-50175.pbf\",\"iiA0M\",\"../fonts/pbf/Flama Medium/50176-50431.pbf\",\"91frj\",\"../fonts/pbf/Flama Medium/50432-50687.pbf\",\"9zblF\",\"../fonts/pbf/Flama Medium/50688-50943.pbf\",\"2D0nm\",\"../fonts/pbf/Flama Medium/50944-51199.pbf\",\"3w6Tz\",\"../fonts/pbf/Flama Medium/512-767.pbf\",\"4tr3X\",\"../fonts/pbf/Flama Medium/5120-5375.pbf\",\"9pAm6\",\"../fonts/pbf/Flama Medium/51200-51455.pbf\",\"c9qf4\",\"../fonts/pbf/Flama Medium/51456-51711.pbf\",\"fIc7y\",\"../fonts/pbf/Flama Medium/51712-51967.pbf\",\"ibA9w\",\"../fonts/pbf/Flama Medium/51968-52223.pbf\",\"39X4b\",\"../fonts/pbf/Flama Medium/52224-52479.pbf\",\"gChy5\",\"../fonts/pbf/Flama Medium/52480-52735.pbf\",\"jNgoP\",\"../fonts/pbf/Flama Medium/52736-52991.pbf\",\"ku69u\",\"../fonts/pbf/Flama Medium/52992-53247.pbf\",\"gGA4T\",\"../fonts/pbf/Flama Medium/53248-53503.pbf\",\"cyyII\",\"../fonts/pbf/Flama Medium/53504-53759.pbf\",\"bSXRY\",\"../fonts/pbf/Flama Medium/5376-5631.pbf\",\"dwOYR\",\"../fonts/pbf/Flama Medium/53760-54015.pbf\",\"24Vgw\",\"../fonts/pbf/Flama Medium/54016-54271.pbf\",\"jJdmV\",\"../fonts/pbf/Flama Medium/54272-54527.pbf\",\"fvVhh\",\"../fonts/pbf/Flama Medium/54528-54783.pbf\",\"jNLCC\",\"../fonts/pbf/Flama Medium/54784-55039.pbf\",\"jQrUi\",\"../fonts/pbf/Flama Medium/55040-55295.pbf\",\"jPmzZ\",\"../fonts/pbf/Flama Medium/55296-55551.pbf\",\"hA8ZP\",\"../fonts/pbf/Flama Medium/55552-55807.pbf\",\"cAPrR\",\"../fonts/pbf/Flama Medium/55808-56063.pbf\",\"la3eO\",\"../fonts/pbf/Flama Medium/56064-56319.pbf\",\"6UTEj\",\"../fonts/pbf/Flama Medium/5632-5887.pbf\",\"dRhQG\",\"../fonts/pbf/Flama Medium/56320-56575.pbf\",\"gahMd\",\"../fonts/pbf/Flama Medium/56576-56831.pbf\",\"5PmMz\",\"../fonts/pbf/Flama Medium/56832-57087.pbf\",\"3z9a8\",\"../fonts/pbf/Flama Medium/57088-57343.pbf\",\"4fQiT\",\"../fonts/pbf/Flama Medium/57344-57599.pbf\",\"jl4re\",\"../fonts/pbf/Flama Medium/57600-57855.pbf\",\"ge06N\",\"../fonts/pbf/Flama Medium/57856-58111.pbf\",\"8QRHf\",\"../fonts/pbf/Flama Medium/58112-58367.pbf\",\"1fDML\",\"../fonts/pbf/Flama Medium/58368-58623.pbf\",\"5vaKg\",\"../fonts/pbf/Flama Medium/58624-58879.pbf\",\"jO5m8\",\"../fonts/pbf/Flama Medium/5888-6143.pbf\",\"gRGyf\",\"../fonts/pbf/Flama Medium/58880-59135.pbf\",\"aGkqR\",\"../fonts/pbf/Flama Medium/59136-59391.pbf\",\"dRzrl\",\"../fonts/pbf/Flama Medium/59392-59647.pbf\",\"ddPKC\",\"../fonts/pbf/Flama Medium/59648-59903.pbf\",\"kChqg\",\"../fonts/pbf/Flama Medium/59904-60159.pbf\",\"jKgSo\",\"../fonts/pbf/Flama Medium/60160-60415.pbf\",\"fjMHX\",\"../fonts/pbf/Flama Medium/60416-60671.pbf\",\"ezTJQ\",\"../fonts/pbf/Flama Medium/60672-60927.pbf\",\"3QWhi\",\"../fonts/pbf/Flama Medium/60928-61183.pbf\",\"lgahV\",\"../fonts/pbf/Flama Medium/61184-61439.pbf\",\"kfxOQ\",\"../fonts/pbf/Flama Medium/6144-6399.pbf\",\"2QQG4\",\"../fonts/pbf/Flama Medium/61440-61695.pbf\",\"5nGZd\",\"../fonts/pbf/Flama Medium/61696-61951.pbf\",\"dWbML\",\"../fonts/pbf/Flama Medium/61952-62207.pbf\",\"3GM56\",\"../fonts/pbf/Flama Medium/62208-62463.pbf\",\"eWch5\",\"../fonts/pbf/Flama Medium/62464-62719.pbf\",\"idYp7\",\"../fonts/pbf/Flama Medium/62720-62975.pbf\",\"dXPpI\",\"../fonts/pbf/Flama Medium/62976-63231.pbf\",\"3aS9L\",\"../fonts/pbf/Flama Medium/63232-63487.pbf\",\"3ec4z\",\"../fonts/pbf/Flama Medium/63488-63743.pbf\",\"kfXft\",\"../fonts/pbf/Flama Medium/63744-63999.pbf\",\"cdbpu\",\"../fonts/pbf/Flama Medium/6400-6655.pbf\",\"6Zrnt\",\"../fonts/pbf/Flama Medium/64000-64255.pbf\",\"bolPH\",\"../fonts/pbf/Flama Medium/64256-64511.pbf\",\"aZHBJ\",\"../fonts/pbf/Flama Medium/64512-64767.pbf\",\"3VdWX\",\"../fonts/pbf/Flama Medium/64768-65023.pbf\",\"0gyKl\",\"../fonts/pbf/Flama Medium/65024-65279.pbf\",\"hGb3C\",\"../fonts/pbf/Flama Medium/65280-65535.pbf\",\"chFf0\",\"../fonts/pbf/Flama Medium/6656-6911.pbf\",\"h75Tr\",\"../fonts/pbf/Flama Medium/6912-7167.pbf\",\"iCrjp\",\"../fonts/pbf/Flama Medium/7168-7423.pbf\",\"deY84\",\"../fonts/pbf/Flama Medium/7424-7679.pbf\",\"81c6U\",\"../fonts/pbf/Flama Medium/768-1023.pbf\",\"3WAFq\",\"../fonts/pbf/Flama Medium/7680-7935.pbf\",\"jlDLN\",\"../fonts/pbf/Flama Medium/7936-8191.pbf\",\"8m0RE\",\"../fonts/pbf/Flama Medium/8192-8447.pbf\",\"9NaaU\",\"../fonts/pbf/Flama Medium/8448-8703.pbf\",\"ghwA2\",\"../fonts/pbf/Flama Medium/8704-8959.pbf\",\"lRYXj\",\"../fonts/pbf/Flama Medium/8960-9215.pbf\",\"ukbcp\",\"../fonts/pbf/Flama Medium/9216-9471.pbf\",\"b2J3a\",\"../fonts/pbf/Flama Medium/9472-9727.pbf\",\"4Q97p\",\"../fonts/pbf/Flama Medium/9728-9983.pbf\",\"lnbEo\",\"../fonts/pbf/Flama Medium/9984-10239.pbf\",\"linSZ\",\"../images/arrow.73d21102.svg\",\"l4bEW\",\"../images/baby.167c9afa.svg\",\"ianKN\",\"../images/basket.4974ed98.svg\",\"7DHso\",\"../images/bus.b8577684.svg\",\"lDHaZ\",\"../images/circle.13ecd4ba.svg\",\"f40mn\",\"../images/coathanger.09f0d4e7.svg\",\"5YqPh\",\"../images/elevator.f4dcfc22.svg\",\"eJiUf\",\"../images/entrance-arrow.9385de0d.svg\",\"kGiay\",\"../images/escalator.fa586bad.svg\",\"hFafX\",\"../images/film.ac25e3be.svg\",\"dKdN8\",\"../images/first-aid.3b271d3f.svg\",\"g97Pl\",\"../images/food.6762c7ad.svg\",\"7lcHx\",\"../images/info.03dd8cd9.svg\",\"khq6G\",\"../images/marker.f7ef3d6e.svg\",\"aAoXr\",\"../images/parking.555a64aa.svg\",\"lyxjx\",\"../images/pattern-diagonalDash.334ef050.svg\",\"eBc63\",\"../images/pattern-diagonalLine.d0864ee7.svg\",\"ag1jo\",\"../images/pattern-grass.d1f613dd.svg\",\"9N0oP\",\"../images/person-dress.937fd6a0.svg\",\"lCIRD\",\"../images/person.d4a1a84c.svg\",\"12YBV\",\"../images/stairs.1320acd1.svg\",\"lJKcF\",\"../images/ticket.c33843e3.svg\",\"4ODg1\",\"../images/toilet.df4c78ba.svg\",\"1g7Yb\",\"../images/train.fdf27324.svg\",\"6XXAY\",\"../../404.7ef1daf4.js\",\"aKWLR\",\"../../visit/gallery-maps/index.eb966409.css\"]"));

},{"bfd4468d0f1d21fd":"fMwJs","410d4fcdc5344565":"dqXhb"}],"llR9X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _appJs = require("/src/app.js");
var _appJsDefault = parcelHelpers.interopDefault(_appJs);
var _galleryMaps = require("./gallery-maps");
var _galleryMapsDefault = parcelHelpers.interopDefault(_galleryMaps);
(0, _appJsDefault.default).plugin((0, _galleryMapsDefault.default));
(0, _appJsDefault.default).start();

},{"/src/app.js":"1jCaX","./gallery-maps":"kJc4v","@parcel/transformer-js/src/esmodule-helpers.js":"68Hdb"}],"kJc4v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "component", ()=>component);
var _galleryMapsScss = require("./gallery-maps.scss");
var _ = require("url:./fonts/**");
var _mapLayersJs = require("./map-layers.js");
var _mapStyleJs = require("./map-style.js");
var _mapStyleJsDefault = parcelHelpers.interopDefault(_mapStyleJs);
var _svg = require("url:./svgs/*.svg");
var _svgDefault = parcelHelpers.interopDefault(_svg);
var _svg1 = require("bundle-text:./svgs/artworks/*.svg");
var _svgDefault1 = parcelHelpers.interopDefault(_svg1);
var _arrowRightSvg = require("bundle-text:/src/assets/svgs/arrow-right.svg");
var _arrowRightSvgDefault = parcelHelpers.interopDefault(_arrowRightSvg);
var _geojsonExtent = require("@mapbox/geojson-extent");
var _geojsonExtentDefault = parcelHelpers.interopDefault(_geojsonExtent);
var _maplibreGl = require("maplibre-gl");
var _maplibreGlDefault = parcelHelpers.interopDefault(_maplibreGl);
var _mapboxGlPitchToggleControl = require("@watergis/mapbox-gl-pitch-toggle-control");
var _mapboxGlPitchToggleControlDefault = parcelHelpers.interopDefault(_mapboxGlPitchToggleControl);
var _buildingControl = require("./BuildingControl");
var _buildingControlDefault = parcelHelpers.interopDefault(_buildingControl);
var _indexJs = require("/src/utils/sanity/index.js");
var _commonJs = require("/src/$content/_common.js");
var _eventsJs = require("/src/$content/events.js");
var _eventsJs1 = require("/src/_includes/_partials/events.js");
var _venuesJs = require("/src/utils/venues.js");
var _datesJs = require("/src/utils/dates.js");
var _qagomaGeojson = require("json:/tmp/qagoma.geojson");
var _qagomaGeojsonDefault = parcelHelpers.interopDefault(_qagomaGeojson);
const source = 'qagoma';
const iconMap = {
    baby: 'parents_room',
    basket: 'retail',
    coathanger: 'cloakroom',
    film: 'cinema',
    'first-aid': 'first_aid',
    food: 'foodAndBeverage',
    info: 'information_desk',
    person: 'toilet_mens',
    'person-dress': 'toilet_womens',
    ticket: 'cinema_box_office'
};
class LegendControl {
    onAdd() {
        var container = this.container, legend = this.legend, group = document.createElement('div'), button = document.createElement('button'), span = document.createElement('span');
        group.className = 'maplibregl-ctrl-group';
        button.title = 'Toggle Map Legend';
        button.className = 'maplibregl-ctrl-legend';
        span.className = 'maplibregl-ctrl-icon';
        container.append(group, legend);
        group.append(button);
        button.append(span);
        button.addEventListener('click', ()=>{
            this.open = !this.open;
            legend.hidden = !this.open;
            button.classList.toggle('active', this.open);
        });
        return container;
    }
    addItem(name, image) {
        const li = document.createElement('li'), label = name.split('_').map((w)=>w.charAt(0).toUpperCase() + w.slice(1)).join(' ').replace(/\b((?:wo)?men|parent)s\b/gi, "$1's").replace(/(Toilet) (.*)/gi, '$2 $1').replace('And', ' and ');
        li.append(image, label);
        this.legend.querySelector('ul').append(li);
    }
    constructor(){
        const container = this.container = document.createElement('div');
        container.className = 'maplibregl-ctrl maplibregl-ctrl-legend';
        const legend = this.legend = document.createElement('div');
        legend.className = 'map__legend';
        legend.innerHTML = `<h2>Legend</h2><ul></ul>`;
        legend.hidden = true;
        this.getContainer = ()=>this.container;
        this.getLegend = ()=>this.legend;
    }
}
const mapLegend = new LegendControl();
const buildingControl = new (0, _buildingControlDefault.default)('qagoma');
const mapControls = {
    'top-left': [
        new (0, _maplibreGlDefault.default).GeolocateControl({
            positionOptions: {
                enableHighAccuracy: true
            },
            showUserHeading: true,
            trackUserLocation: true
        }),
        new (0, _mapboxGlPitchToggleControlDefault.default)({}),
        new (0, _maplibreGlDefault.default).NavigationControl({
            showZoom: false
        })
    ],
    'bottom-left': [
        new (0, _maplibreGlDefault.default).NavigationControl({
            showCompass: false
        }),
        buildingControl,
        mapLegend
    ]
};
const start = (()=>{
    const url = new URL(location.href);
    const start = url.searchParams.has('start') ? new Date(url.searchParams.get('start')) : new Date();
    start.setHours(0, 0, 0, 0);
    return start;
})();
const activeVenues = (0, _indexJs.client).fetch(`{
  "exhibitionVenues": *[
      _type == "event"
      && type == "exhibition"
      && count(venues) > 0
      && (!defined(end) || end > $start)
      && start <= $start
    ] | order(start desc, priority desc, ticketed desc, string::lower(title) asc, end desc)
    .venues[]._ref
}{
  "venues": *[_type == "venue" && (_id in ^.exhibitionVenues || type == "cinema" || defined(hours) || defined(description)) && !(type in ["external", "galleryBuilding", 'functionSpace'])]
}.venues[]._id`, {
    start
});
const init = (Alpine1)=>{
    Alpine1.data('galleryMap', component);
};
const component = ()=>({
        assets: [],
        get selectedFeatures () {
            return Array.from(this.assets && new Set(this.assets.flatMap(({ _id, venues })=>[
                    _id,
                    venues === null || venues === void 0 ? void 0 : venues.map(({ _id })=>_id)
                ].flat()))).filter(Boolean);
        },
        selectedAsset: null,
        selectedVenue: null,
        setAsset: null,
        async init () {
            const cache = new Map();
            const map = mapSetup.bind(this)();
            this.setAsset = (id)=>this.assets = [
                    cache.get(id)
                ];
            this.$watch('selectedFeatures', (curr, prev)=>{
                new Map(map.querySourceFeatures(source, {
                    filter: [
                        'in',
                        [
                            'get',
                            'venueId'
                        ],
                        [
                            'literal',
                            [
                                curr,
                                prev
                            ].flat()
                        ]
                    ]
                }).map(({ id, properties: { venueId } })=>[
                        id,
                        venueId
                    ])).forEach((venueId, id)=>{
                    if (!curr.includes(venueId)) map.removeFeatureState({
                        id,
                        source
                    }, 'selected');
                    if (!prev.includes(venueId)) map.setFeatureState({
                        id,
                        source
                    }, {
                        selected: true
                    });
                });
            });
            Alpine.effect(()=>{
                if (this.selectedAsset) this.info.open = true;
            });
            Alpine.effect(()=>{
                if (!this.info.open) {
                    this.assets = [];
                    this.selectedVenue = null;
                    this.selectedAsset = null;
                }
            });
            Alpine.effect(()=>{
                if (this.assets.length > 0) {
                    this.info.loading = true;
                    const assets = this.assets;
                    if (assets.length === 1) {
                        var _ref;
                        const properties = assets[0];
                        const { _id, _type, title, subtitle, image, summary, introduction, description, start, end, venues, type, hours, url } = properties;
                        this.selectedAsset = _id;
                        const when = (start || end) && (0, _eventsJs.eventFormatDate)({
                            start,
                            end,
                            type
                        }, {
                            showPermanent: true
                        }), where = _type == 'event' && venues && (0, _venuesJs.formatVenues)(venues.filter(({ type })=>type != 'galleryBuilding'), true);
                        const intro = (_ref = summary || introduction || description) === null || _ref === void 0 ? void 0 : _ref[0];
                        this.info.data = {
                            title: [
                                title,
                                subtitle && `<span>${subtitle}</span>`
                            ].filter(Boolean).join(' '),
                            image: image && (0, _indexJs.imageUrlBuilder)(image).width(500).height(238),
                            url: url || _type == 'event' && (0, _eventsJs.eventUrl)(properties),
                            content: [
                                (when || where) && {
                                    title: [
                                        when && 'When',
                                        where && 'Where'
                                    ].filter(Boolean).join('/'),
                                    content: (0, _indexJs.toHTML)([
                                        when,
                                        where
                                    ].map((x)=>({
                                            _type: 'block',
                                            style: 'normal',
                                            children: [
                                                {
                                                    _type: 'span',
                                                    text: x
                                                }
                                            ],
                                            listItem: 'bullet'
                                        })))
                                },
                                hours && {
                                    title: 'Opening Hours',
                                    content: hours.reduce((html, { days, open, close })=>{
                                        let times = open || close;
                                        return `${html}<div>
                      ${days && `<strong>${(0, _datesJs.formatDays)(days)}${times ? `:` : ``}</strong>` || ``}
                      ${times && (0, _datesJs.formatTime)(open, close) || ``}
                    </div>`;
                                    }, '')
                                },
                                {
                                    title: (when || where) && 'About',
                                    content: (0, _indexJs.toHTML)([
                                        intro
                                    ])
                                }
                            ].filter(Boolean).map(({ title, content })=>`<div>${title ? `<h2>${title}</h2>` : ``}<div>${content}</div></div>`).join('\n\n'),
                            admission: _type == 'event' && (0, _eventsJs1.getAdmission)((0, _eventsJs.withTicketUrl)(properties))
                        };
                    } else {
                        const feature = map.querySourceFeatures('qagoma', {
                            layers: [
                                'qagomaSpaces'
                            ],
                            filter: [
                                '==',
                                [
                                    'get',
                                    'id'
                                ],
                                this.selectedVenue
                            ]
                        }).reduce((acc, { properties })=>Object.assign(acc, properties), {});
                        this.info.data = {
                            title: `${feature.name} <br><span>${assets.length} exhibitions</span>`,
                            content: `<ul style="display:grid; gap:var(--g-gap); margin-top:var(--g-gap)">
              ${assets.map((properties)=>{
                                const { title, subtitle, _id, _type, image, url } = properties;
                                return `<li style="display: flex; display: grid; grid-template-columns: 0.5fr 1fr; gap: var(--g-gap); align-items: end;">
                    <a href="${url || _type == 'event' && (0, _eventsJs.eventUrl)(properties)}" @click.prevent="setAsset('${_id}')">
                      <img src="${(0, _indexJs.imageUrlBuilder)(image).width(150).height(150).fit('crop')}" style="display:block">
                    </a>
                    <div>
                      <a href="${url || _type == 'event' && (0, _eventsJs.eventUrl)(properties)}" @click.prevent="setAsset('${_id}')">
                        <h2 class="cta-see-more" style="margin:0; align-items: end;">
                          <div>
                          ${[
                                    title,
                                    subtitle && `<span>${subtitle}</span>`
                                ].filter(Boolean).join(' ')}
                          </div>
                          ${0, _arrowRightSvgDefault.default}
                        </h2>
                      </a>
                    
                      <div class="card__details">
                        <div class="card__admission">
                          ${(0, _eventsJs1.getAdmission)((0, _eventsJs.withTicketUrl)(properties))}
                        </div>
                      </div>
                    </div>
                  </li>`;
                            }).join('')}</ul>`
                        };
                    }
                    this.info.loading = false;
                }
            });
            Alpine.effect(()=>{
                const venueId = this.selectedVenue;
                if (venueId) {
                    if (map.hasControl(buildingControl)) {
                        let { building, level } = map.querySourceFeatures('qagoma', {
                            layers: [
                                'qagomaSpaces'
                            ],
                            filter: [
                                '==',
                                [
                                    'get',
                                    'id'
                                ],
                                venueId
                            ]
                        })[0].properties;
                        if (building && level) buildingControl.setLevel(building, level);
                    }
                    if (venueId === this.selectedAsset) {
                        this.info.loading = true;
                        return new Promise((resolve)=>{
                            if (cache.has(venueId)) return resolve(cache.get(venueId));
                            return resolve((0, _indexJs.client).fetch(`*[_id == $id][0]{
                    ...,
                    "assets": *[references($id)][
                      _type == "event"
                      && type == "exhibition"
                      && count(venues) > 0
                      && (!defined(end) || end > $start)
                      && start <= $start
                    ]{
                      ...,
                      "externalEvent": coalesce(externalEvent, ticketing),
                      ticketing,
                      type,
                      _type,
                      start,
                      end,
                      ${(0, _commonJs.venuesProjection)},
                      title,
                      subtitle,
                      summary,
                      image,
                      "slug": slug.current
                    } | order(start desc, priority desc, ticketed desc, string::lower(title) asc, end desc),
                    type == "cinema" => {
                      ...,
                      "assets": *[_id == "6ab8b823-f21b-4c06-8228-f7f9b12715e6"]{
                        ...$venueData,
                        ...,
                        "venues": *[_type == "venue" && type == "cinema" && _id != ^._id],
                        "image": coalesce(images[0], [
                          ...*[_type == "venue" && title match "Cinema*" && defined(images)].images[]
                        ][0])
                      }
                    }
                  }{
                    ...$venueData,
                    ...,
                    "image": images[0]
                  }`, {
                                start,
                                id: venueId,
                                venueData: map.querySourceFeatures('qagoma', {
                                    layers: [
                                        'qagomaSpaces'
                                    ],
                                    filter: [
                                        'all',
                                        [
                                            'has',
                                            'venue'
                                        ],
                                        [
                                            '==',
                                            [
                                                'get',
                                                'venueId'
                                            ],
                                            venueId
                                        ]
                                    ]
                                }).reduce((acc, { properties })=>Object.assign(acc, JSON.parse(properties.venue)), {})
                            }).then(({ assets, ...venue })=>{
                                if (assets) {
                                    venue.assets = new Set();
                                    assets.forEach((asset)=>{
                                        cache.set(asset._id, asset);
                                        venue.assets.add(cache.get(asset._id));
                                    });
                                }
                                cache.set(venue._id, venue);
                                return venue;
                            }));
                        }).then((venue)=>{
                            var _venue$assets;
                            if ((venue === null || venue === void 0 || (_venue$assets = venue.assets) === null || _venue$assets === void 0 ? void 0 : _venue$assets.size) > 0) return Array.from(venue.assets);
                            return [
                                venue
                            ];
                        }).then((assets)=>{
                            this.assets = assets;
                        });
                    }
                }
            });
        },
        info: {
            open: false,
            loading: false,
            data: {
                title: null,
                image: null,
                content: null
            },
            get content () {
                return [
                    this.data.content
                ].flat().filter(Boolean).join('\n\n');
            }
        },
        artwork: {
            ['x-init'] () {
                this.building = buildingControl._state.buildings.get(this.building);
            },
            ['x-transition']: undefined,
            ['x-show']: `building.activeLevel && building.activeLevel === level`
        }
    });
function mapSetup() {
    (0, _qagomaGeojsonDefault.default).features.forEach(({ properties: { venue, type, id } }, i)=>{
        var _venue$_id;
        if (venue || type == 'gallery_space') (0, _qagomaGeojsonDefault.default).features[i].properties.venueId = (_venue$_id = venue === null || venue === void 0 ? void 0 : venue._id) !== null && _venue$_id !== void 0 ? _venue$_id : id;
    });
    const map = new (0, _maplibreGlDefault.default).Map({
        container: 'map',
        style: (0, _mapStyleJsDefault.default),
        transformRequest: (url)=>({
                url: new URL(`${url}?key=a715f0bf4ea29737`, window.location.origin).toString()
            }),
        crossSourceCollisions: false,
        zoom: 16,
        minZoom: 14,
        maxZoom: 20,
        bounds: (0, _qagomaGeojsonDefault.default).properties.extent,
        padding: 20
    }).fitBounds((0, _qagomaGeojsonDefault.default).properties.extent, {
        padding: 20,
        maxZoom: 16
    });
    map.on('click', 'qagomaSpaces', onVenueClick.bind(this));
    map.on('click', 'qagomaBaseCover', onBuildingClick);
    map.on('click', 'amenities', onAmenitiesClick);
    map.on('sourcedata', onSourceData);
    map.on('load', ()=>{
        map.addSource('qagoma', {
            type: 'geojson',
            data: (0, _qagomaGeojsonDefault.default),
            promoteId: 'id'
        });
        addLayers(map);
        loadIcons(map);
        addArtworks(map);
        addControls(map);
        addInterPathwayPopup(map);
        addClosedVenuePopup(map);
    });
    return map;
}
function onSourceData({ dataType, isSourceLoaded, sourceId, target: map }) {
    if (dataType === 'source' && sourceId === source && isSourceLoaded) setupFeatures(map);
}
async function loadIcons(map) {
    for (let [id, icon] of Object.entries((0, _svgDefault.default)))loadImage(icon).then((icon)=>{
        id = (iconMap === null || iconMap === void 0 ? void 0 : iconMap[id]) || id;
        map.addImage(id, icon, {
            pixelRatio: 2.5
        });
        if (!id.match(/arrow|marker|circle|pattern-/)) mapLegend.addItem(id, icon);
    });
}
async function addLayers(map) {
    Object.values(_mapLayersJs).forEach((layer)=>map.addLayer(layer));
}
async function setupFeatures(map) {
    activeVenues.then((activeVenues)=>{
        map.querySourceFeatures(source, {
            filter: [
                'has',
                'venueId'
            ]
        }).forEach(({ id, properties: { venueId } })=>{
            map.setFeatureState({
                id,
                source
            }, {
                isSelectable: activeVenues.includes(venueId)
            });
        });
    });
}
async function addControls(map) {
    for (const [location1, controls] of Object.entries(mapControls))for (const control of controls)map.addControl(control, location1);
}
async function addArtworks(map) {
    (0, _qagomaGeojsonDefault.default).features.filter(({ properties: { type } })=>type == 'artwork').forEach((feature)=>addArtwork(map, feature));
}
async function addArtwork(map, { properties, geometry }) {
    const artwork = (0, _svgDefault1.default) === null || (0, _svgDefault1.default) === void 0 ? void 0 : (0, _svgDefault1.default)[properties.icon];
    if (artwork) {
        const el = document.createElement('div');
        el.innerHTML = artwork;
        el.className = 'artwork';
        const icon = el.firstElementChild;
        icon.style.opacity = 0;
        if (properties.level) {
            el.setAttribute('x-data', JSON.stringify(properties));
            el.setAttribute('x-bind', `artwork`);
        }
        const marker = new (0, _maplibreGlDefault.default).Marker(el, {
            anchor: 'bottom',
            offset: [
                0,
                25
            ]
        }).setLngLat(geometry.coordinates).addTo(map);
        map.on('zoom', ()=>{
            const zoom = map.getZoom();
            const scale = Math.max(0, 1 + (zoom - 19) * 0.3);
            icon.style.opacity = Math.min(Math.max(0, (17 - zoom) / -1), 1);
            icon.style.transform = `scale(${scale})`;
            icon.style.transformOrigin = 'center bottom';
        });
        map.on('rotate', ()=>{
            el.style.zIndex = Math.round(marker._pos.y / map.getContainer().clientHeight * 100);
        });
    }
}
function addInterPathwayPopup(map) {
    const popup = new (0, _maplibreGlDefault.default).Popup({
        closeButton: false,
        closeOnClick: false,
        maxWidth: '21em'
    }).setHTML('Our two riverside galleries, Queensland Art Gallery (QAG) and Gallery of Modern Art (GOMA), sit 150 metres apart in the Queensland Cultural Centre');
    map.on('mouseenter', 'qagomaInterBuildingPathwayTarget', (e)=>{
        let pathwayFeatures = e.target.queryRenderedFeatures({
            layers: [
                'qagomaInterBuildingPathway'
            ]
        });
        let mappedFeatures = e.features.map((feature)=>pathwayFeatures.find(({ geometry })=>JSON.stringify(geometry) == JSON.stringify(feature.geometry)));
        if (mappedFeatures.some(({ layer })=>layer.paint['line-opacity'])) popup.setLngLat(e.lngLat).addTo(map).trackPointer();
    });
    map.on('mouseleave', 'qagomaInterBuildingPathwayTarget', ()=>{
        if (popup.isOpen()) popup.remove();
    });
}
function addClosedVenuePopup(map) {
    (0, _qagomaGeojsonDefault.default).features.filter(({ properties })=>properties.isClosed && properties.type === 'internal_venue').forEach((feature)=>{
        console.log(feature);
        const venue = feature.properties.venue, venueId = venue._id, message = venue.closureMessage;
        const popup = new (0, _maplibreGlDefault.default).Popup({
            closeButton: false,
            closeOnClick: false,
            maxWidth: '21em'
        }).setHTML((0, _indexJs.toHTML)(message));
        map.on('mouseenter', 'qagomaInaccessible', (e)=>{
            if (e.features.find(({ properties })=>properties.venueId === venueId)) popup.setLngLat(e.lngLat).addTo(map).trackPointer();
        });
        map.on('mouseleave', 'qagomaInaccessible', ()=>{
            if (popup.isOpen()) popup.remove();
        });
    });
}
function onVenueClick({ target: map, features }) {
    var _feature$state;
    if (map.getZoom() <= 17) return;
    const feature = features.find(({ id })=>id);
    if (feature && ((_feature$state = feature.state) === null || _feature$state === void 0 ? void 0 : _feature$state.isSelectable) !== false) this.selectedAsset = this.selectedVenue = feature.properties.venueId;
    return map;
}
function onBuildingClick({ target: map, features }) {
    map.fitBounds((0, _geojsonExtentDefault.default)(features[0]), {
        padding: 20
    });
    return map;
}
function onAmenitiesClick({ target: map, features }) {
    let feature = features[0];
    if (feature) {
        let coordinates = feature.geometry.coordinates.slice(), name = feature.properties.name;
        new (0, _maplibreGlDefault.default).Popup().setLngLat(coordinates).setHTML(name).addTo(map);
    }
    return map;
}
function loadImage(url) {
    return new Promise((resolve, reject)=>{
        const image = new Image();
        image.addEventListener('load', ()=>resolve(image));
        image.addEventListener('error', (err)=>reject(err));
        image.src = url;
    });
}
exports.default = init;

},{"./gallery-maps.scss":"DFkWP","url:./fonts/**":"c2cGH","./map-layers.js":"4KPza","./map-style.js":"fD8Om","url:./svgs/*.svg":"lrjqx","bundle-text:./svgs/artworks/*.svg":"7s1jh","bundle-text:/src/assets/svgs/arrow-right.svg":"1mMYX","@mapbox/geojson-extent":"6KLtd","maplibre-gl":"jIT58","@watergis/mapbox-gl-pitch-toggle-control":"PZsMs","./BuildingControl":"i2suf","/src/utils/sanity/index.js":"cNfnF","/src/$content/_common.js":"29kg9","/src/$content/events.js":"czltv","/src/_includes/_partials/events.js":"6OjHn","/src/utils/venues.js":"bm3yO","/src/utils/dates.js":"dqz38","json:/tmp/qagoma.geojson":"aexFM","@parcel/transformer-js/src/esmodule-helpers.js":"68Hdb"}],"DFkWP":[function() {},{}],"c2cGH":[function(require,module,exports,__globalThis) {
const _temp0 = require("eb14f00276bdd7b8");
const _temp1 = require("269369950901f68b");
const _temp2 = require("66b7dc4a6ed38856");
const _temp3 = require("7103f2e6f4c535ab");
const _temp4 = require("24920f96ab2187a8");
const _temp5 = require("532c671f50b43e09");
const _temp6 = require("a4f3d005cd2756a");
const _temp7 = require("6262d990dc9cfa81");
const _temp8 = require("8802e40319ac4662");
const _temp9 = require("cb055fd51fed6e3");
const _temp10 = require("33d5f17074d461db");
const _temp11 = require("2c451c3ca1ceb3b0");
const _temp12 = require("c7e3da609d600b90");
const _temp13 = require("c7201ce6c84dc333");
const _temp14 = require("da71913a8a1006c3");
const _temp15 = require("6a67a00b2d92ecc0");
const _temp16 = require("274bf89516c199ee");
const _temp17 = require("234f74d4591fd872");
const _temp18 = require("9fdc7984fc2b7536");
const _temp19 = require("10d806120ae77ed4");
const _temp20 = require("a61ecb84ea79709e");
const _temp21 = require("a57718dd9f3831dd");
const _temp22 = require("f7b76cc473bb2656");
const _temp23 = require("bf7facc1e56dc270");
const _temp24 = require("6f2531784f402d41");
const _temp25 = require("b1793221b3db46e4");
const _temp26 = require("b0726a16a668d188");
const _temp27 = require("5c8c74e2a682f935");
const _temp28 = require("f9f32e7d0ebad425");
const _temp29 = require("761875583076959e");
const _temp30 = require("76f98653ba6355ae");
const _temp31 = require("41c14423e76e1198");
const _temp32 = require("9cb67f8f686469d9");
const _temp33 = require("b64a1a6b150e00f5");
const _temp34 = require("bc494742dd291d55");
const _temp35 = require("38377ab6ba0ff08d");
const _temp36 = require("9f1958d926e07993");
const _temp37 = require("5c7e9d7474a6a7cf");
const _temp38 = require("dc8abbd96c6ea7c1");
const _temp39 = require("ca5323e82be5b917");
const _temp40 = require("210f5b150cc4c14a");
const _temp41 = require("f96fcd623bc5f94a");
const _temp42 = require("3d44d1cb2c5aeea");
const _temp43 = require("361cc8a4a761ad76");
const _temp44 = require("45d7e94b501695b1");
const _temp45 = require("3a6493f33f45abaa");
const _temp46 = require("2f6aefe284c02456");
const _temp47 = require("869042492935dbba");
const _temp48 = require("78d612b0b59f0d4e");
const _temp49 = require("c4408c368048e89b");
const _temp50 = require("52e30b18f0f6b91c");
const _temp51 = require("95526412f7a496ff");
const _temp52 = require("2704638a57be43e3");
const _temp53 = require("158966bfcc08d259");
const _temp54 = require("87ded1a5c224a4b6");
const _temp55 = require("c58ecb5831b32904");
const _temp56 = require("712e0466b4a6de3d");
const _temp57 = require("d3fdf71534f9248d");
const _temp58 = require("b849fa5c831c4946");
const _temp59 = require("83a36c53b255f99d");
const _temp60 = require("d3825b27dbbfd88a");
const _temp61 = require("583f2424b14eb849");
const _temp62 = require("2a33a1a5fdc10d5c");
const _temp63 = require("a31e1ab469947fab");
const _temp64 = require("1fcb2f9e1ed9a7ad");
const _temp65 = require("eccc1549fd16740f");
const _temp66 = require("cd7916cd794d99de");
const _temp67 = require("ab4ad9068f7ac43c");
const _temp68 = require("5c4d409bb09f170e");
const _temp69 = require("8121595e62ce47a");
const _temp70 = require("d7098297448be7f9");
const _temp71 = require("7fd0011de18ba372");
const _temp72 = require("78b7a3777a6b0089");
const _temp73 = require("5bcac181d9532e58");
const _temp74 = require("724fdb3deaaaf673");
const _temp75 = require("d2c4458b296cff7");
const _temp76 = require("ac1f4ffdd5118eec");
const _temp77 = require("5362975b0afea9b4");
const _temp78 = require("736dc3d35373ee9d");
const _temp79 = require("18946e2267b71599");
const _temp80 = require("566afa6f7549cc0f");
const _temp81 = require("6c33805dacee429b");
const _temp82 = require("ca65f87fe3a38433");
const _temp83 = require("9dec4c1698a90776");
const _temp84 = require("7bb735383cfca062");
const _temp85 = require("ffbc1dd4f82eb7ef");
const _temp86 = require("57daacf750a41709");
const _temp87 = require("b3b22be006e390a6");
const _temp88 = require("f0111c1c83957254");
const _temp89 = require("bdc336b22905404b");
const _temp90 = require("186df628b8af5e0a");
const _temp91 = require("5e1b958bbb6b086b");
const _temp92 = require("257116eec8a6b933");
const _temp93 = require("5a8419f1953ed5cf");
const _temp94 = require("bf8ac06a1ef73d65");
const _temp95 = require("27506881f95fae19");
const _temp96 = require("42e4034fc253ec95");
const _temp97 = require("9971ba9ee6d148e");
const _temp98 = require("50bf2d3a0731b8ab");
const _temp99 = require("ea181f5b91e836ed");
const _temp100 = require("c59e527697b7b2ea");
const _temp101 = require("70f08145cfecef32");
const _temp102 = require("c301dfe7816a2415");
const _temp103 = require("6822bea612016cd");
const _temp104 = require("41fbfa4946d2b36b");
const _temp105 = require("9e36ea8ccfb565ee");
const _temp106 = require("ee3fc9864854a46");
const _temp107 = require("6e554b08cb4a9b9");
const _temp108 = require("3bc3743e0ca1bc2");
const _temp109 = require("ec0dcf37bef8dd67");
const _temp110 = require("b0e118b2ef2e3d3c");
const _temp111 = require("ef26ad23a3c53d15");
const _temp112 = require("24129679968c9693");
const _temp113 = require("1dd20b690a71b9b0");
const _temp114 = require("a302ef30c3cf4b97");
const _temp115 = require("134a6e3237d52c4");
const _temp116 = require("6754cf2a38844df8");
const _temp117 = require("2782cc57969cb6");
const _temp118 = require("9b7c528f42c05cc3");
const _temp119 = require("68c1e262d0df21ea");
const _temp120 = require("4dbf9af4851ee6cc");
const _temp121 = require("c9295b2821e2d170");
const _temp122 = require("9eef9790378ce5aa");
const _temp123 = require("64dfcd5b3aa33062");
const _temp124 = require("61253d4251e53cf7");
const _temp125 = require("64f7ac3b95eee529");
const _temp126 = require("945448e87c57275b");
const _temp127 = require("1e1e1118511cd14d");
const _temp128 = require("2b54bb9b7d723080");
const _temp129 = require("5b342fde55902abd");
const _temp130 = require("482971891590f603");
const _temp131 = require("8abe4d755c9578ca");
const _temp132 = require("77a61606265ac238");
const _temp133 = require("3e3ea923cac80285");
const _temp134 = require("d638afd285be5afe");
const _temp135 = require("7f57cd38b4a527ca");
const _temp136 = require("2c9c208542d6ad93");
const _temp137 = require("e3e44b21a7853207");
const _temp138 = require("8fa21f7d39eb0fc6");
const _temp139 = require("dc047531556d1aae");
const _temp140 = require("4a15ad9b9141526b");
const _temp141 = require("cff9847356e8375b");
const _temp142 = require("317550eb126e981e");
const _temp143 = require("cee0d98ac6858477");
const _temp144 = require("fda2b0b607550262");
const _temp145 = require("84993257a224e452");
const _temp146 = require("6f4452db4e74f321");
const _temp147 = require("5b5482d65644c9f6");
const _temp148 = require("8dadf1de22d6e266");
const _temp149 = require("69a02e01f094186e");
const _temp150 = require("1314147a268d289a");
const _temp151 = require("5571c7bca31e6753");
const _temp152 = require("6784657e2bd6bd63");
const _temp153 = require("40906f19959fad46");
const _temp154 = require("b5925282c4110581");
const _temp155 = require("9e9d734d4363ff55");
const _temp156 = require("22130490c8638cef");
const _temp157 = require("c93c865896cd8255");
const _temp158 = require("741006c4a228547b");
const _temp159 = require("9dc5be4128243207");
const _temp160 = require("43b8390bf62f151a");
const _temp161 = require("b8518e6f5689cd32");
const _temp162 = require("89665c97e037838");
const _temp163 = require("f3663d2d1f2624b3");
const _temp164 = require("bbe91b5090376b42");
const _temp165 = require("2d6c0a8835d92dbe");
const _temp166 = require("35bdd290a41087dc");
const _temp167 = require("c5e84340e09af5f9");
const _temp168 = require("d9b2143e30c2ef51");
const _temp169 = require("6a6bfc1c6e0733dc");
const _temp170 = require("431b968db55b0177");
const _temp171 = require("efdd96206dbadbc1");
const _temp172 = require("d88881c468a51401");
const _temp173 = require("25a17b557309a300");
const _temp174 = require("83b6660afaef6355");
const _temp175 = require("2f296f14af3935f2");
const _temp176 = require("ef295eef53177513");
const _temp177 = require("a34d713718c9e2e8");
const _temp178 = require("d0fbbaf249d1ba1e");
const _temp179 = require("186c3ab5f7337433");
const _temp180 = require("4636f4a7404734ce");
const _temp181 = require("48599e1331b149af");
const _temp182 = require("5785aaedb71e4beb");
const _temp183 = require("c1578c7c77414fea");
const _temp184 = require("b628db85e3a50adb");
const _temp185 = require("326298a636da5863");
const _temp186 = require("536e7101fe3c14f8");
const _temp187 = require("678b7e7d0d8649b9");
const _temp188 = require("b599ef96b90e9e50");
const _temp189 = require("2979830887559a70");
const _temp190 = require("ce2c34db6b1adc80");
const _temp191 = require("e496decbe182da73");
const _temp192 = require("24bc121a06c2f002");
const _temp193 = require("8bc81b39933986c8");
const _temp194 = require("ddb7f2706d64b475");
const _temp195 = require("663baeb224abb735");
const _temp196 = require("bad3ac959c18a491");
const _temp197 = require("688bd9f9a3e3dfd8");
const _temp198 = require("5758b057dce7eceb");
const _temp199 = require("a6ff3166b282b4cf");
const _temp200 = require("83864241f2d1abc9");
const _temp201 = require("aa5cfffec1706142");
const _temp202 = require("c3aa548c0f66f766");
const _temp203 = require("8974ca90049ef152");
const _temp204 = require("ec0ef4a1a21cfe83");
const _temp205 = require("b2a967b8d2aa6c30");
const _temp206 = require("a975e6f0f0ddf0f4");
const _temp207 = require("d299ba0ffdf0bec5");
const _temp208 = require("136208c9f3bc9011");
const _temp209 = require("f10643c7b31c6e6");
const _temp210 = require("1ab9f814e2e9b9e9");
const _temp211 = require("4473981f3d1d0bb2");
const _temp212 = require("8d6e306059b28484");
const _temp213 = require("81258b61d2848699");
const _temp214 = require("9ebb33ec2fbd6399");
const _temp215 = require("725d183e4712b8cf");
const _temp216 = require("891d897bd746a084");
const _temp217 = require("beb2f58893eeca50");
const _temp218 = require("e79d252761eebe3");
const _temp219 = require("8cc4fc925da90cb1");
const _temp220 = require("47b7012ce6f130dc");
const _temp221 = require("de7e445b1eee6315");
const _temp222 = require("19f59b5aaf121c53");
const _temp223 = require("2e1fb7cbe08c50a1");
const _temp224 = require("9c92bfed745b5efe");
const _temp225 = require("c5b4440345556f1d");
const _temp226 = require("73c2e755536cdd88");
const _temp227 = require("e993de6725def9d2");
const _temp228 = require("9f4bdcac8599167d");
const _temp229 = require("bf1b28e19a24dd3f");
const _temp230 = require("6b32fa0ec17e6dd2");
const _temp231 = require("fe07fc9c7761e2c0");
const _temp232 = require("a35ebdaab599e591");
const _temp233 = require("86cb4300e7875184");
const _temp234 = require("831fc54db90b040a");
const _temp235 = require("ec3145cb1d4f85ae");
const _temp236 = require("bce501edfaf1171d");
const _temp237 = require("1af0ea9d25a2cd6a");
const _temp238 = require("b47cad552576b610");
const _temp239 = require("c27f9dcb7697388f");
const _temp240 = require("4eb66a8a9b5b95c");
const _temp241 = require("9f215cf1f5dffcb3");
const _temp242 = require("721c3e51ea8a1dda");
const _temp243 = require("2c70a267997d9c7c");
const _temp244 = require("3486559970599733");
const _temp245 = require("fe359394d21256ab");
const _temp246 = require("ccc977c033c7aa3d");
const _temp247 = require("bc486fdc23a24586");
const _temp248 = require("97cd4846c42bd6b8");
const _temp249 = require("bad7c55398eec98d");
const _temp250 = require("a51a9ec8edd24258");
const _temp251 = require("70d02f2de925219b");
const _temp252 = require("1b5dbb72c60ea860");
const _temp253 = require("b62337296a452f25");
const _temp254 = require("a2a974e92b3beb6c");
const _temp255 = require("bbbbf7478e70d8a1");
const _temp256 = require("9e59e890e45178a4");
const _temp257 = require("b9bed337dd21c151");
const _temp258 = require("8c6bbc353201f33b");
const _temp259 = require("1f4eb5f6204fdda4");
const _temp260 = require("5a22f12f8948155e");
const _temp261 = require("bfa6ea08b695ca7f");
const _temp262 = require("9dfc3fdd217cbef9");
const _temp263 = require("2448e3d0dcdeffbf");
const _temp264 = require("a34cb07cbc59912f");
const _temp265 = require("e430fb64c588bb6c");
const _temp266 = require("2c59c3baefc48f6e");
const _temp267 = require("1451f4305ce47b49");
const _temp268 = require("74adb35c3ae97541");
const _temp269 = require("1f2fe3dffc3938e9");
const _temp270 = require("401c173d001962e6");
const _temp271 = require("19fe5598d38f518b");
const _temp272 = require("38c596e473b11a8b");
const _temp273 = require("f0dd9cdf6e84633c");
const _temp274 = require("9fa35a29a546c9b9");
const _temp275 = require("a63b2f483d109a");
const _temp276 = require("eda95b20028c6573");
const _temp277 = require("79350d30c9b74954");
const _temp278 = require("5e10c1812ff30a91");
const _temp279 = require("c9099523b2cce10b");
const _temp280 = require("338bed7fe68a0c94");
const _temp281 = require("62b55b4e07fc9d57");
const _temp282 = require("3ce38eafd0c30e27");
const _temp283 = require("ee23ca013d4c1f5e");
const _temp284 = require("a618adb9017ed125");
const _temp285 = require("e1adf33c6be8951b");
const _temp286 = require("7e532ecf6d8ceaf");
const _temp287 = require("7c6d02edb920e07f");
const _temp288 = require("f2b58d7b8fd06456");
const _temp289 = require("9efeee71818edcc3");
const _temp290 = require("662e681e78929861");
const _temp291 = require("7e0fa6041936907e");
const _temp292 = require("4833d7b57a2b5187");
const _temp293 = require("211837053a1005e7");
const _temp294 = require("e82071d94c33b941");
const _temp295 = require("d74a953d91fa0ba");
const _temp296 = require("b19a62f0d4987e24");
const _temp297 = require("d2bfad2faef32d73");
const _temp298 = require("cc7277b366bb9c3e");
const _temp299 = require("df9162753b3d43dd");
const _temp300 = require("808690d2caa875c6");
const _temp301 = require("e5e820802e4df8c2");
const _temp302 = require("68c0b5241a6b3358");
const _temp303 = require("e6121393afebea4");
const _temp304 = require("c2c0dcb296074f3e");
const _temp305 = require("d1c587d0bf4375e3");
const _temp306 = require("a1fcabbf9c7db982");
const _temp307 = require("2d2af77fd2ea1689");
const _temp308 = require("9dcfd36a5b40f8a3");
const _temp309 = require("db36ba0bd672d981");
const _temp310 = require("d8a5a414ad207d3b");
const _temp311 = require("6f9732ea61c9cba1");
const _temp312 = require("6d9b6fc20299e9d0");
const _temp313 = require("55b59e8868192d31");
const _temp314 = require("5ccdc3def6af5ce6");
const _temp315 = require("c6f6f5f02f7ba475");
const _temp316 = require("92e42b0e8480f4df");
const _temp317 = require("3e77b8153895b49c");
const _temp318 = require("ef4c47a1f95207ce");
const _temp319 = require("ae208017d0420d2a");
const _temp320 = require("87622cb26b029d1e");
const _temp321 = require("89bee5de72736454");
const _temp322 = require("f2a6c791dd9c6c9f");
const _temp323 = require("61d83776e1b35b12");
const _temp324 = require("944b31ca8f4d1ebd");
const _temp325 = require("8437f9433741fdc9");
const _temp326 = require("5eba9d5405009922");
const _temp327 = require("61d7413a10f03252");
const _temp328 = require("c5a1113d0b5db195");
const _temp329 = require("1cf0218204b8b07f");
const _temp330 = require("7bc3eef7f152fa9f");
const _temp331 = require("607cadf362eb9482");
const _temp332 = require("77752bc612560c2a");
const _temp333 = require("908bf727711be540");
const _temp334 = require("4ec21b2a8ec30e54");
const _temp335 = require("c09d0d32f94e6f54");
const _temp336 = require("a4ba12d876a3b2d2");
const _temp337 = require("3e06d9dea3ce69b2");
const _temp338 = require("800386419b9b86a");
const _temp339 = require("6c7c43964047c9d4");
const _temp340 = require("a99c2e6f15e52aab");
const _temp341 = require("31869e2191f61a90");
const _temp342 = require("30ea8c6da6ec7302");
const _temp343 = require("11b9a938afb166ba");
const _temp344 = require("a0dfc6079d69400");
const _temp345 = require("4a8408fc395fc6f0");
const _temp346 = require("cb8fd30ed07f2bf");
const _temp347 = require("ce385115e88ba5ff");
const _temp348 = require("8cebb3ff32b43bb3");
const _temp349 = require("f974e5fb28bc3649");
const _temp350 = require("c426d611531ab109");
const _temp351 = require("42c43aabb8082df2");
const _temp352 = require("214c4930830043dc");
const _temp353 = require("50da58c3f37754eb");
const _temp354 = require("c304922585f8f61c");
const _temp355 = require("58fdfa5910037ae3");
const _temp356 = require("960e34fabef3874b");
const _temp357 = require("68d7029d448f2daf");
const _temp358 = require("2899fd4e4311896");
const _temp359 = require("9110b0398183e2a3");
const _temp360 = require("f292e365e89faee3");
const _temp361 = require("5d09a17c5b7b6dea");
const _temp362 = require("74d05c5fd92453d7");
const _temp363 = require("72d76f681ecf3642");
const _temp364 = require("250603e7ae4d62b0");
const _temp365 = require("88ff192d7d114f9");
const _temp366 = require("318426eeb9c275be");
const _temp367 = require("b0065b1630532f03");
const _temp368 = require("43ff110c6c2feb18");
const _temp369 = require("6ad23034c7541677");
const _temp370 = require("c2ae2b4b52b991bf");
const _temp371 = require("f01dcd9adad8a7dc");
const _temp372 = require("d5c4527e2fd8d356");
const _temp373 = require("5065c762bbaa8b88");
const _temp374 = require("d565bc720fe6c892");
const _temp375 = require("9ef55f20e4f2cb96");
const _temp376 = require("1dac8df6d91dbb8a");
const _temp377 = require("43f19f50289c3d55");
const _temp378 = require("ebbab81208ff7e43");
const _temp379 = require("a48b679191a96b48");
const _temp380 = require("f9e642ce090ceb9f");
const _temp381 = require("307616d58965271e");
const _temp382 = require("99d0e5c83a5b787");
const _temp383 = require("7ac8cb0f984d4715");
const _temp384 = require("a27d955ac5631466");
const _temp385 = require("1ac43193e21d22a2");
const _temp386 = require("6b7a0103bb31b5e");
const _temp387 = require("3de995ac515099bb");
const _temp388 = require("48277e0201c6cecf");
const _temp389 = require("8ebba396d30181be");
const _temp390 = require("c7d1a4905bdd1b42");
const _temp391 = require("783b47de23e13d8b");
const _temp392 = require("b5200714779093c5");
const _temp393 = require("976313440f91c02c");
const _temp394 = require("5cab174c63ed022d");
const _temp395 = require("77d6b8da30b13964");
const _temp396 = require("98091d7b8778632c");
const _temp397 = require("97e1c29b82d64020");
const _temp398 = require("d9f11ea95551870c");
const _temp399 = require("511471d35aab75ec");
const _temp400 = require("ca9af461c82c3a63");
const _temp401 = require("125e27957b00290e");
const _temp402 = require("f5945ea3b445d898");
const _temp403 = require("6fb0cc371ca25ff");
const _temp404 = require("dd62abdfe20a6f60");
const _temp405 = require("d2fbe813c61aa5a3");
const _temp406 = require("57eb94bd4ab4113");
const _temp407 = require("b11f2e0d90e88996");
const _temp408 = require("c2618aa176bc5580");
const _temp409 = require("891c1a53def623f6");
const _temp410 = require("c0fe7502eaf847fa");
const _temp411 = require("3ed6ccd55af875de");
const _temp412 = require("40a450e53195b2e3");
const _temp413 = require("a52bb6266381ca02");
const _temp414 = require("7f9442df855825cc");
const _temp415 = require("cbfe0f8843e0eb5b");
const _temp416 = require("22fa309fd56e3317");
const _temp417 = require("9f050e4353265ca5");
const _temp418 = require("1634e0d3236aed9e");
const _temp419 = require("e26809d17a45f13b");
const _temp420 = require("e896ef05348aff95");
const _temp421 = require("a4a6f8b57d6a6096");
const _temp422 = require("1e48aef9262402e");
const _temp423 = require("2e5c65ad1a4e2f87");
const _temp424 = require("1badd8ab246bfd91");
const _temp425 = require("b5ee649742fee723");
const _temp426 = require("eabe24565ef56d69");
const _temp427 = require("d7e32bc16ebbcf93");
const _temp428 = require("3894f5079bab8b58");
const _temp429 = require("225d0c5ed6870d3");
const _temp430 = require("2ec85e4fbf833a15");
const _temp431 = require("fdc592980b63c2fc");
const _temp432 = require("c9f4af221674ed35");
const _temp433 = require("b3ee7671323a8364");
const _temp434 = require("dd36c135d45eaa4e");
const _temp435 = require("af279847b5403cc3");
const _temp436 = require("46e0705ac021bf23");
const _temp437 = require("8bcb3910e42216f9");
const _temp438 = require("c9d51d956aceb102");
const _temp439 = require("64b8a718ed6f8219");
const _temp440 = require("bfebf7c9c5b1ad43");
const _temp441 = require("c5b5337c738e8667");
const _temp442 = require("e69f5b29a1ad3822");
const _temp443 = require("d4f7db0e6b334f04");
const _temp444 = require("175c8c82c8ba1ee4");
const _temp445 = require("c0227dd8fa738870");
const _temp446 = require("14fa9e03452ba884");
const _temp447 = require("10f7539ea40189dd");
const _temp448 = require("d910537909727a29");
const _temp449 = require("35687299ae19de4e");
const _temp450 = require("c29e8d68f7df6f28");
const _temp451 = require("7bb6625d2f04f350");
const _temp452 = require("481442ba14c91449");
const _temp453 = require("3690b44bf52cc926");
const _temp454 = require("8a1cc5db49ebf5fa");
const _temp455 = require("d67fc3e80cb496da");
const _temp456 = require("1618de67af6f6b38");
const _temp457 = require("5d924cc3fd49e26d");
const _temp458 = require("498055114fcfc10c");
const _temp459 = require("9c93d1c345406d86");
const _temp460 = require("a4e5b6966cdad8fd");
const _temp461 = require("5b9a091f47582cfe");
const _temp462 = require("13b19df7bc0d2842");
const _temp463 = require("b5f989cf3edba924");
const _temp464 = require("13bd5c3227218a9a");
const _temp465 = require("3ef82bd22ba73310");
const _temp466 = require("f198eba4692ab80f");
const _temp467 = require("6cfe4c2edcc51569");
const _temp468 = require("f01a72c010076aca");
const _temp469 = require("22535882cef679d6");
const _temp470 = require("e03bf5cf3c0f4f1b");
const _temp471 = require("8448f6ab3537fd62");
const _temp472 = require("c2940734ae34025f");
const _temp473 = require("7e804011bea7f9fb");
const _temp474 = require("dcff12dd9318bb4");
const _temp475 = require("9db5b7efd32bb878");
const _temp476 = require("d53795a943cd02cf");
const _temp477 = require("6322229a877531cd");
const _temp478 = require("dd8fd30c3ac0bf04");
const _temp479 = require("30acb1c06df3e129");
const _temp480 = require("ae08beda7f6be9da");
const _temp481 = require("ec1cc954c47850e0");
const _temp482 = require("1dddf28a25f2d236");
const _temp483 = require("c832c5b4a40e91dd");
const _temp484 = require("99f3b33f387370e");
const _temp485 = require("d6806b4987d7e36");
const _temp486 = require("f22623ee00bf1adc");
const _temp487 = require("8fe8255389580dbf");
const _temp488 = require("9746530083c6e863");
const _temp489 = require("acfe59a83e2e7c59");
const _temp490 = require("4f5a8958d6761a32");
const _temp491 = require("ff2e931ea40f731d");
const _temp492 = require("608b91e743deb7ad");
const _temp493 = require("939aa3091cadf642");
const _temp494 = require("e74e51d07a89b768");
const _temp495 = require("1ae60bb0f7d444a");
const _temp496 = require("20cde5cd5abc71b1");
const _temp497 = require("9adb509bc5658f3a");
const _temp498 = require("746a8789d6be32b4");
const _temp499 = require("7faaf2563c60078b");
const _temp500 = require("55c57135eecc683d");
const _temp501 = require("bd24a8fa4634bca1");
const _temp502 = require("bf49655e0bbb1ce5");
const _temp503 = require("55a554401d6712e4");
const _temp504 = require("83287674fb8c9e49");
const _temp505 = require("ab37ce3cb3e9f7f3");
const _temp506 = require("f82997ab061302d1");
const _temp507 = require("79c480453c9fcb3c");
const _temp508 = require("8df335a41a8e9f06");
const _temp509 = require("6515b7f7a49fd01f");
const _temp510 = require("c2938c36de24e99b");
const _temp511 = require("9450184fdc31f25f");
module.exports = {
    "Flama Book": {
        "0-255.pbf": _temp0,
        "1024-1279.pbf": _temp1,
        "10240-10495.pbf": _temp2,
        "10496-10751.pbf": _temp3,
        "10752-11007.pbf": _temp4,
        "11008-11263.pbf": _temp5,
        "11264-11519.pbf": _temp6,
        "11520-11775.pbf": _temp7,
        "11776-12031.pbf": _temp8,
        "12032-12287.pbf": _temp9,
        "12288-12543.pbf": _temp10,
        "12544-12799.pbf": _temp11,
        "1280-1535.pbf": _temp12,
        "12800-13055.pbf": _temp13,
        "13056-13311.pbf": _temp14,
        "13312-13567.pbf": _temp15,
        "13568-13823.pbf": _temp16,
        "13824-14079.pbf": _temp17,
        "14080-14335.pbf": _temp18,
        "14336-14591.pbf": _temp19,
        "14592-14847.pbf": _temp20,
        "14848-15103.pbf": _temp21,
        "15104-15359.pbf": _temp22,
        "1536-1791.pbf": _temp23,
        "15360-15615.pbf": _temp24,
        "15616-15871.pbf": _temp25,
        "15872-16127.pbf": _temp26,
        "16128-16383.pbf": _temp27,
        "16384-16639.pbf": _temp28,
        "16640-16895.pbf": _temp29,
        "16896-17151.pbf": _temp30,
        "17152-17407.pbf": _temp31,
        "17408-17663.pbf": _temp32,
        "17664-17919.pbf": _temp33,
        "1792-2047.pbf": _temp34,
        "17920-18175.pbf": _temp35,
        "18176-18431.pbf": _temp36,
        "18432-18687.pbf": _temp37,
        "18688-18943.pbf": _temp38,
        "18944-19199.pbf": _temp39,
        "19200-19455.pbf": _temp40,
        "19456-19711.pbf": _temp41,
        "19712-19967.pbf": _temp42,
        "19968-20223.pbf": _temp43,
        "20224-20479.pbf": _temp44,
        "2048-2303.pbf": _temp45,
        "20480-20735.pbf": _temp46,
        "20736-20991.pbf": _temp47,
        "20992-21247.pbf": _temp48,
        "21248-21503.pbf": _temp49,
        "21504-21759.pbf": _temp50,
        "21760-22015.pbf": _temp51,
        "22016-22271.pbf": _temp52,
        "22272-22527.pbf": _temp53,
        "22528-22783.pbf": _temp54,
        "22784-23039.pbf": _temp55,
        "2304-2559.pbf": _temp56,
        "23040-23295.pbf": _temp57,
        "23296-23551.pbf": _temp58,
        "23552-23807.pbf": _temp59,
        "23808-24063.pbf": _temp60,
        "24064-24319.pbf": _temp61,
        "24320-24575.pbf": _temp62,
        "24576-24831.pbf": _temp63,
        "24832-25087.pbf": _temp64,
        "25088-25343.pbf": _temp65,
        "25344-25599.pbf": _temp66,
        "256-511.pbf": _temp67,
        "2560-2815.pbf": _temp68,
        "25600-25855.pbf": _temp69,
        "25856-26111.pbf": _temp70,
        "26112-26367.pbf": _temp71,
        "26368-26623.pbf": _temp72,
        "26624-26879.pbf": _temp73,
        "26880-27135.pbf": _temp74,
        "27136-27391.pbf": _temp75,
        "27392-27647.pbf": _temp76,
        "27648-27903.pbf": _temp77,
        "27904-28159.pbf": _temp78,
        "2816-3071.pbf": _temp79,
        "28160-28415.pbf": _temp80,
        "28416-28671.pbf": _temp81,
        "28672-28927.pbf": _temp82,
        "28928-29183.pbf": _temp83,
        "29184-29439.pbf": _temp84,
        "29440-29695.pbf": _temp85,
        "29696-29951.pbf": _temp86,
        "29952-30207.pbf": _temp87,
        "30208-30463.pbf": _temp88,
        "30464-30719.pbf": _temp89,
        "3072-3327.pbf": _temp90,
        "30720-30975.pbf": _temp91,
        "30976-31231.pbf": _temp92,
        "31232-31487.pbf": _temp93,
        "31488-31743.pbf": _temp94,
        "31744-31999.pbf": _temp95,
        "32000-32255.pbf": _temp96,
        "32256-32511.pbf": _temp97,
        "32512-32767.pbf": _temp98,
        "32768-33023.pbf": _temp99,
        "33024-33279.pbf": _temp100,
        "3328-3583.pbf": _temp101,
        "33280-33535.pbf": _temp102,
        "33536-33791.pbf": _temp103,
        "33792-34047.pbf": _temp104,
        "34048-34303.pbf": _temp105,
        "34304-34559.pbf": _temp106,
        "34560-34815.pbf": _temp107,
        "34816-35071.pbf": _temp108,
        "35072-35327.pbf": _temp109,
        "35328-35583.pbf": _temp110,
        "35584-35839.pbf": _temp111,
        "3584-3839.pbf": _temp112,
        "35840-36095.pbf": _temp113,
        "36096-36351.pbf": _temp114,
        "36352-36607.pbf": _temp115,
        "36608-36863.pbf": _temp116,
        "36864-37119.pbf": _temp117,
        "37120-37375.pbf": _temp118,
        "37376-37631.pbf": _temp119,
        "37632-37887.pbf": _temp120,
        "37888-38143.pbf": _temp121,
        "38144-38399.pbf": _temp122,
        "3840-4095.pbf": _temp123,
        "38400-38655.pbf": _temp124,
        "38656-38911.pbf": _temp125,
        "38912-39167.pbf": _temp126,
        "39168-39423.pbf": _temp127,
        "39424-39679.pbf": _temp128,
        "39680-39935.pbf": _temp129,
        "39936-40191.pbf": _temp130,
        "40192-40447.pbf": _temp131,
        "40448-40703.pbf": _temp132,
        "40704-40959.pbf": _temp133,
        "4096-4351.pbf": _temp134,
        "40960-41215.pbf": _temp135,
        "41216-41471.pbf": _temp136,
        "41472-41727.pbf": _temp137,
        "41728-41983.pbf": _temp138,
        "41984-42239.pbf": _temp139,
        "42240-42495.pbf": _temp140,
        "42496-42751.pbf": _temp141,
        "42752-43007.pbf": _temp142,
        "43008-43263.pbf": _temp143,
        "43264-43519.pbf": _temp144,
        "4352-4607.pbf": _temp145,
        "43520-43775.pbf": _temp146,
        "43776-44031.pbf": _temp147,
        "44032-44287.pbf": _temp148,
        "44288-44543.pbf": _temp149,
        "44544-44799.pbf": _temp150,
        "44800-45055.pbf": _temp151,
        "45056-45311.pbf": _temp152,
        "45312-45567.pbf": _temp153,
        "45568-45823.pbf": _temp154,
        "45824-46079.pbf": _temp155,
        "4608-4863.pbf": _temp156,
        "46080-46335.pbf": _temp157,
        "46336-46591.pbf": _temp158,
        "46592-46847.pbf": _temp159,
        "46848-47103.pbf": _temp160,
        "47104-47359.pbf": _temp161,
        "47360-47615.pbf": _temp162,
        "47616-47871.pbf": _temp163,
        "47872-48127.pbf": _temp164,
        "48128-48383.pbf": _temp165,
        "48384-48639.pbf": _temp166,
        "4864-5119.pbf": _temp167,
        "48640-48895.pbf": _temp168,
        "48896-49151.pbf": _temp169,
        "49152-49407.pbf": _temp170,
        "49408-49663.pbf": _temp171,
        "49664-49919.pbf": _temp172,
        "49920-50175.pbf": _temp173,
        "50176-50431.pbf": _temp174,
        "50432-50687.pbf": _temp175,
        "50688-50943.pbf": _temp176,
        "50944-51199.pbf": _temp177,
        "512-767.pbf": _temp178,
        "5120-5375.pbf": _temp179,
        "51200-51455.pbf": _temp180,
        "51456-51711.pbf": _temp181,
        "51712-51967.pbf": _temp182,
        "51968-52223.pbf": _temp183,
        "52224-52479.pbf": _temp184,
        "52480-52735.pbf": _temp185,
        "52736-52991.pbf": _temp186,
        "52992-53247.pbf": _temp187,
        "53248-53503.pbf": _temp188,
        "53504-53759.pbf": _temp189,
        "5376-5631.pbf": _temp190,
        "53760-54015.pbf": _temp191,
        "54016-54271.pbf": _temp192,
        "54272-54527.pbf": _temp193,
        "54528-54783.pbf": _temp194,
        "54784-55039.pbf": _temp195,
        "55040-55295.pbf": _temp196,
        "55296-55551.pbf": _temp197,
        "55552-55807.pbf": _temp198,
        "55808-56063.pbf": _temp199,
        "56064-56319.pbf": _temp200,
        "5632-5887.pbf": _temp201,
        "56320-56575.pbf": _temp202,
        "56576-56831.pbf": _temp203,
        "56832-57087.pbf": _temp204,
        "57088-57343.pbf": _temp205,
        "57344-57599.pbf": _temp206,
        "57600-57855.pbf": _temp207,
        "57856-58111.pbf": _temp208,
        "58112-58367.pbf": _temp209,
        "58368-58623.pbf": _temp210,
        "58624-58879.pbf": _temp211,
        "5888-6143.pbf": _temp212,
        "58880-59135.pbf": _temp213,
        "59136-59391.pbf": _temp214,
        "59392-59647.pbf": _temp215,
        "59648-59903.pbf": _temp216,
        "59904-60159.pbf": _temp217,
        "60160-60415.pbf": _temp218,
        "60416-60671.pbf": _temp219,
        "60672-60927.pbf": _temp220,
        "60928-61183.pbf": _temp221,
        "61184-61439.pbf": _temp222,
        "6144-6399.pbf": _temp223,
        "61440-61695.pbf": _temp224,
        "61696-61951.pbf": _temp225,
        "61952-62207.pbf": _temp226,
        "62208-62463.pbf": _temp227,
        "62464-62719.pbf": _temp228,
        "62720-62975.pbf": _temp229,
        "62976-63231.pbf": _temp230,
        "63232-63487.pbf": _temp231,
        "63488-63743.pbf": _temp232,
        "63744-63999.pbf": _temp233,
        "6400-6655.pbf": _temp234,
        "64000-64255.pbf": _temp235,
        "64256-64511.pbf": _temp236,
        "64512-64767.pbf": _temp237,
        "64768-65023.pbf": _temp238,
        "65024-65279.pbf": _temp239,
        "65280-65535.pbf": _temp240,
        "6656-6911.pbf": _temp241,
        "6912-7167.pbf": _temp242,
        "7168-7423.pbf": _temp243,
        "7424-7679.pbf": _temp244,
        "768-1023.pbf": _temp245,
        "7680-7935.pbf": _temp246,
        "7936-8191.pbf": _temp247,
        "8192-8447.pbf": _temp248,
        "8448-8703.pbf": _temp249,
        "8704-8959.pbf": _temp250,
        "8960-9215.pbf": _temp251,
        "9216-9471.pbf": _temp252,
        "9472-9727.pbf": _temp253,
        "9728-9983.pbf": _temp254,
        "9984-10239.pbf": _temp255
    },
    "Flama Medium": {
        "0-255.pbf": _temp256,
        "1024-1279.pbf": _temp257,
        "10240-10495.pbf": _temp258,
        "10496-10751.pbf": _temp259,
        "10752-11007.pbf": _temp260,
        "11008-11263.pbf": _temp261,
        "11264-11519.pbf": _temp262,
        "11520-11775.pbf": _temp263,
        "11776-12031.pbf": _temp264,
        "12032-12287.pbf": _temp265,
        "12288-12543.pbf": _temp266,
        "12544-12799.pbf": _temp267,
        "1280-1535.pbf": _temp268,
        "12800-13055.pbf": _temp269,
        "13056-13311.pbf": _temp270,
        "13312-13567.pbf": _temp271,
        "13568-13823.pbf": _temp272,
        "13824-14079.pbf": _temp273,
        "14080-14335.pbf": _temp274,
        "14336-14591.pbf": _temp275,
        "14592-14847.pbf": _temp276,
        "14848-15103.pbf": _temp277,
        "15104-15359.pbf": _temp278,
        "1536-1791.pbf": _temp279,
        "15360-15615.pbf": _temp280,
        "15616-15871.pbf": _temp281,
        "15872-16127.pbf": _temp282,
        "16128-16383.pbf": _temp283,
        "16384-16639.pbf": _temp284,
        "16640-16895.pbf": _temp285,
        "16896-17151.pbf": _temp286,
        "17152-17407.pbf": _temp287,
        "17408-17663.pbf": _temp288,
        "17664-17919.pbf": _temp289,
        "1792-2047.pbf": _temp290,
        "17920-18175.pbf": _temp291,
        "18176-18431.pbf": _temp292,
        "18432-18687.pbf": _temp293,
        "18688-18943.pbf": _temp294,
        "18944-19199.pbf": _temp295,
        "19200-19455.pbf": _temp296,
        "19456-19711.pbf": _temp297,
        "19712-19967.pbf": _temp298,
        "19968-20223.pbf": _temp299,
        "20224-20479.pbf": _temp300,
        "2048-2303.pbf": _temp301,
        "20480-20735.pbf": _temp302,
        "20736-20991.pbf": _temp303,
        "20992-21247.pbf": _temp304,
        "21248-21503.pbf": _temp305,
        "21504-21759.pbf": _temp306,
        "21760-22015.pbf": _temp307,
        "22016-22271.pbf": _temp308,
        "22272-22527.pbf": _temp309,
        "22528-22783.pbf": _temp310,
        "22784-23039.pbf": _temp311,
        "2304-2559.pbf": _temp312,
        "23040-23295.pbf": _temp313,
        "23296-23551.pbf": _temp314,
        "23552-23807.pbf": _temp315,
        "23808-24063.pbf": _temp316,
        "24064-24319.pbf": _temp317,
        "24320-24575.pbf": _temp318,
        "24576-24831.pbf": _temp319,
        "24832-25087.pbf": _temp320,
        "25088-25343.pbf": _temp321,
        "25344-25599.pbf": _temp322,
        "256-511.pbf": _temp323,
        "2560-2815.pbf": _temp324,
        "25600-25855.pbf": _temp325,
        "25856-26111.pbf": _temp326,
        "26112-26367.pbf": _temp327,
        "26368-26623.pbf": _temp328,
        "26624-26879.pbf": _temp329,
        "26880-27135.pbf": _temp330,
        "27136-27391.pbf": _temp331,
        "27392-27647.pbf": _temp332,
        "27648-27903.pbf": _temp333,
        "27904-28159.pbf": _temp334,
        "2816-3071.pbf": _temp335,
        "28160-28415.pbf": _temp336,
        "28416-28671.pbf": _temp337,
        "28672-28927.pbf": _temp338,
        "28928-29183.pbf": _temp339,
        "29184-29439.pbf": _temp340,
        "29440-29695.pbf": _temp341,
        "29696-29951.pbf": _temp342,
        "29952-30207.pbf": _temp343,
        "30208-30463.pbf": _temp344,
        "30464-30719.pbf": _temp345,
        "3072-3327.pbf": _temp346,
        "30720-30975.pbf": _temp347,
        "30976-31231.pbf": _temp348,
        "31232-31487.pbf": _temp349,
        "31488-31743.pbf": _temp350,
        "31744-31999.pbf": _temp351,
        "32000-32255.pbf": _temp352,
        "32256-32511.pbf": _temp353,
        "32512-32767.pbf": _temp354,
        "32768-33023.pbf": _temp355,
        "33024-33279.pbf": _temp356,
        "3328-3583.pbf": _temp357,
        "33280-33535.pbf": _temp358,
        "33536-33791.pbf": _temp359,
        "33792-34047.pbf": _temp360,
        "34048-34303.pbf": _temp361,
        "34304-34559.pbf": _temp362,
        "34560-34815.pbf": _temp363,
        "34816-35071.pbf": _temp364,
        "35072-35327.pbf": _temp365,
        "35328-35583.pbf": _temp366,
        "35584-35839.pbf": _temp367,
        "3584-3839.pbf": _temp368,
        "35840-36095.pbf": _temp369,
        "36096-36351.pbf": _temp370,
        "36352-36607.pbf": _temp371,
        "36608-36863.pbf": _temp372,
        "36864-37119.pbf": _temp373,
        "37120-37375.pbf": _temp374,
        "37376-37631.pbf": _temp375,
        "37632-37887.pbf": _temp376,
        "37888-38143.pbf": _temp377,
        "38144-38399.pbf": _temp378,
        "3840-4095.pbf": _temp379,
        "38400-38655.pbf": _temp380,
        "38656-38911.pbf": _temp381,
        "38912-39167.pbf": _temp382,
        "39168-39423.pbf": _temp383,
        "39424-39679.pbf": _temp384,
        "39680-39935.pbf": _temp385,
        "39936-40191.pbf": _temp386,
        "40192-40447.pbf": _temp387,
        "40448-40703.pbf": _temp388,
        "40704-40959.pbf": _temp389,
        "4096-4351.pbf": _temp390,
        "40960-41215.pbf": _temp391,
        "41216-41471.pbf": _temp392,
        "41472-41727.pbf": _temp393,
        "41728-41983.pbf": _temp394,
        "41984-42239.pbf": _temp395,
        "42240-42495.pbf": _temp396,
        "42496-42751.pbf": _temp397,
        "42752-43007.pbf": _temp398,
        "43008-43263.pbf": _temp399,
        "43264-43519.pbf": _temp400,
        "4352-4607.pbf": _temp401,
        "43520-43775.pbf": _temp402,
        "43776-44031.pbf": _temp403,
        "44032-44287.pbf": _temp404,
        "44288-44543.pbf": _temp405,
        "44544-44799.pbf": _temp406,
        "44800-45055.pbf": _temp407,
        "45056-45311.pbf": _temp408,
        "45312-45567.pbf": _temp409,
        "45568-45823.pbf": _temp410,
        "45824-46079.pbf": _temp411,
        "4608-4863.pbf": _temp412,
        "46080-46335.pbf": _temp413,
        "46336-46591.pbf": _temp414,
        "46592-46847.pbf": _temp415,
        "46848-47103.pbf": _temp416,
        "47104-47359.pbf": _temp417,
        "47360-47615.pbf": _temp418,
        "47616-47871.pbf": _temp419,
        "47872-48127.pbf": _temp420,
        "48128-48383.pbf": _temp421,
        "48384-48639.pbf": _temp422,
        "4864-5119.pbf": _temp423,
        "48640-48895.pbf": _temp424,
        "48896-49151.pbf": _temp425,
        "49152-49407.pbf": _temp426,
        "49408-49663.pbf": _temp427,
        "49664-49919.pbf": _temp428,
        "49920-50175.pbf": _temp429,
        "50176-50431.pbf": _temp430,
        "50432-50687.pbf": _temp431,
        "50688-50943.pbf": _temp432,
        "50944-51199.pbf": _temp433,
        "512-767.pbf": _temp434,
        "5120-5375.pbf": _temp435,
        "51200-51455.pbf": _temp436,
        "51456-51711.pbf": _temp437,
        "51712-51967.pbf": _temp438,
        "51968-52223.pbf": _temp439,
        "52224-52479.pbf": _temp440,
        "52480-52735.pbf": _temp441,
        "52736-52991.pbf": _temp442,
        "52992-53247.pbf": _temp443,
        "53248-53503.pbf": _temp444,
        "53504-53759.pbf": _temp445,
        "5376-5631.pbf": _temp446,
        "53760-54015.pbf": _temp447,
        "54016-54271.pbf": _temp448,
        "54272-54527.pbf": _temp449,
        "54528-54783.pbf": _temp450,
        "54784-55039.pbf": _temp451,
        "55040-55295.pbf": _temp452,
        "55296-55551.pbf": _temp453,
        "55552-55807.pbf": _temp454,
        "55808-56063.pbf": _temp455,
        "56064-56319.pbf": _temp456,
        "5632-5887.pbf": _temp457,
        "56320-56575.pbf": _temp458,
        "56576-56831.pbf": _temp459,
        "56832-57087.pbf": _temp460,
        "57088-57343.pbf": _temp461,
        "57344-57599.pbf": _temp462,
        "57600-57855.pbf": _temp463,
        "57856-58111.pbf": _temp464,
        "58112-58367.pbf": _temp465,
        "58368-58623.pbf": _temp466,
        "58624-58879.pbf": _temp467,
        "5888-6143.pbf": _temp468,
        "58880-59135.pbf": _temp469,
        "59136-59391.pbf": _temp470,
        "59392-59647.pbf": _temp471,
        "59648-59903.pbf": _temp472,
        "59904-60159.pbf": _temp473,
        "60160-60415.pbf": _temp474,
        "60416-60671.pbf": _temp475,
        "60672-60927.pbf": _temp476,
        "60928-61183.pbf": _temp477,
        "61184-61439.pbf": _temp478,
        "6144-6399.pbf": _temp479,
        "61440-61695.pbf": _temp480,
        "61696-61951.pbf": _temp481,
        "61952-62207.pbf": _temp482,
        "62208-62463.pbf": _temp483,
        "62464-62719.pbf": _temp484,
        "62720-62975.pbf": _temp485,
        "62976-63231.pbf": _temp486,
        "63232-63487.pbf": _temp487,
        "63488-63743.pbf": _temp488,
        "63744-63999.pbf": _temp489,
        "6400-6655.pbf": _temp490,
        "64000-64255.pbf": _temp491,
        "64256-64511.pbf": _temp492,
        "64512-64767.pbf": _temp493,
        "64768-65023.pbf": _temp494,
        "65024-65279.pbf": _temp495,
        "65280-65535.pbf": _temp496,
        "6656-6911.pbf": _temp497,
        "6912-7167.pbf": _temp498,
        "7168-7423.pbf": _temp499,
        "7424-7679.pbf": _temp500,
        "768-1023.pbf": _temp501,
        "7680-7935.pbf": _temp502,
        "7936-8191.pbf": _temp503,
        "8192-8447.pbf": _temp504,
        "8448-8703.pbf": _temp505,
        "8704-8959.pbf": _temp506,
        "8960-9215.pbf": _temp507,
        "9216-9471.pbf": _temp508,
        "9472-9727.pbf": _temp509,
        "9728-9983.pbf": _temp510,
        "9984-10239.pbf": _temp511
    }
};

},{"eb14f00276bdd7b8":"edlMv","269369950901f68b":"f8og2","66b7dc4a6ed38856":"5Sekj","7103f2e6f4c535ab":"9PRL7","24920f96ab2187a8":"9RLO5","532c671f50b43e09":"hRZGG","a4f3d005cd2756a":"cNgNh","6262d990dc9cfa81":"fV2tV","8802e40319ac4662":"9tV3C","cb055fd51fed6e3":"hh74Z","33d5f17074d461db":"lcWT4","2c451c3ca1ceb3b0":"dhizu","c7e3da609d600b90":"fuNlM","c7201ce6c84dc333":"ffXGz","da71913a8a1006c3":"90EBC","6a67a00b2d92ecc0":"gQ3hy","274bf89516c199ee":"kVA4i","234f74d4591fd872":"8zOIw","9fdc7984fc2b7536":"54stz","10d806120ae77ed4":"d7LgI","a61ecb84ea79709e":"fcVXv","a57718dd9f3831dd":"km8oJ","f7b76cc473bb2656":"49TAc","bf7facc1e56dc270":"dusJ6","6f2531784f402d41":"fDOb6","b1793221b3db46e4":"7YmTD","b0726a16a668d188":"2m1v6","5c8c74e2a682f935":"8bLKg","f9f32e7d0ebad425":"F2rcV","761875583076959e":"ki0H0","76f98653ba6355ae":"hiLU9","41c14423e76e1198":"dCRnM","9cb67f8f686469d9":"9zzCj","b64a1a6b150e00f5":"jHxSn","bc494742dd291d55":"g6VSV","38377ab6ba0ff08d":"aIeV4","9f1958d926e07993":"kydhS","5c7e9d7474a6a7cf":"lu1q3","dc8abbd96c6ea7c1":"aAXRa","ca5323e82be5b917":"kujmz","210f5b150cc4c14a":"bTloZ","f96fcd623bc5f94a":"YEMTI","3d44d1cb2c5aeea":"5sNiV","361cc8a4a761ad76":"dOomG","45d7e94b501695b1":"kU8uH","3a6493f33f45abaa":"hda2O","2f6aefe284c02456":"76mZ0","869042492935dbba":"bOpC5","78d612b0b59f0d4e":"ehPvf","c4408c368048e89b":"EbnT1","52e30b18f0f6b91c":"hYyUs","95526412f7a496ff":"hxqOK","2704638a57be43e3":"inZ8S","158966bfcc08d259":"aPNQc","87ded1a5c224a4b6":"59o7m","c58ecb5831b32904":"5HyY7","712e0466b4a6de3d":"efngB","d3fdf71534f9248d":"klb0D","b849fa5c831c4946":"5n5YC","83a36c53b255f99d":"8Uaw7","d3825b27dbbfd88a":"gBPbG","583f2424b14eb849":"g0PHx","2a33a1a5fdc10d5c":"g9sEk","a31e1ab469947fab":"6Q1Bl","1fcb2f9e1ed9a7ad":"3ISOa","eccc1549fd16740f":"cNKPh","cd7916cd794d99de":"5eBvB","ab4ad9068f7ac43c":"kusmU","5c4d409bb09f170e":"hSEgc","8121595e62ce47a":"2DE5v","d7098297448be7f9":"b0otk","7fd0011de18ba372":"13XTu","78b7a3777a6b0089":"5zIWR","5bcac181d9532e58":"kLwbs","724fdb3deaaaf673":"akH0F","d2c4458b296cff7":"dI4X6","ac1f4ffdd5118eec":"2yA7i","5362975b0afea9b4":"gGgkr","736dc3d35373ee9d":"1oDtk","18946e2267b71599":"1AmuV","566afa6f7549cc0f":"fMRVU","6c33805dacee429b":"5OyTI","ca65f87fe3a38433":"clTbO","9dec4c1698a90776":"bhplO","7bb735383cfca062":"kBzl3","ffbc1dd4f82eb7ef":"7UC4Z","57daacf750a41709":"30RLd","b3b22be006e390a6":"hwtir","f0111c1c83957254":"7nuvX","bdc336b22905404b":"QUn26","186df628b8af5e0a":"d76vn","5e1b958bbb6b086b":"70WSW","257116eec8a6b933":"aEJcl","5a8419f1953ed5cf":"fKxWn","bf8ac06a1ef73d65":"iJ8RX","27506881f95fae19":"4RevP","42e4034fc253ec95":"bT7T4","9971ba9ee6d148e":"3y25E","50bf2d3a0731b8ab":"eJHyL","ea181f5b91e836ed":"jhduN","c59e527697b7b2ea":"9HbiD","70f08145cfecef32":"3b2Vx","c301dfe7816a2415":"8tCyq","6822bea612016cd":"cTxu9","41fbfa4946d2b36b":"3Kpt2","9e36ea8ccfb565ee":"aZgzF","ee3fc9864854a46":"kAuAz","6e554b08cb4a9b9":"edxp0","3bc3743e0ca1bc2":"6UPgh","ec0dcf37bef8dd67":"7UEV0","b0e118b2ef2e3d3c":"eopTO","ef26ad23a3c53d15":"9kyro","24129679968c9693":"h5Q5N","1dd20b690a71b9b0":"2Ekv4","a302ef30c3cf4b97":"4CfTh","134a6e3237d52c4":"k0oCo","6754cf2a38844df8":"erIZQ","2782cc57969cb6":"8qV3J","9b7c528f42c05cc3":"4fbda","68c1e262d0df21ea":"RAb30","4dbf9af4851ee6cc":"iDA5x","c9295b2821e2d170":"iApxy","9eef9790378ce5aa":"03Nkt","64dfcd5b3aa33062":"d0Cjj","61253d4251e53cf7":"li5M8","64f7ac3b95eee529":"d2AOs","945448e87c57275b":"9QZtL","1e1e1118511cd14d":"9ReLn","2b54bb9b7d723080":"lEYlu","5b342fde55902abd":"8ege4","482971891590f603":"hZ2kf","8abe4d755c9578ca":"5137C","77a61606265ac238":"8tUJx","3e3ea923cac80285":"gZN1I","d638afd285be5afe":"kmDD1","7f57cd38b4a527ca":"7PDAR","2c9c208542d6ad93":"bRtIW","e3e44b21a7853207":"3E4z5","8fa21f7d39eb0fc6":"ak3rf","dc047531556d1aae":"15Yzb","4a15ad9b9141526b":"hQiV5","cff9847356e8375b":"fUKZG","317550eb126e981e":"LvVLX","cee0d98ac6858477":"ejnKL","fda2b0b607550262":"1jxv2","84993257a224e452":"jFhhh","6f4452db4e74f321":"bROFp","5b5482d65644c9f6":"cggqq","8dadf1de22d6e266":"aOwbA","69a02e01f094186e":"kIxv1","1314147a268d289a":"2YXfC","5571c7bca31e6753":"lnUhD","6784657e2bd6bd63":"dks3Q","40906f19959fad46":"bWM6n","b5925282c4110581":"7N6CN","9e9d734d4363ff55":"lqWrn","22130490c8638cef":"6YnJh","c93c865896cd8255":"8kl94","741006c4a228547b":"2umKs","9dc5be4128243207":"6X0jy","43b8390bf62f151a":"a1rWJ","b8518e6f5689cd32":"bb8v3","89665c97e037838":"a7Zsp","f3663d2d1f2624b3":"dLn1W","bbe91b5090376b42":"lKHOT","2d6c0a8835d92dbe":"2V2c8","35bdd290a41087dc":"j5NMU","c5e84340e09af5f9":"jzIro","d9b2143e30c2ef51":"dpg3r","6a6bfc1c6e0733dc":"49pJ8","431b968db55b0177":"2gTj1","efdd96206dbadbc1":"ajgTh","d88881c468a51401":"28KLS","25a17b557309a300":"epzWd","83b6660afaef6355":"dMJJA","2f296f14af3935f2":"jPY5w","ef295eef53177513":"7HizV","a34d713718c9e2e8":"g0kWn","d0fbbaf249d1ba1e":"7b3i6","186c3ab5f7337433":"2CcdR","4636f4a7404734ce":"8CGAS","48599e1331b149af":"at4Sk","5785aaedb71e4beb":"8SW6p","c1578c7c77414fea":"jVOuB","b628db85e3a50adb":"66sAn","326298a636da5863":"fR8Ti","536e7101fe3c14f8":"6BaDE","678b7e7d0d8649b9":"2ES3F","b599ef96b90e9e50":"go2sC","2979830887559a70":"8je4B","ce2c34db6b1adc80":"jkvZy","e496decbe182da73":"dz72W","24bc121a06c2f002":"6sPPA","8bc81b39933986c8":"dUoYN","ddb7f2706d64b475":"jIVtg","663baeb224abb735":"gOynh","bad3ac959c18a491":"8INZU","688bd9f9a3e3dfd8":"7JbrA","5758b057dce7eceb":"kQncj","a6ff3166b282b4cf":"gKdO1","83864241f2d1abc9":"b7eFh","aa5cfffec1706142":"72vpG","c3aa548c0f66f766":"8Qpbi","8974ca90049ef152":"702Fd","ec0ef4a1a21cfe83":"IxTQy","b2a967b8d2aa6c30":"ikYGL","a975e6f0f0ddf0f4":"iBz9o","d299ba0ffdf0bec5":"aJSsp","136208c9f3bc9011":"cqbNb","f10643c7b31c6e6":"beFXW","1ab9f814e2e9b9e9":"5pQjx","4473981f3d1d0bb2":"c37E1","8d6e306059b28484":"6Gheq","81258b61d2848699":"800sg","9ebb33ec2fbd6399":"4TFll","725d183e4712b8cf":"McorA","891d897bd746a084":"9jJ7m","beb2f58893eeca50":"1bsiY","e79d252761eebe3":"42lDr","8cc4fc925da90cb1":"d0LW9","47b7012ce6f130dc":"5sFDY","de7e445b1eee6315":"5TNt0","19f59b5aaf121c53":"j2CJb","2e1fb7cbe08c50a1":"7exTo","9c92bfed745b5efe":"3IuhG","c5b4440345556f1d":"7k69a","73c2e755536cdd88":"1nh5t","e993de6725def9d2":"k5t5N","9f4bdcac8599167d":"4gtXF","bf1b28e19a24dd3f":"1BcOj","6b32fa0ec17e6dd2":"dW8eU","fe07fc9c7761e2c0":"k2jl2","a35ebdaab599e591":"4tC7x","86cb4300e7875184":"4ZCQd","831fc54db90b040a":"4VYBf","ec3145cb1d4f85ae":"h90Ea","bce501edfaf1171d":"j4dlz","1af0ea9d25a2cd6a":"kQQWT","b47cad552576b610":"b82R6","c27f9dcb7697388f":"kohLO","4eb66a8a9b5b95c":"kffSK","9f215cf1f5dffcb3":"aZGnW","721c3e51ea8a1dda":"7b13B","2c70a267997d9c7c":"gU5ti","3486559970599733":"lBgKW","fe359394d21256ab":"30FGG","ccc977c033c7aa3d":"ePCow","bc486fdc23a24586":"6fA5I","97cd4846c42bd6b8":"cxbp0","bad7c55398eec98d":"inacE","a51a9ec8edd24258":"38e5e","70d02f2de925219b":"jRL3T","1b5dbb72c60ea860":"fdR7W","b62337296a452f25":"aEO5V","a2a974e92b3beb6c":"h1J2o","bbbbf7478e70d8a1":"4NZpy","9e59e890e45178a4":"e1nSz","b9bed337dd21c151":"8rWK7","8c6bbc353201f33b":"rDB7Q","1f4eb5f6204fdda4":"fIgtA","5a22f12f8948155e":"8jcOr","bfa6ea08b695ca7f":"hmnGX","9dfc3fdd217cbef9":"5ZPco","2448e3d0dcdeffbf":"fieJj","a34cb07cbc59912f":"l24dL","e430fb64c588bb6c":"91V0P","2c59c3baefc48f6e":"4o1y7","1451f4305ce47b49":"i43yV","74adb35c3ae97541":"ko9Mx","1f2fe3dffc3938e9":"Fd8zl","401c173d001962e6":"cgQmi","19fe5598d38f518b":"dMvGF","38c596e473b11a8b":"9UcBj","f0dd9cdf6e84633c":"gqMKV","9fa35a29a546c9b9":"2ES8c","a63b2f483d109a":"6N1Lg","eda95b20028c6573":"cH08g","79350d30c9b74954":"a9VVa","5e10c1812ff30a91":"6u12y","c9099523b2cce10b":"axuVx","338bed7fe68a0c94":"2Yq6W","62b55b4e07fc9d57":"7i6m0","3ce38eafd0c30e27":"hMP3l","ee23ca013d4c1f5e":"gaKW6","a618adb9017ed125":"CG3cj","e1adf33c6be8951b":"dlUma","7e532ecf6d8ceaf":"gQiLQ","7c6d02edb920e07f":"s1Qqp","f2b58d7b8fd06456":"eHr0m","9efeee71818edcc3":"jJrs4","662e681e78929861":"YIDwU","7e0fa6041936907e":"gr0EA","4833d7b57a2b5187":"ddJtl","211837053a1005e7":"ed8gi","e82071d94c33b941":"jaIIr","d74a953d91fa0ba":"e32pW","b19a62f0d4987e24":"aI38O","d2bfad2faef32d73":"kZPBh","cc7277b366bb9c3e":"6D3Vu","df9162753b3d43dd":"e7t7O","808690d2caa875c6":"7XpeK","e5e820802e4df8c2":"23k0L","68c0b5241a6b3358":"3wuIg","e6121393afebea4":"eCEFg","c2c0dcb296074f3e":"8Y3Vd","d1c587d0bf4375e3":"14MCP","a1fcabbf9c7db982":"aN5Zi","2d2af77fd2ea1689":"jtWDI","9dcfd36a5b40f8a3":"9mpmN","db36ba0bd672d981":"ezcFb","d8a5a414ad207d3b":"1lUvQ","6f9732ea61c9cba1":"hkPLV","6d9b6fc20299e9d0":"lE7Nz","55b59e8868192d31":"jGaSi","5ccdc3def6af5ce6":"8mhK4","c6f6f5f02f7ba475":"iwkQo","92e42b0e8480f4df":"1kGnV","3e77b8153895b49c":"3iRN6","ef4c47a1f95207ce":"dphpD","ae208017d0420d2a":"jg3SA","87622cb26b029d1e":"7rnco","89bee5de72736454":"9ymmy","f2a6c791dd9c6c9f":"f6iwu","61d83776e1b35b12":"aHr67","944b31ca8f4d1ebd":"4HRXs","8437f9433741fdc9":"dhYji","5eba9d5405009922":"llO9F","61d7413a10f03252":"iXzBs","c5a1113d0b5db195":"iGz8Z","1cf0218204b8b07f":"fhsgZ","7bc3eef7f152fa9f":"d9Ptz","607cadf362eb9482":"ZEWaf","77752bc612560c2a":"9ggMw","908bf727711be540":"bi9od","4ec21b2a8ec30e54":"l9lcD","c09d0d32f94e6f54":"acCiJ","a4ba12d876a3b2d2":"5Ophs","3e06d9dea3ce69b2":"bFo6o","800386419b9b86a":"9Btsh","6c7c43964047c9d4":"3LaU2","a99c2e6f15e52aab":"lQNDy","31869e2191f61a90":"9BGuI","30ea8c6da6ec7302":"lOoIx","11b9a938afb166ba":"jUX7X","a0dfc6079d69400":"k3eSX","4a8408fc395fc6f0":"5L5I0","cb8fd30ed07f2bf":"cguG9","ce385115e88ba5ff":"8JIXN","8cebb3ff32b43bb3":"b71Bv","f974e5fb28bc3649":"3NxZz","c426d611531ab109":"eCHlM","42c43aabb8082df2":"2T1os","214c4930830043dc":"5EPll","50da58c3f37754eb":"btvIQ","c304922585f8f61c":"hkJdB","58fdfa5910037ae3":"44Yc9","960e34fabef3874b":"b4IRm","68d7029d448f2daf":"hScnS","2899fd4e4311896":"iJY1i","9110b0398183e2a3":"kAvEB","f292e365e89faee3":"7uAJF","5d09a17c5b7b6dea":"hIMBP","74d05c5fd92453d7":"ht4Gi","72d76f681ecf3642":"jXxvQ","250603e7ae4d62b0":"cXBoo","88ff192d7d114f9":"6qRk7","318426eeb9c275be":"aeBHQ","b0065b1630532f03":"1Btxd","43ff110c6c2feb18":"kThss","6ad23034c7541677":"ksL8V","c2ae2b4b52b991bf":"iv7VV","f01dcd9adad8a7dc":"ceOsE","d5c4527e2fd8d356":"h6rfs","5065c762bbaa8b88":"dzBBQ","d565bc720fe6c892":"f1VZn","9ef55f20e4f2cb96":"ikhXZ","1dac8df6d91dbb8a":"lecoY","43f19f50289c3d55":"lyrVM","ebbab81208ff7e43":"4CAug","a48b679191a96b48":"fgSR5","f9e642ce090ceb9f":"kNQ2N","307616d58965271e":"4RsgL","99d0e5c83a5b787":"dsNpo","7ac8cb0f984d4715":"j7OZd","a27d955ac5631466":"5gVHp","1ac43193e21d22a2":"biiJs","6b7a0103bb31b5e":"7T9bv","3de995ac515099bb":"cYzXG","48277e0201c6cecf":"6aZWZ","8ebba396d30181be":"67W8n","c7d1a4905bdd1b42":"djLmq","783b47de23e13d8b":"h6FOp","b5200714779093c5":"2a0ht","976313440f91c02c":"ajLU5","5cab174c63ed022d":"7EFiV","77d6b8da30b13964":"37U7a","98091d7b8778632c":"aOAqZ","97e1c29b82d64020":"eugQg","d9f11ea95551870c":"ayQW3","511471d35aab75ec":"iu9aZ","ca9af461c82c3a63":"6kNBR","125e27957b00290e":"dRlGB","f5945ea3b445d898":"d9g18","6fb0cc371ca25ff":"aXg0k","dd62abdfe20a6f60":"4y96d","d2fbe813c61aa5a3":"26I0a","57eb94bd4ab4113":"50fFv","b11f2e0d90e88996":"l4xTP","c2618aa176bc5580":"exa1L","891c1a53def623f6":"bmCIs","c0fe7502eaf847fa":"hGSe4","3ed6ccd55af875de":"bqjC1","40a450e53195b2e3":"eBTW8","a52bb6266381ca02":"f2EEa","7f9442df855825cc":"eJ7Xl","cbfe0f8843e0eb5b":"8dz5v","22fa309fd56e3317":"cxR9Y","9f050e4353265ca5":"97q1V","1634e0d3236aed9e":"5acTm","e26809d17a45f13b":"ls2Av","e896ef05348aff95":"3tYHl","a4a6f8b57d6a6096":"3s9oF","1e48aef9262402e":"81ALH","2e5c65ad1a4e2f87":"kSBX6","1badd8ab246bfd91":"5oegc","b5ee649742fee723":"jI2gM","eabe24565ef56d69":"lXgJz","d7e32bc16ebbcf93":"aEh7L","3894f5079bab8b58":"jKVlX","225d0c5ed6870d3":"5DVg0","2ec85e4fbf833a15":"kM4BS","fdc592980b63c2fc":"3nPGL","c9f4af221674ed35":"gEoaK","b3ee7671323a8364":"c1gk2","dd36c135d45eaa4e":"ky2Tm","af279847b5403cc3":"hoG41","46e0705ac021bf23":"9510O","8bcb3910e42216f9":"c92iG","c9d51d956aceb102":"QkGUZ","64b8a718ed6f8219":"03u3L","bfebf7c9c5b1ad43":"aN4gb","c5b5337c738e8667":"8KZIM","e69f5b29a1ad3822":"3rMmK","d4f7db0e6b334f04":"d2SXL","175c8c82c8ba1ee4":"hryhn","c0227dd8fa738870":"pOQSH","14fa9e03452ba884":"2DHWH","10f7539ea40189dd":"9b5SB","d910537909727a29":"bSjj1","35687299ae19de4e":"b8cjd","c29e8d68f7df6f28":"iA6vu","7bb6625d2f04f350":"8ZOff","481442ba14c91449":"8Jsqp","3690b44bf52cc926":"9shSQ","8a1cc5db49ebf5fa":"5pYzr","d67fc3e80cb496da":"SYlBc","1618de67af6f6b38":"29GX4","5d924cc3fd49e26d":"aXlJ7","498055114fcfc10c":"jLQMS","9c93d1c345406d86":"purh8","a4e5b6966cdad8fd":"l10lV","5b9a091f47582cfe":"ebsZx","13b19df7bc0d2842":"dkZfs","b5f989cf3edba924":"8vQ9f","13bd5c3227218a9a":"keOe8","3ef82bd22ba73310":"6n9y4","f198eba4692ab80f":"elwCL","6cfe4c2edcc51569":"dc5ix","f01a72c010076aca":"5bHCj","22535882cef679d6":"9TIZO","e03bf5cf3c0f4f1b":"2RoTn","8448f6ab3537fd62":"mETpr","c2940734ae34025f":"bQQ8F","7e804011bea7f9fb":"6iU4U","dcff12dd9318bb4":"g9r0D","9db5b7efd32bb878":"a7rkh","d53795a943cd02cf":"fI1TL","6322229a877531cd":"hsVyF","dd8fd30c3ac0bf04":"h5k6x","30acb1c06df3e129":"496xS","ae08beda7f6be9da":"aextB","ec1cc954c47850e0":"3271z","1dddf28a25f2d236":"7zz5P","c832c5b4a40e91dd":"atoZb","99f3b33f387370e":"bw4iW","d6806b4987d7e36":"hX6jp","f22623ee00bf1adc":"gCVRt","8fe8255389580dbf":"lY719","9746530083c6e863":"bXODx","acfe59a83e2e7c59":"8C7jb","4f5a8958d6761a32":"3Csv5","ff2e931ea40f731d":"1NgzW","608b91e743deb7ad":"i3jhg","939aa3091cadf642":"2U1hU","e74e51d07a89b768":"9MbPa","1ae60bb0f7d444a":"7s5DZ","20cde5cd5abc71b1":"lqN3Z","9adb509bc5658f3a":"gOZxQ","746a8789d6be32b4":"kBhwY","7faaf2563c60078b":"eQefu","55c57135eecc683d":"8VQ0m","bd24a8fa4634bca1":"cBtss","bf49655e0bbb1ce5":"51utm","55a554401d6712e4":"jR6dY","83287674fb8c9e49":"kWOm3","ab37ce3cb3e9f7f3":"4BDA1","f82997ab061302d1":"Tbk86","79c480453c9fcb3c":"1R6Xq","8df335a41a8e9f06":"1Jjiq","6515b7f7a49fd01f":"4zTln","c2938c36de24e99b":"ioPHM","9450184fdc31f25f":"4yV54"}],"edlMv":[function(require,module,exports,__globalThis) {
module.exports = require("e56fe82342029b1b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/0-255.pbf";

},{"e56fe82342029b1b":"dqXhb"}],"f8og2":[function(require,module,exports,__globalThis) {
module.exports = require("8daa41dc80c41aae").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/1024-1279.pbf";

},{"8daa41dc80c41aae":"dqXhb"}],"5Sekj":[function(require,module,exports,__globalThis) {
module.exports = require("3b3c1e16ca541f").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/10240-10495.pbf";

},{"3b3c1e16ca541f":"dqXhb"}],"9PRL7":[function(require,module,exports,__globalThis) {
module.exports = require("c605dd17cf04c428").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/10496-10751.pbf";

},{"c605dd17cf04c428":"dqXhb"}],"9RLO5":[function(require,module,exports,__globalThis) {
module.exports = require("c1e64203e112ffff").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/10752-11007.pbf";

},{"c1e64203e112ffff":"dqXhb"}],"hRZGG":[function(require,module,exports,__globalThis) {
module.exports = require("5d84554aba04a1f7").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/11008-11263.pbf";

},{"5d84554aba04a1f7":"dqXhb"}],"cNgNh":[function(require,module,exports,__globalThis) {
module.exports = require("375f391ebe12e486").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/11264-11519.pbf";

},{"375f391ebe12e486":"dqXhb"}],"fV2tV":[function(require,module,exports,__globalThis) {
module.exports = require("d5dd21bdca3b4982").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/11520-11775.pbf";

},{"d5dd21bdca3b4982":"dqXhb"}],"9tV3C":[function(require,module,exports,__globalThis) {
module.exports = require("fd87903e58219d25").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/11776-12031.pbf";

},{"fd87903e58219d25":"dqXhb"}],"hh74Z":[function(require,module,exports,__globalThis) {
module.exports = require("7d65d4065becf19b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/12032-12287.pbf";

},{"7d65d4065becf19b":"dqXhb"}],"lcWT4":[function(require,module,exports,__globalThis) {
module.exports = require("7b53cff96a9bec09").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/12288-12543.pbf";

},{"7b53cff96a9bec09":"dqXhb"}],"dhizu":[function(require,module,exports,__globalThis) {
module.exports = require("aad6200c4223de0c").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/12544-12799.pbf";

},{"aad6200c4223de0c":"dqXhb"}],"fuNlM":[function(require,module,exports,__globalThis) {
module.exports = require("dd790a63e0297c35").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/1280-1535.pbf";

},{"dd790a63e0297c35":"dqXhb"}],"ffXGz":[function(require,module,exports,__globalThis) {
module.exports = require("c08094dc00a85f75").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/12800-13055.pbf";

},{"c08094dc00a85f75":"dqXhb"}],"90EBC":[function(require,module,exports,__globalThis) {
module.exports = require("324c2b32eb985e3c").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/13056-13311.pbf";

},{"324c2b32eb985e3c":"dqXhb"}],"gQ3hy":[function(require,module,exports,__globalThis) {
module.exports = require("d4bde232057a5116").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/13312-13567.pbf";

},{"d4bde232057a5116":"dqXhb"}],"kVA4i":[function(require,module,exports,__globalThis) {
module.exports = require("6b2651cf3de148a1").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/13568-13823.pbf";

},{"6b2651cf3de148a1":"dqXhb"}],"8zOIw":[function(require,module,exports,__globalThis) {
module.exports = require("1cf11b43f478da92").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/13824-14079.pbf";

},{"1cf11b43f478da92":"dqXhb"}],"54stz":[function(require,module,exports,__globalThis) {
module.exports = require("2125f80e8db111dc").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/14080-14335.pbf";

},{"2125f80e8db111dc":"dqXhb"}],"d7LgI":[function(require,module,exports,__globalThis) {
module.exports = require("9a19ace74111aa76").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/14336-14591.pbf";

},{"9a19ace74111aa76":"dqXhb"}],"fcVXv":[function(require,module,exports,__globalThis) {
module.exports = require("e62c5ac673e85cbc").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/14592-14847.pbf";

},{"e62c5ac673e85cbc":"dqXhb"}],"km8oJ":[function(require,module,exports,__globalThis) {
module.exports = require("8b02b1bc474f98d7").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/14848-15103.pbf";

},{"8b02b1bc474f98d7":"dqXhb"}],"49TAc":[function(require,module,exports,__globalThis) {
module.exports = require("60d03d887e6bb353").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/15104-15359.pbf";

},{"60d03d887e6bb353":"dqXhb"}],"dusJ6":[function(require,module,exports,__globalThis) {
module.exports = require("5eefd97b7e4262d1").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/1536-1791.pbf";

},{"5eefd97b7e4262d1":"dqXhb"}],"fDOb6":[function(require,module,exports,__globalThis) {
module.exports = require("bd37f533f8d0b422").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/15360-15615.pbf";

},{"bd37f533f8d0b422":"dqXhb"}],"7YmTD":[function(require,module,exports,__globalThis) {
module.exports = require("65491f3674de0375").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/15616-15871.pbf";

},{"65491f3674de0375":"dqXhb"}],"2m1v6":[function(require,module,exports,__globalThis) {
module.exports = require("be126522b8e22fbe").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/15872-16127.pbf";

},{"be126522b8e22fbe":"dqXhb"}],"8bLKg":[function(require,module,exports,__globalThis) {
module.exports = require("3f2db34dbbd8f381").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/16128-16383.pbf";

},{"3f2db34dbbd8f381":"dqXhb"}],"F2rcV":[function(require,module,exports,__globalThis) {
module.exports = require("14f0178bb01a9f8c").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/16384-16639.pbf";

},{"14f0178bb01a9f8c":"dqXhb"}],"ki0H0":[function(require,module,exports,__globalThis) {
module.exports = require("24bf838fcdf5b270").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/16640-16895.pbf";

},{"24bf838fcdf5b270":"dqXhb"}],"hiLU9":[function(require,module,exports,__globalThis) {
module.exports = require("7fac569ccc1c9346").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/16896-17151.pbf";

},{"7fac569ccc1c9346":"dqXhb"}],"dCRnM":[function(require,module,exports,__globalThis) {
module.exports = require("c465eac8acb0637a").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/17152-17407.pbf";

},{"c465eac8acb0637a":"dqXhb"}],"9zzCj":[function(require,module,exports,__globalThis) {
module.exports = require("a117da25a8aebbc2").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/17408-17663.pbf";

},{"a117da25a8aebbc2":"dqXhb"}],"jHxSn":[function(require,module,exports,__globalThis) {
module.exports = require("608167a9e4bf52c6").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/17664-17919.pbf";

},{"608167a9e4bf52c6":"dqXhb"}],"g6VSV":[function(require,module,exports,__globalThis) {
module.exports = require("b2a9e6217ad9ecab").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/1792-2047.pbf";

},{"b2a9e6217ad9ecab":"dqXhb"}],"aIeV4":[function(require,module,exports,__globalThis) {
module.exports = require("c2fbe571b1fffe35").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/17920-18175.pbf";

},{"c2fbe571b1fffe35":"dqXhb"}],"kydhS":[function(require,module,exports,__globalThis) {
module.exports = require("8ae9435be62151fd").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/18176-18431.pbf";

},{"8ae9435be62151fd":"dqXhb"}],"lu1q3":[function(require,module,exports,__globalThis) {
module.exports = require("1a8cbb186238558f").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/18432-18687.pbf";

},{"1a8cbb186238558f":"dqXhb"}],"aAXRa":[function(require,module,exports,__globalThis) {
module.exports = require("acc1ac121752474c").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/18688-18943.pbf";

},{"acc1ac121752474c":"dqXhb"}],"kujmz":[function(require,module,exports,__globalThis) {
module.exports = require("c5ff8f545668fd1d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/18944-19199.pbf";

},{"c5ff8f545668fd1d":"dqXhb"}],"bTloZ":[function(require,module,exports,__globalThis) {
module.exports = require("a92e9b0c369cedb").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/19200-19455.pbf";

},{"a92e9b0c369cedb":"dqXhb"}],"YEMTI":[function(require,module,exports,__globalThis) {
module.exports = require("28ddf1c544806ab9").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/19456-19711.pbf";

},{"28ddf1c544806ab9":"dqXhb"}],"5sNiV":[function(require,module,exports,__globalThis) {
module.exports = require("1f84c65e37615eca").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/19712-19967.pbf";

},{"1f84c65e37615eca":"dqXhb"}],"dOomG":[function(require,module,exports,__globalThis) {
module.exports = require("105d5f02729f4816").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/19968-20223.pbf";

},{"105d5f02729f4816":"dqXhb"}],"kU8uH":[function(require,module,exports,__globalThis) {
module.exports = require("a753e4d93eef355a").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/20224-20479.pbf";

},{"a753e4d93eef355a":"dqXhb"}],"hda2O":[function(require,module,exports,__globalThis) {
module.exports = require("ce42082fa95b97e0").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/2048-2303.pbf";

},{"ce42082fa95b97e0":"dqXhb"}],"76mZ0":[function(require,module,exports,__globalThis) {
module.exports = require("7032e7bc9ae5a184").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/20480-20735.pbf";

},{"7032e7bc9ae5a184":"dqXhb"}],"bOpC5":[function(require,module,exports,__globalThis) {
module.exports = require("fca02e7d542ca294").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/20736-20991.pbf";

},{"fca02e7d542ca294":"dqXhb"}],"ehPvf":[function(require,module,exports,__globalThis) {
module.exports = require("e3be6d3e6fda41ba").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/20992-21247.pbf";

},{"e3be6d3e6fda41ba":"dqXhb"}],"EbnT1":[function(require,module,exports,__globalThis) {
module.exports = require("63620cd8ae63ced2").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/21248-21503.pbf";

},{"63620cd8ae63ced2":"dqXhb"}],"hYyUs":[function(require,module,exports,__globalThis) {
module.exports = require("b1962d8d27ac8f67").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/21504-21759.pbf";

},{"b1962d8d27ac8f67":"dqXhb"}],"hxqOK":[function(require,module,exports,__globalThis) {
module.exports = require("80e5919a8f8484d8").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/21760-22015.pbf";

},{"80e5919a8f8484d8":"dqXhb"}],"inZ8S":[function(require,module,exports,__globalThis) {
module.exports = require("5ac2bacd01001caf").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/22016-22271.pbf";

},{"5ac2bacd01001caf":"dqXhb"}],"aPNQc":[function(require,module,exports,__globalThis) {
module.exports = require("dc1995937d762811").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/22272-22527.pbf";

},{"dc1995937d762811":"dqXhb"}],"59o7m":[function(require,module,exports,__globalThis) {
module.exports = require("baead0dec6760a74").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/22528-22783.pbf";

},{"baead0dec6760a74":"dqXhb"}],"5HyY7":[function(require,module,exports,__globalThis) {
module.exports = require("b6055c553b988512").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/22784-23039.pbf";

},{"b6055c553b988512":"dqXhb"}],"efngB":[function(require,module,exports,__globalThis) {
module.exports = require("6522e9b2ab9d11ac").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/2304-2559.pbf";

},{"6522e9b2ab9d11ac":"dqXhb"}],"klb0D":[function(require,module,exports,__globalThis) {
module.exports = require("8b0d3c7e306f0300").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/23040-23295.pbf";

},{"8b0d3c7e306f0300":"dqXhb"}],"5n5YC":[function(require,module,exports,__globalThis) {
module.exports = require("d732f6b4e0c9125e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/23296-23551.pbf";

},{"d732f6b4e0c9125e":"dqXhb"}],"8Uaw7":[function(require,module,exports,__globalThis) {
module.exports = require("f00f5e35ce31f7dd").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/23552-23807.pbf";

},{"f00f5e35ce31f7dd":"dqXhb"}],"gBPbG":[function(require,module,exports,__globalThis) {
module.exports = require("f1bd1a3615391582").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/23808-24063.pbf";

},{"f1bd1a3615391582":"dqXhb"}],"g0PHx":[function(require,module,exports,__globalThis) {
module.exports = require("37f904f532b8a67e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/24064-24319.pbf";

},{"37f904f532b8a67e":"dqXhb"}],"g9sEk":[function(require,module,exports,__globalThis) {
module.exports = require("6007c760b66154b7").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/24320-24575.pbf";

},{"6007c760b66154b7":"dqXhb"}],"6Q1Bl":[function(require,module,exports,__globalThis) {
module.exports = require("775646740da02a44").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/24576-24831.pbf";

},{"775646740da02a44":"dqXhb"}],"3ISOa":[function(require,module,exports,__globalThis) {
module.exports = require("6a20fb218e2852e9").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/24832-25087.pbf";

},{"6a20fb218e2852e9":"dqXhb"}],"cNKPh":[function(require,module,exports,__globalThis) {
module.exports = require("467a58ae0d25b145").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/25088-25343.pbf";

},{"467a58ae0d25b145":"dqXhb"}],"5eBvB":[function(require,module,exports,__globalThis) {
module.exports = require("47027206f217f37e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/25344-25599.pbf";

},{"47027206f217f37e":"dqXhb"}],"kusmU":[function(require,module,exports,__globalThis) {
module.exports = require("b186104c36d1ff65").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/256-511.pbf";

},{"b186104c36d1ff65":"dqXhb"}],"hSEgc":[function(require,module,exports,__globalThis) {
module.exports = require("2d8006fb16c4b518").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/2560-2815.pbf";

},{"2d8006fb16c4b518":"dqXhb"}],"2DE5v":[function(require,module,exports,__globalThis) {
module.exports = require("f089ff72795ca2e1").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/25600-25855.pbf";

},{"f089ff72795ca2e1":"dqXhb"}],"b0otk":[function(require,module,exports,__globalThis) {
module.exports = require("320afc50455d576b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/25856-26111.pbf";

},{"320afc50455d576b":"dqXhb"}],"13XTu":[function(require,module,exports,__globalThis) {
module.exports = require("868117c9ba4f9943").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/26112-26367.pbf";

},{"868117c9ba4f9943":"dqXhb"}],"5zIWR":[function(require,module,exports,__globalThis) {
module.exports = require("8a56b772e75c57b5").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/26368-26623.pbf";

},{"8a56b772e75c57b5":"dqXhb"}],"kLwbs":[function(require,module,exports,__globalThis) {
module.exports = require("8ba6c394f633c325").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/26624-26879.pbf";

},{"8ba6c394f633c325":"dqXhb"}],"akH0F":[function(require,module,exports,__globalThis) {
module.exports = require("d22a1fccf51e5e79").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/26880-27135.pbf";

},{"d22a1fccf51e5e79":"dqXhb"}],"dI4X6":[function(require,module,exports,__globalThis) {
module.exports = require("f06d446f584fdc72").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/27136-27391.pbf";

},{"f06d446f584fdc72":"dqXhb"}],"2yA7i":[function(require,module,exports,__globalThis) {
module.exports = require("87ac8958976454ed").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/27392-27647.pbf";

},{"87ac8958976454ed":"dqXhb"}],"gGgkr":[function(require,module,exports,__globalThis) {
module.exports = require("1fe96aaf42d91e07").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/27648-27903.pbf";

},{"1fe96aaf42d91e07":"dqXhb"}],"1oDtk":[function(require,module,exports,__globalThis) {
module.exports = require("d902560c3aafd9b1").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/27904-28159.pbf";

},{"d902560c3aafd9b1":"dqXhb"}],"1AmuV":[function(require,module,exports,__globalThis) {
module.exports = require("e2270a8d6ff9d215").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/2816-3071.pbf";

},{"e2270a8d6ff9d215":"dqXhb"}],"fMRVU":[function(require,module,exports,__globalThis) {
module.exports = require("308fb367947d9b87").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/28160-28415.pbf";

},{"308fb367947d9b87":"dqXhb"}],"5OyTI":[function(require,module,exports,__globalThis) {
module.exports = require("d56fa2e220366831").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/28416-28671.pbf";

},{"d56fa2e220366831":"dqXhb"}],"clTbO":[function(require,module,exports,__globalThis) {
module.exports = require("fe5cc28cc7595ec4").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/28672-28927.pbf";

},{"fe5cc28cc7595ec4":"dqXhb"}],"bhplO":[function(require,module,exports,__globalThis) {
module.exports = require("8f1c5f5ec2b6449").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/28928-29183.pbf";

},{"8f1c5f5ec2b6449":"dqXhb"}],"kBzl3":[function(require,module,exports,__globalThis) {
module.exports = require("d13c8b1cff594515").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/29184-29439.pbf";

},{"d13c8b1cff594515":"dqXhb"}],"7UC4Z":[function(require,module,exports,__globalThis) {
module.exports = require("ec552022ff284a38").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/29440-29695.pbf";

},{"ec552022ff284a38":"dqXhb"}],"30RLd":[function(require,module,exports,__globalThis) {
module.exports = require("6e36e2e290b63d25").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/29696-29951.pbf";

},{"6e36e2e290b63d25":"dqXhb"}],"hwtir":[function(require,module,exports,__globalThis) {
module.exports = require("689a17014bcaab57").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/29952-30207.pbf";

},{"689a17014bcaab57":"dqXhb"}],"7nuvX":[function(require,module,exports,__globalThis) {
module.exports = require("4f1852c9d51701b7").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/30208-30463.pbf";

},{"4f1852c9d51701b7":"dqXhb"}],"QUn26":[function(require,module,exports,__globalThis) {
module.exports = require("d06ae5dfd692e14b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/30464-30719.pbf";

},{"d06ae5dfd692e14b":"dqXhb"}],"d76vn":[function(require,module,exports,__globalThis) {
module.exports = require("d8f925f571e9d411").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/3072-3327.pbf";

},{"d8f925f571e9d411":"dqXhb"}],"70WSW":[function(require,module,exports,__globalThis) {
module.exports = require("3263613b2494c268").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/30720-30975.pbf";

},{"3263613b2494c268":"dqXhb"}],"aEJcl":[function(require,module,exports,__globalThis) {
module.exports = require("d05cbdd3615bb17e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/30976-31231.pbf";

},{"d05cbdd3615bb17e":"dqXhb"}],"fKxWn":[function(require,module,exports,__globalThis) {
module.exports = require("c7e7307a7aa1081").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/31232-31487.pbf";

},{"c7e7307a7aa1081":"dqXhb"}],"iJ8RX":[function(require,module,exports,__globalThis) {
module.exports = require("5e302d85b68e5eff").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/31488-31743.pbf";

},{"5e302d85b68e5eff":"dqXhb"}],"4RevP":[function(require,module,exports,__globalThis) {
module.exports = require("c12c1d6a954062e0").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/31744-31999.pbf";

},{"c12c1d6a954062e0":"dqXhb"}],"bT7T4":[function(require,module,exports,__globalThis) {
module.exports = require("46d719e28c39bdad").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/32000-32255.pbf";

},{"46d719e28c39bdad":"dqXhb"}],"3y25E":[function(require,module,exports,__globalThis) {
module.exports = require("3a70700d3c8c476d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/32256-32511.pbf";

},{"3a70700d3c8c476d":"dqXhb"}],"eJHyL":[function(require,module,exports,__globalThis) {
module.exports = require("3366529de61f78cd").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/32512-32767.pbf";

},{"3366529de61f78cd":"dqXhb"}],"jhduN":[function(require,module,exports,__globalThis) {
module.exports = require("2eda48c129b68d2").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/32768-33023.pbf";

},{"2eda48c129b68d2":"dqXhb"}],"9HbiD":[function(require,module,exports,__globalThis) {
module.exports = require("d67fffcd028cecab").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/33024-33279.pbf";

},{"d67fffcd028cecab":"dqXhb"}],"3b2Vx":[function(require,module,exports,__globalThis) {
module.exports = require("9d455c95a32026de").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/3328-3583.pbf";

},{"9d455c95a32026de":"dqXhb"}],"8tCyq":[function(require,module,exports,__globalThis) {
module.exports = require("f348715c6efb69d9").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/33280-33535.pbf";

},{"f348715c6efb69d9":"dqXhb"}],"cTxu9":[function(require,module,exports,__globalThis) {
module.exports = require("3cf3b7cfeaacc1af").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/33536-33791.pbf";

},{"3cf3b7cfeaacc1af":"dqXhb"}],"3Kpt2":[function(require,module,exports,__globalThis) {
module.exports = require("e4fee3f570a25e55").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/33792-34047.pbf";

},{"e4fee3f570a25e55":"dqXhb"}],"aZgzF":[function(require,module,exports,__globalThis) {
module.exports = require("d5645b51e668e3f0").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/34048-34303.pbf";

},{"d5645b51e668e3f0":"dqXhb"}],"kAuAz":[function(require,module,exports,__globalThis) {
module.exports = require("db3826c2279a3d4").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/34304-34559.pbf";

},{"db3826c2279a3d4":"dqXhb"}],"edxp0":[function(require,module,exports,__globalThis) {
module.exports = require("3620abafec0b661e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/34560-34815.pbf";

},{"3620abafec0b661e":"dqXhb"}],"6UPgh":[function(require,module,exports,__globalThis) {
module.exports = require("ebacd0555ee4d2a6").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/34816-35071.pbf";

},{"ebacd0555ee4d2a6":"dqXhb"}],"7UEV0":[function(require,module,exports,__globalThis) {
module.exports = require("c3a69f416933938d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/35072-35327.pbf";

},{"c3a69f416933938d":"dqXhb"}],"eopTO":[function(require,module,exports,__globalThis) {
module.exports = require("454b96849f696f8c").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/35328-35583.pbf";

},{"454b96849f696f8c":"dqXhb"}],"9kyro":[function(require,module,exports,__globalThis) {
module.exports = require("eac1936d8af87856").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/35584-35839.pbf";

},{"eac1936d8af87856":"dqXhb"}],"h5Q5N":[function(require,module,exports,__globalThis) {
module.exports = require("577cded7c1770b53").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/3584-3839.pbf";

},{"577cded7c1770b53":"dqXhb"}],"2Ekv4":[function(require,module,exports,__globalThis) {
module.exports = require("70bb755fdfeccc6b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/35840-36095.pbf";

},{"70bb755fdfeccc6b":"dqXhb"}],"4CfTh":[function(require,module,exports,__globalThis) {
module.exports = require("784c5debaf53fcd4").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/36096-36351.pbf";

},{"784c5debaf53fcd4":"dqXhb"}],"k0oCo":[function(require,module,exports,__globalThis) {
module.exports = require("ac1aadd1e59b9346").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/36352-36607.pbf";

},{"ac1aadd1e59b9346":"dqXhb"}],"erIZQ":[function(require,module,exports,__globalThis) {
module.exports = require("2926df2fc9cbe760").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/36608-36863.pbf";

},{"2926df2fc9cbe760":"dqXhb"}],"8qV3J":[function(require,module,exports,__globalThis) {
module.exports = require("23c18a70669cbc0a").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/36864-37119.pbf";

},{"23c18a70669cbc0a":"dqXhb"}],"4fbda":[function(require,module,exports,__globalThis) {
module.exports = require("cb786be864e2cae1").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/37120-37375.pbf";

},{"cb786be864e2cae1":"dqXhb"}],"RAb30":[function(require,module,exports,__globalThis) {
module.exports = require("fd5174d138b09e1b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/37376-37631.pbf";

},{"fd5174d138b09e1b":"dqXhb"}],"iDA5x":[function(require,module,exports,__globalThis) {
module.exports = require("3316fbb5a8440ef4").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/37632-37887.pbf";

},{"3316fbb5a8440ef4":"dqXhb"}],"iApxy":[function(require,module,exports,__globalThis) {
module.exports = require("c1b4831486cce3b6").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/37888-38143.pbf";

},{"c1b4831486cce3b6":"dqXhb"}],"03Nkt":[function(require,module,exports,__globalThis) {
module.exports = require("e95e1ff1216241e4").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/38144-38399.pbf";

},{"e95e1ff1216241e4":"dqXhb"}],"d0Cjj":[function(require,module,exports,__globalThis) {
module.exports = require("364a2aec3f4ce31b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/3840-4095.pbf";

},{"364a2aec3f4ce31b":"dqXhb"}],"li5M8":[function(require,module,exports,__globalThis) {
module.exports = require("602aa8b5eaeb33df").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/38400-38655.pbf";

},{"602aa8b5eaeb33df":"dqXhb"}],"d2AOs":[function(require,module,exports,__globalThis) {
module.exports = require("90ce240e571fe867").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/38656-38911.pbf";

},{"90ce240e571fe867":"dqXhb"}],"9QZtL":[function(require,module,exports,__globalThis) {
module.exports = require("dd5df5ccdddf8105").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/38912-39167.pbf";

},{"dd5df5ccdddf8105":"dqXhb"}],"9ReLn":[function(require,module,exports,__globalThis) {
module.exports = require("28ef6c81656c2ac4").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/39168-39423.pbf";

},{"28ef6c81656c2ac4":"dqXhb"}],"lEYlu":[function(require,module,exports,__globalThis) {
module.exports = require("8eae76eab3c6051f").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/39424-39679.pbf";

},{"8eae76eab3c6051f":"dqXhb"}],"8ege4":[function(require,module,exports,__globalThis) {
module.exports = require("341598a3cac900b9").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/39680-39935.pbf";

},{"341598a3cac900b9":"dqXhb"}],"hZ2kf":[function(require,module,exports,__globalThis) {
module.exports = require("33167be3b0db630e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/39936-40191.pbf";

},{"33167be3b0db630e":"dqXhb"}],"5137C":[function(require,module,exports,__globalThis) {
module.exports = require("6fb10a7079e6a80c").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/40192-40447.pbf";

},{"6fb10a7079e6a80c":"dqXhb"}],"8tUJx":[function(require,module,exports,__globalThis) {
module.exports = require("e9e24b1934076f0").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/40448-40703.pbf";

},{"e9e24b1934076f0":"dqXhb"}],"gZN1I":[function(require,module,exports,__globalThis) {
module.exports = require("e6ff17fb562a31af").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/40704-40959.pbf";

},{"e6ff17fb562a31af":"dqXhb"}],"kmDD1":[function(require,module,exports,__globalThis) {
module.exports = require("6966177bd76ddfa3").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/4096-4351.pbf";

},{"6966177bd76ddfa3":"dqXhb"}],"7PDAR":[function(require,module,exports,__globalThis) {
module.exports = require("3f64c772a8d1a138").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/40960-41215.pbf";

},{"3f64c772a8d1a138":"dqXhb"}],"bRtIW":[function(require,module,exports,__globalThis) {
module.exports = require("25a2db02ffa73a6f").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/41216-41471.pbf";

},{"25a2db02ffa73a6f":"dqXhb"}],"3E4z5":[function(require,module,exports,__globalThis) {
module.exports = require("96f914acd12deac7").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/41472-41727.pbf";

},{"96f914acd12deac7":"dqXhb"}],"ak3rf":[function(require,module,exports,__globalThis) {
module.exports = require("66c04a3759b43c0c").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/41728-41983.pbf";

},{"66c04a3759b43c0c":"dqXhb"}],"15Yzb":[function(require,module,exports,__globalThis) {
module.exports = require("36171869afeafe6").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/41984-42239.pbf";

},{"36171869afeafe6":"dqXhb"}],"hQiV5":[function(require,module,exports,__globalThis) {
module.exports = require("b4e393d801a5703a").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/42240-42495.pbf";

},{"b4e393d801a5703a":"dqXhb"}],"fUKZG":[function(require,module,exports,__globalThis) {
module.exports = require("ac540c14ee14f88").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/42496-42751.pbf";

},{"ac540c14ee14f88":"dqXhb"}],"LvVLX":[function(require,module,exports,__globalThis) {
module.exports = require("8527a6d9b8826fea").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/42752-43007.pbf";

},{"8527a6d9b8826fea":"dqXhb"}],"ejnKL":[function(require,module,exports,__globalThis) {
module.exports = require("e9132ac8e2ca3af8").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/43008-43263.pbf";

},{"e9132ac8e2ca3af8":"dqXhb"}],"1jxv2":[function(require,module,exports,__globalThis) {
module.exports = require("a726e23711aa7b5e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/43264-43519.pbf";

},{"a726e23711aa7b5e":"dqXhb"}],"jFhhh":[function(require,module,exports,__globalThis) {
module.exports = require("acd353a4eb3ea305").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/4352-4607.pbf";

},{"acd353a4eb3ea305":"dqXhb"}],"bROFp":[function(require,module,exports,__globalThis) {
module.exports = require("ba80612ee36e4d6c").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/43520-43775.pbf";

},{"ba80612ee36e4d6c":"dqXhb"}],"cggqq":[function(require,module,exports,__globalThis) {
module.exports = require("688f3fc3da465e21").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/43776-44031.pbf";

},{"688f3fc3da465e21":"dqXhb"}],"aOwbA":[function(require,module,exports,__globalThis) {
module.exports = require("a69faff72bb563f9").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/44032-44287.pbf";

},{"a69faff72bb563f9":"dqXhb"}],"kIxv1":[function(require,module,exports,__globalThis) {
module.exports = require("9ed841c0c239a17b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/44288-44543.pbf";

},{"9ed841c0c239a17b":"dqXhb"}],"2YXfC":[function(require,module,exports,__globalThis) {
module.exports = require("65fd6a2e89a635fc").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/44544-44799.pbf";

},{"65fd6a2e89a635fc":"dqXhb"}],"lnUhD":[function(require,module,exports,__globalThis) {
module.exports = require("d0f9f67206269e04").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/44800-45055.pbf";

},{"d0f9f67206269e04":"dqXhb"}],"dks3Q":[function(require,module,exports,__globalThis) {
module.exports = require("4966030c473a85c8").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/45056-45311.pbf";

},{"4966030c473a85c8":"dqXhb"}],"bWM6n":[function(require,module,exports,__globalThis) {
module.exports = require("c782dcc5051b7d6a").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/45312-45567.pbf";

},{"c782dcc5051b7d6a":"dqXhb"}],"7N6CN":[function(require,module,exports,__globalThis) {
module.exports = require("b6c2aab39dbadd8f").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/45568-45823.pbf";

},{"b6c2aab39dbadd8f":"dqXhb"}],"lqWrn":[function(require,module,exports,__globalThis) {
module.exports = require("af9414aae8723297").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/45824-46079.pbf";

},{"af9414aae8723297":"dqXhb"}],"6YnJh":[function(require,module,exports,__globalThis) {
module.exports = require("6cad64b60fe4b4da").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/4608-4863.pbf";

},{"6cad64b60fe4b4da":"dqXhb"}],"8kl94":[function(require,module,exports,__globalThis) {
module.exports = require("c341ecdb0036f7c6").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/46080-46335.pbf";

},{"c341ecdb0036f7c6":"dqXhb"}],"2umKs":[function(require,module,exports,__globalThis) {
module.exports = require("7b38f01fecc7e329").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/46336-46591.pbf";

},{"7b38f01fecc7e329":"dqXhb"}],"6X0jy":[function(require,module,exports,__globalThis) {
module.exports = require("503e1839cd3f42dc").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/46592-46847.pbf";

},{"503e1839cd3f42dc":"dqXhb"}],"a1rWJ":[function(require,module,exports,__globalThis) {
module.exports = require("b712e4e83736ffa3").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/46848-47103.pbf";

},{"b712e4e83736ffa3":"dqXhb"}],"bb8v3":[function(require,module,exports,__globalThis) {
module.exports = require("f8a5b0a52e77d778").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/47104-47359.pbf";

},{"f8a5b0a52e77d778":"dqXhb"}],"a7Zsp":[function(require,module,exports,__globalThis) {
module.exports = require("21a841cda4044a2d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/47360-47615.pbf";

},{"21a841cda4044a2d":"dqXhb"}],"dLn1W":[function(require,module,exports,__globalThis) {
module.exports = require("cab0038efa3dea9e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/47616-47871.pbf";

},{"cab0038efa3dea9e":"dqXhb"}],"lKHOT":[function(require,module,exports,__globalThis) {
module.exports = require("454ed5c2edcd2384").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/47872-48127.pbf";

},{"454ed5c2edcd2384":"dqXhb"}],"2V2c8":[function(require,module,exports,__globalThis) {
module.exports = require("1ee3750ddb4313bd").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/48128-48383.pbf";

},{"1ee3750ddb4313bd":"dqXhb"}],"j5NMU":[function(require,module,exports,__globalThis) {
module.exports = require("f476a12c71abeb42").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/48384-48639.pbf";

},{"f476a12c71abeb42":"dqXhb"}],"jzIro":[function(require,module,exports,__globalThis) {
module.exports = require("5ab4b87f37dea82d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/4864-5119.pbf";

},{"5ab4b87f37dea82d":"dqXhb"}],"dpg3r":[function(require,module,exports,__globalThis) {
module.exports = require("ab611ee56f59bf0b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/48640-48895.pbf";

},{"ab611ee56f59bf0b":"dqXhb"}],"49pJ8":[function(require,module,exports,__globalThis) {
module.exports = require("7a8ab2db12e6a291").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/48896-49151.pbf";

},{"7a8ab2db12e6a291":"dqXhb"}],"2gTj1":[function(require,module,exports,__globalThis) {
module.exports = require("44c59bf4437fca72").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/49152-49407.pbf";

},{"44c59bf4437fca72":"dqXhb"}],"ajgTh":[function(require,module,exports,__globalThis) {
module.exports = require("fe274de1748dd256").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/49408-49663.pbf";

},{"fe274de1748dd256":"dqXhb"}],"28KLS":[function(require,module,exports,__globalThis) {
module.exports = require("31c9f570c80385ee").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/49664-49919.pbf";

},{"31c9f570c80385ee":"dqXhb"}],"epzWd":[function(require,module,exports,__globalThis) {
module.exports = require("2506286415e5dcd3").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/49920-50175.pbf";

},{"2506286415e5dcd3":"dqXhb"}],"dMJJA":[function(require,module,exports,__globalThis) {
module.exports = require("362dde623b6cc8e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/50176-50431.pbf";

},{"362dde623b6cc8e":"dqXhb"}],"jPY5w":[function(require,module,exports,__globalThis) {
module.exports = require("348aceaa96e703e0").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/50432-50687.pbf";

},{"348aceaa96e703e0":"dqXhb"}],"7HizV":[function(require,module,exports,__globalThis) {
module.exports = require("f14aea8b59824529").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/50688-50943.pbf";

},{"f14aea8b59824529":"dqXhb"}],"g0kWn":[function(require,module,exports,__globalThis) {
module.exports = require("98cdb274959be678").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/50944-51199.pbf";

},{"98cdb274959be678":"dqXhb"}],"7b3i6":[function(require,module,exports,__globalThis) {
module.exports = require("60f440120ea59aa0").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/512-767.pbf";

},{"60f440120ea59aa0":"dqXhb"}],"2CcdR":[function(require,module,exports,__globalThis) {
module.exports = require("b61b35d93b97e9b4").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/5120-5375.pbf";

},{"b61b35d93b97e9b4":"dqXhb"}],"8CGAS":[function(require,module,exports,__globalThis) {
module.exports = require("663826536029964f").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/51200-51455.pbf";

},{"663826536029964f":"dqXhb"}],"at4Sk":[function(require,module,exports,__globalThis) {
module.exports = require("bc3d6b9ad1d4367b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/51456-51711.pbf";

},{"bc3d6b9ad1d4367b":"dqXhb"}],"8SW6p":[function(require,module,exports,__globalThis) {
module.exports = require("1b956b27e57321b5").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/51712-51967.pbf";

},{"1b956b27e57321b5":"dqXhb"}],"jVOuB":[function(require,module,exports,__globalThis) {
module.exports = require("7ea3cb0d22b51d14").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/51968-52223.pbf";

},{"7ea3cb0d22b51d14":"dqXhb"}],"66sAn":[function(require,module,exports,__globalThis) {
module.exports = require("5d4f44062c25c266").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/52224-52479.pbf";

},{"5d4f44062c25c266":"dqXhb"}],"fR8Ti":[function(require,module,exports,__globalThis) {
module.exports = require("a0a4c0354729ce0e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/52480-52735.pbf";

},{"a0a4c0354729ce0e":"dqXhb"}],"6BaDE":[function(require,module,exports,__globalThis) {
module.exports = require("39f9ade10a571efc").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/52736-52991.pbf";

},{"39f9ade10a571efc":"dqXhb"}],"2ES3F":[function(require,module,exports,__globalThis) {
module.exports = require("42a7fbbcf5c26166").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/52992-53247.pbf";

},{"42a7fbbcf5c26166":"dqXhb"}],"go2sC":[function(require,module,exports,__globalThis) {
module.exports = require("767c5ce711bd6168").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/53248-53503.pbf";

},{"767c5ce711bd6168":"dqXhb"}],"8je4B":[function(require,module,exports,__globalThis) {
module.exports = require("723bf91db4ba2586").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/53504-53759.pbf";

},{"723bf91db4ba2586":"dqXhb"}],"jkvZy":[function(require,module,exports,__globalThis) {
module.exports = require("fc89ec6c849e7eba").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/5376-5631.pbf";

},{"fc89ec6c849e7eba":"dqXhb"}],"dz72W":[function(require,module,exports,__globalThis) {
module.exports = require("e3bc56f7ac359296").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/53760-54015.pbf";

},{"e3bc56f7ac359296":"dqXhb"}],"6sPPA":[function(require,module,exports,__globalThis) {
module.exports = require("44d5e8cdcff38190").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/54016-54271.pbf";

},{"44d5e8cdcff38190":"dqXhb"}],"dUoYN":[function(require,module,exports,__globalThis) {
module.exports = require("5d212dddf898260b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/54272-54527.pbf";

},{"5d212dddf898260b":"dqXhb"}],"jIVtg":[function(require,module,exports,__globalThis) {
module.exports = require("adc5a63ba8fb9742").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/54528-54783.pbf";

},{"adc5a63ba8fb9742":"dqXhb"}],"gOynh":[function(require,module,exports,__globalThis) {
module.exports = require("db9cbf2dc4adcbd4").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/54784-55039.pbf";

},{"db9cbf2dc4adcbd4":"dqXhb"}],"8INZU":[function(require,module,exports,__globalThis) {
module.exports = require("dcbfe3a4e8a9b61b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/55040-55295.pbf";

},{"dcbfe3a4e8a9b61b":"dqXhb"}],"7JbrA":[function(require,module,exports,__globalThis) {
module.exports = require("945f2cf8294f5180").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/55296-55551.pbf";

},{"945f2cf8294f5180":"dqXhb"}],"kQncj":[function(require,module,exports,__globalThis) {
module.exports = require("26de575aeb4e4a41").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/55552-55807.pbf";

},{"26de575aeb4e4a41":"dqXhb"}],"gKdO1":[function(require,module,exports,__globalThis) {
module.exports = require("cab1586a51395d00").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/55808-56063.pbf";

},{"cab1586a51395d00":"dqXhb"}],"b7eFh":[function(require,module,exports,__globalThis) {
module.exports = require("43ca40d5937e5ac4").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/56064-56319.pbf";

},{"43ca40d5937e5ac4":"dqXhb"}],"72vpG":[function(require,module,exports,__globalThis) {
module.exports = require("87ef7fa8ec01e015").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/5632-5887.pbf";

},{"87ef7fa8ec01e015":"dqXhb"}],"8Qpbi":[function(require,module,exports,__globalThis) {
module.exports = require("50c24c9cc1a264a6").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/56320-56575.pbf";

},{"50c24c9cc1a264a6":"dqXhb"}],"702Fd":[function(require,module,exports,__globalThis) {
module.exports = require("c29684c91249d1b2").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/56576-56831.pbf";

},{"c29684c91249d1b2":"dqXhb"}],"IxTQy":[function(require,module,exports,__globalThis) {
module.exports = require("6fd8ddd48d076606").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/56832-57087.pbf";

},{"6fd8ddd48d076606":"dqXhb"}],"ikYGL":[function(require,module,exports,__globalThis) {
module.exports = require("4444b662b4624504").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/57088-57343.pbf";

},{"4444b662b4624504":"dqXhb"}],"iBz9o":[function(require,module,exports,__globalThis) {
module.exports = require("8fc393cfeabe6683").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/57344-57599.pbf";

},{"8fc393cfeabe6683":"dqXhb"}],"aJSsp":[function(require,module,exports,__globalThis) {
module.exports = require("64877b25092ddcf9").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/57600-57855.pbf";

},{"64877b25092ddcf9":"dqXhb"}],"cqbNb":[function(require,module,exports,__globalThis) {
module.exports = require("5763140710c4b7d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/57856-58111.pbf";

},{"5763140710c4b7d":"dqXhb"}],"beFXW":[function(require,module,exports,__globalThis) {
module.exports = require("8d80b4d1a27a0ed0").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/58112-58367.pbf";

},{"8d80b4d1a27a0ed0":"dqXhb"}],"5pQjx":[function(require,module,exports,__globalThis) {
module.exports = require("fe41b7a552571ea0").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/58368-58623.pbf";

},{"fe41b7a552571ea0":"dqXhb"}],"c37E1":[function(require,module,exports,__globalThis) {
module.exports = require("e217f3ba8616c657").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/58624-58879.pbf";

},{"e217f3ba8616c657":"dqXhb"}],"6Gheq":[function(require,module,exports,__globalThis) {
module.exports = require("8ad49d12a2df279b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/5888-6143.pbf";

},{"8ad49d12a2df279b":"dqXhb"}],"800sg":[function(require,module,exports,__globalThis) {
module.exports = require("cadbc5881dafc48").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/58880-59135.pbf";

},{"cadbc5881dafc48":"dqXhb"}],"4TFll":[function(require,module,exports,__globalThis) {
module.exports = require("f620e1b3c1a6d302").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/59136-59391.pbf";

},{"f620e1b3c1a6d302":"dqXhb"}],"McorA":[function(require,module,exports,__globalThis) {
module.exports = require("d68ce4eebf650a2b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/59392-59647.pbf";

},{"d68ce4eebf650a2b":"dqXhb"}],"9jJ7m":[function(require,module,exports,__globalThis) {
module.exports = require("7fed441bc4650bc9").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/59648-59903.pbf";

},{"7fed441bc4650bc9":"dqXhb"}],"1bsiY":[function(require,module,exports,__globalThis) {
module.exports = require("de8be0c78daca307").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/59904-60159.pbf";

},{"de8be0c78daca307":"dqXhb"}],"42lDr":[function(require,module,exports,__globalThis) {
module.exports = require("e99a48ebed28fa8").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/60160-60415.pbf";

},{"e99a48ebed28fa8":"dqXhb"}],"d0LW9":[function(require,module,exports,__globalThis) {
module.exports = require("c4cbea30dd11a30e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/60416-60671.pbf";

},{"c4cbea30dd11a30e":"dqXhb"}],"5sFDY":[function(require,module,exports,__globalThis) {
module.exports = require("863c2acbd834d68d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/60672-60927.pbf";

},{"863c2acbd834d68d":"dqXhb"}],"5TNt0":[function(require,module,exports,__globalThis) {
module.exports = require("4685c42d46ff1566").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/60928-61183.pbf";

},{"4685c42d46ff1566":"dqXhb"}],"j2CJb":[function(require,module,exports,__globalThis) {
module.exports = require("b585c395488fda92").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/61184-61439.pbf";

},{"b585c395488fda92":"dqXhb"}],"7exTo":[function(require,module,exports,__globalThis) {
module.exports = require("24f94c168c32eaf5").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/6144-6399.pbf";

},{"24f94c168c32eaf5":"dqXhb"}],"3IuhG":[function(require,module,exports,__globalThis) {
module.exports = require("1c2664088ceb613f").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/61440-61695.pbf";

},{"1c2664088ceb613f":"dqXhb"}],"7k69a":[function(require,module,exports,__globalThis) {
module.exports = require("ce04f1b952a5dab0").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/61696-61951.pbf";

},{"ce04f1b952a5dab0":"dqXhb"}],"1nh5t":[function(require,module,exports,__globalThis) {
module.exports = require("7333f9ab1dc77066").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/61952-62207.pbf";

},{"7333f9ab1dc77066":"dqXhb"}],"k5t5N":[function(require,module,exports,__globalThis) {
module.exports = require("29d29dd22dc4e73").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/62208-62463.pbf";

},{"29d29dd22dc4e73":"dqXhb"}],"4gtXF":[function(require,module,exports,__globalThis) {
module.exports = require("82c376f468ce1edd").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/62464-62719.pbf";

},{"82c376f468ce1edd":"dqXhb"}],"1BcOj":[function(require,module,exports,__globalThis) {
module.exports = require("130294daca1b3af").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/62720-62975.pbf";

},{"130294daca1b3af":"dqXhb"}],"dW8eU":[function(require,module,exports,__globalThis) {
module.exports = require("8697958b778c77c4").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/62976-63231.pbf";

},{"8697958b778c77c4":"dqXhb"}],"k2jl2":[function(require,module,exports,__globalThis) {
module.exports = require("8af8ab245e617694").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/63232-63487.pbf";

},{"8af8ab245e617694":"dqXhb"}],"4tC7x":[function(require,module,exports,__globalThis) {
module.exports = require("ee652e4fdfc15362").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/63488-63743.pbf";

},{"ee652e4fdfc15362":"dqXhb"}],"4ZCQd":[function(require,module,exports,__globalThis) {
module.exports = require("9264251c9c26c516").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/63744-63999.pbf";

},{"9264251c9c26c516":"dqXhb"}],"4VYBf":[function(require,module,exports,__globalThis) {
module.exports = require("1ed1faf29a578c38").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/6400-6655.pbf";

},{"1ed1faf29a578c38":"dqXhb"}],"h90Ea":[function(require,module,exports,__globalThis) {
module.exports = require("70877ca8bc9a2602").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/64000-64255.pbf";

},{"70877ca8bc9a2602":"dqXhb"}],"j4dlz":[function(require,module,exports,__globalThis) {
module.exports = require("785786fd02abbdcf").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/64256-64511.pbf";

},{"785786fd02abbdcf":"dqXhb"}],"kQQWT":[function(require,module,exports,__globalThis) {
module.exports = require("b8247c76297e712d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/64512-64767.pbf";

},{"b8247c76297e712d":"dqXhb"}],"b82R6":[function(require,module,exports,__globalThis) {
module.exports = require("4a95e332a26d2ede").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/64768-65023.pbf";

},{"4a95e332a26d2ede":"dqXhb"}],"kohLO":[function(require,module,exports,__globalThis) {
module.exports = require("1be41f4f13dda463").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/65024-65279.pbf";

},{"1be41f4f13dda463":"dqXhb"}],"kffSK":[function(require,module,exports,__globalThis) {
module.exports = require("7d741d4eb4640fce").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/65280-65535.pbf";

},{"7d741d4eb4640fce":"dqXhb"}],"aZGnW":[function(require,module,exports,__globalThis) {
module.exports = require("ecd042d11d2dde15").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/6656-6911.pbf";

},{"ecd042d11d2dde15":"dqXhb"}],"7b13B":[function(require,module,exports,__globalThis) {
module.exports = require("4c58cf0b2644e513").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/6912-7167.pbf";

},{"4c58cf0b2644e513":"dqXhb"}],"gU5ti":[function(require,module,exports,__globalThis) {
module.exports = require("2a266d017d5cc362").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/7168-7423.pbf";

},{"2a266d017d5cc362":"dqXhb"}],"lBgKW":[function(require,module,exports,__globalThis) {
module.exports = require("6230f3f06abca120").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/7424-7679.pbf";

},{"6230f3f06abca120":"dqXhb"}],"30FGG":[function(require,module,exports,__globalThis) {
module.exports = require("85cfa376ce7e96fa").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/768-1023.pbf";

},{"85cfa376ce7e96fa":"dqXhb"}],"ePCow":[function(require,module,exports,__globalThis) {
module.exports = require("6e7d6d0438bd4dc9").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/7680-7935.pbf";

},{"6e7d6d0438bd4dc9":"dqXhb"}],"6fA5I":[function(require,module,exports,__globalThis) {
module.exports = require("6cbf6db787724d6e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/7936-8191.pbf";

},{"6cbf6db787724d6e":"dqXhb"}],"cxbp0":[function(require,module,exports,__globalThis) {
module.exports = require("816a3e2def2ba4a5").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/8192-8447.pbf";

},{"816a3e2def2ba4a5":"dqXhb"}],"inacE":[function(require,module,exports,__globalThis) {
module.exports = require("d7423e6c5b5f38fd").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/8448-8703.pbf";

},{"d7423e6c5b5f38fd":"dqXhb"}],"38e5e":[function(require,module,exports,__globalThis) {
module.exports = require("109521b918cd8bb1").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/8704-8959.pbf";

},{"109521b918cd8bb1":"dqXhb"}],"jRL3T":[function(require,module,exports,__globalThis) {
module.exports = require("97a66c414a402a1f").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/8960-9215.pbf";

},{"97a66c414a402a1f":"dqXhb"}],"fdR7W":[function(require,module,exports,__globalThis) {
module.exports = require("4e5d831cd8d2f4d5").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/9216-9471.pbf";

},{"4e5d831cd8d2f4d5":"dqXhb"}],"aEO5V":[function(require,module,exports,__globalThis) {
module.exports = require("ccb271d2e310b6c2").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/9472-9727.pbf";

},{"ccb271d2e310b6c2":"dqXhb"}],"h1J2o":[function(require,module,exports,__globalThis) {
module.exports = require("25b864b8893e50ae").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/9728-9983.pbf";

},{"25b864b8893e50ae":"dqXhb"}],"4NZpy":[function(require,module,exports,__globalThis) {
module.exports = require("7f200265014685db").getBundleURL('2c9kW') + "../fonts/pbf/Flama Book/9984-10239.pbf";

},{"7f200265014685db":"dqXhb"}],"e1nSz":[function(require,module,exports,__globalThis) {
module.exports = require("a60f302bc726a28d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/0-255.pbf";

},{"a60f302bc726a28d":"dqXhb"}],"8rWK7":[function(require,module,exports,__globalThis) {
module.exports = require("595a63f923e3f5eb").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/1024-1279.pbf";

},{"595a63f923e3f5eb":"dqXhb"}],"rDB7Q":[function(require,module,exports,__globalThis) {
module.exports = require("54e15874a0c929c2").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/10240-10495.pbf";

},{"54e15874a0c929c2":"dqXhb"}],"fIgtA":[function(require,module,exports,__globalThis) {
module.exports = require("7faca66328a52071").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/10496-10751.pbf";

},{"7faca66328a52071":"dqXhb"}],"8jcOr":[function(require,module,exports,__globalThis) {
module.exports = require("f26396ed5da48c1c").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/10752-11007.pbf";

},{"f26396ed5da48c1c":"dqXhb"}],"hmnGX":[function(require,module,exports,__globalThis) {
module.exports = require("964cdc1e047f0c63").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/11008-11263.pbf";

},{"964cdc1e047f0c63":"dqXhb"}],"5ZPco":[function(require,module,exports,__globalThis) {
module.exports = require("78dc8ea0f9d62eb3").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/11264-11519.pbf";

},{"78dc8ea0f9d62eb3":"dqXhb"}],"fieJj":[function(require,module,exports,__globalThis) {
module.exports = require("e06dea665122a87").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/11520-11775.pbf";

},{"e06dea665122a87":"dqXhb"}],"l24dL":[function(require,module,exports,__globalThis) {
module.exports = require("a564b1ec8cea5749").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/11776-12031.pbf";

},{"a564b1ec8cea5749":"dqXhb"}],"91V0P":[function(require,module,exports,__globalThis) {
module.exports = require("bfb5e1e48795d43e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/12032-12287.pbf";

},{"bfb5e1e48795d43e":"dqXhb"}],"4o1y7":[function(require,module,exports,__globalThis) {
module.exports = require("1be820e849a09963").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/12288-12543.pbf";

},{"1be820e849a09963":"dqXhb"}],"i43yV":[function(require,module,exports,__globalThis) {
module.exports = require("f2ae0e63094303f9").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/12544-12799.pbf";

},{"f2ae0e63094303f9":"dqXhb"}],"ko9Mx":[function(require,module,exports,__globalThis) {
module.exports = require("ece4e2763c39df1e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/1280-1535.pbf";

},{"ece4e2763c39df1e":"dqXhb"}],"Fd8zl":[function(require,module,exports,__globalThis) {
module.exports = require("b06e58c7577d0a0b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/12800-13055.pbf";

},{"b06e58c7577d0a0b":"dqXhb"}],"cgQmi":[function(require,module,exports,__globalThis) {
module.exports = require("c69d6deb2042db1e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/13056-13311.pbf";

},{"c69d6deb2042db1e":"dqXhb"}],"dMvGF":[function(require,module,exports,__globalThis) {
module.exports = require("ec567d7a0345d78a").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/13312-13567.pbf";

},{"ec567d7a0345d78a":"dqXhb"}],"9UcBj":[function(require,module,exports,__globalThis) {
module.exports = require("a5f4a60a0f249d41").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/13568-13823.pbf";

},{"a5f4a60a0f249d41":"dqXhb"}],"gqMKV":[function(require,module,exports,__globalThis) {
module.exports = require("3264b229e28e37b3").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/13824-14079.pbf";

},{"3264b229e28e37b3":"dqXhb"}],"2ES8c":[function(require,module,exports,__globalThis) {
module.exports = require("c09d3ce2e3bb0229").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/14080-14335.pbf";

},{"c09d3ce2e3bb0229":"dqXhb"}],"6N1Lg":[function(require,module,exports,__globalThis) {
module.exports = require("633b41c92c70efa0").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/14336-14591.pbf";

},{"633b41c92c70efa0":"dqXhb"}],"cH08g":[function(require,module,exports,__globalThis) {
module.exports = require("a9f7311bc19ecb87").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/14592-14847.pbf";

},{"a9f7311bc19ecb87":"dqXhb"}],"a9VVa":[function(require,module,exports,__globalThis) {
module.exports = require("ce107d6ac84d9102").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/14848-15103.pbf";

},{"ce107d6ac84d9102":"dqXhb"}],"6u12y":[function(require,module,exports,__globalThis) {
module.exports = require("6adca7263ce847dc").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/15104-15359.pbf";

},{"6adca7263ce847dc":"dqXhb"}],"axuVx":[function(require,module,exports,__globalThis) {
module.exports = require("bf5dae958ce74fb4").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/1536-1791.pbf";

},{"bf5dae958ce74fb4":"dqXhb"}],"2Yq6W":[function(require,module,exports,__globalThis) {
module.exports = require("bebd7855df7fe7af").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/15360-15615.pbf";

},{"bebd7855df7fe7af":"dqXhb"}],"7i6m0":[function(require,module,exports,__globalThis) {
module.exports = require("789be10e71da22b7").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/15616-15871.pbf";

},{"789be10e71da22b7":"dqXhb"}],"hMP3l":[function(require,module,exports,__globalThis) {
module.exports = require("7e4f04c609079f9a").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/15872-16127.pbf";

},{"7e4f04c609079f9a":"dqXhb"}],"gaKW6":[function(require,module,exports,__globalThis) {
module.exports = require("deeb26bfaad33854").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/16128-16383.pbf";

},{"deeb26bfaad33854":"dqXhb"}],"CG3cj":[function(require,module,exports,__globalThis) {
module.exports = require("b2dca036eab61747").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/16384-16639.pbf";

},{"b2dca036eab61747":"dqXhb"}],"dlUma":[function(require,module,exports,__globalThis) {
module.exports = require("5a52e60dbeb7dcf5").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/16640-16895.pbf";

},{"5a52e60dbeb7dcf5":"dqXhb"}],"gQiLQ":[function(require,module,exports,__globalThis) {
module.exports = require("40ea057a9c73fc2d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/16896-17151.pbf";

},{"40ea057a9c73fc2d":"dqXhb"}],"s1Qqp":[function(require,module,exports,__globalThis) {
module.exports = require("650fd96aa0f07afc").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/17152-17407.pbf";

},{"650fd96aa0f07afc":"dqXhb"}],"eHr0m":[function(require,module,exports,__globalThis) {
module.exports = require("18e2fe27f81387b7").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/17408-17663.pbf";

},{"18e2fe27f81387b7":"dqXhb"}],"jJrs4":[function(require,module,exports,__globalThis) {
module.exports = require("40d8724b73d82c10").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/17664-17919.pbf";

},{"40d8724b73d82c10":"dqXhb"}],"YIDwU":[function(require,module,exports,__globalThis) {
module.exports = require("cdecc19106abb1ca").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/1792-2047.pbf";

},{"cdecc19106abb1ca":"dqXhb"}],"gr0EA":[function(require,module,exports,__globalThis) {
module.exports = require("780dea95c92a90b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/17920-18175.pbf";

},{"780dea95c92a90b":"dqXhb"}],"ddJtl":[function(require,module,exports,__globalThis) {
module.exports = require("233a829ae8127a71").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/18176-18431.pbf";

},{"233a829ae8127a71":"dqXhb"}],"ed8gi":[function(require,module,exports,__globalThis) {
module.exports = require("3cf6f089a2789c6a").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/18432-18687.pbf";

},{"3cf6f089a2789c6a":"dqXhb"}],"jaIIr":[function(require,module,exports,__globalThis) {
module.exports = require("c34a337bd98fafac").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/18688-18943.pbf";

},{"c34a337bd98fafac":"dqXhb"}],"e32pW":[function(require,module,exports,__globalThis) {
module.exports = require("bb37ca97cc452d4a").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/18944-19199.pbf";

},{"bb37ca97cc452d4a":"dqXhb"}],"aI38O":[function(require,module,exports,__globalThis) {
module.exports = require("15a8d04cf20f6a7b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/19200-19455.pbf";

},{"15a8d04cf20f6a7b":"dqXhb"}],"kZPBh":[function(require,module,exports,__globalThis) {
module.exports = require("e02e7ac057da50f0").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/19456-19711.pbf";

},{"e02e7ac057da50f0":"dqXhb"}],"6D3Vu":[function(require,module,exports,__globalThis) {
module.exports = require("154612dd1f57b1cc").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/19712-19967.pbf";

},{"154612dd1f57b1cc":"dqXhb"}],"e7t7O":[function(require,module,exports,__globalThis) {
module.exports = require("7272c42f2969b864").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/19968-20223.pbf";

},{"7272c42f2969b864":"dqXhb"}],"7XpeK":[function(require,module,exports,__globalThis) {
module.exports = require("b81acf888599a419").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/20224-20479.pbf";

},{"b81acf888599a419":"dqXhb"}],"23k0L":[function(require,module,exports,__globalThis) {
module.exports = require("f12f54ba35edc86e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/2048-2303.pbf";

},{"f12f54ba35edc86e":"dqXhb"}],"3wuIg":[function(require,module,exports,__globalThis) {
module.exports = require("f5291866f1155c41").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/20480-20735.pbf";

},{"f5291866f1155c41":"dqXhb"}],"eCEFg":[function(require,module,exports,__globalThis) {
module.exports = require("df33e6f2cffdc9e3").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/20736-20991.pbf";

},{"df33e6f2cffdc9e3":"dqXhb"}],"8Y3Vd":[function(require,module,exports,__globalThis) {
module.exports = require("7c654956e43d6efb").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/20992-21247.pbf";

},{"7c654956e43d6efb":"dqXhb"}],"14MCP":[function(require,module,exports,__globalThis) {
module.exports = require("dbe5d9d5e392c3a4").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/21248-21503.pbf";

},{"dbe5d9d5e392c3a4":"dqXhb"}],"aN5Zi":[function(require,module,exports,__globalThis) {
module.exports = require("63465128aa045d61").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/21504-21759.pbf";

},{"63465128aa045d61":"dqXhb"}],"jtWDI":[function(require,module,exports,__globalThis) {
module.exports = require("60f14a8c11ac1952").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/21760-22015.pbf";

},{"60f14a8c11ac1952":"dqXhb"}],"9mpmN":[function(require,module,exports,__globalThis) {
module.exports = require("ca141c0108a1209b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/22016-22271.pbf";

},{"ca141c0108a1209b":"dqXhb"}],"ezcFb":[function(require,module,exports,__globalThis) {
module.exports = require("71f97a2dd0343fe2").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/22272-22527.pbf";

},{"71f97a2dd0343fe2":"dqXhb"}],"1lUvQ":[function(require,module,exports,__globalThis) {
module.exports = require("455c89184f740442").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/22528-22783.pbf";

},{"455c89184f740442":"dqXhb"}],"hkPLV":[function(require,module,exports,__globalThis) {
module.exports = require("75e993598dfab4f4").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/22784-23039.pbf";

},{"75e993598dfab4f4":"dqXhb"}],"lE7Nz":[function(require,module,exports,__globalThis) {
module.exports = require("796805a874bff527").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/2304-2559.pbf";

},{"796805a874bff527":"dqXhb"}],"jGaSi":[function(require,module,exports,__globalThis) {
module.exports = require("6ee9cdd50d5aaaf2").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/23040-23295.pbf";

},{"6ee9cdd50d5aaaf2":"dqXhb"}],"8mhK4":[function(require,module,exports,__globalThis) {
module.exports = require("b48e77dcf0bed5e2").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/23296-23551.pbf";

},{"b48e77dcf0bed5e2":"dqXhb"}],"iwkQo":[function(require,module,exports,__globalThis) {
module.exports = require("23372e592d1f10bf").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/23552-23807.pbf";

},{"23372e592d1f10bf":"dqXhb"}],"1kGnV":[function(require,module,exports,__globalThis) {
module.exports = require("2fa8cdfc2bc0f6a").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/23808-24063.pbf";

},{"2fa8cdfc2bc0f6a":"dqXhb"}],"3iRN6":[function(require,module,exports,__globalThis) {
module.exports = require("14d8e1607ed300e7").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/24064-24319.pbf";

},{"14d8e1607ed300e7":"dqXhb"}],"dphpD":[function(require,module,exports,__globalThis) {
module.exports = require("c0eca341d31ad059").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/24320-24575.pbf";

},{"c0eca341d31ad059":"dqXhb"}],"jg3SA":[function(require,module,exports,__globalThis) {
module.exports = require("48a0df4f2fe4877f").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/24576-24831.pbf";

},{"48a0df4f2fe4877f":"dqXhb"}],"7rnco":[function(require,module,exports,__globalThis) {
module.exports = require("239533916ae7444f").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/24832-25087.pbf";

},{"239533916ae7444f":"dqXhb"}],"9ymmy":[function(require,module,exports,__globalThis) {
module.exports = require("cff45ce733eb944").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/25088-25343.pbf";

},{"cff45ce733eb944":"dqXhb"}],"f6iwu":[function(require,module,exports,__globalThis) {
module.exports = require("9fe45f2658a82f6c").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/25344-25599.pbf";

},{"9fe45f2658a82f6c":"dqXhb"}],"aHr67":[function(require,module,exports,__globalThis) {
module.exports = require("a1bf814756588490").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/256-511.pbf";

},{"a1bf814756588490":"dqXhb"}],"4HRXs":[function(require,module,exports,__globalThis) {
module.exports = require("d6c04b610745d614").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/2560-2815.pbf";

},{"d6c04b610745d614":"dqXhb"}],"dhYji":[function(require,module,exports,__globalThis) {
module.exports = require("f34e5a9749eb4f67").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/25600-25855.pbf";

},{"f34e5a9749eb4f67":"dqXhb"}],"llO9F":[function(require,module,exports,__globalThis) {
module.exports = require("82952a7c4c630ec2").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/25856-26111.pbf";

},{"82952a7c4c630ec2":"dqXhb"}],"iXzBs":[function(require,module,exports,__globalThis) {
module.exports = require("3b18f6dfbdafa31f").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/26112-26367.pbf";

},{"3b18f6dfbdafa31f":"dqXhb"}],"iGz8Z":[function(require,module,exports,__globalThis) {
module.exports = require("80102166bfb39be9").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/26368-26623.pbf";

},{"80102166bfb39be9":"dqXhb"}],"fhsgZ":[function(require,module,exports,__globalThis) {
module.exports = require("9c1825e8b3c638f4").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/26624-26879.pbf";

},{"9c1825e8b3c638f4":"dqXhb"}],"d9Ptz":[function(require,module,exports,__globalThis) {
module.exports = require("668b790faf3258f5").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/26880-27135.pbf";

},{"668b790faf3258f5":"dqXhb"}],"ZEWaf":[function(require,module,exports,__globalThis) {
module.exports = require("d84b48d59ddbe595").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/27136-27391.pbf";

},{"d84b48d59ddbe595":"dqXhb"}],"9ggMw":[function(require,module,exports,__globalThis) {
module.exports = require("fabcdcb26814993f").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/27392-27647.pbf";

},{"fabcdcb26814993f":"dqXhb"}],"bi9od":[function(require,module,exports,__globalThis) {
module.exports = require("32d7c9fa15446dc0").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/27648-27903.pbf";

},{"32d7c9fa15446dc0":"dqXhb"}],"l9lcD":[function(require,module,exports,__globalThis) {
module.exports = require("a03c01df8368b139").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/27904-28159.pbf";

},{"a03c01df8368b139":"dqXhb"}],"acCiJ":[function(require,module,exports,__globalThis) {
module.exports = require("57394ece005b87ac").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/2816-3071.pbf";

},{"57394ece005b87ac":"dqXhb"}],"5Ophs":[function(require,module,exports,__globalThis) {
module.exports = require("4fc251b3d08e39ce").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/28160-28415.pbf";

},{"4fc251b3d08e39ce":"dqXhb"}],"bFo6o":[function(require,module,exports,__globalThis) {
module.exports = require("f5ad9fe772251dcf").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/28416-28671.pbf";

},{"f5ad9fe772251dcf":"dqXhb"}],"9Btsh":[function(require,module,exports,__globalThis) {
module.exports = require("628d6f5cef251958").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/28672-28927.pbf";

},{"628d6f5cef251958":"dqXhb"}],"3LaU2":[function(require,module,exports,__globalThis) {
module.exports = require("68d3b2df5a32ab94").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/28928-29183.pbf";

},{"68d3b2df5a32ab94":"dqXhb"}],"lQNDy":[function(require,module,exports,__globalThis) {
module.exports = require("644ef516347e31b8").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/29184-29439.pbf";

},{"644ef516347e31b8":"dqXhb"}],"9BGuI":[function(require,module,exports,__globalThis) {
module.exports = require("18eecb5d9b81f9cf").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/29440-29695.pbf";

},{"18eecb5d9b81f9cf":"dqXhb"}],"lOoIx":[function(require,module,exports,__globalThis) {
module.exports = require("27f8477e9b48b6d8").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/29696-29951.pbf";

},{"27f8477e9b48b6d8":"dqXhb"}],"jUX7X":[function(require,module,exports,__globalThis) {
module.exports = require("3d8792ef63a1874a").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/29952-30207.pbf";

},{"3d8792ef63a1874a":"dqXhb"}],"k3eSX":[function(require,module,exports,__globalThis) {
module.exports = require("bbee0231e989e143").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/30208-30463.pbf";

},{"bbee0231e989e143":"dqXhb"}],"5L5I0":[function(require,module,exports,__globalThis) {
module.exports = require("481af2f0d21189bf").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/30464-30719.pbf";

},{"481af2f0d21189bf":"dqXhb"}],"cguG9":[function(require,module,exports,__globalThis) {
module.exports = require("1e804e19dc8fba60").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/3072-3327.pbf";

},{"1e804e19dc8fba60":"dqXhb"}],"8JIXN":[function(require,module,exports,__globalThis) {
module.exports = require("3caa06a3e042d06").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/30720-30975.pbf";

},{"3caa06a3e042d06":"dqXhb"}],"b71Bv":[function(require,module,exports,__globalThis) {
module.exports = require("c2db8eeda48d7f92").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/30976-31231.pbf";

},{"c2db8eeda48d7f92":"dqXhb"}],"3NxZz":[function(require,module,exports,__globalThis) {
module.exports = require("7efdc732eb8a3fe8").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/31232-31487.pbf";

},{"7efdc732eb8a3fe8":"dqXhb"}],"eCHlM":[function(require,module,exports,__globalThis) {
module.exports = require("17e72e03ab7bbfc2").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/31488-31743.pbf";

},{"17e72e03ab7bbfc2":"dqXhb"}],"2T1os":[function(require,module,exports,__globalThis) {
module.exports = require("dfbe7d58910fca09").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/31744-31999.pbf";

},{"dfbe7d58910fca09":"dqXhb"}],"5EPll":[function(require,module,exports,__globalThis) {
module.exports = require("ea2a53c7131b4aeb").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/32000-32255.pbf";

},{"ea2a53c7131b4aeb":"dqXhb"}],"btvIQ":[function(require,module,exports,__globalThis) {
module.exports = require("6c25418e7b21449c").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/32256-32511.pbf";

},{"6c25418e7b21449c":"dqXhb"}],"hkJdB":[function(require,module,exports,__globalThis) {
module.exports = require("9637794dc82e52f5").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/32512-32767.pbf";

},{"9637794dc82e52f5":"dqXhb"}],"44Yc9":[function(require,module,exports,__globalThis) {
module.exports = require("29d4cf87d58d803b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/32768-33023.pbf";

},{"29d4cf87d58d803b":"dqXhb"}],"b4IRm":[function(require,module,exports,__globalThis) {
module.exports = require("74bf4dd98db80acb").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/33024-33279.pbf";

},{"74bf4dd98db80acb":"dqXhb"}],"hScnS":[function(require,module,exports,__globalThis) {
module.exports = require("13e45ad059039515").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/3328-3583.pbf";

},{"13e45ad059039515":"dqXhb"}],"iJY1i":[function(require,module,exports,__globalThis) {
module.exports = require("8ba83945d0119fe").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/33280-33535.pbf";

},{"8ba83945d0119fe":"dqXhb"}],"kAvEB":[function(require,module,exports,__globalThis) {
module.exports = require("88394bee73629039").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/33536-33791.pbf";

},{"88394bee73629039":"dqXhb"}],"7uAJF":[function(require,module,exports,__globalThis) {
module.exports = require("75cd0bf9e30ef42").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/33792-34047.pbf";

},{"75cd0bf9e30ef42":"dqXhb"}],"hIMBP":[function(require,module,exports,__globalThis) {
module.exports = require("81f00bb2300c496d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/34048-34303.pbf";

},{"81f00bb2300c496d":"dqXhb"}],"ht4Gi":[function(require,module,exports,__globalThis) {
module.exports = require("95bf73c91d240f86").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/34304-34559.pbf";

},{"95bf73c91d240f86":"dqXhb"}],"jXxvQ":[function(require,module,exports,__globalThis) {
module.exports = require("aa47a126cf8086dc").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/34560-34815.pbf";

},{"aa47a126cf8086dc":"dqXhb"}],"cXBoo":[function(require,module,exports,__globalThis) {
module.exports = require("2e842231324d24dd").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/34816-35071.pbf";

},{"2e842231324d24dd":"dqXhb"}],"6qRk7":[function(require,module,exports,__globalThis) {
module.exports = require("f9248a7e1ab0796d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/35072-35327.pbf";

},{"f9248a7e1ab0796d":"dqXhb"}],"aeBHQ":[function(require,module,exports,__globalThis) {
module.exports = require("9f562b86d8db39be").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/35328-35583.pbf";

},{"9f562b86d8db39be":"dqXhb"}],"1Btxd":[function(require,module,exports,__globalThis) {
module.exports = require("408e8bf516d74c20").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/35584-35839.pbf";

},{"408e8bf516d74c20":"dqXhb"}],"kThss":[function(require,module,exports,__globalThis) {
module.exports = require("34e88df0cb48fd76").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/3584-3839.pbf";

},{"34e88df0cb48fd76":"dqXhb"}],"ksL8V":[function(require,module,exports,__globalThis) {
module.exports = require("41bcec16c23b1c5b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/35840-36095.pbf";

},{"41bcec16c23b1c5b":"dqXhb"}],"iv7VV":[function(require,module,exports,__globalThis) {
module.exports = require("e2b5d9addcd57144").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/36096-36351.pbf";

},{"e2b5d9addcd57144":"dqXhb"}],"ceOsE":[function(require,module,exports,__globalThis) {
module.exports = require("cfdfecd71fccc627").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/36352-36607.pbf";

},{"cfdfecd71fccc627":"dqXhb"}],"h6rfs":[function(require,module,exports,__globalThis) {
module.exports = require("aef7dffc5cf053dc").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/36608-36863.pbf";

},{"aef7dffc5cf053dc":"dqXhb"}],"dzBBQ":[function(require,module,exports,__globalThis) {
module.exports = require("5ac0a94afa0e1676").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/36864-37119.pbf";

},{"5ac0a94afa0e1676":"dqXhb"}],"f1VZn":[function(require,module,exports,__globalThis) {
module.exports = require("2259a180f19587bf").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/37120-37375.pbf";

},{"2259a180f19587bf":"dqXhb"}],"ikhXZ":[function(require,module,exports,__globalThis) {
module.exports = require("6f1d0daa639afe05").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/37376-37631.pbf";

},{"6f1d0daa639afe05":"dqXhb"}],"lecoY":[function(require,module,exports,__globalThis) {
module.exports = require("865fbdf2734715bc").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/37632-37887.pbf";

},{"865fbdf2734715bc":"dqXhb"}],"lyrVM":[function(require,module,exports,__globalThis) {
module.exports = require("e4cb064400697755").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/37888-38143.pbf";

},{"e4cb064400697755":"dqXhb"}],"4CAug":[function(require,module,exports,__globalThis) {
module.exports = require("77a5ae7779aa45d2").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/38144-38399.pbf";

},{"77a5ae7779aa45d2":"dqXhb"}],"fgSR5":[function(require,module,exports,__globalThis) {
module.exports = require("99d6d444be3af828").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/3840-4095.pbf";

},{"99d6d444be3af828":"dqXhb"}],"kNQ2N":[function(require,module,exports,__globalThis) {
module.exports = require("a80e6162f13bfc10").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/38400-38655.pbf";

},{"a80e6162f13bfc10":"dqXhb"}],"4RsgL":[function(require,module,exports,__globalThis) {
module.exports = require("8ee056a2ba978843").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/38656-38911.pbf";

},{"8ee056a2ba978843":"dqXhb"}],"dsNpo":[function(require,module,exports,__globalThis) {
module.exports = require("dd90adf28d2216f3").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/38912-39167.pbf";

},{"dd90adf28d2216f3":"dqXhb"}],"j7OZd":[function(require,module,exports,__globalThis) {
module.exports = require("fcfbc11706d93a61").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/39168-39423.pbf";

},{"fcfbc11706d93a61":"dqXhb"}],"5gVHp":[function(require,module,exports,__globalThis) {
module.exports = require("cab813c1cb4621b6").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/39424-39679.pbf";

},{"cab813c1cb4621b6":"dqXhb"}],"biiJs":[function(require,module,exports,__globalThis) {
module.exports = require("d1d808d57118d863").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/39680-39935.pbf";

},{"d1d808d57118d863":"dqXhb"}],"7T9bv":[function(require,module,exports,__globalThis) {
module.exports = require("fe90f241728b553a").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/39936-40191.pbf";

},{"fe90f241728b553a":"dqXhb"}],"cYzXG":[function(require,module,exports,__globalThis) {
module.exports = require("fe0589f6dfc00ea0").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/40192-40447.pbf";

},{"fe0589f6dfc00ea0":"dqXhb"}],"6aZWZ":[function(require,module,exports,__globalThis) {
module.exports = require("1faa19a8789ae047").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/40448-40703.pbf";

},{"1faa19a8789ae047":"dqXhb"}],"67W8n":[function(require,module,exports,__globalThis) {
module.exports = require("ab42a08d2001290b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/40704-40959.pbf";

},{"ab42a08d2001290b":"dqXhb"}],"djLmq":[function(require,module,exports,__globalThis) {
module.exports = require("73178846ec530458").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/4096-4351.pbf";

},{"73178846ec530458":"dqXhb"}],"h6FOp":[function(require,module,exports,__globalThis) {
module.exports = require("824cfe76e123260").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/40960-41215.pbf";

},{"824cfe76e123260":"dqXhb"}],"2a0ht":[function(require,module,exports,__globalThis) {
module.exports = require("f26913cb46e994bb").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/41216-41471.pbf";

},{"f26913cb46e994bb":"dqXhb"}],"ajLU5":[function(require,module,exports,__globalThis) {
module.exports = require("6cea381da91f362e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/41472-41727.pbf";

},{"6cea381da91f362e":"dqXhb"}],"7EFiV":[function(require,module,exports,__globalThis) {
module.exports = require("cebbd3a15e06c8ef").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/41728-41983.pbf";

},{"cebbd3a15e06c8ef":"dqXhb"}],"37U7a":[function(require,module,exports,__globalThis) {
module.exports = require("b7ff884ef828be73").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/41984-42239.pbf";

},{"b7ff884ef828be73":"dqXhb"}],"aOAqZ":[function(require,module,exports,__globalThis) {
module.exports = require("540e268121ed6a16").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/42240-42495.pbf";

},{"540e268121ed6a16":"dqXhb"}],"eugQg":[function(require,module,exports,__globalThis) {
module.exports = require("d30f52b2e84a57d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/42496-42751.pbf";

},{"d30f52b2e84a57d":"dqXhb"}],"ayQW3":[function(require,module,exports,__globalThis) {
module.exports = require("fab9294ec0449cfe").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/42752-43007.pbf";

},{"fab9294ec0449cfe":"dqXhb"}],"iu9aZ":[function(require,module,exports,__globalThis) {
module.exports = require("9ec0be67b2b8333c").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/43008-43263.pbf";

},{"9ec0be67b2b8333c":"dqXhb"}],"6kNBR":[function(require,module,exports,__globalThis) {
module.exports = require("605225264e61b975").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/43264-43519.pbf";

},{"605225264e61b975":"dqXhb"}],"dRlGB":[function(require,module,exports,__globalThis) {
module.exports = require("9d3482fb7f1b6bcc").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/4352-4607.pbf";

},{"9d3482fb7f1b6bcc":"dqXhb"}],"d9g18":[function(require,module,exports,__globalThis) {
module.exports = require("3d47274bdbef216e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/43520-43775.pbf";

},{"3d47274bdbef216e":"dqXhb"}],"aXg0k":[function(require,module,exports,__globalThis) {
module.exports = require("3159a2322318a12").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/43776-44031.pbf";

},{"3159a2322318a12":"dqXhb"}],"4y96d":[function(require,module,exports,__globalThis) {
module.exports = require("da65df5ddb8eaeaa").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/44032-44287.pbf";

},{"da65df5ddb8eaeaa":"dqXhb"}],"26I0a":[function(require,module,exports,__globalThis) {
module.exports = require("1076078bcbc694e3").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/44288-44543.pbf";

},{"1076078bcbc694e3":"dqXhb"}],"50fFv":[function(require,module,exports,__globalThis) {
module.exports = require("cfe2026f8b7f16a9").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/44544-44799.pbf";

},{"cfe2026f8b7f16a9":"dqXhb"}],"l4xTP":[function(require,module,exports,__globalThis) {
module.exports = require("467855bad65ea44a").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/44800-45055.pbf";

},{"467855bad65ea44a":"dqXhb"}],"exa1L":[function(require,module,exports,__globalThis) {
module.exports = require("90a7e22348686e06").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/45056-45311.pbf";

},{"90a7e22348686e06":"dqXhb"}],"bmCIs":[function(require,module,exports,__globalThis) {
module.exports = require("4856588c2b55f4b8").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/45312-45567.pbf";

},{"4856588c2b55f4b8":"dqXhb"}],"hGSe4":[function(require,module,exports,__globalThis) {
module.exports = require("200725bddd6a353e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/45568-45823.pbf";

},{"200725bddd6a353e":"dqXhb"}],"bqjC1":[function(require,module,exports,__globalThis) {
module.exports = require("b2baad0c146296b9").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/45824-46079.pbf";

},{"b2baad0c146296b9":"dqXhb"}],"eBTW8":[function(require,module,exports,__globalThis) {
module.exports = require("67425c34ff348069").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/4608-4863.pbf";

},{"67425c34ff348069":"dqXhb"}],"f2EEa":[function(require,module,exports,__globalThis) {
module.exports = require("42f9152a2ac72c2c").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/46080-46335.pbf";

},{"42f9152a2ac72c2c":"dqXhb"}],"eJ7Xl":[function(require,module,exports,__globalThis) {
module.exports = require("10d1c803bc8c12cf").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/46336-46591.pbf";

},{"10d1c803bc8c12cf":"dqXhb"}],"8dz5v":[function(require,module,exports,__globalThis) {
module.exports = require("382da30d3b0fc6").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/46592-46847.pbf";

},{"382da30d3b0fc6":"dqXhb"}],"cxR9Y":[function(require,module,exports,__globalThis) {
module.exports = require("87042ad2f92d2d97").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/46848-47103.pbf";

},{"87042ad2f92d2d97":"dqXhb"}],"97q1V":[function(require,module,exports,__globalThis) {
module.exports = require("e38ba87b2474890e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/47104-47359.pbf";

},{"e38ba87b2474890e":"dqXhb"}],"5acTm":[function(require,module,exports,__globalThis) {
module.exports = require("2f19eae6281b9f97").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/47360-47615.pbf";

},{"2f19eae6281b9f97":"dqXhb"}],"ls2Av":[function(require,module,exports,__globalThis) {
module.exports = require("d8694bee46ec4db9").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/47616-47871.pbf";

},{"d8694bee46ec4db9":"dqXhb"}],"3tYHl":[function(require,module,exports,__globalThis) {
module.exports = require("3e244256f0ac6107").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/47872-48127.pbf";

},{"3e244256f0ac6107":"dqXhb"}],"3s9oF":[function(require,module,exports,__globalThis) {
module.exports = require("a884523360149f3").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/48128-48383.pbf";

},{"a884523360149f3":"dqXhb"}],"81ALH":[function(require,module,exports,__globalThis) {
module.exports = require("8972b790cceda266").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/48384-48639.pbf";

},{"8972b790cceda266":"dqXhb"}],"kSBX6":[function(require,module,exports,__globalThis) {
module.exports = require("570c71fb241ebecb").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/4864-5119.pbf";

},{"570c71fb241ebecb":"dqXhb"}],"5oegc":[function(require,module,exports,__globalThis) {
module.exports = require("35070f586da29041").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/48640-48895.pbf";

},{"35070f586da29041":"dqXhb"}],"jI2gM":[function(require,module,exports,__globalThis) {
module.exports = require("b1014945a24849d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/48896-49151.pbf";

},{"b1014945a24849d":"dqXhb"}],"lXgJz":[function(require,module,exports,__globalThis) {
module.exports = require("6f225a4011ceffda").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/49152-49407.pbf";

},{"6f225a4011ceffda":"dqXhb"}],"aEh7L":[function(require,module,exports,__globalThis) {
module.exports = require("2456682db0135f51").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/49408-49663.pbf";

},{"2456682db0135f51":"dqXhb"}],"jKVlX":[function(require,module,exports,__globalThis) {
module.exports = require("3bbddfe5a0d84a9").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/49664-49919.pbf";

},{"3bbddfe5a0d84a9":"dqXhb"}],"5DVg0":[function(require,module,exports,__globalThis) {
module.exports = require("c84e3f2b4933fc53").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/49920-50175.pbf";

},{"c84e3f2b4933fc53":"dqXhb"}],"kM4BS":[function(require,module,exports,__globalThis) {
module.exports = require("efcfeaa20f8a3e75").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/50176-50431.pbf";

},{"efcfeaa20f8a3e75":"dqXhb"}],"3nPGL":[function(require,module,exports,__globalThis) {
module.exports = require("5c20a3706d63f080").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/50432-50687.pbf";

},{"5c20a3706d63f080":"dqXhb"}],"gEoaK":[function(require,module,exports,__globalThis) {
module.exports = require("ce12a05ffa27f132").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/50688-50943.pbf";

},{"ce12a05ffa27f132":"dqXhb"}],"c1gk2":[function(require,module,exports,__globalThis) {
module.exports = require("8beabdd2987ca79d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/50944-51199.pbf";

},{"8beabdd2987ca79d":"dqXhb"}],"ky2Tm":[function(require,module,exports,__globalThis) {
module.exports = require("f805caca0550e7d9").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/512-767.pbf";

},{"f805caca0550e7d9":"dqXhb"}],"hoG41":[function(require,module,exports,__globalThis) {
module.exports = require("d469e4acaf12ca26").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/5120-5375.pbf";

},{"d469e4acaf12ca26":"dqXhb"}],"9510O":[function(require,module,exports,__globalThis) {
module.exports = require("1427d918df42a994").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/51200-51455.pbf";

},{"1427d918df42a994":"dqXhb"}],"c92iG":[function(require,module,exports,__globalThis) {
module.exports = require("b991bcf199552bc2").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/51456-51711.pbf";

},{"b991bcf199552bc2":"dqXhb"}],"QkGUZ":[function(require,module,exports,__globalThis) {
module.exports = require("249fcdafbfa26833").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/51712-51967.pbf";

},{"249fcdafbfa26833":"dqXhb"}],"03u3L":[function(require,module,exports,__globalThis) {
module.exports = require("af0d3679697201e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/51968-52223.pbf";

},{"af0d3679697201e":"dqXhb"}],"aN4gb":[function(require,module,exports,__globalThis) {
module.exports = require("e62dc03a482fdaa0").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/52224-52479.pbf";

},{"e62dc03a482fdaa0":"dqXhb"}],"8KZIM":[function(require,module,exports,__globalThis) {
module.exports = require("bfe8c04601146bc6").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/52480-52735.pbf";

},{"bfe8c04601146bc6":"dqXhb"}],"3rMmK":[function(require,module,exports,__globalThis) {
module.exports = require("4ed64618ba0feef9").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/52736-52991.pbf";

},{"4ed64618ba0feef9":"dqXhb"}],"d2SXL":[function(require,module,exports,__globalThis) {
module.exports = require("a4e56fbc35c1a33").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/52992-53247.pbf";

},{"a4e56fbc35c1a33":"dqXhb"}],"hryhn":[function(require,module,exports,__globalThis) {
module.exports = require("e5c703fb8f1284d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/53248-53503.pbf";

},{"e5c703fb8f1284d":"dqXhb"}],"pOQSH":[function(require,module,exports,__globalThis) {
module.exports = require("ee524055c2a0a4c8").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/53504-53759.pbf";

},{"ee524055c2a0a4c8":"dqXhb"}],"2DHWH":[function(require,module,exports,__globalThis) {
module.exports = require("7eaeb5a9b367f7ff").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/5376-5631.pbf";

},{"7eaeb5a9b367f7ff":"dqXhb"}],"9b5SB":[function(require,module,exports,__globalThis) {
module.exports = require("9ec92e15e00c7160").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/53760-54015.pbf";

},{"9ec92e15e00c7160":"dqXhb"}],"bSjj1":[function(require,module,exports,__globalThis) {
module.exports = require("7472d323698f18ba").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/54016-54271.pbf";

},{"7472d323698f18ba":"dqXhb"}],"b8cjd":[function(require,module,exports,__globalThis) {
module.exports = require("d40df094b4434817").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/54272-54527.pbf";

},{"d40df094b4434817":"dqXhb"}],"iA6vu":[function(require,module,exports,__globalThis) {
module.exports = require("c1e0cdf7de64867b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/54528-54783.pbf";

},{"c1e0cdf7de64867b":"dqXhb"}],"8ZOff":[function(require,module,exports,__globalThis) {
module.exports = require("e5380b14c2aa866f").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/54784-55039.pbf";

},{"e5380b14c2aa866f":"dqXhb"}],"8Jsqp":[function(require,module,exports,__globalThis) {
module.exports = require("4317da4b9fedd39").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/55040-55295.pbf";

},{"4317da4b9fedd39":"dqXhb"}],"9shSQ":[function(require,module,exports,__globalThis) {
module.exports = require("e1c496167dc248fd").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/55296-55551.pbf";

},{"e1c496167dc248fd":"dqXhb"}],"5pYzr":[function(require,module,exports,__globalThis) {
module.exports = require("b01272b618674cf3").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/55552-55807.pbf";

},{"b01272b618674cf3":"dqXhb"}],"SYlBc":[function(require,module,exports,__globalThis) {
module.exports = require("f109e5feaa06ddc5").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/55808-56063.pbf";

},{"f109e5feaa06ddc5":"dqXhb"}],"29GX4":[function(require,module,exports,__globalThis) {
module.exports = require("bfc4d7a490d24e93").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/56064-56319.pbf";

},{"bfc4d7a490d24e93":"dqXhb"}],"aXlJ7":[function(require,module,exports,__globalThis) {
module.exports = require("c37cd0daf577355f").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/5632-5887.pbf";

},{"c37cd0daf577355f":"dqXhb"}],"jLQMS":[function(require,module,exports,__globalThis) {
module.exports = require("f33e2a1e495730d0").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/56320-56575.pbf";

},{"f33e2a1e495730d0":"dqXhb"}],"purh8":[function(require,module,exports,__globalThis) {
module.exports = require("92f83631889af3c5").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/56576-56831.pbf";

},{"92f83631889af3c5":"dqXhb"}],"l10lV":[function(require,module,exports,__globalThis) {
module.exports = require("d645c10480819c67").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/56832-57087.pbf";

},{"d645c10480819c67":"dqXhb"}],"ebsZx":[function(require,module,exports,__globalThis) {
module.exports = require("817043ca26dd97e3").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/57088-57343.pbf";

},{"817043ca26dd97e3":"dqXhb"}],"dkZfs":[function(require,module,exports,__globalThis) {
module.exports = require("a2277a504a952499").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/57344-57599.pbf";

},{"a2277a504a952499":"dqXhb"}],"8vQ9f":[function(require,module,exports,__globalThis) {
module.exports = require("c820ed8c83e75c60").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/57600-57855.pbf";

},{"c820ed8c83e75c60":"dqXhb"}],"keOe8":[function(require,module,exports,__globalThis) {
module.exports = require("c60eaccd5ca7b9b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/57856-58111.pbf";

},{"c60eaccd5ca7b9b":"dqXhb"}],"6n9y4":[function(require,module,exports,__globalThis) {
module.exports = require("529af86b1e49cd63").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/58112-58367.pbf";

},{"529af86b1e49cd63":"dqXhb"}],"elwCL":[function(require,module,exports,__globalThis) {
module.exports = require("c590d8f847af6ded").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/58368-58623.pbf";

},{"c590d8f847af6ded":"dqXhb"}],"dc5ix":[function(require,module,exports,__globalThis) {
module.exports = require("86ed1042da759dc0").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/58624-58879.pbf";

},{"86ed1042da759dc0":"dqXhb"}],"5bHCj":[function(require,module,exports,__globalThis) {
module.exports = require("a0fb62e9af4698b6").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/5888-6143.pbf";

},{"a0fb62e9af4698b6":"dqXhb"}],"9TIZO":[function(require,module,exports,__globalThis) {
module.exports = require("a5c56d58d68c8166").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/58880-59135.pbf";

},{"a5c56d58d68c8166":"dqXhb"}],"2RoTn":[function(require,module,exports,__globalThis) {
module.exports = require("29d1ad8fa1ca045d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/59136-59391.pbf";

},{"29d1ad8fa1ca045d":"dqXhb"}],"mETpr":[function(require,module,exports,__globalThis) {
module.exports = require("3abc752c0f832afb").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/59392-59647.pbf";

},{"3abc752c0f832afb":"dqXhb"}],"bQQ8F":[function(require,module,exports,__globalThis) {
module.exports = require("2fe14f9b9bff20ca").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/59648-59903.pbf";

},{"2fe14f9b9bff20ca":"dqXhb"}],"6iU4U":[function(require,module,exports,__globalThis) {
module.exports = require("1a409d6ae520849a").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/59904-60159.pbf";

},{"1a409d6ae520849a":"dqXhb"}],"g9r0D":[function(require,module,exports,__globalThis) {
module.exports = require("94b7b55a90c66c2b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/60160-60415.pbf";

},{"94b7b55a90c66c2b":"dqXhb"}],"a7rkh":[function(require,module,exports,__globalThis) {
module.exports = require("20d6156ff67e0453").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/60416-60671.pbf";

},{"20d6156ff67e0453":"dqXhb"}],"fI1TL":[function(require,module,exports,__globalThis) {
module.exports = require("a9f126522876359d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/60672-60927.pbf";

},{"a9f126522876359d":"dqXhb"}],"hsVyF":[function(require,module,exports,__globalThis) {
module.exports = require("21e599d9d815bb36").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/60928-61183.pbf";

},{"21e599d9d815bb36":"dqXhb"}],"h5k6x":[function(require,module,exports,__globalThis) {
module.exports = require("d70acc0d9d5900b1").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/61184-61439.pbf";

},{"d70acc0d9d5900b1":"dqXhb"}],"496xS":[function(require,module,exports,__globalThis) {
module.exports = require("712f9942555205b4").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/6144-6399.pbf";

},{"712f9942555205b4":"dqXhb"}],"aextB":[function(require,module,exports,__globalThis) {
module.exports = require("543980d51b135091").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/61440-61695.pbf";

},{"543980d51b135091":"dqXhb"}],"3271z":[function(require,module,exports,__globalThis) {
module.exports = require("94b40b23555837df").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/61696-61951.pbf";

},{"94b40b23555837df":"dqXhb"}],"7zz5P":[function(require,module,exports,__globalThis) {
module.exports = require("a1810ed0f11bac7a").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/61952-62207.pbf";

},{"a1810ed0f11bac7a":"dqXhb"}],"atoZb":[function(require,module,exports,__globalThis) {
module.exports = require("69806e8e832fb0de").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/62208-62463.pbf";

},{"69806e8e832fb0de":"dqXhb"}],"bw4iW":[function(require,module,exports,__globalThis) {
module.exports = require("8cdb18cdcca2265f").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/62464-62719.pbf";

},{"8cdb18cdcca2265f":"dqXhb"}],"hX6jp":[function(require,module,exports,__globalThis) {
module.exports = require("f5e4e824e6950fe5").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/62720-62975.pbf";

},{"f5e4e824e6950fe5":"dqXhb"}],"gCVRt":[function(require,module,exports,__globalThis) {
module.exports = require("1531b2359bd96d8e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/62976-63231.pbf";

},{"1531b2359bd96d8e":"dqXhb"}],"lY719":[function(require,module,exports,__globalThis) {
module.exports = require("76e6b06257386e7").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/63232-63487.pbf";

},{"76e6b06257386e7":"dqXhb"}],"bXODx":[function(require,module,exports,__globalThis) {
module.exports = require("8dac28a6834fa21a").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/63488-63743.pbf";

},{"8dac28a6834fa21a":"dqXhb"}],"8C7jb":[function(require,module,exports,__globalThis) {
module.exports = require("f9bd64086738a60e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/63744-63999.pbf";

},{"f9bd64086738a60e":"dqXhb"}],"3Csv5":[function(require,module,exports,__globalThis) {
module.exports = require("e868e38b0a389c27").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/6400-6655.pbf";

},{"e868e38b0a389c27":"dqXhb"}],"1NgzW":[function(require,module,exports,__globalThis) {
module.exports = require("2b7bb746faf976b2").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/64000-64255.pbf";

},{"2b7bb746faf976b2":"dqXhb"}],"i3jhg":[function(require,module,exports,__globalThis) {
module.exports = require("87170ed438d58764").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/64256-64511.pbf";

},{"87170ed438d58764":"dqXhb"}],"2U1hU":[function(require,module,exports,__globalThis) {
module.exports = require("b4da99f4827166b7").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/64512-64767.pbf";

},{"b4da99f4827166b7":"dqXhb"}],"9MbPa":[function(require,module,exports,__globalThis) {
module.exports = require("ffc9dfd5fabb5bfc").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/64768-65023.pbf";

},{"ffc9dfd5fabb5bfc":"dqXhb"}],"7s5DZ":[function(require,module,exports,__globalThis) {
module.exports = require("24327230cfdd5bb3").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/65024-65279.pbf";

},{"24327230cfdd5bb3":"dqXhb"}],"lqN3Z":[function(require,module,exports,__globalThis) {
module.exports = require("27087e9fb2516028").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/65280-65535.pbf";

},{"27087e9fb2516028":"dqXhb"}],"gOZxQ":[function(require,module,exports,__globalThis) {
module.exports = require("2711af0463eb17dd").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/6656-6911.pbf";

},{"2711af0463eb17dd":"dqXhb"}],"kBhwY":[function(require,module,exports,__globalThis) {
module.exports = require("9b1cc47dedb4676d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/6912-7167.pbf";

},{"9b1cc47dedb4676d":"dqXhb"}],"eQefu":[function(require,module,exports,__globalThis) {
module.exports = require("6f3c7151795abd48").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/7168-7423.pbf";

},{"6f3c7151795abd48":"dqXhb"}],"8VQ0m":[function(require,module,exports,__globalThis) {
module.exports = require("a8d6f7d13495d01b").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/7424-7679.pbf";

},{"a8d6f7d13495d01b":"dqXhb"}],"cBtss":[function(require,module,exports,__globalThis) {
module.exports = require("1e478e291efa39be").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/768-1023.pbf";

},{"1e478e291efa39be":"dqXhb"}],"51utm":[function(require,module,exports,__globalThis) {
module.exports = require("dd6ce4e5e7370861").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/7680-7935.pbf";

},{"dd6ce4e5e7370861":"dqXhb"}],"jR6dY":[function(require,module,exports,__globalThis) {
module.exports = require("d90836e8e9ac5edb").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/7936-8191.pbf";

},{"d90836e8e9ac5edb":"dqXhb"}],"kWOm3":[function(require,module,exports,__globalThis) {
module.exports = require("ff47cb6449f243").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/8192-8447.pbf";

},{"ff47cb6449f243":"dqXhb"}],"4BDA1":[function(require,module,exports,__globalThis) {
module.exports = require("5954762dfd13148e").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/8448-8703.pbf";

},{"5954762dfd13148e":"dqXhb"}],"Tbk86":[function(require,module,exports,__globalThis) {
module.exports = require("b17d3abc6f14bb31").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/8704-8959.pbf";

},{"b17d3abc6f14bb31":"dqXhb"}],"1R6Xq":[function(require,module,exports,__globalThis) {
module.exports = require("9bf17410e9328e29").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/8960-9215.pbf";

},{"9bf17410e9328e29":"dqXhb"}],"1Jjiq":[function(require,module,exports,__globalThis) {
module.exports = require("383032c2987f9884").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/9216-9471.pbf";

},{"383032c2987f9884":"dqXhb"}],"4zTln":[function(require,module,exports,__globalThis) {
module.exports = require("d6b1a54878f9bf41").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/9472-9727.pbf";

},{"d6b1a54878f9bf41":"dqXhb"}],"ioPHM":[function(require,module,exports,__globalThis) {
module.exports = require("5b0e870393fade9c").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/9728-9983.pbf";

},{"5b0e870393fade9c":"dqXhb"}],"4yV54":[function(require,module,exports,__globalThis) {
module.exports = require("397850e1b344851d").getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/9984-10239.pbf";

},{"397850e1b344851d":"dqXhb"}],"4KPza":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "culturalCentreBuildingLabels", ()=>culturalCentreBuildingLabels);
parcelHelpers.export(exports, "amenities", ()=>amenities);
parcelHelpers.export(exports, "transitLabels", ()=>transitLabels);
parcelHelpers.export(exports, "transitBuildingLabels", ()=>transitBuildingLabels);
parcelHelpers.export(exports, "qagomaInterBuildingPathway", ()=>qagomaInterBuildingPathway);
parcelHelpers.export(exports, "qagomaInterBuildingPathwayTarget", ()=>qagomaInterBuildingPathwayTarget);
parcelHelpers.export(exports, "qagomaBase", ()=>qagomaBase);
parcelHelpers.export(exports, "qagomaBasePattern", ()=>qagomaBasePattern);
parcelHelpers.export(exports, "qagomaBaseBorder", ()=>qagomaBaseBorder);
parcelHelpers.export(exports, "qagomaLevel", ()=>qagomaLevel);
parcelHelpers.export(exports, "qagomaGrass", ()=>qagomaGrass);
parcelHelpers.export(exports, "qagomaGrassFill", ()=>qagomaGrassFill);
parcelHelpers.export(exports, "qagomaWater", ()=>qagomaWater);
parcelHelpers.export(exports, "qagomaInaccessible", ()=>qagomaInaccessible);
parcelHelpers.export(exports, "qagomaInaccessiblePattern", ()=>qagomaInaccessiblePattern);
parcelHelpers.export(exports, "qagomaSpaces", ()=>qagomaSpaces);
parcelHelpers.export(exports, "qagomaEntrances", ()=>qagomaEntrances);
parcelHelpers.export(exports, "qagomaInternalWalls", ()=>qagomaInternalWalls);
parcelHelpers.export(exports, "qagomaLevelBorder", ()=>qagomaLevelBorder);
parcelHelpers.export(exports, "qagomaTraversalBase", ()=>qagomaTraversalBase);
parcelHelpers.export(exports, "qagomaTraversal", ()=>qagomaTraversal);
parcelHelpers.export(exports, "qagomaAmenities", ()=>qagomaAmenities);
parcelHelpers.export(exports, "qagomaTraversalIcon", ()=>qagomaTraversalIcon);
parcelHelpers.export(exports, "qagomaSpacesLabel", ()=>qagomaSpacesLabel);
parcelHelpers.export(exports, "qagomaSpacesMarker", ()=>qagomaSpacesMarker);
parcelHelpers.export(exports, "qagomaEntranceLabels", ()=>qagomaEntranceLabels);
parcelHelpers.export(exports, "qagomaBaseCover", ()=>qagomaBaseCover);
parcelHelpers.export(exports, "qagomaBaseCoverBorder", ()=>qagomaBaseCoverBorder);
parcelHelpers.export(exports, "qagomaInterBuildingPathwayPoints", ()=>qagomaInterBuildingPathwayPoints);
parcelHelpers.export(exports, "qagomaBuildingLabels", ()=>qagomaBuildingLabels);
var _variablesModuleScss = require("/src/assets/styles/variables.module.scss");
const interpolateWidth = (value, baseZoom = 20, minZoom = 0, maxZoom = 24)=>{
    return [
        'interpolate',
        [
            'exponential',
            2
        ],
        [
            'zoom'
        ],
        minZoom,
        [
            '*',
            value,
            [
                '^',
                2,
                minZoom - baseZoom
            ]
        ],
        maxZoom,
        [
            '*',
            value,
            [
                '^',
                2,
                maxZoom - baseZoom
            ]
        ]
    ];
};
const levelFilter = (filter)=>[
        'let',
        'activeLevels',
        [
            'literal',
            [
                'qag_level_1',
                'goma_level_1'
            ]
        ],
        [
            'let',
            'isActiveLevel',
            [
                'any',
                [
                    '!',
                    [
                        'has',
                        'level'
                    ]
                ],
                [
                    'in',
                    [
                        'concat',
                        [
                            'get',
                            'building'
                        ],
                        '_',
                        [
                            'get',
                            'level'
                        ]
                    ],
                    [
                        'array',
                        [
                            'var',
                            'activeLevels'
                        ]
                    ]
                ]
            ],
            filter
        ]
    ];
const closedVenueFilter = [
    'to-boolean',
    [
        'coalesce',
        [
            'get',
            'isClosed'
        ],
        false
    ]
];
const openVenueFilter = [
    '!',
    closedVenueFilter
];
const culturalCentreBounds = [
    [
        [
            153.01653742790222,
            -27.470439296677753
        ],
        [
            153.01742792129517,
            -27.472390704839142
        ],
        [
            153.0183720588684,
            -27.473828061432265
        ],
        [
            153.01827549934387,
            -27.474170739706445
        ],
        [
            153.01669836044312,
            -27.47508454322731
        ],
        [
            153.01735281944275,
            -27.475969783161016
        ],
        [
            153.01933765411377,
            -27.47521780560758
        ],
        [
            153.01991701126096,
            -27.475465292457592
        ],
        [
            153.0211615562439,
            -27.4747513865715
        ],
        [
            153.0199384689331,
            -27.472885690683164
        ],
        [
            153.01949858665466,
            -27.47166725999056
        ],
        [
            153.01812529563904,
            -27.470467854119498
        ],
        [
            153.01726698875427,
            -27.469830069490843
        ],
        [
            153.01653742790222,
            -27.470439296677753
        ]
    ]
];
const culturalCentreBuildingLabels = {
    id: 'culturalCentreBuildingLabels',
    filter: [
        'in',
        [
            'get',
            'name'
        ],
        [
            'literal',
            [
                'State Library of Queensland',
                'Queensland Performing Arts Centre',
                'Queensland Museum',
                'The Edge'
            ]
        ]
    ],
    source: 'protomaps',
    'source-layer': 'buildings',
    type: 'symbol',
    layout: {
        'text-anchor': 'center',
        'text-field': [
            'get',
            'name'
        ],
        'text-font': [
            'Flama Book'
        ],
        'text-letter-spacing': 0.02,
        'text-line-height': 1.1,
        'text-max-width': 8,
        'text-overlap': 'never',
        'text-size': 14,
        'text-rotation-alignment': 'map'
    },
    paint: {
        'text-color': '#797979',
        'text-halo-color': 'white',
        'text-halo-width': 2
    },
    minzoom: 16
};
const amenities = {
    id: 'amenities',
    filter: [
        'all',
        [
            'in',
            [
                'get',
                'amenity'
            ],
            [
                'literal',
                [
                    'parking',
                    'parking_entrance',
                    'bus_station'
                ]
            ]
        ],
        [
            'within',
            {
                type: 'Feature',
                properties: {},
                geometry: {
                    type: 'Polygon',
                    coordinates: culturalCentreBounds
                }
            }
        ]
    ],
    source: 'protomaps',
    'source-layer': 'pois',
    type: 'symbol',
    layout: {
        'icon-image': 'parking',
        'icon-size': [
            'interpolate',
            [
                'exponential',
                2
            ],
            [
                'zoom'
            ],
            16,
            0.5,
            22,
            2
        ],
        'icon-allow-overlap': true,
        'icon-overlap': 'always'
    },
    minzoom: 16
};
const transitLabels = {
    id: 'transitLabels',
    filter: [
        'all',
        [
            'within',
            {
                type: 'Feature',
                properties: {},
                geometry: {
                    type: 'Polygon',
                    coordinates: culturalCentreBounds
                }
            }
        ],
        [
            'any',
            [
                '==',
                [
                    'get',
                    'railway'
                ],
                'station'
            ]
        ]
    ],
    source: 'protomaps',
    'source-layer': 'pois',
    type: 'symbol',
    layout: {
        'text-anchor': 'center',
        'text-field': [
            'concat',
            [
                'get',
                'name'
            ],
            ' ',
            [
                'get',
                'railway'
            ]
        ],
        'text-font': [
            'Flama Book'
        ],
        'text-letter-spacing': 0.02,
        'text-line-height': 1.1,
        'text-max-width': 8,
        'text-overlap': 'never',
        'text-size': 14
    },
    paint: {
        'text-color': '#797979',
        'text-halo-color': 'white',
        'text-halo-width': 2
    },
    minzoom: 16
};
const transitBuildingLabels = {
    id: 'transitBuildingLabels',
    filter: [
        'all',
        [
            'in',
            [
                'get',
                'name'
            ],
            [
                'literal',
                [
                    'Cultural Centre Platform 1',
                    'Cultural Centre Platform 2'
                ]
            ]
        ]
    ],
    source: 'protomaps',
    'source-layer': 'buildings',
    type: 'symbol',
    layout: {
        'text-anchor': 'center',
        'text-field': [
            'get',
            'name'
        ],
        'text-font': [
            'Flama Book'
        ],
        'text-letter-spacing': 0.02,
        'text-line-height': 1.1,
        'text-max-width': 8,
        'text-overlap': 'never',
        'text-size': 14
    },
    paint: {
        'text-color': '#797979',
        'text-halo-color': 'white',
        'text-halo-width': 2
    },
    minzoom: 16
};
const qagomaInterBuildingPathway = {
    id: `qagomaInterBuildingPathway`,
    filter: [
        'all',
        [
            '==',
            [
                'get',
                'type'
            ],
            'interBuildingPathway'
        ]
    ],
    type: 'line',
    source: 'qagoma',
    layout: {
        'line-cap': 'round',
        'line-join': 'round'
    },
    paint: {
        'line-pattern': 'circle',
        'line-color': 'red',
        'line-width': 4,
        'line-opacity': [
            'interpolate',
            [
                'exponential',
                10
            ],
            [
                'zoom'
            ],
            16.9,
            [
                'case',
                [
                    '==',
                    [
                        'get',
                        'detail'
                    ],
                    'low'
                ],
                1,
                0
            ],
            17,
            [
                'case',
                [
                    '==',
                    [
                        'get',
                        'detail'
                    ],
                    'high'
                ],
                1,
                0
            ]
        ]
    }
};
const qagomaInterBuildingPathwayTarget = {
    id: `qagomaInterBuildingPathwayTarget`,
    filter: [
        'all',
        [
            '==',
            [
                'get',
                'type'
            ],
            'interBuildingPathway'
        ]
    ],
    type: 'line',
    source: 'qagoma',
    layout: {
        'line-cap': 'round',
        'line-join': 'round'
    },
    paint: {
        'line-width': 20,
        'line-opacity': 0
    }
};
const qagomaBase = {
    id: `qagomaBase`,
    filter: [
        '==',
        [
            'get',
            'type'
        ],
        'building'
    ],
    type: 'fill',
    source: 'qagoma',
    paint: {
        'fill-color': '#d8d9df'
    }
};
const qagomaBasePattern = {
    id: `qagomaBasePattern`,
    filter: [
        '==',
        [
            'get',
            'type'
        ],
        'building'
    ],
    type: 'fill',
    source: 'qagoma',
    paint: {
        'fill-pattern': 'pattern-diagonalLine'
    }
};
const qagomaBaseBorder = {
    id: `qagomaBaseBorder`,
    filter: [
        '==',
        [
            'get',
            'type'
        ],
        'building'
    ],
    type: 'line',
    source: 'qagoma',
    paint: {
        'line-color': _variablesModuleScss['map-primary'],
        'line-width': interpolateWidth(5),
        'line-offset': interpolateWidth(-2.5)
    }
};
const qagomaLevel = {
    id: `qagomaLevel`,
    filter: levelFilter([
        'all',
        [
            '==',
            [
                'get',
                'type'
            ],
            'level'
        ],
        [
            'var',
            'isActiveLevel'
        ]
    ]),
    type: 'fill',
    source: 'qagoma',
    paint: {
        'fill-color': _variablesModuleScss['map-fill']
    }
};
const qagomaGrass = {
    id: `qagomaGrass`,
    filter: levelFilter([
        'all',
        [
            '==',
            [
                'coalesce',
                [
                    'get',
                    'terrain'
                ],
                [
                    'get',
                    'type'
                ]
            ],
            'grass'
        ],
        [
            'var',
            'isActiveLevel'
        ]
    ]),
    type: 'fill',
    source: 'qagoma',
    paint: {
        'fill-pattern': 'pattern-grass',
        'fill-opacity': [
            'interpolate',
            [
                'exponential',
                2
            ],
            [
                'zoom'
            ],
            17,
            0,
            18,
            1
        ]
    }
};
const qagomaGrassFill = {
    id: `qagomaGrassFill`,
    filter: levelFilter([
        'all',
        [
            '==',
            [
                'coalesce',
                [
                    'get',
                    'terrain'
                ],
                [
                    'get',
                    'type'
                ]
            ],
            'grass'
        ],
        [
            'var',
            'isActiveLevel'
        ]
    ]),
    type: 'fill',
    source: 'qagoma',
    paint: {
        'fill-color': _variablesModuleScss['map-terrain'],
        'fill-opacity': [
            'interpolate',
            [
                'exponential',
                2
            ],
            [
                'zoom'
            ],
            15,
            0,
            18,
            0.25
        ]
    }
};
const qagomaWater = {
    id: `qagomaWater`,
    filter: levelFilter([
        'all',
        [
            '==',
            [
                'get',
                'type'
            ],
            'water'
        ],
        [
            'var',
            'isActiveLevel'
        ]
    ]),
    type: 'fill',
    source: 'qagoma',
    paint: {
        'fill-color': _variablesModuleScss['map-water']
    }
};
const qagomaInaccessible = {
    id: `qagomaInaccessible`,
    filter: levelFilter([
        'all',
        [
            'var',
            'isActiveLevel'
        ],
        [
            'any',
            [
                '==',
                [
                    'get',
                    'type'
                ],
                'inaccessibleAreas'
            ],
            [
                'all',
                closedVenueFilter,
                [
                    'in',
                    [
                        'get',
                        'type'
                    ],
                    [
                        'literal',
                        [
                            'gallery_space',
                            'internal_venue',
                            'internal_venue_fill'
                        ]
                    ]
                ],
                [
                    '!=',
                    [
                        'coalesce',
                        [
                            'get',
                            'hidden'
                        ],
                        false
                    ],
                    true
                ]
            ]
        ]
    ]),
    type: 'fill',
    source: 'qagoma',
    paint: {
        'fill-color': _variablesModuleScss['map-primary'],
        'fill-opacity': 0.25
    }
};
const qagomaInaccessiblePattern = {
    id: `qagomaInaccessiblePattern`,
    filter: qagomaInaccessible.filter,
    type: 'fill',
    source: 'qagoma',
    paint: {
        'fill-pattern': 'pattern-diagonalDash'
    }
};
const qagomaSpaces = {
    id: `qagomaSpaces`,
    filter: levelFilter([
        'all',
        openVenueFilter,
        [
            'in',
            [
                'get',
                'type'
            ],
            [
                'literal',
                [
                    'gallery_space',
                    'internal_venue',
                    'internal_venue_fill'
                ]
            ]
        ],
        [
            'any',
            [
                'boolean',
                [
                    'var',
                    'isActiveLevel'
                ]
            ],
            [
                'coalesce',
                [
                    'get',
                    'ignoreVisibility'
                ],
                false
            ]
        ],
        [
            '!',
            [
                'in',
                [
                    'geometry-type'
                ],
                [
                    'literal',
                    [
                        'Point',
                        'MultiPoint'
                    ]
                ]
            ]
        ]
    ]),
    type: 'fill',
    source: 'qagoma',
    paint: {
        'fill-color': [
            'case',
            [
                'any',
                [
                    '==',
                    [
                        'get',
                        'hidden'
                    ],
                    true
                ],
                [
                    'has',
                    'terrain'
                ]
            ],
            [
                'rgba',
                0,
                0,
                0,
                0
            ],
            [
                '==',
                [
                    'feature-state',
                    'isSelectable'
                ],
                false
            ],
            'rgb(213, 218, 223)',
            [
                '==',
                [
                    'get',
                    'type'
                ],
                'gallery_space'
            ],
            _variablesModuleScss['map-gallery'],
            _variablesModuleScss['map-venue']
        ],
        'fill-opacity': [
            'case',
            [
                '==',
                [
                    'feature-state',
                    'selected'
                ],
                true
            ],
            1,
            [
                '==',
                [
                    'feature-state',
                    'isSelectable'
                ],
                false
            ],
            0.3,
            0.15
        ]
    },
    minzoom: 16
};
const qagomaEntrances = {
    id: `qagomaEntrances`,
    filter: levelFilter([
        'all',
        [
            '==',
            [
                'get',
                'type'
            ],
            'entrance'
        ],
        [
            'var',
            'isActiveLevel'
        ]
    ]),
    type: 'line',
    source: 'qagoma',
    paint: {
        'line-color': _variablesModuleScss['map-fill'],
        'line-width': interpolateWidth(10),
        'line-offset': interpolateWidth([
            'case',
            [
                'all',
                [
                    '==',
                    [
                        'get',
                        'building'
                    ],
                    'goma'
                ],
                [
                    '==',
                    [
                        'get',
                        'level'
                    ],
                    'level_1'
                ]
            ],
            118,
            0
        ])
    }
};
const qagomaInternalWalls = {
    id: `qagomaInternalWalls`,
    filter: levelFilter([
        'all',
        openVenueFilter,
        [
            'in',
            [
                'get',
                'type'
            ],
            [
                'literal',
                [
                    'internalWalls',
                    'inaccessibleAreas',
                    'water'
                ]
            ]
        ],
        [
            'var',
            'isActiveLevel'
        ]
    ]),
    type: 'line',
    source: 'qagoma',
    paint: {
        'line-color': _variablesModuleScss['map-primary'],
        'line-width': interpolateWidth(2.5)
    }
};
const qagomaLevelBorder = {
    id: `qagomaLevelBorder`,
    filter: levelFilter([
        'all',
        [
            'any',
            [
                '==',
                [
                    'get',
                    'type'
                ],
                'level_outline'
            ],
            [
                'all',
                [
                    '==',
                    [
                        'get',
                        'type'
                    ],
                    'level'
                ],
                [
                    '!=',
                    [
                        'get',
                        'outline'
                    ],
                    false
                ]
            ]
        ],
        [
            'var',
            'isActiveLevel'
        ]
    ]),
    type: 'line',
    source: 'qagoma',
    paint: {
        'line-color': _variablesModuleScss['map-primary'],
        'line-width': interpolateWidth(10)
    }
};
const qagomaTraversalBase = {
    id: `qagomaTraversalBase`,
    filter: levelFilter([
        'all',
        openVenueFilter,
        [
            '==',
            [
                'get',
                'type'
            ],
            'traversal'
        ],
        [
            'var',
            'isActiveLevel'
        ]
    ]),
    type: 'fill',
    source: 'qagoma',
    paint: {
        'fill-color': _variablesModuleScss['map-fill']
    }
};
const qagomaTraversal = {
    id: `qagomaTraversal`,
    filter: levelFilter([
        'all',
        openVenueFilter,
        [
            '==',
            [
                'get',
                'type'
            ],
            'traversal'
        ],
        [
            'var',
            'isActiveLevel'
        ]
    ]),
    type: 'line',
    source: 'qagoma',
    paint: {
        'line-color': _variablesModuleScss['map-primary'],
        'line-width': interpolateWidth(2.5)
    }
};
const qagomaAmenities = {
    id: `qagomaAmenities`,
    filter: levelFilter([
        'all',
        openVenueFilter,
        [
            'has',
            'amenity'
        ],
        [
            'var',
            'isActiveLevel'
        ]
    ]),
    type: 'symbol',
    source: 'qagoma',
    layout: {
        'icon-image': [
            'image',
            [
                'get',
                'amenity'
            ]
        ],
        'icon-size': [
            'interpolate',
            [
                'exponential',
                2
            ],
            [
                'zoom'
            ],
            17,
            0.5,
            20,
            1.25
        ],
        'icon-overlap': 'cooperative'
    },
    minzoom: 16
};
const qagomaTraversalIcon = {
    id: `qagomaTraversalIcon`,
    filter: levelFilter([
        'all',
        openVenueFilter,
        [
            'has',
            'traversal'
        ],
        [
            'var',
            'isActiveLevel'
        ]
    ]),
    type: 'symbol',
    source: 'qagoma',
    layout: {
        'icon-image': [
            'image',
            [
                'get',
                'traversal'
            ]
        ],
        'icon-size': [
            'interpolate',
            [
                'exponential',
                2
            ],
            [
                'zoom'
            ],
            17,
            0.5,
            20,
            1.25
        ],
        'icon-overlap': 'cooperative'
    },
    minzoom: 16
};
const qagomaSpacesLabel = {
    id: `qagomaSpacesLabel`,
    filter: levelFilter([
        'all',
        openVenueFilter,
        [
            'in',
            [
                'get',
                'type'
            ],
            [
                'literal',
                [
                    'gallery_space',
                    'internal_venue',
                    'internal_venue_label'
                ]
            ]
        ],
        [
            '!',
            [
                'has',
                'markerLabel'
            ]
        ],
        [
            'any',
            [
                'all',
                [
                    'var',
                    'isActiveLevel'
                ],
                [
                    '!=',
                    [
                        'get',
                        'inverseVisibility'
                    ],
                    true
                ]
            ],
            [
                'all',
                [
                    '==',
                    [
                        'get',
                        'inverseVisibility'
                    ],
                    true
                ],
                [
                    '!',
                    [
                        'var',
                        'isActiveLevel'
                    ]
                ]
            ]
        ]
    ]),
    type: 'symbol',
    source: 'qagoma',
    layout: {
        'icon-image': [
            'case',
            [
                'has',
                'venue'
            ],
            [
                'get',
                'type',
                [
                    'get',
                    'venue'
                ]
            ],
            ''
        ],
        'icon-size': [
            'interpolate',
            [
                'exponential',
                2
            ],
            [
                'zoom'
            ],
            16.5,
            0.5,
            20,
            1.25
        ],
        'icon-anchor': [
            'step',
            [
                'zoom'
            ],
            'center',
            18,
            'bottom'
        ],
        'icon-offset': [
            0,
            -5
        ],
        'text-field': [
            'step',
            [
                'zoom'
            ],
            '',
            18,
            [
                'get',
                'name'
            ]
        ],
        'text-font': [
            'Flama Medium'
        ],
        'text-justify': 'auto',
        'text-letter-spacing': 0.05,
        'text-line-height': 0.9,
        'text-max-width': 8,
        'text-optional': true,
        'text-size': [
            'interpolate',
            [
                'exponential',
                2
            ],
            [
                'zoom'
            ],
            16,
            9,
            20,
            28
        ],
        'text-anchor': 'top'
    },
    paint: {
        'text-color': _variablesModuleScss['map-primary'],
        'text-halo-color': _variablesModuleScss['map-fill'],
        'text-halo-width': [
            'interpolate',
            [
                'exponential',
                2
            ],
            [
                'zoom'
            ],
            16.5,
            [
                'case',
                [
                    'has',
                    'terrain'
                ],
                2,
                1
            ],
            20,
            [
                'case',
                [
                    'has',
                    'terrain'
                ],
                5,
                3
            ]
        ]
    },
    minzoom: 16.5
};
const qagomaSpacesMarker = {
    id: `qagomaSpacesMarker`,
    filter: levelFilter([
        'all',
        [
            'in',
            [
                'get',
                'type'
            ],
            [
                'literal',
                [
                    'gallery_space',
                    'internal_venue'
                ]
            ]
        ],
        [
            'has',
            'markerLabel'
        ],
        [
            'var',
            'isActiveLevel'
        ]
    ]),
    type: 'symbol',
    source: 'qagoma',
    layout: {
        'icon-image': 'marker',
        'icon-size': [
            'interpolate',
            [
                'exponential',
                2
            ],
            [
                'zoom'
            ],
            16,
            0.5,
            20,
            1.5
        ],
        'icon-anchor': 'bottom',
        'icon-allow-overlap': true,
        'icon-overlap': 'always',
        'text-anchor': 'bottom',
        'text-field': [
            'get',
            'markerLabel'
        ],
        'text-font': [
            'Flama Medium'
        ],
        'text-letter-spacing': 0.07,
        'text-line-height': 1.1,
        'text-max-width': 8,
        'text-offset': [
            0,
            -1.25
        ],
        'text-overlap': 'never',
        'text-size': [
            'interpolate',
            [
                'exponential',
                2
            ],
            [
                'zoom'
            ],
            16,
            9,
            20,
            28
        ]
    },
    paint: {
        'text-color': _variablesModuleScss['map-fill'],
        'text-halo-color': _variablesModuleScss['map-primary'],
        'text-halo-width': [
            'interpolate',
            [
                'exponential',
                2
            ],
            [
                'zoom'
            ],
            16.5,
            [
                'case',
                [
                    'has',
                    'terrain'
                ],
                2,
                1
            ],
            20,
            [
                'case',
                [
                    'has',
                    'terrain'
                ],
                5,
                3
            ]
        ]
    },
    minzoom: 16
};
const qagomaEntranceLabels = {
    id: `qagomaEntranceLabels`,
    filter: levelFilter([
        'all',
        [
            '==',
            [
                'get',
                'type'
            ],
            'entranceLabel'
        ],
        [
            'var',
            'isActiveLevel'
        ]
    ]),
    type: 'symbol',
    source: 'qagoma',
    layout: {
        'symbol-placement': 'line-center',
        'icon-allow-overlap': true,
        'icon-anchor': 'top',
        'icon-image': 'arrow',
        'icon-offset': [
            0,
            2
        ],
        'icon-overlap': 'always',
        'icon-rotation-alignment': 'map',
        'icon-size': [
            'interpolate',
            [
                'exponential',
                2
            ],
            [
                'zoom'
            ],
            16,
            0.4,
            20,
            1
        ],
        'text-allow-overlap': true,
        'text-anchor': 'center',
        'text-field': 'Entrance',
        'text-font': [
            'Flama Medium'
        ],
        'text-keep-upright': true,
        'text-letter-spacing': 0.07,
        'text-line-height': 1.1,
        'text-max-width': 20,
        'text-offset': [
            0,
            2.25
        ],
        'text-overlap': 'always',
        'text-padding': 20,
        'text-rotation-alignment': 'map',
        'text-size': [
            'interpolate',
            [
                'exponential',
                2
            ],
            [
                'zoom'
            ],
            16,
            11,
            20,
            28
        ]
    },
    paint: {
        'text-color': _variablesModuleScss['map-outline'],
        'text-halo-color': _variablesModuleScss['map-fill'],
        'text-halo-width': [
            'interpolate',
            [
                'exponential',
                2
            ],
            [
                'zoom'
            ],
            16,
            1,
            20,
            3
        ]
    },
    minzoom: 16
};
const qagomaBaseCover = {
    id: `qagomaBaseCover`,
    filter: [
        '==',
        [
            'get',
            'type'
        ],
        'building'
    ],
    type: 'fill',
    source: 'qagoma',
    paint: {
        'fill-color': _variablesModuleScss['map-primary'],
        'fill-opacity': [
            'interpolate',
            [
                'exponential',
                0.5
            ],
            [
                'zoom'
            ],
            16,
            1,
            17,
            0
        ]
    },
    maxzoom: 17
};
const qagomaBaseCoverBorder = {
    id: `qagomaBaseCoverBorder`,
    filter: [
        '==',
        [
            'get',
            'type'
        ],
        'building'
    ],
    type: 'line',
    source: 'qagoma',
    paint: {
        'line-color': _variablesModuleScss['map-outline'],
        'line-width': 2,
        'line-opacity': [
            'interpolate',
            [
                'exponential',
                0.5
            ],
            [
                'zoom'
            ],
            16,
            1,
            17,
            0
        ]
    },
    maxzoom: 17
};
const qagomaInterBuildingPathwayPoints = {
    id: `qagomaInterBuildingPathwayPoints`,
    filter: [
        'all',
        [
            '==',
            [
                'get',
                'type'
            ],
            'interBuildingPathwayPoint'
        ]
    ],
    type: 'symbol',
    source: 'qagoma',
    layout: {
        'icon-anchor': 'top',
        'icon-image': 'entrance-arrow',
        'icon-offset': [
            0,
            -5
        ],
        'icon-padding': 0,
        'icon-rotation-alignment': 'map',
        'icon-size': 0.5,
        'symbol-placement': 'line-center'
    },
    maxzoom: 17
};
const qagomaBuildingLabels = {
    id: `qagomaBuildingLabels`,
    filter: [
        'all',
        [
            '==',
            [
                'get',
                'type'
            ],
            'buildingLabel'
        ]
    ],
    type: 'symbol',
    source: 'qagoma',
    layout: {
        'symbol-sort-key': -1,
        'symbol-avoid-edges': true,
        'text-justify': 'center',
        'text-anchor': 'center',
        'text-field': [
            'get',
            'name'
        ],
        'text-font': [
            'Flama Medium'
        ],
        'text-letter-spacing': 0.07,
        'text-line-height': 1.1,
        'text-max-width': 8,
        'text-overlap': 'always',
        'text-allow-overlap': true,
        'text-radial-offset': 10,
        'text-size': [
            'interpolate',
            [
                'exponential',
                1.16
            ],
            [
                'zoom'
            ],
            0,
            18,
            15,
            18,
            22,
            16
        ]
    },
    paint: {
        'text-opacity': [
            'interpolate',
            [
                'exponential',
                0.5
            ],
            [
                'zoom'
            ],
            14,
            1,
            16,
            1,
            17,
            0
        ],
        'text-color': _variablesModuleScss['map-fill'],
        'text-halo-color': _variablesModuleScss['map-primary'],
        'text-halo-width': 1.5,
        'text-halo-blur': 0
    },
    maxzoom: 17
};

},{"/src/assets/styles/variables.module.scss":"3byYk","@parcel/transformer-js/src/esmodule-helpers.js":"68Hdb"}],"3byYk":[function(require,module,exports,__globalThis) {
module.exports["--c-off-white"] = "var(--c-off-white)";
module.exports["--c-goma-grey"] = "var(--c-goma-grey)";
module.exports["--c-white"] = "var(--c-white)";
module.exports["--c-mid-grey"] = "var(--c-mid-grey)";
module.exports["--c-map-blue"] = "var(--c-map-blue)";
module.exports["--c-goma-grey-hover"] = "var(--c-goma-grey-hover)";
module.exports["--c-goma-grey-selected"] = "var(--c-goma-grey-selected)";
module.exports["--c-goma-grey-disabled"] = "var(--c-goma-grey-disabled)";
module.exports["--g-gap"] = "var(--g-gap)";
module.exports["--g-col-size"] = "var(--g-col-size)";
module.exports["--container-width"] = "var(--container-width)";
module.exports["--slope"] = "var(--slope)";
module.exports["map-primary"] = "#65677f";
module.exports["map-outline"] = "#51536f";
module.exports["map-fill"] = "#ffffff";
module.exports["map-terrain"] = "#569972";
module.exports["map-water"] = "#a4cae1";
module.exports["map-gallery"] = "#db519b";
module.exports["map-venue"] = "#64acd6";

},{}],"fD8Om":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    version: 8,
    glyphs: '/assets/fonts/pbf/{fontstack}/{range}.pbf',
    name: 'protomaps-themes-base/light-customised',
    sources: {
        protomaps: {
            type: 'vector',
            tiles: [
                'https://api.protomaps.com/tiles/v2/{z}/{x}/{y}.pbf'
            ],
            minzoom: 0,
            maxzoom: 14,
            attribution: '<a href="https://protomaps.com" target="_blank">Protomaps</a> \xa9 <a href="https://www.openstreetmap.org" target="_blank"> OpenStreetMap</a>'
        }
    },
    layers: [
        {
            id: 'background',
            type: 'background',
            paint: {
                'background-color': '#f2f2f2'
            }
        },
        {
            id: 'earth',
            type: 'fill',
            source: 'protomaps',
            'source-layer': 'earth',
            paint: {
                'fill-color': '#f2f2f2'
            }
        },
        {
            id: 'landuse_park',
            type: 'fill',
            source: 'protomaps',
            'source-layer': 'landuse',
            filter: [
                'any',
                [
                    '==',
                    'pmap:kind',
                    'park'
                ],
                [
                    '==',
                    'landuse',
                    'cemetery'
                ]
            ],
            paint: {
                'fill-color': '#f9f9f9'
            }
        },
        {
            id: 'landuse_hospital',
            type: 'fill',
            source: 'protomaps',
            'source-layer': 'landuse',
            filter: [
                'any',
                [
                    '==',
                    'pmap:kind',
                    'hospital'
                ]
            ],
            paint: {
                'fill-color': '#f2f2f2'
            }
        },
        {
            id: 'landuse_industrial',
            type: 'fill',
            source: 'protomaps',
            'source-layer': 'landuse',
            filter: [
                'any',
                [
                    '==',
                    'pmap:kind',
                    'industrial'
                ]
            ],
            paint: {
                'fill-color': '#f2f2f2'
            }
        },
        {
            id: 'landuse_school',
            type: 'fill',
            source: 'protomaps',
            'source-layer': 'landuse',
            filter: [
                'any',
                [
                    '==',
                    'pmap:kind',
                    'school'
                ]
            ],
            paint: {
                'fill-color': '#f2f2f2'
            }
        },
        {
            id: 'landuse_pedestrian',
            type: 'fill',
            source: 'protomaps',
            'source-layer': 'landuse',
            filter: [
                'any',
                [
                    '==',
                    'highway',
                    'footway'
                ]
            ],
            paint: {
                'fill-color': '#f2f2f2'
            }
        },
        {
            id: 'water',
            type: 'fill',
            source: 'protomaps',
            'source-layer': 'water',
            paint: {
                'fill-color': '#c8e5f3'
            }
        },
        {
            id: 'roads_tunnels_other_casing',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '<',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'other'
                ]
            ],
            paint: {
                'line-color': '#ffffff',
                'line-gap-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    14,
                    0,
                    14.5,
                    0.5,
                    20,
                    12
                ]
            }
        },
        {
            id: 'roads_tunnels_other',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '<',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'other'
                ]
            ],
            paint: {
                'line-color': '#f7f7f7',
                'line-dasharray': [
                    1,
                    1
                ],
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    14,
                    0,
                    14.5,
                    0.5,
                    20,
                    12
                ]
            }
        },
        {
            id: 'roads_tunnels_minor_casing',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '<',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'minor_road'
                ]
            ],
            paint: {
                'line-color': '#e2e2e2',
                'line-dasharray': [
                    3,
                    2
                ],
                'line-gap-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0,
                    12.5,
                    0.5,
                    20,
                    32
                ],
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0,
                    12.5,
                    1
                ]
            }
        },
        {
            id: 'roads_tunnels_minor',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '<',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'minor_road'
                ]
            ],
            paint: {
                'line-color': '#ebebeb',
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0,
                    12.5,
                    0.5,
                    20,
                    32
                ]
            }
        },
        {
            id: 'roads_tunnels_medium_casing',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '<',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'medium_road'
                ]
            ],
            paint: {
                'line-color': '#e1e1e1',
                'line-dasharray': [
                    3,
                    2
                ],
                'line-gap-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    7,
                    0,
                    7.5,
                    0.5,
                    20,
                    32
                ],
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    0,
                    10.5,
                    1
                ]
            }
        },
        {
            id: 'roads_tunnels_medium',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '<',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'medium_road'
                ]
            ],
            paint: {
                'line-color': '#ebebeb',
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    7,
                    0,
                    7.5,
                    0.5,
                    20,
                    32
                ]
            }
        },
        {
            id: 'roads_tunnels_major_casing',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '<',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'major_road'
                ]
            ],
            paint: {
                'line-color': '#e8e8e8',
                'line-dasharray': [
                    3,
                    2
                ],
                'line-gap-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    7,
                    0,
                    7.5,
                    0.5,
                    19,
                    32
                ],
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    9,
                    0,
                    9.5,
                    1
                ]
            }
        },
        {
            id: 'roads_tunnels_major',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '<',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'major_road'
                ]
            ],
            paint: {
                'line-color': '#ebebeb',
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    7,
                    0,
                    7.5,
                    0.5,
                    19,
                    32
                ]
            }
        },
        {
            id: 'roads_tunnels_highway_casing',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '<',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'highway'
                ]
            ],
            paint: {
                'line-color': '#e8e8e8',
                'line-dasharray': [
                    3,
                    2
                ],
                'line-gap-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    3,
                    0,
                    3.5,
                    0.5,
                    18,
                    32
                ],
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    7,
                    0,
                    7.5,
                    1
                ]
            }
        },
        {
            id: 'roads_tunnels_highway',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '<',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'highway'
                ]
            ],
            paint: {
                'line-color': '#ebebeb',
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    3,
                    0,
                    3.5,
                    0.5,
                    18,
                    32
                ]
            }
        },
        {
            id: 'physical_line_waterway',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'physical_line',
            filter: [
                '==',
                [
                    'get',
                    'pmap:kind'
                ],
                'waterway'
            ],
            paint: {
                'line-color': '#c8e5f3',
                'line-width': 0.5
            }
        },
        {
            id: 'buildings',
            type: 'fill',
            source: 'protomaps',
            'source-layer': 'buildings',
            filter: [
                '!',
                [
                    'in',
                    [
                        'get',
                        'name'
                    ],
                    [
                        'literal',
                        [
                            'Gallery of Modern Art',
                            'Queensland Art Gallery'
                        ]
                    ]
                ]
            ],
            paint: {
                'fill-color': '#e8e8e8',
                'fill-outline-color': '#d4d4d4'
            }
        },
        {
            id: 'roads_other',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '==',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'other'
                ]
            ],
            paint: {
                'line-color': '#ffffff',
                'line-dasharray': [
                    2,
                    1
                ],
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    14,
                    0,
                    14.5,
                    0.5,
                    20,
                    12
                ]
            }
        },
        {
            id: 'roads_minor_casing',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '==',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'minor_road'
                ]
            ],
            paint: {
                'line-color': '#e2e2e2',
                'line-gap-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0,
                    12.5,
                    0.5,
                    20,
                    32
                ],
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0,
                    12.5,
                    1
                ]
            }
        },
        {
            id: 'roads_minor',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '==',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'minor_road'
                ]
            ],
            paint: {
                'line-color': 'white',
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0,
                    12.5,
                    0.5,
                    20,
                    32
                ]
            }
        },
        {
            id: 'roads_medium_casing',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '==',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'medium_road'
                ]
            ],
            paint: {
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.5
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    0.75,
                    18,
                    2
                ],
                'line-color': 'rgb(232, 232, 232)',
                'line-gap-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.5
                    ],
                    [
                        'zoom'
                    ],
                    5,
                    0.1,
                    18,
                    26
                ]
            }
        },
        {
            id: 'roads_medium',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '==',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'medium_road'
                ]
            ],
            paint: {
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.5
                    ],
                    [
                        'zoom'
                    ],
                    5,
                    0.1,
                    18,
                    26
                ],
                'line-color': 'rgb(255, 255, 255)'
            }
        },
        {
            id: 'roads_major',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '==',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'major_road'
                ]
            ],
            paint: {
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.5
                    ],
                    [
                        'zoom'
                    ],
                    5,
                    0.75,
                    18,
                    32
                ],
                'line-color': 'rgb(255, 255, 255)'
            }
        },
        {
            id: 'roads_highway_casing',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '==',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'highway'
                ]
            ],
            paint: {
                'line-color': '#e8e8e8',
                'line-gap-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    3,
                    0,
                    3.5,
                    0.5,
                    18,
                    32
                ],
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    7,
                    0,
                    7.5,
                    1
                ]
            }
        },
        {
            id: 'roads_highway',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '==',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'highway'
                ]
            ],
            paint: {
                'line-color': '#fefffc',
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    3,
                    0,
                    3.5,
                    0.5,
                    18,
                    32
                ]
            }
        },
        {
            id: 'transit_railway',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'transit',
            filter: [
                'all',
                [
                    '==',
                    'pmap:kind',
                    'railway'
                ]
            ],
            paint: {
                'line-color': 'rgb(218, 218, 218)',
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.5
                    ],
                    [
                        'zoom'
                    ],
                    14,
                    0.5,
                    20,
                    1
                ]
            }
        },
        {
            id: 'transit_railway_tracks',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'transit',
            filter: [
                'all',
                [
                    '==',
                    'pmap:kind',
                    'railway'
                ]
            ],
            paint: {
                'line-color': 'rgb(218, 218, 218)',
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.5
                    ],
                    [
                        'zoom'
                    ],
                    14,
                    4,
                    20,
                    8
                ],
                'line-dasharray': [
                    0.1,
                    15
                ],
                'line-opacity': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    13.75,
                    0,
                    14,
                    1
                ]
            }
        },
        {
            id: 'physical_line_waterway_label',
            type: 'symbol',
            source: 'protomaps',
            'source-layer': 'physical_line',
            minzoom: 14,
            layout: {
                'symbol-placement': 'line',
                'text-font': [
                    'Flama Book'
                ],
                'text-field': [
                    'get',
                    'name'
                ],
                'text-size': 16
            },
            paint: {
                'text-color': '#6d9db6'
            }
        },
        {
            id: 'roads_bridges_other_casing',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '>',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'other'
                ]
            ],
            paint: {
                'line-color': '#ffffff',
                'line-gap-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    14,
                    0,
                    14.5,
                    0.5,
                    20,
                    12
                ]
            }
        },
        {
            id: 'roads_bridges_other_fill',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '>',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'other'
                ]
            ],
            paint: {
                'line-color': '#f2f2f2',
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    14,
                    0,
                    14.5,
                    10,
                    20,
                    24
                ]
            }
        },
        {
            id: 'roads_bridges_other',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '>',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'other'
                ]
            ],
            paint: {
                'line-color': '#ffffff',
                'line-dasharray': [
                    2,
                    1
                ],
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    14,
                    0,
                    14.5,
                    0.5,
                    20,
                    12
                ]
            }
        },
        {
            id: 'roads_bridges_minor_casing',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '>',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'minor_road'
                ]
            ],
            paint: {
                'line-color': '#e2e2e2',
                'line-gap-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0,
                    12.5,
                    0.5,
                    20,
                    32
                ],
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0,
                    12.5,
                    1
                ]
            }
        },
        {
            id: 'roads_bridges_minor',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '>',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'minor_road'
                ]
            ],
            paint: {
                'line-color': 'white',
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0,
                    12.5,
                    0.5,
                    20,
                    32
                ]
            }
        },
        {
            id: 'roads_bridges_medium_casing',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '>',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'medium_road'
                ]
            ],
            paint: {
                'line-color': '#e1e1e1',
                'line-gap-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    7,
                    0,
                    7.5,
                    0.5,
                    20,
                    32
                ],
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    0,
                    10.5,
                    1
                ]
            }
        },
        {
            id: 'roads_bridges_medium',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '>',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'medium_road'
                ]
            ],
            paint: {
                'line-color': '#ffffff',
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    7,
                    0,
                    7.5,
                    0.5,
                    20,
                    32
                ]
            }
        },
        {
            id: 'roads_bridges_major_casing',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '>',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'major_road'
                ]
            ],
            paint: {
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.5
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    [
                        'match',
                        [
                            'get',
                            'class'
                        ],
                        'primary',
                        1,
                        0.75
                    ],
                    18,
                    2
                ],
                'line-color': 'rgb(232, 232, 232)',
                'line-gap-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.5
                    ],
                    [
                        'zoom'
                    ],
                    5,
                    [
                        'match',
                        [
                            'get',
                            'class'
                        ],
                        'primary',
                        0.75,
                        0.1
                    ],
                    18,
                    [
                        'match',
                        [
                            'get',
                            'class'
                        ],
                        'primary',
                        32,
                        26
                    ]
                ],
                'line-opacity': [
                    'step',
                    [
                        'zoom'
                    ],
                    0,
                    10,
                    1
                ]
            }
        },
        {
            id: 'roads_major_casing',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '==',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'major_road'
                ]
            ],
            paint: {
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.5
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    1,
                    18,
                    2
                ],
                'line-color': 'rgb(232, 232, 232)',
                'line-gap-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.5
                    ],
                    [
                        'zoom'
                    ],
                    5,
                    0.75,
                    18,
                    32
                ]
            }
        },
        {
            id: 'roads_bridges_major',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '>',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'major_road'
                ]
            ],
            layout: {
                'line-cap': [
                    'step',
                    [
                        'zoom'
                    ],
                    'butt',
                    14,
                    'round'
                ]
            },
            paint: {
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.5
                    ],
                    [
                        'zoom'
                    ],
                    5,
                    [
                        'match',
                        [
                            'get',
                            'class'
                        ],
                        'primary',
                        0.75,
                        0.1
                    ],
                    18,
                    [
                        'match',
                        [
                            'get',
                            'class'
                        ],
                        'primary',
                        32,
                        26
                    ]
                ],
                'line-color': 'rgb(255, 255, 255)'
            }
        },
        {
            id: 'roads_bridges_highway_casing',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '>',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'highway'
                ]
            ],
            paint: {
                'line-color': '#e8e8e8',
                'line-gap-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    3,
                    0,
                    3.5,
                    0.5,
                    18,
                    32
                ],
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    7,
                    0,
                    7.5,
                    1
                ]
            }
        },
        {
            id: 'roads_bridges_highway',
            type: 'line',
            source: 'protomaps',
            'source-layer': 'roads',
            filter: [
                'all',
                [
                    '>',
                    'pmap:level',
                    0
                ],
                [
                    '==',
                    'pmap:kind',
                    'highway'
                ]
            ],
            paint: {
                'line-color': '#fefffc',
                'line-width': [
                    'interpolate',
                    [
                        'exponential',
                        1.6
                    ],
                    [
                        'zoom'
                    ],
                    3,
                    0,
                    3.5,
                    0.5,
                    18,
                    32
                ]
            }
        },
        {
            id: 'roads_labels',
            type: 'symbol',
            source: 'protomaps',
            'source-layer': 'roads',
            layout: {
                'symbol-placement': 'line',
                'text-font': [
                    'Flama Book'
                ],
                'text-field': [
                    'get',
                    'name'
                ],
                'text-size': 14
            },
            paint: {
                'text-color': '#797979',
                'text-halo-color': 'white',
                'text-halo-width': 2
            }
        },
        {
            id: 'mask',
            type: 'fill',
            source: 'protomaps',
            'source-layer': 'mask',
            paint: {
                'fill-color': '#dddddd'
            }
        },
        {
            id: 'physical_point_ocean',
            type: 'symbol',
            source: 'protomaps',
            'source-layer': 'physical_point',
            filter: [
                'any',
                [
                    '==',
                    'place',
                    'sea'
                ],
                [
                    '==',
                    'place',
                    'ocean'
                ]
            ],
            layout: {
                'text-font': [
                    'Flama Book'
                ],
                'text-field': [
                    'get',
                    'name'
                ],
                'text-size': 14,
                'text-letter-spacing': 0.15
            },
            paint: {
                'text-color': 'white',
                'text-halo-color': '#a4cae1',
                'text-halo-width': 1
            }
        },
        {
            id: 'places_subplace',
            type: 'symbol',
            source: 'protomaps',
            'source-layer': 'places',
            filter: [
                '==',
                'pmap:kind',
                'neighbourhood'
            ],
            layout: {
                'text-field': '{name}',
                'text-font': [
                    'Flama Book'
                ],
                'text-size': {
                    base: 1.2,
                    stops: [
                        [
                            11,
                            10
                        ],
                        [
                            14,
                            12
                        ]
                    ]
                },
                'text-transform': 'uppercase'
            },
            paint: {
                'text-color': '#757d91',
                'text-halo-color': 'white',
                'text-halo-width': 0.5
            }
        },
        {
            id: 'places_city_circle',
            type: 'circle',
            source: 'protomaps',
            'source-layer': 'places',
            filter: [
                '==',
                'pmap:kind',
                'city'
            ],
            paint: {
                'circle-radius': 2,
                'circle-stroke-width': 2,
                'circle-stroke-color': 'white',
                'circle-color': '#666666'
            },
            maxzoom: 8
        },
        {
            id: 'places_city',
            type: 'symbol',
            source: 'protomaps',
            'source-layer': 'places',
            filter: [
                '==',
                'pmap:kind',
                'city'
            ],
            layout: {
                'text-field': '{name}',
                'text-font': [
                    'Flama Medium'
                ],
                'text-size': [
                    'step',
                    [
                        'get',
                        'pmap:rank'
                    ],
                    0,
                    1,
                    12,
                    2,
                    10
                ],
                'text-variable-anchor': [
                    'bottom-left'
                ],
                'text-radial-offset': 0.2
            },
            paint: {
                'text-color': '#787878',
                'text-halo-color': 'white',
                'text-halo-width': 1
            }
        }
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"68Hdb"}],"lrjqx":[function(require,module,exports,__globalThis) {
const _temp0 = require("cb9cf6a6e4713d31");
const _temp1 = require("a0ab5238f53a25d5");
const _temp2 = require("c9455387c744feda");
const _temp3 = require("24fa6ee91197fdd8");
const _temp4 = require("2db28b486f0a8d72");
const _temp5 = require("71970ecea39ca649");
const _temp6 = require("204eeb5cd87e9c9d");
const _temp7 = require("b43d7b9847de32f4");
const _temp8 = require("407d6fea2c627c3a");
const _temp9 = require("1801382211000103");
const _temp10 = require("a1195a3d1e066b3b");
const _temp11 = require("eb4f0dd05f9e80eb");
const _temp12 = require("a0eb0876797c2b05");
const _temp13 = require("fc3f63bf0c75d047");
const _temp14 = require("3d36ea8c181aa89");
const _temp15 = require("98c7a5896f9401dd");
const _temp16 = require("4e291bf55e25574e");
const _temp17 = require("9a2632c0820d3f8c");
const _temp18 = require("69b1e467e3dd98fd");
const _temp19 = require("1cd07c88a968a88c");
const _temp20 = require("85a067b867591150");
const _temp21 = require("f8cabc6d8bd2f1eb");
const _temp22 = require("41e7d8771e7a0c36");
const _temp23 = require("956369df4c8be917");
module.exports = {
    "arrow": _temp0,
    "baby": _temp1,
    "basket": _temp2,
    "bus": _temp3,
    "circle": _temp4,
    "coathanger": _temp5,
    "elevator": _temp6,
    "entrance-arrow": _temp7,
    "escalator": _temp8,
    "film": _temp9,
    "first-aid": _temp10,
    "food": _temp11,
    "info": _temp12,
    "marker": _temp13,
    "parking": _temp14,
    "pattern-diagonalDash": _temp15,
    "pattern-diagonalLine": _temp16,
    "pattern-grass": _temp17,
    "person-dress": _temp18,
    "person": _temp19,
    "stairs": _temp20,
    "ticket": _temp21,
    "toilet": _temp22,
    "train": _temp23
};

},{"cb9cf6a6e4713d31":"1jSYs","a0ab5238f53a25d5":"iej5V","c9455387c744feda":"3pkVN","24fa6ee91197fdd8":"fbQZc","2db28b486f0a8d72":"7eSgi","71970ecea39ca649":"01dvd","204eeb5cd87e9c9d":"4siCD","b43d7b9847de32f4":"dHdUW","407d6fea2c627c3a":"2odrH","1801382211000103":"k3Dis","a1195a3d1e066b3b":"RSkba","eb4f0dd05f9e80eb":"1MLhM","a0eb0876797c2b05":"8Alqd","fc3f63bf0c75d047":"13L1y","3d36ea8c181aa89":"6h8U1","98c7a5896f9401dd":"2fOUQ","4e291bf55e25574e":"1Ak93","9a2632c0820d3f8c":"aOkwQ","69b1e467e3dd98fd":"ikCVO","1cd07c88a968a88c":"gM6j7","85a067b867591150":"7p18h","f8cabc6d8bd2f1eb":"8D07i","41e7d8771e7a0c36":"byjML","956369df4c8be917":"7sDlg"}],"1jSYs":[function(require,module,exports,__globalThis) {
module.exports = require("f81e92ca83b10206").getBundleURL('2c9kW') + "../images/arrow.73d21102.svg";

},{"f81e92ca83b10206":"dqXhb"}],"iej5V":[function(require,module,exports,__globalThis) {
module.exports = require("ebc1d773cfc598b9").getBundleURL('2c9kW') + "../images/baby.167c9afa.svg";

},{"ebc1d773cfc598b9":"dqXhb"}],"3pkVN":[function(require,module,exports,__globalThis) {
module.exports = require("1efe0c44aa2c197a").getBundleURL('2c9kW') + "../images/basket.4974ed98.svg";

},{"1efe0c44aa2c197a":"dqXhb"}],"fbQZc":[function(require,module,exports,__globalThis) {
module.exports = require("f1a07db3acd63785").getBundleURL('2c9kW') + "../images/bus.b8577684.svg";

},{"f1a07db3acd63785":"dqXhb"}],"7eSgi":[function(require,module,exports,__globalThis) {
module.exports = require("b385dbe98760e809").getBundleURL('2c9kW') + "../images/circle.13ecd4ba.svg";

},{"b385dbe98760e809":"dqXhb"}],"01dvd":[function(require,module,exports,__globalThis) {
module.exports = require("272c6772d607e793").getBundleURL('2c9kW') + "../images/coathanger.09f0d4e7.svg";

},{"272c6772d607e793":"dqXhb"}],"4siCD":[function(require,module,exports,__globalThis) {
module.exports = require("869b57f8cd6c7326").getBundleURL('2c9kW') + "../images/elevator.f4dcfc22.svg";

},{"869b57f8cd6c7326":"dqXhb"}],"dHdUW":[function(require,module,exports,__globalThis) {
module.exports = require("b687490c84dbc311").getBundleURL('2c9kW') + "../images/entrance-arrow.9385de0d.svg";

},{"b687490c84dbc311":"dqXhb"}],"2odrH":[function(require,module,exports,__globalThis) {
module.exports = require("319a6d2c2a176ac3").getBundleURL('2c9kW') + "../images/escalator.fa586bad.svg";

},{"319a6d2c2a176ac3":"dqXhb"}],"k3Dis":[function(require,module,exports,__globalThis) {
module.exports = require("952ce126bc9292c7").getBundleURL('2c9kW') + "../images/film.ac25e3be.svg";

},{"952ce126bc9292c7":"dqXhb"}],"RSkba":[function(require,module,exports,__globalThis) {
module.exports = require("efffd250e11c924b").getBundleURL('2c9kW') + "../images/first-aid.3b271d3f.svg";

},{"efffd250e11c924b":"dqXhb"}],"1MLhM":[function(require,module,exports,__globalThis) {
module.exports = require("1f2dd59f42013ed7").getBundleURL('2c9kW') + "../images/food.6762c7ad.svg";

},{"1f2dd59f42013ed7":"dqXhb"}],"8Alqd":[function(require,module,exports,__globalThis) {
module.exports = require("a2fdb71c6377e3ec").getBundleURL('2c9kW') + "../images/info.03dd8cd9.svg";

},{"a2fdb71c6377e3ec":"dqXhb"}],"13L1y":[function(require,module,exports,__globalThis) {
module.exports = require("15a467e2518cb3b9").getBundleURL('2c9kW') + "../images/marker.f7ef3d6e.svg";

},{"15a467e2518cb3b9":"dqXhb"}],"6h8U1":[function(require,module,exports,__globalThis) {
module.exports = require("508bc93b8a10d5d5").getBundleURL('2c9kW') + "../images/parking.555a64aa.svg";

},{"508bc93b8a10d5d5":"dqXhb"}],"2fOUQ":[function(require,module,exports,__globalThis) {
module.exports = require("287f6d70a962ed94").getBundleURL('2c9kW') + "../images/pattern-diagonalDash.334ef050.svg";

},{"287f6d70a962ed94":"dqXhb"}],"1Ak93":[function(require,module,exports,__globalThis) {
module.exports = require("3329b099a2f0aa64").getBundleURL('2c9kW') + "../images/pattern-diagonalLine.d0864ee7.svg";

},{"3329b099a2f0aa64":"dqXhb"}],"aOkwQ":[function(require,module,exports,__globalThis) {
module.exports = require("b9ced433ebdc4016").getBundleURL('2c9kW') + "../images/pattern-grass.d1f613dd.svg";

},{"b9ced433ebdc4016":"dqXhb"}],"ikCVO":[function(require,module,exports,__globalThis) {
module.exports = require("4a4f383df8497b3").getBundleURL('2c9kW') + "../images/person-dress.937fd6a0.svg";

},{"4a4f383df8497b3":"dqXhb"}],"gM6j7":[function(require,module,exports,__globalThis) {
module.exports = require("f65a8c691c80e1fd").getBundleURL('2c9kW') + "../images/person.d4a1a84c.svg";

},{"f65a8c691c80e1fd":"dqXhb"}],"7p18h":[function(require,module,exports,__globalThis) {
module.exports = require("5992236e8cc13313").getBundleURL('2c9kW') + "../images/stairs.1320acd1.svg";

},{"5992236e8cc13313":"dqXhb"}],"8D07i":[function(require,module,exports,__globalThis) {
module.exports = require("fa086ebbc67d4211").getBundleURL('2c9kW') + "../images/ticket.c33843e3.svg";

},{"fa086ebbc67d4211":"dqXhb"}],"byjML":[function(require,module,exports,__globalThis) {
module.exports = require("d04bf5d793a9e0fc").getBundleURL('2c9kW') + "../images/toilet.df4c78ba.svg";

},{"d04bf5d793a9e0fc":"dqXhb"}],"7sDlg":[function(require,module,exports,__globalThis) {
module.exports = require("87fe615c6b292071").getBundleURL('2c9kW') + "../images/train.fdf27324.svg";

},{"87fe615c6b292071":"dqXhb"}],"7s1jh":[function(require,module,exports,__globalThis) {
const _temp0 = require("1bf16ccfbc4f7920");
const _temp1 = require("5a4bc0f400726188");
const _temp2 = require("8254253de6c1adca");
const _temp3 = require("1e25de80fa822ea4");
const _temp4 = require("a49f0aa0ee259960");
const _temp5 = require("32d730a110f53135");
const _temp6 = require("c13c0b29ca0205c2");
module.exports = {
    "bodhi-tree": _temp0,
    "sculpture": _temp1,
    "snowman": _temp2,
    "the-high-perpetual-xmas-no-abstractions": _temp3,
    "the-world-turns": _temp4,
    "tow-row": _temp5,
    "we-are-shipwrecked-and-landlocked": _temp6
};

},{"1bf16ccfbc4f7920":"cK9DL","5a4bc0f400726188":"bNNTy","8254253de6c1adca":"9YEkJ","1e25de80fa822ea4":"7anvG","a49f0aa0ee259960":"hpK5Z","32d730a110f53135":"hpkHY","c13c0b29ca0205c2":"iayLl"}],"cK9DL":[function(require,module,exports,__globalThis) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"71.44\" height=\"108.85\"><defs><linearGradient id=\"z\" x1=\"51.07\" x2=\"46.88\" y1=\"2781.32\" y2=\"2862.97\" gradientTransform=\"matrix(1 0 0 -1 .03 2860.28)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#48a187\"/><stop offset=\".12\" stop-color=\"#5aaa7e\"/><stop offset=\".35\" stop-color=\"#78ba6f\"/><stop offset=\".57\" stop-color=\"#8cc463\"/><stop offset=\".79\" stop-color=\"#98ca5c\"/><stop offset=\"1\" stop-color=\"#9dcd5b\"/></linearGradient><linearGradient id=\"b\" x1=\"31.95\" x2=\"31.95\" y1=\"2776.32\" y2=\"2860.2\" gradientTransform=\"matrix(1 0 0 -1 .03 2860.28)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#a2d397\"/><stop offset=\".15\" stop-color=\"#8ac592\"/><stop offset=\".36\" stop-color=\"#6db58d\"/><stop offset=\".58\" stop-color=\"#58aa89\"/><stop offset=\".79\" stop-color=\"#4da387\"/><stop offset=\"1\" stop-color=\"#48a187\"/></linearGradient></defs><path d=\"M14.64 100.6c.83 1.96 3.11 3.84 6.9 5.35 9.69 3.87 25.4 3.87 35.09 0s9.69-10.15 0-14.02-25.4-3.87-35.09 0c-3.89 1.55-6.19 3.5-6.96 5.52l.06 3.16Z\" opacity=\".25\"/><path d=\"M34.31.09C19.23.86 20.33 13.7 4.09 43.89c-12.33 22.92 4.8 41.56 35.67 39.98 18.37-.94 32.5-16.6 31.56-34.97C70.37 30.52 52.68-.85 34.31.09\" style=\"fill:#9bcc5b\"/><path d=\"M41.92 13.21c-2.69 12.78-16.11 16.46-14.66 23.98 2.66 13.77 25.77-15.49 33.31-6.22 5.77 7.11 4.05 21.41-5.33 27.09-14.22 8.62-17.57 30.62 8.22 14.06 5.28-6.24 8.3-14.42 7.85-23.22-.9-17.57-17.11-47-34.59-48.73 3.83 2.12 6.68 5.99 5.19 13.04z\" style=\"fill:url(#z)\"/><path d=\"M63.48 72.11c-25.81 16.59-22.47-5.42-8.24-14.04 9.38-5.69 11.1-19.99 5.33-27.09-7.54-9.27-30.65 19.99-33.31 6.22C25.8 29.67 39.23 26 41.92 13.22 43.41 6.15 40.53 2.27 36.68.16 35.89.08 35.1.06 34.3.1 19.23.86 20.33 13.7 4.09 43.89c-12.33 22.92 4.8 41.56 35.67 39.98 9.57-.49 17.99-4.98 23.73-11.76Z\" style=\"fill:url(#b)\"/><path d=\"M71.39 48.89c-.48-9.28-5.18-21.71-11.98-31.68-3.59-5.27-7.62-9.6-11.66-12.53C43.19 1.36 38.67-.2 34.3.02 23.89.55 21.17 6.79 15.2 20.46c-2.72 6.22-6.09 13.95-11.17 23.39-5.12 9.51-5.37 18.8-.7 26.17 2.92 4.62 7.71 8.33 13.84 10.75 5.35 2.11 11.73 3.21 18.65 3.25-.78 6.45-2.13 15.78-2.13 15.78l8.86.19s-1.62-9.15-2.48-16.08c8.79-.53 16.86-4.41 22.77-10.95 5.97-6.62 9.01-15.17 8.55-24.07m-8.66 23.98c-5.88 6.52-13.93 10.38-22.68 10.91-.47-3.83-.7-6.95-.28-7.41.63-.7 1.18-1.21 1.52-1.56 2.38-.14 4.79-1.42 6.96-2.25 2.6-1 5.04-2.34 6.59-4.73.02-.03-.03-.07-.05-.04-2.92 3.75-8.71 5.13-13.53 5.93 2.4-1.48 4.45-3.7 5.9-5.92.25-.38.49-.77.74-1.16.05.01.1.02.16 0 4.07-.98 8.15-4.35 10.98-7.35 2.75-2.91 5.43-6.53 5.32-10.72 0-.02-.03-.02-.03 0-1.98 7.76-8.29 14.67-15.98 17.32 2.38-3.96 4.43-8.5 4.82-13.02 0-.03-.04-.04-.05 0-.79 4.56-3.05 8.98-5.54 12.86-1.4 2.19-3.02 4.36-5.16 5.9-1.05.76-2.23 1.26-3.36 1.85 1.76-3.57 1.69-8.4 1.75-12.11 0-.44 0-.88.02-1.32 2.25-3.5 4-7.12 5.54-11 1.44-3.64 1.64-7.09 2.29-10.86h-.02c-1.07 4.06-1.52 7.85-3.21 11.78-1.38 3.2-3.25 6.19-4.6 9.39.05-5.07-.17-10.22-2.57-14.78 0-.02-.05 0-.04.02 1.7 5.11 2.06 10.24 1.88 15.59-.17 4.92-.48 9.46-2.54 13.83-2.75-4.06-5.3-8-6.9-12.74-1.69-4.99-1.61-10.06-2.61-15.16 0-.02-.03 0-.03 0-.04 5.53.42 11.33 2.26 16.59.12.35.26.72.39 1.08-2.28-2.9-4.45-6.84-5.88-10.04-2.12-4.74-3.34-9.66-3.44-14.86h-.02c-.15 5.6 1.09 11.09 3.59 16.11 1.35 2.71 2.81 5.43 4.51 7.93.4.59.85 1.44 1.56 1.72 1.34 3.47 3.18 7.13 5.85 9.63-.86.01-1.71 0-2.43-.04-3.35-1.74-6.01-5.75-7.98-8.64-2.3-3.38-3.24-7.27-5.19-10.8h-.01c1.36 4.11 2.74 8.14 4.98 11.78-1.79-1.24-4.06-2.15-5.65-3.41-2.6-2.07-4.85-4.36-6.9-6.98-1.49-1.9-2.91-3.79-4.14-5.85-.51-.85-1.02-2.12-1.88-2.69-.17-.11-.36.17-.2.29 1.41.99 2.12 3.57 3.13 4.97 1.52 2.1 3.07 4.25 4.83 6.15 3.26 3.51 7.16 6.59 11.52 8.62.45.65.92 1.3 1.44 1.92.99 1.19 2.42 3.25 4.07 4.51-.87-.13-1.76-.19-2.67-.41-2.62-.62-4.95-1.87-7.11-3.45-3.81-2.79-7.12-5.83-10.09-9.51-.06-.07-.16 0-.12.08 2.23 4.58 6.47 7.73 10.55 10.58 2.87 2 5.92 3.13 9.27 3.53.22.11.53.21.97.28 2.05.35 2.98.75 3.09 3.01.03.68-.19 2.89-.53 5.65C20.9 83.78 8.95 78.7 3.4 69.93c-4.63-7.32-4.38-16.57.71-26.03 5.08-9.45 8.46-17.18 11.18-23.4C21.28 6.9 23.99.69 34.31.16c.27-.01.54-.02.81-.02 4.08 0 8.3 1.56 12.54 4.65 4.02 2.92 8.04 7.25 11.62 12.5 6.79 9.95 11.48 22.36 11.96 31.61.45 8.87-2.57 17.38-8.52 23.97Z\" style=\"fill:#131f36\"/></svg>";

},{}],"bNNTy":[function(require,module,exports,__globalThis) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"21.408\" height=\"100\"><path d=\"M12.39 93.562s2.165-.065 3.437.143c1.271.209 3.668.667 4.106 1.105s.458.771.27 1.167 0 .626-.187.938-.417.355-.313.688.188.563-.187.98-1.73 1.105-3.752 1.23-3.94.104-6.712-.105c-2.772-.208-3.564-.229-4.71-.416s-1.689-.438-2.168-.71-1.334-.312-1.397-.54.25-.855-.146-1.397-.52-.458-.52-.938.985-1.192 2.48-1.459c1.52-.27 2.159-.288 2.159-.288\" style=\"fill:#9e9fa3\"/><path d=\"M7.095 15.46s-.577-1.788-1.154-3.807-.577-3.75-.75-5.307-.195-2.85.111-3.538c.377-.845 1.028-.76 1.375-1.452S7.21 0 8.133.059c.923.057 2.769.461 3.519 1.211s1.615 1.615 1.615 2.769.083 1.562.288 2.25.53 1.278.173 1.846-.461.98-.577 2.653-.576 2.596-1.038 3.346-.322.83-.346 1.557.058.865.52 1.038.586.287 1.96 1.443c1.375 1.155.49.818 1.375 1.155l.885.338s.105-.686.278-1.263.231-.865.174-1.615-.351-1.595.115-1.269.539.504.692 1.27 1.038.46 1.442.75 1.205 1.689 1.212 2.48.2.975-.577 1.615-1.154.923-1.154.923.466.14.808.923.9 2.936 1.211 5.422.75 3.75.635 5.422c-.116 1.673-.284 2.638-.886 2.895-.503.216-2.172.278-3.383.105 0 0-.591-.083-.677.196s-.129 1.354-.043 1.89.28 1.805.28 2.6-.044 1.697-.151 2.428-.236 1.396-.193 1.955.107 1.353.107 2.148.058 1.28 0 2.127 0 3.673-.107 4.511-.344 3.867-.73 5.628-1.526 5.264-1.913 6.273-.58 1.955-.644 2.278-.228 1.417-.258 1.718.064 1.139.107 1.762.451 5.284.15 7.626-.45 5.65-.6 6.875-.28 3.501-.302 4.253-.106 1.295.108 1.633 1.267 1.31 1.633 1.697.988.988 1.267 1.246.559.365.193.473-.86.385-1.439.365-.88-.13-1.654-.559-1.59-1.01-2.041-1.117-.838-.258-.838-.451.108-.43-.172-.43-1.289.022-1.761.108-.86.064-1.29.043-.794.021-1.095-.172-.258-.344-.021-.516 2.47-.816 2.943-1.16.967-.902 1.332-2.04 0-2.836-.086-3.524-.322-2.513-.537-3.308-.58-2.084-.774-3.008-.515-2.921-.623-3.587-.43-1.955-.386-2.943 0-1.934-.043-2.45-.172-1.654-.15-2.384-.022-1.482-.087-2.04-1.181-2.88-1.74-4.319-1.933-5.22-2.685-8.464S.929 49.012.95 47.745s.172-2.04.408-2.385.408-.386.408-.386-.236-.967-.021-1.848 1.29-2.426 1.675-3.158.73-1.31.752-2.02-.687-3.05-.687-3.05-.258.043-.516.344-.408.516-.515.28-.07-.889.215-1.526.43-1.053.386-1.246-1.39-2.168-1.547-2.62-.214-.667-.085-.774.257-.022.257-.022-.923-1.826-.58-3.48 3.115-4.039 3.523-4.36 1.418-1.247 1.762-1.934.687-1.01.752-1.719-.043-2.38-.043-2.38Z\" style=\"fill:#a5a9b5\"/><path d=\"M21.097 31.37c-.416-2.885-.96-6.467-1.185-7.144-.211-.633-.875-1.324-1.14-1.582a4 4 0 0 0 .34-.294c.126-.126.288-.244.459-.37.4-.293.855-.626.933-1.156.108-.73-.007-1.213-.289-1.956-.283-.747-.353-.805-.806-1.187l-.048-.04c-.463-.39-1.247-.252-1.452-.207-.16-.13-.168-.484-.176-.827-.007-.315-.014-.612-.128-.816a.53.53 0 0 0-.338-.279c-.245-.059-.474.091-.484.098l-.052.035.003.062c.033.684.075 2.064.003 2.39l-.025.111c-.071.314-.175.784-.228 1.337-.113-.06-.564-.288-.88-.327-.31-.04-.607-.306-1.113-.851-.402-.433-.756-.685-1.13-.953a13 13 0 0 1-.444-.325 6 6 0 0 0-.75-.472c-.145-.08-.327-.18-.348-.222-.02-.104-.011-1.103 0-1.789.249-.35.467-.756.633-1.16.48-1.171.908-3.114.908-3.824 0-.348.138-.771.27-1.18.14-.426.27-.83.27-1.182 0-.39-.154-.675-.304-.951-.123-.227-.239-.44-.256-.698a3.4 3.4 0 0 1 .016-.602c.024-.254.05-.543.004-1.1-.083-.992-.606-1.646-1.676-2.654C10.641.272 9.204.07 8.214.005 7.287-.059 6.95.557 6.598 1.208l-.05.094c-.158.29-.35.396-.573.518-.272.148-.58.316-.812.852-.416.956-.386 1.859-.168 3.401.1.717.159 1.312.215 1.888a27 27 0 0 0 .245 1.998c.145.852.457 1.71.708 2.398.136.371.253.692.315.934.065.251.156.509.244.758.161.455.328.925.353 1.402.038.71-.068 2.274-.079 2.435-.048.147-.56 1.652-1.749 2.803-.266.258-.556.534-.856.817-1.134 1.075-2.42 2.294-2.903 3.067-.612.978-.698 1.306-.678 1.924.02.606.409 1.989.426 2.051l.244.766c-.13.046-.27.152-.27.361 0 .2.349.817.88 1.735.152.263.29.5.375.66q.082.15.163.288c.25.435.384.692.205.934l-.018.039c-.001.004-.12.461-.35.788-.326.462-.357 1.221-.142 1.472.048.055.123.129.228.129.132 0 .224-.107.364-.27q.049-.057.11-.125l.066-.075c.09-.1.207-.232.27-.273l.008.03c.014.074.061.204.126.383.215.595.616 1.702.526 2.644-.069.72-.736 1.841-1.324 2.83-.411.691-.799 1.343-.959 1.81-.338.99-.192 1.986-.138 2.27-.128.084-.392.29-.514.608-.189.492-.35 1.625-.185 3.2.183 1.742 1.198 6.783 2.055 9.471.854 2.68 2.546 6.994 3.183 8.45.5 1.143.434 2.285.394 2.968q-.016.238-.017.404c0 .596.2 1.837.208 1.87 0 .025-.057 2.55.15 3.97.098.67.257 1.506.411 2.314.175.916.356 1.864.45 2.586.085.655.278 1.333.481 2.052.228.805.465 1.638.589 2.554q.075.543.157 1.1c.202 1.384.41 2.815.318 3.627-.12 1.044-.984 2.434-1.683 2.702-.244.094-.576.21-.927.331-.793.276-1.613.56-1.889.751-.015.01-.018.026-.031.037l-.003-.091c-.026 0-.665.02-2.176.29C.983 94.42 0 95.173 0 95.706c0 .353.064.442.25.648.076.084.17.189.292.355.246.337.187.72.144 1-.023.15-.04.267-.015.361.05.187.323.257.699.353.255.066.544.14.75.256.454.257 1 .524 2.204.721.865.142 1.528.189 2.98.292.48.034 1.049.074 1.74.127 1.624.121 2.976.181 4.25.181.841 0 1.649-.026 2.477-.077 2.073-.129 3.448-.845 3.827-1.266.409-.455.32-.737.218-1.065l-.007-.022c-.052-.166-.005-.218.107-.344.058-.064.129-.144.195-.254.11-.182.11-.341.11-.494 0-.143 0-.278.083-.453.228-.482.143-.857-.293-1.293-.489-.488-3.077-.957-4.167-1.136-1.15-.188-3.026-.155-3.381-.146-.254-.348-.283-.577-.303-.738a1 1 0 0 0-.026-.153c-.046-.187.124-2.314.241-3.611.05-.633.135-1.506.233-2.516.255-2.63.604-6.232.604-8.365 0-2.82-.392-6.456-.418-6.691a29 29 0 0 1 .415-2.696c.094-.443.327-1.081.622-1.89.592-1.625 1.404-3.85 1.957-6.754.725-3.802.666-6.614.638-7.965q-.008-.33-.008-.558c0-.398.02-.78.04-1.156a.1.1 0 0 0 .014-.068l-.01-.035q.002-.046.003-.092c.033-.598.063-1.162.022-1.655-.069-.825-.138-2.42-.14-2.422.001-.009.073-.919.278-2.292.172-1.143.018-2.484-.118-3.667a71 71 0 0 1-.09-.821c-.133-1.327.124-1.812.125-1.816l-.191-.11c-.012.022-.295.535-.154 1.948q.042.4.091.824c.134 1.17.286 2.495.12 3.61a35 35 0 0 0-.28 2.32c0 .017.07 1.615.139 2.444.033.395.015.852-.009 1.329-.037-.056-.072-.111-.123-.174-.283-.354-1.216-.78-1.256-.797a.11.11 0 0 0-.145.055.11.11 0 0 0 .055.146c.256.116.966.474 1.174.734.178.223.25.39.277.467-.021.398-.043.803-.043 1.228q.001.229.008.563c.03 1.447.086 4.14-.634 7.919-.55 2.886-1.358 5.102-1.948 6.72-.298.816-.533 1.461-.63 1.92a30 30 0 0 0-.42 2.73l-.001.012.001.011c.004.038.418 3.791.418 6.679 0 2.122-.348 5.718-.603 8.343a167 167 0 0 0-.233 2.52c-.052.568-.305 3.422-.235 3.686q.014.055.02.124c.036.287.096.766 1.102 1.622.672.572 1.156 1.055 1.51 1.408.252.252.452.452.615.578.123.095.126.143.126.143-.01.023-.095.056-.145.056-.04 0-.087.016-.228.066-.036.014-.09.031-.135.047l.09-.068c-.01-.012-.229-.303-.456-.542a3.5 3.5 0 0 0-.59-.478l-.118.187c.003.002.318.202.548.443.188.198.369.43.418.495a5 5 0 0 1-.423.12c-.024-.05-.126-.229-.446-.5-.35-.296-.949-.636-.974-.65l-.11.192c.007.003.608.344.941.626.207.175.307.303.355.374a2.1 2.1 0 0 1-.748.017c-.521-.1-.831-.314-1.3-.64-.24-.165-.511-.353-.871-.57-.676-.408-1.037-.429-1.275-.443-.153-.009-.204-.015-.268-.087-.316-.357-.092-1.004.07-1.476l.058-.17c.004-.016.311-1.519.415-2.77.06-.713-.268-2.45-.648-4.46-.298-1.574-.634-3.357-.82-4.864-.314-2.531-.443-4.525-.385-5.927.035-.848-.233-1.728-.242-1.756a5.8 5.8 0 0 1-.132-1.36 7 7 0 0 0-.036-.794c-.08-.722.034-2.122.154-3.604l.016-.196c.135-1.661.213-3.175.213-5.996 0-1.732-.042-3.042-.079-4.198-.024-.76-.045-1.416-.048-2.044-.009-1.38.275-2.381.687-3.194q.013-.017.02-.038c.332-.645.743-1.172 1.163-1.657.906-1.046 2.247-1.514 2.26-1.52l-.07-.208c-.058.02-1.41.491-2.357 1.584-.37.426-.735.879-1.047 1.415-.25-1.115-1.1-2.786-2.032-3.272-.754-.394-1.477-.325-2.114-.265-.216.02-.42.04-.612.04-.673 0-1.078-.855-1.078-1.079a.11.11 0 1 0-.221 0c0 .314.475 1.3 1.3 1.3.201 0 .41-.02.632-.04.606-.058 1.295-.124 1.99.24.941.49 1.83 2.372 1.971 3.392-.427.84-.722 1.875-.713 3.304.003.63.024 1.288.049 2.05.037 1.153.078 2.461.078 4.19 0 2.814-.078 4.323-.212 5.978l-.016.196c-.121 1.493-.236 2.904-.153 3.647.032.288.033.522.034.77.002.39.004.794.14 1.415.002.01.268.881.234 1.691-.058 1.413.071 3.42.386 5.963.187 1.514.525 3.301.823 4.878.377 1.995.702 3.717.645 4.4-.103 1.238-.408 2.729-.408 2.731l-.053.156c-.181.524-.429 1.24-.028 1.694.128.145.264.153.42.162.218.012.546.032 1.175.41.354.215.622.4.859.564.492.341.817.567 1.384.675q.18.034.366.033c.552 0 1.106-.199 1.4-.305.065-.024.14-.05.152-.053.093 0 .301-.05.354-.206q.063-.186-.2-.389a7 7 0 0 1-.595-.56c-.356-.355-.843-.842-1.522-1.42a5 5 0 0 1-.546-.526c.588-.01 2.163-.018 3.17.147 1.718.282 3.684.712 4.046 1.074.42.42.406.71.249 1.042-.104.22-.104.394-.104.548 0 .14 0 .25-.078.38-.056.093-.117.16-.17.221-.125.14-.243.272-.154.557l.007.022c.099.316.153.49-.171.85-.356.397-1.67 1.07-3.677 1.194-2.07.128-4.01.098-6.697-.104-.691-.052-1.26-.092-1.74-.126-1.446-.103-2.105-.15-2.96-.29-1.17-.19-1.694-.448-2.132-.695-.23-.13-.535-.209-.803-.278-.193-.049-.515-.132-.541-.197-.014-.049.003-.156.02-.27.046-.3.116-.753-.184-1.163a4 4 0 0 0-.306-.373c-.156-.173-.193-.214-.193-.5 0-.386.909-1.086 2.39-1.35 1.131-.202 1.774-.262 2.022-.28a.3.3 0 0 0-.017.236c.087.25.474.44.826.421.007 0 .614.02 1.255.02.352 0 .496-.042.648-.087.133-.04.271-.08.588-.1.675-.04 1.235-.021 1.24-.02l.008-.221c-.005 0-.575-.021-1.261.02-.342.021-.5.068-.638.11a1.7 1.7 0 0 1-.585.078c-.637 0-1.241-.02-1.258-.02-.282.016-.567-.135-.615-.273-.007-.022-.027-.08.083-.155.25-.174 1.092-.466 1.835-.724.353-.123.687-.239.934-.334.841-.323 1.706-1.856 1.823-2.883.096-.84-.106-2.222-.32-3.685-.053-.368-.107-.736-.156-1.096-.126-.932-.364-1.772-.594-2.586-.202-.71-.392-1.38-.475-2.02-.095-.728-.277-1.68-.452-2.599a58 58 0 0 1-.41-2.304c-.204-1.401-.148-3.909-.149-3.954-.002-.013-.206-1.276-.206-1.854q.001-.16.016-.391c.041-.703.11-1.878-.412-3.07-.635-1.452-2.323-5.754-3.175-8.428-.853-2.676-1.863-7.694-2.046-9.427-.212-2.024.132-2.994.172-3.098.132-.342.48-.535.484-.537l.074-.04-.019-.082c-.002-.01-.255-1.142.116-2.227.152-.445.535-1.087.94-1.768.629-1.058 1.28-2.153 1.354-2.922.094-.992-.317-2.13-.538-2.74a4 4 0 0 1-.118-.352c-.005-.023-.015-.036-.022-.055.066-.003.143-.004.22-.003.188 0 .404.001.585-.034a3.1 3.1 0 0 0 .858-.317l-.109-.192c-.004.002-.38.214-.79.293-.16.03-.364.03-.544.03-.187-.002-.334-.002-.422.03l.014.038c-.133.004-.263.142-.449.35l-.066.075q-.062.07-.113.128c-.069.08-.163.19-.196.193 0 0-.019-.004-.06-.052-.14-.163-.116-.818.155-1.201.228-.323.35-.742.378-.84.253-.365.04-.733-.205-1.158a13 13 0 0 1-.16-.283c-.086-.16-.224-.4-.378-.666-.318-.548-.849-1.466-.85-1.624 0-.147.165-.167.198-.17l.14-.009-.322-1.011c-.004-.015-.397-1.416-.416-1.996-.019-.574.059-.863.644-1.799.468-.75 1.743-1.957 2.868-3.023.3-.285.591-.561.858-.819 1.286-1.246 1.789-2.842 1.81-2.909l.005-.025c.004-.07.12-1.716.08-2.475-.027-.508-.2-.994-.366-1.464-.09-.256-.176-.497-.238-.74-.065-.252-.184-.577-.321-.954-.249-.68-.557-1.526-.698-2.359a27 27 0 0 1-.243-1.982c-.057-.579-.115-1.177-.217-1.898-.211-1.5-.243-2.374.152-3.283.203-.466.452-.602.715-.746.233-.127.473-.258.662-.606l.05-.094C7.152.651 7.41.171 8.2.224c.956.064 2.342.257 3.334 1.192 1.028.968 1.53 1.59 1.607 2.51.045.54.019.817-.004 1.062a4 4 0 0 0-.018.495 1.7 1.7 0 0 1-.387-.179c-.134-.08-.268-.214-.409-.355-.226-.227-.46-.461-.754-.534-.454-.114-1.461.028-1.504.034l.017.22c.008-.001.946-.008 1.32.114.215.07.325.167.463.29.096.086.204.182.36.278.49.3.779.363.92.374.04.257.144.48.258.689q.08.149.145.299a2.1 2.1 0 0 0-.715-.418c-.588-.196-.794-.532-.802-.573a.056.056 0 0 0-.065-.043.055.055 0 0 0-.044.065c.02.1.274.455.876.656.416.138.7.404.821.534.03.103.062.205.062.326 0 .318-.126.704-.26 1.114q-.014.054-.032.108a2.2 2.2 0 0 0-.097-.495 2 2 0 0 0-.017-.342c-.032-.286-.383-.694-.709-.825-.272-.109-.61-.494-.64-.558a.055.055 0 0 0-.11.01c0 .093.419.535.71.65.283.114.612.492.64.735l.003.046a1.4 1.4 0 0 0-.24-.336c-.288-.291-.692-.427-1.196-.404-.076-.008-1.87-.196-2.721.245-.778.403-1.41 1.024-1.787 1.395l-.102.1a.055.055 0 1 0 .077.079l.102-.1c.373-.367.997-.98 1.76-1.376.823-.425 2.641-.235 2.668-.233q.721-.03 1.12.37c.166.168.267.372.33.567v.008c0 .004.007.005.007.009.112.351.1.667.099.672 0 .016.017.02.028.031-.093.309-.174.615-.174.892 0 .684-.432 2.621-.892 3.74a5.7 5.7 0 0 1-.605 1.115h-.041l-.002.06c-.38.518-.799.842-1.156.859-1.255.056-1.936-.546-1.942-.552l-.15.163c.03.027.748.671 2.102.61.394-.019.79-.305 1.14-.719-.007.557-.015 1.421.01 1.542.027.133.19.222.457.37.208.115.466.257.722.454.155.12.304.226.45.33.365.26.71.507 1.097.923.554.598.866.872 1.248.92.312.039.841.322.846.325l.05-.094q-.015.207-.018.424c-.182 0-.363.081-.539.169-.258.128-.501.25-.729.096-.366-.247-.275-.925-.274-.932a.11.11 0 0 0-.094-.124.11.11 0 0 0-.125.093c-.005.034-.111.821.37 1.146a.6.6 0 0 0 .353.11c.214 0 .42-.103.598-.192.158-.079.305-.147.434-.148v1.175l-.665.553a.11.11 0 0 0-.14-.012c-.025.02-.649.475-1.371-.15-.336-.29-.233-.708-.102-1.238.104-.42.222-.897.138-1.41-.197-1.218-1.944-1.263-2.018-1.264-.055.005-.112.047-.113.108a.11.11 0 0 0 .109.113c.016 0 1.636.04 1.804 1.079.076.468-.036.921-.135 1.321-.136.555-.266 1.08.172 1.458.336.29.66.379.93.379.118 0 .222-.018.316-.042a1399 1399 0 0 0-4.607 3.85 3.2 3.2 0 0 0-.303-.612c-.238-.375-.946-.764-.976-.78a.11.11 0 1 0-.106.194c.007.004.688.378.896.705.209.328.303.626.309.645-1.058.89-1.899 1.604-2.12 1.81a7 7 0 0 0-.565.617c-.246.292-.463.533-.735.68a.1.1 0 0 0-.014-.062 31 31 0 0 0-1.078-1.404c-.301-.368-.748-.806-1.131-1.16a.1.1 0 0 0 .028-.068c0-.152 0-.613.199-.968.299-.534.683-.76.794-.797a.11.11 0 0 0-.07-.21c-.205.069-.617.365-.917.9-.194.346-.22.752-.225.97a10 10 0 0 0-.555-.477.11.11 0 1 0-.123.184c.102.068 1.258 1.068 1.83 1.766a30 30 0 0 1 1.068 1.393c.005.007.015.005.022.011-.096.032-.194.06-.309.066-.813.047-1.644-.364-1.652-.368a.11.11 0 1 0-.099.198c.036.018.888.439 1.763.39.644-.035.982-.437 1.373-.902a6 6 0 0 1 .547-.597c.701-.655 7.94-6.672 8.012-6.732l.04-.034v-1.38c0-.815.161-1.526.257-1.951l.025-.112c.088-.395.022-2.017.006-2.38a.4.4 0 0 1 .258-.038q.117.029.196.17c.087.158.094.441.1.716.01.426.02.868.322 1.035l.039.022.043-.011c.008-.002.865-.218 1.303.151l.047.04c.435.365.48.403.743 1.097.268.706.378 1.162.277 1.845-.065.438-.462.729-.846 1.01-.178.13-.347.254-.485.392-.33.33-1.004.774-1.546 1.131-.162.107-.313.207-.441.295-.289.196-.536.603-.986 1.342-.48.79-1.206 1.983-2.458 3.693-1.54 2.103-3.297 3.941-5.222 5.463l-.049.038c-.578.457-.892.44-1.47.288-.51-.132-.794-.382-1.739-1.209l-.323-.283c-1.18-1.03-2.584-3.341-2.598-3.364a.11.11 0 0 0-.189.114c.058.096 1.435 2.364 2.642 3.417l.323.282c.949.831 1.268 1.11 1.828 1.257.229.06.43.104.63.104.312 0 .622-.107 1.033-.433l.049-.038c.435-.344.859-.71 1.277-1.086a.1.1 0 0 0 .062.034c.008 0 .21.02.759.05.058.004.155.005.282.005 1.117 0 4.623-.113 5.866-.196a30 30 0 0 1 2.594-.05c.07 0 .112-.046.114-.107a.11.11 0 0 0-.107-.114c-.012 0-1.258-.039-2.616.05-1.34.09-5.574.221-6.12.192a32 32 0 0 1-.634-.04 29 29 0 0 0 3.786-4.244 48 48 0 0 0 1.412-2.031c.202.167.947.841 1.256 1.922.402 1.406-.572 2.626-.582 2.639a.11.11 0 0 0 .171.14c.043-.054 1.057-1.32.623-2.84-.146-.51-.38-.93-.615-1.257.006 0 .011.006.017.006l.017-.001a.11.11 0 0 0 .093-.126c-.034-.223-.03-1.239-.022-1.745.001-.054-.04-.095-.091-.105l.19-.31c.433-.713.672-1.105.92-1.275.129-.087.279-.186.44-.292.343-.226.73-.484 1.062-.732.231.224.909.917 1.109 1.518.122.365.425 1.894 1.176 7.106.268 1.855.42 3.051.212 4.224-.21 1.176-.315 1.52-1.296 1.638-1.071.13-3.915-.102-6.209-.505-2-.35-4.31-1.157-5.55-1.59a49 49 0 0 0-.632-.219l-.07.21c.165.055.378.13.629.217 1.247.435 3.567 1.246 5.585 1.6 1.896.333 4.093.545 5.453.545.327 0 .605-.013.82-.038 1.14-.137 1.28-.657 1.487-1.82.215-1.205.06-2.416-.21-4.293Zm-5.225-4.136a4 4 0 0 0-.635-.665c.24-.368.436-.682.613-.97-.004.335-.012 1.34.022 1.635M13.06 97.433l-.016.22a17 17 0 0 0-1.258-.02c-.509.004-1.207.008-2.264-.003-1.886-.02-2.142-.056-3.568-.26a130 130 0 0 0-1.143-.162c-2.543-.35-4.19-1.432-4.206-1.443l.122-.183c.016.01 1.624 1.065 4.114 1.408.459.063.83.116 1.144.16 1.414.204 1.668.24 3.54.26 1.055.01 1.751.006 2.26.003.6-.003.931-.006 1.275.02m4.15.062c.399-.016.687-.028 1.096-.33.288-.214.367-.353.43-.465.059-.102.1-.176.309-.3.46-.277.926-.534.93-.536l-.106-.194c-.004.003-.474.262-.938.54-.258.154-.32.264-.386.38-.059.104-.12.212-.37.397-.355.262-.588.271-.974.288a7 7 0 0 0-.563.042c-.719.09-1.108.068-1.168.051l-.07.21c.045.014.155.026.331.026.216 0 .528-.018.934-.068a6 6 0 0 1 .545-.04Zm-6.456-58.95c.06.017.12-.02.135-.078s-.02-.12-.078-.135a.44.44 0 0 0-.388.073c-.166.126-.265.365-.27.658-.005.229.143.39.377.41l.047.001c.195 0 .403-.1.43-.277a.11.11 0 0 0-.218-.032c-.006.036-.109.098-.24.087q-.179-.015-.175-.185c.004-.221.072-.402.182-.485a.22.22 0 0 1 .198-.037M5.527 45.98q-.408-.11-.787-.203c-1.365-.331-2.167-.83-2.175-.836a.11.11 0 0 0-.118.187c.034.021.838.523 2.24.863q.378.093.783.203c1.164.31 2.47.658 4.146.658q.22 0 .452-.008a65 65 0 0 0 3.914-.256.11.11 0 0 0 .098-.121.11.11 0 0 0-.122-.098c-.016.001-1.636.17-3.898.254-1.866.07-3.282-.31-4.533-.643M8.72 69.957c-.058 0-.114.041-.118.102-.004.051-.083 1.264.496 2.154a.11.11 0 1 0 .185-.12c-.538-.827-.462-2.007-.46-2.018a.11.11 0 0 0-.103-.118m1.864 2.933a.11.11 0 0 0 .083.205c.034-.014.815-.343 1.034-1.217.198-.792.077-2.025.071-2.077a.11.11 0 1 0-.219.022c.001.012.122 1.248-.067 2.002-.19.763-.895 1.062-.902 1.065M7.389 3.304c-.623.012-1.422.463-1.456.482l-.674.385.754-.181c.011-.003 1.108-.262 2.077-.154.988.11 1.967.265 1.977.267l.326.045-.238-.24c-.078-.079-.287-.29-1.317-.75a12.4 12.4 0 0 1-1.852-1.036l-.127.18c.007.006.539.375 1.278.76l.72.504c-.363-.126-.904-.271-1.468-.262m1.875 1.09a6.3 6.3 0 0 0-1.307-.046 4 4 0 0 0-1.444.38l-.551.283 4.047-.49zM6.61 6.374l-.22.62.41-.514c.004-.005.367-.457.776-.64.43-.19 1.426-.498 1.436-.501l-.045-.216c-.043.005-1.074.12-1.632.47-.57.356-.72.764-.725.781m1.418-4.09.22-.005a3 3 0 0 0 0-.179c.008-.175.037-.476.136-.856a.86.86 0 0 1 .553-.6c.11-.035.16-.043.163-.043L9.072.38a1 1 0 0 0-.2.053 5 5 0 0 0-.642.264c-.604.288-1.081.927-1.101.954l.171.139c.14-.16.426-.42.593-.438.07.037.127.365.135.736-.005.119 0 .187 0 .194Zm.224 4.754a.055.055 0 0 0-.072-.031c-.027.01-.686.271-1.487 1.032l-.647.787a.055.055 0 1 0 .085.07l.643-.782c.779-.74 1.44-1.002 1.447-1.004a.055.055 0 0 0 .031-.072m2.23 5.054a.5.5 0 0 1-.12-.089.55.55 0 0 0-.23-.144.9.9 0 0 0-.424 0 .055.055 0 0 0-.038.068c.008.03.039.046.068.038.002 0 .181-.05.366 0 .076.021.129.07.184.12a.6.6 0 0 0 .148.108.8.8 0 0 0 .347.075.77.77 0 0 0 .57-.243c.096-.105.115-.268.097-.456.065.03.34.172.348.419.01.355-.125.824-.127.828l.054.016c.005-.02.139-.482.128-.846-.01-.312-.39-.474-.407-.48l-.003.007a5 5 0 0 0-.13-.59c-.053-.2-.104-.39-.113-.527-.017-.257.164-.595.498-.929a.055.055 0 1 0-.078-.078c-.21.21-.557.62-.53 1.014.01.149.062.343.117.549.103.388.22.827.064 1-.189.208-.514.265-.79.14Zm-1.114 1.073a.055.055 0 0 0 .012.077c.02.015.515.368 1.001.368s.845-.251.86-.262a.055.055 0 1 0-.064-.09 1.5 1.5 0 0 1-.796.242c-.45 0-.932-.344-.936-.348a.055.055 0 0 0-.077.013m2-.253a.055.055 0 0 0-.06-.05.06.06 0 0 0-.044.03c-.015.007-.072.022-.241.008a.45.45 0 0 1-.262-.097c-.054-.04-.11-.081-.215-.066a.32.32 0 0 0-.225.132.32.32 0 0 0-.225-.132c-.106-.015-.161.026-.216.066a.45.45 0 0 1-.261.097c-.17.014-.226-.001-.242-.007a.06.06 0 0 0-.044-.03.055.055 0 0 0-.06.05c0 .009 0 .033.022.056.021.022.066.048.202.048q.055 0 .13-.007a.55.55 0 0 0 .318-.118c.048-.035.075-.054.136-.045.136.02.173.12.175.126.008.024.033.03.057.03.002 0 0 .004.003.004q.002 0 .004-.001.003.002.005.002c.003 0 0-.005.003-.007.024.001.05-.004.058-.028.001-.005.038-.107.175-.126.06-.009.087.01.135.045a.55.55 0 0 0 .318.118q.075.007.13.007c.137 0 .181-.026.203-.048a.07.07 0 0 0 .022-.057Zm-1.4.23c.07.015.11.035.15.055.054.026.105.051.21.052h.004c.09 0 .145-.025.194-.048.052-.024.096-.045.177-.033.17.026.37.001.378 0l-.007-.055a1.6 1.6 0 0 1-.363 0 .32.32 0 0 0-.208.038c-.046.021-.093.043-.17.043h-.005c-.092 0-.133-.021-.186-.047a.6.6 0 0 0-.164-.058 1.4 1.4 0 0 0-.375-.014l.006.055c.002 0 .196-.02.358.013Zm-.238-2.266-.054-.01c-.001.005-.09.491-.295.765-.241.321-.375.652-.359.884l.056-.004c-.016-.22.114-.536.347-.847.213-.284.301-.767.305-.788m-.12-1.308c-.35-.149-.903-.174-1.2-.188a2 2 0 0 1-.187-.012.055.055 0 0 0-.046.1c.026.013.072.015.228.023l.117.006c-.018.01-.038.022-.036.044 0 .004.05.44.45.517q.111.022.203.022a.5.5 0 0 0 .302-.086.33.33 0 0 0 .13-.216.055.055 0 0 0-.049-.06.054.054 0 0 0-.06.049c0 .003-.01.082-.09.14-.087.064-.23.079-.414.043-.32-.062-.36-.406-.362-.42-.002-.02-.022-.023-.038-.031.302.016.726.05 1.009.17.395.168.45.258.452.258a.055.055 0 1 0 .11-.016c-.006-.04-.068-.151-.52-.343Zm3.198.177a.055.055 0 0 0-.025-.074c-.012-.006-.299-.148-.577-.11-.28.036-.54.321-.552.333a.055.055 0 0 0 .041.092q.024 0 .041-.018c.003-.003.245-.267.485-.298.243-.034.51.098.513.1.026.013.06.002.074-.025m-.569.246c-.164.03-.265-.112-.27-.118a.056.056 0 0 0-.076-.014.055.055 0 0 0-.015.077.41.41 0 0 0 .316.17.42.42 0 0 0 .406-.335.055.055 0 0 0-.109-.02.31.31 0 0 1-.252.24M6.941 8.623a.055.055 0 0 0-.08-.077c-.024.025-.601.624-.77 1.074-.105.28-.026.584.044.852.044.167.085.326.064.434a.055.055 0 0 0 .109.02c.025-.132-.017-.294-.066-.482-.066-.252-.14-.538-.048-.785.161-.429.741-1.03.747-1.036m5.845 22.365a.11.11 0 0 0-.141.067.11.11 0 0 0 .066.141 7 7 0 0 1 1.206.614c.617.391.735.699.735.7a.11.11 0 0 0 .21-.07c-.005-.014-.132-.376-.827-.816a7 7 0 0 0-1.25-.636Zm3.595.03.492 1.689a.11.11 0 1 0 .213-.061l-.493-1.69zM9.996 98.553a.11.11 0 0 0 .013-.22c-.558-.068-1.338-.085-2.164-.102-1.54-.034-3.286-.071-4.275-.435-1.114-.411-1.804-.727-1.811-.73a.11.11 0 0 0-.092.2c.007.003.704.323 1.827.737 1.023.377 2.789.415 4.347.448.82.018 1.595.035 2.141.1zm-.967.377a.114.114 0 0 0-.121.099.11.11 0 0 0 .099.12c.023.003 2.05.199 3.792.199q.292 0 .567-.008c1.988-.058 3.217-.142 3.614-.397a.11.11 0 1 0-.12-.186c-.39.25-2.011.319-3.5.362-1.818.054-4.306-.187-4.331-.19Z\" style=\"fill:#65677f\"/></svg>";

},{}],"9YEkJ":[function(require,module,exports,__globalThis) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"34.47\" height=\"67.93\"><defs><linearGradient id=\"a\" x1=\"16.77\" x2=\"19.32\" y1=\"1436.44\" y2=\"1431.07\" gradientTransform=\"matrix(1 0 0 -1 .03 1444.4)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\".75\" stop-color=\"#666880\"/></linearGradient></defs><path d=\"M14.11 67.93c-.31 0-.64-.03-1-.09-1.53-.26-3.83-.79-6.04-1.83-.41-.19-.79-.36-1.15-.52-1.54-.68-2.65-1.18-3.59-2.35-.65-.81-.78-1.48-.88-2.02-.08-.43-.14-.74-.42-1-.24-.22-.43-.31-.56-.37-.38-.17-.49-.33-.46-1.06.01-.31.04-.72.08-1.2.09-1.18.21-2.78.15-4.09-.09-1.89 0-3.62.24-4.42.04-.13.09-.32.15-.53.3-1.06.85-3.03 1.28-3.74.21-.35.4-.55.57-.74.23-.25.38-.41.45-.78.04-.23.02-.47 0-.7-.05-.44-.11-.94.32-1.47.23-.28.38-.54.51-.77.21-.36.39-.66.74-.82.31-.14.58-.33.72-.44-.06-.17-.17-.52-.27-.87-.06-.04-.12-.08-.18-.13-.27-.21-.55-.75-1.01-1.9-.24-.6-.46-.92-.74-1.32q-.465-.66-.84-1.38c-.38-.72-.39-.94-.41-1.31 0-.15-.02-.32-.06-.57-.08-.51-.15-1.04-.2-1.51v-.1c-.04-.27-.08-.53-.11-.8-.1-.66.04-1.56.18-2.42.07-.4.03-.69 0-.94s-.06-.49.02-.77c.06-.21.12-.58.18-.98.1-.58.21-1.31.4-2.1.05-.21.1-.41.14-.61.24-1.09.43-1.95 1.02-2.86.5-.77 1.02-1.11 1.73-1.57.28-.18.6-.39.96-.66 1.31-.97 2.68-1.5 3.53-1.67.58-.12 1.16-.04 1.53.04-.09-.1-.17-.21-.25-.32-.41-.52-.76-1.09-1.04-1.69-.56-1.22-.86-2.62-.86-4.06 0-2.32.75-4.44 2.12-5.99C12.47.9 14.48.01 16.72.01c4.69 0 8.51 3.82 8.51 8.51 0 2.32-.77 5.03-2.47 6.32l.13-.03c.12-.05 1.27-.46 2.41-.23 1.24.25 2.89.98 3.79 2.06.82.99 1.7 2.12 1.95 3.07.25.94.48 3.28.55 3.98.04.39.14 1.03.25 1.7.16.97.32 1.95.34 2.54.05 1.12-.12 2.84-.6 4.16-.41 1.12-1.28 2.61-1.97 3.8-.16.28-.31.54-.45.77-.25.44-.46.76-.62 1-.29.44-.31.5-.26.55.08.1.4.55.9 1.27.84 1.21 1.99 2.86 2.51 3.49.56.69 1.54 2.01 1.77 3.13.14.68.15.96.16 1.32 0 .14.01.27.02.43.05.64.28 1.38.48 1.84.24.52.48 1.06.38 1.57-.09.43-.09 1.17 0 1.65.05.29-.06.57-.18.86-.13.3-.27.65-.27 1.09v.64c0 .53-.01.94.05 1.57.09.87.18 1.76.04 2.38-.08.34-.28.59-.46.83-.17.21-.35.43-.45.73-.22.67-1.14 2.26-1.67 2.88-.27.32-1.13.54-2.5.88-1.11.27-2.34.57-2.75.92-.25.21-.34.41-.43.63-.21.48-.41.94-2.09 1-.94.04-1.8-.02-2.63-.08-1.2-.09-2.34-.16-3.56.08-.55.11-1.01.22-1.41.31-.79.19-1.35.32-2.02.32Z\" style=\"fill:#fff\"/><path d=\"M14.11 67.93c-.31 0-.64-.03-1-.09-1.53-.26-3.83-.79-6.04-1.83-.41-.19-.79-.36-1.15-.52-1.54-.68-2.65-1.18-3.59-2.35-.65-.81-.78-1.48-.88-2.02-.08-.43-.14-.74-.42-1-.24-.22-.43-.31-.56-.37-.38-.17-.49-.33-.46-1.06.01-.31.04-.72.08-1.2.09-1.18.21-2.78.15-4.09-.09-1.89 0-3.62.24-4.42.04-.13.09-.32.15-.53.3-1.06.85-3.03 1.28-3.74.21-.35.4-.55.57-.74.23-.25.38-.41.45-.78.04-.23.02-.47 0-.7-.05-.44-.11-.94.32-1.47.23-.28.38-.54.51-.77.21-.36.39-.66.74-.82.31-.14.58-.33.72-.44-.06-.17-.17-.52-.27-.87-.06-.04-.12-.08-.18-.13-.27-.21-.55-.75-1.01-1.9-.24-.6-.46-.92-.74-1.32q-.465-.66-.84-1.38c-.38-.72-.39-.94-.41-1.31 0-.15-.02-.32-.06-.57-.08-.51-.15-1.04-.2-1.51v-.1c-.04-.27-.08-.53-.11-.8-.1-.66.04-1.56.18-2.42.07-.4.03-.69 0-.94s-.06-.49.02-.77c.06-.21.12-.58.18-.98.1-.58.21-1.31.4-2.1.05-.21.1-.41.14-.61.24-1.09.43-1.95 1.02-2.86.5-.77 1.02-1.11 1.73-1.57.28-.18.6-.39.96-.66 1.31-.97 2.68-1.5 3.53-1.67.58-.12 1.16-.04 1.53.04-.09-.1-.17-.21-.25-.32-.41-.52-.76-1.09-1.04-1.69-.56-1.22-.86-2.62-.86-4.06 0-2.32.75-4.44 2.12-5.99C12.47.9 14.48.01 16.72.01c4.69 0 8.51 3.82 8.51 8.51 0 2.32-.77 5.03-2.47 6.32l.13-.03c.12-.05 1.27-.46 2.41-.23 1.24.25 2.89.98 3.79 2.06.82.99 1.7 2.12 1.95 3.07.25.94.48 3.28.55 3.98.04.39.14 1.03.25 1.7.16.97.32 1.95.34 2.54.05 1.12-.12 2.84-.6 4.16-.41 1.12-1.28 2.61-1.97 3.8-.16.28-.31.54-.45.77-.25.44-.46.76-.62 1-.29.44-.31.5-.26.55.08.1.4.55.9 1.27.84 1.21 1.99 2.86 2.51 3.49.56.69 1.54 2.01 1.77 3.13.14.68.15.96.16 1.32 0 .14.01.27.02.43.05.64.28 1.38.48 1.84.24.52.48 1.06.38 1.57-.09.43-.09 1.17 0 1.65.05.29-.06.57-.18.86-.13.3-.27.65-.27 1.09v.64c0 .53-.01.94.05 1.57.09.87.18 1.76.04 2.38-.08.34-.28.59-.46.83-.17.21-.35.43-.45.73-.22.67-1.14 2.26-1.67 2.88-.27.32-1.13.54-2.5.88-1.11.27-2.34.57-2.75.92-.25.21-.34.41-.43.63-.21.48-.41.94-2.09 1-.94.04-1.8-.02-2.63-.08-1.2-.09-2.34-.16-3.56.08-.55.11-1.01.22-1.41.31-.79.19-1.35.32-2.02.32Zm-3.96-53.08c-.19 0-.37.02-.55.05-.8.16-2.11.66-3.37 1.6-.37.27-.7.49-.97.67-.67.44-1.15.76-1.61 1.46-.55.85-.73 1.67-.97 2.71-.05.2-.09.41-.14.63-.18.76-.29 1.47-.39 2.05h-.13l.12.03c-.07.44-.13.78-.19 1.01-.05.2-.03.38 0 .61.03.28.07.6 0 1.05-.13.8-.27 1.7-.18 2.3.04.25.07.55.11.87.06.48.12 1.02.21 1.54.04.27.05.46.06.61.02.33.03.5.37 1.15.33.63.59 1.01.82 1.34.28.41.52.76.78 1.4.41 1.04.69 1.57.89 1.73.06.05.13.1.2.14l.04.03.04.06c.12.46.27.9.33 1.07l.05.14-.1.09c-.28.23-.59.43-.92.58-.24.11-.37.33-.56.66-.14.24-.3.52-.55.83-.32.4-.28.76-.24 1.18.03.26.06.53 0 .82-.09.49-.3.71-.54.97-.2.21-.38.44-.53.68-.4.66-.94 2.6-1.23 3.64l-.03.12-.12.42c-.22.75-.31 2.47-.22 4.29.07 1.34-.06 2.95-.15 4.13-.04.49-.07.9-.08 1.2-.02.56.01.58.22.68.16.07.38.18.67.44.38.35.46.77.54 1.22.1.52.21 1.11.8 1.84.89 1.1 1.96 1.58 3.44 2.23l.04.02c.36.16.72.32 1.12.51 2.18 1.02 4.43 1.54 5.94 1.8 1.11.19 1.76.04 2.83-.22.39-.09.87-.21 1.45-.32 1.27-.25 2.43-.17 3.66-.08l.02.13v-.12c.82.06 1.66.11 2.57.08 1.43-.06 1.56-.35 1.74-.76.1-.23.22-.51.54-.78.48-.4 1.71-.7 2.91-1 .93-.23 2.09-.51 2.29-.75.51-.6 1.39-2.11 1.6-2.75.12-.37.32-.62.51-.86.18-.22.33-.42.39-.67.13-.56.04-1.41-.05-2.24-.07-.65-.06-1.07-.05-1.6v-.65c0-.52.17-.92.3-1.24.11-.26.19-.46.16-.64-.09-.52-.09-1.33 0-1.8.08-.39-.14-.87-.35-1.33-.22-.49-.47-1.29-.52-1.98-.01-.17-.02-.3-.02-.43-.01-.35-.03-.62-.16-1.27-.15-.77-.75-1.81-1.68-2.95-.53-.65-1.68-2.31-2.52-3.52-.39-.57-.8-1.15-.88-1.25-.24-.29-.07-.55.24-1.02.16-.24.36-.55.61-.98.11-.19.23-.4.36-.62l.09-.15c.69-1.18 1.54-2.65 1.95-3.74.47-1.27.63-2.93.58-4.01-.03-.56-.18-1.53-.33-2.47-.11-.7-.22-1.34-.26-1.75-.05-.49-.29-2.98-.54-3.92-.23-.87-1.07-1.97-1.87-2.92-.84-1.01-2.39-1.7-3.56-1.93-1.05-.21-2.16.2-2.21.22-.28.08-1.14.31-1.42.21l-.14-.05-.21.03.13-.06-.31-.11.53-.18c2.23-.76 3.24-3.9 3.24-6.5 0-4.47-3.64-8.11-8.11-8.11-2.15 0-4 .81-5.36 2.35-1.3 1.47-2.02 3.51-2.02 5.73 0 1.38.28 2.73.82 3.89l.11.25c.26.57.47 1.04.75 1.45.2.25.41.49.64.71l.17.17.12.09.85.63-.39-.17.05.05-.15-.09-.98-.42s-.55-.17-1.14-.17ZM5.38 36.51s-.51-.35-1.02-1.1-.31-1.88-.16-2.94c.16-1.06.35-2.24.39-2.75s-.43-2-.12-2.59.35-1.53.24-2.39.16-1.41.35-1.77.43-.9.67-1.22.63-1.18 1.18-1.92c.28-.38 1.03-1.43 1.8-2.25.76-.8 1.65-1.38 1.65-1.38s-1.72.56-2.6 1.8-1.96 3.25-2.62 3.91-.44 1.38-.72 2.07.06 1.54-.03 2.04-.36.94-.33 1.54.36 1.35.17 2.62-.55 3.47-.5 4 .22 1.21.58 1.57m23.18 2.22s-.66-.17-1.31-.22c-.66-.05-1.26-.16-2.19-.22s-1.09.05-1.64.22c-.55.16-.88.16-1.7.16s-1.48-.06-2.08-.06-1.04.05-1.81 0-1.37-.11-2.08-.11-1.53.11-2.08.11-1.29.04-1.95.15-1.55.28-1.83.39-1.74.21-1.74.21-.18.12.82.1c1-.03 1.08-.21 1.65-.28s1.04-.33 1.79-.33 1.17-.08 2.03-.07.8-.13 1.48-.11.95.01 1.67.08 1.37.07 2.15.05 1.53.01 2.12.05.76.08 1.24-.03c.47-.1.66-.36 1.08-.38s.66-.09 1.42.03 1.34.16 1.82.21.75.07.96.08.17-.06.17-.06Zm-.15 21.06c.18-.36 0-1.05-.18-1.71s0-.65.4-1.13.62-1.02 1.09-1.6.51-.73.84-1.2.76-.8 1.02-.98.43-1.09.43-1.09-1.03 1.19-1.44 1.65-.77.88-1.03 1.29-.72 1.29-1.13 1.65-.77.72-.52 1.24.57 1.75.15 2.11c0 0 .2.13.38-.23ZM5.16 55.3s.22 1.01.87 1.26 1.41.14 1.7.29c0 0-.74-.2-1.2-.3s-.64-.15-.79-.39-.58-.86-.58-.86m1.05 8.59c.47.14.87.54 1.05.72s.51.22.69.04.29-.79.54-.58.97.5 1.05.18-.29-.97.14-.9c0 0-.33-.17-.33.08s.24.68.05.79-.59-.29-.88-.31-.42.05-.51.28 0 .43-.29.41-.29-.04-.54-.23-.41-.47-.65-.48-.31.01-.31.01Zm8.04-57.3c-.15 0-.29-.15-.36-.29s.15-.36.29-.59.29-.12.59-.12.33.23.44.46.02.21-.19.25-.08.19-.25.23-.36.06-.52.06m5.9-.32c.09.06.04.13.25.25s.27 0 .47-.05c.21-.06.24-.14.3-.31s-.08-.3-.24-.44-.26-.12-.45-.13-.46.2-.46.37.05.25.13.31m-5.01 6.01c.96.21 1.44-.02 2.42-.05.98-.02 1.18.06 1.79.13s.77-.01 1.23-.18c.45-.17.71-.7.71-.7s-.18.2-.49.32-.32.08-1.37.04c-1.05-.05-1.86.01-2.74.02s-1.55.08-1.99-.04-.98-.77-1-.83c0 0 .48 1.07 1.44 1.29m-2.79 22.03c.92.49 1.1.4 1.77.43s1.07.34 2.41.43 1.68.09 2.96-.06 2.26-.12 2.6-.34.67-.76.89-1.13.61-.34 1.01-.73.92-1.5.92-1.5-.92 1.5-1.59 1.71-.86.89-1.28 1.22-1.22.31-2.11.43-1.68 0-2.11.09-2.02-.03-2.75-.21-.95-.21-1.77-.31c-.82-.09-3.57-2.41-3.57-2.41s1.71 1.89 2.63 2.38Zm3.62-18.68c.68 0 1.05.02 2.1.05s3.15.23 3.15.23-1.58-.33-1.95-.38-2-.12-3.15-.15-2.58.37-2.58.37 1.75-.13 2.43-.13Zm-4.45 49.22c.07.1 1.2.6 1.63.63s.9-.03 1.2-.03 1.23-.5.93 0-.17.86.07.93.6-.1 1.33-.2 1.01-.06 1.56 0c.78.09 1 .43 1.4.1.45-.38.1-.83.63-1.23s.57-1.13 1.5-1.03c0 0-.47-.11-.65 0s-.49.49-.68.71-.35.26-.43.38-.17.37-.23.63-.14.52-.4.55-.78-.25-1.73-.27-1.56.15-1.89.21-.56.05-.55-.16.25-.57.23-.78-.37-.19-.76-.08-1.11.21-1.44.18-1.01-.27-1.28-.35-.43-.17-.43-.17Zm20.12-10.39s-.19.54-.53.98-.65.6-1.21.47-.77-.37-1.12-.4-.56 0-.56 0 .42.12.86.26.77.37 1.12.37.81-.3 1.05-.49.4-1.19.4-1.19ZM6.22 29.86c-.22-.3-.37-.85-.41-1.44s.15-.7.15-.7-.28.09-.36.61c-.04.23-.05.84.35 1.64.34.67.22.64.11 1.26s-.37.93-.88.37c-.19-.21-.48-.63-.48-.63s-.04.63.85 1.4c.35.3.55.84.82 1.13.43.44.84.57.84.57s-.49-.4-.76-.83c-.17-.27-.13-.56-.2-.75-.18-.52.26-1.66.44-2.14s.04-1.4.04-1.4-.3 1.22-.52.92Zm22.98 2.76c.02-.94.2-1.33.07-1.71s.11-.88.36-1.3.2-1.24.29-2.07-.09-1.37-.13-2.07-.43-2.02-.63-2.67-.54-1.82-.85-2.31-1.39-1.89-1.77-2.22-.72-.65-1.01-.88-.36-.49-.9-.74-1.47-.69-1.47-.69 1.55.96 1.97 1.33.64.78 1.1 1.1 1.51 1.6 1.92 2.38.64 1.65.87 2.24.59 2.24.69 3.06c.09.82.14 2.38-.23 3.15s-.59 1.23-.46 1.87-.05 1.74-.18 2.51c-.1.56-.22 1.12-.34 1.68l-.07.33s.77-2.04.79-2.99Z\" style=\"fill:#666880\"/><path d=\"M17.8 7.46s.9.38.86 1.17-.26 1.34-.61 1.51-.56.43-1.04.28-.81-.33-1.1-.82-.16-1.1-.04-1.36\" style=\"fill:url(#a)\"/><path d=\"M10.43 38.2c.7-.15 1.58-.15 2.14-.19 1.27-.09 1.29-.05 2.3-.06s1.91-.08 3.14.02 4.15-.07 5.12-.24 3.06.04 3.06.04-1.23.17-2.26.57-1.7 1.67-3.01 1.7c-1.3.03-2.94-.7-4.25-.5s-3.91.13-5.15-.5c-1.24-.64-2.61-.37-2.61-.37s.62-.27 1.52-.47m15.78-19.82s-.8-.89-1.01-1.08-.57-.57-.84-.6 1.52 1.89 1.89 2.41.98 1.59 1.19 2.17.21 1.22.86 2.14c.64.92 1.1 2.23 1.13 3.3s.21 1.93.21 1.93.37-2.08 0-3.61-.79-2.14-.92-2.87.11-1.02-.42-1.67-1.38-1.6-1.57-1.81-.52-.3-.52-.3\" style=\"fill:#e3e4f0\"/></svg>";

},{}],"7anvG":[function(require,module,exports,__globalThis) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"98.733\" height=\"191.864\"><path d=\"m63.827 24.53-9.868 5.414-8.879-2.824.887 30.089.154 5.207 1.617 54.837.066 2.226.197 6.677.041 1.418 1.612 54.651h10.979l1.618-55.123.003-.111.24-8.181.006-.19 1.707-58.177.013-.437.964-32.869z\" style=\"fill:#fff\"/><path d=\"m45.967 57.209.154 5.207-24.413 4.54-4.902-4.942zM85.261 46.59l7.488-9.81-1.374-6.107-9.656 12.263z\" style=\"fill:#2c2c2c\"/><path d=\"m48 126.156.042 1.418-7.249.24-3.325-1.345zm-23.175-7.829 4.695 1.984 18.284-.832-.066-2.226zM36.943 185.355h30.11v6.509h-30.11z\"/><path d=\"M72.866 182.019h-5.813v9.845l5.051-2.162v-5.01l.762-.1z\" style=\"fill:#2c2c2c\"/><path d=\"M8.94 82.156v4.483H0v5.403h8.873v4.482l8.508-6.546h3.633v-1.266h-3.616zm.183 13.86v-4.224H.25v-4.903h8.94v-4.223l8.61 6.674zm51.641 86.003L65.31 27.141l.001-.032-1.432-2.75-9.933 5.45L45.118 27l-.169-.054 4.574 155.072H36.132v3.336h30.921v-3.336h-6.289Zm3.174-157.004 1.12 2.151-4.543 154.853h-.888zM45.21 27.292l8.71 2.77.052.017 9.724-5.335-4.319 157.275h-9.603z\" style=\"fill:#4c4c4c\"/><path d=\"m25.607 100.28 57.453-4.296v18.701l-57.453 2.82zM9.123 96.015v-4.224H.25v-4.903h8.94v-4.223l8.61 6.674z\" style=\"fill:#fff\"/><path d=\"m83.06 97.229-57.453 3.968v-.1L83.06 97.13zm0 1.35v-.1l-57.453 3.934v.1zm0 1.35v-.1l-57.453 3.899v.1L83.06 99.93Zm0 1.35v-.1l-57.453 3.864v.1zm0 1.351v-.1l-57.453 3.828v.1zm0 1.35v-.1l-57.453 3.793v.1zm0 1.351v-.1l-57.453 3.758v.1zm0 1.351v-.1l-57.453 3.722v.1zm0 1.35v-.1l-57.453 3.688v.1zm-57.453 4.902v.1l57.453-3.651v-.1zm0 1.316v.1l57.453-3.617v-.1zm57.453-2.266-57.453 3.581v.1l57.453-3.582v-.1Zm0 1.45v-.1l-57.453 3.547v.1l57.453-3.548Z\" style=\"fill:#757575\"/><path d=\"m62.374 127.101-1.452-1.329-23.454.697v-5.294l33.12-1.544 1.91 1.32.13 5.807zm.249-8.296-1.453-2.182-36.345 1.704V99.553l.362-.027 58.584-4.38 2.212 1.419.451 21.161-23.811 1.078Zm-37.016-1.3 57.453-2.82V95.984l-57.453 4.295zm8.084-4.027q.072.124.073.294a.6.6 0 0 1-.072.302.54.54 0 0 1-.204.21.7.7 0 0 1-.304.088l-.393.024.001.718-.348.02-.004-1.851.349-.021.393-.023a.6.6 0 0 1 .304.052.46.46 0 0 1 .205.187m-.288.315a.26.26 0 0 0-.027-.12.2.2 0 0 0-.074-.077.2.2 0 0 0-.111-.022l-.402.024.001.461.402-.024a.2.2 0 0 0 .11-.035.2.2 0 0 0 .074-.085.3.3 0 0 0 .027-.122m3.341-.768-1.355.081v.336l.504-.03.003 1.516.348-.02-.003-1.517.504-.03v-.336Zm6.907-.414-.368.022-.346.616-.353-.574-.368.022.539.876-.55.977.367-.022.368-.654.374.61.368-.023-.56-.91zm-5.778.346.002 1.191q0 .159-.085.252a.34.34 0 0 1-.242.103q-.156.01-.24-.074-.086-.082-.086-.242l-.002-1.19-.349.02.002 1.182a.8.8 0 0 0 .08.368.5.5 0 0 0 .23.222.75.75 0 0 0 .366.06.8.8 0 0 0 .365-.104.6.6 0 0 0 .231-.25.84.84 0 0 0 .079-.377l-.002-1.182zm2.69 1.355-.002-1.516-.348.02.003 1.853.155-.01 1.084-.064-.001-.336-.89.053Zm-1.286-1.439.71 1.81-.375.022-.104-.29-.677.04-.104.303-.375.023.704-1.895zm.113 1.212-.223-.618-.22.645zm3.608-4.88-.001-.605-1.283.077-.001-.8 1.53-.092-.002-.605-1.53.092-.193.012-.197.011-.224.014.006 3.333.615-.037-.003-1.322 1.283-.077Zm-10 1.923.637-.038-.006-3.334-.638.039zm27.073-7.681q.183.355.535.525.35.17.847.14.495-.03.848-.242.352-.212.536-.59.183-.376.182-.891l-.005-2.796-.808.049.005 2.816q0 .377-.198.597-.2.22-.562.241-.36.022-.558-.174-.198-.197-.198-.573l-.006-2.817-.808.049.005 2.796q0 .514.185.87m5.348 4.628-.698-2.182-.633.037 1.093 3.269.48-.029 1.08-3.399-.633.038zm-17.54-3.194 2.581-.155-.001-.795-2.065.124-.002-.982 1.74-.105-.001-.795-1.74.104-.003-1.012 2.066-.124-.002-.795-2.581.155-.292.017.008 4.38zm-6.848-3.175.006 3.585.809-.048-.007-3.585 1.169-.07-.002-.796-3.145.189.002.795zm3.263 3.39-.003-1.774 1.54-.093.003 1.774.809-.048-.008-4.38-.809.048.003 1.811-1.54.092-.003-1.81-.808.048.008 4.38zm26.096.577a1.16 1.16 0 0 0-.416.462 1.45 1.45 0 0 0-.145.662l.001.984q0 .35.15.607c.15.257.242.3.424.387q.273.13.63.107.354-.021.624-.191a1.15 1.15 0 0 0 .415-.464q.147-.291.146-.663l-.001-.651-1.132.068.001.605.495-.03v.055a.7.7 0 0 1-.067.319.5.5 0 0 1-.192.214.6.6 0 0 1-.29.087.6.6 0 0 1-.297-.046.43.43 0 0 1-.198-.172.5.5 0 0 1-.07-.27l-.002-.984q0-.177.068-.316a.54.54 0 0 1 .193-.22.6.6 0 0 1 .288-.09.6.6 0 0 1 .217.026q.104.034.182.106a.4.4 0 0 1 .112.176l.664-.04a1.2 1.2 0 0 0-.224-.507 1.04 1.04 0 0 0-.413-.323 1.16 1.16 0 0 0-.539-.09 1.3 1.3 0 0 0-.624.192m-5.769-1.799-.006-3.157 1.525 3.066.995-.06-.008-4.376-.773.046.006 3.207-1.532-3.116-.988.06.008 4.377zm2.753 5.193 1.965-.117-.001-.606-1.572.095-.001-.748 1.324-.08-.001-.605-1.325.08v-.77l1.57-.095v-.605l-1.572.094-.615.037.006 3.334zm-37.836 5.906v-.416l.75-.044-.001-.337-.75.045-.001-.428.89-.053-.001-.336-1.112.066-.126.008.003 1.852.349-.02v-.001l.89-.053-.001-.337zm-.697-1.204q.073.124.073.293a.6.6 0 0 1-.072.302.54.54 0 0 1-.203.21.7.7 0 0 1-.305.089l-.393.023.002.719-.349.02-.003-1.852.348-.02.393-.024a.6.6 0 0 1 .305.053.46.46 0 0 1 .204.187m-.288.315a.26.26 0 0 0-.026-.12.18.18 0 0 0-.074-.077.2.2 0 0 0-.111-.022l-.402.024v.461l.403-.024a.22.22 0 0 0 .184-.12.3.3 0 0 0 .026-.122m9.176-6.573-.616.037.007 3.333.222-.013 1.965-.118-.001-.605-1.572.094-.002-.747 1.325-.08-.001-.605-1.325.08-.001-.771 1.572-.094-.002-.606zm-5.137 3.036-1.571.094-.005-2.728-.616.037.006 3.334.616-.037 1.571-.095v-.605Zm11.742-.098-.616.036-.006-3.335.616-.037.815-.049q.27-.017.474.095a.76.76 0 0 1 .317.331q.113.219.113.517c0 .298-.037.376-.111.53a.9.9 0 0 1-.531.472l.783 1.328-.745.045-.739-1.297-.373.023zm-.004-1.947.766-.046a.3.3 0 0 0 .165-.058.34.34 0 0 0 .112-.144.56.56 0 0 0 .001-.413.3.3 0 0 0-.111-.13.3.3 0 0 0-.169-.039l-.765.046zm-8.95-2.874-.007-3.159 1.526 3.067.994-.06-.008-4.377-.773.047.006 3.207-1.532-3.116-.988.06.008 4.377zm.249 5.343 1.08-3.4-.633.039-.69 2.265-.697-2.182-.633.038 1.092 3.268zm-1.908-5.241-.008-4.38-.838.05.008 4.38zm.666 8.952v-.415l.75-.045-.001-.336-.75.045-.001-.428.89-.054v-.336l-1.113.067-.126.007.003 1.852.349-.02.89-.054-.001-.336zm36.548-11.917q.192-.384.191-.871l-.002-.856-1.486.09.001.795.65-.04v.073q0 .238-.088.418c-.088.18-.143.214-.252.282a.8.8 0 0 1-.382.114.8.8 0 0 1-.39-.06.56.56 0 0 1-.26-.226.67.67 0 0 1-.092-.356l-.002-1.292q0-.232.09-.415a.7.7 0 0 1 .253-.29.76.76 0 0 1 .378-.119.8.8 0 0 1 .285.036q.137.044.24.14.1.094.146.23l.873-.052a1.6 1.6 0 0 0-.294-.667 1.37 1.37 0 0 0-.543-.424 1.5 1.5 0 0 0-.708-.118 1.7 1.7 0 0 0-.82.252q-.354.225-.546.607a1.9 1.9 0 0 0-.192.87l.002 1.292q0 .46.198.8.197.336.556.506t.828.142q.466-.029.82-.252.352-.225.546-.609m-.39 8.1.71 1.81-.375.022-.105-.29-.677.04-.103.303-.375.023.703-1.895zm.112 1.212-.222-.618-.22.645zm1.595.075a.29.29 0 0 1-.24.147.3.3 0 0 1-.166-.03.24.24 0 0 1-.106-.11.4.4 0 0 1-.036-.183l-.001-.508q0-.108.036-.187a.3.3 0 0 1 .105-.124.34.34 0 0 1 .166-.05.26.26 0 0 1 .239.12.4.4 0 0 1 .063.152l.361-.021a.9.9 0 0 0-.125-.339.56.56 0 0 0-.539-.261.8.8 0 0 0-.36.103.6.6 0 0 0-.229.25.84.84 0 0 0-.078.379v.508q.001.22.08.37.08.15.23.221t.36.06a.66.66 0 0 0 .537-.327 1 1 0 0 0 .125-.353l-.361.022a.5.5 0 0 1-.06.161Zm-5.987-.179a1.5 1.5 0 0 0-.308-.068l-.015-.002-.01-.002h-.01a2 2 0 0 1-.19-.036.25.25 0 0 1-.113-.06.17.17 0 0 1-.046-.125v-.001q0-.096.088-.154a.5.5 0 0 1 .247-.067.7.7 0 0 1 .223.027.9.9 0 0 1 .224.101l.147-.304a1.1 1.1 0 0 0-.392-.147 1 1 0 0 0-.202-.011.9.9 0 0 0-.369.09.55.55 0 0 0-.232.207.6.6 0 0 0-.08.312v.001q.001.202.086.308t.208.141q.121.037.307.055l.028.002.007.001h.007q.105.012.173.027.068.016.11.058a.15.15 0 0 1 .042.114v.002q0 .105-.094.17a.53.53 0 0 1-.264.073.9.9 0 0 1-.288-.03.7.7 0 0 1-.247-.122l-.16.298a.9.9 0 0 0 .199.112q.11.045.238.064.126.02.258.011.224-.012.381-.088a.56.56 0 0 0 .24-.207.56.56 0 0 0 .083-.309v-.002a.48.48 0 0 0-.08-.293.42.42 0 0 0-.196-.146m2.845.05.453.753-.422.025-.419-.72-.21.013v.745l-.348.021-.003-1.853.138-.009.672-.04a.5.5 0 0 1 .268.053.43.43 0 0 1 .18.183.6.6 0 0 1 .064.288.66.66 0 0 1-.063.294.5.5 0 0 1-.18.205c-.038.025-.087.028-.13.042m-.01-.404a.3.3 0 0 0 .002-.23.16.16 0 0 0-.063-.072.16.16 0 0 0-.096-.02l-.433.025v.436l.434-.026a.18.18 0 0 0 .157-.113Zm4.99-.967-1.355.082v.336l.505-.03.002 1.516.349-.021-.003-1.516.503-.03v-.337Zm-6.133.368-1.355.081v.336l.504-.03.003 1.516.348-.02-.003-1.516.504-.03v-.337Zm11.545.16a1.5 1.5 0 0 0-.308-.069l-.015-.002-.01-.001-.01-.001a2 2 0 0 1-.19-.035.26.26 0 0 1-.113-.061.17.17 0 0 1-.046-.124v-.002q0-.095.087-.153a.5.5 0 0 1 .248-.068.7.7 0 0 1 .223.028.9.9 0 0 1 .224.1l.147-.304a1.05 1.05 0 0 0-.594-.158.9.9 0 0 0-.369.09.55.55 0 0 0-.232.207.6.6 0 0 0-.08.312v.002q.001.202.086.307.085.106.208.142.12.036.307.055l.028.002h.007l.007.001q.105.01.173.027a.23.23 0 0 1 .11.057.15.15 0 0 1 .042.115v.001q0 .105-.094.17a.5.5 0 0 1-.264.073.9.9 0 0 1-.288-.03.7.7 0 0 1-.247-.121l-.16.297a.8.8 0 0 0 .198.112 1.1 1.1 0 0 0 .497.075 1 1 0 0 0 .38-.088.56.56 0 0 0 .241-.207.56.56 0 0 0 .083-.308v-.002a.48.48 0 0 0-.08-.293.43.43 0 0 0-.196-.147Zm-1.752-.747.002 1.356-.66-1.317-.425.026.003 1.85.333-.02-.002-1.335.657 1.297.429-.026-.004-1.85zm-12.839 1.898q.045.09.045.213v.004a.55.55 0 0 1-.066.276.47.47 0 0 1-.194.185.8.8 0 0 1-.307.077l-.623.038-.152.009-.004-1.852.349-.021.405-.025a.7.7 0 0 1 .307.041q.127.052.193.16a.5.5 0 0 1 .067.267.4.4 0 0 1-.043.195.4.4 0 0 1-.123.144.5.5 0 0 1-.196.084.5.5 0 0 1 .21.062.35.35 0 0 1 .132.143m-.951-.337.394-.024a.25.25 0 0 0 .167-.065.2.2 0 0 0 .059-.158q0-.09-.06-.135a.25.25 0 0 0-.167-.04l-.394.024zm.645.519a.2.2 0 0 0-.029-.118.17.17 0 0 0-.086-.071.3.3 0 0 0-.135-.018l-.394.024v.446l.395-.024a.3.3 0 0 0 .184-.07.22.22 0 0 0 .065-.165zm13.054-4.493q.145-.236.145-.554v-.005q-.002-.34-.14-.527a.75.75 0 0 0-.348-.264 2.6 2.6 0 0 0-.544-.123l-.043-.007q-.009 0-.018-.002a3 3 0 0 1-.335-.062.44.44 0 0 1-.2-.111.3.3 0 0 1-.081-.223v-.003q-.001-.171.154-.276.154-.105.438-.121.188-.012.394.05.205.06.394.182l.26-.548a1.9 1.9 0 0 0-.691-.265 1.6 1.6 0 0 0-.358-.02 1.65 1.65 0 0 0-.651.16q-.27.135-.41.374c-.14.239-.142.345-.141.56v.003q0 .365.151.554a.74.74 0 0 0 .367.255q.216.066.544.1l.049.003.012.002.012.001q.188.02.306.049.12.03.193.103.075.074.075.206v.003a.35.35 0 0 1-.166.304q-.165.114-.466.133a1.5 1.5 0 0 1-.508-.056 1.3 1.3 0 0 1-.436-.218l-.284.535q.154.121.352.202.195.082.42.116.223.035.457.021a1.8 1.8 0 0 0 .672-.16 1 1 0 0 0 .425-.371m-3.39 2.622.003 1.852.361-.022-.003-1.852zm1.042-2.05-.662.04-.185-.524-1.196.072-.182.545-.662.04 1.242-3.409.39-.023zm-1.056-1.077-.392-1.113-.388 1.16zm2.07 3.667v.525a.8.8 0 0 1-.083.364.64.64 0 0 1-.236.253.75.75 0 0 1-.354.106.7.7 0 0 1-.355-.063.54.54 0 0 1-.237-.226.7.7 0 0 1-.085-.353v-.525q0-.204.083-.363a.64.64 0 0 1 .236-.254.75.75 0 0 1 .354-.106.7.7 0 0 1 .355.063.54.54 0 0 1 .237.226.7.7 0 0 1 .084.353Zm-.36.556-.001-.543a.35.35 0 0 0-.04-.168.26.26 0 0 0-.11-.108.3.3 0 0 0-.165-.03.35.35 0 0 0-.165.05.3.3 0 0 0-.11.12.4.4 0 0 0-.039.174l.001.542q0 .097.04.169a.26.26 0 0 0 .11.107.3.3 0 0 0 .165.03.35.35 0 0 0 .165-.05.3.3 0 0 0 .11-.12.4.4 0 0 0 .039-.173m-29.303.692.71 1.81-.375.023-.105-.291-.677.04-.103.304-.375.022.703-1.894zm.112 1.213-.222-.619-.22.645zm4.824-6.964-.618 2.284-.626-2.21-.81.05.005 3.333.56-.033-.005-2.324.605 1.916.544-.033.598-2.032.004 2.368.56-.034-.007-3.333zm-2.659 1.354.002.945q0 .367-.147.654a1.14 1.14 0 0 1-.418.456q-.27.17-.625.19a1.2 1.2 0 0 1-.626-.115.96.96 0 0 1-.42-.406 1.3 1.3 0 0 1-.149-.636l-.001-.945q0-.367.147-.654t.418-.456.625-.19a1.2 1.2 0 0 1 .625.115q.27.136.42.406a1.3 1.3 0 0 1 .149.636m-.636 1-.002-.978a.64.64 0 0 0-.069-.303.45.45 0 0 0-.194-.193.56.56 0 0 0-.292-.055.6.6 0 0 0-.292.09.54.54 0 0 0-.194.217.7.7 0 0 0-.068.311l.002.977q0 .174.07.303a.45.45 0 0 0 .194.193.56.56 0 0 0 .292.055.6.6 0 0 0 .292-.09.54.54 0 0 0 .193-.216.7.7 0 0 0 .068-.312Zm7.39-4.62v-.796l-2.066.124-.006-3.585-.809.049.008 4.38.36-.022 2.514-.15Zm.965 3.995q.08.162.081.382v.007a1 1 0 0 1-.117.498.83.83 0 0 1-.343.331q-.224.12-.542.14l-1.1.065-.27.016-.006-3.333.616-.037.716-.043q.316-.02.541.074a.7.7 0 0 1 .342.29q.117.195.118.48 0 .195-.075.349a.7.7 0 0 1-.218.26.9.9 0 0 1-.346.15.8.8 0 0 1 .37.113q.153.094.233.258m-1.679-.61.696-.042a.44.44 0 0 0 .295-.117.38.38 0 0 0 .104-.283q0-.161-.105-.244t-.295-.072l-.696.042zm1.14.935a.4.4 0 0 0-.052-.212.3.3 0 0 0-.152-.128.55.55 0 0 0-.239-.032l-.696.042.002.802.695-.042a.5.5 0 0 0 .327-.124.4.4 0 0 0 .115-.299zm-11.048 3.793-.35 1.27-.354-1.228-.46.028.004 1.852.316-.02-.002-1.29.343 1.064.307-.019.34-1.128.002 1.314.316-.019-.003-1.852zm18.797-4.225v-.005q-.001-.34-.14-.527a.75.75 0 0 0-.348-.263 2.6 2.6 0 0 0-.57-.128l-.017-.002a.45.45 0 0 1-.553-.175.3.3 0 0 1-.081-.224v-.002a.32.32 0 0 1 .154-.277q.154-.105.438-.121.188-.01.394.05c.206.06.268.101.394.183l.26-.548a1.8 1.8 0 0 0-.691-.266 1.6 1.6 0 0 0-.358-.02 1.6 1.6 0 0 0-.651.16.97.97 0 0 0-.41.374 1.07 1.07 0 0 0-.141.561v.002q0 .365.152.554a.73.73 0 0 0 .366.256q.216.066.544.099l.049.004.012.002.013.001q.186.019.305.048.12.03.193.103.075.074.075.207v.002a.35.35 0 0 1-.166.305q-.166.114-.466.132a1.5 1.5 0 0 1-.508-.056 1.3 1.3 0 0 1-.436-.218l-.284.536q.154.12.352.202.195.081.42.116.223.035.457.02a1.8 1.8 0 0 0 .672-.159 1 1 0 0 0 .425-.372 1.03 1.03 0 0 0 .145-.554m-15.36 4.87a1.5 1.5 0 0 0-.309-.068l-.014-.002-.01-.002h-.01a2 2 0 0 1-.19-.035.26.26 0 0 1-.114-.061.17.17 0 0 1-.045-.125v-.001q0-.096.087-.154a.5.5 0 0 1 .248-.067.7.7 0 0 1 .223.027.9.9 0 0 1 .223.101l.147-.304a1.04 1.04 0 0 0-.594-.158.9.9 0 0 0-.368.09.55.55 0 0 0-.233.207.6.6 0 0 0-.08.312v.001a.48.48 0 0 0 .087.308q.085.105.207.141.122.037.308.055l.028.002q.004.002.007.001l.007.001q.105.01.173.027.067.016.11.057a.15.15 0 0 1 .041.114v.002q0 .105-.093.17a.53.53 0 0 1-.265.073.9.9 0 0 1-.287-.03.7.7 0 0 1-.247-.122l-.161.298a.8.8 0 0 0 .199.112 1.1 1.1 0 0 0 .497.075q.222-.012.38-.088a.56.56 0 0 0 .241-.207.56.56 0 0 0 .082-.308v-.003a.48.48 0 0 0-.08-.292.42.42 0 0 0-.196-.147Zm11.774-7.012.006 3.333.638-.038-.006-3.334zm.576 5.95v.525a.8.8 0 0 1-.083.364.64.64 0 0 1-.236.253.75.75 0 0 1-.354.106.7.7 0 0 1-.355-.063.54.54 0 0 1-.237-.226.7.7 0 0 1-.085-.353v-.525a.8.8 0 0 1 .082-.363.64.64 0 0 1 .237-.254.75.75 0 0 1 .354-.106.7.7 0 0 1 .354.064q.154.075.238.225a.7.7 0 0 1 .085.354Zm-.36.556-.002-.543a.35.35 0 0 0-.039-.168.26.26 0 0 0-.11-.108.3.3 0 0 0-.165-.03.35.35 0 0 0-.165.05.3.3 0 0 0-.11.12.4.4 0 0 0-.039.174l.001.542q0 .097.04.169a.25.25 0 0 0 .11.107.3.3 0 0 0 .165.03.34.34 0 0 0 .165-.05.3.3 0 0 0 .11-.12.4.4 0 0 0 .038-.173Zm-2.854-8.324a1.6 1.6 0 0 1-.822-.151 1.26 1.26 0 0 1-.551-.534 1.7 1.7 0 0 1-.197-.836l-.002-1.24q0-.483.194-.86a1.5 1.5 0 0 1 .549-.6q.354-.221.82-.25c.466-.029.586.032.823.151q.355.18.551.534.195.354.196.836l.003 1.241q0 .483-.194.86c-.194.377-.312.452-.549.6q-.354.22-.821.249m-.002-.826a.8.8 0 0 0 .384-.118.7.7 0 0 0 .255-.284.9.9 0 0 0 .089-.41l-.003-1.283a.84.84 0 0 0-.09-.398.6.6 0 0 0-.256-.254.73.73 0 0 0-.384-.072.8.8 0 0 0-.383.118.7.7 0 0 0-.255.285.9.9 0 0 0-.09.409l.003 1.283q0 .23.091.398a.6.6 0 0 0 .256.255q.165.084.383.071m5.033 7.822.71 1.81-.375.022-.105-.29-.677.04-.103.303-.375.022.703-1.894zm.112 1.212-.222-.618-.22.645zm-4.836-2.917-.615.037-.006-3.336.245-.014 1.185-.071q.27-.017.474.095a.76.76 0 0 1 .317.33q.113.22.113.518t-.11.53a.9.9 0 0 1-.532.472l.784 1.328-.746.045-.738-1.297-.373.022zm-.003-1.946.765-.046a.3.3 0 0 0 .166-.058.34.34 0 0 0 .111-.144.56.56 0 0 0 .002-.413.3.3 0 0 0-.112-.131.3.3 0 0 0-.168-.038l-.766.046zm.856 3.883.003 1.356-.66-1.317-.426.026.003 1.85.334-.02-.003-1.335.657 1.296.429-.025-.004-1.851z\"/><path d=\"M88.715 59.058H78.566v9.472h-3.892l-.06-3.922-1.27-3.002H63.195v6.924h-3.156v-3.922H49.891v3.922h-3.375l-.003-1.711-1.318-2.211H35.047v3.922h-1.494v-1.537l-2.294-3.465H21.11v15.795l2.498 2.371h9.945v-7.012h1.494v5.721l1.864 1.553 9.632.146-.015-7.42h3.363v5.721l.775.934h8.722l.651-.934v-5.721h3.156v2.719l1.193 2.286h10.456l-.076-5.005h3.798v.171l.938 1.504h10.124V61.316z\" style=\"fill:#2c2c2c\"/><path d=\"M31.259 79.323H21.11V63.528h10.149zm13.936-14.715H35.047v15.795h10.148zm14.844 0H49.891v15.795h10.148zm13.305-3.002H63.195v15.795h10.149zm15.371-2.548H78.566v15.795h10.149zm-15.981 44.333-.808.049-.008-4.38.808-.05 2.065-.123.001.795-2.065.124.002 1.013 1.74-.105.002.795-1.74.105.002.982 2.064-.124.002.796zm-41.43 11.067-.21.013v.745l-.348.02-.003-1.852.139-.009.67-.04a.5.5 0 0 1 .27.053.43.43 0 0 1 .179.183.6.6 0 0 1 .064.287q0 .165-.063.295a.5.5 0 0 1-.18.205c-.037.025-.087.027-.13.042l.453.753-.422.025zm-.211-.324.433-.026a.18.18 0 0 0 .157-.112.3.3 0 0 0 0-.23.16.16 0 0 0-.062-.072.16.16 0 0 0-.096-.021l-.433.026v.435Zm21.87-1.829-.831.173.602.563-.14.853.742-.443.744.354-.143-.836.6-.635-.831-.073-.373-.747z\" style=\"fill:#6c6c6c\"/><path d=\"m64.338 60.435 29.807-.843-1.396-5.277-29.786 1.113z\" style=\"fill:#2c2c2c\"/><path d=\"m62.963 55.428 29.786-1.113-11.03-11.378 9.656-12.263-37.467 7.55-35.812 1.299 8.296 10.37-9.586 12.121 38.159-6.288z\"/><path d=\"m52.229 20.387-20.111.893 19.979-5.868 1.467-15.4 1.34 15.048 20.245-.724-19.979 5.868-1.422 20.02zM9.943 87.72H1.376v3.43h8.523v2.898l5.996-4.613-5.952-4.613zm83.85 11.072V91.21s-63.434 4.453-66.564 4.353-3.972-.381-5.657-1.705-11.314-27.806-11.314-27.806 11.593 18.386 13.07 20.793 3.1 3.41 4.985 3.28c1.884-.13 66.202-4.934 66.202-4.934l-1.204-23.177s5.297 21.25 5.297 25.463-4.815 11.315-4.815 11.315Z\" style=\"fill:#7c7c7c;stroke:#7c7c7c;stroke-miterlimit:10;stroke-width:.25px\"/><path d=\"m42.31 121.632.664-.024-1.02 3.466-.504.018-1.26-3.386.664-.023.808 2.26zm2.532-.09 1.43 3.38-.695.025-.211-.543-1.255.044-.173.556-.695.025 1.19-3.472.41-.014Zm.284 2.248-.45-1.154-.369 1.183zm3.255.202a.54.54 0 0 1-.184.19.5.5 0 0 1-.252.07.6.6 0 0 1-.312-.063.5.5 0 0 1-.201-.209.8.8 0 0 1-.08-.339l-.033-.94a.8.8 0 0 1 .056-.345.5.5 0 0 1 .186-.224.6.6 0 0 1 .306-.084.5.5 0 0 1 .45.231.9.9 0 0 1 .127.286l.67-.024a1.7 1.7 0 0 0-.253-.631 1.14 1.14 0 0 0-.434-.39 1.2 1.2 0 0 0-.582-.118 1.4 1.4 0 0 0-.664.174 1 1 0 0 0-.409.452q-.135.292-.122.697l.033.94q.015.405.17.686a1 1 0 0 0 .44.42q.284.14.674.127a1.16 1.16 0 0 0 .572-.16q.247-.147.405-.418.156-.27.21-.648l-.67.024a.8.8 0 0 1-.103.296m2.82-2.672 1.43 3.379-.696.024-.211-.542-1.255.044-.173.556-.695.024 1.19-3.471zm.283 2.247-.45-1.154-.369 1.183zm3.747-2.39.088 2.51-1.306-2.466-.79.027.121 3.424.617-.022-.086-2.47 1.3 2.427.794-.028-.12-3.423-.618.022Zm3.365 2.456a.52.52 0 0 1-.437.26.6.6 0 0 1-.311-.062.5.5 0 0 1-.202-.21.8.8 0 0 1-.08-.338l-.032-.94q-.007-.2.055-.346c.062-.146.104-.171.187-.223a.6.6 0 0 1 .306-.085.5.5 0 0 1 .45.232.9.9 0 0 1 .127.285l.67-.023a1.7 1.7 0 0 0-.253-.632 1.14 1.14 0 0 0-.435-.389 1.2 1.2 0 0 0-.582-.119 1.4 1.4 0 0 0-.664.174 1 1 0 0 0-.408.453 1.5 1.5 0 0 0-.122.696l.033.94q.014.406.17.686.155.282.44.421.282.14.674.127a1.2 1.2 0 0 0 .571-.16q.247-.147.405-.418.157-.272.21-.648l-.67.023a.9.9 0 0 1-.102.296m1.476-2.625.12 3.426.67-.024-.12-3.425zm4.059 2.664-1.65.058-.027-.768 1.39-.049-.021-.621-1.39.048-.028-.791 1.649-.058-.022-.622-2.061.072-.234.008.12 3.426.646-.022 1.65-.059zm3.246-.5q-.012-.349-.165-.545a.85.85 0 0 0-.374-.28 3 3 0 0 0-.604-.145l-.019-.003a.51.51 0 0 1-.587-.194.32.32 0 0 1-.092-.231v-.002a.3.3 0 0 1 .152-.28q.159-.105.456-.114.197-.008.416.06.219.067.421.198l.254-.556a2.1 2.1 0 0 0-.735-.29 1.7 1.7 0 0 0-.377-.03 1.7 1.7 0 0 0-.68.148.94.94 0 0 0-.418.374q-.14.24-.128.573v.003q.013.374.178.572.165.199.394.272t.575.115l.052.006.013.002.013.001q.197.024.323.058a.5.5 0 0 1 .207.11.3.3 0 0 1 .085.214v.003a.34.34 0 0 1-.164.308q-.17.113-.486.125a1.6 1.6 0 0 1-.536-.07 1.5 1.5 0 0 1-.465-.235l-.28.543q.166.129.376.217c.21.088.288.102.446.13q.235.04.48.032.413-.015.702-.147a.96.96 0 0 0 .434-.372 1 1 0 0 0 .134-.566zM29.931 67.89v8.55h-2.368v-7.634c0-.318-.013-.577-.013-.577h-.26c-.122 0-.083.335-.083.747l-.066 6.927a.54.54 0 0 1-.541.536h-1.252a.54.54 0 0 1-.541-.536l-.066-6.927c0-.412.04-.747-.083-.747h-.26s-.014.259-.014.577v7.633h-2.368v-8.55c0-1.927 1.081-2.352 2.093-2.352.917 0 1.569.38 1.865 1.377.296-.997.947-1.377 1.865-1.377 1.012 0 2.092.425 2.092 2.353m14.397 4.342c0 3.527-1.884 6.386-4.207 6.386s-4.207-2.859-4.207-6.386 1.883-6.385 4.207-6.385 4.207 2.859 4.207 6.385m-2.615-.105c0-1.41-.766-2.554-1.712-2.554s-1.713 1.144-1.713 2.554.767 2.554 1.713 2.554 1.713-1.143 1.713-2.554Zm9.015-2.08 3.003-.034v8.93h2.636v-9.029l2.834-.094v-3.347l-8.473.227zm15.995 1.028c0-.335.271-.606.606-.606h3.997v-2.673h-3.848a.606.606 0 0 1-.607-.607v-.123c0-.335.272-.607.607-.607h4.615v-3.737h-4.22a3.7 3.7 0 0 0-3.7 3.7v6.41a2.86 2.86 0 0 0 2.86 2.858h5.333v-4.009h-5.037a.606.606 0 0 1-.606-.606m17.043-1.941c-1.52 0-1.232-.374-1.232-1.894V60.7h-2.93v9.167a2.52 2.52 0 0 0 2.519 2.519h5.985v-3.252zM58.036 41.81a9.3 9.3 0 0 1 1.498-1.694 4.7 4.7 0 0 1 1.74-.986 6 6 0 0 1 .53-.05q.14-.009.25 0a.6.6 0 0 1 .157.024.21.21 0 0 0 .217-.065.4.4 0 0 0 .099-.225.53.53 0 0 0-.029-.253q-.045-.123-.156-.142a3 3 0 0 0-.608-.067 3.3 3.3 0 0 0-.73.067q-1.538.343-2.743 1.237c-1.205.894-1.516 1.305-2.137 2.129a15.5 15.5 0 0 0-1.628 2.707 30 30 0 0 0-1.214 2.96 3.4 3.4 0 0 0-.941-1.238 5.2 5.2 0 0 0-1.397-.822l.242-.677q.22-.662.463-1.288.242-.624.53-1.19.301.004.596-.026t.597-.071a8 8 0 0 0 .49-.086q.245-.052.468-.106.244-.069.54-.198a2.3 2.3 0 0 0 .527-.32q.234-.19.36-.436a.75.75 0 0 0 .05-.55.93.93 0 0 0-.32-.482 1.5 1.5 0 0 0-.531-.26 2.7 2.7 0 0 0-.62-.089 3.6 3.6 0 0 0-.584.03 5 5 0 0 0-1.27.41 4.4 4.4 0 0 0-1.045.72.15.15 0 0 1-.067-.014l-.111-.032q-.57-.096-1.2-.189a21 21 0 0 0-1.282-.148 16 16 0 0 0-1.316-.056 9 9 0 0 0-1.298.087 6.3 6.3 0 0 0-1.403.366q-.69.266-1.318.716-.63.45-1.16 1.098-.534.648-.942 1.523a3.2 3.2 0 0 0-.246 1.123q-.026.6.133 1.128.045.145.096.296.05.15.118.27.18.385.476.688a2.77 2.77 0 0 0 1.509.795q.45.084.942.027.323-.045.59-.124.267-.078.5-.251.279-.214.222-.464a.38.38 0 0 0-.196-.235q-.152-.08-.407-.02a1.33 1.33 0 0 1-.736-.008 2 2 0 0 1-.665-.352 2.4 2.4 0 0 1-.538-.615 3.2 3.2 0 0 1-.354-.798 3.3 3.3 0 0 1-.121-.995q.015-.522.235-1.033.354-.868.954-1.268.6-.399 1.391-.51a5.4 5.4 0 0 1 .747-.046q.413 0 .864.037.452.034.92.087l.926.103q.356.055.77.102.411.047.803.086-.389.608-.72 1.302t-.651 1.48a7.7 7.7 0 0 0-1.996.085q-.156.027-.29.058-.189.073-.244.213a.45.45 0 0 0-.01.296.57.57 0 0 0 .241.325q.186.125.452.005l-.011.002a3 3 0 0 1 .379-.076q.255-.036.54-.047.284-.01.575.008v.012q-.155.396-.32.863a290 290 0 0 1-.821 2.267q-.248.678-.525 1.33-.275.654-.569 1.238-.293.586-.614 1.033-.322.45-.666.731t-.7.32a1.8 1.8 0 0 1-.798-.1 1.65 1.65 0 0 1-.62-.404 1.7 1.7 0 0 1-.035-.322q0-.153.054-.218a1.1 1.1 0 0 0 .222-.406.6.6 0 0 0-.002-.327.55.55 0 0 0-.33-.363 1.03 1.03 0 0 0-.552-.064 1.4 1.4 0 0 0-.379.112 1.3 1.3 0 0 0-.344.23 1.16 1.16 0 0 0-.365.828q.058.53.394.94.336.408.834.678.496.27 1.077.382c.581.112.766.086 1.137.034q.747-.105 1.375-.467a5.2 5.2 0 0 0 1.156-.91q.526-.547.964-1.24c.438-.693.56-.944.803-1.445q.364-.753.673-1.533t.574-1.496l.397-1.05.066-.172q.693.29 1.219.77.526.484.718 1.181.078.259.091.596a4.4 4.4 0 0 1-.052.79q-.132.453-.247.884l-.225.844-.308 1.201q-.087.34-.042.509.08.27.33.322.251.053.652.02.223-.02.396-.05.173-.029.3-.094a.6.6 0 0 0 .217-.188 1 1 0 0 0 .144-.33l.099-.388q.054-.218.12-.456.066-.237.12-.467a74 74 0 0 1 .682-2.405q.385-1.276.865-2.548c.48-1.272.673-1.671 1.06-2.47q.58-1.198 1.273-2.19m-4.548-1.13q.222-.131.512-.207.122-.028.267-.043t.274-.015.234.013q.105.014.15.042a.3.3 0 0 1-.094.173 1.2 1.2 0 0 1-.205.155q-.123.075-.262.128a1.2 1.2 0 0 1-.261.07q-.213.03-.474.035a5 5 0 0 1-.574-.028q.21-.194.433-.324Zm3.966 4.814a.77.77 0 0 1 .221-.4l-.01.002q.276-.308.622-.356a.98.98 0 0 1 .726.191.9.9 0 0 1 .28.44.9.9 0 0 1 .019.455.95.95 0 0 1-.205.414 1.04 1.04 0 0 1-.645.347.9.9 0 0 1-.703-.194.82.82 0 0 1-.292-.45 1 1 0 0 1-.013-.449m15.21.935a.5.5 0 0 0-.162-.252.34.34 0 0 0-.274-.073.42.42 0 0 0-.278.144l-.531.951q-.09.141-.233.337a4 4 0 0 1-.666.707 1.2 1.2 0 0 1-.373.222.1.1 0 0 0-.05.018.2.2 0 0 1-.044.018.4.4 0 0 1 .016-.154q.027-.109.05-.218l.628-1.678q.142-.382.053-.697a.79.79 0 0 0-.476-.53 1.3 1.3 0 0 0-1.365.237q.364-.893.667-1.655t.458-1.17v-.011a1 1 0 0 0 .066-.243.4.4 0 0 0-.012-.174.32.32 0 0 0-.269-.243 1.7 1.7 0 0 0-.49-.014q-.29.03-.484.115c-.194.085-.236.173-.317.348a154 154 0 0 0-.883 2.153q-.275.687-.579 1.45l-.39.982c-.015-.015-.018-.04-.035-.052a.37.37 0 0 0-.28-.066.45.45 0 0 0-.277.144 11 11 0 0 1-1.064 1.582 9.4 9.4 0 0 1-1.099 1.13l.287-.8.804-2.207q.121-.262.066-.43a.32.32 0 0 0-.263-.244 1.7 1.7 0 0 0-.496-.013 1.7 1.7 0 0 0-.452.098.63.63 0 0 0-.316.279 1.2 1.2 0 0 0-.509-.269 2 2 0 0 0-.696-.03 2 2 0 0 0-.752.256 3.8 3.8 0 0 0-.728.54q-.344.324-.632.738c-.09.129-.147.268-.222.401-.027-.044-.043-.097-.084-.13a.34.34 0 0 0-.273-.073.42.42 0 0 0-.278.144l-.531.951q-.067.115-.2.28a4.5 4.5 0 0 1-.966.866.25.25 0 0 1-.15-.073q-.063-.061-.04-.158l.01.01.85-2.212a.8.8 0 0 0 .06-.249.5.5 0 0 0-.018-.178.32.32 0 0 0-.263-.244 1.7 1.7 0 0 0-.496-.013q-.29.029-.484.109t-.305.34l-.32.747q-.32.735-.536 1.367-.214.633-.156 1.256.012.104.085.275.073.17.202.334t.313.273a.76.76 0 0 0 .43.097 1.4 1.4 0 0 0 .456-.104q.256-.1.567-.331.312-.23.684-.634.372-.402.815-1.026c.04-.057.077-.12.116-.18-.028.26-.018.509.042.743a1.3 1.3 0 0 0 .449.692q.18.144.419.228.24.083.54.053a1.6 1.6 0 0 0 .485-.15 2.6 2.6 0 0 0 .462-.286l-.055.195-.122.356a.2.2 0 0 0-.033.028.2.2 0 0 1-.033.028l-.011.013q-.4.29-.834.614a6 6 0 0 0-.772.68 3 3 0 0 0-.526.735 1.26 1.26 0 0 0-.12.789q.035.217.147.395a1.3 1.3 0 0 0 .269.307q.156.13.357.196.201.065.413.06a1.9 1.9 0 0 0 .935-.354 2.7 2.7 0 0 0 .655-.694q.265-.406.442-.868.176-.464.308-.892l.22-.638.1-.26v.012l.055-.149q.434-.317.906-.717t.933-.873q.443-.458.85-.981l-.018.046-.392 1.003q-.11.285-.065.418.057.215.252.245.195.031.496.013.324-.022.512-.107.19-.084.311-.359.132-.323.342-.849t.464-1.158a8 8 0 0 1 .41-.642q.22-.312.399-.541.177-.23.282-.344.105-.115.073-.04l-.276.741-.011-.01q-.078.186-.144.377-.065.19-.132.375l-.01-.01q-.166.408-.238.688t.009.654q.033.159.123.316t.241.27.347.168a.9.9 0 0 0 .429.01q.19-.026.45-.144.263-.12.584-.363.322-.243.695-.629.372-.385.793-.959.166-.233.316-.488t.27-.483l.122-.204q.055-.112 0-.327ZM61.22 52.976a6 6 0 0 1-.122.28 4 4 0 0 1-.176.34 3 3 0 0 1-.217.324.9.9 0 0 1-.25.227q-.045-.016-.028-.09.017-.072.055-.165.04-.093.094-.188a3 3 0 0 1 .1-.16v.01q.133-.158.277-.307.146-.149.278-.296zm1.795-5.269a22 22 0 0 0-.309.78q-.486.992-.898 1.05a.3.3 0 0 1-.358-.208.9.9 0 0 1-.013-.378q.033-.233.132-.492c.099-.259.149-.348.249-.526q.15-.267.338-.468.188-.202.417-.322a.83.83 0 0 1 .473-.095q.078.012.068.195t-.099.464M35.501 46.27q-.069.216-.162.44-.116.291-.245.591-.13.3-.28.584a5 5 0 0 1-.33.54q-.18.255-.386.455-.208.201-.455.336t-.532.18a1.5 1.5 0 0 1-.48-.011 1.5 1.5 0 0 1-.452-.158 1.2 1.2 0 0 1-.347-.288.75.75 0 0 1-.165-.396.5.5 0 0 1 .153-.348.6.6 0 0 1 .303-.143.44.44 0 0 1 .232.026q.105.045.138.153a.26.26 0 0 1 0 .137.5.5 0 0 1-.092.17q-.023.029-.023.092 0 .064.015.135a.72.72 0 0 0 .594.211.68.68 0 0 0 .404-.203q.18-.177.332-.449.154-.271.288-.614.135-.343.268-.7l.222-.57q.153-.395.315-.768a5 5 0 0 1 .357-.68 2.6 2.6 0 0 1 .44-.53q.244-.224.562-.317-.323.021-.643.009l-.633-.027q-.375-.016-.72-.025a4 4 0 0 0-.65.035 1.9 1.9 0 0 0-.697.232q-.298.177-.474.57-.107.237-.115.474a1.42 1.42 0 0 0 .221.822q.11.168.254.284a.9.9 0 0 0 .311.165.7.7 0 0 0 .342.016.4.4 0 0 1 .161.021q.078.029.096.094.015.052-.006.105a.2.2 0 0 1-.086.097h.004a.8.8 0 0 1-.238.113 2 2 0 0 1-.266.054 1.5 1.5 0 0 1-.43-.011 1.23 1.23 0 0 1-.685-.366 1.2 1.2 0 0 1-.22-.315 2 2 0 0 1-.1-.256 1.6 1.6 0 0 1-.053-.51q.012-.274.11-.518.19-.453.455-.778.265-.324.58-.544a2.7 2.7 0 0 1 .667-.344q.352-.123.717-.174a5.6 5.6 0 0 1 1.047-.048q.519.026.987.068.36.034.667.052.306.019.521-.021a.7.7 0 0 0 .206-.07.4.4 0 0 0 .125-.099h.005a.2.2 0 0 1 .13-.073.19.19 0 0 1 .21.132q.035.094-.044.203-.093.117-.168.188a.7.7 0 0 1-.196.128 2.5 2.5 0 0 1-.462.172 4 4 0 0 1-.49.098.2.2 0 0 1 .112.122.12.12 0 0 1-.018.11.18.18 0 0 1-.102.073.8.8 0 0 0-.339.19 1.4 1.4 0 0 0-.253.323 3 3 0 0 0-.202.43q-.09.24-.178.513zm5.01.12q-.067.005-.127.077a3.7 3.7 0 0 1-.502.712q-.135.147-.278.248-.141.1-.287.15a.5.5 0 0 1-.102.025.3.3 0 0 1-.113-.005.2.2 0 0 1-.098-.045.2.2 0 0 1-.061-.104l-.014-.042q.214-.05.43-.146.213-.096.386-.23.173-.135.284-.303a.7.7 0 0 0 .12-.36.5.5 0 0 0-.05-.184.4.4 0 0 0-.13-.156.5.5 0 0 0-.221-.087.9.9 0 0 0-.32.013 1.3 1.3 0 0 0-.339.123 2.2 2.2 0 0 0-.613.498 2 2 0 0 0-.176.253c-.01-.015-.016-.036-.031-.048a.14.14 0 0 0-.114-.03.18.18 0 0 0-.117.06l-.223.4a2.3 2.3 0 0 1-.23.299 2 2 0 0 1-.147.138.5.5 0 0 1-.196.108.2.2 0 0 1 .007-.065l.02-.09.264-.705a.46.46 0 0 0 .022-.293.33.33 0 0 0-.2-.222.55.55 0 0 0-.572.1 96 96 0 0 0 .472-1.185v-.004a.4.4 0 0 0 .028-.102.2.2 0 0 0-.005-.073.13.13 0 0 0-.113-.102.7.7 0 0 0-.205-.006.7.7 0 0 0-.204.048.28.28 0 0 0-.132.146l-.158.378a80 80 0 0 0-.456 1.133l-.462 1.171-.165.42q-.046.12-.027.176.024.09.106.103t.208.005a.6.6 0 0 0 .215-.045q.08-.035.13-.15l.144-.356q.087-.222.194-.486.08-.139.172-.27a8 8 0 0 1 .167-.227q.075-.096.119-.144c.044-.048.04-.037.03-.016l-.115.31-.005-.004a3 3 0 0 0-.06.158l-.056.157-.005-.004a2 2 0 0 0-.099.289.6.6 0 0 0 .056.407.4.4 0 0 0 .1.113.4.4 0 0 0 .325.075.7.7 0 0 0 .19-.061q.11-.049.245-.152.135-.102.291-.264.156-.16.333-.402.038-.057.075-.117c0 .045-.014.094-.005.137q.048.165.15.283a.8.8 0 0 0 .24.187q.136.07.295.092a1.26 1.26 0 0 0 .827-.167q.228-.138.417-.336t.344-.433.29-.465l.005-.025v.02a.22.22 0 0 0-.05-.266.16.16 0 0 0-.117-.035Zm-1.352.248q.136-.18.298-.272a.2.2 0 0 1 .089-.033q.038 0 .042.024.02.18-.148.366a1.15 1.15 0 0 1-.48.3q.065-.205.2-.385Z\" style=\"fill:#fdffff\"/></svg>";

},{}],"hpK5Z":[function(require,module,exports,__globalThis) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"98.468\" height=\"88.938\"><path d=\"M2.974 68.93S-9.873 81.778 17.833 83.644c22.391 1.509 34.176.783 45.655 3.653s26.362 2.17 32.35-3.653c9.392-9.13-9.392-11.74-9.392-11.74L47.988 68.32Z\" opacity=\".25\"/><path fill=\"#989aab\" d=\"M28.584 4.45c-.639-.338-.428-.733-1.025-.892-.723-.193-.747-.651-1.422-.989a4.7 4.7 0 0 1-1.037-.615c-.492-.43-.642-1.105-.94-1.29-.254-.157-.808-.06-1.773-.06S20.47.206 18.915.254a11.2 11.2 0 0 0-3.883 1.11 32 32 0 0 0-1.88 3.387 2.4 2.4 0 0 1-1.58 1.206c-.303.033-.084.989-.133 1.809-.056.954-.816 1.783-.844 2.29a19 19 0 0 1-.494 2.532 28.3 28.3 0 0 0-.169 4.811 36 36 0 0 0 .193 4.365 7.5 7.5 0 0 1-.217 2.146 13 13 0 0 0-.663 2.447c-.171 2.298-.18 4.208-.362 5.643a10.8 10.8 0 0 1-.795 2.568 20 20 0 0 1-1.76 2.291 6.5 6.5 0 0 0-1.267 2.725c0 .82.225 1.508.241 2.436a6.6 6.6 0 0 1-.229 1.58 45 45 0 0 0-.12 5.196c-.023 1.88-.615 2.592-.615 3.894 0 2.293-.174 7.491-.314 9.224-.106 1.32-.563 3.452-.723 5.932-.096 1.495-.639 3.762-.7 4.702.298.046 2.079.23 4.016.325 2.15.106 4.517.122 5.739.133 1.442.013 3.422.025 5.244-.072 1.637-.087 3.147-.287 3.991-.241a40.6 40.6 0 0 0 5.92.253c2.797-.145 5.811-.085 7.692.012s3.75.096 5.727.072a21.4 21.4 0 0 0 4.172-.554c.331-.053 1.784-.603 2.29-.664a11.7 11.7 0 0 1-1.519-4.412c-.337-1.785-.12-2.159-.458-2.64a11.2 11.2 0 0 0-1.953-2.22c-.469-.401-.415-1.253-.434-1.928a43 43 0 0 0-.205-2.87c-.136-1.248-.145-2.026-.313-3.014-.051-.299-.63-1.276-.784-1.712-.627-1.785-.326-2.243-.277-4.076s-1.797-6.8-2.23-7.86-.097-2.244-.556-3.305c-.172-.399-.602-.723-1.567-2.146 0-1.109.675-1.929.048-3.135s-.337-2.025-.385-3.617a38 38 0 0 0-.217-4.75c-.242-1.447.361-15.891-2.098-17.242a61 61 0 0 0-5.86-2.435\"/><path fill=\"#666880\" d=\"M47.608 71.686a11.45 11.45 0 0 1-1.489-4.333 14 14 0 0 1-.216-1.664l-.013-.148.095.055-.18-.603c-.004-.011-.012-.02-.015-.03a1.3 1.3 0 0 0-.167-.343l-.001-.003a11.5 11.5 0 0 0-1.997-2.266c-.325-.279-.334-.917-.342-1.48l-.005-.267a44 44 0 0 0-.206-2.89c-.053-.479-.086-.888-.117-1.267-.05-.614-.093-1.143-.199-1.761a4.3 4.3 0 0 0-.396-.914l-.03-.059a8 8 0 0 1-.368-.78 5.3 5.3 0 0 1-.374-2.1c.007-.214.023-.435.042-.68.026-.341.056-.727.069-1.206v-.01a5.6 5.6 0 0 0-.09-.975c-.003-.014-.001-.029-.004-.043l-.034-.185h-.002a42 42 0 0 0-1.817-5.968h.003l-.128-.331a29 29 0 0 0-.177-.45 4.6 4.6 0 0 1-.25-1.545 4.9 4.9 0 0 0-.307-1.764 3.2 3.2 0 0 0-.482-.698 20 20 0 0 1-1.064-1.424 4.8 4.8 0 0 1 .154-.95 4.7 4.7 0 0 0 .16-1.037 2.46 2.46 0 0 0-.295-1.188l-.004-.01a3.3 3.3 0 0 1-.2-.485 10 10 0 0 1-.177-1.314q.003-.191.01-.399 0-.05.002-.1c.012-.356.025-.748.012-1.19a39 39 0 0 0-.03-1.97 38 38 0 0 0-.19-2.825c-.052-.31-.064-1.35-.077-2.671l-.001-.097v-.023l-.01-.858a154 154 0 0 0-.093-4.203l-.007-.03c-.184-4.717-.667-8.785-2.05-9.544a61 61 0 0 0-5.86-2.438c-.031-.016-.054-.033-.08-.049-.024-.015-.051-.03-.072-.046a1 1 0 0 1-.065-.058c-.014-.013-.032-.026-.044-.04q-.027-.03-.05-.06l-.032-.042-.001-.001q-.035-.051-.068-.104a.98.98 0 0 0-.655-.506 1.32 1.32 0 0 1-.676-.435 2.5 2.5 0 0 0-.712-.542 4.5 4.5 0 0 1-.972-.573 2.6 2.6 0 0 1-.514-.717q-.067-.122-.132-.231l1.75-.13-2.305-.325-.02-.002a3 3 0 0 0-.672-.031c-.073.002-.146-.013-.22-.004q-.387 0-.764.027a4 4 0 0 1-.572-.042 16 16 0 0 1-.642-.102A10.4 10.4 0 0 0 18.89.005a11.4 11.4 0 0 0-3.969 1.134l-.062.03-.038.06a32 32 0 0 0-1.89 3.404 2.15 2.15 0 0 1-1.389 1.076.4.4 0 0 0-.164.06l-.044.034-.01.01-.007.008-.026.03-.026.03-.288.344.188.01c-.005.06-.004.13-.004.197v.063q.002.184.015.409a8 8 0 0 1 .014.847 3.6 3.6 0 0 1-.497 1.389 2.5 2.5 0 0 0-.346.886 19 19 0 0 1-.494 2.533 28.5 28.5 0 0 0-.17 4.836 36 36 0 0 0 .192 4.38 7.3 7.3 0 0 1-.2 2.047 13.4 13.4 0 0 0-.68 2.517c-.072.977-.116 1.884-.156 2.715-.054 1.126-.1 2.098-.202 2.903a10.6 10.6 0 0 1-.769 2.49q-.387.585-.818 1.148l-.177.199a8 8 0 0 0-.74.909l-.002.002-.008.01a7 7 0 0 0-.412.593c-.042.067-.078.138-.118.207a7 7 0 0 0-.236.443q-.059.129-.115.26a7 7 0 0 0-.262.72c-.018.061-.042.12-.06.182l-.037-.011-.005.017.038.01q-.059.22-.105.448a8 8 0 0 0 .117 1.217q.047.308.085.637c.02.186.036.376.04.576a6 6 0 0 1-.065.772l-.005.023a7 7 0 0 1-.159.77 45 45 0 0 0-.121 5.214 8.3 8.3 0 0 1-.344 2.24c-.041.155-.074.31-.11.465-.022.09-.048.18-.066.273-.02.107-.025.23-.04.341a4 4 0 0 0-.051.44l-.011.242h.006v.242l-.002.172-.003.321-.003.206-.005.34-.004.243-.007.327-.006.286-.008.323-.008.326-.007.263-.01.405-.007.213-.014.46-.006.192-.016.472-.007.206-.016.458-.009.215-.016.414-.013.313-.012.308-.024.524-.002.044-.024.487-.003.06c-.027.52-.054.96-.08 1.28-.041.514-.138 1.16-.25 1.907-.167 1.123-.377 2.521-.474 4.029a28 28 0 0 1-.413 2.83c-.138.773-.258 1.441-.286 1.872l-.015.228.226.035c.182.028.932.11 1.942.19a69 69 0 0 0 3.354.189l.162.005q.714.024 1.397.037l.058.002.128.003q.048 0 .098.002h.005l.137.003.133.002.317.004.18.003c.743.011 1.397.017 1.873.02h.019l1.397.009q.505 0 1.04-.003.149 0 .296-.003l.43-.005.232-.004v-.003a56 56 0 0 0 1.853-.062 60 60 0 0 0 1.842-.134 20 20 0 0 1 2.106-.109 41.4 41.4 0 0 0 5.962.255 65 65 0 0 1 1.678-.061l.5-.012.594-.007.462-.005h.559l.473.002.435.005.55.008.212.005c.441.01.836.021 1.172.033l.142.005.31.013.58.026q.798.04 1.599.06l.281.006c.153.004.302.003.454.006q.551.009 1.15.011l.303.003.242-.002c.377 0 .764-.001 1.179-.006l.332-.003v-.001c.068-.001.14 0 .208-.002a21.7 21.7 0 0 0 4.203-.557 4 4 0 0 0 .501-.14c.117-.036.244-.077.397-.127.183-.06.374-.121.56-.18l.162-.05.155-.044a5 5 0 0 1 .505-.122l.38-.044Zm-2.263-6.472a4 4 0 0 1 .06.514 14 14 0 0 0 .22 1.704 12 12 0 0 0 .582 2.401 17 17 0 0 0-1.349-1.518c-.714-.754-1.02-2.43-1.222-3.54q-.055-.302-.1-.533a3.5 3.5 0 0 0 .594-.067 4.9 4.9 0 0 0 1.215 1.04ZM43.6 63.456l.048.068.002.004.14.195c-.127.014-.26.015-.38.02l-.188-.021a2.5 2.5 0 0 1-.388-.041 3 3 0 0 1-1.142-.508l-.035-.03a14 14 0 0 1-1.595-4.534 4 4 0 0 1-.051-.487l-.003-.108-.081-.073-.008-.006-.004-.004-.016-.014-.006-.006a5.1 5.1 0 0 0-2.92-1.238l-.05-.004-.049.015a3.7 3.7 0 0 1-2.148.048l-.082-.023c-.189-.063-.508-.318-1.017-1.115-.474-.75-.956-1.717-1.305-2.418-.298-.6-.534-1.074-.709-1.336a1 1 0 0 0-.233-.252.7.7 0 0 0-.431-.147.5.5 0 0 0-.118.01 1.88 1.88 0 0 0-1.037.718 7 7 0 0 0-.5.657 9 9 0 0 1-.483.596l-.373.444q-.106-.362-.207-.719a73 73 0 0 1-1.014-4.04c-.052-.528 0-2.329.048-3.919.03-1.036.058-1.958.054-2.492q0-.19-.008-.31a2.23 2.23 0 0 1 .298-1.552l.006-.008.089-.143-.1-.137c-.183-.253.014-1.11.437-2.043a9 9 0 0 1 .41-.795v-.001a19 19 0 0 0 .973-2.72 5 5 0 0 0 .185-.535c.112-.373.157-.49.378-.55l.016-.004q.408-.074.82-.109a6 6 0 0 0 1.03 2.194c.259.416.527.847.778 1.32.13.242-.12.987-.279 1.415l-.077.203v.002l-.137.356-.002.006.384-.023q.324-.014.648-.005c-.09.393-.204.845-.314 1.29-.222.89-.432 1.732-.467 2.073-.089.84 1.486 3.112 3.297 4.035a7.2 7.2 0 0 1 1.696 1.501 2.3 2.3 0 0 0-.384.308 1.3 1.3 0 0 0-.278.332l-.003.003-.036.08a3.87 3.87 0 0 0 .37 2.802 20 20 0 0 0 1.73 1.93l.038.037v.001l.013.011.004.006.01.009.02.02a3 3 0 0 1 .366.421 4.4 4.4 0 0 0 2.092 1.667c.023 1.14.233 5.133 1 6.001a20 20 0 0 1 1.278 1.672m-9.11-6.271h.003a4.25 4.25 0 0 0 2.486-.01 4.6 4.6 0 0 1 2.537 1.072q.01.116.029.259a15.6 15.6 0 0 0 1.658 4.878 22.6 22.6 0 0 1-2.446 4.18l-.011.015-.001.001-.002.002-.001.001a5 5 0 0 1-1.27.496c-.182.056-.319.098-.422.134a3.5 3.5 0 0 0-.419-.552 1.3 1.3 0 0 1-.214-.28c-.04-.12-.33-.658-1.083-2.052-.904-1.67-2.142-3.957-2.418-4.642-.308-.761-.093-3.204.187-4.988.54.881.976 1.346 1.385 1.485Zm-7.82 7.058c.003.588.01 1.363.016 2.109.008.92.017 1.869.013 2.254h-.013a18.7 18.7 0 0 1-4.968-1.242.98.98 0 0 1-.488-.79 1.4 1.4 0 0 0 .16-.182 8.9 8.9 0 0 1 2.182-2.295l2.833.124-.018.022Zm-3.25-.654-.07.05a8 8 0 0 0-.227.17 9.4 9.4 0 0 0-1.809 1.822h-.001l-.003.005-.096.13a11 11 0 0 0-.026-2.195c-.097-.795-.065-2.562-.031-4.432a40 40 0 0 0-.215-7.123v-.002l-.002-.004-.002-.01c-.458-1.794-1.1-5.59-1.444-7.633l-.14-.822a162 162 0 0 0-.202-1.145c-.15-.84-.322-1.796-.46-2.686l.099-.027.03-.148.064-.297c.25-1.153.56-2.302.925-3.429l.068-.211.005-.018c.135-.465.393-1.246.667-2.072.182-.551.368-1.113.518-1.586.111-.35.203-.65.259-.863a12.5 12.5 0 0 0 .162-2.153 16.5 16.5 0 0 1 .319-3.435 2.5 2.5 0 0 1 .842-1.136l.002-.002a6.4 6.4 0 0 1 2.493-1.288h.011a3.3 3.3 0 0 1 .912.764l.023.023.002.002.023.023c.381.377.852.84 1.468 1.353a6.2 6.2 0 0 0 2.483 1.212 7 7 0 0 0 .826.157c-.33 1.854-.859 5.961-.859 6.442v.002a.44.44 0 0 0 .141.31l.022.023q-.1.014-.204.033h-.004l-.091.016q-.056.015-.104.031h-.001l-.003.001-.004.002-.004.001c-.44.157-.543.501-.652.865-.029.096-.06.202-.105.326q-.03.083-.068.172l-.011.033a19 19 0 0 1-.94 2.641 7.5 7.5 0 0 0-.965 2.758 1.2 1.2 0 0 0 .075.449 2.7 2.7 0 0 0-.34 1.365 2.5 2.5 0 0 0 .04.39c.005.107.007.28.005.5v.002c-.005.54-.03 1.37-.056 2.234-.05 1.68-.101 3.419-.045 3.98a46 46 0 0 0 1.123 4.45l.087.3.127.437.028.094.008.028.138.47.001-.001c.387 1.286.716 2.285.916 2.778a6.2 6.2 0 0 1 .51 2.27 2.2 2.2 0 0 1-.552 1.607 12 12 0 0 1-1.148.968 4.3 4.3 0 0 0-1.213 1.17Zm-9.71-18.134a2 2 0 0 1-.035-.422 12 12 0 0 1 .151-1.51 9 9 0 0 0 .142-1.727l-.005-.031a8.2 8.2 0 0 0-1.075-2.706l.007-.097v-.03q.001-.036.011-.143l.015-.186a.9.9 0 0 1 .282.019 4 4 0 0 1 .508.138l.023.008h.001a3.4 3.4 0 0 1 .798.396q.073.046.138.084a1 1 0 0 0 .17.08.48.48 0 0 0 .393-.015 2.06 2.06 0 0 0 1.249.435c.098.01.188.02.258.032l.008.002a4.7 4.7 0 0 0 .848.091 4.5 4.5 0 0 0 .608-.04c.138.89.308 1.836.459 2.68.072.407.14.785.197 1.116l.138.811c.347 2.057.995 5.886 1.458 7.697l.004.013a6.8 6.8 0 0 1-1.096 2.798.2.2 0 0 1-.029.024l-.023.01a.8.8 0 0 1-.308.046 5.96 5.96 0 0 1-2.765-1.326 7 7 0 0 1-.354-.307 8.26 8.26 0 0 1-2.182-3.997q.02-.314.034-.63a22 22 0 0 0-.028-3.313m2.8-13.47v-.011l-.001-.002a2 2 0 0 1-.015-.143v-.004a2.7 2.7 0 0 1 .068-.705l.001-.003a11.6 11.6 0 0 1 .59-1.731 11 11 0 0 0 .608-1.81c.429-2.144.59-2.435 2.4-2.744a.4.4 0 0 0 .09-.028 3.7 3.7 0 0 0 1.164-.208 3 3 0 0 0 .419-.154 2.5 2.5 0 0 0-.507.893 16.8 16.8 0 0 0-.338 3.56 13 13 0 0 1-.146 2.04l-.003.014c-.058.216-.153.527-.268.888-.145.454-.321.988-.495 1.512-.28.844-.544 1.641-.676 2.105a36 36 0 0 0-1.01 3.707l-.027.123a3.4 3.4 0 0 1-.772.089 4 4 0 0 1-.745-.082l-.01-.002a5 5 0 0 0-.3-.039 1.8 1.8 0 0 1-.915-.263l.008-.01h.001a.84.84 0 0 0 .163-.351v-.002h.001a8.5 8.5 0 0 0 .101-1.772 6.8 6.8 0 0 1 .11-1.696l.003-.006a5.84 5.84 0 0 0 .502-3.165Zm15.143-8.809a17 17 0 0 1 .606 2.036c-.017.025-.044.058-.066.088a3 3 0 0 0-.24.342l-.052.083.002.004a2.4 2.4 0 0 0-.155.353 5.9 5.9 0 0 1-1.566-.142 6.3 6.3 0 0 1-2.282-1.113 22 22 0 0 1-1.48-1.37c-.547-.54-.877-.868-1.208-.905a5.85 5.85 0 0 0-2.578 1.156c.216-.72-.164-2.146-.708-3.992a14 14 0 0 1-.4-1.52 42 42 0 0 1-.122-.981c-.07-.594-.14-1.205-.296-2.17l.307.037a4.5 4.5 0 0 0 1.14.064 1.3 1.3 0 0 0 .67-.354c1.597-1.367 1.796-2.091 1.918-3.04.173-1.347.282-2.185.379-2.751a7 7 0 0 1 .133-.631 2.4 2.4 0 0 0 .169.368 3.58 3.58 0 0 0 1.17 2.45l.142.182a2.65 2.65 0 0 0 1.643 1.208c1.15.274 2.59-.792 3.296-1.59a9 9 0 0 1 .605 2.163l.145.666.053.243.073.372c.097.487.18.969.252 1.417l.05.322q.053.338.101.672l.02.144a25.3 25.3 0 0 0-1.721 4.822 2.67 2.67 0 0 0 0 1.367m2.898 15.812a1.4 1.4 0 0 0-.642-.184q-.27-.028-.544-.04a9 9 0 0 0-.493-.013c.275-.768.39-1.324.202-1.682l-.001-.002a22 22 0 0 0-.797-1.348 7.3 7.3 0 0 1-.913-1.765l.144.06c.828.348 1.866.813 2.128 1.424a6 6 0 0 0 .58 1.02 1.87 1.87 0 0 1 .418 1.773l-.03.113a1.7 1.7 0 0 0-.052.644m6.598 9.27a5 5 0 0 1 .05.676c-.012.468-.042.846-.067 1.18-.028.363-.053.68-.047 1.008a6 6 0 0 0 .405 1.977 8 8 0 0 0 .394.84l.19.381a2.6 2.6 0 0 1 .19.45c.1.596.143 1.116.193 1.717.03.384.064.798.118 1.282.09.829.182 2.107.203 2.85l.005.259q.003.297.026.602c.003.035 0 .071.004.107q-.057-.068-.116-.135c-.579-.654-.878-4.401-.878-5.856v-.193l-.186-.049-.047-.013a3.84 3.84 0 0 1-1.962-1.532 3 3 0 0 0-.43-.49 20 20 0 0 1-1.727-1.91 3.36 3.36 0 0 1-.314-2.363 1.8 1.8 0 0 1 .251-.28 5 5 0 0 1 .46-.308h.001l.28-.132-.014-.018q.15-.081.3-.152a19 19 0 0 1 2.71.04q.005.031.008.062m-1.919-6.463a43.6 43.6 0 0 1 1.826 5.902 20 20 0 0 0-2.702-.038l-.091.024a8 8 0 0 0-.442.222 7.8 7.8 0 0 0-1.889-1.683c-1.772-.905-3.102-3.031-3.048-3.55.032-.306.247-1.17.455-2.004.12-.48.241-.969.337-1.383a4 4 0 0 1 .188.017h.01a1.1 1.1 0 0 1 .688.297q.089.067.192.14a4.6 4.6 0 0 0 1.238 1.644 2.26 2.26 0 0 0 2.35.624 2.8 2.8 0 0 1 .888-.212m-2.528-9.688a4 4 0 0 0 .218.495l.003.008a1.97 1.97 0 0 1 .238.968 3 3 0 0 1-.047.452c-.027.151-.063.304-.1.462a5 5 0 0 0-.168 1.137v.077l.043.063c.514.76.887 1.22 1.134 1.523a3 3 0 0 1 .411.582 4.5 4.5 0 0 1 .267 1.591 5 5 0 0 0 .285 1.709c.016.037.035.086.051.127a3.3 3.3 0 0 0-.905.253c-.463.224-1.141.018-1.817-.554a4.2 4.2 0 0 1-.973-1.181l-.157-.347-.022-.052a2 2 0 0 1-.11-.448 1.5 1.5 0 0 1 .029-.487 4 4 0 0 0 .08-.332 2.35 2.35 0 0 0-.53-1.97 5.7 5.7 0 0 1-.537-.941c-.346-.809-1.49-1.31-2.45-1.712l-.108-.045-.366-.155a.5.5 0 0 0-.091-.04c-.443-.195-.54-.285-.546-.265 0-.423.515-4.499.858-6.396a2.1 2.1 0 0 0 .583-.06l.157-.012.046-.171.03-.105a9.8 9.8 0 0 0 1.88 2.286 3.9 3.9 0 0 1 1.121 1.312 7 7 0 0 0 .562.811 3.5 3.5 0 0 1 .422.658 3.3 3.3 0 0 0 .509.76ZM36.138 17.2c.013.443.025.885.034 1.312l.01.531a217 217 0 0 1 .029 2.28c.014 1.445.024 2.489.082 2.832.067.621.108 1.25.144 1.878.01.163.03.323.037.486q.054 1.178.034 2.361a11 11 0 0 0-.025 1.696v.09l.001.065v.112a3.3 3.3 0 0 0-.33-.474 6.5 6.5 0 0 1-.52-.754 4.3 4.3 0 0 0-1.24-1.44 9.3 9.3 0 0 1-1.914-2.426q.057-.078.106-.14c.039-.049.079-.1.111-.152a.5.5 0 0 0 .065-.138.27.27 0 0 0-.004-.161 17 17 0 0 0-.604-2.067l-.031-.087-.001-.001a1.2 1.2 0 0 1-.06-.403c0-.914.603-2.75 1.8-5.477l.028-.065-.01-.07v-.004l-.066-.453-.017-.112c.512.062 1.129.152 1.982.287a3 3 0 0 1 .345.076zm-.28-.988a53 53 0 0 0-2.138-.305 43 43 0 0 0-.182-1.079 7.2 7.2 0 0 0 1.68.506c.3.025.593.336.87.923a4 4 0 0 0-.23-.045m-5.53-10.566a.4.4 0 0 0 .026-.245 61 61 0 0 1 3.97 1.704c1.108.61 1.552 4.4 1.74 8.194a1.2 1.2 0 0 0-.782-.46 6.6 6.6 0 0 1-1.862-.62 26 26 0 0 0-.106-.508l-.146-.665a7.1 7.1 0 0 0-.844-2.63l-.197-.324-.22.309c-.511.719-1.993 1.936-3.011 1.692a2.2 2.2 0 0 1-1.364-1.028l-.175-.217a3.12 3.12 0 0 1-1.037-2.193l-.036-.12a1.8 1.8 0 0 1-.262-1.003l.17-.271c.34-.542 1.916-.91 2.857-1.13.911-.214 1.178-.284 1.279-.485M23.954.867l.085.022a.5.5 0 0 1 .091.107c.015.02.028.032.043.055.046.073.093.156.14.24a3 3 0 0 0 .633.86c.119.093.246.173.372.255a5 5 0 0 0 .707.386 2 2 0 0 1 .567.44 5 5 0 0 0 .165.163 1.65 1.65 0 0 0 .738.404.5.5 0 0 1 .361.29q.05.079.12.172a1.4 1.4 0 0 0 .491.41l.007.003.004.002a12 12 0 0 0 1.298.519c.04.103.063.17.077.207-.174.067-.58.161-.917.24a8.2 8.2 0 0 0-2.855 1.034l.016-.238-.506.84a3.3 3.3 0 0 0-.457 1.102c-.098.419-.186 1-.31 1.938-.052.39-.11.842-.178 1.37-.11.858-.282 1.47-1.747 2.724a.75.75 0 0 1-.498.25 6 6 0 0 1-.926-.076l-.64-.076-.329-.036.055.326.001.006c.19 1.143.269 1.816.345 2.466.035.303.07.594.113.918l.01.075a14 14 0 0 0 .417 1.593c.332 1.13 1.023 3.479.65 3.82a3.2 3.2 0 0 1-.828.441 7 7 0 0 1-.956.168l-.145.018h-.08l-.013.011-.033.004c-.237.03-.498.061-.789.102a3.9 3.9 0 0 0-1.545.657c-.318.199-.59.374-.762.318l-.034-.014a.8.8 0 0 1-.288-.366 3 3 0 0 1-.071-.155 10.5 10.5 0 0 1-.413-3.402 9.7 9.7 0 0 0-.27-2.663 12 12 0 0 1-.335-1.177c-.483-1.995-1.007-5.386-.332-6.467a8.2 8.2 0 0 0 1.008-3.801 5 5 0 0 0-.003-.296h.014c.147.013.299.023.49.029a1.11 1.11 0 0 0 1.074-.493 9.7 9.7 0 0 0 .698-2.518 6.3 6.3 0 0 1 .724-2.367l.044-.05c.445-.465 3.452-.698 4.702-.79M12.558 5.774a2.6 2.6 0 0 0 .325-.277c.044-.044.092-.082.134-.13a2.7 2.7 0 0 0 .36-.508 31 31 0 0 1 1.829-3.302A10.9 10.9 0 0 1 18.922.504a9 9 0 0 1 1.26.058h.001c.249.03.479.067.7.105l.032.005a4.15 4.15 0 0 0-2.014.629l-.01.01-.007.007a2.3 2.3 0 0 0-.44.78l-.002.002v.003l-.002.002v.003a13 13 0 0 0-.447 1.872 9.4 9.4 0 0 1-.65 2.38c-.101.193-.37.231-.675.225-.135-.003-.274-.015-.403-.026l-.044-.004-.187-.015q-.543-.159-1.096-.287a19 19 0 0 0-2.447-.421c.024-.017.043-.041.067-.058M8.315 34.671a11 11 0 0 0 .816-2.64c.106-.835.153-1.817.208-2.953.04-.827.083-1.73.153-2.679a13 13 0 0 1 .659-2.428 7.8 7.8 0 0 0 .223-2.234 36 36 0 0 1-.192-4.35 28 28 0 0 1 .16-4.734 19 19 0 0 0 .503-2.583 2.3 2.3 0 0 1 .29-.698 4 4 0 0 0 .554-1.592 8 8 0 0 0-.014-.904 5 5 0 0 1-.01-.611 20.6 20.6 0 0 1 3.007.44q.518.12 1.03.269.01.13.01.262l-.002.104q-.003.227-.02.453a7.7 7.7 0 0 1-.788 2.858q-.063.126-.13.25c-.79 1.263-.205 4.83.285 6.852.13.538.254.967.343 1.214a9.5 9.5 0 0 1 .24 2.504 12 12 0 0 0 .372 3.376q.038.107.08.21c.198.468.421.728.703.817a1.2 1.2 0 0 0 .986-.253 8.2 8.2 0 0 0-.51 1.857 10.7 10.7 0 0 1-.583 1.723 12.6 12.6 0 0 0-.598 1.74v.001l-.001.002v.003a3.5 3.5 0 0 0-.099.792v.008a2 2 0 0 0 .024.296 5.34 5.34 0 0 1-.455 2.89l-.01.02a6.3 6.3 0 0 0-.153 1.9c0 .28 0 .648-.014.979a2 2 0 0 1-.13.817 2 2 0 0 1-.123.13l-.017.015a.3.3 0 0 1-.092.066 1 1 0 0 1-.219-.12 4 4 0 0 0-.931-.454l-.037-.013a5 5 0 0 0-.522-.14 1.03 1.03 0 0 0-.618.016 8 8 0 0 0-.547-.353 3.4 3.4 0 0 1-1.182-1.032 3.21 3.21 0 0 0-2.17-1.475 4.3 4.3 0 0 0-.777-.105 5 5 0 0 0 .298-.513M6.53 37.008q.47-.53.906-1.097.1-.112.198-.225l.025-.001.004-.001h.005a3.8 3.8 0 0 1 1.029.095 2.74 2.74 0 0 1 1.853 1.262 3.9 3.9 0 0 0 1.339 1.184c.169.102.345.208.534.345l-.014.176v.009l-.001.003q-.01.099-.011.147l-.002.04c-.088.125-.797.074-1.101.051a9 9 0 0 0-.483-.026q-.15-.003-.288.007l-.05.01-.007.001a15 15 0 0 1-1.569.226l-.128.004a3.8 3.8 0 0 1-.84-.077 4 4 0 0 0-.46-.062 3 3 0 0 0-.832.063l-.02.004a2 2 0 0 0-.16.039l-.005.001-.003.001c-.736.216-.802.761-.861 1.246a2.8 2.8 0 0 1-.12.604q-.014-.113-.032-.225-.005-.043-.012-.086l-.007-.055q-.05-.328-.08-.636a5 5 0 0 1-.03-.4 6.3 6.3 0 0 1 1.223-2.627M4.65 52.064c.013-.088.023-.18.04-.266a10 10 0 0 1 .104-.43l.05-.206a8.9 8.9 0 0 0 .36-2.375 45 45 0 0 1 .112-5.122c.056-.206.093-.416.13-.626a7 7 0 0 0 .108-1.024l-.007-.171a1 1 0 0 0 .122-.137l.016-.02.01-.015a2.34 2.34 0 0 0 .39-1.179c.06-.498.09-.749.63-.857h.003a2.5 2.5 0 0 1 .81-.05c.106.011.207.029.316.048a4.5 4.5 0 0 0 .853.084q.11-.002.234-.006c.46-.041.92-.103 1.36-.183l.3-.057.017-.002q.088-.003.195-.002c.136.004.293.015.455.027a6 6 0 0 0 .911.022 1.3 1.3 0 0 0 .364-.079q.134.223.253.454a7.7 7.7 0 0 1 .685 1.956 3 3 0 0 1 .005.174 12 12 0 0 1-.144 1.432l-.002.013a9.6 9.6 0 0 0-.147 1.8 2 2 0 0 0 .034.257 31 31 0 0 1 .023 3.204q-.02.297-.049.593l-.001.02-.003.03v.002a67 67 0 0 1-.115 1.498c-.272 3.071-.52 3.622-.614 3.716a.4.4 0 0 1-.228.113c-.23.052-.437.132-.623.583a8 8 0 0 0-.123.334c-.07.2-.143.395-.222.574a4 4 0 0 1-.546.786.8.8 0 0 1-.614.144c-2.277-.334-3.176-2.507-3.66-3.675a4.4 4.4 0 0 0-.29-.627.83.83 0 0 0-.807-.475q-.07-.001-.146.004-.023 0-.045.002a4 4 0 0 1-.532 0c.008-.095.013-.194.028-.286M9.562 69.32a2.9 2.9 0 0 1-.248 1.366l-.001.002a.83.83 0 0 0-.121.43v.004a4.4 4.4 0 0 0 .128.956 10 10 0 0 1 .116.64q-.755-.016-1.437-.038l-.119-.005a67 67 0 0 1-5.007-.344q.018-.153.045-.335l.003-.02c.054-.358.13-.784.21-1.228l.13-.734a22 22 0 0 0 .29-2.15c.071-1.115.206-2.175.339-3.105q.067-.465.13-.884c.113-.756.211-1.408.253-1.94q.014-.16.027-.36v-.004q.013-.196.026-.425l.005-.076.022-.415.005-.1.023-.452.002-.06.024-.525.005-.116.02-.504.008-.18.017-.453.01-.285q.008-.185.013-.372l.01-.316q.008-.173.012-.346l.012-.39.008-.26.012-.44.006-.212.01-.45.005-.185.01-.443.003-.162.008-.457.002-.113.005-.407.001-.132.003-.366v-.078a5 5 0 0 0 .59-.001q.115-.003.189-.006c.177.002.234.045.363.244v.001l.002.003a5 5 0 0 1 .249.547c.48 1.161 1.476 3.568 3.988 3.969l.058.008a1.3 1.3 0 0 0 .36.01 1.2 1.2 0 0 0 .255-.054c.011.517.038 1.15.063 1.748.033.79.064 1.537.054 1.83l-.002.039a7.3 7.3 0 0 1-.306 1.304 8 8 0 0 0-.23.895 11.6 11.6 0 0 0-.296 2.134c.028.507-.184 2.275-.298 3.224Zm5.73 3.435-.183.003a92 92 0 0 1-1.067.006c-.31 0-.613 0-.9-.002l-.784-.005-.195-.002-.493-.004-.072-.001-.346-.004c-.4-.004-.841-.01-1.311-.018-.03-.25-.081-.503-.13-.75a2.25 2.25 0 0 1-.076-1.023l.014-.025.001-.002a3.34 3.34 0 0 0 .31-1.595l.063-.527a32 32 0 0 0 .3-3.286 11 11 0 0 1 .264-1.935l.002-.014.001-.005.002-.005.004-.016v-.004l.001-.004.002-.007.002-.007v-.005l.002-.005v-.002l.002-.006.001-.007v-.001l.001-.003.004-.014a8 8 0 0 1 .219-.846 7.3 7.3 0 0 0 .325-1.416l.002-.042v-.001c.012-.315-.019-1.044-.054-1.883-.029-.71-.06-1.468-.068-2.018a2.7 2.7 0 0 0 .574-.857 4.2 4.2 0 0 0 .36-.941c.102-.25.151-.26.27-.288a.86.86 0 0 0 .471-.247l.009-.008c.207-.218.433-.798.681-3.282q.035-.34.069-.731l.02-.18a8.8 8.8 0 0 0 1.948 3.014l.006.006a8 8 0 0 0 1.83 1.261 3.9 3.9 0 0 0 1.747.503c-.25 1.769-.62 5.138-.587 5.835l.012.233c.05.902.185 3.299-.705 4.25-1.494 1.6-2.329 3.862-2.549 6.913Zm12.212-.058a40 40 0 0 1-5.899-.253 18 18 0 0 0-2.19.109c-.569.047-1.188.098-1.828.132-.586.031-1.187.048-1.788.06.217-2.906 1.002-5.059 2.406-6.56 1.037-1.109.898-3.57.839-4.62l-.012-.23c-.03-.643.352-4.2.619-5.986a.7.7 0 0 0 .096-.08 7.3 7.3 0 0 0 .888-1.753c.096 1.493.057 3.648.022 5.615a45 45 0 0 0 .035 4.502 11 11 0 0 1 .017 2.188 1.7 1.7 0 0 0 .019.697 1.47 1.47 0 0 0 .72 1.268 17.6 17.6 0 0 0 5.245 1.31h.05a15 15 0 0 0 1.542 3.573c-.26.01-.525.015-.781.028m8.75-1.258c.09.417.194.914.254 1.306-.432-.012-.857-.014-1.292-.036a51 51 0 0 0-.839-.037l-.077-.003q-.407-.015-.929-.029l-.052-.001a79 79 0 0 0-4.15-.002q-.162.002-.325.007a14.6 14.6 0 0 1-1.653-3.801l.003-.038q.006-.092.006-.45c0-.42-.006-1.102-.014-2.007-.007-.845-.015-1.73-.016-2.335.062-.258.587-.664 1.095-1.057a13 13 0 0 0 1.195-1.01c.847-.846.93-2.37.24-4.194l-.086-.219q-.535-1.526-1.004-3.084c.2-.252.405-.493.585-.706.217-.255.404-.475.512-.634a6 6 0 0 1 .543-.699 1.35 1.35 0 0 1 .632-.46.3.3 0 0 1 .063-.008c.005-.014.055 0 .102.026h.004a.45.45 0 0 1 .144.147c0 .01.002.002.002.003.158.237.399.72.678 1.281.287.578.565 1.126.836 1.62-.226 1.26-.71 4.74-.26 5.856.288.712 1.483 2.919 2.443 4.692.494.913 1.004 1.856 1.049 1.973a1.4 1.4 0 0 0 .313.452 2.8 2.8 0 0 1 .403.548c-.023.06-.051.147-.091.269-.044.135-.102.316-.178.56-.105.333-.25.791-.28.858-.076.127-.063.24.144 1.212m2.075 1.351q-.17 0-.337-.003c-.32-.003-.65-.02-.976-.027-.058-.416-.17-.945-.272-1.421-.074-.35-.166-.781-.175-.916.046-.11.122-.347.296-.9.065-.208.145-.462.203-.64l.056-.164c.098-.04.314-.106.493-.16l.025-.007a6.4 6.4 0 0 0 1.277-.482 54 54 0 0 0 1.143 4.714c-.572.005-1.142.01-1.733.006m2.598-.009-.34.001a53 53 0 0 1-1.247-5.172 23 23 0 0 0 2.262-3.894 4 4 0 0 0 .368.2 7.6 7.6 0 0 0 .005 1.712 18.7 18.7 0 0 0 1.897 5.311 11 11 0 0 1 .72 1.377 21 21 0 0 1-3.665.465m5.685-1.029-.2.06q-.183.058-.366.118l-.161.051c-.165.054-.332.108-.477.153l-.058.018-.134.04-.06.015-.051.012a11 11 0 0 0-.802-1.53 18.2 18.2 0 0 1-1.834-5.137 7 7 0 0 1-.016-1.448 4 4 0 0 0 .566.115c.039.173.08.397.125.646.213 1.17.536 2.936 1.355 3.798l.004.006a16.2 16.2 0 0 1 2.383 3.002c-.085.023-.181.054-.274.081\"/><path fill=\"#a5a9b5\" d=\"M32.129 3.78c2.683.783 2.162 1.54 3.924 2.225 1.863.724 1.63 1.762 1.935 3.11a9.3 9.3 0 0 0 1.23 2.569c1.085.47 3.834-1.374 6.909-1.736a3.29 3.29 0 0 1 2.46-2.424c3.018-.503 4.372-.107 5.606-.289 4.452-.657 5.468-.919 6.619-.362 2.242 1.085 2.048 3.167 5.1 4.811 3.291 1.772 5.28 2.64 6.764 3.979a16.2 16.2 0 0 1 4.05 5.317 29.6 29.6 0 0 1 1.665 6.366 57 57 0 0 0 2.604 8.356 18.2 18.2 0 0 0 3.074 5.763 29.4 29.4 0 0 1 3.002 7.294c.374.422.37.382.856.953a16 16 0 0 0 2.327 2.881c.28.226.1 1.338.157 2.159.11 1.59-.726 3.248-1.278 5.208a20.7 20.7 0 0 0-.772 5.619c.042 1.202.711 1.282.893 2.315a9 9 0 0 1-.12 4.147 6.8 6.8 0 0 1-3.4 3.376c-1.592.556-3.871-.45-6.705 0a26.6 26.6 0 0 1-4.726.651c-2.713-.147-4.425-1.422-6.776-1.422-3.406 0-4.364-1.616-8.005-1.954-1.03-.095-1.555-1.176-2.34-1.712a9.75 9.75 0 0 1-4.364-5.86c-.877-3.288-.004-5.812 1.375-8.632a8.35 8.35 0 0 1 2.7-3.4c-.82-.29-1.76-.507-2.098-1.568a8.2 8.2 0 0 1-3.424-1.977 58 58 0 0 1-5.907.338c-2.122 0-2.58-1.11-2.918-1.037-1.88.402-6.945.868-9.332-1.134-.182-.152-.936-.723-1.83-1.547-.728-.672-2.608 1.29-2.848.173-.482-2.243-.338-5.956 2.146-6.92a6.67 6.67 0 0 1 3.207-.363c1.132.068.548 1.117 4.702 1.375 4.654.29 10.562-2.412 11.117-3.448a25 25 0 0 0-2.966-5.426c-2.122-.603-1.64-2.315-2.46-3.979a9.7 9.7 0 0 0-2.749-3.424c-.795-.706-.965-1.206-2.29-1.182-.058.549-.296 1.881-1.219 1.809a.906.906 0 0 1-.976.506 2.056 2.056 0 0 1-2.069-1.583 3.28 3.28 0 0 1-.535-2.492c.032-.84-.397-1.315-.507-2.037-.26-1.71-.448-3.501-.868-5.408-.467-2.125-.506-2.478-.958-3.22-.489.688-2.062 2.08-3.274 1.791-.872-.208-1.15-.67-1.646-1.302a3.35 3.35 0 0 1-1.12-2.37 2.404 2.404 0 0 1 .723-3.092c2.061-1.664 4.238-2.11 5.335-1.79Z\"/><path fill=\"#fff\" d=\"M58.732 64.801a12.06 12.06 0 0 0-6.529 2.17c-3.58 2.08-3.562 4.142-3.526 4.793s.27.525.47-.036a6.88 6.88 0 0 1 3.219-3.038 20.7 20.7 0 0 1 5.444-1.23c.65 0 .615-1.773.922-2.659m-3.424 5.039c.065.062.124.13.19.191-.506.254-1.027.486-1.554.687q.7-.408 1.364-.878\"/><path fill=\"#666880\" d=\"m54.799 21.686.09.493a5.16 5.16 0 0 0-2.353 1.066 6.8 6.8 0 0 1-1.805.997 5.94 5.94 0 0 1-4.038-.198l.193-.461a5.43 5.43 0 0 0 3.69.184 6.3 6.3 0 0 0 1.67-.93 5.66 5.66 0 0 1 2.553-1.15Zm6.45 20.763a8.2 8.2 0 0 0-1.512-1.156 30 30 0 0 1-2.952-2.04 18.4 18.4 0 0 0-3.549-2.317l-.162.473a19 19 0 0 1 3.412 2.246 30 30 0 0 0 3.013 2.078 8 8 0 0 1 1.417 1.089A6.84 6.84 0 0 0 65.986 45q.169 0 .345-.006l-.018-.5a6.36 6.36 0 0 1-5.064-2.045m-1.462-3.146a61 61 0 0 0-6.053-4.89l-.289.407a60 60 0 0 1 6.004 4.851Zm-4.824-18.728a5.1 5.1 0 0 0-2.437.915 8.7 8.7 0 0 1-3.656 1.546l.084.493a9.2 9.2 0 0 0 3.864-1.634 4.6 4.6 0 0 1 2.196-.823ZM46.33 40.654a6.62 6.62 0 0 1 4.715 2.021l.361-.346a7.13 7.13 0 0 0-5.073-2.175Zm44.33 14.08a9.6 9.6 0 0 1-.76 3.643c-.18.53-.367 1.078-.528 1.65q-.21.767-.365 1.552c-.014.068-.023.137-.035.205q-.117.619-.197 1.243a20 20 0 0 0-.165 2.552 1.95 1.95 0 0 0 .412 1.174 2.66 2.66 0 0 1 .477 1.098 9.3 9.3 0 0 1-.126 4.254 7.06 7.06 0 0 1-3.538 3.54 6.9 6.9 0 0 1-2.982.065 13.6 13.6 0 0 0-3.786-.046 27 27 0 0 1-4.753.654 13.6 13.6 0 0 1-3.577-.767 10.4 10.4 0 0 0-3.21-.656 10.1 10.1 0 0 1-4.175-.933 12.6 12.6 0 0 0-3.855-1.02 2.8 2.8 0 0 1-1.735-1.091 4.8 4.8 0 0 0-.721-.665 10 10 0 0 1-1.13-.812 17.3 17.3 0 0 1-2.858 1.177 2 2 0 0 1-.331.035c-.19 0-.384-.049-.437-.247-.042-.158.02-.39.554-.587a18 18 0 0 0 2.104-1.277 9.4 9.4 0 0 1-.85-1.078 20 20 0 0 0-1.64.527 6.66 6.66 0 0 0-3.086 2.92c-.085.249-.247.61-.53.61l-.05-.005c-.326-.047-.351-.5-.36-.672-.13-2.323 1.913-4.013 3.65-5.021.275-.193.56-.37.849-.54a10 10 0 0 1-.35-1.032c-.856-3.211-.103-5.75 1.39-8.805a8.6 8.6 0 0 1 2.41-3.204 2.53 2.53 0 0 1-1.775-1.451 8.5 8.5 0 0 1-3.319-1.92 59 59 0 0 1-5.818.327 3.9 3.9 0 0 1-2.678-.885 1.3 1.3 0 0 0-.224-.157c-1.766.385-6.993.923-9.51-1.188l-.174-.14a29 29 0 0 1-1.664-1.414c-.22-.203-.75.032-1.224.247l-.021.01a11 11 0 0 1-.36.156l-.025.01a3 3 0 0 1-.318.11l-.034.01a1.2 1.2 0 0 1-.305.047l-.01-.002a.66.66 0 0 1-.29-.064.6.6 0 0 1-.158-.137c-.017-.02-.041-.028-.056-.05a.8.8 0 0 1-.122-.295 10 10 0 0 1-.146-.886q-.007-.063-.012-.127-.045-.396-.061-.828l-.002-.02-.008-.311.006.001a9.4 9.4 0 0 1 .11-1.492q.014-.091.03-.182a4.11 4.11 0 0 1 2.383-3.362 7 7 0 0 1 3.33-.377 1.57 1.57 0 0 1 .937.393c.435.324 1.094.816 3.748.98 4.51.282 10.043-2.258 10.82-3.227a25 25 0 0 0-2.839-5.182c-1.52-.466-1.774-1.499-2.042-2.59a7 7 0 0 0-.488-1.494 10.2 10.2 0 0 0-2.68-3.337l-.01-.01a10 10 0 0 1-.421-.4l-.037-.035a7 7 0 0 0-.22-.21q-.048-.042-.094-.08a2 2 0 0 0-.207-.15q-.038-.024-.077-.048a1.8 1.8 0 0 0-.849-.195 4 4 0 0 1-.157.67l-.045.132c-.016.04-.027.088-.043.126a1.3 1.3 0 0 1-.211.38v.002a1.3 1.3 0 0 1-.122.149 1 1 0 0 1-.17.129 1 1 0 0 1-.12.09 1 1 0 0 1-.426.13 1.5 1.5 0 0 1-.524.429q-.008.005-.018.01a1 1 0 0 1-.227.057c-.02.003-.04.012-.06.015a1.1 1.1 0 0 1-.336-.009 2 2 0 0 1-.372-.02l-.037-.007a2 2 0 0 1-.312-.074l-.08-.03a2 2 0 0 1-.25-.107l-.094-.05c-.04-.024-.083-.042-.121-.067-.025-.015-.042-.038-.066-.053a2 2 0 0 1-.225-.181 2 2 0 0 1-.358-.399l-.032-.045a2 2 0 0 1-.154-.225l-.116-.239.028-.012a2 2 0 0 1-.064-.201 2.84 2.84 0 0 1-.497-1.147q-.029-.105-.05-.21c-.005-.034-.021-.066-.024-.1-.018-.113-.018-.227-.024-.34-.005-.07-.015-.14-.015-.212a3.5 3.5 0 0 1 .054-.616c.002-.01 0-.022.003-.032a2.7 2.7 0 0 0-.254-1.1 4 4 0 0 1-.254-.854 99 99 0 0 1-.205-1.437c-.176-1.27-.358-2.583-.66-3.954l-.146-.668a9 9 0 0 0-.605-2.161 5.5 5.5 0 0 1-2.124 1.482l-.001.015-.164.05c-.018.005-.037.003-.055.008a2.3 2.3 0 0 1-.52.077l-.01.002a2 2 0 0 1-.414-.043l-.004-.001h-.003c-.013-.004-.021-.01-.034-.012a2.6 2.6 0 0 1-.464-.164 2 2 0 0 1-.253-.145q-.1-.059-.195-.126-.055-.046-.109-.095a2.5 2.5 0 0 1-.516-.577v-.002q-.037-.043-.072-.088l-.141-.183a3.4 3.4 0 0 1-.529-.611 3 3 0 0 1-.205-.34c-.03-.055-.067-.105-.094-.162a3.3 3.3 0 0 1-.347-1.35 2.6 2.6 0 0 1-.16-.403l-.033-.005-.039-.17a2.6 2.6 0 0 1-.045-.785v-.01a3 3 0 0 1 .051-.33q.026-.124.06-.245l.03-.086a2.63 2.63 0 0 1 .964-1.322c2.15-1.736 4.387-2.165 5.55-1.828a5.5 5.5 0 0 1 2.588 1.368 3.8 3.8 0 0 0 1.357.864 2.72 2.72 0 0 1 1.96 2.584c.036.224.073.459.129.705a9 9 0 0 0 1.148 2.417 5.7 5.7 0 0 0 2.563-.623 19 19 0 0 1 3.986-1.134 3.51 3.51 0 0 1 2.602-2.44 19.4 19.4 0 0 1 4.135-.258 8.3 8.3 0 0 0 1.49-.036l1.557-.233c3.175-.48 4.134-.626 5.208-.106a5.64 5.64 0 0 1 2.228 2.118 7.67 7.67 0 0 0 2.881 2.698c.769.413 1.465.778 2.1 1.11a22.3 22.3 0 0 1 4.713 2.903 16.3 16.3 0 0 1 4.11 5.395 29.8 29.8 0 0 1 1.685 6.438 57 57 0 0 0 2.59 8.299 17.9 17.9 0 0 0 3.038 5.7 29.6 29.6 0 0 1 3.031 7.327l.009.01c.12.134.197.216.271.295.096.103.186.199.35.387l.191.222a16 16 0 0 0 2.31 2.865c.263.21.249.753.23 1.441-.008.3-.016.608.002.878ZM27.106 7.264a.23.23 0 0 0 .008-.24c-.076-.132-.349-.287-.888-.347a2 2 0 0 0-.15.485q-.02.1-.03.2a2 2 0 0 0-.001.217 2 2 0 0 0 .019.272 1.28 1.28 0 0 0 1.042-.587m.407 2.368a1.48 1.48 0 0 0-1.151-.68 3.1 3.1 0 0 0 .5 1.313 3 3 0 0 0 .199.253c.332-.322.523-.754.452-.886m1.946 2.454a1.15 1.15 0 0 0-.686-.95 1.32 1.32 0 0 0-1.004.226q.04.05.083.096a2 2 0 0 0 .358.323q.049.036.102.067a2 2 0 0 0 .579.243 1.5 1.5 0 0 0 .505.008c.02-.003.042-.01.063-.013m2.319-1.529a12.8 12.8 0 0 0-2.345-2.16 2.4 2.4 0 0 1-.516-2.752c.402-.804.96-1.62 2.063-1.572a7.8 7.8 0 0 1 3.305 1.123l-.057.093a1.4 1.4 0 0 1 .273.035l-.052-.046a5.05 5.05 0 0 0-2.39-1.257c-1.079-.313-3.176.185-5.11 1.745a2.2 2.2 0 0 0-.451.445 1.46 1.46 0 0 1 1.05.564.75.75 0 0 1-.006.734 1.79 1.79 0 0 1-1.342.823q.024.066.055.132a1.97 1.97 0 0 1 1.69.918c.243.448-.135 1.106-.554 1.508l.073.09a1.83 1.83 0 0 1 1.461-.318 1.66 1.66 0 0 1 1.006 1.285 5.14 5.14 0 0 0 1.847-1.39m.196-4.08a3.8 3.8 0 0 0 .564-.541 1.46 1.46 0 0 1 1.034-.572 7.3 7.3 0 0 0-2.627-.792l-.06-.001c-.719 0-1.13.517-1.518 1.293a1.89 1.89 0 0 0 .386 2.151 13 13 0 0 1 1.914 1.656c-.264-1.102-.486-2.572.307-3.193Zm3.19 15.845c-.026-.08-.21-.193-.498-.24v.024c.01.088.014.176.03.263.015.085.04.168.062.251a3 3 0 0 0 .1.312q.049.123.11.241.043.081.09.16a.5.5 0 0 0 .087-.115 1.3 1.3 0 0 0 .018-.896Zm1.01 2.515a.57.57 0 0 0-.17-.405.43.43 0 0 0-.485-.144l.009.012a1.8 1.8 0 0 0 .544.489q.05.026.102.048m1.463.038a.26.26 0 0 0-.24-.042.53.53 0 0 0-.268.203l.049.001a.74.74 0 0 0 .332-.07.6.6 0 0 0 .127-.092m1.34-1.808c-.302-.144-.628-.27-.994-.413-.28-.109-.585-.227-.925-.37a13 13 0 0 1-2.364-1.134l-.001.068-.001.01a3 3 0 0 0-.03.35 1.09 1.09 0 0 1 .978.593 1.8 1.8 0 0 1-.052 1.278.94.94 0 0 1-.315.352l.012.036a1.3 1.3 0 0 1 .394-.07.94.94 0 0 1 .672.305 1.07 1.07 0 0 1 .322.744 1.03 1.03 0 0 1 .587-.464.76.76 0 0 1 .71.15 1.3 1.3 0 0 1 .567-.612 1.6 1.6 0 0 1 .265-.087q.026-.072.049-.143.017-.06.031-.116.035-.132.057-.25c.013-.07.026-.14.034-.197Zm5.736 4.885a5.7 5.7 0 0 1-.08-2.39 3.3 3.3 0 0 0-.744-.569 10.6 10.6 0 0 0-2.463-1.288c.086.084.167.166.27.257.089.07.167.151.253.224a10.3 10.3 0 0 1 2.557 3.28 5 5 0 0 1 .207.486m1.724 3.228a6.5 6.5 0 0 0-.12-.986 2.9 2.9 0 0 1-1.432-1.703q.081.293.146.567.075.311.157.593l.026.09q.04.13.089.251l.021.057a3 3 0 0 0 .117.247l.019.035a2 2 0 0 0 .15.23l.024.03a2 2 0 0 0 .188.203q.02.019.042.036a2 2 0 0 0 .222.168c.028.018.061.033.091.05a2 2 0 0 0 .241.125Zm-.299-1.68a7 7 0 0 0-.26-.677 9 9 0 0 1-.579-1.755 6 6 0 0 0-.245-.84 4.04 4.04 0 0 0 1.084 3.273Zm3.737 7.24c.117.004.247.01.401.025a27 27 0 0 0-2.443-4.215c-.333-.509-.64-.978-.896-1.39l.005.197q-.002.023-.003.044l.005.007a25.4 25.4 0 0 1 2.93 5.331Zm-21.237 6.323a1.58 1.58 0 0 0 1.206-.625.94.94 0 0 0-.607-1.373 6 6 0 0 0-.393.97l-.003.014a6 6 0 0 0-.196.95zm1.06 2.382a1.8 1.8 0 0 0-1.112-.61l.001.022a10 10 0 0 0 .192 1.424v.002c.012.054.034.121.073.14.009.006.029 0 .04.003a1.9 1.9 0 0 0 .775-.235l.095-.043.015-.006.033-.016a.94.94 0 0 0-.112-.68Zm23.36 19.612a9 9 0 0 0 .307.919 12.2 12.2 0 0 1 2.605-1.021 6.04 6.04 0 0 1-2.166-3.371c-.285-1.38.102-3.17 1.152-5.326a9.3 9.3 0 0 1 1.919-2.645 1 1 0 0 1-.078-.117 8.1 8.1 0 0 0-2.376 3.092c-1.485 3.038-2.182 5.392-1.362 8.469Zm6.937-9.645.01-.014a2.2 2.2 0 0 0-.62-.23c-2.792 3.298-2.256 6.122-1.892 7.193a2.85 2.85 0 0 0 1.337 1.806l.037.009h.005l.008.003c.084.017.128.01.23-.354l.041-.153c.097-.378.245-.948.734-1.04.153-.028.351-.062.582-.1.347-.06.771-.13 1.237-.218a.93.93 0 0 0 .608-.332 1.2 1.2 0 0 1 .536-.366c.129-.043.159-.103.24-.368a2.4 2.4 0 0 1 .44-.879 8 8 0 0 1 .067-.856 1.6 1.6 0 0 0-.064-1.024l-.045-.064c-.39-.553-.428-.594-.633-.714l-.037-.021-.063-.038h-.02c-1.218-.038-1.93-.277-2.303-.772a1.06 1.06 0 0 1-.206-.532v-.001a1.9 1.9 0 0 1 .075-.67l.017-.066q-.079-.064-.16-.12Zm.814.284-.025.103a1.6 1.6 0 0 0-.067.457.57.57 0 0 0 .113.322c.276.368.911.55 2 .576l.066.002.17.1a1.4 1.4 0 0 1 .362.267 5 5 0 0 1 .404.525 4.3 4.3 0 0 1 2.168.973 17.4 17.4 0 0 0 5.188 1.536 1.83 1.83 0 0 1 1.474 1.148 2.26 2.26 0 0 0 1.994 1.347 4.3 4.3 0 0 1 1.87.48q.163-.24.308-.499a21.5 21.5 0 0 0 1.813-6.205 5.06 5.06 0 0 0-1.546-4.095 6.4 6.4 0 0 1-.705-.962 50 50 0 0 1-.452-.883 13 13 0 0 0-1.766-2.95c-.608-.511-1.546-.38-2.74-.412a5.3 5.3 0 0 1-1.021-.11 2.2 2.2 0 0 0-.928 0 3.9 3.9 0 0 0-.994.287 4.2 4.2 0 0 1-1.673.366 2.07 2.07 0 0 0-1.996 1.03 2 2 0 0 1-.376.372l.005.134a4.3 4.3 0 0 1-.11 1.351 5.5 5.5 0 0 1-1.36 2.818 2.2 2.2 0 0 1-.948.399.95.95 0 0 0-.696.373 7 7 0 0 1-.355.438q-.121.143-.256.306l.04.055.022.02.02.06a.5.5 0 0 1-.003.271m4.304-7.654c-.324.154-.547.318-.587.486a3 3 0 0 0-.033.16 2.4 2.4 0 0 1 .62-.646M76.86 64.855a7 7 0 0 0-.064.493v.005a2.05 2.05 0 0 0 .846 1.57 3.4 3.4 0 0 0 3.142.585c2.656-.738 3.766-1.85 3.766-3.81q0-.118-.006-.243c-.093-2.089-3.125-7.114-4.728-9.34-.419-.583-.841-1.23-1.29-1.916a21.5 21.5 0 0 0-2.8-3.726c-1.342-1.237-1.782-1.526-3.013-1.526a7.4 7.4 0 0 1-1.285-.133 4.4 4.4 0 0 0-2.192.051c-.343.099-.77.2-1.227.31-.444.106-.995.238-1.527.389a2.4 2.4 0 0 1 .358.006 3.75 3.75 0 0 0 1.472-.33 4.4 4.4 0 0 1 1.11-.32 2.7 2.7 0 0 1 1.096.006 4.8 4.8 0 0 0 .937.1c1.25.035 2.278-.118 3.047.53a12.7 12.7 0 0 1 1.892 3.107c.165.328.316.63.446.872a6 6 0 0 0 .65.881 5.55 5.55 0 0 1 1.656 4.479 22 22 0 0 1-1.866 6.366 7 7 0 0 1-.423.675 1.8 1.8 0 0 1 .003.92Zm-18.07-9.76a1.7 1.7 0 0 1-.366-.14 1.3 1.3 0 0 1-.383-.273 1 1 0 0 1-.111-.116.94.94 0 0 1-.178-.367 1 1 0 0 1-.022-.096 2 2 0 0 1-.445-.173l-.01-.005a8.8 8.8 0 0 0-1.868 2.552c-1 2.053-1.374 3.736-1.113 5a5.58 5.58 0 0 0 2.238 3.314c.135-.025.273-.032.409-.053.349-.063.702-.106 1.057-.138.15-.015.298-.046.447-.058A3.77 3.77 0 0 1 57 62.499c-.38-1.12-.94-4.028 1.788-7.404Zm-1 12.116c.242-.001.382-.857.466-1.367.043-.264.087-.533.143-.778a11.77 11.77 0 0 0-6.051 2.11c-1.6.93-3.458 2.44-3.425 4.448a7.18 7.18 0 0 1 3.34-3.162 21 21 0 0 1 5.526-1.251Zm-2.29 2.82c-.067-.06-.126-.129-.19-.191q-.663.469-1.365.878a17 17 0 0 0 1.555-.687m33.107-3.002a2.46 2.46 0 0 1-.495-1.441 21 21 0 0 1 .14-2.335 8.1 8.1 0 0 1-.39-3.173 9.6 9.6 0 0 0-.094-1.865c-.154-.747-.268-2.247-.37-3.571-.048-.628-.093-1.226-.14-1.7a378 378 0 0 1-.38-4.03l-.048-.09a29 29 0 0 0-2.975-7.234 18.3 18.3 0 0 1-3.097-5.812 57 57 0 0 1-2.61-8.376 29.5 29.5 0 0 0-1.654-6.332 15.85 15.85 0 0 0-3.98-5.218 22 22 0 0 0-4.614-2.835 180 180 0 0 1-2.105-1.113 8.2 8.2 0 0 1-3.053-2.849A5.17 5.17 0 0 0 60.703 7.1c-.933-.452-1.775-.326-4.916.15l-1.558.233a9 9 0 0 1-1.577.041 18.7 18.7 0 0 0-4.025.248 3.01 3.01 0 0 0-2.257 2.236l-.041.169h-.002a6.6 6.6 0 0 0-.243 1.47 1.5 1.5 0 0 1-.223.706l-.048.079-.088.028c-.674.216-.974.906-1.24 1.515a6 6 0 0 1-.244.522 6 6 0 0 0 .682-.779 3 3 0 0 0 .19-.375 1.07 1.07 0 0 1 .505-.622l.21.453c-.113.054-.163.158-.258.37a3 3 0 0 1-.235.456 6.4 6.4 0 0 1-1.928 1.751.5.5 0 0 1-.1.139l.037.005a8.8 8.8 0 0 0 2.003-1.15 4.5 4.5 0 0 0 1.314-1.943l.473.163a5 5 0 0 1-1.472 2.169 9.4 9.4 0 0 1-1.691 1.03l.048.002a15.6 15.6 0 0 0 2.213-1.288 2.28 2.28 0 0 0 .91-1.507l.494.072a2.79 2.79 0 0 1-1.114 1.843 16 16 0 0 1-1.927 1.153.89.89 0 0 0 .865-.185c.183-.125.351-.225.525-.33.754-.449 1.608-.96 1.788-1.912a2.12 2.12 0 0 0-.42-1.367 3 3 0 0 1-.212-.4 3.67 3.67 0 0 1 .088-2.107c.084-.207.14-.328.188-.425l-.014-.003.153-.297c.39-.759 1.249-.557 1.876-.41a2.8 2.8 0 0 0 .648.105 25 25 0 0 1 2.508-.132l.379.016c1 .046 2.86.131 3.958.056l1.601-.107-1.493.59a2 2 0 0 0-.265.126 1.5 1.5 0 0 1-.61.19 15 15 0 0 1-1.855-.145c-.822-.023-1.59-.045-2.23-.01a2.2 2.2 0 0 0-.707.153 3.6 3.6 0 0 1-.768.195 15.6 15.6 0 0 1-2.67-.232l-.033.066c-.05.101-.107.216-.199.44a3.16 3.16 0 0 0-.079 1.782c.025.058.091.168.166.296a2.54 2.54 0 0 1 .481 1.712 3.57 3.57 0 0 1-2.022 2.25c-.168.1-.33.196-.477.294a1.32 1.32 0 0 1-.892.335 1.4 1.4 0 0 1-.892-.318c-.617-.019-.896-.049-.964-.304l-.002-.01c-.263-.052-.445-.14-.476-.335-.037-.226.175-.358.317-.428-.041-.176.105-.304.193-.382a3.9 3.9 0 0 0 .978-1.43 2.87 2.87 0 0 1 1.45-1.759 1 1 0 0 0 .108-.395 7 7 0 0 1 .21-1.363 19 19 0 0 0-3.678 1.066c-1.311.486-2.348.87-2.998.59l-.066-.03-.04-.059a9.5 9.5 0 0 1-1.264-2.637 11 11 0 0 1-.14-.753 2.22 2.22 0 0 0-1.646-2.197 4.5 4.5 0 0 1-.767-.382l.028.121a.78.78 0 0 1-.508-.077 1.2 1.2 0 0 0-.694-.099c-.787.097-.874.197-1.107.464a4.2 4.2 0 0 1-.632.606c-.703.552-.186 2.491.034 3.32l.073.275-.032.008a7.3 7.3 0 0 1 .81 2.57l.145.666c.307 1.391.49 2.714.667 3.994q.099.725.204 1.43a3.5 3.5 0 0 0 .227.75 5 5 0 0 1 .207.619 12.4 12.4 0 0 0 2.623 1.314c.348.147.648.264.924.371.393.152.74.288 1.07.448l.002-.024a1.43 1.43 0 0 0 .824-.23 3.1 3.1 0 0 1 2.14-.347c.414.057.8.118 1.172.177a13.4 13.4 0 0 0 5.472.024 7.9 7.9 0 0 0 2.468-1.09 11.7 11.7 0 0 1 1.779-.906 10.1 10.1 0 0 1 3.993-1.281 18.3 18.3 0 0 0 6.65-.88c.042-.012 1.733-.39 2.19-1.473a2.08 2.08 0 0 0-.346-1.92l.424-.265a2.54 2.54 0 0 1 .383 2.382 3.83 3.83 0 0 1-2.52 1.757 18.4 18.4 0 0 1-6.768.897 9.7 9.7 0 0 0-3.794 1.233 12 12 0 0 0-1.74.888 8.4 8.4 0 0 1-2.622 1.148 14 14 0 0 1-5.647-.02c-.369-.058-.752-.12-1.163-.176a2.6 2.6 0 0 0-1.842.297l-.025.014a11 11 0 0 1 2.392.844l.105-.352c.313.093.74.198 1.229.318 1.86.457 4.408 1.082 5.215 2.132a6.6 6.6 0 0 1 .746 1.541 13.22 13.22 0 0 0 5.037 6.607l-.29.407a13.66 13.66 0 0 1-5.212-6.83 6.3 6.3 0 0 0-.677-1.42c-.7-.911-3.251-1.537-4.938-1.951q-.361-.088-.67-.166a11 11 0 0 1 .958.602 3.2 3.2 0 0 1 1.141 1.038l.011-.03a9.76 9.76 0 0 1 3.78 3.515c.142.202.31.463.501.757a12.1 12.1 0 0 0 2.685 3.275l-.27.42a12.2 12.2 0 0 1-2.835-3.423 24 24 0 0 0-.49-.742 10.6 10.6 0 0 0-3.082-3.115c.07.216.126.442.185.68a8.6 8.6 0 0 0 .55 1.668 7 7 0 0 1 .479 1.511l.076-.04c.281.538.806 1.34 1.361 2.19a24 24 0 0 1 2.58 4.557 6.5 6.5 0 0 1 3.94 1.845 17.5 17.5 0 0 1 1.554 2.464 10.2 10.2 0 0 0 1.205 1.884l-.36.348a10.3 10.3 0 0 1-1.282-1.99 17 17 0 0 0-1.505-2.391c-1.045-1.29-3.456-1.73-4.565-1.754-.977 1.2-6.739 3.718-11.243 3.437-.217-.013-.4-.033-.594-.05a9.1 9.1 0 0 1-2.356.568 9 9 0 0 1-1.375.15 2.35 2.35 0 0 0-1.502.417c-.656.492-.672 1.967-.686 3.27-.003.21-.005.42-.01.622l-.5-.012q.007-.302.01-.617c.016-1.486.032-3.024.886-3.664a2.8 2.8 0 0 1 1.776-.515 9 9 0 0 0 1.328-.145 9 9 0 0 0 1.252-.221 4.54 4.54 0 0 1-2.245-.881 1.1 1.1 0 0 0-.685-.296 6.5 6.5 0 0 0-3.105.346 2.82 2.82 0 0 0-1.262.993 1.4 1.4 0 0 1 .227.087 1.446 1.446 0 0 1 .537 1.97l-.016.024a2.08 2.08 0 0 1-1.666.842 10 10 0 0 0-.021.76 2.37 2.37 0 0 1 1.548.846 1.34 1.34 0 0 1 .205.742 1.15 1.15 0 0 1 1.232.066 28 28 0 0 0 1.636 1.391l.184.149c2.352 1.971 7.5 1.426 9.12 1.08.22-.05.396.092.601.253a3.4 3.4 0 0 0 2.368.779 58 58 0 0 0 5.593-.313l-.172-.134a3 3 0 0 0 .197-.289c-3.257-.512-7.328-1.052-8.698-1.153a5.1 5.1 0 0 1-2.379-.885 13 13 0 0 0-1.535-.798l.196-.46a13.5 13.5 0 0 1 1.592.827 4.7 4.7 0 0 0 2.162.818c1.405.103 5.616.662 8.912 1.184a5 5 0 0 0 .445-1.505 30 30 0 0 1-3.633.096 4.56 4.56 0 0 1-2.146-.55 3.5 3.5 0 0 0-1.377-.427 10.5 10.5 0 0 0-1.448-.027 7.7 7.7 0 0 1-2.46-.233 9.1 9.1 0 0 1-2.17-.975 8.7 8.7 0 0 0-2.979-1.19l.076-.494a9.1 9.1 0 0 1 3.146 1.247 8.8 8.8 0 0 0 2.05.928 7.2 7.2 0 0 0 2.321.218 11 11 0 0 1 1.511.028 4 4 0 0 1 1.553.477 4 4 0 0 0 1.942.498 29 29 0 0 0 3.628-.1 1.8 1.8 0 0 0-.235-.823c-.661-1.114-1.162-1.864-2.063-2.131l.142-.48.07.022a8.75 8.75 0 0 0-4.314-.92 56 56 0 0 1-1.088-.06l.033-.498q.556.036 1.079.058a9 9 0 0 1 4.606 1.028 24 24 0 0 1 2.088 1.497 17 17 0 0 0 1.92 1.356 8.8 8.8 0 0 1 1.626 1.257 3.7 3.7 0 0 0 1.122.823l-.175.469a4.1 4.1 0 0 1-1.287-.925 8.3 8.3 0 0 0-1.536-1.19 17.5 17.5 0 0 1-1.976-1.395 49 49 0 0 0-.813-.623 9.6 9.6 0 0 1 .995 1.456c.714 1.202.035 3.04-.566 3.946l.042-.004.085.081a8 8 0 0 0 3.037 1.817 9 9 0 0 1 .185-1.286 5.6 5.6 0 0 0 .173-1.961l.495-.082a5.9 5.9 0 0 1-.18 2.144 6.6 6.6 0 0 0-.194 1.502c.28.784.948 1.025 1.662 1.268a1 1 0 0 1 .043-.142 6 6 0 0 1 .462-.79 9.3 9.3 0 0 0 1.671-4.037l.498.047a9.9 9.9 0 0 1-1.749 4.259 6 6 0 0 0-.422.714 1 1 0 0 0-.028.115l.223.078-.22.163.01.049a.5.5 0 0 0 .136.157l.04.028a1 1 0 0 0 .133.082 2 2 0 0 0 .319.125 4.1 4.1 0 0 1 .915-1.051l.258-.24a21.4 21.4 0 0 0 2.49-2.633l.392.311a21.7 21.7 0 0 1-2.544 2.69l-.256.239a4.4 4.4 0 0 0-.778.839l-.057.124a.37.37 0 0 0-.015.211.8.8 0 0 0 .138.214q.014.016.032.033a1 1 0 0 0 .184.132 1.35 1.35 0 0 0 .705.14l.572-.018-.124.142a2.7 2.7 0 0 1 .57.257c.098-.121.196-.236.284-.342.136-.16.253-.297.329-.403a1.43 1.43 0 0 1 .999-.573 1.75 1.75 0 0 0 .721-.282 5.05 5.05 0 0 0 1.202-2.55 3.9 3.9 0 0 0 .1-1.229 10 10 0 0 1-.009-.307 4 4 0 0 1 .013-.394 3 3 0 0 1 .081-.512c.186-.774 1.66-1.195 3.732-1.693l.119-.029c.449-.108.869-.208 1.207-.304a4.9 4.9 0 0 1 2.41-.064 7 7 0 0 0 1.203.126c1.369 0 1.914.333 3.351 1.658a21.8 21.8 0 0 1 2.881 3.82c.445.681.865 1.324 1.278 1.896 1.466 2.04 4.717 7.29 4.82 9.613q.007.13.007.255c-.001 2.771-2.08 3.73-4.131 4.301a3.9 3.9 0 0 1-3.597-.681 2.6 2.6 0 0 1-1.03-1.873q0-.066.006-.131c.016-.193.044-.367.068-.527.057-.368.085-.584-.01-.723l-.017-.026c-.176-.214-.729-.367-1.737-.481a2.73 2.73 0 0 1-2.37-1.592c-.282-.485-.485-.836-1.102-.902a17.8 17.8 0 0 1-5.398-1.616 4 4 0 0 0-1.62-.829 3.1 3.1 0 0 1-.02.96c-.019.171-.04.356-.053.555l.323-.377a9.9 9.9 0 0 0 3.833 2.022 13 13 0 0 0 2.817.425l-.022.5a13.6 13.6 0 0 1-2.924-.443 10.4 10.4 0 0 1-4.027-2.123q-.01.16-.01.333v.094l-.062.07a1.9 1.9 0 0 0-.4.77.87.87 0 0 1-.56.696.74.74 0 0 0-.332.236 1.4 1.4 0 0 1-.875.477c-.47.09-.898.162-1.248.22a33 33 0 0 0-.573.1c-.177.032-.276.418-.341.672l-.044.163-.014.049a8.4 8.4 0 0 1 1.291-.524 6.8 6.8 0 0 1 1.554-.443l.08.494a6.4 6.4 0 0 0-1.463.418 8 8 0 0 0-2.09 1.002c-.017.051-.03.112-.044.169-.053.223-.1.479-.147.757q-.056.337-.12.646a5 5 0 0 1-.054.235 3 3 0 0 1-.111.363l-.012.03a1.2 1.2 0 0 1-.3.497.42.42 0 0 0-.095.396 1.29 1.29 0 0 0 .778.941q.225.094.396.172a1.62 1.62 0 0 0 1.333.177l.112.488a2.8 2.8 0 0 1-.624.082 2.35 2.35 0 0 1-1.024-.29q-.168-.075-.386-.168a1.78 1.78 0 0 1-1.079-1.327.9.9 0 0 1 .026-.388 20 20 0 0 0-2.99.527 9 9 0 0 0 .753.924l.015-.011.151.147q.288.281.61.555l.28.238-.02.011a10 10 0 0 0 .914.64 5.2 5.2 0 0 1 .812.74 2.4 2.4 0 0 0 1.42.937 13 13 0 0 1 3.994 1.054 9.7 9.7 0 0 0 3.988.898 10.8 10.8 0 0 1 3.363.68 13.2 13.2 0 0 0 3.427.743 26.5 26.5 0 0 0 4.656-.644 14 14 0 0 1 3.937.039 6.6 6.6 0 0 0 2.74-.032 6.54 6.54 0 0 0 3.255-3.244 8.8 8.8 0 0 0 .104-3.993 2.2 2.2 0 0 0-.403-.915ZM49.29 9.482a2.6 2.6 0 0 0-.915-.109q.456.069.915.11Zm40.868 44.36a3.1 3.1 0 0 0-.065-1.057 16.2 16.2 0 0 1-2.377-2.94c-.122-.141-.21-.24-.283-.322.105 1.16.228 2.415.322 3.371.046.478.093 1.079.14 1.711.101 1.309.215 2.793.362 3.51a10 10 0 0 1 .104 1.969 14 14 0 0 0 .065 1.879c.01-.06.028-.116.04-.175a20 20 0 0 1 .417-1.856q.004-.02.009-.038c.165-.586.353-1.141.536-1.677a9.2 9.2 0 0 0 .734-3.448c-.02-.294-.012-.616-.004-.926Zm-17.383 15.56-.271.42c-.986-.64-2.21-1.315-3.122-1.04a2.1 2.1 0 0 1 .06.568 2.76 2.76 0 0 1-1.435 2.14l-.206-.384a.94.94 0 0 1-.446.234 2.31 2.31 0 0 1-1.613-.613 3 3 0 0 0-.228-.158c-.116-.071-.529.058-.802.14a6 6 0 0 1-.617.162l-.092-.492a5 5 0 0 0 .484-.125 12 12 0 0 1-1.358-.312l.14-.48a12 12 0 0 0 1.505.337 2.6 2.6 0 0 1 .838.083l.123-.138q.037-.044.077-.087l-.29-.06.021-.09-.372.138a1.4 1.4 0 0 1 .129-1.228l-.335.167a2.6 2.6 0 0 1-.223-1.288 5 5 0 0 0-.248.046l-.105-.488q.231-.05.478-.08a.7.7 0 0 1 .205-.272l.185.24a6.4 6.4 0 0 1 2.274.297 7 7 0 0 1 .315-1.3l.472.163a6.4 6.4 0 0 0-.307 1.326 3.5 3.5 0 0 1 .723.437 3 3 0 0 1 .044-.259 2.76 2.76 0 0 1 .553-1.284 13 13 0 0 0-2.125-1.232 8.6 8.6 0 0 1-1.4-.902 10 10 0 0 0-1.78-1.122l.202-.459a10.7 10.7 0 0 1 1.873 1.178 8.4 8.4 0 0 0 1.311.849 13.3 13.3 0 0 1 2.264 1.32 3 3 0 0 1 .475-.344l.25.434a2.3 2.3 0 0 0-.316.218 13 13 0 0 1 1.237 1.101l-.355.352a13 13 0 0 0-1.235-1.093 2.3 2.3 0 0 0-.462 1.075 1.8 1.8 0 0 0-.01.8c1.11-.321 2.445.41 3.515 1.105m-7.046-1.418a1.75 1.75 0 0 1 1.737.044 7 7 0 0 1 .014-.482 5.9 5.9 0 0 0-2.228-.303 2.1 2.1 0 0 0 .13 1.056 1.4 1.4 0 0 1 .347-.315m.841 2.173v.001a.22.22 0 0 0 .168-.074.7.7 0 0 0 .132-.362.9.9 0 0 0-.615.205c.094.144.155.244.315.23m2.373-.845a2.1 2.1 0 0 0-.102-.627 8 8 0 0 1-.065-.257 2.2 2.2 0 0 0-.806-.67 7 7 0 0 0 0 .488l-.236.009-.33.352a1.23 1.23 0 0 0-1.423-.191.89.89 0 0 0-.383.9 1.22 1.22 0 0 1 .646-.782 1.32 1.32 0 0 1 1.171.121l-.258.43a.83.83 0 0 0-.712-.093.71.71 0 0 0-.358.441 1.4 1.4 0 0 1 1.107-.165l.175.047.01.181a1.4 1.4 0 0 1-.27.923.73.73 0 0 1-.517.24.2.2 0 0 1-.047 0 1.07 1.07 0 0 0 .709.19c.316-.064.501-.523.626-.915a.83.83 0 0 0-.212-.78l.357-.35a1.34 1.34 0 0 1 .335 1.27 2.8 2.8 0 0 1-.408.865 2.26 2.26 0 0 0 .991-1.627m-1.082-5.984a2.57 2.57 0 0 1-1.691-.835l-.371.336a3 3 0 0 0 1.974.988 9 9 0 0 1 3.197 1.65 6.1 6.1 0 0 0 3.797 1.712l.037-.498a5.63 5.63 0 0 1-3.502-1.586 9.5 9.5 0 0 0-3.44-1.767Zm-4.432 2.915a3.3 3.3 0 0 0 .556-.613 1.47 1.47 0 0 1 1.204-.761l-.039-.498a1.96 1.96 0 0 0-1.564.957 3 3 0 0 1-.498.552 3.69 3.69 0 0 0-.932 3.122l.494-.082a3.18 3.18 0 0 1 .779-2.677m13.306-24.672a13 13 0 0 0-4.681-.935 8.9 8.9 0 0 1-3.847-1.03c-.423-.182-.856-.369-1.313-.545l-.18.467c.45.174.879.358 1.295.537a9.26 9.26 0 0 0 4.049 1.071 12.4 12.4 0 0 1 4.47.89 9 9 0 0 1 2.955 2.439l.395-.309a9.5 9.5 0 0 0-3.143-2.585\"/></svg>";

},{}],"hpkHY":[function(require,module,exports,__globalThis) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"59.376\" height=\"54.632\"><path d=\"M2.053 38.998s1.799 3.623 5.445 3.965 6.724.456 7.863 2.165 4.103 2.393 7.522 2.05 8.547 1.597 11.737 4.56 26.78 5.356 24.616-1.824S33.941 33.4 21.173 32.982c-18.803-.618-19.12 6.016-19.12 6.016\" opacity=\".25\"/><path fill=\"#3c3c3c\" d=\"M55.554 43.592c.35-.328.251-.795.125-1.385q-.037-.174-.073-.361a3.5 3.5 0 0 0-1.269-1.675c-.153-.14-.312-.284-.465-.433a.96.96 0 0 1-.287-1.132 3.4 3.4 0 0 0 .105-.933c-.02-.449.029-.566.06-.596.016-.016.045-.015.105-.01a.38.38 0 0 0 .29-.065 1.7 1.7 0 0 0 .41-1.196 1.05 1.05 0 0 0-.277-.616c-.112-.149-.209-.278-.192-.4a2.5 2.5 0 0 0-.046-.72 7 7 0 0 1-.07-.541 2.37 2.37 0 0 1 .611-1.351q.127-.185.262-.39a4.8 4.8 0 0 0 .88-2.122 3 3 0 0 0-.075-.386 1 1 0 0 1-.04-.256c0-.225-.287-.385-.65-.587l-.1-.056c-.204-.115-.213-.211-.239-.498a5 5 0 0 0-.09-.61c-.085-.391-.025-.429.052-.477a.4.4 0 0 0 .206-.305 2.12 2.12 0 0 0-.131-1.495 7 7 0 0 1-.356-.629 5 5 0 0 0-.42-.71 1.98 1.98 0 0 1-.495-1.097 3 3 0 0 1-.018-.322.3.3 0 0 0-.06-.205l-.027-.048a.8.8 0 0 0-.225-.23.6.6 0 0 1-.11-.101l.005-.004q-.022-.016-.044-.032a.55.55 0 0 1-.129-.271 1.1 1.1 0 0 0-.083-.421 2 2 0 0 1-.083-.252.8.8 0 0 0-.235-.393 1.2 1.2 0 0 1-.261-.391c-.152-.362-.163-.377-.378-.546a8 8 0 0 1-.209-.168.69.69 0 0 1-.282-.609.5.5 0 0 0-.017-.167 8 8 0 0 1-.253-1.015c-.02-.114-.05-.223-.14-.255s-.166.035-.244.105a.6.6 0 0 1-.224.145c-.106.026-.153-.029-.29-.259a3 3 0 0 0-.245-.364.34.34 0 0 1-.057-.42.63.63 0 0 0 .053-.383 4.2 4.2 0 0 0-.573-1.174c-.246-.41-.326-.442-.592-.409l-.127.013c-.12.008-.174-.052-.283-.188a1.3 1.3 0 0 0-.438-.387c-.404-.213-.755-.658-.634-.983a2.23 2.23 0 0 0-.14-1.4 1.25 1.25 0 0 0-.479-.518c-.161-.119-.301-.221-.311-.343a.7.7 0 0 0-.25-.5 4 4 0 0 1-.26-.299c-.245-.314.068-.872.158-1.019 1.022-.088 1.702-.257 1.886-.571.19-.323-.189-.125-1.749 0s-1.518.066-2.564.195-2.37.428-3.48.534a16.5 16.5 0 0 0-2.5.599c-.984.213-1.304.064-1.88.363s-1.753.726-1.753.726-.184.053-.47.139a2 2 0 0 0 .032-.317 3.7 3.7 0 0 0-.146-.875 4.2 4.2 0 0 1-.172-1.152 2.7 2.7 0 0 1 .068-.612 3.4 3.4 0 0 0 .056-1.058 3.8 3.8 0 0 0-.82-1.887 4.6 4.6 0 0 1-.548-.96 8 8 0 0 1-.352-1.781c.292-.133.51-.064 1.022-.24A1.62 1.62 0 0 0 33.683.439c.033-.634-.812-.44-1.397-.276a1.95 1.95 0 0 0-.91.552s-.098-.294-.26-.358-.195.066-.422.39a3.33 3.33 0 0 1-1.708 1.17 17 17 0 0 1-4.14 1.235c-1.496.162-1.268-.065-1.95.585a55 55 0 0 0-4.777 4.19c-2.339 2.406-2.859 2.763-3.704 4.16a49.6 49.6 0 0 0-2.762 6.419c-.974 2.52-1.787 4.077-2.144 6.254-.049.312-.118.621-.173.933-.127.103-.26.199-.385.304-.277.406.002 0-.127.406s-.428.299-.62.47-.192.363-.662.962a8.8 8.8 0 0 1-1.345 1.26c-.705.64-.065.106-.322.555a1.85 1.85 0 0 1-.555.684c-.299.278-.149.02-.598.448s-.429.492-.727.748-.32.19-.448.32.192.662-.15 1.004-.321.236-.705.257c-.384.02-.235.47-.427 1.047s-.385.533-.522.854-.355.449-.867.919-.001 0-.171.385.193.877.214.94.15.32.15.32L0 39.348a.9.9 0 0 0 .428.385.69.69 0 0 0 .662-.15s.343-.577.748-1.218l.077-.12a.8.8 0 0 1 .138.17l.011.03a.206.206 0 0 0 .274.1.63.63 0 0 1 .406.02 1.1 1.1 0 0 1 .29.135c.153.096.268.152.828.174a2.6 2.6 0 0 0 .741-.03 2.8 2.8 0 0 1 .536-.055 11 11 0 0 1 1.105.039c.384.027.782.055 1.232.046a10 10 0 0 1 1.66.117c.172.023.35.046.547.069a2.5 2.5 0 0 1 .709.145 1.6 1.6 0 0 0 .38.1 1.7 1.7 0 0 0 .596-.026 1.9 1.9 0 0 1 .732-.017.72.72 0 0 1 .538.317.55.55 0 0 0 .27.222.86.86 0 0 0 .429.012 1.3 1.3 0 0 1 .49 0c.327.064.666.434 1.178.994l.355.384c.712.76 2.002 1.943 2.553 2.448l.062.056c.02.014.042.024.062.038.009.01.013.025.027.026h.005l.007-.001a7.5 7.5 0 0 0 3.089 1.223 5.44 5.44 0 0 0 3.45-.426c.582-.325 1.532-.96 2.162-1.38.308-.205.551-.367.635-.417a1.12 1.12 0 0 1 1.046.202 3.25 3.25 0 0 0 1.249.334q.197.023.392.06.013.004.026.008l-.043.062.098-.045c.197.061.266.169.41.435.051.093.108.199.184.326a1.17 1.17 0 0 0 1.032.532 2 2 0 0 1 .273.036 1.53 1.53 0 0 1 .664.38l.24.188a1.4 1.4 0 0 0 .587.265 1 1 0 0 1 .477.223c.102.088.173.155.23.208a1.4 1.4 0 0 0 .486.323 3.4 3.4 0 0 0 1.16.313c.154.01.171.045.217.136a.72.72 0 0 0 .328.344 1.06 1.06 0 0 0 .596.136 1.5 1.5 0 0 1 .53.075.43.43 0 0 1 .329.283.95.95 0 0 0 .948.537 1.3 1.3 0 0 1 .424.005l.236.036a.6.6 0 0 1 .159.032q.1.035.203.065a2 2 0 0 0 .308.063 3.9 3.9 0 0 1 2.077 1.133 6 6 0 0 0 .692.642c.734.583.922.709.96.732a.67.67 0 0 0 .668.098 3.5 3.5 0 0 1 .538-.081c.339-.024.38.016.453.088a.97.97 0 0 0 .473.259 1.3 1.3 0 0 0 .372.062 1 1 0 0 0 .524-.17 2.7 2.7 0 0 1 .493-.22 2.8 2.8 0 0 1 1.303.044 3 3 0 0 0 .614.077c.26-.014.338-.088.385-.211.014-.038.015-.04.05-.048a8 8 0 0 1 1.107-.092 1.3 1.3 0 0 0 .634-.131 3 3 0 0 1 .259-.108 1.75 1.75 0 0 1 1.07-.02.41.41 0 0 0 .324-.027.4.4 0 0 0 .15-.28.4.4 0 0 1 .025-.087c.027-.044.156-.071.32-.105q.15-.031.372-.086a.36.36 0 0 0 .262-.178c.046-.116-.026-.233-.102-.357a1.1 1.1 0 0 1-.14-.282.17.17 0 0 1 .014-.154c.089-.132.414-.172.608-.196a.4.4 0 0 0 .309-.184.72.72 0 0 0 .002-.574.33.33 0 0 0-.23-.172c-.062-.022-.122-.043-.137-.08-.01-.024-.015-.087.059-.234.112-.224.186-.233.24-.24.155-.018.177-.115.167-.3-.007-.121-.021-.237-.033-.341a1.2 1.2 0 0 1-.012-.39c.172-.104.095-.41-.058-1.02l-.017-.066a2.4 2.4 0 0 1-.01-1.01 2.4 2.4 0 0 0 .568-.419m-1.427-8.29a.9.9 0 0 1 .24.503 1.53 1.53 0 0 1-.34 1.05.2.2 0 0 1-.156.024.3.3 0 0 0-.251.062c-.103.099-.138.313-.12.74a3.1 3.1 0 0 1-.1.884 1.14 1.14 0 0 0 .34 1.307c.156.152.316.297.47.438a3.4 3.4 0 0 1 1.11 1.352 4 4 0 0 0-.517-.317 1 1 0 0 0-.22-.102.7.7 0 0 0-.187-.272 6.3 6.3 0 0 1-1.514-2.208 4 4 0 0 1 .324-2.02c.063-.188.123-.365.175-.543a4.52 4.52 0 0 0-.39-3.096 2.47 2.47 0 0 1-.244-1.198 3.11 3.11 0 0 0 .304-2.92 6.7 6.7 0 0 1-.266-1.36c-.024-.36-.028-.692-.03-1.017q.066-.042.128-.085a2.44 2.44 0 0 0 .66 1.066 1.1 1.1 0 0 1 .321.28v.029a5 5 0 0 0 .142 1.051 6.3 6.3 0 0 0-.723 2.085 5.9 5.9 0 0 0 .16 2.596 2.8 2.8 0 0 0 .442.917c.001.072.02.143.015.215a.77.77 0 0 0 .227.54Zm-1.878 13.36c.055.158.242.165.392.17.08.004.19.008.21.04.003.006.014.032-.017.11-.121.298-.774.618-1.08.745-.165-.199-.339-.39-.492-.6a.59.59 0 0 1-.086-.43 1.7 1.7 0 0 0-.073-.691c-.028-.088-.065-.172-.096-.259l.01.002v-.001a.25.25 0 0 0-.048-.156 3 3 0 0 0 .438-.465q.118-.15.25-.29a3.8 3.8 0 0 0 .471-1.08c.005.07.022.138.023.208q.028.417.028.836a1.7 1.7 0 0 0 .016.514v.002a1.7 1.7 0 0 0 .162.48 1 1 0 0 0 .17.263c-.017.018-.03.04-.046.058-.188.216-.302.346-.232.544m-4.101.555a3.8 3.8 0 0 0-1.568-.947c-.549-.23-.64-.4-.655-.463a.08.08 0 0 1 .012-.071l-.009-.01.028-.072c.158-.413-.087-.734-.397-1.142-.02-.025-.033-.056-.053-.081a1.5 1.5 0 0 1 .013-.349.73.73 0 0 1 .553-.02 3.4 3.4 0 0 1 .564.265 3.9 3.9 0 0 0 .383 1.449c.012.011.03.014.042.026h.002a1 1 0 0 0 .755.256 4.5 4.5 0 0 0 .628-.076 4 4 0 0 0-.279.506 1.9 1.9 0 0 0-.02.73Zm-.74-.406a1 1 0 0 1-.5.194c-.024-.094-.12-.194-.333-.315a3.3 3.3 0 0 0-.962-.322 4 4 0 0 0 .22-.439 1.45 1.45 0 0 0 .692.47 10 10 0 0 1 .883.412m-2.99-2.314-.302.284a2.02 2.02 0 0 0-.17-1.41 1.75 1.75 0 0 1-.163-.694 5 5 0 0 1 .306-.564l.004-.005-.001-.001a4.6 4.6 0 0 1 .49-.665c.005.097.012.204.023.342a3.4 3.4 0 0 1-.025.93c-.044.26-.043.354.252.944.017.032.043.06.06.092l-.08.014c.001.003.044.32-.394.733m-2.356-1.246-.014.014a1.56 1.56 0 0 0-.393.734l-.016-.026c-.692-.785-.8-.997-.805-1.276a6 6 0 0 1 .655-.362 5 5 0 0 0 .665-.36l.047.018c.005-.018-.003-.036 0-.053a5 5 0 0 0 .493-.36 1.5 1.5 0 0 0 .271-.315 1.03 1.03 0 0 0 .48.569.6.6 0 0 0 .192.036.54.54 0 0 0 .24-.057 1.7 1.7 0 0 0 .642-.87.8.8 0 0 1 .05.291 4.6 4.6 0 0 0-.595.795 4 4 0 0 1-.598.356 7 7 0 0 1-.428.213 2.1 2.1 0 0 0-.865.633l-.025-.008q.001.015.004.028m-.84.943c-.71-.443-.785-.666-.813-.75l-.007-.015a1.5 1.5 0 0 1 .095-.381.7.7 0 0 1 .202-.245c.035.283.202.546.834 1.264a4.7 4.7 0 0 1 .524.873 2.9 2.9 0 0 0-.835-.746m.889 1.01a2.64 2.64 0 0 0-1.145-.247 1.02 1.02 0 0 1-.993-.517c.047-.054.098-.108.168-.178a.82.82 0 0 0 .233-.582 2.7 2.7 0 0 0 .773.634 3.2 3.2 0 0 1 .964.89m-2.892-2.614q-.065.268-.11.54a1.7 1.7 0 0 1-.248-.78 1 1 0 0 0-.04-.17l.235-.204a.66.66 0 0 1 .395-.166 7 7 0 0 0-.225.75l-.017.028Zm-.188 1.252c-.037-.007-.632-.109-.817-.413a.38.38 0 0 1-.027-.336.66.66 0 0 1 .607-.384l.039-.007a1.8 1.8 0 0 0 .234.548l.03-.026c-.025.181-.056.361-.068.545zM28.226 40.83a1 1 0 0 0-.006-.142.77.77 0 0 1 .269-.547.6.6 0 0 1 .14-.087.61.61 0 0 1 .205.45 1.43 1.43 0 0 1-.335.714q-.017-.01-.033-.022l.005-.008a.54.54 0 0 1-.245-.358m-4.87 2.218-.002-.001v.005c-.005.008-.005.018-.011.026a4 4 0 0 1-.715.549.4.4 0 0 0-.12-.237c.021-.03.049-.053.068-.084a1.14 1.14 0 0 0-.051-.752 2 2 0 0 0 .228.125.6.6 0 0 0 .138.016 1.2 1.2 0 0 0 .572-.246.72.72 0 0 1-.107.599m.084.036h-.001v-.002Zm-.949.18a1.5 1.5 0 0 1-.513.496.8.8 0 0 0-.122-.198.48.48 0 0 1-.135-.51.75.75 0 0 1 .705-.487l.004-.001a1.08 1.08 0 0 1 .061.7m.285-.676a1.66 1.66 0 0 1-.725-.547 1.2 1.2 0 0 0 .426-.321l-.023-.017a2 2 0 0 0 .225.034l.013-.001v-.003a2 2 0 0 0 .144.286.7.7 0 0 0 .553.284h.129a.92.92 0 0 1-.742.285m-2.393-.169a.785.785 0 0 1 .372-.814l-.004-.009c.211.193.332.328.253.486l-.046.09a3.4 3.4 0 0 0-.236.551 6 6 0 0 1-.339-.304m.313.406a1 1 0 0 0-.012.403 1 1 0 0 0-.063-.104l-.015-.027a2 2 0 0 1-.181-.515c.09.081.176.167.27.243Zm-2-1.042c-.059-.135-.12-.274-.168-.41a2 2 0 0 0-.1-.203 1 1 0 0 1 .011-.24 4.6 4.6 0 0 1 .348-1.02 2 2 0 0 1 .125.165 2.1 2.1 0 0 1 .321.844q-.023.105-.075.287a2.7 2.7 0 0 1-.412.702c-.01-.02-.014-.04-.024-.06l.014-.015q-.02-.024-.04-.05m-1.12-1.492-.068-.052c-.427-.324-.477-.487-.277-.922.027-.059.068-.111.1-.169a1.04 1.04 0 0 0 .492.29l.026.01a.6.6 0 0 0-.359.57.53.53 0 0 0 .086.273m-.692-1.486.017-.006c-.022-.061.186-.25.323-.374a2.4 2.4 0 0 0 .368-.383.82.82 0 0 0 .086-.539c.021.02.036.046.058.065a2.9 2.9 0 0 1-.078.832 1.5 1.5 0 0 1-.203.354c-.057.077-.097.165-.146.247l-.059.012a.3.3 0 0 0 .021.052c-.04.072-.091.138-.126.214-.01.022-.012.037-.02.059l.002-.072a.61.61 0 0 0-.243-.461m-.808-.247a1.1 1.1 0 0 1 .245-.149 1.8 1.8 0 0 0 .335.327c.203.162.378.302.378.53a1 1 0 0 1-.015.134l-.003-.014a1.1 1.1 0 0 0-.43.207.5.5 0 0 0 .083-.405 1.06 1.06 0 0 0-.593-.63m-.171.998.007-.003a1.5 1.5 0 0 1-.071-.627.49.49 0 0 1 .171-.307.94.94 0 0 1 .565.589c.062.29-.15.454-.396.642a3 3 0 0 0-.293.25c-.01.01-.01.02-.018.029a1.3 1.3 0 0 0 .035-.573m-.679-.916a.59.59 0 0 0-.737-.215c-.056-.14.028-.362.21-.724l.033.029a1.6 1.6 0 0 1 .45.515l.003-.001a2.1 2.1 0 0 0 .267.528 2 2 0 0 1 .257.488 1.17 1.17 0 0 1-.097 1.213 1.2 1.2 0 0 0-.118-.313l-.06-.13a1 1 0 0 1-.062-.182 1 1 0 0 0 .03-.068 1.62 1.62 0 0 0-.176-1.14m-1.339-1.523a.4.4 0 0 0-.148-.131.6.6 0 0 1-.267-.29.85.85 0 0 1 .109-.738.5.5 0 0 0 .11.097.35.35 0 0 1 .192.198l.023-.007c.021.098.037.197.064.295l.018-.006a1.3 1.3 0 0 0-.118.4c.001.062.013.121.018.182Zm-.826.614a.47.47 0 0 0 .31.262l.016.01a.47.47 0 0 0-.423.196c-.094.157-.276.13-.452.107a.7.7 0 0 0-.268-.006.8.8 0 0 0-.214.09l-.018-.007a3 3 0 0 1 .006-.25 3.3 3.3 0 0 1 .113-.5h.006v.001a.4.4 0 0 1 .011-.083l.003-.018c.023-.073.074-.089.175-.118a1.3 1.3 0 0 0 .358-.155.5.5 0 0 0 .263-.318c.004-.023-.012-.043-.015-.066a.256.256 0 0 1 .113.339l.086.024a.53.53 0 0 0-.07.493Zm.45.402.02-.052a.18.18 0 0 1 .053.157c-.01.146-.12.232-.26.341a1 1 0 0 0-.338.386 3 3 0 0 0-.307-.299 1.8 1.8 0 0 0-.503-.225l-.016-.005a1 1 0 0 1 .111-.046.6.6 0 0 1 .228.008c.187.026.42.06.546-.15.144-.241.453-.12.466-.115m-3.138-2.425a.5.5 0 0 1 .053-.172c.213-.399.49-.344.547-.329l.042.037-.017.007c.004.013.103.296-.252.56a1.5 1.5 0 0 0-.3.266 1 1 0 0 1-.052-.163h.003a.44.44 0 0 0-.024-.206m-6.164 1.315a1.7 1.7 0 0 1-.317-.212c-.171-.169-.112-.276-.108-.282l-.023-.015.023.015-.022-.015a1.1 1.1 0 0 0 .355-.175 1.5 1.5 0 0 1 .193-.093c.118.156.238.314.305.398a1 1 0 0 0 .074.074c.075.067.125.112.1.617a.39.39 0 0 1-.205.377.7.7 0 0 0 .087-.242c-.003-.181-.237-.317-.462-.447m.11.881-.038.028a1.2 1.2 0 0 0-.202.26c-.028-.139-.182-.234-.354-.331-.157-.09-.318-.182-.358-.302a.5.5 0 0 1 .167-.467l-.003-.004a.25.25 0 0 0 .166-.078.23.23 0 0 0 .024-.21 1.2 1.2 0 0 0-.152-.247l.037.005c.028-.004.053-.016.08-.022a.35.35 0 0 0 .141.342 1.8 1.8 0 0 0 .334.226c.194.113.414.24.416.368.004.216-.264.42-.267.422Zm-.206-2.07c-.106-.135-.033-.359.007-.458.013-.001.025-.006.037-.007a1.2 1.2 0 0 0 .656-.229.2.2 0 0 0-.037.092 1.03 1.03 0 0 0 .287.587 1.1 1.1 0 0 1-.484.198 1.6 1.6 0 0 0-.24.113c-.084-.111-.166-.22-.226-.296m1.14-2.258a.55.55 0 0 0 .25.396.74.74 0 0 0 .372.053.4.4 0 0 1 .191.01.6.6 0 0 1-.064.138 3 3 0 0 1-.173.223 1 1 0 0 0-.073.105.85.85 0 0 1-.544-.375.5.5 0 0 1-.073-.336 2 2 0 0 0 .114-.214m-.034-.07.02-.02q.002.014.005.029Zm.336-.456a.48.48 0 0 0 .19.392 1.4 1.4 0 0 0 .255.143.7.7 0 0 1 .119.074.6.6 0 0 1-.013.289.5.5 0 0 0-.235-.017.65.65 0 0 1-.329-.044.47.47 0 0 1-.222-.476l-.006-.001a.9.9 0 0 0 .24-.36Zm-.006-.034.004-.003v.003Zm1.3.419a.22.22 0 0 1-.183.094.33.33 0 0 0-.245.094.24.24 0 0 0-.04.158.8.8 0 0 0-.174-.177v-.011l-.012.004a.8.8 0 0 0-.156-.098 1.3 1.3 0 0 1-.24-.133.41.41 0 0 1-.107-.513l.001-.005.013-.015a.9.9 0 0 1 .25-.258 1.5 1.5 0 0 1 .226-.051.84.84 0 0 0 .473.484 2 2 0 0 0 .206.071l-.01.004a.48.48 0 0 1-.002.352m.1-.325a2 2 0 0 0 .276.096c.137.029.2.044.232.107q.009.019.016.038a.72.72 0 0 0-.397.086.34.34 0 0 0-.184.203.31.31 0 0 0 .057.246c.011.017.027.032.038.05a.4.4 0 0 0-.35.203 5 5 0 0 1-.137-.196c-.024-.135-.033-.225-.003-.264.023-.03.076-.047.178-.056a.31.31 0 0 0 .254-.138.56.56 0 0 0 .02-.375m-.442 1.625a.4.4 0 0 0-.104.143.7.7 0 0 0-.276-.245 2 2 0 0 0-.28-.099c.02-.024.032-.054.054-.077a3 3 0 0 0 .178-.231.7.7 0 0 0 .067-.148.4.4 0 0 1 .108.072c.233.27.3.433.24.58Zm-.475.243a.72.72 0 0 0-.414.3l-.03-.043a1.4 1.4 0 0 1 .023-.186 1.1 1.1 0 0 1 .18-.435h.002a2 2 0 0 1 .293.104.59.59 0 0 1 .324.405l.007.031a.42.42 0 0 0-.385-.176m.49.58.073-.021c.02.027.027.062.05.088a.29.29 0 0 1 .088.209 1.6 1.6 0 0 1-.18.36.54.54 0 0 0-.149.376 2.5 2.5 0 0 1-.503-.266 1 1 0 0 1-.08-.122 5 5 0 0 1-.02-.207 1.9 1.9 0 0 0-.115-.6c-.005-.012-.016-.02-.021-.03a.54.54 0 0 1 .38-.274c.324-.045.475.48.477.487m-.197-1.47a.5.5 0 0 0-.14-.095.7.7 0 0 0 .026-.277.7.7 0 0 1 .171.22c.01.017.018.026.028.04.003.02.003.031.007.052l.025-.005c.044.065.09.133.129.186l.008.01-.007.01.015.003c.15.203.187.275.048.39-.014.011-.02.019-.034.03a.84.84 0 0 0-.276-.563Zm-.623.491a1.2 1.2 0 0 0-.182.452c-.007.03-.006.063-.011.094a1 1 0 0 0-.213-.164l-.001-.006h-.008a1 1 0 0 0-.147-.09 2.1 2.1 0 0 1-.592-.396c-.01-.01-.012-.017-.02-.025.061-.042.132-.07.191-.114a2 2 0 0 0 .336-.381.7.7 0 0 0 .074.222.94.94 0 0 0 .573.408m-.648-.83a2 2 0 0 1-.395.508c-.06.045-.13.073-.192.114a1.4 1.4 0 0 1-.331-.545.6.6 0 0 1 .229-.112.9.9 0 0 1 .332.005.45.45 0 0 0 .434-.136.4.4 0 0 0-.077.166m-.57.787a2.2 2.2 0 0 0 .615.414c.019.006.032.022.05.03a.6.6 0 0 0-.312.135.2.2 0 0 0 .016-.166.6.6 0 0 0-.52-.39q.059-.032.114-.068c.016.016.02.029.037.045m.386.706c.01-.091.16-.158.404-.188a.8.8 0 0 1 .219.207 1.5 1.5 0 0 0 .144.8.75.75 0 0 0-.29-.13.97.97 0 0 1-.477-.69Zm.712.262.024-.06a1.8 1.8 0 0 1 .1.538l.002.017a1.4 1.4 0 0 1-.126-.495m.166.893a.4.4 0 0 0-.01-.13.78.78 0 0 0 .23.47 1.1 1.1 0 0 1-.161.52 1.3 1.3 0 0 1-.347.27 1.5 1.5 0 0 0-.218.15c-.176-.173-.273-.271-.17-.561a.77.77 0 0 1 .407-.426c.129-.073.251-.143.269-.293m.117-.007a2.6 2.6 0 0 0 .572.293.58.58 0 0 0 .345.227 1.1 1.1 0 0 1-.576-.125.56.56 0 0 1-.34-.395Zm.953.633a.6.6 0 0 0 .255-.043l-.003-.006q.046.007.093.01a.67.67 0 0 1-.227.628 2.3 2.3 0 0 1-.627-.693 1.7 1.7 0 0 0 .51.104Zm-.024-1.35a1 1 0 0 0-.075-.107.95.95 0 0 1-.187-.33c-.011-.039-.015-.062-.023-.093h.008c-.003-.016-.014-.027-.018-.042-.044-.198-.003-.246.195-.407.2-.163.125-.302-.005-.48A.31.31 0 0 1 7 34.027a.15.15 0 0 1 .086.035c.012.013.02.03.033.043l.01-.01a.8.8 0 0 1 .082.274c-.15.514-.293.97-.417 1.305Zm.398-1.66c-.01-.011-.027-.007-.039-.016a1.3 1.3 0 0 1-.125-.162.22.22 0 0 1-.044-.172.25.25 0 0 1 .137-.144.64.64 0 0 1 .352-.074q-.106.386-.212.752a1 1 0 0 0-.069-.184m.052-.898a1.9 1.9 0 0 1-.546-.19.78.78 0 0 1-.425-.421 1.5 1.5 0 0 1 .522 0l.009.024.045-.018c.022.005.045 0 .067.007a2.5 2.5 0 0 0 .425.035c.198-.01.27-.092.293-.16a.32.32 0 0 0-.038-.24 1.7 1.7 0 0 1 .144.31l-.215.794c-.056-.088-.15-.114-.281-.141m2.086.215.034-.044.023-.03a1.3 1.3 0 0 0 .168.166c.324.162.392.344.373.51a.6.6 0 0 0-.045.17 2 2 0 0 1-.054.122l.008.004a1.6 1.6 0 0 1-.229.204 4 4 0 0 1-.31.222 1.4 1.4 0 0 1-.256-.422c.057-.03.115-.055.169-.09.287-.199.174-.643.12-.812Zm-.012-2.037c.074-.026.158-.056.265-.091a1 1 0 0 0 .285-.18.43.43 0 0 0 .071.343 1.3 1.3 0 0 1 .121.266.71.71 0 0 1-.209.743 1.1 1.1 0 0 1-.365.037 4 4 0 0 0-.292.014 1.1 1.1 0 0 0 .327-.523.55.55 0 0 0-.203-.61Zm1.438-3.506c-.014-.027-.038-.034-.057-.053a.25.25 0 0 1 .126.041.5.5 0 0 0 .055.177l.001.006a.7.7 0 0 1-.08.318.52.52 0 0 0 .022.569.74.74 0 0 0 .328.287c.082.042.1.075.08.154a.37.37 0 0 0-.244-.13.36.36 0 0 0-.25.09.4.4 0 0 0-.044-.12 2 2 0 0 1-.075-.147 1.06 1.06 0 0 1 .075-.527 1.05 1.05 0 0 0 .063-.665m.864-4.014a1.4 1.4 0 0 0 .297-.634c.115.077.188.158.178.238a.9.9 0 0 0-.001.221c-.105.1-.219.188-.323.288q-.043.03-.084.06c-.038-.045-.079-.086-.115-.131q.024-.021.048-.042m-.103-.1a3 3 0 0 1-.222-.805 3 3 0 0 1 .508.203 1.5 1.5 0 0 1-.286.602m1.525-3.488a6 6 0 0 0 .408-.701 2 2 0 0 1 .09.149 5 5 0 0 1 .16.525c.107.416.192.746.716.822a2.6 2.6 0 0 1 .604.133c-.374.29-.755.573-1.119.877a1.6 1.6 0 0 0-.568-.903.82.82 0 0 1-.31-.544c.01-.05.027-.1.034-.152a1 1 0 0 0-.015-.206m-.116-1.514a3 3 0 0 0 .61-.333 3.7 3.7 0 0 1-.036.78c-.013.03-.034.054-.048.083a1.8 1.8 0 0 0-.526-.53m1.661-.781a19 19 0 0 1-.037-.4 1.8 1.8 0 0 1 .08-.723 1.6 1.6 0 0 0 .322.92 2 2 0 0 0 .194.216 8 8 0 0 1-.223.958 2.8 2.8 0 0 0-.345 1.056 1.4 1.4 0 0 1-.268-.525.23.23 0 0 1 .092-.215c.29-.207.243-.684.185-1.287m.684-2.85c.027.048.048.099.078.146a2.9 2.9 0 0 1 .633.942.4.4 0 0 1-.149.208.69.69 0 0 0-.268.463l-.013-.03a3 3 0 0 1-.124-.294l.002-.022h-.01a3 3 0 0 1-.215-.808c-.02-.119-.057-.233-.085-.35.036-.115.065-.232.103-.347l.013.024-.025.037c.02.012.041.019.06.03Zm2.23-2.967a3.5 3.5 0 0 1 .3 1.297 3.5 3.5 0 0 0-.315.372.55.55 0 0 1-.486-.121 4 4 0 0 1-.372-.67c.064-.172.301-.704.551-1.254a5 5 0 0 0 .24-.396 2.4 2.4 0 0 0-.005.515q.038.115.087.257m.677 1.353a2.4 2.4 0 0 0 .697-.487 3 3 0 0 1 .197.413 7.3 7.3 0 0 0-1.235 1.789c-.171.638.685 1.344.777 1.416a2.3 2.3 0 0 0 .006.647.87.87 0 0 1-.117.74 2 2 0 0 0-.158.29 6.2 6.2 0 0 1-.758-1.874 9 9 0 0 1 .119-1.427 3 3 0 0 0 .472-1.507m-.369 1.015c.04-.181.063-.365.114-.543a4 4 0 0 0 .022-.474l.004-.01c.03-.03.053-.063.083-.092a2.9 2.9 0 0 1-.223 1.119m.528-1.495a3.2 3.2 0 0 0 .767-1.419 1.54 1.54 0 0 1-.098 1.086 2.36 2.36 0 0 1-.827.65c0-.041.004-.082.001-.124zm-.083-.124a6 6 0 0 1 .422-.63c.032-.046.057-.097.089-.143a3.1 3.1 0 0 1-.511.773m.958-1.45-.034.012c.023-.04.05-.077.073-.117a2 2 0 0 0 .173-.626 2.2 2.2 0 0 0 .373.243c.026.011.047.033.072.045a3.7 3.7 0 0 0-.094 1.983l.023.225a1.24 1.24 0 0 0 .041.994l.076.232c.053.675.016.91-.269 1.12a.79.79 0 0 0-.24.81 1.4 1.4 0 0 1-.107.83 3.8 3.8 0 0 0-.37 1.216l-.227.147a1.2 1.2 0 0 1-.257-.143 2 2 0 0 1 .165-.307.99.99 0 0 0 .15-.85 2.2 2.2 0 0 1 .027-.862 4 4 0 0 1 .314-.772 2.7 2.7 0 0 0 .358-1.193 2.96 2.96 0 0 0-.477-1.525c.045-.05.1-.087.14-.14a1.66 1.66 0 0 0 .09-1.321Zm1.927-2.824za.4.4 0 0 0 .058-.005c.15-.025.289-.148.437-.386.122-.226.213-.465.317-.7.078-.078.147-.152.236-.236.189-.21.354-.436.529-.657q.195.157.378.319a2.2 2.2 0 0 1-.366.503 1.6 1.6 0 0 0-.469.555l-.022-.014a3.3 3.3 0 0 1-.615.72 1 1 0 0 0-.256.255 1.26 1.26 0 0 1-.497.415c-.101.053-.207.102-.31.15-.453.212-.881.412-.825.83.063.14.15.266.226.4l-.039.099c-.02-.01-.035-.027-.056-.036a1.3 1.3 0 0 1-.434-.313 2 2 0 0 0-.039-.444 1.14 1.14 0 0 1 .584-.636 4 4 0 0 0 .613-.46c.144-.137.27-.267.39-.396a.5.5 0 0 0 .16.038m-.052-.158.237-.264q.162-.183.34-.376c-.054.11-.093.224-.151.332q-.182.296-.34.32a.3.3 0 0 1-.086-.012m3.327.032a2.4 2.4 0 0 1 .497.983c-.039.037-.087.078-.122.114a6 6 0 0 1-.696.544 6 6 0 0 1-.128-1.315q.223-.166.449-.326m-.434.017c.007-.131.003-.262.019-.393a2.4 2.4 0 0 1 .242.207zm2.324-1.396a8 8 0 0 1 .05 1.08 35 35 0 0 1-.472.413 5 5 0 0 1 .047-1.207q.196-.147.375-.286m-.322-.05c.012-.053.012-.108.026-.161.059-.123.135-.235.205-.352.02.1.033.2.049.3-.086.068-.186.142-.28.213m.372 3.312a3 3 0 0 1-.16-.247 6 6 0 0 1-.293-1.227l.062-.054q.202-.175.387-.338c-.005.094.007.189-.002.283l-.01.44c-.011.431-.006.809.016 1.143m-.293-.2a3 3 0 0 0 .321.503c.005.041.007.087.012.127a2 2 0 0 1-.2.073 3.4 3.4 0 0 0-1.147.373c-.04-.032-.075-.07-.114-.102a8 8 0 0 0 .19-.932 2.5 2.5 0 0 0-.036-.585c.205-.196.441-.407.69-.623a6 6 0 0 0 .284 1.166m5.367-2.623c.01.018.025.037.036.055a3 3 0 0 0-.314.4 1.3 1.3 0 0 1-.383.415 16 16 0 0 1-.284-1.883 2 2 0 0 1 .158-.188 3 3 0 0 1 .589-.436c-.018.105-.036.21-.052.293a1.54 1.54 0 0 0 .25 1.344m2.367 8.239a1 1 0 0 1 .18.547c.006.235.042.312.86.706a10 10 0 0 1 1.063.575q.207.171.42.335a.74.74 0 0 1 .234.762 3.5 3.5 0 0 1-.242.61c-.138.287-.247.515-.028.733a.51.51 0 0 0 .447.116 1.3 1.3 0 0 1 .46.041 1.4 1.4 0 0 0-.359-.001 1.12 1.12 0 0 1-.742-.1c-.376-.175-.318-.316-.203-.597a1.26 1.26 0 0 0 .103-.877 1.6 1.6 0 0 0-.718-.796 11 11 0 0 0-.48-.305 2.9 2.9 0 0 1-1.066-.868c-.005-.027-.017-.053-.02-.081-.002-.011-.009-.02-.01-.031a1.8 1.8 0 0 1-.05-1.126l.004-.027a1.7 1.7 0 0 0 .147.384m-.062-.711a5 5 0 0 0 .46.859 12 12 0 0 0 1.142 1.195q-.21-.107-.44-.217c-.774-.373-.775-.422-.78-.584a1.15 1.15 0 0 0-.198-.614 1.6 1.6 0 0 1-.184-.639m2.924 3.111c.113.079.222.163.338.238.088.06.168.13.254.193.019.1.044.212.058.299.104.637.167 1.02 1.233 1.544.52.255.571.413.605.517.051.154.095.214.604.235a2 2 0 0 0 .203.099q.026.007.052.013l-.022.102-.045-.002c-1.166-.017-1.285-.162-1.547-.48-.02-.026-.048-.045-.07-.07a.87.87 0 0 0-.46-.46h-.002a1.47 1.47 0 0 0-1.138-.385c-.155.01-.248.015-.339-.075-.142-.142-.088-.27.057-.572a3.7 3.7 0 0 0 .25-.633.83.83 0 0 0-.031-.563m.76.56c.145.11.295.212.432.33a2.2 2.2 0 0 0 .55.404 1.6 1.6 0 0 1 .588.523 1.26 1.26 0 0 1 .268.598.74.74 0 0 0 .246.452c-.184-.023-.202-.061-.222-.12-.042-.127-.105-.32-.676-.6-1-.491-1.053-.808-1.157-1.44zm-.474-3.898.062.062a2.4 2.4 0 0 0 .831.598 2 2 0 0 1 .226.144 1 1 0 0 1-.246.336.6.6 0 0 1-.177.124 6 6 0 0 0-.598-.551l.03-.008a5 5 0 0 1-.128-.705m6.373-4.268a6 6 0 0 1 .864.717l-.014.016a1.8 1.8 0 0 0-.193.56c-.01-.003-.019-.01-.029-.012a4 4 0 0 1-.583-.251c-.176-.132-.363-.25-.546-.372a.35.35 0 0 1-.108-.193 8 8 0 0 1 .61-.465Zm-.25.003a1 1 0 0 0 .075-.072l.018.007zm9.68 19.393a8.7 8.7 0 0 1-.426 1.402 5.3 5.3 0 0 0-.356 1.254c-.099.118-.182.248-.275.371l-.014.003.003.012-.122.165a14 14 0 0 0-.046-2.485 51 51 0 0 1-.043-1.017 1.2 1.2 0 0 1 .295-.486 3 3 0 0 0 .486-.757l.007.009a2 2 0 0 0 .27.227c.264.192.41.296.22 1.302Zm.138.026a4.3 4.3 0 0 0 .087-.71 2.86 2.86 0 0 1-.123 2.22l-.026-.038a.66.66 0 0 0-.208.433 2.9 2.9 0 0 1-.48.538 7 7 0 0 1 .318-1.018 9 9 0 0 0 .432-1.425m.488 13.179a.73.73 0 0 1 .26.4 2 2 0 0 1-.052.437 3 3 0 0 1-.118-.288 4.75 4.75 0 0 0-1.335-2.074 4.28 4.28 0 0 1-1.37-3.336l.007-.034-.007-.002c-.02-.432-.021-.895-.017-1.405.012-1.336.095-1.403.234-1.516a1.2 1.2 0 0 0 .4-.644c.077-.421.126-.846.163-1.27q.09-.133.184-.26a2.8 2.8 0 0 0 .416 1.027.905.905 0 0 1 .19 1.085c-.033.093-.092.234-.167.414-.378.903-1.081 2.585-.835 3.675a2.85 2.85 0 0 0 1.05 1.65 2.7 2.7 0 0 1 .476.503 1.18 1.18 0 0 1 .273.738.755.755 0 0 0 .248.9m-.44 2.099a1.54 1.54 0 0 1-.01.87 1.7 1.7 0 0 0-.138.278 1.4 1.4 0 0 1-.276.449 3 3 0 0 0-.182.233 2 2 0 0 1-.006-.246 12 12 0 0 0-.028-.845 4 4 0 0 0-.176-1.05q.007-.014.014-.03l-.026-.01-.03-.1a7 7 0 0 0 .48.535.34.34 0 0 0 .164.05.2.2 0 0 0 .06-.01m-2.621.382a.7.7 0 0 1-.27-.196c-.066-.116-.09-.293.311-.635a2.1 2.1 0 0 0 .497-.642.9.9 0 0 0 .293-.33 2 2 0 0 0 .149-.34 4 4 0 0 1 .112 1.328 2.4 2.4 0 0 1-.25.946 4 4 0 0 0-.11.25 4 4 0 0 1-.28.374 1 1 0 0 0 .018-.272c-.04-.253-.268-.375-.47-.483m-2.579 1.013c-.58.017-.75-.161-.773-.187q-.012-.08-.02-.16l.018-.075c.05-.206.184-.287.427-.437a5 5 0 0 0 .552-.381c.016-.014.023-.024.038-.037l.023-.002-.004-.017a1.5 1.5 0 0 0 .43-.531c.174.691.325 1.277.454 1.713a1.5 1.5 0 0 0-.442.034 5 5 0 0 1-.703.08m.686.064c-.018.052-.084.177-.334.357a3.5 3.5 0 0 1-.425.27 2 2 0 0 0-.208.126 1 1 0 0 0-.167.136l-.003-.002a3.8 3.8 0 0 1-.297-.947 1.3 1.3 0 0 0 .668.139l.084-.002a5 5 0 0 0 .682-.077m-1.64-2.076a2 2 0 0 0-.148-.235c.11-.06.32-.178.532-.313a.8.8 0 0 0 .244-.229 1.4 1.4 0 0 0 .075.246 1.21 1.21 0 0 0 .87.529h-.02c0 .004-.014.245-.42.602a1.9 1.9 0 0 1-.602 0 .84.84 0 0 1-.488-.422l-.006.002c-.014-.06-.02-.121-.037-.18m.01 1.44a3.6 3.6 0 0 0-.516-.233.86.86 0 0 0-.572.005 1.5 1.5 0 0 1 .11-.336c.192-.24.266-.251.62-.306a.5.5 0 0 0 .292-.139 4 4 0 0 1 .064.715c-.005.098 0 .196.003.294Zm-4.79-3.08a1.6 1.6 0 0 0 .321-.18.74.74 0 0 0 .171-.736q.108.033.213.073c.03.033.066.062.097.095l.019.04c.304.595.359.703-.068 1.103-.125.104-.26.194-.394.286a.7.7 0 0 0 .001-.154 2 2 0 0 0-.36-.526Zm-1.083.405c.051-.025.104-.046.154-.073a2.8 2.8 0 0 1 .62-.233 2 2 0 0 0 .16-.05 2 2 0 0 1 .371.51.6.6 0 0 1 .002.22 5 5 0 0 1-.641.346 7 7 0 0 0-.59.32v-.006a4 4 0 0 0-.076-1.034M38.884 41.9a1.65 1.65 0 0 1-.433-.843 1 1 0 0 0-.02-.128q.295.312.576.636a2.6 2.6 0 0 0 .59.513 1.2 1.2 0 0 0-.653.343 1.6 1.6 0 0 0 .077-.221.4.4 0 0 0-.137-.3m-.835.711c-.052.033-.292.153-.852-.08a1.1 1.1 0 0 1-.651-.56 1 1 0 0 0 .303.093q.038.003.075.003a1.05 1.05 0 0 0 .725-.312 1.5 1.5 0 0 0 .245-.314 2 2 0 0 0 .157.177.7.7 0 0 0-.132.588 1.1 1.1 0 0 0 .13.405m-.015 1.62a.7.7 0 0 0 .245-.405 1 1 0 0 0 0-.128.77.77 0 0 1 .488.662 2 2 0 0 0 .048.25l-.03.005a.75.75 0 0 0-.624.347 1.26 1.26 0 0 0-.127-.731m.033.749-.006.015a.596.596 0 0 1-.728.338.4.4 0 0 0 .094-.275 1.2 1.2 0 0 0-.13-.477 2.9 2.9 0 0 0 .662-.277l.003-.003c.038.08.214.473.105.679m.12-1.173a.62.62 0 0 1-.276.417 2.8 2.8 0 0 1-.65.272l-.004-.008c-.135-.271-.233-.467.116-.735a1.19 1.19 0 0 0 .563-1.003v-.004l.003-.001a.66.66 0 0 0 .141.54.66.66 0 0 1 .107.522m-5.543-2.176a1.4 1.4 0 0 1-.34-.368.85.85 0 0 1 .024-.974 1.34 1.34 0 0 0 .21-.751l.096.027c.324.09.604.168.77.83.14.566-.608 1.129-.76 1.236m.411-.122a1 1 0 0 0 .195.375 1.7 1.7 0 0 0-.41-.186zm.44-1.137c-.179-.715-.498-.803-.835-.897a1.25 1.25 0 0 1-.648-.345c-.522-.547-.336-.752-.335-.752l-.001-.002c.194-.19.389-.38.567-.585a1.22 1.22 0 0 0 .5.73 3 3 0 0 0 .51.264 2 2 0 0 1 .854.588c.3.353.352.503.36.555a12 12 0 0 1-1.109 1.117 1.05 1.05 0 0 0 .137-.673m-2.235-2.735a1.4 1.4 0 0 0-.101-.145.92.92 0 0 0 .175-.687 2.7 2.7 0 0 0 .57.409 1 1 0 0 1 .09.06l.001.002a1 1 0 0 1 .132.087.35.35 0 0 1 .101.238l-.032.037a10 10 0 0 1-.833.86 1.27 1.27 0 0 0-.103-.861m-2.31 2.04a2 2 0 0 0-.04-.274 3.1 3.1 0 0 1-.067-1.078l.08.064.229.18c.09.074.17.132.24.184a1.5 1.5 0 0 1 .198.166 1.4 1.4 0 0 0 .069.18.5.5 0 0 1-.032.128 1.4 1.4 0 0 0 .098 1.36q.014.013.03.026a1.4 1.4 0 0 1-.42-.266c-.356-.357-.357-.381-.365-.538 0-.014-.005-.027-.006-.04l.019-.004a1 1 0 0 0-.033-.088m-.772.748c-.026-.154-.058-.339-.088-.596-.054-.464.032-.644.112-.714a.19.19 0 0 1 .15-.04 2.3 2.3 0 0 1 .508.63c.003.037.015.072.016.108a1 1 0 0 0 .01.085.65.65 0 0 0-.46.174.86.86 0 0 0-.248.353m.011.583a1 1 0 0 0 .035.069q-.03-.013-.06-.025zm-2.772-.93a.4.4 0 0 0 .082.15q-.032-.013-.063-.022c-.253-.084-.407-.145-.377-.323a3 3 0 0 1 .17-.646 2 2 0 0 1 .154-.325l.007-.008h-.003a1.42 1.42 0 0 0 .156-1.162.98.98 0 0 0-.48-.718.86.86 0 0 1-.412-.543.76.76 0 0 1 .173-.836 1.5 1.5 0 0 0 .252-.412c.008.034.012.069.021.103a4.7 4.7 0 0 1 .164 1.07l.026.003c-.025.5.328.877.785 1.34l.2.205a.13.13 0 0 1 .004.099c-.022.074-.107.189-.387.312-.604.266-.61 1.192-.472 1.714Zm-2.762 1.56a1.7 1.7 0 0 1-1.029-.4.4.4 0 0 1-.06-.112 1.5 1.5 0 0 1 .023-.426 1.34 1.34 0 0 0 .754-.274.95.95 0 0 0 .137-.525c.186.257.176.343.098.7a1.9 1.9 0 0 0 .077 1.037m-4.638-2.215v-.022l-.038.005a1 1 0 0 0-.127-.055.87.87 0 0 1-.47-.29c.05-.084.091-.173.149-.252a1.6 1.6 0 0 0 .215-.376 3 3 0 0 0 .083-.81 1 1 0 0 0 .192.112.3.3 0 0 0 .133.113c.108.06.2.112.188.358a1.1 1.1 0 0 1-.162.515.61.61 0 0 0-.096.502c.006.02.028.066.237.24q-.04.064-.078.13a.46.46 0 0 0-.226-.17m.175.259-.016-.014Zm-5.399-3.968-.018-.006a.4.4 0 0 0-.202-.118.44.44 0 0 1-.36-.31.87.87 0 0 1 .056-.624.59.59 0 0 0 .031-.51c-.111-.18-.332-.12-.545-.062a.8.8 0 0 1-.505.036.42.42 0 0 1-.23-.293.8.8 0 0 0-.318-.417.87.87 0 0 1 .521.024 6 6 0 0 1 .537.252l.017-.03a1.7 1.7 0 0 0 .39.309 1.25 1.25 0 0 1 .43.34l.001.003a1.25 1.25 0 0 1 .273.589 2 2 0 0 0-.102.726 1 1 0 0 0 .024.091m-.135.85a.45.45 0 0 0 .191.25l-.015.013a.14.14 0 0 1 .02.104.44.44 0 0 1-.22.25 1.2 1.2 0 0 1-.334.145 1 1 0 0 0-.116.043 3 3 0 0 0 .079-.404 1.2 1.2 0 0 0-.031-.338q.085-.09.18-.17a2.7 2.7 0 0 0 .334-.598.46.46 0 0 1-.038.266.76.76 0 0 0-.05.44Zm-1.642-1.442a.8.8 0 0 1-.192-.446 1 1 0 0 1-.002-.398.9.9 0 0 0 .002-.363 1.4 1.4 0 0 0-.134-.396.7.7 0 0 1 .243.342.51.51 0 0 0 .281.345 1 1 0 0 0 .227.024l-.012.022c.004.002.371.218.295.508-.032.127-.12.175-.221.23a.54.54 0 0 0-.262.255.4.4 0 0 1-.217-.115l.002-.005Zm-.673.37a1 1 0 0 0-.016.13.9.9 0 0 0-.202-.166 2.5 2.5 0 0 1-.529-.45c-.1-.112-.17-.196-.238-.28a4 4 0 0 0 .308-.22 2 2 0 0 0 .231-.205.6.6 0 0 0 .026.1.84.84 0 0 0 .444.414.57.57 0 0 1 .329.33.7.7 0 0 0-.353.348Zm0 .553h-.009a.03.03 0 0 1-.013.016c-.015.007-.08.023-.267-.097a.9.9 0 0 1-.274-.288.47.47 0 0 0-.376-.264 1.17 1.17 0 0 0-.568.052c-.015-.05-.037-.096-.048-.147a.32.32 0 0 1 .119-.266 4 4 0 0 1 .374-.27c.07.087.143.174.244.288a2.6 2.6 0 0 0 .548.466c.15.1.221.155.228.294a.8.8 0 0 0 .042.217Zm-.334-1.973a.6.6 0 0 0 .008-.11.5.5 0 0 1 .141-.186 1 1 0 0 0 .182-.255.33.33 0 0 0 .026-.24 1 1 0 0 0 .13.091 1.4 1.4 0 0 1 .184.387c-.04.023-.379.22-.566.322a.26.26 0 0 0-.137.157.5.5 0 0 1-.004-.094 1 1 0 0 0 .036-.072m-.412-.734a1.3 1.3 0 0 1-.154-.155c.018-.025.04-.05.056-.074a.55.55 0 0 0 .116-.433.8.8 0 0 1 .198.158q.126.125.262.24c.2.174.261.226.179.408a1 1 0 0 1-.167.233.6.6 0 0 0-.073.083.59.59 0 0 0-.417-.46m1.904-3.562a.5.5 0 0 1-.164-.336 1 1 0 0 1 .094-.517.83.83 0 0 0 .08-.434.7.7 0 0 0 .093.098c.081.069.145.124.153.226a.45.45 0 0 1-.07.26.8.8 0 0 0-.106.427.295.295 0 0 0 .19.305.26.26 0 0 1 .169.25.82.82 0 0 1-.238.8l-.12.142a1 1 0 0 0-.118.167l-.014-.008c-.005.009-.002.026-.006.036a1.2 1.2 0 0 0-.182.443c-.005.024-.003.048-.007.072a.5.5 0 0 0-.073-.17 2.5 2.5 0 0 1-.177-.397c-.122-.363-.001-.485.24-.728q.09-.088.195-.204c.208-.232.177-.314.061-.432m.073-3.342c.01.01.014.024.026.033a3 3 0 0 0 .217.164c.14.098.204.143.2.276a1 1 0 0 1-.05.217.66.66 0 0 0-.06.376.26.26 0 0 0-.142-.062.22.22 0 0 1-.188-.138.6.6 0 0 1-.003-.44.62.62 0 0 0 0-.426m1.533-1.538-.005-.006a2 2 0 0 1-.096-.123.31.31 0 0 0-.262-.142q.199-.196.4-.388a2 2 0 0 0-.037.659m-.178-.075c.042.059.074.098.1.13.079.096.088.106.106.45a.8.8 0 0 0 .06.234.47.47 0 0 1-.284-.142.98.98 0 0 1-.347-.663h-.032l.09-.087a.24.24 0 0 1 .307.078m.567-.634a.44.44 0 0 1 .158.307 1.6 1.6 0 0 1 0 .379.7.7 0 0 0 .328.754c.498.385.677.362.707.352l-.002-.007a3.8 3.8 0 0 0 .673.289.8.8 0 0 0-.097.35c-.02.342.397.789.499.894-.087.088-.168.182-.263.262a2 2 0 0 0-.079-.302c-.107-.35-.314-.408-.322-.41l-.025.09c.007.003.167.052.258.347a1.76 1.76 0 0 1 .052.901.4.4 0 0 0-.103-.12 1.5 1.5 0 0 1-.285-.394c-.153-.313-.095-.442-.054-.512a.1.1 0 0 0 .03-.013.94.94 0 0 0 .057-.865.54.54 0 0 0-.298-.316.5.5 0 0 0-.346.012 1.15 1.15 0 0 0-.439-.577 1 1 0 0 0-.386-.155.38.38 0 0 1-.322-.253 1.83 1.83 0 0 1 .016-1.068l.011-.012a.4.4 0 0 1 .232.067m-.144-.152q.076-.075.153-.148a.6.6 0 0 0 .073.256c-.01-.01-.016-.023-.027-.032a.5.5 0 0 0-.199-.076m1.601-.963a.595.595 0 0 0 .57.51.8.8 0 0 0-.215.55 1.6 1.6 0 0 1-.36-.161c.006-.02.005-.041.01-.061q.034-.2.057-.4a.76.76 0 0 0-.43-.682l.285-.28a.7.7 0 0 1 .135.018 1 1 0 0 0-.052.506m.485-4.814c-.044.654.003.924.447 1.138-.004.095 0 .191-.006.287a2.7 2.7 0 0 1-.148.84l.043.017-.08.061a2.7 2.7 0 0 1-.613-.29 1.4 1.4 0 0 1-.38-.267 2.7 2.7 0 0 1 .349-1.12 8 8 0 0 0 .21-.884 1.6 1.6 0 0 1 .178.218m-.137-.39a8 8 0 0 0 .105-1.081q.008.02.017.04l.107.24c-.02.313-.042.575-.062.808l-.014.179a2 2 0 0 0-.153-.186m.758-1.574c.011.03.03.055.04.085a.36.36 0 0 1-.111.33.51.51 0 0 0-.141.47l.006.119a1.1 1.1 0 0 1-.178-.259c.028-.41.14-.505.247-.593a.7.7 0 0 0 .137-.152m-.048-.436a3 3 0 0 0-.499-.695 4 4 0 0 0 .406.193.8.8 0 0 1 .093.379c.003.05 0 .082 0 .123m.881-.303c.01.132.017.264.039.394a1.68 1.68 0 0 0-.009 1.383 4.7 4.7 0 0 0 1.108 1.604q-.459.308-.976.665a5 5 0 0 0-.411-1.423 1.9 1.9 0 0 0-.594-.706c-.019-.013-.032-.031-.05-.045-.006-.091-.006-.182-.013-.273a.37.37 0 0 1 .112-.356.49.49 0 0 0 .14-.442c-.027-.085-.076-.16-.11-.242a1.3 1.3 0 0 0 .024-.388.9.9 0 0 0-.06-.316 4 4 0 0 0 .434.136 1 1 0 0 0 .226.023 1 1 0 0 0 .14-.014m.5-1.664a3.5 3.5 0 0 0-.337.667 7 7 0 0 1-.286-.343 1.52 1.52 0 0 1-.187-1.057 4 4 0 0 0 .308.552.59.59 0 0 0 .472.185q.015-.001.03-.004m.181-.02c.016-.004.032-.003.047-.006l-.012-.049c.029-.04.055-.08.086-.119a6 6 0 0 0-.296 1.063c-.027.193-.077.381-.116.571a6 6 0 0 0-.234.383 4 4 0 0 1-.043-.451 3.4 3.4 0 0 1 .568-1.393Zm.485 4.153-.048-.043-.451-.934c-.359-.742-.354-.76-.24-1.194.04-.148.06-.3.092-.449l.107-.162a9 9 0 0 0-.072 1.124 6.2 6.2 0 0 0 .612 1.658m-.539-3.04-.032.046c.014-.084.04-.165.051-.25a6 6 0 0 1 .248-.924v.008a9 9 0 0 0-.213 1.019c-.02.032-.032.069-.054.1Zm-.322.763q-.007.035-.014.07a2 2 0 0 0-.069.32c-.01-.047-.028-.09-.036-.138a3 3 0 0 1 .12-.252Zm.663 2.289.034.03.282.58c-.019.064-.03.13-.043.196a4.7 4.7 0 0 1-1.078-1.56 1.55 1.55 0 0 1-.07-1.088 4.5 4.5 0 0 0 .875 1.842m.607 1.574-.012.018c.008.006.831.583.821 1.109a1.6 1.6 0 0 0 .176.873l-.007.006a.5.5 0 0 1 .062.103q.01.02.021.037a.535.535 0 0 1-.107.604.53.53 0 0 0-.212.39.5.5 0 0 0 .054.2c-.083-.033-.148-.097-.224-.32a2 2 0 0 1-.023-.84 2.8 2.8 0 0 0-.064-1.212 1.07 1.07 0 0 0-.872-.716q.182-.12.387-.252m-.144-.985c.012-.037.017-.075.031-.111.032.047.059.097.091.144l-.08.054Zm1.317-2.352c-.026-.305-.031-.47.146-.6a.9.9 0 0 0 .374-.761 4 4 0 0 0 .26.411 10.2 10.2 0 0 0-.79 2.564l-.428.276a3.6 3.6 0 0 1 .308-.931 1.65 1.65 0 0 0 .13-.96Zm6.943-5.428a3 3 0 0 0 .418.388 6 6 0 0 1 .771.755l.012.014c-.025.01-.043.032-.07.039a.9.9 0 0 1-.54.027 1 1 0 0 0-.183-.001 2.8 2.8 0 0 1-.435-1.21q.014-.006.027-.012m-.068-.331a12 12 0 0 1-.036-1.348l.01-.44c.013-.142.016-.285.022-.427.169-.152.315-.29.418-.403.281-.308.907-.98 1.222-1.316-.03.418-.189 2.053-.868 2.574a1.75 1.75 0 0 0-.768 1.36m3.328-2.056.05-.049a.5.5 0 0 0 .141.198c.031.022.072.02.107.033a.3.3 0 0 1 .053.041l-.016.016c.007.01.036.045.027.07-.005.013-.044.08-.333.107-.015 0-.03.005-.045.006a3 3 0 0 0 .031-.333c-.002-.03-.013-.059-.015-.089m.111-.67a2.3 2.3 0 0 1 .146-.643.72.72 0 0 1 .068.59c-.06.08-.14.141-.205.218 0-.059-.013-.098-.009-.164Zm-.069 1.226a.54.54 0 0 0 .416-.166 1 1 0 0 1 .047.267 1 1 0 0 1-.026.334c-.035.153-.044.247.13.715.05.132.114.258.173.387a.1.1 0 0 0-.015.06 3.7 3.7 0 0 1-.938.083 1.2 1.2 0 0 0-.639.064q.114-.244.265-.505a3.1 3.1 0 0 0 .511-1.23c.026-.001.05-.008.076-.01Zm6.144 11.16c.018.009.038.01.056.017l-.012.009a.5.5 0 0 1 .08.365.44.44 0 0 1-.252.269c-.183.092-.431.204-.677.31-.098-.037-.193-.08-.292-.115a2 2 0 0 1 .32-.267.7.7 0 0 0 .354-.457c.097-.395-.24-.615-.705-.92l-.166-.11c-.045-.036-.078-.085-.121-.124.088-.08.168-.168.258-.245a1.27 1.27 0 0 0 .403-.953 1.36 1.36 0 0 1 .577.657 1.13 1.13 0 0 1-.098.786c-.115.28-.223.547.275.778m.26.317a1.8 1.8 0 0 0 .172.38 4.4 4.4 0 0 1-.355.603 1.6 1.6 0 0 1-.308-.102c-.127-.06-.26-.102-.39-.154.204-.09.403-.181.556-.258a.57.57 0 0 0 .327-.362 1 1 0 0 0-.002-.107m.788.423-.029.012a2 2 0 0 1 .1.442c-.042-.034-.088-.062-.129-.097-.027-.02-.05-.046-.075-.068-.013-.016-.021-.035-.034-.05a1 1 0 0 1-.036-.051l-.029.012a1.7 1.7 0 0 1-.468-.831 1.2 1.2 0 0 0 .38.006.43.43 0 0 0-.044.25c.03.146.167.268.364.375m2.887-6.681q.374.179.764.322a1.7 1.7 0 0 0 .019.517q-.037.34-.075.68c-.135-.128-.42-.391-.791-.707a2 2 0 0 0 .11-.242c.09-.328.066-.434-.027-.57m1.14-.002c.01-.013.02-.02.03-.031a2 2 0 0 1-.016.277 6 6 0 0 1-.218.66q-.006-.033-.01-.067l.001-.02a4 4 0 0 1 .03-.478 1.1 1.1 0 0 1 .183-.341m-.159.078c.013-.073.038-.143.054-.215.018-.04.026-.083.048-.122.023-.062.033-.127.053-.189a2 2 0 0 1 .03.286 1 1 0 0 0-.101.105 1 1 0 0 0-.084.135m.312.188a2.4 2.4 0 0 0 .016-.427 1.3 1.3 0 0 1 .39-.164c.11.087.23.164.335.259l-.063.1a2.9 2.9 0 0 0-.411.879c-.168.774.042.91.74 1.358l.107.069a1.5 1.5 0 0 1-.003.347 2.66 2.66 0 0 1-1.034-.984c-.075-.104-.152-.212-.239-.327a1.6 1.6 0 0 1-.108-.232 6 6 0 0 0 .27-.878m-.073-.961.033.025c.125.082.237.184.356.275a1.4 1.4 0 0 0-.307.13 2 2 0 0 0-.082-.43m2.748-1.34a2 2 0 0 0 .04.238 3 3 0 0 1-.846-.214 3 3 0 0 0-.583-.175 1.07 1.07 0 0 1-.132-.715.5.5 0 0 1 .116-.178q.099.066.198.134a.6.6 0 0 0 .134.125 4 4 0 0 0 .397.236c.233.173.456.36.676.548Zm-.17-.322c.045.016.086.039.131.054.023.006.042.02.065.027l-.008.072zm8.873 13.723q-.351-.32-.728-.612a.9.9 0 0 0 .066-.318.93.93 0 0 0-.476-.974 1.04 1.04 0 0 0-.562-.887 7.4 7.4 0 0 1-1.454-1.14 2.7 2.7 0 0 1 .637-.024 13 13 0 0 1 1.677 1.425 4.67 4.67 0 0 1 .84 2.53m-.202-1.604a17 17 0 0 1 1.201 1.622 5 5 0 0 1-.479.499c-.127-.132-.253-.265-.386-.39a4.8 4.8 0 0 0-.336-1.731m.181 2.54c-.097.065-.192.13-.294.188a1.7 1.7 0 0 0-.354-.523l-.045-.057a.37.37 0 0 1-.084-.29 1 1 0 0 1 .32-.472c.159.134.32.264.473.405a5 5 0 0 1-.017.548zm-2.806 13.739c.084.315.205.617.314.924-.13.33-.48 1.083-.769 1.178-.075.024-.144.063-.217.091a1.17 1.17 0 0 0 .406-.607 4.8 4.8 0 0 0-.272-1.41h-.003a.58.58 0 0 0 .099-.347 1.37 1.37 0 0 0-.425-.956 1.44 1.44 0 0 1-.438-.973c.01-.436.22-.536.485-.662a1.01 1.01 0 0 0 .615-.6c.185-.525-.222-.73-.615-.93a2.2 2.2 0 0 1-.489-.303c.315-.156.71-.357 1.01-.528a1.9 1.9 0 0 1 .507.77 2 2 0 0 1 .025.489l-.017.058a9 9 0 0 0-.216 3.806m-.282 3.093a.6.6 0 0 1 .109-.485 1.68 1.68 0 0 1 1.075-.301c.117.235.217.478.35.706.012.025.03.046.044.072l-.02-.005a1.63 1.63 0 0 1-.479.782.58.58 0 0 1-.436.118c-.426-.056-.477-.13-.58-.28a2 2 0 0 0-.122-.133.9.9 0 0 0 .06-.474Zm.006-.581a.72.72 0 0 0-.147.589.75.75 0 0 1-.017.36 2 2 0 0 0-.134-.144 4.8 4.8 0 0 0-.861-.557l.014-.007a1.6 1.6 0 0 0 .357-.241 5 5 0 0 1 .653-.276q.276-.092.604-.712c.07-.133.127-.27.186-.408.133.358.287.706.453 1.05a1.76 1.76 0 0 0-1.108.346m-3.945-.332a1 1 0 0 0 .038-.112l.005.019c.045-.012 1.107-.3 1.274-.913a1.37 1.37 0 0 0 .022-.746c.01.011.026.018.036.03l.02-.011a.65.65 0 0 0 .207.436.77.77 0 0 0-.091.475 5.1 5.1 0 0 0 .498 1.407c.06.123.11.25.164.376a5.3 5.3 0 0 0-2.172-.961Zm1.627.764v.006l-.01-.011Zm-.124-.067a14 14 0 0 1-.777.529 4 4 0 0 0-.22-.368.84.84 0 0 1-.101-.615 5.2 5.2 0 0 1 1.098.454m-2.363-1.815a3 3 0 0 0 .431-.331 1.8 1.8 0 0 0 .142.457 1.3 1.3 0 0 1 .093.195.9.9 0 0 0-.298.085.9.9 0 0 0-.251.156c.019-.059.05-.113.063-.173a.43.43 0 0 0-.18-.39Zm-1.657.74a2 2 0 0 1-.242.31l-.037-.073q-.012-.024-.024-.05l.003-.001-.007-.007-.04-.086.006-.011-.015-.006a11 11 0 0 1-.576-1.347 4 4 0 0 0-.171-.497c.21-.19.424-.386.634-.611.04-.048.076-.1.116-.148h.002l.001-.004.011-.014a2.5 2.5 0 0 0 .268.537l.235.348-.001.003a1.3 1.3 0 0 0 .006.96l-.015.007a.72.72 0 0 1-.154.69m-5.512-1.16a2 2 0 0 0 .274.457 1.14 1.14 0 0 1-.976.599.75.75 0 0 1-.349-.126 2.14 2.14 0 0 0-.299-1.503c.05-.054.088-.12.144-.17a4.5 4.5 0 0 1 .977-.553c.108.154.226.302.343.45l-.018-.008a1.44 1.44 0 0 0-.096.854m-5.592-3.828a2.5 2.5 0 0 1-.741-.598l.256-.318a1.26 1.26 0 0 0 .262-.87 4 4 0 0 0 .65.122c-.002.01-.008.02-.009.032a.53.53 0 0 0 .15.379 1.07 1.07 0 0 0-.538.53 1.5 1.5 0 0 0-.03.723m-1.486 2.77a2.7 2.7 0 0 1-.723-.782.3.3 0 0 0-.09-.208.9.9 0 0 1-.06-.385 6.5 6.5 0 0 1 .176-.948 3 3 0 0 0 .134-1.13c-.002-.027-.01-.053-.015-.08l.079.135q.055.091.108.185c.013.02.033.034.047.054a1.5 1.5 0 0 0 .04 1.2 2.6 2.6 0 0 0 .258.37 1.5 1.5 0 0 0-.227.756 1.08 1.08 0 0 0 .248.71l-.003.014a1 1 0 0 0 .028.11Zm-.966-1.381a1.4 1.4 0 0 0 .026.274l-.093-.072a9 9 0 0 1-.236-.182l-.23-.18c-.428-.331-.96-.742-1.035-1.155a2.8 2.8 0 0 1-.02-.622 4 4 0 0 0 0-.377 1 1 0 0 0 .292.34 2 2 0 0 0 .626.239c.237.057.394.094.481.312a3 3 0 0 1 .174.912l.046-.001c-.021.297-.032.508-.032.512Zm-1.123.507a6 6 0 0 0-.274-.24 2.5 2.5 0 0 0-.738-.445c-.168-.066-.218-.086-.28-.332a1.9 1.9 0 0 1 .032-.5l.002-.003h-.002a1.9 1.9 0 0 1 .201-.573 5 5 0 0 0 .195-.522 1.1 1.1 0 0 0-.355-.962c.402.137.556.24.589.595a2.1 2.1 0 0 0-.286 1.084c-.012.732.221 1.213.675 1.39.447.175.563.232.564.232l.023-.045a3 3 0 0 0 .08.765l.006.036a3 3 0 0 0-.43-.478l.001-.002Zm-1.626-2.16a3 3 0 0 1 .053.366.21.21 0 0 1-.062.17c-.183.187-.668.182-.757.18l-.093-.097a1.67 1.67 0 0 0 .717-.471c.146-.236-.076-.457-.379-.67a3 3 0 0 1 .412.017q.051.004.1.004a1.1 1.1 0 0 0 .53-.13 1 1 0 0 0 .154-.111.6.6 0 0 1-.004.262c-.024.078-.058.153-.086.23-.087-.102-.269-.281-.462-.235-.205.049-.169.24-.123.485m-.928.547a1.26 1.26 0 0 1-.46-1.038 4 4 0 0 1 .176-.724.66.66 0 0 0 .286.539l.05.033c.392.25.797.509.654.742a1.6 1.6 0 0 1-.706.448m-1.277-.862a1 1 0 0 0 .06.124 2.5 2.5 0 0 0-.617-.29.447.447 0 0 1-.352-.502h-.003c.099-.23-.16-.665-.395-.99a1.66 1.66 0 0 0 .837.412c.663.09.654.327.654.334a.85.85 0 0 0-.184.912m-.259 1.308a1 1 0 0 0 .04.08 5.4 5.4 0 0 0-.747-.322c-.275-.097-.255-.156-.172-.403a3 3 0 0 0 .08-.293.48.48 0 0 1 .445-.076.76.76 0 0 1 .495.349.15.15 0 0 1 .013.124l.03.015a.53.53 0 0 0-.184.526m-.463 1.863a2.2 2.2 0 0 0-.302.407.9.9 0 0 0-.037-.257.94.94 0 0 1 .281-.843 1.3 1.3 0 0 0 .18-.879.56.56 0 0 1 .028.423 3.2 3.2 0 0 0-.119 1.116l-.023.024-.01.005Zm-.131-.752a1 1 0 0 0-.253.393.46.46 0 0 0-.29-.578.51.51 0 0 1-.32-.323c-.112-.382.25-.717.423-.878q.024-.022.046-.046a.43.43 0 0 0 .241.163 1.4 1.4 0 0 1 .24.204 1.22 1.22 0 0 1-.087 1.065m-1.798.624a.48.48 0 0 0-.237-.206l.006-.011c.032-.067.053-.136.079-.205a2.4 2.4 0 0 1 .451.42l.076.097c.045.056.068.089.103.134a.88.88 0 0 1-.116.587 1.1 1.1 0 0 1-.678.246 1.5 1.5 0 0 1 .237-.557.56.56 0 0 0 .08-.505Zm-3.495-3.113a.6.6 0 0 0-.24-.284c-.053-.04-.095-.07-.098-.102-.002-.02.01-.06.08-.132a1.4 1.4 0 0 1 .56-.357c.164.17.249.378.048.814a1.85 1.85 0 0 1-.446.61.7.7 0 0 0 .096-.55Zm-4.318-4.288a1.36 1.36 0 0 1 .584.81 1.8 1.8 0 0 1-.02 1.046 2.5 2.5 0 0 1-.549-.866l-.017.005a3.6 3.6 0 0 0 .04-.56 1.8 1.8 0 0 0-.037-.435Zm.676.794a1.44 1.44 0 0 0-.652-.897l-.028.049a1.8 1.8 0 0 0-.166-.439 4.3 4.3 0 0 1 .911.669 2.3 2.3 0 0 0 .35.272 2 2 0 0 0-.03.819 1.4 1.4 0 0 0 .577.862 2.3 2.3 0 0 0 .478.28l.036-.086a1.4 1.4 0 0 0 .28.443 3 3 0 0 0 .06.436 4 4 0 0 0-.25-.317 2.36 2.36 0 0 0-.937-.583 2.4 2.4 0 0 1-.666-.365 1.9 1.9 0 0 0 .037-1.143m-2.508-4.046a.9.9 0 0 1-.294-.132c-.155-.104-.115-.26-.037-.509a1.1 1.1 0 0 0 .074-.493c.01.018.009.04.021.057a1 1 0 0 0 .552.24c-.002.01 0 .022-.003.033a5 5 0 0 1-.062.243 1.1 1.1 0 0 0-.002.912 1.7 1.7 0 0 0 .264.214l-.007.028c-.012.057-.033.112-.047.169l-.014-.003a2 2 0 0 1-.268.493c-.024.064-.028.13-.045.196a.67.67 0 0 1-.286-.577.47.47 0 0 1 .195-.389.29.29 0 0 0 .137-.265c-.018-.166-.073-.188-.178-.217m-.201-2.144a.75.75 0 0 0 .461.132l.023-.001a.56.56 0 0 0-.016.45c.01.016.028.026.04.041a1.7 1.7 0 0 1 .018.592.9.9 0 0 1-.49-.21.58.58 0 0 1-.042-.606 1 1 0 0 0 .054-.241.3.3 0 0 0-.048-.157m2.355-.48a.4.4 0 0 1 .28-.012.45.45 0 0 1 .244.266.9.9 0 0 1 .016.656c-.06-.224-.348-.398-.658-.553a2.65 2.65 0 0 1-.927-.853.4.4 0 0 0-.044-.076.8.8 0 0 1-.1-.305l-.004-.054a.45.45 0 0 0 .315.203.9.9 0 0 1 .352.14 1.07 1.07 0 0 1 .473.91l.094-.013a1.2 1.2 0 0 0-.041-.31Zm.492 1.648c.017.033.047.058.066.09a1.15 1.15 0 0 1-.666-.568.73.73 0 0 1 .069-.663c.355.193.509.347.495.512l-.009.016c-.048.083-.137.24.045.613m.391-1.788q-.049-.018-.097-.038a2 2 0 0 0-.122-.901 1 1 0 0 0-.096-.102 1.7 1.7 0 0 0 .344.197q-.002.018-.005.036a3 3 0 0 0-.073.595.5.5 0 0 0 .05.213Zm-1.606-1.83a.6.6 0 0 0 .108.095 1.9 1.9 0 0 1 .388.267 3.5 3.5 0 0 0-.034.732.68.68 0 0 0 .3.423 2.3 2.3 0 0 1-.418-.267.61.61 0 0 1-.292-.672 1.7 1.7 0 0 0 0-.4.5.5 0 0 0-.052-.178m.556 1.084a3.4 3.4 0 0 1 .033-.675 1.2 1.2 0 0 1 .711.519 1.9 1.9 0 0 1 .115.827c-.087-.036-.177-.063-.262-.104-.369-.183-.575-.38-.597-.567m.673-.493a2.2 2.2 0 0 1 .01-.82 2 2 0 0 0 .236.106l-.021.022a.9.9 0 0 1 .242.607 2.5 2.5 0 0 1-.049.384.9.9 0 0 1-.418-.3Zm1-2.762a.3.3 0 0 1 .138.153.75.75 0 0 1-.02.648c-.052-.022-.096-.056-.145-.082.01-.027.018-.046.032-.09a1.8 1.8 0 0 0-.005-.63Zm3.026.53c.111.323.215.365.375.406q.014.005.028.01l.003.005.002-.003a.7.7 0 0 1 .352.209c.033.034.059.075.091.11a.85.85 0 0 0 .154.77 1 1 0 0 0 .201.123l-.037.013a2.5 2.5 0 0 0 .56.566c.063.051.114.114.171.17a2.12 2.12 0 0 0-.69 1.371 2 2 0 0 0-.119-.247c-.214-.373-.15-.447-.034-.58a.9.9 0 0 0 .17-.26c.142-.35-.116-.665-.508-1.145q-.079-.094-.164-.2a2.5 2.5 0 0 1-.62-1.263l-.12-.418a3 3 0 0 1-.102-.457q.002-.013.003-.026a2 2 0 0 0-.02-.121.7.7 0 0 1 .044-.266.95.95 0 0 0 .01-.607.94.94 0 0 0-.77-.687 2 2 0 0 0-.227-.024l.254-.169a.96.96 0 0 1 .905.666 2.7 2.7 0 0 1 .06 1.174 2.1 2.1 0 0 0 .028.88m3.711 4.587c-.186-.118-.399-.251-.646-.43a1.97 1.97 0 0 1-.69-.86c0-.02-.005-.04-.005-.06h-.016a4 4 0 0 0-.154-.683l-.003-.008-.005-.006c-.015-.019-.035-.033-.051-.051-.013-.04-.02-.082-.035-.121-.105-.207-.235-.398-.358-.594a1.68 1.68 0 0 1 1.176.939q.238.459.453.93a3.3 3.3 0 0 0 .414.705.79.79 0 0 0 .523.383c.124.03.181.044.202.348a.95.95 0 0 1-.084.45c0-.033.01-.065.01-.098 0-.386-.259-.55-.731-.844m.543 1.758a1.35 1.35 0 0 0 .564.927.76.76 0 0 0-.365.045c-.112-.522-.82-.99-1.018-1.11a2 2 0 0 0 .158-.381c.116-.436-.107-.64-.417-.92a5 5 0 0 1-.343-.33 2.25 2.25 0 0 1-.432-1.01 2.05 2.05 0 0 0 .61.668c.25.18.462.314.65.432.457.286.687.43.687.766 0 .132-.03.262-.041.393a.77.77 0 0 0-.053.52m-.962-4.182.006.009c-.007.054-.006.107-.009.161a7 7 0 0 0-.369-.526c.04-.036.164-.182.212-.675a.68.68 0 0 0-.14-.46 1.17 1.17 0 0 1 .497.602 1 1 0 0 1-.064.227.82.82 0 0 0-.133.662m.7-11.306a9 9 0 0 0 .771-.868 1.9 1.9 0 0 1 .137 1.395 2 2 0 0 0-.048.3 4 4 0 0 1-.448.528 3 3 0 0 0-.531.647q-.074-.076-.143-.155a3.23 3.23 0 0 0 .263-1.847Zm1.833-.281c-.012.014-.029.024-.041.038a5 5 0 0 0-.759.86c.004-.012.002-.025.006-.037a2.05 2.05 0 0 0-.169-1.571c.045-.06.097-.114.141-.175q.19-.249.334-.424a3 3 0 0 1 .356-.314 2.8 2.8 0 0 0-.125 1.064 3.5 3.5 0 0 0 .257.559m2.938 2.114a1.6 1.6 0 0 1-.682.17.6.6 0 0 1-.11-.02l.007-.047a.98.98 0 0 0-.31-.812c.294-.158.624-.332.978-.516a3 3 0 0 0-.063.46 1.13 1.13 0 0 0 .18.765m2.37-2.483c.364-.18.712-.348 1.028-.498.029.063.208.484.008.729a3 3 0 0 0-.135.493c-.072-.038-.14-.085-.216-.117a24 24 0 0 0-.759-.307c.025-.1.043-.202.077-.3Zm1.244-.285c.186.185.387.355.584.528a3.2 3.2 0 0 1-.645.634c-.049-.032-.103-.054-.154-.084a2.7 2.7 0 0 1 .116-.473.71.71 0 0 0 .099-.605m-.184 1.25c-.02.014-.036.022-.055.034l.007-.059q.025.013.048.026Zm.458 3.045a1.08 1.08 0 0 1 .465.62 2.7 2.7 0 0 1 .163.68 2.7 2.7 0 0 0 .041.885 1.35 1.35 0 0 1-.702-.443c-.055-.07-.12-.131-.179-.199l.032-.03a1.9 1.9 0 0 0 .553-.64c.07-.271-.185-.402-.41-.518-.177-.091-.36-.184-.405-.334v-.01a2.3 2.3 0 0 0 .236-.305.37.37 0 0 0 .206.294m-.2-1.27c.025.005.046.017.071.02l.175.048c.029.007.05.014.078.022a9 9 0 0 1-.23.451 2.7 2.7 0 0 0-.093-.54Zm5.71 6.33c.003.022.01.043.012.064a2 2 0 0 1-.075.279.9.9 0 0 1-.544.48 4 4 0 0 1-.542-.278 6 6 0 0 1-.317-.215 3 3 0 0 1 .149-.172l.15-.17c.09-.104.166-.217.245-.328.018.004.035.014.054.018a2.06 2.06 0 0 1 .868.323Zm-.864-.419a4.5 4.5 0 0 0 .307-.526 1.8 1.8 0 0 0 .284.303 1.5 1.5 0 0 1 .248.509 2.15 2.15 0 0 0-.825-.281Zm1.017.863a1.6 1.6 0 0 0 .01-.326 2 2 0 0 1 .369.368c.135.176.225.309.298.417a1.1 1.1 0 0 0 .265.32c-.042.056-.068.123-.116.175a2.3 2.3 0 0 1-.437.257 1.18 1.18 0 0 0-.638-.636 2 2 0 0 0 .25-.575Zm-.125-.844.025.019c0 .017.004.034.004.051zm5.17-5.706a1.17 1.17 0 0 1 .111-1.185q.04.053.077.107a5.8 5.8 0 0 0 1.869 1.91 2.6 2.6 0 0 1 .62.897l-.195-.031a18 18 0 0 1-.937-.168 6.3 6.3 0 0 0-.805-.531 26 26 0 0 1-.528-.332l-.074-.048a4 4 0 0 0-.138-.619m.033.552-.001-.001c-.7-.45-.827-.532-.68-1.21a2.7 2.7 0 0 1 .394-.833l.046-.075.001-.001a3 3 0 0 1 .222.25q.019.025.036.05c-.007.01-.01.021-.017.03a1.26 1.26 0 0 0-.124 1.266 4 4 0 0 1 .123.524m.277-2.264c.002-.06.01-.116.015-.175a7 7 0 0 0 .463.249 4 4 0 0 1 .902.55q.432.407.844.835a2.7 2.7 0 0 1 .291.676l.108.408a4.4 4.4 0 0 1 .213.98q-.161-.031-.3-.054a2.8 2.8 0 0 0-.707-1.04 5.7 5.7 0 0 1-1.832-1.873q-.057-.083-.12-.164a.9.9 0 0 0 .123-.392m-.065-.35c-.028-.023-.053-.05-.08-.073l.025-.006q.03-.006.063-.01-.005.044-.008.09Zm1.698-1.162c.03.002.058-.004.087-.003l-.055.019a2.2 2.2 0 0 1 .106.585c-.03-.046-.065-.088-.094-.135a1.8 1.8 0 0 1-.201-.485c.053.004.104.018.157.019m-.193-.165a2 2 0 0 1-.02-.162q.102.09.203.184c-.062-.001-.122-.017-.183-.022M51.81 26.23l.045.056a1.6 1.6 0 0 1 .339.498c-.118.062-.235.126-.358.178l-.084.034c-.056-.23-.115-.502-.183-.84-.149-.733-.028-.812.112-.903a.6.6 0 0 0 .157-.14c.073.057.14.12.212.178a1.1 1.1 0 0 0-.352.54.5.5 0 0 0 .112.399m-.207-1.095a.45.45 0 0 0-.223.29c-.01-.025-.028-.048-.039-.074a3.8 3.8 0 0 0 .174-.944 3 3 0 0 0 .002-.513.79.79 0 0 1 .316.767c-.017.334-.12.402-.23.474m-.327.093a2 2 0 0 0-.117-.22 5 5 0 0 1-.187-.326 3.4 3.4 0 0 0-1.962-1.797.89.89 0 0 1-.58-.495.86.86 0 0 1 .05-.574c.17.126.344.245.511.375q.67.51 1.366.984c.267.177.493.304.693.417.139.078.256.145.356.211a3 3 0 0 1 .015.596 3.8 3.8 0 0 1-.145.829m-.157-1.758c-.197-.112-.421-.24-.684-.412-.409-.27-.87-.615-1.36-.98-.141-.11-.29-.21-.433-.317.219-.021.437-.04.655-.071.026-.006.053-.004.08-.01a5 5 0 0 0 .546.528 4.6 4.6 0 0 0 .977.686.92.92 0 0 1 .476.729 7 7 0 0 0-.257-.153m-1.84-1.92a15 15 0 0 1-.806.088q-.103-.076-.206-.151c.178.007.356.003.534.015l.185.012.385.025c-.03.006-.061.004-.092.01Zm-.887.238a.94.94 0 0 0-.051.633.97.97 0 0 0 .636.552 3.32 3.32 0 0 1 1.913 1.755q.096.18.19.33a1.8 1.8 0 0 1 .283.667 3.5 3.5 0 0 0 .067.46c.07.345.13.628.189.865a8 8 0 0 0-.457.204 8 8 0 0 0-.29-.855 1.4 1.4 0 0 0-.162-.36 3.4 3.4 0 0 0-.322-1.185 2.5 2.5 0 0 0-.764-.64l-.026-.192c-.026-.192-.344-.422-.86-.781a12 12 0 0 1-.537-.387.99.99 0 0 1-.306-1.014l-.075-.023c.19-.008.382-.013.573-.029Zm2.934 7.868q.01.285.025.602a3.4 3.4 0 0 0-.474-.927 8.4 8.4 0 0 0 .345-1.137 8 8 0 0 1 .092.95c0 .14.006.309.011.473-.003.013-.011.025-.014.039Zm-.545-.463a2.2 2.2 0 0 1-.555-1.136 3.5 3.5 0 0 1 .845-.596c.033.131.068.262.094.394a8.5 8.5 0 0 1-.384 1.338M48.654 42.67c-.013.007-.027.01-.039.017l.006.01a5 5 0 0 1-.81.482c-.03-.066-.055-.135-.087-.2a5 5 0 0 1-.39-1.02 2.6 2.6 0 0 0 .691-.514 3 3 0 0 0 .524-.856l-.008-.003a.7.7 0 0 1 .238.014c.013.004.027 0 .04.003-.005.056-.019.173-.053.452a1.53 1.53 0 0 0 .184 1.158.15.15 0 0 1 .003.12.76.76 0 0 1-.23.28l-.072.052Zm-2-2.38a2.5 2.5 0 0 0-.655-.312 4 4 0 0 1 .691-.676l.003.002.001-.001.004-.008c.04-.03.074-.07.116-.098a.8.8 0 0 0 .19-.137 2.5 2.5 0 0 0 .634.614c.064.046.119.103.18.153q-.029.017-.058.033a1.7 1.7 0 0 0-.69.468.7.7 0 0 0-.09.245c-.03-.032-.065-.056-.097-.085l-.002-.008-.005.002a1.5 1.5 0 0 0-.222-.192m.114 1.12c-.125.457-.88.723-1.106.793a.9.9 0 0 0-.001-.23.76.76 0 0 1 .068-.42 1.2 1.2 0 0 1 .365-.442c.065-.055.147-.124.255-.224a1.1 1.1 0 0 0 .29-.427 2 2 0 0 1 .12.1 1.3 1.3 0 0 1 .01.85Zm-1.967-1.615c.088.299.194.592.308.882a2.3 2.3 0 0 1-.532-.516.76.76 0 0 1-.077-.76 1.5 1.5 0 0 0 .274-.247 1.6 1.6 0 0 0 .027.64Zm.136-.037a1.5 1.5 0 0 1 .006-.8l-.037-.012a1.4 1.4 0 0 0 .118-.25l.035.017h.001a1.2 1.2 0 0 1 .258-.213 1.6 1.6 0 0 1 .491.714 1.13 1.13 0 0 1 .024.744c-.062.08-.135.151-.192.236a5 5 0 0 1-.388.474 10 10 0 0 1-.316-.91m-2.409-1.325a1.5 1.5 0 0 0 .315-.236 3 3 0 0 1 .263-.223 2.3 2.3 0 0 1 .59-.34l-.006-.019a1.6 1.6 0 0 0 .294.05q-.589.833-1.239 1.62a4 4 0 0 0 .035-.36.53.53 0 0 0-.252-.492m-1.93.15a1.34 1.34 0 0 1-.884-.577 1.25 1.25 0 0 1-.207-.98.85.85 0 0 1 .711.046 4.1 4.1 0 0 1 .717.811.53.53 0 0 0-.382.565 1 1 0 0 0 .044.135Zm-1.26.244a1.6 1.6 0 0 1-.614-.397 1.75 1.75 0 0 0 .228-.85 1.42 1.42 0 0 0-.802-1.085q.017-.013.033-.026a1 1 0 0 0 .258-.53 1.53 1.53 0 0 0 .652.458h.013c.235 0 .682-.387 1.022-.718a2 2 0 0 0 .077.183 2.6 2.6 0 0 0-.423.355 1.8 1.8 0 0 0-.409.73l-.047.149.033-.015a1.36 1.36 0 0 0 .237 1.002 1.45 1.45 0 0 0 .496.464c-.112.102-.459.39-.754.28m.25.129-.03.03v-.02q.015-.006.03-.01m-2.201.496a9 9 0 0 1-.72-1.256 2 2 0 0 1 .079-.345 1.09 1.09 0 0 0 .723.378 1 1 0 0 0 .15-.014c.397-.071.685-.58.875-.915a1.4 1.4 0 0 1 .123-.196 1.3 1.3 0 0 1 .195.493c.102.848-1.106 1.657-1.425 1.854Zm1.281-.9-.024-.006.007-.01Zm-3.33-1.804a9 9 0 0 1-.037-.787 12 12 0 0 1 .144-1.21c.044-.021.183-.084.55-.234a2.4 2.4 0 0 0 .395-.235 3.4 3.4 0 0 0-.36.794l-.024.009.01.026a3.57 3.57 0 0 0 .117 2.17.8.8 0 0 1-.246.678 4 4 0 0 1-.378.305 2 2 0 0 0-.174.14 4.6 4.6 0 0 0 .002-1.656Zm-2.212-.729c-.201-.063-.61-.233-.601-.56a1.1 1.1 0 0 1 .271-.61c.1-.136.18-.256.152-.371a1.1 1.1 0 0 1 .36-.33.78.78 0 0 0 .29-.455 1.95 1.95 0 0 1 .253.836c-.019.013-.034.03-.053.042a1.6 1.6 0 0 0-.54.554 1.3 1.3 0 0 0-.132.894m-3.369-1.92a2.8 2.8 0 0 1 .211.662 2.2 2.2 0 0 1-.483-.352 1.17 1.17 0 0 1-.325-.741.4.4 0 0 0-.022-.149c.021-.143.239-.339.471-.52.02.017.028.042.05.056a1 1 0 0 0 .266.128l-.019.025a1.2 1.2 0 0 0-.177.22.67.67 0 0 0 .028.67Zm-.597 1.914-.21-.178a3.2 3.2 0 0 1-.668-1.182l.23.194-.002.026.038.005c.29.244.563.474.72.618l.071.067a1.13 1.13 0 0 1 .486.857 2.9 2.9 0 0 1-.133 1.093c-.015.057-.019.117-.032.175.014-.176.03-.365.05-.554.064-.606-.14-.778-.55-1.121m-4.48-6.197c.003-.055.021-.107.029-.162a1.2 1.2 0 0 0 .23.124c.017.068.036.14.066.242q.138.463.248.935a3 3 0 0 1 .108.463l-.012.003.015.04a3.3 3.3 0 0 1 .033.512 1.24 1.24 0 0 0-.28-.61 2 2 0 0 1-.397-.832 2.6 2.6 0 0 1-.037-.655l.013-.001Zm-4.062-7.665a.54.54 0 0 1-.106-.486.64.64 0 0 1 .38-.307 1 1 0 0 0 .172.068q.14.034.283.063a1.1 1.1 0 0 0 .006.79 2.6 2.6 0 0 0 .54.518 7 7 0 0 1 .515.45 1 1 0 0 1 .074.54 1.76 1.76 0 0 0-.786-.718 2 2 0 0 0-.384-.251l-.017.036-.062-.032c-.306-.157-.306-.157-.421-.353a7 7 0 0 0-.193-.316Zm1.924 1.859a1.05 1.05 0 0 0-.066-.828 7 7 0 0 0-.524-.458 2.5 2.5 0 0 1-.52-.495 1.02 1.02 0 0 1 .008-.72l.004.002c.43.089.8.166.957.473.194.377.152.502.152.502l.03.015a3 3 0 0 0 .003.33 2 2 0 0 0 .342 1.12q.066.106.127.216a2 2 0 0 0 .125.196 1.4 1.4 0 0 1-.113.624.4.4 0 0 1-.122.143c-.026.02-.052.043-.05.079l-.246-.106a.53.53 0 0 1-.3-.282 2 2 0 0 1 .123-.476.5.5 0 0 0 .07-.335m3.878-7.806c.04.01.078.03.118.04-.023.05-.035.103-.06.15a3 3 0 0 0-.323.868c0 .01.005.018.005.027a.6.6 0 0 1-.223-.18 1.2 1.2 0 0 0-.303-.23c-.002-.008.002-.017 0-.025l-.031.011-.074-.035a1.14 1.14 0 0 0 .35-.65 1.1 1.1 0 0 0 .26.118l.04.002a.36.36 0 0 0 .24-.096Zm.122.275q.01-.022.02-.043c.02-.04.03-.084.05-.124a2.3 2.3 0 0 1 .773.617 1.5 1.5 0 0 0 .083.227c.012.182-.074.254-.198.344a.7.7 0 0 0-.34.498 2 2 0 0 0-.011.173 2.7 2.7 0 0 1-.421-.335 2 2 0 0 0 .113-.743 3.3 3.3 0 0 0-.069-.614m2.386-.373a4 4 0 0 0-.463-.293 4 4 0 0 1-.538-.34 1 1 0 0 1-.052-.06 1.3 1.3 0 0 1 .412-.33 2 2 0 0 0 .187-.13.6.6 0 0 0 .384.435 1.5 1.5 0 0 0 .07.718m-.51-.212c.474.27.757.449.602.723-.22.388-.564.97-.678 1.163l-.097-.05a2.5 2.5 0 0 0-.756-1.117 2.6 2.6 0 0 1 .138-.764 1.3 1.3 0 0 1 .201-.354c.015.016.026.035.042.05a4.4 4.4 0 0 0 .548.349m1.632-.84a5 5 0 0 1-.21.735l-.031-.024a3.2 3.2 0 0 0-.744-.435l-.043-.02a2.6 2.6 0 0 1 .149-.383.85.85 0 0 1 .64-.42c.024-.005.039-.011.06-.017a.57.57 0 0 1 .18.564Zm-.082-.604.004-.005.013.022Zm.16.253a5 5 0 0 0 .489.583c.175.209.326.389.404.499a.72.72 0 0 1 .029.59 1.1 1.1 0 0 0-.04.383 63 63 0 0 0-1.092-.904l.01-.03a5 5 0 0 0 .215-.753.67.67 0 0 0-.016-.368Zm3.545 8.342a2.6 2.6 0 0 1-.264.969c-.278-.234-.551-.474-.85-.682l-.14-.104a2 2 0 0 0 .31-.25 1.85 1.85 0 0 0 .35-.839q.252.194.487.41a2.4 2.4 0 0 1 .107.496m.667-.967a1.7 1.7 0 0 1 .013-.316 1 1 0 0 1 .03-.108c.022-.009.148-.06.332-.138a2.5 2.5 0 0 0 .745.791.47.47 0 0 0 .037.363c.051.14-.01.205-.155.337a1 1 0 0 0-.093.115l-.008-.003-.001.015a1.2 1.2 0 0 0-.208.257 3 3 0 0 0-.114.355c-.186-.191-.38-.395-.595-.63-.069-.08-.147-.152-.22-.23a.4.4 0 0 0 .1-.091 1.18 1.18 0 0 0 .137-.717m-.071-.474a3.2 3.2 0 0 0 .118-.678q.128.053.321.12l-.16.169a.9.9 0 0 0-.279.389m1.36 1.018a.46.46 0 0 1-.046-.224c.094.067.19.135.304.207a4 4 0 0 0 .365.2c-.01 0-.018.004-.028.004a1.05 1.05 0 0 0-.532.188 4 4 0 0 0-.299.345.27.27 0 0 1-.017-.156c.023-.022.036-.054.061-.074.142-.131.278-.255.192-.49m3.78 1.843a1.4 1.4 0 0 0 .078.227c.111.269.167.454-.043.574a2 2 0 0 0-.428.375 2.7 2.7 0 0 1-.666-.671c.158-.276.33-.545.503-.812v.007c.141.02.516.116.555.3Zm2.916-1.227c.067.031.138.052.204.086l.021-.039c.163.154.325.31.494.457a4.8 4.8 0 0 0-.795.97l.026-.097a1.94 1.94 0 0 1-.746-.412 1 1 0 0 1 .107-.11 3.4 3.4 0 0 0 .482-.517 2 2 0 0 0 .206-.338Zm-.004-.103a5 5 0 0 0-.513-.214 1.2 1.2 0 0 1-.485-.23c.072-.11.138-.219.208-.328a7 7 0 0 1 .568.505c.11.112.232.21.344.318-.031-.015-.064-.025-.095-.04a.1.1 0 0 0-.013-.024Zm1.898-.2.007.011a5 5 0 0 0-.591.324 4 4 0 0 0-.299-.69 31 31 0 0 0-.357-.596c.526-.036.964-.062 1.395-.082l-.029.068a1.2 1.2 0 0 0-.126.965m1.648-1.22c-.272.006-.521.012-.758.019-.002-.068.013-.134.015-.2l.085-.005c.21-.017.421-.016.632-.027.01.07.015.143.026.214Zm-.011-1.699a3 3 0 0 0 .672.48l-.165.017-.152.017c-.108.021-.218.03-.327.048a15 15 0 0 1-.028-.562m-1.083-1.558a4 4 0 0 1 .337.546 3 3 0 0 0 .19.34 8 8 0 0 1-.222.868 7 7 0 0 1-.434-.642l-.043-.08a.6.6 0 0 1 .055-.186 1.56 1.56 0 0 0 .117-.847Zm.766 1.222c.055.067.105.14.165.202q.01.36.038.717c-.166.026-.331.056-.498.074q.134-.501.295-.993m-.236.266c.042-.142.067-.29.101-.434l.03.038c-.043.132-.09.263-.13.396Zm.292-.424q.05-.147.103-.294l.006.007c-.002.139-.007.278-.005.417a3 3 0 0 1-.104-.13m.155 1.218q.006.066.015.132l-.581.014q.008-.032.018-.065c.183-.019.365-.053.548-.081m-.524-.52q-.07.234-.134.47l-.06.003c.064-.158.14-.312.194-.474Zm-.025 1.168-.066.003.007-.092q.338 0 .674-.005l.008.067c-.208.011-.416.01-.623.027m-.049-.23c.007-.043.003-.088.01-.131l.62-.014.017.14q-.324.006-.647.005m.559-2.392-.003.009c-.02.049-.034.1-.052.149q-.045-.084-.085-.174a4.5 4.5 0 0 0 .039-.932q.084.016.174.035-.05.456-.073.913m-.12.34-.1.287q-.023-.036-.042-.07c.024-.116.06-.228.08-.344.022.04.038.087.063.126Zm-.136-.605q-.089-.236-.172-.485a3 3 0 0 0-.08-.274q.123.02.266.049a4.4 4.4 0 0 1-.014.71m-.028.273q-.002.023-.005.047c-.016.108-.054.211-.075.319-.037-.068-.08-.131-.112-.202a4 4 0 0 0-.448-.725c-.03-.033-.066-.059-.096-.092-.007-.018-.01-.037-.017-.055l-.029.012a6 6 0 0 0-.543-.515v-.002H44.1l-.028-.026c.233.044.463.1.697.136l.28.045a3 3 0 0 1 .101.346 7 7 0 0 0 .277.712m-1.315-1.007a2 2 0 0 0-.18.004 1 1 0 0 1 .113-.068c.024.02.044.044.067.064m.167.157c.093.088.19.17.278.264a1.44 1.44 0 0 1-.027 1.052 1 1 0 0 0-.023.074q-.016-.033-.034-.064a2.4 2.4 0 0 0-.486-.73 3.4 3.4 0 0 0-.47-.284 1.2 1.2 0 0 1 .181-.264.7.7 0 0 1 .148-.054 1.4 1.4 0 0 1 .433.006m.756 2.392c-.025.072-.059.14-.086.211a1.9 1.9 0 0 1-.352-.86 7 7 0 0 0 .438.649m-.061.522.077-.004-.015.055-.083.001Zm.131 1.037c.246-.007.505-.013.788-.019a3.6 3.6 0 0 1 .13.65l-.107-.12a.21.21 0 0 0-.222-.062.67.67 0 0 0-.388.542.62.62 0 0 1-.32.463l.01.026a1.7 1.7 0 0 1-.565-.36 1.01 1.01 0 0 0 .674-1.12M47.6 24.84a6.75 6.75 0 0 1 1.87 2.035 3.85 3.85 0 0 1 .261 1.64h.002a2 2 0 0 0-.069.155l-.046.153a3.2 3.2 0 0 0-.639-1.04 1.6 1.6 0 0 1-.413-.74 6 6 0 0 0-.326-.762l.022-.025-.053-.047c-.035-.07-.055-.147-.093-.216-.255-.472-.473-.725-.667-.775a.3.3 0 0 0-.25.052.56.56 0 0 0-.206-.163 2 2 0 0 1-.29-.185 1.17 1.17 0 0 0-1.148-.008 3.7 3.7 0 0 0 .47-1.046l.02.006-.02.107a4.1 4.1 0 0 1 1.575.859m.514-1.875c.165.129.357.262.543.39.348.244.781.546.801.686l.012.089c-.064-.032-.12-.078-.187-.104a5 5 0 0 1-1.091-.702c-.423-.404-.503-.43-.693-.366a.74.74 0 0 1-.361.035.82.82 0 0 1-.492-.337 1.3 1.3 0 0 0 .627-.2.74.74 0 0 0 .337-.63q.074-.002.148-.006a1.15 1.15 0 0 0 .356 1.145m1.896 8.775a4 4 0 0 0 .249.507l-.026.019a.69.69 0 0 1 .07.718 1.07 1.07 0 0 1-.436.336.96.96 0 0 0-.363.266c-.299-.246-.308-.405-.305-.43a2 2 0 0 0 .106-.229c.076-.102.164-.194.237-.297.112-.154.202-.275.25-.335a2.3 2.3 0 0 0 .075-1.378 1.72 1.72 0 0 0-.596-.855 4 4 0 0 0 .43-1.027l.097-.321a1.5 1.5 0 0 1 .194-.376 5.6 5.6 0 0 0 .567 1.378c-.06.134-.104.273-.17.404a1.54 1.54 0 0 0-.379 1.62m-2.946 5.072-.051.016.044-.031a1.96 1.96 0 0 1-.206-.825 1.1 1.1 0 0 1 .114-.627c.011.003.02.013.031.014l.014-.003a1.5 1.5 0 0 1 .722.424 1.8 1.8 0 0 1 .42.66l.001.005a1.76 1.76 0 0 1-.35 1.477 6 6 0 0 1-.557.676.8.8 0 0 0 .01-.216 5.5 5.5 0 0 0-.192-1.57m-.57 1.318c-.215-.388-.344-.51-.43-.54a5 5 0 0 1 .346-.694.8.8 0 0 0 .135-.492c.21.247.36.429.386.46a5.4 5.4 0 0 1 .183 1.516.68.68 0 0 1-.36.686 1.65 1.65 0 0 0-.26-.936m-3.105-1.093a1.23 1.23 0 0 0 .506.473 1.5 1.5 0 0 1-.617-.295c-.429-.43-.305-.602-.079-.915a2.2 2.2 0 0 0 .379-.73h.001c.03-.078.24-.185.462-.3.168-.08.321-.184.48-.28.018.026.024.058.041.085a3.2 3.2 0 0 1-.518.765c-.112.13-.223.24-.32.337-.279.276-.499.494-.335.86m-5.403-.591a1.4 1.4 0 0 0-.262-.08 2 2 0 0 1-.213-.07c-.263-.12-.37-.543-.37-.547l-.007.001a2.2 2.2 0 0 0 .5-.699l.062.068c.054.066.329.398.631.707a.9.9 0 0 1-.249.548c-.028.027-.063.045-.092.072m.546.544a1.1 1.1 0 0 0-.16.24c-.168.294-.446.787-.778.847a.91.91 0 0 1-.79-.35 2 2 0 0 1 .151-.303 3.6 3.6 0 0 1 .575-.445 4 4 0 0 0 .487-.38 1.27 1.27 0 0 1 .515.39Zm-8.535-5.895a.45.45 0 0 1-.272-.256 2 2 0 0 1 .375-.71 1 1 0 0 1 .081-.06 1.5 1.5 0 0 1 .193.395 2 2 0 0 1 .075.492h.016a1 1 0 0 0-.002.13.62.62 0 0 1-.466.009m.465.08v.01l-.012-.007Zm-3.567 1.169a.93.93 0 0 1 .198-.708 1.8 1.8 0 0 0 .197-.386.697.697 0 0 0-.233-.905 1.15 1.15 0 0 1-.366-.498.73.73 0 0 1 .117-.82l.003.009a.86.86 0 0 0 .182.583.34.34 0 0 0 .238.09l.054-.003a.52.52 0 0 0 .424-.335.38.38 0 0 0 .133.208c-.129.072-.608.377-.573.84a1.14 1.14 0 0 0 .182.528 1.13 1.13 0 0 1 .187.597 1.4 1.4 0 0 1-.027.54 1 1 0 0 0-.037.138 1.4 1.4 0 0 1-.302.505.5.5 0 0 0-.094.103l.001-.014c-.002 0-.204-.028-.284-.472m-.458.337a1.7 1.7 0 0 1 .21-.93c.107.05.177.092.19.126.004.01.006.025-.011.06l.009.004a1 1 0 0 0-.032.42c.072.407.245.51.325.538a.5.5 0 0 0-.053.176 1 1 0 0 0 .058.33 1 1 0 0 0-.105-.069 1 1 0 0 0-.13-.059.62.62 0 0 1-.46-.593Zm-1.58-4.515a1.4 1.4 0 0 1 .363.267 1.8 1.8 0 0 0 .219.354l-.328.422c-.16.204-.208.29-.19.452a2 2 0 0 1-.187-.114 2.6 2.6 0 0 1 .11-.478 3 3 0 0 0 .013-.903m-.572-2.035.007-.01a.63.63 0 0 0 .097-.528l.026.023a4 4 0 0 1 .546.487.33.33 0 0 0-.095.354.8.8 0 0 0 .293.38c.125.11.244.214.232.32-.006.06.026.079.04.084l.011.001q-.006.027-.011.053l-.003-.004-.014.007a.58.58 0 0 0-.352.545 1.13 1.13 0 0 1-.445-.647.46.46 0 0 1 .127-.42.38.38 0 0 0 .117-.336c-.04-.255-.378-.303-.576-.309m-.893-1.675a.87.87 0 0 1-.023-.718q.032-.114.058-.23a1.6 1.6 0 0 0-.003-.642 1.1 1.1 0 0 1-.02-.358.41.41 0 0 1 .428.275 1.56 1.56 0 0 0 .417.632 1.06 1.06 0 0 1-.005.717 5 5 0 0 1-.27.405 1.1 1.1 0 0 0-.216.38 3 3 0 0 1-.177-.189l.009-.01a2 2 0 0 1-.198-.262m-1.323-3.5c-.153-.193-.21-.418 0-.921a1.33 1.33 0 0 0 .126-.734 1 1 0 0 1 .008-.097h.012a.3.3 0 0 0-.007-.06.8.8 0 0 1 .017-.215.85.85 0 0 0 .05-.434 1.6 1.6 0 0 0 .177.51 2.4 2.4 0 0 0 .234.34l-.022.002a1.2 1.2 0 0 1-.152.63 1 1 0 0 1-.195.188.595.595 0 0 0-.296.604 2 2 0 0 0 .048.187m1.084-2.792.006-.012a1.4 1.4 0 0 1 .016.3.65.65 0 0 1-.22.528.54.54 0 0 0-.18.325 2 2 0 0 1-.242-.35 1.55 1.55 0 0 1-.125-1.233 1 1 0 0 0 .036-.222 1.1 1.1 0 0 0 .544.557l.096.043q-.01.014-.017.026Zm.103.013.212.096a.27.27 0 0 1 .065.169.6.6 0 0 1-.04.26 1.2 1.2 0 0 0-.059.534.51.51 0 0 0 .344.452.6.6 0 0 1 .115.068 2.2 2.2 0 0 0-.602.535q-.004.016-.009.033a1.1 1.1 0 0 0-.127-.257 1.4 1.4 0 0 1-.297-.722.45.45 0 0 1 .164-.3.74.74 0 0 0 .247-.591 2 2 0 0 0-.013-.277m.227-.034a.5.5 0 0 1-.136-.182c-.083-.183.106-.545.197-.687a.3.3 0 0 1 .04.04v-.01h.005a.53.53 0 0 0 .082.348c.051.086.076.13-.007.233a.6.6 0 0 1-.14.134.095.095 0 0 0-.04.124Zm.14.27a.7.7 0 0 0 .247.149.9.9 0 0 1 .376.217 1.1 1.1 0 0 1 .285.394l.024-.004a2.4 2.4 0 0 0-.394.535.4.4 0 0 0-.061.123.7.7 0 0 0-.278-.223.42.42 0 0 1-.294-.377 1.1 1.1 0 0 1 .053-.496.7.7 0 0 0 .046-.297q-.002-.011-.005-.021Zm1.775-1.541a1 1 0 0 1 .15.07.63.63 0 0 1-.131.55 8 8 0 0 1-.287.314 1.3 1.3 0 0 0-.22-.251 1.2 1.2 0 0 1-.24-.26 2.6 2.6 0 0 1-.228-1.104.54.54 0 0 1 .301.143c.046.054.088.115.13.173.128.18.26.368.488.368zm.648.473a.7.7 0 0 0 .135.075.84.84 0 0 0 .206.433 3 3 0 0 1-.123.322 3 3 0 0 0-.446.862 2.4 2.4 0 0 1-.404-.642 2.2 2.2 0 0 1 .192-.57 2.1 2.1 0 0 1 .452-.464Zm1.489-.048a1.55 1.55 0 0 0 .66.613 2.4 2.4 0 0 1 .07.308c.003.132 0 .245-.003.354-.128.095-.266.175-.4.262a4.3 4.3 0 0 0-.626-.454l-.15-.096q-.04-.026-.077-.052a2 2 0 0 1 .014-.22.6.6 0 0 1 .302-.436.42.42 0 0 0 .21-.28Zm-.045-.55a2.4 2.4 0 0 1 .616.895 1.2 1.2 0 0 1-.616-.895m6.254 5.969q.25.237.475.496c.235.257.449.48.65.686q-.005.017-.011.035a1.6 1.6 0 0 1-.225.587.46.46 0 0 1-.432.18c-.106-.095-.23-.209-.383-.358-.087-.08-.188-.145-.278-.223a2.7 2.7 0 0 0 .274-1.083 3 3 0 0 0-.07-.32m3.127 1.785a3 3 0 0 1-.087.357 1.4 1.4 0 0 0-.636.098q-.012.009-.024.018c-.049-.05-.094-.104-.143-.153l.01-.01a.3.3 0 0 1-.098-.22c.01-.09.092-.19.258-.31a.43.43 0 0 0 .201-.391c0-.017.012-.03.013-.047a3 3 0 0 1 .65.292 1.2 1.2 0 0 0-.144.366m.268-.299c.248.166.484.333.488.444q.001.073-.14.178a.62.62 0 0 1-.479.047c-.027-.006-.054 0-.081-.005.03-.11.062-.217.081-.33a1 1 0 0 1 .131-.334m1.966 1.664a3 3 0 0 0 .292.19 6 6 0 0 1 .794.504 2.7 2.7 0 0 0-.491.597 3 3 0 0 0-.142.269 1 1 0 0 1-.057.102c-.025-.016-.044-.039-.07-.052a4 4 0 0 1-.247-.166 2.1 2.1 0 0 1-.55-.718h-.002l.003-.018a2 2 0 0 1 .251-.6l.22-.108Zm-.114-.049.014-.016.008.005Zm3.694-.707a5 5 0 0 0 .55.27 7 7 0 0 1 1.34.7c-.113.157-.224.316-.344.469a11 11 0 0 0-.942-.673c-.233-.166-.453-.322-.63-.452-.048-.04-.085-.093-.13-.136.03-.03.054-.066.084-.096Zm-.316-.321h-.003a4.6 4.6 0 0 1 .544-.706c.068.105.201.332-.193.779l-.067.074a5 5 0 0 0-.28-.147Zm2.25.066a4 4 0 0 0-.289-.38 2.3 2.3 0 0 1-.627-1.047q-.006-.013-.01-.025c.078-.053.165-.093.247-.14a2.06 2.06 0 0 1 .832.407 1.8 1.8 0 0 0-.06.505 2.9 2.9 0 0 0 .352 1.229l-.02.028c-.037-.058-.08-.112-.116-.171a4 4 0 0 0-.305-.4l.001-.002Zm.367-1.333-.01-.022a9 9 0 0 0 .915.326 3.6 3.6 0 0 1-.459 1.019 2.65 2.65 0 0 0-.317-1.082 2 2 0 0 0-.184-.144.3.3 0 0 1 .059-.1Zm4.406 8.398a3 3 0 0 0-.613-1.07c.174-.261.31-.478.419-.662a1.6 1.6 0 0 1 .53.747c.034.26.137 1.049-.045 1.272a9 9 0 0 0-.255.34l-.02.024a1.7 1.7 0 0 0-.016-.651m-2.247 1.968a3.4 3.4 0 0 1-.15 1.321l-.014-.005a4.7 4.7 0 0 1-.612-.899q.217-.32.465-.68l.01.005.002-.021.013-.02.075.015a.04.04 0 0 1-.018.029.04.04 0 0 1-.024.007c.008.002.071.025.253.248m-.363 2.576a33 33 0 0 0-.375-.436c-.008-.007-.01-.02-.018-.026l-.002.003c-.217-.248-.45-.504-.668-.723q.254-.388.563-.848a4.7 4.7 0 0 0 .578.84 1.03 1.03 0 0 0-.15.704 2.4 2.4 0 0 0 .072.486m-4.319-5.17c-.057-.09-.103-.185-.166-.27a4 4 0 0 0-.435-.426 4.6 4.6 0 0 0 .411-.73l.014.003c.276.056.557.157.55.475a2.6 2.6 0 0 1-.374.948m.023.307-.076.055.038-.06c.007-.009.01-.02.017-.03q.011.018.021.035m-2.778 1.632a3 3 0 0 0-.479.463 4 4 0 0 0-1.033-.917c.15-.088.289-.192.446-.266l.003-.002h.014v-.008a4.1 4.1 0 0 0 .961-.639 5.4 5.4 0 0 1 .712 1.123 1.6 1.6 0 0 0-.624.246m.693-.118q.318.558.652 1.107c.072.114.16.216.235.328-.1.149-.473.661-.853.57-.375-.087-.923-.94-1.122-1.295a2.8 2.8 0 0 1 .48-.48 1.45 1.45 0 0 1 .608-.23m-5.99-3.628.021.007a3.4 3.4 0 0 1 .611-1.021c.032.041.07.078.101.12a3 3 0 0 0 .706.723 1.6 1.6 0 0 1-.262.357 3.8 3.8 0 0 1-.769.59c-.351-.312-.349-.545-.349-.545l.002-.01v-.01a.8.8 0 0 0-.061-.21Zm-.939 1.97a.83.83 0 0 1-.318.699 2.3 2.3 0 0 1-.617-.471 2.23 2.23 0 0 1-.558-1.546 1 1 0 0 1 .036-.274 2.3 2.3 0 0 0 .678.899 1.3 1.3 0 0 0 .517.235l-.002.003a.72.72 0 0 1 .264.455m-.692-.805a2.2 2.2 0 0 1-.694-.948c-.003-.01-.006-.008-.008-.015a1 1 0 0 1 .29-.356l.47.298a1.07 1.07 0 0 0 .436.758c.187.172.354.32.501.453l.033.03a1.26 1.26 0 0 1-1.028-.22m2.124-4.659c.06.16.124.34.203.572q.172.5.335.892a2.3 2.3 0 0 1-.327.702l-.014.016c-.023.023-.038.052-.06.076-.094-.113-.182-.23-.284-.336a1.54 1.54 0 0 0-.518-.39 1.8 1.8 0 0 0 .737-1.234 3 3 0 0 0-.072-.298m1.585 2.088a.68.68 0 0 1-.181.54 2.7 2.7 0 0 1-.718-1.177l.004-.011h-.008a14 14 0 0 1-.212-.543c.104-.059.198-.133.298-.2a4.4 4.4 0 0 1 .731 1.112.7.7 0 0 1 .086.252q-.007.011-.013.022Zm1.4 1.139a1.76 1.76 0 0 1 .445.702 9 9 0 0 0-.375.25q-.471-.42-.907-.88c-.02-.022-.047-.039-.067-.061.023-.084.04-.169.066-.251l.031.002h.001a.6.6 0 0 1 .124-.225l-.003.03a1.3 1.3 0 0 1 .684.433Zm.967-.562a1.35 1.35 0 0 1 .33.796h.002c-.251.12-.5.245-.738.39a1.85 1.85 0 0 0-.46-.722 1.4 1.4 0 0 0-.708-.45c.027-.03.047-.056.081-.09a1.4 1.4 0 0 1 .576-.267 1 1 0 0 0 .352-.14l-.002.006a1.8 1.8 0 0 1 .567.477m-.302-1.072a.4.4 0 0 1 .067.135.63.63 0 0 0 .319.473 1.8 1.8 0 0 1 .568.664c.057.118.1.243.148.365l-.009.006c-.115.047-.222.112-.335.164a1.46 1.46 0 0 0-.349-.827 1.8 1.8 0 0 0-.557-.473c.024-.02.051-.031.073-.052a.65.65 0 0 0 .075-.455m1.982-.737c.083.071.172.133.25.209-.03.076-.076.145-.102.223-.11.295-.195.539-.27.755a19 19 0 0 1-.135.375 1.3 1.3 0 0 1 .112-.508 1.9 1.9 0 0 0 .145-1.054m-.278 1.007a2.5 2.5 0 0 0-.125.487 9 9 0 0 0-.145-.296 1.3 1.3 0 0 0-.375-.436 1 1 0 0 0 .072-.124 3 3 0 0 1 .135-.257 3.2 3.2 0 0 1 .476-.582q.04.032.078.065a1.93 1.93 0 0 1-.116 1.143m-.396.256q.154.297.285.606l.001.002a.94.94 0 0 1-.37.43c-.047-.12-.09-.242-.146-.358a2 2 0 0 0-.606-.71l-.015-.014a1.1 1.1 0 0 0 .29-.127.9.9 0 0 0 .241-.208 1.15 1.15 0 0 1 .32.379m-.632-.293a1.3 1.3 0 0 1-.327.153.4.4 0 0 1-.142-.268.57.57 0 0 0-.193-.349 2.7 2.7 0 0 1 .03-.553 2.2 2.2 0 0 0 .504.623q.124.089.253.17c.028.014.05.039.076.056a.7.7 0 0 1-.201.168m-3.04.89a.6.6 0 0 0 .104.069 6 6 0 0 1 .533.498c-.038.134-.077.269-.108.405a3.8 3.8 0 0 1-.681-.41 1.7 1.7 0 0 0 .152-.563Zm-.27.482a2.9 2.9 0 0 1-.663-.682c-.038-.052-.085-.098-.124-.148.026-.029.045-.064.072-.091l.015-.016a2.3 2.3 0 0 0 .303-.613 3.9 3.9 0 0 0 .54.943 1.6 1.6 0 0 1-.144.607Zm1.024.194.008.008q.424.449.885.861c-.063.046-.132.082-.194.13a7 7 0 0 0-1.08 1.078c.04-.185.07-.386.099-.617a9 9 0 0 1 .282-1.46m.674 1.213a1 1 0 0 0 .087.463 1.2 1.2 0 0 1-.403.62.4.4 0 0 0-.157.155 2.4 2.4 0 0 0-.502-.247 6.7 6.7 0 0 1 .975-.99Zm-.362 1.347a.22.22 0 0 1 .12-.143 1.3 1.3 0 0 0 .407-.57c.009.012.01.027.018.039a1.14 1.14 0 0 0 .428.377c.151.087.242.139.259.333q.023.22.026.443a5.6 5.6 0 0 0-1.014.648 1.8 1.8 0 0 0-.057-.518 2 2 0 0 0-.114-.312.6.6 0 0 1-.078-.283l.011-.004Zm1.044-.42a1 1 0 0 1-.382-.333 1 1 0 0 1-.061-.131l.001-.003-.003-.001a.88.88 0 0 1-.102-.578c.063-.048.133-.085.197-.131.268.235.54.465.824.68a5.4 5.4 0 0 1 .752.73 4 4 0 0 1-.876.588c-.005-.127-.008-.253-.022-.378a.51.51 0 0 0-.328-.442Zm-1.373-2.626c-.024.073-.038.15-.06.224a5 5 0 0 0-.453-.418.7.7 0 0 0 .148-.2.9.9 0 0 0 .062-.406 2.7 2.7 0 0 1 .275-.464 1.3 1.3 0 0 1 .254-.225 2 2 0 0 0 .01.19 2.75 2.75 0 0 1-.236 1.299m-1.602-2.145c-.028-.08-.055-.149-.085-.235l-.133-.38a3.5 3.5 0 0 1 1.001-.978q.199.204.39.413a3.4 3.4 0 0 1-.552.762 5 5 0 0 1-.62.418Zm-1.357.792a1 1 0 0 1-.238.12 1 1 0 0 0-.12-.136q.503-.492.955-1.031a1 1 0 0 0 .232-.509 1 1 0 0 1 .038.296 1.68 1.68 0 0 1-.867 1.26m-.582 1.185c-.084-.037-.17-.07-.252-.113-.338-.185-.407-.252-.457-.447l-.008-.03a1.1 1.1 0 0 1 .084-.787l.14-.392a1.6 1.6 0 0 0 .44.465 1.3 1.3 0 0 1 .316.349.85.85 0 0 1-.263.955m1.07-2.32c-.368.454-.902.978-.938 1.014a1 1 0 0 0-.09-.103 1 1 0 0 1-.12-.103 3.3 3.3 0 0 1 .148-.8h.008l-.002-.015a.46.46 0 0 1 .292-.326 1.8 1.8 0 0 0 .3-.177 1.6 1.6 0 0 0 .446-.527q.067.1.127.21a.87.87 0 0 1-.172.827Zm-.457-.586a1.7 1.7 0 0 1-.286.168.54.54 0 0 0-.268.241c-.003-.013 0-.027-.004-.04-.063-.188-.342-.36-.45-.422a1.5 1.5 0 0 1 .484-.332 1 1 0 0 0 .244-.145 3 3 0 0 0 .307-.502 4 4 0 0 1 .418.495 1.56 1.56 0 0 1-.445.537m-.647.4a.5.5 0 0 1 .016.156 3.3 3.3 0 0 0-.146.765 1.47 1.47 0 0 1-.42-.845.72.72 0 0 1 .135-.451c.127.072.367.23.415.375m-.545.565h-.002l-.185.517a1.2 1.2 0 0 0-.122.417c-.218-.082-.583-.266-.589-.502-.007-.274.005-.286.203-.482q.075-.073.187-.19a1.3 1.3 0 0 0 .25-.35l.07.243.068-.02a1.6 1.6 0 0 0 .12.367m-.3 1.09a1.2 1.2 0 0 0 .025.298l.008.028c.066.253.171.34.526.535.056.029.115.05.171.077a1.07 1.07 0 0 0-.4.567c-.004.026.001.052 0 .078l-.438-.278a4 4 0 0 1-.459-.386v-.001a4 4 0 0 1-.446-.507 3 3 0 0 0-.246-.288l.011.005h.001a2 2 0 0 1 .403-.566l.132-.099c.11.304.572.488.712.537m1.227 2.733c-.115-.103-.23-.204-.364-.328a.98.98 0 0 1-.405-.82.94.94 0 0 1 .405-.587c.057.025.111.055.17.077a1.9 1.9 0 0 1 .567.307 2.2 2.2 0 0 1-.018.806 3.4 3.4 0 0 1-.355.545m-.142-1.79q-.036-.015-.073-.032a1 1 0 0 0 .271-1.008 1 1 0 0 0 .25-.116q.016-.011.032-.023l.023-.006c.054-.005.219.023.561.375.106.11.198.232.295.35a3.5 3.5 0 0 0-.597.973.7.7 0 0 0-.11-.129l-.001-.017-.012.002a1.9 1.9 0 0 0-.639-.368Zm2.021 1.014a1.9 1.9 0 0 1-.345.677l-.026.037a2 2 0 0 1-.25-.14c-.027-.02-.038-.035-.062-.054a3.8 3.8 0 0 0 .684-.52Zm-.234.765a2.03 2.03 0 0 0 .446-.982l-.01-.001a2 2 0 0 0 .151-.22 3.7 3.7 0 0 0 .715.424 9 9 0 0 0-.159 1.004 6 6 0 0 1-.121.72 1.3 1.3 0 0 0-.21-.547.75.75 0 0 0-.517-.297 2 2 0 0 1-.3-.093Zm1.036 1.296.012.002-.002-.024q.063-.086.13-.171a2 2 0 0 1 .554.284.9.9 0 0 0 .09.308 2 2 0 0 1 .107.293 1.7 1.7 0 0 1 .049.613 6 6 0 0 0-.544.495l-.019.025c-.04-.055-.113-.15-.253-.33-.268-.345-.504-.692-.41-.89a1.1 1.1 0 0 0 .09-.344 1 1 0 0 0 .196-.261m.503 1.892a5.4 5.4 0 0 1 .559-.507l.014.003v-.017a5 5 0 0 1 .574-.412l.04.029a3.7 3.7 0 0 1 1.04.942 3.1 3.1 0 0 1-.834.772 5 5 0 0 0-.556.375l-.953-1.032c.04-.05.072-.102.116-.153m1.936-2.877c-.27-.205-.527-.425-.782-.647a8.5 8.5 0 0 1 1.63-.907l.007-.005a5.5 5.5 0 0 1 .229.782 4 4 0 0 0 .285.879c-.185.22-.356.422-.491.573-.03.03-.067.052-.099.081a5.6 5.6 0 0 0-.779-.756m1.221-.811a6 6 0 0 0-.243-.82c.351-.199.473-.502.715-1.2.075-.215.16-.458.27-.752.015-.047.043-.087.06-.133l.038.046c-.016.03-.038.055-.053.085q-.08.248-.164.485a5.1 5.1 0 0 0-.37 1.598c-.02.572-.031 1.126-.037 1.4a4 4 0 0 1-.216-.71Zm4.912-.67c.183-.114.357-.238.534-.36a.78.78 0 0 1 .037.568c-.067.134-.156.256-.23.386-.37-.404-.323-.585-.323-.587Zm.267.718a8 8 0 0 1-.49.743 22 22 0 0 0-.555-.51 3.5 3.5 0 0 0 .493-.631l.01.002v-.021q.056-.094.101-.183.027-.02.055-.037a1.25 1.25 0 0 0 .386.637m-1.147.14c-.046-.039-.087-.083-.133-.121l-.447-.407.266-.253a2.5 2.5 0 0 0 .762.217 3.4 3.4 0 0 1-.448.564m0 .193c.194.168.38.344.567.52-.163.208-.32.422-.504.614-.031.026-.05.062-.08.09a31 31 0 0 1-.634-.652 8 8 0 0 0 .652-.572Zm.166 1.229c.184-.192.34-.406.504-.615q.293.278.574.569c-.264.255-.519.502-.733.711a1.3 1.3 0 0 0-.268-.42l-.16-.152c.03-.03.05-.066.083-.093m.889.332a1.34 1.34 0 0 0 .586.863 5 5 0 0 0 .962.652q-.228.33-.428.624a1.04 1.04 0 0 0-.698-.328 3.1 3.1 0 0 1-.684-.685 1.5 1.5 0 0 1-.185-.491 1 1 0 0 0-.049-.152zm.674.752c-.6-.478-.537-.852-.537-.855l-.024-.006.172-.166c.262.276.527.549.773.839a4 4 0 0 1 .433.743 5 5 0 0 1-.817-.555m-.969-1.808a8 8 0 0 0 .49-.735 5 5 0 0 0 .451.397c.108.087.196.195.3.289l-.655.628q-.286-.296-.586-.58Zm1.028-.45a5 5 0 0 1-.465-.41c.085-.147.185-.285.26-.437a.9.9 0 0 0-.052-.698l.074-.05a16 16 0 0 1 1.293 1.113c-.035.037-.062.08-.098.117l-.699.669c-.107-.098-.2-.212-.313-.303Zm-.062-1.677c.076-.055.16-.101.235-.158.058-.051.109-.109.165-.161l-.01.015q.528.368 1.045.75c.067.064.121.139.186.204a5 5 0 0 1-.36.438 16 16 0 0 0-1.261-1.088m1.52.333c-.575-.425-.976-.702-1.03-.74q.32-.298.616-.62l.126.125c.29.277.561.573.83.87l-.046-.018a4.6 4.6 0 0 1-.323.572c-.06-.06-.111-.13-.174-.19Zm-.189-1.336-.133-.131c.167-.187.333-.373.487-.571a4 4 0 0 0 .28.348 1.15 1.15 0 0 1 .29.438 6.6 6.6 0 0 1 .255 1.159c-.04-.045-.077-.081-.118-.128-.417-.485-.73-.791-1.061-1.115m.256-.803c-.154.198-.322.385-.489.573a21 21 0 0 1-.61-.628c.212-.29.413-.576.582-.848a2.4 2.4 0 0 0 .43.774c.028.042.066.077.095.118Zm-.58.681a11 11 0 0 1-.86.857c-.34.257-.698.488-1.06.714q.037-.09.071-.18c.05-.134.103-.271.173-.414a11 11 0 0 1 .957-1.437q.059-.08.116-.16c.226.242.424.444.602.62Zm-1.703.75a1.02 1.02 0 0 1 .031-.608 2 2 0 0 1 .162-.173c.058.06.125.11.182.17a11 11 0 0 0-.375.61Zm-.077-.7a.67.67 0 0 0-.09.42 1.2 1.2 0 0 0-.247-.283 6.6 6.6 0 0 0-1.001-.576c.183-.198.37-.393.539-.602a12 12 0 0 1 .967.864 2 2 0 0 0-.168.177m-.426.246a1.4 1.4 0 0 1 .331.507 1.8 1.8 0 0 0-.49-.227 2.9 2.9 0 0 1-.983-.722q.066-.068.13-.138a6.6 6.6 0 0 1 1.012.58m-.19.368a1.8 1.8 0 0 1 .578.287 6 6 0 0 0-.163.39c-.048.125-.097.25-.158.378l-.01.007.004.007q-.031.063-.067.128a2.4 2.4 0 0 1-.725-.192l.287-.276c.126-.124.25-.271.214-.426-.032-.137-.183-.244-.475-.338a.87.87 0 0 1-.612-.58l-.01.002c.042-.041.08-.087.121-.13a3 3 0 0 0 1.016.743m-.558.1c.291.093.367.179.381.235.015.068-.04.16-.176.293-.095.092-.212.205-.327.314-.056-.028-.117-.044-.171-.077a2.64 2.64 0 0 1-.798-.94c.12-.122.233-.251.354-.371q.031-.034.063-.067a1 1 0 0 0 .674.613m-.369.884c.043.026.093.038.138.062l-.232.22-.104-.097a2.3 2.3 0 0 1-.577-1.069 2.7 2.7 0 0 0 .775.884m-.768-.428a2.4 2.4 0 0 0 .472.714l.111.103a2 2 0 0 0-.285.173 1 1 0 0 0-.121.193.78.78 0 0 0-.602-.404 5 5 0 0 0 .186-.48.63.63 0 0 1 .24-.299Zm-.376.263a4.4 4.4 0 0 1-.613 1.28 4 4 0 0 0-.583-.393l.122-.143.023.006c.003-.01-.003-.02 0-.031q.62-.724 1.282-1.412a2.4 2.4 0 0 0 .1.294.76.76 0 0 0-.331.399m-1.759 1.55c.152-.19.315-.369.471-.554a4 4 0 0 1 .598.407c-.02.027-.032.057-.052.084a1.94 1.94 0 0 1-1.237.325l.032-.038h.003v-.004zm-.18-.006c.006-.288.017-.808.036-1.347a5 5 0 0 1 .082-.555 3 3 0 0 0 .496.642.42.42 0 0 1 .136.378c-.227.265-.46.525-.679.797Zm1.121-1.319a1.5 1.5 0 0 1-.034-.76 1.1 1.1 0 0 1 .37-.605l.01-.01a5 5 0 0 1 .495.47 34 34 0 0 0-.841.905m-.168-.8a1.6 1.6 0 0 0 .054.934l-.128.15a.55.55 0 0 0-.186-.342 2.9 2.9 0 0 1-.544-.74 5 5 0 0 1 .247-.786q.087-.239.167-.49l.015-.023a4 4 0 0 0 .517.436c.091.061.175.133.261.2a1.23 1.23 0 0 0-.403.66Zm-1.001 2.992a.56.56 0 0 0 .035-.465h.024a1.96 1.96 0 0 0 1.29-.37c.02-.025.032-.054.05-.08a4 4 0 0 1 .399.388c.075.102.132.215.198.323-.02.028-.03.06-.051.088q-.055.082-.086.133a3 3 0 0 1-.146.23 13 13 0 0 1-1.139.704l-.098-.06c-.668-.429-.579-.643-.476-.89Zm2.558-1.167.022.004a.8.8 0 0 1 .172-.42 2 2 0 0 1 .3-.181q.19.175.442.402c.043.036.082.078.125.115a9.3 9.3 0 0 1-1.11.914c-.095.076-.198.141-.295.215l-.054-.09a2.7 2.7 0 0 0 .398-.959m.033.948c.136-.098.25-.187.366-.276.126.133.395.414.654.671a2.13 2.13 0 0 0-.516.99l-.017-.02a4.6 4.6 0 0 1-.753-1.084c-.01-.02-.025-.038-.036-.059.1-.076.205-.143.302-.222m.622 1.515a2 2 0 0 1 .497-1.023l.158.152a1.2 1.2 0 0 1 .253.425c-.166.163-.309.305-.388.387-.107.093-.221.178-.331.268zm.08.298q-.054.045-.109.088a2 2 0 0 1-.004-.212zm.541-.26c.07-.072.193-.194.334-.333.006.026.02.05.024.076a1.7 1.7 0 0 0 .204.534 3.1 3.1 0 0 0 .681.696 2.6 2.6 0 0 1-.489.557 60 60 0 0 1-.597-.684l-.495-.57c.112-.092.229-.18.338-.275Zm1.367 1.027c.091.009.478.058.61.292l.006.01q-.323.478-.585.88l-.04-.041a10 10 0 0 1-.51-.533 2.5 2.5 0 0 0 .52-.608Zm1.233-.599a3.3 3.3 0 0 0-.484-.87c-.25-.297-.52-.576-.788-.857l.66-.634a7.4 7.4 0 0 1 1.23 1.48q-.333.471-.618.881m-.51-2.458.695-.665c.04-.04.069-.087.107-.127.023.023.051.041.075.065a3.36 3.36 0 0 1 .85 1.46l-.128.183c-.137.19-.26.365-.386.542a7.5 7.5 0 0 0-1.214-1.458Zm.975-.827c-.026-.026-.057-.047-.084-.072a5 5 0 0 0 .352-.42 7.2 7.2 0 0 1 .997 1.315 36 36 0 0 1-.41.592 3.44 3.44 0 0 0-.855-1.415m.342-.62a5 5 0 0 0 .333-.595c.051.057.109.109.159.167q.428.49.897.942l.079.078a14 14 0 0 1-.46.726 7.2 7.2 0 0 0-1.008-1.318m1.54.466-.052-.052a18 18 0 0 1-.66-.684l.049-.005a6.6 6.6 0 0 0-.286-1.33 1.3 1.3 0 0 0-.317-.481 4 4 0 0 1-.293-.364c.192-.246.4-.493.53-.644a6 6 0 0 1 .294.688 1.77 1.77 0 0 0 .444.792 3.1 3.1 0 0 1 .66 1.1l.039-.012-.009.029a4 4 0 0 1-.398.963Zm-1.65-3.028c-.02-.03-.048-.055-.068-.085a2.6 2.6 0 0 1-.457-.833 1.34 1.34 0 0 0 .255-.614c.009-.004.02-.004.027-.01a.16.16 0 0 1 .14-.034c.104.026.288.17.578.705.034.062.052.131.084.195-.12.137-.35.41-.558.676Zm-.662-.963c-.174.29-.4.609-.632.927q-.178-.193-.387-.431a7 7 0 0 1-.707-.907c.1-.143.199-.288.305-.435.075-.04.785-.406 1.181-.09a2 2 0 0 0 .312.199c.108.058.166.092.18.142.023.083-.052.26-.252.595m-1.856-2.125a2.8 2.8 0 0 1 .313 1.206l-.154.22a2.8 2.8 0 0 1-.306-1.094 2 2 0 0 1 .04-.414c.033.03.075.05.107.082m.043 1.838a7 7 0 0 0 .689.876c.05.058.093.103.14.157-.301-.18-.754-.455-1.053-.651q-.019-.012-.039-.024c.082-.117.176-.225.254-.345Zm1.073 1.34.012-.022.011.012-.131.18c-.147.186-.282.38-.416.575a11 11 0 0 0-1.246-1.136c.122-.154.236-.316.35-.477l.045.028c.485.318 1.365.835 1.375.84m-3.54-1.484q.314.229.632.454c.328.203.634.437.94.672-.153.189-.321.363-.485.542a1.4 1.4 0 0 0-.341-.395 9 9 0 0 1-1.012-1.268c.044-.049.084-.101.129-.148.048.045.086.1.137.143m.654 1.38a1 1 0 0 1 .328.4q-.083.09-.169.178a7.7 7.7 0 0 0-1.355-1.001 3 3 0 0 1-.329-.248c.155-.21.337-.398.51-.594a9 9 0 0 0 1.015 1.265m-1.239-.34a7.5 7.5 0 0 1 1.333.987c-.092.093-.173.196-.269.286-.193.19-.373.392-.561.588a4.7 4.7 0 0 0-.881-.77 4 4 0 0 1-.523-.444 9 9 0 0 1 .565-.9 3 3 0 0 0 .336.254Zm-.997.54c-.017-.023-.04-.05-.049-.064a3.6 3.6 0 0 1 .527-.866q.034.027.07.052a9 9 0 0 0-.548.878m-.146-.19c-.112-.106-.234-.2-.354-.298q-.003-.018-.007-.037l-.02.014a6 6 0 0 0-1.004-.675 3 3 0 0 1-.243-.158 1.97 1.97 0 0 0 .665-.813.4.4 0 0 0 .01.107.75.75 0 0 0 .527.4 2.15 2.15 0 0 1 .823.549c.034.033.079.053.114.086a3.8 3.8 0 0 0-.51.825Zm-2.304-.371c-.007.027-.008.055-.013.082l-.024.01q.01.015.017.03a2.7 2.7 0 0 0-.048.578l-.006-.018-.029.011c-.052-.042-.091-.081-.155-.129a6 6 0 0 1-.698-.594c.146-.055.646-.251 1.152-.484a2 2 0 0 0-.196.514m-.342.679c.07.051.11.09.163.132a.77.77 0 0 1 .001.592.95.95 0 0 1-.466.22 1.5 1.5 0 0 0-.635.303c-.04.04-.063.071-.094.106a2.8 2.8 0 0 0 .133-1 1.2 1.2 0 0 1 .005-.314l.001-.001v-.002a3 3 0 0 1 .197-.626 6 6 0 0 0 .695.59m-1.025-.028a1.4 1.4 0 0 0-.391.344 3 3 0 0 0-.21.357 1 1 0 0 0-.043-.163 4.5 4.5 0 0 0-.746-1.132c.081-.058.17-.104.247-.166a3.5 3.5 0 0 0 .566-.766c.146.161.308.307.448.474.11.134.233.254.353.378a3.7 3.7 0 0 0-.224.674m-.607-1.763a18 18 0 0 0-.344-.364 1.3 1.3 0 0 1 .526-.084 3.4 3.4 0 0 1-.182.448m-.358-1.558a.29.29 0 0 1-.143.28c-.204.149-.3.275-.315.41v.005q-.023-.025-.047-.05a47 47 0 0 1-.619-.611l.074.03a3.4 3.4 0 0 1 .242-.389.55.55 0 0 0 .264.118l.21.042a3 3 0 0 1 .356.089c-.003.026-.023.049-.022.076m-1.167-.01-.015-.016a2.7 2.7 0 0 1 .131-.408 1 1 0 0 1 .085-.105.4.4 0 0 0 .027.088c.007.01.02.016.028.027a3.5 3.5 0 0 0-.256.413Zm.563.756c.143.134.266.288.405.427a3.6 3.6 0 0 0-.96.928 2.3 2.3 0 0 0-.706-1.154.6.6 0 0 0 .4-.227 1.7 1.7 0 0 0 .236-.592c.225.227.432.429.625.618m-1.888-.19q.112.107.228.213a2.8 2.8 0 0 1-.328.54 1 1 0 0 1-.206.118 1.05 1.05 0 0 0-.728.851l-.048-.17c-.01-.022-.027-.039-.038-.06l-.006-.021-.005.003a1.1 1.1 0 0 0-.137-.219 2.3 2.3 0 0 0 .279-.763 2.4 2.4 0 0 0 .582-.425 3 3 0 0 0 .161-.264c.08.069.169.125.246.197m-1.376 1.155a1.1 1.1 0 0 0-.209-.166.75.75 0 0 1-.41-.783v-.005a2.2 2.2 0 0 1 .113-.618 1.7 1.7 0 0 0 .625.547.22.22 0 0 1 .127.145 1.55 1.55 0 0 1-.246.88m-.35-.11c.022.017.036.044.06.059a1 1 0 0 1 .414.435c.003.016.03.156-.27.473a7 7 0 0 1-.184.185.57.57 0 0 0-.229.432 1.3 1.3 0 0 1-.306-.323c-.206-.291-.16-.386-.16-.386l-.006.006-.023-.025a2 2 0 0 1 .162-.317 1.8 1.8 0 0 1 .541-.538Zm-.629 1.342a1.8 1.8 0 0 0 .353.396l-.139.104a2 2 0 0 0-.417.57l-.008-.008c-.002-.01.003-.02.001-.03l-.023.003c-.048-.05-.084-.11-.135-.157a4 4 0 0 1-.42-.443q-.019-.02-.036-.042c-.014-.016-.017-.036-.029-.053a2.7 2.7 0 0 0 .682-.678 1 1 0 0 0 .171.338m-1.649 2.96c-.001.067-.032.338-.465.539q-.06.028-.12.06a4 4 0 0 1-.288-.29.85.85 0 0 1-.179-.55 1.26 1.26 0 0 0 .67.23q.234.013.37.012h.012Zm-.377-.104c-.47-.026-.823-.29-.823-.508a.8.8 0 0 1 .215-.43c.037-.046.063-.1.096-.149.013.013.029.022.041.035a2 2 0 0 1 .2.3.85.85 0 0 0 .332.382.9.9 0 0 0 .332.093.33.33 0 0 0 .084.277 3 3 0 0 1-.477 0m-2.666-1.14a.7.7 0 0 1-.183-.347.82.82 0 0 0 .582.25h.016c.162-.003.388-.224.5-.346 0 .013-.008.025-.008.038a.68.68 0 0 0 .191.52 1 1 0 0 0 .09.073.8.8 0 0 0-.133.318h-.036c0 .022-.014.514-.416.562a.26.26 0 0 1-.218-.063.8.8 0 0 1-.152-.514v-.006a.9.9 0 0 0-.233-.485m-1.106-1.369a.2.2 0 0 0 .04.02.82.82 0 0 1 .6.609 1.01 1.01 0 0 1-.321.894 3.4 3.4 0 0 1-.415-1.15 1.6 1.6 0 0 1 .096-.373m-.099-.13a.9.9 0 0 0-.246-.28.74.74 0 0 1-.263-.328c-.036-.164.025-.238.067-.268l.058.06a1.12 1.12 0 0 1 .387.785Zm.123.077.011-.026.011.01Zm.706.659a.92.92 0 0 0-.663-.675l-.031-.011a1.6 1.6 0 0 1 .125-.232c.022.024.032.055.056.077a1.6 1.6 0 0 0 1.003.304.97.97 0 0 0-.406.637 1 1 0 0 0 .005.108l-.036.018c.01.02.027.036.04.055a.8.8 0 0 0 .087.335c-.107.082-.418.338-.449.569-.039-.057-.06-.123-.096-.182a1.09 1.09 0 0 0 .365-1.003m-2.106-4.57a1.5 1.5 0 0 1-.268-.456.51.51 0 0 0-.5-.34 1 1 0 0 1 .032-.17c.082-.225.176-.306.24-.334a.2.2 0 0 1 .092-.014 1.5 1.5 0 0 0 .26.758 1.2 1.2 0 0 0 .156.535l-.016.01Zm-1.096-3.06a1.2 1.2 0 0 1 .154.3 4 4 0 0 0-.15.565.6.6 0 0 0-.174-.067c.011-.014.016-.031.027-.044l.067-.098a1.16 1.16 0 0 0 .076-.656m.089.91a4 4 0 0 1 .193-.731 1 1 0 0 1 .281-.294.94.94 0 0 1 .255.719 3 3 0 0 1-.116.58l-.004.002h.002a3 3 0 0 1-.098.29c-.05-.062-.091-.112-.147-.185a1.7 1.7 0 0 0-.39-.386Zm2.152-2.617a2.5 2.5 0 0 0 .461.717.8.8 0 0 0 .034.365c-.025-.027-.045-.058-.072-.083a4.4 4.4 0 0 1-.508-.903l-.009.004q.04-.068.071-.139c-.002.012-.009.022-.01.034Zm.356 1.066a1.7 1.7 0 0 1 .245.277l.021-.012a2 2 0 0 0 .118.163c.056.06.122.109.182.164h-.014c0 .044.013.086.017.13a1.3 1.3 0 0 0-.466.213.95.95 0 0 0-.204-.646 1.4 1.4 0 0 0-.485-.417 1.3 1.3 0 0 1-.29-.2.5.5 0 0 1-.063-.069 2 2 0 0 1 .171-.158 1.6 1.6 0 0 0 .27-.317 4.4 4.4 0 0 0 .498.872m.087 1.089c.058-.135.342-.233.494-.273a1.46 1.46 0 0 0 .584.96.6.6 0 0 1-.066.404 1.6 1.6 0 0 1-.207.175l-.15.119a1.7 1.7 0 0 1-.443-.475 3.6 3.6 0 0 0-.36-.45c-.015-.015-.036-.023-.052-.037l.013-.023a.94.94 0 0 0 .178-.404Zm1.389 5.94-.003.007a1 1 0 0 0-.067.134.55.55 0 0 0-.192-.22 2 2 0 0 0 .209-.317q.192-.367.05-.542a1.7 1.7 0 0 0-.596-.384.7.7 0 0 0 .011-.368 4 4 0 0 0 .444.198 2 2 0 0 1 .191.152.5.5 0 0 1 .156.273.4.4 0 0 0-.032.112 1.1 1.1 0 0 0 .362.685c-.122.02-.44.084-.533.27m.74.666c.11.206-.016.368-.15.538a.55.55 0 0 0-.132.192.56.56 0 0 0-.207-.232.63.63 0 0 1-.262-.294.89.89 0 0 1 .092-.821l.003-.006a1.83 1.83 0 0 1 .656.623m-3.29-4.863a.92.92 0 0 0 .47.563 2 2 0 0 0 .195.1l-.058-.021a1 1 0 0 0-.013.11 1.37 1.37 0 0 0-.657-.295l-.264-.075a.37.37 0 0 1-.157-.11v-.005h-.005a1.23 1.23 0 0 1-.233-.599c.192.21.345.326.487.33a3 3 0 0 0 .235.002m-.012-.446v-.002Zm.144-.19a6 6 0 0 1 .361-.497.94.94 0 0 1 .466 1.296 1.5 1.5 0 0 1-.296.393c-.047-.025-.097-.043-.14-.071a.845.845 0 0 1-.39-1.12Zm.563 1.314a2.1 2.1 0 0 0 .609.205.85.85 0 0 1 .373.13.47.47 0 0 0-.272.388 1 1 0 0 0-.028.258c-.01-.012-.014-.027-.025-.038a.68.68 0 0 0-.413-.317.32.32 0 0 1-.19-.116.59.59 0 0 1-.053-.51Zm.802.74c.06-.311.259-.331.267-.331h.003a.7.7 0 0 0 .206.289 1 1 0 0 0 .18.131 1.1 1.1 0 0 0-.184.655.67.67 0 0 0 .162.318c-.084-.04-.173-.07-.255-.114a.77.77 0 0 1-.321-.269.7.7 0 0 0-.063-.26 1 1 0 0 1 .005-.418Zm1.336-2.093a3 3 0 0 0 .499.199l.003-.019q.039.047.087.096a1.15 1.15 0 0 0-.689.569 2 2 0 0 0-.12.484 1.4 1.4 0 0 0-.288-.481 1 1 0 0 1 .15-.072c.15-.06.291-.118.35-.27a.95.95 0 0 0 .008-.506m1.144-.921q.03.025.06.05c.063.068.137.124.206.186a2 2 0 0 0-.162.214 2.05 2.05 0 0 0-.28.933 1.8 1.8 0 0 1-.539-.539 4.8 4.8 0 0 0 .715-.844m-.76.757a1.4 1.4 0 0 1-.106-.324 1.6 1.6 0 0 1 .015-1.051 4 4 0 0 1 .777.556 5 5 0 0 1-.686.819m1.081 1.247c-.016.139-.14.284-.356.417a.9.9 0 0 0-.404.44 2.4 2.4 0 0 0-.383-.445.404.404 0 0 1-.097-.493 2 2 0 0 0 .045-.172c.034-.19.336-.359.47-.419q.094.078.212.157l-.001.01h.015q.141.094.32.195c.047.025.081.048.123.072l-.014.015a.29.29 0 0 1 .07.223m.098 1.738a.76.76 0 0 1 .174-.488l.003-.003c.088-.108.188-.204.282-.305a1.3 1.3 0 0 1 .025.903 2.3 2.3 0 0 1-.319.532 1.3 1.3 0 0 1-.165-.637h.001Zm.105-.553a1 1 0 0 0-.186.444.8.8 0 0 0-.288-.25 2 2 0 0 0-.479-.19.82.82 0 0 1 .365-.637.5.5 0 0 0 .192.35.94.94 0 0 0 .44.236q-.022.023-.044.047m-1.438.499.015-.002c-.012-.082.14-.294.304-.39a.5.5 0 0 0 .073-.055.94.94 0 0 0 .226.528l-.043-.027a3.2 3.2 0 0 1-.433.507.65.65 0 0 0-.142-.561m-.606.534c-.022-.016-.041-.036-.064-.051-.172-.122-.308-.218-.33-.423a1.04 1.04 0 0 1 .175-.61 1 1 0 0 0 .138.055.65.65 0 0 1 .35.212c.31.322.476.665.394.815a2 2 0 0 0-.093.188c-.044.037-.082.08-.128.114a.4.4 0 0 0-.079.085.47.47 0 0 0-.157-.22 2 2 0 0 0-.157-.126l.004-.015q-.026-.012-.053-.024m.631-1.74c.314.315.39.438.396.486l.007-.001a1 1 0 0 0-.025.149l-.026.033a.02.02 0 0 1-.009-.015s-.006.028-.096.08a.83.83 0 0 0-.33.378q-.03-.038-.06-.073l.003-.002a2 2 0 0 1-.13-1.712 1.06 1.06 0 0 1 .66-.532l.007-.003c-.136.067-.433.236-.475.463a2 2 0 0 1-.042.163.49.49 0 0 0 .12.587Zm-.33.827a.74.74 0 0 0-.357-.207l-.009-.005a.81.81 0 0 0 .12-.601c-.07-.182-.294-.303-.49-.41-.01-.005-.017-.014-.026-.019.017-.027.025-.05.046-.078a1 1 0 0 1 .196-.179 1.36 1.36 0 0 1 .337.588l.033-.008a2.1 2.1 0 0 0 .15.92Zm.806-.01a2 2 0 0 1 .417.168.73.73 0 0 1 .313.29 1 1 0 0 0 .042.381 1.13 1.13 0 0 1-.518-.34.85.85 0 0 1-.254-.498Zm-.826-1.906c-.045.114-.157.16-.299.217a1 1 0 0 0-.177.086c-.02-.02-.034-.047-.056-.066a1.4 1.4 0 0 1-.33-.318q.076-.064.148-.118a1.6 1.6 0 0 0 .22-.188.7.7 0 0 0 .09-.393 3 3 0 0 0 .395.25.88.88 0 0 1 .009.53m-.591.31c.012.01.018.024.03.035a1 1 0 0 0-.211.196c-.018.024-.032.053-.05.078a.8.8 0 0 1-.167-.116.7.7 0 0 1-.056-.332v-.012c-.007-.049.043-.113.114-.18a1.6 1.6 0 0 0 .34.33Zm-.202.45c.011.004.02.013.032.016.182.098.39.21.446.36a.66.66 0 0 1-.103.528.8.8 0 0 1-.284-.155.53.53 0 0 1-.091-.749m.338 3.558a.6.6 0 0 0-.156-.088.74.74 0 0 1-.278-.174c-.19-.215-.085-.508.062-.838.008-.016.007-.033.014-.049a1.7 1.7 0 0 1 .549.353c.142.172-.14.593-.26.74Zm-.736-1.882a1 1 0 0 0 .286.217l.031.013a.62.62 0 0 1-.039.513 2.4 2.4 0 0 0-.136.385 3.7 3.7 0 0 1-.641-.168 2 2 0 0 1 .28-.507l.012-.012a.73.73 0 0 0 .207-.44Zm.146 1.521a.5.5 0 0 0 .086.16.8.8 0 0 0 .31.198c.158.07.295.13.347.327a1 1 0 0 0-.042.4l-.01-.043a1.7 1.7 0 0 1-1.158-.27 1 1 0 0 1-.06-.082 1.6 1.6 0 0 1 .313-.321.86.86 0 0 0 .214-.369m1.139-.44h.001a.5.5 0 0 0 0-.127.3.3 0 0 1 .122-.185 3 3 0 0 0 .34-.302 3.2 3.2 0 0 1 .08.847.39.39 0 0 1-.128.273c-.074.007-.085.026-.093.045a1.15 1.15 0 0 1-.322-.55Zm.635.247a3.3 3.3 0 0 0-.09-.937 3 3 0 0 0 .33-.415c.018.019.026.043.045.06a1.18 1.18 0 0 0 .644.395 1 1 0 0 0 .084.169q.009.012.018.025a2 2 0 0 1-.17.2 2.2 2.2 0 0 0-.546.804 5 5 0 0 0-.413-.043.6.6 0 0 0 .098-.258m.93-.44a2 2 0 0 0 .158-.184 3 3 0 0 0 .504.642 1.36 1.36 0 0 0-.319.75 1.12 1.12 0 0 0-.774-.442l-.087-.012a2.1 2.1 0 0 1 .518-.753Zm.22-.256a2.3 2.3 0 0 0 .215-.324l.08.039a6 6 0 0 1 .57.29c.02.011.037.028.057.04a2.6 2.6 0 0 1-.354.5c-.029.027-.043.065-.07.093a3 3 0 0 1-.498-.638m.64.607a2.7 2.7 0 0 0 .36-.51 1.3 1.3 0 0 1 .315.295l-.002.003a1.2 1.2 0 0 0-.346.628 3 3 0 0 1-.396-.326c.026-.028.04-.065.068-.09Zm.33-.644c-.02-.011-.036-.028-.057-.038a6 6 0 0 0-.579-.296q-.038-.016-.074-.036c.03-.06.07-.115.094-.177a1.4 1.4 0 0 0-.04-1.012c.052-.054.098-.114.153-.166q.023-.024.045-.05a6 6 0 0 0 .448.43.1.1 0 0 0 .029.055.79.79 0 0 1 .204.692 2.6 2.6 0 0 1-.224.598Zm-.569-1.792a6 6 0 0 0-.406.437.87.87 0 0 1-.443-.231c-.197-.18-.169-.32-.161-.35a.73.73 0 0 0 .384-.474.4.4 0 0 0-.024-.174 3 3 0 0 1 .388.282 1.4 1.4 0 0 0 .312.456c-.018.017-.032.037-.05.054m-.328-.687a4 4 0 0 0-.525-.334 4 4 0 0 1-.28-.168 1.73 1.73 0 0 1 .428-1.144c.041.035.078.077.121.11a1.15 1.15 0 0 1 .38.429c-.01.022-.028.038-.035.062a1.4 1.4 0 0 0-.09 1.045Zm-.39-1.784c-.065-.058-.134-.11-.193-.173-.026-.027-.058-.046-.085-.072a5 5 0 0 0 .297-.54 3.4 3.4 0 0 0 .498.32 2.1 2.1 0 0 0-.518.465Zm-.005-.932a3 3 0 0 1-.32-.284 1.38 1.38 0 0 1-.237-1.036v-.031c.026.046.075.12.173.267.107.158.227.338.293.46a2.6 2.6 0 0 0 .223.348c-.022.059-.055.113-.075.173-.015.036-.04.067-.057.103m-.395-.226a3.4 3.4 0 0 0 .348.31 5 5 0 0 1-.299.542 4 4 0 0 0-1.009-.69l-.017-.008c-.263-.14-.277-.166-.34-.5.051-.04.096-.085.15-.12.174-.097.331-.22.499-.33a4 4 0 0 1 .471.49l.026-.023a1.5 1.5 0 0 0 .171.329m-1.02.236.017.01c.05.023.095.058.145.084a1.6 1.6 0 0 0-.05.908 2.2 2.2 0 0 0-.54-.4 3.7 3.7 0 0 1-.596-.415 2 2 0 0 0 .15-.18 2.7 2.7 0 0 1 .496-.523.55.55 0 0 0 .378.516m-.477.683a2.2 2.2 0 0 1 .607.46c.005.026.004.041.01.069a1.3 1.3 0 0 0 .22.532 3.2 3.2 0 0 1-.878-.462 1.4 1.4 0 0 1-.631-1.082 3.8 3.8 0 0 0 .672.483m-1.106.895a1.8 1.8 0 0 0 .45.485c-.091.086-.157.172-.148.257a.51.51 0 0 0 .256.552.72.72 0 0 0-.1.463.78.78 0 0 0-.432-.187 2 2 0 0 1-.575-.192 1.17 1.17 0 0 0 .278-1.374.95.95 0 0 0-.48-.432c.046-.057.082-.121.13-.177a.7.7 0 0 1 .27.168 3.4 3.4 0 0 1 .351.437m-1.248.1a1 1 0 0 0-.058.224.6.6 0 0 1-.079-.094 1.4 1.4 0 0 0-.37-.37.7.7 0 0 0-.257-.109 3 3 0 0 0 .104-.554 1.02 1.02 0 0 0-.278-.782c.105-.079.188-.132.24-.165a.6.6 0 0 1 .1.118l.017-.01a.86.86 0 0 0 .338.644 1.1 1.1 0 0 0 .69.346 1 1 0 0 1 .082.021 6 6 0 0 0-.529.73Zm-.9.046a3 3 0 0 0 .107-.311c.014-.001.066 0 .237.105a1.3 1.3 0 0 1 .344.347c.058.077.092.115.13.127a1 1 0 0 0 .02.271c-.038.002-.1.002-.219-.001-.122-.004-.269-.116-.508-.396v-.021l-.027-.012h-.003c-.026-.031-.061-.078-.09-.113Zm.385 1.023c.037.027.066.067.111.08q.134.042.268.078c.304.082.591.16.648.312l.02-.008a.66.66 0 0 0 .096.397.4.4 0 0 0 .237.145.6.6 0 0 1 .363.283l.028.029a.6.6 0 0 1 .098.165l.005.03-.1-.1a1.08 1.08 0 0 0-.58-.316 6 6 0 0 1-.598-.223 1.14 1.14 0 0 1-.596-.872m.677 1.002c.16.066.322.13.487.182a1 1 0 0 1 .537.288l.202.202a.4.4 0 0 0 .028.065.64.64 0 0 1-.207.495 2 2 0 0 0-.298.536 1.37 1.37 0 0 1-.65-.463 1.9 1.9 0 0 1-.099-1.305m.81 1.889a2.3 2.3 0 0 0 .621.169.76.76 0 0 1-.224.6 1.7 1.7 0 0 0-.31.314.9.9 0 0 1-.193-.543 2 2 0 0 1 .106-.54m.835 2.276a.85.85 0 0 1 .542-.665 1 1 0 0 0 .056.214.72.72 0 0 0 .295.333.47.47 0 0 1 .192.212c-.131.15-.354.358-.472.36a.72.72 0 0 1-.606-.324 1 1 0 0 1-.007-.13m1.37.7a.57.57 0 0 1-.17-.448l.001-.01v-.01c-.02-.103.066-.213.157-.33a1 1 0 0 0 .187-.317c.12.074.25.133.375.2a.8.8 0 0 0-.127.199 1.34 1.34 0 0 0 .045 1.107.37.37 0 0 0-.17-.15 1 1 0 0 1-.299-.24Zm.457-.438a4 4 0 0 1 .453.376 2 2 0 0 1-.099.153.86.86 0 0 0-.197.366 1.1 1.1 0 0 1-.135-.255 1.25 1.25 0 0 1-.022-.64m1.44 1.097-.003.057a.8.8 0 0 1-.299-.086.78.78 0 0 1-.29-.344 2 2 0 0 0-.21-.314c-.02-.02-.043-.032-.062-.051.02-.033.045-.062.062-.096a1.5 1.5 0 0 0 .13-.416 1.38 1.38 0 0 1 .595.626.93.93 0 0 1 .077.624m-.887-.874c-.014.027-.034.05-.05.076a4 4 0 0 0-.48-.402 1 1 0 0 1 .03-.141.7.7 0 0 1 .124-.189c.105.054.204.119.312.167a1.4 1.4 0 0 1 .194.078 1.5 1.5 0 0 1-.13.41Zm-.397-.773c-.14-.074-.286-.14-.42-.225a.4.4 0 0 0-.047-.226 1.9 1.9 0 0 0-.671-.645 1 1 0 0 1 .45-.16l-.002-.021.019.017c.064.439.611.63.861.692.166.041.311.075.447.105a2.8 2.8 0 0 0-.637.463m.213-.66c-.69-.172-.801-.492-.8-.682l.018-.011a4 4 0 0 1 .682.064 1.03 1.03 0 0 1 .91.814l-.162-.034c-.187-.042-.398-.088-.648-.15Zm.764-.171.015-.086a1.27 1.27 0 0 1 .3-.714 3 3 0 0 0 .429.35 1.22 1.22 0 0 0 .292 1.024 4.4 4.4 0 0 0 .43.455c.019.017.032.04.05.058a8 8 0 0 0-.513-.378 2.4 2.4 0 0 0-.858-.33 1.2 1.2 0 0 0-.145-.38Zm.562 1.132a1.3 1.3 0 0 0 .05-.501 3 3 0 0 1 .339.156 7 7 0 0 1 .624.46 1.2 1.2 0 0 1-.118.542 2.2 2.2 0 0 1-.759.03.27.27 0 0 1-.187-.112c-.07-.115-.019-.31.035-.515Zm.449-.87a1.09 1.09 0 0 1 .239-1.374l.016-.018c.05-.045.088-.099.134-.147.022-.004.231-.026.359.433.125.45-.56.974-.748 1.107Zm.17-1.508a1.3 1.3 0 0 0-.331-.31 2.7 2.7 0 0 0 .235-.63.86.86 0 0 0-.124-.602 6 6 0 0 0 .477.354l.02-.035a1.7 1.7 0 0 0 .194.616 2.5 2.5 0 0 1-.47.607Zm.595-2.208c.032-.042.073-.077.107-.118a1.5 1.5 0 0 1 .077.777 2.5 2.5 0 0 1-.225.783 1.53 1.53 0 0 1 .041-1.442m-.116-.081a1.7 1.7 0 0 0-.22.926 6 6 0 0 1-1.031-.88 5 5 0 0 0 .312-.338.85.85 0 0 0 .213-.415 3.5 3.5 0 0 0 .404.23 1.3 1.3 0 0 1 .472.313c-.049.056-.105.105-.15.164m-1.013-.35c-.092.115-.197.219-.299.324a1 1 0 0 1-.115-.136.7.7 0 0 0-.13-.186 1.29 1.29 0 0 1-.007-1.204c.004-.016.017-.027.022-.042a4 4 0 0 0 .734.84l.002.002c.001 0 .046.076-.207.402m-.598-1.405a1.2 1.2 0 0 0-.373-.41c-.044-.033-.08-.074-.123-.11a2 2 0 0 1 .512-.46l.024-.017c.027.013.05.032.076.044-.011.023-.036.038-.039.064a.9.9 0 0 0 .244.553.83.83 0 0 0-.321.336m.162-1.028.002-.005a3.4 3.4 0 0 1-.663-.42c.021-.048.055-.089.075-.137.012-.037.033-.07.047-.106a2.6 2.6 0 0 0 .602.605c-.018.012-.03.025-.048.038-.009.005-.008.018-.016.025Zm-.555-.866a3 3 0 0 1-.185-.29 7 7 0 0 0-.298-.468 3 3 0 0 1-.171-.27c.16-.123.3-.268.45-.402.216.086.43.178.652.247l.041.014a3.3 3.3 0 0 1-.28.693 5 5 0 0 0-.209.476m-.087-1.536c.146-.134.304-.255.441-.4a1.3 1.3 0 0 0 .075-.245 1.7 1.7 0 0 1 .1.876l-.037-.012c-.197-.061-.387-.144-.58-.219Zm.466-.803a1.3 1.3 0 0 1-.108.36c-.141.147-.303.27-.454.407-.116-.046-.237-.081-.35-.132-.05-.023-.086-.046-.13-.069.116-.196.457-.774.676-1.161a.4.4 0 0 0 .045-.12 1.5 1.5 0 0 0 .315.32l.004.005a1.3 1.3 0 0 1 .011.359l-.016.009q.004.011.007.022m-.97.763c.094.042.194.07.29.11-.144.126-.279.263-.432.38.002-.095.005-.185.003-.295a3 3 0 0 0-.06-.266 2 2 0 0 0 .198.07Zm-.197 1.268a4 4 0 0 0-.373-.387c.11-.073.224-.14.331-.217a1.5 1.5 0 0 0 .042.604m-1.267-.926.152.097a4 4 0 0 1 .594.429c-.161.103-.312.222-.48.315-.043.028-.08.066-.121.097a6 6 0 0 0-.106-.481 1.6 1.6 0 0 1-.072-.48Zm.037.857.027.146a2.8 2.8 0 0 0-.55.57 2 2 0 0 1-.144.174c-.087-.077-.178-.149-.258-.233-.484-.563-.24-.994.196-1.65a2 2 0 0 0 .12-.3 3 3 0 0 0 .45.352 1.7 1.7 0 0 0 .071.565q.05.186.088.376m-.647-1.481a.67.67 0 0 1-.175-.47 3 3 0 0 1 .22-.634 2.5 2.5 0 0 1-.045 1.104m-.899.037a2.3 2.3 0 0 0-.169.5 1.3 1.3 0 0 0-.164-.4c.047-.047.133-.137.296-.322a.71.71 0 0 0 .152-.568 1.1 1.1 0 0 1 .223.182.7.7 0 0 0 .124.133 2.2 2.2 0 0 0-.462.475m-.261.52a1.5 1.5 0 0 1-.398.585c-.06.044-.108.101-.163.15a.3.3 0 0 1 .053-.243 1 1 0 0 0 .127-.396.68.68 0 0 1 .198-.5 1.2 1.2 0 0 1 .183.405Zm-.512.958a1.4 1.4 0 0 0 .31.21 1.3 1.3 0 0 1 .456.397.866.866 0 0 1-.009 1.092l-.008.013a.75.75 0 0 0-.375-.146 1 1 0 0 1-.218-.065 2.3 2.3 0 0 0 .093-.658 3.2 3.2 0 0 0-.315-.92l-.004.002.01-.01c.023.028.028.065.06.085m.155.848a2.2 2.2 0 0 1-.094.625 1 1 0 0 1-.324-.23c-.485-.47-.265-.724-.255-.734l.008-.011a2.3 2.3 0 0 1 .37-.509 3.2 3.2 0 0 1 .295.859m-2.59-2.405a1.6 1.6 0 0 0-.052.753 1 1 0 0 0-.269-.361.67.67 0 0 1-.137-.607l.45-.276c.03.041.095.173.008.49Zm-.388.459c.286.286.324.36.206.745-.008.025 0 .053-.007.08a.9.9 0 0 0-.423-.32 1.3 1.3 0 0 1-.33-.304 2.5 2.5 0 0 0 .11-.644l.256-.157a.76.76 0 0 0 .188.6m.45 2.08a1.2 1.2 0 0 0 .21-.203 1.27 1.27 0 0 0 .162-.62.2.2 0 0 0 .039.027 1.5 1.5 0 0 0 .191.513h-.007l.006.04a1.06 1.06 0 0 1-.04.762l-.066.097c-.023.026-.033.06-.054.088a.2.2 0 0 0-.052.01l.018.047a1.2 1.2 0 0 0-.185.493q-.156-.145-.322-.31a.8.8 0 0 1-.165-.427c-.046-.262.098-.38.264-.516Zm.492.8c.102.01.312.082.603.464.094.123.176.226.254.322-.022.003-.046-.008-.067.002a.62.62 0 0 0-.295.389 1 1 0 0 0-.04.204 3 3 0 0 0-.039-.263.66.66 0 0 0-.385-.393 8 8 0 0 1-.221-.2 1.1 1.1 0 0 1 .19-.525m-.023.803.007.006.01.003a.56.56 0 0 1 .333.339 2.5 2.5 0 0 1 .107.715h.03a1.5 1.5 0 0 1 0 .587q-.026.12-.057.224a1.25 1.25 0 0 0-.062.511c-.022-.037-.058-.064-.078-.102a5 5 0 0 0-.13-.22 1.9 1.9 0 0 1-.328-1.076 2.8 2.8 0 0 1 .093-1.058zm1.201 2.753a5 5 0 0 0 .277-.413 1.15 1.15 0 0 0 .051-.752 1.2 1.2 0 0 0 .332.264l.03.01a1.97 1.97 0 0 0 .108 1.39 2.3 2.3 0 0 0 .702.498 2 2 0 0 0-.11.578 1 1 0 0 0 .23.618 2 2 0 0 0-.115.188 1.22 1.22 0 0 0-.403-.807 4.5 4.5 0 0 0-.68-.625c-.04-.03-.073-.066-.112-.097-.003-.006 0-.014-.004-.02l-.011.007a7 7 0 0 1-.512-.442 1.1 1.1 0 0 1 .217-.397m1.355 2.827c-.008.042-.022.082-.027.125a3.2 3.2 0 0 0 .66 1.573.1.1 0 0 0 .032.009.05.05 0 0 0 .032-.01c.032-.026.023-.07.02-.09-.032-.165.248-.424.404-.546a1 1 0 0 0 .072.122.8.8 0 0 1 .179.325.7.7 0 0 0-.16.198.94.94 0 0 0-.017.73 1.76 1.76 0 0 0-.324.996 1.28 1.28 0 0 0 .265.748l-.145-.062c-.455-.191-.559-.44-.384-.918a1.54 1.54 0 0 0 .144-1.185.87.87 0 0 0-.338-.41 1.65 1.65 0 0 1-.508-.622l.008-.005-.023-.022c-.019-.04-.048-.072-.063-.112-.162-.407-.097-.687.173-.844m1.265 4.202a1.17 1.17 0 0 1-.3-.773 1.7 1.7 0 0 1 .28-.886 1.24 1.24 0 0 0 .344.453.61.61 0 0 1 .207.805 1.7 1.7 0 0 1-.187.367 1 1 0 0 0-.113.223.6.6 0 0 0-.214-.145l.011-.017Zm-1.484-2.355.322-.413a2 2 0 0 0 .188.182l-.028.018a1.3 1.3 0 0 1 .184.76 1.7 1.7 0 0 1-.215.454 1.8 1.8 0 0 0-.283.7l-.008-.034c-.104-.444-.188-.73-.25-.94-.13-.443-.13-.443.09-.727m.219 1.899a1.7 1.7 0 0 1 .313-.852 1.8 1.8 0 0 0 .226-.48 1.34 1.34 0 0 0-.141-.698.8.8 0 0 1 .264.328c.126.39.052.59-.143 1.124a.696.696 0 0 0 .436 1.037q.11.046.2.085a1.8 1.8 0 0 0-.192.657 1.2 1.2 0 0 0-.189-.344 1.2 1.2 0 0 0-.34-.23c-.177-.094-.334-.186-.382-.365-.013-.088-.037-.175-.057-.262Zm2.391-1.968a.74.74 0 0 1 .138-.405 1 1 0 0 0 .16.13c.089.05.148.085.172.168l.087-.025a1 1 0 0 0 .08.141.44.44 0 0 0 .133.25.93.93 0 0 0 .201.7c.083.1.184.184.276.277q-.104.057-.204.122a.7.7 0 0 0-.009-.182.9.9 0 0 0-.445-.551l-.059-.035c-.489-.288-.55-.325-.53-.59m.672.794a.72.72 0 0 1 .284.626 2 2 0 0 0-.207.165 1.6 1.6 0 0 0 .064-.305 1.8 1.8 0 0 0-.141-.486m-.19-.122.045.026a1.7 1.7 0 0 1 .192.582 1.5 1.5 0 0 1-.088.418 1.4 1.4 0 0 0-.227.304.92.92 0 0 1-.47-.731.96.96 0 0 1 .33-.732c.066.04.129.08.218.133m.2 1.112.022.009h.001c.005-.012.003-.025.008-.036a2 2 0 0 1 .33-.28h.006v-.004a3 3 0 0 1 .276-.16c.061.059.114.126.179.18a2 2 0 0 1 .12.122.49.49 0 0 1-.289.409 1.9 1.9 0 0 1-.434.15.9.9 0 0 0-.5.233l-.004-.014a.94.94 0 0 1 .286-.61Zm1.2.92a.67.67 0 0 0-.27.367 1.34 1.34 0 0 0-.301-.537 1.1 1.1 0 0 0-.77-.124 1.2 1.2 0 0 1 .383-.144 2 2 0 0 0 .457-.16.57.57 0 0 0 .315-.418c.033.036.074.065.103.104a2 2 0 0 0-.044.546 3 3 0 0 0 .127.366m-1.418-.213.004.018a1.04 1.04 0 0 1 .782.096 1.3 1.3 0 0 1 .334.688h.002a.58.58 0 0 0 .165.439 1.8 1.8 0 0 0-.443.45 2.5 2.5 0 0 0-.19-.367 10 10 0 0 0-.276-.415 1.8 1.8 0 0 1-.405-.857.2.2 0 0 1 .027-.052m1.212.801c.035-.307.117-.412.237-.497.015.037.022.077.04.114a3 3 0 0 1 .185.536l-.058.041c-.087.063-.18.13-.27.198a.48.48 0 0 1-.134-.391Zm.173-.964a2 2 0 0 1 .053-.56.53.53 0 0 0 .277.22 1.1 1.1 0 0 0 .277.039.5.5 0 0 0 .09-.021 2.4 2.4 0 0 1-.436.543 2 2 0 0 1-.149.1 3 3 0 0 1-.112-.321m.393-1.465a2.05 2.05 0 0 0-.407.771l-.014.005q.004.008.01.015-.005.018-.008.035a1 1 0 0 0-.1-.102c.001-.015.013-.027.012-.041l-.045.005a1.4 1.4 0 0 0-.123-.127c-.058-.048-.103-.108-.158-.16.032-.015.051-.033.085-.048.494-.229.52-.553.52-.628.047-.002.094-.001.141-.007a.5.5 0 0 0 .209.056l.04-.002a.78.78 0 0 0 .442-.264 1 1 0 0 0 .06.166 1.05 1.05 0 0 0-.664.326m.564-.601c.001.009.008.016.01.026l-.009-.006a.7.7 0 0 1-.413.26.4.4 0 0 1-.31-.123c-.081-.075-.066-.19-.046-.345a1.03 1.03 0 0 0-.088-.682 1.46 1.46 0 0 0-.917-.778c-.1-.045-.19-.105-.287-.154a3.1 3.1 0 0 1 .685-.472l-.004-.008.075.017a3 3 0 0 1 .668.18l-.013.004a1.3 1.3 0 0 1-.048.51l-.015.06a.8.8 0 0 0-.026.589.36.36 0 0 0 .247.155 1.4 1.4 0 0 0 .304.03 2.6 2.6 0 0 0 .432-.054c-.015.026-.02.057-.037.083a.9.9 0 0 0-.208.708m.313-.615a1.3 1.3 0 0 0 .23-.747 3 3 0 0 1 .235.276 4 4 0 0 0 .43.5.67.67 0 0 1-.302.68 8 8 0 0 1-.226.179 1.7 1.7 0 0 0-.287.214.97.97 0 0 1-.253-.504.76.76 0 0 1 .173-.598m.453.999q.117-.089.23-.181a.8.8 0 0 0 .359-.665q.143.133.299.25a1.13 1.13 0 0 0-.418.895 2.4 2.4 0 0 0 .029.443c-.133-.08-.358-.222-.69-.454-.035-.023-.054-.06-.084-.086a1.6 1.6 0 0 1 .275-.202m.605 1.153a2.4 2.4 0 0 0 .457.78 2.4 2.4 0 0 0 .287.26 1.38 1.38 0 0 0-.668.91 3 3 0 0 0-.613-.598l-.032-.026a12 12 0 0 1-.28-.241c.023-.018.042-.042.066-.06a4 4 0 0 0 .435-.364.97.97 0 0 0 .348-.66Zm.856 1.134a2.4 2.4 0 0 0 .425.245c.032.015.058.04.09.057a.9.9 0 0 0-.035.628 1.6 1.6 0 0 0 .169.376.65.65 0 0 1-.25.596 1.5 1.5 0 0 0-.361.32 1 1 0 0 0-.123-.14 1.57 1.57 0 0 1-.594-1.084 1.28 1.28 0 0 1 .68-.998Zm.618.9a.8.8 0 0 1 .017-.523 3 3 0 0 1 .413.262 3.8 3.8 0 0 1 .62.667 1.23 1.23 0 0 1-.328.84c-.06.057-.128.103-.193.154a2.1 2.1 0 0 0-.327-.957 1.4 1.4 0 0 1-.202-.443m.82 1.349a1.34 1.34 0 0 0 .309-.61 2.34 2.34 0 0 1-.018 1.729 1.26 1.26 0 0 1-.757-.047.364.364 0 0 1-.235-.45.1.1 0 0 0 0-.048 1.5 1.5 0 0 1 .315-.267 3 3 0 0 0 .386-.307m.2-1.177a3.6 3.6 0 0 0-.496-.54 3 3 0 0 0-.653-.413q-.018-.01-.036-.02a.96.96 0 0 0 .332-.777.84.84 0 0 0-.197-.42c.04.004.077.02.117.02a1.3 1.3 0 0 0 .404-.064c.493.443.737.693.757 1.05.027.493.02.578.02.58l.027.003a.57.57 0 0 0-.276.58Zm-.596-2.466-.03-.028a3.5 3.5 0 0 0 .378-.584 2.2 2.2 0 0 0 .049-.632.7.7 0 0 1 .063.213c-.006.068-.004.415.582.82a2 2 0 0 0 .25.14.94.94 0 0 0-.084 1.209 1.45 1.45 0 0 0 .46.49 2 2 0 0 1-.244.066 2.6 2.6 0 0 0-.442.134 5 5 0 0 0-.017-.535c-.025-.455-.34-.735-.965-1.293m1.327 1.064a.81.81 0 0 1 .095-1.069 2 2 0 0 0 .35.109.61.61 0 0 1 .435.242 1.18 1.18 0 0 1 .206.748c-.074.103-.162.195-.23.302a2 2 0 0 1-.324.17 1.06 1.06 0 0 1-.532-.502m1.231 1.68q.135.173.268.348a2.2 2.2 0 0 1-.754.559c-.236.096-.38.157-.465.195a11.6 11.6 0 0 1 .508-1.878 2.1 2.1 0 0 0 .443.776m.287.578.816.882c-.128.275-.425.791-.708.805-.334.016-.58-.472-.658-.646a3.5 3.5 0 0 1 .55-1.04Zm1.139 1.028a3.4 3.4 0 0 1 .531-.366 3.3 3.3 0 0 0 .843-.76c.169.29.696 1.133 1.132 1.28-.402.428-1.032 1.016-1.25 1.016h-.008c-.22-.015-.861-.702-1.248-1.17m2.67.186h.002c.388 0 .72-.414.85-.6l.067.094a2.6 2.6 0 0 1-.719.824 2.6 2.6 0 0 0-.395.204 1.5 1.5 0 0 1-.096-.22c.13-.13.234-.24.29-.302Zm1.006-.385c.11.152.21.31.327.458a3.7 3.7 0 0 1-.816.79 3 3 0 0 0-.306.204l-.002-.001a1.5 1.5 0 0 1-.348-.415 2.5 2.5 0 0 1 .399-.204 2.6 2.6 0 0 0 .746-.832m-1.267 1.111a1.6 1.6 0 0 0 .353.42 3 3 0 0 0-.503.471.9.9 0 0 0-.561-.033 1.7 1.7 0 0 1 .34-.55 2.5 2.5 0 0 1 .371-.308m.46.514c.115.096.229.19.325.266a2.5 2.5 0 0 1 .551.52.5.5 0 0 1 .092.25 4 4 0 0 1-.514.233c-.04.015-.071.03-.108.045a4.2 4.2 0 0 0-.771-.87c-.012-.008-.028-.008-.04-.015a3 3 0 0 1 .466-.429Zm.413.156-.289-.237a3 3 0 0 1 .27-.176 3.7 3.7 0 0 0 .771-.731l.001.01a1 1 0 0 0 .084-.031c.604.771.895 1.172.288 1.672a4 4 0 0 1-.44.296.56.56 0 0 0-.102-.247 2.6 2.6 0 0 0-.583-.556m.037-2.52a43 43 0 0 1-.667-1.132 5.6 5.6 0 0 0-.779-1.241c.035-.033.077-.058.111-.092.124-.14.276-.32.441-.516a.44.44 0 0 1-.023.416c-.112.268-.237.57.53 1.062.342.219.587.358.766.459a2 2 0 0 1 .205.138 1.9 1.9 0 0 0 .309.944.88.88 0 0 1 .217.94.55.55 0 0 1-.258.212 13 13 0 0 1-.852-1.19m.71-.994h-.006a2 2 0 0 0-.255-.174 17 17 0 0 1-.533-.314 11 11 0 0 0 1.472-.943q.014.021.026.042a4.7 4.7 0 0 0 .774 1.115l.088.097a2 2 0 0 0-.01.446q-.38.291-.783.554c-.035-.046-.086-.077-.119-.125a1.94 1.94 0 0 0-.653-.694Zm1.573.438c.008.055.002.11.015.165a2.3 2.3 0 0 0 .604.763 2 2 0 0 1 .347.364c-.148.09-.29.187-.446.262a3 3 0 0 0-.374.213.96.96 0 0 0-.48-.899 2.6 2.6 0 0 1-.367-.38q.358-.233.7-.488Zm1.088 1.22a2.2 2.2 0 0 0-.37-.393 2.3 2.3 0 0 1-.57-.71 2 2 0 0 1-.02-.221q.095-.076.189-.153c.163.186.331.38.497.573.2.232.402.466.597.685-.038.03-.07.067-.109.095-.068.047-.144.08-.214.125Zm.298-.011c.044-.03.078-.071.12-.104.184.205.361.394.517.543l.06.06c-.202.31-.383.594-.55.86a3 3 0 0 0-.049-.614 2.2 2.2 0 0 0-.297-.628c.065-.042.136-.073.199-.117m.134 1.636q.034-.05.067-.1c.18-.287.378-.596.598-.935.239.242.5.535.73.799.06.098.115.29-.082.624a3.7 3.7 0 0 0-.305.605.65.65 0 0 0-.205-.287 4 4 0 0 0-.806-.64c.003-.022 0-.044.003-.066m2.861-.751a1.6 1.6 0 0 0-.708-.428 3.4 3.4 0 0 0 .157-1.182c.035.047.061.079.102.137a2.1 2.1 0 0 1 .4.723.7.7 0 0 0 .056.177c.014.057.042.109.052.167l.045.003a4 4 0 0 0 .279.347q.01.009.023.018c-.18.088-.303.147-.315.152-.031-.037-.056-.08-.091-.114m-.016-1.043a5 5 0 0 0-.317-.511c-.363-.516-.51-.617-.584-.631l.48-.687c-.046.284-.002.716.681 1.037a2 2 0 0 1 .209.126c-.032.036-.058.077-.09.113a1.7 1.7 0 0 0-.38.553Zm.32-.92c-.771-.362-.627-.843-.557-1.074a.25.25 0 0 0 .014-.114l.425-.597.073-.104.048-.009a4.6 4.6 0 0 0 .505.682 1.2 1.2 0 0 1 .323.613c-.193.25-.383.5-.588.738a2 2 0 0 0-.243-.135m.608-1.316a4.5 4.5 0 0 1-.541-.731q.28-.396.487-.703a2.9 2.9 0 0 1 .562.987 1.6 1.6 0 0 1-.12.952l-.062.078a1.3 1.3 0 0 0-.326-.583m1.111-4.127a4 4 0 0 0-.124-.968l.053.113a1.2 1.2 0 0 0 .588-.727 1.8 1.8 0 0 0-.254-1.111 2 2 0 0 1 .454.505q.002.014.005.029h.008a1.2 1.2 0 0 1 .146.317l.004.012a8 8 0 0 1 .294.871 3.06 3.06 0 0 0-1.174.96Zm-.129-.984a4 4 0 0 0-.134-.483 6.85 6.85 0 0 0-1.907-2.08 4.1 4.1 0 0 0-1.3-.754 13.8 13.8 0 0 1 3.467 1.416c.128.217.495.884.385 1.263a1.1 1.1 0 0 1-.51.638Zm.226-2.01-.027-.043-.017.01a7 7 0 0 0-1.126-.588 2.5 2.5 0 0 0-.076-.353.85.85 0 0 0-.435-.468 1.7 1.7 0 0 1-.407-.33c-.225-.268-.18-.392-.168-.416a2 2 0 0 1 .394.328 5 5 0 0 0 1.123.725 2.5 2.5 0 0 1 1.044.768 3.4 3.4 0 0 1 .264.871 2.9 2.9 0 0 0-.569-.504m-2.763-2.947a1.15 1.15 0 0 1-.646.184c-.035-.048-.07-.092-.104-.148a4 4 0 0 1-.263-.523c.338-.006.71-.01 1.142-.014.05 0 .099-.006.149-.006a.6.6 0 0 1-.278.507m-.07.794a.9.9 0 0 0 .42-.041l.017-.004c-.023.093-.018.258.199.517a1.8 1.8 0 0 0 .44.357c.184.119.33.213.374.385.025.081.04.166.057.25-.745-.307-1.6-.577-2.462-.832l-.105-.033a3.7 3.7 0 0 0 .109-1.015l.02-.018-.019-.021a3.8 3.8 0 0 0-.127-.77c.115.275.533 1.168 1.077 1.225m-1.194.558a10 10 0 0 1-.825-.288.74.74 0 0 0 .338-.508.55.55 0 0 1 .287-.434.07.07 0 0 1 .08.02l.222.25a3.6 3.6 0 0 1-.102.96m-1.064-.241a.4.4 0 0 0-.05.08 2.1 2.1 0 0 0-.713-.357c.067-.036.131-.076.2-.109a1.6 1.6 0 0 0 .563.386m-.662 1.091a16 16 0 0 1-.983-.763q.172-.151.358-.285a2.46 2.46 0 0 0 .625 1.048m.213.28a4 4 0 0 1 .39.512c.046.077.102.148.15.223l-.04.058c-.079.122-.175.232-.258.351a7 7 0 0 0-1.377-.72 5 5 0 0 1-.5-.244l.041-.046c.478-.54.274-.845.198-.96l-.013-.021q.067-.07.139-.137.61.523 1.27.983Zm-1.422-.833.011-.012.002.012Zm-.747.992q.016-.029.035-.056c.01-.002.018-.011.028-.006.06.026.15.075.243.127l-.047.053c-.028.027-.049.06-.076.088a3 3 0 0 1-.184-.192c-.003-.005.002-.01 0-.014Zm.091.311a9 9 0 0 0-.75.868q-.03-.023-.061-.047c.032-.037.055-.08.088-.116a2.1 2.1 0 0 0 .511-.82q.02-.032.04-.065c.051.066.115.12.172.18m-.829.61c-.036.038-.06.086-.095.126-.033-.03-.075-.049-.107-.08a2.2 2.2 0 0 0-.859-.57c-.575-.173-.494-.533-.49-.548h-.002l.007-.013c.022-.047.055-.086.077-.132a.73.73 0 0 0 .453.205 1.05 1.05 0 0 1 .627.274c.074.054.15.11.24.168a1.3 1.3 0 0 0 .44.202 2 2 0 0 1-.291.368m-1.63-1.127a1.9 1.9 0 0 1-.74.947l-.043-.028a2 2 0 0 1 .394-.345c.297-.172.179-.46.083-.692a1.3 1.3 0 0 1-.074-.21c-.055-.26-.497-.35-.598-.368.049-.073.09-.15.139-.223l.01-.017a2.4 2.4 0 0 0 .416.358 5 5 0 0 1 .477.407q.013.01.025.02c-.027.052-.064.098-.089.15Zm-.956.974q-.057.075-.107.154c-.502.238-1.02.443-1.217.519l.017-.04q.302-.657.657-1.288a2.8 2.8 0 0 0 .65.655m-1.436.577-.028.066c-.102-.108-.21-.21-.304-.325-.15-.18-.325-.338-.482-.51a3.5 3.5 0 0 0 .219-.551c.032.004.064-.001.096.006a.74.74 0 0 0 .583-.074.39.39 0 0 0 .195-.296c-.005-.163-.184-.312-.55-.556a1.05 1.05 0 0 1 .366-.297 9.5 9.5 0 0 1 .517 1.326l.006-.002c-.22.397-.429.8-.618 1.213m-.394-2.308a3 3 0 0 0-.693-.31c.01-.02.005-.046.018-.065a2 2 0 0 1 .205-.226 2 2 0 0 0 .293-.344 1.05 1.05 0 0 1 .61.587 1.2 1.2 0 0 0-.433.358m-.217-1.11c-.018-.004-.033-.014-.051-.018-.048-.016-.093-.038-.14-.055a1 1 0 0 0 .353-.277 2 2 0 0 1-.162.35m-.1.115a2 2 0 0 1-.254.294 2 2 0 0 0-.22.246c-.022.033-.018.075-.032.112a3 3 0 0 0-.367-.092l-.208-.041a.4.4 0 0 1-.21-.093 3.4 3.4 0 0 1 .299-.345.96.96 0 0 1 .463-.154 1 1 0 0 0 .244-.039c.095.039.188.08.286.112ZM34.2 22.08a1.1 1.1 0 0 1-.11.63.24.24 0 0 1-.084.075 8 8 0 0 0-.38-.37 1.6 1.6 0 0 0 .259-.166 1.06 1.06 0 0 0 .327-.456 2 2 0 0 0-.012.287m-1.724 1.366c.305.212.585.456.868.696a3 3 0 0 1-.139.275 2.3 2.3 0 0 1-.479.348 1 1 0 0 0-.002-.09.36.36 0 0 0-.203-.231 1.57 1.57 0 0 1-.622-.564 2 2 0 0 1 .127-.297 1.4 1.4 0 0 1 .285-.26zm-.561.05a2.3 2.3 0 0 0-.168.381l-.017.013.007.01a2.3 2.3 0 0 0-.154.736 1.13 1.13 0 0 0 .114.572 1 1 0 0 0 .192.182 1.9 1.9 0 0 0-.558.563l-.003-.054c-.101-.364-.264-.482-.383-.52a2.6 2.6 0 0 0 .589-1.383c.044-.603-.06-.818-.12-.894.062-.067.118-.14.185-.202.016-.013.024-.033.04-.047.056.027.107.066.166.09l.003-.008q.178.147.388.304a1.5 1.5 0 0 0-.281.257m-.546-1.286a1.34 1.34 0 0 1 .19-.696.64.64 0 0 1 .332.829 2 2 0 0 1-.232.272.9.9 0 0 1-.29-.405m.132.59c-.071.065-.13.143-.196.214a1.4 1.4 0 0 0-.492-.33 3.3 3.3 0 0 1-.473-.268 4 4 0 0 1-.74-.856.7.7 0 0 1 .289-.3q.242.304.596.679.134.142.24.26a3 3 0 0 0 .788.587Zm-.915-1.321a2 2 0 0 0 0 .36c-.366-.39-.916-.979-.887-1.221a.08.08 0 0 1 .038-.063 2 2 0 0 0 .18-.129 1 1 0 0 0 .352.348c.134.098.285.167.427.252a.5.5 0 0 1-.045.179.65.65 0 0 0-.065.274m-.807-1.137a2.5 2.5 0 0 1-.63-.65 5 5 0 0 1 .232-.528 3.4 3.4 0 0 0 .286-.706c.466.155.717.267.773.66a1.29 1.29 0 0 1-.66 1.224Zm-.07-2.018a1.77 1.77 0 0 0-.143-1.063 1.3 1.3 0 0 0-.004-.306q.055.05.108.098a4.7 4.7 0 0 0 .399.82 2.2 2.2 0 0 1 .326.823 1.5 1.5 0 0 0-.685-.372Zm.026-1.87c.038-.153.089-.303.138-.452q.543.44 1.076.892a.5.5 0 0 1-.102.066 1.5 1.5 0 0 0-.636.377 10 10 0 0 1-.47-.41 1 1 0 0 1-.006-.473m-.015-.58.074.063a7 7 0 0 0-.151.496 1.2 1.2 0 0 0-.022.385c-.02-.02-.04-.035-.061-.056a1.43 1.43 0 0 1-.57-1.312l.017.008a3 3 0 0 1 .713.417Zm-2.228-.067a1.5 1.5 0 0 0-.166.703 2.8 2.8 0 0 0-.664-.322 5 5 0 0 0 .24-.592 1 1 0 0 0 .121.02 1.7 1.7 0 0 0 .655-.14 1.4 1.4 0 0 0-.186.33Zm-.154.913a2.3 2.3 0 0 0-.435-.349 2.7 2.7 0 0 1 .43.25c.002.033 0 .067.005.1Zm-1.936.058c-.205.025-.32-.138-.453-.325a3 3 0 0 0-.134-.18.9.9 0 0 0-.63-.212c.395-.24.746-.45 1.039-.625a2 2 0 0 0 .193.34 1.14 1.14 0 0 0 .373.363c-.034.175-.168.613-.388.639m-1.138-.618a1 1 0 0 1 .082.01 2.6 2.6 0 0 0 .245 1.178 1.3 1.3 0 0 0 .258.278 1.2 1.2 0 0 1 .172.197.75.75 0 0 0-.232.563.9.9 0 0 1-.117.358l-.028.038a.32.32 0 0 0-.007.31l-.026.025a1.4 1.4 0 0 0-.297-.403 1 1 0 0 0-.412-.241c-.142-.05-.245-.088-.288-.22l-.027-.08a1 1 0 0 1-.021-.068l.01-.008a.7.7 0 0 0 .162-.153.25.25 0 0 0 .014-.34.44.44 0 0 1-.071-.337.57.57 0 0 1 .214-.437c.044-.042.098-.094.166-.167a.6.6 0 0 0 .203-.503m-.272.439a4 4 0 0 1-.162.163.65.65 0 0 0-.23.442.6.6 0 0 0-.117-.09 1.14 1.14 0 0 1-.268-.463l.819-.499.132.002c.007.018.064.187-.174.445m-.912-.815c-.047-.043-.112-.109-.153-.148a2.8 2.8 0 0 1 .525-.66 4 4 0 0 0 .307-.362 2.4 2.4 0 0 0 .103.7c-.26.157-.525.308-.782.47m-.133.081-.178.108q.044-.102.093-.2c.031.029.053.065.085.092m.183.837a1.06 1.06 0 0 0 .305.493c.017.01.018.014.032.023-.031.049-.326.516-.205.783a.6.6 0 0 0 .085.114l-.138-.062a.1.1 0 0 0-.028-.017l-.006.002-.149-.067a1.14 1.14 0 0 1-.588-.844zm-.575-.599-.372.225a7 7 0 0 0 .437-.818c.046.05.09.103.139.15a3 3 0 0 0-.204.443m-.65.392-.497.299-.047-.15.027-.001a4 4 0 0 1 .14-1.293 2.4 2.4 0 0 1 .391-.839 4.5 4.5 0 0 0 .593.882 7 7 0 0 1-.607 1.102m-.523 1.282a2.4 2.4 0 0 1-.077.498 1.3 1.3 0 0 1-.153-.355zm-.12.61a2.4 2.4 0 0 1-.137.363 2 2 0 0 0-.132.316 2.7 2.7 0 0 1-.51-.73l.577-.359a1.3 1.3 0 0 0 .203.41Zm-.057.412a2.5 2.5 0 0 0 .128-.334 1.3 1.3 0 0 0 .335.282c.34.145.425.323.446.406a1 1 0 0 0-.013.156 1.23 1.23 0 0 1-.12.69c-.277.669-.119.9.134 1.154l.052.048a.4.4 0 0 0 .1.12l.01-.016q.15.144.305.284c0 .012-.007.022-.007.034l.04-.002q.04.037.079.073a3 3 0 0 0-.101.492 2 2 0 0 0-.108-.245c-.176-.342-.559-.426-1.002-.518a1 1 0 0 1 .056-.11 1.76 1.76 0 0 0 .28-1.187c-.02-.378-.298-.61-.59-.855q-.08-.068-.16-.138a2 2 0 0 1 .136-.334m1.799 6.403a.5.5 0 0 0 .146-.17 1.5 1.5 0 0 0 .117-.533c.038.05.084.094.127.14a2.7 2.7 0 0 0 .348.397 7 7 0 0 0 .538.463.56.56 0 0 1-.064.568l-.017.02c0-.18-.194-.346-.763-.656q-.198-.106-.305-.16a2 2 0 0 1-.127-.068Zm1.206 1.024c.185-.005.526.026.558.229a.29.29 0 0 1-.096.262.56.56 0 0 0-.148.492 1.2 1.2 0 0 0 .531.752 1.3 1.3 0 0 0 .066.252 1.4 1.4 0 0 0-.296-.185l-.053-.03a1.35 1.35 0 0 1-.826-.892.73.73 0 0 1 .198-.796zm.016 1.523a1.4 1.4 0 0 0 .501.33l.03.018a3.1 3.1 0 0 1 0 .936 2.7 2.7 0 0 0-.108.463c-.036-.025-.078-.041-.113-.068-.485-.327-.368-.912-.283-1.34a.9.9 0 0 0-.027-.34Zm1.24 4.64a1.4 1.4 0 0 0 .351.675q.128.122.25.25a1.7 1.7 0 0 0 .679.458c.709.349 1.028.674 1.006 1.024l-.024.36a2.35 2.35 0 0 0-1.573-1.33 1.46 1.46 0 0 1-.61-.362l-.001-.004-.005-.002a.72.72 0 0 1-.203-.395.7.7 0 0 1 .041-.226 3.4 3.4 0 0 0 .088-.447Zm.622 1.513a5 5 0 0 1-.089.624 1.5 1.5 0 0 0-.089-.413 4 4 0 0 0-.16-.378 2 2 0 0 0 .338.167m-.156.884a.37.37 0 0 0 .066-.252c-.014.077-.015.156-.033.233l-.018.05c-.025.062-.042.106-.02.15.028.059.105.082.332.149q.152.044.416.129l.242.077.078.025-.008.01a1.6 1.6 0 0 1 .434.624.8.8 0 0 1-.179.128 1.05 1.05 0 0 1-.579.115 2.5 2.5 0 0 0-.56-.018l-.164-.106-.05-.033a.7.7 0 0 1-.232-.714 4 4 0 0 1 .275-.567m1.013.447-.241-.077q-.267-.086-.418-.13a1 1 0 0 1-.275-.1.3.3 0 0 1 .023-.074l.02-.052a5 5 0 0 0 .124-.863 2.26 2.26 0 0 1 1.559 1.45c.027.109.038.22.055.332v.01c-.11-.258-.359-.342-.847-.496m.887.845a4 4 0 0 1 .001.457 3 3 0 0 0 .02.643c.073.398.512.774.919 1.092l-.021-.003a3 3 0 0 0-.013.347 11 11 0 0 0-.554-.226c-.523-.204-.623-.821-.616-1.302a2 2 0 0 1 .264-1.008m0-.69-.004-.025c-.016-.046-.044-.084-.063-.13l.052.005.028-.436c.016-.247-.076-.631-1.057-1.114a1.65 1.65 0 0 1-.653-.438c-.062-.064-.138-.144-.253-.254a1.31 1.31 0 0 1-.355-1.03l-.035-.004a3 3 0 0 0-.016-.306 1.2 1.2 0 0 0 .318.22 1.2 1.2 0 0 1 .314.21 1.1 1.1 0 0 1 .235.601v.006a.71.71 0 0 0 .52.672 1 1 0 0 1 .12.054 1.3 1.3 0 0 1 .185.115 1 1 0 0 0 .235.34c.138.14.374.348.632.568l-.027.005a2 2 0 0 1-.176.941m-.362-1.58a.9.9 0 0 1-.214-.307l.012-.01c-.008-.007-.02-.01-.028-.017a.95.95 0 0 1-.071-.388.37.37 0 0 1 .154-.28 1.4 1.4 0 0 0 .271-.395.86.86 0 0 0 .441.653c.541.254.514 1.299.487 1.669l-.308-.26c-.006-.023-.019-.042-.024-.064l-.04.009a13 13 0 0 1-.68-.61m2.291 1.815a.21.21 0 0 1 .117-.13.515.515 0 0 0 .219-.535c.21.123.372.239.393.447l.019.172a.81.81 0 0 1-.168.76 1.5 1.5 0 0 0-.156.275l-.014-.015a5 5 0 0 0-.11-.186c-.166-.28-.356-.597-.3-.788m.075-.214a.3.3 0 0 0-.165.188.4.4 0 0 0-.004.16 1.2 1.2 0 0 0-.264-.263l-.072-.066a23 23 0 0 0-.727-.626 4 4 0 0 0 .01-.733c-.054-.58-.235-.947-.539-1.09a.66.66 0 0 1-.41-.627 1.1 1.1 0 0 1 .081-.412l-.009-.004a1.5 1.5 0 0 0-.005-.395 1.2 1.2 0 0 0-.2-.64 1.04 1.04 0 0 1-.17-.488c-.033-.462.536-.76.542-.762l-.01-.031c.028.022.049.043.087.068a1.04 1.04 0 0 0-.345.793 1 1 0 0 0 .528.805.8.8 0 0 0-.066.307c.005.048.028.092.037.14q-.004.008-.007.015l.011.002a1.9 1.9 0 0 0 .42.902q.142.2.273.41a2 2 0 0 1 .216.436q-.003.008-.007.015a1.26 1.26 0 0 0 .375.96 2.3 2.3 0 0 0 .585.428c.02.195.005.423-.165.508m-.16-2.463c.088-.066.176-.13.254-.185l.145-.106a1.8 1.8 0 0 0 .376-.482 2 2 0 0 1-.054.206 2 2 0 0 1-.417.732 1 1 0 0 1-.304-.165m.344-.366-.01.006a3 3 0 0 0-.176-.515c-.02-.043-.028-.09-.046-.133l.013-.008q.083-.05.16-.108a2.4 2.4 0 0 0 .5-.62 1 1 0 0 0 .03.243l-.023.02a.7.7 0 0 1 .047.377l-.005-.001a1.74 1.74 0 0 1-.49.739m.49-1.837a2 2 0 0 0-.045-.303 1.6 1.6 0 0 0-.208-.427 1 1 0 0 1 .475-.193 1 1 0 0 0 .17.228 1.7 1.7 0 0 0-.391.694Zm.095.17a1.6 1.6 0 0 1 .395-.764c.034.03.056.071.094.097.235.169.48.322.727.47l-.04.026c.01.015.214.365-.255.813a4 4 0 0 1-.422.354c-.033.023-.057.054-.089.079a1.06 1.06 0 0 1-.41-1.075m.412 1.262c.093.083.187.164.296.255l.032.027c.078.064.137.115.2.169a3.4 3.4 0 0 1-.28 1.175 1.44 1.44 0 0 1-.695.585 1.4 1.4 0 0 1-.166-.362 1.55 1.55 0 0 1 .145-1.284 2.1 2.1 0 0 1 .468-.565m.37 1.695a3.5 3.5 0 0 0 .285-1.135c.235.208.334.336.307.47l-.004.022.008.02c.01.023.227.573-.632 1.274a3.4 3.4 0 0 0-.338.315 1.4 1.4 0 0 1-.365-.335 1.55 1.55 0 0 0 .738-.631Zm-.345 1.149c.027.014.05.034.077.047a4 4 0 0 0 .476.179 1.14 1.14 0 0 1-.224.837l-.245.303-.009-.01c-.378-.496-.489-.866-.075-1.356m.134-.083q-.02-.013-.04-.025a4 4 0 0 1 .305-.28 1.74 1.74 0 0 0 .694-1.014 1.7 1.7 0 0 0 .508.696 1.1 1.1 0 0 1 .17.186c.028.05-.05.156-.132.268a1.2 1.2 0 0 0-.254.52 3.8 3.8 0 0 1-1.251-.351m2.204.26q.017-.022.033-.044a.5.5 0 0 0 .332.43 1.3 1.3 0 0 0 .498.096 1.4 1.4 0 0 0 .207-.026 1.3 1.3 0 0 1-.204.189c-.19.14-.342.239-.49.335-.115.073-.212.168-.322.25a1.17 1.17 0 0 1-.054-1.23m.453 1.099c.143-.093.304-.198.496-.34.026-.02.042-.041.066-.06a1.44 1.44 0 0 1 .46.452 2.35 2.35 0 0 1 .365.99l.04-.005a4.5 4.5 0 0 1-.083 1.136l-.033-.085c-.11-.286-.308-.304-.702-.34a8 8 0 0 1-.556-.065 2.4 2.4 0 0 1-1.276-.595 5.6 5.6 0 0 1 1.223-1.088m1.327-.338q0 .401.036.802c.01.05.01.101.017.152a2.4 2.4 0 0 0-.283-.621 1.45 1.45 0 0 0-.467-.459c.596-.562.423-1.348.196-2.33l-.023-.099v-.01l-.001-.002c-.141-.624.207-.709.692-.823a2 2 0 0 0 .646-.235 11.5 11.5 0 0 0-.813 3.625m.946-.658c.126.238.367.588.7.588h.024a.46.46 0 0 0 .193-.062 1.04 1.04 0 0 0 .43.6 2 2 0 0 0 .231.078 1 1 0 0 1 .167.048 4 4 0 0 1-.4.31 3.6 3.6 0 0 0-.6.469 2 2 0 0 0-.28.667 4.06 4.06 0 0 1-.465-2.698m5.123 2.613a3.9 3.9 0 0 0 1.121-.628c.7-.577.343-1.087-.238-1.832a.7.7 0 0 0 .295-.258 1.015 1.015 0 0 0-.238-1.105 1.8 1.8 0 0 1-.255-.74 1.8 1.8 0 0 1 .505.58 2.7 2.7 0 0 0 .614.64c.33.269.546.447.411.959a2 2 0 0 1-.36.69c-.235.326-.42.583.093 1.096a1.6 1.6 0 0 0 .395.232 2.3 2.3 0 0 0-.549.315 3 3 0 0 0-.275.232 1.36 1.36 0 0 1-.76.4 1.87 1.87 0 0 1-1.191-.357 1.4 1.4 0 0 1 .432-.224m2.29-.933c-.12-.265.006-.407.304-.702q.17-.166.327-.346a3.3 3.3 0 0 0 .487-.703 2 2 0 0 1 .164.339 2.3 2.3 0 0 1 .031.832c-.227.363-.471.715-.715 1.067a1.12 1.12 0 0 1-.599-.487Zm1.186-.137-.059.157.272-.366a4 4 0 0 1 .766.614.52.52 0 0 1 .213.402l-.017.044v.005h.004c-.05.256-.369.487-.613.658a1 1 0 0 0-.198.172c.009-.04.028-.077.034-.12a.8.8 0 0 0-.121-.607.97.97 0 0 0-.698-.23c-.023.001-.043-.01-.066-.01q.247-.355.483-.719m.725 1.574a1.3 1.3 0 0 0 .591-.69c.026.01.128.071.35.473.361.649.23.968.209 1.012a4.3 4.3 0 0 0-.574.536 1.4 1.4 0 0 0-.062-.575 1.7 1.7 0 0 0-.514-.756m1.767 1.974a1.8 1.8 0 0 1 .626-.404c.038-.018.071-.044.108-.062a3.7 3.7 0 0 1 .506.541 1 1 0 0 0-.136.032 3 3 0 0 1-.287.116 1.75 1.75 0 0 0-.745.424.5.5 0 0 1-.099-.115.57.57 0 0 1 .027-.532m.865.355a3 3 0 0 0 .302-.122l.012-.003a2.9 2.9 0 0 1-.455.729 2.5 2.5 0 0 1-.627.47c-.016-.068-.042-.133-.056-.202-.057-.55.411-.721.824-.872m.844.327.052-.434.002-.023a.5.5 0 0 0 .195-.05 4.8 4.8 0 0 1 .246 1.276.96.96 0 0 1-.317.481.28.28 0 0 0-.008-.173 1.4 1.4 0 0 1-.17-1.077m.214-.635c-.07.058-.187.043-.322.023a.8.8 0 0 0-.196-.016 3.8 3.8 0 0 0-.54-.594c.097-.055.199-.103.291-.167a1.34 1.34 0 0 0 .33-.623 1.5 1.5 0 0 0 .149.175 1.24 1.24 0 0 1 .394.86.49.49 0 0 1-.106.342m-.855-.864a3 3 0 0 1-.317.18c-.076-.063-.144-.134-.225-.191a2.4 2.4 0 0 1-.607-.585 6 6 0 0 0 .801-.972 1.88 1.88 0 0 0 .371-1.602 1.9 1.9 0 0 0-.27-.49l.344-.167a2.3 2.3 0 0 0 .563.36c.44.224.682.369.545.757a.87.87 0 0 1-.543.52.784.784 0 0 0-.565.787 1.54 1.54 0 0 0 .221.738 1.23 1.23 0 0 1-.318.665m.06-4.037a3 3 0 0 1-.311-.395 2 2 0 0 0-.094-.273c-.007-.187.106-.386.384-.682.038-.043.07-.092.107-.135a1.61 1.61 0 0 1 .646 1.185h.001a35 35 0 0 1-.678.345q-.029-.022-.056-.045Zm.174-1.596c.2-.232.383-.475.57-.716a.85.85 0 0 0 .35.472 1 1 0 0 0-.066.086 8 8 0 0 0-.238 1.081 2 2 0 0 0-.044-.198 1.8 1.8 0 0 0-.572-.725m.985-.104c.01-.017.026-.029.036-.045a1.24 1.24 0 0 1 .44.638 1.76 1.76 0 0 1-.479.576l-.268.149a8 8 0 0 1 .271-1.318m.123-.154a.84.84 0 0 1 .325-.237 1.2 1.2 0 0 0 .49-.384.8.8 0 0 0 .09-.432c.026.036.047.076.074.112.037.047.065.1.1.148a10.4 10.4 0 0 1-.642 1.39 1.35 1.35 0 0 0-.437-.597m.537-1.986c-.192-.592-.079-.891.358-1.492.057-.11.094-.23.147-.342l.006.01a1.94 1.94 0 0 1 .422 1.71 7 7 0 0 1-.332 1.143q-.02-.032-.043-.064a4.3 4.3 0 0 1-.558-.965m.487-2.15a5.5 5.5 0 0 1-.537-1.35l.058-.066a2.24 2.24 0 0 0 .577 1.149l.01.015q-.053.127-.108.252m-3.31-7.85c-.505.006-.933.01-1.314.017q-.003-.015-.006-.031c-.01-.062-.013-.125-.021-.186q1.019-.05 2.039-.016.122.089.243.178a15 15 0 0 1-.94.039Zm-1.357-.341-.007-.062c.4-.006.8.008 1.201-.008.2-.005.399.006.599.006l.06.042q-.927-.023-1.853.022m1.19-.211c-.404.016-.809.003-1.213.009l-.017-.144c.448-.012.9-.025 1.338-.039q.131.084.262.17c-.124.001-.255 0-.37.004m-1.246-.276q-.01-.075-.017-.149c.112-.019.224-.027.335-.05l.152-.015.34-.037c.113.07.223.146.336.218q-.57.018-1.146.033m.705-.486a3 3 0 0 1-.767-.564c-.004-.14 0-.28 0-.42a1.33 1.33 0 0 0 .599.364 13 13 0 0 1 1.519.591c-.375.03-.783.072-1.213.118q-.069-.044-.138-.09Zm-.131-.756a1.22 1.22 0 0 1-.633-.436c.003-.135 0-.271.006-.407.085-.234.157-.451.234-.673a2.43 2.43 0 0 0 1.004.976 1.9 1.9 0 0 1 .85 1.104 13 13 0 0 0-1.46-.564Zm-.586-1.393c.01-.117.016-.234.028-.35l.088.019-.116.33Zm.162-.465-.125-.027c.036-.378.05-.757.057-1.137.015.01.026.023.042.032.056.05.122.085.181.129a6 6 0 0 1-.105.86c-.014.045-.035.097-.05.143m.026-1.21c-.033-.018-.058-.045-.089-.065q.007-.698-.052-1.395c.048.036.101.064.152.096l.006.059a5.7 5.7 0 0 1 .118 1.401c-.044-.034-.093-.06-.135-.096m-.146-1.573-.001-.015a4.3 4.3 0 0 0-.695-1.588l-.214-.343c-.143-.154-.298-.294-.448-.44a1.5 1.5 0 0 0 .351-.087c.044.038.097.065.139.107a5 5 0 0 0 .4.41 1.34 1.34 0 0 1 .518 1.184c.012.265.054.561.094.862-.047-.032-.1-.055-.144-.09m-1.03-1.872.215.344a4.1 4.1 0 0 1 .607 1.327 3 3 0 0 1-.271-.281 5 5 0 0 0-.413-.47 5 5 0 0 1-.569-.696 1 1 0 0 0-.004-.318 3 3 0 0 0-.098-.413h.01c.177.166.356.33.523.507m-.474.327a5.3 5.3 0 0 0 .544.659 5 5 0 0 1 .407.462 2.7 2.7 0 0 0 .41.427l.005.016q.06.693.058 1.388a1.86 1.86 0 0 1-.722-1.292 2 2 0 0 0-.112-.446c-.169-.395-.359-.517-.867-.841l-.342-.222h.002a1.2 1.2 0 0 0 .543-.036c.038-.02.053-.072.075-.115Zm-.327.45c.503.324.672.432.831.8a2 2 0 0 1 .105.426 1.96 1.96 0 0 0 .81 1.387 16 16 0 0 1-.06 1.208l-.192-.038a4.5 4.5 0 0 0-.222-1.045l-.108-.406a2.8 2.8 0 0 0-.86-1.394 6 6 0 0 1-.907-1.137l-.062-.102q.1-.002.202.001.264.176.463.3m-.723-.395-.09-.147a2 2 0 0 0 .211.148q-.06-.002-.12 0Zm0 .269a6 6 0 0 0 .829 1.056q-.076-.074-.15-.143a4 4 0 0 0-.924-.566 7 7 0 0 1-.497-.265l.016-.179a4 4 0 0 1 .619-.078c.036.06.07.112.107.175m-.717-.193c.04-.37.06-.687-.192-.847a.77.77 0 0 1-.324-.507.75.75 0 0 1 .305-.034c.036.074.082.158.127.24a2.4 2.4 0 0 0 .277.481c.073.12.137.23.221.366l.138.224a4 4 0 0 0-.552.077m.807 3.71c-.07-.017-.13-.029-.208-.047a2.7 2.7 0 0 1-.81-.27 1.5 1.5 0 0 0 .01-.33q.26.166.509.318c.176.095.333.217.499.328Zm-.24.09c.154.037.311.058.467.09a4.6 4.6 0 0 0-1.187.393c-.022-.004-.041-.015-.063-.02l-.009.055c-.129.064-.265.112-.388.189a2.04 2.04 0 0 0-.526.828 1.3 1.3 0 0 1 .015-.189 4.3 4.3 0 0 1 .541-1.05l.011-.012a1.5 1.5 0 0 0 .33-.547 2.8 2.8 0 0 0 .81.263Zm-1.212.223-.01.013a4.3 4.3 0 0 0-.455.84 2.3 2.3 0 0 0 .022-.453.23.23 0 0 0-.075-.17.28.28 0 0 0-.222-.033.3.3 0 0 1-.232-.035.6.6 0 0 1-.129-.15q.014-.02.026-.041a3.5 3.5 0 0 1 .336-.555 1.5 1.5 0 0 1 .424-.394 2.8 2.8 0 0 0 .632.448 1.4 1.4 0 0 1-.317.53m-.491 1.556a2 2 0 0 1 .586-1.001c.129-.078.27-.13.405-.195a3.4 3.4 0 0 1 .664.205 1 1 0 0 0-.09.146 2.95 2.95 0 0 1-1.325 1.52c-.057-.121-.123-.238-.176-.361a1.3 1.3 0 0 1-.067-.315Zm1.116-1.255a4.6 4.6 0 0 1 1.192-.371v-.003q.068.057.137.117a1.3 1.3 0 0 0-.253.167.9.9 0 0 0-.482.27 3.5 3.5 0 0 0-.594-.18m.883.139a1 1 0 0 0-.09.156q-.026-.017-.05-.03a.7.7 0 0 1 .14-.126m-.05.29a3.4 3.4 0 0 1 .446.268 2.3 2.3 0 0 1 .464.7q.038.074.078.147a1.84 1.84 0 0 0 .418 1.242l-.008.02a11 11 0 0 1-2.122-.046.4.4 0 0 0 .074-.071 2.8 2.8 0 0 0 .556-1.705 1.2 1.2 0 0 1 .094-.555m1.415 2.708.118-.002q-.01.064-.018.13h-.153c.02-.041.034-.085.053-.128m.08.268-.008.1-.229.014.015-.034c.013-.025.02-.053.032-.078zm-.01.242q-.003.098-.002.196l-.37.013.083-.192.29-.017Zm-.002.337a.86.86 0 0 1-.595.99l-.018.01-.004-.006c-.099-.204-.034-.446.13-.85.016-.041.037-.086.054-.128zm-.526-.12c-.474.02-.953.048-1.54.089l-.06-.1c-.025-.037-.045-.077-.07-.114.171-.004.342 0 .512-.012.461-.014.862-.034 1.24-.055l-.082.191Zm-1.616.236c.144.237.28.463.393.657a3.7 3.7 0 0 1 .307.708 5 5 0 0 0-.403.323 16 16 0 0 1-.947-.875 7 7 0 0 0-.59-.525q.068-.104.133-.208zm-1.31.224c-.047-.038-.088-.082-.135-.119l.22-.016zm-.051.08c-.078.122-.151.243-.23.363a.68.68 0 0 1-.422-.16 2 2 0 0 1-.225-.344l.615-.044.049-.004c.075.058.14.128.212.19Zm-.187.47a1.4 1.4 0 0 0 .506.242 5 5 0 0 1 .46.192 2 2 0 0 1-.197.319 3.3 3.3 0 0 1-.469.502 3 3 0 0 0-.124.118c-.01-.01-.025-.016-.036-.027a1.7 1.7 0 0 0-.722-.513c.193-.266.39-.544.582-.833m.03 1.433a2.06 2.06 0 0 0 .926.543l-.04.067c-.015.01-.033.013-.045.027a.2.2 0 0 0-.045.119c-.033.06-.076.112-.106.173a2 2 0 0 1-.152.318 1.2 1.2 0 0 1-.43-.197c-.087-.056-.16-.111-.233-.164a1.14 1.14 0 0 0-.679-.293.64.64 0 0 1-.41-.192 7 7 0 0 1 .52-.885 1.56 1.56 0 0 1 .694.484m-1.286.339-.007-.006a5 5 0 0 0-.487-.414 2 2 0 0 1-.419-.366l.175-.273.05-.07-.005-.001q.16-.255.302-.503a1.6 1.6 0 0 0 .691.678q.113.051.207.092a7 7 0 0 0-.507.863m-.592-1.568a4 4 0 0 1-.21-.351 13 13 0 0 0-.588-.977l-.01-.014a1.4 1.4 0 0 0 .175.09c.304.123.33.217.35.286.04.14.086.202.613.193-.04.135-.073.273-.116.408-.064.12-.14.243-.214.365m-.334-.282a4 4 0 0 0 .253.422l-.148.237a2 2 0 0 0-.239-.113 1.7 1.7 0 0 1-.399-.325 2.6 2.6 0 0 0 .259-.703c.102.174.196.34.274.482m-.188.676a2 2 0 0 1 .217.102l-.018.029c-.065-.024-.23-.089-.553-.233a1 1 0 0 1-.15-.092q.047-.068.089-.14a1.8 1.8 0 0 0 .415.334m-.393-.016q.266.122.541.226l-.128.2q-.39.578-.732 1.182a9.4 9.4 0 0 0-.48-1.235 2.5 2.5 0 0 0 .466-.275 3 3 0 0 0 .163-.203 1 1 0 0 0 .17.105m-.252-.264a1 1 0 0 1-.239-.297 8 8 0 0 0-.302-.421 2.1 2.1 0 0 0-.436-.422 2 2 0 0 0 .025-.28c.076.056.147.119.226.172a1.13 1.13 0 0 1 .518.545 1.8 1.8 0 0 0 .319.538 3 3 0 0 1-.11.164Zm-2.42-1.252-.15.168a3 3 0 0 0-.155.181 2.5 2.5 0 0 1-.687-.723c.136-.057.286-.121.442-.19.156.063.317.115.47.187a1.7 1.7 0 0 0 .29.095c-.07.095-.134.193-.21.282m-1.122-.472-.059.012.003.011-.139.058q.05-.055.127-.131.084-.086.204-.213c.085.028.166.068.25.099-.137.06-.27.116-.386.164m.067-.39a6 6 0 0 1-.387-.147q.019-.376.018-.762v-.028a3.6 3.6 0 0 0-.087-.612q.092-.09.186-.177c.05.047.09.104.144.147l.166.11c.486.318.716.483.646.768a.55.55 0 0 1-.296.374 2.3 2.3 0 0 0-.39.327m-.494-1.706a4 4 0 0 0-.124-.374 3 3 0 0 0 .25.254zm-.016.769v.028q.001.352-.013.694c-.119-.072-.114-.12-.1-.19a.73.73 0 0 0-.302-.698l.004-.005c.11-.116.234-.218.348-.33a3.4 3.4 0 0 1 .063.5Zm-.243.202a.45.45 0 0 1 .037.314c-.026.131-.01.21.184.31a3.5 3.5 0 0 1-.084.592 1.05 1.05 0 0 0-.319-.49.8.8 0 0 0-.31-.163 2 2 0 0 1 .05-.262.9.9 0 0 0 .036-.307c-.003-.074.005-.113.168-.29a.53.53 0 0 1 .238.296m-.27.835a.94.94 0 0 1 .333.643.94.94 0 0 1-.292.419.9.9 0 0 1-.277.17.06.06 0 0 1 .032.01l-.016.027c-.138-.12-.274-.242-.421-.352q-.027-.022-.053-.045a.82.82 0 0 1 .223-.647.68.68 0 0 0 .214-.363.7.7 0 0 1 .256.138Zm-.576.13a.93.93 0 0 0-.241.64 4 4 0 0 1-.354-.32.97.97 0 0 1 .012-.563.8.8 0 0 1 .11-.258c.038.02.069.05.107.07a1.1 1.1 0 0 0 .484.127 1 1 0 0 1 .074.013.7.7 0 0 1-.192.29Zm-.719-.28a1.1 1.1 0 0 0-.04.421c-.038-.043-.08-.082-.116-.126-.115-.133-.256-.242-.38-.366q.146-.23.305-.466a4 4 0 0 0 .36.238.9.9 0 0 0-.129.299m-.264.387a4.4 4.4 0 0 0 .758.73 1.75 1.75 0 0 1-.331.839 2 2 0 0 1-.312.25q-.006.007-.014.013a9 9 0 0 1-.546-.43 2 2 0 0 0 .265-.315.78.78 0 0 0-.406-1.011 7 7 0 0 1 .24-.41c.112.115.24.212.346.334m-.707.002q-.154-.08-.272-.138c-.15-.07-.282-.167-.424-.25.003-.061.004-.131.003-.222a7 7 0 0 1 .019-.691 1.8 1.8 0 0 0 .431.386c.18.144.333.318.498.479-.093.15-.181.296-.255.435Zm-.335-.013.276.14a1.46 1.46 0 0 0-.206.793.8.8 0 0 0 .207.352 3 3 0 0 1-.606-.48c-.044-.049-.1-.108-.152-.164a2.3 2.3 0 0 1 .002-.453.6.6 0 0 1 .056-.241.5.5 0 0 0 .05-.168c.125.072.242.16.373.22Zm-.452-.596c0 .068 0 .116-.002.165-.117-.072-.243-.128-.354-.21-.313-.223-.314-.3-.313-.303l.003-.017a1.56 1.56 0 0 0 .497-.805 2 2 0 0 0 .193.327 7 7 0 0 0-.024.843m-.177-1.757a2.3 2.3 0 0 0-.379-1.118 7 7 0 0 1-.324-.631q.27.235.519.435a6 6 0 0 1 .846.783 2.5 2.5 0 0 0-.618.757c0-.025.008-.049.007-.074a1 1 0 0 0-.05-.152Zm-.095-1.424-.115-.095a1.45 1.45 0 0 1 .577-.334.6.6 0 0 0 .153-.103.93.93 0 0 0 .45.37c.235.122.378.204.338.358a2 2 0 0 1-.512.572l-.031.029a6 6 0 0 0-.86-.797m.71-.824a1 1 0 0 1 .042-.293.83.83 0 0 0-.05-.7 6 6 0 0 0-.262-.33 1.3 1.3 0 0 0 .366.189 2.7 2.7 0 0 1 .132.796 3 3 0 0 1-.228.338m-.617-2.027c-.105-.24.028-.326.365-.52l.047-.028a2.8 2.8 0 0 0 .082.68 5 5 0 0 0 .15.53c.01.024.013.05.022.074a1.18 1.18 0 0 1-.666-.736m.185-1.065c.087.038.168.088.251.134-.01.074-.023.147-.027.221-.037.022-.078.049-.113.069-.315.179-.585.333-.425.697a1.3 1.3 0 0 0 .092.189 5.4 5.4 0 0 1-.61-.878 4 4 0 0 1 .09-.721c.248.094.499.183.742.289m-.834-.487-.173-.064.216-.106c-.017.056-.028.113-.043.17m-.037.148a4 4 0 0 0-.099.799l.01.015a37 37 0 0 1-.713-.692l.487-.245c.107.037.21.084.315.123m.002 1.087-.065.016a.98.98 0 0 0-.736.497 3 3 0 0 0-.15.382.435.435 0 0 1-.287-.44.4.4 0 0 0 .061-.3c-.003-.018-.012-.033-.017-.05a4.2 4.2 0 0 1 .285-.975q.443.446.91.87Zm-1.292-.116a1.1 1.1 0 0 0-.458-.368q.338-.174.686-.35a4 4 0 0 0-.228.718m-.047.23c-.009.057-.027.112-.034.17a.6.6 0 0 0-.013.141 1.2 1.2 0 0 1-.246.186 1.5 1.5 0 0 0-.431.34 1.87 1.87 0 0 1-.091-1.226l.239-.124a.9.9 0 0 1 .576.513m-1.67.977-.003.023a.4.4 0 0 1-.15-.125.98.98 0 0 1-.129-.641.88.88 0 0 1 .282.743m-.228-.045a.5.5 0 0 0 .206.164 5 5 0 0 1-.24.593c-.031-.01-.061-.024-.094-.033.225-.362-.297-1.012-.43-1.168.127-.071.264-.148.42-.232a1.15 1.15 0 0 0 .138.676m-.227.72a.27.27 0 0 1-.232.084 1.07 1.07 0 0 1-.652-.478 2.3 2.3 0 0 1-.194-.336c.21-.125.396-.235.527-.31l.135-.077c.213.243.66.858.416 1.117m-2.399-.878a1.9 1.9 0 0 1-.048-.833c.035-.046.08-.083.112-.131a5 5 0 0 1 .786-.9l.019-.016a3.5 3.5 0 0 0 .775.89q-.83.482-1.644.99m-1.412.003a4.4 4.4 0 0 1-.552-.847 2.4 2.4 0 0 1 .534-.492c.096-.085.18-.181.273-.27a3.15 3.15 0 0 1-.255 1.61Zm-.106-1.45a2.5 2.5 0 0 0-.521.471c-.013-.028-.034-.052-.047-.081l-.11-.33c-.048-.165-.116-.322-.172-.484a.9.9 0 0 0 .105-.28l.018-.011c.049-.033.131-.087.258-.177a2 2 0 0 0 .395-.404c.124.25.248.501.351.76a2 2 0 0 1 .048.215c-.11.106-.21.22-.325.32Zm-.813.103.11.332c.023.053.06.097.085.15a2.5 2.5 0 0 0-.452.928 4 4 0 0 0-.138 1l-.064-.204a2.5 2.5 0 0 0-.412-.675c-.035-.042-.06-.09-.093-.134.027-.058.043-.12.07-.177a2.3 2.3 0 0 0 .517-.937 4 4 0 0 1 .261-.61c.036.11.084.215.116.327m-.287-.522a4.6 4.6 0 0 0-.312.726 2.1 2.1 0 0 1-.46.85q-.028.061-.057.125a3.6 3.6 0 0 1-.382-.74l-.007-.022c-.01-.13-.019-.25-.034-.407l-.037-.39-.03-.298a9 9 0 0 1 .104-.25 3.3 3.3 0 0 1 .709-1.004 10 10 0 0 1 .562 1.28 1 1 0 0 1-.056.13m-.782 2.18.01.015a2.3 2.3 0 0 1 .376.604l.234.743q-.598.36-1.286.792a10 10 0 0 1 .666-2.153Zm-.177 2.83a2.7 2.7 0 0 0 .527.752l.035.03q-.014.055-.025.111a2 2 0 0 0-.515-.18.75.75 0 0 1-.551-.382l.53-.332Zm0 .805a1.4 1.4 0 0 1 .515.186 2 2 0 0 0 .022.795.75.75 0 0 1-.155.51q-.023.03-.046.064a.7.7 0 0 0-.187-.33.74.74 0 0 0-.58-.283.36.36 0 0 1-.333-.163c-.184-.282.036-.988.096-1.166l.049-.03a.92.92 0 0 0 .62.417Zm.303 1.903a.3.3 0 0 0 .074-.16c0-.019-.01-.035-.012-.054a1 1 0 0 1 .092-.141.84.84 0 0 0 .174-.58 1.96 1.96 0 0 1 .011-.921l.121.105c.278.232.54.45.558.788a1.66 1.66 0 0 1-.252 1.115 1 1 0 0 0-.082.157q-.15-.03-.303-.068a1 1 0 0 1-.2-.075l-.001-.002h-.002a.33.33 0 0 1-.18-.145c-.002-.006.004-.013.002-.019m.07.22a.72.72 0 0 0-.352.317.6.6 0 0 0-.013.279 1 1 0 0 0-.182-.12l-.084-.073a1.5 1.5 0 0 1-.16-.145.5.5 0 0 1-.066-.197.68.68 0 0 1 .164-.61.18.18 0 0 1 .165-.06c.163.033.316.316.361.422l.006.013v.004l.003.003.016.038.01-.008a.34.34 0 0 0 .132.136Zm-.275.913a.3.3 0 0 0-.016-.087c.016.02.037.037.051.06l.002.004q.1.153.192.312c.126.216.134.223.46.39q.209.106.415.217l.023.014a.8.8 0 0 1 .36.649 1.1 1.1 0 0 1-.174.605c-.03-.038-.052-.08-.083-.118a1.77 1.77 0 0 0-.888-.677c-.103-.043-.219-.091-.353-.16-.34-.17-.216-.504-.095-.83a1.4 1.4 0 0 0 .106-.38Zm2.11 2.962q.245.11.495.21l.011-.03.053.028a1 1 0 0 0-.03.715.73.73 0 0 0 .242.42c.01.009.014.023.024.033-.013-.008-.02-.02-.033-.028l-.078-.073a4 4 0 0 0-.408-.323 1.1 1.1 0 0 1-.536-.671 2 2 0 0 1-.021-.508.6.6 0 0 0 .281.227m.62.899a.94.94 0 0 1 .02-.647c.048.024.079.04.14.073.738.402.76.522.71.648l.03.012-.06.076a.81.81 0 0 0-.237.78c-.024-.044-.055-.085-.078-.13a1.3 1.3 0 0 0-.31-.437.64.64 0 0 1-.216-.375Zm.63 1.75a1.1 1.1 0 0 0 .02-.546c.021.033.037.07.06.102a.83.83 0 0 1 .22.677c-.086.427-.215 1.072.322 1.435.056.038.097.064.142.093-.01.064-.037.124-.042.189a.78.78 0 0 1-.539-.303 1.07 1.07 0 0 1-.277-1.29q.047-.159.094-.357m.765 2.708a2.1 2.1 0 0 0 .412.87 1.17 1.17 0 0 1 .306.77l.04.003a3.3 3.3 0 0 1-.099.624.7.7 0 0 0-.044.26.6.6 0 0 0 .073.187.87.87 0 0 1-.141-.477c-.054-.571-.396-.688-.911-.848a1.34 1.34 0 0 0-.028-1.77 1 1 0 0 0-.064-.049q.216.046.436.07a3 3 0 0 0 .02.36m.303 3.75a3 3 0 0 0-.207-.353q.174-.084.296-.152a.8.8 0 0 0-.104.34c.002.056.012.11.015.165m-.297-.413a.8.8 0 0 1-.263.085 1.1 1.1 0 0 1 .155-.613.79.79 0 0 0-.052-.763c.367.124.55.243.637.469l.018-.007a1 1 0 0 0 .205.402 2.1 2.1 0 0 1-.7.427m-.698-.244c-.153-.422-.494-.483-1.009-.575a9 9 0 0 1-.496-.098.78.78 0 0 1-.552-.324.3.3 0 0 1-.01-.195.8.8 0 0 0 .743.045c.213-.075.381-.134.707.217a3.7 3.7 0 0 1 .678 1.014 1.3 1.3 0 0 0 .143.249 3 3 0 0 1-.239.15c.009-.014.022-.023.03-.037a.56.56 0 0 0 .005-.446m-.373.647a1.34 1.34 0 0 1-1.174-.007.73.73 0 0 1-.452-.81.82.82 0 0 0-.099-.527 3.4 3.4 0 0 0-1.23-.852 5 5 0 0 0-.328-.362c.015-.031.02-.065.037-.094a1.6 1.6 0 0 1 .357-.56.1.1 0 0 1 .029.034l.004.04a1.28 1.28 0 0 0 .622.943c.001.034-.007.067-.005.1l.094-.007.002-.032c.106.077.216.154.352.239a.4.4 0 0 0 .022.29.85.85 0 0 0 .616.376c.183.043.352.073.5.1.501.089.803.144.937.514a.47.47 0 0 1 0 .373.54.54 0 0 1-.285.24Zm-.233.848c.203.323.29.564.234.677a.72.72 0 0 0-.088.433 2 2 0 0 1-.035.505c-.012.063-.034.124-.05.186a1.6 1.6 0 0 0-.322-.592 1.27 1.27 0 0 0 .346-.912 1.6 1.6 0 0 0-.085-.297m.24 1.106a.6.6 0 0 1 .007-.195.54.54 0 0 0 .4.387c.074.023.137.05.204.077a.46.46 0 0 0 .02.302.8.8 0 0 0-.233-.101.55.55 0 0 0-.435.057 2 2 0 0 0 .037-.527m-.265.996a.5.5 0 0 0-.024.163v-.001a1 1 0 0 1-.076.074 1.47 1.47 0 0 0-.446.626 2 2 0 0 1-.093-.156l.002-.008h-.007a1.8 1.8 0 0 1-.167-1.336l.067-.283c.019-.058.02-.12.035-.178a1.6 1.6 0 0 1 .38.238c.306.387.41.672.305.846Zm-2.245.639a.41.41 0 0 1-.082-.511c.263.143.58.318.58.478a.33.33 0 0 1-.034.177l-.023.03a.3.3 0 0 1-.074.095l.005.009a1 1 0 0 0-.091.178.8.8 0 0 0-.281-.456m.215.539v.008c.001.007.02.16-.218.31a.5.5 0 0 0-.101.094c0-.043.006-.086.003-.13a1.4 1.4 0 0 1 .128-.651.7.7 0 0 1 .188.369m-.428-.727a2 2 0 0 0-.465-.233 3.6 3.6 0 0 0 .064-.548.74.74 0 0 0 .238.29q.103.062.21.12a.5.5 0 0 0-.047.37Zm-1.654-1.14c-.022-.077-.045-.154-.065-.24a.97.97 0 0 1 .058-.594c.004.02.002.038.006.058a1.2 1.2 0 0 0 .58.719c-.161.064-.418.199-.459.436L19.3 37a2 2 0 0 0-.09-.386l-.011-.043c0-.008.008-.015.008-.023Zm-.156-.22c.02.09.043.168.066.247a.38.38 0 0 1-.248.317 2 2 0 0 1-.231.047.5.5 0 0 0-.162.036 2 2 0 0 0 .388-.558l.024-.037a.75.75 0 0 0-.249-1.031 1.6 1.6 0 0 1-.207-.2c-.058-.065-.129-.116-.192-.175a3.1 3.1 0 0 0-.151-.93 2.4 2.4 0 0 0-.171-.308 2 2 0 0 0 .458.064h.013a1 1 0 0 1-.046.167.65.65 0 0 0-.029.695 2 2 0 0 0 .497.547l.014-.022a.56.56 0 0 0 .306.418 1.08 1.08 0 0 0-.08.724Zm-2.794-2.687a12 12 0 0 0-.43-.347 1.84 1.84 0 0 1-.299-.903.97.97 0 0 1 .634.443.85.85 0 0 1 .095.807m.056.222a2.4 2.4 0 0 1 .212.903 1.2 1.2 0 0 1-.218-.414 1.4 1.4 0 0 1 .006-.49Zm-.546-.495.006.003q.222.168.434.35c.012.01.018.028.03.04a1.5 1.5 0 0 0-.022.612c.01.036.034.065.047.1-.014-.005-.881-.366-.997-1.07a1.9 1.9 0 0 1 .025-.76.3.3 0 0 0 .095.024.1.1 0 0 0 .058-.014c.017-.012.012-.035.022-.052a1.8 1.8 0 0 0 .302.767m-2.741-5.222c.043.01.087.012.129.026.26.098.232.283.193.538q-.015.096-.025.199a1.5 1.5 0 0 1-.055.264.7.7 0 0 0-.03.418 1.6 1.6 0 0 1-.34-.162c.04-.16.078-.322.12-.466a1.8 1.8 0 0 0 .008-.817m.271 1.572a.7.7 0 0 0 .087.186.9.9 0 0 0 .224.162 1.3 1.3 0 0 0-.108.574c.003.02.012.039.016.059l-.031.004a.5.5 0 0 1-.036.202 1.6 1.6 0 0 0-.392-.28.63.63 0 0 1-.32-.606c.049-.162.099-.325.136-.49a1.7 1.7 0 0 0 .424.189m.22-1.918a10 10 0 0 0 .294-.017 1.2 1.2 0 0 1 .379-.002 1.3 1.3 0 0 1 .006.409 1.3 1.3 0 0 0 .043.522 2 2 0 0 1-.429-.296.69.69 0 0 1-.219-.6l-.046-.01.046.009Zm-.09-1.492c.1.04.317.177.484.67q.076.223.16.442c.02.037.023.079.039.117a1.44 1.44 0 0 1-.6-.452 1.2 1.2 0 0 1-.083-.76zm.573.64c-.197-.583-.466-.71-.575-.739a1 1 0 0 0-.005-.216 2.9 2.9 0 0 0 .853.723l.042.023a.83.83 0 0 0-.079.737 1 1 0 0 0 .121.157 1 1 0 0 1-.135-.052 1.4 1.4 0 0 0-.062-.193 12 12 0 0 1-.16-.44m1.156 3.184a1 1 0 0 0-.066-.056l.01-.024-.068-.026c-.015-.01-.024-.023-.04-.034a1.6 1.6 0 0 1-.355-.32c-.292-.355-.13-.513-.124-.52l-.028-.032a.4.4 0 0 0 .148.087 1 1 0 0 1 .401.18l.009-.01a1 1 0 0 0 .108.102c-.01.082-.029.163-.033.247a1.5 1.5 0 0 0 .038.406m-.501-1.017a.47.47 0 0 1-.287-.294l.006-.015-.02-.014a1.24 1.24 0 0 1-.064-.59 1.4 1.4 0 0 0-.025-.49 2 2 0 0 0 .151.043l.006-.038a1.2 1.2 0 0 0 .527.382.87.87 0 0 0-.256.716 1.1 1.1 0 0 0 .178.399 1 1 0 0 0-.216-.1Zm-.38-.266a.7.7 0 0 0 .165.245c-.034.035-.205.237.124.638a2 2 0 0 0 .214.192 29 29 0 0 1-.68-.29.68.68 0 0 1-.404-.406 1.07 1.07 0 0 1 .106-.707 2.2 2.2 0 0 0 .475.328m-.434.73a.8.8 0 0 0 .22.142q.456.203.923.385a.29.29 0 0 1 .16.274.6.6 0 0 1-.137.295c-.017.02-.027.045-.042.067a1.2 1.2 0 0 0-.587-.598 1 1 0 0 0-.21-.018.8.8 0 0 1-.448-.094c.006-.014.008-.028.015-.041q.032-.076.053-.138a1 1 0 0 0 .053-.275Zm.325.64a1 1 0 0 1 .19.016 1.08 1.08 0 0 1 .54.618 1 1 0 0 0-.098.653l-.016-.015a.7.7 0 0 0-.322-.144 3 3 0 0 1-.39-.13.72.72 0 0 1-.478-.597 1.3 1.3 0 0 1 .095-.498.9.9 0 0 0 .48.098Zm.742.862a.95.95 0 0 1 .421.642c.023.107.038.229.055.347a.69.69 0 0 1-.464-.437.93.93 0 0 1-.012-.552m-1.897-.374a1.5 1.5 0 0 1 .42.298.55.55 0 0 1-.207.23 1.1 1.1 0 0 0-.422.36 1.92 1.92 0 0 1-.131-1.322.7.7 0 0 0 .34.434m.26.61a.64.64 0 0 0 .218-.238 1.5 1.5 0 0 1 .254.378q.044.103.098.202a1.7 1.7 0 0 1 .187.61 1.7 1.7 0 0 0-.174-.35 1.01 1.01 0 0 0-.78-.417h-.043a1 1 0 0 1 .24-.185m.624.237a2 2 0 0 1-.066-.133 1.6 1.6 0 0 0-.3-.448.7.7 0 0 0 .024-.135.8.8 0 0 0 .481.466 3 3 0 0 0 .4.133.64.64 0 0 1 .282.122l.126.12a.81.81 0 0 0 .56.509q.007.037.012.073a2 2 0 0 0 .04.264l-.048.007c.002.011 0 .033-.008.038s-.097.035-.483-.313a4.3 4.3 0 0 0-1.009-.73Zm1.526.149a1.05 1.05 0 0 0-.48-.726q.008-.027.02-.053l.039.01c.004-.016-.01-.039-.01-.056a1 1 0 0 1 .095-.15.7.7 0 0 0 .144-.324 1.5 1.5 0 0 0 .146.297c0 .01-.007.02-.008.03a1.35 1.35 0 0 0 .331 1.012 2.2 2.2 0 0 0 .52.398c.041.019.066.059.104.084-.04-.003-.07-.007-.125-.01a3.3 3.3 0 0 1-.711-.103c-.02-.14-.038-.282-.065-.41Zm-.152-2.489a.72.72 0 0 0 .183.496 3.4 3.4 0 0 0 .399.29 1.1 1.1 0 0 1-.25.294.57.57 0 0 0-.185.26 2.07 2.07 0 0 1-.147-1.34m.998 2.846a2.1 2.1 0 0 1-.5-.381 1.26 1.26 0 0 1-.295-.838 4.6 4.6 0 0 0 .533.531c.242.21.416.362.41.53l.061.003a2 2 0 0 0 .027.352 1 1 0 0 0-.236-.197m.207-.513-.018.097c-.002.028.007.055.006.083a1.7 1.7 0 0 0-.395-.426 4.4 4.4 0 0 1-.577-.574q-.009-.018-.016-.037a.5.5 0 0 1 .178-.318 1.18 1.18 0 0 0 .452-.843 1.47 1.47 0 0 0 .111.875 2 2 0 0 0 .354.316 4 4 0 0 1-.095.827m-.244-7.08a.71.71 0 0 1-.098-.685 1.4 1.4 0 0 0 .265.375 3 3 0 0 1-.167.31m.24-.25a.54.54 0 0 0 .213.104c.014.006.026.017.04.024l-.002.107a4 4 0 0 1-.036.382l-.004.022c-.13-.103-.261-.205-.385-.316a3 3 0 0 0 .174-.323m-.22.407q.202.177.414.339a1.3 1.3 0 0 0 .168.887c-.006.01-.008.023-.015.034a2 2 0 0 0-.172-.193 2.2 2.2 0 0 0-.448-.218c-.013-.03-.021-.062-.037-.09-.086-.194-.16-.361-.064-.472.064-.089.1-.193.155-.287Zm.464-1.272q-.015-.025-.032-.05a1.8 1.8 0 0 0-.542-.322.82.82 0 0 0 .061-.539.9.9 0 0 0 .243.318.65.65 0 0 1 .302.453h-.035Zm.453-.811c.023.023.052.038.076.06a4 4 0 0 0-.195.283.9.9 0 0 0-.2.49c-.002-.031-.01-.06-.008-.091a.3.3 0 0 0 .002-.055q0-.166.015-.331a4 4 0 0 0-.017-.976.75.75 0 0 0-.605-.617l.184-.16a.8.8 0 0 0 .554.449h.009a1.03 1.03 0 0 0 .185.948m.42-.92a.8.8 0 0 0 .154.32l-.01.006a2.1 2.1 0 0 1 .205.806l-.031.15a1.9 1.9 0 0 1-.66-.416.94.94 0 0 1-.168-.886 3 3 0 0 0 .36.028 1 1 0 0 0 .15-.008m1.893 2.999q.045.109.086.22c.103.276.192.516.382.516h.114a.8.8 0 0 1-.11.169q-.019.022-.035.046a1 1 0 0 0-.312-.31 1.4 1.4 0 0 1-.366-.35 1.6 1.6 0 0 1-.05-.576.42.42 0 0 1 .291.285m-.28-.377a2 2 0 0 1 .026-.21q.018-.133.034-.265a3 3 0 0 0 .186.273l.165.2c.372.454.593.734.498 1.02h-.16c-.125 0-.207-.22-.295-.453a5 5 0 0 0-.087-.225.5.5 0 0 0-.366-.34Zm3.073 5.772-.007-.032a1.3 1.3 0 0 1-.035-.656l.01.008a.37.37 0 0 0 .057-.235 1 1 0 0 1 .064-.14c.208.127.912.597.978 1.085a2.27 2.27 0 0 1-.45 1.258 2.06 2.06 0 0 1-.617-1.288m1.207 1.739a7 7 0 0 0 .739.262c.533.165.827.257.876.778 0 .023.011.045.013.069a1.27 1.27 0 0 0-.687-.396l-.017-.028-.024.016a14 14 0 0 0-.49-.135 2.4 2.4 0 0 1-1.273-1.154 2.1 2.1 0 0 0 .863.588m-.996-.719a3.7 3.7 0 0 1-.687-.772 1.7 1.7 0 0 1 .467.11 2.05 2.05 0 0 0 .339.773l-.004-.002c-.033-.025-.058-.059-.09-.085-.001-.01.005-.02.003-.031Zm-1.676.05-.014-.128c-.026-.205-.026-.205.194-.45l.033-.037a3 3 0 0 0 .128-.29 1.7 1.7 0 0 0 .45.065c.025 0 .05.006.074.006a4 4 0 0 0 .26.373c-.084.025-.225.112-.396.436a2.4 2.4 0 0 0-.188.915 1.16 1.16 0 0 1-.535-.833l-.003-.03c-.001-.008.004-.016.001-.023Zm-.107-.118a1.2 1.2 0 0 0-.234-.113 1.6 1.6 0 0 1-.391-.26 1.7 1.7 0 0 0 .181-.515 2.7 2.7 0 0 0 .043-.544c.006-.002.07-.007.287.174a.69.69 0 0 1 .295.675l.07.02v.003l-.034.038c-.233.26-.247.276-.217.522m.357 4.432a.72.72 0 0 0-.623.409 2 2 0 0 0-.083.38c-.009-.061-.02-.114-.028-.18a2.3 2.3 0 0 1 .426-1.101 1.8 1.8 0 0 1 .308.492m-.306-.496.002-.003Zm-.229.938c.102-.276.443-.331.555-.35l.008-.002a.8.8 0 0 1 .024.467q-.112.39-.004.515a.13.13 0 0 0 .086.04 1 1 0 0 0-.004.108.8.8 0 0 0-.277-.053.94.94 0 0 0-.439.147 2 2 0 0 1-.08-.279 2 2 0 0 1 .131-.593m.654.569c-.022-.026-.065-.12.023-.428a1.38 1.38 0 0 0-.241-.959 1 1 0 0 0 .124.075c.171.08.305.143.331.273l.033-.007a.54.54 0 0 0 .067.367 1.08 1.08 0 0 0-.317.689.04.04 0 0 1-.02-.01m.277-1.135a.7.7 0 0 0-.332-.262.91.91 0 0 1-.583-.557 1.5 1.5 0 0 1 .034-1.02 2.7 2.7 0 0 0 .706.404 2.4 2.4 0 0 1 .378.19 2 2 0 0 1 .05.383l-.039.109a4 4 0 0 0-.214.753m-2.198-.25a1.5 1.5 0 0 0-.074.497.48.48 0 0 1-.263-.507 1.3 1.3 0 0 1 .291-.503 1.8 1.8 0 0 0 .257-.391.28.28 0 0 1 .134.183c-.021.054-.033.11-.059.163l-.085.148a1.5 1.5 0 0 0-.194.39h-.007v.01Zm-2.646-5.115a5 5 0 0 0 .343.394c-.014.095-.01.192-.03.287l-.044.262a4 4 0 0 0-.215-.177c.001-.083.01-.165.005-.248a1.4 1.4 0 0 0-.06-.518Zm-.09-.257-.002-.003c-.418-.572-.283-.922-.204-1.049a2.6 2.6 0 0 0 .536.285l-.039.018a2.6 2.6 0 0 1 .2.838 4 4 0 0 1-.047.446 5 5 0 0 1-.445-.535Zm.055.777c.003.055-.004.111-.003.167a2 2 0 0 1-.282-.25 1.82 1.82 0 0 1-.067-1.035 1.7 1.7 0 0 0 .22.397l.003.003a1.36 1.36 0 0 1 .13.718Zm-.096-3.777a1 1 0 0 0 .101.037 2 2 0 0 0-.023.252.95.95 0 0 0 .417.51.7.7 0 0 1-.062.255 1.9 1.9 0 0 1-.664.734 1.1 1.1 0 0 0 .321-.768.72.72 0 0 0-.318-.587 4 4 0 0 0 .26-.418Zm-.235-1.062a2 2 0 0 1 .346.177 1.6 1.6 0 0 1 .174.24 1.8 1.8 0 0 0-.175.587c-.351-.114-.395-.344-.396-.355h-.003a2 2 0 0 0 .108-.362 1.2 1.2 0 0 0-.054-.287m1.623-2.603c.03.012.056.03.086.04a1.3 1.3 0 0 1 .387.219.5.5 0 0 0 .08.136.9.9 0 0 1-.092.308 2.2 2.2 0 0 0-.18.554c-.072 0-.33-.03-.427-.434a.98.98 0 0 1 .16-.81Zm.014-.896q.116.105.238.2c.151.12.203.165.208.24l.035-.002a1.3 1.3 0 0 0-.067.554 5 5 0 0 0-.303-.14l.036-.172a2.2 2.2 0 0 0-.147-.68m.798 2.16a.36.36 0 0 1 .048.369.36.36 0 0 1-.118.147.16.16 0 0 0-.066.092.5.5 0 0 1-.316-.56 2 2 0 0 1 .187-.571 2 2 0 0 0 .102-.265.6.6 0 0 0 .134.052c-.007.024-.008.048-.017.07a.9.9 0 0 0-.057.414 1 1 0 0 0 .103.253Zm.433 2.452a.8.8 0 0 0 .517.22v-.025a.26.26 0 0 0 .111.196.53.53 0 0 1 .195.269 1.8 1.8 0 0 0-.273.699 1.47 1.47 0 0 0 .46.976 3 3 0 0 1-.112.24 2 2 0 0 1-.11.16.53.53 0 0 0-.052-.464c-.149-.192-.196-.247-.352-.43l-.123-.144a2 2 0 0 0-.168-.174.6.6 0 0 1-.132-.164c-.004-.026.001-.052-.004-.078l-.027.006a1.8 1.8 0 0 1-.079-.384 1.15 1.15 0 0 1 .184-.871Zm.64 5.39a1.1 1.1 0 0 1-.47-.581 2 2 0 0 1 .048-.52c.092.11.185.218.287.319a.84.84 0 0 0 .365.185.7.7 0 0 0 .173.219q.016.017.03.033a1.45 1.45 0 0 0-.125.596 1.2 1.2 0 0 0-.226-.187c-.014-.007-.023-.021-.036-.029l.004-.02ZM16.9 28.919h.001a1.2 1.2 0 0 1 .634.413l.121.194a3.8 3.8 0 0 0 .12 1.163 1.3 1.3 0 0 1 .057.33c-.044-.052-.074-.115-.123-.163a3 3 0 0 0-.253-.215 5 5 0 0 1-.421-.378 4 4 0 0 0 .053-.527 2.7 2.7 0 0 0-.189-.817m.935-2.914a1.7 1.7 0 0 1 .354.054l-.005.004a1.2 1.2 0 0 1 .138.78q-.02.128-.034.233c-.007.06-.022.118-.031.178a1.2 1.2 0 0 1-.445-.344c-.007-.016-.007-.033-.013-.048q.038-.05.071-.098a.83.83 0 0 0-.035-.759m.068-.526a.8.8 0 0 1 .012-.576 1 1 0 0 0 .027.124.7.7 0 0 0 .301.216.51.51 0 0 1 .366.515 2 2 0 0 1-.024.345c-.014-.008-.03-.01-.045-.017l.005-.008a2.2 2.2 0 0 1-.642-.6Zm.674.734c-.008.054 0 .11-.012.165a1.17 1.17 0 0 0 .024.689 2 2 0 0 0 .144.296 1.2 1.2 0 0 1-.385-.078c.01-.065.026-.13.034-.196l.033-.232a1.26 1.26 0 0 0-.126-.773 1.7 1.7 0 0 1 .288.129m.186 1.211a2 2 0 0 0 .092.19v.003a1.5 1.5 0 0 0 .111.478 1.2 1.2 0 0 1-.053.51 2 2 0 0 0-.07-.333c-.158-.545-.452-.62-.56-.629l.003-.007c.02-.085.03-.17.045-.255a1.3 1.3 0 0 0 .432.08Zm.98 2.215a2 2 0 0 0-.155.22.3.3 0 0 0-.015.062.3.3 0 0 0-.047-.03 1 1 0 0 1-.394-.284c-.373-.404-.299-.566-.152-.89a1.3 1.3 0 0 0 .086-.486q.027.03.06.062a2 2 0 0 1 .16.167l.124.144c.155.182.202.236.348.426.16.205-.04.59-.042.595Zm-1.123 1.269a2 2 0 0 0-.16-.212c-.034-.035-.058-.077-.089-.114a5 5 0 0 0 .212-.46.98.98 0 0 0 .32.674c.022.022.035.052.055.076a1.5 1.5 0 0 0-.181.352 1 1 0 0 0-.128-.277c0-.016.008-.03.007-.045Zm-.794-1.286-.21-.34a1.3 1.3 0 0 0-.334-.292l.193-.192c.173-.174.237-.288.243-.38a1.3 1.3 0 0 0 .216.187c-.045.185-.103.368-.134.557a2 2 0 0 0 .026.46m.192-.962a1.3 1.3 0 0 0 .164.109.4.4 0 0 1 .063.032 1 1 0 0 0 .122.12 2.3 2.3 0 0 0 .345.248l-.01.005a1.2 1.2 0 0 1-.06.505 4.5 4.5 0 0 1-.334.821 2.04 2.04 0 0 1-.415-1.324c.029-.175.083-.344.125-.516m.128-.535q.061-.193.112-.39c.033 0 .333.005.495.564.127.438.057.563.056.564l.004.003a.7.7 0 0 0-.034.248 2 2 0 0 1-.438-.361l.003-.003-.011-.006a.64.64 0 0 1-.188-.611l.002-.007Zm-.02.496q-.044-.026-.085-.056.012-.054.026-.108a.8.8 0 0 0 .058.165Zm.198 2.053c.024.027.041.058.066.085a2 2 0 0 1 .164.215.76.76 0 0 1-.257.584c-.027.03-.044.068-.069.1a.92.92 0 0 1 .019-.834c.03-.049.05-.1.077-.15m.41-.972a1.1 1.1 0 0 0 .058-.454.7.7 0 0 0 .271.422 1.05 1.05 0 0 0 .428.309c.072.028.073.028.065.114a1.5 1.5 0 0 1-.129.344 2 2 0 0 0-.213.617 3 3 0 0 0-.238-.319.91.91 0 0 1-.243-1.033Zm-.494-2.353c-.015.088-.026.177-.046.265a6 6 0 0 1-.137.482c-.043.135-.064.276-.1.414a1.23 1.23 0 0 1-.38-.447.866.866 0 0 1 .154-1.11l.001.006a1.3 1.3 0 0 0 .508.39m-.88.213a2 2 0 0 1-.293-.153l-.001-.026-.033.003a.9.9 0 0 1-.4-.47 2 2 0 0 1 .02-.195l.013.005a1.53 1.53 0 0 1 .818.393.94.94 0 0 0-.125.443Zm-.304-.05a2 2 0 0 0 .307.154.93.93 0 0 0 .134.446 1 1 0 0 0 .097.133c-.007-.001-.008-.011-.015-.012a2.4 2.4 0 0 1-.588-.508 1 1 0 0 0 .065-.212Zm.496.81q.077.025.087.064.022.091-.23.345l-.218.217a1.3 1.3 0 0 0-.255-.115 2.5 2.5 0 0 1-.629-.334 2.05 2.05 0 0 0 .64-.687 2.5 2.5 0 0 0 .605.51m.202 1.36q.12.192.121.192l.014-.01a2.1 2.1 0 0 0 .372.728c-.032.059-.057.121-.092.179a.92.92 0 0 0-.108.552c-.04-.063-.089-.12-.134-.179a1.4 1.4 0 0 0-.06-.477 3.8 3.8 0 0 1-.113-.984Zm.162 1.602a3 3 0 0 1 .166.22h.001c.006.02 0 .042.008.063.019.063.05.122.074.183a2.4 2.4 0 0 0-.378.766 5 5 0 0 1-.11.284c-.11-.075-.214-.16-.327-.231a2.5 2.5 0 0 1 .4-.797 1.4 1.4 0 0 0 .166-.488m-.04 1.264a2 2 0 0 1 .106-.273 1.7 1.7 0 0 1 .593.436c.206.24.084.51-.023.749a1.4 1.4 0 0 0-.08.206.55.55 0 0 0-.169-.421c-.175-.14-.364-.26-.548-.39q.067-.15.12-.307Zm.77.102a1.8 1.8 0 0 0-.63-.462 2.3 2.3 0 0 1 .19-.335 2 2 0 0 0 .267.444 1.5 1.5 0 0 1 .319.595q-.014.068-.024.135a.74.74 0 0 0-.122-.377m-.099-.412a2.1 2.1 0 0 1-.276-.48c.032-.042.054-.09.09-.13a.83.83 0 0 0 .265-.526.7.7 0 0 1 .08.249l.04.004a1.52 1.52 0 0 0 .071 1.007c.025.064.05.114.076.17l-.004-.001c-.024.067-.037.138-.056.207a1.5 1.5 0 0 0-.286-.5m.247-.461a1.1 1.1 0 0 1 .52.36.83.83 0 0 1 .235.514l.02.002a2.6 2.6 0 0 0 .005.517c-.109-.028-.41-.163-.67-.841a1.5 1.5 0 0 1-.11-.552m.086 1.141.02-.002c-.003-.01-.01-.02-.012-.03q.027-.113.063-.224a1.5 1.5 0 0 0 .314.427l-.015.02a.69.69 0 0 1 .224.728c-.015.048-.041.092-.061.138l-.071-.041a.88.88 0 0 1-.52-.563 2.6 2.6 0 0 1 .058-.453m.685.944a.8.8 0 0 0-.09-.63.5.5 0 0 0 .116.037.5.5 0 0 0 .172.214l-.004-.001a.3.3 0 0 0-.008.073 2.2 2.2 0 0 1-.114.606.5.5 0 0 0-.144-.136 2 2 0 0 0 .072-.163m-.177-1.784a1.16 1.16 0 0 0-.597-.404 1.45 1.45 0 0 1 .228-.72 2 2 0 0 1 .15.208.04.04 0 0 1 .014-.032.04.04 0 0 1 .025-.006v.014l-.04.065a.1.1 0 0 0 .033.01 2 2 0 0 0-.027.315 1.18 1.18 0 0 0 .504.635 3 3 0 0 0-.074.33.9.9 0 0 0-.216-.415m.528-.71a.8.8 0 0 1-.251-.128 4 4 0 0 1-.315-.35 2 2 0 0 1 .163-.414 1.5 1.5 0 0 0 .105-.287 1.7 1.7 0 0 0 .33.438.8.8 0 0 0-.083.503.7.7 0 0 0 .05.238Zm-.246-1.258a.24.24 0 0 1 0-.204 2 2 0 0 1 .196-.278 2 2 0 0 0 .211-.304c.02-.034.045-.088.073-.15a2.7 2.7 0 0 1-.001.885 1.7 1.7 0 0 1-.165.473 1.6 1.6 0 0 1-.314-.422m.507-1.24-.022.052-.023.006a1.4 1.4 0 0 1-.39-.863 1.7 1.7 0 0 1 .214-.596c.017.05.033.095.05.162a5.3 5.3 0 0 1 .171 1.2Zm-1.32-1.456a2 2 0 0 1-.18-.38 1.1 1.1 0 0 1-.02-.64c.01-.044.003-.09.01-.136a1.7 1.7 0 0 1 .302.24l.008-.005a.7.7 0 0 0 .052.159c.009.01.022.013.031.023a1.2 1.2 0 0 0-.203.739m.073-1.062a1.7 1.7 0 0 0-.255-.202 2.4 2.4 0 0 0 .028-.4.604.604 0 0 0-.42-.593.6.6 0 0 1-.265-.185.65.65 0 0 1 .03-.658 1 1 0 0 0 .072.017.6.6 0 0 0 .411.633l.002-.007a1 1 0 0 0 .009.106q.011.055.02.106c.039.235.088.4.492.604l-.077.239a.7.7 0 0 0-.047.34m-.438-3.017c-.003-.03.008-.062-.006-.09s-.062-.052-.094-.078l-.02-.051a1.2 1.2 0 0 1 .006-.332c.062-.004.222.013.294.262a1 1 0 0 1-.014.378.4.4 0 0 1-.166-.09Zm-.877.495a.62.62 0 0 0 .231.377 2.3 2.3 0 0 1-.778-.261.816.816 0 0 1 .043-1.012 6 6 0 0 1 .188-.277 2 2 0 0 0 .488.3 1.06 1.06 0 0 0-.172.873m.323.493.005-.033c.006.003.014.002.02.005a.8.8 0 0 0-.099.299 1.7 1.7 0 0 1-.585-.387 1 1 0 0 1-.154-.14 2.3 2.3 0 0 0 .813.256m-.069.375a1 1 0 0 0 .023.102l-.039-.02a.9.9 0 0 0-.033.743 2.2 2.2 0 0 0 .446.46c-.036-.01-.068-.03-.105-.038a1.6 1.6 0 0 0-.475-.035c.004-.025-.002-.05.003-.073a3.5 3.5 0 0 0 .02-.518 2.7 2.7 0 0 0-.406-.97 1.7 1.7 0 0 0 .566.349m-.12 1.305-.009.005a.75.75 0 0 1 .051.705l-.024.033a1.7 1.7 0 0 1-.085-.746q.033.002.067.002Zm-.05.838-.035.047a1 1 0 0 0-.124.159 1.6 1.6 0 0 0-.373-.265 1.7 1.7 0 0 0-.3-.814l.016-.038a1.85 1.85 0 0 0 .7.546l.005-.017a1.8 1.8 0 0 0 .11.382Zm-.638-.092a1.6 1.6 0 0 0-.377-.116c-.009-.002-.012-.006-.02-.008a1.8 1.8 0 0 1 .148-.532 1.6 1.6 0 0 1 .249.656m-.131 4.296a.57.57 0 0 1 .184.418 3 3 0 0 1-.136.505 1.6 1.6 0 0 1-.084-.682c.012-.089.024-.164.036-.241m.277.424a.7.7 0 0 0-.26-.538q.028-.177.054-.325c.016-.075.011-.152.023-.227a5 5 0 0 0 .374.335q.128.099.247.21a3 3 0 0 1 .189.25 1.3 1.3 0 0 1-.162.545 3 3 0 0 0-.4.772 1.6 1.6 0 0 1-.235-.385 3.2 3.2 0 0 0 .17-.637m.054 1.152.064.063.003-.016c.087.056.167.121.252.18a2.5 2.5 0 0 0-.382.932 2.2 2.2 0 0 1-.326-.494c.105-.334.233-.694.276-.814a2 2 0 0 0 .113.149m.396.28c.196.136.397.266.584.415a.44.44 0 0 1 .141.38 2 2 0 0 1-.535-.062 2.4 2.4 0 0 0-.363-.428 4 4 0 0 1 .173-.304Zm.74 1.143.001-.003.045-.085a1 1 0 0 0 .112-.248 1.3 1.3 0 0 1 .083-.21.7.7 0 0 0 .104-.219c-.003.038-.011.075-.012.113a.97.97 0 0 0 .565.624c.033.018.05.034.077.05a1.7 1.7 0 0 1-.25.385 1.4 1.4 0 0 0-.31.542 1 1 0 0 0-.002.094 1.9 1.9 0 0 1-.432-.478.5.5 0 0 1 .018-.565Zm1.038 1.497a.75.75 0 0 1-.1-.503 1.4 1.4 0 0 1 .19-.378l.06-.106a1.1 1.1 0 0 1 .378.25.6.6 0 0 1 .092.19l-.007.13a1.9 1.9 0 0 1-.139.772 1.7 1.7 0 0 1-.474-.355m.418.437c-.009.01-.013.023-.022.032l-.242.219a.87.87 0 0 1-.305-.475 1.4 1.4 0 0 1-.017-.388.8.8 0 0 0 .092.23 1.7 1.7 0 0 0 .494.382m.19-1.224a1.2 1.2 0 0 0-.417-.289c.019-.04.03-.083.046-.125l.024.002a.3.3 0 0 0-.008-.046 2.3 2.3 0 0 0 .157-.735l.002-.028a1.6 1.6 0 0 0 .557.161 1.5 1.5 0 0 0-.013.487.92.92 0 0 0-.32.636l-.029-.063Zm-.379-1.543a2.5 2.5 0 0 1 .096-.982l.006.005c.13.088.252.172.257.238l.016-.001a1.46 1.46 0 0 0 .375.857q.031.024.064.046a1.5 1.5 0 0 0-.053.228c-.058-.005-.655-.064-.76-.391Zm.496-.63.006.005a.13.13 0 0 1 .09-.046c.085-.013.283.008.66.3a2.06 2.06 0 0 1 .695 1.06 4 4 0 0 0-.31-.15 2.6 2.6 0 0 1-.822-.49 1.37 1.37 0 0 1-.32-.678Zm1.581 1.97.04-.11a2 2 0 0 0-.035-.317l.02.035-.001.049a1.1 1.1 0 0 1 .382.099.72.72 0 0 1 .428.607 3 3 0 0 1-.053 1.101 1.6 1.6 0 0 0-.373-.102 1.4 1.4 0 0 1-.568-.206c-.2-.19.062-.89.16-1.155Zm.12-.414a.43.43 0 0 0-.13-.158 2.12 2.12 0 0 0-.758-1.214 1.07 1.07 0 0 0-.74-.316.2.2 0 0 0-.094.055 1.4 1.4 0 0 1 .102-.679c.103.107.207.215.299.332l.008.01.01.004a3.5 3.5 0 0 1 1.2.822.73.73 0 0 1 .083.47.82.82 0 0 0 .252.734 1 1 0 0 0-.232-.06m-1.633-2.54c-.01.017-.01.035-.02.051l-.001-.001a.64.64 0 0 1-.248-.527.7.7 0 0 1 .069-.44 1.7 1.7 0 0 0 .392.26 1 1 0 0 1 .175.08 1.7 1.7 0 0 0-.367.578Zm1.305-1.527c.016.028.039.05.055.079a1.7 1.7 0 0 1-.417-.057 2.6 2.6 0 0 0 .152-.861 1.1 1.1 0 0 0 .172-.612.86.86 0 0 0-.45-.706 1.4 1.4 0 0 0-.322-.127c.043-.095.093-.187.139-.28a3.4 3.4 0 0 1 .72.567 4 4 0 0 1 .303.36 2.5 2.5 0 0 1-.188.533 1.49 1.49 0 0 0-.164 1.104m-.443-.027a.2.2 0 0 1-.085-.15.7.7 0 0 1 .2-.465c.007-.008.01-.02.016-.027a2.5 2.5 0 0 1-.13.642ZM21 27.995a.76.76 0 0 1 .4.629 1 1 0 0 1-.076.426 2.6 2.6 0 0 0-.062-.44.57.57 0 0 0-.479-.424 1.2 1.2 0 0 0-.219-.014q.06-.15.124-.3a1.3 1.3 0 0 1 .312.123m.17.637a2.5 2.5 0 0 1 .059.575 1 1 0 0 1-.099.164.77.77 0 0 0-.188.377l-.082-.18c-.05-.106-.016-.131.056-.184a.414.414 0 0 0-.051-.685.83.83 0 0 0-.535.042l.055-.135c.044-.12.098-.236.146-.354.187.003.56.05.64.38Zm-.343.153a.25.25 0 0 1 .141.183c.056.22-.023.28-.107.34l-.025.014a.207.207 0 0 0-.062.286l.142.307h.001a.28.28 0 0 0 .137.213c-.03.076-.058.151-.095.224a.78.78 0 0 0-.327-.718c-.164-.137-.275-.193-.35-.187a3 3 0 0 0-.05-.367l.022-.028q-.016-.016-.031-.032l-.002-.013.062-.15a.77.77 0 0 1 .544-.072m-.534.734c-.003.009-.006.009-.008.01v-.013Zm1.293 1.648a1.25 1.25 0 0 1 .385.537c.013.036.032.07.047.107a.2.2 0 0 0 .026.118l.019-.015a3.3 3.3 0 0 0 .285.528.7.7 0 0 1-.502-.115 6 6 0 0 1-.421-.285 2.3 2.3 0 0 1 .16-.875Zm.473.51a1.33 1.33 0 0 0-.436-.603c.205-.37.349-.372.355-.372a4 4 0 0 0 .424.398.44.44 0 0 1-.185.4.44.44 0 0 0-.158.176Zm.223-2.8q-.013.028-.026.057a1.7 1.7 0 0 0-.27-.52 2.6 2.6 0 0 0 .062-.582 1 1 0 0 0-.074-.279q.043.044.088.086c.306.277.49.444.39.824a2 2 0 0 1-.17.414m-.093.204a1.37 1.37 0 0 0-.03.92l.007.033.056.232a1.8 1.8 0 0 0-.511-.106c-.028-.045-.066-.084-.092-.13a1.43 1.43 0 0 1 .166-1.03 2.6 2.6 0 0 0 .166-.474 1.2 1.2 0 0 1 .238.555m-.285-.78a4 4 0 0 0-.254-.293 3.5 3.5 0 0 0-.745-.587q.067-.136.137-.27h.006l.049-.007a.78.78 0 0 1 .857.697 2.5 2.5 0 0 1-.05.46m-.816-1.24c.025-.047.046-.097.072-.143a1 1 0 0 0 .15-.447 2.3 2.3 0 0 0 .334.724 1.2 1.2 0 0 0-.556-.134m-.006-.196c-.092.165-.173.336-.257.505-.026-.015-.049-.034-.075-.048a.88.88 0 0 1-.448-.416 1 1 0 0 0-.05-.257 1 1 0 0 1-.009-.17 2.06 2.06 0 0 1 .674-1.37q.047.043.091.09a3 3 0 0 1 .083.29 2 2 0 0 0 .122.454 1.4 1.4 0 0 1-.131.922m-.813.198a.82.82 0 0 0 .434.34c.028.015.052.036.079.051-.049.1-.101.197-.147.298l-.003-.001-.003.016c-.06.131-.11.266-.164.399-.018 0-.035-.005-.052-.003l.01.093h.005c-.042.105-.09.208-.13.315l-.037.09a5.7 5.7 0 0 0-.165-1.054 2 2 0 0 0-.07-.228 1.7 1.7 0 0 1 .243-.316m-.285.216a.6.6 0 0 0-.203-.262c-.055-.041-.083-.061-.083-.196a.76.76 0 0 1 .228-.55.1.1 0 0 1 .05-.027 1.3 1.3 0 0 1 .173.35.8.8 0 0 0 .044.294c.003.034.016.065.015.099a1.8 1.8 0 0 0-.224.292m-.119-1.08a.86.86 0 0 0-.26.62v.006a.72.72 0 0 1-.5-.23.62.62 0 0 1-.038-.555q.033-.107.072-.223c.018.008.026.015.046.024a3 3 0 0 0 .706.252l.006-.001v-.015c.013.03.024.058.043.092-.026.01-.055.01-.075.03m-.013-.215a3 3 0 0 1-.63-.23c-.023-.01-.033-.018-.054-.028.09-.264.176-.502.196-.557a1.4 1.4 0 0 0 .17.165c.139.107.297.228.29.3l.027.002a.38.38 0 0 0 .001.348m-.543-.868-.023-.008c-.001.004-.103.282-.202.575-.351-.176-.393-.311-.429-.53l-.02-.11c-.034-.164-.022-.173.016-.202a.45.45 0 0 0 .145-.18.44.44 0 0 0-.049-.454c-.008-.014-.01-.03-.018-.044a1 1 0 0 1 .228.15.38.38 0 0 1 .1.25l.019.002a1.7 1.7 0 0 0 .065.389 1.4 1.4 0 0 0 .168.162m-.192-1.1a1.7 1.7 0 0 0-.037.32.5.5 0 0 0-.052-.085 1.1 1.1 0 0 0-.36-.238c-.004-.012-.012-.023-.015-.035a.8.8 0 0 1 .056-.366c.01-.024.01-.05.018-.074q.073.012.14.02c.113.013.221.024.263.077a.15.15 0 0 1 .022.115q-.015.134-.035.267Zm-.24-.551-.129-.018a1 1 0 0 0 .014-.427.38.38 0 0 0-.38-.324 1.2 1.2 0 0 1 .149-.385 1 1 0 0 0 .09-.204c.016.07.028.13.053.218l.12.417a2.6 2.6 0 0 0 .266.752.5.5 0 0 0-.183-.03Zm-.276-2.067a1 1 0 0 0-.038.15.6.6 0 0 0-.167-.084 5 5 0 0 1-.595-.272c-.018-.008-.03-.024-.048-.032a1.5 1.5 0 0 0 .284-.255 1.1 1.1 0 0 0 .177-.566.83.83 0 0 1 .393.502.86.86 0 0 1-.006.557m-.844-.123a5 5 0 0 0 .605.277c.136.052.17.065.19.155.002.04.01.093.017.144a.8.8 0 0 1-.122.418 1.3 1.3 0 0 0-.071.186.6.6 0 0 0-.213-.238 5 5 0 0 1-.305-.256.74.74 0 0 1-.186-.728l.01-.009c.027.014.047.039.075.05Zm-.615 2.934-.021.016a2.7 2.7 0 0 1 .493 1.1c.004.108-.006.216-.013.324-.017-.131-.02-.264-.05-.393a1.5 1.5 0 0 0-.749-.965c.002-.191 0-.402-.003-.59a1.15 1.15 0 0 0 .343.508m-.342.243v-.053a1.42 1.42 0 0 1 .658.873c.021.097.024.197.039.295a3.4 3.4 0 0 0-.637-.554c-.036-.027-.067-.058-.102-.084.005-.029-.003-.057.005-.085a4 4 0 0 0 .037-.392m.002.635a3.6 3.6 0 0 1 .62.535 1.4 1.4 0 0 1 .115.253c.006.062.022.124.025.187l.023.002a2 2 0 0 0-.011.299 1.8 1.8 0 0 1-.668-.544 1.2 1.2 0 0 1-.156-.775q.026.022.052.043m-.613.785a1.8 1.8 0 0 1-.343.776 3 3 0 0 1-.364-.4.7.7 0 0 1 .107-.15q.06-.07.132-.161a.59.59 0 0 0 .128-.463 2 2 0 0 1 .246.07 1.1 1.1 0 0 1 .094.328m-.276.845a2 2 0 0 0 .212-.355.58.58 0 0 0 .282.268 4 4 0 0 1-.236.38 2 2 0 0 0-.267-.3Zm.274.445a.63.63 0 0 1 .273.515 1.02 1.02 0 0 1-.29.692 1.14 1.14 0 0 1-.29-.85c.073-.076.157-.142.225-.224.032-.042.052-.09.082-.133m-.298.977.009-.008a1.2 1.2 0 0 0 .313.422l.005.002a.77.77 0 0 0-.066.583l-.01-.001a4 4 0 0 0-.048.346 1.2 1.2 0 0 0-.028-.32 1.7 1.7 0 0 0-.29-.424c-.098-.115-.219-.258-.19-.308a1.4 1.4 0 0 1 .305-.292m.663 3.424a4 4 0 0 0 .095-.77q.104.081.2.172c-.016.096-.03.194-.046.308a1.7 1.7 0 0 0 .138.84c-.016.045-.019.094-.037.138a3 3 0 0 0-.135.48 2.1 2.1 0 0 1-.234-1.071Zm.438.72c.005-.012.005-.026.01-.038a2 2 0 0 0 .098.16l-.023-.007a24 24 0 0 0-.244.705.6.6 0 0 1-.03-.15 3 3 0 0 1 .19-.67Zm-.158 1.133a2.6 2.6 0 0 0 .36.505.5.5 0 0 0 .034.162 2.2 2.2 0 0 0 .443.525 1.35 1.35 0 0 1-.826-.341.64.64 0 0 1-.09-.567c.02-.082.048-.18.08-.284Zm.481.632a.4.4 0 0 1-.016-.085l.033-.032-.048-.053a1.4 1.4 0 0 1 .157-.581 2.3 2.3 0 0 1 .336.403l-.007.016.018.002a2.3 2.3 0 0 1 .199.355 3 3 0 0 1 .138.807c-.053-.045-.098-.099-.154-.14a2.1 2.1 0 0 1-.656-.692m2.55 2.504c.084.053.17.103.244.145a1.4 1.4 0 0 1 .251.163 3.5 3.5 0 0 1-.069.567 2 2 0 0 0-.296-.085c-.297-.053-.46-.498-.489-.58a1 1 0 0 1 .358-.21Zm.291.064a7 7 0 0 1-.245-.146l-.008-.03-.025.009a3 3 0 0 1-.217-.157l.235-.213a1.4 1.4 0 0 0 .248-.95l.007-.123h.009c-.001-.007-.007-.012-.008-.018l.007-.132a.84.84 0 0 1 .252-.55 2 2 0 0 0 .025.176 1 1 0 0 0 .231.358 2.33 2.33 0 0 0-.45 1.177c.014.128.038.27.068.415a2 2 0 0 0 .098.33 2 2 0 0 0-.227-.146m.58.5a.7.7 0 0 1-.24-.325 1 1 0 0 1 .407-.133.7.7 0 0 1 .296.057v-.002a1 1 0 0 0 .058.224 1.37 1.37 0 0 0 .564.675 2 2 0 0 1-.168.245l-.005.007c0-.008.005-.015.004-.023 0-.22-.33-.4-.65-.573-.099-.054-.192-.104-.266-.152m1.096.646a3 3 0 0 1 .022.41 1.2 1.2 0 0 0-.268-.08q.067-.086.14-.176c.042-.046.068-.104.106-.154m-.3.411.022.006a1 1 0 0 1 .294.089 2.8 2.8 0 0 1-.127.698q-.01-.01-.021-.02c-.166-.117-.266-.188-.302-.368a.55.55 0 0 1 .133-.404Zm.41.13a1.1 1.1 0 0 1 .295.23.5.5 0 0 1 .07.105c-.023.06-.057.117-.074.18a3.4 3.4 0 0 1-.177.46 2.5 2.5 0 0 0-.26-.243 2.8 2.8 0 0 0 .145-.732Zm-.6-1.403a.98.98 0 0 1 .221-1.102q.054.03.109.055l-.009.07c.005 0 .503.069.581.37a1.7 1.7 0 0 1-.246 1.046l-.019.042c-.026.05-.067.092-.097.14a1.3 1.3 0 0 1-.54-.621m.723.518.019-.042a1.78 1.78 0 0 0 .251-1.107.47.47 0 0 0-.215-.267l.008.001a1.6 1.6 0 0 1 .378.102c-.016.061-.018.125-.037.186l-.066.285a1.9 1.9 0 0 0 .063 1.154 1.2 1.2 0 0 1-.41-.088c-.037-.016-.062-.049-.097-.068.033-.053.078-.099.106-.155Zm.933-1.136a1.6 1.6 0 0 0-.383-.242 3.1 3.1 0 0 0 .055-1.136.82.82 0 0 0-.244-.51 1.2 1.2 0 0 0 .28.091l-.005.008a1.5 1.5 0 0 1 .62.942 1.2 1.2 0 0 1-.323.847m-.138-1.778h.01l-.004.004Zm1.222-.823a3.8 3.8 0 0 0-.694-1.037c-.367-.397-.581-.321-.807-.241a.7.7 0 0 1-.132.022 3.3 3.3 0 0 1-.341-.641.37.37 0 0 1 .166-.207.52.52 0 0 0 .21-.4q.018.017.035.033a3 3 0 0 0 .343.509 2 2 0 0 0 .989.689c.194.05.354.095.494.138.074.124.272.502.103.755a1.16 1.16 0 0 0-.169.664c-.075-.03-.12-.123-.197-.284m.368-2.331a1.9 1.9 0 0 1-.284.55 7 7 0 0 1-.663-.234 2.8 2.8 0 0 1-.551-.302 2.3 2.3 0 0 0 .463-1.292.66.66 0 0 1 .755.16 1.04 1.04 0 0 1 .28 1.118m-3.533-6.374c-.062-.06-.116-.127-.183-.181a2.5 2.5 0 0 1-.46-.457 1 1 0 0 0 .22.05c.028.003.052.015.08.019.12.186.24.372.343.569m-.889-.868a.73.73 0 0 1-.15-.617 7.4 7.4 0 0 1 .628.804.84.84 0 0 1-.478-.186Zm-.725-1.357a.44.44 0 0 1 .18-.32.63.63 0 0 0 .18-.51c.027.032.049.069.079.099a.66.66 0 0 1 .205.868q-.07.196-.121.393c-.018-.02-.031-.041-.049-.06a.8.8 0 0 0-.366-.22.4.4 0 0 1-.108-.25m-1.395-2.525a.8.8 0 0 1 .22.064 1 1 0 0 1-.163.555 1.3 1.3 0 0 1-.294.26 1 1 0 0 1-.419-.45.36.36 0 0 1 .012-.242q.135-.096.32-.221a2 2 0 0 1 .324.035Zm-.311.941-.003.002-.006.018a.8.8 0 0 0-.026.338 2.5 2.5 0 0 1-.47-.022l.004-.015a1.3 1.3 0 0 0-.087-.873q.063-.055.125-.11l.01-.006a.5.5 0 0 0 .017.179 1.1 1.1 0 0 0 .436.49Zm-.587.28c-.008.017-.008.035-.015.052q-.012-.001-.023-.001a.73.73 0 0 1-.494-.42c.152-.131.3-.268.454-.396a1.2 1.2 0 0 1 .078.766Zm-.336-1.584a2 2 0 0 1-.204-.074.7.7 0 0 1-.266-.224c.172.086.345.171.51.27Zm.17-.117a8 8 0 0 0-.79-.42l-.025-.051q.025-.826-.02-1.651a1.75 1.75 0 0 1 .509.617 5 5 0 0 1 .41 1.447Zm-.823-.06q.001-.063.002-.126a.9.9 0 0 0 .39.358c.038.02.083.026.123.043-.22.155-.423.329-.64.487a2.8 2.8 0 0 0 .125-.762m.115 1.69.008.002a.66.66 0 0 1 .59.557 3.8 3.8 0 0 1 .015.953q-.003.045-.004.09a.9.9 0 0 0-.259-.296A2.3 2.3 0 0 1 16 21.493l.135-.117Zm-.041 1.694a2 2 0 0 1 .495.283q.06.085.114.177c.003.201.007.466.006.705l-.01-.005-.013-.003c-.003-.001-.288-.043-.526-.569a2 2 0 0 1-.092-.233.39.39 0 0 1 .026-.355m.07 1.49c-.053.093-.09.195-.152.283a.77.77 0 0 0-.316-.334c-.135-.094-.262-.183-.298-.321a.69.69 0 0 1 .225-.576c.013.026.02.054.034.079a.8.8 0 0 0 .328.284.86.86 0 0 0 .18.585Zm-.52.026c.15.105.292.205.302.375h.007a.76.76 0 0 0 .106.458c.003.005.002.013.006.019a2 2 0 0 0-.25-.071 4 4 0 0 1-.384-.138 2.6 2.6 0 0 0 .053-.42.98.98 0 0 0-.217-.592c.02.006.037.016.056.021a.7.7 0 0 0 .32.348Zm-.227.758.002-.017c.153.063.286.105.34.122a.5.5 0 0 1-.113.43q-.068.09-.128.158a1 1 0 0 0-.09.128.5.5 0 0 1-.082-.245 2.8 2.8 0 0 1 .071-.576m.39 1.398a1.9 1.9 0 0 1 .314.348c-.032.047-.055.1-.09.146-.06.073-.136.132-.202.202-.094-.097-.49-.52-.472-.821a.7.7 0 0 1 .066-.285 3.5 3.5 0 0 0 .384.41m.052 1.3-.027.022a1.4 1.4 0 0 0-.327.317 1.9 1.9 0 0 0 .006-.51l.008.01c.098-.081.179-.18.27-.27a1.2 1.2 0 0 0 .07.43Zm-.157.758a1.6 1.6 0 0 1 .274.397 1.08 1.08 0 0 1-.096.716 3 3 0 0 1-.382-.277c-.175-.148-.16-.553-.148-.7.021-.056.03-.114.057-.167a2 2 0 0 0 .083-.292.9.9 0 0 0 .212.323m-.383-.066c-.016.04-.024.083-.038.124l-.019-.002-.007.087a3 3 0 0 0-.104.42 1.04 1.04 0 0 1-.38-.565.83.83 0 0 1 .28-.683 1.6 1.6 0 0 0 .161.223c.082.085.135.143.14.227-.016.055-.012.114-.033.169m-1.907-1.607a1.52 1.52 0 0 0 .73.554l.005.014a1 1 0 0 0-.358-.008 1.46 1.46 0 0 1-.73-.043c-.191-.122-.154-.736-.116-1.03a1 1 0 0 0 .371.258l.014-.04a1.3 1.3 0 0 0 .084.295m-.404.597a.77.77 0 0 0 .398.08q.039-.002.078-.005a.78.78 0 0 0 .227.654 1.15 1.15 0 0 0-.121.802.8.8 0 0 0 .157.25.9.9 0 0 1-.062.315l-.052.134-.007.02a.8.8 0 0 1-.183-.131.61.61 0 0 1-.1-.648 1.5 1.5 0 0 0 .059-.28q.009-.099.024-.193c.04-.264.078-.514-.253-.64a2 2 0 0 0-.444-.091c-.016 0-.031-.008-.047-.008a1.8 1.8 0 0 0-.003-.496.6.6 0 0 0 .228.11.3.3 0 0 0 .101.127m-.291.36a2 2 0 0 1 .198.04 1.7 1.7 0 0 1-.002.81c-.039.133-.074.282-.11.429a1.6 1.6 0 0 1-.213-.168c-.15-.218-.069-.517.016-.834q.034-.123.063-.247c.003-.013.001-.025.004-.037.015 0 .029.008.044.008Zm-.198 2.117a2 2 0 0 0 .107-.2v.007c-.017.057-.028.115-.047.172a2.03 2.03 0 0 0 .134 1.482l.053-.028a1.1 1.1 0 0 0-.132.257 2.15 2.15 0 0 1-.115-1.69m.377 1.39a1 1 0 0 1 .133.002 4 4 0 0 0-.183.642 2 2 0 0 1-.154-.251 1.04 1.04 0 0 1 .204-.393m.23.004a.95.95 0 0 1 .631.37 1.7 1.7 0 0 1 .264.734h.01c.002.08-.012.16-.016.24a1.31 1.31 0 0 1-1.089-.591 3.8 3.8 0 0 1 .2-.753m3.194 2.14c.006-.02.005-.043.012-.064a.94.94 0 0 0-.11-.896 1.04 1.04 0 0 0-.723-.484c0-.015-.007-.03-.007-.044l-.006-.04a3.6 3.6 0 0 0 .69.1 1 1 0 0 1 .274.034c.023.023.056.034.075.06l.012-.006a2.1 2.1 0 0 0 .18.464l.017-.01c-.006.032-.02.062-.026.094a.75.75 0 0 0 .064.348 6 6 0 0 0-.11.387.73.73 0 0 0 .107.647 1.4 1.4 0 0 0 .962.394c.007.007.008.016.015.024a3.6 3.6 0 0 0-.324.549l.002-.03a1.24 1.24 0 0 1-.805-.379q-.003-.029-.007-.057a2.25 2.25 0 0 0-.292-1.09Zm1.076 1.615c-.044.096-.092.19-.128.29a.83.83 0 0 0 .091.622.83.83 0 0 1-.574-.537v-.004l-.01-.038a3.4 3.4 0 0 1-.137-.648 1.37 1.37 0 0 0 .758.316Zm-.038.318a3.5 3.5 0 0 1 .443-.837 1.2 1.2 0 0 1 .255.76 1.3 1.3 0 0 1-.279.73c-.047.067-.078.143-.118.213a1.03 1.03 0 0 1-.3-.866Zm.52-.882c.012.008.02.019.032.027a3 3 0 0 1 .433.393 1.6 1.6 0 0 0 .22.213l.08.075a1.46 1.46 0 0 0-.546.352 1.4 1.4 0 0 0 .053-.248 1.26 1.26 0 0 0-.272-.812m.759 2.244a2 2 0 0 0 .242-.05.46.46 0 0 0 .263-.25 1.9 1.9 0 0 1 .081.806l-.001.009a5 5 0 0 1-.187.566 2 2 0 0 0-.039-.566c-.074-.283-.372-.341-.551-.375-.034-.007-.075-.015-.1-.022a.45.45 0 0 1 .292-.118m.679.527v-.01c.003-.023.038-.31.089-.606.005-.028.028-.047.04-.071.073.178.248.515.531.566a2 2 0 0 1 .3.085 3.5 3.5 0 0 1-.198.619c-.067-.04-.13-.088-.199-.123a1.2 1.2 0 0 0-.658-.169c.028-.098.073-.191.095-.291m.845.63a3.6 3.6 0 0 0 .206-.64 2 2 0 0 1 .54.283.5.5 0 0 0 .089.114c.011.008.017.021.027.03a1.3 1.3 0 0 0-.159.726c.001.014-.002.028 0 .042a3.7 3.7 0 0 0-.704-.552Zm.773.946.017-.008-.009-.03q.005-.048.009-.097a.32.32 0 0 1 .156-.187.6.6 0 0 0 .202-.202.65.65 0 0 0 .335.415c.015.01.024.026.039.036-.029.078-.053.157-.089.233a2 2 0 0 1-.111.189.47.47 0 0 0-.29-.081.45.45 0 0 1-.298-.083q.024-.092.04-.185Zm1.416.442-.068-.085c-.043-.056-.106-.092-.154-.144a3.5 3.5 0 0 0 .193-.5c.009-.031.027-.06.037-.09a1.6 1.6 0 0 1-.008.82Zm-.003-1.042a1 1 0 0 0-.043-.064 1.2 1.2 0 0 0-.358-.268 3 3 0 0 0-.031-.538 1.4 1.4 0 0 0 .574.168h.008c.018.043.046.082.068.125a.86.86 0 0 1-.14.387c-.034.06-.05.127-.078.19m.157-.14a.9.9 0 0 0 .133-.317c.031.05.054.106.091.154l.018-.014a.6.6 0 0 0 .005.15l-.017-.008a4 4 0 0 0-.158.4q-.026.07-.052.133l-.027.072a1 1 0 0 0-.087-.337 2 2 0 0 1 .094-.233m.107.534q.026-.062.053-.137.015-.04.031-.079a1 1 0 0 0 .329.426.45.45 0 0 1 .223.497.4.4 0 0 1-.079.087 2.2 2.2 0 0 0-.466-.368c-.208-.14-.17-.23-.09-.426Zm.462.13a.94.94 0 0 1-.332-.462q.02-.053.041-.104a.6.6 0 0 0 .34.334c.188.096.337.172.225.589l-.006.016a.54.54 0 0 0-.268-.373m1.22-2.203.016-.008a.37.37 0 0 1-.042-.306 1.3 1.3 0 0 1 .445.284q.006.013.013.027a.23.23 0 0 1 .05.107c.004.06-.082.138-.173.22l-.067.064a.22.22 0 0 0-.008-.133.9.9 0 0 0-.234-.255m-.19-1.686a1.6 1.6 0 0 1-1.036-.67 1.8 1.8 0 0 0 .531-.125 2.8 2.8 0 0 0 .624-.347l-.01-.011a.2.2 0 0 0 .062.029v.007l.01-.002c.017.004.027.023.047.023a.9.9 0 0 0 .303-.094 2.7 2.7 0 0 1 .325.622 5 5 0 0 0 .07.409.6.6 0 0 1-.033.178 1.4 1.4 0 0 1-.194.316c-.009-.018-.006-.04-.019-.055a1.02 1.02 0 0 0-.68-.28m.906-1.03a.7.7 0 0 1 .295-.53.7.7 0 0 0 .107-.103.3.3 0 0 0 .095.037 1.3 1.3 0 0 0 .166.147l-.036.019c.114.22.377.83.224 1.017a4 4 0 0 0-.217.446l-.042-.013a2 2 0 0 0-.037.174 4 4 0 0 0-.235.797 4.6 4.6 0 0 0-.14-.813c-.027-.103-.044-.207-.065-.31a1.2 1.2 0 0 0-.073-.43c-.017-.146-.036-.29-.042-.437Zm4.403 2.879c-.105-.263-.31-.312-.546-.368a1.9 1.9 0 0 1-.599-.228.9.9 0 0 1-.343-.482c-.007-.08-.028-.16-.04-.241a1 1 0 0 1 .017-.222 2.05 2.05 0 0 0 .196-.981l.04.033a3.2 3.2 0 0 0 .752 1.377q.112.099.21.178c.408.342.577.484.518 1.04-.021.2-.038.4-.053.585a3 3 0 0 0-.152-.691m.85.84a1.4 1.4 0 0 1-.05-1.076 1.2 1.2 0 0 0 .341.267 1.3 1.3 0 0 1 .492.443 4 4 0 0 1-.327.426 1.5 1.5 0 0 0-.232.261 2.5 2.5 0 0 1-.225-.321Zm.34-.89a1.1 1.1 0 0 1-.351-.282 1.4 1.4 0 0 1 .164-.29.9.9 0 0 0 .188-.83l-.02-.17c-.027-.273-.24-.406-.493-.552a2.8 2.8 0 0 0-.248-.786.59.59 0 0 1-.033-.578 1.1 1.1 0 0 1 .167-.208 2.1 2.1 0 0 0 .51-.861 1.9 1.9 0 0 0 .126-.677 2 2 0 0 0 .298.348 2.2 2.2 0 0 0-.48.584 1.7 1.7 0 0 0-.16 1.4 1.57 1.57 0 0 0 .651.88c-.45.55-.32.983.084 1.515q.017.017.033.034l-.015.019.11.089.004-.005q.051.058.105.11l-.029.023c.002.002.14.22-.116.674a1.4 1.4 0 0 0-.496-.436Zm1.526-.552a.94.94 0 0 1 .51-.483 1.6 1.6 0 0 0 .52.242 1.3 1.3 0 0 0 .165.337 5.8 5.8 0 0 0-.976.956.5.5 0 0 0-.115-.198 1 1 0 0 0-.11-.075 1.37 1.37 0 0 1 .006-.78Zm.242 1.238h.002v-.002c.055-.072.121-.134.18-.204a2.37 2.37 0 0 0 1.27.613 1.3 1.3 0 0 1-.356.729c-.06-.029-.113-.069-.176-.091a3 3 0 0 1-.495-.255 1.15 1.15 0 0 1-.482-.725c.017-.024.04-.042.057-.065m1.542.423c.206.03.382.047.522.06.377.034.533.048.623.28l.086.224a4.5 4.5 0 0 1-.274.832c-.107.135-.23.257-.342.388a1.6 1.6 0 0 0-.348-.548 2.1 2.1 0 0 0-.63-.48 1.36 1.36 0 0 0 .363-.756m1.352.673.02-.007-.012-.031q.013-.056.023-.11l.022.004c.02-.101.1-.16.248-.266a4 4 0 0 0 .386-.312.88.88 0 0 0 .27-.487c.073.19.153.382.25.583q.024.047.048.094c-.002.02-.01.038-.013.058l.046.005q.034.07.07.138h-.018c.001.003.003.165-.254.36a1.6 1.6 0 0 1-.545.204 1.6 1.6 0 0 0-.63.255l-.105.09a5 5 0 0 0 .194-.578m.064.51a1.5 1.5 0 0 1 .47.728 3 3 0 0 1 .021.68.7.7 0 0 1-.447-.435 2.4 2.4 0 0 1-.12-.934c.024-.015.051-.025.076-.04Zm.085-.045a1.5 1.5 0 0 1 .416-.141 1.7 1.7 0 0 0 .578-.22.7.7 0 0 0 .268-.333 9 9 0 0 0 .6 1.02 4.5 4.5 0 0 0-.985.562 2.6 2.6 0 0 0-.368.404 2.6 2.6 0 0 0-.033-.537 1.6 1.6 0 0 0-.476-.755m.493 1.483a2.5 2.5 0 0 1 .236-.278 2.04 2.04 0 0 1 .277 1.364 1.93 1.93 0 0 1-.54-1.041Zm1.557-1.137a5 5 0 0 0 .744-.55 1.8 1.8 0 0 0 .334-.313 4.3 4.3 0 0 0-.058.995 1.8 1.8 0 0 1-.156.913 9 9 0 0 1-.864-1.045m1.162.124a4.2 4.2 0 0 1 .074-1.104 1.6 1.6 0 0 0 .201.184 1.5 1.5 0 0 0 .273.982q.076.139.16.285c.057.084.097.178.149.266l-.02.006a3.3 3.3 0 0 0-.904.555l-.07-.077-.054-.06a1.9 1.9 0 0 0 .191-1.037m.888.75c.013-.005.026-.006.04-.012a5.3 5.3 0 0 1 .464 1.092.7.7 0 0 1-.272.49 2.5 2.5 0 0 1-.631-.533c-.163-.189-.311-.347-.461-.509a3.2 3.2 0 0 1 .86-.527Zm-.057-.473-.16-.284a1.4 1.4 0 0 1-.255-.843 1.5 1.5 0 0 0 .248.125.5.5 0 0 0 .127.022 2.7 2.7 0 0 0 .592 1.187 2 2 0 0 0-.388.086c-.057-.097-.101-.2-.164-.293m.103-.967a2.36 2.36 0 0 0 .965.504 4.4 4.4 0 0 1 .883.379 1.05 1.05 0 0 1-.709.252c-.183.014-.32.016-.43.018-.033-.001-.065.007-.097.008l-.037-.052a2.8 2.8 0 0 1-.575-1.109m1 .367a2.25 2.25 0 0 1-.86-.44 1.3 1.3 0 0 0 .527-.31 1.5 1.5 0 0 0 .403.123l.003-.044a.76.76 0 0 0 .265.333 3.8 3.8 0 0 1 .636.762 4.4 4.4 0 0 0-.974-.424m.433-.443c-.183-.165-.283-.256-.298-.481a.4.4 0 0 1 .025-.192 2.2 2.2 0 0 0 1.08.407 1 1 0 0 0 .219-.022 1.5 1.5 0 0 0 .415-.14l-.009.024a.41.41 0 0 1 .215.408 3.4 3.4 0 0 1-.055.568c-.03.035-.056.073-.086.109-.196.21-.39.39-.594.574a3.9 3.9 0 0 0-.912-1.255m1.013 1.93a11 11 0 0 0 .465 1.12c-.191-.194-.38-.392-.585-.57a.96.96 0 0 0-.754-.254 7 7 0 0 1 .724-.733 4 4 0 0 1 .15.438Zm1.11-.861a2.4 2.4 0 0 1-.278-.592q.684-.828 1.3-1.707c.047.004.092.025.14.024.26.022.486.042.6.18a.68.68 0 0 1 .09.502c-.063.65-.513.875-.948 1.092-.332.165-.645.32-.718.658l-.022.086Zm.255.465a6 6 0 0 0 .069-.279c.059-.27.329-.406.643-.562a1.4 1.4 0 0 0 .235-.11.9.9 0 0 0 .147.743 2.4 2.4 0 0 0 .62.59 2.2 2.2 0 0 1-1.568.766 1.18 1.18 0 0 1-.146-1.148m1.902.453a2.8 2.8 0 0 0 .483-.63c.044-.064.1-.118.148-.18a2.4 2.4 0 0 1 .622.281 1 1 0 0 1-.272.407c-.106.097-.186.165-.25.22a1.36 1.36 0 0 0-.397.48 1 1 0 0 0-.058.176 1.4 1.4 0 0 0-.123-.265 1.6 1.6 0 0 1-.153-.49Zm2.074 2.387a5 5 0 0 1 .503.357l.01-.01a9 9 0 0 1 .324.929 1.09 1.09 0 0 1-.733-.444 1.27 1.27 0 0 1-.104-.832m.52.014q.184-.092.36-.194a4.8 4.8 0 0 1 .92.588 1.5 1.5 0 0 1 .148.16.7.7 0 0 1-.109.185 4 4 0 0 1-.83.633l-.035-.142a9 9 0 0 0-.453-1.23Zm1.734-8.24a4 4 0 0 0 .483-.584l.046-.006c-.003-.012-.011-.021-.014-.032a4 4 0 0 0 .439-.856c.084-.184.15-.375.223-.563a4 4 0 0 1 .344.645l.077-.023a9.4 9.4 0 0 0-1.036 2.35c-.005-.039-.002-.078-.01-.117a1.85 1.85 0 0 0-.551-.814Zm1.24-2.2a10 10 0 0 0 .376-1.261 2.08 2.08 0 0 0-.443-1.813l-.058-.087q.059-.13.112-.26a3.3 3.3 0 0 1 .552 1.33 14 14 0 0 1 .021 2.555 9 9 0 0 0-.166.254 4 4 0 0 0-.394-.718m.47-5.006.003-.014-.006-.002a8 8 0 0 0-.108-.45q.228-.113.456-.207a2.5 2.5 0 0 0 .49 1.07 3 3 0 0 1-.493.785 1.2 1.2 0 0 0-.193.247c-.001-.045-.004-.103-.004-.145a7.7 7.7 0 0 0-.146-1.284Zm.478-.727.099-.04c.125-.052.242-.117.361-.18a1.6 1.6 0 0 1 .042 1.009c-.02.066-.057.125-.082.19a2.5 2.5 0 0 1-.42-.979m-2.793-5.761-.185-.012c-.248-.016-.496-.013-.744-.021l-.063-.046q.871.011 1.74.083l.07.05zm-1.216-.235q-.134-.088-.27-.175a241 241 0 0 1 1.514-.042c.16.092.319.183.474.282a26 26 0 0 0-1.717-.065Zm-.477-.31q-.18-.119-.362-.234c.381-.04.747-.077 1.084-.104l.004.018.005-.019c.058-.005.109-.006.165-.01.195.095.384.202.574.307q-.692.018-1.47.042m.79-.565.006-.022a.97.97 0 0 1 .682-.674 1.73 1.73 0 0 1 .866.08 7.4 7.4 0 0 1 .943.685l.07.1a8.3 8.3 0 0 0-2.434-.097c-.045-.022-.087-.05-.133-.072m.661-.834a1.02 1.02 0 0 0-.717.584 1.9 1.9 0 0 0-.882-1.055 2.34 2.34 0 0 1-.987-.975l-.04.019.024-.07c.127.028.236.051.336.071-.01.11.007.349 1.304.803a7.4 7.4 0 0 1 1.471.606 1.9 1.9 0 0 0-.509.017m-2.26-1.424.02.004-.015.01-.004-.014Zm-.295-.207c.013-.042.032-.088.045-.13a6 6 0 0 0 .107-.806 2.7 2.7 0 0 0 .642.312l.002.008c.023.107.082.235.51.517a5 5 0 0 1 .68.604 5 5 0 0 0-1.132-.341 14 14 0 0 1-.854-.164m.036-2.627c-.046-.342-.092-.67-.105-.965a1.47 1.47 0 0 0-.116-.703 3 3 0 0 1 .281.323 2.1 2.1 0 0 0 .39.472 8.3 8.3 0 0 0 .483 1.503 4 4 0 0 0-.414-.322q-.176-.101-.317-.18c-.072-.035-.133-.087-.202-.127Zm.134-1.403a3.4 3.4 0 0 0-.344-.394l-.052.057a1.46 1.46 0 0 0-.405-.505 5 5 0 0 1-.39-.4c-.033-.033-.075-.054-.11-.085a1.5 1.5 0 0 0 .332-.228c.632.482 1.058.844 1.159 1.476.02.139.058.274.085.412a9 9 0 0 1-.275-.333m-1.423-1.422a2.9 2.9 0 0 0-.886-.499 2 2 0 0 1 .036-.203.8.8 0 0 1 .165-.34c.357.312.69.567.985.79l.04.031a1.4 1.4 0 0 1-.34.22Zm-.154.058a1.4 1.4 0 0 1-.35.06 13 13 0 0 0-.408-.368q-.002-.053 0-.107a2.7 2.7 0 0 1 .758.415m-.573.723c.049.08.107.154.16.231a.17.17 0 0 1-.062.113 1.25 1.25 0 0 1-.495.026c-.05-.005-.099.002-.148 0l-.043-.03a2.3 2.3 0 0 1-.518-.42c-.201-.326-.362-.6-.482-.833a4 4 0 0 1 .446.14 3 3 0 0 0 .919.226 1.8 1.8 0 0 0 .223.547m-1.943-1.833a1.14 1.14 0 0 0 .112.737.9.9 0 0 0-.258.039 4 4 0 0 1-.034-.755c.004-.143-.004-.285-.006-.428.106.062.215.12.319.185a.6.6 0 0 0-.133.222m.15 1.509c.21.134.187.42.146.783-.032.007-.065.008-.097.016l-.084.021-.012-.01a.58.58 0 0 0-.09-.401 1.5 1.5 0 0 0-.668-.517c.058-.082.105-.17.17-.247a.9.9 0 0 1 .273-.2.85.85 0 0 0 .361.555Zm-.256.487a.46.46 0 0 1 .072.198 7 7 0 0 1-.596-.626 1.4 1.4 0 0 1 .524.428m.19.439.007-.002c.06.052.116.11.179.16-.007.077-.017.152-.02.232a.9.9 0 0 1-.088.312l-.003-.003a3 3 0 0 0-.257-.286 1.7 1.7 0 0 0 .181-.413Zm-.287.313c-.074-.066-.158-.118-.234-.18.049-.013.09-.024.145-.037l.216-.056a1.7 1.7 0 0 1-.127.273m-1.154 1.516c.023.044.036.093.064.136.087.113.163.22.237.323a3 3 0 0 0 .305.408 1 1 0 0 0-.143-.07 2.6 2.6 0 0 1-.583-.459l.008-.074.065-.142c.018-.04.03-.082.047-.122m.432.886a1.5 1.5 0 0 1 .262.115 1.9 1.9 0 0 0-.403.392 3.6 3.6 0 0 0-.345.57l-.007.011-.002-.002a1.7 1.7 0 0 0-.207-.29c.03-.28.065-.586.101-.903l.035-.318a2.6 2.6 0 0 0 .566.425m-.618 1.153c.012.023.036.036.05.058a3 3 0 0 1-.206.338l.005-.062c.011-.14.028-.306.046-.48a2 2 0 0 1 .105.146m-.2-.587a1.5 1.5 0 0 1 .068-.608zm.029 1.18a.5.5 0 0 1 .071-.11 3 3 0 0 0 .214-.35.7.7 0 0 0 .117.136.43.43 0 0 0 .335.065c.05-.005.1-.011.117.004a.12.12 0 0 1 .023.072 2.2 2.2 0 0 1-.032.662 1.48 1.48 0 0 0 .055.838c.152.351.323.693.502 1.032l-.042-.006a2.4 2.4 0 0 1-1.472-.978c.055-.454.096-.909.112-1.366Zm1.332 2.48c.048.01.096.013.144.022.03.056.067.108.099.164l-.09-.006c-1.017-.102-1.097-.203-1.487-.688l-.166-.203.031-.224a2.53 2.53 0 0 0 1.47.936Zm.239-.107c-.108-.2-.201-.407-.3-.612a3.03 3.03 0 0 0 1.394-1.59.7.7 0 0 1 .103-.127c.026.013.049.031.074.045a1.3 1.3 0 0 0-.11.61 2.72 2.72 0 0 1-.535 1.634.33.33 0 0 1-.16.109 9 9 0 0 1-.467-.069Zm2.687.282-.019.048c-.985.017-1.874.017-2.493-.025-.029-.05-.062-.099-.09-.15a11 11 0 0 0 2.602.127m-.077.19c-.019.041-.032.085-.052.127h-.046v-.005c-.014-.002-.96-.065-2.226-.105l-.022-.036c.605.034 1.435.034 2.346.019m-.11.268-.007.019-.043.1c-.397.022-.818.043-1.307.059-.197.013-.394.01-.591.014q-.086-.14-.17-.282c.706.043 1.412.08 2.119.09Zm-1.916.519.023.037-.931.067c.033-.053.07-.107.102-.16l.021-.035-.079-.052-.023.038c-.043.072-.094.145-.138.218l-.462.035a7 7 0 0 0-.692-.432c.225.013.451.013.675.04a12 12 0 0 0 1.393.06c.04.06.071.124.111.184m-1.64.159q-.329.024-.582.04a2.2 2.2 0 0 1-.164-.496l.01.001a7 7 0 0 1 .735.455Zm-.329.594a.77.77 0 0 0 .425.174q-.283.423-.567.811l-.229-.102a1.48 1.48 0 0 1-.673-.681c.019-.034.042-.069.06-.102.052-.159.092-.32.139-.48.155-.006.34-.016.572-.03a2.3 2.3 0 0 0 .273.41m-.951-.519a4 4 0 0 1-.298 0c-.198-.008-.204-.031-.22-.087-.033-.117-.093-.242-.433-.377-.436-.176-.459-.326-.472-.513.236.269.47.407 1.563.423h.017c-.046.187-.105.37-.157.554m-1.285-.332c.069.1.132.207.197.312a2.5 2.5 0 0 1-.255.76 1.7 1.7 0 0 1-.272-.464 1.27 1.27 0 0 0-.568-.61c-.109-.072-.208-.157-.312-.236a2 2 0 0 0-.089-.493 5 5 0 0 0 .535.185 1.09 1.09 0 0 1 .764.546m-.725-.682a4 4 0 0 1-.534-.184c-.235-.1-.374-.22-.4-.345a.3.3 0 0 1 .064-.226 1.26 1.26 0 0 1 .869.186 3 3 0 0 1 .413.415 1 1 0 0 1 .032.184 1 1 0 0 0 .02.165 1.2 1.2 0 0 0-.464-.195m-3.008-2.24c-.092.078-.173.168-.262.25a3.2 3.2 0 0 1-.655-.904c.002-.03.015-.059.015-.09l.003-.121a2.5 2.5 0 0 0-.088-1.064 3 3 0 0 0 .925.72q.22.132.428.269a1.2 1.2 0 0 1-.366.94m-.972-.334a3.4 3.4 0 0 1 .366.91c-.135.132-.28.253-.41.39-.018.018-.026.029-.042.046a.5.5 0 0 0-.224-.012 3 3 0 0 1-.292-.02 1 1 0 0 0 .007-.145l-.053.012a.6.6 0 0 0 .186-.185l.1-.155a2.05 2.05 0 0 0 .362-.842Zm-.607 1.407c.098.01.197.02.295.02.055.003.1.005.143.01-.139.157-.16.222-.155.334a.8.8 0 0 1-.03.263 2 2 0 0 0-.052.273 1 1 0 0 0-.088-.016.96.96 0 0 1-.429-.112c-.03-.016-.055-.04-.085-.056.012-.014.02-.031.034-.044a2.4 2.4 0 0 0 .204-.242.85.85 0 0 0 .163-.43m-.13-.12a1 1 0 0 1-.098-.028 1 1 0 0 0 .101-.026c.002.018-.004.036-.004.054Zm-.007.095a.7.7 0 0 1-.14.37 2 2 0 0 1-.193.23c-.02.018-.031.043-.049.063a4 4 0 0 1-.37-.243l.261-.395a2 2 0 0 0 .074-.142 1 1 0 0 0 .133.03 1 1 0 0 0 .284.087m-.458-.365a1 1 0 0 1-.062-.115l-.018.004q-.013-.04-.025-.081c.06.023.106.05.12.086a.24.24 0 0 1-.015.106m-.1.217h.002c-.02.034-.028.058-.053.096q-.136.207-.274.414-.185.276-.354.54c-.161-.155-.308-.324-.483-.464a1.75 1.75 0 0 1-.673-.801c-.08-.284.274-.649.618-.967.055.063.117.12.169.187a1.5 1.5 0 0 0 .852.523 2.7 2.7 0 0 0 .163.442l.012.02Zm-.304-2.248a1.22 1.22 0 0 0-.519-.69c-.134-.093-.196-.136-.164-.316q-.002-.023-.003-.044c.12-.2.236-.428.349-.665.473.133.766.259.948.699.132.314-.058.62-.258.944a1.9 1.9 0 0 0-.238.472 4 4 0 0 0-.115-.4m-.415-1.883-.102-.03-.174-.046a1 1 0 0 1-.154-.043c-.018-.054-.026-.11-.048-.162a5 5 0 0 1-.147-.513 2.7 2.7 0 0 1-.082-.738c.054-.032.104-.059.16-.097l.032-.023a12 12 0 0 1 .9.747q-.197.5-.385.905m-.396-1.74a3.3 3.3 0 0 0 .63-.62c.072.061.137.13.21.19l.096.078q.034.026.067.053a4 4 0 0 1-.082.776c-.029.077-.057.146-.086.22a12 12 0 0 0-.835-.697m.93-.54c-.079-.064-.146-.14-.222-.205a3 3 0 0 0 .227-.366 4 4 0 0 1 .073.634Zm-.014-.801a3 3 0 0 1-.314.498c-.251-.222-.504-.442-.738-.683.468-.22.846-.388 1.087-.48q.014.019.03.038a.93.93 0 0 1-.065.627m-1.026-1.067a7 7 0 0 1-.412-.675l.037-.027a.1.1 0 0 0 .032-.042c.062-.018.127-.024.19-.045a2.3 2.3 0 0 0 .439-.174 5 5 0 0 0 .617.654c-.285.094-.59.198-.903.309m-.2-.922c-.065.022-.133.028-.199.047l-.114-.042h-.007c-.06-.13-.124-.257-.175-.39-.167-.45-.15-.52-.125-.636a1.2 1.2 0 0 0 .03-.37.8.8 0 0 0-.127-.432 1 1 0 0 0 .231-.045c.031-.014.055-.039.084-.055a4.6 4.6 0 0 0 .572 1.476c.066.103.152.191.225.29a2.2 2.2 0 0 1-.396.157Zm-1.409.335a3.8 3.8 0 0 0 .96-.084l.01.042a.07.07 0 0 0 .11.04v-.001a6 6 0 0 0 .381.641c-.356.127-.719.26-1.073.402-.265.127-.518.275-.781.406a1.6 1.6 0 0 1-.345-.552 1.07 1.07 0 0 1 .03-.804 1.5 1.5 0 0 1 .708-.09m-.694 1.603c-.202.101-.4.209-.601.313a1.9 1.9 0 0 0-.374-.71.96.96 0 0 0 .406-.45 2 2 0 0 1 .21-.303 2.5 2.5 0 0 0 .137.8c.104.251.145.347.222.35m-.727.378q-.177.092-.355.185l.003-.005a4 4 0 0 1-.748-.724q-.026-.032-.05-.066c.016.003.031-.003.047 0a1.05 1.05 0 0 0 .613-.031 1 1 0 0 0 .116-.064 1.9 1.9 0 0 1 .374.705m-1.206-.45a3.9 3.9 0 0 0 .724.7c-.244.13-.492.25-.734.383a12 12 0 0 0-.758-1.023c.03-.017.063-.029.093-.046a.9.9 0 0 1 .551-.175q.059.084.124.16Zm-.136 1.148c-.384.212-.76.434-1.139.654a3.9 3.9 0 0 1-.812-.905 2.8 2.8 0 0 1 .849-.6c.117-.05.228-.112.34-.171a12 12 0 0 1 .762 1.022m-1.158-.98a2.9 2.9 0 0 0-.868.607 3.4 3.4 0 0 1-.224-.485 2.66 2.66 0 0 1 .165-1.166q.104-.07.211-.131l.008.007q.347.3.676.62c.118.127.223.264.335.395-.1.052-.199.109-.303.153m-.873-1.247.016-.055.03.027q-.022.015-.045.028Zm-.061-.312a4 4 0 0 1-.61-.7 6 6 0 0 0 .748-.588 2.4 2.4 0 0 1 .03.445 7 7 0 0 1-.168.843m-.041.15c-.025.091-.046.183-.074.272a3.4 3.4 0 0 0-.522.44q-.146.18-.337.43c-.028.04-.063.075-.092.114a.5.5 0 0 0-.189-.241c-.052-.035-.107-.07-.22-.32a1.4 1.4 0 0 1-.103-.553 1 1 0 0 0-.01-.185 4.4 4.4 0 0 1 .87-.724 3.9 3.9 0 0 0 .677.768Zm-1.291 1.132c.047.03.09.064.167.248a9 9 0 0 1-.744.852c-.015-.05-.016-.103-.035-.151a11 11 0 0 0-.394-.854 2 2 0 0 0 .213-.407 3.3 3.3 0 0 1 .404-.712q.002.02.002.039a1.5 1.5 0 0 0 .116.606c.121.266.191.327.271.379m-.544-1.218a3.5 3.5 0 0 0-.464.81 2 2 0 0 1-.127.246 1 1 0 0 1-.105-.921c.101-.304.24-.592.365-.886a2 2 0 0 0 .14.166.95.95 0 0 1 .305.472c-.036.039-.079.072-.114.113m-.83.094a1.14 1.14 0 0 0 .156 1.097l.006.014a1.8 1.8 0 0 1-.413.466c-.124.088-.202.139-.252.173a.24.24 0 0 0-.115.143 11 11 0 0 0-.533-1.173l.014-.015q.163-.165.365-.382c.24-.26.344-.386.456-.52.13-.157.294-.35.694-.784a13 13 0 0 0-.378.98Zm-.497-.347c-.11.13-.213.256-.448.51-.11.122-.21.222-.305.319a5 5 0 0 1-.665-.875c.025-.06.041-.124.07-.183a4.43 4.43 0 0 1 1.825-1.409 2.2 2.2 0 0 0 .272.793c-.44.477-.61.679-.749.845m.456-2.055c-.003.056.007.111.008.167a4.6 4.6 0 0 0-2.019 1.548q-.007.017-.014.035c-.038-.071-.087-.136-.122-.21-.038-.28.312-.444.718-.634q.16-.074.316-.153a1.46 1.46 0 0 0 .56-.468.8.8 0 0 1 .21-.212 3.4 3.4 0 0 0 .373-.374 1.6 1.6 0 0 0-.03.3Zm-1.996 2.327c.054.035.113.064.163.104a5 5 0 0 0 .497.591 3.6 3.6 0 0 0-.74 1.019 3.5 3.5 0 0 1 .08-1.714m-.46 7.823c-.085.277-.232.862-.051 1.139a.45.45 0 0 0 .405.205.65.65 0 0 1 .517.252.66.66 0 0 1 .188.376.6.6 0 0 0-.045.1c-.075-.13-.2-.309-.358-.341a.27.27 0 0 0-.25.084.78.78 0 0 0-.19.695v.001a2 2 0 0 1-.122-.174 1.1 1.1 0 0 1-.097-.557 1.8 1.8 0 0 0-.081-.647 1.13 1.13 0 0 0-.567-.72q.311-.199.65-.413Zm-.174 1.16a1.7 1.7 0 0 1 .077.618 1.2 1.2 0 0 0 .105.598 1.6 1.6 0 0 0 .293.375.55.55 0 0 0 .195.187c.02.01.036.026.056.037.14.12.25.232.244.366a1.3 1.3 0 0 1-.1.352c-.123.329-.276.739.14.947q.177.087.36.16a1.68 1.68 0 0 1 .849.648 7 7 0 0 1 .589.838 2 2 0 0 0 .016.326 1.18 1.18 0 0 0 .572.724 4 4 0 0 1 .397.314l.079.074c.405.375.609.563.46 1.212a6 6 0 0 1-.093.35 1.15 1.15 0 0 0 .299 1.38.87.87 0 0 0 .613.333c-.003.07.01.14.012.21a5 5 0 0 1-.488-.08 1.27 1.27 0 0 1-.815-1.02 4 4 0 0 0 .05-.484 1 1 0 0 1 .048-.115 1.05 1.05 0 0 0 .163-.656c-.023-.356-.115-.395-.273-.433a.7.7 0 0 1-.468-.346 3.2 3.2 0 0 1-.406-.691 21 21 0 0 0-.455-.933 1.79 1.79 0 0 0-1.326-1.007 7.5 7.5 0 0 0-.73-.951 4 4 0 0 1 .134-.455.75.75 0 0 0-.232-.97 1.5 1.5 0 0 1-.432-1.21c.01-.54-.715-1.083-.839-1.17l.338-.218a1.06 1.06 0 0 1 .568.69m-1.205-1.6-.063-.13.093.075c-.008.02-.022.036-.03.056Zm-2.371-.949q.046.738.033 1.478c-.039-.099-.076-.19-.12-.313a1.7 1.7 0 0 0-.192-.445l.026-.326q.023-.273.048-.616a1.2 1.2 0 0 0 .205.222m-.22 1.212c.07.197.133.36.196.505-.214-.132-.277-.302-.27-.679a2 2 0 0 1 .074.174m.276 2.862a4 4 0 0 0 .144.566 1.06 1.06 0 0 0-.515-.244c.12-.11.249-.213.37-.322Zm-.09.516h-.004a1.8 1.8 0 0 1 .016.65q-.012.037-.026.073a2.4 2.4 0 0 1-.29-.164.83.83 0 0 1-.12-.59l-.027-.004.09-.088a1.7 1.7 0 0 1 .36.123Zm-.05.808h-.006a.053.053 0 0 0 .04.064l.013.002c.011 0 .019-.015.027-.024.055.028.103.067.16.091a.48.48 0 0 0-.033.43c.026.078.053.143.08.207a1 1 0 0 0-.069.21.74.74 0 0 1-.258-.235.9.9 0 0 1-.12-.443.93.93 0 0 0-.135-.474 2.4 2.4 0 0 0 .301.172m-.259.31a1 1 0 0 0 .051.288.51.51 0 0 1-.526-.435.93.93 0 0 1 .053-.475.66.66 0 0 1 .29.163.85.85 0 0 1 .132.46Zm-.598.3c-.011.115-.033.25-.056.395l-.003.018c-.04-.028-.083-.05-.12-.08a3.2 3.2 0 0 1-.475-.69q.123-.125.249-.246c.094.051.44.263.405.604Zm-.24.405a2 2 0 0 0 .166.111 2.1 2.1 0 0 0-.006.92l.01.012a1.3 1.3 0 0 0-.563-.332c.003-.02 0-.04.003-.06l.036-.243c.03-.2.058-.386.067-.54a.46.46 0 0 0-.273-.487l.077-.076a3.2 3.2 0 0 0 .483.695m-.38-.138c-.01.15-.037.336-.067.532l-.037.245v.012a2 2 0 0 0-.346-.24.54.54 0 0 1-.239-.533c.093-.087.18-.18.274-.265.053-.056.11-.106.163-.161a.363.363 0 0 1 .251.41Zm-1.532 1.697a1 1 0 0 0 .081.1.56.56 0 0 0 .346.167.1.1 0 0 1 .054.02l.035.064a.4.4 0 0 1 .03.064 1 1 0 0 1 .004.432 1.3 1.3 0 0 0-.012.448.94.94 0 0 1-.478-.464 2.4 2.4 0 0 1-.06-.83Zm.018.93a1 1 0 0 0 .102.143l-.03-.004a2.9 2.9 0 0 0 .003.947.5.5 0 0 1-.203-.145l-.002-.016-.011.003c-.01-.012-.023-.019-.031-.031a.49.49 0 0 1 .039-.436 1.2 1.2 0 0 0 .133-.46Zm-.208.392a.8.8 0 0 1-.494-.123.26.26 0 0 1-.07-.22 1.2 1.2 0 0 1 .037-.215.55.55 0 0 0 .007-.273 1.7 1.7 0 0 0-.157-.459l.104-.113a.93.93 0 0 0 .351.594c.269.142.475.26.222.809m-.995.743.003-.063a.3.3 0 0 0 .161.066c.077.014.127.023.167.21a1 1 0 0 1-.07.487 1 1 0 0 0-.07.39 1 1 0 0 0-.109-.104.58.58 0 0 1-.23-.34.35.35 0 0 1 .04-.323.7.7 0 0 0 .108-.323m-.08 4.46a3.3 3.3 0 0 0 .408.842 2.3 2.3 0 0 0 .521.598.5.5 0 0 1 .14.145.57.57 0 0 1 .069.645 1.3 1.3 0 0 0-.424-.334 1.6 1.6 0 0 1-.54-.482 2.4 2.4 0 0 1-.325-1.744 1 1 0 0 1 .048-.15 2 2 0 0 0 .102.475Zm.027-.758a1 1 0 0 1 .122-.173l.046-.054a1.7 1.7 0 0 0 .153.638 2 2 0 0 1-.278.272 2 2 0 0 1-.043-.683m1.058 2.227a.6.6 0 0 0-.098-.103 2.2 2.2 0 0 1-.502-.576 2.1 2.1 0 0 1-.395-.755 2 2 0 0 0 .298-.292 1.7 1.7 0 0 0 .19.287q.102.111.21.22c.262.272.371.384.364.73a1.3 1.3 0 0 1-.067.49Zm-.801-2.56a1 1 0 0 0 .056-.07c.078.103.297.453.141.683-.014.02-.037.032-.053.051a1.6 1.6 0 0 1-.144-.663Zm-.19 2.556c.023.033.054.058.08.09a6 6 0 0 0-.419-.197.95.95 0 0 0-.655-.014c-.017-.008-.024-.017-.04-.026q-.01-.018-.02-.036l-.015.012c-.108-.07-.181-.14-.197-.21-.024-.118.078-.246.19-.384a1.5 1.5 0 0 1 .32-.26.94.94 0 0 0 .378-.371 2.5 2.5 0 0 0 .378 1.396m-1.187 1.278a.75.75 0 0 1-.387-.35l.051-.036a.1.1 0 0 1-.014-.08.18.18 0 0 1 .098-.103c.173-.095.47-.266.549-.311.006.026.018.05.023.078a.8.8 0 0 1-.002.33 1.1 1.1 0 0 0 .002.43 1 1 0 0 0 .152.416.5.5 0 0 0-.1.011.61.61 0 0 0-.372-.385m1.064.397a.2.2 0 0 0 .039.02.41.41 0 0 1 .329.458.6.6 0 0 1-.136.34.6.6 0 0 0-.06.105.46.46 0 0 0-.195-.2.36.36 0 0 1-.197-.39.45.45 0 0 1 .22-.333m.185 1.182.035.004a.4.4 0 0 0-.019-.102.5.5 0 0 1 .09-.185 1.14 1.14 0 0 1 .403.928 3 3 0 0 1-.067.343.97.97 0 0 1-.451-.931zm.153-.36a.7.7 0 0 0 .124-.331.5.5 0 0 0-.378-.554.45.45 0 0 0 .257-.282.56.56 0 0 0-.26-.56 1 1 0 0 0 .224-.05c.227-.061.37-.09.44.022.07.114.02.26-.04.43a.96.96 0 0 0-.055.688.53.53 0 0 0 .425.367.4.4 0 0 1 .14.062 2.7 2.7 0 0 1-.342.644q-.077.067-.148.142a1.2 1.2 0 0 0-.387-.579Zm.893-1.664a.6.6 0 0 0 .077-.15.77.77 0 0 0-.123-.594 1.3 1.3 0 0 0 .09-.572.95.95 0 0 0-.392-.797q-.091-.093-.208-.218a1.6 1.6 0 0 1-.171-.31c.025-.03.06-.05.084-.082.198-.295-.074-.709-.158-.81a.9.9 0 0 0 .129-.71.35.35 0 0 0-.22-.324.206.206 0 0 1-.138-.223.7.7 0 0 1 .095-.383.54.54 0 0 0 .079-.308l-.002-.023a.4.4 0 0 0 .07.06 1 1 0 0 0 .322.145c.086.023.098.026.108.136.009.081-.03.12-.105.184a.56.56 0 0 0-.227.456.76.76 0 0 0 .352.684l.006-.01a2.2 2.2 0 0 0 .427 1.902q.014.017.026.033a4 4 0 0 0-.053.393 2.06 2.06 0 0 0 .349 1.178 1.27 1.27 0 0 0-.189.839 1.3 1.3 0 0 0-.228-.496m1.094-.065c-.028.078-.065.153-.099.229a3 3 0 0 1-.38-.384c-.035-.042-.06-.088-.09-.132l.001-.003.22-.2a2 2 0 0 0 .222-.215.575.575 0 0 1 .126.705m.047.128a5 5 0 0 0-.03.217c-.017-.013-.028-.03-.044-.044q.038-.086.074-.173m-.457-.688c-.063.056-.138.122-.215.193a2 2 0 0 1-.287-.79 5 5 0 0 1 .637.342l.046.023c.013.007.02.02.033.027a2 2 0 0 1-.214.205m-.21.367c.024.032.042.066.067.097a3 3 0 0 0 .415.416q-.008.02-.017.04a2 2 0 0 0-.252.873l-.277-.34a1.2 1.2 0 0 1 .065-1.086Zm.55.594.004-.01c.018.015.03.036.05.05l.011.006.008.003a5 5 0 0 0-.021.676q-.003.008-.007.015h.008a5 5 0 0 0 .083.7.4.4 0 0 0-.126-.09.45.45 0 0 1-.27-.41 1.9 1.9 0 0 1 .26-.94m-.154-1.295a5 5 0 0 0-.695-.374c-.005-.063-.014-.126-.013-.19.005-.098.027-.192.04-.289a1.46 1.46 0 0 0 1.063.567l.037-.003a4 4 0 0 1-.027.386 10 10 0 0 0-.05.313.66.66 0 0 0-.355-.41m.316 1.385a1.1 1.1 0 0 1 .23.13l-.002.002a3 3 0 0 0-.24.28c0-.137 0-.275.012-.412m.297.196.006-.008a1.14 1.14 0 0 1 .353.53.92.92 0 0 1-.31.754 1.3 1.3 0 0 0-.191.266 5 5 0 0 1-.17-1.094 1.1 1.1 0 0 1 .312-.448m-.003-.139a1.2 1.2 0 0 0-.281-.155c.016-.154.033-.309.063-.461l.033-.242c.027-.216.052-.357.072-.47.01-.05.003-.1.01-.148a2.6 2.6 0 0 0 .548.822 1.8 1.8 0 0 1-.185.36 7 7 0 0 1-.26.294m.52-.591a2.4 2.4 0 0 0 .659.358 2.3 2.3 0 0 1 .901.558 2.2 2.2 0 0 1 .415.604c.007.02.01.042.017.063a.87.87 0 0 0 .716.6 1.7 1.7 0 0 0 .195.26c-.04.074-.09.142-.122.22a.53.53 0 0 0-.015.373 3.6 3.6 0 0 1-.846-.916 2.02 2.02 0 0 0-1.264-1.034l-.102-.044c-.634-.27-.72-.653-.73-.709a2 2 0 0 0 .176-.333m1.646 2.408a2.8 2.8 0 0 1-.484.556.7.7 0 0 0-.204-.201c-.06-.053-.128-.112-.206-.187-.019-.02-.043-.035-.062-.054a1 1 0 0 0 .082-.111.71.71 0 0 0-.017-.76l-.04.033a3 3 0 0 0 .22-.39 1.9 1.9 0 0 1 .663.51l-.022.015a.68.68 0 0 1 .07.589m-1.129-1.28.102.045a2 2 0 0 1 .228.088 3.2 3.2 0 0 1-.489.742.83.83 0 0 1-.33-.554.51.51 0 0 1 .188-.483 2 2 0 0 0 .301.163Zm.172.604a.62.62 0 0 1-.003.639c-.015.035-.048.058-.067.09a3 3 0 0 0-.303-.26 3.3 3.3 0 0 0 .373-.469m-.055.865c.017.017.037.03.053.047.08.076.149.136.209.189a.59.59 0 0 1 .285.642 2.6 2.6 0 0 1-.41.977 2 2 0 0 1-.258-.564 2.1 2.1 0 0 1 .003-1.131 1 1 0 0 0 .118-.16m.641.884a.68.68 0 0 0-.06-.435 2.9 2.9 0 0 0 .514-.593.74.74 0 0 0 .018-.429c.03.049.066.092.092.144a3.6 3.6 0 0 0 .404.522 1.73 1.73 0 0 0-.847.796 2.3 2.3 0 0 1-.254.443 2.6 2.6 0 0 0 .133-.448m1.025-.718c.071.074.157.131.233.199l-.038.005a2.2 2.2 0 0 1-.038.732c-.079.27-.55.541-.645.593a2 2 0 0 1-.149-.144.87.87 0 0 1-.178-.625 1.67 1.67 0 0 1 .815-.76m.248.962a2.2 2.2 0 0 0 .042-.716 4 4 0 0 0 .283.238.74.74 0 0 1-.065.565 2.3 2.3 0 0 1-.354.366 1.2 1.2 0 0 0-.343.39l-.102-.084a2 2 0 0 1-.127-.124c.143-.08.58-.346.666-.635m.317-.67a.44.44 0 0 1 .003-.356 2.7 2.7 0 0 1 .281-.504 1.4 1.4 0 0 0 .15-.265.4.4 0 0 0 .113.119.53.53 0 0 1 .208.242c.112.297-.286.765-.29.77l.017.014a.6.6 0 0 0-.096.258.3.3 0 0 0 .017.09 1 1 0 0 1-.403-.368m.604 1.964a.52.52 0 0 1 .088-.432 1.2 1.2 0 0 0 .173-.556.4.4 0 0 0-.235-.444.22.22 0 0 1-.113-.09l.003-.006-.013-.008a.22.22 0 0 1-.027-.144.46.46 0 0 1 .202-.332c.023.042.079.058.174.076.168.032.419.08.478.306a1.9 1.9 0 0 1 .007.828l.022.005a4.6 4.6 0 0 1-.42.75c-.005.01-.07.109-.144.23a1 1 0 0 1-.195-.183m.418.006a4.7 4.7 0 0 0 .448-.808 3 3 0 0 0 .075.435l-.059-.015a8 8 0 0 1-.273.868l-.019.043a2 2 0 0 0-.32-.282l-.002-.002c.081-.132.15-.238.15-.24Zm.275.522a8 8 0 0 0 .262-.83 3.3 3.3 0 0 0 .226.586 1.36 1.36 0 0 1-.039 1.332l-.014-.003a2.2 2.2 0 0 0-.311-.783 2 2 0 0 0-.162-.215c.014-.029.023-.06.038-.087m.564-.3a3.3 3.3 0 0 1-.322-1.183l-.02.001c.034-.084.057-.172.085-.259a1.9 1.9 0 0 0 .438.53 3 3 0 0 0 .28.175c-.075.218-.165.431-.22.656a4 4 0 0 1-.122.394 1.5 1.5 0 0 0-.119-.314m.245-.981a2 2 0 0 1-.43-.508 1.3 1.3 0 0 1 .593.166c.073.037.137.087.207.129-.05.119-.08.245-.123.367-.081-.053-.17-.094-.247-.154m.452-.163a3.7 3.7 0 0 1 .705.56l.028-.025q.001.087-.004.172a.3.3 0 0 0-.008.088c-.004.035-.015.07-.021.104a2 2 0 0 0-.562-.368c-.093-.045-.174-.11-.261-.164.043-.121.073-.247.123-.367m.745 1.134a.6.6 0 0 0 .317.079.35.35 0 0 1 .243.07 2 2 0 0 1-.27.325c-.182.183-.274.303-.18.582a.5.5 0 0 0-.176.01.66.66 0 0 0-.364.323.69.69 0 0 1 .094-.748 2 2 0 0 0 .336-.64Zm-.396 1.507a.51.51 0 0 1 .544-.363c.016.04.042.088.065.134l-.007.003a.72.72 0 0 1 .013.498 2.3 2.3 0 0 1-.243.366l-.065-.061c-.207-.187-.402-.363-.307-.577m.752-.968a2.1 2.1 0 0 0 .395-.532.4.4 0 0 1 .2.165.47.47 0 0 1-.076.42 1.58 1.58 0 0 0-.276 1.09 1.7 1.7 0 0 1-.228-.293c-.313-.546-.232-.63-.015-.85m1.248-.211c-.002-.013.003-.026 0-.038l-.025.005-.03-.04a2.4 2.4 0 0 0 .073-.395.5.5 0 0 0 .154.155 2.6 2.6 0 0 1 .438.335 1 1 0 0 1-.101.029.35.35 0 0 0-.295.286 1.5 1.5 0 0 0-.214-.337m.531.143a.7.7 0 0 0 .175-.067l.011.006.002-.013a.4.4 0 0 0 .13-.126l.011.004q.001-.01.002-.021a1 1 0 0 0 .07-.161 1 1 0 0 0 .001.353.8.8 0 0 1 .053.343 2.25 2.25 0 0 0-.239.944l-.006.04c-.062-.032-.127-.059-.187-.095a.78.78 0 0 1-.275-.558c-.039-.58.09-.61.252-.65Zm.31 1.28v-.005a2.15 2.15 0 0 1 .221-.903l.022.004c.001-.011-.006-.022-.005-.033a2.1 2.1 0 0 1 .35-.489l.014-.008.042-.004v-.018c.185-.096.67-.308.892.002.081.113-.142.286-.378.468-.331.257-.707.547-.616.904.052.202.251.306.495.387a2.6 2.6 0 0 1-1.044-.236.4.4 0 0 1 .006-.068Zm.645-1.623a3.2 3.2 0 0 1 .113-.985.73.73 0 0 0-.198-.743l-.007-.021a5 5 0 0 1 .509.219l.08.039a.5.5 0 0 0 .078.069c.143.103.246.176-.01.706a2.3 2.3 0 0 1-.528.676q-.02.02-.037.04m.541-1.574a.43.43 0 0 1-.114-.18c-.065-.238.115-.4.274-.542.107-.096.19-.18.197-.277a1 1 0 0 0 .148.13.89.89 0 0 1 .44.66 1.3 1.3 0 0 1 .052.37l-.008-.003a.2.2 0 0 1-.11.085.9.9 0 0 1-.66-.135Zm.223.21a1.4 1.4 0 0 0 .522.148.5.5 0 0 0 .172-.03c.033-.01.05-.043.077-.065a1.3 1.3 0 0 1-.199.634l-.01.022a.4.4 0 0 1-.167.029c-.17.01-.371-.26-.401-.32a.47.47 0 0 0 .006-.418m1.411-.496-.053-.056a1.25 1.25 0 0 0 .738-.205.3.3 0 0 0 .088-.242 3 3 0 0 0-.055-.377c-.048-.263-.056-.35.052-.375.157-.038.332.151.403.247-.023.058-.04.12-.066.177a2 2 0 0 0-.208.576 1 1 0 0 1-.127.148 1.02 1.02 0 0 0-.321.647.77.77 0 0 0-.246-.33Zm.839-.042c.02-.018.034-.04.052-.06a2 2 0 0 0-.022.406c.07.28.149.323.337.397a2 2 0 0 1 .235.115.485.485 0 0 1-.064.553 1.4 1.4 0 0 1-.205.192.45.45 0 0 0-.202-.025c-.062-.02-.425-.153-.425-.77a.93.93 0 0 1 .294-.808m.348 1.718c.013.007.03.002.042.01a.46.46 0 0 1 .171.309c.033.179-.075.29-.2.418l-.014.01a.6.6 0 0 0-.154.178 1.4 1.4 0 0 1-.149-.399.54.54 0 0 1 .287-.51q.008-.007.017-.016m.081.802a.55.55 0 0 0 .225-.5.54.54 0 0 0-.213-.37l-.014-.006a1.5 1.5 0 0 0 .185-.175.57.57 0 0 0 .089-.563 2.4 2.4 0 0 1 .379.267c.073.06.135.115.196.17a.3.3 0 0 0-.111.057q-.218.184-.146.798c.032.28.068.488.095.64.015.086.026.154.034.214a1 1 0 0 0-.016.083 1 1 0 0 0 .023.067.36.36 0 0 1-.056.171c-.108-.046-.212-.101-.325-.136a1.4 1.4 0 0 1-.521-.49.46.46 0 0 1 .176-.228Zm2.308-.902c.006-.017.005-.027.01-.043a1.4 1.4 0 0 0 .241.309 3 3 0 0 0 .5.435l.03-.045a1 1 0 0 0 .066.218 1.84 1.84 0 0 0 .347 1.1 2.5 2.5 0 0 0-.559-.338 1.5 1.5 0 0 1-.23-.118c-.02-.012-.045-.024-.067-.035a1.5 1.5 0 0 1-.25-.21 1.31 1.31 0 0 1-.088-1.273m.768.36a1.15 1.15 0 0 1-.183-.606 1.4 1.4 0 0 1 .192-.665 2.6 2.6 0 0 0 .396.369 1 1 0 0 1 .127.118 1.7 1.7 0 0 0-.532.783Zm.465-.974a2.5 2.5 0 0 1-.403-.384 1.4 1.4 0 0 1 .245-.284 4 4 0 0 0 .311-.407c.022.036.054.064.072.103a1.22 1.22 0 0 1 .087.927l-.173.167a2 2 0 0 0-.139-.122m4.037.907.015-.041.16-.14a2.5 2.5 0 0 0 .125.896.8.8 0 0 0 .333.388.93.93 0 0 0-.447.719 1.07 1.07 0 0 1-1.08-.805 12 12 0 0 0 .894-1.017m.694 1.173-.023-.046a1 1 0 0 0 .13.08c.004.02.014.038.018.057l-.005.057.016-.026a2.5 2.5 0 0 0 .169.518 1.07 1.07 0 0 0 .453.54l-.006.007a7 7 0 0 1-.58.644 3 3 0 0 0-.207-.276 1.2 1.2 0 0 1-.385-.864.84.84 0 0 1 .42-.691m.777 1.308a1.3 1.3 0 0 0 .64.548 3 3 0 0 0-.395.31 1 1 0 0 0-.22.344.024.024 0 0 1-.042.004 2 2 0 0 1-.097-.183.73.73 0 0 0-.41-.449 6 6 0 0 0 .524-.574m.734.593a2 2 0 0 0 .416.122 3 3 0 0 0-.364.054 5 5 0 0 0-.496.19c.009-.01.012-.024.022-.034a3 3 0 0 1 .422-.332m-.731.718h.01a.12.12 0 0 0 .1-.075 1 1 0 0 1 .091-.143 4.5 4.5 0 0 1 .607-.233 3 3 0 0 1 .576-.09 1.18 1.18 0 0 1-.528.874.58.58 0 0 0-.267.409c-.038-.067-.078-.134-.134-.235a.92.92 0 0 0-.578-.335.8.8 0 0 0 .085-.194c.014.006.023.022.038.022m1.233-2.472a1.3 1.3 0 0 1 .072-.685q.238.288.5.557a1 1 0 0 1 .045.253h-.012l.01.068a.6.6 0 0 1-.12.35l-.059.078a1.8 1.8 0 0 1-.436-.621m.538.719q.031-.04.07-.09a.7.7 0 0 0 .087-.148 1.56 1.56 0 0 0 .403.65.26.26 0 0 1 .09.199 1.3 1.3 0 0 1-.376.71l-.073-.071a.94.94 0 0 1-.371-.65.6.6 0 0 1 .17-.6m1.505.599.014-.002.01-.007.003-.003c.047.026.089.062.138.086a2 2 0 0 1 .222.126c-.03.056-.064.109-.091.166a7 7 0 0 0-.45.908.83.83 0 0 1-.566-.916c.024-.16.436-.305.72-.358m.229-.051c-.036-.018-.066-.045-.102-.064a.83.83 0 0 0 .296-.57 5 5 0 0 0-.468-1.127 1.7 1.7 0 0 1 .41-.078q.347.485.681.978a1 1 0 0 0-.028.102 7 7 0 0 0-.563.886 2 2 0 0 0-.226-.127m.3-1.852h.007q.219-.003.437-.018a1.09 1.09 0 0 0 .826-.325c.034.021.072.036.106.058l.01-.016q.08.14.147.286a7 7 0 0 0-.895.92h-.007a46 46 0 0 0-.63-.905Zm.715 1.03a.83.83 0 0 1 .816.188c.18.157.344.332.514.5a3 3 0 0 0-.566-.113 2.2 2.2 0 0 0-.858-.018.9.9 0 0 1-.005-.43zm.742.714a3 3 0 0 1 .509.098h-.044a.2.2 0 0 0 .005.036.61.61 0 0 1-.12.633 1.5 1.5 0 0 1-.336.173c-.035-.032-.062-.072-.1-.102a5.6 5.6 0 0 1-.566-.628 1 1 0 0 1-.14-.224 1.7 1.7 0 0 1 .792.014m1.178.495a3 3 0 0 0 .287-.373.84.84 0 0 0 .2-.5 4.5 4.5 0 0 0 .42.567 4.3 4.3 0 0 0 .603.6l.003.003a1.67 1.67 0 0 1-.597.862.4.4 0 0 1-.322.016c-.267-.1-.433-.562-.458-.634a.93.93 0 0 0-.136-.542Zm1.431.018a4 4 0 0 1-.415-.416 5 5 0 0 1-.308-.396 2.8 2.8 0 0 0 .993-.335l.001.002c.05.025.165.083.165.323a1.9 1.9 0 0 1-.436.821Zm.436-.436.043.025a.8.8 0 0 1 .344-.265c.224-.1.304-.071.304-.071l-.006-.003.005-.008a1.3 1.3 0 0 1 .059.368l.008.001a.73.73 0 0 1-.297.526 1.8 1.8 0 0 1-.54.318.4.4 0 0 0-.188-.288c-.025-.02-.043-.046-.067-.067a2 2 0 0 0 .336-.536Zm-.021 1.663c-.015-.198-.023-.346-.03-.466l-.011-.16a1.8 1.8 0 0 0 .61-.354.9.9 0 0 0 .2-.214c.116.021.228.055.343.084a.98.98 0 0 0 .117.726c.08.114.15.234.219.356a3 3 0 0 1-.631.287 1.27 1.27 0 0 0-.61.346 1.5 1.5 0 0 0-.23.666.63.63 0 0 1-.003-.305 3.5 3.5 0 0 0 .026-.967Zm.314.696a1.15 1.15 0 0 1 .55-.304c.096-.03.18-.086.273-.125a2 2 0 0 1 .302.281c-.012.022-.169.292-.785.364a1.9 1.9 0 0 0-.486.108 1.4 1.4 0 0 1 .146-.324m.96-.492a3 3 0 0 0 .31-.141q.454-.282.883-.6a1.4 1.4 0 0 0-.02.512c0 .008-.01.15-.26.309-.214.135-.426.255-.53.312a2 2 0 0 0-.383-.392m1.109 1.486a1.8 1.8 0 0 0 .33.03c.032 0 .062-.008.093-.009a5 5 0 0 1-.395.273 1.2 1.2 0 0 0-.381.324c0-.073-.006-.146-.002-.22a4 4 0 0 0-.052-.665.95.95 0 0 0 .407.267m1.264-.64a4.2 4.2 0 0 0 .77-.571c.174.14.549.49.563.762a1 1 0 0 1-.014.216.5.5 0 0 0-.077-.121 1 1 0 0 0-.676-.295.78.78 0 0 0-.52.19Zm.878-.665.014-.012a1 1 0 0 0 .108-.18c.024.032.059.054.08.088.128.185.21.277.678.34a1 1 0 0 0 .102.006 1 1 0 0 0 .213-.04 2 2 0 0 1-.358.425 2 2 0 0 0-.243.253c-.002-.01.003-.021.002-.032-.018-.359-.465-.742-.596-.848m1.748 1.998c.038-.093.074-.168.108-.24a2.55 2.55 0 0 0 .263-.992 4 4 0 0 0-.091-1.245 7 7 0 0 0 .6.89l-.025.014c.04.1.06.207.092.311a3.7 3.7 0 0 1-.595.99 6 6 0 0 1-.44.391c.028-.041.063-.077.088-.12Zm.166-2.94a12 12 0 0 1-1.238-2.974 8.8 8.8 0 0 1 .15-3.443l.036.009a2 2 0 0 0 .047-.367 9.4 9.4 0 0 1 1.202-2.836q-.052.504-.14 1.004a1.08 1.08 0 0 1-.356.582c-.195.158-.274.276-.286 1.624-.004.518-.003.99.017 1.429a5.2 5.2 0 0 0-.036 2.194 4.4 4.4 0 0 0 .727 1.116 7 7 0 0 1 .881 1.304 1.75 1.75 0 0 1-.087 1.734 6.4 6.4 0 0 1-.917-1.375Zm1.55 1.992a.16.16 0 0 1-.11-.03c-.157-.145-.283-.316-.424-.475a1.92 1.92 0 0 0 .115-1.907 7.2 7.2 0 0 0-.898-1.33 4.2 4.2 0 0 1-.705-1.077 5.2 5.2 0 0 1-.051-1.573 4.1 4.1 0 0 0 1.372 2.882 4.57 4.57 0 0 1 1.297 2.019 3 3 0 0 0 .185.45 2 2 0 0 1-.78 1.04Zm.235-3.806a2.8 2.8 0 0 0-.5-.53 2.73 2.73 0 0 1-1.007-1.576c-.236-1.047.483-2.764.828-3.59q.09-.208.17-.421a1.04 1.04 0 0 0-.23-1.238 2.6 2.6 0 0 1-.402-1.071c.045-.06.083-.125.13-.184v-.001a1.1 1.1 0 0 0 .115.455 1.9 1.9 0 0 0 .554.685c.158.13.218.177.162.39a7 7 0 0 0-.12.64c-.06.38-.141.9-.347 1.737-.083.339-.183.654-.281.959-.29.912-.538 1.699 0 2.289q.737.814 1.415 1.68a3 3 0 0 0-.221.357 1.8 1.8 0 0 0-.266-.581m-.362-12.905a1.7 1.7 0 0 1-.25-.21l-.048-.055c.038-.092.088-.178.117-.273a1.75 1.75 0 0 0-.052-1.106q.123-.07.241-.15c.002.3.007.605.03.934a5.7 5.7 0 0 0 .18 1.05 1.1 1.1 0 0 0-.218-.19m.147-2.164c.016-.138.006-.274.01-.412q.145.14.285.287-.143.121-.294.232zm.395-.025c.063.066.131.127.193.195.171.21.352.459.52.697a2 2 0 0 0 0 .463 2 2 0 0 0-.238-.188 2.35 2.35 0 0 1-.626-1.035c.053-.041.1-.088.15-.132Zm.302.106c-.062-.07-.132-.131-.196-.199a5 5 0 0 0 .452-.47 10 10 0 0 1 .262 1.002 2 2 0 0 0-.08.247 12 12 0 0 0-.438-.58m.28-.908-.003.003a17 17 0 0 0-1.302-1.75l-.058.048a5 5 0 0 0-.461-.825 13 13 0 0 0-1.509-1.311 2.7 2.7 0 0 1 1.14.489 8 8 0 0 1 .957.57 15.5 15.5 0 0 1 .949 1.81l.016.04a1 1 0 0 0 .285.35c.095.083.17.15.175.233a.55.55 0 0 1-.184.337Zm-2.123-3.47a2.8 2.8 0 0 0-.688-.36 2.8 2.8 0 0 1 1.117.347q.127.19.248.383a8 8 0 0 0-.677-.37m.274-.252a5.3 5.3 0 0 0-1.798-.336l-.072-.05c.098.009.196.011.294.022a5.6 5.6 0 0 1 1.506.256c.025.035.045.073.07.108m-.05-.335c.133.058.269.107.397.175.04.021.076.051.115.074a3 3 0 0 0-.447-.15q-.019-.03-.038-.06zm-2.06-.221c-.15-.1-.292-.209-.446-.303a6.2 6.2 0 0 1 2.27.419c.034.05.06.096.097.148a15 15 0 0 0-1.92-.264Zm-.715-.447a13 13 0 0 0-.595-.32 7.1 7.1 0 0 1 2.352.16.06.06 0 0 0 .034.013l.007-.003a3 3 0 0 1 .367.137c.07.115.158.244.238.368a6.9 6.9 0 0 0-2.403-.355m1.829-.287a2.4 2.4 0 0 1-.18-.243 7.5 7.5 0 0 0-.874-.653l.02-.04c-.048-.02-.1-.023-.148-.04a7.5 7.5 0 0 0-1.866-.846c-1.015-.354-1.19-.554-1.207-.64.163.03.293.052.4.069a4.9 4.9 0 0 1 1.4.468l.031.033.015-.013c.048.025.1.04.146.066l.086.038a6.6 6.6 0 0 0 1.631.634 9 9 0 0 1 .523.835c.069.119.155.261.236.397q-.105-.035-.213-.065m-2.31-2.357c.219.365.274.43.916.58a1.3 1.3 0 0 1 .705.434 9 9 0 0 1-1.43-.586l-.085-.04c-.054-.03-.114-.047-.17-.075a5.2 5.2 0 0 0-.931-.868c-.306-.203-.397-.31-.43-.374a2.6 2.6 0 0 0 .838.076c.016.023.028.047.044.07a6.6 6.6 0 0 1 .543.783m-.115-.413a3.6 3.6 0 0 1 .902.099 1.125 1.125 0 0 1 .818 1.04 1 1 0 0 0 .032.126 1.5 1.5 0 0 0-.689-.41c-.602-.14-.627-.183-.827-.514-.07-.12-.158-.226-.236-.34Zm-2.105-.971a5.8 5.8 0 0 0-.105-1.46c.048.026.09.064.14.088q.158.088.314.18a3.6 3.6 0 0 1 .551.429 8.3 8.3 0 0 0 .674 1.2 2.55 2.55 0 0 1-1.574-.437m.503-2.3a2 2 0 0 0 .318.193c.01.051.03.1.037.153a4.3 4.3 0 0 0 .255.915q.069.148.124.283a1.2 1.2 0 0 0 .103.235 2 2 0 0 1-.281-.235 8.2 8.2 0 0 1-.556-1.544m-.035-.171c-.046-.205-.097-.407-.127-.615a2.48 2.48 0 0 0-1.188-1.548 1.5 1.5 0 0 1 .223-.17 10 10 0 0 1 .932 1.25 4.5 4.5 0 0 1 .488 1.342 2 2 0 0 1-.328-.26ZM45.4 12.027l-.005.004-.065-.051a16 16 0 0 1-1.01-.811 11 11 0 0 0-.876-.742l.08-.055q.168-.117.323-.227.439.432.913.826a10 10 0 0 1 .873.877 1.7 1.7 0 0 0-.233.179m-1.958-1.771-.145.1-.028-.008c-.016-.005-.03-.015-.047-.02a1 1 0 0 0 .074-.12 1.16 1.16 0 0 0-.112-.75c.18.202.372.393.564.584q-.153.108-.306.214m-.565.249a.84.84 0 0 0-.299.402l-.065.062c-.14-.087-.284-.165-.427-.246a9 9 0 0 0-.084-.96l-.093.015c.007.042.008.086.014.129a1.7 1.7 0 0 0-.084-.366 3.7 3.7 0 0 0 .982.77c.051.028.108.044.161.068a1 1 0 0 1-.105.126m-.886.165q-.046-.027-.093-.052c.007-.029.006-.059.015-.087a1.7 1.7 0 0 0 .031-.417c.02.185.039.37.047.556m-.108.535a1.3 1.3 0 0 1-.01-.44l.12.069c.005.159.013.317.008.477a4 4 0 0 0 .038.785 1.1 1.1 0 0 0-.35.254c-.074.088-.13.188-.195.282l-.002-.001a1.5 1.5 0 0 1 .135-.207 1.02 1.02 0 0 0 .265-.514 2.6 2.6 0 0 0-.009-.705m-.371 1.647a7 7 0 0 0 .727.76q-.002.024-.005.05l-.274.07c-.083.02-.148.037-.217.056-.148-.116-.29-.24-.446-.343q-.035-.026-.07-.052a4 4 0 0 1 .285-.54Zm-.403.379c-.004.02-.013.04-.017.06l-.043-.031a.44.44 0 0 0-.216-.162.4.4 0 0 1-.17-.28c.003-.112.118-.214.238-.313h.001a4 4 0 0 0 .386.184 1.7 1.7 0 0 0-.179.542m-.354-.015c.062.052.13.096.193.144a.7.7 0 0 1 .077.147 4 4 0 0 0-.154.528 1.7 1.7 0 0 0-.13.374 9 9 0 0 1-.734-.31c-.219-.11-.214-.138-.182-.328a2 2 0 0 0 .036-.418.9.9 0 0 1 .113-.562q.164.097.318.21a1.06 1.06 0 0 0 .463.215m-.901 1.55a2 2 0 0 1-.089.194.85.85 0 0 0-.538-.21 1.8 1.8 0 0 1-.638-.133 1.3 1.3 0 0 1-.278-.132c.018-.326.045-.651.095-.974a.6.6 0 0 1 .2-.444c.088.07.181.131.263.208a2.4 2.4 0 0 0 .456.33c.115.065.153.087.283.338a2 2 0 0 0 .2.312c.108.142.137.18.046.51Zm-1.563.263c0-.13.01-.261.015-.392a1.5 1.5 0 0 0 .234.112 2 2 0 0 0 .681.143.72.72 0 0 1 .485.197 2 2 0 0 1-.258.36 2.4 2.4 0 0 0-.385.593q-.007.026-.014.054a5 5 0 0 1-.533-.385 2.4 2.4 0 0 0-.28-.178 1.14 1.14 0 0 0 .055-.504m-.025-1.537a10 10 0 0 0-.093.92 1.3 1.3 0 0 1-.3-.292 3 3 0 0 0-.53-.526q-.028-.02-.053-.039a1.2 1.2 0 0 0-.019-.88.8.8 0 0 1-.057-.534 1.5 1.5 0 0 1 .587.33c.271.202.412.296.515.366.065.043.12.098.182.144a.73.73 0 0 0-.232.51Zm-1.012.214a3 3 0 0 1 .508.503 1.5 1.5 0 0 0 .405.363c-.007.152-.017.304-.017.457a1 1 0 0 1-.037.426 2 2 0 0 0-.217-.138 2.3 2.3 0 0 1-.79-.57 6 6 0 0 0-.197-.194 1.04 1.04 0 0 1 .15-.521q.057-.115.11-.232a1 1 0 0 0 .057-.115q.015.01.028.02Zm.653 2.326a1.1 1.1 0 0 0 .272-.37 2 2 0 0 1 .248.159 6 6 0 0 0 .585.423 4.4 4.4 0 0 0-.167 1.011c-.267-.285-.54-.564-.827-.83l-.276-.276a1 1 0 0 0 .165-.117m1.066 1.347a4.3 4.3 0 0 1 .163-1.054 3.4 3.4 0 0 0 .557.282c.241.098.305.123.475.588a.81.81 0 0 1-.201 1.034l-.154.185c-.023-.034-.039-.073-.063-.106a16 16 0 0 0-.79-.93Zm1.1.942a.94.94 0 0 0 .228-1.175c-.184-.502-.273-.557-.556-.67a3.2 3.2 0 0 1-.57-.29l-.004-.002c.009-.03.012-.06.022-.088a2.2 2.2 0 0 1 .365-.558 2 2 0 0 0 .262-.358q.41.348.8.72c-.158.393-.38 1.079-.128 1.363l.01.015c-.025.238-.047.458-.062.64l-.016.199q-.004.066-.01.13a.6.6 0 0 0-.035.303l.015-.005c-.016.264-.031.528-.06.791a2.4 2.4 0 0 1-.173-.338 5 5 0 0 0-.271-.456 5 5 0 0 1 .183-.22Zm.293 1.83q.042.049.083.098c.4.499.508.633 1.582.74l.193.014.026.043-.286-.008c-.327-.024-.655-.028-.981-.06a1.8 1.8 0 0 1-.712-.288q.052-.269.095-.539m.256.869-.104-.001c-.12 0-.22 0-.317-.002l.04-.182a2 2 0 0 0 .38.185Zm-.104.139c.532.001 1.064.015 1.596.029l.23.014q.087.149.178.296-.268 0-.535-.011l-.002-.05a5.5 5.5 0 0 1-1.814-.277v-.003zm-.02.235q-.106-.008-.213-.013c-.044-.024-.083-.056-.127-.079.112.036.227.063.34.092m-.268.124a2.3 2.3 0 0 0 .16.509q-.262.016-.447.023c.052-.18.108-.358.153-.54.045 0 .09.007.134.008m-6.637-4.855.001.001a1.3 1.3 0 0 0 .049.182 2.5 2.5 0 0 1 .095 1.087l-.003.122a1.93 1.93 0 0 1-.41 1.176l-.1.157a.5.5 0 0 1-.475.237l-.035-.026a.4.4 0 0 0 .036-.27c-.041-.11-.158-.156-.3-.199a2.5 2.5 0 0 1-.075-1.017 1.8 1.8 0 0 1 .297-.658c.21-.34.428-.692.268-1.072a1.3 1.3 0 0 0-1.017-.773c.13-.284.252-.573.358-.84q.422.392.803.824a1.7 1.7 0 0 1 .381.644 2 2 0 0 0 .127.425m-.088-1.322a2 2 0 0 0-.07.495 1.8 1.8 0 0 0-.246-.338 12 12 0 0 0-.85-.873l.103-.27a4 4 0 0 0 .08-.718 5.3 5.3 0 0 1 .832.788 1.5 1.5 0 0 1 .17.54l.034-.003c-.014.127-.027.254-.053.379m-.031-.99a5.3 5.3 0 0 0-.932-.88 4 4 0 0 0-.1-.953 1 1 0 0 0 .091-.435 6.5 6.5 0 0 1 .83 1.498 5 5 0 0 0 .187.95 2 2 0 0 0-.076-.18m-.977-2.554c-.003-.01 0-.021-.004-.032.124-.05.251-.09.375-.138a6 6 0 0 1 .265.58 4 4 0 0 1 .18.91 6.5 6.5 0 0 0-.816-1.32m.079-.885-.002.018h-.001v.001l.001.003-.005.053-.232.076a5 5 0 0 1-.647-.674 2.34 2.34 0 0 0 .865-.89 3 3 0 0 1 .086.547c-.052.74-.067.882-.065.866m-.975-.637c-.077-.102-.167-.195-.236-.303a4.6 4.6 0 0 1-.562-1.476 1.4 1.4 0 0 0 .462-.475 3 3 0 0 1 .277-.36c.104.171.209.341.331.52a3.1 3.1 0 0 1 .625 1.14 2.25 2.25 0 0 1-.897.954m-.959-1.84c-.034.02-.06.048-.096.064a.45.45 0 0 1-.345.017.5.5 0 0 0-.079-.03l-.001.01-.002-.001a.4.4 0 0 1-.113-.205 6 6 0 0 0 .371-.447 1.1 1.1 0 0 0-.154-.98 2 2 0 0 1 .135-.237 15 15 0 0 0 .284 1.81Zm-.5-1.717c-.17-.291-.389-.597-.608-.9a16 16 0 0 1-.385-.551 5 5 0 0 1 .796-1.243 2.17 2.17 0 0 1 .317 1.094c.004.3.028.772.077 1.306a2.5 2.5 0 0 0-.197.294m-.798-.761a10 10 0 0 1 .669 1.008 2.5 2.5 0 0 0-.2.816 2 2 0 0 0 .006.325l-.031.033a4.1 4.1 0 0 0-.434-1.327 2.9 2.9 0 0 1-.322-.88 1.1 1.1 0 0 1 .028-.373q.135.192.284.398m.34 2.941a3 3 0 0 0-.412.072q.23-.183.442-.387a3 3 0 0 1-.03.315m-.022.145a2.9 2.9 0 0 1-.485 1.139 1.8 1.8 0 0 0-.35.677l-.018.012c-.017-.177-.028-.355-.056-.531a6 6 0 0 0-.18-.737c-.016-.044-.02-.09-.033-.133a6 6 0 0 0 .415-.259 3 3 0 0 1 .707-.168m-1.068 2.03a2.2 2.2 0 0 0-.312.453.82.82 0 0 1-.371.407q-.014-.017-.029-.034a6.3 6.3 0 0 0-.789-.773 3 3 0 0 1-.372-.344 2.1 2.1 0 0 0 .704-.508 7 7 0 0 1 .694-.57c.064-.053.134-.095.201-.142.011.036.014.073.026.109a5 5 0 0 1 .175.708 8 8 0 0 1 .073.694m-.556-1.484a7 7 0 0 0-.708.58 2 2 0 0 1-.68.474 1.62 1.62 0 0 1 .718-1.377 2.73 2.73 0 0 0 .782-1.638c.013-.066.014-.133.026-.2 0 .29-.005.598-.015.9a3.6 3.6 0 0 0 .124 1.087c-.083.056-.169.109-.247.174m.125-3.367c-.035.039-1.03 1.101-1.408 1.515a5 5 0 0 1-.234.232 8 8 0 0 0-.073-1.035c.173-.137.33-.266.455-.38q.346-.314.7-.618.238-.189.456-.4c.208.473.11.679.104.686m-1.341 5.844a1.03 1.03 0 0 0-.525.192c-.037.022-.078.037-.116.058-.12-.143-.236-.292-.364-.43a15 15 0 0 0-.659-.604 3.3 3.3 0 0 1 1.056-.333 2 2 0 0 0 .206-.055 3 3 0 0 0 .402 1.172m-1.077-3.41c-.255.22-.5.437-.722.645a2.5 2.5 0 0 0-.495-.961l.028-.02c.384-.273.811-.576 1.212-.87a5 5 0 0 0-.023 1.205Zm-1.779 1.506a4.6 4.6 0 0 0-.8.652 1.1 1.1 0 0 0-.325-.466 2 2 0 0 1-.173-.206c.048-.111.087-.226.138-.336.375-.402.564-.596.648-.68l.08-.064c.093-.072.19-.137.285-.207a6 6 0 0 0 .147 1.307m-.132-1.618c-.168.121-.31.225-.409.304a.9.9 0 0 0-.193.169 37 37 0 0 0-.717.757l-.053.057a2 2 0 0 1-.236-.742c.044-.017.085-.04.13-.056.258-.121.501-.236.7-.35a1.44 1.44 0 0 0 .653-.926l.003-.01a.5.5 0 0 0 .153.184c-.028.203-.023.408-.03.613Zm-.347-.86a1.23 1.23 0 0 1-.548.796c-.19.109-.429.22-.682.34q-.022.009-.042.018c0-.038-.007-.074-.005-.112a1.5 1.5 0 0 1 .133-.627c.016-.024.037-.046.052-.07l-.018-.012a1.5 1.5 0 0 1 .451-.531 2.3 2.3 0 0 0 .374-.508 5 5 0 0 1 .401.407 3 3 0 0 0-.116.299m-4.837 8.604c-.008.033-.007.068-.014.102-.21-.183-.789-.74-.663-1.212a7.4 7.4 0 0 1 1.167-1.685 2.9 2.9 0 0 1 .178.864 2.6 2.6 0 0 1-.344 1.134 4.3 4.3 0 0 0-.324.797m-2.167-3.354a1.66 1.66 0 0 0 .176 1.369q.16.207.335.402l.002-.002a3.5 3.5 0 0 0-.132.563c0 .048.012.094.014.142a1 1 0 0 1-.32 0 4 4 0 0 1-.543-.17.9.9 0 0 0-.336-.325.5.5 0 0 1-.285-.474c.123-.34.264-.672.406-1.003a3 3 0 0 1 .507-.61c.147-.175.313-.385.476-.592-.147.33-.266.603-.3.7M15.6 15.03a1 1 0 0 1 .09.065c-.1-.047-.2-.094-.297-.15a2 2 0 0 1-.099-.235l.002-.008a.63.63 0 0 0 .304.328m-.314 1.468a8 8 0 0 1-.1 1.24 2 2 0 0 1-.12-.132 1.45 1.45 0 0 1-.247-1.296c.062-.253.15-.499.222-.749.006.031.018.06.023.092a3.1 3.1 0 0 0 .222.845m-.274 3.936a2.7 2.7 0 0 0 .542.274l-.262.2c-.236-.077-.545-.222-.594-.428-.006-.082-.002-.164 0-.246a1.5 1.5 0 0 0 .314.2m.3 1.678a.9.9 0 0 0 .127.556.74.74 0 0 0-.487-.202c.121-.117.237-.24.36-.354m-2.066-.913a1.5 1.5 0 0 1 .545.89c-.106.09-.207.187-.313.278a1.76 1.76 0 0 0-.919-.342c.006-.039.005-.078.014-.116a3.4 3.4 0 0 1 .274-.843 2 2 0 0 0 .107-.264 1 1 0 0 0 .292.397m.14 1.25q-.34.295-.672.599a1.74 1.74 0 0 1-.172-.878 2.1 2.1 0 0 1 .844.28Zm-.831.6a10 10 0 0 1-.436-.363 2.24 2.24 0 0 1-.459-.93 2.4 2.4 0 0 0 .742.384 1.85 1.85 0 0 0 .153.91Zm.125 2.305c-.009.063-.004.127-.008.19a1.6 1.6 0 0 0-.128-.265.4.4 0 0 0-.327-.124q.132-.14.266-.277a1.03 1.03 0 0 0 .197.476m-.208-.015a1.5 1.5 0 0 1 .191.536h.003a2 2 0 0 0 .04.241.9.9 0 0 0-.305-.222c-.212-.112-.296-.48-.318-.594l.043-.047a.4.4 0 0 1 .346.086m-.642.235a1.7 1.7 0 0 1 .136.395.46.46 0 0 1-.005.235 1.3 1.3 0 0 0-.04.23.34.34 0 0 0 .031.188c-.028-.022-.048-.045-.081-.068a2 2 0 0 1-.21-.158.53.53 0 0 1-.206-.417q.186-.204.375-.405m-.351.742a.43.43 0 0 0-.247-.094q.074-.081.148-.161a.6.6 0 0 0 .099.255m.007.136a.54.54 0 0 1-.004.388.8.8 0 0 0-.023.42 1 1 0 0 0-.096-.025.4.4 0 0 1-.292-.177.84.84 0 0 1-.02-.64l.088-.096a.305.305 0 0 1 .347.13m-.451.698a.5.5 0 0 0 .307.177c.116.026.164.036.148.193a.6.6 0 0 1-.095.283.43.43 0 0 0-.057.338.5.5 0 0 0-.094-.025.34.34 0 0 1-.273-.18.32.32 0 0 0-.073-.215.35.35 0 0 1 .074-.216.5.5 0 0 0 .085-.31c-.002-.019-.017-.028-.022-.045m-.084.902a.5.5 0 0 0 .277.157c.095.016.152.026.188.209a.74.74 0 0 1-.072.47 1 1 0 0 0-.068.21 1 1 0 0 0-.084-.05.65.65 0 0 1-.29-.253.43.43 0 0 1-.015-.48.8.8 0 0 0 .065-.263Zm-.237 1.655c.013-.023.003-.048.004-.073a.44.44 0 0 0 .046-.31l.009.007a.27.27 0 0 1 .211-.08c.148.005.261.21.264.216a.59.59 0 0 0 .186.375c.08.084.108.11-.064.304q-.093.102-.192.2c-.243.244-.403.406-.261.824a2.6 2.6 0 0 0 .182.412.42.42 0 0 1 .072.388c-.048.154-.211.264-.383.38a1.5 1.5 0 0 0-.24.198 1 1 0 0 0-.137-.426c-.209-.41-.119-.487.178-.744l.108-.093c.208-.18.224-.202.154-.38-.019-.047-.043-.106-.069-.191a.73.73 0 0 0-.416-.406c-.14-.075-.227-.126-.22-.214.008-.097.081-.13.21-.177a.58.58 0 0 0 .321-.229Zm-.538.591a1 1 0 0 0 .146.093.63.63 0 0 1 .271.208 1.6 1.6 0 0 0-.5.146 1 1 0 0 0 .112-.31.6.6 0 0 0-.029-.137m.478.388.038.055q.031.101.071.2c.03.07.04.096.03.118a.7.7 0 0 1-.158.155l-.108.093c-.303.263-.442.383-.2.858.192.375.133.454.132.455l.006-.004c-.006.007-.014.01-.02.017-.123.153-.239.299-.205.459l.006.01-.11-.1a4 4 0 0 1-.256-.235.8.8 0 0 0-.38-.263 1.1 1.1 0 0 0 .398-.047.81.81 0 0 0 .251-.853 1.4 1.4 0 0 0-.128-.284.34.34 0 0 1-.057-.345c.07-.185.504-.268.69-.289m-1.113 1.931-.017.007a.48.48 0 0 1-.102.43l-.046.062a1.27 1.27 0 0 1-.314-.568v.006l-.028-.006a1 1 0 0 1 .136-.025l.003.014a.76.76 0 0 1 .368.08m-.383 1.449c-.045.03-.095.05-.142.076a1 1 0 0 1-.022-.144 1 1 0 0 1 .266-.574c.046.17.104.498-.102.642m.062.644a5 5 0 0 0-.372.267.4.4 0 0 0-.116.15 1 1 0 0 0-.093-.185.63.63 0 0 1-.118-.327c.01-.131.16-.201.35-.29.031-.013.059-.033.09-.047a1.5 1.5 0 0 0 .258.432Zm-.835 1.16a.56.56 0 0 0-.258.278 1.4 1.4 0 0 1 .115-.277 2.9 2.9 0 0 0 .245-1.021.7.7 0 0 0 .071.138.84.84 0 0 1 .14.385q.004.078.009.133c.015.165.016.183-.322.365Zm.115-6.287a.7.7 0 0 0-.073-.142c.039-.011.085-.022.116-.034zm-.05.1q.01.02.016.04c-.056.218-.1.44-.159.657-.053.18-.117.413-.188.676a.8.8 0 0 0-.401-.202 1 1 0 0 0-.149-.472 1 1 0 0 1-.046-.134c.026-.002.05-.009.076-.01a.95.95 0 0 0 .655-.214.6.6 0 0 0 .196-.342Zm-.365 1.498c-.091.337-.193.716-.3 1.119a4 4 0 0 0-.335-.493q-.107-.142-.219-.296c-.04-.057-.07-.106-.104-.159.13-.367.255-.446.338-.441.23.012.563.108.62.27m-.54 1.18c-.027.078-.143.095-.209.099a2.5 2.5 0 0 1-.407-.036c-.022-.006-.046-.002-.068-.007l-.04-.1a1 1 0 0 0-.208-.271 2 2 0 0 1-.167-.214.65.65 0 0 0 .275-.35c.013.007.021.02.034.025a1.4 1.4 0 0 1 .446.313c.254.23.383.432.344.542Zm.53 4.026a.8.8 0 0 0 .311.609 3 3 0 0 0 .278.204c.125.083.223.148.23.218q.009.075-.123.21a.5.5 0 0 1-.148.11.8.8 0 0 0-.284-.088 1.16 1.16 0 0 1-.786-.647c.514-.013.466-.24.521-.616Zm.763 1.308c.112-.115.159-.204.15-.287-.012-.114-.121-.186-.272-.286a3 3 0 0 1-.27-.197.72.72 0 0 1-.293-.595.48.48 0 0 1 .277-.376c.26-.14.343-.206.365-.307a2 2 0 0 0 .222.395 1.16 1.16 0 0 0-.347.748.56.56 0 0 0 .248.46 2 2 0 0 1 .228.23 1.7 1.7 0 0 0-.404.349l-.042-.032a.6.6 0 0 0 .138-.102m.141-.516a.47.47 0 0 1-.215-.397 1.1 1.1 0 0 1 .314-.667 1.9 1.9 0 0 0 .43.4q.166.13.334.256l-.06-.003a.67.67 0 0 1-.264.478 4 4 0 0 1-.23.143c-.022.01-.04.027-.061.04a2 2 0 0 0-.248-.25m.358.29c.078-.046.16-.094.235-.146a.75.75 0 0 0 .298-.53 1.2 1.2 0 0 1 .218.186c.019.029.012.055-.016.138l-.005.014.04.013c.002.024-.004.047-.001.07a.9.9 0 0 1-.052.64l-.047.106a.74.74 0 0 1-.394.466l-.011.008a1.18 1.18 0 0 0-.313-.937c.018-.007.03-.021.048-.027Zm.773-.601a2 2 0 0 0-.208-.17 17 17 0 0 1-.335-.256 1.8 1.8 0 0 1-.702-.888 1.05 1.05 0 0 1 .53-.048c.167.015.226.103.307.223a1 1 0 0 0 .301.314.6.6 0 0 0 .291.116.2.2 0 0 0 .068-.014c.007-.004.006-.013.012-.017q.006.019.014.037a1.44 1.44 0 0 0-.278.703m.474-.794-.014.043c.008.003.814.276.94.749a.59.59 0 0 1-.01.478c-.004.002-.01 0-.014.003-.044.016-.137.052-.35-.094a1.9 1.9 0 0 1-.455-.455l-.003.001a1.25 1.25 0 0 0-.154-.538l-.037-.086a1 1 0 0 1 .097-.1Zm.97 1.405a.68.68 0 0 0 .046-.638c-.128-.482-.84-.756-.972-.804a1.3 1.3 0 0 1 .174-.15.585.585 0 0 0 .29-.594.5.5 0 0 0 .115.039.5.5 0 0 0-.045.117.45.45 0 0 0 .234.48.36.36 0 0 1 .187.282.6.6 0 0 0-.026.15 1.06 1.06 0 0 0 .525 1.04c-.015.06-.017.121-.035.18a3.4 3.4 0 0 0-.122.54c-.01.076-.003.153-.006.23a.95.95 0 0 1-.516-.338.23.23 0 0 1-.004-.185 3 3 0 0 1 .155-.35Zm1.391-.708a.37.37 0 0 1-.196-.227.67.67 0 0 1 .048-.388.54.54 0 0 0 .045-.254.8.8 0 0 0 .215.294 2 2 0 0 1 .144.158.66.66 0 0 1 .04.69 2 2 0 0 1-.085.144c-.01.01-.01.026-.018.037a.36.36 0 0 0-.193-.454m.331-.476a2 2 0 0 0-.153-.167.7.7 0 0 1-.26-.51 1.9 1.9 0 0 1 .1-.693 1.3 1.3 0 0 0 .08.25c.205.249.332.408.34.419a.53.53 0 0 0 .125.301.9.9 0 0 0-.148.564.8.8 0 0 0-.084-.164m1.034-.051a1 1 0 0 0 .33-.831 1.2 1.2 0 0 0-.38-.584q.092-.1.198-.225a1.04 1.04 0 0 0 .391.49.6.6 0 0 0-.208.54.9.9 0 0 0 .365.618c-.028.031-.05.067-.079.097l-.199.189a2.16 2.16 0 0 0-.699.908 2.6 2.6 0 0 1-.065-.507 1.2 1.2 0 0 1 .346-.695m.482.363.17-.162a3 3 0 0 1 .308.27 1 1 0 0 1-.131.178h-.002v.004c-.01.009-.014.024-.025.033a1.6 1.6 0 0 0-.377.496 2.6 2.6 0 0 0-.352.87 2.6 2.6 0 0 1-.32-.722 2.1 2.1 0 0 1 .729-.967m.323 1.38a1.6 1.6 0 0 0-.322-.327l-.049-.045c.026-.05.046-.092.075-.146a1.5 1.5 0 0 1 .29-.383 2.2 2.2 0 0 0 .006.9Zm.634 1.151a2 2 0 0 0-.217-.414 3 3 0 0 0 .19-.332l.006.014c.023-.01.124-.097.382-.563a.93.93 0 0 0 .157.489c-.114.048-.49.231-.52.587a2 2 0 0 0 .002.219m2.232.362c.149.067.186.12.194.144a.03.03 0 0 1-.001.026l.017.013a3 3 0 0 0-.087.162 1 1 0 0 0-.003.823 1 1 0 0 0 .077.18c-.017-.02-.027-.034-.047-.056l-.096-.106a2 2 0 0 0-.168-.145c-.1-.112-.296-.362-.283-.515.036-.447.31-.515.397-.526m.207.386c.047-.096.129-.234.206-.362a1.8 1.8 0 0 1 .329.301 4.7 4.7 0 0 0-.376 1.09c-.005.027-.001.053-.004.08-.007-.01-.01-.024-.017-.034a.8.8 0 0 1-.135-.317c-.107-.401-.108-.543-.003-.758m1.061 1.347c.016-.057.023-.089.035-.135a1.8 1.8 0 0 0 .323.604 1.37 1.37 0 0 1-.156.747 2.5 2.5 0 0 1-.446.451 2.6 2.6 0 0 0-.219-.89 2.7 2.7 0 0 0 .463-.777m.126-.325.008-.012a1.45 1.45 0 0 0 .207-.627l.001.002a2.3 2.3 0 0 1 .402-.322 2.1 2.1 0 0 0 .554-.863l-.088-.032a2.1 2.1 0 0 1-.52.817 2.3 2.3 0 0 0-.335.27 1.5 1.5 0 0 0-.027-.28l.03.014a4 4 0 0 0 .156-.504c.053-.216.14-.42.212-.63.084.05.16.113.248.155.28.149.566.301.575.435a1.9 1.9 0 0 1-.328.66.79.79 0 0 0-.184.541l-.021-.011a2.8 2.8 0 0 1-.453.595.6.6 0 0 0-.184.447c-.336-.492-.253-.655-.253-.655m.495.282a2.8 2.8 0 0 0 .424-.553.8.8 0 0 0 .094.274c-.09.25.107.452.303.63a.88.88 0 0 0-.406.79 6 6 0 0 1-.567-.633c-.003-.041-.02-.373.152-.508m1.172 1.027.046-.092a.3.3 0 0 0 .026-.136c.007.006.016.008.024.014l-.017.03a1.01 1.01 0 0 1 .405.873.92.92 0 0 1-.24.683.56.56 0 0 0-.156.359.9.9 0 0 0-.192-.406c-.35-.432-.109-.906.104-1.325m.121-.307a1 1 0 0 0-.077-.052.8.8 0 0 0-.167-.233 2.3 2.3 0 0 0 .26-.387.8.8 0 0 0 .043-.313 1.8 1.8 0 0 0 .332.373.5.5 0 0 0 .195.176l.01-.019a1.8 1.8 0 0 0 .612.237 1.14 1.14 0 0 1-.568.357.69.69 0 0 1-.64-.14Zm2.228.3a.6.6 0 0 1-.48-.248 1.85 1.85 0 0 1-.24-1.34l.005-.032a.87.87 0 0 0 .295.575 2 2 0 0 0 .25.14 1.08 1.08 0 0 0 .63.814 2 2 0 0 0 .214.08c-.022.001-.044-.003-.066 0-.135.008-.32.018-.608.01Zm.507-.172a1.05 1.05 0 0 1-.574-.678 2.4 2.4 0 0 0 1.111.21c.11 0 .182-.005.192-.005v-.014l.028.009q.204.053.398.12c.008.005.01.01.02.016l.003-.006a.83.83 0 0 1 .649.713 2.4 2.4 0 0 1-.036.341.6.6 0 0 0-.049-.17c-.119-.256-.408-.275-.742-.296a2.15 2.15 0 0 1-1-.24m.782-.57c-.359-.095-.669-.177-.727-.407-.076-.296.273-.566.582-.806.284-.22.53-.41.396-.597a.58.58 0 0 0-.68-.163 2 2 0 0 0-.19.081l.005-.004a2.4 2.4 0 0 0 .547-.703c.036-.074.05-.123.074-.183a.7.7 0 0 0 .122.169.5.5 0 0 0 .307.156h.011a.6.6 0 0 0 .114-.019c-.034.07-.072.137-.099.21a3 3 0 0 0-.176.665c-.045.267.202.349.44.429.036.012.068.028.104.04 0 .006.005.01.004.016-.003.048-.044.154-.297.324-.256.172-.493.363-.49.582a.42.42 0 0 0 .141.266c-.063-.018-.126-.039-.188-.055Zm.828-1.414c-.245-.925.127-1.474.42-1.603q.376-.166.438-.372c.004-.011-.005-.022-.003-.034a.68.68 0 0 1 .173.59 1.27 1.27 0 0 0 .12.764 5 5 0 0 0 .155.814l-.029-.08c-.008.003-.78.28-1.128.1a.27.27 0 0 1-.146-.18Zm1.241-.67v-.01l-.004-.006a1.17 1.17 0 0 1-.116-.63.94.94 0 0 0 .21.42.6.6 0 0 0 .256.154l.01.002h.01c.036-.006.067.017.102.022a.63.63 0 0 0-.289.554 1.5 1.5 0 0 0 .2.514.55.55 0 0 0 .012.346 1.3 1.3 0 0 1-.197-.337 5 5 0 0 1-.194-1.03Zm.233 1.308a1.4 1.4 0 0 0 .222.279.74.74 0 0 1 .272.5 1.6 1.6 0 0 1-.234.653l-.029.06a1.03 1.03 0 0 0-.172-.56.76.76 0 0 0-.486-.36.7.7 0 0 0-.169-.006 2.7 2.7 0 0 1 .596-.566m.306.153-.023-.033a.46.46 0 0 1-.066-.286 1.5 1.5 0 0 0 .521.44l.012.005c.1.031.192.081.29.122l-.014.018a2 2 0 0 0-.154.252c-.033-.023-.059-.056-.094-.077a1.25 1.25 0 0 1-.472-.44Zm.79.329c.014-.016.02-.03.031-.044a4 4 0 0 1 .337.165l-.007.01a1.1 1.1 0 0 0-.213.357 2 2 0 0 0-.299-.24 2 2 0 0 1 .151-.248m.85-.66a.7.7 0 0 0-.219-.506.6.6 0 0 1 .203-.022 1.6 1.6 0 0 0 .356.427 1.5 1.5 0 0 0 .59.347c.051.018.091.037.133.055.023.016.05.025.075.04.143.09.193.233.09.655a2 2 0 0 1-.363.673 5.8 5.8 0 0 0-.829-.654 4 4 0 0 0-.387-.258 1.5 1.5 0 0 0 .35-.757Zm1.32 1.018a.94.94 0 0 0 .016-.575c.015.007.029.018.045.024.461.224.937.457.682 1.1a3.2 3.2 0 0 1-.582 1.008 1.22 1.22 0 0 0 .202-.708.27.27 0 0 0-.128-.183.5.5 0 0 1-.276-.474.3.3 0 0 0-.006-.068l-.014.003c.017-.044.048-.082.061-.127m.745-.34a1.74 1.74 0 0 1-.315-.908 1 1 0 0 0 .097.127 5.1 5.1 0 0 1 .95 1.337c.057.114.136.216.201.326a3.4 3.4 0 0 1-.933-.881Zm.857.49a5.2 5.2 0 0 0-.973-1.37.81.81 0 0 1-.284-.562c.008-.335.357-.664.8-1.081.057-.053.106-.114.162-.167a1.12 1.12 0 0 0 .39.693 1.2 1.2 0 0 0 .497.313 1.25 1.25 0 0 1-.194.73 1.09 1.09 0 0 0 .36 1.479c-.03.027-.066.058-.09.083-.117.135-.225.278-.339.416a5 5 0 0 1-.329-.534m.41.658a1.16 1.16 0 0 0 .538.224l.047-.006c-.036.125-.037.376.258.8l.186.268c.16.236.344.455.527.675a3.4 3.4 0 0 0-.789-.38 1.9 1.9 0 0 1-.78-.544 1 1 0 0 1 .09-.101c.154-.158.345-.354-.003-.808-.03-.04-.048-.085-.077-.125Zm.634.118-.002.002a.2.2 0 0 1-.087.01 1.1 1.1 0 0 1-.486-.202c.1-.122.193-.247.295-.366.041-.04.095-.087.148-.135a1.7 1.7 0 0 1 .59.29 2.2 2.2 0 0 1 .481.489l.016.016c-.016.027-.02.058-.032.086-.081-.13-.273-.39-.515-.39a.35.35 0 0 0-.287.127.22.22 0 0 1-.12.074Zm.642-.346a1 1 0 0 0 .144.074q.158.048.28.08a1.67 1.67 0 0 1 .811.412 4 4 0 0 0 .676.498l.004-.009a1 1 0 0 0-.017.243l-.007-.001a2.2 2.2 0 0 1-1.01-.391 2.7 2.7 0 0 1-.51-.53 2.3 2.3 0 0 0-.371-.376m1.296.494a1.77 1.77 0 0 0-.848-.431q-.12-.031-.276-.078a.93.93 0 0 1-.577-.656q.46-.376.879-.796a.95.95 0 0 0 .484.638 1.16 1.16 0 0 0 .589.196v-.001a.4.4 0 0 0 .094-.014 1.29 1.29 0 0 0 .395.877 2.5 2.5 0 0 1 .215.287c-.023.023-.04.05-.064.072a.8.8 0 0 0-.251.378 4 4 0 0 1-.64-.472m.951.166c.036-.033.064-.074.098-.108l-.002.028c.002 0 .208.026.378.403a2 2 0 0 0 .091.172.67.67 0 0 1-.366.472 2 2 0 0 0-.315.206c-.008-.014-.39-.747.116-1.173m.243 1.05a.76.76 0 0 0 .273-.224.78.78 0 0 1 .533.3c.15.27.247.425.247.427l.018.037a1.6 1.6 0 0 0-.368.009 1.1 1.1 0 0 0-.673.368.8.8 0 0 0-.16-.28.65.65 0 0 0-.436-.244 1.9 1.9 0 0 1 .566-.393m-.204.696c.173.22.15.3.15.3l.003-.004a1.5 1.5 0 0 0-.141.87 1.6 1.6 0 0 1-.495-.345.9.9 0 0 1-.27-.451c.018-.076.018-.155.043-.23a2 2 0 0 1 .287-.364.56.56 0 0 1 .423.224m.231.346.002-.002a1.24 1.24 0 0 1 1.083-.409l.035.077a1.15 1.15 0 0 1 .16.528c-.002.275-.166.317-.414.38a1.15 1.15 0 0 0-.67.368 1.8 1.8 0 0 0-.2.3 1.44 1.44 0 0 1 .004-1.242m.89.666a1 1 0 0 0 .312-.118.7.7 0 0 0 .246.05.72.72 0 0 0 .588-.339.47.47 0 0 0 .044.354 1.3 1.3 0 0 0 .788.439 3 3 0 0 0-.66.163.93.93 0 0 0-.483.491 3.6 3.6 0 0 0-1.395-.753 1.05 1.05 0 0 1 .56-.287m2.051-1.626-.202.176a.88.88 0 0 0-.512-.484.75.75 0 0 0-.124-.366.57.57 0 0 1-.127-.511.5.5 0 0 0 .08-.035 1 1 0 0 0 .224.259l.122.12.05.053.05-.051a1.6 1.6 0 0 0 .323-.455.97.97 0 0 0 .654.985l-.044.115a.75.75 0 0 0-.494.194m1.163-1.284c.023-.047.051-.09.075-.137a1.77 1.77 0 0 1 .371.924c-.064.03-.126.065-.192.092a1.95 1.95 0 0 0-.894.602c-.02.027-.035.058-.054.085a7 7 0 0 1 .694-1.566m.146-.266a7 7 0 0 1 .415-.675 1.04 1.04 0 0 0 .236.646 6 6 0 0 0 .582.645c.018.014.031.033.048.049-.03.007-.057.02-.087.027a3 3 0 0 0-.652.247c-.036.02-.075.034-.111.053a1.75 1.75 0 0 0-.432-.992Zm2.706 2.372c.126-.06.27-.127.435-.218.183-.1.302-.17.396-.225-.065.124-.143.242-.196.372a2 2 0 0 0 .04.365l-.02.006a.98.98 0 0 1-.3 1.01 1.8 1.8 0 0 1-.71.332 1.82 1.82 0 0 1-.45-1.06 1.94 1.94 0 0 1 .805-.582m.432 1.428a.9.9 0 0 0 .387-.7 1.9 1.9 0 0 1 .1 1.508 3 3 0 0 1-.226.294 6 6 0 0 1-.845-.68c-.036-.03-.063-.066-.096-.098a1.9 1.9 0 0 0 .68-.324m1.373-.866h.018a1.4 1.4 0 0 1 .036-.308c.015-.021.097-.104.547-.156a1.2 1.2 0 0 0 .862-.389 2 2 0 0 1 .218.346c.016.06.023.123.036.184-.008.05-.05.152-.277.188a.85.85 0 0 0-.708.357 1.7 1.7 0 0 0-.171.72 6 6 0 0 1-.416-.637 7 7 0 0 1-.145-.305m3.45 2.589a1.55 1.55 0 0 1-1.016-.106 1 1 0 0 1 .129-.103 2 2 0 0 1 .195-.118 3.6 3.6 0 0 0 .44-.28c.366-.262.397-.435.397-.49.176-.028.313-.042.365.008.018.057.037.125.054.176a3 3 0 0 1 .122.324l-.008.037.022.003a3 3 0 0 1 .093.344 5 5 0 0 1-.793.205m.74-.84c-.017-.038-.026-.08-.043-.117-.133-.401-.298-1.027-.492-1.794l.012.01a.64.64 0 0 1 .472-.183.87.87 0 0 1 .577.25.35.35 0 0 1 .1.26l.06.004a1 1 0 0 1-.207.379 1.7 1.7 0 0 0-.253.42 5 5 0 0 0-.227.771Zm.356-.717a1.6 1.6 0 0 1 .135-.223 1.5 1.5 0 0 0 .458.748q.082.07.164.138c-.038.032-.07.071-.109.102-.116.106-.236.216-.347.323a3.6 3.6 0 0 0-.43.472 3.4 3.4 0 0 0-.136-.586 5 5 0 0 1 .265-.974m.687.419a1.38 1.38 0 0 1-.45-.762l-.032.004c.012-.015.018-.034.03-.05a1.2 1.2 0 0 0 .179-.328.8.8 0 0 0 .317.243c.181.097.367.198.397.382a.9.9 0 0 1-.067.412l-.04.029.015.025q-.01.026-.023.05-.075.074-.152.142-.091-.075-.174-.147m.364.163.028.022c.015-.018.018-.042.03-.061q.101.196.192.398a13 13 0 0 0-.304-.258l-.028-.025zm.16-.151q.047-.054.092-.109a5.6 5.6 0 0 0 .81-.663 3.8 3.8 0 0 0 .551-.886q.041.16.067.323l-.009-.002a3.8 3.8 0 0 1-.526 1.326c-.097.098-.178.2-.258.298a2.8 2.8 0 0 1-.396.429 8 8 0 0 0-.33-.716Zm1.905.97a1.7 1.7 0 0 1-.135-.418 1.4 1.4 0 0 1 .273-.398 1.5 1.5 0 0 0 .241-.392 1.5 1.5 0 0 0 .062.47.8.8 0 0 0 .213.273c-.075.106-.151.212-.233.333-.086.125-.185.241-.282.359a1 1 0 0 1-.139-.226Zm.537-.053c.075-.11.144-.206.213-.304a1.6 1.6 0 0 1 .195.192 1.5 1.5 0 0 1 .15.848 3 3 0 0 0-.352-.121.9.9 0 0 1-.503-.235c.102-.125.206-.247.297-.38m.2-.53a.6.6 0 0 1-.168-.214 1.4 1.4 0 0 1 .004-.78l-.005-.002a1.7 1.7 0 0 0 .054-.71 1.7 1.7 0 0 0 .331.45c.106.11.223.207.338.306a4.2 4.2 0 0 1-.555.95Zm.318-1.353c-.478-.492-.356-.71-.354-.712l-.045-.03a2.1 2.1 0 0 0 .465-.713 3 3 0 0 0 .306.454q.026.026.053.05l-.004.002a2.5 2.5 0 0 1-.088 1.143c-.01.026-.025.05-.035.076-.1-.09-.204-.174-.298-.27m.132-1.628a2.2 2.2 0 0 0 .109-.661.85.85 0 0 0-.302-.48c-.212-.207-.395-.386-.145-.902l.028-.056a3 3 0 0 1 .192-.318 5.65 5.65 0 0 1 1.13 1.848 7 7 0 0 0 .043.902l.032-.005a2.6 2.6 0 0 0 .064.58l.017.069a3 3 0 0 1 .083.322 4.3 4.3 0 0 1-.909-.77 3 3 0 0 1-.342-.529m-1.517-4.308c-.484-.53-.257-1.245.03-2.15.098-.307.199-.625.283-.967.208-.844.289-1.368.349-1.75a6 6 0 0 1 .118-.626.44.44 0 0 0-.21-.534 1.74 1.74 0 0 1-.517-.64 1.07 1.07 0 0 1-.098-.556l.049-.053a3 3 0 0 0 .451-.471 3 3 0 0 0 .26 1.056 4.4 4.4 0 0 1 .384 3.002q-.078.26-.173.538a4.1 4.1 0 0 0-.328 2.094 6.3 6.3 0 0 0 1.551 2.279c.037.031.049.08.077.12a.91.91 0 0 0-.826.322 34 34 0 0 0-1.4-1.664m1.963-12.292a10 10 0 0 1 .093 1.49q-.006.02-.012.041a4.8 4.8 0 0 1-.185-1.19v-.005c0-.005.007-.01.007-.015l-.007-.03v-.154a2 2 0 0 1-.02-.319zm-.1-.395c.005-.043.006-.087.015-.13.013.071.03.14.041.212Zm-.184 6.123a3 3 0 0 0-.043.26c.018.207.047.39.072.554a2 2 0 0 1 .017.253 2.7 2.7 0 0 1-.338-.748 5.8 5.8 0 0 1-.157-2.557 6.2 6.2 0 0 1 .67-1.958q.032.129.072.256a3.8 3.8 0 0 1-.379.932 2.8 2.8 0 0 0-.318.777c-.308 1.926.342 2.208.404 2.231m.86-1.6q-.132.203-.26.386a2.5 2.5 0 0 0-.576 1.068c-.116-.072-.545-.456-.289-2.062a2.7 2.7 0 0 1 .304-.735 4 4 0 0 0 .33-.743 4.9 4.9 0 0 0 .873 1.458 5 5 0 0 1-.381.628Zm.08-3.141.102.057c.272.15.552.308.552.423a1.2 1.2 0 0 0 .047.3 3 3 0 0 1 .07.367 4.8 4.8 0 0 1-.399 1.224 4.8 4.8 0 0 1-.873-1.568c.025-.094.06-.185.078-.28a10 10 0 0 0-.062-1.254l.171.263a.55.55 0 0 0 .314.468m-1.08-4.843c.018.022.027.05.047.073a5 5 0 0 1 .4.68 7 7 0 0 0 .367.646 1.97 1.97 0 0 1 .103 1.358.22.22 0 0 1-.121.179c-.146.092-.241.194-.136.676a5 5 0 0 1 .065.44l-.163-.244q-.053-.381-.133-.756a1.8 1.8 0 0 1 .179-.342 1.82 1.82 0 0 0-.068-1.687 79 79 0 0 0-.728-1.186c.06.057.13.104.188.163m.418 1.094a1.68 1.68 0 0 1 .067 1.547 2 2 0 0 0-.1.182 10 10 0 0 0-.246-.877l-.013-.02.025-.028.006-.006a.65.65 0 0 0 .218-.44.5.5 0 0 0-.222-.33.86.86 0 0 1-.248-.3l-.017-.038a16 16 0 0 0-.783-1.56c.179.133.338.29.505.438l-.053.033q.436.696.861 1.399m-.795-1.812a2 2 0 0 0 .057.212 8 8 0 0 0-.786-.597c-.074-.12-.154-.237-.23-.355a8 8 0 0 1 .923.773Zm-.11-.405a2 2 0 0 0 .068.25 8 8 0 0 0-.935-.782c-.064-.047-.128-.086-.191-.125-.04-.059-.075-.12-.116-.178q.24.083.472.189a5 5 0 0 1 .702.645Zm-.016-.204a5 5 0 0 0-.487-.45 3.4 3.4 0 0 1 .487.446Zm-.494-.742a.7.7 0 0 0 .25.27.7.7 0 0 1 .178.175l.022.04a4.2 4.2 0 0 0-1.465-.914c-.075-.113-.151-.227-.218-.333a7 7 0 0 1 1.233.762m-.83-1.863c.023.049.049.11.084.194a1.4 1.4 0 0 0 .297.447.64.64 0 0 1 .19.312 2 2 0 0 0 .09.273.9.9 0 0 1 .07.364c.003.014.013.025.015.04a6.6 6.6 0 0 0-1.086-.655c-.063-.034-.132-.058-.197-.088-.12-.198-.234-.39-.336-.566-.163-.28-.304-.522-.444-.727l.028.005.254.046a2.2 2.2 0 0 1 1.035.355m-.451-.45q.094.08.19.154a4.4 4.4 0 0 0-.748-.197l-.4-.074a.9.9 0 0 1-.129-.361 1.25 1.25 0 0 0-.926-1.158 3.7 3.7 0 0 0-1.032-.102c-.07-.1-.132-.205-.208-.3q.228-.005.455-.014c.623-.023.937-.036 1.297.384a4.6 4.6 0 0 1 .43.62c.187.307.334.549.54.56l.233.015a.85.85 0 0 0 .298.474Zm-.993-1.757a.74.74 0 0 0 .303-.187q.026-.024.053-.046a1 1 0 0 1 .02.087 8 8 0 0 0 .26 1.043.5.5 0 0 1 .007.108 1 1 0 0 0 .035.184l-.212-.012c-.154-.01-.29-.233-.464-.516a4.7 4.7 0 0 0-.438-.633c-.39-.454-.74-.441-1.373-.417q-.162.007-.358.012l-.152.004a8 8 0 0 1-.585-.992 2 2 0 0 0 .278.2 1.26 1.26 0 0 0 .91.535 6 6 0 0 1 1.281.386c.106.166.223.297.435.244m-.727-.687a3 3 0 0 1 .164.244 6 6 0 0 0-1.124-.325 1.1 1.1 0 0 1-.568-.22 12 12 0 0 0 1.515.274c.006.008.006.02.013.027M48.9 14.6a1.3 1.3 0 0 1 .195.276 4.1 4.1 0 0 1 .55 1.117.45.45 0 0 1-.044.275.5.5 0 0 0 .022.475 12 12 0 0 1-1.451-.264 2 2 0 0 1-.22-.108 1.1 1.1 0 0 1-.229-.43 6 6 0 0 0-.127-.29 4.2 4.2 0 0 1-.244-.882c-.002-.016-.009-.03-.01-.046a2 2 0 0 0 .38.12q.086.005.165.005v-.001A1.62 1.62 0 0 0 48.9 14.6m-3.035-4.407a.51.51 0 0 1 .2.384c.015.209.196.342.387.482a1.1 1.1 0 0 1 .414.435 2.06 2.06 0 0 1 .14 1.265c-.161.43.249.966.723 1.216a1.14 1.14 0 0 1 .378.337.49.49 0 0 0 .444.258q.077-.007.135-.014a1 1 0 0 1 .098-.007 1.7 1.7 0 0 1-1.058.2 1.1 1.1 0 0 1-.404-.103 4.6 4.6 0 0 0-.541-1.527 10 10 0 0 0-.936-1.26c.02-.01.034-.03.055-.041a.52.52 0 0 0 .327-.35c.046-.265-.22-.548-.53-.877l-.085-.09c-.391-.414-.73-.772-.706-1.027.015-.157.355-.272.61-.327a.8.8 0 0 0 .077.733 4 4 0 0 0 .272.313m-.196-1.42a2 2 0 0 0-.1.217c-.216.04-.776.169-.803.47-.029.32.312.68.743 1.138l.085.09c.271.288.528.56.493.755q-.023.137-.25.249c-.034.018-.058.049-.09.069a10 10 0 0 0-.904-.905c-.3-.257-.589-.527-.872-.802.335-.244.59-.46.642-.636a.5.5 0 0 0-.036-.405.6.6 0 0 0-.104-.103c.399-.046.796-.101 1.196-.138Zm-1.417.163a.46.46 0 0 1 .205.152.36.36 0 0 1 .02.29c-.04.14-.304.355-.613.578a19 19 0 0 1-.826-.875c.403-.058.81-.097 1.214-.145m-1.405.178c.153.25.411.76.315 1.049-.02.04-.06.065-.085.102a2 2 0 0 1-.19-.081 3.8 3.8 0 0 1-1.062-.895c.34-.058.68-.124 1.022-.175m-1.226.21a2.15 2.15 0 0 1 .166 1.142c-.009.026-.008.054-.016.08-.103-.055-.203-.119-.308-.171a2.2 2.2 0 0 1-.924-.865c.359-.071.721-.122 1.082-.185Zm-1.16.2-.063.03a2.3 2.3 0 0 0 1.004.948c.116.058.226.128.34.19a1.4 1.4 0 0 0 0 .526 2.5 2.5 0 0 1 .011.668.9.9 0 0 1-.235.448 2 2 0 0 0-.153.236 4 4 0 0 1-.348-.162 1.53 1.53 0 0 0 .334-1.155c-.034-.31-.269-.357-.625-.428-.146-.03-.328-.065-.535-.126a.95.95 0 0 1-.607-.953c.292-.074.587-.138.877-.222m-.93.717a.93.93 0 0 0 .62.593c.213.064.398.1.548.13.372.074.49.106.512.304a1.39 1.39 0 0 1-.304 1.049l-.016.013-.044-.03a5 5 0 0 0-.91-.467l-.088-.038.12.018-.417-.201c-.036-.021-.063-.053-.097-.076a9 9 0 0 1 .075-1.295Zm-.04 1.54a4 4 0 0 0 .391.182 4.8 4.8 0 0 1 .885.453l.01.007a.57.57 0 0 0-.255.392.5.5 0 0 0 .06.2 1 1 0 0 1-.208-.13 4 4 0 0 0-.376-.246c-.475-.278-.547-.397-.547-.662a.33.33 0 0 1 .04-.195Zm-.053-1.998a13 13 0 0 0-.114 1.65 2 2 0 0 1-.504-.575 2 2 0 0 1-.113-.22c0-.29-.019-.54-.03-.667.256-.055.507-.125.76-.188Zm-.788 1.662a4 4 0 0 0 .052-.51 2.2 2.2 0 0 0 .625.692.2.2 0 0 0 .054.078.47.47 0 0 0-.071.272 1 1 0 0 0 .016.131 2 2 0 0 0-.131-.12l-.233-.14c-.1-.06-.215-.128-.332-.2a2 2 0 0 1 .02-.203m.24.525.231.14a1.4 1.4 0 0 1 .39.352l.002-.002a2 2 0 0 0 .345.254 1 1 0 0 0-.139.642 2 2 0 0 1-.033.39l-.004.037a.64.64 0 0 0-.288-.302 2.3 2.3 0 0 1-.432-.313c-.084-.08-.18-.143-.271-.215a.37.37 0 0 0 .075-.321 2.3 2.3 0 0 0-.084-.4 1.5 1.5 0 0 1-.066-.429c.094.058.19.117.274.167m-.383-1.968a1 1 0 0 0 .059.664 4.5 4.5 0 0 1-.055.755c-.01.046-.007.094-.013.141a7 7 0 0 1-.35-.236 3.1 3.1 0 0 1-.681-1.138c.347-.056.695-.115 1.04-.186m-1.069.503a2.55 2.55 0 0 0 .626.935q.212.153.419.282a1.6 1.6 0 0 0 .063.548 2 2 0 0 1 .08.377.3.3 0 0 1-.034.228c-.067-.05-.127-.11-.197-.156-.102-.07-.24-.162-.51-.362a1.6 1.6 0 0 0-.64-.355h-.001c.008-.02.004-.041.013-.06l.056-.194a6.5 6.5 0 0 0 .125-1.243m-1.25.007c.272-.077.54-.169.813-.24.1-.015.2-.038.3-.054a9 9 0 0 1-.124 1.492q-.029.107-.055.192c-.006.013-.003.027-.008.04a1.4 1.4 0 0 1-.32-.145 2.5 2.5 0 0 1-.652-.817c.017-.156.022-.313.046-.468m-.07.72a2.6 2.6 0 0 0 .603.686 1.5 1.5 0 0 0 .364.164.93.93 0 0 0 .058.65 1.06 1.06 0 0 1 .027.734c-.118-.09-.233-.183-.358-.263a5 5 0 0 1-.432-.31c-.413-.316-.389-.465-.347-.737a2 2 0 0 0 .033-.385c.005-.18.038-.358.052-.538Zm-.076-.677c-.01.066-.01.132-.02.198-.014-.037-.04-.066-.053-.103q-.015-.032-.031-.064l.104-.03Zm-.24.071q.02.04.038.08a3 3 0 0 0 .158.3c-.026.256-.068.51-.074.767a2 2 0 0 1-.03.362c-.046.292-.079.504.4.87a5 5 0 0 0 .443.317c.13.084.252.181.375.277a1 1 0 0 1-.072.14q-.061.134-.108.23a1.2 1.2 0 0 0-.147.461 19 19 0 0 1-.903-1.017l-.008.006c-.018-.025-.03-.055-.049-.08a1.2 1.2 0 0 0-.606-.464l-.05-.02a.3.3 0 0 1 .018-.104.82.82 0 0 0-.218-.774l-.108-.157a3.1 3.1 0 0 1-.314-.812c.414-.14.835-.257 1.254-.382Zm1.106 4.747c-.059-.047-.104-.107-.164-.151l-.033-.044-.122-.163a1.9 1.9 0 0 1-.314-.716 2.3 2.3 0 0 0-.114-.34c.202.233.441.498.61.656a5 5 0 0 0 .137.758m-2.494-4.316a3.2 3.2 0 0 0 .33.84q.058.089.109.16c.19.275.268.388.198.658-.052.197-.013.248.124.293a1.07 1.07 0 0 1 .54.42 2.2 2.2 0 0 1 .425.908 2 2 0 0 0 .337.765l.12.16c.048.066.054.074.084.087a7 7 0 0 1 .88.82l.357.357a16 16 0 0 1 1.72 1.868 4.4 4.4 0 0 1 .398.668 2.5 2.5 0 0 0 .265.51l-.033.24c-.069-.08-.136-.158-.223-.251q-.389-.418-.744-.813a23 23 0 0 0-1.88-1.926 9.8 9.8 0 0 1-2.438-3.436 58 58 0 0 1-.603-2.316Zm-.166.06q.278 1.16.6 2.307a9.96 9.96 0 0 0 2.48 3.503 23 23 0 0 1 1.87 1.914q.354.396.743.815c.104.112.2.232.3.349a16 16 0 0 1-.1.605 1.8 1.8 0 0 1-.557-.75 4.1 4.1 0 0 0-1.11-1.326 15.8 15.8 0 0 1-2.625-2.955c-.328-.436-.637-.847-.897-1.15a1.58 1.58 0 0 1-.468-1.402 2.4 2.4 0 0 0-.042-.832 1.85 1.85 0 0 0-.508-.962c.105-.037.209-.079.314-.115Zm-.467.173a1.6 1.6 0 0 1 .524.94 2.3 2.3 0 0 1 .038.786 1.72 1.72 0 0 0 .502 1.507c.256.297.565.707.891 1.14a15.9 15.9 0 0 0 2.654 2.984 4 4 0 0 1 1.072 1.286 1.9 1.9 0 0 0 .648.823q-.026.129-.055.258l-.273-.006a.62.62 0 0 1-.389-.502 1.4 1.4 0 0 0-.295-.655 1.7 1.7 0 0 0-.632-.56 2.1 2.1 0 0 1-.52-.382c-.18-.156-.376-.293-.569-.435-.014-.075-.022-.136-.042-.22a1.1 1.1 0 0 0-.76-.948 4.6 4.6 0 0 1-.96-.578c-.873-.677-.967-1.041-1.057-1.393a3 3 0 0 0-.087-.294 7.6 7.6 0 0 1-.22-1.404c-.053-.492-.106-1-.19-1.424a2.2 2.2 0 0 0-.327-.906Zm-.189.07a1.8 1.8 0 0 1 .331.88q.123.702.187 1.41a7.6 7.6 0 0 0 .228 1.44 3 3 0 0 1 .084.28c.097.375.196.762 1.107 1.469a4.7 4.7 0 0 0 .988.595c.377.176.533.249.68.854l.011.057c-.045-.032-.085-.07-.131-.1a12 12 0 0 1-.664-.466 2.6 2.6 0 0 0-.452-.36 12 12 0 0 1-1.653-1.633 4.7 4.7 0 0 1-.562-1.111 1.6 1.6 0 0 1 .067-.29 3.7 3.7 0 0 0 .088-1.183 5.6 5.6 0 0 0-.5-1.772zm.17 1.857a3.6 3.6 0 0 1-.058.96 7 7 0 0 0-.204-.641c-.01-.1-.028-.198-.031-.298a4 4 0 0 0-.205-1.084 6 6 0 0 0-.262-.577c.089-.035.179-.065.267-.099a5.6 5.6 0 0 1 .493 1.739m-.622-2.803a1.3 1.3 0 0 1-.056.41l-.175.055q.032-.406.06-.811a3.4 3.4 0 0 0-.824-2.074 9 9 0 0 1-.362-.567c.034-.03.062-.064.097-.092a.62.62 0 0 1 .485-.146 1.1 1.1 0 0 1 .551.37c-.008.051-.01.104-.02.156a3 3 0 0 0-.074.666 4.5 4.5 0 0 0 .18 1.226 3.5 3.5 0 0 1 .138.807m-.647-4.963a3.55 3.55 0 0 1 .453 1.28 3 3 0 0 1-.007.653 1.2 1.2 0 0 0-.552-.334.75.75 0 0 0-.594.174c-.031.025-.057.056-.087.082a1.23 1.23 0 0 1-.205-1.105c.022-.113.05-.255.076-.428.01-.038.01-.078.017-.116a3 3 0 0 1 .899-.206m-1.279-3.178c.016-.013.027-.015.043-.027a6.8 6.8 0 0 0 .337 1.718 4.8 4.8 0 0 0 .581 1.024 4 4 0 0 1 .21.293 2.9 2.9 0 0 0-.767.216 2.4 2.4 0 0 0 .01-.577 7 7 0 0 1-.049-.553A3.1 3.1 0 0 0 30.51 2.6a1.8 1.8 0 0 0 .705-.327Zm-1.47.668a2 2 0 0 1 .408-.223 3.1 3.1 0 0 1 1.098 1.666c.016.302.036.46.05.577a2.1 2.1 0 0 1-.04.704 2.5 2.5 0 0 0-.727.525c-.026.025-.045.056-.07.083a17 17 0 0 1-.06-1.157 2.35 2.35 0 0 0-.908-1.84c.082-.112.157-.23.25-.335Zm.181 1.043-.075-.067a5.3 5.3 0 0 0-.793 1.209 1.14 1.14 0 0 1-.238-.606 4.6 4.6 0 0 1 .593-1.132 2.2 2.2 0 0 1 .513.596m-.798-.754q.04.02.08.043a4.7 4.7 0 0 0-.459.849 3.3 3.3 0 0 0-.063-.732c.148-.05.297-.1.442-.16m-.495 1.573a2.9 2.9 0 0 0 .325.598 1.3 1.3 0 0 0-.064.549 3 3 0 0 0 .334.923 4 4 0 0 1 .44 1.393 6 6 0 0 1-1.187.953 3.3 3.3 0 0 1-.084-.884c.03-.89.006-1.864.001-2.06a1.18 1.18 0 0 0-.156-.926c.116-.12.233-.24.34-.37.02-.057.033-.117.051-.176M27.28 3.72a7.3 7.3 0 0 0 1.176-.25 2.5 2.5 0 0 1-.066 1.375c-.083.1-.19.176-.278.27a8 8 0 0 0-.695-1.02c-.158-.194-.158-.194-.119-.326l-.038-.012q.01-.018.02-.037m-.046.524a7.6 7.6 0 0 1 .707 1.037 6 6 0 0 1-.49.477q-.314.268-.706.622c-.091.083-.214.181-.333.278-.021-.128-.05-.255-.078-.382.01-.014.015-.03.025-.043a2.28 2.28 0 0 0 .51-1.333 2 2 0 0 0-.054-.395 4 4 0 0 0 .284-.451 1.5 1.5 0 0 0 .135.19m-.263-.442a4 4 0 0 1-.238.433 1.1 1.1 0 0 0-.18-.306c.14-.04.277-.09.418-.127m-.698.213.127-.039a.86.86 0 0 1 .234.387 4 4 0 0 1-.294.38c-.052.03-.108.052-.162.077a5 5 0 0 1 .095-.805m.191.928c.086-.09.154-.193.231-.289a2 2 0 0 1 .033.249 2.13 2.13 0 0 1-.437 1.166l-.006-.03a4.8 4.8 0 0 1-.111-.956 2 2 0 0 0 .29-.14m-.285 1.32a4 4 0 0 0-.298.512c-.03.111-.034.227-.057.34-.452.337-.954.695-1.403 1.013l-.062.044a2.5 2.5 0 0 0-.362-.312.73.73 0 0 0-.166-.408.53.53 0 0 1 .35-.3.92.92 0 0 0 .674-.72 1.85 1.85 0 0 1 .37-.682 2.2 2.2 0 0 1 .81-.594 5 5 0 0 0 .113.917c.016.062.017.127.03.19ZM26.12 4.06a5 5 0 0 0-.091.832 2.47 2.47 0 0 0-.98.7 2.1 2.1 0 0 0-.416.763c-.102.292-.164.469-.519.57a.74.74 0 0 0-.443.328 5 5 0 0 0-.396-.4l.003-.005q.076-.152.166-.296a4 4 0 0 1 .318-.434 3.6 3.6 0 0 0 .688-1.426 17 17 0 0 1 1.67-.632m-2.25.877c.133-.064.273-.111.407-.172a3.55 3.55 0 0 1-.623 1.262 4 4 0 0 0-.33.45q-.045.073-.09.157-.035.06-.066.12a10 10 0 0 0-.362-.303 13 13 0 0 0 1-1.478c.02-.01.043-.027.064-.036m-1.364.931a7 7 0 0 1 1.042-.754 13 13 0 0 1-.854 1.25q-.149-.116-.274-.209c.028-.096.061-.19.086-.287m.1.606c-.16.201-.311.408-.482.6.1-.253.175-.514.253-.774q.114.085.228.174Zm-.428-.32.081.058a10 10 0 0 1-.424 1.16q-.343.35-.616.66-.133.15-.267.297l-.034-.022a1.1 1.1 0 0 1-.26-.656 34 34 0 0 1 1.52-1.498Zm-3.052 3.04c.427-.396.913-.903 1.42-1.428a1.4 1.4 0 0 0 .283.65c.008.008.019.011.027.018a9 9 0 0 1-.364.37 3.7 3.7 0 0 1-.592.444 1.54 1.54 0 0 0-.565.515 2 2 0 0 0-.265-.521zm-.164.14a1.8 1.8 0 0 1 .286.666 1 1 0 0 0-.035.13.52.52 0 0 0 .077.351 1.8 1.8 0 0 1-.091.495 3 3 0 0 0 .019-.447 2.6 2.6 0 0 0-.402-1.07q.073-.062.146-.124Zm-.92.79q.33-.29.666-.572a2.5 2.5 0 0 1 .371 1 3 3 0 0 1-.095.877 10 10 0 0 1-.425.684 6 6 0 0 0-.428.638 3 3 0 0 0-.123-.51 4.3 4.3 0 0 1 .051-2.113Zm-.218.32.038-.048a4.3 4.3 0 0 0 .021 1.91 3 3 0 0 1 .145.645 6 6 0 0 0-.105.205 3.6 3.6 0 0 0-.289-1.13l-.085-.252a2.22 2.22 0 0 1 .275-1.33m-.284.11-.005.025c-.134.29-.329.716-.52 1.14-.054.069-.105.141-.165.206-.221.297-.44.558-.651.81-.072.065-.134.14-.199.211a8.5 8.5 0 0 0 .62-1.513c.305-.294.605-.594.92-.879m-2.416 2.954q.408-.737.851-1.455c.139-.14.286-.272.427-.41a8.4 8.4 0 0 1-.54 1.266c-.069.149-.12.305-.185.455a3.2 3.2 0 0 0-.434 1.018c-.002.016.003.03.002.046-.01.029-.024.056-.034.084a2.3 2.3 0 0 1-.097-.78l-.003-.084a1 1 0 0 1 .013-.14m-.15.28a2.4 2.4 0 0 0 .162.96c-.031.09-.053.184-.082.275a5 5 0 0 0-.305-.797c.076-.145.147-.293.225-.437Zm-.31.603a5 5 0 0 1 .31.899c-.1.327-.21.65-.292.982a1.9 1.9 0 0 0-.272 1.229q.017.21.036.402c.055.559.098 1-.127 1.16a.37.37 0 0 0-.15.336 1.5 1.5 0 0 0 .386.694 3 3 0 0 0 .006.419c.059.25.359.408.597.496l-.004.004a2.6 2.6 0 0 0-.717-.171c-.432-.064-.492-.296-.6-.72a5 5 0 0 0-.165-.54 2 2 0 0 0-.139-.24c.029-.058.071-.108.098-.167a3.8 3.8 0 0 0 .041-.95.8.8 0 0 0 .227-.316 2 2 0 0 0 .032-.25 2.26 2.26 0 0 0 .437-1.02 2 2 0 0 0-.284-1.072q.279-.594.58-1.175m-.658 1.348a1.9 1.9 0 0 1 .222.887 2.1 2.1 0 0 1-.284.738 2.3 2.3 0 0 0-.232-.973q.144-.328.294-.652m-.373.83a2.2 2.2 0 0 1 .16 1.046 2 2 0 0 1-.029.25.6.6 0 0 1-.103.175 3.8 3.8 0 0 0-.248-.94q.108-.267.22-.532Zm-.745 1.885c.139-.388.294-.77.447-1.153a3.7 3.7 0 0 1 .192.873 2.6 2.6 0 0 1-.674.372q.018-.045.035-.092m-.114.304a1.64 1.64 0 0 1 .593.588 6 6 0 0 1-.367.63 1.2 1.2 0 0 0-.444-.638c.077-.19.147-.385.218-.58m-.272.72a1.1 1.1 0 0 1 .4.716 1 1 0 0 0-.024.303 2 2 0 0 1-.159.51 3.5 3.5 0 0 0-.285.873c-.009.04-.008.08-.015.12a2.3 2.3 0 0 1-.792-.44c.267-.684.583-1.371.875-2.082m-1.158 2.859c.054-.174.125-.347.189-.52a2.3 2.3 0 0 0 .459.923 1 1 0 0 0-.074-.041c-.265-.067-.537-.14-.625-.162.019-.066.031-.134.051-.2m-.086.337c.09.024.361.095.626.162.186.046.395.3.522.484q-.089.079-.176.158c0-.026 0-.05.005-.083.044-.355-.637-.59-.986-.688Zm-.044.17.012.003-.013.001Zm-.038.147a3.1 3.1 0 0 0 .232.782 7 7 0 0 1-.498.437q.111-.615.266-1.219m-.304 1.439a7 7 0 0 0 .594-.522c.032.042.07.079.105.12-.243.165-.48.337-.718.508zm.059 2.114a.93.93 0 0 0 .04.475.6.6 0 0 0-.363-.156c.106-.109.219-.21.323-.32Zm-.41.404c.07.006.418.044.443.258a.4.4 0 0 1-.075.252.5.5 0 0 0-.07.183q.002.014.002.028a.5.5 0 0 0-.113-.028.4.4 0 0 1-.158-.045.73.73 0 0 1-.156-.522zm-.225.223.012-.012a.7.7 0 0 0 .16.482 1 1 0 0 0-.297.061q.066-.273.125-.531m-.15.638.016-.004c.178-.067.424-.136.511.026.065.119-.007.372-.07.595a1 1 0 0 0-.077.358l-.284-.232a.54.54 0 0 1-.17-.436zm-.136.559a.64.64 0 0 0 .172.256l.338.277.008-.01v.022a.9.9 0 0 0-.386-.157.36.36 0 0 0-.238.034zm-.152.6a.26.26 0 0 1 .271-.12.8.8 0 0 1 .408.18q.034.075.074.145a.35.35 0 0 1 .045.337.5.5 0 0 0-.215-.071 1.6 1.6 0 0 1-.592-.436Zm-.04.155a1.45 1.45 0 0 0 .61.409c.15.02.19.053.202.07a.5.5 0 0 1-.308.226c-.115.043-.223.098-.253.226a.6.6 0 0 0-.121-.14l-.078-.078a.7.7 0 0 1-.11-.483h-.001l.06-.23Zm-.136.515a.8.8 0 0 0 .12.264l.08.08c.141.14.253.25.23.44a.9.9 0 0 1-.559.69 13 13 0 0 0-.338.118 35 35 0 0 0 .467-1.592m-.506 1.716.003-.01.082-.03-.02.034a.45.45 0 0 1 .19.526 1.05 1.05 0 0 1-.342.532l.02.029a.5.5 0 0 0-.26.101c.085-.366.185-.752.327-1.182m-.349 1.277.04.017.001-.001a.18.18 0 0 1 .113-.085 1.3 1.3 0 0 0 .34.627l-.031.04a1.35 1.35 0 0 0-.39.776 1 1 0 0 0 .03.182c-.033.016-.064.038-.098.053a1.3 1.3 0 0 0-.295.17 16 16 0 0 1 .29-1.78Zm-.505-3.668c.141-.116.277-.24.416-.358q-.081.345-.167.688a1 1 0 0 1-.187.065.44.44 0 0 1-.062-.395m-.225.194q.063-.054.124-.107a.52.52 0 0 0 .074.331l-.028.008a2.7 2.7 0 0 0-.583.179c.14-.135.27-.28.413-.411m.188.324c.023-.005.033-.011.054-.016q.031.049.058.095l-.05.048c.001 0 .078.099-.16.35a.9.9 0 0 1-.596.186c-.033 0-.066.009-.099.012a1.2 1.2 0 0 1-.085-.25c.048-.165.385-.328.878-.425m-.96.444a1 1 0 0 0 .043.246 1.5 1.5 0 0 0-.4.116c-.013.005-.02.017-.03.023.125-.132.258-.256.387-.385m-.313.445a1.5 1.5 0 0 1 .398-.11 1 1 0 0 0 .074.16 1.4 1.4 0 0 1 .15.418 2 2 0 0 0-.164-.022c-.214-.013-.343.262-.408.436a1.02 1.02 0 0 1-.216-.677.3.3 0 0 1 .166-.205m-.528.433c.11-.123.215-.247.327-.367a.4.4 0 0 0-.057.118 1.18 1.18 0 0 0 .268.809l-.004.012.017.007c.038.06.072.117.12.183q.109.15.213.288c-.034-.035-.064-.068-.104-.104a1.5 1.5 0 0 0-.473-.33.5.5 0 0 1-.21-.152.39.39 0 0 1-.088-.46Zm-.25.299q.077-.094.155-.186a.47.47 0 0 0 .123.416.6.6 0 0 0 .144.102l-.013.009-.005-.014c0 .001-.013.161-.25.328-.026-.038-.061-.07-.085-.11a.71.71 0 0 1-.07-.545Zm-.104.123a.8.8 0 0 0 .091.47c.022.036.055.065.079.1a1.3 1.3 0 0 1-.45.124 1.1 1.1 0 0 0-.383.095c.21-.272.44-.527.663-.79Zm-.737.879.022.032a1.1 1.1 0 0 1 .448-.123 1.4 1.4 0 0 0 .501-.135 2 2 0 0 0 .181.23.9.9 0 0 1 .19.243l.021.055a1.6 1.6 0 0 0-.588.026h-.006v.001a1.6 1.6 0 0 0-.256.062 1 1 0 0 0-.277.283c-.124.174-.23.324-.737.372a2 2 0 0 1-.404.012c.277-.313.592-.662.905-1.058M4.1 33.619l.007.002v-.001zq.136-.17.299-.356a1 1 0 0 0 .11.006q.196-.004.39-.024a.9.9 0 0 0 .537-.152 1.2 1.2 0 0 1-.318.38c-.212.189-.28.177-.407.154a1 1 0 0 0-.364-.004.6.6 0 0 0-.233.105 1 1 0 0 1-.008-.107zm-.082.101c.002.018.009.044.013.066a2 2 0 0 0-.188.184q.077-.12.175-.25m-.387.757a1 1 0 0 1 .03-.108 2.4 2.4 0 0 1 .39-.478 1.6 1.6 0 0 0 .335.528 3 3 0 0 1-.395.235 3 3 0 0 0-.379.223 2.3 2.3 0 0 1 .019-.4m-.014.505a3 3 0 0 1 .416-.244c.07-.031.129-.081.196-.117l.003.025a.5.5 0 0 1 .53.332.1.1 0 0 1-.006.092c-.065.107-.346.158-.617.207-.022.002-.043.01-.066.013l-.014-.007-.005.01a2 2 0 0 0-.48.135.9.9 0 0 0 .043-.446m-.242.67a1 1 0 0 0 .08-.071 2 2 0 0 1 .559-.183.53.53 0 0 0 .023.495c.058.073.135.176.214.279a2 2 0 0 0-.185.088c-.197.123-.383.239-.525.197a.6.6 0 0 1-.14-.085 1 1 0 0 0-.153-.125 1.9 1.9 0 0 1-.269-.374 2.3 2.3 0 0 0 .396-.221m-.513.62c-.017-.192-.003-.282.042-.34a2 2 0 0 0 .249.348l-.004.007c.013.007.02.019.033.026a1 1 0 0 0 .172.139 1.1 1.1 0 0 1 .275.373.15.15 0 0 1-.007.128c-.046.059-.2.057-.363.055a.99.99 0 0 0-.7.173 1.9 1.9 0 0 0 .303-.91Zm-.573 2.09-.044.01a.2.2 0 0 1-.024-.04 1 1 0 0 0-.206-.246c.138-.216.286-.45.421-.684a1.21 1.21 0 0 0 .08.935.8.8 0 0 0-.227.026Zm1.624.233c-.01.02-.014.04-.025.06l.006.004q-.003.013-.007.026h-.019c-.537-.02-.62-.072-.735-.144a1.3 1.3 0 0 0-.333-.155 1 1 0 0 0-.175-.037 1.06 1.06 0 0 1-.063-1.044c.143-.212.436-.207.696-.204.06 0 .11-.003.162-.005a.58.58 0 0 0-.143.493c.05.154.228.256.4.354.151.086.307.175.317.278a1 1 0 0 1-.012.136 1.2 1.2 0 0 0-.07.238Zm.652.064a2.4 2.4 0 0 1-.582.022q.005-.019.011-.038a.8.8 0 0 0 .08-.273 1.2 1.2 0 0 1 .266-.365 3 3 0 0 1 .248-.181.5.5 0 0 0 .293-.484c.027-.526-.024-.595-.13-.691a1 1 0 0 1-.064-.063c-.065-.08-.179-.23-.292-.38a1.5 1.5 0 0 1 .2-.095 1.15 1.15 0 0 0 .534-.223 1 1 0 0 0 .192.134c.248.067.361.139.333.365-.012.098-.089.146-.222.222a.86.86 0 0 0-.449.476.526.526 0 0 0 .18.646 1.5 1.5 0 0 0-.256.284 1.2 1.2 0 0 0-.165.626c-.059.008-.119.006-.177.018m.567-.058a3 3 0 0 0-.296.03 1.13 1.13 0 0 1 .153-.57 1.5 1.5 0 0 1 .237-.26 2 2 0 0 1 .23.266.9.9 0 0 1 .205.552c-.176-.005-.352-.021-.53-.018Zm.977.034c-.119-.008-.238-.007-.357-.012a.96.96 0 0 0-.218-.608 2 2 0 0 0-.231-.267 1.5 1.5 0 0 1 .206-.14 1.3 1.3 0 0 0 .375-.297 1.2 1.2 0 0 0 .167-.516.6.6 0 0 0 .104.07 2.34 2.34 0 0 0 .698.803c-.012.006-.02.016-.033.022-.44.179-.66.394-.71.696a.7.7 0 0 0 0 .25Zm1.76.062c-.133-.003-.265-.013-.398-.011-.442.009-.835-.02-1.215-.045-.016-.002-.031 0-.047-.002a.4.4 0 0 1-.006-.238c.032-.19.134-.413.652-.624a1 1 0 0 0 .075-.05 2 2 0 0 0 .222.168c.62.274.747.459.747.652 0 .104-.02.138-.03.15m.079.002a.3.3 0 0 0 .045-.152c0-.28-.218-.48-.803-.738-.066-.037-.116-.095-.179-.137a.72.72 0 0 0 .262-.676c.052.004.1.01.155.012l.046-.002-.023.01a1.24 1.24 0 0 0 .875.728.7.7 0 0 1 .14.04l-.053.013c-.134.015-.26.029-.339.326a.64.64 0 0 0 .064.582q-.094-.003-.19-.006m.312.01c-.054-.045-.192-.195-.095-.562.061-.235.135-.243.258-.257a.6.6 0 0 0 .18-.045 1 1 0 0 1 .099.067 1.64 1.64 0 0 0-.073.833c-.123-.012-.246-.029-.369-.037Zm.458.046-.011-.032a1 1 0 0 1 .054-.754.7.7 0 0 1 .19.36 1.7 1.7 0 0 1 .048.458q-.14-.018-.28-.032Zm.442.05-.057-.007a1.4 1.4 0 0 0-.284-.906.97.97 0 0 1 .386-.348 1.11 1.11 0 0 1 .303.942l.02.008a.86.86 0 0 0-.275.322Zm.543.068-.35-.044a.8.8 0 0 1 .308-.324.83.83 0 0 0 .431-.507l.047-.103a.98.98 0 0 0 .055-.71 1.33 1.33 0 0 1 .232-.916c.006.009.005.02.011.03a1.2 1.2 0 0 1 .157.752 3 3 0 0 1-.3.66.96.96 0 0 0-.12.99q.08.101.16.196c.034.038.06.084.092.125a2.6 2.6 0 0 0-.723-.15Zm1.141.244c-.014-.002-.03.004-.044.002a1.5 1.5 0 0 1-.23-.06 2 2 0 0 0-.164-.222q-.079-.095-.158-.194a.87.87 0 0 1 .126-.881 3 3 0 0 0 .222-.489c.047.026.583.32.595.703a1.5 1.5 0 0 1-.2.692 1.5 1.5 0 0 0-.136.34 1 1 0 0 0-.01.109Zm.49-.023a1.5 1.5 0 0 1-.397.018 1 1 0 0 1 .01-.085 1.5 1.5 0 0 1 .13-.318 1.54 1.54 0 0 0 .21-.736c-.017-.441-.6-.758-.652-.786.014-.039.039-.073.051-.112a1 1 0 0 0-.004-.146 2 2 0 0 0 .4.402.6.6 0 0 0 .325.126.3.3 0 0 0 .058-.012 3 3 0 0 0-.156.35.32.32 0 0 0 .008.258 1.06 1.06 0 0 0 .599.397 2.6 2.6 0 0 0 .07.616 2 2 0 0 0-.652.028m1.57.025a1.3 1.3 0 0 0-.062.394c-.016-.018-.042-.026-.054-.047a.9.9 0 0 0-.656-.39c-.016-.002-.033 0-.05-.003a2.5 2.5 0 0 1-.073-.59l.135.05a1.8 1.8 0 0 1 .472.206 3 3 0 0 1 .323.312c-.01.024-.028.043-.036.068Zm.814.492.015.017a1.5 1.5 0 0 0-.424 0 .7.7 0 0 1-.342-.005c-.012-.005-.017-.02-.029-.025a1 1 0 0 1 .056-.454.94.94 0 0 1 .386-.489c.147-.114.285-.22.297-.41.014-.222-.138-.284-.272-.338-.109-.045-.213-.087-.257-.207a.45.45 0 0 1 .086-.462 2 2 0 0 0 .09-.153.74.74 0 0 0 .082-.318.7.7 0 0 0 .281.3.32.32 0 0 1 .19.295 1 1 0 0 1-.08.438 1.1 1.1 0 0 0-.086.413.6.6 0 0 0 .234.434.5.5 0 0 1 .19.304c.016.276-.412.656-.417.66m.469.158a1 1 0 0 0-.325-.141c-.009-.002-.017.001-.026 0 .117-.112.409-.417.392-.683a.56.56 0 0 0-.217-.365.5.5 0 0 1-.205-.367 1 1 0 0 1 .08-.382 1.1 1.1 0 0 0 .06-.33 2.7 2.7 0 0 0 .476 1.025.6.6 0 0 0-.182.35 5 5 0 0 0-.053.893m.372.303a3 3 0 0 0-.283-.237 5 5 0 0 1 .056-.941c.083-.42.355-.402.367-.402l.002-.019a.5.5 0 0 1 .445.218 1.5 1.5 0 0 1 .169.915.29.29 0 0 0-.04.233.4.4 0 0 1-.138.165.9.9 0 0 1-.578.068m.741.778-.157-.17a16 16 0 0 0-.47-.496c.021 0 .041.008.062.008a1 1 0 0 0 .444-.103.5.5 0 0 0 .136-.123 1 1 0 0 0 .033.105l.06.13c.115.25.136.299.095.376l.024.012a1.6 1.6 0 0 1-.227.26Zm.75.777a21 21 0 0 1-.554-.565l-.132-.143a2 2 0 0 0 .317-.38 1.3 1.3 0 0 0 .099-.183.94.94 0 0 0 .123.424 1.3 1.3 0 0 1 .162.503 1.2 1.2 0 0 1-.015.344m-.062-.887c-.109-.227-.195-.406-.033-.574a3 3 0 0 1 .283-.24q.115-.089.218-.184a.45.45 0 0 0 .047.315.55.55 0 0 1 .055.47.8.8 0 0 1-.233.283.39.39 0 0 0-.182.393 1.4 1.4 0 0 0-.155-.463m.635 1.442a48 48 0 0 1-.475-.459 2 2 0 0 0 .01-.444q-.002-.015-.006-.028a1 1 0 0 0 .286.42c.134.142.261.276.224.392Zm1.461 1.359-.045-.041a104 104 0 0 1-1.34-1.246l.052-.162c.055-.17-.09-.323-.245-.485a.94.94 0 0 1-.274-.4c-.03-.163.043-.228.155-.326a.9.9 0 0 0 .256-.313.64.64 0 0 0-.054-.55c-.058-.133-.09-.218-.046-.281a1 1 0 0 1 .466-.249 1.2 1.2 0 0 1-.026.236l.057.04a.84.84 0 0 0 .4.542c.012.019.323.567.114.815a1.26 1.26 0 0 0 .035 1.419c.296.316.59.676.516.94-.004.02-.015.04-.021.06Zm.084.057.028-.093c.086-.308-.208-.677-.538-1.03a1.165 1.165 0 0 1-.032-1.293c.172-.205.07-.535-.02-.742a2 2 0 0 1 .192.166l.024.028.004-.004c.044.043.098.075.138.12l.097.107c.244.264.264.366.264.366l.014-.001a1.1 1.1 0 0 0 .273.608l.002.006c.027.05.04.107.064.159-.032.037-.057.08-.09.116a1.3 1.3 0 0 0-.357.629 3 3 0 0 0 .045.924q-.055-.033-.108-.066m.212.13a3 3 0 0 1-.058-.966 1.2 1.2 0 0 1 .33-.582c.025-.026.042-.058.066-.084a2.6 2.6 0 0 1 .201.863 1.9 1.9 0 0 1-.378.869q-.081-.049-.161-.1m.24.148a1.94 1.94 0 0 0 .372-.839l.003.004a2.6 2.6 0 0 0 .533-.538 1.4 1.4 0 0 0 .165-.69 6 6 0 0 0 .6.652l.001.026a2 2 0 0 0 .23.653l.015.027c.17.308.222.4.03.752-.01.017-.008.037-.016.054a2 2 0 0 0-.203-.89 1.6 1.6 0 0 0-.77-.687l-.033.088a1.5 1.5 0 0 1 .342.218 1.3 1.3 0 0 0-.313.683 2.6 2.6 0 0 0 .141 1.012 7.3 7.3 0 0 1-1.097-.525m1.203.56a2.6 2.6 0 0 1-.155-1.031 1.2 1.2 0 0 1 .296-.648 1.5 1.5 0 0 1 .303.374 1.97 1.97 0 0 1 .202.98l.043.003a.85.85 0 0 0 .004.537 7 7 0 0 1-.693-.214Zm1.036.288c-.096-.02-.19-.037-.285-.06l.033-.016a.8.8 0 0 1 .044-.68.66.66 0 0 0 .114-.52 1 1 0 0 0 .098.153.86.86 0 0 1 .06 1.035Zm.337.072c-.08-.013-.157-.036-.236-.05l.04-.054a.94.94 0 0 0 .156-.522 2.1 2.1 0 0 0 .354.664c-.105-.015-.21-.017-.314-.038m.44.054a2.1 2.1 0 0 1-.428-.798.49.49 0 0 1 .152-.406 1 1 0 0 0 .258-.744 1.1 1.1 0 0 0-.271-.782.8.8 0 0 0 .256.05.9.9 0 0 0 .223-.03 1 1 0 0 0 .133-.058 1.7 1.7 0 0 0 .422.395.83.83 0 0 0-.75.548.57.57 0 0 0 .15.598.74.74 0 0 1 .208.58 1.4 1.4 0 0 1-.177.668q-.087-.009-.176-.021m.278.034a1.6 1.6 0 0 0 .17-.674.8.8 0 0 0-.057-.369 1.6 1.6 0 0 0 .423-.378.33.33 0 0 1 .079.346c-.023.092-.096.128-.181.169l-.017.005a.31.31 0 0 0-.197.395.79.79 0 0 0 .445.5 5 5 0 0 1-.665.006m1.847-.203a5.2 5.2 0 0 1-.978.189c-.114-.04-.49-.195-.557-.512-.042-.196.044-.238.164-.296a.36.36 0 0 0 .23-.23.4.4 0 0 0 .004-.112l.011.019a4 4 0 0 0 .768-.592 1.1 1.1 0 0 1 .324.365 1.53 1.53 0 0 1 .034 1.169m.76-.29a5 5 0 0 1-.646.246 1.6 1.6 0 0 0-.069-1.176 1.2 1.2 0 0 0-.353-.395l-.005-.004a.8.8 0 0 0 .102-.679 1 1 0 0 0 .1-.074l-.006-.005a8 8 0 0 0 .359-.011c.025-.004.05 0 .074-.001a.97.97 0 0 0 .223.51 1 1 0 0 1 .142.482.74.74 0 0 0 .317.639.8.8 0 0 1 .243.183c-.175.108-.34.206-.48.285Zm.285-.55c-.215-.122-.242-.34-.27-.57a1.1 1.1 0 0 0-.16-.523.9.9 0 0 1-.204-.458.9.9 0 0 1 .319.062l.01-.027a2.3 2.3 0 0 0 .39.047c.317.02.567.036.662.243.194.418-.222 1.052-.226 1.058l.015.01a2.4 2.4 0 0 1-.28.36.9.9 0 0 0-.256-.202m.51.066a2.46 2.46 0 0 0 .502-1.512.92.92 0 0 0-.717-.797q-.278-.178-.281-.342c-.002-.174.226-.352.449-.502.208-.142.315-.268.33-.382a.45.45 0 0 1 .278.234 1.6 1.6 0 0 1 .011.71 4.4 4.4 0 0 0-.038.958.94.94 0 0 0 .619.88c-.354.236-.76.503-1.154.753Zm1.356-.888-.112.074a.844.844 0 0 1-.616-.826 4.4 4.4 0 0 1 .037-.94 1.6 1.6 0 0 0-.016-.753.44.44 0 0 0-.195-.225.8.8 0 0 0 .2.04v-.001a2.9 2.9 0 0 0 .842-.166c.018.072.02.147.041.219a1.4 1.4 0 0 0 .087.17 3 3 0 0 0-.444.367 1.16 1.16 0 0 0-.41.934 2.17 2.17 0 0 0 .59 1.104Zm.409-.391.032.097-.36.24a2.1 2.1 0 0 1-.574-1.067.82.82 0 0 1 .15-.552.65.65 0 0 1 .631.329.97.97 0 0 1 .165.69.4.4 0 0 0-.044.263m.433-.077a1.3 1.3 0 0 0-.197.045c-.023.013-.08.05-.122.077l-.025-.075a.3.3 0 0 1 .031-.18l.015.004c.002-.011-.002-.022 0-.033a3 3 0 0 1 .108-.221 1.6 1.6 0 0 0 .245-.696.8.8 0 0 0-.077-.262 1.3 1.3 0 0 0 .216.156c.036.02.062.054.096.077a2 2 0 0 0-.288.885c-.005.103-.005.17-.002.223m.098-.023a1.3 1.3 0 0 1-.002-.196 1.9 1.9 0 0 1 .267-.83 2 2 0 0 1 .283.228l.026.032a1.1 1.1 0 0 0 0 .575 1.5 1.5 0 0 0 .181.347 1.26 1.26 0 0 0-.755-.156m1.007.295a1.4 1.4 0 0 1-.342-.51 1 1 0 0 1-.014-.457c.44.538.48.87.465 1.008-.036-.015-.074-.024-.11-.04Zm.2.074c.026-.158-.004-.537-.526-1.153a1 1 0 0 1 .22-.382l.01-.015a4 4 0 0 1 .386.259 5 5 0 0 1 .817.645 2 2 0 0 1-.304.314c-.175.153-.322.283-.343.428-.09-.025-.174-.063-.26-.096m1.317.272a7 7 0 0 0-.406-.062 3 3 0 0 1-.554-.088c.008-.11.118-.218.308-.384a2 2 0 0 0 .337-.35l.034-.003c0-.005-.01-.015-.012-.02a2 2 0 0 0 .284-.478.59.59 0 0 0 .307.494.18.18 0 0 1 .084.123 1.45 1.45 0 0 1-.285.8 1 1 0 0 0-.097-.032m.618.555a1 1 0 0 0-.38-.47 2.9 2.9 0 0 0 .703-1.138.74.74 0 0 0-.021-.709 3.4 3.4 0 0 0 .996.873q.017.026.032.052c-.423.521-.83 1.055-1.208 1.609zm2.343 1.403-.236-.186a1.7 1.7 0 0 0-.74-.416 2 2 0 0 0-.3-.041.98.98 0 0 1-.864-.414 24 24 0 0 1 1.206-1.61c.021.03.036.064.058.094.274.357.164.469.014.624a.49.49 0 0 0-.164.586A4.8 4.8 0 0 0 33.054 45c.07.065.128.143.192.215a1 1 0 0 1-.148-.088Zm1.194.606c-.04-.037-.068-.064-.123-.111a1.2 1.2 0 0 0-.553-.264c-.024-.005-.046-.016-.07-.022a3.5 3.5 0 0 0-.391-.435 4.8 4.8 0 0 1-.951-1.188.32.32 0 0 1-.008-.256 1.94 1.94 0 0 0 .803.555 3.4 3.4 0 0 1 .908.454l.018-.024c.028.033.051.07.08.103a1.25 1.25 0 0 1 .287 1.188m.63.42c-.026-.011-.055-.017-.081-.03a1.2 1.2 0 0 1-.436-.29l-.036-.032a1.1 1.1 0 0 0 .072-.332 1.45 1.45 0 0 0-.364-.984 9 9 0 0 1-.71-.912l-.187-.27c-.342-.49-.26-.705-.229-.758a.3.3 0 0 0 .131-.094.26.26 0 0 1 .22-.098c.25 0 .463.39.472.407a.95.95 0 0 0-.026.546 1.04 1.04 0 0 0 .497.562 1.05 1.05 0 0 1 .467.494 2.8 2.8 0 0 1 .133.786l.078.001a3 3 0 0 0 0 1.005Zm.012-1.06a2.8 2.8 0 0 0-.132-.76 1.13 1.13 0 0 0-.503-.542c-.21-.147-.409-.286-.46-.506a.88.88 0 0 1 .08-.651 2.8 2.8 0 0 0 .441.458 2.3 2.3 0 0 0 1.053.41l.02.003.005-.022a1.6 1.6 0 0 0 .147.509l.067-.037a2 2 0 0 0-.626.666c-.02.058-.02.121-.035.18h-.001l-.047.003c.005.031.022.058.03.089a3 3 0 0 0-.04.2Zm1.012 1.33q-.005-.002-.011-.002a3.2 3.2 0 0 1-.917-.232 3 3 0 0 1 .015-1.117 1 1 0 0 0 .24.334 1.7 1.7 0 0 0 .568.388l.004-.014a1.5 1.5 0 0 0 .135.408l.035-.018a.65.65 0 0 0-.069.254Zm2.147 1.08a.61.61 0 0 0-.44-.383 1.7 1.7 0 0 0-.588-.084.9.9 0 0 1-.505-.112.53.53 0 0 1-.252-.264.36.36 0 0 0-.267-.212.9.9 0 0 1 .264-.557 3.6 3.6 0 0 1 1.606.92 2.8 2.8 0 0 1 .416.97.58.58 0 0 1-.234-.277Zm1.23.435a1.5 1.5 0 0 0-.476-.005.58.58 0 0 1-.404-.082 2.8 2.8 0 0 0-.455-1.094c-.044-.045-.094-.083-.14-.125a.86.86 0 0 1 .447-.466 3 3 0 0 1 .737-.181l-.006-.067.006-.04a5.9 5.9 0 0 0 .362 2.07Zm.907.196a2 2 0 0 1-.284-.058c-.114-.033-.163-.051-.193-.062a.8.8 0 0 0-.194-.04l-.007-.002a5.85 5.85 0 0 1-.382-2.193 7 7 0 0 1 .188-1.17 4 4 0 0 1 .276-.428 1.8 1.8 0 0 1 .833-.552c.055-.023.107-.053.162-.078a3.9 3.9 0 0 1 .067.965l-.003.112a.94.94 0 0 0-.326.365 1.6 1.6 0 0 0-.124.622.69.69 0 0 1-.202.548c-.379.379-.476.514-.205 1.1a6 6 0 0 0 .584.923c-.064-.016-.125-.04-.19-.052m2.185 1.19a4.07 4.07 0 0 0-1.774-1.078 5.8 5.8 0 0 1-.677-1.041c-.156-.337-.168-.487-.074-.644a1.15 1.15 0 0 0 1.076.537 2.3 2.3 0 0 1 1.282.35 4.7 4.7 0 0 1 .23 1.935c-.02-.021-.044-.038-.063-.06Zm.04-1.726.017.013-.101-.24-.004-.006a4.8 4.8 0 0 0-.622-1.222l.012.002.002-.02a1.6 1.6 0 0 1 .328-.67 1.9 1.9 0 0 0 .675 1.226 6 6 0 0 0 .851.682 3.4 3.4 0 0 1-1.048.786 5 5 0 0 0-.11-.551m1.27-.145.006.005a1.5 1.5 0 0 1 .49.755 2.74 2.74 0 0 0-1.085.48 1.8 1.8 0 0 0-.508.423 5 5 0 0 0-.039-.82 3.5 3.5 0 0 0 1.136-.843m-.638 2.495a6 6 0 0 1-.47-.436l.047-.041a.14.14 0 0 1-.015-.096c.014-.091.105-.284.56-.56a2.8 2.8 0 0 1 1.04-.469 1.5 1.5 0 0 1 .03.212 8.2 8.2 0 0 1-.514 1.917 36 36 0 0 1-.678-.527m.794.614.014-.033a8 8 0 0 0 .525-1.966 1.62 1.62 0 0 0-.606-1.22 4 4 0 0 0 .227-.3l.473-.443a1.2 1.2 0 0 0 .436-.761 6 6 0 0 0 .496.759c.306.4.508.666.378 1.006l-.047.123a3.7 3.7 0 0 1-.803 1.257l-.187.244a3.45 3.45 0 0 0-.787 1.42 1 1 0 0 1-.119-.086m.678.179a.56.56 0 0 1-.426-.008c-.002-.096.043-.48.766-1.42l.187-.243a3.8 3.8 0 0 0 .455-.574 3.3 3.3 0 0 1 .964.316.74.74 0 0 1 .274.212 3 3 0 0 1-.306.016c-.86 0-1.533 1.415-1.643 1.66-.09.014-.182.02-.271.04Zm2.027.287a.77.77 0 0 1-.471-.019.8.8 0 0 1-.394-.212c-.111-.109-.194-.17-.598-.142-.042.003-.082.015-.123.019a4.6 4.6 0 0 1 .703-1.06 1.05 1.05 0 0 0 .403.595 2 2 0 0 0 .488.152 5 5 0 0 0-.008.667m.01-.812a2 2 0 0 1-.427-.133 1.06 1.06 0 0 1-.37-.554.1.1 0 0 1-.003.022l-.022-.008a1.06 1.06 0 0 1 .699-.362q.15-.001.274-.013a.58.58 0 0 0 .075.508l.01.006c-.088.047-.199.162-.236.489-.002.015.001.03 0 .045m.797.468a3 3 0 0 0-.525.233 1 1 0 0 1-.14.055 5 5 0 0 1 .01-.785c.044-.401.2-.401.2-.401l.002-.032a.4.4 0 0 0 .243.052.67.67 0 0 1 .592.276c.231.275.384.451.48.56a3 3 0 0 0-.862.042m1.079-.01c-.019-.02-.195-.215-.588-.683a.8.8 0 0 0-.699-.326c-.128-.002-.197-.006-.253-.076a.44.44 0 0 1-.048-.438 1.03 1.03 0 0 0 .655-.271 1.65 1.65 0 0 1 .671.666 4.2 4.2 0 0 1 .28 1.131Zm-.137-1.192c-.014-.028-.036-.046-.05-.072l.029-.007a1.85 1.85 0 0 1-.016-.86 4 4 0 0 1 .333-.605 5 5 0 0 0 .453-.127 3.2 3.2 0 0 1-.033 1.27 10.3 10.3 0 0 0-.425 1.554 4.3 4.3 0 0 0-.29-1.153Zm1.4 1.072a.23.23 0 0 0-.158.151c-.017.044-.03.08-.22.09a2.8 2.8 0 0 1-.568-.074q-.018-.003-.036-.005a10.4 10.4 0 0 1 .428-1.58 3.5 3.5 0 0 0 .075-1.047l.011.003h.001c.001-.007.048-.158.49-.583.111-.106.23-.215.345-.32.044-.034.08-.078.122-.114l.042.035a6 6 0 0 1 .501.453 3 3 0 0 1-.32.23c-.662.39-.793.568-.927 1.022a1.5 1.5 0 0 0 .02.867.4.4 0 0 0-.002.06l.016-.005a1.5 1.5 0 0 0 .142.289.55.55 0 0 1 .037.528Zm1.047-2.326a.86.86 0 0 1-.646.76 1.04 1.04 0 0 0-.516.435 1.34 1.34 0 0 1 .037-.568c.123-.418.223-.565.863-.94.083-.048.153-.111.23-.166a.64.64 0 0 1 .032.479m.958 1.989a3 3 0 0 0-.276.114 1.14 1.14 0 0 1-.561.114 8 8 0 0 0-1.025.086.67.67 0 0 0-.056-.572 1.3 1.3 0 0 1-.141-.299.75.75 0 0 1 .51-.542.985.985 0 0 0 .729-.86.7.7 0 0 0 .029-.266l.02.055a1.6 1.6 0 0 1 .066.64.72.72 0 0 0 .11.517 12 12 0 0 0 .8.976 2 2 0 0 0-.205.037m2.41-.675s-.014.033-.134.065a7 7 0 0 1-.363.083c-.233.049-.374.079-.442.193a.5.5 0 0 0-.047.145c-.014.066-.028.134-.07.16a.26.26 0 0 1-.18.003 1.9 1.9 0 0 0-.81-.04c-.09-.099-.169-.208-.256-.31.262-.112.97-.44 1.116-.806a.26.26 0 0 0 .005-.24c-.06-.093-.193-.098-.322-.103-.142-.006-.243-.014-.265-.076-.04-.115.022-.194.206-.405q.02-.026.04-.052a1.04 1.04 0 0 0 .56.262 2.5 2.5 0 0 1 .742.328.36.36 0 0 0-.027.27 1.2 1.2 0 0 0 .16.334c.04.064.099.16.088.189Zm.575-1.672c.048.016.107.037.115.06a.53.53 0 0 1 .014.41.22.22 0 0 1-.171.095 1.3 1.3 0 0 0-.662.204 3 3 0 0 0-.311-.175 1.62 1.62 0 0 0-.18-.998 2 2 0 0 0-.222-.219 4.3 4.3 0 0 0 .569-.96q.032.03.065.06a1.1 1.1 0 0 1 .412.494 1.7 1.7 0 0 1 .15.541.47.47 0 0 0-.03.3.36.36 0 0 0 .25.188Zm.22-2.224a3 3 0 0 1 .029.299c-.134.08-.111.287-.078.573q.02.165.032.332a1 1 0 0 1 0 .1h-.001a.42.42 0 0 0-.316.227 1.7 1.7 0 0 0-.126-.39 1.24 1.24 0 0 0-.454-.55c-.032-.025-.06-.056-.092-.083.018-.045.044-.086.06-.131a2.6 2.6 0 0 0 .098-1.052 4.3 4.3 0 0 0 .848.675m-.07-1.791-.046.015c-.002-.094-.015-.188-.013-.282a5.6 5.6 0 0 0-1.181-1.962.79.79 0 0 1 .833-.285c.004.01.014.016.017.026l.03-.004a.8.8 0 0 1 .224.108 4 4 0 0 1 .684.417q.034.179.072.357c.118.555.203.955-.07 1.21a1.9 1.9 0 0 1-.55.4\"/>q</svg>";

},{}],"iayLl":[function(require,module,exports,__globalThis) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"148.24\" height=\"120.48\"><path d=\"M16.03 113.92c5.5 0 9.97 1.01 9.97 2.26s-4.46 2.26-9.97 2.26-9.97-1.01-9.97-2.26 4.46-2.26 9.97-2.26m84.07-3.7c4.74 0 8.59.87 8.59 1.95s-3.85 1.95-8.59 1.95-8.59-.87-8.59-1.95 3.85-1.95 8.59-1.95m28.54 6.36c4.74 0 8.59.87 8.59 1.95s-3.85 1.95-8.59 1.95-8.59-.87-8.59-1.95 3.85-1.95 8.59-1.95\" opacity=\".25\"/><path fill=\"#fff\" d=\"M22.14 28.36 25 21.58l8.32-7.37-10.01.71.11-.92-3.71-1.27-.24-1.18h-2.84l.12-3.81L5.37 9.1l3.8 8.17-3.56-.99-3.12 7.97-2.19.06 1.5 1.94-.43 1.6h2.48L9.6 33.6l2.38 5.23 1.5-.06-.8 77.34v.14c.91.36 1.9.54 2.88.51 1.07 0 2.13-.17 3.14-.51l.75-73.46 2.74-8.95.7.78 8.51 3.2-5.11-8.33-4.15-1.12ZM141.08.3l-14.09 1.47.2 3.67-4.69-2.61 1 7.44-10.13.93.19.27-5.94.48 9.57 11.09 1.55-.51-5.28 8.36.7.81 6.16-.83 3.4-4 1.39 91.14c1.1.5 2.3.75 3.51.73 1.22.02 2.42-.2 3.56-.63v-.14l-1.49-83.67h2.02l4.14-8.28 1.24.05.82-.99 1.03.72.74-.85-.67-.85 7.92-7.73-15.16.86zm-25.65 25.12-10.39.73-3.22-1.53-.21-4.88-2.41.08v-3.28l-4.76-2.05.89 5.96-7.34.42 3.89 7.65-3.09 5.7-5.23.62 8.6 9.01.64-.2 1.94 3.76h1.65l.87 64.36v.13c.89.34 1.84.49 2.79.44.94.05 1.89-.1 2.77-.44l-1.04-71.77h1.74l3.04-6.57h.64l1.29-1.37 1.37 1 .64-.63-1.04-1.08 5.98-6.07Z\"/><path fill=\"#65677f\" d=\"m109.87 31.49 5.78-5.86c.09-.09.11-.22.06-.34a.3.3 0 0 0-.27-.17l-10.33.73-2.99-1.42-.2-4.7c0-.16-.14-.29-.3-.29l-2.11.07v-2.97c0-.12-.07-.23-.18-.28l-4.76-2.04s-.08-.02-.12-.02a.28.28 0 0 0-.18.06.28.28 0 0 0-.11.28l.84 5.63-7.01.4c-.1 0-.19.06-.24.15a.3.3 0 0 0 0 .29l3.82 7.51-2.94 5.42-5.08.6c-.11.01-.21.09-.25.2s-.01.23.07.31l8.61 9.02c.06.06.14.09.22.09.03 0 .06 0 .09-.01l.4-.12 1.83 3.53c.05.1.15.16.27.16h1.36l.87 64.2c0 .12.08.23.19.28.82.31 1.68.47 2.56.47h.66c.87 0 1.73-.16 2.54-.47.12-.04.19-.16.19-.28l-1.04-71.47h1.43c.12 0 .22-.07.27-.17l2.95-6.4h.45c.08 0 .16-.03.22-.09l1.11-1.18 1.15.84a.3.3 0 0 0 .18.06q.12 0 .21-.09l.64-.63a.29.29 0 0 0 0-.42l-.84-.87ZM106.82 33s-.07-.03-.11-.03l-9.11-.81-.04-.34 2.2-4.94h2.02c.17 0 .3-.13.3-.3v-1.2l2.78 1.32s.08.03.13.03l8.97-.63-5.1 5.18c-.11.12-.12.3 0 .42l.23.24-.45-.33a.31.31 0 0 0-.4.03L106.96 33h-.13Zm-5.31 6.57c-.08 0-.16.03-.21.09s-.09.13-.09.21l1.04 71.57c-.56.24-1.18.37-1.79.37-.12 0-.25 0-.38-.02h-.05c-.12 0-.24.01-.36.01-.62 0-1.25-.13-1.83-.37l-.87-64.3c0-.16-.14-.3-.3-.3H95.1l-1.83-3.54-2.65-5.88 2.87-.03c.11 0 .2-.06.26-.15l.9-1.53c.04-.07.05-.15.03-.23s-.07-.14-.14-.18l-.24-.14s-.1-.04-.15-.04c-.1 0-.2.05-.26.15l-.73 1.25-3.42.04c-.1 0-.2.05-.25.14s-.06.19-.02.28l2.74 6.08-7.43-7.79 4.23-.5c.1-.01.18-.07.23-.15l2.95-5.43 2.34 1.81 2.44 12.44c.03.14.15.24.29.24l1.17-.06c.17 0 .29-.15.29-.31v-.27a.43.43 0 0 0-.11-.21.32.32 0 0 0-.2-.08l-.68.03-2.66-13.58 1.52.06.08 1.43c0 .16.14.28.3.28h.01l-.28.62s-.03.1-.02.16l.12.96c.02.14.13.25.27.26l8.78.78-2.68 5.8h-1.65Zm-2.87-22.65v3.18c0 .08.03.16.09.22.06.05.13.08.21.08l2.13-.07.19 4.49c-.03.05-.05.1-.05.16V26h-1.82c-.12 0-.23.07-.27.18l-1.18 2.66-1.98-8.56s-.04-.08-.08-.12l-.7-4.73 3.47 1.49Zm-3.4 4.12 1.7 7.37-2.57-.1c-.09 0-.17.04-.23.1-.06.07-.08.16-.07.25l.2 1.04-1.88-1.45-3.48-6.84 6.32-.36Zm52.99-4.82a.3.3 0 0 0-.27-.18l-14.66.83L141.36.43c.05-.1.04-.21-.02-.3a.31.31 0 0 0-.25-.13c-.01 0-14.12 1.47-14.12 1.47-.16.02-.28.15-.27.31l.17 3.13-4.22-2.35s-.1-.04-.15-.04c-.06 0-.12.02-.17.05-.09.06-.14.18-.13.29l.96 7.13-9.82.9c-.11 0-.2.08-.25.17-.02.04-.03.09-.03.13l-5.47.44c-.11 0-.21.08-.25.19s-.02.22.05.31l9.57 11.09c.06.07.14.1.23.1.03 0 .06 0 .09-.01l.76-.25-4.83 7.65c-.07.11-.06.26.03.36l.7.81c.06.07.14.1.23.1.01 0 6.2-.83 6.2-.83.07 0 .14-.05.19-.1l2.88-3.39 1.38 90.34c0 .12.07.22.18.27 1.11.5 2.29.75 3.5.75h.26c1.21 0 2.41-.22 3.54-.65.12-.04.2-.16.19-.29l-1.48-83.5h1.71c.11 0 .22-.06.27-.17l4.05-8.11 1.06.04c.09 0 .17-.04.23-.11l.64-.78.81.56c.05.04.11.05.17.05.08 0 .17-.04.23-.1l.74-.85c.09-.11.1-.27 0-.38l-.5-.64 7.73-7.54c.09-.09.12-.22.06-.34Zm-8.77 7.62c-.11.11-.12.28-.03.4l.53.67-.09.11-.82-.57a.26.26 0 0 0-.17-.05c-.09 0-.17.04-.23.11l-.8.97-.94-.03v-.09a.293.293 0 0 0-.28-.32l-10.59-.64 1.75-6.32 4.35.04q.12 0 .21-.09c.09-.09.09-.13.09-.21v-.02l14.01-.79-7 6.84Zm-9.02 9.88c-.08 0-.16.03-.21.09a.3.3 0 0 0-.09.22l1.48 83.62c-.3.14-1.16.46-3 .46s-2.68-.38-2.93-.52l-1.32-86.27.81 6.98c.02.15.15.27.3.27l1.9-.05c.08 0 .16-.04.21-.09.05-.06.08-.13.08-.21v-.27a.315.315 0 0 0-.31-.29l-1.37.04-2.02-17.4s1.3.39 1.31.39l.08.4c.03.14.15.24.29.24h.06s.29-.06.3-.06l-1 3.61c-.02.09 0 .18.04.25s.14.12.23.12l11 .67-3.92 7.84h-1.94Zm-16.03-2.64-.22-.25 5.24-8.31.22-.33s.04-.05.05-.08l1.73-2.58 1.62.46.69 5.96-3.71 4.37-5.63.76Zm12.95-24.9s.1.04.15.04c.06 0 .11-.02.16-.05.09-.06.15-.16.14-.27l-.2-3.62L140.13.97l-7.98 16.26-4.78-.05a.31.31 0 0 0-.29.22l-.9 3.26-2.08-10.34-.87-6.44 4.13 2.29Zm-6.07 12.4s-.05-.01-.08-.01c-.1 0-.19.05-.25.13l-1.62 2.42-4.89-9.32s-.04-.06-.06-.08v-.04l8.94-.82 1.77 8.83-1.57-.47zm-7.65-6.54c0 .06 0 .12.03.17l5.1 9.72-1.37.45-8.58-9.95 4.83-.39Zm-80.3 1.86-9.67.68.07-.56a.304.304 0 0 0-.2-.32l-3.55-1.22-.2-1.01a.3.3 0 0 0-.29-.24h-2.54l.11-3.5a.29.29 0 0 0-.1-.23.32.32 0 0 0-.2-.08c-.01 0-11.42 1.36-11.42 1.36-.1.01-.18.07-.23.15s-.05.19 0 .27l3.53 7.58-2.93-.81s-.05-.01-.08-.01c-.12 0-.23.07-.28.19l-3.05 7.79L.32 24c-.11 0-.21.07-.26.17s-.04.22.03.31L1.5 26.3l-.39 1.46c-.02.09 0 .19.05.26.06.07.15.12.24.12h2.32l5.62 5.62 2.36 5.18c.05.11.16.18.27.18l1.2-.04-.8 77.16c0 .12.07.24.19.28.89.35 1.83.53 2.8.53h.24c1.09 0 2.16-.18 3.19-.53.12-.04.2-.15.2-.28l.74-73.37 2.58-8.44.35.38s.07.06.12.08l8.51 3.2s.07.02.11.02a.299.299 0 0 0 .25-.46l-5.11-8.33a.27.27 0 0 0-.18-.13l-3.82-1.03 2.7-6.4 8.27-7.33c.1-.09.13-.22.08-.34a.31.31 0 0 0-.28-.18Zm-10.1 20.22-.67-.74s-.02-.03-.03-.04l-2.08-2.26.49.04c.11 0 .22-.06.27-.17l.96-1.99 3.76 1.02 4.12 6.71-6.82-2.56Zm-1.56-.51-2.1 6.85v-9.13zm-5.54 82.51c-.17 0-.34 0-.54-.02-1.46 0-2.1-.21-2.32-.31l.8-77.31a.3.3 0 0 0-.09-.22.32.32 0 0 0-.21-.08l-1.41.05-2.25-4.93-.06-.09-.3-.3c.08-.09.11-.21.06-.33l-2.1-4.71 3.51-.02c.11 0 .21-.06.26-.16l1.6 6.55c.03.13.14.22.27.23l1.65.12c.16 0 .29-.12.3-.28l.02-.22a.34.34 0 0 0-.07-.22.28.28 0 0 0-.21-.1l-1.25-.09-3.75-15.37 2.4.41v.26c.01.16.15.29.31.29h.23c.08 0 .15-.04.21-.09.05-.06.08-.14.08-.21v-.1l.75.13-1.31 2.06s-.05.11-.04.17l.04 1.44c0 .15.13.28.28.29l9.53.65q.09 0 .18-.06l1.25-.9-2.43 5.77s-.02.06-.02.08l-.85 1.77-1.58-.13a.28.28 0 0 0-.2.08c-.06.06-.1.14-.1.22v10.34c0 .17.13.3.3.3h.22s.08 0 .12-.02l-.48 1.57s-.02.08-.02.1l-.74 73.02q-.975.36-2.01.36ZM2.34 25.99l-.9-1.16 1.24-.04c.12 0 .23-.08.27-.19l3-7.66 3.1.86 2.26 9.26s-.07-.02-.11-.02l-4.31.02c-.1 0-.2.05-.25.14-.01.02-.02.03-.03.05l-2.53.04s-.09-.03-.13-.03H2.1l.27-1.01c.02-.09 0-.19-.05-.26Zm4.34 2.07a.3.3 0 0 0 .18-.06l1.63 3.66-3.57-3.57zm15.67-5.29-8.85-.6-.02-.81L17 15.83c.09-.14.05-.33-.09-.41l-.18-.12s-.1-.05-.16-.05h-.06c-.08.02-.15.06-.19.13l-1.81 2.85-1.26-.21-.18-5.64 1.52.06c.16 0 .29-.13.3-.29v-.23a.3.3 0 0 0-.07-.22.32.32 0 0 0-.21-.1l-2.08-.08c-.08 0-.16.03-.21.09a.3.3 0 0 0-.09.22l.2 6.03-2.48-.42-3.69-7.92 9.93-1.19-.1 3.43c0 .08.03.16.08.22.06.06.13.09.22.09h2.66l.18.88c.02.1.1.19.2.23l3.42 1.18-.09.79c-.01.09.02.18.08.24s.14.09.22.09l8.67-.61-7.04 6.24-2.29 1.65Z\"/></svg>";

},{}],"1mMYX":[function(require,module,exports,__globalThis) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><path id=\"path\" d=\"M98.99 47.6 77.04 25.65a3.447 3.447 0 0 0-4.88-.08 3.447 3.447 0 0 0-.08 4.88l.08.08 16.06 16.06H3.45a3.45 3.45 0 0 0 0 6.9h84.78L72.17 69.55a3.465 3.465 0 0 0 .08 4.88 3.45 3.45 0 0 0 4.79 0l21.95-21.95a3.446 3.446 0 0 0 0-4.88\"/></svg>";

},{}],"6KLtd":[function(require,module,exports,__globalThis) {
var geojsonCoords = require("69d636fd63e2c381"), traverse = require("50dedaee7ca02e1a"), extent = require("52ae807f8f1303cf");
var geojsonTypesByDataAttributes = {
    features: [
        'FeatureCollection'
    ],
    coordinates: [
        'Point',
        'MultiPoint',
        'LineString',
        'MultiLineString',
        'Polygon',
        'MultiPolygon'
    ],
    geometry: [
        'Feature'
    ],
    geometries: [
        'GeometryCollection'
    ]
};
var dataAttributes = Object.keys(geojsonTypesByDataAttributes);
module.exports = function(_) {
    return getExtent(_).bbox();
};
module.exports.polygon = function(_) {
    return getExtent(_).polygon();
};
module.exports.bboxify = function(_) {
    return traverse(_).map(function(value) {
        if (!value) return;
        var isValid = dataAttributes.some(function(attribute) {
            if (value[attribute]) return geojsonTypesByDataAttributes[attribute].indexOf(value.type) !== -1;
            return false;
        });
        if (isValid) {
            value.bbox = getExtent(value).bbox();
            this.update(value);
        }
    });
};
function getExtent(_) {
    var ext = extent(), coords = geojsonCoords(_);
    for(var i = 0; i < coords.length; i++)ext.include(coords[i]);
    return ext;
}

},{"69d636fd63e2c381":"iPqfz","50dedaee7ca02e1a":"1WU4z","52ae807f8f1303cf":"fHD2n"}],"iPqfz":[function(require,module,exports,__globalThis) {
var geojsonNormalize = require("78aa560685fc8e3a"), geojsonFlatten = require("1db8f248b3ad8009"), flatten = require("d70b86954c6df6e");
if (!(geojsonFlatten instanceof Function)) geojsonFlatten = geojsonFlatten.default;
module.exports = function(_) {
    if (!_) return [];
    var normalized = geojsonFlatten(geojsonNormalize(_)), coordinates = [];
    normalized.features.forEach(function(feature) {
        if (!feature.geometry) return;
        coordinates = coordinates.concat(flatten(feature.geometry.coordinates));
    });
    return coordinates;
};

},{"78aa560685fc8e3a":"hisZf","1db8f248b3ad8009":"lcHjy","d70b86954c6df6e":"754oq"}],"hisZf":[function(require,module,exports,__globalThis) {
module.exports = normalize;
var types = {
    Point: 'geometry',
    MultiPoint: 'geometry',
    LineString: 'geometry',
    MultiLineString: 'geometry',
    Polygon: 'geometry',
    MultiPolygon: 'geometry',
    GeometryCollection: 'geometry',
    Feature: 'feature',
    FeatureCollection: 'featurecollection'
};
/**
 * Normalize a GeoJSON feature into a FeatureCollection.
 *
 * @param {object} gj geojson data
 * @returns {object} normalized geojson data
 */ function normalize(gj) {
    if (!gj || !gj.type) return null;
    var type = types[gj.type];
    if (!type) return null;
    if (type === 'geometry') return {
        type: 'FeatureCollection',
        features: [
            {
                type: 'Feature',
                properties: {},
                geometry: gj
            }
        ]
    };
    else if (type === 'feature') return {
        type: 'FeatureCollection',
        features: [
            gj
        ]
    };
    else if (type === 'featurecollection') return gj;
}

},{}],"lcHjy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>e);
function e(t) {
    switch(t && t.type || null){
        case "FeatureCollection":
            return t.features = t.features.reduce(function(t, r) {
                return t.concat(e(r));
            }, []), t;
        case "Feature":
            return t.geometry ? e(t.geometry).map(function(e) {
                var r = {
                    type: "Feature",
                    properties: JSON.parse(JSON.stringify(t.properties)),
                    geometry: e
                };
                return void 0 !== t.id && (r.id = t.id), r;
            }) : [
                t
            ];
        case "MultiPoint":
            return t.coordinates.map(function(e) {
                return {
                    type: "Point",
                    coordinates: e
                };
            });
        case "MultiPolygon":
            return t.coordinates.map(function(e) {
                return {
                    type: "Polygon",
                    coordinates: e
                };
            });
        case "MultiLineString":
            return t.coordinates.map(function(e) {
                return {
                    type: "LineString",
                    coordinates: e
                };
            });
        case "GeometryCollection":
            return t.geometries.map(e).reduce(function(e, t) {
                return e.concat(t);
            }, []);
        case "Point":
        case "Polygon":
        case "LineString":
            return [
                t
            ];
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"68Hdb"}],"754oq":[function(require,module,exports,__globalThis) {
module.exports = function flatten(list) {
    return _flatten(list);
    function _flatten(list) {
        if (Array.isArray(list) && list.length && typeof list[0] === 'number') return [
            list
        ];
        return list.reduce(function(acc, item) {
            if (Array.isArray(item) && Array.isArray(item[0])) return acc.concat(_flatten(item));
            else {
                acc.push(item);
                return acc;
            }
        }, []);
    }
};

},{}],"1WU4z":[function(require,module,exports,__globalThis) {
'use strict';
var whichTypedArray = require("2bb9b8dccd99ccca");
var taSlice = require("ef4c0bef2beabae");
var gopd = require("56889cb72c60f10f");
// TODO: use call-bind, is-date, is-regex, is-string, is-boolean-object, is-number-object
function toS(obj) {
    return Object.prototype.toString.call(obj);
}
function isDate(obj) {
    return toS(obj) === '[object Date]';
}
function isRegExp(obj) {
    return toS(obj) === '[object RegExp]';
}
function isError(obj) {
    return toS(obj) === '[object Error]';
}
function isBoolean(obj) {
    return toS(obj) === '[object Boolean]';
}
function isNumber(obj) {
    return toS(obj) === '[object Number]';
}
function isString(obj) {
    return toS(obj) === '[object String]';
}
// TODO: use isarray
var isArray = Array.isArray || function isArray(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
// TODO: use for-each?
function forEach(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
    return void 0;
}
// TODO: use object-keys
var objectKeys = Object.keys || function keys(obj) {
    var res = [];
    for(var key in obj)res[res.length] = key;
     // eslint-disable-line no-restricted-syntax
    return res;
};
var propertyIsEnumerable = Object.prototype.propertyIsEnumerable;
var getOwnPropertySymbols = Object.getOwnPropertySymbols; // eslint-disable-line id-length
// TODO: use reflect.ownkeys and filter out non-enumerables
function ownEnumerableKeys(obj) {
    var res = objectKeys(obj);
    // Include enumerable symbol properties.
    if (getOwnPropertySymbols) {
        var symbols = getOwnPropertySymbols(obj);
        for(var i = 0; i < symbols.length; i++)if (propertyIsEnumerable.call(obj, symbols[i])) res[res.length] = symbols[i];
    }
    return res;
}
// TODO: use object.hasown
var hasOwnProperty = Object.prototype.hasOwnProperty || function(obj, key) {
    return key in obj;
};
function isWritable(object, key) {
    if (typeof gopd !== 'function') return true;
    var desc = gopd(object, key);
    return !desc || !desc.writable;
}
function copy(src, options) {
    if (typeof src === 'object' && src !== null) {
        var dst;
        if (isArray(src)) dst = [];
        else if (isDate(src)) dst = new Date(src.getTime ? src.getTime() : src);
        else if (isRegExp(src)) dst = new RegExp(src);
        else if (isError(src)) dst = {
            message: src.message
        };
        else if (isBoolean(src) || isNumber(src) || isString(src)) dst = Object(src);
        else {
            var ta = whichTypedArray(src);
            if (ta) return taSlice(src);
            else if (Object.create && Object.getPrototypeOf) dst = Object.create(Object.getPrototypeOf(src));
            else if (src.constructor === Object) dst = {};
            else {
                var proto = src.constructor && src.constructor.prototype || src.__proto__ || {};
                var T = function T() {}; // eslint-disable-line func-style, func-name-matching
                T.prototype = proto;
                dst = new T();
            }
        }
        var iteratorFunction = options.includeSymbols ? ownEnumerableKeys : objectKeys;
        forEach(iteratorFunction(src), function(key) {
            dst[key] = src[key];
        });
        return dst;
    }
    return src;
}
/** @type {TraverseOptions} */ var emptyNull = {
    __proto__: null
};
function walk(root, cb) {
    var path = [];
    var parents = [];
    var alive = true;
    var options = arguments.length > 2 ? arguments[2] : emptyNull;
    var iteratorFunction = options.includeSymbols ? ownEnumerableKeys : objectKeys;
    var immutable = !!options.immutable;
    return function walker(node_) {
        var node = immutable ? copy(node_, options) : node_;
        var modifiers = {
            __proto__: null
        };
        var keepGoing = true;
        var state = {
            node: node,
            node_: node_,
            path: [].concat(path),
            parent: parents[parents.length - 1],
            parents: parents,
            key: path[path.length - 1],
            removedKeys: {
                __proto__: null
            },
            isRoot: path.length === 0,
            level: path.length,
            circular: null,
            update: function(x, stopHere) {
                if (!state.isRoot) state.parent.node[state.key] = x;
                state.node = x;
                if (stopHere) keepGoing = false;
            },
            delete: function(stopHere) {
                delete state.parent.node[state.key];
                state.parent.removedKeys[state.key] = true;
                if (stopHere) keepGoing = false;
            },
            remove: function(stopHere) {
                if (isArray(state.parent.node)) {
                    state.parent.node.splice(state.key, 1);
                    state.parent.removedKeys[state.key] = true;
                    if (stopHere) keepGoing = false;
                } else state.delete(stopHere);
            },
            keys: null,
            before: function(f) {
                modifiers.before = f;
            },
            after: function(f) {
                modifiers.after = f;
            },
            pre: function(f) {
                modifiers.pre = f;
            },
            post: function(f) {
                modifiers.post = f;
            },
            stop: function() {
                alive = false;
            },
            block: function() {
                keepGoing = false;
            }
        };
        if (!alive) return state;
        function updateState() {
            if (typeof state.node === 'object' && state.node !== null) {
                if (!state.keys || state.node_ !== state.node) state.keys = iteratorFunction(state.node);
                state.isLeaf = state.keys.length === 0;
                for(var i = 0; i < parents.length; i++)if (parents[i].node_ === node_) {
                    state.circular = parents[i];
                    break; // eslint-disable-line no-restricted-syntax
                }
            } else {
                state.isLeaf = true;
                state.keys = null;
            }
            state.notLeaf = !state.isLeaf;
            state.notRoot = !state.isRoot;
        }
        updateState();
        // use return values to update if defined
        var ret = cb.call(state, state.node);
        if (ret !== undefined && state.update) state.update(ret);
        if (modifiers.before) modifiers.before.call(state, state.node);
        if (!keepGoing) return state;
        if (typeof state.node === 'object' && state.node !== null && !state.circular) {
            parents[parents.length] = state;
            updateState();
            forEach(state.keys, function(key, i) {
                var prevIsRemoved = i - 1 in state.removedKeys;
                if (prevIsRemoved) key = state.keys[i - 1]; // eslint-disable-line no-param-reassign
                path[path.length] = key;
                if (modifiers.pre) modifiers.pre.call(state, state.node[key], key);
                var child = walker(state.node[key]);
                if (immutable && hasOwnProperty.call(state.node, key) && !isWritable(state.node, key) && !prevIsRemoved) state.node[key] = child.node;
                child.isLast = i === state.keys.length - 1;
                child.isFirst = i === 0;
                if (modifiers.post) modifiers.post.call(state, child);
                path.pop();
            });
            parents.pop();
        }
        if (modifiers.after) modifiers.after.call(state, state.node);
        return state;
    }(root).node;
}
/** @typedef {{ immutable?: boolean, includeSymbols?: boolean }} TraverseOptions */ /**
 * A traverse constructor
 * @param {object} obj - the object to traverse
 * @param {TraverseOptions | undefined} [options] - options for the traverse
 * @constructor
 */ function Traverse(obj) {
    /** @type {TraverseOptions} */ this.options = arguments.length > 1 ? arguments[1] : emptyNull;
    this.value = obj;
}
/** @type {(ps: PropertyKey[]) => Traverse['value']} */ Traverse.prototype.get = function(ps) {
    var node = this.value;
    for(var i = 0; node && i < ps.length; i++){
        var key = ps[i];
        if (!hasOwnProperty.call(node, key) || !this.options.includeSymbols && typeof key === 'symbol') return void 0;
        node = node[key];
    }
    return node;
};
/** @type {(ps: PropertyKey[]) => boolean} */ Traverse.prototype.has = function(ps) {
    var node = this.value;
    // TODO: remove ps.length check
    if (!node && ps.length > 0) return false;
    for(var i = 0; node && i < ps.length; i++){
        var key = ps[i];
        if (!hasOwnProperty.call(node, key) || !this.options.includeSymbols && typeof key === 'symbol') return false;
        node = node[key];
    }
    return true;
};
Traverse.prototype.set = function(ps, value) {
    var node = this.value;
    for(var i = 0; i < ps.length - 1; i++){
        var key = ps[i];
        if (!hasOwnProperty.call(node, key)) node[key] = {};
        node = node[key];
    }
    node[ps[i]] = value;
    return value;
};
Traverse.prototype.map = function(cb) {
    return walk(this.value, cb, {
        __proto__: null,
        immutable: true,
        includeSymbols: !!this.options.includeSymbols
    });
};
Traverse.prototype.forEach = function(cb) {
    this.value = walk(this.value, cb, this.options);
    return this.value;
};
Traverse.prototype.reduce = function(cb, init) {
    var skip = arguments.length === 1;
    var acc = skip ? this.value : init;
    this.forEach(function(x) {
        if (!this.isRoot || !skip) acc = cb.call(this, acc, x);
    });
    return acc;
};
Traverse.prototype.paths = function() {
    var acc = [];
    this.forEach(function() {
        acc[acc.length] = this.path;
    });
    return acc;
};
Traverse.prototype.nodes = function() {
    var acc = [];
    this.forEach(function() {
        acc[acc.length] = this.node;
    });
    return acc;
};
Traverse.prototype.clone = function() {
    var parents = [];
    var nodes = [];
    var options = this.options;
    if (whichTypedArray(this.value)) return taSlice(this.value);
    return function clone(src) {
        for(var i = 0; i < parents.length; i++){
            if (parents[i] === src) return nodes[i];
        }
        if (typeof src === 'object' && src !== null) {
            var dst = copy(src, options);
            parents[parents.length] = src;
            nodes[nodes.length] = dst;
            var iteratorFunction = options.includeSymbols ? ownEnumerableKeys : objectKeys;
            forEach(iteratorFunction(src), function(key) {
                dst[key] = clone(src[key]);
            });
            parents.pop();
            nodes.pop();
            return dst;
        }
        return src;
    }(this.value);
};
/** @type {(obj: object, options?: TraverseOptions) => Traverse} */ function traverse(obj) {
    var options = arguments.length > 1 ? arguments[1] : emptyNull;
    return new Traverse(obj, options);
}
// TODO: replace with object.assign?
forEach(ownEnumerableKeys(Traverse.prototype), function(key) {
    traverse[key] = function(obj) {
        var args = [].slice.call(arguments, 1);
        var t = new Traverse(obj);
        return t[key].apply(t, args);
    };
});
module.exports = traverse;

},{"2bb9b8dccd99ccca":"e0N37","ef4c0bef2beabae":"1qLMv","56889cb72c60f10f":"2RdtU"}],"1qLMv":[function(require,module,exports,__globalThis) {
'use strict';
var define = require("dd0f01b0fdf295fe");
var callBind = require("b5eb68501ab65b9");
var implementation = require("b981d5a42d1645d2");
var getPolyfill = require("402f87798bf559c7");
var shim = require("f0bb14f47e319f5d");
var bound = callBind(getPolyfill());
define(bound, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = bound;

},{"dd0f01b0fdf295fe":"ak2Bc","b5eb68501ab65b9":"4HjpY","b981d5a42d1645d2":"7yZgg","402f87798bf559c7":"kKTgT","f0bb14f47e319f5d":"aWs0O"}],"7yZgg":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("f973740d6ac08763");
var Get = require("1ec78300640e1c3f");
var GetValueFromBuffer = require("c4d76985232a7bf9");
var IsDetachedBuffer = require("f4cfb42944ccf302");
var max = require("e104dc7f2a93cbf");
var min = require("d55f738287b759de");
var Set = require("b7d788f66ce3f8ce");
var SetValueInBuffer = require("48a6a86df2704fc6");
var ToIntegerOrInfinity = require("a47b3860cedfc203");
var ToString = require("1da61460fe80de02");
var TypedArrayElementSize = require("20911d2a2d5593d4");
var TypedArrayElementType = require("9a00d23b4fb34543");
var TypedArraySpeciesCreate = require("47182bdbe591294b");
var ValidateTypedArray = require("6bea66a027b83389");
var typedArrayBuffer = require("b1df25403b52edf");
var typedArrayByteOffset = require("40d668ae39d83401");
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
module.exports = function slice(start, end) {
    var O = this; // step 1
    ValidateTypedArray(O, 'SEQ-CST'); // step 2
    // 3. Let len be O.[[ArrayLength]].
    var len = O.length; // steps 3
    var relativeStart = ToIntegerOrInfinity(start); // step 4
    var k;
    if (relativeStart === -Infinity) k = 0; // step 5
    else if (relativeStart < 0) k = max(len + relativeStart, 0); // step 6
    else k = min(relativeStart, len); // step 7
    var relativeEnd = typeof end === 'undefined' ? len : ToIntegerOrInfinity(end); // step 8
    var final;
    if (relativeEnd === -Infinity) final = 0; // step 9
    else if (relativeEnd < 0) final = max(len + relativeEnd, 0); // step 10
    else final = min(relativeEnd, len); // step 11
    var count = max(final - k, 0); // step 12
    var A = TypedArraySpeciesCreate(O, [
        count
    ]); // step 13
    if (count > 0) {
        if (IsDetachedBuffer(typedArrayBuffer(O))) throw new $TypeError('Cannot use a Typed Array with an underlying ArrayBuffer that is detached'); // step 14.a
        var srcType = TypedArrayElementType(O); // step 14.b
        var targetType = TypedArrayElementType(A); // step 14.c
        if (srcType === targetType) {
            //  1. NOTE: The transfer must be performed in a manner that preserves the bit-level encoding of the source data.
            var srcBuffer = typedArrayBuffer(O); // step 14.d.ii
            var targetBuffer = typedArrayBuffer(A); // step 14.d.iii
            var elementSize = TypedArrayElementSize(O); // step 14.d.iv
            var srcByteOffset = typedArrayByteOffset(O); // step 14.d.v
            var srcByteIndex = k * elementSize + srcByteOffset; // step 14.d.vi
            var targetByteIndex = typedArrayByteOffset(A); // step 14.d.vii
            var limit = targetByteIndex + count * elementSize; // step 14.d.viii
            while(targetByteIndex < limit){
                var value = GetValueFromBuffer(srcBuffer, srcByteIndex, 'UINT8', true, 'UNORDERED'); // step 14.d.ix.1
                SetValueInBuffer(targetBuffer, targetByteIndex, 'UINT8', value, true, 'UNORDERED'); // step 14.d.ix.2
                srcByteIndex += 1; // step 14.d.ix.3
                targetByteIndex += 1; // step 14.d.ix.4
            }
        } else {
            var n = 0; // step 14.e.i
            while(k < final){
                var Pk = ToString(k); // step 14.e.ii.1
                var kValue = Get(O, Pk); // step 14.e.ii.2
                Set(A, ToString(n), kValue, true); // step 14.e.ii.3
                k += 1; // step 14.e.ii.4
                n += 1; // step 14.e.ii.5
            }
        }
    }
    return A; // step 15
};

},{"f973740d6ac08763":"e08S4","1ec78300640e1c3f":"3FQpc","c4d76985232a7bf9":"ajRRG","f4cfb42944ccf302":"lYoAc","e104dc7f2a93cbf":"58Q7H","d55f738287b759de":"ct1xo","b7d788f66ce3f8ce":"dJpLa","48a6a86df2704fc6":"lIciM","a47b3860cedfc203":"hM9ML","1da61460fe80de02":"8fcbW","20911d2a2d5593d4":"hgopq","9a00d23b4fb34543":"afj6G","47182bdbe591294b":"fyuE2","6bea66a027b83389":"doM6P","b1df25403b52edf":"cow6L","40d668ae39d83401":"krjcN"}],"3FQpc":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("1f995e2eeb9d38ab");
var inspect = require("7780f20a78fe8912");
var isObject = require("46b899014ec22bc");
var isPropertyKey = require("22c62efe7a3be9f8");
// https://262.ecma-international.org/6.0/#sec-get-o-p
module.exports = function Get(O, P) {
    // 7.3.1.1
    if (!isObject(O)) throw new $TypeError('Assertion failed: Type(O) is not Object');
    // 7.3.1.2
    if (!isPropertyKey(P)) throw new $TypeError('Assertion failed: P is not a Property Key, got ' + inspect(P));
    // 7.3.1.3
    return O[P];
};

},{"1f995e2eeb9d38ab":"e08S4","7780f20a78fe8912":"2SV8o","46b899014ec22bc":"axMar","22c62efe7a3be9f8":"33Tnt"}],"2SV8o":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}
var utilInspect = require("faefcb1694f2ad90");
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if (has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return isArray(obj) ? '[Array]' : '[Object]';
    var indent = getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if (indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !isRegExp(obj)) {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) return '[' + indentedJoin(xs, indent) + ']';
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) return utilInspect(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) return weakCollectionOf('WeakMap');
    if (isWeakSet(obj)) return weakCollectionOf('WeakSet');
    if (isWeakRef(obj)) return weakCollectionOf('WeakRef');
    if (isNumber(obj)) return markBoxed(inspect(Number(obj)));
    if (isBigInt(obj)) return markBoxed(inspect(bigIntValueOf.call(obj)));
    if (isBoolean(obj)) return markBoxed(booleanValueOf.call(obj));
    if (isString(obj)) return markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof global !== 'undefined' && obj === global) return '{ [object globalThis] }';
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}
function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}
function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) {
    return toStr(obj) === '[object Array]' && canTrustToString(obj);
}
function isDate(obj) {
    return toStr(obj) === '[object Date]' && canTrustToString(obj);
}
function isRegExp(obj) {
    return toStr(obj) === '[object RegExp]' && canTrustToString(obj);
}
function isError(obj) {
    return toStr(obj) === '[object Error]' && canTrustToString(obj);
}
function isString(obj) {
    return toStr(obj) === '[object String]' && canTrustToString(obj);
}
function isNumber(obj) {
    return toStr(obj) === '[object Number]' && canTrustToString(obj);
}
function isBoolean(obj) {
    return toStr(obj) === '[object Boolean]' && canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !symToString) return false;
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) return false;
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function has(obj, key) {
    return hasOwn.call(obj, key);
}
function toStr(obj) {
    return objectToString.call(obj);
}
function nameOf(f) {
    if (f.name) return f.name;
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') return false;
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') return false;
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') return false;
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') return false;
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}
function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
    return 'Object(' + str + ')';
}
function weakCollectionOf(type) {
    return type + ' { ? }';
}
function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if (indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}
function indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if (isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

},{"faefcb1694f2ad90":"1dFdn"}],"axMar":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function isObject(x) {
    return !!x && (typeof x === 'function' || typeof x === 'object');
};

},{}],"33Tnt":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function isPropertyKey(argument) {
    return typeof argument === 'string' || typeof argument === 'symbol';
};

},{}],"ajRRG":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("e7fca202cb55b273");
var $SyntaxError = require("e4199fa3c7f7f778");
var $TypeError = require("7aee3770c83c1a6a");
var callBound = require("ef223867098b398b");
var isInteger = require("994a799063fb07bc");
var $Uint8Array = GetIntrinsic('%Uint8Array%', true);
var $slice = callBound('Array.prototype.slice');
var IsDetachedBuffer = require("16f802f24deb7cb9");
var RawBytesToNumeric = require("713c3eb8f5538f3");
var isArrayBuffer = require("2dfad02b8865b3");
var isSharedArrayBuffer = require("7a02f0a9c5310047");
var safeConcat = require("b359b6fc8a753166");
var tableTAO = require("6b0d5af166542a9b");
var defaultEndianness = require("c43af1ea51b3fd63");
// https://262.ecma-international.org/15.0/#sec-getvaluefrombuffer
module.exports = function GetValueFromBuffer(arrayBuffer, byteIndex, type, isTypedArray, order) {
    var isSAB = isSharedArrayBuffer(arrayBuffer);
    if (!isArrayBuffer(arrayBuffer) && !isSAB) throw new $TypeError('Assertion failed: `arrayBuffer` must be an ArrayBuffer or a SharedArrayBuffer');
    if (!isInteger(byteIndex)) throw new $TypeError('Assertion failed: `byteIndex` must be an integer');
    if (typeof type !== 'string' || typeof tableTAO.size['$' + type] !== 'number') throw new $TypeError('Assertion failed: `type` must be a Typed Array element type');
    if (typeof isTypedArray !== 'boolean') throw new $TypeError('Assertion failed: `isTypedArray` must be a boolean');
    if (order !== 'SEQ-CST' && order !== 'UNORDERED') throw new $TypeError('Assertion failed: `order` must be either `SEQ-CST` or `UNORDERED`');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean') throw new $TypeError('Assertion failed: `isLittleEndian` must be a boolean, if present');
    if (IsDetachedBuffer(arrayBuffer)) throw new $TypeError('Assertion failed: `arrayBuffer` is detached'); // step 1
    // 2. Assert: There are sufficient bytes in arrayBuffer starting at byteIndex to represent a value of type.
    if (byteIndex < 0) throw new $TypeError('Assertion failed: `byteIndex` must be non-negative'); // step 3
    // 4. Let block be arrayBuffer.[[ArrayBufferData]].
    var elementSize = tableTAO.size['$' + type]; // step 5
    if (!elementSize) throw new $TypeError('Assertion failed: `type` must be one of "INT8", "UINT8", "UINT8C", "INT16", "UINT16", "INT32", "UINT32", "BIGINT64", "BIGUINT64", "FLOAT32", or "FLOAT64"');
    var rawValue;
    if (isSAB) /*
		a. Let execution be the [[CandidateExecution]] field of the surrounding agent's Agent Record.
		b. Let eventList be the [[EventList]] field of the element in execution.[[EventLists]] whose [[AgentSignifier]] is AgentSignifier().
		c. If isTypedArray is true and type is "Int8", "Uint8", "Int16", "Uint16", "Int32", or "Uint32", let noTear be true; otherwise let noTear be false.
		d. Let rawValue be a List of length elementSize of nondeterministically chosen byte values.
		e. NOTE: In implementations, rawValue is the result of a non-atomic or atomic read instruction on the underlying hardware. The nondeterminism is a semantic prescription of the memory model to describe observable behaviour of hardware with weak consistency.
		f. Let readEvent be ReadSharedMemory{ [[Order]]: order, [[NoTear]]: noTear, [[Block]]: block, [[ByteIndex]]: byteIndex, [[ElementSize]]: elementSize }.
		g. Append readEvent to eventList.
		h. Append Chosen Value Record { [[Event]]: readEvent, [[ChosenValue]]: rawValue } to execution.[[ChosenValues]].
		*/ throw new $SyntaxError('SharedArrayBuffer is not supported by this implementation');
    else // 7. Let rawValue be a List of elementSize containing, in order, the elementSize sequence of bytes starting with block[byteIndex].
    rawValue = $slice(new $Uint8Array(arrayBuffer, byteIndex), 0, elementSize); // step 6
    // 8. If isLittleEndian is not present, set isLittleEndian to either true or false. The choice is implementation dependent and should be the alternative that is most efficient for the implementation. An implementation must use the same value each time this step is executed and the same value must be used for the corresponding step in the SetValueInBuffer abstract operation.
    var isLittleEndian = arguments.length > 5 ? arguments[5] : defaultEndianness === 'little'; // step 8
    var bytes = isLittleEndian ? $slice(safeConcat([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ], rawValue), -elementSize) : $slice(safeConcat(rawValue, [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ]), 0, elementSize);
    return RawBytesToNumeric(type, bytes, isLittleEndian);
};

},{"e7fca202cb55b273":"2umKQ","e4199fa3c7f7f778":"6Pwu2","7aee3770c83c1a6a":"e08S4","ef223867098b398b":"8ZomV","994a799063fb07bc":"3MEYt","16f802f24deb7cb9":"lYoAc","713c3eb8f5538f3":"4ej4J","2dfad02b8865b3":"6TxHP","7a02f0a9c5310047":"bDJMm","b359b6fc8a753166":"cDXiE","6b0d5af166542a9b":"4BG8z","c43af1ea51b3fd63":"9vt4R"}],"3MEYt":[function(require,module,exports,__globalThis) {
'use strict';
var $abs = require("ae0b5f0219c4aed3");
var $floor = require("94eaeb38d1a1e2b");
var $isNaN = require("b6bee2e4f06405ea");
var $isFinite = require("6d2ad7c7d509dd92");
/** @type {import('./isInteger')} */ module.exports = function isInteger(argument) {
    if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) return false;
    var absValue = $abs(argument);
    return $floor(absValue) === absValue;
};

},{"ae0b5f0219c4aed3":"7TMfH","94eaeb38d1a1e2b":"iiSoG","b6bee2e4f06405ea":"i8IDp","6d2ad7c7d509dd92":"4HRNi"}],"4HRNi":[function(require,module,exports,__globalThis) {
'use strict';
var $isNaN = require("d3fff083039926e5");
/** @type {import('./isFinite')} */ module.exports = function isFinite(x) {
    return (typeof x === 'number' || typeof x === 'bigint') && !$isNaN(x) && x !== Infinity && x !== -Infinity;
};

},{"d3fff083039926e5":"i8IDp"}],"lYoAc":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var $TypeError = require("654e79c970f9e853");
var $byteLength = require("cd441771ea3c52d2");
var availableTypedArrays = require("d8b989f50d8b4f")();
var callBound = require("94df805ecefefeb6");
var isArrayBuffer = require("94c0af6fa719b81a");
var isSharedArrayBuffer = require("e12d77c956f19e89");
var $sabByteLength = callBound('SharedArrayBuffer.prototype.byteLength', true);
// https://262.ecma-international.org/8.0/#sec-isdetachedbuffer
module.exports = function IsDetachedBuffer(arrayBuffer) {
    var isSAB = isSharedArrayBuffer(arrayBuffer);
    if (!isArrayBuffer(arrayBuffer) && !isSAB) throw new $TypeError('Assertion failed: `arrayBuffer` must be an Object with an [[ArrayBufferData]] internal slot');
    if ((isSAB ? $sabByteLength : $byteLength)(arrayBuffer) === 0) try {
        new global[availableTypedArrays[0]](arrayBuffer); // eslint-disable-line no-new
    } catch (error) {
        return !!error && error.name === 'TypeError';
    }
    return false;
};

},{"654e79c970f9e853":"e08S4","cd441771ea3c52d2":"g6Oam","d8b989f50d8b4f":"jCTS7","94df805ecefefeb6":"8ZomV","94c0af6fa719b81a":"6TxHP","e12d77c956f19e89":"bDJMm"}],"g6Oam":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("a0464b2f7ada73c1");
var $byteLength = callBound('ArrayBuffer.prototype.byteLength', true);
var isArrayBuffer = require("6382a20b4706fa1a");
/** @type {import('.')} */ module.exports = function byteLength(ab) {
    if (!isArrayBuffer(ab)) return NaN;
    return $byteLength ? $byteLength(ab) : ab.byteLength;
}; // in node < 0.11, byteLength is an own nonconfigurable property

},{"a0464b2f7ada73c1":"8ZomV","6382a20b4706fa1a":"6TxHP"}],"6TxHP":[function(require,module,exports,__globalThis) {
'use strict';
var callBind = require("a30b9eee5dc55b4b");
var callBound = require("ad05cf87a5483492");
var GetIntrinsic = require("2e6ed2d884c5409");
var $ArrayBuffer = GetIntrinsic('%ArrayBuffer%', true);
/** @type {undefined | ((receiver: ArrayBuffer) => number) | ((receiver: unknown) => never)} */ var $byteLength = callBound('ArrayBuffer.prototype.byteLength', true);
var $toString = callBound('Object.prototype.toString');
// in node 0.10, ArrayBuffers have no prototype methods, but have an own slot-checking `slice` method
var abSlice = !!$ArrayBuffer && !$byteLength && new $ArrayBuffer(0).slice;
var $abSlice = !!abSlice && callBind(abSlice);
/** @type {import('.')} */ module.exports = $byteLength || $abSlice ? function isArrayBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    try {
        if ($byteLength) // @ts-expect-error no idea why TS can't handle the overload
        $byteLength(obj);
        else // @ts-expect-error TS chooses not to type-narrow inside a closure
        $abSlice(obj, 0);
        return true;
    } catch (e) {
        return false;
    }
} : $ArrayBuffer ? function isArrayBuffer(obj) {
    return $toString(obj) === '[object ArrayBuffer]';
} : function isArrayBuffer(obj) {
    return false;
};

},{"a30b9eee5dc55b4b":"4HjpY","ad05cf87a5483492":"8ZomV","2e6ed2d884c5409":"2umKQ"}],"bDJMm":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("2c2e7f091c1af1ff");
/** @type {undefined | ((thisArg: SharedArrayBuffer) => number)} */ var $byteLength = callBound('SharedArrayBuffer.prototype.byteLength', true);
/** @type {import('.')} */ module.exports = $byteLength ? function isSharedArrayBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    try {
        // @ts-expect-error TS can't figure out this closed-over variable is non-nullable, and it's fine that `obj` might not be a SAB
        $byteLength(obj);
        return true;
    } catch (e) {
        return false;
    }
} : function isSharedArrayBuffer(_obj) {
    return false;
};

},{"2c2e7f091c1af1ff":"8ZomV"}],"4ej4J":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("8cb48da88667a2ea");
var callBound = require("137063ea252e21b6");
var $RangeError = require("a5e2ed1a9b78c123");
var $SyntaxError = require("37a8734c7c0ed4e1");
var $TypeError = require("182bf0c65366262f");
var $BigInt = GetIntrinsic('%BigInt%', true);
var hasOwnProperty = require("afd0a5b83177b2dd");
var IsArray = require("e62cbd72e1dbaab5");
var IsBigIntElementType = require("2de8fc1a496c3f3a");
var IsUnsignedElementType = require("429f52acff807482");
var bytesAsFloat32 = require("d629cbdec43d76ce");
var bytesAsFloat64 = require("68738d6f19df5fa3");
var bytesAsInteger = require("cb1842064441efbf");
var every = require("b62281de8e841bcf");
var isByteValue = require("415688b4a2792c09");
var $reverse = callBound('Array.prototype.reverse');
var $slice = callBound('Array.prototype.slice');
var keys = require("3ff134c7672a4fd7");
// https://262.ecma-international.org/15.0/#table-the-typedarray-constructors
var TypeToSizes = {
    __proto__: null,
    INT8: 1,
    UINT8: 1,
    UINT8C: 1,
    INT16: 2,
    UINT16: 2,
    INT32: 4,
    UINT32: 4,
    BIGINT64: 8,
    BIGUINT64: 8,
    FLOAT32: 4,
    FLOAT64: 8
};
// https://262.ecma-international.org/15.0/#sec-rawbytestonumeric
module.exports = function RawBytesToNumeric(type, rawBytes, isLittleEndian) {
    if (!hasOwnProperty(TypeToSizes, type)) throw new $TypeError('Assertion failed: `type` must be a TypedArray element type: ' + keys(TypeToSizes));
    if (!IsArray(rawBytes) || !every(rawBytes, isByteValue)) throw new $TypeError('Assertion failed: `rawBytes` must be an Array of bytes');
    if (typeof isLittleEndian !== 'boolean') throw new $TypeError('Assertion failed: `isLittleEndian` must be a Boolean');
    var elementSize = TypeToSizes[type]; // step 1
    if (rawBytes.length !== elementSize) // this assertion is not in the spec, but it'd be an editorial error if it were ever violated
    throw new $RangeError('Assertion failed: `rawBytes` must have a length of ' + elementSize + ' for type ' + type);
    var isBigInt = IsBigIntElementType(type);
    if (isBigInt && !$BigInt) throw new $SyntaxError('this environment does not support BigInts');
    // eslint-disable-next-line no-param-reassign
    rawBytes = $slice(rawBytes, 0, elementSize);
    if (!isLittleEndian) $reverse(rawBytes); // step 2
    if (type === 'FLOAT32') return bytesAsFloat32(rawBytes);
    if (type === 'FLOAT64') return bytesAsFloat64(rawBytes);
    return bytesAsInteger(rawBytes, elementSize, IsUnsignedElementType(type), isBigInt);
};

},{"8cb48da88667a2ea":"2umKQ","137063ea252e21b6":"8ZomV","a5e2ed1a9b78c123":"jdhJj","37a8734c7c0ed4e1":"6Pwu2","182bf0c65366262f":"e08S4","afd0a5b83177b2dd":"2dTty","e62cbd72e1dbaab5":"hl3iI","2de8fc1a496c3f3a":"1LrRR","429f52acff807482":"7lT9r","d629cbdec43d76ce":"i5ITC","68738d6f19df5fa3":"aQRSP","cb1842064441efbf":"j9JJp","b62281de8e841bcf":"aTGCB","415688b4a2792c09":"6LmBx","3ff134c7672a4fd7":"fEUfC"}],"2dTty":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("d63f4c87c0b2fb5e");
var hasOwn = require("7c717d2be6ddcb55");
var isObject = require("5d609981587a222f");
var isPropertyKey = require("c5c4bf73b171150d");
// https://262.ecma-international.org/6.0/#sec-hasownproperty
module.exports = function HasOwnProperty(O, P) {
    if (!isObject(O)) throw new $TypeError('Assertion failed: `O` must be an Object');
    if (!isPropertyKey(P)) throw new $TypeError('Assertion failed: `P` must be a Property Key');
    return hasOwn(O, P);
};

},{"d63f4c87c0b2fb5e":"e08S4","7c717d2be6ddcb55":"oWOGY","5d609981587a222f":"axMar","c5c4bf73b171150d":"33Tnt"}],"hl3iI":[function(require,module,exports,__globalThis) {
'use strict';
// https://262.ecma-international.org/6.0/#sec-isarray
module.exports = require("c47c4bd4ac1f20e1");

},{"c47c4bd4ac1f20e1":"gAEip"}],"gAEip":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("3a1e7a0dea5ae10d");
var $Array = GetIntrinsic('%Array%');
// eslint-disable-next-line global-require
var toStr = !$Array.isArray && require("3d9fb99604ee3220")('Object.prototype.toString');
module.exports = $Array.isArray || function IsArray(argument) {
    return toStr(argument) === '[object Array]';
};

},{"3a1e7a0dea5ae10d":"2umKQ","3d9fb99604ee3220":"8ZomV"}],"1LrRR":[function(require,module,exports,__globalThis) {
'use strict';
// https://262.ecma-international.org/15.0/#sec-isbigintelementtype
module.exports = function IsBigIntElementType(type) {
    return type === 'BIGUINT64' || type === 'BIGINT64';
};

},{}],"7lT9r":[function(require,module,exports,__globalThis) {
'use strict';
// https://262.ecma-international.org/15.0/#sec-isunsignedelementtype
module.exports = function IsUnsignedElementType(type) {
    return type === 'UINT8' || type === 'UINT8C' || type === 'UINT16' || type === 'UINT32' || type === 'BIGUINT64';
};

},{}],"i5ITC":[function(require,module,exports,__globalThis) {
'use strict';
var $pow = require("5e0c75364c4e100e");
module.exports = function bytesAsFloat32(rawBytes) {
    // return new $Float32Array(new $Uint8Array(rawBytes).buffer)[0];
    /*
        Let value be the byte elements of rawBytes concatenated and interpreted as a little-endian bit string encoding of an IEEE 754-2008 binary32 value.
If value is an IEEE 754-2008 binary32 NaN value, return the NaN Number value.
Return the Number value that corresponds to value.
        */ var sign = rawBytes[3] & 0x80 ? -1 : 1; // Check the sign bit
    var exponent = (rawBytes[3] & 0x7F) << 1 | rawBytes[2] >> 7; // Combine bits for exponent
    var mantissa = (rawBytes[2] & 0x7F) << 16 | rawBytes[1] << 8 | rawBytes[0]; // Combine bits for mantissa
    if (exponent === 0 && mantissa === 0) return sign === 1 ? 0 : -0;
    if (exponent === 0xFF && mantissa === 0) return sign === 1 ? Infinity : -Infinity;
    if (exponent === 0xFF && mantissa !== 0) return NaN;
    exponent -= 127; // subtract the bias
    if (exponent === -127) return sign * mantissa * $pow(2, -149);
    return sign * (1 + mantissa * $pow(2, -23)) * $pow(2, exponent);
};

},{"5e0c75364c4e100e":"4NXOD"}],"aQRSP":[function(require,module,exports,__globalThis) {
'use strict';
var $pow = require("5b70fc65b323ce96");
module.exports = function bytesAsFloat64(rawBytes) {
    // return new $Float64Array(new $Uint8Array(rawBytes).buffer)[0];
    /*
    Let value be the byte elements of rawBytes concatenated and interpreted as a little-endian bit string encoding of an IEEE 754-2008 binary64 value.
If value is an IEEE 754-2008 binary64 NaN value, return the NaN Number value.
Return the Number value that corresponds to value.
    */ var sign = rawBytes[7] & 0x80 ? -1 : 1; // first bit
    var exponent = (rawBytes[7] & 0x7F) << 4 // 7 bits from index 7
     | (rawBytes[6] & 0xF0) >> 4; // 4 bits from index 6
    var mantissa = (rawBytes[6] & 0x0F) * 0x1000000000000 // 4 bits from index 6
     + rawBytes[5] * 0x10000000000 // 8 bits from index 5
     + rawBytes[4] * 0x100000000 // 8 bits from index 4
     + rawBytes[3] * 0x1000000 // 8 bits from index 3
     + rawBytes[2] * 0x10000 // 8 bits from index 2
     + rawBytes[1] * 0x100 // 8 bits from index 1
     + rawBytes[0]; // 8 bits from index 0
    if (exponent === 0 && mantissa === 0) return sign * 0;
    if (exponent === 0x7FF && mantissa !== 0) return NaN;
    if (exponent === 0x7FF && mantissa === 0) return sign * Infinity;
    exponent -= 1023; // subtract the bias
    // Handle subnormal numbers
    if (exponent === -1023) return sign * mantissa * 5e-324; // $pow(2, -1022 - 52)
    return sign * (1 + mantissa / 0x10000000000000) * $pow(2, exponent);
};

},{"5b70fc65b323ce96":"4NXOD"}],"j9JJp":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("f22726be47254fac");
var $pow = require("bbc9b3f6a75ab7c3");
var $Number = GetIntrinsic('%Number%');
var $BigInt = GetIntrinsic('%BigInt%', true);
module.exports = function bytesAsInteger(rawBytes, elementSize, isUnsigned, isBigInt) {
    var Z = isBigInt ? $BigInt : $Number;
    // this is common to both branches
    var intValue = Z(0);
    for(var i = 0; i < rawBytes.length; i++)intValue += Z(rawBytes[i] * $pow(2, 8 * i));
    /*
	Let intValue be the byte elements of rawBytes concatenated and interpreted as a bit string encoding of an unsigned little-endian binary number.
	*/ if (!isUnsigned) {
        // Let intValue be the byte elements of rawBytes concatenated and interpreted as a bit string encoding of a binary little-endian 2's complement number of bit length elementSize × 8.
        var bitLength = elementSize * 8;
        if (rawBytes[elementSize - 1] & 0x80) intValue -= Z($pow(2, bitLength));
    }
    return intValue; // step 7
};

},{"f22726be47254fac":"2umKQ","bbc9b3f6a75ab7c3":"4NXOD"}],"aTGCB":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function every(array, predicate) {
    for(var i = 0; i < array.length; i += 1){
        if (!predicate(array[i], i, array)) return false;
    }
    return true;
};

},{}],"6LmBx":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function isByteValue(value) {
    return typeof value === 'number' && value >= 0 && value <= 255 && (value | 0) === value;
};

},{}],"cDXiE":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("32ca8070becce872");
var $concat = GetIntrinsic('%Array.prototype.concat%');
var callBind = require("6c6d7cbf587fc5aa");
var callBound = require("6837bdb9cb3d6124");
var $slice = callBound('Array.prototype.slice');
var hasSymbols = require("4b9969dac99c6aaa")();
var isConcatSpreadable = hasSymbols && Symbol.isConcatSpreadable;
/** @type {never[]} */ var empty = [];
var $concatApply = isConcatSpreadable ? callBind.apply($concat, empty) : null;
// eslint-disable-next-line no-extra-parens
var isArray = isConcatSpreadable ? /** @type {(value: unknown) => value is unknown[]} */ require("706348fd714fce4c") : null;
/** @type {import('.')} */ module.exports = isConcatSpreadable ? function safeArrayConcat(item) {
    for(var i = 0; i < arguments.length; i += 1){
        /** @type {typeof item} */ var arg = arguments[i];
        // @ts-expect-error ts(2538) see https://github.com/microsoft/TypeScript/issues/9998#issuecomment-1890787975; works if `const`
        if (arg && typeof arg === 'object' && typeof arg[isConcatSpreadable] === 'boolean') {
            // @ts-expect-error ts(7015) TS doesn't yet support Symbol indexing
            if (!empty[isConcatSpreadable]) // @ts-expect-error ts(7015) TS doesn't yet support Symbol indexing
            empty[isConcatSpreadable] = true;
            // @ts-expect-error ts(2721) ts(18047) not sure why TS can't figure out this can't be null
            var arr = isArray(arg) ? $slice(arg) : [
                arg
            ];
            // @ts-expect-error ts(7015) TS can't handle expandos on an array
            arr[isConcatSpreadable] = true; // shadow the property. TODO: use [[Define]]
            arguments[i] = arr;
        }
    }
    // @ts-expect-error ts(2345) https://github.com/microsoft/TypeScript/issues/57164 TS doesn't understand that apply can take an arguments object
    return $concatApply(arguments);
} : callBind($concat, empty);

},{"32ca8070becce872":"2umKQ","6c6d7cbf587fc5aa":"4HjpY","6837bdb9cb3d6124":"8ZomV","4b9969dac99c6aaa":"1MT9o","706348fd714fce4c":"4R0um"}],"4R0um":[function(require,module,exports,__globalThis) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == '[object Array]';
};

},{}],"4BG8z":[function(require,module,exports,__globalThis) {
'use strict';
// https://262.ecma-international.org/15.0/#table-the-typedarray-constructors
module.exports = {
    __proto__: null,
    name: {
        __proto__: null,
        $Int8Array: 'INT8',
        $Uint8Array: 'UINT8',
        $Uint8ClampedArray: 'UINT8C',
        $Int16Array: 'INT16',
        $Uint16Array: 'UINT16',
        $Int32Array: 'INT32',
        $Uint32Array: 'UINT32',
        $BigInt64Array: 'BIGINT64',
        $BigUint64Array: 'BIGUINT64',
        $Float32Array: 'FLOAT32',
        $Float64Array: 'FLOAT64'
    },
    size: {
        __proto__: null,
        $INT8: 1,
        $UINT8: 1,
        $UINT8C: 1,
        $INT16: 2,
        $UINT16: 2,
        $INT32: 4,
        $UINT32: 4,
        $BIGINT64: 8,
        $BIGUINT64: 8,
        $FLOAT32: 4,
        $FLOAT64: 8
    }
};

},{}],"9vt4R":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("daca1d96c2fdcd0b");
var $Uint8Array = GetIntrinsic('%Uint8Array%', true);
var $Uint32Array = GetIntrinsic('%Uint32Array%', true);
var typedArrayBuffer = require("3372c0fea38c79be");
var uInt32 = $Uint32Array && new $Uint32Array([
    0x12345678
]);
var uInt8 = uInt32 && new $Uint8Array(typedArrayBuffer(uInt32));
module.exports = uInt8 ? uInt8[0] === 0x78 ? 'little' : uInt8[0] === 0x12 ? 'big' : uInt8[0] === 0x34 ? 'mixed' // https://developer.mozilla.org/en-US/docs/Glossary/Endianness
 : 'unknown' // ???
 : 'indeterminate'; // no way to know

},{"daca1d96c2fdcd0b":"2umKQ","3372c0fea38c79be":"cow6L"}],"cow6L":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("e48e3bf1182f54b");
var callBound = require("749d73ae9b5b61d0");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $typedArrayBuffer = callBound('TypedArray.prototype.buffer', true);
var isTypedArray = require("ab9db50ce28124c2");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $typedArrayBuffer || function typedArrayBuffer(x) {
    if (!isTypedArray(x)) throw new $TypeError('Not a Typed Array');
    return x.buffer;
};

},{"e48e3bf1182f54b":"e08S4","749d73ae9b5b61d0":"8ZomV","ab9db50ce28124c2":"gSNWJ"}],"dJpLa":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("8c30b9f2781b230d");
var isPropertyKey = require("8792b5f63af632a6");
var SameValue = require("aeac800ccb1232e1");
var isObject = require("cfc97ebc5fe9cead");
// IE 9 does not throw in strict mode when writability/configurability/extensibility is violated
var noThrowOnStrictViolation = function() {
    try {
        delete [].length;
        return true;
    } catch (e) {
        return false;
    }
}();
// https://262.ecma-international.org/6.0/#sec-set-o-p-v-throw
module.exports = function Set(O, P, V, Throw) {
    if (!isObject(O)) throw new $TypeError('Assertion failed: `O` must be an Object');
    if (!isPropertyKey(P)) throw new $TypeError('Assertion failed: `P` must be a Property Key');
    if (typeof Throw !== 'boolean') throw new $TypeError('Assertion failed: `Throw` must be a Boolean');
    if (Throw) {
        O[P] = V; // eslint-disable-line no-param-reassign
        if (noThrowOnStrictViolation && !SameValue(O[P], V)) throw new $TypeError('Attempted to assign to readonly property.');
        return true;
    }
    try {
        O[P] = V; // eslint-disable-line no-param-reassign
        return noThrowOnStrictViolation ? SameValue(O[P], V) : true;
    } catch (e) {
        return false;
    }
};

},{"8c30b9f2781b230d":"e08S4","8792b5f63af632a6":"33Tnt","aeac800ccb1232e1":"eYP2G","cfc97ebc5fe9cead":"axMar"}],"eYP2G":[function(require,module,exports,__globalThis) {
'use strict';
var $isNaN = require("d68d1e08231caa2e");
// http://262.ecma-international.org/5.1/#sec-9.12
module.exports = function SameValue(x, y) {
    if (x === y) {
        if (x === 0) return 1 / x === 1 / y;
        return true;
    }
    return $isNaN(x) && $isNaN(y);
};

},{"d68d1e08231caa2e":"i8IDp"}],"lIciM":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("a1d2ff29a2b718e4");
var $SyntaxError = require("c653fbe03b625c1b");
var $TypeError = require("37e62034ae14549c");
var isInteger = require("3c0c78f1484fa778");
var $Uint8Array = GetIntrinsic('%Uint8Array%', true);
var IsBigIntElementType = require("db10c01fa195dfc8");
var IsDetachedBuffer = require("81455f4f7a8d800");
var NumericToRawBytes = require("76adba375be845fb");
var isArrayBuffer = require("d8babd6d44370f91");
var isSharedArrayBuffer = require("e280d6596558855c");
var hasOwn = require("e1c383314628a6cf");
var tableTAO = require("85aa833195ce9f3d");
var defaultEndianness = require("b44d1a91677d4531");
var forEach = require("e49fc03b52792aa");
// https://262.ecma-international.org/15.0/#sec-setvalueinbuffer
/* eslint max-params: 0 */ module.exports = function SetValueInBuffer(arrayBuffer, byteIndex, type, value, isTypedArray, order) {
    var isSAB = isSharedArrayBuffer(arrayBuffer);
    if (!isArrayBuffer(arrayBuffer) && !isSAB) throw new $TypeError('Assertion failed: `arrayBuffer` must be an ArrayBuffer or a SharedArrayBuffer');
    if (!isInteger(byteIndex) || byteIndex < 0) throw new $TypeError('Assertion failed: `byteIndex` must be a non-negative integer');
    if (typeof type !== 'string' || !hasOwn(tableTAO.size, '$' + type)) throw new $TypeError('Assertion failed: `type` must be a Typed Array Element Type');
    if (typeof value !== 'number' && typeof value !== 'bigint') throw new $TypeError('Assertion failed: `value` must be a Number or a BigInt');
    if (typeof isTypedArray !== 'boolean') throw new $TypeError('Assertion failed: `isTypedArray` must be a boolean');
    if (order !== 'SEQ-CST' && order !== 'UNORDERED' && order !== 'INIT') throw new $TypeError('Assertion failed: `order` must be `"SEQ-CST"`, `"UNORDERED"`, or `"INIT"`');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $TypeError('Assertion failed: `isLittleEndian` must be a boolean, if present');
    if (IsDetachedBuffer(arrayBuffer)) throw new $TypeError('Assertion failed: ArrayBuffer is detached'); // step 1
    // 2. Assert: There are sufficient bytes in arrayBuffer starting at byteIndex to represent a value of type.
    if (IsBigIntElementType(type) ? typeof value !== 'bigint' : typeof value !== 'number') throw new $TypeError('Assertion failed: `value` must be a BigInt if type is ~BIGINT64~ or ~BIGUINT64~, otherwise a Number');
    // 4. Let block be arrayBuffer’s [[ArrayBufferData]] internal slot.
    var elementSize = tableTAO.size['$' + type]; // step 5
    // 6. If isLittleEndian is not present, set isLittleEndian to either true or false. The choice is implementation dependent and should be the alternative that is most efficient for the implementation. An implementation must use the same value each time this step is executed and the same value must be used for the corresponding step in the GetValueFromBuffer abstract operation.
    var isLittleEndian = arguments.length > 6 ? arguments[6] : defaultEndianness === 'little'; // step 6
    var rawBytes = NumericToRawBytes(type, value, isLittleEndian); // step 7
    if (isSAB) /*
			Let execution be the [[CandidateExecution]] field of the surrounding agent's Agent Record.
			Let eventList be the [[EventList]] field of the element in execution.[[EventsRecords]] whose [[AgentSignifier]] is AgentSignifier().
			If isTypedArray is true and IsNoTearConfiguration(type, order) is true, let noTear be true; otherwise let noTear be false.
			Append WriteSharedMemory { [[Order]]: order, [[NoTear]]: noTear, [[Block]]: block, [[ByteIndex]]: byteIndex, [[ElementSize]]: elementSize, [[Payload]]: rawBytes } to eventList.
		*/ throw new $SyntaxError('SharedArrayBuffer is not supported by this implementation');
    else {
        // 9. Store the individual bytes of rawBytes into block, in order, starting at block[byteIndex].
        var arr = new $Uint8Array(arrayBuffer, byteIndex, elementSize);
        forEach(rawBytes, function(rawByte, i) {
            arr[i] = rawByte;
        });
    }
// 10. Return NormalCompletion(undefined).
};

},{"a1d2ff29a2b718e4":"2umKQ","c653fbe03b625c1b":"6Pwu2","37e62034ae14549c":"e08S4","3c0c78f1484fa778":"3MEYt","db10c01fa195dfc8":"1LrRR","81455f4f7a8d800":"lYoAc","76adba375be845fb":"gRLgT","d8babd6d44370f91":"6TxHP","e280d6596558855c":"bDJMm","e1c383314628a6cf":"oWOGY","85aa833195ce9f3d":"4BG8z","b44d1a91677d4531":"9vt4R","e49fc03b52792aa":"8zRKQ"}],"gRLgT":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("c84e752f02e44745");
var hasOwnProperty = require("48182bd9b09e950e");
var ToBigInt64 = require("f18762d7cd4caaf3");
var ToBigUint64 = require("798e0ea38d871b23");
var ToInt16 = require("c47de391ef480bd1");
var ToInt32 = require("11e515a243b995c9");
var ToInt8 = require("f37eaa7a75eab31d");
var ToUint16 = require("9c13b83256eaca8b");
var ToUint32 = require("fe94f6fcfce29463");
var ToUint8 = require("8961b715f68294b3");
var ToUint8Clamp = require("9a62921f23e9c2c6");
var valueToFloat32Bytes = require("1c19507fc58ac95b");
var valueToFloat64Bytes = require("e31c161a1898355f");
var integerToNBytes = require("2e29f06e476fa0fe");
var keys = require("30107d61308310be");
// https://262.ecma-international.org/15.0/#table-the-typedarray-constructors
var TypeToSizes = {
    __proto__: null,
    INT8: 1,
    UINT8: 1,
    UINT8C: 1,
    INT16: 2,
    UINT16: 2,
    INT32: 4,
    UINT32: 4,
    BIGINT64: 8,
    BIGUINT64: 8,
    FLOAT32: 4,
    FLOAT64: 8
};
var TypeToAO = {
    __proto__: null,
    INT8: ToInt8,
    UINT8: ToUint8,
    UINT8C: ToUint8Clamp,
    INT16: ToInt16,
    UINT16: ToUint16,
    INT32: ToInt32,
    UINT32: ToUint32,
    BIGINT64: ToBigInt64,
    BIGUINT64: ToBigUint64
};
// https://262.ecma-international.org/15.0/#sec-numerictorawbytes
module.exports = function NumericToRawBytes(type, value, isLittleEndian) {
    if (typeof type !== 'string' || !hasOwnProperty(TypeToSizes, type)) throw new $TypeError('Assertion failed: `type` must be a TypedArray element type: ' + keys(TypeToSizes));
    if (typeof value !== 'number' && typeof value !== 'bigint') throw new $TypeError('Assertion failed: `value` must be a Number or a BigInt');
    if (typeof isLittleEndian !== 'boolean') throw new $TypeError('Assertion failed: `isLittleEndian` must be a Boolean');
    if (type === 'FLOAT32') return valueToFloat32Bytes(value, isLittleEndian);
    else if (type === 'FLOAT64') return valueToFloat64Bytes(value, isLittleEndian);
     // step 3
    var n = TypeToSizes[type]; // step 3.a
    var convOp = TypeToAO[type]; // step 3.b
    var intValue = convOp(value); // step 3.c
    return integerToNBytes(intValue, n, isLittleEndian); // step 3.d, 3.e, 4
};

},{"c84e752f02e44745":"e08S4","48182bd9b09e950e":"2dTty","f18762d7cd4caaf3":"kZcry","798e0ea38d871b23":"gsmut","c47de391ef480bd1":"fOHos","11e515a243b995c9":"3l2ra","f37eaa7a75eab31d":"b8p5C","9c13b83256eaca8b":"kUevR","fe94f6fcfce29463":"lS0SP","8961b715f68294b3":"6GDuM","9a62921f23e9c2c6":"atND1","1c19507fc58ac95b":"eVhkQ","e31c161a1898355f":"6Z2nx","2e29f06e476fa0fe":"20QxS","30107d61308310be":"fEUfC"}],"kZcry":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("ccd05efd4e79a311");
var $BigInt = GetIntrinsic('%BigInt%', true);
var $pow = require("6bbcc98faa245400");
var ToBigInt = require("e37ebf70b3f8a567");
var BigIntRemainder = require("a0d1a94cd1fe93f1");
var modBigInt = require("c3ab735ab0ce6266");
// BigInt(2**63), but node v10.4-v10.8 have a bug where you can't `BigInt(x)` anything larger than MAX_SAFE_INTEGER
var twoSixtyThree = $BigInt && BigInt($pow(2, 32)) * BigInt($pow(2, 31));
// BigInt(2**64), but node v10.4-v10.8 have a bug where you can't `BigInt(x)` anything larger than MAX_SAFE_INTEGER
var twoSixtyFour = $BigInt && BigInt($pow(2, 32)) * BigInt($pow(2, 32));
// https://262.ecma-international.org/11.0/#sec-tobigint64
module.exports = function ToBigInt64(argument) {
    var n = ToBigInt(argument);
    var int64bit = modBigInt(BigIntRemainder, n, twoSixtyFour);
    return int64bit >= twoSixtyThree ? int64bit - twoSixtyFour : int64bit;
};

},{"ccd05efd4e79a311":"2umKQ","6bbcc98faa245400":"4NXOD","e37ebf70b3f8a567":"5meFL","a0d1a94cd1fe93f1":"3NCvT","c3ab735ab0ce6266":"fJwLx"}],"5meFL":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("bf5b100016a571d7");
var $BigInt = GetIntrinsic('%BigInt%', true);
var $Number = GetIntrinsic('%Number%');
var $TypeError = require("3a81a8a5732c6315");
var $SyntaxError = require("cbe2bda7f3b0a2c6");
var StringToBigInt = require("b6b07a665e48235e");
var ToPrimitive = require("59ec32721ddf03bc");
// https://262.ecma-international.org/13.0/#sec-tobigint
module.exports = function ToBigInt(argument) {
    if (!$BigInt) throw new $SyntaxError('BigInts are not supported in this environment');
    var prim = ToPrimitive(argument, $Number);
    if (prim == null) throw new $TypeError('Cannot convert null or undefined to a BigInt');
    if (typeof prim === 'boolean') return prim ? $BigInt(1) : $BigInt(0);
    if (typeof prim === 'number') throw new $TypeError('Cannot convert a Number value to a BigInt');
    if (typeof prim === 'string') {
        var n = StringToBigInt(prim);
        if (typeof n === 'undefined') throw new $TypeError('Failed to parse String to BigInt');
        return n;
    }
    if (typeof prim === 'symbol') throw new $TypeError('Cannot convert a Symbol value to a BigInt');
    if (typeof prim !== 'bigint') throw new $SyntaxError('Assertion failed: unknown primitive type');
    return prim;
};

},{"bf5b100016a571d7":"2umKQ","3a81a8a5732c6315":"e08S4","cbe2bda7f3b0a2c6":"6Pwu2","b6b07a665e48235e":"f9y9Y","59ec32721ddf03bc":"1iqtz"}],"f9y9Y":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("dc9a44d605316575");
var $BigInt = GetIntrinsic('%BigInt%', true);
var $TypeError = require("18a1d85e8c793d6f");
var $SyntaxError = require("df11828288bb632a");
// https://262.ecma-international.org/14.0/#sec-stringtobigint
module.exports = function StringToBigInt(argument) {
    if (typeof argument !== 'string') throw new $TypeError('`argument` must be a string');
    if (!$BigInt) throw new $SyntaxError('BigInts are not supported in this environment');
    try {
        return $BigInt(argument);
    } catch (e) {
        return void 0;
    }
};

},{"dc9a44d605316575":"2umKQ","18a1d85e8c793d6f":"e08S4","df11828288bb632a":"6Pwu2"}],"1iqtz":[function(require,module,exports,__globalThis) {
'use strict';
var toPrimitive = require("af5228d0a426ea3f");
// https://262.ecma-international.org/6.0/#sec-toprimitive
module.exports = function ToPrimitive(input) {
    if (arguments.length > 1) return toPrimitive(input, arguments[1]);
    return toPrimitive(input);
};

},{"af5228d0a426ea3f":"hFZm0"}],"hFZm0":[function(require,module,exports,__globalThis) {
'use strict';
var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
var isPrimitive = require("ce9e8c729dd036c1");
var isCallable = require("92c0bcca2bd991f");
var isDate = require("ba79d23e421f80b8");
var isSymbol = require("e98b7b3733b2b729");
/** @type {(O: { valueOf?: () => unknown, toString?: () => unknown }, hint: 'number' | 'string' | 'default') => null | undefined | string | symbol | number | boolean | bigint} */ var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
    if (typeof O === 'undefined' || O === null) throw new TypeError('Cannot call method on ' + O);
    if (typeof hint !== 'string' || hint !== 'number' && hint !== 'string') throw new TypeError('hint must be "string" or "number"');
    /** @type {('toString' | 'valueOf')[]} */ var methodNames = hint === 'string' ? [
        'toString',
        'valueOf'
    ] : [
        'valueOf',
        'toString'
    ];
    var method, result, i;
    for(i = 0; i < methodNames.length; ++i){
        method = O[methodNames[i]];
        if (isCallable(method)) {
            result = method.call(O);
            if (isPrimitive(result)) return result;
        }
    }
    throw new TypeError('No default value');
};
/** @type {<K extends PropertyKey>(O: Record<K, unknown>, P: K) => Function | undefined} */ var GetMethod = function GetMethod(O, P) {
    var func = O[P];
    if (func !== null && typeof func !== 'undefined') {
        if (!isCallable(func)) throw new TypeError(func + ' returned for property ' + String(P) + ' of object ' + O + ' is not a function');
        return func;
    }
    return void 0;
};
/** @type {import('./es2015')} */ // http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
module.exports = function ToPrimitive(input) {
    if (isPrimitive(input)) return input;
    /** @type {'default' | 'string' | 'number'} */ var hint = 'default';
    if (arguments.length > 1) {
        if (arguments[1] === String) hint = 'string';
        else if (arguments[1] === Number) hint = 'number';
    }
    var exoticToPrim;
    if (hasSymbols) {
        if (Symbol.toPrimitive) // eslint-disable-next-line no-extra-parens
        exoticToPrim = GetMethod(/** @type {Record<PropertyKey, unknown>} */ input, Symbol.toPrimitive);
        else if (isSymbol(input)) exoticToPrim = Symbol.prototype.valueOf;
    }
    if (typeof exoticToPrim !== 'undefined') {
        var result = exoticToPrim.call(input, hint);
        if (isPrimitive(result)) return result;
        throw new TypeError('unable to convert exotic object to primitive');
    }
    if (hint === 'default' && (isDate(input) || isSymbol(input))) hint = 'string';
    // eslint-disable-next-line no-extra-parens
    return ordinaryToPrimitive(/** @type {object} */ input, hint === 'default' ? 'number' : hint);
};

},{"ce9e8c729dd036c1":"81yr8","92c0bcca2bd991f":"9DBI4","ba79d23e421f80b8":"4fbba","e98b7b3733b2b729":"9eqXO"}],"81yr8":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {(value: unknown) => value is null | undefined | string | symbol | number | boolean | bigint} */ module.exports = function isPrimitive(value) {
    return value === null || typeof value !== 'function' && typeof value !== 'object';
};

},{}],"4fbba":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("f7aa53f619d004c5");
var getDay = callBound('Date.prototype.getDay');
/** @type {import('.')} */ var tryDateObject = function tryDateGetDayCall(value) {
    try {
        getDay(value);
        return true;
    } catch (e) {
        return false;
    }
};
/** @type {(value: unknown) => string} */ var toStr = callBound('Object.prototype.toString');
var dateClass = '[object Date]';
var hasToStringTag = require("a0fda07f3b6c493a")();
/** @type {import('.')} */ module.exports = function isDateObject(value) {
    if (typeof value !== 'object' || value === null) return false;
    return hasToStringTag ? tryDateObject(value) : toStr(value) === dateClass;
};

},{"f7aa53f619d004c5":"8ZomV","a0fda07f3b6c493a":"ebyHr"}],"9eqXO":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("ff444bb3649385a8");
var $toString = callBound('Object.prototype.toString');
var hasSymbols = require("19da2b43c74a37a0")();
var safeRegexTest = require("d20208420ab81532");
if (hasSymbols) {
    var $symToStr = callBound('Symbol.prototype.toString');
    var isSymString = safeRegexTest(/^Symbol\(.*\)$/);
    /** @type {(value: object) => value is Symbol} */ var isSymbolObject = function isRealSymbolObject(value) {
        if (typeof value.valueOf() !== 'symbol') return false;
        return isSymString($symToStr(value));
    };
    /** @type {import('.')} */ module.exports = function isSymbol(value) {
        if (typeof value === 'symbol') return true;
        if (!value || typeof value !== 'object' || $toString(value) !== '[object Symbol]') return false;
        try {
            return isSymbolObject(value);
        } catch (e) {
            return false;
        }
    };
} else /** @type {import('.')} */ module.exports = function isSymbol(value) {
    // this environment does not support Symbols.
    return false;
};

},{"ff444bb3649385a8":"8ZomV","19da2b43c74a37a0":"9nYRo","d20208420ab81532":"2WKic"}],"3NCvT":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("12fddae312e4acf2");
var $BigInt = GetIntrinsic('%BigInt%', true);
var $RangeError = require("b16bd6e0235f7230");
var $TypeError = require("6f1170c4eed2de95");
var zero = $BigInt && $BigInt(0);
// https://262.ecma-international.org/11.0/#sec-numeric-types-bigint-remainder
module.exports = function BigIntRemainder(n, d) {
    if (typeof n !== 'bigint' || typeof d !== 'bigint') throw new $TypeError('Assertion failed: `n` and `d` arguments must be BigInts');
    if (d === zero) throw new $RangeError('Division by zero');
    if (n === zero) return zero;
    // shortcut for the actual spec mechanics
    return n % d;
};

},{"12fddae312e4acf2":"2umKQ","b16bd6e0235f7230":"jdhJj","6f1170c4eed2de95":"e08S4"}],"fJwLx":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function bigIntMod(BigIntRemainder, bigint, modulo) {
    var remain = BigIntRemainder(bigint, modulo);
    return remain >= 0 ? remain : remain + modulo;
};

},{}],"gsmut":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("6c2a339a66cf6ae2");
var $BigInt = GetIntrinsic('%BigInt%', true);
var $pow = require("1b507868fb7c0509");
var ToBigInt = require("650144d951545508");
var BigIntRemainder = require("15d2014dbcfd1b14");
var modBigInt = require("4980a26928fed12b");
// BigInt(2**64), but node v10.4-v10.8 have a bug where you can't `BigInt(x)` anything larger than MAX_SAFE_INTEGER
var twoSixtyFour = $BigInt && BigInt($pow(2, 32)) * BigInt($pow(2, 32));
// https://262.ecma-international.org/11.0/#sec-tobiguint64
module.exports = function ToBigUint64(argument) {
    var n = ToBigInt(argument);
    var int64bit = modBigInt(BigIntRemainder, n, twoSixtyFour);
    return int64bit;
};

},{"6c2a339a66cf6ae2":"2umKQ","1b507868fb7c0509":"4NXOD","650144d951545508":"5meFL","15d2014dbcfd1b14":"3NCvT","4980a26928fed12b":"fJwLx"}],"fOHos":[function(require,module,exports,__globalThis) {
'use strict';
var modulo = require("f06f75b692ba2e8b");
var ToNumber = require("9f523d717b4a602b");
var truncate = require("aada065ccf63823f");
var isFinite = require("f1afa771fb0b444c");
// https://262.ecma-international.org/14.0/#sec-toint16
var two16 = 0x10000; // Math.pow(2, 16);
module.exports = function ToInt16(argument) {
    var number = ToNumber(argument);
    if (!isFinite(number) || number === 0) return 0;
    var int = truncate(number);
    var int16bit = modulo(int, two16);
    return int16bit >= 0x8000 ? int16bit - two16 : int16bit;
};

},{"f06f75b692ba2e8b":"jwZ3F","9f523d717b4a602b":"iesaX","aada065ccf63823f":"7M7tx","f1afa771fb0b444c":"4HRNi"}],"jwZ3F":[function(require,module,exports,__globalThis) {
'use strict';
var mod = require("f0abeb35e96fcc6f");
// https://262.ecma-international.org/5.1/#sec-5.2
module.exports = function modulo(x, y) {
    return mod(x, y);
};

},{"f0abeb35e96fcc6f":"GJ8AQ"}],"GJ8AQ":[function(require,module,exports,__globalThis) {
'use strict';
// TODO, semver-major: delete
module.exports = require("e41fecc6f60d01ee");

},{"e41fecc6f60d01ee":"6aKuT"}],"6aKuT":[function(require,module,exports,__globalThis) {
'use strict';
var $floor = require("7c1f12202e56042");
/** @type {import('./mod')} */ module.exports = function mod(number, modulo) {
    var remain = number % modulo;
    return $floor(remain >= 0 ? remain : remain + modulo);
};

},{"7c1f12202e56042":"iiSoG"}],"iesaX":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("26ac6ba987f0fe3c");
var $TypeError = require("45810fe6dc91bb26");
var $Number = GetIntrinsic('%Number%');
var isPrimitive = require("bc07e4c7860ac242");
var ToPrimitive = require("bef930c0acf22e84");
var StringToNumber = require("17d4bc75f5b28e05");
// https://262.ecma-international.org/13.0/#sec-tonumber
module.exports = function ToNumber(argument) {
    var value = isPrimitive(argument) ? argument : ToPrimitive(argument, $Number);
    if (typeof value === 'symbol') throw new $TypeError('Cannot convert a Symbol value to a number');
    if (typeof value === 'bigint') throw new $TypeError('Conversion from \'BigInt\' to \'number\' is not allowed.');
    if (typeof value === 'string') return StringToNumber(value);
    return +value;
};

},{"26ac6ba987f0fe3c":"2umKQ","45810fe6dc91bb26":"e08S4","bc07e4c7860ac242":"cfAWs","bef930c0acf22e84":"1iqtz","17d4bc75f5b28e05":"lwSuZ"}],"cfAWs":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function isPrimitive(value) {
    return value === null || typeof value !== 'function' && typeof value !== 'object';
};

},{}],"lwSuZ":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("fe898a6137715b0f");
var $RegExp = GetIntrinsic('%RegExp%');
var $TypeError = require("90742725ae171cd3");
var $parseInteger = GetIntrinsic('%parseInt%');
var callBound = require("c29128433ff86fb3");
var regexTester = require("416e10b860950269");
var $strSlice = callBound('String.prototype.slice');
var isBinary = regexTester(/^0b[01]+$/i);
var isOctal = regexTester(/^0o[0-7]+$/i);
var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
var nonWS = [
    '\u0085',
    '\u200b',
    '\ufffe'
].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = regexTester(nonWSregex);
var $trim = require("52fcdf9e6aca66e");
// https://262.ecma-international.org/13.0/#sec-stringtonumber
module.exports = function StringToNumber(argument) {
    if (typeof argument !== 'string') throw new $TypeError('Assertion failed: `argument` is not a String');
    if (isBinary(argument)) return +$parseInteger($strSlice(argument, 2), 2);
    if (isOctal(argument)) return +$parseInteger($strSlice(argument, 2), 8);
    if (hasNonWS(argument) || isInvalidHexLiteral(argument)) return NaN;
    var trimmed = $trim(argument);
    if (trimmed !== argument) return StringToNumber(trimmed);
    return +argument;
};

},{"fe898a6137715b0f":"2umKQ","90742725ae171cd3":"e08S4","c29128433ff86fb3":"8ZomV","416e10b860950269":"2WKic","52fcdf9e6aca66e":"fFQWi"}],"fFQWi":[function(require,module,exports,__globalThis) {
'use strict';
var callBind = require("cb54086d750bde5a");
var define = require("e45c3966791855be");
var RequireObjectCoercible = require("7e2f33509d03556e");
var implementation = require("4c0cbe299aec9a10");
var getPolyfill = require("e3d8c7918535bb39");
var shim = require("5f21cf28bd17a9f2");
var bound = callBind(getPolyfill());
var boundMethod = function trim(receiver) {
    RequireObjectCoercible(receiver);
    return bound(receiver);
};
define(boundMethod, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = boundMethod;

},{"cb54086d750bde5a":"4HjpY","e45c3966791855be":"ak2Bc","7e2f33509d03556e":"36gx5","4c0cbe299aec9a10":"52kqB","e3d8c7918535bb39":"95C8x","5f21cf28bd17a9f2":"3nzjT"}],"36gx5":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("7a8f85b6ac57aec7");
/** @type {import('./RequireObjectCoercible')} */ module.exports = function RequireObjectCoercible(value) {
    if (value == null) throw new $TypeError(arguments.length > 0 && arguments[1] || 'Cannot call method on ' + value);
    return value;
};

},{"7a8f85b6ac57aec7":"e08S4"}],"52kqB":[function(require,module,exports,__globalThis) {
'use strict';
var RequireObjectCoercible = require("f734a0b689dda1d2");
var ToString = require("57c1b66912150b1f");
var callBound = require("ed0014c27c63b1c5");
var $replace = callBound('String.prototype.replace');
var mvsIsWS = /^\s$/.test('\u180E');
/* eslint-disable no-control-regex */ var leftWhitespace = mvsIsWS ? /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/ : /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
var rightWhitespace = mvsIsWS ? /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/ : /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;
/* eslint-enable no-control-regex */ module.exports = function trim() {
    var S = ToString(RequireObjectCoercible(this));
    return $replace($replace(S, leftWhitespace, ''), rightWhitespace, '');
};

},{"f734a0b689dda1d2":"36gx5","57c1b66912150b1f":"8fcbW","ed0014c27c63b1c5":"8ZomV"}],"8fcbW":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("aa9b6cde95698212");
var $String = GetIntrinsic('%String%');
var $TypeError = require("7026f77497f66000");
// https://262.ecma-international.org/6.0/#sec-tostring
module.exports = function ToString(argument) {
    if (typeof argument === 'symbol') throw new $TypeError('Cannot convert a Symbol value to a string');
    return $String(argument);
};

},{"aa9b6cde95698212":"2umKQ","7026f77497f66000":"e08S4"}],"95C8x":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("4c26705dde2546f2");
var zeroWidthSpace = '\u200b';
var mongolianVowelSeparator = '\u180E';
module.exports = function getPolyfill() {
    if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace && mongolianVowelSeparator.trim() === mongolianVowelSeparator && ('_' + mongolianVowelSeparator).trim() === '_' + mongolianVowelSeparator && (mongolianVowelSeparator + '_').trim() === mongolianVowelSeparator + '_') return String.prototype.trim;
    return implementation;
};

},{"4c26705dde2546f2":"52kqB"}],"3nzjT":[function(require,module,exports,__globalThis) {
'use strict';
var supportsDescriptors = require("228708157ff9fb18")();
var defineDataProperty = require("cc757f84e24f26d4");
var getPolyfill = require("be5d6cfb6d22b05");
module.exports = function shimStringTrim() {
    var polyfill = getPolyfill();
    if (String.prototype.trim !== polyfill) {
        if (supportsDescriptors) defineDataProperty(String.prototype, 'trim', polyfill, true);
        else defineDataProperty(String.prototype, 'trim', polyfill);
    }
    return polyfill;
};

},{"228708157ff9fb18":"he0V7","cc757f84e24f26d4":"eqaar","be5d6cfb6d22b05":"95C8x"}],"7M7tx":[function(require,module,exports,__globalThis) {
'use strict';
var floor = require("42a607cc20169b05");
var $TypeError = require("2a7fde71379eebf0");
// https://262.ecma-international.org/14.0/#eqn-truncate
module.exports = function truncate(x) {
    if (typeof x !== 'number' && typeof x !== 'bigint') throw new $TypeError('argument must be a Number or a BigInt');
    var result = x < 0 ? -floor(-x) : floor(x);
    return result === 0 ? 0 : result; // in the spec, these are math values, so we filter out -0 here
};

},{"42a607cc20169b05":"kWsp2","2a7fde71379eebf0":"e08S4"}],"kWsp2":[function(require,module,exports,__globalThis) {
'use strict';
// var modulo = require('./modulo');
var $floor = require("64839d2dc3f75584");
// http://262.ecma-international.org/11.0/#eqn-floor
module.exports = function floor(x) {
    // return x - modulo(x, 1);
    if (typeof x === 'bigint') return x;
    return $floor(x);
};

},{"64839d2dc3f75584":"iiSoG"}],"3l2ra":[function(require,module,exports,__globalThis) {
'use strict';
var modulo = require("5f4e7a9b26a1f4eb");
var ToNumber = require("f6669c2e3278cfbb");
var truncate = require("f484771bfb2fe603");
var isFinite = require("8ee3734a27429068");
// https://262.ecma-international.org/14.0/#sec-toint32
var two31 = 0x80000000; // Math.pow(2, 31);
var two32 = 0x100000000; // Math.pow(2, 32);
module.exports = function ToInt32(argument) {
    var number = ToNumber(argument);
    if (!isFinite(number) || number === 0) return 0;
    var int = truncate(number);
    var int32bit = modulo(int, two32);
    var result = int32bit >= two31 ? int32bit - two32 : int32bit;
    return result === 0 ? 0 : result; // in the spec, these are math values, so we filter out -0 here
};

},{"5f4e7a9b26a1f4eb":"jwZ3F","f6669c2e3278cfbb":"iesaX","f484771bfb2fe603":"7M7tx","8ee3734a27429068":"4HRNi"}],"b8p5C":[function(require,module,exports,__globalThis) {
'use strict';
var modulo = require("9a1cbd3086141339");
var ToNumber = require("9bdfc2e2ce6c45a8");
var truncate = require("3000f7a2ae04068a");
var isFinite = require("8b8270619405e46a");
// https://262.ecma-international.org/14.0/#sec-toint8
module.exports = function ToInt8(argument) {
    var number = ToNumber(argument);
    if (!isFinite(number) || number === 0) return 0;
    var int = truncate(number);
    var int8bit = modulo(int, 0x100);
    return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
};

},{"9a1cbd3086141339":"jwZ3F","9bdfc2e2ce6c45a8":"iesaX","3000f7a2ae04068a":"7M7tx","8b8270619405e46a":"4HRNi"}],"kUevR":[function(require,module,exports,__globalThis) {
'use strict';
var modulo = require("198969c443a8185a");
var ToNumber = require("ca77bea0778f73e1");
var truncate = require("6bd816d99880742b");
var isFinite = require("eb076017b9bf099c");
// https://262.ecma-international.org/14.0/#sec-touint16
var two16 = 0x10000; // Math.pow(2, 16)
module.exports = function ToUint16(argument) {
    var number = ToNumber(argument);
    if (!isFinite(number) || number === 0) return 0;
    var int = truncate(number);
    var int16bit = modulo(int, two16);
    return int16bit === 0 ? 0 : int16bit; // in the spec, these are math values, so we filter out -0 here
};

},{"198969c443a8185a":"jwZ3F","ca77bea0778f73e1":"iesaX","6bd816d99880742b":"7M7tx","eb076017b9bf099c":"4HRNi"}],"lS0SP":[function(require,module,exports,__globalThis) {
'use strict';
var modulo = require("703b08a4a01ff117");
var ToNumber = require("9c6a95a8a404015d");
var truncate = require("37a4d6e9b5ec15e8");
var isFinite = require("f439c562708db15");
// https://262.ecma-international.org/14.0/#sec-touint32
var two32 = 0x100000000; // Math.pow(2, 32);
module.exports = function ToUint32(argument) {
    var number = ToNumber(argument);
    if (!isFinite(number) || number === 0) return 0;
    var int = truncate(number);
    var int32bit = modulo(int, two32);
    return int32bit === 0 ? 0 : int32bit; // in the spec, these are math values, so we filter out -0 here
};

},{"703b08a4a01ff117":"jwZ3F","9c6a95a8a404015d":"iesaX","37a4d6e9b5ec15e8":"7M7tx","f439c562708db15":"4HRNi"}],"6GDuM":[function(require,module,exports,__globalThis) {
'use strict';
var isFinite = require("22b6c11634558d09");
var modulo = require("e284e12c8bd73ca1");
var ToNumber = require("23ae8b12c4b1f2f6");
var truncate = require("fc5514d8b02b3edd");
// https://262.ecma-international.org/14.0/#sec-touint8
module.exports = function ToUint8(argument) {
    var number = ToNumber(argument);
    if (!isFinite(number) || number === 0) return 0;
    var int = truncate(number);
    var int8bit = modulo(int, 0x100);
    return int8bit;
};

},{"22b6c11634558d09":"4HRNi","e284e12c8bd73ca1":"jwZ3F","23ae8b12c4b1f2f6":"iesaX","fc5514d8b02b3edd":"7M7tx"}],"atND1":[function(require,module,exports,__globalThis) {
'use strict';
var clamp = require("2eeb8a5901c18272");
var ToNumber = require("9b80b008cd860068");
var floor = require("35f5470bbbc2f41");
var $isNaN = require("95f128d91ddb54f");
// https://262.ecma-international.org/15.0/#sec-touint8clamp
module.exports = function ToUint8Clamp(argument) {
    var number = ToNumber(argument); // step 1
    if ($isNaN(number)) return 0;
     // step 2
    var clamped = clamp(number, 0, 255); // step 4
    var f = floor(clamped); // step 5
    if (clamped < f + 0.5) return f;
     // step 6
    if (clamped > f + 0.5) return f + 1;
     // step 7
    return f % 2 === 0 ? f : f + 1; // step 8
};

},{"2eeb8a5901c18272":"4mJyM","9b80b008cd860068":"iesaX","35f5470bbbc2f41":"kWsp2","95f128d91ddb54f":"i8IDp"}],"4mJyM":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("133f92718b379692");
var max = require("324eba6ee6b23091");
var min = require("83dbc15c55506fbd");
// https://262.ecma-international.org/12.0/#clamping
module.exports = function clamp(x, lower, upper) {
    if (typeof x !== 'number' || typeof lower !== 'number' || typeof upper !== 'number' || !(lower <= upper)) throw new $TypeError('Assertion failed: all three arguments must be MVs, and `lower` must be `<= upper`');
    return min(max(lower, x), upper);
};

},{"133f92718b379692":"e08S4","324eba6ee6b23091":"58Q7H","83dbc15c55506fbd":"ct1xo"}],"eVhkQ":[function(require,module,exports,__globalThis) {
'use strict';
var $abs = require("27cc83fceeb29eb5");
var $floor = require("c6b3c33bd4f6593c");
var $pow = require("9db86deb4fa071ed");
var isFinite = require("358a61e41bc4a70c");
var isNaN = require("2014ef6603b74d3e");
var isNegativeZero = require("1957435f7346ec5b");
var maxFiniteFloat32 = 3.4028234663852886e+38; // roughly 2 ** 128 - 1
module.exports = function valueToFloat32Bytes(value, isLittleEndian) {
    if (isNaN(value)) return isLittleEndian ? [
        0,
        0,
        192,
        127
    ] : [
        127,
        192,
        0,
        0
    ]; // hardcoded
    var leastSig;
    if (value === 0) {
        leastSig = isNegativeZero(value) ? 0x80 : 0;
        return isLittleEndian ? [
            0,
            0,
            0,
            leastSig
        ] : [
            leastSig,
            0,
            0,
            0
        ];
    }
    if ($abs(value) > maxFiniteFloat32 || !isFinite(value)) {
        leastSig = value < 0 ? 255 : 127;
        return isLittleEndian ? [
            0,
            0,
            128,
            leastSig
        ] : [
            leastSig,
            128,
            0,
            0
        ];
    }
    var sign = value < 0 ? 1 : 0;
    value = $abs(value); // eslint-disable-line no-param-reassign
    var exponent = 0;
    while(value >= 2){
        exponent += 1;
        value /= 2; // eslint-disable-line no-param-reassign
    }
    while(value < 1){
        exponent -= 1;
        value *= 2; // eslint-disable-line no-param-reassign
    }
    var mantissa = value - 1;
    mantissa *= $pow(2, 23) + 0.5;
    mantissa = $floor(mantissa);
    exponent += 127;
    exponent <<= 23;
    var result = sign << 31 | exponent | mantissa;
    var byte0 = result & 255;
    result >>= 8;
    var byte1 = result & 255;
    result >>= 8;
    var byte2 = result & 255;
    result >>= 8;
    var byte3 = result & 255;
    if (isLittleEndian) return [
        byte0,
        byte1,
        byte2,
        byte3
    ];
    return [
        byte3,
        byte2,
        byte1,
        byte0
    ];
};

},{"27cc83fceeb29eb5":"7TMfH","c6b3c33bd4f6593c":"iiSoG","9db86deb4fa071ed":"4NXOD","358a61e41bc4a70c":"4HRNi","2014ef6603b74d3e":"i8IDp","1957435f7346ec5b":"d3MdZ"}],"d3MdZ":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./isNegativeZero')} */ module.exports = function isNegativeZero(x) {
    return x === 0 && 1 / x === 1 / -0;
};

},{}],"6Z2nx":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("14a72171403f654");
var $parseInt = GetIntrinsic('%parseInt%');
var $abs = require("3ec805beb9ff8a97");
var $floor = require("f5fde1ea1f2294f7");
var isNegativeZero = require("7441b4d3939c5482");
var callBound = require("488741aa3ab80c36");
var $strIndexOf = callBound('String.prototype.indexOf');
var $strSlice = callBound('String.prototype.slice');
var fractionToBitString = require("29470255bcc407e0");
var intToBinString = require("52398839375358c5");
var float64bias = 1023;
var elevenOnes = '11111111111';
var elevenZeroes = '00000000000';
var fiftyOneZeroes = elevenZeroes + elevenZeroes + elevenZeroes + elevenZeroes + '0000000';
// IEEE 754-1985
module.exports = function valueToFloat64Bytes(value, isLittleEndian) {
    var signBit = value < 0 || isNegativeZero(value) ? '1' : '0';
    var exponentBits;
    var significandBits;
    if (isNaN(value)) {
        exponentBits = elevenOnes;
        significandBits = '1' + fiftyOneZeroes;
    } else if (!isFinite(value)) {
        exponentBits = elevenOnes;
        significandBits = '0' + fiftyOneZeroes;
    } else if (value === 0) {
        exponentBits = elevenZeroes;
        significandBits = '0' + fiftyOneZeroes;
    } else {
        value = $abs(value); // eslint-disable-line no-param-reassign
        // Isolate the integer part (digits before the decimal):
        var integerPart = $floor(value);
        var intBinString = intToBinString(integerPart); // bit string for integer part
        var fracBinString = fractionToBitString(value - integerPart); // bit string for fractional part
        var numberOfBits;
        // find exponent needed to normalize integer+fractional parts
        if (intBinString) exponentBits = intBinString.length - 1; // move the decimal to the left
        else {
            var first1 = $strIndexOf(fracBinString, '1');
            if (first1 > -1) numberOfBits = first1 + 1;
            exponentBits = -numberOfBits; // move the decimal to the right
        }
        significandBits = intBinString + fracBinString;
        if (exponentBits < 0) {
            // subnormals
            if (exponentBits <= -float64bias) numberOfBits = float64bias - 1; // limit number of removed bits
            significandBits = $strSlice(significandBits, numberOfBits); // remove all leading 0s and the first 1 for normal values; for subnormals, remove up to `float64bias - 1` leading bits
        } else significandBits = $strSlice(significandBits, 1); // remove the leading '1' (implicit/hidden bit)
        exponentBits = $strSlice(elevenZeroes + intToBinString(exponentBits + float64bias), -11); // Convert the exponent to a bit string
        significandBits = $strSlice(significandBits + fiftyOneZeroes + '0', 0, 52); // fill in any trailing zeros and ensure we have only 52 fraction bits
    }
    var bits = signBit + exponentBits + significandBits;
    var rawBytes = [];
    for(var i = 0; i < 8; i++){
        var targetIndex = isLittleEndian ? 8 - i - 1 : i;
        rawBytes[targetIndex] = $parseInt($strSlice(bits, i * 8, (i + 1) * 8), 2);
    }
    return rawBytes;
};

},{"14a72171403f654":"2umKQ","3ec805beb9ff8a97":"7TMfH","f5fde1ea1f2294f7":"iiSoG","7441b4d3939c5482":"d3MdZ","488741aa3ab80c36":"8ZomV","29470255bcc407e0":"g9Exr","52398839375358c5":"bIGZt"}],"g9Exr":[function(require,module,exports,__globalThis) {
'use strict';
var MAX_ITER = 1075; // 1023+52 (subnormals) => BIAS+NUM_SIGNFICAND_BITS-1
var maxBits = 54; // only 53 bits for fraction
module.exports = function fractionToBitString(x) {
    var str = '';
    if (x === 0) return str;
    var j = MAX_ITER;
    var y;
    // Each time we multiply by 2 and find a ones digit, add a '1'; otherwise, add a '0'..
    for(var i = 0; i < MAX_ITER; i += 1){
        y = x * 2;
        if (y >= 1) {
            x = y - 1; // eslint-disable-line no-param-reassign
            str += '1';
            if (j === MAX_ITER) j = i; // first 1
        } else {
            x = y; // eslint-disable-line no-param-reassign
            str += '0';
        }
        // Stop when we have no more decimals to process or in the event we found a fraction which cannot be represented in a finite number of bits...
        if (y === 1 || i - j > maxBits) return str;
    }
    return str;
};

},{}],"bIGZt":[function(require,module,exports,__globalThis) {
'use strict';
var $floor = require("733c8062b39fb23c");
// https://runestone.academy/ns/books/published/pythonds/BasicDS/ConvertingDecimalNumberstoBinaryNumbers.html#:~:text=The%20Divide%20by%202%20algorithm,have%20a%20remainder%20of%200
module.exports = function intToBinaryString(x) {
    var str = '';
    var y;
    while(x > 0){
        y = x / 2;
        x = $floor(y); // eslint-disable-line no-param-reassign
        if (y === x) str = '0' + str;
        else str = '1' + str;
    }
    return str;
};

},{"733c8062b39fb23c":"iiSoG"}],"20QxS":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("223e0ac6fd77d531");
var $Number = GetIntrinsic('%Number%');
var $BigInt = GetIntrinsic('%BigInt%', true);
module.exports = function integerToNBytes(intValue, n, isLittleEndian) {
    var Z = typeof intValue === 'bigint' ? $BigInt : $Number;
    /*
	if (intValue >= 0) { // step 3.d
		// Let rawBytes be a List containing the n-byte binary encoding of intValue. If isLittleEndian is false, the bytes are ordered in big endian order. Otherwise, the bytes are ordered in little endian order.
	} else { // step 3.e
		// Let rawBytes be a List containing the n-byte binary 2's complement encoding of intValue. If isLittleEndian is false, the bytes are ordered in big endian order. Otherwise, the bytes are ordered in little endian order.
	}
    */ if (intValue < 0) intValue >>>= 0; // eslint-disable-line no-param-reassign
    var rawBytes = [];
    for(var i = 0; i < n; i++){
        rawBytes[isLittleEndian ? i : n - 1 - i] = $Number(intValue & Z(0xFF));
        intValue >>= Z(8); // eslint-disable-line no-param-reassign
    }
    return rawBytes; // step 4
};

},{"223e0ac6fd77d531":"2umKQ"}],"8zRKQ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function forEach(array, callback) {
    for(var i = 0; i < array.length; i += 1)callback(array[i], i, array); // eslint-disable-line callback-return
};

},{}],"hM9ML":[function(require,module,exports,__globalThis) {
'use strict';
var ToNumber = require("c98b913dd22c84db");
var truncate = require("64835638b42e236f");
var $isNaN = require("4ce9e06aebf9cb6e");
var $isFinite = require("6539da0041d11565");
// https://262.ecma-international.org/14.0/#sec-tointegerorinfinity
module.exports = function ToIntegerOrInfinity(value) {
    var number = ToNumber(value);
    if ($isNaN(number) || number === 0) return 0;
    if (!$isFinite(number)) return number;
    return truncate(number);
};

},{"c98b913dd22c84db":"iesaX","64835638b42e236f":"7M7tx","4ce9e06aebf9cb6e":"i8IDp","6539da0041d11565":"4HRNi"}],"hgopq":[function(require,module,exports,__globalThis) {
'use strict';
var $SyntaxError = require("6a37d99c1af78869");
var $TypeError = require("6bf10734847ff385");
var isInteger = require("f54c8a9b347c98ed");
var whichTypedArray = require("1561820b2a8a8bc2");
// https://262.ecma-international.org/13.0/#sec-typedarrayelementsize
var tableTAO = require("7bd57c7821773fb9");
module.exports = function TypedArrayElementSize(O) {
    var type = whichTypedArray(O);
    if (!type) throw new $TypeError('Assertion failed: `O` must be a TypedArray');
    var size = tableTAO.size['$' + tableTAO.name['$' + type]];
    if (!isInteger(size) || size < 0) throw new $SyntaxError('Assertion failed: Unknown TypedArray type `' + type + '`');
    return size;
};

},{"6a37d99c1af78869":"6Pwu2","6bf10734847ff385":"e08S4","f54c8a9b347c98ed":"3MEYt","1561820b2a8a8bc2":"e0N37","7bd57c7821773fb9":"4BG8z"}],"afj6G":[function(require,module,exports,__globalThis) {
'use strict';
var $SyntaxError = require("a4ac78ed13f569e4");
var $TypeError = require("50cf526966245ccb");
var whichTypedArray = require("b869eaf3e7d00f07");
// https://262.ecma-international.org/13.0/#sec-typedarrayelementtype
var tableTAO = require("ae28d7e68fb22827");
module.exports = function TypedArrayElementType(O) {
    var type = whichTypedArray(O);
    if (!type) throw new $TypeError('Assertion failed: `O` must be a TypedArray');
    var result = tableTAO.name['$' + type];
    if (typeof result !== 'string') throw new $SyntaxError('Assertion failed: Unknown TypedArray type `' + type + '`');
    return result;
};

},{"a4ac78ed13f569e4":"6Pwu2","50cf526966245ccb":"e08S4","b869eaf3e7d00f07":"e0N37","ae28d7e68fb22827":"4BG8z"}],"fyuE2":[function(require,module,exports,__globalThis) {
'use strict';
var $SyntaxError = require("fdc691fccdf225a8");
var $TypeError = require("bf7dedbb5b1611a6");
var whichTypedArray = require("fb6c4d1ff9d0beae");
var availableTypedArrays = require("d77f87d87730bf03")();
var IsArray = require("e5e019d6d275517c");
var SpeciesConstructor = require("2c5f955ec57345df");
var TypedArrayCreateFromConstructor = require("2ae68fc3fecd9703");
var getConstructor = require("2432e9de08f70b0a");
// https://262.ecma-international.org/15.0/#typedarray-species-create
module.exports = function TypedArraySpeciesCreate(exemplar, argumentList) {
    if (availableTypedArrays.length === 0) throw new $SyntaxError('Assertion failed: Typed Arrays are not supported in this environment');
    var kind = whichTypedArray(exemplar);
    if (!kind) throw new $TypeError('Assertion failed: exemplar must be a TypedArray'); // step 1
    if (!IsArray(argumentList)) throw new $TypeError('Assertion failed: `argumentList` must be a List'); // step 1
    var defaultConstructor = getConstructor(kind); // step 2
    if (typeof defaultConstructor !== 'function') throw new $SyntaxError('Assertion failed: `constructor` of `exemplar` (' + kind + ') must exist. Please report this!');
    var constructor = SpeciesConstructor(exemplar, defaultConstructor); // step 3
    return TypedArrayCreateFromConstructor(constructor, argumentList); // step 4
};

},{"fdc691fccdf225a8":"6Pwu2","bf7dedbb5b1611a6":"e08S4","fb6c4d1ff9d0beae":"e0N37","d77f87d87730bf03":"jCTS7","e5e019d6d275517c":"hl3iI","2c5f955ec57345df":"dGZ0y","2ae68fc3fecd9703":"l7TV6","2432e9de08f70b0a":"eZxnG"}],"dGZ0y":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("b82c4b4a5a46ddd3");
var $species = GetIntrinsic('%Symbol.species%', true);
var $TypeError = require("4d21defd189c095d");
var IsConstructor = require("9c3c385f03712185");
var isObject = require("9c236815ca7895ed");
// https://262.ecma-international.org/6.0/#sec-speciesconstructor
module.exports = function SpeciesConstructor(O, defaultConstructor) {
    if (!isObject(O)) throw new $TypeError('Assertion failed: Type(O) is not Object');
    var C = O.constructor;
    if (typeof C === 'undefined') return defaultConstructor;
    if (!isObject(C)) throw new $TypeError('O.constructor is not an Object');
    var S = $species ? C[$species] : void 0;
    if (S == null) return defaultConstructor;
    if (IsConstructor(S)) return S;
    throw new $TypeError('no constructor found');
};

},{"b82c4b4a5a46ddd3":"2umKQ","4d21defd189c095d":"e08S4","9c3c385f03712185":"5ohaP","9c236815ca7895ed":"axMar"}],"5ohaP":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("680dc23aa24e50f5");
var $construct = GetIntrinsic('%Reflect.construct%', true);
var DefinePropertyOrThrow = require("943b86ff66315179");
try {
    DefinePropertyOrThrow({}, '', {
        '[[Get]]': function() {}
    });
} catch (e) {
    // Accessor properties aren't supported
    DefinePropertyOrThrow = null;
}
// https://262.ecma-international.org/6.0/#sec-isconstructor
if (DefinePropertyOrThrow && $construct) {
    var isConstructorMarker = {};
    var badArrayLike = {};
    DefinePropertyOrThrow(badArrayLike, 'length', {
        '[[Get]]': function() {
            throw isConstructorMarker;
        },
        '[[Enumerable]]': true
    });
    module.exports = function IsConstructor(argument) {
        try {
            // `Reflect.construct` invokes `IsConstructor(target)` before `Get(args, 'length')`:
            $construct(argument, badArrayLike);
        } catch (err) {
            return err === isConstructorMarker;
        }
    };
} else module.exports = function IsConstructor(argument) {
    // unfortunately there's no way to truly check this without try/catch `new argument` in old environments
    return typeof argument === 'function' && !!argument.prototype;
};

},{"680dc23aa24e50f5":"56pI7","943b86ff66315179":"ib1cO"}],"56pI7":[function(require,module,exports,__globalThis) {
'use strict';
// TODO: remove, semver-major
module.exports = require("31749184ab120120");

},{"31749184ab120120":"2umKQ"}],"ib1cO":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("b01ae337b71c5ff1");
var isPropertyDescriptor = require("32601f692edc457a");
var DefineOwnProperty = require("e237fdaf5cafaae7");
var FromPropertyDescriptor = require("46c7e2a5e088b06e");
var IsDataDescriptor = require("985fff3c6dd04ec9");
var isPropertyKey = require("4cf4bda5d91a9aeb");
var SameValue = require("1254f73361b1d1c5");
var ToPropertyDescriptor = require("c14d7689913fe05f");
var isObject = require("be30f778178bfc43");
// https://262.ecma-international.org/6.0/#sec-definepropertyorthrow
module.exports = function DefinePropertyOrThrow(O, P, desc) {
    if (!isObject(O)) throw new $TypeError('Assertion failed: Type(O) is not Object');
    if (!isPropertyKey(P)) throw new $TypeError('Assertion failed: P is not a Property Key');
    var Desc = isPropertyDescriptor(desc) ? desc : ToPropertyDescriptor(desc);
    if (!isPropertyDescriptor(Desc)) throw new $TypeError('Assertion failed: Desc is not a valid Property Descriptor');
    return DefineOwnProperty(IsDataDescriptor, SameValue, FromPropertyDescriptor, O, P, Desc);
};

},{"b01ae337b71c5ff1":"e08S4","32601f692edc457a":"3LqBz","e237fdaf5cafaae7":"hhoQX","46c7e2a5e088b06e":"rBL0O","985fff3c6dd04ec9":"hjPO1","4cf4bda5d91a9aeb":"33Tnt","1254f73361b1d1c5":"eYP2G","c14d7689913fe05f":"wTbya","be30f778178bfc43":"axMar"}],"3LqBz":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("3ee3916f0fe5a6fa");
var hasOwn = require("6df726afbdac3428");
var allowed = {
    __proto__: null,
    '[[Configurable]]': true,
    '[[Enumerable]]': true,
    '[[Get]]': true,
    '[[Set]]': true,
    '[[Value]]': true,
    '[[Writable]]': true
};
// https://262.ecma-international.org/6.0/#sec-property-descriptor-specification-type
module.exports = function isPropertyDescriptor(Desc) {
    if (!Desc || typeof Desc !== 'object') return false;
    for(var key in Desc){
        if (hasOwn(Desc, key) && !allowed[key]) return false;
    }
    var isData = hasOwn(Desc, '[[Value]]') || hasOwn(Desc, '[[Writable]]');
    var IsAccessor = hasOwn(Desc, '[[Get]]') || hasOwn(Desc, '[[Set]]');
    if (isData && IsAccessor) throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
    return true;
};

},{"3ee3916f0fe5a6fa":"e08S4","6df726afbdac3428":"oWOGY"}],"hhoQX":[function(require,module,exports,__globalThis) {
'use strict';
var hasPropertyDescriptors = require("da62d0feb68dd33e");
var $defineProperty = require("c69e3efc3fccbf9e");
var hasArrayLengthDefineBug = hasPropertyDescriptors.hasArrayLengthDefineBug();
// eslint-disable-next-line global-require
var isArray = hasArrayLengthDefineBug && require("287d9714cb4d2fbd");
var callBound = require("8838ca8d8f675778");
var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');
// eslint-disable-next-line max-params
module.exports = function DefineOwnProperty(IsDataDescriptor, SameValue, FromPropertyDescriptor, O, P, desc) {
    if (!$defineProperty) {
        if (!IsDataDescriptor(desc)) // ES3 does not support getters/setters
        return false;
        if (!desc['[[Configurable]]'] || !desc['[[Writable]]']) return false;
        // fallback for ES3
        if (P in O && $isEnumerable(O, P) !== !!desc['[[Enumerable]]']) // a non-enumerable existing property
        return false;
        // property does not exist at all, or exists but is enumerable
        var V = desc['[[Value]]'];
        // eslint-disable-next-line no-param-reassign
        O[P] = V; // will use [[Define]]
        return SameValue(O[P], V);
    }
    if (hasArrayLengthDefineBug && P === 'length' && '[[Value]]' in desc && isArray(O) && O.length !== desc['[[Value]]']) {
        // eslint-disable-next-line no-param-reassign
        O.length = desc['[[Value]]'];
        return O.length === desc['[[Value]]'];
    }
    $defineProperty(O, P, FromPropertyDescriptor(desc));
    return true;
};

},{"da62d0feb68dd33e":"he0V7","c69e3efc3fccbf9e":"jOMdj","287d9714cb4d2fbd":"gAEip","8838ca8d8f675778":"8ZomV"}],"rBL0O":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("8b52b305e9e079f7");
var isPropertyDescriptor = require("e4920ed41dcad684");
var fromPropertyDescriptor = require("4ab64baf4c44752f");
// https://262.ecma-international.org/6.0/#sec-frompropertydescriptor
module.exports = function FromPropertyDescriptor(Desc) {
    if (typeof Desc !== 'undefined' && !isPropertyDescriptor(Desc)) throw new $TypeError('Assertion failed: `Desc` must be a Property Descriptor');
    return fromPropertyDescriptor(Desc);
};

},{"8b52b305e9e079f7":"e08S4","e4920ed41dcad684":"3LqBz","4ab64baf4c44752f":"gntPg"}],"gntPg":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function fromPropertyDescriptor(Desc) {
    if (typeof Desc === 'undefined') return Desc;
    var obj = {};
    if ('[[Value]]' in Desc) obj.value = Desc['[[Value]]'];
    if ('[[Writable]]' in Desc) obj.writable = !!Desc['[[Writable]]'];
    if ('[[Get]]' in Desc) obj.get = Desc['[[Get]]'];
    if ('[[Set]]' in Desc) obj.set = Desc['[[Set]]'];
    if ('[[Enumerable]]' in Desc) obj.enumerable = !!Desc['[[Enumerable]]'];
    if ('[[Configurable]]' in Desc) obj.configurable = !!Desc['[[Configurable]]'];
    return obj;
};

},{}],"hjPO1":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("499278277182ed97");
var hasOwn = require("d5665baddc3aaf0a");
var isPropertyDescriptor = require("23fa7b68a9ff79f5");
// https://262.ecma-international.org/5.1/#sec-8.10.2
module.exports = function IsDataDescriptor(Desc) {
    if (typeof Desc === 'undefined') return false;
    if (!isPropertyDescriptor(Desc)) throw new $TypeError('Assertion failed: `Desc` must be a Property Descriptor');
    if (!hasOwn(Desc, '[[Value]]') && !hasOwn(Desc, '[[Writable]]')) return false;
    return true;
};

},{"499278277182ed97":"e08S4","d5665baddc3aaf0a":"oWOGY","23fa7b68a9ff79f5":"3LqBz"}],"wTbya":[function(require,module,exports,__globalThis) {
'use strict';
var hasOwn = require("e986f56e5da9c41b");
var $TypeError = require("20eb1b3029ac92f1");
var IsCallable = require("a7cd260534663b4e");
var ToBoolean = require("d7a603bfe3320429");
var isObject = require("736dcd4dbcdbf131");
// https://262.ecma-international.org/5.1/#sec-8.10.5
module.exports = function ToPropertyDescriptor(Obj) {
    if (!isObject(Obj)) throw new $TypeError('ToPropertyDescriptor requires an object');
    var desc = {};
    if (hasOwn(Obj, 'enumerable')) desc['[[Enumerable]]'] = ToBoolean(Obj.enumerable);
    if (hasOwn(Obj, 'configurable')) desc['[[Configurable]]'] = ToBoolean(Obj.configurable);
    if (hasOwn(Obj, 'value')) desc['[[Value]]'] = Obj.value;
    if (hasOwn(Obj, 'writable')) desc['[[Writable]]'] = ToBoolean(Obj.writable);
    if (hasOwn(Obj, 'get')) {
        var getter = Obj.get;
        if (typeof getter !== 'undefined' && !IsCallable(getter)) throw new $TypeError('getter must be a function');
        desc['[[Get]]'] = getter;
    }
    if (hasOwn(Obj, 'set')) {
        var setter = Obj.set;
        if (typeof setter !== 'undefined' && !IsCallable(setter)) throw new $TypeError('setter must be a function');
        desc['[[Set]]'] = setter;
    }
    if ((hasOwn(desc, '[[Get]]') || hasOwn(desc, '[[Set]]')) && (hasOwn(desc, '[[Value]]') || hasOwn(desc, '[[Writable]]'))) throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
    return desc;
};

},{"e986f56e5da9c41b":"oWOGY","20eb1b3029ac92f1":"e08S4","a7cd260534663b4e":"iB02W","d7a603bfe3320429":"aZHOa","736dcd4dbcdbf131":"axMar"}],"iB02W":[function(require,module,exports,__globalThis) {
'use strict';
// http://262.ecma-international.org/5.1/#sec-9.11
module.exports = require("b1d43c8f0344aee9");

},{"b1d43c8f0344aee9":"9DBI4"}],"aZHOa":[function(require,module,exports,__globalThis) {
'use strict';
// http://262.ecma-international.org/5.1/#sec-9.2
module.exports = function ToBoolean(value) {
    return !!value;
};

},{}],"l7TV6":[function(require,module,exports,__globalThis) {
'use strict';
var $SyntaxError = require("508a8d06674d0489");
var $TypeError = require("e676da483807bd95");
var IsArray = require("d2f53bba95a23aab");
var IsConstructor = require("cee378a9c889b4f6");
var IsTypedArrayOutOfBounds = require("13f2d38fd195dce6");
var TypedArrayLength = require("2c78a28498c03861");
var ValidateTypedArray = require("d2740260d0bb2885");
var availableTypedArrays = require("cdc96cc4fa606495")();
// https://262.ecma-international.org/15.0/#typedarraycreatefromconstructor
module.exports = function TypedArrayCreateFromConstructor(constructor, argumentList) {
    if (!IsConstructor(constructor)) throw new $TypeError('Assertion failed: `constructor` must be a constructor');
    if (!IsArray(argumentList)) throw new $TypeError('Assertion failed: `argumentList` must be a List');
    if (availableTypedArrays.length === 0) throw new $SyntaxError('Assertion failed: Typed Arrays are not supported in this environment');
    // var newTypedArray = Construct(constructor, argumentList); // step 1
    var newTypedArray;
    if (argumentList.length === 0) newTypedArray = new constructor();
    else if (argumentList.length === 1) newTypedArray = new constructor(argumentList[0]);
    else if (argumentList.length === 2) newTypedArray = new constructor(argumentList[0], argumentList[1]);
    else newTypedArray = new constructor(argumentList[0], argumentList[1], argumentList[2]);
    var taRecord = ValidateTypedArray(newTypedArray, 'SEQ-CST'); // step 2
    if (argumentList.length === 1 && typeof argumentList[0] === 'number') {
        if (IsTypedArrayOutOfBounds(taRecord)) throw new $TypeError('new Typed Array is out of bounds'); // step 3.a
        var length = TypedArrayLength(taRecord); // step 3.b
        if (length < argumentList[0]) throw new $TypeError('`argumentList[0]` must be <= `newTypedArray.length`'); // step 3.c
    }
    return newTypedArray; // step 4
};

},{"508a8d06674d0489":"6Pwu2","e676da483807bd95":"e08S4","d2f53bba95a23aab":"hl3iI","cee378a9c889b4f6":"5ohaP","13f2d38fd195dce6":"2krYx","2c78a28498c03861":"1jTPR","d2740260d0bb2885":"doM6P","cdc96cc4fa606495":"jCTS7"}],"2krYx":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("eb460a26a088958");
var IsDetachedBuffer = require("2d3e78dd14440995");
var TypedArrayElementSize = require("ce63c5b44011d19d");
var isTypedArrayWithBufferWitnessRecord = require("5df3a24edb5a74de");
var typedArrayBuffer = require("718ae0e119b1c98a");
var typedArrayByteOffset = require("1af2487e3db79ab1");
var typedArrayLength = require("52d2e5fa8bb46cef");
// https://262.ecma-international.org/15.0/#sec-istypedarrayoutofbounds
module.exports = function IsTypedArrayOutOfBounds(taRecord) {
    if (!isTypedArrayWithBufferWitnessRecord(taRecord)) throw new $TypeError('Assertion failed: `taRecord` must be a TypedArray With Buffer Witness Record');
    var O = taRecord['[[Object]]']; // step 1
    var bufferByteLength = taRecord['[[CachedBufferByteLength]]']; // step 2
    if (IsDetachedBuffer(typedArrayBuffer(O)) && bufferByteLength !== 'DETACHED') throw new $TypeError('Assertion failed: typed array is detached only if the byte length is ~DETACHED~'); // step 3
    if (bufferByteLength === 'DETACHED') return true; // step 4
    var byteOffsetStart = typedArrayByteOffset(O); // step 5
    var byteOffsetEnd;
    var length = typedArrayLength(O);
    // TODO: probably use package for array length
    // seems to apply when TA is backed by a resizable/growable AB
    if (length === 'AUTO') byteOffsetEnd = bufferByteLength; // step 6.a
    else {
        var elementSize = TypedArrayElementSize(O); // step 7.a
        byteOffsetEnd = byteOffsetStart + length * elementSize; // step 7.b
    }
    if (byteOffsetStart > bufferByteLength || byteOffsetEnd > bufferByteLength) return true; // step 8
    // 9. NOTE: 0-length TypedArrays are not considered out-of-bounds.
    return false; // step 10
};

},{"eb460a26a088958":"e08S4","2d3e78dd14440995":"lYoAc","ce63c5b44011d19d":"hgopq","5df3a24edb5a74de":"hP6Nq","718ae0e119b1c98a":"cow6L","1af2487e3db79ab1":"krjcN","52d2e5fa8bb46cef":"9IP6L"}],"hP6Nq":[function(require,module,exports,__globalThis) {
'use strict';
var hasOwn = require("75401eaeba6622e3");
var isTypedArray = require("d70ca43e3c3bfa73");
var isInteger = require("38725aaa5259113f");
module.exports = function isTypedArrayWithBufferWitnessRecord(value) {
    return !!value && typeof value === 'object' && hasOwn(value, '[[Object]]') && hasOwn(value, '[[CachedBufferByteLength]]') && (isInteger(value['[[CachedBufferByteLength]]']) && value['[[CachedBufferByteLength]]'] >= 0 || value['[[CachedBufferByteLength]]'] === 'DETACHED') && isTypedArray(value['[[Object]]']);
};

},{"75401eaeba6622e3":"oWOGY","d70ca43e3c3bfa73":"gSNWJ","38725aaa5259113f":"4d3xf"}],"4d3xf":[function(require,module,exports,__globalThis) {
'use strict';
// TODO, semver-major: delete
module.exports = require("26de0d082e30476e");

},{"26de0d082e30476e":"3MEYt"}],"krjcN":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var forEach = require("49da5a8e40c26df3");
var callBind = require("5cea590fcc8ba41a");
var gPO = require("ad490b8d22b6004c")();
var typedArrays = require("f9956443408d4051")();
/** @typedef {(x: import('.').TypedArray) => number} ByteOffsetGetter */ /** @type {Record<import('.').TypedArrayName, ByteOffsetGetter>} */ var getters = {
    // @ts-expect-error TS can't handle __proto__ or `satisfies` in jsdoc
    __proto__: null
};
var gOPD = require("eff225dc8a66d531");
var oDP = Object.defineProperty;
if (gOPD) {
    /** @type {ByteOffsetGetter} */ var getByteOffset = function(x) {
        return x.byteOffset;
    };
    forEach(typedArrays, function(typedArray) {
        // In Safari 7, Typed Array constructors are typeof object
        if (typeof global[typedArray] === 'function' || typeof global[typedArray] === 'object') {
            var Proto = global[typedArray].prototype;
            // @ts-expect-error TS can't guarantee the callback is invoked sync
            var descriptor = gOPD(Proto, 'byteOffset');
            if (!descriptor) {
                var superProto = gPO(Proto);
                // @ts-expect-error TS can't guarantee the callback is invoked sync
                descriptor = gOPD(superProto, 'byteOffset');
            }
            // Opera 12.16 has a magic byteOffset data property on instances AND on Proto
            if (descriptor && descriptor.get) getters[typedArray] = callBind(descriptor.get);
            else if (oDP) {
                // this is likely an engine where instances have a magic byteOffset data property
                var arr = new global[typedArray](2);
                // @ts-expect-error TS can't guarantee the callback is invoked sync
                descriptor = gOPD(arr, 'byteOffset');
                if (descriptor && descriptor.configurable) oDP(arr, 'length', {
                    value: 3
                });
                if (arr.length === 2) getters[typedArray] = getByteOffset;
            }
        }
    });
}
/** @type {ByteOffsetGetter} */ var tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {number} */ var foundOffset;
    forEach(getters, /** @type {(getter: ByteOffsetGetter) => void} */ function(getter) {
        if (typeof foundOffset !== 'number') try {
            var offset = getter(value);
            if (typeof offset === 'number') foundOffset = offset;
        } catch (e) {}
    });
    // @ts-expect-error TS can't guarantee the callback is invoked sync
    return foundOffset;
};
var isTypedArray = require("3f10c7b6501ceb01");
/** @type {import('.')} */ module.exports = function typedArrayByteOffset(value) {
    if (!isTypedArray(value)) return false;
    return tryTypedArrays(value);
};

},{"49da5a8e40c26df3":"9ON3E","5cea590fcc8ba41a":"4HjpY","ad490b8d22b6004c":"5sHTj","f9956443408d4051":"jCTS7","eff225dc8a66d531":"2RdtU","3f10c7b6501ceb01":"gSNWJ"}],"5sHTj":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("108b6ca63455ae7c");
var getProto = require("804df69d798c385d");
module.exports = function getPolyfill() {
    if (typeof Reflect === 'object' && Reflect && Reflect.getPrototypeOf) return Reflect.getPrototypeOf;
    return getProto ? function getPrototypeOf(O) {
        return getProto(O);
    } : implementation;
};

},{"108b6ca63455ae7c":"eQ0NH","804df69d798c385d":"f8lrw"}],"eQ0NH":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("ffa1be510c96060e");
var IsCallable = require("7d45b1d8025c3d28");
var isObject = require("70ce6d68649618a3");
var whichBuiltinType = require("680e53d54f18810d");
var $TypeError = require("9ab1c2136ba0d679");
var gPO = require("8d661d95304dcedc");
var $Object = require("e02f002ac31a2cd9");
module.exports = function getPrototypeOf(O) {
    if (!isObject(O)) throw new $TypeError('Reflect.getPrototypeOf called on non-object');
    if (gPO) return gPO(O);
    var type = whichBuiltinType(O);
    if (type) {
        var intrinsic = GetIntrinsic('%' + type + '.prototype%', true);
        if (intrinsic) return intrinsic;
    }
    if (IsCallable(O.constructor)) return O.constructor.prototype;
    if (O instanceof Object) return $Object.prototype;
    /*
	 * Correctly return null for Objects created with `Object.create(null)` (shammed or native) or `{ __proto__: null}`.  Also returns null for
	 * cross-realm objects on browsers that lack `__proto__` support (like IE <11), but that's the best we can do.
	 */ return null;
};

},{"ffa1be510c96060e":"2umKQ","7d45b1d8025c3d28":"iB02W","70ce6d68649618a3":"axMar","680e53d54f18810d":"41J0Q","9ab1c2136ba0d679":"e08S4","8d661d95304dcedc":"f8lrw","e02f002ac31a2cd9":"3zPJM"}],"41J0Q":[function(require,module,exports,__globalThis) {
'use strict';
var whichBoxedPrimitive = require("2cad87740c7c6912");
var whichCollection = require("2a7297bac64d0a9a");
var whichTypedArray = require("2c7f0922f412ff95");
var isArray = require("5879967842e8e36a");
var isDate = require("4adf8991014cbbde");
var isRegex = require("5284baf2c21a132");
var isWeakRef = require("58705e46e35ee25f");
var isFinalizationRegistry = require("cc1118c56015be7f");
var name = require("e7255ca1e4045e68");
var isGeneratorFunction = require("4147ec5ea852012");
var isAsyncFunction = require("602d182d4643d563");
var callBound = require("16cea39a8e3b7fc2");
var hasToStringTag = require("70c8c692327d8096")();
var toStringTag = hasToStringTag && Symbol.toStringTag;
var $Object = Object;
/** @type {undefined | ((value: ThisParameterType<typeof Promise.prototype.then>, ...args: Parameters<typeof Promise.prototype.then>) => ReturnType<typeof Promise.prototype.then>)} */ var promiseThen = callBound('Promise.prototype.then', true);
/** @type {<T = unknown>(value: unknown) => value is Promise<T>} */ var isPromise = function isPromise(value) {
    if (!value || typeof value !== 'object' || !promiseThen) return false;
    try {
        promiseThen(value, null, function() {});
        return true;
    } catch (e) {}
    return false;
};
/** @type {(builtinName: unknown) => boolean} */ var isKnownBuiltin = function isKnownBuiltin(builtinName) {
    return !!builtinName && builtinName !== 'BigInt' && builtinName !== 'Boolean' && builtinName !== 'Null' && builtinName !== 'Number' && builtinName !== 'String' && builtinName !== 'Symbol' && builtinName !== 'Undefined' && builtinName !== 'Math' && builtinName !== 'JSON' && builtinName !== 'Reflect' && builtinName !== 'Atomics' && builtinName !== 'Map' && builtinName !== 'Set' && builtinName !== 'WeakMap' && builtinName !== 'WeakSet' && builtinName !== 'BigInt64Array' && builtinName !== 'BigUint64Array' && builtinName !== 'Float32Array' && builtinName !== 'Float64Array' && builtinName !== 'Int16Array' && builtinName !== 'Int32Array' && builtinName !== 'Int8Array' && builtinName !== 'Uint16Array' && builtinName !== 'Uint32Array' && builtinName !== 'Uint8Array' && builtinName !== 'Uint8ClampedArray' && builtinName !== 'Array' && builtinName !== 'Date' && builtinName !== 'FinalizationRegistry' && builtinName !== 'Promise' && builtinName !== 'RegExp' && builtinName !== 'WeakRef' && builtinName !== 'Function' && builtinName !== 'GeneratorFunction' && builtinName !== 'AsyncFunction';
};
/** @type {import('.')} */ module.exports = function whichBuiltinType(value) {
    if (value == null) return value;
    // covers: primitives, {,Weak}Map/Set, typed arrays
    var which = whichBoxedPrimitive($Object(value)) || whichCollection(value) || whichTypedArray(value);
    if (which) return which;
    if (isArray(value)) return 'Array';
    if (isDate(value)) return 'Date';
    if (isRegex(value)) return 'RegExp';
    if (isWeakRef(value)) return 'WeakRef';
    if (isFinalizationRegistry(value)) return 'FinalizationRegistry';
    if (typeof value === 'function') {
        if (isGeneratorFunction(value)) return 'GeneratorFunction';
        if (isAsyncFunction(value)) return 'AsyncFunction';
        return 'Function';
    }
    if (isPromise(value)) return 'Promise';
    // @ts-expect-error TS can't figure out that `value` is an `object` after the `which` check above
    if (toStringTag && toStringTag in value) {
        var tag = value[toStringTag];
        if (isKnownBuiltin(tag)) return tag;
    }
    if (typeof value.constructor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var constructorName = name(/** @type {Parameters<name>[0]} */ value.constructor);
        if (isKnownBuiltin(constructorName)) return constructorName;
    }
    return 'Object';
};

},{"2cad87740c7c6912":"3v8b1","2a7297bac64d0a9a":"9kCHa","2c7f0922f412ff95":"e0N37","5879967842e8e36a":"2vRGK","4adf8991014cbbde":"4fbba","5284baf2c21a132":"apYBZ","58705e46e35ee25f":"aHLCG","cc1118c56015be7f":"grxpY","e7255ca1e4045e68":"fSHP1","4147ec5ea852012":"chCFj","602d182d4643d563":"lprRg","16cea39a8e3b7fc2":"8ZomV","70c8c692327d8096":"ebyHr"}],"3v8b1":[function(require,module,exports,__globalThis) {
'use strict';
var isString = require("11d3feda75cd5852");
var isNumber = require("a2d99dd0b4e7e2f");
var isBoolean = require("276e2da6a047a0b8");
var isSymbol = require("d5677c34fc7072a0");
var isBigInt = require("56526aa18a4172fb");
/** @type {import('.')} */ // eslint-disable-next-line consistent-return
module.exports = function whichBoxedPrimitive(value) {
    // eslint-disable-next-line eqeqeq
    if (value == null || typeof value !== 'object' && typeof value !== 'function') return null;
    if (isString(value)) return 'String';
    if (isNumber(value)) return 'Number';
    if (isBoolean(value)) return 'Boolean';
    if (isSymbol(value)) return 'Symbol';
    if (isBigInt(value)) return 'BigInt';
};

},{"11d3feda75cd5852":"eBnnf","a2d99dd0b4e7e2f":"9Thr2","276e2da6a047a0b8":"5ZlUX","d5677c34fc7072a0":"9eqXO","56526aa18a4172fb":"hyLcP"}],"eBnnf":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("7797830052e17b97");
/** @type {(receiver: ThisParameterType<typeof String.prototype.valueOf>, ...args: Parameters<typeof String.prototype.valueOf>) => ReturnType<typeof String.prototype.valueOf>} */ var $strValueOf = callBound('String.prototype.valueOf');
/** @type {import('.')} */ var tryStringObject = function tryStringObject(value) {
    try {
        $strValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
};
/** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $toString = callBound('Object.prototype.toString');
var strClass = '[object String]';
var hasToStringTag = require("dc253d94c90af370")();
/** @type {import('.')} */ module.exports = function isString(value) {
    if (typeof value === 'string') return true;
    if (!value || typeof value !== 'object') return false;
    return hasToStringTag ? tryStringObject(value) : $toString(value) === strClass;
};

},{"7797830052e17b97":"8ZomV","dc253d94c90af370":"ebyHr"}],"9Thr2":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("686514a1546e2e02");
var $numToStr = callBound('Number.prototype.toString');
/** @type {import('.')} */ var tryNumberObject = function tryNumberObject(value) {
    try {
        $numToStr(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $toString = callBound('Object.prototype.toString');
var numClass = '[object Number]';
var hasToStringTag = require("6c3ebb022928d133")();
/** @type {import('.')} */ module.exports = function isNumberObject(value) {
    if (typeof value === 'number') return true;
    if (!value || typeof value !== 'object') return false;
    return hasToStringTag ? tryNumberObject(value) : $toString(value) === numClass;
};

},{"686514a1546e2e02":"8ZomV","6c3ebb022928d133":"ebyHr"}],"5ZlUX":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("726d7551e5ce9bc6");
var $boolToStr = callBound('Boolean.prototype.toString');
var $toString = callBound('Object.prototype.toString');
/** @type {import('.')} */ var tryBooleanObject = function booleanBrandCheck(value) {
    try {
        $boolToStr(value);
        return true;
    } catch (e) {
        return false;
    }
};
var boolClass = '[object Boolean]';
var hasToStringTag = require("c7e31dd187752fb0")();
/** @type {import('.')} */ module.exports = function isBoolean(value) {
    if (typeof value === 'boolean') return true;
    if (value === null || typeof value !== 'object') return false;
    return hasToStringTag ? tryBooleanObject(value) : $toString(value) === boolClass;
};

},{"726d7551e5ce9bc6":"8ZomV","c7e31dd187752fb0":"ebyHr"}],"hyLcP":[function(require,module,exports,__globalThis) {
'use strict';
var hasBigInts = require("5d154ac48fe82ab8")();
if (hasBigInts) {
    var bigIntValueOf = BigInt.prototype.valueOf;
    /** @type {(value: object) => value is BigInt} */ var tryBigInt = function tryBigIntObject(value) {
        try {
            bigIntValueOf.call(value);
            return true;
        } catch (e) {}
        return false;
    };
    /** @type {import('.')} */ module.exports = function isBigInt(value) {
        if (value === null || typeof value === 'undefined' || typeof value === 'boolean' || typeof value === 'string' || typeof value === 'number' || typeof value === 'symbol' || typeof value === 'function') return false;
        if (typeof value === 'bigint') return true;
        return tryBigInt(value);
    };
} else /** @type {import('.')} */ module.exports = function isBigInt(value) {
    return false;
};

},{"5d154ac48fe82ab8":"b8dVK"}],"b8dVK":[function(require,module,exports,__globalThis) {
'use strict';
var $BigInt = typeof BigInt !== 'undefined' && BigInt;
/** @type {import('.')} */ module.exports = function hasNativeBigInts() {
    return typeof $BigInt === 'function' && typeof BigInt === 'function' && typeof $BigInt(42) === 'bigint' // eslint-disable-line no-magic-numbers
     && typeof BigInt(42) === 'bigint'; // eslint-disable-line no-magic-numbers
};

},{}],"9kCHa":[function(require,module,exports,__globalThis) {
'use strict';
var isMap = require("d4cc45a59360005a");
var isSet = require("4af25f4aa4b77a83");
var isWeakMap = require("d0ab6821281ca1fa");
var isWeakSet = require("d25c2dcce56d3a64");
/** @type {import('.')} */ module.exports = function whichCollection(/** @type {unknown} */ value) {
    if (value && typeof value === 'object') {
        if (isMap(value)) return 'Map';
        if (isSet(value)) return 'Set';
        if (isWeakMap(value)) return 'WeakMap';
        if (isWeakSet(value)) return 'WeakSet';
    }
    return false;
};

},{"d4cc45a59360005a":"axVTh","4af25f4aa4b77a83":"jvbmB","d0ab6821281ca1fa":"gSMqg","d25c2dcce56d3a64":"emkzp"}],"axVTh":[function(require,module,exports,__globalThis) {
'use strict';
/** @const */ var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;
var exported;
if (!$Map) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
exported = function isMap(x) {
    // `Map` is not present in this environment.
    return false;
};
var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$mapHas) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
exported = function isMap(x) {
    // `Map` does not have a `has` method
    return false;
};
/** @type {import('.')} */ module.exports = exported || function isMap(x) {
    if (!x || typeof x !== 'object') return false;
    try {
        $mapHas.call(x);
        if ($setHas) try {
            $setHas.call(x);
        } catch (e) {
            return true;
        }
        // @ts-expect-error TS can't figure out that $Map is always truthy here
        return x instanceof $Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};

},{}],"jvbmB":[function(require,module,exports,__globalThis) {
'use strict';
var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;
var exported;
if (!$Set) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
exported = function isSet(x) {
    // `Set` is not present in this environment.
    return false;
};
var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$setHas) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
exported = function isSet(x) {
    // `Set` does not have a `has` method
    return false;
};
/** @type {import('.')} */ module.exports = exported || function isSet(x) {
    if (!x || typeof x !== 'object') return false;
    try {
        $setHas.call(x);
        if ($mapHas) try {
            $mapHas.call(x);
        } catch (e) {
            return true;
        }
        // @ts-expect-error TS can't figure out that $Set is always truthy here
        return x instanceof $Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};

},{}],"gSMqg":[function(require,module,exports,__globalThis) {
'use strict';
var $WeakMap = typeof WeakMap === 'function' && WeakMap.prototype ? WeakMap : null;
var $WeakSet = typeof WeakSet === 'function' && WeakSet.prototype ? WeakSet : null;
var exported;
if (!$WeakMap) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
exported = function isWeakMap(x) {
    // `WeakMap` is not present in this environment.
    return false;
};
var $mapHas = $WeakMap ? $WeakMap.prototype.has : null;
var $setHas = $WeakSet ? $WeakSet.prototype.has : null;
if (!exported && !$mapHas) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
exported = function isWeakMap(x) {
    // `WeakMap` does not have a `has` method
    return false;
};
/** @type {import('.')} */ module.exports = exported || function isWeakMap(x) {
    if (!x || typeof x !== 'object') return false;
    try {
        $mapHas.call(x, $mapHas);
        if ($setHas) try {
            $setHas.call(x, $setHas);
        } catch (e) {
            return true;
        }
        // @ts-expect-error TS can't figure out that $WeakMap is always truthy here
        return x instanceof $WeakMap; // core-js workaround, pre-v3
    } catch (e) {}
    return false;
};

},{}],"emkzp":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("5468f65dce743940");
var callBound = require("c711b1eed95ae4d4");
var $WeakSet = GetIntrinsic('%WeakSet%', true);
/** @type {undefined | (<V>(thisArg: Set<V>, value: V) => boolean)} */ var $setHas = callBound('WeakSet.prototype.has', true);
if ($setHas) {
    /** @type {undefined | (<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean)} */ var $mapHas = callBound('WeakMap.prototype.has', true);
    /** @type {import('.')} */ module.exports = function isWeakSet(x) {
        if (!x || typeof x !== 'object') return false;
        try {
            // @ts-expect-error TS can't figure out that $setHas is always truthy here
            $setHas(x, $setHas);
            if ($mapHas) try {
                // @ts-expect-error this indeed might not be a weak collection
                $mapHas(x, $mapHas);
            } catch (e) {
                return true;
            }
            // @ts-expect-error TS can't figure out that $WeakSet is always truthy here
            return x instanceof $WeakSet; // core-js workaround, pre-v3
        } catch (e) {}
        return false;
    };
} else /** @type {import('.')} */ // @ts-expect-error
module.exports = function isWeakSet(x) {
    // `WeakSet` does not exist, or does not have a `has` method
    return false;
};

},{"5468f65dce743940":"2umKQ","c711b1eed95ae4d4":"8ZomV"}],"2vRGK":[function(require,module,exports,__globalThis) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == '[object Array]';
};

},{}],"aHLCG":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("33a59bab4044038a");
// eslint-disable-next-line no-extra-parens
var $deref = /** @type {<T extends WeakKey>(thisArg: WeakRef<T>) => T | undefined} */ callBound('WeakRef.prototype.deref', true);
/** @type {import('.')} */ module.exports = typeof WeakRef === 'undefined' ? function isWeakRef(_value) {
    return false;
} : function isWeakRef(value) {
    if (!value || typeof value !== 'object') return false;
    try {
        // @ts-expect-error
        $deref(value);
        return true;
    } catch (e) {
        return false;
    }
};

},{"33a59bab4044038a":"8ZomV"}],"grxpY":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("dd8322dbea4ae1ed");
/** @type {undefined | ((value: ThisParameterType<typeof FinalizationRegistry.prototype.register>, ...args: Parameters<typeof FinalizationRegistry.prototype.register>) => ReturnType<typeof FinalizationRegistry.prototype.register>)} */ var $register = callBound('FinalizationRegistry.prototype.register', true);
/** @type {import('.')} */ module.exports = $register ? function isFinalizationRegistry(value) {
    if (!value || typeof value !== 'object') return false;
    try {
        // @ts-expect-error TS can't figure out that it's always truthy here
        $register(value, {}, null);
        return true;
    } catch (e) {
        return false;
    }
} : function isFinalizationRegistry(value) {
    return false;
};

},{"dd8322dbea4ae1ed":"8ZomV"}],"fSHP1":[function(require,module,exports,__globalThis) {
'use strict';
var define = require("cb84411438c5585d");
var callBind = require("2d3570eed0799718");
var implementation = require("7ccc9c4fb5f9bae7");
var getPolyfill = require("f722acb344ac694c");
var shim = require("3bc06c68fbf4584d");
var bound = callBind(implementation);
define(bound, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = bound;

},{"cb84411438c5585d":"ak2Bc","2d3570eed0799718":"4HjpY","7ccc9c4fb5f9bae7":"9SgWw","f722acb344ac694c":"b01TI","3bc06c68fbf4584d":"lFNzn"}],"9SgWw":[function(require,module,exports,__globalThis) {
'use strict';
var IsCallable = require("c1047f8eee3ac12");
var hasOwn = require("ee700751a0ad1a65");
var functionsHaveNames = require("44d4f55d80739906")();
var callBound = require("15488fd7a0a1e5a2");
var $functionToString = callBound('Function.prototype.toString');
var $stringMatch = callBound('String.prototype.match');
var toStr = callBound('Object.prototype.toString');
var classRegex = /^class /;
var isClass = function isClassConstructor(fn) {
    if (IsCallable(fn)) return false;
    if (typeof fn !== 'function') return false;
    try {
        var match = $stringMatch($functionToString(fn), classRegex);
        return !!match;
    } catch (e) {}
    return false;
};
var regex = /\s*function\s+([^(\s]*)\s*/;
var isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var objectClass = '[object Object]';
var ddaClass = '[object HTMLAllCollection]';
var functionProto = Function.prototype;
var isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var all = document.all;
    if (toStr(all) === toStr(document.all)) isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = toStr(value);
            // IE 6-8 uses `objectClass`
            return (str === ddaClass || str === objectClass) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = function getName() {
    if (isDDA(this) || !isClass(this) && !IsCallable(this)) throw new TypeError('Function.prototype.name sham getter called on non-function');
    if (functionsHaveNames && hasOwn(this, 'name')) return this.name;
    if (this === functionProto) return '';
    var str = $functionToString(this);
    var match = $stringMatch(str, regex);
    var name = match && match[1];
    return name;
};

},{"c1047f8eee3ac12":"9DBI4","ee700751a0ad1a65":"oWOGY","44d4f55d80739906":"5yh10","15488fd7a0a1e5a2":"8ZomV"}],"5yh10":[function(require,module,exports,__globalThis) {
'use strict';
var functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === 'string';
};
var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) try {
    gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    gOPD = null;
}
functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!functionsHaveNames() || !gOPD) return false;
    var desc = gOPD(function() {}, 'name');
    return !!desc && !!desc.configurable;
};
var $bind = Function.prototype.bind;
functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return functionsHaveNames() && typeof $bind === 'function' && (function f() {}).bind().name !== '';
};
module.exports = functionsHaveNames;

},{}],"b01TI":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("482a3bb60c11c2fc");
module.exports = function getPolyfill() {
    return implementation;
};

},{"482a3bb60c11c2fc":"9SgWw"}],"lFNzn":[function(require,module,exports,__globalThis) {
'use strict';
var supportsDescriptors = require("bfd7f458ab0baf05").supportsDescriptors;
var functionsHaveNames = require("324a752bea0c9628")();
var getPolyfill = require("f7d5813174e8dd11");
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
module.exports = function shimName() {
    var polyfill = getPolyfill();
    if (functionsHaveNames) return polyfill;
    if (!supportsDescriptors) throw new TypeErr('Shimming Function.prototype.name support requires ES5 property descriptor support.');
    var functionProto = Function.prototype;
    defineProperty(functionProto, 'name', {
        configurable: true,
        enumerable: false,
        get: function() {
            var name = polyfill.call(this);
            if (this !== functionProto) defineProperty(this, 'name', {
                configurable: true,
                enumerable: false,
                value: name,
                writable: false
            });
            return name;
        }
    });
    return polyfill;
};

},{"bfd7f458ab0baf05":"ak2Bc","324a752bea0c9628":"5yh10","f7d5813174e8dd11":"b01TI"}],"lprRg":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("2621c530208b1b6e");
var safeRegexTest = require("d07c87c1e730d108");
var toStr = callBound('Object.prototype.toString');
var fnToStr = callBound('Function.prototype.toString');
var isFnRegex = safeRegexTest(/^\s*async(?:\s+function(?:\s+|\()|\s*\()/);
var hasToStringTag = require("f5304f95172351c6")();
var getProto = require("4e53a79ed30f8c");
var getAsyncFunc = require("3af549ac06cb48ea");
/** @type {import('.')} */ module.exports = function isAsyncFunction(fn) {
    if (typeof fn !== 'function') return false;
    if (isFnRegex(fnToStr(fn))) return true;
    if (!hasToStringTag) {
        var str = toStr(fn);
        return str === '[object AsyncFunction]';
    }
    if (!getProto) return false;
    var asyncFunc = getAsyncFunc();
    return asyncFunc && asyncFunc.prototype === getProto(fn);
};

},{"2621c530208b1b6e":"8ZomV","d07c87c1e730d108":"2WKic","f5304f95172351c6":"ebyHr","4e53a79ed30f8c":"f8lrw","3af549ac06cb48ea":"a5B7h"}],"a5B7h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/** @type {import('./index.d.mts').default} */ exports.default = (0, _indexJsDefault.default);

},{"./index.js":"6nL7Q","@parcel/transformer-js/src/esmodule-helpers.js":"68Hdb"}],"6nL7Q":[function(require,module,exports,__globalThis) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const cached = /** @type {import('.').AsyncFunctionConstructor} */ (async function() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>cached;

},{}],"9IP6L":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
// / <reference types="node" />
var callBind = require("36fcbbd04022df30");
var forEach = require("b30593249310045");
var gOPD = require("5eea06a14a7e9724");
var isTypedArray = require("4c3043f950080bd7");
var typedArrays = require("97c2b13f57cc23bd");
var gPO = require("903d5b7e47cfe51b")();
/** @typedef {(value: import('.').TypedArray) => number} TypedArrayLengthGetter */ /** @typedef {{ [k in `$${import('.').TypedArrayName}` | '__proto__']: k extends '__proto__' ? null : TypedArrayLengthGetter }} Cache */ /** @type {Cache} */ // @ts-expect-error TS doesn't seem to have a "will eventually satisfy" type
var getters = {
    __proto__: null
};
var oDP = Object.defineProperty;
if (gOPD) {
    var getLength = /** @type {TypedArrayLengthGetter} */ function(x) {
        return x.length;
    };
    forEach(typedArrays, /** @type {(typedArray: import('.').TypedArrayName) => void} */ function(typedArray) {
        var TA = global[typedArray];
        // In Safari 7, Typed Array constructors are typeof object
        if (typeof TA === 'function' || typeof TA === 'object') {
            var Proto = TA.prototype;
            // @ts-expect-error TS doesn't narrow types inside callbacks, which is weird
            var descriptor = gOPD(Proto, 'length');
            if (!descriptor) {
                var superProto = gPO(Proto);
                // @ts-expect-error TS doesn't narrow types inside callbacks, which is weird
                descriptor = gOPD(superProto, 'length');
            }
            // Opera 12.16 has a magic length data property on instances AND on Proto
            if (descriptor && descriptor.get) // eslint-disable-next-line no-extra-parens
            getters[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = callBind(descriptor.get);
            else if (oDP) {
                // this is likely an engine where instances have a magic length data property
                var arr = new global[typedArray](2);
                // @ts-expect-error TS doesn't narrow types inside callbacks, which is weird
                descriptor = gOPD(arr, 'length');
                if (descriptor && descriptor.configurable) oDP(arr, 'length', {
                    value: 3
                });
                if (arr.length === 2) // eslint-disable-next-line no-extra-parens
                getters[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = getLength;
            }
        }
    });
}
/** @type {TypedArrayLengthGetter} */ var tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {number} */ var foundLength;
    // @ts-expect-error not sure why this won't work
    forEach(getters, /** @type {(getter: TypedArrayLengthGetter) => void} */ function(getter) {
        if (typeof foundLength !== 'number') try {
            var length = getter(value);
            if (typeof length === 'number') foundLength = length;
        } catch (e) {}
    });
    // @ts-expect-error TS can't guarantee the above callback is invoked sync
    return foundLength;
};
/** @type {import('.')} */ module.exports = function typedArrayLength(value) {
    if (!isTypedArray(value)) return false;
    return tryTypedArrays(value);
};

},{"36fcbbd04022df30":"4HjpY","b30593249310045":"9ON3E","5eea06a14a7e9724":"2RdtU","4c3043f950080bd7":"gSNWJ","97c2b13f57cc23bd":"alCsn","903d5b7e47cfe51b":"5sHTj"}],"1jTPR":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("1a1defcb7e079fc9");
var floor = require("d9dc2f80aa32eb2e");
var IsFixedLengthArrayBuffer = require("4232ef55439aaf6d");
var IsTypedArrayOutOfBounds = require("112b13680f309566");
var TypedArrayElementSize = require("2d883eb2bb3b31b5");
var isTypedArrayWithBufferWitnessRecord = require("c5e1be4ccab1c0b7");
var typedArrayBuffer = require("effc443c9f593cb9");
var typedArrayByteOffset = require("3afc3fc5e4fd38fb");
var typedArrayLength = require("a8924f10ef5f5e4c");
// http://www.ecma-international.org/ecma-262/15.0/#sec-typedarraylength
module.exports = function TypedArrayLength(taRecord) {
    if (!isTypedArrayWithBufferWitnessRecord(taRecord)) throw new $TypeError('Assertion failed: `taRecord` must be a TypedArray With Buffer Witness Record');
    if (IsTypedArrayOutOfBounds(taRecord)) throw new $TypeError('Assertion failed: `taRecord` is out of bounds'); // step 1
    var O = taRecord['[[Object]]']; // step 2
    var length = typedArrayLength(O);
    if (length !== 'AUTO') return length; // step 3
    if (IsFixedLengthArrayBuffer(typedArrayBuffer(O))) throw new $TypeError('Assertion failed: array buffer is not fixed length'); // step 4
    var byteOffset = typedArrayByteOffset(O); // step 5
    var elementSize = TypedArrayElementSize(O); // step 6
    var byteLength = taRecord['[[CachedBufferByteLength]]']; // step 7
    if (byteLength === 'DETACHED') throw new $TypeError('Assertion failed: typed array is detached'); // step 8
    return floor((byteLength - byteOffset) / elementSize); // step 9
};

},{"1a1defcb7e079fc9":"e08S4","d9dc2f80aa32eb2e":"kWsp2","4232ef55439aaf6d":"dV8lo","112b13680f309566":"2krYx","2d883eb2bb3b31b5":"hgopq","c5e1be4ccab1c0b7":"hP6Nq","effc443c9f593cb9":"cow6L","3afc3fc5e4fd38fb":"krjcN","a8924f10ef5f5e4c":"9IP6L"}],"dV8lo":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("35621f5dd69a5d74");
var callBound = require("224e700c7fe538a9");
var $arrayBufferResizable = callBound('%ArrayBuffer.prototype.resizable%', true);
var $sharedArrayGrowable = callBound('%SharedArrayBuffer.prototype.growable%', true);
var isArrayBuffer = require("cfa413252abf4de7");
var isSharedArrayBuffer = require("d21df8b99ffeb8e3");
// https://262.ecma-international.org/15.0/#sec-isfixedlengtharraybuffer
module.exports = function IsFixedLengthArrayBuffer(arrayBuffer) {
    var isAB = isArrayBuffer(arrayBuffer);
    var isSAB = isSharedArrayBuffer(arrayBuffer);
    if (!isAB && !isSAB) throw new $TypeError('Assertion failed: `arrayBuffer` must be an ArrayBuffer or SharedArrayBuffer');
    if (isAB && $arrayBufferResizable) return !$arrayBufferResizable(arrayBuffer); // step 1
    if (isSAB && $sharedArrayGrowable) return !$sharedArrayGrowable(arrayBuffer); // step 1
    return true; // step 2
};

},{"35621f5dd69a5d74":"e08S4","224e700c7fe538a9":"8ZomV","cfa413252abf4de7":"6TxHP","d21df8b99ffeb8e3":"bDJMm"}],"doM6P":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("de9862f05ef698ed");
var IsTypedArrayOutOfBounds = require("2404496ea8303b39");
var MakeTypedArrayWithBufferWitnessRecord = require("b56ee3699593decf");
var isObject = require("953763390ab53c5b");
var isTypedArray = require("d2b9cf290352f83f");
// https://262.ecma-international.org/15.0/#sec-validatetypedarray
module.exports = function ValidateTypedArray(O, order) {
    if (order !== 'SEQ-CST' && order !== 'UNORDERED') throw new $TypeError('Assertion failed: `order` must be ~SEQ-CST~ or ~UNORDERED~');
    if (!isObject(O)) throw new $TypeError('Assertion failed: `O` must be an Object'); // step 1
    if (!isTypedArray(O)) throw new $TypeError('Assertion failed: `O` must be a Typed Array'); // steps 1 - 2
    var taRecord = MakeTypedArrayWithBufferWitnessRecord(O, order); // step 3
    if (IsTypedArrayOutOfBounds(taRecord)) throw new $TypeError('`O` must be in-bounds and backed by a non-detached buffer'); // step 4
    return taRecord; // step 5
};

},{"de9862f05ef698ed":"e08S4","2404496ea8303b39":"2krYx","b56ee3699593decf":"l0Fbb","953763390ab53c5b":"axMar","d2b9cf290352f83f":"gSNWJ"}],"l0Fbb":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("11889e09f2732c76");
var ArrayBufferByteLength = require("f7e69f829b1ef50b");
var IsDetachedBuffer = require("d79bc541be47d345");
var isTypedArray = require("849ef2bb74a29c69");
var typedArrayBuffer = require("3049bc1b0ddbfcc5");
// https://262.ecma-international.org/15.0/#sec-maketypedarraywithbufferwitnessrecord
module.exports = function MakeTypedArrayWithBufferWitnessRecord(obj, order) {
    if (!isTypedArray(obj)) throw new $TypeError('Assertion failed: `obj` must be a Typed Array');
    if (order !== 'SEQ-CST' && order !== 'UNORDERED') throw new $TypeError('Assertion failed: `order` must be ~SEQ-CST~ or ~UNORDERED~');
    var buffer = typedArrayBuffer(obj); // step 1
    var byteLength = IsDetachedBuffer(buffer) ? 'DETACHED' : ArrayBufferByteLength(buffer, order); // steps 2 - 3
    return {
        '[[Object]]': obj,
        '[[CachedBufferByteLength]]': byteLength
    }; // step 4
};

},{"11889e09f2732c76":"e08S4","f7e69f829b1ef50b":"37Wkh","d79bc541be47d345":"lYoAc","849ef2bb74a29c69":"gSNWJ","3049bc1b0ddbfcc5":"cow6L"}],"37Wkh":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("9c02468eedcf6024");
// https://262.ecma-international.org/15.0/#sec-arraybufferbytelength
var IsDetachedBuffer = require("6c1c50160345d88e");
var isArrayBuffer = require("510ad9e95ad66f46");
var isSharedArrayBuffer = require("6f2d3fe7b4813fbe");
var arrayBufferByteLength = require("5596650ea15235f3");
var isGrowable = false; // TODO: support this
module.exports = function ArrayBufferByteLength(arrayBuffer, order) {
    var isSAB = isSharedArrayBuffer(arrayBuffer);
    if (!isArrayBuffer(arrayBuffer) && !isSAB) throw new $TypeError('Assertion failed: `arrayBuffer` must be an ArrayBuffer or a SharedArrayBuffer');
    if (order !== 'SEQ-CST' && order !== 'UNORDERED') throw new $TypeError('Assertion failed: `order` must be ~SEQ-CST~ or ~UNORDERED~');
    // 1. If IsSharedArrayBuffer(arrayBuffer) is true and arrayBuffer has an [[ArrayBufferByteLengthData]] internal slot, then
    // TODO: see if IsFixedLengthArrayBuffer can be used here in the spec instead
    isSAB && isGrowable;
    if (IsDetachedBuffer(arrayBuffer)) throw new $TypeError('Assertion failed: `arrayBuffer` must not be detached'); // step 2
    return arrayBufferByteLength(arrayBuffer);
};

},{"9c02468eedcf6024":"e08S4","6c1c50160345d88e":"lYoAc","510ad9e95ad66f46":"6TxHP","6f2d3fe7b4813fbe":"bDJMm","5596650ea15235f3":"g6Oam"}],"eZxnG":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("f40b6ff84e48c5ac");
var constructors = {
    __proto__: null,
    $Int8Array: GetIntrinsic('%Int8Array%', true),
    $Uint8Array: GetIntrinsic('%Uint8Array%', true),
    $Uint8ClampedArray: GetIntrinsic('%Uint8ClampedArray%', true),
    $Int16Array: GetIntrinsic('%Int16Array%', true),
    $Uint16Array: GetIntrinsic('%Uint16Array%', true),
    $Int32Array: GetIntrinsic('%Int32Array%', true),
    $Uint32Array: GetIntrinsic('%Uint32Array%', true),
    $BigInt64Array: GetIntrinsic('%BigInt64Array%', true),
    $BigUint64Array: GetIntrinsic('%BigUint64Array%', true),
    $Float32Array: GetIntrinsic('%Float32Array%', true),
    $Float64Array: GetIntrinsic('%Float64Array%', true)
};
module.exports = function getConstructor(kind) {
    return constructors['$' + kind];
};

},{"f40b6ff84e48c5ac":"2umKQ"}],"kKTgT":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("c2e736406a92fa0f");
module.exports = function getPolyfill() {
    return typeof Uint8Array === 'function' && Uint8Array.prototype.slice || implementation;
};

},{"c2e736406a92fa0f":"7yZgg"}],"aWs0O":[function(require,module,exports,__globalThis) {
'use strict';
var define = require("54df4418486a7f28");
var getProto = require("fd71c81fc1f762ba");
var getPolyfill = require("8be3db0839d05e2f");
module.exports = function shimTypedArraySlice() {
    if (typeof Uint8Array === 'function') {
        var polyfill = getPolyfill();
        var proto = getProto(Uint8Array.prototype);
        define(proto, {
            slice: polyfill
        }, {
            slice: function() {
                return proto.slice !== polyfill;
            }
        });
    }
    return polyfill;
};

},{"54df4418486a7f28":"ak2Bc","fd71c81fc1f762ba":"f8lrw","8be3db0839d05e2f":"kKTgT"}],"fHD2n":[function(require,module,exports,__globalThis) {
module.exports = Extent;
function Extent(bbox) {
    if (!(this instanceof Extent)) return new Extent(bbox);
    this._bbox = bbox || [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    this._valid = !!bbox;
}
Extent.prototype.include = function(ll) {
    this._valid = true;
    this._bbox[0] = Math.min(this._bbox[0], ll[0]);
    this._bbox[1] = Math.min(this._bbox[1], ll[1]);
    this._bbox[2] = Math.max(this._bbox[2], ll[0]);
    this._bbox[3] = Math.max(this._bbox[3], ll[1]);
    return this;
};
Extent.prototype.equals = function(_) {
    var other;
    if (_ instanceof Extent) other = _.bbox();
    else other = _;
    return this._bbox[0] == other[0] && this._bbox[1] == other[1] && this._bbox[2] == other[2] && this._bbox[3] == other[3];
};
Extent.prototype.center = function(_) {
    if (!this._valid) return null;
    return [
        (this._bbox[0] + this._bbox[2]) / 2,
        (this._bbox[1] + this._bbox[3]) / 2
    ];
};
Extent.prototype.union = function(_) {
    this._valid = true;
    var other;
    if (_ instanceof Extent) other = _.bbox();
    else other = _;
    this._bbox[0] = Math.min(this._bbox[0], other[0]);
    this._bbox[1] = Math.min(this._bbox[1], other[1]);
    this._bbox[2] = Math.max(this._bbox[2], other[2]);
    this._bbox[3] = Math.max(this._bbox[3], other[3]);
    return this;
};
Extent.prototype.bbox = function() {
    if (!this._valid) return null;
    return this._bbox;
};
Extent.prototype.contains = function(ll) {
    if (!ll) return this._fastContains();
    if (!this._valid) return null;
    var lon = ll[0], lat = ll[1];
    return this._bbox[0] <= lon && this._bbox[1] <= lat && this._bbox[2] >= lon && this._bbox[3] >= lat;
};
Extent.prototype.intersect = function(_) {
    if (!this._valid) return null;
    var other;
    if (_ instanceof Extent) other = _.bbox();
    else other = _;
    return !(this._bbox[0] > other[2] || this._bbox[2] < other[0] || this._bbox[3] < other[1] || this._bbox[1] > other[3]);
};
Extent.prototype._fastContains = function() {
    if (!this._valid) return new Function('return null;');
    var body = 'return ' + this._bbox[0] + '<= ll[0] &&' + this._bbox[1] + '<= ll[1] &&' + this._bbox[2] + '>= ll[0] &&' + this._bbox[3] + '>= ll[1]';
    return new Function('ll', body);
};
Extent.prototype.polygon = function() {
    if (!this._valid) return null;
    return {
        type: 'Polygon',
        coordinates: [
            [
                // W, S
                [
                    this._bbox[0],
                    this._bbox[1]
                ],
                // E, S
                [
                    this._bbox[2],
                    this._bbox[1]
                ],
                // E, N
                [
                    this._bbox[2],
                    this._bbox[3]
                ],
                // W, N
                [
                    this._bbox[0],
                    this._bbox[3]
                ],
                // W, S
                [
                    this._bbox[0],
                    this._bbox[1]
                ]
            ]
        ]
    };
};

},{}],"jIT58":[function(require,module,exports,__globalThis) {
/* MapLibre GL JS is licensed under the 3-Clause BSD License. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v2.4.0/LICENSE.txt */ (function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    /* eslint-disable */ var shared, worker, maplibregl;
    // define gets called three times: one for each chunk. we rely on the order
    // they're imported to know which is which
    function define(_, chunk) {
        if (!shared) shared = chunk;
        else if (!worker) worker = chunk;
        else {
            var workerBundleString = 'var sharedChunk = {}; (' + shared + ')(sharedChunk); (' + worker + ')(sharedChunk);';
            var sharedChunk = {};
            shared(sharedChunk);
            maplibregl = chunk(sharedChunk);
            if (typeof window !== 'undefined') maplibregl.workerUrl = window.URL.createObjectURL(new Blob([
                workerBundleString
            ], {
                type: 'text/javascript'
            }));
        }
    }
    define([
        "exports"
    ], function(t1) {
        "use strict";
        var e1 = r;
        function r(t1, e1, r, n) {
            this.cx = 3 * t1, this.bx = 3 * (r - t1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e1, this.by = 3 * (n - e1) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t1, this.p1y = e1, this.p2x = r, this.p2y = n;
        }
        function n(t1, r, n, i) {
            const a = new e1(t1, r, n, i);
            return function(t1) {
                return a.solve(t1);
            };
        }
        r.prototype = {
            sampleCurveX: function(t1) {
                return ((this.ax * t1 + this.bx) * t1 + this.cx) * t1;
            },
            sampleCurveY: function(t1) {
                return ((this.ay * t1 + this.by) * t1 + this.cy) * t1;
            },
            sampleCurveDerivativeX: function(t1) {
                return (3 * this.ax * t1 + 2 * this.bx) * t1 + this.cx;
            },
            solveCurveX: function(t1, e1) {
                if (void 0 === e1 && (e1 = 1e-6), t1 < 0) return 0;
                if (t1 > 1) return 1;
                for(var r = t1, n = 0; n < 8; n++){
                    var i = this.sampleCurveX(r) - t1;
                    if (Math.abs(i) < e1) return r;
                    var a = this.sampleCurveDerivativeX(r);
                    if (Math.abs(a) < 1e-6) break;
                    r -= i / a;
                }
                var s = 0, o = 1;
                for(r = t1, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - t1) < e1)); n++)t1 > i ? s = r : o = r, r = .5 * (o - s) + s;
                return r;
            },
            solve: function(t1, e1) {
                return this.sampleCurveY(this.solveCurveX(t1, e1));
            }
        };
        const i = n(.25, .1, .25, 1);
        function a(t1, e1, r) {
            return Math.min(r, Math.max(e1, t1));
        }
        function s(t1, e1, r) {
            const n = r - e1, i = ((t1 - e1) % n + n) % n + e1;
            return i === e1 ? r : i;
        }
        function o(t1, ...e1) {
            for (const r of e1)for(const e1 in r)t1[e1] = r[e1];
            return t1;
        }
        let l = 1;
        function u(t1, e1) {
            t1.forEach((t1)=>{
                e1[t1] && (e1[t1] = e1[t1].bind(e1));
            });
        }
        function c(t1, e1, r) {
            const n = {};
            for(const i in t1)n[i] = e1.call(r || this, t1[i], i, t1);
            return n;
        }
        function h(t1, e1, r) {
            const n = {};
            for(const i in t1)e1.call(r || this, t1[i], i, t1) && (n[i] = t1[i]);
            return n;
        }
        function p(t1) {
            return Array.isArray(t1) ? t1.map(p) : "object" == typeof t1 && t1 ? c(t1, p) : t1;
        }
        const f = {};
        function d(t1) {
            f[t1] || ("undefined" != typeof console && console.warn(t1), f[t1] = !0);
        }
        function y(t1, e1, r) {
            return (r.y - t1.y) * (e1.x - t1.x) > (e1.y - t1.y) * (r.x - t1.x);
        }
        function m(t1) {
            let e1 = 0;
            for(let r, n, i = 0, a = t1.length, s = a - 1; i < a; s = i++)r = t1[i], n = t1[s], e1 += (n.x - r.x) * (r.y + n.y);
            return e1;
        }
        function g() {
            return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
        }
        function x(t1) {
            const e1 = {};
            if (t1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t1, r, n, i)=>{
                const a = n || i;
                return e1[r] = !a || a.toLowerCase(), "";
            }), e1["max-age"]) {
                const t1 = parseInt(e1["max-age"], 10);
                isNaN(t1) ? delete e1["max-age"] : e1["max-age"] = t1;
            }
            return e1;
        }
        let v, b, w = null;
        function _(t1) {
            if (null == w) {
                const e1 = t1.navigator ? t1.navigator.userAgent : null;
                w = !!t1.safari || !(!e1 || !(/\b(iPad|iPhone|iPod)\b/.test(e1) || e1.match("Safari") && !e1.match("Chrome")));
            }
            return w;
        }
        function A(t1) {
            return "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap;
        }
        const k = {
            now: "undefined" != typeof performance && performance && performance.now ? performance.now.bind(performance) : Date.now.bind(Date),
            frame (t1) {
                const e1 = requestAnimationFrame(t1);
                return {
                    cancel: ()=>cancelAnimationFrame(e1)
                };
            },
            getImageData (t1, e1 = 0) {
                const r = window.document.createElement("canvas"), n = r.getContext("2d");
                if (!n) throw new Error("failed to create canvas 2d context");
                return r.width = t1.width, r.height = t1.height, n.drawImage(t1, 0, 0, t1.width, t1.height), n.getImageData(-e1, -e1, t1.width + 2 * e1, t1.height + 2 * e1);
            },
            resolveURL: (t1)=>(v || (v = document.createElement("a")), v.href = t1, v.href),
            hardwareConcurrency: "undefined" != typeof navigator && navigator.hardwareConcurrency || 4,
            get prefersReducedMotion () {
                return !!matchMedia && (null == b && (b = matchMedia("(prefers-reduced-motion: reduce)")), b.matches);
            }
        };
        var S = I;
        function I(t1, e1) {
            this.x = t1, this.y = e1;
        }
        I.prototype = {
            clone: function() {
                return new I(this.x, this.y);
            },
            add: function(t1) {
                return this.clone()._add(t1);
            },
            sub: function(t1) {
                return this.clone()._sub(t1);
            },
            multByPoint: function(t1) {
                return this.clone()._multByPoint(t1);
            },
            divByPoint: function(t1) {
                return this.clone()._divByPoint(t1);
            },
            mult: function(t1) {
                return this.clone()._mult(t1);
            },
            div: function(t1) {
                return this.clone()._div(t1);
            },
            rotate: function(t1) {
                return this.clone()._rotate(t1);
            },
            rotateAround: function(t1, e1) {
                return this.clone()._rotateAround(t1, e1);
            },
            matMult: function(t1) {
                return this.clone()._matMult(t1);
            },
            unit: function() {
                return this.clone()._unit();
            },
            perp: function() {
                return this.clone()._perp();
            },
            round: function() {
                return this.clone()._round();
            },
            mag: function() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals: function(t1) {
                return this.x === t1.x && this.y === t1.y;
            },
            dist: function(t1) {
                return Math.sqrt(this.distSqr(t1));
            },
            distSqr: function(t1) {
                var e1 = t1.x - this.x, r = t1.y - this.y;
                return e1 * e1 + r * r;
            },
            angle: function() {
                return Math.atan2(this.y, this.x);
            },
            angleTo: function(t1) {
                return Math.atan2(this.y - t1.y, this.x - t1.x);
            },
            angleWith: function(t1) {
                return this.angleWithSep(t1.x, t1.y);
            },
            angleWithSep: function(t1, e1) {
                return Math.atan2(this.x * e1 - this.y * t1, this.x * t1 + this.y * e1);
            },
            _matMult: function(t1) {
                var e1 = t1[2] * this.x + t1[3] * this.y;
                return this.x = t1[0] * this.x + t1[1] * this.y, this.y = e1, this;
            },
            _add: function(t1) {
                return this.x += t1.x, this.y += t1.y, this;
            },
            _sub: function(t1) {
                return this.x -= t1.x, this.y -= t1.y, this;
            },
            _mult: function(t1) {
                return this.x *= t1, this.y *= t1, this;
            },
            _div: function(t1) {
                return this.x /= t1, this.y /= t1, this;
            },
            _multByPoint: function(t1) {
                return this.x *= t1.x, this.y *= t1.y, this;
            },
            _divByPoint: function(t1) {
                return this.x /= t1.x, this.y /= t1.y, this;
            },
            _unit: function() {
                return this._div(this.mag()), this;
            },
            _perp: function() {
                var t1 = this.y;
                return this.y = this.x, this.x = -t1, this;
            },
            _rotate: function(t1) {
                var e1 = Math.cos(t1), r = Math.sin(t1), n = r * this.x + e1 * this.y;
                return this.x = e1 * this.x - r * this.y, this.y = n, this;
            },
            _rotateAround: function(t1, e1) {
                var r = Math.cos(t1), n = Math.sin(t1), i = e1.y + n * (this.x - e1.x) + r * (this.y - e1.y);
                return this.x = e1.x + r * (this.x - e1.x) - n * (this.y - e1.y), this.y = i, this;
            },
            _round: function() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
        }, I.convert = function(t1) {
            return t1 instanceof I ? t1 : Array.isArray(t1) ? new I(t1[0], t1[1]) : t1;
        };
        const M = {
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            REGISTERED_PROTOCOLS: {}
        }, z = "mapbox-tiles";
        let B, C, P = 500, V = 50;
        function E() {
            "undefined" == typeof caches || B || (B = caches.open(z));
        }
        let F = 1 / 0;
        const T = {
            supported: !1,
            testSupport: function(t1) {
                !$ && D && (R ? O(t1) : L = t1);
            }
        };
        let L, D, $ = !1, R = !1;
        function O(t1) {
            const e1 = t1.createTexture();
            t1.bindTexture(t1.TEXTURE_2D, e1);
            try {
                if (t1.texImage2D(t1.TEXTURE_2D, 0, t1.RGBA, t1.RGBA, t1.UNSIGNED_BYTE, D), t1.isContextLost()) return;
                T.supported = !0;
            } catch (t1) {}
            t1.deleteTexture(e1), $ = !0;
        }
        "undefined" != typeof document && (D = document.createElement("img"), D.onload = function() {
            L && O(L), L = null, R = !0;
        }, D.onerror = function() {
            $ = !0, L = null;
        }, D.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
        const U = {
            Unknown: "Unknown",
            Style: "Style",
            Source: "Source",
            Tile: "Tile",
            Glyphs: "Glyphs",
            SpriteImage: "SpriteImage",
            SpriteJSON: "SpriteJSON",
            Image: "Image"
        };
        "function" == typeof Object.freeze && Object.freeze(U);
        class q extends Error {
            constructor(t1, e1, r, n){
                super(`AJAXError: ${e1} (${t1}): ${r}`), this.status = t1, this.statusText = e1, this.url = r, this.body = n;
            }
        }
        const j = g() ? ()=>self.worker && self.worker.referrer : ()=>("blob:" === window.location.protocol ? window.parent : window).location.href;
        function N(t1, e1) {
            const r = new AbortController, n = new Request(t1.url, {
                method: t1.method || "GET",
                body: t1.body,
                credentials: t1.credentials,
                headers: t1.headers,
                referrer: j(),
                signal: r.signal
            });
            let i = !1, a = !1;
            "json" === t1.type && n.headers.set("Accept", "application/json");
            return ((r, s, o)=>{
                if (a) return;
                const l = Date.now();
                fetch(n).then((r)=>r.ok ? ((r, s, o)=>{
                        ("arrayBuffer" === t1.type ? r.arrayBuffer() : "json" === t1.type ? r.json() : r.text()).then((t1)=>{
                            a || (s && o && function(t1, e1, r) {
                                if (E(), !B) return;
                                const n = {
                                    status: e1.status,
                                    statusText: e1.statusText,
                                    headers: new Headers
                                };
                                e1.headers.forEach((t1, e1)=>n.headers.set(e1, t1));
                                const i = x(e1.headers.get("Cache-Control") || "");
                                i["no-store"] || (i["max-age"] && n.headers.set("Expires", new Date(r + 1e3 * i["max-age"]).toUTCString()), new Date(n.headers.get("Expires")).getTime() - r < 42e4 || function(t1, e1) {
                                    if (void 0 === C) try {
                                        new Response(new ReadableStream), C = !0;
                                    } catch (t1) {
                                        C = !1;
                                    }
                                    C ? e1(t1.body) : t1.blob().then(e1);
                                }(e1, (e1)=>{
                                    const r = new Response(e1, n);
                                    E(), B && B.then((e1)=>e1.put(function(t1) {
                                            const e1 = t1.indexOf("?");
                                            return e1 < 0 ? t1 : t1.slice(0, e1);
                                        }(t1.url), r)).catch((t1)=>d(t1.message));
                                }));
                            }(n, s, o), i = !0, e1(null, t1, r.headers.get("Cache-Control"), r.headers.get("Expires")));
                        }).catch((t1)=>{
                            a || e1(new Error(t1.message));
                        });
                    })(r, null, l) : r.blob().then((n)=>e1(new q(r.status, r.statusText, t1.url, n)))).catch((t1)=>{
                    20 !== t1.code && e1(new Error(t1.message));
                });
            })(), {
                cancel: ()=>{
                    a = !0, i || r.abort();
                }
            };
        }
        const Z = function(t1, e1) {
            if (/:\/\//.test(t1.url) && !/^https?:|^file:/.test(t1.url)) {
                if (g() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t1, e1);
                if (!g()) {
                    const r = t1.url.substring(0, t1.url.indexOf("://"));
                    return (M.REGISTERED_PROTOCOLS[r] || N)(t1, e1);
                }
            }
            if (!(/^file:/.test(r = t1.url) || /^file:/.test(j()) && !/^\w+:/.test(r))) {
                if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, "signal")) return N(t1, e1);
                if (g() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t1, e1, void 0, !0);
            }
            var r;
            return function(t1, e1) {
                const r = new XMLHttpRequest;
                r.open(t1.method || "GET", t1.url, !0), "arrayBuffer" === t1.type && (r.responseType = "arraybuffer");
                for(const e1 in t1.headers)r.setRequestHeader(e1, t1.headers[e1]);
                return "json" === t1.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === t1.credentials, r.onerror = ()=>{
                    e1(new Error(r.statusText));
                }, r.onload = ()=>{
                    if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                        let n = r.response;
                        if ("json" === t1.type) try {
                            n = JSON.parse(r.response);
                        } catch (t1) {
                            return e1(t1);
                        }
                        e1(null, n, r.getResponseHeader("Cache-Control"), r.getResponseHeader("Expires"));
                    } else {
                        const n = new Blob([
                            r.response
                        ], {
                            type: r.getResponseHeader("Content-Type")
                        });
                        e1(new q(r.status, r.statusText, t1.url, n));
                    }
                }, r.send(t1.body), {
                    cancel: ()=>r.abort()
                };
            }(t1, e1);
        }, K = function(t1, e1) {
            return Z(o(t1, {
                type: "arrayBuffer"
            }), e1);
        };
        function G(t1) {
            const e1 = window.document.createElement("a");
            return e1.href = t1, e1.protocol === window.document.location.protocol && e1.host === window.document.location.host;
        }
        const J = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        let X, Y;
        X = [], Y = 0;
        const H = function(t1, e1) {
            if (T.supported && (t1.headers || (t1.headers = {}), t1.headers.accept = "image/webp,*/*"), Y >= M.MAX_PARALLEL_IMAGE_REQUESTS) {
                const r = {
                    requestParameters: t1,
                    callback: e1,
                    cancelled: !1,
                    cancel () {
                        this.cancelled = !0;
                    }
                };
                return X.push(r), r;
            }
            Y++;
            let r = !1;
            const n = ()=>{
                if (!r) for(r = !0, Y--; X.length && Y < M.MAX_PARALLEL_IMAGE_REQUESTS;){
                    const t1 = X.shift(), { requestParameters: e1, callback: r, cancelled: n } = t1;
                    n || (t1.cancel = H(e1, r).cancel);
                }
            }, i = K(t1, (t1, r, i, a)=>{
                n(), t1 ? e1(t1) : r && function(t1, e1) {
                    "function" == typeof createImageBitmap ? function(t1, e1) {
                        const r = new Blob([
                            new Uint8Array(t1)
                        ], {
                            type: "image/png"
                        });
                        createImageBitmap(r).then((t1)=>{
                            e1(null, t1);
                        }).catch((t1)=>{
                            e1(new Error(`Could not load image because of ${t1.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
                        });
                    }(t1, e1) : function(t1, e1) {
                        const r = new Image;
                        r.onload = ()=>{
                            e1(null, r), URL.revokeObjectURL(r.src), r.onload = null, window.requestAnimationFrame(()=>{
                                r.src = J;
                            });
                        }, r.onerror = ()=>e1(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                        const n = new Blob([
                            new Uint8Array(t1)
                        ], {
                            type: "image/png"
                        });
                        r.src = t1.byteLength ? URL.createObjectURL(n) : J;
                    }(t1, e1);
                }(r, (t1, r)=>{
                    null != t1 ? e1(t1) : null != r && e1(null, r, {
                        cacheControl: i,
                        expires: a
                    });
                });
            });
            return {
                cancel: ()=>{
                    i.cancel(), n();
                }
            };
        };
        function W(t1, e1, r) {
            r[t1] && -1 !== r[t1].indexOf(e1) || (r[t1] = r[t1] || [], r[t1].push(e1));
        }
        function Q(t1, e1, r) {
            if (r && r[t1]) {
                const n = r[t1].indexOf(e1);
                -1 !== n && r[t1].splice(n, 1);
            }
        }
        class tt {
            constructor(t1, e1 = {}){
                o(this, e1), this.type = t1;
            }
        }
        class et extends tt {
            constructor(t1, e1 = {}){
                super("error", o({
                    error: t1
                }, e1));
            }
        }
        class rt {
            on(t1, e1) {
                return this._listeners = this._listeners || {}, W(t1, e1, this._listeners), this;
            }
            off(t1, e1) {
                return Q(t1, e1, this._listeners), Q(t1, e1, this._oneTimeListeners), this;
            }
            once(t1, e1) {
                return this._oneTimeListeners = this._oneTimeListeners || {}, W(t1, e1, this._oneTimeListeners), this;
            }
            fire(t1, e1) {
                "string" == typeof t1 && (t1 = new tt(t1, e1 || {}));
                const r = t1.type;
                if (this.listens(r)) {
                    t1.target = this;
                    const e1 = this._listeners && this._listeners[r] ? this._listeners[r].slice() : [];
                    for (const r of e1)r.call(this, t1);
                    const n = this._oneTimeListeners && this._oneTimeListeners[r] ? this._oneTimeListeners[r].slice() : [];
                    for (const e1 of n)Q(r, e1, this._oneTimeListeners), e1.call(this, t1);
                    const i = this._eventedParent;
                    i && (o(t1, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i.fire(t1));
                } else t1 instanceof et && console.error(t1.error);
                return this;
            }
            listens(t1) {
                return this._listeners && this._listeners[t1] && this._listeners[t1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t1] && this._oneTimeListeners[t1].length > 0 || this._eventedParent && this._eventedParent.listens(t1);
            }
            setEventedParent(t1, e1) {
                return this._eventedParent = t1, this._eventedParentData = e1, this;
            }
        }
        var nt = {
            $version: 8,
            $root: {
                version: {
                    required: !0,
                    type: "enum",
                    values: [
                        8
                    ]
                },
                name: {
                    type: "string"
                },
                metadata: {
                    type: "*"
                },
                center: {
                    type: "array",
                    value: "number"
                },
                zoom: {
                    type: "number"
                },
                bearing: {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees"
                },
                pitch: {
                    type: "number",
                    default: 0,
                    units: "degrees"
                },
                light: {
                    type: "light"
                },
                terrain: {
                    type: "terrain"
                },
                sources: {
                    required: !0,
                    type: "sources"
                },
                sprite: {
                    type: "string"
                },
                glyphs: {
                    type: "string"
                },
                transition: {
                    type: "transition"
                },
                layers: {
                    required: !0,
                    type: "array",
                    value: "layer"
                }
            },
            sources: {
                "*": {
                    type: "source"
                }
            },
            source: [
                "source_vector",
                "source_raster",
                "source_raster_dem",
                "source_geojson",
                "source_video",
                "source_image"
            ],
            source_vector: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        vector: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                attribution: {
                    type: "string"
                },
                promoteId: {
                    type: "promoteId"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        raster: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                attribution: {
                    type: "string"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster_dem: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        "raster-dem": {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                attribution: {
                    type: "string"
                },
                encoding: {
                    type: "enum",
                    values: {
                        terrarium: {},
                        mapbox: {}
                    },
                    default: "mapbox"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_geojson: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        geojson: {}
                    }
                },
                data: {
                    type: "*"
                },
                maxzoom: {
                    type: "number",
                    default: 18
                },
                attribution: {
                    type: "string"
                },
                buffer: {
                    type: "number",
                    default: 128,
                    maximum: 512,
                    minimum: 0
                },
                filter: {
                    type: "*"
                },
                tolerance: {
                    type: "number",
                    default: .375
                },
                cluster: {
                    type: "boolean",
                    default: !1
                },
                clusterRadius: {
                    type: "number",
                    default: 50,
                    minimum: 0
                },
                clusterMaxZoom: {
                    type: "number"
                },
                clusterMinPoints: {
                    type: "number"
                },
                clusterProperties: {
                    type: "*"
                },
                lineMetrics: {
                    type: "boolean",
                    default: !1
                },
                generateId: {
                    type: "boolean",
                    default: !1
                },
                promoteId: {
                    type: "promoteId"
                }
            },
            source_video: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        video: {}
                    }
                },
                urls: {
                    required: !0,
                    type: "array",
                    value: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            source_image: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        image: {}
                    }
                },
                url: {
                    required: !0,
                    type: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            layer: {
                id: {
                    type: "string",
                    required: !0
                },
                type: {
                    type: "enum",
                    values: {
                        fill: {},
                        line: {},
                        symbol: {},
                        circle: {},
                        heatmap: {},
                        "fill-extrusion": {},
                        raster: {},
                        hillshade: {},
                        background: {}
                    },
                    required: !0
                },
                metadata: {
                    type: "*"
                },
                source: {
                    type: "string"
                },
                "source-layer": {
                    type: "string"
                },
                minzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                maxzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                filter: {
                    type: "filter"
                },
                layout: {
                    type: "layout"
                },
                paint: {
                    type: "paint"
                }
            },
            layout: [
                "layout_fill",
                "layout_line",
                "layout_circle",
                "layout_heatmap",
                "layout_fill-extrusion",
                "layout_symbol",
                "layout_raster",
                "layout_hillshade",
                "layout_background"
            ],
            layout_background: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_fill: {
                "fill-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_circle: {
                "circle-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_heatmap: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            "layout_fill-extrusion": {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_line: {
                "line-cap": {
                    type: "enum",
                    values: {
                        butt: {},
                        round: {},
                        square: {}
                    },
                    default: "butt",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-join": {
                    type: "enum",
                    values: {
                        bevel: {},
                        round: {},
                        miter: {}
                    },
                    default: "miter",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-miter-limit": {
                    type: "number",
                    default: 2,
                    requires: [
                        {
                            "line-join": "miter"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-round-limit": {
                    type: "number",
                    default: 1.05,
                    requires: [
                        {
                            "line-join": "round"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_symbol: {
                "symbol-placement": {
                    type: "enum",
                    values: {
                        point: {},
                        line: {},
                        "line-center": {}
                    },
                    default: "point",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-spacing": {
                    type: "number",
                    default: 250,
                    minimum: 1,
                    units: "pixels",
                    requires: [
                        {
                            "symbol-placement": "line"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-avoid-edges": {
                    type: "boolean",
                    default: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "symbol-z-order": {
                    type: "enum",
                    values: {
                        auto: {},
                        "viewport-y": {},
                        source: {}
                    },
                    default: "auto",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "!": "icon-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-size": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    units: "factor of the original icon size",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-text-fit": {
                    type: "enum",
                    values: {
                        none: {},
                        width: {},
                        height: {},
                        both: {}
                    },
                    default: "none",
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-text-fit-padding": {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        0,
                        0,
                        0,
                        0
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image",
                        "text-field",
                        {
                            "icon-text-fit": [
                                "both",
                                "width",
                                "height"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-image": {
                    type: "resolvedImage",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-padding": {
                    type: "padding",
                    default: [
                        2
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-keep-upright": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "icon-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-offset": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        "viewport-glyph": {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-field": {
                    type: "formatted",
                    default: "",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-font": {
                    type: "array",
                    value: "string",
                    default: [
                        "Open Sans Regular",
                        "Arial Unicode MS Regular"
                    ],
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-size": {
                    type: "number",
                    default: 16,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-width": {
                    type: "number",
                    default: 10,
                    minimum: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-line-height": {
                    type: "number",
                    default: 1.2,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-letter-spacing": {
                    type: "number",
                    default: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-justify": {
                    type: "enum",
                    values: {
                        auto: {},
                        left: {},
                        center: {},
                        right: {}
                    },
                    default: "center",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-radial-offset": {
                    type: "number",
                    units: "ems",
                    default: 0,
                    requires: [
                        "text-field"
                    ],
                    "property-type": "data-driven",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    }
                },
                "text-variable-anchor": {
                    type: "array",
                    value: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "text-field",
                        {
                            "!": "text-variable-anchor"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-angle": {
                    type: "number",
                    default: 45,
                    units: "degrees",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-writing-mode": {
                    type: "array",
                    value: "enum",
                    values: {
                        horizontal: {},
                        vertical: {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-padding": {
                    type: "number",
                    default: 2,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-keep-upright": {
                    type: "boolean",
                    default: !0,
                    requires: [
                        "text-field",
                        {
                            "text-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-transform": {
                    type: "enum",
                    values: {
                        none: {},
                        uppercase: {},
                        lowercase: {}
                    },
                    default: "none",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-offset": {
                    type: "array",
                    value: "number",
                    units: "ems",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "text-field",
                        {
                            "!": "text-radial-offset"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        {
                            "!": "text-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_raster: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_hillshade: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            filter: {
                type: "array",
                value: "*"
            },
            filter_operator: {
                type: "enum",
                values: {
                    "==": {},
                    "!=": {},
                    ">": {},
                    ">=": {},
                    "<": {},
                    "<=": {},
                    in: {},
                    "!in": {},
                    all: {},
                    any: {},
                    none: {},
                    has: {},
                    "!has": {},
                    within: {}
                }
            },
            geometry_type: {
                type: "enum",
                values: {
                    Point: {},
                    LineString: {},
                    Polygon: {}
                }
            },
            function: {
                expression: {
                    type: "expression"
                },
                stops: {
                    type: "array",
                    value: "function_stop"
                },
                base: {
                    type: "number",
                    default: 1,
                    minimum: 0
                },
                property: {
                    type: "string",
                    default: "$zoom"
                },
                type: {
                    type: "enum",
                    values: {
                        identity: {},
                        exponential: {},
                        interval: {},
                        categorical: {}
                    },
                    default: "exponential"
                },
                colorSpace: {
                    type: "enum",
                    values: {
                        rgb: {},
                        lab: {},
                        hcl: {}
                    },
                    default: "rgb"
                },
                default: {
                    type: "*",
                    required: !1
                }
            },
            function_stop: {
                type: "array",
                minimum: 0,
                maximum: 24,
                value: [
                    "number",
                    "color"
                ],
                length: 2
            },
            expression: {
                type: "array",
                value: "*",
                minimum: 1
            },
            light: {
                anchor: {
                    type: "enum",
                    default: "viewport",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    "property-type": "data-constant",
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                position: {
                    type: "array",
                    default: [
                        1.15,
                        210,
                        30
                    ],
                    length: 3,
                    value: "number",
                    "property-type": "data-constant",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                color: {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                intensity: {
                    type: "number",
                    "property-type": "data-constant",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                }
            },
            terrain: {
                source: {
                    type: "string",
                    required: !0
                },
                exaggeration: {
                    type: "number",
                    minimum: 0,
                    default: 1
                },
                elevationOffset: {
                    type: "number",
                    default: 450
                }
            },
            paint: [
                "paint_fill",
                "paint_line",
                "paint_circle",
                "paint_heatmap",
                "paint_fill-extrusion",
                "paint_symbol",
                "paint_raster",
                "paint_hillshade",
                "paint_background"
            ],
            paint_fill: {
                "fill-antialias": {
                    type: "boolean",
                    default: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-outline-color": {
                    type: "color",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        },
                        {
                            "fill-antialias": !0
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                }
            },
            "paint_fill-extrusion": {
                "fill-extrusion-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-extrusion-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-extrusion-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "fill-extrusion-height": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-base": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    requires: [
                        "fill-extrusion-height"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-vertical-gradient": {
                    type: "boolean",
                    default: !0,
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_line: {
                "line-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "line-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-width": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-gap-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-offset": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-dasharray": {
                    type: "array",
                    value: "number",
                    minimum: 0,
                    transition: !0,
                    units: "line widths",
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "line-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "line-gradient": {
                    type: "color",
                    transition: !1,
                    requires: [
                        {
                            "!": "line-dasharray"
                        },
                        {
                            "!": "line-pattern"
                        },
                        {
                            source: "geojson",
                            has: {
                                lineMetrics: !0
                            }
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "line-progress"
                        ]
                    },
                    "property-type": "color-ramp"
                }
            },
            paint_circle: {
                "circle-radius": {
                    type: "number",
                    default: 5,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-blur": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "circle-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-scale": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-stroke-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                }
            },
            paint_heatmap: {
                "heatmap-radius": {
                    type: "number",
                    default: 30,
                    minimum: 1,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-weight": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-intensity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "heatmap-color": {
                    type: "color",
                    default: [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "heatmap-density"
                        ],
                        0,
                        "rgba(0, 0, 255, 0)",
                        .1,
                        "royalblue",
                        .3,
                        "cyan",
                        .5,
                        "lime",
                        .7,
                        "yellow",
                        1,
                        "red"
                    ],
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "heatmap-density"
                        ]
                    },
                    "property-type": "color-ramp"
                },
                "heatmap-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_symbol: {
                "icon-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "icon-image",
                        "icon-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    overridable: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "text-field",
                        "text-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_raster: {
                "raster-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-hue-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    transition: !0,
                    units: "degrees",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-min": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-max": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-saturation": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-contrast": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-resampling": {
                    type: "enum",
                    values: {
                        linear: {},
                        nearest: {}
                    },
                    default: "linear",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-fade-duration": {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    transition: !1,
                    units: "milliseconds",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_hillshade: {
                "hillshade-illumination-direction": {
                    type: "number",
                    default: 335,
                    minimum: 0,
                    maximum: 359,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-illumination-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-exaggeration": {
                    type: "number",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-shadow-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-highlight-color": {
                    type: "color",
                    default: "#FFFFFF",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-accent-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_background: {
                "background-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "background-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "background-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "background-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            transition: {
                duration: {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    units: "milliseconds"
                },
                delay: {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "milliseconds"
                }
            },
            "property-type": {
                "data-driven": {
                    type: "property-type"
                },
                "cross-faded": {
                    type: "property-type"
                },
                "cross-faded-data-driven": {
                    type: "property-type"
                },
                "color-ramp": {
                    type: "property-type"
                },
                "data-constant": {
                    type: "property-type"
                },
                constant: {
                    type: "property-type"
                }
            },
            promoteId: {
                "*": {
                    type: "string"
                }
            }
        };
        class it {
            constructor(t1, e1, r, n){
                this.message = (t1 ? `${t1}: ` : "") + r, n && (this.identifier = n), null != e1 && e1.__line__ && (this.line = e1.__line__);
            }
        }
        function at(t1) {
            const e1 = t1.value;
            return e1 ? [
                new it(t1.key, e1, "constants have been deprecated as of v8")
            ] : [];
        }
        function st(t1, ...e1) {
            for (const r of e1)for(const e1 in r)t1[e1] = r[e1];
            return t1;
        }
        function ot(t1) {
            return t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean ? t1.valueOf() : t1;
        }
        function lt(t1) {
            if (Array.isArray(t1)) return t1.map(lt);
            if (t1 instanceof Object && !(t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean)) {
                const e1 = {};
                for(const r in t1)e1[r] = lt(t1[r]);
                return e1;
            }
            return ot(t1);
        }
        class ut extends Error {
            constructor(t1, e1){
                super(e1), this.message = e1, this.key = t1;
            }
        }
        class ct {
            concat(t1) {
                return new ct(this, t1);
            }
            get(t1) {
                if (this.bindings[t1]) return this.bindings[t1];
                if (this.parent) return this.parent.get(t1);
                throw new Error(`${t1} not found in scope.`);
            }
            has(t1) {
                return !!this.bindings[t1] || !!this.parent && this.parent.has(t1);
            }
            constructor(t1, e1 = []){
                this.parent = t1, this.bindings = {};
                for (const [t1, r] of e1)this.bindings[t1] = r;
            }
        }
        const ht = {
            kind: "null"
        }, pt = {
            kind: "number"
        }, ft = {
            kind: "string"
        }, dt = {
            kind: "boolean"
        }, yt = {
            kind: "color"
        }, mt = {
            kind: "object"
        }, gt = {
            kind: "value"
        }, xt = {
            kind: "collator"
        }, vt = {
            kind: "formatted"
        }, bt = {
            kind: "padding"
        }, wt = {
            kind: "resolvedImage"
        };
        function _t(t1, e1) {
            return {
                kind: "array",
                itemType: t1,
                N: e1
            };
        }
        function At(t1) {
            if ("array" === t1.kind) {
                const e1 = At(t1.itemType);
                return "number" == typeof t1.N ? `array<${e1}, ${t1.N}>` : "value" === t1.itemType.kind ? "array" : `array<${e1}>`;
            }
            return t1.kind;
        }
        const kt = [
            ht,
            pt,
            ft,
            dt,
            yt,
            vt,
            mt,
            _t(gt),
            bt,
            wt
        ];
        function St(t1, e1) {
            if ("error" === e1.kind) return null;
            if ("array" === t1.kind) {
                if ("array" === e1.kind && (0 === e1.N && "value" === e1.itemType.kind || !St(t1.itemType, e1.itemType)) && ("number" != typeof t1.N || t1.N === e1.N)) return null;
            } else {
                if (t1.kind === e1.kind) return null;
                if ("value" === t1.kind) {
                    for (const t1 of kt)if (!St(t1, e1)) return null;
                }
            }
            return `Expected ${At(t1)} but found ${At(e1)} instead.`;
        }
        function It(t1, e1) {
            return e1.some((e1)=>e1.kind === t1.kind);
        }
        function Mt(t1, e1) {
            return e1.some((e1)=>"null" === e1 ? null === t1 : "array" === e1 ? Array.isArray(t1) : "object" === e1 ? t1 && !Array.isArray(t1) && "object" == typeof t1 : e1 === typeof t1);
        }
        var zt, Bt = {
            transparent: [
                0,
                0,
                0,
                0
            ],
            aliceblue: [
                240,
                248,
                255,
                1
            ],
            antiquewhite: [
                250,
                235,
                215,
                1
            ],
            aqua: [
                0,
                255,
                255,
                1
            ],
            aquamarine: [
                127,
                255,
                212,
                1
            ],
            azure: [
                240,
                255,
                255,
                1
            ],
            beige: [
                245,
                245,
                220,
                1
            ],
            bisque: [
                255,
                228,
                196,
                1
            ],
            black: [
                0,
                0,
                0,
                1
            ],
            blanchedalmond: [
                255,
                235,
                205,
                1
            ],
            blue: [
                0,
                0,
                255,
                1
            ],
            blueviolet: [
                138,
                43,
                226,
                1
            ],
            brown: [
                165,
                42,
                42,
                1
            ],
            burlywood: [
                222,
                184,
                135,
                1
            ],
            cadetblue: [
                95,
                158,
                160,
                1
            ],
            chartreuse: [
                127,
                255,
                0,
                1
            ],
            chocolate: [
                210,
                105,
                30,
                1
            ],
            coral: [
                255,
                127,
                80,
                1
            ],
            cornflowerblue: [
                100,
                149,
                237,
                1
            ],
            cornsilk: [
                255,
                248,
                220,
                1
            ],
            crimson: [
                220,
                20,
                60,
                1
            ],
            cyan: [
                0,
                255,
                255,
                1
            ],
            darkblue: [
                0,
                0,
                139,
                1
            ],
            darkcyan: [
                0,
                139,
                139,
                1
            ],
            darkgoldenrod: [
                184,
                134,
                11,
                1
            ],
            darkgray: [
                169,
                169,
                169,
                1
            ],
            darkgreen: [
                0,
                100,
                0,
                1
            ],
            darkgrey: [
                169,
                169,
                169,
                1
            ],
            darkkhaki: [
                189,
                183,
                107,
                1
            ],
            darkmagenta: [
                139,
                0,
                139,
                1
            ],
            darkolivegreen: [
                85,
                107,
                47,
                1
            ],
            darkorange: [
                255,
                140,
                0,
                1
            ],
            darkorchid: [
                153,
                50,
                204,
                1
            ],
            darkred: [
                139,
                0,
                0,
                1
            ],
            darksalmon: [
                233,
                150,
                122,
                1
            ],
            darkseagreen: [
                143,
                188,
                143,
                1
            ],
            darkslateblue: [
                72,
                61,
                139,
                1
            ],
            darkslategray: [
                47,
                79,
                79,
                1
            ],
            darkslategrey: [
                47,
                79,
                79,
                1
            ],
            darkturquoise: [
                0,
                206,
                209,
                1
            ],
            darkviolet: [
                148,
                0,
                211,
                1
            ],
            deeppink: [
                255,
                20,
                147,
                1
            ],
            deepskyblue: [
                0,
                191,
                255,
                1
            ],
            dimgray: [
                105,
                105,
                105,
                1
            ],
            dimgrey: [
                105,
                105,
                105,
                1
            ],
            dodgerblue: [
                30,
                144,
                255,
                1
            ],
            firebrick: [
                178,
                34,
                34,
                1
            ],
            floralwhite: [
                255,
                250,
                240,
                1
            ],
            forestgreen: [
                34,
                139,
                34,
                1
            ],
            fuchsia: [
                255,
                0,
                255,
                1
            ],
            gainsboro: [
                220,
                220,
                220,
                1
            ],
            ghostwhite: [
                248,
                248,
                255,
                1
            ],
            gold: [
                255,
                215,
                0,
                1
            ],
            goldenrod: [
                218,
                165,
                32,
                1
            ],
            gray: [
                128,
                128,
                128,
                1
            ],
            green: [
                0,
                128,
                0,
                1
            ],
            greenyellow: [
                173,
                255,
                47,
                1
            ],
            grey: [
                128,
                128,
                128,
                1
            ],
            honeydew: [
                240,
                255,
                240,
                1
            ],
            hotpink: [
                255,
                105,
                180,
                1
            ],
            indianred: [
                205,
                92,
                92,
                1
            ],
            indigo: [
                75,
                0,
                130,
                1
            ],
            ivory: [
                255,
                255,
                240,
                1
            ],
            khaki: [
                240,
                230,
                140,
                1
            ],
            lavender: [
                230,
                230,
                250,
                1
            ],
            lavenderblush: [
                255,
                240,
                245,
                1
            ],
            lawngreen: [
                124,
                252,
                0,
                1
            ],
            lemonchiffon: [
                255,
                250,
                205,
                1
            ],
            lightblue: [
                173,
                216,
                230,
                1
            ],
            lightcoral: [
                240,
                128,
                128,
                1
            ],
            lightcyan: [
                224,
                255,
                255,
                1
            ],
            lightgoldenrodyellow: [
                250,
                250,
                210,
                1
            ],
            lightgray: [
                211,
                211,
                211,
                1
            ],
            lightgreen: [
                144,
                238,
                144,
                1
            ],
            lightgrey: [
                211,
                211,
                211,
                1
            ],
            lightpink: [
                255,
                182,
                193,
                1
            ],
            lightsalmon: [
                255,
                160,
                122,
                1
            ],
            lightseagreen: [
                32,
                178,
                170,
                1
            ],
            lightskyblue: [
                135,
                206,
                250,
                1
            ],
            lightslategray: [
                119,
                136,
                153,
                1
            ],
            lightslategrey: [
                119,
                136,
                153,
                1
            ],
            lightsteelblue: [
                176,
                196,
                222,
                1
            ],
            lightyellow: [
                255,
                255,
                224,
                1
            ],
            lime: [
                0,
                255,
                0,
                1
            ],
            limegreen: [
                50,
                205,
                50,
                1
            ],
            linen: [
                250,
                240,
                230,
                1
            ],
            magenta: [
                255,
                0,
                255,
                1
            ],
            maroon: [
                128,
                0,
                0,
                1
            ],
            mediumaquamarine: [
                102,
                205,
                170,
                1
            ],
            mediumblue: [
                0,
                0,
                205,
                1
            ],
            mediumorchid: [
                186,
                85,
                211,
                1
            ],
            mediumpurple: [
                147,
                112,
                219,
                1
            ],
            mediumseagreen: [
                60,
                179,
                113,
                1
            ],
            mediumslateblue: [
                123,
                104,
                238,
                1
            ],
            mediumspringgreen: [
                0,
                250,
                154,
                1
            ],
            mediumturquoise: [
                72,
                209,
                204,
                1
            ],
            mediumvioletred: [
                199,
                21,
                133,
                1
            ],
            midnightblue: [
                25,
                25,
                112,
                1
            ],
            mintcream: [
                245,
                255,
                250,
                1
            ],
            mistyrose: [
                255,
                228,
                225,
                1
            ],
            moccasin: [
                255,
                228,
                181,
                1
            ],
            navajowhite: [
                255,
                222,
                173,
                1
            ],
            navy: [
                0,
                0,
                128,
                1
            ],
            oldlace: [
                253,
                245,
                230,
                1
            ],
            olive: [
                128,
                128,
                0,
                1
            ],
            olivedrab: [
                107,
                142,
                35,
                1
            ],
            orange: [
                255,
                165,
                0,
                1
            ],
            orangered: [
                255,
                69,
                0,
                1
            ],
            orchid: [
                218,
                112,
                214,
                1
            ],
            palegoldenrod: [
                238,
                232,
                170,
                1
            ],
            palegreen: [
                152,
                251,
                152,
                1
            ],
            paleturquoise: [
                175,
                238,
                238,
                1
            ],
            palevioletred: [
                219,
                112,
                147,
                1
            ],
            papayawhip: [
                255,
                239,
                213,
                1
            ],
            peachpuff: [
                255,
                218,
                185,
                1
            ],
            peru: [
                205,
                133,
                63,
                1
            ],
            pink: [
                255,
                192,
                203,
                1
            ],
            plum: [
                221,
                160,
                221,
                1
            ],
            powderblue: [
                176,
                224,
                230,
                1
            ],
            purple: [
                128,
                0,
                128,
                1
            ],
            rebeccapurple: [
                102,
                51,
                153,
                1
            ],
            red: [
                255,
                0,
                0,
                1
            ],
            rosybrown: [
                188,
                143,
                143,
                1
            ],
            royalblue: [
                65,
                105,
                225,
                1
            ],
            saddlebrown: [
                139,
                69,
                19,
                1
            ],
            salmon: [
                250,
                128,
                114,
                1
            ],
            sandybrown: [
                244,
                164,
                96,
                1
            ],
            seagreen: [
                46,
                139,
                87,
                1
            ],
            seashell: [
                255,
                245,
                238,
                1
            ],
            sienna: [
                160,
                82,
                45,
                1
            ],
            silver: [
                192,
                192,
                192,
                1
            ],
            skyblue: [
                135,
                206,
                235,
                1
            ],
            slateblue: [
                106,
                90,
                205,
                1
            ],
            slategray: [
                112,
                128,
                144,
                1
            ],
            slategrey: [
                112,
                128,
                144,
                1
            ],
            snow: [
                255,
                250,
                250,
                1
            ],
            springgreen: [
                0,
                255,
                127,
                1
            ],
            steelblue: [
                70,
                130,
                180,
                1
            ],
            tan: [
                210,
                180,
                140,
                1
            ],
            teal: [
                0,
                128,
                128,
                1
            ],
            thistle: [
                216,
                191,
                216,
                1
            ],
            tomato: [
                255,
                99,
                71,
                1
            ],
            turquoise: [
                64,
                224,
                208,
                1
            ],
            violet: [
                238,
                130,
                238,
                1
            ],
            wheat: [
                245,
                222,
                179,
                1
            ],
            white: [
                255,
                255,
                255,
                1
            ],
            whitesmoke: [
                245,
                245,
                245,
                1
            ],
            yellow: [
                255,
                255,
                0,
                1
            ],
            yellowgreen: [
                154,
                205,
                50,
                1
            ]
        };
        function Ct(t1) {
            return (t1 = Math.round(t1)) < 0 ? 0 : t1 > 255 ? 255 : t1;
        }
        function Pt(t1) {
            return Ct("%" === t1[t1.length - 1] ? parseFloat(t1) / 100 * 255 : parseInt(t1));
        }
        function Vt(t1) {
            var e1;
            return (e1 = "%" === t1[t1.length - 1] ? parseFloat(t1) / 100 : parseFloat(t1)) < 0 ? 0 : e1 > 1 ? 1 : e1;
        }
        function Et(t1, e1, r) {
            return r < 0 ? r += 1 : r > 1 && (r -= 1), 6 * r < 1 ? t1 + (e1 - t1) * r * 6 : 2 * r < 1 ? e1 : 3 * r < 2 ? t1 + (e1 - t1) * (2 / 3 - r) * 6 : t1;
        }
        try {
            zt = ({}).parseCSSColor = function(t1) {
                var e1, r = t1.replace(/ /g, "").toLowerCase();
                if (r in Bt) return Bt[r].slice();
                if ("#" === r[0]) return 4 === r.length ? (e1 = parseInt(r.substr(1), 16)) >= 0 && e1 <= 4095 ? [
                    (3840 & e1) >> 4 | (3840 & e1) >> 8,
                    240 & e1 | (240 & e1) >> 4,
                    15 & e1 | (15 & e1) << 4,
                    1
                ] : null : 7 === r.length && (e1 = parseInt(r.substr(1), 16)) >= 0 && e1 <= 16777215 ? [
                    (16711680 & e1) >> 16,
                    (65280 & e1) >> 8,
                    255 & e1,
                    1
                ] : null;
                var n = r.indexOf("("), i = r.indexOf(")");
                if (-1 !== n && i + 1 === r.length) {
                    var a = r.substr(0, n), s = r.substr(n + 1, i - (n + 1)).split(","), o = 1;
                    switch(a){
                        case "rgba":
                            if (4 !== s.length) return null;
                            o = Vt(s.pop());
                        case "rgb":
                            return 3 !== s.length ? null : [
                                Pt(s[0]),
                                Pt(s[1]),
                                Pt(s[2]),
                                o
                            ];
                        case "hsla":
                            if (4 !== s.length) return null;
                            o = Vt(s.pop());
                        case "hsl":
                            if (3 !== s.length) return null;
                            var l = (parseFloat(s[0]) % 360 + 360) % 360 / 360, u = Vt(s[1]), c = Vt(s[2]), h = c <= .5 ? c * (u + 1) : c + u - c * u, p = 2 * c - h;
                            return [
                                Ct(255 * Et(p, h, l + 1 / 3)),
                                Ct(255 * Et(p, h, l)),
                                Ct(255 * Et(p, h, l - 1 / 3)),
                                o
                            ];
                        default:
                            return null;
                    }
                }
                return null;
            };
        } catch (t1) {}
        class Ft {
            static parse(t1) {
                if (!t1) return;
                if (t1 instanceof Ft) return t1;
                if ("string" != typeof t1) return;
                const e1 = zt(t1);
                return e1 ? new Ft(e1[0] / 255 * e1[3], e1[1] / 255 * e1[3], e1[2] / 255 * e1[3], e1[3]) : void 0;
            }
            toString() {
                const [t1, e1, r, n] = this.toArray();
                return `rgba(${Math.round(t1)},${Math.round(e1)},${Math.round(r)},${n})`;
            }
            toArray() {
                const { r: t1, g: e1, b: r, a: n } = this;
                return 0 === n ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    255 * t1 / n,
                    255 * e1 / n,
                    255 * r / n,
                    n
                ];
            }
            constructor(t1, e1, r, n = 1){
                this.r = t1, this.g = e1, this.b = r, this.a = n;
            }
        }
        Ft.black = new Ft(0, 0, 0, 1), Ft.white = new Ft(1, 1, 1, 1), Ft.transparent = new Ft(0, 0, 0, 0), Ft.red = new Ft(1, 0, 0, 1);
        class Tt {
            compare(t1, e1) {
                return this.collator.compare(t1, e1);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
            constructor(t1, e1, r){
                this.sensitivity = t1 ? e1 ? "variant" : "case" : e1 ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
        }
        class Lt {
            constructor(t1, e1, r, n, i){
                this.text = t1, this.image = e1, this.scale = r, this.fontStack = n, this.textColor = i;
            }
        }
        class Dt {
            static fromString(t1) {
                return new Dt([
                    new Lt(t1, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((t1)=>0 !== t1.text.length || t1.image && 0 !== t1.image.name.length);
            }
            static factory(t1) {
                return t1 instanceof Dt ? t1 : Dt.fromString(t1);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((t1)=>t1.text).join("");
            }
            constructor(t1){
                this.sections = t1;
            }
        }
        class $t {
            static parse(t1) {
                if (t1 instanceof $t) return t1;
                if ("number" == typeof t1) return new $t([
                    t1,
                    t1,
                    t1,
                    t1
                ]);
                if (Array.isArray(t1) && !(t1.length < 1 || t1.length > 4)) {
                    for (const e1 of t1)if ("number" != typeof e1) return;
                    switch(t1.length){
                        case 1:
                            t1 = [
                                t1[0],
                                t1[0],
                                t1[0],
                                t1[0]
                            ];
                            break;
                        case 2:
                            t1 = [
                                t1[0],
                                t1[1],
                                t1[0],
                                t1[1]
                            ];
                            break;
                        case 3:
                            t1 = [
                                t1[0],
                                t1[1],
                                t1[2],
                                t1[1]
                            ];
                    }
                    return new $t(t1);
                }
            }
            toString() {
                return JSON.stringify(this.values);
            }
            constructor(t1){
                this.values = t1.slice();
            }
        }
        class Rt {
            toString() {
                return this.name;
            }
            static fromString(t1) {
                return t1 ? new Rt({
                    name: t1,
                    available: !1
                }) : null;
            }
            constructor(t1){
                this.name = t1.name, this.available = t1.available;
            }
        }
        function Ot(t1, e1, r, n) {
            return "number" == typeof t1 && t1 >= 0 && t1 <= 255 && "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                t1,
                e1,
                r,
                n
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                t1,
                e1,
                r,
                n
            ] : [
                t1,
                e1,
                r
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function Ut(t1) {
            if (null === t1) return !0;
            if ("string" == typeof t1) return !0;
            if ("boolean" == typeof t1) return !0;
            if ("number" == typeof t1) return !0;
            if (t1 instanceof Ft) return !0;
            if (t1 instanceof Tt) return !0;
            if (t1 instanceof Dt) return !0;
            if (t1 instanceof $t) return !0;
            if (t1 instanceof Rt) return !0;
            if (Array.isArray(t1)) {
                for (const e1 of t1)if (!Ut(e1)) return !1;
                return !0;
            }
            if ("object" == typeof t1) {
                for(const e1 in t1)if (!Ut(t1[e1])) return !1;
                return !0;
            }
            return !1;
        }
        function qt(t1) {
            if (null === t1) return ht;
            if ("string" == typeof t1) return ft;
            if ("boolean" == typeof t1) return dt;
            if ("number" == typeof t1) return pt;
            if (t1 instanceof Ft) return yt;
            if (t1 instanceof Tt) return xt;
            if (t1 instanceof Dt) return vt;
            if (t1 instanceof $t) return bt;
            if (t1 instanceof Rt) return wt;
            if (Array.isArray(t1)) {
                const e1 = t1.length;
                let r;
                for (const e1 of t1){
                    const t1 = qt(e1);
                    if (r) {
                        if (r === t1) continue;
                        r = gt;
                        break;
                    }
                    r = t1;
                }
                return _t(r || gt, e1);
            }
            return mt;
        }
        function jt(t1) {
            const e1 = typeof t1;
            return null === t1 ? "" : "string" === e1 || "number" === e1 || "boolean" === e1 ? String(t1) : t1 instanceof Ft || t1 instanceof Dt || t1 instanceof $t || t1 instanceof Rt ? t1.toString() : JSON.stringify(t1);
        }
        class Nt {
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error(`'literal' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                if (!Ut(t1[1])) return e1.error("invalid value");
                const r = t1[1];
                let n = qt(r);
                const i = e1.expectedType;
                return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new Nt(n, r);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            constructor(t1, e1){
                this.type = t1, this.value = e1;
            }
        }
        class Zt {
            toJSON() {
                return this.message;
            }
            constructor(t1){
                this.name = "ExpressionEvaluationError", this.message = t1;
            }
        }
        const Kt = {
            string: ft,
            number: pt,
            boolean: dt,
            object: mt
        };
        class Gt {
            static parse(t1, e1) {
                if (t1.length < 2) return e1.error("Expected at least one argument.");
                let r, n = 1;
                const i = t1[0];
                if ("array" === i) {
                    let i, a;
                    if (t1.length > 2) {
                        const r = t1[1];
                        if ("string" != typeof r || !(r in Kt) || "object" === r) return e1.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        i = Kt[r], n++;
                    } else i = gt;
                    if (t1.length > 3) {
                        if (null !== t1[2] && ("number" != typeof t1[2] || t1[2] < 0 || t1[2] !== Math.floor(t1[2]))) return e1.error('The length argument to "array" must be a positive integer literal', 2);
                        a = t1[2], n++;
                    }
                    r = _t(i, a);
                } else {
                    if (!Kt[i]) throw new Error(`Types doesn't contain name = ${i}`);
                    r = Kt[i];
                }
                const a = [];
                for(; n < t1.length; n++){
                    const r = e1.parse(t1[n], n, gt);
                    if (!r) return null;
                    a.push(r);
                }
                return new Gt(r, a);
            }
            evaluate(t1) {
                for(let e1 = 0; e1 < this.args.length; e1++){
                    const r = this.args[e1].evaluate(t1);
                    if (!St(this.type, qt(r))) return r;
                    if (e1 === this.args.length - 1) throw new Zt(`Expected value to be of type ${At(this.type)}, but found ${At(qt(r))} instead.`);
                }
                throw new Error;
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            constructor(t1, e1){
                this.type = t1, this.args = e1;
            }
        }
        const Jt = {
            "to-boolean": dt,
            "to-color": yt,
            "to-number": pt,
            "to-string": ft
        };
        class Xt {
            static parse(t1, e1) {
                if (t1.length < 2) return e1.error("Expected at least one argument.");
                const r = t1[0];
                if (!Jt[r]) throw new Error(`Can't parse ${r} as it is not part of the known types`);
                if (("to-boolean" === r || "to-string" === r) && 2 !== t1.length) return e1.error("Expected one argument.");
                const n = Jt[r], i = [];
                for(let r = 1; r < t1.length; r++){
                    const n = e1.parse(t1[r], r, gt);
                    if (!n) return null;
                    i.push(n);
                }
                return new Xt(n, i);
            }
            evaluate(t1) {
                if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(t1));
                if ("color" === this.type.kind) {
                    let e1, r;
                    for (const n of this.args){
                        if (e1 = n.evaluate(t1), r = null, e1 instanceof Ft) return e1;
                        if ("string" == typeof e1) {
                            const r = t1.parseColor(e1);
                            if (r) return r;
                        } else if (Array.isArray(e1) && (r = e1.length < 3 || e1.length > 4 ? `Invalid rbga value ${JSON.stringify(e1)}: expected an array containing either three or four numeric values.` : Ot(e1[0], e1[1], e1[2], e1[3]), !r)) return new Ft(e1[0] / 255, e1[1] / 255, e1[2] / 255, e1[3]);
                    }
                    throw new Zt(r || `Could not parse color from value '${"string" == typeof e1 ? e1 : JSON.stringify(e1)}'`);
                }
                if ("padding" === this.type.kind) {
                    let e1;
                    for (const r of this.args){
                        e1 = r.evaluate(t1);
                        const n = $t.parse(e1);
                        if (n) return n;
                    }
                    throw new Zt(`Could not parse padding from value '${"string" == typeof e1 ? e1 : JSON.stringify(e1)}'`);
                }
                if ("number" === this.type.kind) {
                    let e1 = null;
                    for (const r of this.args){
                        if (e1 = r.evaluate(t1), null === e1) return 0;
                        const n = Number(e1);
                        if (!isNaN(n)) return n;
                    }
                    throw new Zt(`Could not convert ${JSON.stringify(e1)} to number.`);
                }
                return "formatted" === this.type.kind ? Dt.fromString(jt(this.args[0].evaluate(t1))) : "resolvedImage" === this.type.kind ? Rt.fromString(jt(this.args[0].evaluate(t1))) : jt(this.args[0].evaluate(t1));
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            constructor(t1, e1){
                this.type = t1, this.args = e1;
            }
        }
        const Yt = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class Ht {
            id() {
                return this.feature && "id" in this.feature ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? Yt[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            parseColor(t1) {
                let e1 = this._parseColorCache[t1];
                return e1 || (e1 = this._parseColorCache[t1] = Ft.parse(t1)), e1;
            }
            constructor(){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
            }
        }
        class Wt {
            evaluate(t1) {
                return this._evaluate(t1, this.args);
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return !1;
            }
            static parse(t1, e1) {
                const r = t1[0], n = Wt.definitions[r];
                if (!n) return e1.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const i = Array.isArray(n) ? n[0] : n.type, a = Array.isArray(n) ? [
                    [
                        n[1],
                        n[2]
                    ]
                ] : n.overloads, s = a.filter(([e1])=>!Array.isArray(e1) || e1.length === t1.length - 1);
                let o = null;
                for (const [n, a] of s){
                    o = new we(e1.registry, e1.path, null, e1.scope);
                    const s = [];
                    let l = !1;
                    for(let e1 = 1; e1 < t1.length; e1++){
                        const r = t1[e1], i = Array.isArray(n) ? n[e1 - 1] : n.type, a = o.parse(r, 1 + s.length, i);
                        if (!a) {
                            l = !0;
                            break;
                        }
                        s.push(a);
                    }
                    if (!l) {
                        if (Array.isArray(n) && n.length !== s.length) o.error(`Expected ${n.length} arguments, but found ${s.length} instead.`);
                        else {
                            for(let t1 = 0; t1 < s.length; t1++){
                                const e1 = Array.isArray(n) ? n[t1] : n.type, r = s[t1];
                                o.concat(t1 + 1).checkSubtype(e1, r.type);
                            }
                            if (0 === o.errors.length) return new Wt(r, i, a, s);
                        }
                    }
                }
                if (1 === s.length) e1.errors.push(...o.errors);
                else {
                    const r = (s.length ? s : a).map(([t1])=>{
                        var e1;
                        return e1 = t1, Array.isArray(e1) ? `(${e1.map(At).join(", ")})` : `(${At(e1.type)}...)`;
                    }).join(" | "), n = [];
                    for(let r = 1; r < t1.length; r++){
                        const i = e1.parse(t1[r], 1 + n.length);
                        if (!i) return null;
                        n.push(At(i.type));
                    }
                    e1.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);
                }
                return null;
            }
            static register(t1, e1) {
                Wt.definitions = e1;
                for(const r in e1)t1[r] = Wt;
            }
            constructor(t1, e1, r, n){
                this.name = t1, this.type = e1, this._evaluate = r, this.args = n;
            }
        }
        class Qt {
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error("Expected one argument.");
                const r = t1[1];
                if ("object" != typeof r || Array.isArray(r)) return e1.error("Collator options argument must be an object.");
                const n = e1.parse(void 0 !== r["case-sensitive"] && r["case-sensitive"], 1, dt);
                if (!n) return null;
                const i = e1.parse(void 0 !== r["diacritic-sensitive"] && r["diacritic-sensitive"], 1, dt);
                if (!i) return null;
                let a = null;
                return r.locale && (a = e1.parse(r.locale, 1, ft), !a) ? null : new Qt(n, i, a);
            }
            evaluate(t1) {
                return new Tt(this.caseSensitive.evaluate(t1), this.diacriticSensitive.evaluate(t1), this.locale ? this.locale.evaluate(t1) : null);
            }
            eachChild(t1) {
                t1(this.caseSensitive), t1(this.diacriticSensitive), this.locale && t1(this.locale);
            }
            outputDefined() {
                return !1;
            }
            constructor(t1, e1, r){
                this.type = xt, this.locale = r, this.caseSensitive = t1, this.diacriticSensitive = e1;
            }
        }
        const te = 8192;
        function ee(t1, e1) {
            t1[0] = Math.min(t1[0], e1[0]), t1[1] = Math.min(t1[1], e1[1]), t1[2] = Math.max(t1[2], e1[0]), t1[3] = Math.max(t1[3], e1[1]);
        }
        function re(t1, e1) {
            return !(t1[0] <= e1[0] || t1[2] >= e1[2] || t1[1] <= e1[1] || t1[3] >= e1[3]);
        }
        function ne(t1, e1) {
            const r = (180 + t1[0]) / 360, n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1[1] * Math.PI / 360))) / 360, i = Math.pow(2, e1.z);
            return [
                Math.round(r * i * te),
                Math.round(n * i * te)
            ];
        }
        function ie(t1, e1, r) {
            const n = t1[0] - e1[0], i = t1[1] - e1[1], a = t1[0] - r[0], s = t1[1] - r[1];
            return n * s - a * i == 0 && n * a <= 0 && i * s <= 0;
        }
        function ae(t1, e1) {
            let r = !1;
            for(let s = 0, o = e1.length; s < o; s++){
                const o = e1[s];
                for(let e1 = 0, s = o.length; e1 < s - 1; e1++){
                    if (ie(t1, o[e1], o[e1 + 1])) return !1;
                    (i = o[e1])[1] > (n = t1)[1] != (a = o[e1 + 1])[1] > n[1] && n[0] < (a[0] - i[0]) * (n[1] - i[1]) / (a[1] - i[1]) + i[0] && (r = !r);
                }
            }
            var n, i, a;
            return r;
        }
        function se(t1, e1) {
            for(let r = 0; r < e1.length; r++)if (ae(t1, e1[r])) return !0;
            return !1;
        }
        function oe(t1, e1, r, n) {
            const i = n[0] - r[0], a = n[1] - r[1], s = (t1[0] - r[0]) * a - i * (t1[1] - r[1]), o = (e1[0] - r[0]) * a - i * (e1[1] - r[1]);
            return s > 0 && o < 0 || s < 0 && o > 0;
        }
        function le(t1, e1, r) {
            for (const u of r)for(let r = 0; r < u.length - 1; ++r)if (0 != (o = [
                (s = u[r + 1])[0] - (a = u[r])[0],
                s[1] - a[1]
            ])[0] * (l = [
                (i = e1)[0] - (n = t1)[0],
                i[1] - n[1]
            ])[1] - o[1] * l[0] && oe(n, i, a, s) && oe(a, s, n, i)) return !0;
            var n, i, a, s, o, l;
            return !1;
        }
        function ue(t1, e1) {
            for(let r = 0; r < t1.length; ++r)if (!ae(t1[r], e1)) return !1;
            for(let r = 0; r < t1.length - 1; ++r)if (le(t1[r], t1[r + 1], e1)) return !1;
            return !0;
        }
        function ce(t1, e1) {
            for(let r = 0; r < e1.length; r++)if (ue(t1, e1[r])) return !0;
            return !1;
        }
        function he(t1, e1, r) {
            const n = [];
            for(let i = 0; i < t1.length; i++){
                const a = [];
                for(let n = 0; n < t1[i].length; n++){
                    const s = ne(t1[i][n], r);
                    ee(e1, s), a.push(s);
                }
                n.push(a);
            }
            return n;
        }
        function pe(t1, e1, r) {
            const n = [];
            for(let i = 0; i < t1.length; i++){
                const a = he(t1[i], e1, r);
                n.push(a);
            }
            return n;
        }
        function fe(t1, e1, r, n) {
            if (t1[0] < r[0] || t1[0] > r[2]) {
                const e1 = .5 * n;
                let i = t1[0] - r[0] > e1 ? -n : r[0] - t1[0] > e1 ? n : 0;
                0 === i && (i = t1[0] - r[2] > e1 ? -n : r[2] - t1[0] > e1 ? n : 0), t1[0] += i;
            }
            ee(e1, t1);
        }
        function de(t1, e1, r, n) {
            const i = Math.pow(2, n.z) * te, a = [
                n.x * te,
                n.y * te
            ], s = [];
            for (const n of t1)for (const t1 of n){
                const n = [
                    t1.x + a[0],
                    t1.y + a[1]
                ];
                fe(n, e1, r, i), s.push(n);
            }
            return s;
        }
        function ye(t1, e1, r, n) {
            const i = Math.pow(2, n.z) * te, a = [
                n.x * te,
                n.y * te
            ], s = [];
            for (const r of t1){
                const t1 = [];
                for (const n of r){
                    const r = [
                        n.x + a[0],
                        n.y + a[1]
                    ];
                    ee(e1, r), t1.push(r);
                }
                s.push(t1);
            }
            if (e1[2] - e1[0] <= i / 2) {
                (o = e1)[0] = o[1] = 1 / 0, o[2] = o[3] = -1 / 0;
                for (const t1 of s)for (const n of t1)fe(n, e1, r, i);
            }
            var o;
            return s;
        }
        class me {
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error(`'within' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                if (Ut(t1[1])) {
                    const e1 = t1[1];
                    if ("FeatureCollection" === e1.type) for(let t1 = 0; t1 < e1.features.length; ++t1){
                        const r = e1.features[t1].geometry.type;
                        if ("Polygon" === r || "MultiPolygon" === r) return new me(e1, e1.features[t1].geometry);
                    }
                    else if ("Feature" === e1.type) {
                        const t1 = e1.geometry.type;
                        if ("Polygon" === t1 || "MultiPolygon" === t1) return new me(e1, e1.geometry);
                    } else if ("Polygon" === e1.type || "MultiPolygon" === e1.type) return new me(e1, e1);
                }
                return e1.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(t1) {
                if (null != t1.geometry() && null != t1.canonicalID()) {
                    if ("Point" === t1.geometryType()) return function(t1, e1) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t1.canonicalID();
                        if ("Polygon" === e1.type) {
                            const a = he(e1.coordinates, n, i), s = de(t1.geometry(), r, n, i);
                            if (!re(r, n)) return !1;
                            for (const t1 of s)if (!ae(t1, a)) return !1;
                        }
                        if ("MultiPolygon" === e1.type) {
                            const a = pe(e1.coordinates, n, i), s = de(t1.geometry(), r, n, i);
                            if (!re(r, n)) return !1;
                            for (const t1 of s)if (!se(t1, a)) return !1;
                        }
                        return !0;
                    }(t1, this.geometries);
                    if ("LineString" === t1.geometryType()) return function(t1, e1) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t1.canonicalID();
                        if ("Polygon" === e1.type) {
                            const a = he(e1.coordinates, n, i), s = ye(t1.geometry(), r, n, i);
                            if (!re(r, n)) return !1;
                            for (const t1 of s)if (!ue(t1, a)) return !1;
                        }
                        if ("MultiPolygon" === e1.type) {
                            const a = pe(e1.coordinates, n, i), s = ye(t1.geometry(), r, n, i);
                            if (!re(r, n)) return !1;
                            for (const t1 of s)if (!ce(t1, a)) return !1;
                        }
                        return !0;
                    }(t1, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            constructor(t1, e1){
                this.type = dt, this.geojson = t1, this.geometries = e1;
            }
        }
        function ge(t1) {
            if (t1 instanceof Wt) {
                if ("get" === t1.name && 1 === t1.args.length) return !1;
                if ("feature-state" === t1.name) return !1;
                if ("has" === t1.name && 1 === t1.args.length) return !1;
                if ("properties" === t1.name || "geometry-type" === t1.name || "id" === t1.name) return !1;
                if (/^filter-/.test(t1.name)) return !1;
            }
            if (t1 instanceof me) return !1;
            let e1 = !0;
            return t1.eachChild((t1)=>{
                e1 && !ge(t1) && (e1 = !1);
            }), e1;
        }
        function xe(t1) {
            if (t1 instanceof Wt && "feature-state" === t1.name) return !1;
            let e1 = !0;
            return t1.eachChild((t1)=>{
                e1 && !xe(t1) && (e1 = !1);
            }), e1;
        }
        function ve(t1, e1) {
            if (t1 instanceof Wt && e1.indexOf(t1.name) >= 0) return !1;
            let r = !0;
            return t1.eachChild((t1)=>{
                r && !ve(t1, e1) && (r = !1);
            }), r;
        }
        class be {
            static parse(t1, e1) {
                if (2 !== t1.length || "string" != typeof t1[1]) return e1.error("'var' expression requires exactly one string literal argument.");
                const r = t1[1];
                return e1.scope.has(r) ? new be(r, e1.scope.get(r)) : e1.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(t1) {
                return this.boundExpression.evaluate(t1);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            constructor(t1, e1){
                this.type = e1.type, this.name = t1, this.boundExpression = e1;
            }
        }
        class we {
            parse(t1, e1, r, n, i = {}) {
                return e1 ? this.concat(e1, r, n)._parse(t1, i) : this._parse(t1, i);
            }
            _parse(t1, e1) {
                function r(t1, e1, r) {
                    return "assert" === r ? new Gt(e1, [
                        t1
                    ]) : "coerce" === r ? new Xt(e1, [
                        t1
                    ]) : t1;
                }
                if (null !== t1 && "string" != typeof t1 && "boolean" != typeof t1 && "number" != typeof t1 || (t1 = [
                    "literal",
                    t1
                ]), Array.isArray(t1)) {
                    if (0 === t1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const n = t1[0];
                    if ("string" != typeof n) return this.error(`Expression name must be a string, but found ${typeof n} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                    const i = this.registry[n];
                    if (i) {
                        let n = i.parse(t1, this);
                        if (!n) return null;
                        if (this.expectedType) {
                            const t1 = this.expectedType, i = n.type;
                            if ("string" !== t1.kind && "number" !== t1.kind && "boolean" !== t1.kind && "object" !== t1.kind && "array" !== t1.kind || "value" !== i.kind) {
                                if ("color" !== t1.kind && "formatted" !== t1.kind && "resolvedImage" !== t1.kind || "value" !== i.kind && "string" !== i.kind) {
                                    if ("padding" !== t1.kind || "value" !== i.kind && "number" !== i.kind && "array" !== i.kind) {
                                        if (this.checkSubtype(t1, i)) return null;
                                    } else n = r(n, t1, e1.typeAnnotation || "coerce");
                                } else n = r(n, t1, e1.typeAnnotation || "coerce");
                            } else n = r(n, t1, e1.typeAnnotation || "assert");
                        }
                        if (!(n instanceof Nt) && "resolvedImage" !== n.type.kind && _e(n)) {
                            const t1 = new Ht;
                            try {
                                n = new Nt(n.type, n.evaluate(t1));
                            } catch (t1) {
                                return this.error(t1.message), null;
                            }
                        }
                        return n;
                    }
                    return this.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`, 0);
                }
                return this.error(void 0 === t1 ? "'undefined' value invalid. Use null instead." : "object" == typeof t1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t1} instead.`);
            }
            concat(t1, e1, r) {
                const n = "number" == typeof t1 ? this.path.concat(t1) : this.path, i = r ? this.scope.concat(r) : this.scope;
                return new we(this.registry, n, e1 || null, i, this.errors);
            }
            error(t1, ...e1) {
                const r = `${this.key}${e1.map((t1)=>`[${t1}]`).join("")}`;
                this.errors.push(new ut(r, t1));
            }
            checkSubtype(t1, e1) {
                const r = St(t1, e1);
                return r && this.error(r), r;
            }
            constructor(t1, e1 = [], r, n = new ct, i = []){
                this.registry = t1, this.path = e1, this.key = e1.map((t1)=>`[${t1}]`).join(""), this.scope = n, this.errors = i, this.expectedType = r;
            }
        }
        function _e(t1) {
            if (t1 instanceof be) return _e(t1.boundExpression);
            if (t1 instanceof Wt && "error" === t1.name) return !1;
            if (t1 instanceof Qt) return !1;
            if (t1 instanceof me) return !1;
            const e1 = t1 instanceof Xt || t1 instanceof Gt;
            let r = !0;
            return t1.eachChild((t1)=>{
                r = e1 ? r && _e(t1) : r && t1 instanceof Nt;
            }), !!r && ge(t1) && ve(t1, [
                "zoom",
                "heatmap-density",
                "line-progress",
                "accumulated",
                "is-supported-script"
            ]);
        }
        function Ae(t1, e1) {
            const r = t1.length - 1;
            let n, i, a = 0, s = r, o = 0;
            for(; a <= s;)if (o = Math.floor((a + s) / 2), n = t1[o], i = t1[o + 1], n <= e1) {
                if (o === r || e1 < i) return o;
                a = o + 1;
            } else {
                if (!(n > e1)) throw new Zt("Input is not a number.");
                s = o - 1;
            }
            return 0;
        }
        class ke {
            static parse(t1, e1) {
                if (t1.length - 1 < 4) return e1.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                const r = e1.parse(t1[1], 1, pt);
                if (!r) return null;
                const n = [];
                let i = null;
                e1.expectedType && "value" !== e1.expectedType.kind && (i = e1.expectedType);
                for(let r = 1; r < t1.length; r += 2){
                    const a = 1 === r ? -1 / 0 : t1[r], s = t1[r + 1], o = r, l = r + 1;
                    if ("number" != typeof a) return e1.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', o);
                    if (n.length && n[n.length - 1][0] >= a) return e1.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', o);
                    const u = e1.parse(s, l, i);
                    if (!u) return null;
                    i = i || u.type, n.push([
                        a,
                        u
                    ]);
                }
                return new ke(i, r, n);
            }
            evaluate(t1) {
                const e1 = this.labels, r = this.outputs;
                if (1 === e1.length) return r[0].evaluate(t1);
                const n = this.input.evaluate(t1);
                if (n <= e1[0]) return r[0].evaluate(t1);
                const i = e1.length;
                return n >= e1[i - 1] ? r[i - 1].evaluate(t1) : r[Ae(e1, n)].evaluate(t1);
            }
            eachChild(t1) {
                t1(this.input);
                for (const e1 of this.outputs)t1(e1);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined());
            }
            constructor(t1, e1, r){
                this.type = t1, this.input = e1, this.labels = [], this.outputs = [];
                for (const [t1, e1] of r)this.labels.push(t1), this.outputs.push(e1);
            }
        }
        function Se(t1, e1, r) {
            return t1 * (1 - r) + e1 * r;
        }
        var Ie = Object.freeze({
            __proto__: null,
            number: Se,
            color: function(t1, e1, r) {
                return new Ft(Se(t1.r, e1.r, r), Se(t1.g, e1.g, r), Se(t1.b, e1.b, r), Se(t1.a, e1.a, r));
            },
            array: function(t1, e1, r) {
                return t1.map((t1, n)=>Se(t1, e1[n], r));
            },
            padding: function(t1, e1, r) {
                const n = t1.values, i = e1.values;
                return new $t([
                    Se(n[0], i[0], r),
                    Se(n[1], i[1], r),
                    Se(n[2], i[2], r),
                    Se(n[3], i[3], r)
                ]);
            }
        });
        const Me = .95047, ze = 1.08883, Be = 4 / 29, Ce = 6 / 29, Pe = 3 * Ce * Ce, Ve = Math.PI / 180, Ee = 180 / Math.PI;
        function Fe(t1) {
            return t1 > .008856451679035631 ? Math.pow(t1, 1 / 3) : t1 / Pe + Be;
        }
        function Te(t1) {
            return t1 > Ce ? t1 * t1 * t1 : Pe * (t1 - Be);
        }
        function Le(t1) {
            return 255 * (t1 <= .0031308 ? 12.92 * t1 : 1.055 * Math.pow(t1, 1 / 2.4) - .055);
        }
        function De(t1) {
            return (t1 /= 255) <= .04045 ? t1 / 12.92 : Math.pow((t1 + .055) / 1.055, 2.4);
        }
        function $e(t1) {
            const e1 = De(t1.r), r = De(t1.g), n = De(t1.b), i = Fe((.4124564 * e1 + .3575761 * r + .1804375 * n) / Me), a = Fe((.2126729 * e1 + .7151522 * r + .072175 * n) / 1);
            return {
                l: 116 * a - 16,
                a: 500 * (i - a),
                b: 200 * (a - Fe((.0193339 * e1 + .119192 * r + .9503041 * n) / ze)),
                alpha: t1.a
            };
        }
        function Re(t1) {
            let e1 = (t1.l + 16) / 116, r = isNaN(t1.a) ? e1 : e1 + t1.a / 500, n = isNaN(t1.b) ? e1 : e1 - t1.b / 200;
            return e1 = 1 * Te(e1), r = Me * Te(r), n = ze * Te(n), new Ft(Le(3.2404542 * r - 1.5371385 * e1 - .4985314 * n), Le(-0.969266 * r + 1.8760108 * e1 + .041556 * n), Le(.0556434 * r - .2040259 * e1 + 1.0572252 * n), t1.alpha);
        }
        function Oe(t1, e1, r) {
            const n = e1 - t1;
            return t1 + r * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n);
        }
        const Ue = {
            forward: $e,
            reverse: Re,
            interpolate: function(t1, e1, r) {
                return {
                    l: Se(t1.l, e1.l, r),
                    a: Se(t1.a, e1.a, r),
                    b: Se(t1.b, e1.b, r),
                    alpha: Se(t1.alpha, e1.alpha, r)
                };
            }
        }, qe = {
            forward: function(t1) {
                const { l: e1, a: r, b: n } = $e(t1), i = Math.atan2(n, r) * Ee;
                return {
                    h: i < 0 ? i + 360 : i,
                    c: Math.sqrt(r * r + n * n),
                    l: e1,
                    alpha: t1.a
                };
            },
            reverse: function(t1) {
                const e1 = t1.h * Ve, r = t1.c;
                return Re({
                    l: t1.l,
                    a: Math.cos(e1) * r,
                    b: Math.sin(e1) * r,
                    alpha: t1.alpha
                });
            },
            interpolate: function(t1, e1, r) {
                return {
                    h: Oe(t1.h, e1.h, r),
                    c: Se(t1.c, e1.c, r),
                    l: Se(t1.l, e1.l, r),
                    alpha: Se(t1.alpha, e1.alpha, r)
                };
            }
        };
        var je = Object.freeze({
            __proto__: null,
            lab: Ue,
            hcl: qe
        });
        class Ne {
            static interpolationFactor(t1, r, n, i) {
                let a = 0;
                if ("exponential" === t1.name) a = Ze(r, t1.base, n, i);
                else if ("linear" === t1.name) a = Ze(r, 1, n, i);
                else if ("cubic-bezier" === t1.name) {
                    const s = t1.controlPoints;
                    a = new e1(s[0], s[1], s[2], s[3]).solve(Ze(r, 1, n, i));
                }
                return a;
            }
            static parse(t1, e1) {
                let [r, n, i, ...a] = t1;
                if (!Array.isArray(n) || 0 === n.length) return e1.error("Expected an interpolation type expression.", 1);
                if ("linear" === n[0]) n = {
                    name: "linear"
                };
                else if ("exponential" === n[0]) {
                    const t1 = n[1];
                    if ("number" != typeof t1) return e1.error("Exponential interpolation requires a numeric base.", 1, 1);
                    n = {
                        name: "exponential",
                        base: t1
                    };
                } else {
                    if ("cubic-bezier" !== n[0]) return e1.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                    {
                        const t1 = n.slice(1);
                        if (4 !== t1.length || t1.some((t1)=>"number" != typeof t1 || t1 < 0 || t1 > 1)) return e1.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        n = {
                            name: "cubic-bezier",
                            controlPoints: t1
                        };
                    }
                }
                if (t1.length - 1 < 4) return e1.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                if (i = e1.parse(i, 2, pt), !i) return null;
                const s = [];
                let o = null;
                "interpolate-hcl" === r || "interpolate-lab" === r ? o = yt : e1.expectedType && "value" !== e1.expectedType.kind && (o = e1.expectedType);
                for(let t1 = 0; t1 < a.length; t1 += 2){
                    const r = a[t1], n = a[t1 + 1], i = t1 + 3, l = t1 + 4;
                    if ("number" != typeof r) return e1.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i);
                    if (s.length && s[s.length - 1][0] >= r) return e1.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i);
                    const u = e1.parse(n, l, o);
                    if (!u) return null;
                    o = o || u.type, s.push([
                        r,
                        u
                    ]);
                }
                return "number" === o.kind || "color" === o.kind || "padding" === o.kind || "array" === o.kind && "number" === o.itemType.kind && "number" == typeof o.N ? new Ne(o, r, n, i, s) : e1.error(`Type ${At(o)} is not interpolatable.`);
            }
            evaluate(t1) {
                const e1 = this.labels, r = this.outputs;
                if (1 === e1.length) return r[0].evaluate(t1);
                const n = this.input.evaluate(t1);
                if (n <= e1[0]) return r[0].evaluate(t1);
                const i = e1.length;
                if (n >= e1[i - 1]) return r[i - 1].evaluate(t1);
                const a = Ae(e1, n), s = Ne.interpolationFactor(this.interpolation, n, e1[a], e1[a + 1]), o = r[a].evaluate(t1), l = r[a + 1].evaluate(t1);
                return "interpolate" === this.operator ? Ie[this.type.kind.toLowerCase()](o, l, s) : "interpolate-hcl" === this.operator ? qe.reverse(qe.interpolate(qe.forward(o), qe.forward(l), s)) : Ue.reverse(Ue.interpolate(Ue.forward(o), Ue.forward(l), s));
            }
            eachChild(t1) {
                t1(this.input);
                for (const e1 of this.outputs)t1(e1);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined());
            }
            constructor(t1, e1, r, n, i){
                this.type = t1, this.operator = e1, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                for (const [t1, e1] of i)this.labels.push(t1), this.outputs.push(e1);
            }
        }
        function Ze(t1, e1, r, n) {
            const i = n - r, a = t1 - r;
            return 0 === i ? 0 : 1 === e1 ? a / i : (Math.pow(e1, a) - 1) / (Math.pow(e1, i) - 1);
        }
        class Ke {
            static parse(t1, e1) {
                if (t1.length < 2) return e1.error("Expectected at least one argument.");
                let r = null;
                const n = e1.expectedType;
                n && "value" !== n.kind && (r = n);
                const i = [];
                for (const n of t1.slice(1)){
                    const t1 = e1.parse(n, 1 + i.length, r, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!t1) return null;
                    r = r || t1.type, i.push(t1);
                }
                if (!r) throw new Error("No output type");
                const a = n && i.some((t1)=>St(n, t1.type));
                return new Ke(a ? gt : r, i);
            }
            evaluate(t1) {
                let e1, r = null, n = 0;
                for (const i of this.args)if (n++, r = i.evaluate(t1), r && r instanceof Rt && !r.available && (e1 || (e1 = r.name), r = null, n === this.args.length && (r = e1)), null !== r) break;
                return r;
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            constructor(t1, e1){
                this.type = t1, this.args = e1;
            }
        }
        class Ge {
            evaluate(t1) {
                return this.result.evaluate(t1);
            }
            eachChild(t1) {
                for (const e1 of this.bindings)t1(e1[1]);
                t1(this.result);
            }
            static parse(t1, e1) {
                if (t1.length < 4) return e1.error(`Expected at least 3 arguments, but found ${t1.length - 1} instead.`);
                const r = [];
                for(let n = 1; n < t1.length - 1; n += 2){
                    const i = t1[n];
                    if ("string" != typeof i) return e1.error(`Expected string, but found ${typeof i} instead.`, n);
                    if (/[^a-zA-Z0-9_]/.test(i)) return e1.error("Variable names must contain only alphanumeric characters or '_'.", n);
                    const a = e1.parse(t1[n + 1], n + 1);
                    if (!a) return null;
                    r.push([
                        i,
                        a
                    ]);
                }
                const n = e1.parse(t1[t1.length - 1], t1.length - 1, e1.expectedType, r);
                return n ? new Ge(r, n) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
            constructor(t1, e1){
                this.type = e1.type, this.bindings = [].concat(t1), this.result = e1;
            }
        }
        class Je {
            static parse(t1, e1) {
                if (3 !== t1.length) return e1.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1, pt), n = e1.parse(t1[2], 2, _t(e1.expectedType || gt));
                return r && n ? new Je(n.type.itemType, r, n) : null;
            }
            evaluate(t1) {
                const e1 = this.index.evaluate(t1), r = this.input.evaluate(t1);
                if (e1 < 0) throw new Zt(`Array index out of bounds: ${e1} < 0.`);
                if (e1 >= r.length) throw new Zt(`Array index out of bounds: ${e1} > ${r.length - 1}.`);
                if (e1 !== Math.floor(e1)) throw new Zt(`Array index must be an integer, but found ${e1} instead.`);
                return r[e1];
            }
            eachChild(t1) {
                t1(this.index), t1(this.input);
            }
            outputDefined() {
                return !1;
            }
            constructor(t1, e1, r){
                this.type = t1, this.index = e1, this.input = r;
            }
        }
        class Xe {
            static parse(t1, e1) {
                if (3 !== t1.length) return e1.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1, gt), n = e1.parse(t1[2], 2, gt);
                return r && n ? It(r.type, [
                    dt,
                    ft,
                    pt,
                    ht,
                    gt
                ]) ? new Xe(r, n) : e1.error(`Expected first argument to be of type boolean, string, number or null, but found ${At(r.type)} instead`) : null;
            }
            evaluate(t1) {
                const e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                if (!r) return !1;
                if (!Mt(e1, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new Zt(`Expected first argument to be of type boolean, string, number or null, but found ${At(qt(e1))} instead.`);
                if (!Mt(r, [
                    "string",
                    "array"
                ])) throw new Zt(`Expected second argument to be of type array or string, but found ${At(qt(r))} instead.`);
                return r.indexOf(e1) >= 0;
            }
            eachChild(t1) {
                t1(this.needle), t1(this.haystack);
            }
            outputDefined() {
                return !0;
            }
            constructor(t1, e1){
                this.type = dt, this.needle = t1, this.haystack = e1;
            }
        }
        class Ye {
            static parse(t1, e1) {
                if (t1.length <= 2 || t1.length >= 5) return e1.error(`Expected 3 or 4 arguments, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1, gt), n = e1.parse(t1[2], 2, gt);
                if (!r || !n) return null;
                if (!It(r.type, [
                    dt,
                    ft,
                    pt,
                    ht,
                    gt
                ])) return e1.error(`Expected first argument to be of type boolean, string, number or null, but found ${At(r.type)} instead`);
                if (4 === t1.length) {
                    const i = e1.parse(t1[3], 3, pt);
                    return i ? new Ye(r, n, i) : null;
                }
                return new Ye(r, n);
            }
            evaluate(t1) {
                const e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                if (!Mt(e1, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new Zt(`Expected first argument to be of type boolean, string, number or null, but found ${At(qt(e1))} instead.`);
                if (!Mt(r, [
                    "string",
                    "array"
                ])) throw new Zt(`Expected second argument to be of type array or string, but found ${At(qt(r))} instead.`);
                if (this.fromIndex) {
                    const n = this.fromIndex.evaluate(t1);
                    return r.indexOf(e1, n);
                }
                return r.indexOf(e1);
            }
            eachChild(t1) {
                t1(this.needle), t1(this.haystack), this.fromIndex && t1(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
            constructor(t1, e1, r){
                this.type = pt, this.needle = t1, this.haystack = e1, this.fromIndex = r;
            }
        }
        class He {
            static parse(t1, e1) {
                if (t1.length < 5) return e1.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if (t1.length % 2 != 1) return e1.error("Expected an even number of arguments.");
                let r, n;
                e1.expectedType && "value" !== e1.expectedType.kind && (n = e1.expectedType);
                const i = {}, a = [];
                for(let s = 2; s < t1.length - 1; s += 2){
                    let o = t1[s];
                    const l = t1[s + 1];
                    Array.isArray(o) || (o = [
                        o
                    ]);
                    const u = e1.concat(s);
                    if (0 === o.length) return u.error("Expected at least one branch label.");
                    for (const t1 of o){
                        if ("number" != typeof t1 && "string" != typeof t1) return u.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof t1 && Math.abs(t1) > Number.MAX_SAFE_INTEGER) return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof t1 && Math.floor(t1) !== t1) return u.error("Numeric branch labels must be integer values.");
                        if (r) {
                            if (u.checkSubtype(r, qt(t1))) return null;
                        } else r = qt(t1);
                        if (void 0 !== i[String(t1)]) return u.error("Branch labels must be unique.");
                        i[String(t1)] = a.length;
                    }
                    const c = e1.parse(l, s, n);
                    if (!c) return null;
                    n = n || c.type, a.push(c);
                }
                const s = e1.parse(t1[1], 1, gt);
                if (!s) return null;
                const o = e1.parse(t1[t1.length - 1], t1.length - 1, n);
                return o ? "value" !== s.type.kind && e1.concat(1).checkSubtype(r, s.type) ? null : new He(r, n, s, i, a, o) : null;
            }
            evaluate(t1) {
                const e1 = this.input.evaluate(t1);
                return (qt(e1) === this.inputType && this.outputs[this.cases[e1]] || this.otherwise).evaluate(t1);
            }
            eachChild(t1) {
                t1(this.input), this.outputs.forEach(t1), t1(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined()) && this.otherwise.outputDefined();
            }
            constructor(t1, e1, r, n, i, a){
                this.inputType = t1, this.type = e1, this.input = r, this.cases = n, this.outputs = i, this.otherwise = a;
            }
        }
        class We {
            static parse(t1, e1) {
                if (t1.length < 4) return e1.error(`Expected at least 3 arguments, but found only ${t1.length - 1}.`);
                if (t1.length % 2 != 0) return e1.error("Expected an odd number of arguments.");
                let r;
                e1.expectedType && "value" !== e1.expectedType.kind && (r = e1.expectedType);
                const n = [];
                for(let i = 1; i < t1.length - 1; i += 2){
                    const a = e1.parse(t1[i], i, dt);
                    if (!a) return null;
                    const s = e1.parse(t1[i + 1], i + 1, r);
                    if (!s) return null;
                    n.push([
                        a,
                        s
                    ]), r = r || s.type;
                }
                const i = e1.parse(t1[t1.length - 1], t1.length - 1, r);
                if (!i) return null;
                if (!r) throw new Error("Can't infer output type");
                return new We(r, n, i);
            }
            evaluate(t1) {
                for (const [e1, r] of this.branches)if (e1.evaluate(t1)) return r.evaluate(t1);
                return this.otherwise.evaluate(t1);
            }
            eachChild(t1) {
                for (const [e1, r] of this.branches)t1(e1), t1(r);
                t1(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([t1, e1])=>e1.outputDefined()) && this.otherwise.outputDefined();
            }
            constructor(t1, e1, r){
                this.type = t1, this.branches = e1, this.otherwise = r;
            }
        }
        class Qe {
            static parse(t1, e1) {
                if (t1.length <= 2 || t1.length >= 5) return e1.error(`Expected 3 or 4 arguments, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1, gt), n = e1.parse(t1[2], 2, pt);
                if (!r || !n) return null;
                if (!It(r.type, [
                    _t(gt),
                    ft,
                    gt
                ])) return e1.error(`Expected first argument to be of type array or string, but found ${At(r.type)} instead`);
                if (4 === t1.length) {
                    const i = e1.parse(t1[3], 3, pt);
                    return i ? new Qe(r.type, r, n, i) : null;
                }
                return new Qe(r.type, r, n);
            }
            evaluate(t1) {
                const e1 = this.input.evaluate(t1), r = this.beginIndex.evaluate(t1);
                if (!Mt(e1, [
                    "string",
                    "array"
                ])) throw new Zt(`Expected first argument to be of type array or string, but found ${At(qt(e1))} instead.`);
                if (this.endIndex) {
                    const n = this.endIndex.evaluate(t1);
                    return e1.slice(r, n);
                }
                return e1.slice(r);
            }
            eachChild(t1) {
                t1(this.input), t1(this.beginIndex), this.endIndex && t1(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
            constructor(t1, e1, r, n){
                this.type = t1, this.input = e1, this.beginIndex = r, this.endIndex = n;
            }
        }
        function tr(t1, e1) {
            return "==" === t1 || "!=" === t1 ? "boolean" === e1.kind || "string" === e1.kind || "number" === e1.kind || "null" === e1.kind || "value" === e1.kind : "string" === e1.kind || "number" === e1.kind || "value" === e1.kind;
        }
        function er(t1, e1, r, n) {
            return 0 === n.compare(e1, r);
        }
        function rr(t1, e1, r) {
            const n = "==" !== t1 && "!=" !== t1;
            return class i {
                static parse(t1, e1) {
                    if (3 !== t1.length && 4 !== t1.length) return e1.error("Expected two or three arguments.");
                    const r = t1[0];
                    let a = e1.parse(t1[1], 1, gt);
                    if (!a) return null;
                    if (!tr(r, a.type)) return e1.concat(1).error(`"${r}" comparisons are not supported for type '${At(a.type)}'.`);
                    let s = e1.parse(t1[2], 2, gt);
                    if (!s) return null;
                    if (!tr(r, s.type)) return e1.concat(2).error(`"${r}" comparisons are not supported for type '${At(s.type)}'.`);
                    if (a.type.kind !== s.type.kind && "value" !== a.type.kind && "value" !== s.type.kind) return e1.error(`Cannot compare types '${At(a.type)}' and '${At(s.type)}'.`);
                    n && ("value" === a.type.kind && "value" !== s.type.kind ? a = new Gt(s.type, [
                        a
                    ]) : "value" !== a.type.kind && "value" === s.type.kind && (s = new Gt(a.type, [
                        s
                    ])));
                    let o = null;
                    if (4 === t1.length) {
                        if ("string" !== a.type.kind && "string" !== s.type.kind && "value" !== a.type.kind && "value" !== s.type.kind) return e1.error("Cannot use collator to compare non-string types.");
                        if (o = e1.parse(t1[3], 3, xt), !o) return null;
                    }
                    return new i(a, s, o);
                }
                evaluate(i) {
                    const a = this.lhs.evaluate(i), s = this.rhs.evaluate(i);
                    if (n && this.hasUntypedArgument) {
                        const e1 = qt(a), r = qt(s);
                        if (e1.kind !== r.kind || "string" !== e1.kind && "number" !== e1.kind) throw new Zt(`Expected arguments for "${t1}" to be (string, string) or (number, number), but found (${e1.kind}, ${r.kind}) instead.`);
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        const t1 = qt(a), r = qt(s);
                        if ("string" !== t1.kind || "string" !== r.kind) return e1(i, a, s);
                    }
                    return this.collator ? r(i, a, s, this.collator.evaluate(i)) : e1(i, a, s);
                }
                eachChild(t1) {
                    t1(this.lhs), t1(this.rhs), this.collator && t1(this.collator);
                }
                outputDefined() {
                    return !0;
                }
                constructor(t1, e1, r){
                    this.type = dt, this.lhs = t1, this.rhs = e1, this.collator = r, this.hasUntypedArgument = "value" === t1.type.kind || "value" === e1.type.kind;
                }
            };
        }
        const nr = rr("==", function(t1, e1, r) {
            return e1 === r;
        }, er), ir = rr("!=", function(t1, e1, r) {
            return e1 !== r;
        }, function(t1, e1, r, n) {
            return !er(0, e1, r, n);
        }), ar = rr("<", function(t1, e1, r) {
            return e1 < r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) < 0;
        }), sr = rr(">", function(t1, e1, r) {
            return e1 > r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) > 0;
        }), or = rr("<=", function(t1, e1, r) {
            return e1 <= r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) <= 0;
        }), lr = rr(">=", function(t1, e1, r) {
            return e1 >= r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) >= 0;
        });
        class ur {
            static parse(t1, e1) {
                if (3 !== t1.length) return e1.error("Expected two arguments.");
                const r = e1.parse(t1[1], 1, pt);
                if (!r) return null;
                const n = t1[2];
                if ("object" != typeof n || Array.isArray(n)) return e1.error("NumberFormat options argument must be an object.");
                let i = null;
                if (n.locale && (i = e1.parse(n.locale, 1, ft), !i)) return null;
                let a = null;
                if (n.currency && (a = e1.parse(n.currency, 1, ft), !a)) return null;
                let s = null;
                if (n["min-fraction-digits"] && (s = e1.parse(n["min-fraction-digits"], 1, pt), !s)) return null;
                let o = null;
                return n["max-fraction-digits"] && (o = e1.parse(n["max-fraction-digits"], 1, pt), !o) ? null : new ur(r, i, a, s, o);
            }
            evaluate(t1) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t1) : [], {
                    style: this.currency ? "currency" : "decimal",
                    currency: this.currency ? this.currency.evaluate(t1) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t1) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t1) : void 0
                }).format(this.number.evaluate(t1));
            }
            eachChild(t1) {
                t1(this.number), this.locale && t1(this.locale), this.currency && t1(this.currency), this.minFractionDigits && t1(this.minFractionDigits), this.maxFractionDigits && t1(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
            constructor(t1, e1, r, n, i){
                this.type = ft, this.number = t1, this.locale = e1, this.currency = r, this.minFractionDigits = n, this.maxFractionDigits = i;
            }
        }
        class cr {
            static parse(t1, e1) {
                if (t1.length < 2) return e1.error("Expected at least one argument.");
                const r = t1[1];
                if (!Array.isArray(r) && "object" == typeof r) return e1.error("First argument must be an image or text section.");
                const n = [];
                let i = !1;
                for(let r = 1; r <= t1.length - 1; ++r){
                    const a = t1[r];
                    if (i && "object" == typeof a && !Array.isArray(a)) {
                        i = !1;
                        let t1 = null;
                        if (a["font-scale"] && (t1 = e1.parse(a["font-scale"], 1, pt), !t1)) return null;
                        let r = null;
                        if (a["text-font"] && (r = e1.parse(a["text-font"], 1, _t(ft)), !r)) return null;
                        let s = null;
                        if (a["text-color"] && (s = e1.parse(a["text-color"], 1, yt), !s)) return null;
                        const o = n[n.length - 1];
                        o.scale = t1, o.font = r, o.textColor = s;
                    } else {
                        const a = e1.parse(t1[r], 1, gt);
                        if (!a) return null;
                        const s = a.type.kind;
                        if ("string" !== s && "value" !== s && "null" !== s && "resolvedImage" !== s) return e1.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        i = !0, n.push({
                            content: a,
                            scale: null,
                            font: null,
                            textColor: null
                        });
                    }
                }
                return new cr(n);
            }
            evaluate(t1) {
                return new Dt(this.sections.map((e1)=>{
                    const r = e1.content.evaluate(t1);
                    return qt(r) === wt ? new Lt("", r, null, null, null) : new Lt(jt(r), null, e1.scale ? e1.scale.evaluate(t1) : null, e1.font ? e1.font.evaluate(t1).join(",") : null, e1.textColor ? e1.textColor.evaluate(t1) : null);
                }));
            }
            eachChild(t1) {
                for (const e1 of this.sections)t1(e1.content), e1.scale && t1(e1.scale), e1.font && t1(e1.font), e1.textColor && t1(e1.textColor);
            }
            outputDefined() {
                return !1;
            }
            constructor(t1){
                this.type = vt, this.sections = t1;
            }
        }
        class hr {
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error("Expected two arguments.");
                const r = e1.parse(t1[1], 1, ft);
                return r ? new hr(r) : e1.error("No image name provided.");
            }
            evaluate(t1) {
                const e1 = this.input.evaluate(t1), r = Rt.fromString(e1);
                return r && t1.availableImages && (r.available = t1.availableImages.indexOf(e1) > -1), r;
            }
            eachChild(t1) {
                t1(this.input);
            }
            outputDefined() {
                return !1;
            }
            constructor(t1){
                this.type = wt, this.input = t1;
            }
        }
        class pr {
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error(`Expected 1 argument, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1);
                return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e1.error(`Expected argument of type string or array, but found ${At(r.type)} instead.`) : new pr(r) : null;
            }
            evaluate(t1) {
                const e1 = this.input.evaluate(t1);
                if ("string" == typeof e1) return e1.length;
                if (Array.isArray(e1)) return e1.length;
                throw new Zt(`Expected value to be of type string or array, but found ${At(qt(e1))} instead.`);
            }
            eachChild(t1) {
                t1(this.input);
            }
            outputDefined() {
                return !1;
            }
            constructor(t1){
                this.type = pt, this.input = t1;
            }
        }
        const fr = {
            "==": nr,
            "!=": ir,
            ">": sr,
            "<": ar,
            ">=": lr,
            "<=": or,
            array: Gt,
            at: Je,
            boolean: Gt,
            case: We,
            coalesce: Ke,
            collator: Qt,
            format: cr,
            image: hr,
            in: Xe,
            "index-of": Ye,
            interpolate: Ne,
            "interpolate-hcl": Ne,
            "interpolate-lab": Ne,
            length: pr,
            let: Ge,
            literal: Nt,
            match: He,
            number: Gt,
            "number-format": ur,
            object: Gt,
            slice: Qe,
            step: ke,
            string: Gt,
            "to-boolean": Xt,
            "to-color": Xt,
            "to-number": Xt,
            "to-string": Xt,
            var: be,
            within: me
        };
        function dr(t1, [e1, r, n, i]) {
            e1 = e1.evaluate(t1), r = r.evaluate(t1), n = n.evaluate(t1);
            const a = i ? i.evaluate(t1) : 1, s = Ot(e1, r, n, a);
            if (s) throw new Zt(s);
            return new Ft(e1 / 255 * a, r / 255 * a, n / 255 * a, a);
        }
        function yr(t1, e1) {
            return t1 in e1;
        }
        function mr(t1, e1) {
            const r = e1[t1];
            return void 0 === r ? null : r;
        }
        function gr(t1) {
            return {
                type: t1
            };
        }
        function xr(t1) {
            return {
                result: "success",
                value: t1
            };
        }
        function vr(t1) {
            return {
                result: "error",
                value: t1
            };
        }
        function br(t1) {
            return "data-driven" === t1["property-type"] || "cross-faded-data-driven" === t1["property-type"];
        }
        function wr(t1) {
            return !!t1.expression && t1.expression.parameters.indexOf("zoom") > -1;
        }
        function _r(t1) {
            return !!t1.expression && t1.expression.interpolated;
        }
        function Ar(t1) {
            return t1 instanceof Number ? "number" : t1 instanceof String ? "string" : t1 instanceof Boolean ? "boolean" : Array.isArray(t1) ? "array" : null === t1 ? "null" : typeof t1;
        }
        function kr(t1) {
            return "object" == typeof t1 && null !== t1 && !Array.isArray(t1);
        }
        function Sr(t1) {
            return t1;
        }
        function Ir(t1, e1) {
            const r = "color" === e1.type, n = t1.stops && "object" == typeof t1.stops[0][0], i = n || !(n || void 0 !== t1.property), a = t1.type || (_r(e1) ? "exponential" : "interval");
            if (r || "padding" === e1.type) {
                const n = r ? Ft.parse : $t.parse;
                (t1 = st({}, t1)).stops && (t1.stops = t1.stops.map((t1)=>[
                        t1[0],
                        n(t1[1])
                    ])), t1.default = n(t1.default ? t1.default : e1.default);
            }
            if (t1.colorSpace && "rgb" !== t1.colorSpace && !je[t1.colorSpace]) throw new Error(`Unknown color space: ${t1.colorSpace}`);
            let s, o, l;
            if ("exponential" === a) s = Cr;
            else if ("interval" === a) s = Br;
            else if ("categorical" === a) {
                s = zr, o = Object.create(null);
                for (const e1 of t1.stops)o[e1[0]] = e1[1];
                l = typeof t1.stops[0][0];
            } else {
                if ("identity" !== a) throw new Error(`Unknown function type "${a}"`);
                s = Pr;
            }
            if (n) {
                const r = {}, n = [];
                for(let e1 = 0; e1 < t1.stops.length; e1++){
                    const i = t1.stops[e1], a = i[0].zoom;
                    void 0 === r[a] && (r[a] = {
                        zoom: a,
                        type: t1.type,
                        property: t1.property,
                        default: t1.default,
                        stops: []
                    }, n.push(a)), r[a].stops.push([
                        i[0].value,
                        i[1]
                    ]);
                }
                const i = [];
                for (const t1 of n)i.push([
                    r[t1].zoom,
                    Ir(r[t1], e1)
                ]);
                const a = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: a,
                    interpolationFactor: Ne.interpolationFactor.bind(void 0, a),
                    zoomStops: i.map((t1)=>t1[0]),
                    evaluate: ({ zoom: r }, n)=>Cr({
                            stops: i,
                            base: t1.base
                        }, e1, r).evaluate(r, n)
                };
            }
            if (i) {
                const r = "exponential" === a ? {
                    name: "exponential",
                    base: void 0 !== t1.base ? t1.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: r,
                    interpolationFactor: Ne.interpolationFactor.bind(void 0, r),
                    zoomStops: t1.stops.map((t1)=>t1[0]),
                    evaluate: ({ zoom: r })=>s(t1, e1, r, o, l)
                };
            }
            return {
                kind: "source",
                evaluate (r, n) {
                    const i = n && n.properties ? n.properties[t1.property] : void 0;
                    return void 0 === i ? Mr(t1.default, e1.default) : s(t1, e1, i, o, l);
                }
            };
        }
        function Mr(t1, e1, r) {
            return void 0 !== t1 ? t1 : void 0 !== e1 ? e1 : void 0 !== r ? r : void 0;
        }
        function zr(t1, e1, r, n, i) {
            return Mr(typeof r === i ? n[r] : void 0, t1.default, e1.default);
        }
        function Br(t1, e1, r) {
            if ("number" !== Ar(r)) return Mr(t1.default, e1.default);
            const n = t1.stops.length;
            if (1 === n) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[n - 1][0]) return t1.stops[n - 1][1];
            const i = Ae(t1.stops.map((t1)=>t1[0]), r);
            return t1.stops[i][1];
        }
        function Cr(t1, e1, r) {
            const n = void 0 !== t1.base ? t1.base : 1;
            if ("number" !== Ar(r)) return Mr(t1.default, e1.default);
            const i = t1.stops.length;
            if (1 === i) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[i - 1][0]) return t1.stops[i - 1][1];
            const a = Ae(t1.stops.map((t1)=>t1[0]), r), s = function(t1, e1, r, n) {
                const i = n - r, a = t1 - r;
                return 0 === i ? 0 : 1 === e1 ? a / i : (Math.pow(e1, a) - 1) / (Math.pow(e1, i) - 1);
            }(r, n, t1.stops[a][0], t1.stops[a + 1][0]), o = t1.stops[a][1], l = t1.stops[a + 1][1];
            let u = Ie[e1.type] || Sr;
            if (t1.colorSpace && "rgb" !== t1.colorSpace) {
                const e1 = je[t1.colorSpace];
                u = (t1, r)=>e1.reverse(e1.interpolate(e1.forward(t1), e1.forward(r), s));
            }
            return "function" == typeof o.evaluate ? {
                evaluate (...t1) {
                    const e1 = o.evaluate.apply(void 0, t1), r = l.evaluate.apply(void 0, t1);
                    if (void 0 !== e1 && void 0 !== r) return u(e1, r, s);
                }
            } : u(o, l, s);
        }
        function Pr(t1, e1, r) {
            switch(e1.type){
                case "color":
                    r = Ft.parse(r);
                    break;
                case "formatted":
                    r = Dt.fromString(r.toString());
                    break;
                case "resolvedImage":
                    r = Rt.fromString(r.toString());
                    break;
                case "padding":
                    r = $t.parse(r);
                    break;
                default:
                    Ar(r) === e1.type || "enum" === e1.type && e1.values[r] || (r = void 0);
            }
            return Mr(r, t1.default, e1.default);
        }
        Wt.register(fr, {
            error: [
                {
                    kind: "error"
                },
                [
                    ft
                ],
                (t1, [e1])=>{
                    throw new Zt(e1.evaluate(t1));
                }
            ],
            typeof: [
                ft,
                [
                    gt
                ],
                (t1, [e1])=>At(qt(e1.evaluate(t1)))
            ],
            "to-rgba": [
                _t(pt, 4),
                [
                    yt
                ],
                (t1, [e1])=>e1.evaluate(t1).toArray()
            ],
            rgb: [
                yt,
                [
                    pt,
                    pt,
                    pt
                ],
                dr
            ],
            rgba: [
                yt,
                [
                    pt,
                    pt,
                    pt,
                    pt
                ],
                dr
            ],
            has: {
                type: dt,
                overloads: [
                    [
                        [
                            ft
                        ],
                        (t1, [e1])=>yr(e1.evaluate(t1), t1.properties())
                    ],
                    [
                        [
                            ft,
                            mt
                        ],
                        (t1, [e1, r])=>yr(e1.evaluate(t1), r.evaluate(t1))
                    ]
                ]
            },
            get: {
                type: gt,
                overloads: [
                    [
                        [
                            ft
                        ],
                        (t1, [e1])=>mr(e1.evaluate(t1), t1.properties())
                    ],
                    [
                        [
                            ft,
                            mt
                        ],
                        (t1, [e1, r])=>mr(e1.evaluate(t1), r.evaluate(t1))
                    ]
                ]
            },
            "feature-state": [
                gt,
                [
                    ft
                ],
                (t1, [e1])=>mr(e1.evaluate(t1), t1.featureState || {})
            ],
            properties: [
                mt,
                [],
                (t1)=>t1.properties()
            ],
            "geometry-type": [
                ft,
                [],
                (t1)=>t1.geometryType()
            ],
            id: [
                gt,
                [],
                (t1)=>t1.id()
            ],
            zoom: [
                pt,
                [],
                (t1)=>t1.globals.zoom
            ],
            "heatmap-density": [
                pt,
                [],
                (t1)=>t1.globals.heatmapDensity || 0
            ],
            "line-progress": [
                pt,
                [],
                (t1)=>t1.globals.lineProgress || 0
            ],
            accumulated: [
                gt,
                [],
                (t1)=>void 0 === t1.globals.accumulated ? null : t1.globals.accumulated
            ],
            "+": [
                pt,
                gr(pt),
                (t1, e1)=>{
                    let r = 0;
                    for (const n of e1)r += n.evaluate(t1);
                    return r;
                }
            ],
            "*": [
                pt,
                gr(pt),
                (t1, e1)=>{
                    let r = 1;
                    for (const n of e1)r *= n.evaluate(t1);
                    return r;
                }
            ],
            "-": {
                type: pt,
                overloads: [
                    [
                        [
                            pt,
                            pt
                        ],
                        (t1, [e1, r])=>e1.evaluate(t1) - r.evaluate(t1)
                    ],
                    [
                        [
                            pt
                        ],
                        (t1, [e1])=>-e1.evaluate(t1)
                    ]
                ]
            },
            "/": [
                pt,
                [
                    pt,
                    pt
                ],
                (t1, [e1, r])=>e1.evaluate(t1) / r.evaluate(t1)
            ],
            "%": [
                pt,
                [
                    pt,
                    pt
                ],
                (t1, [e1, r])=>e1.evaluate(t1) % r.evaluate(t1)
            ],
            ln2: [
                pt,
                [],
                ()=>Math.LN2
            ],
            pi: [
                pt,
                [],
                ()=>Math.PI
            ],
            e: [
                pt,
                [],
                ()=>Math.E
            ],
            "^": [
                pt,
                [
                    pt,
                    pt
                ],
                (t1, [e1, r])=>Math.pow(e1.evaluate(t1), r.evaluate(t1))
            ],
            sqrt: [
                pt,
                [
                    pt
                ],
                (t1, [e1])=>Math.sqrt(e1.evaluate(t1))
            ],
            log10: [
                pt,
                [
                    pt
                ],
                (t1, [e1])=>Math.log(e1.evaluate(t1)) / Math.LN10
            ],
            ln: [
                pt,
                [
                    pt
                ],
                (t1, [e1])=>Math.log(e1.evaluate(t1))
            ],
            log2: [
                pt,
                [
                    pt
                ],
                (t1, [e1])=>Math.log(e1.evaluate(t1)) / Math.LN2
            ],
            sin: [
                pt,
                [
                    pt
                ],
                (t1, [e1])=>Math.sin(e1.evaluate(t1))
            ],
            cos: [
                pt,
                [
                    pt
                ],
                (t1, [e1])=>Math.cos(e1.evaluate(t1))
            ],
            tan: [
                pt,
                [
                    pt
                ],
                (t1, [e1])=>Math.tan(e1.evaluate(t1))
            ],
            asin: [
                pt,
                [
                    pt
                ],
                (t1, [e1])=>Math.asin(e1.evaluate(t1))
            ],
            acos: [
                pt,
                [
                    pt
                ],
                (t1, [e1])=>Math.acos(e1.evaluate(t1))
            ],
            atan: [
                pt,
                [
                    pt
                ],
                (t1, [e1])=>Math.atan(e1.evaluate(t1))
            ],
            min: [
                pt,
                gr(pt),
                (t1, e1)=>Math.min(...e1.map((e1)=>e1.evaluate(t1)))
            ],
            max: [
                pt,
                gr(pt),
                (t1, e1)=>Math.max(...e1.map((e1)=>e1.evaluate(t1)))
            ],
            abs: [
                pt,
                [
                    pt
                ],
                (t1, [e1])=>Math.abs(e1.evaluate(t1))
            ],
            round: [
                pt,
                [
                    pt
                ],
                (t1, [e1])=>{
                    const r = e1.evaluate(t1);
                    return r < 0 ? -Math.round(-r) : Math.round(r);
                }
            ],
            floor: [
                pt,
                [
                    pt
                ],
                (t1, [e1])=>Math.floor(e1.evaluate(t1))
            ],
            ceil: [
                pt,
                [
                    pt
                ],
                (t1, [e1])=>Math.ceil(e1.evaluate(t1))
            ],
            "filter-==": [
                dt,
                [
                    ft,
                    gt
                ],
                (t1, [e1, r])=>t1.properties()[e1.value] === r.value
            ],
            "filter-id-==": [
                dt,
                [
                    gt
                ],
                (t1, [e1])=>t1.id() === e1.value
            ],
            "filter-type-==": [
                dt,
                [
                    ft
                ],
                (t1, [e1])=>t1.geometryType() === e1.value
            ],
            "filter-<": [
                dt,
                [
                    ft,
                    gt
                ],
                (t1, [e1, r])=>{
                    const n = t1.properties()[e1.value], i = r.value;
                    return typeof n == typeof i && n < i;
                }
            ],
            "filter-id-<": [
                dt,
                [
                    gt
                ],
                (t1, [e1])=>{
                    const r = t1.id(), n = e1.value;
                    return typeof r == typeof n && r < n;
                }
            ],
            "filter->": [
                dt,
                [
                    ft,
                    gt
                ],
                (t1, [e1, r])=>{
                    const n = t1.properties()[e1.value], i = r.value;
                    return typeof n == typeof i && n > i;
                }
            ],
            "filter-id->": [
                dt,
                [
                    gt
                ],
                (t1, [e1])=>{
                    const r = t1.id(), n = e1.value;
                    return typeof r == typeof n && r > n;
                }
            ],
            "filter-<=": [
                dt,
                [
                    ft,
                    gt
                ],
                (t1, [e1, r])=>{
                    const n = t1.properties()[e1.value], i = r.value;
                    return typeof n == typeof i && n <= i;
                }
            ],
            "filter-id-<=": [
                dt,
                [
                    gt
                ],
                (t1, [e1])=>{
                    const r = t1.id(), n = e1.value;
                    return typeof r == typeof n && r <= n;
                }
            ],
            "filter->=": [
                dt,
                [
                    ft,
                    gt
                ],
                (t1, [e1, r])=>{
                    const n = t1.properties()[e1.value], i = r.value;
                    return typeof n == typeof i && n >= i;
                }
            ],
            "filter-id->=": [
                dt,
                [
                    gt
                ],
                (t1, [e1])=>{
                    const r = t1.id(), n = e1.value;
                    return typeof r == typeof n && r >= n;
                }
            ],
            "filter-has": [
                dt,
                [
                    gt
                ],
                (t1, [e1])=>e1.value in t1.properties()
            ],
            "filter-has-id": [
                dt,
                [],
                (t1)=>null !== t1.id() && void 0 !== t1.id()
            ],
            "filter-type-in": [
                dt,
                [
                    _t(ft)
                ],
                (t1, [e1])=>e1.value.indexOf(t1.geometryType()) >= 0
            ],
            "filter-id-in": [
                dt,
                [
                    _t(gt)
                ],
                (t1, [e1])=>e1.value.indexOf(t1.id()) >= 0
            ],
            "filter-in-small": [
                dt,
                [
                    ft,
                    _t(gt)
                ],
                (t1, [e1, r])=>r.value.indexOf(t1.properties()[e1.value]) >= 0
            ],
            "filter-in-large": [
                dt,
                [
                    ft,
                    _t(gt)
                ],
                (t1, [e1, r])=>(function(t1, e1, r, n) {
                        for(; r <= n;){
                            const i = r + n >> 1;
                            if (e1[i] === t1) return !0;
                            e1[i] > t1 ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    })(t1.properties()[e1.value], r.value, 0, r.value.length - 1)
            ],
            all: {
                type: dt,
                overloads: [
                    [
                        [
                            dt,
                            dt
                        ],
                        (t1, [e1, r])=>e1.evaluate(t1) && r.evaluate(t1)
                    ],
                    [
                        gr(dt),
                        (t1, e1)=>{
                            for (const r of e1)if (!r.evaluate(t1)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: dt,
                overloads: [
                    [
                        [
                            dt,
                            dt
                        ],
                        (t1, [e1, r])=>e1.evaluate(t1) || r.evaluate(t1)
                    ],
                    [
                        gr(dt),
                        (t1, e1)=>{
                            for (const r of e1)if (r.evaluate(t1)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                dt,
                [
                    dt
                ],
                (t1, [e1])=>!e1.evaluate(t1)
            ],
            "is-supported-script": [
                dt,
                [
                    ft
                ],
                (t1, [e1])=>{
                    const r = t1.globals && t1.globals.isSupportedScript;
                    return !r || r(e1.evaluate(t1));
                }
            ],
            upcase: [
                ft,
                [
                    ft
                ],
                (t1, [e1])=>e1.evaluate(t1).toUpperCase()
            ],
            downcase: [
                ft,
                [
                    ft
                ],
                (t1, [e1])=>e1.evaluate(t1).toLowerCase()
            ],
            concat: [
                ft,
                gr(gt),
                (t1, e1)=>e1.map((e1)=>jt(e1.evaluate(t1))).join("")
            ],
            "resolved-locale": [
                ft,
                [
                    xt
                ],
                (t1, [e1])=>e1.evaluate(t1).resolvedLocale()
            ]
        });
        class Vr {
            evaluateWithoutErrorHandling(t1, e1, r, n, i, a) {
                return this._evaluator.globals = t1, this._evaluator.feature = e1, this._evaluator.featureState = r, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a, this.expression.evaluate(this._evaluator);
            }
            evaluate(t1, e1, r, n, i, a) {
                this._evaluator.globals = t1, this._evaluator.feature = e1 || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a || null;
                try {
                    const t1 = this.expression.evaluate(this._evaluator);
                    if (null == t1 || "number" == typeof t1 && t1 != t1) return this._defaultValue;
                    if (this._enumValues && !(t1 in this._enumValues)) throw new Zt(`Expected value to be one of ${Object.keys(this._enumValues).map((t1)=>JSON.stringify(t1)).join(", ")}, but found ${JSON.stringify(t1)} instead.`);
                    return t1;
                } catch (t1) {
                    return this._warningHistory[t1.message] || (this._warningHistory[t1.message] = !0, "undefined" != typeof console && console.warn(t1.message)), this._defaultValue;
                }
            }
            constructor(t1, e1){
                this.expression = t1, this._warningHistory = {}, this._evaluator = new Ht, this._defaultValue = e1 ? function(t1) {
                    return "color" === t1.type && kr(t1.default) ? new Ft(0, 0, 0, 0) : "color" === t1.type ? Ft.parse(t1.default) || null : "padding" === t1.type ? $t.parse(t1.default) || null : void 0 === t1.default ? null : t1.default;
                }(e1) : null, this._enumValues = e1 && "enum" === e1.type ? e1.values : null;
            }
        }
        function Er(t1) {
            return Array.isArray(t1) && t1.length > 0 && "string" == typeof t1[0] && t1[0] in fr;
        }
        function Fr(t1, e1) {
            const r = new we(fr, [], e1 ? function(t1) {
                const e1 = {
                    color: yt,
                    string: ft,
                    number: pt,
                    enum: ft,
                    boolean: dt,
                    formatted: vt,
                    padding: bt,
                    resolvedImage: wt
                };
                return "array" === t1.type ? _t(e1[t1.value] || gt, t1.length) : e1[t1.type];
            }(e1) : void 0), n = r.parse(t1, void 0, void 0, void 0, e1 && "string" === e1.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return n ? xr(new Vr(n, e1)) : vr(r.errors);
        }
        class Tr {
            evaluateWithoutErrorHandling(t1, e1, r, n, i, a) {
                return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, a);
            }
            evaluate(t1, e1, r, n, i, a) {
                return this._styleExpression.evaluate(t1, e1, r, n, i, a);
            }
            constructor(t1, e1){
                this.kind = t1, this._styleExpression = e1, this.isStateDependent = "constant" !== t1 && !xe(e1.expression);
            }
        }
        class Lr {
            evaluateWithoutErrorHandling(t1, e1, r, n, i, a) {
                return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, a);
            }
            evaluate(t1, e1, r, n, i, a) {
                return this._styleExpression.evaluate(t1, e1, r, n, i, a);
            }
            interpolationFactor(t1, e1, r) {
                return this.interpolationType ? Ne.interpolationFactor(this.interpolationType, t1, e1, r) : 0;
            }
            constructor(t1, e1, r, n){
                this.kind = t1, this.zoomStops = r, this._styleExpression = e1, this.isStateDependent = "camera" !== t1 && !xe(e1.expression), this.interpolationType = n;
            }
        }
        function Dr(t1, e1) {
            const r = Fr(t1, e1);
            if ("error" === r.result) return r;
            const n = r.value.expression, i = ge(n);
            if (!i && !br(e1)) return vr([
                new ut("", "data expressions not supported")
            ]);
            const a = ve(n, [
                "zoom"
            ]);
            if (!a && !wr(e1)) return vr([
                new ut("", "zoom expressions not supported")
            ]);
            const s = Rr(n);
            return s || a ? s instanceof ut ? vr([
                s
            ]) : s instanceof Ne && !_r(e1) ? vr([
                new ut("", '"interpolate" expressions cannot be used with this property')
            ]) : xr(s ? new Lr(i ? "camera" : "composite", r.value, s.labels, s instanceof Ne ? s.interpolation : void 0) : new Tr(i ? "constant" : "source", r.value)) : vr([
                new ut("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
            ]);
        }
        class $r {
            static deserialize(t1) {
                return new $r(t1._parameters, t1._specification);
            }
            static serialize(t1) {
                return {
                    _parameters: t1._parameters,
                    _specification: t1._specification
                };
            }
            constructor(t1, e1){
                this._parameters = t1, this._specification = e1, st(this, Ir(this._parameters, this._specification));
            }
        }
        function Rr(t1) {
            let e1 = null;
            if (t1 instanceof Ge) e1 = Rr(t1.result);
            else if (t1 instanceof Ke) {
                for (const r of t1.args)if (e1 = Rr(r), e1) break;
            } else (t1 instanceof ke || t1 instanceof Ne) && t1.input instanceof Wt && "zoom" === t1.input.name && (e1 = t1);
            return e1 instanceof ut || t1.eachChild((t1)=>{
                const r = Rr(t1);
                r instanceof ut ? e1 = r : !e1 && r ? e1 = new ut("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : e1 && r && e1 !== r && (e1 = new ut("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), e1;
        }
        function Or(t1) {
            const e1 = t1.key, r = t1.value, n = t1.valueSpec || {}, i = t1.objectElementValidators || {}, a = t1.style, s = t1.styleSpec;
            let o = [];
            const l = Ar(r);
            if ("object" !== l) return [
                new it(e1, r, `object expected, ${l} found`)
            ];
            for(const t1 in r){
                const l = t1.split(".")[0], u = n[l] || n["*"];
                let c;
                if (i[l]) c = i[l];
                else if (n[l]) c = yn;
                else if (i["*"]) c = i["*"];
                else {
                    if (!n["*"]) {
                        o.push(new it(e1, r[t1], `unknown property "${t1}"`));
                        continue;
                    }
                    c = yn;
                }
                o = o.concat(c({
                    key: (e1 ? `${e1}.` : e1) + t1,
                    value: r[t1],
                    valueSpec: u,
                    style: a,
                    styleSpec: s,
                    object: r,
                    objectKey: t1
                }, r));
            }
            for(const t1 in n)i[t1] || n[t1].required && void 0 === n[t1].default && void 0 === r[t1] && o.push(new it(e1, r, `missing required property "${t1}"`));
            return o;
        }
        function Ur(t1) {
            const e1 = t1.value, r = t1.valueSpec, n = t1.style, i = t1.styleSpec, a = t1.key, s = t1.arrayElementValidator || yn;
            if ("array" !== Ar(e1)) return [
                new it(a, e1, `array expected, ${Ar(e1)} found`)
            ];
            if (r.length && e1.length !== r.length) return [
                new it(a, e1, `array length ${r.length} expected, length ${e1.length} found`)
            ];
            if (r["min-length"] && e1.length < r["min-length"]) return [
                new it(a, e1, `array length at least ${r["min-length"]} expected, length ${e1.length} found`)
            ];
            let o = {
                type: r.value,
                values: r.values
            };
            i.$version < 7 && (o.function = r.function), "object" === Ar(r.value) && (o = r.value);
            let l = [];
            for(let t1 = 0; t1 < e1.length; t1++)l = l.concat(s({
                array: e1,
                arrayIndex: t1,
                value: e1[t1],
                valueSpec: o,
                style: n,
                styleSpec: i,
                key: `${a}[${t1}]`
            }));
            return l;
        }
        function qr(t1) {
            const e1 = t1.key, r = t1.value, n = t1.valueSpec;
            let i = Ar(r);
            return "number" === i && r != r && (i = "NaN"), "number" !== i ? [
                new it(e1, r, `number expected, ${i} found`)
            ] : "minimum" in n && r < n.minimum ? [
                new it(e1, r, `${r} is less than the minimum value ${n.minimum}`)
            ] : "maximum" in n && r > n.maximum ? [
                new it(e1, r, `${r} is greater than the maximum value ${n.maximum}`)
            ] : [];
        }
        function jr(t1) {
            const e1 = t1.valueSpec, r = ot(t1.value.type);
            let n, i, a, s = {};
            const o = "categorical" !== r && void 0 === t1.value.property, l = !o, u = "array" === Ar(t1.value.stops) && "array" === Ar(t1.value.stops[0]) && "object" === Ar(t1.value.stops[0][0]), c = Or({
                key: t1.key,
                value: t1.value,
                valueSpec: t1.styleSpec.function,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    stops: function(t1) {
                        if ("identity" === r) return [
                            new it(t1.key, t1.value, 'identity function may not have a "stops" property')
                        ];
                        let e1 = [];
                        const n = t1.value;
                        return e1 = e1.concat(Ur({
                            key: t1.key,
                            value: n,
                            valueSpec: t1.valueSpec,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            arrayElementValidator: h
                        })), "array" === Ar(n) && 0 === n.length && e1.push(new it(t1.key, n, "array must have at least one stop")), e1;
                    },
                    default: function(t1) {
                        return yn({
                            key: t1.key,
                            value: t1.value,
                            valueSpec: e1,
                            style: t1.style,
                            styleSpec: t1.styleSpec
                        });
                    }
                }
            });
            return "identity" === r && o && c.push(new it(t1.key, t1.value, 'missing required property "property"')), "identity" === r || t1.value.stops || c.push(new it(t1.key, t1.value, 'missing required property "stops"')), "exponential" === r && t1.valueSpec.expression && !_r(t1.valueSpec) && c.push(new it(t1.key, t1.value, "exponential functions not supported")), t1.styleSpec.$version >= 8 && (l && !br(t1.valueSpec) ? c.push(new it(t1.key, t1.value, "property functions not supported")) : o && !wr(t1.valueSpec) && c.push(new it(t1.key, t1.value, "zoom functions not supported"))), "categorical" !== r && !u || void 0 !== t1.value.property || c.push(new it(t1.key, t1.value, '"property" property is required')), c;
            function h(t1) {
                let r = [];
                const n = t1.value, o = t1.key;
                if ("array" !== Ar(n)) return [
                    new it(o, n, `array expected, ${Ar(n)} found`)
                ];
                if (2 !== n.length) return [
                    new it(o, n, `array length 2 expected, length ${n.length} found`)
                ];
                if (u) {
                    if ("object" !== Ar(n[0])) return [
                        new it(o, n, `object expected, ${Ar(n[0])} found`)
                    ];
                    if (void 0 === n[0].zoom) return [
                        new it(o, n, "object stop key must have zoom")
                    ];
                    if (void 0 === n[0].value) return [
                        new it(o, n, "object stop key must have value")
                    ];
                    if (a && a > ot(n[0].zoom)) return [
                        new it(o, n[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    ot(n[0].zoom) !== a && (a = ot(n[0].zoom), i = void 0, s = {}), r = r.concat(Or({
                        key: `${o}[0]`,
                        value: n[0],
                        valueSpec: {
                            zoom: {}
                        },
                        style: t1.style,
                        styleSpec: t1.styleSpec,
                        objectElementValidators: {
                            zoom: qr,
                            value: p
                        }
                    }));
                } else r = r.concat(p({
                    key: `${o}[0]`,
                    value: n[0],
                    valueSpec: {},
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }, n));
                return Er(lt(n[1])) ? r.concat([
                    new it(`${o}[1]`, n[1], "expressions are not allowed in function stops.")
                ]) : r.concat(yn({
                    key: `${o}[1]`,
                    value: n[1],
                    valueSpec: e1,
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }));
            }
            function p(t1, a) {
                const o = Ar(t1.value), l = ot(t1.value), u = null !== t1.value ? t1.value : a;
                if (n) {
                    if (o !== n) return [
                        new it(t1.key, u, `${o} stop domain type must match previous stop domain type ${n}`)
                    ];
                } else n = o;
                if ("number" !== o && "string" !== o && "boolean" !== o) return [
                    new it(t1.key, u, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== o && "categorical" !== r) {
                    let n = `number expected, ${o} found`;
                    return br(e1) && void 0 === r && (n += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new it(t1.key, u, n)
                    ];
                }
                return "categorical" !== r || "number" !== o || isFinite(l) && Math.floor(l) === l ? "categorical" !== r && "number" === o && void 0 !== i && l < i ? [
                    new it(t1.key, u, "stop domain values must appear in ascending order")
                ] : (i = l, "categorical" === r && l in s ? [
                    new it(t1.key, u, "stop domain values must be unique")
                ] : (s[l] = !0, [])) : [
                    new it(t1.key, u, `integer expected, found ${l}`)
                ];
            }
        }
        function Nr(t1) {
            const e1 = ("property" === t1.expressionContext ? Dr : Fr)(lt(t1.value), t1.valueSpec);
            if ("error" === e1.result) return e1.value.map((e1)=>new it(`${t1.key}${e1.key}`, t1.value, e1.message));
            const r = e1.value.expression || e1.value._styleExpression.expression;
            if ("property" === t1.expressionContext && "text-font" === t1.propertyKey && !r.outputDefined()) return [
                new it(t1.key, t1.value, `Invalid data expression for "${t1.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === t1.expressionContext && "layout" === t1.propertyType && !xe(r)) return [
                new it(t1.key, t1.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t1.expressionContext && !xe(r)) return [
                new it(t1.key, t1.value, '"feature-state" data expressions are not supported with filters.')
            ];
            if (t1.expressionContext && 0 === t1.expressionContext.indexOf("cluster")) {
                if (!ve(r, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new it(t1.key, t1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t1.expressionContext && !ge(r)) return [
                    new it(t1.key, t1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function Zr(t1) {
            const e1 = t1.key, r = t1.value, n = t1.valueSpec, i = [];
            return Array.isArray(n.values) ? -1 === n.values.indexOf(ot(r)) && i.push(new it(e1, r, `expected one of [${n.values.join(", ")}], ${JSON.stringify(r)} found`)) : -1 === Object.keys(n.values).indexOf(ot(r)) && i.push(new it(e1, r, `expected one of [${Object.keys(n.values).join(", ")}], ${JSON.stringify(r)} found`)), i;
        }
        function Kr(t1) {
            if (!0 === t1 || !1 === t1) return !0;
            if (!Array.isArray(t1) || 0 === t1.length) return !1;
            switch(t1[0]){
                case "has":
                    return t1.length >= 2 && "$id" !== t1[1] && "$type" !== t1[1];
                case "in":
                    return t1.length >= 3 && ("string" != typeof t1[1] || Array.isArray(t1[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== t1.length || Array.isArray(t1[1]) || Array.isArray(t1[2]);
                case "any":
                case "all":
                    for (const e1 of t1.slice(1))if (!Kr(e1) && "boolean" != typeof e1) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        const Gr = {
            type: "boolean",
            default: !1,
            transition: !1,
            "property-type": "data-driven",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            }
        };
        function Jr(t1) {
            if (null == t1) return {
                filter: ()=>!0,
                needGeometry: !1
            };
            Kr(t1) || (t1 = Hr(t1));
            const e1 = Fr(t1, Gr);
            if ("error" === e1.result) throw new Error(e1.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
            return {
                filter: (t1, r, n)=>e1.value.evaluate(t1, r, {}, n),
                needGeometry: Yr(t1)
            };
        }
        function Xr(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function Yr(t1) {
            if (!Array.isArray(t1)) return !1;
            if ("within" === t1[0]) return !0;
            for(let e1 = 1; e1 < t1.length; e1++)if (Yr(t1[e1])) return !0;
            return !1;
        }
        function Hr(t1) {
            if (!t1) return !0;
            const e1 = t1[0];
            var r;
            return t1.length <= 1 ? "any" !== e1 : "==" === e1 ? Wr(t1[1], t1[2], "==") : "!=" === e1 ? en(Wr(t1[1], t1[2], "==")) : "<" === e1 || ">" === e1 || "<=" === e1 || ">=" === e1 ? Wr(t1[1], t1[2], e1) : "any" === e1 ? (r = t1.slice(1), [
                "any"
            ].concat(r.map(Hr))) : "all" === e1 ? [
                "all"
            ].concat(t1.slice(1).map(Hr)) : "none" === e1 ? [
                "all"
            ].concat(t1.slice(1).map(Hr).map(en)) : "in" === e1 ? Qr(t1[1], t1.slice(2)) : "!in" === e1 ? en(Qr(t1[1], t1.slice(2))) : "has" === e1 ? tn(t1[1]) : "!has" === e1 ? en(tn(t1[1])) : "within" !== e1 || t1;
        }
        function Wr(t1, e1, r) {
            switch(t1){
                case "$type":
                    return [
                        `filter-type-${r}`,
                        e1
                    ];
                case "$id":
                    return [
                        `filter-id-${r}`,
                        e1
                    ];
                default:
                    return [
                        `filter-${r}`,
                        t1,
                        e1
                    ];
            }
        }
        function Qr(t1, e1) {
            if (0 === e1.length) return !1;
            switch(t1){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            e1
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            e1
                        ]
                    ];
                default:
                    return e1.length > 200 && !e1.some((t1)=>typeof t1 != typeof e1[0]) ? [
                        "filter-in-large",
                        t1,
                        [
                            "literal",
                            e1.sort(Xr)
                        ]
                    ] : [
                        "filter-in-small",
                        t1,
                        [
                            "literal",
                            e1
                        ]
                    ];
            }
        }
        function tn(t1) {
            switch(t1){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        t1
                    ];
            }
        }
        function en(t1) {
            return [
                "!",
                t1
            ];
        }
        function rn(t1) {
            return Kr(lt(t1.value)) ? Nr(st({}, t1, {
                expressionContext: "filter",
                valueSpec: {
                    value: "boolean"
                }
            })) : nn(t1);
        }
        function nn(t1) {
            const e1 = t1.value, r = t1.key;
            if ("array" !== Ar(e1)) return [
                new it(r, e1, `array expected, ${Ar(e1)} found`)
            ];
            const n = t1.styleSpec;
            let i, a = [];
            if (e1.length < 1) return [
                new it(r, e1, "filter array must have at least 1 element")
            ];
            switch(a = a.concat(Zr({
                key: `${r}[0]`,
                value: e1[0],
                valueSpec: n.filter_operator,
                style: t1.style,
                styleSpec: t1.styleSpec
            })), ot(e1[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    e1.length >= 2 && "$type" === ot(e1[1]) && a.push(new it(r, e1, `"$type" cannot be use with operator "${e1[0]}"`));
                case "==":
                case "!=":
                    3 !== e1.length && a.push(new it(r, e1, `filter array for operator "${e1[0]}" must have 3 elements`));
                case "in":
                case "!in":
                    e1.length >= 2 && (i = Ar(e1[1]), "string" !== i && a.push(new it(`${r}[1]`, e1[1], `string expected, ${i} found`)));
                    for(let s = 2; s < e1.length; s++)i = Ar(e1[s]), "$type" === ot(e1[1]) ? a = a.concat(Zr({
                        key: `${r}[${s}]`,
                        value: e1[s],
                        valueSpec: n.geometry_type,
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    })) : "string" !== i && "number" !== i && "boolean" !== i && a.push(new it(`${r}[${s}]`, e1[s], `string, number, or boolean expected, ${i} found`));
                    break;
                case "any":
                case "all":
                case "none":
                    for(let n = 1; n < e1.length; n++)a = a.concat(nn({
                        key: `${r}[${n}]`,
                        value: e1[n],
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    i = Ar(e1[1]), 2 !== e1.length ? a.push(new it(r, e1, `filter array for "${e1[0]}" operator must have 2 elements`)) : "string" !== i && a.push(new it(`${r}[1]`, e1[1], `string expected, ${i} found`));
                    break;
                case "within":
                    i = Ar(e1[1]), 2 !== e1.length ? a.push(new it(r, e1, `filter array for "${e1[0]}" operator must have 2 elements`)) : "object" !== i && a.push(new it(`${r}[1]`, e1[1], `object expected, ${i} found`));
            }
            return a;
        }
        function an(t1, e1) {
            const r = t1.key, n = t1.style, i = t1.styleSpec, a = t1.value, s = t1.objectKey, o = i[`${e1}_${t1.layerType}`];
            if (!o) return [];
            const l = s.match(/^(.*)-transition$/);
            if ("paint" === e1 && l && o[l[1]] && o[l[1]].transition) return yn({
                key: r,
                value: a,
                valueSpec: i.transition,
                style: n,
                styleSpec: i
            });
            const u = t1.valueSpec || o[s];
            if (!u) return [
                new it(r, a, `unknown property "${s}"`)
            ];
            let c;
            if ("string" === Ar(a) && br(u) && !u.tokens && (c = /^{([^}]+)}$/.exec(a))) return [
                new it(r, a, `"${s}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(c[1])} }\`.`)
            ];
            const h = [];
            return "symbol" === t1.layerType && ("text-field" === s && n && !n.glyphs && h.push(new it(r, a, 'use of "text-field" requires a style "glyphs" property')), "text-font" === s && kr(lt(a)) && "identity" === ot(a.type) && h.push(new it(r, a, '"text-font" does not support identity functions'))), h.concat(yn({
                key: t1.key,
                value: a,
                valueSpec: u,
                style: n,
                styleSpec: i,
                expressionContext: "property",
                propertyType: e1,
                propertyKey: s
            }));
        }
        function sn(t1) {
            return an(t1, "paint");
        }
        function on(t1) {
            return an(t1, "layout");
        }
        function ln(t1) {
            let e1 = [];
            const r = t1.value, n = t1.key, i = t1.style, a = t1.styleSpec;
            r.type || r.ref || e1.push(new it(n, r, 'either "type" or "ref" is required'));
            let s = ot(r.type);
            const o = ot(r.ref);
            if (r.id) {
                const a = ot(r.id);
                for(let s = 0; s < t1.arrayIndex; s++){
                    const t1 = i.layers[s];
                    ot(t1.id) === a && e1.push(new it(n, r.id, `duplicate layer id "${r.id}", previously used at line ${t1.id.__line__}`));
                }
            }
            if ("ref" in r) {
                let t1;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((t1)=>{
                    t1 in r && e1.push(new it(n, r[t1], `"${t1}" is prohibited for ref layers`));
                }), i.layers.forEach((e1)=>{
                    ot(e1.id) === o && (t1 = e1);
                }), t1 ? t1.ref ? e1.push(new it(n, r.ref, "ref cannot reference another ref layer")) : s = ot(t1.type) : e1.push(new it(n, r.ref, `ref layer "${o}" not found`));
            } else if ("background" !== s) {
                if (r.source) {
                    const t1 = i.sources && i.sources[r.source], a = t1 && ot(t1.type);
                    t1 ? "vector" === a && "raster" === s ? e1.push(new it(n, r.source, `layer "${r.id}" requires a raster source`)) : "raster" === a && "raster" !== s ? e1.push(new it(n, r.source, `layer "${r.id}" requires a vector source`)) : "vector" !== a || r["source-layer"] ? "raster-dem" === a && "hillshade" !== s ? e1.push(new it(n, r.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== s || !r.paint || !r.paint["line-gradient"] || "geojson" === a && t1.lineMetrics || e1.push(new it(n, r, `layer "${r.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : e1.push(new it(n, r, `layer "${r.id}" must specify a "source-layer"`)) : e1.push(new it(n, r.source, `source "${r.source}" not found`));
                } else e1.push(new it(n, r, 'missing required property "source"'));
            }
            return e1 = e1.concat(Or({
                key: n,
                value: r,
                valueSpec: a.layer,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>yn({
                            key: `${n}.type`,
                            value: r.type,
                            valueSpec: a.layer.type,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            object: r,
                            objectKey: "type"
                        }),
                    filter: rn,
                    layout: (t1)=>Or({
                            layer: r,
                            key: t1.key,
                            value: t1.value,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            objectElementValidators: {
                                "*": (t1)=>on(st({
                                        layerType: s
                                    }, t1))
                            }
                        }),
                    paint: (t1)=>Or({
                            layer: r,
                            key: t1.key,
                            value: t1.value,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            objectElementValidators: {
                                "*": (t1)=>sn(st({
                                        layerType: s
                                    }, t1))
                            }
                        })
                }
            })), e1;
        }
        function un(t1) {
            const e1 = t1.value, r = t1.key, n = Ar(e1);
            return "string" !== n ? [
                new it(r, e1, `string expected, ${n} found`)
            ] : [];
        }
        const cn = {
            promoteId: function({ key: t1, value: e1 }) {
                if ("string" === Ar(e1)) return un({
                    key: t1,
                    value: e1
                });
                {
                    const r = [];
                    for(const n in e1)r.push(...un({
                        key: `${t1}.${n}`,
                        value: e1[n]
                    }));
                    return r;
                }
            }
        };
        function hn(t1) {
            const e1 = t1.value, r = t1.key, n = t1.styleSpec, i = t1.style;
            if (!e1.type) return [
                new it(r, e1, '"type" is required')
            ];
            const a = ot(e1.type);
            let s;
            switch(a){
                case "vector":
                case "raster":
                case "raster-dem":
                    return s = Or({
                        key: r,
                        value: e1,
                        valueSpec: n[`source_${a.replace("-", "_")}`],
                        style: t1.style,
                        styleSpec: n,
                        objectElementValidators: cn
                    }), s;
                case "geojson":
                    if (s = Or({
                        key: r,
                        value: e1,
                        valueSpec: n.source_geojson,
                        style: i,
                        styleSpec: n,
                        objectElementValidators: cn
                    }), e1.cluster) for(const t1 in e1.clusterProperties){
                        const [n, i] = e1.clusterProperties[t1], a = "string" == typeof n ? [
                            n,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                t1
                            ]
                        ] : n;
                        s.push(...Nr({
                            key: `${r}.${t1}.map`,
                            value: i,
                            expressionContext: "cluster-map"
                        })), s.push(...Nr({
                            key: `${r}.${t1}.reduce`,
                            value: a,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return s;
                case "video":
                    return Or({
                        key: r,
                        value: e1,
                        valueSpec: n.source_video,
                        style: i,
                        styleSpec: n
                    });
                case "image":
                    return Or({
                        key: r,
                        value: e1,
                        valueSpec: n.source_image,
                        style: i,
                        styleSpec: n
                    });
                case "canvas":
                    return [
                        new it(r, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return Zr({
                        key: `${r}.type`,
                        value: e1.type,
                        valueSpec: {
                            values: [
                                "vector",
                                "raster",
                                "raster-dem",
                                "geojson",
                                "video",
                                "image"
                            ]
                        },
                        style: i,
                        styleSpec: n
                    });
            }
        }
        function pn(t1) {
            const e1 = t1.value, r = t1.styleSpec, n = r.light, i = t1.style;
            let a = [];
            const s = Ar(e1);
            if (void 0 === e1) return a;
            if ("object" !== s) return a = a.concat([
                new it("light", e1, `object expected, ${s} found`)
            ]), a;
            for(const t1 in e1){
                const s = t1.match(/^(.*)-transition$/);
                a = a.concat(s && n[s[1]] && n[s[1]].transition ? yn({
                    key: t1,
                    value: e1[t1],
                    valueSpec: r.transition,
                    style: i,
                    styleSpec: r
                }) : n[t1] ? yn({
                    key: t1,
                    value: e1[t1],
                    valueSpec: n[t1],
                    style: i,
                    styleSpec: r
                }) : [
                    new it(t1, e1[t1], `unknown property "${t1}"`)
                ]);
            }
            return a;
        }
        function fn(t1) {
            const e1 = t1.value, r = t1.styleSpec, n = r.terrain, i = t1.style;
            let a = [];
            const s = Ar(e1);
            if (void 0 === e1) return a;
            if ("object" !== s) return a = a.concat([
                new it("terrain", e1, `object expected, ${s} found`)
            ]), a;
            for(const t1 in e1)a = a.concat(n[t1] ? yn({
                key: t1,
                value: e1[t1],
                valueSpec: n[t1],
                style: i,
                styleSpec: r
            }) : [
                new it(t1, e1[t1], `unknown property "${t1}"`)
            ]);
            return a;
        }
        const dn = {
            "*": ()=>[],
            array: Ur,
            boolean: function(t1) {
                const e1 = t1.value, r = t1.key, n = Ar(e1);
                return "boolean" !== n ? [
                    new it(r, e1, `boolean expected, ${n} found`)
                ] : [];
            },
            number: qr,
            color: function(t1) {
                const e1 = t1.key, r = t1.value, n = Ar(r);
                return "string" !== n ? [
                    new it(e1, r, `color expected, ${n} found`)
                ] : null === zt(r) ? [
                    new it(e1, r, `color expected, "${r}" found`)
                ] : [];
            },
            constants: at,
            enum: Zr,
            filter: rn,
            function: jr,
            layer: ln,
            object: Or,
            source: hn,
            light: pn,
            terrain: fn,
            string: un,
            formatted: function(t1) {
                return 0 === un(t1).length ? [] : Nr(t1);
            },
            resolvedImage: function(t1) {
                return 0 === un(t1).length ? [] : Nr(t1);
            },
            padding: function(t1) {
                const e1 = t1.key, r = t1.value;
                if ("array" === Ar(r)) {
                    if (r.length < 1 || r.length > 4) return [
                        new it(e1, r, `padding requires 1 to 4 values; ${r.length} values found`)
                    ];
                    const t1 = {
                        type: "number"
                    };
                    let n = [];
                    for(let i = 0; i < r.length; i++)n = n.concat(yn({
                        key: `${e1}[${i}]`,
                        value: r[i],
                        valueSpec: t1
                    }));
                    return n;
                }
                return qr({
                    key: e1,
                    value: r,
                    valueSpec: {}
                });
            }
        };
        function yn(t1) {
            const e1 = t1.value, r = t1.valueSpec, n = t1.styleSpec;
            return r.expression && kr(ot(e1)) ? jr(t1) : r.expression && Er(lt(e1)) ? Nr(t1) : r.type && dn[r.type] ? dn[r.type](t1) : Or(st({}, t1, {
                valueSpec: r.type ? n[r.type] : r
            }));
        }
        function mn(t1) {
            const e1 = t1.value, r = t1.key, n = un(t1);
            return n.length || (-1 === e1.indexOf("{fontstack}") && n.push(new it(r, e1, '"glyphs" url must include a "{fontstack}" token')), -1 === e1.indexOf("{range}") && n.push(new it(r, e1, '"glyphs" url must include a "{range}" token'))), n;
        }
        function gn(t1, e1 = nt) {
            let r = [];
            return r = r.concat(yn({
                key: "",
                value: t1,
                valueSpec: e1.$root,
                styleSpec: e1,
                style: t1,
                objectElementValidators: {
                    glyphs: mn,
                    "*": ()=>[]
                }
            })), t1.constants && (r = r.concat(at({
                key: "constants",
                value: t1.constants,
                style: t1,
                styleSpec: e1
            }))), xn(r);
        }
        function xn(t1) {
            return [].concat(t1).sort((t1, e1)=>t1.line - e1.line);
        }
        function vn(t1) {
            return function(...e1) {
                return xn(t1.apply(this, e1));
            };
        }
        gn.source = vn(hn), gn.light = vn(pn), gn.terrain = vn(fn), gn.layer = vn(ln), gn.filter = vn(rn), gn.paintProperty = vn(sn), gn.layoutProperty = vn(on);
        const bn = gn, wn = bn.light, _n = bn.paintProperty, An = bn.layoutProperty;
        function kn(t1, e1) {
            let r = !1;
            if (e1 && e1.length) for (const n of e1)t1.fire(new et(new Error(n.message))), r = !0;
            return r;
        }
        class Sn {
            insert(t1, e1, r, n, i) {
                this._forEachCell(e1, r, n, i, this._insertCell, this.uid++, void 0, void 0), this.keys.push(t1), this.bboxes.push(e1), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
            }
            _insertReadonly() {
                throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
            }
            _insertCell(t1, e1, r, n, i, a) {
                this.cells[i].push(a);
            }
            query(t1, e1, r, n, i) {
                const a = this.min, s = this.max;
                if (t1 <= a && e1 <= a && s <= r && s <= n && !i) return Array.prototype.slice.call(this.keys);
                {
                    const a = [];
                    return this._forEachCell(t1, e1, r, n, this._queryCell, a, {}, i), a;
                }
            }
            _queryCell(t1, e1, r, n, i, a, s, o) {
                const l = this.cells[i];
                if (null !== l) {
                    const i = this.keys, u = this.bboxes;
                    for(let c = 0; c < l.length; c++){
                        const h = l[c];
                        if (void 0 === s[h]) {
                            const l = 4 * h;
                            (o ? o(u[l + 0], u[l + 1], u[l + 2], u[l + 3]) : t1 <= u[l + 2] && e1 <= u[l + 3] && r >= u[l + 0] && n >= u[l + 1]) ? (s[h] = !0, a.push(i[h])) : s[h] = !1;
                        }
                    }
                }
            }
            _forEachCell(t1, e1, r, n, i, a, s, o) {
                const l = this._convertToCellCoord(t1), u = this._convertToCellCoord(e1), c = this._convertToCellCoord(r), h = this._convertToCellCoord(n);
                for(let p = l; p <= c; p++)for(let l = u; l <= h; l++){
                    const u = this.d * l + p;
                    if ((!o || o(this._convertFromCellCoord(p), this._convertFromCellCoord(l), this._convertFromCellCoord(p + 1), this._convertFromCellCoord(l + 1))) && i.call(this, t1, e1, r, n, u, a, s, o)) return;
                }
            }
            _convertFromCellCoord(t1) {
                return (t1 - this.padding) / this.scale;
            }
            _convertToCellCoord(t1) {
                return Math.max(0, Math.min(this.d - 1, Math.floor(t1 * this.scale) + this.padding));
            }
            toArrayBuffer() {
                if (this.arrayBuffer) return this.arrayBuffer;
                const t1 = this.cells, e1 = 3 + this.cells.length + 1 + 1;
                let r = 0;
                for(let t1 = 0; t1 < this.cells.length; t1++)r += this.cells[t1].length;
                const n = new Int32Array(e1 + r + this.keys.length + this.bboxes.length);
                n[0] = this.extent, n[1] = this.n, n[2] = this.padding;
                let i = e1;
                for(let e1 = 0; e1 < t1.length; e1++){
                    const r = t1[e1];
                    n[3 + e1] = i, n.set(r, i), i += r.length;
                }
                return n[3 + t1.length] = i, n.set(this.keys, i), i += this.keys.length, n[3 + t1.length + 1] = i, n.set(this.bboxes, i), i += this.bboxes.length, n.buffer;
            }
            static serialize(t1, e1) {
                const r = t1.toArrayBuffer();
                return e1 && e1.push(r), {
                    buffer: r
                };
            }
            static deserialize(t1) {
                return new Sn(t1.buffer);
            }
            constructor(t1, e1, r){
                const n = this.cells = [];
                if (t1 instanceof ArrayBuffer) {
                    this.arrayBuffer = t1;
                    const i = new Int32Array(this.arrayBuffer);
                    t1 = i[0], this.d = (e1 = i[1]) + 2 * (r = i[2]);
                    for(let t1 = 0; t1 < this.d * this.d; t1++){
                        const e1 = i[3 + t1], r = i[3 + t1 + 1];
                        n.push(e1 === r ? null : i.subarray(e1, r));
                    }
                    const a = i[3 + n.length + 1];
                    this.keys = i.subarray(i[3 + n.length], a), this.bboxes = i.subarray(a), this.insert = this._insertReadonly;
                } else {
                    this.d = e1 + 2 * r;
                    for(let t1 = 0; t1 < this.d * this.d; t1++)n.push([]);
                    this.keys = [], this.bboxes = [];
                }
                this.n = e1, this.extent = t1, this.padding = r, this.scale = e1 / t1, this.uid = 0;
                const i = r / e1 * t1;
                this.min = -i, this.max = t1 + i;
            }
        }
        const In = {};
        function Mn(t1, e1, r = {}) {
            if (In[t1]) throw new Error(`${t1} is already registered.`);
            Object.defineProperty(e1, "_classRegistryKey", {
                value: t1,
                writeable: !1
            }), In[t1] = {
                klass: e1,
                omit: r.omit || [],
                shallow: r.shallow || []
            };
        }
        Mn("Object", Object), Mn("TransferableGridIndex", Sn), Mn("Color", Ft), Mn("Error", Error), Mn("AJAXError", q), Mn("ResolvedImage", Rt), Mn("StylePropertyFunction", $r), Mn("StyleExpression", Vr, {
            omit: [
                "_evaluator"
            ]
        }), Mn("ZoomDependentExpression", Lr), Mn("ZoomConstantExpression", Tr), Mn("CompoundExpression", Wt, {
            omit: [
                "_evaluate"
            ]
        });
        for(const t1 in fr)fr[t1]._classRegistryKey || Mn(`Expression_${t1}`, fr[t1]);
        function zn(t1) {
            return t1 && "undefined" != typeof ArrayBuffer && (t1 instanceof ArrayBuffer || t1.constructor && "ArrayBuffer" === t1.constructor.name);
        }
        function Bn(t1, e1) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp || t1 instanceof Blob) return t1;
            if (zn(t1)) return e1 && e1.push(t1), t1;
            if (A(t1)) return e1 && e1.push(t1), t1;
            if (ArrayBuffer.isView(t1)) {
                const r = t1;
                return e1 && e1.push(r.buffer), r;
            }
            if (t1 instanceof ImageData) return e1 && e1.push(t1.data.buffer), t1;
            if (Array.isArray(t1)) {
                const r = [];
                for (const n of t1)r.push(Bn(n, e1));
                return r;
            }
            if ("object" == typeof t1) {
                const r = t1.constructor, n = r._classRegistryKey;
                if (!n) throw new Error("can't serialize object of unregistered class");
                if (!In[n]) throw new Error(`${n} is not registered.`);
                const i = r.serialize ? r.serialize(t1, e1) : {};
                if (r.serialize) {
                    if (e1 && i === e1[e1.length - 1]) throw new Error("statically serialized object won't survive transfer of $name property");
                } else {
                    for(const r in t1){
                        if (!t1.hasOwnProperty(r)) continue;
                        if (In[n].omit.indexOf(r) >= 0) continue;
                        const a = t1[r];
                        i[r] = In[n].shallow.indexOf(r) >= 0 ? a : Bn(a, e1);
                    }
                    t1 instanceof Error && (i.message = t1.message);
                }
                if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
                return "Object" !== n && (i.$name = n), i;
            }
            throw new Error("can't serialize object of type " + typeof t1);
        }
        function Cn(t1) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp || t1 instanceof Blob || zn(t1) || A(t1) || ArrayBuffer.isView(t1) || t1 instanceof ImageData) return t1;
            if (Array.isArray(t1)) return t1.map(Cn);
            if ("object" == typeof t1) {
                const e1 = t1.$name || "Object";
                if (!In[e1]) throw new Error(`can't deserialize unregistered class ${e1}`);
                const { klass: r } = In[e1];
                if (!r) throw new Error(`can't deserialize unregistered class ${e1}`);
                if (r.deserialize) return r.deserialize(t1);
                const n = Object.create(r.prototype);
                for (const r of Object.keys(t1)){
                    if ("$name" === r) continue;
                    const i = t1[r];
                    n[r] = In[e1].shallow.indexOf(r) >= 0 ? i : Cn(i);
                }
                return n;
            }
            throw new Error("can't deserialize object of type " + typeof t1);
        }
        class Pn {
            update(t1, e1) {
                const r = Math.floor(t1);
                return this.first ? (this.first = !1, this.lastIntegerZoom = r, this.lastIntegerZoomTime = 0, this.lastZoom = t1, this.lastFloorZoom = r, !0) : (this.lastFloorZoom > r ? (this.lastIntegerZoom = r + 1, this.lastIntegerZoomTime = e1) : this.lastFloorZoom < r && (this.lastIntegerZoom = r, this.lastIntegerZoomTime = e1), t1 !== this.lastZoom && (this.lastZoom = t1, this.lastFloorZoom = r, !0));
            }
            constructor(){
                this.first = !0;
            }
        }
        const Vn = {
            "Latin-1 Supplement": (t1)=>t1 >= 128 && t1 <= 255,
            Arabic: (t1)=>t1 >= 1536 && t1 <= 1791,
            "Arabic Supplement": (t1)=>t1 >= 1872 && t1 <= 1919,
            "Arabic Extended-A": (t1)=>t1 >= 2208 && t1 <= 2303,
            "Hangul Jamo": (t1)=>t1 >= 4352 && t1 <= 4607,
            "Unified Canadian Aboriginal Syllabics": (t1)=>t1 >= 5120 && t1 <= 5759,
            Khmer: (t1)=>t1 >= 6016 && t1 <= 6143,
            "Unified Canadian Aboriginal Syllabics Extended": (t1)=>t1 >= 6320 && t1 <= 6399,
            "General Punctuation": (t1)=>t1 >= 8192 && t1 <= 8303,
            "Letterlike Symbols": (t1)=>t1 >= 8448 && t1 <= 8527,
            "Number Forms": (t1)=>t1 >= 8528 && t1 <= 8591,
            "Miscellaneous Technical": (t1)=>t1 >= 8960 && t1 <= 9215,
            "Control Pictures": (t1)=>t1 >= 9216 && t1 <= 9279,
            "Optical Character Recognition": (t1)=>t1 >= 9280 && t1 <= 9311,
            "Enclosed Alphanumerics": (t1)=>t1 >= 9312 && t1 <= 9471,
            "Geometric Shapes": (t1)=>t1 >= 9632 && t1 <= 9727,
            "Miscellaneous Symbols": (t1)=>t1 >= 9728 && t1 <= 9983,
            "Miscellaneous Symbols and Arrows": (t1)=>t1 >= 11008 && t1 <= 11263,
            "CJK Radicals Supplement": (t1)=>t1 >= 11904 && t1 <= 12031,
            "Kangxi Radicals": (t1)=>t1 >= 12032 && t1 <= 12255,
            "Ideographic Description Characters": (t1)=>t1 >= 12272 && t1 <= 12287,
            "CJK Symbols and Punctuation": (t1)=>t1 >= 12288 && t1 <= 12351,
            Hiragana: (t1)=>t1 >= 12352 && t1 <= 12447,
            Katakana: (t1)=>t1 >= 12448 && t1 <= 12543,
            Bopomofo: (t1)=>t1 >= 12544 && t1 <= 12591,
            "Hangul Compatibility Jamo": (t1)=>t1 >= 12592 && t1 <= 12687,
            Kanbun: (t1)=>t1 >= 12688 && t1 <= 12703,
            "Bopomofo Extended": (t1)=>t1 >= 12704 && t1 <= 12735,
            "CJK Strokes": (t1)=>t1 >= 12736 && t1 <= 12783,
            "Katakana Phonetic Extensions": (t1)=>t1 >= 12784 && t1 <= 12799,
            "Enclosed CJK Letters and Months": (t1)=>t1 >= 12800 && t1 <= 13055,
            "CJK Compatibility": (t1)=>t1 >= 13056 && t1 <= 13311,
            "CJK Unified Ideographs Extension A": (t1)=>t1 >= 13312 && t1 <= 19903,
            "Yijing Hexagram Symbols": (t1)=>t1 >= 19904 && t1 <= 19967,
            "CJK Unified Ideographs": (t1)=>t1 >= 19968 && t1 <= 40959,
            "Yi Syllables": (t1)=>t1 >= 40960 && t1 <= 42127,
            "Yi Radicals": (t1)=>t1 >= 42128 && t1 <= 42191,
            "Hangul Jamo Extended-A": (t1)=>t1 >= 43360 && t1 <= 43391,
            "Hangul Syllables": (t1)=>t1 >= 44032 && t1 <= 55215,
            "Hangul Jamo Extended-B": (t1)=>t1 >= 55216 && t1 <= 55295,
            "Private Use Area": (t1)=>t1 >= 57344 && t1 <= 63743,
            "CJK Compatibility Ideographs": (t1)=>t1 >= 63744 && t1 <= 64255,
            "Arabic Presentation Forms-A": (t1)=>t1 >= 64336 && t1 <= 65023,
            "Vertical Forms": (t1)=>t1 >= 65040 && t1 <= 65055,
            "CJK Compatibility Forms": (t1)=>t1 >= 65072 && t1 <= 65103,
            "Small Form Variants": (t1)=>t1 >= 65104 && t1 <= 65135,
            "Arabic Presentation Forms-B": (t1)=>t1 >= 65136 && t1 <= 65279,
            "Halfwidth and Fullwidth Forms": (t1)=>t1 >= 65280 && t1 <= 65519
        };
        function En(t1) {
            for (const e1 of t1)if (Ln(e1.charCodeAt(0))) return !0;
            return !1;
        }
        function Fn(t1) {
            for (const e1 of t1)if (!Tn(e1.charCodeAt(0))) return !1;
            return !0;
        }
        function Tn(t1) {
            return !(Vn.Arabic(t1) || Vn["Arabic Supplement"](t1) || Vn["Arabic Extended-A"](t1) || Vn["Arabic Presentation Forms-A"](t1) || Vn["Arabic Presentation Forms-B"](t1));
        }
        function Ln(t1) {
            return !(746 !== t1 && 747 !== t1 && (t1 < 4352 || !(Vn["Bopomofo Extended"](t1) || Vn.Bopomofo(t1) || Vn["CJK Compatibility Forms"](t1) && !(t1 >= 65097 && t1 <= 65103) || Vn["CJK Compatibility Ideographs"](t1) || Vn["CJK Compatibility"](t1) || Vn["CJK Radicals Supplement"](t1) || Vn["CJK Strokes"](t1) || !(!Vn["CJK Symbols and Punctuation"](t1) || t1 >= 12296 && t1 <= 12305 || t1 >= 12308 && t1 <= 12319 || 12336 === t1) || Vn["CJK Unified Ideographs Extension A"](t1) || Vn["CJK Unified Ideographs"](t1) || Vn["Enclosed CJK Letters and Months"](t1) || Vn["Hangul Compatibility Jamo"](t1) || Vn["Hangul Jamo Extended-A"](t1) || Vn["Hangul Jamo Extended-B"](t1) || Vn["Hangul Jamo"](t1) || Vn["Hangul Syllables"](t1) || Vn.Hiragana(t1) || Vn["Ideographic Description Characters"](t1) || Vn.Kanbun(t1) || Vn["Kangxi Radicals"](t1) || Vn["Katakana Phonetic Extensions"](t1) || Vn.Katakana(t1) && 12540 !== t1 || !(!Vn["Halfwidth and Fullwidth Forms"](t1) || 65288 === t1 || 65289 === t1 || 65293 === t1 || t1 >= 65306 && t1 <= 65310 || 65339 === t1 || 65341 === t1 || 65343 === t1 || t1 >= 65371 && t1 <= 65503 || 65507 === t1 || t1 >= 65512 && t1 <= 65519) || !(!Vn["Small Form Variants"](t1) || t1 >= 65112 && t1 <= 65118 || t1 >= 65123 && t1 <= 65126) || Vn["Unified Canadian Aboriginal Syllabics"](t1) || Vn["Unified Canadian Aboriginal Syllabics Extended"](t1) || Vn["Vertical Forms"](t1) || Vn["Yijing Hexagram Symbols"](t1) || Vn["Yi Syllables"](t1) || Vn["Yi Radicals"](t1))));
        }
        function Dn(t1) {
            return !(Ln(t1) || function(t1) {
                return !!(Vn["Latin-1 Supplement"](t1) && (167 === t1 || 169 === t1 || 174 === t1 || 177 === t1 || 188 === t1 || 189 === t1 || 190 === t1 || 215 === t1 || 247 === t1) || Vn["General Punctuation"](t1) && (8214 === t1 || 8224 === t1 || 8225 === t1 || 8240 === t1 || 8241 === t1 || 8251 === t1 || 8252 === t1 || 8258 === t1 || 8263 === t1 || 8264 === t1 || 8265 === t1 || 8273 === t1) || Vn["Letterlike Symbols"](t1) || Vn["Number Forms"](t1) || Vn["Miscellaneous Technical"](t1) && (t1 >= 8960 && t1 <= 8967 || t1 >= 8972 && t1 <= 8991 || t1 >= 8996 && t1 <= 9e3 || 9003 === t1 || t1 >= 9085 && t1 <= 9114 || t1 >= 9150 && t1 <= 9165 || 9167 === t1 || t1 >= 9169 && t1 <= 9179 || t1 >= 9186 && t1 <= 9215) || Vn["Control Pictures"](t1) && 9251 !== t1 || Vn["Optical Character Recognition"](t1) || Vn["Enclosed Alphanumerics"](t1) || Vn["Geometric Shapes"](t1) || Vn["Miscellaneous Symbols"](t1) && !(t1 >= 9754 && t1 <= 9759) || Vn["Miscellaneous Symbols and Arrows"](t1) && (t1 >= 11026 && t1 <= 11055 || t1 >= 11088 && t1 <= 11097 || t1 >= 11192 && t1 <= 11243) || Vn["CJK Symbols and Punctuation"](t1) || Vn.Katakana(t1) || Vn["Private Use Area"](t1) || Vn["CJK Compatibility Forms"](t1) || Vn["Small Form Variants"](t1) || Vn["Halfwidth and Fullwidth Forms"](t1) || 8734 === t1 || 8756 === t1 || 8757 === t1 || t1 >= 9984 && t1 <= 10087 || t1 >= 10102 && t1 <= 10131 || 65532 === t1 || 65533 === t1);
            }(t1));
        }
        function $n(t1) {
            return t1 >= 1424 && t1 <= 2303 || Vn["Arabic Presentation Forms-A"](t1) || Vn["Arabic Presentation Forms-B"](t1);
        }
        function Rn(t1, e1) {
            return !(!e1 && $n(t1) || t1 >= 2304 && t1 <= 3583 || t1 >= 3840 && t1 <= 4255 || Vn.Khmer(t1));
        }
        function On(t1) {
            for (const e1 of t1)if ($n(e1.charCodeAt(0))) return !0;
            return !1;
        }
        const Un = "deferred", qn = "loading", jn = "loaded";
        let Nn = null, Zn = "unavailable", Kn = null;
        const Gn = function(t1) {
            t1 && "string" == typeof t1 && t1.indexOf("NetworkError") > -1 && (Zn = "error"), Nn && Nn(t1);
        };
        function Jn() {
            Xn.fire(new tt("pluginStateChange", {
                pluginStatus: Zn,
                pluginURL: Kn
            }));
        }
        const Xn = new rt, Yn = function() {
            return Zn;
        }, Hn = function() {
            if (Zn !== Un || !Kn) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            Zn = qn, Jn(), Kn && K({
                url: Kn
            }, (t1)=>{
                t1 ? Gn(t1) : (Zn = jn, Jn());
            });
        }, Wn = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: ()=>Zn === jn || null != Wn.applyArabicShaping,
            isLoading: ()=>Zn === qn,
            setState (t1) {
                if (!g()) throw new Error("Cannot set the state of the rtl-text-plugin when not in the web-worker context");
                Zn = t1.pluginStatus, Kn = t1.pluginURL;
            },
            isParsed () {
                if (!g()) throw new Error("rtl-text-plugin is only parsed on the worker-threads");
                return null != Wn.applyArabicShaping && null != Wn.processBidirectionalText && null != Wn.processStyledBidirectionalText;
            },
            getPluginURL () {
                if (!g()) throw new Error("rtl-text-plugin url can only be queried from the worker threads");
                return Kn;
            }
        };
        class Qn {
            isSupportedScript(t1) {
                return function(t1, e1) {
                    for (const r of t1)if (!Rn(r.charCodeAt(0), e1)) return !1;
                    return !0;
                }(t1, Wn.isLoaded());
            }
            crossFadingFactor() {
                return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
            }
            getCrossfadeParameters() {
                const t1 = this.zoom, e1 = t1 - Math.floor(t1), r = this.crossFadingFactor();
                return t1 > this.zoomHistory.lastIntegerZoom ? {
                    fromScale: 2,
                    toScale: 1,
                    t: e1 + (1 - e1) * r
                } : {
                    fromScale: .5,
                    toScale: 1,
                    t: 1 - (1 - r) * e1
                };
            }
            constructor(t1, e1){
                this.zoom = t1, e1 ? (this.now = e1.now, this.fadeDuration = e1.fadeDuration, this.zoomHistory = e1.zoomHistory, this.transition = e1.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Pn, this.transition = {});
            }
        }
        class ti {
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(t1, e1, r) {
                return this.property.possiblyEvaluate(this, t1, e1, r);
            }
            constructor(t1, e1){
                this.property = t1, this.value = e1, this.expression = function(t1, e1) {
                    if (kr(t1)) return new $r(t1, e1);
                    if (Er(t1)) {
                        const r = Dr(t1, e1);
                        if ("error" === r.result) throw new Error(r.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                        return r.value;
                    }
                    {
                        let r = t1;
                        return "color" === e1.type && "string" == typeof t1 ? r = Ft.parse(t1) : "padding" !== e1.type || "number" != typeof t1 && !Array.isArray(t1) || (r = $t.parse(t1)), {
                            kind: "constant",
                            evaluate: ()=>r
                        };
                    }
                }(void 0 === e1 ? t1.specification.default : e1, t1.specification);
            }
        }
        class ei {
            transitioned(t1, e1) {
                return new ni(this.property, this.value, e1, o({}, t1.transition, this.transition), t1.now);
            }
            untransitioned() {
                return new ni(this.property, this.value, null, {}, 0);
            }
            constructor(t1){
                this.property = t1, this.value = new ti(t1, void 0);
            }
        }
        class ri {
            getValue(t1) {
                return p(this._values[t1].value.value);
            }
            setValue(t1, e1) {
                Object.prototype.hasOwnProperty.call(this._values, t1) || (this._values[t1] = new ei(this._values[t1].property)), this._values[t1].value = new ti(this._values[t1].property, null === e1 ? void 0 : p(e1));
            }
            getTransition(t1) {
                return p(this._values[t1].transition);
            }
            setTransition(t1, e1) {
                Object.prototype.hasOwnProperty.call(this._values, t1) || (this._values[t1] = new ei(this._values[t1].property)), this._values[t1].transition = p(e1) || void 0;
            }
            serialize() {
                const t1 = {};
                for (const e1 of Object.keys(this._values)){
                    const r = this.getValue(e1);
                    void 0 !== r && (t1[e1] = r);
                    const n = this.getTransition(e1);
                    void 0 !== n && (t1[`${e1}-transition`] = n);
                }
                return t1;
            }
            transitioned(t1, e1) {
                const r = new ii(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].transitioned(t1, e1._values[n]);
                return r;
            }
            untransitioned() {
                const t1 = new ii(this._properties);
                for (const e1 of Object.keys(this._values))t1._values[e1] = this._values[e1].untransitioned();
                return t1;
            }
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultTransitionablePropertyValues);
            }
        }
        class ni {
            possiblyEvaluate(t1, e1, r) {
                const n = t1.now || 0, i = this.value.possiblyEvaluate(t1, e1, r), a = this.prior;
                if (a) {
                    if (n > this.end) return this.prior = null, i;
                    if (this.value.isDataDriven()) return this.prior = null, i;
                    if (n < this.begin) return a.possiblyEvaluate(t1, e1, r);
                    {
                        const s = (n - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(a.possiblyEvaluate(t1, e1, r), i, function(t1) {
                            if (t1 <= 0) return 0;
                            if (t1 >= 1) return 1;
                            const e1 = t1 * t1, r = e1 * t1;
                            return 4 * (t1 < .5 ? r : 3 * (t1 - e1) + r - .75);
                        }(s));
                    }
                }
                return i;
            }
            constructor(t1, e1, r, n, i){
                this.property = t1, this.value = e1, this.begin = i + n.delay || 0, this.end = this.begin + n.duration || 0, t1.specification.transition && (n.delay || n.duration) && (this.prior = r);
            }
        }
        class ii {
            possiblyEvaluate(t1, e1, r) {
                const n = new oi(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t1, e1, r);
                return n;
            }
            hasTransition() {
                for (const t1 of Object.keys(this._values))if (this._values[t1].prior) return !0;
                return !1;
            }
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultTransitioningPropertyValues);
            }
        }
        class ai {
            getValue(t1) {
                return p(this._values[t1].value);
            }
            setValue(t1, e1) {
                this._values[t1] = new ti(this._values[t1].property, null === e1 ? void 0 : p(e1));
            }
            serialize() {
                const t1 = {};
                for (const e1 of Object.keys(this._values)){
                    const r = this.getValue(e1);
                    void 0 !== r && (t1[e1] = r);
                }
                return t1;
            }
            possiblyEvaluate(t1, e1, r) {
                const n = new oi(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t1, e1, r);
                return n;
            }
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultPropertyValues);
            }
        }
        class si {
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(t1) {
                return "constant" === this.value.kind ? this.value.value : t1;
            }
            evaluate(t1, e1, r, n) {
                return this.property.evaluate(this.value, this.parameters, t1, e1, r, n);
            }
            constructor(t1, e1, r){
                this.property = t1, this.value = e1, this.parameters = r;
            }
        }
        class oi {
            get(t1) {
                return this._values[t1];
            }
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultPossiblyEvaluatedValues);
            }
        }
        class li {
            possiblyEvaluate(t1, e1) {
                if (t1.isDataDriven()) throw new Error("Value should not be data driven");
                return t1.expression.evaluate(e1);
            }
            interpolate(t1, e1, r) {
                const n = Ie[this.specification.type];
                return n ? n(t1, e1, r) : t1;
            }
            constructor(t1){
                this.specification = t1;
            }
        }
        class ui {
            possiblyEvaluate(t1, e1, r, n) {
                return new si(this, "constant" === t1.expression.kind || "camera" === t1.expression.kind ? {
                    kind: "constant",
                    value: t1.expression.evaluate(e1, null, {}, r, n)
                } : t1.expression, e1);
            }
            interpolate(t1, e1, r) {
                if ("constant" !== t1.value.kind || "constant" !== e1.value.kind) return t1;
                if (void 0 === t1.value.value || void 0 === e1.value.value) return new si(this, {
                    kind: "constant",
                    value: void 0
                }, t1.parameters);
                const n = Ie[this.specification.type];
                return n ? new si(this, {
                    kind: "constant",
                    value: n(t1.value.value, e1.value.value, r)
                }, t1.parameters) : t1;
            }
            evaluate(t1, e1, r, n, i, a) {
                return "constant" === t1.kind ? t1.value : t1.evaluate(e1, r, n, i, a);
            }
            constructor(t1, e1){
                this.specification = t1, this.overrides = e1;
            }
        }
        class ci extends ui {
            possiblyEvaluate(t1, e1, r, n) {
                if (void 0 === t1.value) return new si(this, {
                    kind: "constant",
                    value: void 0
                }, e1);
                if ("constant" === t1.expression.kind) {
                    const i = t1.expression.evaluate(e1, null, {}, r, n), a = "resolvedImage" === t1.property.specification.type && "string" != typeof i ? i.name : i, s = this._calculate(a, a, a, e1);
                    return new si(this, {
                        kind: "constant",
                        value: s
                    }, e1);
                }
                if ("camera" === t1.expression.kind) {
                    const r = this._calculate(t1.expression.evaluate({
                        zoom: e1.zoom - 1
                    }), t1.expression.evaluate({
                        zoom: e1.zoom
                    }), t1.expression.evaluate({
                        zoom: e1.zoom + 1
                    }), e1);
                    return new si(this, {
                        kind: "constant",
                        value: r
                    }, e1);
                }
                return new si(this, t1.expression, e1);
            }
            evaluate(t1, e1, r, n, i, a) {
                if ("source" === t1.kind) {
                    const s = t1.evaluate(e1, r, n, i, a);
                    return this._calculate(s, s, s, e1);
                }
                return "composite" === t1.kind ? this._calculate(t1.evaluate({
                    zoom: Math.floor(e1.zoom) - 1
                }, r, n), t1.evaluate({
                    zoom: Math.floor(e1.zoom)
                }, r, n), t1.evaluate({
                    zoom: Math.floor(e1.zoom) + 1
                }, r, n), e1) : t1.value;
            }
            _calculate(t1, e1, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: t1,
                    to: e1
                } : {
                    from: r,
                    to: e1
                };
            }
            interpolate(t1) {
                return t1;
            }
        }
        class hi {
            possiblyEvaluate(t1, e1, r, n) {
                if (void 0 !== t1.value) {
                    if ("constant" === t1.expression.kind) {
                        const i = t1.expression.evaluate(e1, null, {}, r, n);
                        return this._calculate(i, i, i, e1);
                    }
                    return this._calculate(t1.expression.evaluate(new Qn(Math.floor(e1.zoom - 1), e1)), t1.expression.evaluate(new Qn(Math.floor(e1.zoom), e1)), t1.expression.evaluate(new Qn(Math.floor(e1.zoom + 1), e1)), e1);
                }
            }
            _calculate(t1, e1, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: t1,
                    to: e1
                } : {
                    from: r,
                    to: e1
                };
            }
            interpolate(t1) {
                return t1;
            }
            constructor(t1){
                this.specification = t1;
            }
        }
        class pi {
            possiblyEvaluate(t1, e1, r, n) {
                return !!t1.expression.evaluate(e1, null, {}, r, n);
            }
            interpolate() {
                return !1;
            }
            constructor(t1){
                this.specification = t1;
            }
        }
        class fi {
            constructor(t1){
                this.properties = t1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                for(const e1 in t1){
                    const r = t1[e1];
                    r.specification.overridable && this.overridableProperties.push(e1);
                    const n = this.defaultPropertyValues[e1] = new ti(r, void 0), i = this.defaultTransitionablePropertyValues[e1] = new ei(r);
                    this.defaultTransitioningPropertyValues[e1] = i.untransitioned(), this.defaultPossiblyEvaluatedValues[e1] = n.possiblyEvaluate({});
                }
            }
        }
        Mn("DataDrivenProperty", ui), Mn("DataConstantProperty", li), Mn("CrossFadedDataDrivenProperty", ci), Mn("CrossFadedProperty", hi), Mn("ColorRampProperty", pi);
        const di = "-transition";
        class yi extends rt {
            getCrossfadeParameters() {
                return this._crossfadeParameters;
            }
            getLayoutProperty(t1) {
                return "visibility" === t1 ? this.visibility : this._unevaluatedLayout.getValue(t1);
            }
            setLayoutProperty(t1, e1, r = {}) {
                null != e1 && this._validate(An, `layers.${this.id}.layout.${t1}`, t1, e1, r) || ("visibility" !== t1 ? this._unevaluatedLayout.setValue(t1, e1) : this.visibility = e1);
            }
            getPaintProperty(t1) {
                return t1.endsWith(di) ? this._transitionablePaint.getTransition(t1.slice(0, -di.length)) : this._transitionablePaint.getValue(t1);
            }
            setPaintProperty(t1, e1, r = {}) {
                if (null != e1 && this._validate(_n, `layers.${this.id}.paint.${t1}`, t1, e1, r)) return !1;
                if (t1.endsWith(di)) return this._transitionablePaint.setTransition(t1.slice(0, -di.length), e1 || void 0), !1;
                {
                    const r = this._transitionablePaint._values[t1], n = "cross-faded-data-driven" === r.property.specification["property-type"], i = r.value.isDataDriven(), a = r.value;
                    this._transitionablePaint.setValue(t1, e1), this._handleSpecialPaintPropertyUpdate(t1);
                    const s = this._transitionablePaint._values[t1].value;
                    return s.isDataDriven() || i || n || this._handleOverridablePaintPropertyUpdate(t1, a, s);
                }
            }
            _handleSpecialPaintPropertyUpdate(t1) {}
            _handleOverridablePaintPropertyUpdate(t1, e1, r) {
                return !1;
            }
            isHidden(t1) {
                return !!(this.minzoom && t1 < this.minzoom) || !!(this.maxzoom && t1 >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(t1) {
                this._transitioningPaint = this._transitionablePaint.transitioned(t1, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(t1, e1) {
                t1.getCrossfadeParameters && (this._crossfadeParameters = t1.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t1, void 0, e1)), this.paint = this._transitioningPaint.possiblyEvaluate(t1, void 0, e1);
            }
            serialize() {
                const t1 = {
                    id: this.id,
                    type: this.type,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                };
                return this.visibility && (t1.layout = t1.layout || {}, t1.layout.visibility = this.visibility), h(t1, (t1, e1)=>!(void 0 === t1 || "layout" === e1 && !Object.keys(t1).length || "paint" === e1 && !Object.keys(t1).length));
            }
            _validate(t1, e1, r, n, i = {}) {
                return (!i || !1 !== i.validate) && kn(this, t1.call(bn, {
                    key: e1,
                    layerType: this.type,
                    objectKey: r,
                    value: n,
                    styleSpec: nt,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    }
                }));
            }
            is3D() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            resize() {}
            isStateDependent() {
                for(const t1 in this.paint._values){
                    const e1 = this.paint.get(t1);
                    if (e1 instanceof si && br(e1.property.specification) && ("source" === e1.value.kind || "composite" === e1.value.kind) && e1.value.isStateDependent) return !0;
                }
                return !1;
            }
            constructor(t1, e1){
                if (super(), this.id = t1.id, this.type = t1.type, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1
                }, "custom" !== t1.type && (this.metadata = t1.metadata, this.minzoom = t1.minzoom, this.maxzoom = t1.maxzoom, "background" !== t1.type && (this.source = t1.source, this.sourceLayer = t1["source-layer"], this.filter = t1.filter), e1.layout && (this._unevaluatedLayout = new ai(e1.layout)), e1.paint)) {
                    this._transitionablePaint = new ri(e1.paint);
                    for(const e1 in t1.paint)this.setPaintProperty(e1, t1.paint[e1], {
                        validate: !1
                    });
                    for(const e1 in t1.layout)this.setLayoutProperty(e1, t1.layout[e1], {
                        validate: !1
                    });
                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new oi(e1.paint);
                }
            }
        }
        const mi = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class gi {
            constructor(t1, e1){
                this._structArray = t1, this._pos1 = e1 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        class xi {
            static serialize(t1, e1) {
                return t1._trim(), e1 && (t1.isTransferred = !0, e1.push(t1.arrayBuffer)), {
                    length: t1.length,
                    arrayBuffer: t1.arrayBuffer
                };
            }
            static deserialize(t1) {
                const e1 = Object.create(this.prototype);
                return e1.arrayBuffer = t1.arrayBuffer, e1.length = t1.length, e1.capacity = t1.arrayBuffer.byteLength / e1.bytesPerElement, e1._refreshViews(), e1;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(t1) {
                this.reserve(t1), this.length = t1;
            }
            reserve(t1) {
                if (t1 > this.capacity) {
                    this.capacity = Math.max(t1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const e1 = this.uint8;
                    this._refreshViews(), e1 && this.uint8.set(e1);
                }
            }
            _refreshViews() {
                throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
            }
            constructor(){
                this.isTransferred = !1, this.capacity = -1, this.resize(0);
            }
        }
        function vi(t1, e1 = 1) {
            let r = 0, n = 0;
            return {
                members: t1.map((t1)=>{
                    const i = mi[t1.type].BYTES_PER_ELEMENT, a = r = bi(r, Math.max(e1, i)), s = t1.components || 1;
                    return n = Math.max(n, i), r += i * s, {
                        name: t1.name,
                        type: t1.type,
                        components: s,
                        offset: a
                    };
                }),
                size: bi(r, Math.max(n, e1)),
                alignment: e1
            };
        }
        function bi(t1, e1) {
            return Math.ceil(t1 / e1) * e1;
        }
        class wi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }
            emplace(t1, e1, r) {
                const n = 2 * t1;
                return this.int16[n + 0] = e1, this.int16[n + 1] = r, t1;
            }
        }
        wi.prototype.bytesPerElement = 4, Mn("StructArrayLayout2i4", wi);
        class _i extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }
            emplace(t1, e1, r, n, i) {
                const a = 4 * t1;
                return this.int16[a + 0] = e1, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, t1;
            }
        }
        _i.prototype.bytesPerElement = 8, Mn("StructArrayLayout4i8", _i);
        class Ai extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e1, r, n, i, a);
            }
            emplace(t1, e1, r, n, i, a, s) {
                const o = 6 * t1;
                return this.int16[o + 0] = e1, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = a, this.int16[o + 5] = s, t1;
            }
        }
        Ai.prototype.bytesPerElement = 12, Mn("StructArrayLayout2i4i12", Ai);
        class ki extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e1, r, n, i, a);
            }
            emplace(t1, e1, r, n, i, a, s) {
                const o = 4 * t1, l = 8 * t1;
                return this.int16[o + 0] = e1, this.int16[o + 1] = r, this.uint8[l + 4] = n, this.uint8[l + 5] = i, this.uint8[l + 6] = a, this.uint8[l + 7] = s, t1;
            }
        }
        ki.prototype.bytesPerElement = 8, Mn("StructArrayLayout2i4ub8", ki);
        class Si extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }
            emplace(t1, e1, r) {
                const n = 2 * t1;
                return this.float32[n + 0] = e1, this.float32[n + 1] = r, t1;
            }
        }
        Si.prototype.bytesPerElement = 8, Mn("StructArrayLayout2f8", Si);
        class Ii extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, a, s, o, l, u) {
                const c = this.length;
                return this.resize(c + 1), this.emplace(c, t1, e1, r, n, i, a, s, o, l, u);
            }
            emplace(t1, e1, r, n, i, a, s, o, l, u, c) {
                const h = 10 * t1;
                return this.uint16[h + 0] = e1, this.uint16[h + 1] = r, this.uint16[h + 2] = n, this.uint16[h + 3] = i, this.uint16[h + 4] = a, this.uint16[h + 5] = s, this.uint16[h + 6] = o, this.uint16[h + 7] = l, this.uint16[h + 8] = u, this.uint16[h + 9] = c, t1;
            }
        }
        Ii.prototype.bytesPerElement = 20, Mn("StructArrayLayout10ui20", Ii);
        class Mi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, a, s, o, l, u, c, h) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, t1, e1, r, n, i, a, s, o, l, u, c, h);
            }
            emplace(t1, e1, r, n, i, a, s, o, l, u, c, h, p) {
                const f = 12 * t1;
                return this.int16[f + 0] = e1, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.uint16[f + 4] = a, this.uint16[f + 5] = s, this.uint16[f + 6] = o, this.uint16[f + 7] = l, this.int16[f + 8] = u, this.int16[f + 9] = c, this.int16[f + 10] = h, this.int16[f + 11] = p, t1;
            }
        }
        Mi.prototype.bytesPerElement = 24, Mn("StructArrayLayout4i4ui4i24", Mi);
        class zi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }
            emplace(t1, e1, r, n) {
                const i = 3 * t1;
                return this.float32[i + 0] = e1, this.float32[i + 1] = r, this.float32[i + 2] = n, t1;
            }
        }
        zi.prototype.bytesPerElement = 12, Mn("StructArrayLayout3f12", zi);
        class Bi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }
            emplace(t1, e1) {
                return this.uint32[1 * t1 + 0] = e1, t1;
            }
        }
        Bi.prototype.bytesPerElement = 4, Mn("StructArrayLayout1ul4", Bi);
        class Ci extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, a, s, o, l) {
                const u = this.length;
                return this.resize(u + 1), this.emplace(u, t1, e1, r, n, i, a, s, o, l);
            }
            emplace(t1, e1, r, n, i, a, s, o, l, u) {
                const c = 10 * t1, h = 5 * t1;
                return this.int16[c + 0] = e1, this.int16[c + 1] = r, this.int16[c + 2] = n, this.int16[c + 3] = i, this.int16[c + 4] = a, this.int16[c + 5] = s, this.uint32[h + 3] = o, this.uint16[c + 8] = l, this.uint16[c + 9] = u, t1;
            }
        }
        Ci.prototype.bytesPerElement = 20, Mn("StructArrayLayout6i1ul2ui20", Ci);
        class Pi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e1, r, n, i, a);
            }
            emplace(t1, e1, r, n, i, a, s) {
                const o = 6 * t1;
                return this.int16[o + 0] = e1, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = a, this.int16[o + 5] = s, t1;
            }
        }
        Pi.prototype.bytesPerElement = 12, Mn("StructArrayLayout2i2i2i12", Pi);
        class Vi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e1, r, n, i);
            }
            emplace(t1, e1, r, n, i, a) {
                const s = 4 * t1, o = 8 * t1;
                return this.float32[s + 0] = e1, this.float32[s + 1] = r, this.float32[s + 2] = n, this.int16[o + 6] = i, this.int16[o + 7] = a, t1;
            }
        }
        Vi.prototype.bytesPerElement = 16, Mn("StructArrayLayout2f1f2i16", Vi);
        class Ei extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }
            emplace(t1, e1, r, n, i) {
                const a = 12 * t1, s = 3 * t1;
                return this.uint8[a + 0] = e1, this.uint8[a + 1] = r, this.float32[s + 1] = n, this.float32[s + 2] = i, t1;
            }
        }
        Ei.prototype.bytesPerElement = 12, Mn("StructArrayLayout2ub2f12", Ei);
        class Fi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }
            emplace(t1, e1, r, n) {
                const i = 3 * t1;
                return this.uint16[i + 0] = e1, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t1;
            }
        }
        Fi.prototype.bytesPerElement = 6, Mn("StructArrayLayout3ui6", Fi);
        class Ti extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m) {
                const g = this.length;
                return this.resize(g + 1), this.emplace(g, t1, e1, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m);
            }
            emplace(t1, e1, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g) {
                const x = 24 * t1, v = 12 * t1, b = 48 * t1;
                return this.int16[x + 0] = e1, this.int16[x + 1] = r, this.uint16[x + 2] = n, this.uint16[x + 3] = i, this.uint32[v + 2] = a, this.uint32[v + 3] = s, this.uint32[v + 4] = o, this.uint16[x + 10] = l, this.uint16[x + 11] = u, this.uint16[x + 12] = c, this.float32[v + 7] = h, this.float32[v + 8] = p, this.uint8[b + 36] = f, this.uint8[b + 37] = d, this.uint8[b + 38] = y, this.uint32[v + 10] = m, this.int16[x + 22] = g, t1;
            }
        }
        Ti.prototype.bytesPerElement = 48, Mn("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", Ti);
        class Li extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, k, S, I, M) {
                const z = this.length;
                return this.resize(z + 1), this.emplace(z, t1, e1, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, k, S, I, M);
            }
            emplace(t1, e1, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, k, S, I, M, z) {
                const B = 34 * t1, C = 17 * t1;
                return this.int16[B + 0] = e1, this.int16[B + 1] = r, this.int16[B + 2] = n, this.int16[B + 3] = i, this.int16[B + 4] = a, this.int16[B + 5] = s, this.int16[B + 6] = o, this.int16[B + 7] = l, this.uint16[B + 8] = u, this.uint16[B + 9] = c, this.uint16[B + 10] = h, this.uint16[B + 11] = p, this.uint16[B + 12] = f, this.uint16[B + 13] = d, this.uint16[B + 14] = y, this.uint16[B + 15] = m, this.uint16[B + 16] = g, this.uint16[B + 17] = x, this.uint16[B + 18] = v, this.uint16[B + 19] = b, this.uint16[B + 20] = w, this.uint16[B + 21] = _, this.uint16[B + 22] = A, this.uint32[C + 12] = k, this.float32[C + 13] = S, this.float32[C + 14] = I, this.float32[C + 15] = M, this.float32[C + 16] = z, t1;
            }
        }
        Li.prototype.bytesPerElement = 68, Mn("StructArrayLayout8i15ui1ul4f68", Li);
        class Di extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }
            emplace(t1, e1) {
                return this.float32[1 * t1 + 0] = e1, t1;
            }
        }
        Di.prototype.bytesPerElement = 4, Mn("StructArrayLayout1f4", Di);
        class $i extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }
            emplace(t1, e1, r, n) {
                const i = 3 * t1;
                return this.int16[i + 0] = e1, this.int16[i + 1] = r, this.int16[i + 2] = n, t1;
            }
        }
        $i.prototype.bytesPerElement = 6, Mn("StructArrayLayout3i6", $i);
        class Ri extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }
            emplace(t1, e1, r, n) {
                const i = 4 * t1;
                return this.uint32[2 * t1 + 0] = e1, this.uint16[i + 2] = r, this.uint16[i + 3] = n, t1;
            }
        }
        Ri.prototype.bytesPerElement = 8, Mn("StructArrayLayout1ul2ui8", Ri);
        class Oi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }
            emplace(t1, e1, r) {
                const n = 2 * t1;
                return this.uint16[n + 0] = e1, this.uint16[n + 1] = r, t1;
            }
        }
        Oi.prototype.bytesPerElement = 4, Mn("StructArrayLayout2ui4", Oi);
        class Ui extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }
            emplace(t1, e1) {
                return this.uint16[1 * t1 + 0] = e1, t1;
            }
        }
        Ui.prototype.bytesPerElement = 2, Mn("StructArrayLayout1ui2", Ui);
        class qi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }
            emplace(t1, e1, r, n, i) {
                const a = 4 * t1;
                return this.float32[a + 0] = e1, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, t1;
            }
        }
        qi.prototype.bytesPerElement = 16, Mn("StructArrayLayout4f16", qi);
        class ji extends gi {
            get anchorPointX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorPointY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get x1() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get y1() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get x2() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get y2() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 3];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get anchorPoint() {
                return new S(this.anchorPointX, this.anchorPointY);
            }
        }
        ji.prototype.size = 20;
        class Ni extends Ci {
            get(t1) {
                return new ji(this, t1);
            }
        }
        Mn("CollisionBoxArray", Ni);
        class Zi extends gi {
            get anchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 2];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 3];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 4];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 10];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 11];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 12];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 7];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 8];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 36];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 37];
            }
            set placedOrientation(t1) {
                this._structArray.uint8[this._pos1 + 37] = t1;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 38];
            }
            set hidden(t1) {
                this._structArray.uint8[this._pos1 + 38] = t1;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 10];
            }
            set crossTileID(t1) {
                this._structArray.uint32[this._pos4 + 10] = t1;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 22];
            }
        }
        Zi.prototype.size = 48;
        class Ki extends Ti {
            get(t1) {
                return new Zi(this, t1);
            }
        }
        Mn("PlacedSymbolArray", Ki);
        class Gi extends gi {
            get anchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 10];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 11];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 12];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 12];
            }
            set crossTileID(t1) {
                this._structArray.uint32[this._pos4 + 12] = t1;
            }
            get textBoxScale() {
                return this._structArray.float32[this._pos4 + 13];
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 14];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 15];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 16];
            }
        }
        Gi.prototype.size = 68;
        class Ji extends Li {
            get(t1) {
                return new Gi(this, t1);
            }
        }
        Mn("SymbolInstanceArray", Ji);
        class Xi extends Di {
            getoffsetX(t1) {
                return this.float32[1 * t1 + 0];
            }
        }
        Mn("GlyphOffsetArray", Xi);
        class Yi extends $i {
            getx(t1) {
                return this.int16[3 * t1 + 0];
            }
            gety(t1) {
                return this.int16[3 * t1 + 1];
            }
            gettileUnitDistanceFromAnchor(t1) {
                return this.int16[3 * t1 + 2];
            }
        }
        Mn("SymbolLineVertexArray", Yi);
        class Hi extends gi {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
        }
        Hi.prototype.size = 8;
        class Wi extends Ri {
            get(t1) {
                return new Hi(this, t1);
            }
        }
        Mn("FeatureIndexArray", Wi);
        class Qi extends wi {
        }
        class ta extends wi {
        }
        class ea extends wi {
        }
        class ra extends Ai {
        }
        class na extends ki {
        }
        class ia extends Si {
        }
        class aa extends Ii {
        }
        class sa extends Mi {
        }
        class oa extends zi {
        }
        class la extends Bi {
        }
        class ua extends Pi {
        }
        class ca extends Ei {
        }
        class ha extends Fi {
        }
        class pa extends Oi {
        }
        const fa = vi([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: da } = fa;
        class ya {
            prepareSegment(t1, e1, r, n) {
                let i = this.segments[this.segments.length - 1];
                return t1 > ya.MAX_VERTEX_ARRAY_LENGTH && d(`Max vertices per segment is ${ya.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t1}`), (!i || i.vertexLength + t1 > ya.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
                    vertexOffset: e1.length,
                    primitiveOffset: r.length,
                    vertexLength: 0,
                    primitiveLength: 0
                }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const t1 of this.segments)for(const e1 in t1.vaos)t1.vaos[e1].destroy();
            }
            static simpleSegment(t1, e1, r, n) {
                return new ya([
                    {
                        vertexOffset: t1,
                        primitiveOffset: e1,
                        vertexLength: r,
                        primitiveLength: n,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
            constructor(t1 = []){
                this.segments = t1;
            }
        }
        function ma(t1, e1) {
            return 256 * (t1 = a(Math.floor(t1), 0, 255)) + a(Math.floor(e1), 0, 255);
        }
        ya.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Mn("SegmentVector", ya);
        const ga = vi([
            {
                name: "a_pattern_from",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pattern_to",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_from",
                components: 1,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_to",
                components: 1,
                type: "Uint16"
            }
        ]);
        var xa = {
            exports: {}
        }, va = {
            exports: {}
        };
        va.exports = function(t1, e1) {
            var r, n, i, a, s, o, l, u;
            for(n = t1.length - (r = 3 & t1.length), i = e1, s = 3432918353, o = 461845907, u = 0; u < n;)l = 255 & t1.charCodeAt(u) | (255 & t1.charCodeAt(++u)) << 8 | (255 & t1.charCodeAt(++u)) << 16 | (255 & t1.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (a = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (a >>> 16) & 65535) << 16);
            switch(l = 0, r){
                case 3:
                    l ^= (255 & t1.charCodeAt(u + 2)) << 16;
                case 2:
                    l ^= (255 & t1.charCodeAt(u + 1)) << 8;
                case 1:
                    i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t1.charCodeAt(u))) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295;
            }
            return i ^= t1.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
        };
        var ba = {
            exports: {}
        };
        ba.exports = function(t1, e1) {
            for(var r, n = t1.length, i = e1 ^ n, a = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & t1.charCodeAt(a) | (255 & t1.charCodeAt(++a)) << 8 | (255 & t1.charCodeAt(++a)) << 16 | (255 & t1.charCodeAt(++a)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++a;
            switch(n){
                case 3:
                    i ^= (255 & t1.charCodeAt(a + 2)) << 16;
                case 2:
                    i ^= (255 & t1.charCodeAt(a + 1)) << 8;
                case 1:
                    i = 1540483477 * (65535 & (i ^= 255 & t1.charCodeAt(a))) + ((1540483477 * (i >>> 16) & 65535) << 16);
            }
            return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
        };
        var wa = va.exports, _a = ba.exports;
        xa.exports = wa, xa.exports.murmur3 = wa, xa.exports.murmur2 = _a;
        class Aa {
            add(t1, e1, r, n) {
                this.ids.push(ka(t1)), this.positions.push(e1, r, n);
            }
            getPositions(t1) {
                if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
                const e1 = ka(t1);
                let r = 0, n = this.ids.length - 1;
                for(; r < n;){
                    const t1 = r + n >> 1;
                    this.ids[t1] >= e1 ? n = t1 : r = t1 + 1;
                }
                const i = [];
                for(; this.ids[r] === e1;)i.push({
                    index: this.positions[3 * r],
                    start: this.positions[3 * r + 1],
                    end: this.positions[3 * r + 2]
                }), r++;
                return i;
            }
            static serialize(t1, e1) {
                const r = new Float64Array(t1.ids), n = new Uint32Array(t1.positions);
                return Sa(r, n, 0, r.length - 1), e1 && e1.push(r.buffer, n.buffer), {
                    ids: r,
                    positions: n
                };
            }
            static deserialize(t1) {
                const e1 = new Aa;
                return e1.ids = t1.ids, e1.positions = t1.positions, e1.indexed = !0, e1;
            }
            constructor(){
                this.ids = [], this.positions = [], this.indexed = !1;
            }
        }
        function ka(t1) {
            const e1 = +t1;
            return !isNaN(e1) && e1 <= Number.MAX_SAFE_INTEGER ? e1 : xa.exports(String(t1));
        }
        function Sa(t1, e1, r, n) {
            for(; r < n;){
                const i = t1[r + n >> 1];
                let a = r - 1, s = n + 1;
                for(;;){
                    do a++;
                    while (t1[a] < i);
                    do s--;
                    while (t1[s] > i);
                    if (a >= s) break;
                    Ia(t1, a, s), Ia(e1, 3 * a, 3 * s), Ia(e1, 3 * a + 1, 3 * s + 1), Ia(e1, 3 * a + 2, 3 * s + 2);
                }
                s - r < n - s ? (Sa(t1, e1, r, s), r = s + 1) : (Sa(t1, e1, s + 1, n), n = s);
            }
        }
        function Ia(t1, e1, r) {
            const n = t1[e1];
            t1[e1] = t1[r], t1[r] = n;
        }
        Mn("FeaturePositionMap", Aa);
        class Ma {
            constructor(t1, e1){
                this.gl = t1.gl, this.location = e1;
            }
        }
        class za extends Ma {
            set(t1) {
                this.current !== t1 && (this.current = t1, this.gl.uniform1f(this.location, t1));
            }
            constructor(t1, e1){
                super(t1, e1), this.current = 0;
            }
        }
        class Ba extends Ma {
            set(t1) {
                t1[0] === this.current[0] && t1[1] === this.current[1] && t1[2] === this.current[2] && t1[3] === this.current[3] || (this.current = t1, this.gl.uniform4f(this.location, t1[0], t1[1], t1[2], t1[3]));
            }
            constructor(t1, e1){
                super(t1, e1), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
        }
        class Ca extends Ma {
            set(t1) {
                t1.r === this.current.r && t1.g === this.current.g && t1.b === this.current.b && t1.a === this.current.a || (this.current = t1, this.gl.uniform4f(this.location, t1.r, t1.g, t1.b, t1.a));
            }
            constructor(t1, e1){
                super(t1, e1), this.current = Ft.transparent;
            }
        }
        const Pa = new Float32Array(16);
        function Va(t1) {
            return [
                ma(255 * t1.r, 255 * t1.g),
                ma(255 * t1.b, 255 * t1.a)
            ];
        }
        class Ea {
            setUniform(t1, e1, r) {
                t1.set(r.constantOr(this.value));
            }
            getBinding(t1, e1, r) {
                return "color" === this.type ? new Ca(t1, e1) : new za(t1, e1);
            }
            constructor(t1, e1, r){
                this.value = t1, this.uniformNames = e1.map((t1)=>`u_${t1}`), this.type = r;
            }
        }
        class Fa {
            setConstantPatternPositions(t1, e1) {
                this.pixelRatioFrom = e1.pixelRatio, this.pixelRatioTo = t1.pixelRatio, this.patternFrom = e1.tlbr, this.patternTo = t1.tlbr;
            }
            setUniform(t1, e1, r, n) {
                const i = "u_pattern_to" === n ? this.patternTo : "u_pattern_from" === n ? this.patternFrom : "u_pixel_ratio_to" === n ? this.pixelRatioTo : "u_pixel_ratio_from" === n ? this.pixelRatioFrom : null;
                i && t1.set(i);
            }
            getBinding(t1, e1, r) {
                return "u_pattern" === r.substr(0, 9) ? new Ba(t1, e1) : new za(t1, e1);
            }
            constructor(t1, e1){
                this.uniformNames = e1.map((t1)=>`u_${t1}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
            }
        }
        class Ta {
            populatePaintArray(t1, e1, r, n, i) {
                const a = this.paintVertexArray.length, s = this.expression.evaluate(new Qn(0), e1, {}, n, [], i);
                this.paintVertexArray.resize(t1), this._setPaintValue(a, t1, s);
            }
            updatePaintArray(t1, e1, r, n) {
                const i = this.expression.evaluate({
                    zoom: 0
                }, r, n);
                this._setPaintValue(t1, e1, i);
            }
            _setPaintValue(t1, e1, r) {
                if ("color" === this.type) {
                    const n = Va(r);
                    for(let r = t1; r < e1; r++)this.paintVertexArray.emplace(r, n[0], n[1]);
                } else {
                    for(let n = t1; n < e1; n++)this.paintVertexArray.emplace(n, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r));
                }
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            constructor(t1, e1, r, n){
                this.expression = t1, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e1.map((t1)=>({
                        name: `a_${t1}`,
                        type: "Float32",
                        components: "color" === r ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new n;
            }
        }
        class La {
            populatePaintArray(t1, e1, r, n, i) {
                const a = this.expression.evaluate(new Qn(this.zoom), e1, {}, n, [], i), s = this.expression.evaluate(new Qn(this.zoom + 1), e1, {}, n, [], i), o = this.paintVertexArray.length;
                this.paintVertexArray.resize(t1), this._setPaintValue(o, t1, a, s);
            }
            updatePaintArray(t1, e1, r, n) {
                const i = this.expression.evaluate({
                    zoom: this.zoom
                }, r, n), a = this.expression.evaluate({
                    zoom: this.zoom + 1
                }, r, n);
                this._setPaintValue(t1, e1, i, a);
            }
            _setPaintValue(t1, e1, r, n) {
                if ("color" === this.type) {
                    const i = Va(r), a = Va(n);
                    for(let r = t1; r < e1; r++)this.paintVertexArray.emplace(r, i[0], i[1], a[0], a[1]);
                } else {
                    for(let i = t1; i < e1; i++)this.paintVertexArray.emplace(i, r, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                }
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(t1, e1) {
                const r = this.useIntegerZoom ? Math.floor(e1.zoom) : e1.zoom, n = a(this.expression.interpolationFactor(r, this.zoom, this.zoom + 1), 0, 1);
                t1.set(n);
            }
            getBinding(t1, e1, r) {
                return new za(t1, e1);
            }
            constructor(t1, e1, r, n, i, a){
                this.expression = t1, this.uniformNames = e1.map((t1)=>`u_${t1}_t`), this.type = r, this.useIntegerZoom = n, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = e1.map((t1)=>({
                        name: `a_${t1}`,
                        type: "Float32",
                        components: "color" === r ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new a;
            }
        }
        class Da {
            populatePaintArray(t1, e1, r) {
                const n = this.zoomInPaintVertexArray.length;
                this.zoomInPaintVertexArray.resize(t1), this.zoomOutPaintVertexArray.resize(t1), this._setPaintValues(n, t1, e1.patterns && e1.patterns[this.layerId], r);
            }
            updatePaintArray(t1, e1, r, n, i) {
                this._setPaintValues(t1, e1, r.patterns && r.patterns[this.layerId], i);
            }
            _setPaintValues(t1, e1, r, n) {
                if (!n || !r) return;
                const { min: i, mid: a, max: s } = r, o = n[i], l = n[a], u = n[s];
                if (o && l && u) for(let r = t1; r < e1; r++)this.zoomInPaintVertexArray.emplace(r, l.tl[0], l.tl[1], l.br[0], l.br[1], o.tl[0], o.tl[1], o.br[0], o.br[1], l.pixelRatio, o.pixelRatio), this.zoomOutPaintVertexArray.emplace(r, l.tl[0], l.tl[1], l.br[0], l.br[1], u.tl[0], u.tl[1], u.br[0], u.br[1], l.pixelRatio, u.pixelRatio);
            }
            upload(t1) {
                this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = t1.createVertexBuffer(this.zoomInPaintVertexArray, ga.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t1.createVertexBuffer(this.zoomOutPaintVertexArray, ga.members, this.expression.isStateDependent));
            }
            destroy() {
                this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
            }
            constructor(t1, e1, r, n, i, a){
                this.expression = t1, this.type = e1, this.useIntegerZoom = r, this.zoom = n, this.layerId = a, this.zoomInPaintVertexArray = new i, this.zoomOutPaintVertexArray = new i;
            }
        }
        class $a {
            getMaxValue(t1) {
                const e1 = this.binders[t1];
                return e1 instanceof Ta || e1 instanceof La ? e1.maxValue : 0;
            }
            populatePaintArrays(t1, e1, r, n, i) {
                for(const a in this.binders){
                    const s = this.binders[a];
                    (s instanceof Ta || s instanceof La || s instanceof Da) && s.populatePaintArray(t1, e1, r, n, i);
                }
            }
            setConstantPatternPositions(t1, e1) {
                for(const r in this.binders){
                    const n = this.binders[r];
                    n instanceof Fa && n.setConstantPatternPositions(t1, e1);
                }
            }
            updatePaintArrays(t1, e1, r, n, i) {
                let a = !1;
                for(const s in t1){
                    const o = e1.getPositions(s);
                    for (const e1 of o){
                        const o = r.feature(e1.index);
                        for(const r in this.binders){
                            const l = this.binders[r];
                            if ((l instanceof Ta || l instanceof La || l instanceof Da) && !0 === l.expression.isStateDependent) {
                                const u = n.paint.get(r);
                                l.expression = u.value, l.updatePaintArray(e1.start, e1.end, o, t1[s], i), a = !0;
                            }
                        }
                    }
                }
                return a;
            }
            defines() {
                const t1 = [];
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    (r instanceof Ea || r instanceof Fa) && t1.push(...r.uniformNames.map((t1)=>`#define HAS_UNIFORM_${t1}`));
                }
                return t1;
            }
            getBinderAttributes() {
                const t1 = [];
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    if (r instanceof Ta || r instanceof La) for(let e1 = 0; e1 < r.paintVertexAttributes.length; e1++)t1.push(r.paintVertexAttributes[e1].name);
                    else if (r instanceof Da) for(let e1 = 0; e1 < ga.members.length; e1++)t1.push(ga.members[e1].name);
                }
                return t1;
            }
            getBinderUniforms() {
                const t1 = [];
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    if (r instanceof Ea || r instanceof Fa || r instanceof La) for (const e1 of r.uniformNames)t1.push(e1);
                }
                return t1;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(t1, e1) {
                const r = [];
                for(const n in this.binders){
                    const i = this.binders[n];
                    if (i instanceof Ea || i instanceof Fa || i instanceof La) {
                        for (const a of i.uniformNames)if (e1[a]) {
                            const s = i.getBinding(t1, e1[a], a);
                            r.push({
                                name: a,
                                property: n,
                                binding: s
                            });
                        }
                    }
                }
                return r;
            }
            setUniforms(t1, e1, r, n) {
                for (const { name: t1, property: i, binding: a } of e1)this.binders[i].setUniform(a, n, r.get(i), t1);
            }
            updatePaintBuffers(t1) {
                this._buffers = [];
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    if (t1 && r instanceof Da) {
                        const e1 = 2 === t1.fromScale ? r.zoomInPaintVertexBuffer : r.zoomOutPaintVertexBuffer;
                        e1 && this._buffers.push(e1);
                    } else (r instanceof Ta || r instanceof La) && r.paintVertexBuffer && this._buffers.push(r.paintVertexBuffer);
                }
            }
            upload(t1) {
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    (r instanceof Ta || r instanceof La || r instanceof Da) && r.upload(t1);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const t1 in this.binders){
                    const e1 = this.binders[t1];
                    (e1 instanceof Ta || e1 instanceof La || e1 instanceof Da) && e1.destroy();
                }
            }
            constructor(t1, e1, r){
                this.binders = {}, this._buffers = [];
                const n = [];
                for(const i in t1.paint._values){
                    if (!r(i)) continue;
                    const a = t1.paint.get(i);
                    if (!(a instanceof si && br(a.property.specification))) continue;
                    const s = Oa(i, t1.type), o = a.value, l = a.property.specification.type, u = a.property.useIntegerZoom, c = a.property.specification["property-type"], h = "cross-faded" === c || "cross-faded-data-driven" === c;
                    if ("constant" === o.kind) this.binders[i] = h ? new Fa(o.value, s) : new Ea(o.value, s, l), n.push(`/u_${i}`);
                    else if ("source" === o.kind || h) {
                        const r = Ua(i, l, "source");
                        this.binders[i] = h ? new Da(o, l, u, e1, r, t1.id) : new Ta(o, s, l, r), n.push(`/a_${i}`);
                    } else {
                        const t1 = Ua(i, l, "composite");
                        this.binders[i] = new La(o, s, l, u, e1, t1), n.push(`/z_${i}`);
                    }
                }
                this.cacheKey = n.sort().join("");
            }
        }
        class Ra {
            populatePaintArrays(t1, e1, r, n, i, a) {
                for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(t1, e1, n, i, a);
                void 0 !== e1.id && this._featureMap.add(e1.id, r, this._bufferOffset, t1), this._bufferOffset = t1, this.needsUpload = !0;
            }
            updatePaintArrays(t1, e1, r, n) {
                for (const i of r)this.needsUpload = this.programConfigurations[i.id].updatePaintArrays(t1, this._featureMap, e1, i, n) || this.needsUpload;
            }
            get(t1) {
                return this.programConfigurations[t1];
            }
            upload(t1) {
                if (this.needsUpload) {
                    for(const e1 in this.programConfigurations)this.programConfigurations[e1].upload(t1);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const t1 in this.programConfigurations)this.programConfigurations[t1].destroy();
            }
            constructor(t1, e1, r = ()=>!0){
                this.programConfigurations = {};
                for (const n of t1)this.programConfigurations[n.id] = new $a(n, e1, r);
                this.needsUpload = !1, this._featureMap = new Aa, this._bufferOffset = 0;
            }
        }
        function Oa(t1, e1) {
            return ({
                "text-opacity": [
                    "opacity"
                ],
                "icon-opacity": [
                    "opacity"
                ],
                "text-color": [
                    "fill_color"
                ],
                "icon-color": [
                    "fill_color"
                ],
                "text-halo-color": [
                    "halo_color"
                ],
                "icon-halo-color": [
                    "halo_color"
                ],
                "text-halo-blur": [
                    "halo_blur"
                ],
                "icon-halo-blur": [
                    "halo_blur"
                ],
                "text-halo-width": [
                    "halo_width"
                ],
                "icon-halo-width": [
                    "halo_width"
                ],
                "line-gap-width": [
                    "gapwidth"
                ],
                "line-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-extrusion-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ]
            })[t1] || [
                t1.replace(`${e1}-`, "").replace(/-/g, "_")
            ];
        }
        function Ua(t1, e1, r) {
            const n = {
                color: {
                    source: Si,
                    composite: qi
                },
                number: {
                    source: Di,
                    composite: Si
                }
            }, i = function(t1) {
                return ({
                    "line-pattern": {
                        source: aa,
                        composite: aa
                    },
                    "fill-pattern": {
                        source: aa,
                        composite: aa
                    },
                    "fill-extrusion-pattern": {
                        source: aa,
                        composite: aa
                    }
                })[t1];
            }(t1);
            return i && i[r] || n[e1][r];
        }
        Mn("ConstantBinder", Ea), Mn("CrossFadedConstantBinder", Fa), Mn("SourceExpressionBinder", Ta), Mn("CrossFadedCompositeBinder", Da), Mn("CompositeExpressionBinder", La), Mn("ProgramConfiguration", $a, {
            omit: [
                "_buffers"
            ]
        }), Mn("ProgramConfigurationSet", Ra);
        var qa = 8192;
        const ja = Math.pow(2, 14) - 1, Na = -ja - 1;
        function Za(t1) {
            const e1 = qa / t1.extent, r = t1.loadGeometry();
            for(let t1 = 0; t1 < r.length; t1++){
                const n = r[t1];
                for(let t1 = 0; t1 < n.length; t1++){
                    const r = n[t1], i = Math.round(r.x * e1), s = Math.round(r.y * e1);
                    r.x = a(i, Na, ja), r.y = a(s, Na, ja), (i < r.x || i > r.x + 1 || s < r.y || s > r.y + 1) && d("Geometry exceeds allowed extent, reduce your vector tile buffer size");
                }
            }
            return r;
        }
        function Ka(t1, e1) {
            return {
                type: t1.type,
                id: t1.id,
                properties: t1.properties,
                geometry: e1 ? Za(t1) : []
            };
        }
        function Ga(t1, e1, r, n, i) {
            t1.emplaceBack(2 * e1 + (n + 1) / 2, 2 * r + (i + 1) / 2);
        }
        class Ja {
            populate(t1, e1, r) {
                const n = this.layers[0], i = [];
                let a = null, s = !1;
                "circle" === n.type && (a = n.layout.get("circle-sort-key"), s = !a.isConstant());
                for (const { feature: e1, id: n, index: o, sourceLayerIndex: l } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, u = Ka(e1, t1);
                    if (!this.layers[0]._featureFilter.filter(new Qn(this.zoom), u, r)) continue;
                    const c = s ? a.evaluate(u, {}, r) : void 0, h = {
                        id: n,
                        properties: e1.properties,
                        type: e1.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t1 ? u.geometry : Za(e1),
                        patterns: {},
                        sortKey: c
                    };
                    i.push(h);
                }
                s && i.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                for (const n of i){
                    const { geometry: i, index: a, sourceLayerIndex: s } = n, o = t1[a].feature;
                    this.addFeature(n, i, a, r), e1.featureIndex.insert(o, i, a, s, this.index);
                }
            }
            update(t1, e1, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, da), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(t1, e1, r, n) {
                for (const r of e1)for (const e1 of r){
                    const r = e1.x, n = e1.y;
                    if (r < 0 || r >= qa || n < 0 || n >= qa) continue;
                    const i = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t1.sortKey), a = i.vertexLength;
                    Ga(this.layoutVertexArray, r, n, -1, -1), Ga(this.layoutVertexArray, r, n, 1, -1), Ga(this.layoutVertexArray, r, n, 1, 1), Ga(this.layoutVertexArray, r, n, -1, 1), this.indexArray.emplaceBack(a, a + 1, a + 2), this.indexArray.emplaceBack(a, a + 3, a + 2), i.vertexLength += 4, i.primitiveLength += 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, {}, n);
            }
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.layoutVertexArray = new ta, this.indexArray = new ha, this.segments = new ya, this.programConfigurations = new Ra(t1.layers, t1.zoom), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
            }
        }
        function Xa(t1, e1) {
            for(let r = 0; r < t1.length; r++)if (is(e1, t1[r])) return !0;
            for(let r = 0; r < e1.length; r++)if (is(t1, e1[r])) return !0;
            return !!Qa(t1, e1);
        }
        function Ya(t1, e1, r) {
            return !!is(t1, e1) || !!es(e1, t1, r);
        }
        function Ha(t1, e1) {
            if (1 === t1.length) return ns(e1, t1[0]);
            for(let r = 0; r < e1.length; r++){
                const n = e1[r];
                for(let e1 = 0; e1 < n.length; e1++)if (is(t1, n[e1])) return !0;
            }
            for(let r = 0; r < t1.length; r++)if (ns(e1, t1[r])) return !0;
            for(let r = 0; r < e1.length; r++)if (Qa(t1, e1[r])) return !0;
            return !1;
        }
        function Wa(t1, e1, r) {
            if (t1.length > 1) {
                if (Qa(t1, e1)) return !0;
                for(let n = 0; n < e1.length; n++)if (es(e1[n], t1, r)) return !0;
            }
            for(let n = 0; n < t1.length; n++)if (es(t1[n], e1, r)) return !0;
            return !1;
        }
        function Qa(t1, e1) {
            if (0 === t1.length || 0 === e1.length) return !1;
            for(let r = 0; r < t1.length - 1; r++){
                const n = t1[r], i = t1[r + 1];
                for(let t1 = 0; t1 < e1.length - 1; t1++)if (ts(n, i, e1[t1], e1[t1 + 1])) return !0;
            }
            return !1;
        }
        function ts(t1, e1, r, n) {
            return y(t1, r, n) !== y(e1, r, n) && y(t1, e1, r) !== y(t1, e1, n);
        }
        function es(t1, e1, r) {
            const n = r * r;
            if (1 === e1.length) return t1.distSqr(e1[0]) < n;
            for(let r = 1; r < e1.length; r++)if (rs(t1, e1[r - 1], e1[r]) < n) return !0;
            return !1;
        }
        function rs(t1, e1, r) {
            const n = e1.distSqr(r);
            if (0 === n) return t1.distSqr(e1);
            const i = ((t1.x - e1.x) * (r.x - e1.x) + (t1.y - e1.y) * (r.y - e1.y)) / n;
            return t1.distSqr(i < 0 ? e1 : i > 1 ? r : r.sub(e1)._mult(i)._add(e1));
        }
        function ns(t1, e1) {
            let r, n, i, a = !1;
            for(let s = 0; s < t1.length; s++){
                r = t1[s];
                for(let t1 = 0, s = r.length - 1; t1 < r.length; s = t1++)n = r[t1], i = r[s], n.y > e1.y != i.y > e1.y && e1.x < (i.x - n.x) * (e1.y - n.y) / (i.y - n.y) + n.x && (a = !a);
            }
            return a;
        }
        function is(t1, e1) {
            let r = !1;
            for(let n = 0, i = t1.length - 1; n < t1.length; i = n++){
                const a = t1[n], s = t1[i];
                a.y > e1.y != s.y > e1.y && e1.x < (s.x - a.x) * (e1.y - a.y) / (s.y - a.y) + a.x && (r = !r);
            }
            return r;
        }
        function as(t1, e1, r) {
            const n = r[0], i = r[2];
            if (t1.x < n.x && e1.x < n.x || t1.x > i.x && e1.x > i.x || t1.y < n.y && e1.y < n.y || t1.y > i.y && e1.y > i.y) return !1;
            const a = y(t1, e1, r[0]);
            return a !== y(t1, e1, r[1]) || a !== y(t1, e1, r[2]) || a !== y(t1, e1, r[3]);
        }
        function ss(t1, e1, r) {
            const n = e1.paint.get(t1).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(e1.id).getMaxValue(t1);
        }
        function os(t1) {
            return Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]);
        }
        function ls(t1, e1, r, n, i) {
            if (!e1[0] && !e1[1]) return t1;
            const a = S.convert(e1)._mult(i);
            "viewport" === r && a._rotate(-n);
            const s = [];
            for(let e1 = 0; e1 < t1.length; e1++)s.push(t1[e1].sub(a));
            return s;
        }
        Mn("CircleBucket", Ja, {
            omit: [
                "layers"
            ]
        });
        const us = new fi({
            "circle-sort-key": new ui(nt.layout_circle["circle-sort-key"])
        });
        var cs = {
            paint: new fi({
                "circle-radius": new ui(nt.paint_circle["circle-radius"]),
                "circle-color": new ui(nt.paint_circle["circle-color"]),
                "circle-blur": new ui(nt.paint_circle["circle-blur"]),
                "circle-opacity": new ui(nt.paint_circle["circle-opacity"]),
                "circle-translate": new li(nt.paint_circle["circle-translate"]),
                "circle-translate-anchor": new li(nt.paint_circle["circle-translate-anchor"]),
                "circle-pitch-scale": new li(nt.paint_circle["circle-pitch-scale"]),
                "circle-pitch-alignment": new li(nt.paint_circle["circle-pitch-alignment"]),
                "circle-stroke-width": new ui(nt.paint_circle["circle-stroke-width"]),
                "circle-stroke-color": new ui(nt.paint_circle["circle-stroke-color"]),
                "circle-stroke-opacity": new ui(nt.paint_circle["circle-stroke-opacity"])
            }),
            layout: us
        }, hs = 1e-6, ps = "undefined" != typeof Float32Array ? Float32Array : Array;
        function fs() {
            var t1 = new ps(9);
            return ps != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0), t1[0] = 1, t1[4] = 1, t1[8] = 1, t1;
        }
        function ds(t1) {
            return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
        }
        function ys(t1, e1, r) {
            var n = e1[0], i = e1[1], a = e1[2], s = e1[3], o = e1[4], l = e1[5], u = e1[6], c = e1[7], h = e1[8], p = e1[9], f = e1[10], d = e1[11], y = e1[12], m = e1[13], g = e1[14], x = e1[15], v = r[0], b = r[1], w = r[2], _ = r[3];
            return t1[0] = v * n + b * o + w * h + _ * y, t1[1] = v * i + b * l + w * p + _ * m, t1[2] = v * a + b * u + w * f + _ * g, t1[3] = v * s + b * c + w * d + _ * x, t1[4] = (v = r[4]) * n + (b = r[5]) * o + (w = r[6]) * h + (_ = r[7]) * y, t1[5] = v * i + b * l + w * p + _ * m, t1[6] = v * a + b * u + w * f + _ * g, t1[7] = v * s + b * c + w * d + _ * x, t1[8] = (v = r[8]) * n + (b = r[9]) * o + (w = r[10]) * h + (_ = r[11]) * y, t1[9] = v * i + b * l + w * p + _ * m, t1[10] = v * a + b * u + w * f + _ * g, t1[11] = v * s + b * c + w * d + _ * x, t1[12] = (v = r[12]) * n + (b = r[13]) * o + (w = r[14]) * h + (_ = r[15]) * y, t1[13] = v * i + b * l + w * p + _ * m, t1[14] = v * a + b * u + w * f + _ * g, t1[15] = v * s + b * c + w * d + _ * x, t1;
        }
        Math.hypot || (Math.hypot = function() {
            for(var t1 = 0, e1 = arguments.length; e1--;)t1 += arguments[e1] * arguments[e1];
            return Math.sqrt(t1);
        });
        var ms, gs = ys;
        function xs() {
            var t1 = new ps(3);
            return ps != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0), t1;
        }
        function vs(t1, e1, r) {
            var n = new ps(3);
            return n[0] = t1, n[1] = e1, n[2] = r, n;
        }
        function bs(t1, e1, r) {
            var n = e1[0], i = e1[1], a = e1[2], s = e1[3];
            return t1[0] = r[0] * n + r[4] * i + r[8] * a + r[12] * s, t1[1] = r[1] * n + r[5] * i + r[9] * a + r[13] * s, t1[2] = r[2] * n + r[6] * i + r[10] * a + r[14] * s, t1[3] = r[3] * n + r[7] * i + r[11] * a + r[15] * s, t1;
        }
        function ws() {
            var t1 = new ps(4);
            return ps != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0), t1[3] = 1, t1;
        }
        function _s(t1, e1) {
            const r = bs([], [
                t1.x,
                t1.y,
                0,
                1
            ], e1);
            return new S(r[0] / r[3], r[1] / r[3]);
        }
        xs(), ms = new ps(4), ps != Float32Array && (ms[0] = 0, ms[1] = 0, ms[2] = 0, ms[3] = 0), xs(), vs(1, 0, 0), vs(0, 1, 0), ws(), ws(), fs(), function() {
            var t1;
            t1 = new ps(2), ps != Float32Array && (t1[0] = 0, t1[1] = 0);
        }();
        class As extends Ja {
        }
        Mn("HeatmapBucket", As, {
            omit: [
                "layers"
            ]
        });
        var ks = {
            paint: new fi({
                "heatmap-radius": new ui(nt.paint_heatmap["heatmap-radius"]),
                "heatmap-weight": new ui(nt.paint_heatmap["heatmap-weight"]),
                "heatmap-intensity": new li(nt.paint_heatmap["heatmap-intensity"]),
                "heatmap-color": new pi(nt.paint_heatmap["heatmap-color"]),
                "heatmap-opacity": new li(nt.paint_heatmap["heatmap-opacity"])
            })
        };
        function Ss(t1, { width: e1, height: r }, n, i) {
            if (i) {
                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                else if (i.length !== e1 * r * n) throw new RangeError(`mismatched image size. expected: ${i.length} but got: ${e1 * r * n}`);
            } else i = new Uint8Array(e1 * r * n);
            return t1.width = e1, t1.height = r, t1.data = i, t1;
        }
        function Is(t1, { width: e1, height: r }, n) {
            if (e1 === t1.width && r === t1.height) return;
            const i = Ss({}, {
                width: e1,
                height: r
            }, n);
            Ms(t1, i, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(t1.width, e1),
                height: Math.min(t1.height, r)
            }, n), t1.width = e1, t1.height = r, t1.data = i.data;
        }
        function Ms(t1, e1, r, n, i, a) {
            if (0 === i.width || 0 === i.height) return e1;
            if (i.width > t1.width || i.height > t1.height || r.x > t1.width - i.width || r.y > t1.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > e1.width || i.height > e1.height || n.x > e1.width - i.width || n.y > e1.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            const s = t1.data, o = e1.data;
            if (s === o) throw new Error("srcData equals dstData, so image is already copied");
            for(let l = 0; l < i.height; l++){
                const u = ((r.y + l) * t1.width + r.x) * a, c = ((n.y + l) * e1.width + n.x) * a;
                for(let t1 = 0; t1 < i.width * a; t1++)o[c + t1] = s[u + t1];
            }
            return e1;
        }
        class zs {
            resize(t1) {
                Is(this, t1, 1);
            }
            clone() {
                return new zs({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t1, e1, r, n, i) {
                Ms(t1, e1, r, n, i, 1);
            }
            constructor(t1, e1){
                Ss(this, t1, 1, e1);
            }
        }
        class Bs {
            resize(t1) {
                Is(this, t1, 4);
            }
            replace(t1, e1) {
                e1 ? this.data.set(t1) : this.data = t1 instanceof Uint8ClampedArray ? new Uint8Array(t1.buffer) : t1;
            }
            clone() {
                return new Bs({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t1, e1, r, n, i) {
                Ms(t1, e1, r, n, i, 4);
            }
            constructor(t1, e1){
                Ss(this, t1, 4, e1);
            }
        }
        function Cs(t1) {
            const e1 = {}, r = t1.resolution || 256, n = t1.clips ? t1.clips.length : 1, i = t1.image || new Bs({
                width: r,
                height: n
            });
            if (Math.log(r) / Math.LN2 % 1 != 0) throw new Error(`width is not a power of 2 - ${r}`);
            const a = (r, n, a)=>{
                e1[t1.evaluationKey] = a;
                const s = t1.expression.evaluate(e1);
                i.data[r + n + 0] = Math.floor(255 * s.r / s.a), i.data[r + n + 1] = Math.floor(255 * s.g / s.a), i.data[r + n + 2] = Math.floor(255 * s.b / s.a), i.data[r + n + 3] = Math.floor(255 * s.a);
            };
            if (t1.clips) for(let e1 = 0, i = 0; e1 < n; ++e1, i += 4 * r)for(let n = 0, s = 0; n < r; n++, s += 4){
                const o = n / (r - 1), { start: l, end: u } = t1.clips[e1];
                a(i, s, l * (1 - o) + u * o);
            }
            else for(let t1 = 0, e1 = 0; t1 < r; t1++, e1 += 4)a(0, e1, t1 / (r - 1));
            return i;
        }
        Mn("AlphaImage", zs), Mn("RGBAImage", Bs);
        var Ps = {
            paint: new fi({
                "hillshade-illumination-direction": new li(nt.paint_hillshade["hillshade-illumination-direction"]),
                "hillshade-illumination-anchor": new li(nt.paint_hillshade["hillshade-illumination-anchor"]),
                "hillshade-exaggeration": new li(nt.paint_hillshade["hillshade-exaggeration"]),
                "hillshade-shadow-color": new li(nt.paint_hillshade["hillshade-shadow-color"]),
                "hillshade-highlight-color": new li(nt.paint_hillshade["hillshade-highlight-color"]),
                "hillshade-accent-color": new li(nt.paint_hillshade["hillshade-accent-color"])
            })
        };
        const Vs = vi([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: Es } = Vs;
        var Fs = {
            exports: {}
        };
        function Ts(t1, e1, r) {
            r = r || 2;
            var n, i, a, s, o, l, u, c = e1 && e1.length, h = c ? e1[0] * r : t1.length, p = Ls(t1, 0, h, r, !0), f = [];
            if (!p || p.next === p.prev) return f;
            if (c && (p = function(t1, e1, r, n) {
                var i, a, s, o = [];
                for(i = 0, a = e1.length; i < a; i++)(s = Ls(t1, e1[i] * n, i < a - 1 ? e1[i + 1] * n : t1.length, n, !1)) === s.next && (s.steiner = !0), o.push(Gs(s));
                for(o.sort(js), i = 0; i < o.length; i++)r = Ns(o[i], r);
                return r;
            }(t1, e1, p, r)), t1.length > 80 * r) {
                n = a = t1[0], i = s = t1[1];
                for(var d = r; d < h; d += r)(o = t1[d]) < n && (n = o), (l = t1[d + 1]) < i && (i = l), o > a && (a = o), l > s && (s = l);
                u = 0 !== (u = Math.max(a - n, s - i)) ? 32767 / u : 0;
            }
            return $s(p, f, r, n, i, u, 0), f;
        }
        function Ls(t1, e1, r, n, i) {
            var a, s;
            if (i === so(t1, e1, r, n) > 0) for(a = e1; a < r; a += n)s = no(a, t1[a], t1[a + 1], s);
            else for(a = r - n; a >= e1; a -= n)s = no(a, t1[a], t1[a + 1], s);
            return s && Hs(s, s.next) && (io(s), s = s.next), s;
        }
        function Ds(t1, e1) {
            if (!t1) return t1;
            e1 || (e1 = t1);
            var r, n = t1;
            do if (r = !1, n.steiner || !Hs(n, n.next) && 0 !== Ys(n.prev, n, n.next)) n = n.next;
            else {
                if (io(n), (n = e1 = n.prev) === n.next) break;
                r = !0;
            }
            while (r || n !== e1);
            return e1;
        }
        function $s(t1, e1, r, n, i, a, s) {
            if (t1) {
                !s && a && function(t1, e1, r, n) {
                    var i = t1;
                    do 0 === i.z && (i.z = Ks(i.x, i.y, e1, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                    while (i !== t1);
                    i.prevZ.nextZ = null, i.prevZ = null, function(t1) {
                        var e1, r, n, i, a, s, o, l, u = 1;
                        do {
                            for(r = t1, t1 = null, a = null, s = 0; r;){
                                for(s++, n = r, o = 0, e1 = 0; e1 < u && (o++, n = n.nextZ); e1++);
                                for(l = u; o > 0 || l > 0 && n;)0 !== o && (0 === l || !n || r.z <= n.z) ? (i = r, r = r.nextZ, o--) : (i = n, n = n.nextZ, l--), a ? a.nextZ = i : t1 = i, i.prevZ = a, a = i;
                                r = n;
                            }
                            a.nextZ = null, u *= 2;
                        }while (s > 1);
                    }(i);
                }(t1, n, i, a);
                for(var o, l, u = t1; t1.prev !== t1.next;)if (o = t1.prev, l = t1.next, a ? Os(t1, n, i, a) : Rs(t1)) e1.push(o.i / r | 0), e1.push(t1.i / r | 0), e1.push(l.i / r | 0), io(t1), t1 = l.next, u = l.next;
                else if ((t1 = l) === u) {
                    s ? 1 === s ? $s(t1 = Us(Ds(t1), e1, r), e1, r, n, i, a, 2) : 2 === s && qs(t1, e1, r, n, i, a) : $s(Ds(t1), e1, r, n, i, a, 1);
                    break;
                }
            }
        }
        function Rs(t1) {
            var e1 = t1.prev, r = t1, n = t1.next;
            if (Ys(e1, r, n) >= 0) return !1;
            for(var i = e1.x, a = r.x, s = n.x, o = e1.y, l = r.y, u = n.y, c = i < a ? i < s ? i : s : a < s ? a : s, h = o < l ? o < u ? o : u : l < u ? l : u, p = i > a ? i > s ? i : s : a > s ? a : s, f = o > l ? o > u ? o : u : l > u ? l : u, d = n.next; d !== e1;){
                if (d.x >= c && d.x <= p && d.y >= h && d.y <= f && Js(i, o, a, l, s, u, d.x, d.y) && Ys(d.prev, d, d.next) >= 0) return !1;
                d = d.next;
            }
            return !0;
        }
        function Os(t1, e1, r, n) {
            var i = t1.prev, a = t1, s = t1.next;
            if (Ys(i, a, s) >= 0) return !1;
            for(var o = i.x, l = a.x, u = s.x, c = i.y, h = a.y, p = s.y, f = o < l ? o < u ? o : u : l < u ? l : u, d = c < h ? c < p ? c : p : h < p ? h : p, y = o > l ? o > u ? o : u : l > u ? l : u, m = c > h ? c > p ? c : p : h > p ? h : p, g = Ks(f, d, e1, r, n), x = Ks(y, m, e1, r, n), v = t1.prevZ, b = t1.nextZ; v && v.z >= g && b && b.z <= x;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== s && Js(o, c, l, h, u, p, v.x, v.y) && Ys(v.prev, v, v.next) >= 0) return !1;
                if (v = v.prevZ, b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== s && Js(o, c, l, h, u, p, b.x, b.y) && Ys(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            for(; v && v.z >= g;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== s && Js(o, c, l, h, u, p, v.x, v.y) && Ys(v.prev, v, v.next) >= 0) return !1;
                v = v.prevZ;
            }
            for(; b && b.z <= x;){
                if (b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== s && Js(o, c, l, h, u, p, b.x, b.y) && Ys(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            return !0;
        }
        function Us(t1, e1, r) {
            var n = t1;
            do {
                var i = n.prev, a = n.next.next;
                !Hs(i, a) && Ws(i, n, n.next, a) && eo(i, a) && eo(a, i) && (e1.push(i.i / r | 0), e1.push(n.i / r | 0), e1.push(a.i / r | 0), io(n), io(n.next), n = t1 = a), n = n.next;
            }while (n !== t1);
            return Ds(n);
        }
        function qs(t1, e1, r, n, i, a) {
            var s = t1;
            do {
                for(var o = s.next.next; o !== s.prev;){
                    if (s.i !== o.i && Xs(s, o)) {
                        var l = ro(s, o);
                        return s = Ds(s, s.next), l = Ds(l, l.next), $s(s, e1, r, n, i, a, 0), void $s(l, e1, r, n, i, a, 0);
                    }
                    o = o.next;
                }
                s = s.next;
            }while (s !== t1);
        }
        function js(t1, e1) {
            return t1.x - e1.x;
        }
        function Ns(t1, e1) {
            var r = function(t1, e1) {
                var r, n = e1, i = t1.x, a = t1.y, s = -1 / 0;
                do {
                    if (a <= n.y && a >= n.next.y && n.next.y !== n.y) {
                        var o = n.x + (a - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                        if (o <= i && o > s && (s = o, r = n.x < n.next.x ? n : n.next, o === i)) return r;
                    }
                    n = n.next;
                }while (n !== e1);
                if (!r) return null;
                var l, u = r, c = r.x, h = r.y, p = 1 / 0;
                n = r;
                do i >= n.x && n.x >= c && i !== n.x && Js(a < h ? i : s, a, c, h, a < h ? s : i, a, n.x, n.y) && (l = Math.abs(a - n.y) / (i - n.x), eo(n, t1) && (l < p || l === p && (n.x > r.x || n.x === r.x && Zs(r, n))) && (r = n, p = l)), n = n.next;
                while (n !== u);
                return r;
            }(t1, e1);
            if (!r) return e1;
            var n = ro(r, t1);
            return Ds(n, n.next), Ds(r, r.next);
        }
        function Zs(t1, e1) {
            return Ys(t1.prev, t1, e1.prev) < 0 && Ys(e1.next, t1, t1.next) < 0;
        }
        function Ks(t1, e1, r, n, i) {
            return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = (t1 - r) * i | 0) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - n) * i | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
        }
        function Gs(t1) {
            var e1 = t1, r = t1;
            do (e1.x < r.x || e1.x === r.x && e1.y < r.y) && (r = e1), e1 = e1.next;
            while (e1 !== t1);
            return r;
        }
        function Js(t1, e1, r, n, i, a, s, o) {
            return (i - s) * (e1 - o) >= (t1 - s) * (a - o) && (t1 - s) * (n - o) >= (r - s) * (e1 - o) && (r - s) * (a - o) >= (i - s) * (n - o);
        }
        function Xs(t1, e1) {
            return t1.next.i !== e1.i && t1.prev.i !== e1.i && !function(t1, e1) {
                var r = t1;
                do {
                    if (r.i !== t1.i && r.next.i !== t1.i && r.i !== e1.i && r.next.i !== e1.i && Ws(r, r.next, t1, e1)) return !0;
                    r = r.next;
                }while (r !== t1);
                return !1;
            }(t1, e1) && (eo(t1, e1) && eo(e1, t1) && function(t1, e1) {
                var r = t1, n = !1, i = (t1.x + e1.x) / 2, a = (t1.y + e1.y) / 2;
                do r.y > a != r.next.y > a && r.next.y !== r.y && i < (r.next.x - r.x) * (a - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== t1);
                return n;
            }(t1, e1) && (Ys(t1.prev, t1, e1.prev) || Ys(t1, e1.prev, e1)) || Hs(t1, e1) && Ys(t1.prev, t1, t1.next) > 0 && Ys(e1.prev, e1, e1.next) > 0);
        }
        function Ys(t1, e1, r) {
            return (e1.y - t1.y) * (r.x - e1.x) - (e1.x - t1.x) * (r.y - e1.y);
        }
        function Hs(t1, e1) {
            return t1.x === e1.x && t1.y === e1.y;
        }
        function Ws(t1, e1, r, n) {
            var i = to(Ys(t1, e1, r)), a = to(Ys(t1, e1, n)), s = to(Ys(r, n, t1)), o = to(Ys(r, n, e1));
            return i !== a && s !== o || !(0 !== i || !Qs(t1, r, e1)) || !(0 !== a || !Qs(t1, n, e1)) || !(0 !== s || !Qs(r, t1, n)) || !(0 !== o || !Qs(r, e1, n));
        }
        function Qs(t1, e1, r) {
            return e1.x <= Math.max(t1.x, r.x) && e1.x >= Math.min(t1.x, r.x) && e1.y <= Math.max(t1.y, r.y) && e1.y >= Math.min(t1.y, r.y);
        }
        function to(t1) {
            return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
        }
        function eo(t1, e1) {
            return Ys(t1.prev, t1, t1.next) < 0 ? Ys(t1, e1, t1.next) >= 0 && Ys(t1, t1.prev, e1) >= 0 : Ys(t1, e1, t1.prev) < 0 || Ys(t1, t1.next, e1) < 0;
        }
        function ro(t1, e1) {
            var r = new ao(t1.i, t1.x, t1.y), n = new ao(e1.i, e1.x, e1.y), i = t1.next, a = e1.prev;
            return t1.next = e1, e1.prev = t1, r.next = i, i.prev = r, n.next = r, r.prev = n, a.next = n, n.prev = a, n;
        }
        function no(t1, e1, r, n) {
            var i = new ao(t1, e1, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function io(t1) {
            t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
        }
        function ao(t1, e1, r) {
            this.i = t1, this.x = e1, this.y = r, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }
        function so(t1, e1, r, n) {
            for(var i = 0, a = e1, s = r - n; a < r; a += n)i += (t1[s] - t1[a]) * (t1[a + 1] + t1[s + 1]), s = a;
            return i;
        }
        function oo(t1, e1, r, n, i) {
            lo(t1, e1, r || 0, n || t1.length - 1, i || co);
        }
        function lo(t1, e1, r, n, i) {
            for(; n > r;){
                if (n - r > 600) {
                    var a = n - r + 1, s = e1 - r + 1, o = Math.log(a), l = .5 * Math.exp(2 * o / 3), u = .5 * Math.sqrt(o * l * (a - l) / a) * (s - a / 2 < 0 ? -1 : 1);
                    lo(t1, e1, Math.max(r, Math.floor(e1 - s * l / a + u)), Math.min(n, Math.floor(e1 + (a - s) * l / a + u)), i);
                }
                var c = t1[e1], h = r, p = n;
                for(uo(t1, r, e1), i(t1[n], c) > 0 && uo(t1, r, n); h < p;){
                    for(uo(t1, h, p), h++, p--; i(t1[h], c) < 0;)h++;
                    for(; i(t1[p], c) > 0;)p--;
                }
                0 === i(t1[r], c) ? uo(t1, r, p) : uo(t1, ++p, n), p <= e1 && (r = p + 1), e1 <= p && (n = p - 1);
            }
        }
        function uo(t1, e1, r) {
            var n = t1[e1];
            t1[e1] = t1[r], t1[r] = n;
        }
        function co(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function ho(t1, e1) {
            const r = t1.length;
            if (r <= 1) return [
                t1
            ];
            const n = [];
            let i, a;
            for(let e1 = 0; e1 < r; e1++){
                const r = m(t1[e1]);
                0 !== r && (t1[e1].area = Math.abs(r), void 0 === a && (a = r < 0), a === r < 0 ? (i && n.push(i), i = [
                    t1[e1]
                ]) : i.push(t1[e1]));
            }
            if (i && n.push(i), e1 > 1) for(let t1 = 0; t1 < n.length; t1++)n[t1].length <= e1 || (oo(n[t1], e1, 1, n[t1].length - 1, po), n[t1] = n[t1].slice(0, e1));
            return n;
        }
        function po(t1, e1) {
            return e1.area - t1.area;
        }
        function fo(t1, e1, r) {
            const n = r.patternDependencies;
            let i = !1;
            for (const r of e1){
                const e1 = r.paint.get(`${t1}-pattern`);
                e1.isConstant() || (i = !0);
                const a = e1.constantOr(null);
                a && (i = !0, n[a.to] = !0, n[a.from] = !0);
            }
            return i;
        }
        function yo(t1, e1, r, n, i) {
            const a = i.patternDependencies;
            for (const s of e1){
                const e1 = s.paint.get(`${t1}-pattern`).value;
                if ("constant" !== e1.kind) {
                    let t1 = e1.evaluate({
                        zoom: n - 1
                    }, r, {}, i.availableImages), o = e1.evaluate({
                        zoom: n
                    }, r, {}, i.availableImages), l = e1.evaluate({
                        zoom: n + 1
                    }, r, {}, i.availableImages);
                    t1 = t1 && t1.name ? t1.name : t1, o = o && o.name ? o.name : o, l = l && l.name ? l.name : l, a[t1] = !0, a[o] = !0, a[l] = !0, r.patterns[s.id] = {
                        min: t1,
                        mid: o,
                        max: l
                    };
                }
            }
            return r;
        }
        Fs.exports = Ts, Fs.exports.default = Ts, Ts.deviation = function(t1, e1, r, n) {
            var i = e1 && e1.length, a = Math.abs(so(t1, 0, i ? e1[0] * r : t1.length, r));
            if (i) for(var s = 0, o = e1.length; s < o; s++)a -= Math.abs(so(t1, e1[s] * r, s < o - 1 ? e1[s + 1] * r : t1.length, r));
            var l = 0;
            for(s = 0; s < n.length; s += 3){
                var u = n[s] * r, c = n[s + 1] * r, h = n[s + 2] * r;
                l += Math.abs((t1[u] - t1[h]) * (t1[c + 1] - t1[u + 1]) - (t1[u] - t1[c]) * (t1[h + 1] - t1[u + 1]));
            }
            return 0 === a && 0 === l ? 0 : Math.abs((l - a) / a);
        }, Ts.flatten = function(t1) {
            for(var e1 = t1[0][0].length, r = {
                vertices: [],
                holes: [],
                dimensions: e1
            }, n = 0, i = 0; i < t1.length; i++){
                for(var a = 0; a < t1[i].length; a++)for(var s = 0; s < e1; s++)r.vertices.push(t1[i][a][s]);
                i > 0 && r.holes.push(n += t1[i - 1].length);
            }
            return r;
        };
        class mo {
            populate(t1, e1, r) {
                this.hasPattern = fo("fill", this.layers, e1);
                const n = this.layers[0].layout.get("fill-sort-key"), i = !n.isConstant(), a = [];
                for (const { feature: s, id: o, index: l, sourceLayerIndex: u } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, c = Ka(s, t1);
                    if (!this.layers[0]._featureFilter.filter(new Qn(this.zoom), c, r)) continue;
                    const h = i ? n.evaluate(c, {}, r, e1.availableImages) : void 0, p = {
                        id: o,
                        properties: s.properties,
                        type: s.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: t1 ? c.geometry : Za(s),
                        patterns: {},
                        sortKey: h
                    };
                    a.push(p);
                }
                i && a.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                for (const n of a){
                    const { geometry: i, index: a, sourceLayerIndex: s } = n;
                    if (this.hasPattern) {
                        const t1 = yo("fill", this.layers, n, this.zoom, e1);
                        this.patternFeatures.push(t1);
                    } else this.addFeature(n, i, a, r, {});
                    e1.featureIndex.insert(t1[a].feature, i, a, s, this.index);
                }
            }
            update(t1, e1, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
            }
            addFeatures(t1, e1, r) {
                for (const t1 of this.patternFeatures)this.addFeature(t1, t1.geometry, t1.index, e1, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Es), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.indexBuffer2 = t1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
            }
            addFeature(t1, e1, r, n, i) {
                for (const t1 of ho(e1, 500)){
                    let e1 = 0;
                    for (const r of t1)e1 += r.length;
                    const r = this.segments.prepareSegment(e1, this.layoutVertexArray, this.indexArray), n = r.vertexLength, i = [], a = [];
                    for (const e1 of t1){
                        if (0 === e1.length) continue;
                        e1 !== t1[0] && a.push(i.length / 2);
                        const r = this.segments2.prepareSegment(e1.length, this.layoutVertexArray, this.indexArray2), n = r.vertexLength;
                        this.layoutVertexArray.emplaceBack(e1[0].x, e1[0].y), this.indexArray2.emplaceBack(n + e1.length - 1, n), i.push(e1[0].x), i.push(e1[0].y);
                        for(let t1 = 1; t1 < e1.length; t1++)this.layoutVertexArray.emplaceBack(e1[t1].x, e1[t1].y), this.indexArray2.emplaceBack(n + t1 - 1, n + t1), i.push(e1[t1].x), i.push(e1[t1].y);
                        r.vertexLength += e1.length, r.primitiveLength += e1.length;
                    }
                    const s = Fs.exports(i, a);
                    for(let t1 = 0; t1 < s.length; t1 += 3)this.indexArray.emplaceBack(n + s[t1], n + s[t1 + 1], n + s[t1 + 2]);
                    r.vertexLength += e1, r.primitiveLength += s.length / 3;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
            }
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new ea, this.indexArray = new ha, this.indexArray2 = new pa, this.programConfigurations = new Ra(t1.layers, t1.zoom), this.segments = new ya, this.segments2 = new ya, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
            }
        }
        Mn("FillBucket", mo, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        const go = new fi({
            "fill-sort-key": new ui(nt.layout_fill["fill-sort-key"])
        });
        var xo = {
            paint: new fi({
                "fill-antialias": new li(nt.paint_fill["fill-antialias"]),
                "fill-opacity": new ui(nt.paint_fill["fill-opacity"]),
                "fill-color": new ui(nt.paint_fill["fill-color"]),
                "fill-outline-color": new ui(nt.paint_fill["fill-outline-color"]),
                "fill-translate": new li(nt.paint_fill["fill-translate"]),
                "fill-translate-anchor": new li(nt.paint_fill["fill-translate-anchor"]),
                "fill-pattern": new ci(nt.paint_fill["fill-pattern"])
            }),
            layout: go
        };
        const vo = vi([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_normal_ed",
                components: 4,
                type: "Int16"
            }
        ], 4), bo = vi([
            {
                name: "a_centroid",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: wo } = vo;
        var _o = {}, Ao = S, ko = So;
        function So(t1, e1, r, n, i) {
            this.properties = {}, this.extent = r, this.type = 0, this._pbf = t1, this._geometry = -1, this._keys = n, this._values = i, t1.readFields(Io, this, e1);
        }
        function Io(t1, e1, r) {
            1 == t1 ? e1.id = r.readVarint() : 2 == t1 ? function(t1, e1) {
                for(var r = t1.readVarint() + t1.pos; t1.pos < r;){
                    var n = e1._keys[t1.readVarint()], i = e1._values[t1.readVarint()];
                    e1.properties[n] = i;
                }
            }(r, e1) : 3 == t1 ? e1.type = r.readVarint() : 4 == t1 && (e1._geometry = r.pos);
        }
        function Mo(t1) {
            for(var e1, r, n = 0, i = 0, a = t1.length, s = a - 1; i < a; s = i++)n += ((r = t1[s]).x - (e1 = t1[i]).x) * (e1.y + r.y);
            return n;
        }
        So.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ], So.prototype.loadGeometry = function() {
            var t1 = this._pbf;
            t1.pos = this._geometry;
            for(var e1, r = t1.readVarint() + t1.pos, n = 1, i = 0, a = 0, s = 0, o = []; t1.pos < r;){
                if (i <= 0) {
                    var l = t1.readVarint();
                    n = 7 & l, i = l >> 3;
                }
                if (i--, 1 === n || 2 === n) a += t1.readSVarint(), s += t1.readSVarint(), 1 === n && (e1 && o.push(e1), e1 = []), e1.push(new Ao(a, s));
                else {
                    if (7 !== n) throw new Error("unknown command " + n);
                    e1 && e1.push(e1[0].clone());
                }
            }
            return e1 && o.push(e1), o;
        }, So.prototype.bbox = function() {
            var t1 = this._pbf;
            t1.pos = this._geometry;
            for(var e1 = t1.readVarint() + t1.pos, r = 1, n = 0, i = 0, a = 0, s = 1 / 0, o = -1 / 0, l = 1 / 0, u = -1 / 0; t1.pos < e1;){
                if (n <= 0) {
                    var c = t1.readVarint();
                    r = 7 & c, n = c >> 3;
                }
                if (n--, 1 === r || 2 === r) (i += t1.readSVarint()) < s && (s = i), i > o && (o = i), (a += t1.readSVarint()) < l && (l = a), a > u && (u = a);
                else if (7 !== r) throw new Error("unknown command " + r);
            }
            return [
                s,
                l,
                o,
                u
            ];
        }, So.prototype.toGeoJSON = function(t1, e1, r) {
            var n, i, a = this.extent * Math.pow(2, r), s = this.extent * t1, o = this.extent * e1, l = this.loadGeometry(), u = So.types[this.type];
            function c(t1) {
                for(var e1 = 0; e1 < t1.length; e1++){
                    var r = t1[e1];
                    t1[e1] = [
                        360 * (r.x + s) / a - 180,
                        360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r.y + o) / a) * Math.PI / 180)) - 90
                    ];
                }
            }
            switch(this.type){
                case 1:
                    var h = [];
                    for(n = 0; n < l.length; n++)h[n] = l[n][0];
                    c(l = h);
                    break;
                case 2:
                    for(n = 0; n < l.length; n++)c(l[n]);
                    break;
                case 3:
                    for(l = function(t1) {
                        var e1 = t1.length;
                        if (e1 <= 1) return [
                            t1
                        ];
                        for(var r, n, i = [], a = 0; a < e1; a++){
                            var s = Mo(t1[a]);
                            0 !== s && (void 0 === n && (n = s < 0), n === s < 0 ? (r && i.push(r), r = [
                                t1[a]
                            ]) : r.push(t1[a]));
                        }
                        return r && i.push(r), i;
                    }(l), n = 0; n < l.length; n++)for(i = 0; i < l[n].length; i++)c(l[n][i]);
            }
            1 === l.length ? l = l[0] : u = "Multi" + u;
            var p = {
                type: "Feature",
                geometry: {
                    type: u,
                    coordinates: l
                },
                properties: this.properties
            };
            return "id" in this && (p.id = this.id), p;
        };
        var zo = ko, Bo = Co;
        function Co(t1, e1) {
            this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t1, this._keys = [], this._values = [], this._features = [], t1.readFields(Po, this, e1), this.length = this._features.length;
        }
        function Po(t1, e1, r) {
            15 === t1 ? e1.version = r.readVarint() : 1 === t1 ? e1.name = r.readString() : 5 === t1 ? e1.extent = r.readVarint() : 2 === t1 ? e1._features.push(r.pos) : 3 === t1 ? e1._keys.push(r.readString()) : 4 === t1 && e1._values.push(function(t1) {
                for(var e1 = null, r = t1.readVarint() + t1.pos; t1.pos < r;){
                    var n = t1.readVarint() >> 3;
                    e1 = 1 === n ? t1.readString() : 2 === n ? t1.readFloat() : 3 === n ? t1.readDouble() : 4 === n ? t1.readVarint64() : 5 === n ? t1.readVarint() : 6 === n ? t1.readSVarint() : 7 === n ? t1.readBoolean() : null;
                }
                return e1;
            }(r));
        }
        Co.prototype.feature = function(t1) {
            if (t1 < 0 || t1 >= this._features.length) throw new Error("feature index out of bounds");
            this._pbf.pos = this._features[t1];
            var e1 = this._pbf.readVarint() + this._pbf.pos;
            return new zo(this._pbf, e1, this.extent, this._keys, this._values);
        };
        var Vo = Bo;
        function Eo(t1, e1, r) {
            if (3 === t1) {
                var n = new Vo(r, r.readVarint() + r.pos);
                n.length && (e1[n.name] = n);
            }
        }
        _o.VectorTile = function(t1, e1) {
            this.layers = t1.readFields(Eo, {}, e1);
        }, _o.VectorTileFeature = ko, _o.VectorTileLayer = Bo;
        const Fo = _o.VectorTileFeature.types, To = Math.pow(2, 13);
        function Lo(t1, e1, r, n, i, a, s, o) {
            t1.emplaceBack(e1, r, 2 * Math.floor(n * To) + s, i * To * 2, a * To * 2, Math.round(o));
        }
        class Do {
            populate(t1, e1, r) {
                this.features = [], this.hasPattern = fo("fill-extrusion", this.layers, e1);
                for (const { feature: n, id: i, index: a, sourceLayerIndex: s } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, o = Ka(n, t1);
                    if (!this.layers[0]._featureFilter.filter(new Qn(this.zoom), o, r)) continue;
                    const l = {
                        id: i,
                        sourceLayerIndex: s,
                        index: a,
                        geometry: t1 ? o.geometry : Za(n),
                        properties: n.properties,
                        type: n.type,
                        patterns: {}
                    };
                    this.hasPattern ? this.features.push(yo("fill-extrusion", this.layers, l, this.zoom, e1)) : this.addFeature(l, l.geometry, a, r, {}), e1.featureIndex.insert(n, l.geometry, a, s, this.index, !0);
                }
            }
            addFeatures(t1, e1, r) {
                for (const t1 of this.features){
                    const { geometry: n } = t1;
                    this.addFeature(t1, n, t1.index, e1, r);
                }
            }
            update(t1, e1, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.centroidVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, wo), this.centroidVertexBuffer = t1.createVertexBuffer(this.centroidVertexArray, bo.members, !0), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
            }
            addFeature(t1, e1, r, n, i) {
                const a = {
                    x: 0,
                    y: 0,
                    vertexCount: 0
                };
                for (const r of ho(e1, 500)){
                    let e1 = 0;
                    for (const t1 of r)e1 += t1.length;
                    let n = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray);
                    for (const t1 of r){
                        if (0 === t1.length) continue;
                        if (Ro(t1)) continue;
                        let e1 = 0;
                        for(let r = 0; r < t1.length; r++){
                            const i = t1[r];
                            if (r >= 1) {
                                const s = t1[r - 1];
                                if (!$o(i, s)) {
                                    n.vertexLength + 4 > ya.MAX_VERTEX_ARRAY_LENGTH && (n = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                    const t1 = i.sub(s)._perp()._unit(), r = s.dist(i);
                                    e1 + r > 32768 && (e1 = 0), Lo(this.layoutVertexArray, i.x, i.y, t1.x, t1.y, 0, 0, e1), Lo(this.layoutVertexArray, i.x, i.y, t1.x, t1.y, 0, 1, e1), a.x += 2 * i.x, a.y += 2 * i.y, a.vertexCount += 2, e1 += r, Lo(this.layoutVertexArray, s.x, s.y, t1.x, t1.y, 0, 0, e1), Lo(this.layoutVertexArray, s.x, s.y, t1.x, t1.y, 0, 1, e1), a.x += 2 * s.x, a.y += 2 * s.y, a.vertexCount += 2;
                                    const o = n.vertexLength;
                                    this.indexArray.emplaceBack(o, o + 2, o + 1), this.indexArray.emplaceBack(o + 1, o + 2, o + 3), n.vertexLength += 4, n.primitiveLength += 2;
                                }
                            }
                        }
                    }
                    if (n.vertexLength + e1 > ya.MAX_VERTEX_ARRAY_LENGTH && (n = this.segments.prepareSegment(e1, this.layoutVertexArray, this.indexArray)), "Polygon" !== Fo[t1.type]) continue;
                    const i = [], s = [], o = n.vertexLength;
                    for (const t1 of r)if (0 !== t1.length) {
                        t1 !== r[0] && s.push(i.length / 2);
                        for(let e1 = 0; e1 < t1.length; e1++){
                            const r = t1[e1];
                            Lo(this.layoutVertexArray, r.x, r.y, 0, 0, 1, 1, 0), a.x += r.x, a.y += r.y, a.vertexCount += 1, i.push(r.x), i.push(r.y);
                        }
                    }
                    const l = Fs.exports(i, s);
                    for(let t1 = 0; t1 < l.length; t1 += 3)this.indexArray.emplaceBack(o + l[t1], o + l[t1 + 2], o + l[t1 + 1]);
                    n.primitiveLength += l.length / 3, n.vertexLength += e1;
                }
                for(let t1 = 0; t1 < a.vertexCount; t1++)this.centroidVertexArray.emplaceBack(Math.floor(a.x / a.vertexCount), Math.floor(a.y / a.vertexCount));
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
            }
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.layoutVertexArray = new ra, this.centroidVertexArray = new Qi, this.indexArray = new ha, this.programConfigurations = new Ra(t1.layers, t1.zoom), this.segments = new ya, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
            }
        }
        function $o(t1, e1) {
            return t1.x === e1.x && (t1.x < 0 || t1.x > qa) || t1.y === e1.y && (t1.y < 0 || t1.y > qa);
        }
        function Ro(t1) {
            return t1.every((t1)=>t1.x < 0) || t1.every((t1)=>t1.x > qa) || t1.every((t1)=>t1.y < 0) || t1.every((t1)=>t1.y > qa);
        }
        Mn("FillExtrusionBucket", Do, {
            omit: [
                "layers",
                "features"
            ]
        });
        var Oo = {
            paint: new fi({
                "fill-extrusion-opacity": new li(nt["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                "fill-extrusion-color": new ui(nt["paint_fill-extrusion"]["fill-extrusion-color"]),
                "fill-extrusion-translate": new li(nt["paint_fill-extrusion"]["fill-extrusion-translate"]),
                "fill-extrusion-translate-anchor": new li(nt["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                "fill-extrusion-pattern": new ci(nt["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                "fill-extrusion-height": new ui(nt["paint_fill-extrusion"]["fill-extrusion-height"]),
                "fill-extrusion-base": new ui(nt["paint_fill-extrusion"]["fill-extrusion-base"]),
                "fill-extrusion-vertical-gradient": new li(nt["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
            })
        };
        function Uo(t1, e1) {
            return t1.x * e1.x + t1.y * e1.y;
        }
        function qo(t1, e1) {
            if (1 === t1.length) {
                let r = 0;
                const n = e1[r++];
                let i;
                for(; !i || n.equals(i);)if (i = e1[r++], !i) return 1 / 0;
                for(; r < e1.length; r++){
                    const a = e1[r], s = t1[0], o = i.sub(n), l = a.sub(n), u = s.sub(n), c = Uo(o, o), h = Uo(o, l), p = Uo(l, l), f = Uo(u, o), d = Uo(u, l), y = c * p - h * h, m = (p * f - h * d) / y, g = (c * d - h * f) / y, x = n.z * (1 - m - g) + i.z * m + a.z * g;
                    if (isFinite(x)) return x;
                }
                return 1 / 0;
            }
            {
                let t1 = 1 / 0;
                for (const r of e1)t1 = Math.min(t1, r.z);
                return t1;
            }
        }
        const jo = vi([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            }
        ], 4), { members: No } = jo, Zo = vi([
            {
                name: "a_uv_x",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_split_index",
                components: 1,
                type: "Float32"
            }
        ]), { members: Ko } = Zo, Go = _o.VectorTileFeature.types, Jo = Math.cos(Math.PI / 180 * 37.5), Xo = Math.pow(2, 14) / .5;
        class Yo {
            populate(t1, e1, r) {
                this.hasPattern = fo("line", this.layers, e1);
                const n = this.layers[0].layout.get("line-sort-key"), i = !n.isConstant(), a = [];
                for (const { feature: e1, id: s, index: o, sourceLayerIndex: l } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, u = Ka(e1, t1);
                    if (!this.layers[0]._featureFilter.filter(new Qn(this.zoom), u, r)) continue;
                    const c = i ? n.evaluate(u, {}, r) : void 0, h = {
                        id: s,
                        properties: e1.properties,
                        type: e1.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t1 ? u.geometry : Za(e1),
                        patterns: {},
                        sortKey: c
                    };
                    a.push(h);
                }
                i && a.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                for (const n of a){
                    const { geometry: i, index: a, sourceLayerIndex: s } = n;
                    if (this.hasPattern) {
                        const t1 = yo("line", this.layers, n, this.zoom, e1);
                        this.patternFeatures.push(t1);
                    } else this.addFeature(n, i, a, r, {});
                    e1.featureIndex.insert(t1[a].feature, i, a, s, this.index);
                }
            }
            update(t1, e1, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
            }
            addFeatures(t1, e1, r) {
                for (const t1 of this.patternFeatures)this.addFeature(t1, t1.geometry, t1.index, e1, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t1.createVertexBuffer(this.layoutVertexArray2, Ko)), this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, No), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(t1) {
                if (t1.properties && Object.prototype.hasOwnProperty.call(t1.properties, "mapbox_clip_start") && Object.prototype.hasOwnProperty.call(t1.properties, "mapbox_clip_end")) return {
                    start: +t1.properties.mapbox_clip_start,
                    end: +t1.properties.mapbox_clip_end
                };
            }
            addFeature(t1, e1, r, n, i) {
                const a = this.layers[0].layout, s = a.get("line-join").evaluate(t1, {}), o = a.get("line-cap"), l = a.get("line-miter-limit"), u = a.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(t1);
                for (const r of e1)this.addLine(r, t1, s, o, l, u);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
            }
            addLine(t1, e1, r, n, i, a) {
                if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineClips) {
                    this.lineClipsArray.push(this.lineClips);
                    for(let e1 = 0; e1 < t1.length - 1; e1++)this.totalDistance += t1[e1].dist(t1[e1 + 1]);
                    this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                }
                const s = "Polygon" === Go[e1.type];
                let o = t1.length;
                for(; o >= 2 && t1[o - 1].equals(t1[o - 2]);)o--;
                let l = 0;
                for(; l < o - 1 && t1[l].equals(t1[l + 1]);)l++;
                if (o < (s ? 3 : 2)) return;
                "bevel" === r && (i = 1.05);
                const u = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0, c = this.segments.prepareSegment(10 * o, this.layoutVertexArray, this.indexArray);
                let h, p, f, d, y;
                this.e1 = this.e2 = -1, s && (h = t1[o - 2], y = t1[l].sub(h)._unit()._perp());
                for(let e1 = l; e1 < o; e1++){
                    if (f = e1 === o - 1 ? s ? t1[l + 1] : void 0 : t1[e1 + 1], f && t1[e1].equals(f)) continue;
                    y && (d = y), h && (p = h), h = t1[e1], y = f ? f.sub(h)._unit()._perp() : d, d = d || y;
                    let m = d.add(y);
                    0 === m.x && 0 === m.y || m._unit();
                    const g = d.x * y.x + d.y * y.y, x = m.x * y.x + m.y * y.y, v = 0 !== x ? 1 / x : 1 / 0, b = 2 * Math.sqrt(2 - 2 * x), w = x < Jo && p && f, _ = d.x * y.y - d.y * y.x > 0;
                    if (w && e1 > l) {
                        const t1 = h.dist(p);
                        if (t1 > 2 * u) {
                            const e1 = h.sub(h.sub(p)._mult(u / t1)._round());
                            this.updateDistance(p, e1), this.addCurrentVertex(e1, d, 0, 0, c), p = e1;
                        }
                    }
                    const A = p && f;
                    let k = A ? r : s ? "butt" : n;
                    if (A && "round" === k && (v < a ? k = "miter" : v <= 2 && (k = "fakeround")), "miter" === k && v > i && (k = "bevel"), "bevel" === k && (v > 2 && (k = "flipbevel"), v < i && (k = "miter")), p && this.updateDistance(p, h), "miter" === k) m._mult(v), this.addCurrentVertex(h, m, 0, 0, c);
                    else if ("flipbevel" === k) {
                        if (v > 100) m = y.mult(-1);
                        else {
                            const t1 = v * d.add(y).mag() / d.sub(y).mag();
                            m._perp()._mult(t1 * (_ ? -1 : 1));
                        }
                        this.addCurrentVertex(h, m, 0, 0, c), this.addCurrentVertex(h, m.mult(-1), 0, 0, c);
                    } else if ("bevel" === k || "fakeround" === k) {
                        const t1 = -Math.sqrt(v * v - 1), e1 = _ ? t1 : 0, r = _ ? 0 : t1;
                        if (p && this.addCurrentVertex(h, d, e1, r, c), "fakeround" === k) {
                            const t1 = Math.round(180 * b / Math.PI / 20);
                            for(let e1 = 1; e1 < t1; e1++){
                                let r = e1 / t1;
                                if (.5 !== r) {
                                    const t1 = r - .5;
                                    r += r * t1 * (r - 1) * ((1.0904 + g * (g * (3.55645 - 1.43519 * g) - 3.2452)) * t1 * t1 + (.848013 + g * (.215638 * g - 1.06021)));
                                }
                                const n = y.sub(d)._mult(r)._add(d)._unit()._mult(_ ? -1 : 1);
                                this.addHalfVertex(h, n.x, n.y, !1, _, 0, c);
                            }
                        }
                        f && this.addCurrentVertex(h, y, -e1, -r, c);
                    } else if ("butt" === k) this.addCurrentVertex(h, m, 0, 0, c);
                    else if ("square" === k) {
                        const t1 = p ? 1 : -1;
                        this.addCurrentVertex(h, m, t1, t1, c);
                    } else "round" === k && (p && (this.addCurrentVertex(h, d, 0, 0, c), this.addCurrentVertex(h, d, 1, 1, c, !0)), f && (this.addCurrentVertex(h, y, -1, -1, c, !0), this.addCurrentVertex(h, y, 0, 0, c)));
                    if (w && e1 < o - 1) {
                        const t1 = h.dist(f);
                        if (t1 > 2 * u) {
                            const e1 = h.add(f.sub(h)._mult(u / t1)._round());
                            this.updateDistance(h, e1), this.addCurrentVertex(e1, y, 0, 0, c), h = e1;
                        }
                    }
                }
            }
            addCurrentVertex(t1, e1, r, n, i, a = !1) {
                const s = e1.y * n - e1.x, o = -e1.y - e1.x * n;
                this.addHalfVertex(t1, e1.x + e1.y * r, e1.y - e1.x * r, a, !1, r, i), this.addHalfVertex(t1, s, o, a, !0, -n, i), this.distance > Xo / 2 && 0 === this.totalDistance && (this.distance = 0, this.addCurrentVertex(t1, e1, r, n, i, a));
            }
            addHalfVertex({ x: t1, y: e1 }, r, n, i, a, s, o) {
                const l = .5 * (this.lineClips ? this.scaledDistance * (Xo - 1) : this.scaledDistance);
                this.layoutVertexArray.emplaceBack((t1 << 1) + (i ? 1 : 0), (e1 << 1) + (a ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === s ? 0 : s < 0 ? -1 : 1) | (63 & l) << 2, l >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
                const u = o.vertexLength++;
                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u), o.primitiveLength++), a ? this.e2 = u : this.e1 = u;
            }
            updateScaledDistance() {
                this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
            }
            updateDistance(t1, e1) {
                this.distance += t1.dist(e1), this.updateScaledDistance();
            }
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t1)=>{
                    this.gradients[t1.id] = {};
                }), this.layoutVertexArray = new na, this.layoutVertexArray2 = new ia, this.indexArray = new ha, this.programConfigurations = new Ra(t1.layers, t1.zoom), this.segments = new ya, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
            }
        }
        Mn("LineBucket", Yo, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        const Ho = new fi({
            "line-cap": new li(nt.layout_line["line-cap"]),
            "line-join": new ui(nt.layout_line["line-join"]),
            "line-miter-limit": new li(nt.layout_line["line-miter-limit"]),
            "line-round-limit": new li(nt.layout_line["line-round-limit"]),
            "line-sort-key": new ui(nt.layout_line["line-sort-key"])
        });
        var Wo = {
            paint: new fi({
                "line-opacity": new ui(nt.paint_line["line-opacity"]),
                "line-color": new ui(nt.paint_line["line-color"]),
                "line-translate": new li(nt.paint_line["line-translate"]),
                "line-translate-anchor": new li(nt.paint_line["line-translate-anchor"]),
                "line-width": new ui(nt.paint_line["line-width"]),
                "line-gap-width": new ui(nt.paint_line["line-gap-width"]),
                "line-offset": new ui(nt.paint_line["line-offset"]),
                "line-blur": new ui(nt.paint_line["line-blur"]),
                "line-dasharray": new hi(nt.paint_line["line-dasharray"]),
                "line-pattern": new ci(nt.paint_line["line-pattern"]),
                "line-gradient": new pi(nt.paint_line["line-gradient"])
            }),
            layout: Ho
        };
        const Qo = new class extends ui {
            possiblyEvaluate(t1, e1) {
                return e1 = new Qn(Math.floor(e1.zoom), {
                    now: e1.now,
                    fadeDuration: e1.fadeDuration,
                    zoomHistory: e1.zoomHistory,
                    transition: e1.transition
                }), super.possiblyEvaluate(t1, e1);
            }
            evaluate(t1, e1, r, n) {
                return e1 = o({}, e1, {
                    zoom: Math.floor(e1.zoom)
                }), super.evaluate(t1, e1, r, n);
            }
        }(Wo.paint.properties["line-width"].specification);
        function tl(t1, e1) {
            return e1 > 0 ? e1 + 2 * t1 : t1;
        }
        Qo.useIntegerZoom = !0;
        const el = vi([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), rl = vi([
            {
                name: "a_projected_pos",
                components: 3,
                type: "Float32"
            }
        ], 4);
        vi([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const nl = vi([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            }
        ]);
        vi([
            {
                type: "Int16",
                name: "anchorPointX"
            },
            {
                type: "Int16",
                name: "anchorPointY"
            },
            {
                type: "Int16",
                name: "x1"
            },
            {
                type: "Int16",
                name: "y1"
            },
            {
                type: "Int16",
                name: "x2"
            },
            {
                type: "Int16",
                name: "y2"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const il = vi([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), al = vi([
            {
                name: "a_pos",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        function sl(t1, e1, r) {
            return t1.sections.forEach((t1)=>{
                t1.text = function(t1, e1, r) {
                    const n = e1.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === n ? t1 = t1.toLocaleUpperCase() : "lowercase" === n && (t1 = t1.toLocaleLowerCase()), Wn.applyArabicShaping && (t1 = Wn.applyArabicShaping(t1)), t1;
                }(t1.text, e1, r);
            }), t1;
        }
        vi([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), vi([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            }
        ]), vi([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                name: "textBoxScale"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            }
        ]), vi([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), vi([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            },
            {
                type: "Int16",
                name: "tileUnitDistanceFromAnchor"
            }
        ]);
        const ol = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42"
        };
        var ll = 24, ul = pl, cl = function(t1, e1, r, n, i) {
            var a, s, o = 8 * i - n - 1, l = (1 << o) - 1, u = l >> 1, c = -7, h = r ? i - 1 : 0, p = r ? -1 : 1, f = t1[e1 + h];
            for(h += p, a = f & (1 << -c) - 1, f >>= -c, c += o; c > 0; a = 256 * a + t1[e1 + h], h += p, c -= 8);
            for(s = a & (1 << -c) - 1, a >>= -c, c += n; c > 0; s = 256 * s + t1[e1 + h], h += p, c -= 8);
            if (0 === a) a = 1 - u;
            else {
                if (a === l) return s ? NaN : 1 / 0 * (f ? -1 : 1);
                s += Math.pow(2, n), a -= u;
            }
            return (f ? -1 : 1) * s * Math.pow(2, a - n);
        }, hl = function(t1, e1, r, n, i, a) {
            var s, o, l, u = 8 * a - i - 1, c = (1 << u) - 1, h = c >> 1, p = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : a - 1, d = n ? 1 : -1, y = e1 < 0 || 0 === e1 && 1 / e1 < 0 ? 1 : 0;
            for(e1 = Math.abs(e1), isNaN(e1) || e1 === 1 / 0 ? (o = isNaN(e1) ? 1 : 0, s = c) : (s = Math.floor(Math.log(e1) / Math.LN2), e1 * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), (e1 += s + h >= 1 ? p / l : p * Math.pow(2, 1 - h)) * l >= 2 && (s++, l /= 2), s + h >= c ? (o = 0, s = c) : s + h >= 1 ? (o = (e1 * l - 1) * Math.pow(2, i), s += h) : (o = e1 * Math.pow(2, h - 1) * Math.pow(2, i), s = 0)); i >= 8; t1[r + f] = 255 & o, f += d, o /= 256, i -= 8);
            for(s = s << i | o, u += i; u > 0; t1[r + f] = 255 & s, f += d, s /= 256, u -= 8);
            t1[r + f - d] |= 128 * y;
        };
        function pl(t1) {
            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t1) ? t1 : new Uint8Array(t1 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
        }
        pl.Varint = 0, pl.Fixed64 = 1, pl.Bytes = 2, pl.Fixed32 = 5;
        var fl, dl = 4294967296, yl = 1 / dl, ml = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
        function gl(t1) {
            return t1.type === pl.Bytes ? t1.readVarint() + t1.pos : t1.pos + 1;
        }
        function xl(t1, e1, r) {
            return r ? 4294967296 * e1 + (t1 >>> 0) : 4294967296 * (e1 >>> 0) + (t1 >>> 0);
        }
        function vl(t1, e1, r) {
            var n = e1 <= 16383 ? 1 : e1 <= 2097151 ? 2 : e1 <= 268435455 ? 3 : Math.floor(Math.log(e1) / (7 * Math.LN2));
            r.realloc(n);
            for(var i = r.pos - 1; i >= t1; i--)r.buf[i + n] = r.buf[i];
        }
        function bl(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeVarint(t1[r]);
        }
        function wl(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSVarint(t1[r]);
        }
        function _l(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFloat(t1[r]);
        }
        function Al(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeDouble(t1[r]);
        }
        function kl(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeBoolean(t1[r]);
        }
        function Sl(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFixed32(t1[r]);
        }
        function Il(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSFixed32(t1[r]);
        }
        function Ml(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFixed64(t1[r]);
        }
        function zl(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSFixed64(t1[r]);
        }
        function Bl(t1, e1) {
            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + 16777216 * t1[e1 + 3];
        }
        function Cl(t1, e1, r) {
            t1[r] = e1, t1[r + 1] = e1 >>> 8, t1[r + 2] = e1 >>> 16, t1[r + 3] = e1 >>> 24;
        }
        function Pl(t1, e1) {
            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + (t1[e1 + 3] << 24);
        }
        function Vl(t1, e1, r) {
            1 === t1 && r.readMessage(El, e1);
        }
        function El(t1, e1, r) {
            if (3 === t1) {
                const { id: t1, bitmap: n, width: i, height: a, left: s, top: o, advance: l } = r.readMessage(Fl, {});
                e1.push({
                    id: t1,
                    bitmap: new zs({
                        width: i + 6,
                        height: a + 6
                    }, n),
                    metrics: {
                        width: i,
                        height: a,
                        left: s,
                        top: o,
                        advance: l
                    }
                });
            }
        }
        function Fl(t1, e1, r) {
            1 === t1 ? e1.id = r.readVarint() : 2 === t1 ? e1.bitmap = r.readBytes() : 3 === t1 ? e1.width = r.readVarint() : 4 === t1 ? e1.height = r.readVarint() : 5 === t1 ? e1.left = r.readSVarint() : 6 === t1 ? e1.top = r.readSVarint() : 7 === t1 && (e1.advance = r.readVarint());
        }
        function Tl(t1) {
            let e1 = 0, r = 0;
            for (const n of t1)e1 += n.w * n.h, r = Math.max(r, n.w);
            t1.sort((t1, e1)=>e1.h - t1.h);
            const n = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(e1 / .95)), r),
                    h: 1 / 0
                }
            ];
            let i = 0, a = 0;
            for (const e1 of t1)for(let t1 = n.length - 1; t1 >= 0; t1--){
                const r = n[t1];
                if (!(e1.w > r.w || e1.h > r.h)) {
                    if (e1.x = r.x, e1.y = r.y, a = Math.max(a, e1.y + e1.h), i = Math.max(i, e1.x + e1.w), e1.w === r.w && e1.h === r.h) {
                        const e1 = n.pop();
                        t1 < n.length && (n[t1] = e1);
                    } else e1.h === r.h ? (r.x += e1.w, r.w -= e1.w) : e1.w === r.w ? (r.y += e1.h, r.h -= e1.h) : (n.push({
                        x: r.x + e1.w,
                        y: r.y,
                        w: r.w - e1.w,
                        h: e1.h
                    }), r.y += e1.h, r.h -= e1.h);
                    break;
                }
            }
            return {
                w: i,
                h: a,
                fill: e1 / (i * a) || 0
            };
        }
        pl.prototype = {
            destroy: function() {
                this.buf = null;
            },
            readFields: function(t1, e1, r) {
                for(r = r || this.length; this.pos < r;){
                    var n = this.readVarint(), i = n >> 3, a = this.pos;
                    this.type = 7 & n, t1(i, e1, this), this.pos === a && this.skip(n);
                }
                return e1;
            },
            readMessage: function(t1, e1) {
                return this.readFields(t1, e1, this.readVarint() + this.pos);
            },
            readFixed32: function() {
                var t1 = Bl(this.buf, this.pos);
                return this.pos += 4, t1;
            },
            readSFixed32: function() {
                var t1 = Pl(this.buf, this.pos);
                return this.pos += 4, t1;
            },
            readFixed64: function() {
                var t1 = Bl(this.buf, this.pos) + Bl(this.buf, this.pos + 4) * dl;
                return this.pos += 8, t1;
            },
            readSFixed64: function() {
                var t1 = Bl(this.buf, this.pos) + Pl(this.buf, this.pos + 4) * dl;
                return this.pos += 8, t1;
            },
            readFloat: function() {
                var t1 = cl(this.buf, this.pos, !0, 23, 4);
                return this.pos += 4, t1;
            },
            readDouble: function() {
                var t1 = cl(this.buf, this.pos, !0, 52, 8);
                return this.pos += 8, t1;
            },
            readVarint: function(t1) {
                var e1, r, n = this.buf;
                return e1 = 127 & (r = n[this.pos++]), r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e1 : function(t1, e1, r) {
                    var n, i, a = r.buf;
                    if (n = (112 & (i = a[r.pos++])) >> 4, i < 128) return xl(t1, n, e1);
                    if (n |= (127 & (i = a[r.pos++])) << 3, i < 128) return xl(t1, n, e1);
                    if (n |= (127 & (i = a[r.pos++])) << 10, i < 128) return xl(t1, n, e1);
                    if (n |= (127 & (i = a[r.pos++])) << 17, i < 128) return xl(t1, n, e1);
                    if (n |= (127 & (i = a[r.pos++])) << 24, i < 128) return xl(t1, n, e1);
                    if (n |= (1 & (i = a[r.pos++])) << 31, i < 128) return xl(t1, n, e1);
                    throw new Error("Expected varint not more than 10 bytes");
                }(e1 |= (15 & (r = n[this.pos])) << 28, t1, this))));
            },
            readVarint64: function() {
                return this.readVarint(!0);
            },
            readSVarint: function() {
                var t1 = this.readVarint();
                return t1 % 2 == 1 ? (t1 + 1) / -2 : t1 / 2;
            },
            readBoolean: function() {
                return Boolean(this.readVarint());
            },
            readString: function() {
                var t1 = this.readVarint() + this.pos, e1 = this.pos;
                return this.pos = t1, t1 - e1 >= 12 && ml ? function(t1, e1, r) {
                    return ml.decode(t1.subarray(e1, r));
                }(this.buf, e1, t1) : function(t1, e1, r) {
                    for(var n = "", i = e1; i < r;){
                        var a, s, o, l = t1[i], u = null, c = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                        if (i + c > r) break;
                        1 === c ? l < 128 && (u = l) : 2 === c ? 128 == (192 & (a = t1[i + 1])) && (u = (31 & l) << 6 | 63 & a) <= 127 && (u = null) : 3 === c ? (s = t1[i + 2], 128 == (192 & (a = t1[i + 1])) && 128 == (192 & s) && ((u = (15 & l) << 12 | (63 & a) << 6 | 63 & s) <= 2047 || u >= 55296 && u <= 57343) && (u = null)) : 4 === c && (s = t1[i + 2], o = t1[i + 3], 128 == (192 & (a = t1[i + 1])) && 128 == (192 & s) && 128 == (192 & o) && ((u = (15 & l) << 18 | (63 & a) << 12 | (63 & s) << 6 | 63 & o) <= 65535 || u >= 1114112) && (u = null)), null === u ? (u = 65533, c = 1) : u > 65535 && (u -= 65536, n += String.fromCharCode(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n += String.fromCharCode(u), i += c;
                    }
                    return n;
                }(this.buf, e1, t1);
            },
            readBytes: function() {
                var t1 = this.readVarint() + this.pos, e1 = this.buf.subarray(this.pos, t1);
                return this.pos = t1, e1;
            },
            readPackedVarint: function(t1, e1) {
                if (this.type !== pl.Bytes) return t1.push(this.readVarint(e1));
                var r = gl(this);
                for(t1 = t1 || []; this.pos < r;)t1.push(this.readVarint(e1));
                return t1;
            },
            readPackedSVarint: function(t1) {
                if (this.type !== pl.Bytes) return t1.push(this.readSVarint());
                var e1 = gl(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSVarint());
                return t1;
            },
            readPackedBoolean: function(t1) {
                if (this.type !== pl.Bytes) return t1.push(this.readBoolean());
                var e1 = gl(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readBoolean());
                return t1;
            },
            readPackedFloat: function(t1) {
                if (this.type !== pl.Bytes) return t1.push(this.readFloat());
                var e1 = gl(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFloat());
                return t1;
            },
            readPackedDouble: function(t1) {
                if (this.type !== pl.Bytes) return t1.push(this.readDouble());
                var e1 = gl(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readDouble());
                return t1;
            },
            readPackedFixed32: function(t1) {
                if (this.type !== pl.Bytes) return t1.push(this.readFixed32());
                var e1 = gl(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed32());
                return t1;
            },
            readPackedSFixed32: function(t1) {
                if (this.type !== pl.Bytes) return t1.push(this.readSFixed32());
                var e1 = gl(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed32());
                return t1;
            },
            readPackedFixed64: function(t1) {
                if (this.type !== pl.Bytes) return t1.push(this.readFixed64());
                var e1 = gl(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed64());
                return t1;
            },
            readPackedSFixed64: function(t1) {
                if (this.type !== pl.Bytes) return t1.push(this.readSFixed64());
                var e1 = gl(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed64());
                return t1;
            },
            skip: function(t1) {
                var e1 = 7 & t1;
                if (e1 === pl.Varint) for(; this.buf[this.pos++] > 127;);
                else if (e1 === pl.Bytes) this.pos = this.readVarint() + this.pos;
                else if (e1 === pl.Fixed32) this.pos += 4;
                else {
                    if (e1 !== pl.Fixed64) throw new Error("Unimplemented type: " + e1);
                    this.pos += 8;
                }
            },
            writeTag: function(t1, e1) {
                this.writeVarint(t1 << 3 | e1);
            },
            realloc: function(t1) {
                for(var e1 = this.length || 16; e1 < this.pos + t1;)e1 *= 2;
                if (e1 !== this.length) {
                    var r = new Uint8Array(e1);
                    r.set(this.buf), this.buf = r, this.length = e1;
                }
            },
            finish: function() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            },
            writeFixed32: function(t1) {
                this.realloc(4), Cl(this.buf, t1, this.pos), this.pos += 4;
            },
            writeSFixed32: function(t1) {
                this.realloc(4), Cl(this.buf, t1, this.pos), this.pos += 4;
            },
            writeFixed64: function(t1) {
                this.realloc(8), Cl(this.buf, -1 & t1, this.pos), Cl(this.buf, Math.floor(t1 * yl), this.pos + 4), this.pos += 8;
            },
            writeSFixed64: function(t1) {
                this.realloc(8), Cl(this.buf, -1 & t1, this.pos), Cl(this.buf, Math.floor(t1 * yl), this.pos + 4), this.pos += 8;
            },
            writeVarint: function(t1) {
                (t1 = +t1 || 0) > 268435455 || t1 < 0 ? function(t1, e1) {
                    var r, n;
                    if (t1 >= 0 ? (r = t1 % 4294967296 | 0, n = t1 / 4294967296 | 0) : (n = ~(-t1 / 4294967296), 4294967295 ^ (r = ~(-t1 % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), t1 >= 0x10000000000000000 || t1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    e1.realloc(10), function(t1, e1, r) {
                        r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, r.buf[r.pos] = 127 & (t1 >>>= 7);
                    }(r, 0, e1), function(t1, e1) {
                        var r = (7 & t1) << 4;
                        e1.buf[e1.pos++] |= r | ((t1 >>>= 3) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1)))));
                    }(n, e1);
                }(t1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t1 | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = t1 >>> 7 & 127))));
            },
            writeSVarint: function(t1) {
                this.writeVarint(t1 < 0 ? 2 * -t1 - 1 : 2 * t1);
            },
            writeBoolean: function(t1) {
                this.writeVarint(Boolean(t1));
            },
            writeString: function(t1) {
                t1 = String(t1), this.realloc(4 * t1.length), this.pos++;
                var e1 = this.pos;
                this.pos = function(t1, e1, r) {
                    for(var n, i, a = 0; a < e1.length; a++){
                        if ((n = e1.charCodeAt(a)) > 55295 && n < 57344) {
                            if (!i) {
                                n > 56319 || a + 1 === e1.length ? (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189) : i = n;
                                continue;
                            }
                            if (n < 56320) {
                                t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = n;
                                continue;
                            }
                            n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                        } else i && (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = null);
                        n < 128 ? t1[r++] = n : (n < 2048 ? t1[r++] = n >> 6 | 192 : (n < 65536 ? t1[r++] = n >> 12 | 224 : (t1[r++] = n >> 18 | 240, t1[r++] = n >> 12 & 63 | 128), t1[r++] = n >> 6 & 63 | 128), t1[r++] = 63 & n | 128);
                    }
                    return r;
                }(this.buf, t1, this.pos);
                var r = this.pos - e1;
                r >= 128 && vl(e1, r, this), this.pos = e1 - 1, this.writeVarint(r), this.pos += r;
            },
            writeFloat: function(t1) {
                this.realloc(4), hl(this.buf, t1, this.pos, !0, 23, 4), this.pos += 4;
            },
            writeDouble: function(t1) {
                this.realloc(8), hl(this.buf, t1, this.pos, !0, 52, 8), this.pos += 8;
            },
            writeBytes: function(t1) {
                var e1 = t1.length;
                this.writeVarint(e1), this.realloc(e1);
                for(var r = 0; r < e1; r++)this.buf[this.pos++] = t1[r];
            },
            writeRawMessage: function(t1, e1) {
                this.pos++;
                var r = this.pos;
                t1(e1, this);
                var n = this.pos - r;
                n >= 128 && vl(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
            },
            writeMessage: function(t1, e1, r) {
                this.writeTag(t1, pl.Bytes), this.writeRawMessage(e1, r);
            },
            writePackedVarint: function(t1, e1) {
                e1.length && this.writeMessage(t1, bl, e1);
            },
            writePackedSVarint: function(t1, e1) {
                e1.length && this.writeMessage(t1, wl, e1);
            },
            writePackedBoolean: function(t1, e1) {
                e1.length && this.writeMessage(t1, kl, e1);
            },
            writePackedFloat: function(t1, e1) {
                e1.length && this.writeMessage(t1, _l, e1);
            },
            writePackedDouble: function(t1, e1) {
                e1.length && this.writeMessage(t1, Al, e1);
            },
            writePackedFixed32: function(t1, e1) {
                e1.length && this.writeMessage(t1, Sl, e1);
            },
            writePackedSFixed32: function(t1, e1) {
                e1.length && this.writeMessage(t1, Il, e1);
            },
            writePackedFixed64: function(t1, e1) {
                e1.length && this.writeMessage(t1, Ml, e1);
            },
            writePackedSFixed64: function(t1, e1) {
                e1.length && this.writeMessage(t1, zl, e1);
            },
            writeBytesField: function(t1, e1) {
                this.writeTag(t1, pl.Bytes), this.writeBytes(e1);
            },
            writeFixed32Field: function(t1, e1) {
                this.writeTag(t1, pl.Fixed32), this.writeFixed32(e1);
            },
            writeSFixed32Field: function(t1, e1) {
                this.writeTag(t1, pl.Fixed32), this.writeSFixed32(e1);
            },
            writeFixed64Field: function(t1, e1) {
                this.writeTag(t1, pl.Fixed64), this.writeFixed64(e1);
            },
            writeSFixed64Field: function(t1, e1) {
                this.writeTag(t1, pl.Fixed64), this.writeSFixed64(e1);
            },
            writeVarintField: function(t1, e1) {
                this.writeTag(t1, pl.Varint), this.writeVarint(e1);
            },
            writeSVarintField: function(t1, e1) {
                this.writeTag(t1, pl.Varint), this.writeSVarint(e1);
            },
            writeStringField: function(t1, e1) {
                this.writeTag(t1, pl.Bytes), this.writeString(e1);
            },
            writeFloatField: function(t1, e1) {
                this.writeTag(t1, pl.Fixed32), this.writeFloat(e1);
            },
            writeDoubleField: function(t1, e1) {
                this.writeTag(t1, pl.Fixed64), this.writeDouble(e1);
            },
            writeBooleanField: function(t1, e1) {
                this.writeVarintField(t1, Boolean(e1));
            }
        };
        class Ll {
            get tl() {
                return [
                    this.paddedRect.x + 1,
                    this.paddedRect.y + 1
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - 1,
                    this.paddedRect.y + this.paddedRect.h - 1
                ];
            }
            get tlbr() {
                return this.tl.concat(this.br);
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2) / this.pixelRatio,
                    (this.paddedRect.h - 2) / this.pixelRatio
                ];
            }
            constructor(t1, { pixelRatio: e1, version: r, stretchX: n, stretchY: i, content: a }){
                this.paddedRect = t1, this.pixelRatio = e1, this.stretchX = n, this.stretchY = i, this.content = a, this.version = r;
            }
        }
        class Dl {
            addImages(t1, e1, r) {
                for(const n in t1){
                    const i = t1[n], a = {
                        x: 0,
                        y: 0,
                        w: i.data.width + 2,
                        h: i.data.height + 2
                    };
                    r.push(a), e1[n] = new Ll(a, i), i.hasRenderCallback && this.haveRenderCallbacks.push(n);
                }
            }
            patchUpdatedImages(t1, e1) {
                t1.dispatchRenderCallbacks(this.haveRenderCallbacks);
                for(const r in t1.updatedImages)this.patchUpdatedImage(this.iconPositions[r], t1.getImage(r), e1), this.patchUpdatedImage(this.patternPositions[r], t1.getImage(r), e1);
            }
            patchUpdatedImage(t1, e1, r) {
                if (!t1 || !e1) return;
                if (t1.version === e1.version) return;
                t1.version = e1.version;
                const [n, i] = t1.tl;
                r.update(e1.data, void 0, {
                    x: n,
                    y: i
                });
            }
            constructor(t1, e1){
                const r = {}, n = {};
                this.haveRenderCallbacks = [];
                const i = [];
                this.addImages(t1, r, i), this.addImages(e1, n, i);
                const { w: a, h: s } = Tl(i), o = new Bs({
                    width: a || 1,
                    height: s || 1
                });
                for(const e1 in t1){
                    const n = t1[e1], i = r[e1].paddedRect;
                    Bs.copy(n.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: i.x + 1,
                        y: i.y + 1
                    }, n.data);
                }
                for(const t1 in e1){
                    const r = e1[t1], i = n[t1].paddedRect, a = i.x + 1, s = i.y + 1, l = r.data.width, u = r.data.height;
                    Bs.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: a,
                        y: s
                    }, r.data), Bs.copy(r.data, o, {
                        x: 0,
                        y: u - 1
                    }, {
                        x: a,
                        y: s - 1
                    }, {
                        width: l,
                        height: 1
                    }), Bs.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: a,
                        y: s + u
                    }, {
                        width: l,
                        height: 1
                    }), Bs.copy(r.data, o, {
                        x: l - 1,
                        y: 0
                    }, {
                        x: a - 1,
                        y: s
                    }, {
                        width: 1,
                        height: u
                    }), Bs.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: a + l,
                        y: s
                    }, {
                        width: 1,
                        height: u
                    });
                }
                this.image = o, this.iconPositions = r, this.patternPositions = n;
            }
        }
        Mn("ImagePosition", Ll), Mn("ImageAtlas", Dl), t1.WritingMode = void 0, (fl = t1.WritingMode || (t1.WritingMode = {}))[fl.none = 0] = "none", fl[fl.horizontal = 1] = "horizontal", fl[fl.vertical = 2] = "vertical", fl[fl.horizontalOnly = 3] = "horizontalOnly";
        const $l = -17;
        class Rl {
            static forText(t1, e1) {
                const r = new Rl;
                return r.scale = t1 || 1, r.fontStack = e1, r;
            }
            static forImage(t1) {
                const e1 = new Rl;
                return e1.imageName = t1, e1;
            }
            constructor(){
                this.scale = 1, this.fontStack = "", this.imageName = null;
            }
        }
        class Ol {
            static fromFeature(t1, e1) {
                const r = new Ol;
                for(let n = 0; n < t1.sections.length; n++){
                    const i = t1.sections[n];
                    i.image ? r.addImageSection(i) : r.addTextSection(i, e1);
                }
                return r;
            }
            length() {
                return this.text.length;
            }
            getSection(t1) {
                return this.sections[this.sectionIndex[t1]];
            }
            getSectionIndex(t1) {
                return this.sectionIndex[t1];
            }
            getCharCode(t1) {
                return this.text.charCodeAt(t1);
            }
            verticalizePunctuation() {
                this.text = function(t1) {
                    let e1 = "";
                    for(let r = 0; r < t1.length; r++){
                        const n = t1.charCodeAt(r + 1) || null, i = t1.charCodeAt(r - 1) || null;
                        e1 += n && Dn(n) && !ol[t1[r + 1]] || i && Dn(i) && !ol[t1[r - 1]] || !ol[t1[r]] ? t1[r] : ol[t1[r]];
                    }
                    return e1;
                }(this.text);
            }
            trim() {
                let t1 = 0;
                for(let e1 = 0; e1 < this.text.length && ql[this.text.charCodeAt(e1)]; e1++)t1++;
                let e1 = this.text.length;
                for(let r = this.text.length - 1; r >= 0 && r >= t1 && ql[this.text.charCodeAt(r)]; r--)e1--;
                this.text = this.text.substring(t1, e1), this.sectionIndex = this.sectionIndex.slice(t1, e1);
            }
            substring(t1, e1) {
                const r = new Ol;
                return r.text = this.text.substring(t1, e1), r.sectionIndex = this.sectionIndex.slice(t1, e1), r.sections = this.sections, r;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((t1, e1)=>Math.max(t1, this.sections[e1].scale), 0);
            }
            addTextSection(t1, e1) {
                this.text += t1.text, this.sections.push(Rl.forText(t1.scale, t1.fontStack || e1));
                const r = this.sections.length - 1;
                for(let e1 = 0; e1 < t1.text.length; ++e1)this.sectionIndex.push(r);
            }
            addImageSection(t1) {
                const e1 = t1.image ? t1.image.name : "";
                if (0 === e1.length) return void d("Can't add FormattedSection with an empty image.");
                const r = this.getNextImageSectionCharCode();
                r ? (this.text += String.fromCharCode(r), this.sections.push(Rl.forImage(e1)), this.sectionIndex.push(this.sections.length - 1)) : d("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
        }
        function Ul(e1, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m) {
            const g = Ol.fromFeature(e1, a);
            let x;
            p === t1.WritingMode.vertical && g.verticalizePunctuation();
            const { processBidirectionalText: v, processStyledBidirectionalText: b } = Wn;
            if (v && 1 === g.sections.length) {
                x = [];
                const t1 = v(g.toString(), Xl(g, c, s, r, i, d, y));
                for (const e1 of t1){
                    const t1 = new Ol;
                    t1.text = e1, t1.sections = g.sections;
                    for(let r = 0; r < e1.length; r++)t1.sectionIndex.push(0);
                    x.push(t1);
                }
            } else if (b) {
                x = [];
                const t1 = b(g.text, g.sectionIndex, Xl(g, c, s, r, i, d, y));
                for (const e1 of t1){
                    const t1 = new Ol;
                    t1.text = e1[0], t1.sectionIndex = e1[1], t1.sections = g.sections, x.push(t1);
                }
            } else x = function(t1, e1) {
                const r = [], n = t1.text;
                let i = 0;
                for (const n of e1)r.push(t1.substring(i, n)), i = n;
                return i < n.length && r.push(t1.substring(i, n.length)), r;
            }(g, Xl(g, c, s, r, i, d, y));
            const w = [], _ = {
                positionedLines: w,
                text: g.toString(),
                top: h[1],
                bottom: h[1],
                left: h[0],
                right: h[0],
                writingMode: p,
                iconsInText: !1,
                verticalizable: !1
            };
            return function(e1, r, n, i, a, s, o, l, u, c, h, p) {
                let f = 0, d = $l, y = 0, m = 0;
                const g = "right" === l ? 1 : "left" === l ? 0 : .5;
                let x = 0;
                for (const o of a){
                    o.trim();
                    const a = o.getMaxScale(), l = (a - 1) * ll, b = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    e1.positionedLines[x] = b;
                    const w = b.positionedGlyphs;
                    let _ = 0;
                    if (!o.length()) {
                        d += s, ++x;
                        continue;
                    }
                    for(let s = 0; s < o.length(); s++){
                        const y = o.getSection(s), m = o.getSectionIndex(s), g = o.getCharCode(s);
                        let x = 0, b = null, A = null, k = null, S = ll;
                        const I = !(u === t1.WritingMode.horizontal || !h && !Ln(g) || h && (ql[g] || (v = g, Vn.Arabic(v) || Vn["Arabic Supplement"](v) || Vn["Arabic Extended-A"](v) || Vn["Arabic Presentation Forms-A"](v) || Vn["Arabic Presentation Forms-B"](v))));
                        if (y.imageName) {
                            const t1 = i[y.imageName];
                            if (!t1) continue;
                            k = y.imageName, e1.iconsInText = e1.iconsInText || !0, A = t1.paddedRect;
                            const r = t1.displaySize;
                            y.scale = y.scale * ll / p, b = {
                                width: r[0],
                                height: r[1],
                                left: 1,
                                top: -3,
                                advance: I ? r[1] : r[0]
                            }, x = l + (ll - r[1] * y.scale), S = b.advance;
                            const n = I ? r[0] * y.scale - ll * a : r[1] * y.scale - ll * a;
                            n > 0 && n > _ && (_ = n);
                        } else {
                            const t1 = n[y.fontStack], e1 = t1 && t1[g];
                            if (e1 && e1.rect) A = e1.rect, b = e1.metrics;
                            else {
                                const t1 = r[y.fontStack], e1 = t1 && t1[g];
                                if (!e1) continue;
                                b = e1.metrics;
                            }
                            x = (a - y.scale) * ll;
                        }
                        I ? (e1.verticalizable = !0, w.push({
                            glyph: g,
                            imageName: k,
                            x: f,
                            y: d + x,
                            vertical: I,
                            scale: y.scale,
                            fontStack: y.fontStack,
                            sectionIndex: m,
                            metrics: b,
                            rect: A
                        }), f += S * y.scale + c) : (w.push({
                            glyph: g,
                            imageName: k,
                            x: f,
                            y: d + x,
                            vertical: I,
                            scale: y.scale,
                            fontStack: y.fontStack,
                            sectionIndex: m,
                            metrics: b,
                            rect: A
                        }), f += b.advance * y.scale + c);
                    }
                    0 !== w.length && (y = Math.max(f - c, y), Hl(w, 0, w.length - 1, g, _)), f = 0;
                    const A = s * a + _;
                    b.lineOffset = Math.max(_, l), d += A, m = Math.max(A, m), ++x;
                }
                var v;
                const b = d - $l, { horizontalAlign: w, verticalAlign: _ } = Yl(o);
                (function(t1, e1, r, n, i, a, s, o, l) {
                    const u = (e1 - r) * i;
                    let c = 0;
                    c = a !== s ? -o * n - $l : (-n * l + .5) * s;
                    for (const e1 of t1)for (const t1 of e1.positionedGlyphs)t1.x += u, t1.y += c;
                })(e1.positionedLines, g, w, _, y, m, s, b, a.length), e1.top += -_ * b, e1.bottom = e1.top + b, e1.left += -w * y, e1.right = e1.left + y;
            }(_, r, n, i, x, o, l, u, p, c, f, m), !function(t1) {
                for (const e1 of t1)if (0 !== e1.positionedGlyphs.length) return !1;
                return !0;
            }(w) && _;
        }
        const ql = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, jl = {
            10: !0,
            32: !0,
            38: !0,
            40: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        };
        function Nl(t1, e1, r, n, i, a) {
            if (e1.imageName) {
                const t1 = n[e1.imageName];
                return t1 ? t1.displaySize[0] * e1.scale * ll / a + i : 0;
            }
            {
                const n = r[e1.fontStack], a = n && n[t1];
                return a ? a.metrics.advance * e1.scale + i : 0;
            }
        }
        function Zl(t1, e1, r, n) {
            const i = Math.pow(t1 - e1, 2);
            return n ? t1 < e1 ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function Kl(t1, e1, r) {
            let n = 0;
            return 10 === t1 && (n -= 1e4), r && (n += 150), 40 !== t1 && 65288 !== t1 || (n += 50), 41 !== e1 && 65289 !== e1 || (n += 50), n;
        }
        function Gl(t1, e1, r, n, i, a) {
            let s = null, o = Zl(e1, r, i, a);
            for (const t1 of n){
                const n = Zl(e1 - t1.x, r, i, a) + t1.badness;
                n <= o && (s = t1, o = n);
            }
            return {
                index: t1,
                x: e1,
                priorBreak: s,
                badness: o
            };
        }
        function Jl(t1) {
            return t1 ? Jl(t1.priorBreak).concat(t1.index) : [];
        }
        function Xl(t1, e1, r, n, i, a, s) {
            if ("point" !== a) return [];
            if (!t1) return [];
            const o = [], l = function(t1, e1, r, n, i, a) {
                let s = 0;
                for(let r = 0; r < t1.length(); r++){
                    const o = t1.getSection(r);
                    s += Nl(t1.getCharCode(r), o, n, i, e1, a);
                }
                return s / Math.max(1, Math.ceil(s / r));
            }(t1, e1, r, n, i, s), u = t1.text.indexOf("\u200B") >= 0;
            let c = 0;
            for(let r = 0; r < t1.length(); r++){
                const a = t1.getSection(r), p = t1.getCharCode(r);
                if (ql[p] || (c += Nl(p, a, n, i, e1, s)), r < t1.length() - 1) {
                    const e1 = !((h = p) < 11904 || !(Vn["Bopomofo Extended"](h) || Vn.Bopomofo(h) || Vn["CJK Compatibility Forms"](h) || Vn["CJK Compatibility Ideographs"](h) || Vn["CJK Compatibility"](h) || Vn["CJK Radicals Supplement"](h) || Vn["CJK Strokes"](h) || Vn["CJK Symbols and Punctuation"](h) || Vn["CJK Unified Ideographs Extension A"](h) || Vn["CJK Unified Ideographs"](h) || Vn["Enclosed CJK Letters and Months"](h) || Vn["Halfwidth and Fullwidth Forms"](h) || Vn.Hiragana(h) || Vn["Ideographic Description Characters"](h) || Vn["Kangxi Radicals"](h) || Vn["Katakana Phonetic Extensions"](h) || Vn.Katakana(h) || Vn["Vertical Forms"](h) || Vn["Yi Radicals"](h) || Vn["Yi Syllables"](h)));
                    (jl[p] || e1 || a.imageName) && o.push(Gl(r + 1, c, l, o, Kl(p, t1.getCharCode(r + 1), e1 && u), !1));
                }
            }
            var h;
            return Jl(Gl(t1.length(), c, l, o, 0, !0));
        }
        function Yl(t1) {
            let e1 = .5, r = .5;
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    e1 = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    e1 = 0;
            }
            switch(t1){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    r = 0;
            }
            return {
                horizontalAlign: e1,
                verticalAlign: r
            };
        }
        function Hl(t1, e1, r, n, i) {
            if (!n && !i) return;
            const a = t1[r], s = (t1[r].x + a.metrics.advance * a.scale) * n;
            for(let n = e1; n <= r; n++)t1[n].x -= s, t1[n].y += i;
        }
        function Wl(t1, e1, r) {
            const { horizontalAlign: n, verticalAlign: i } = Yl(r), a = e1[0] - t1.displaySize[0] * n, s = e1[1] - t1.displaySize[1] * i;
            return {
                image: t1,
                top: s,
                bottom: s + t1.displaySize[1],
                left: a,
                right: a + t1.displaySize[0]
            };
        }
        function Ql(t1, e1, r, n, i, a) {
            const s = t1.image;
            let o;
            if (s.content) {
                const t1 = s.content, e1 = s.pixelRatio || 1;
                o = [
                    t1[0] / e1,
                    t1[1] / e1,
                    s.displaySize[0] - t1[2] / e1,
                    s.displaySize[1] - t1[3] / e1
                ];
            }
            const l = e1.left * a, u = e1.right * a;
            let c, h, p, f;
            "width" === r || "both" === r ? (f = i[0] + l - n[3], h = i[0] + u + n[1]) : (f = i[0] + (l + u - s.displaySize[0]) / 2, h = f + s.displaySize[0]);
            const d = e1.top * a, y = e1.bottom * a;
            return "height" === r || "both" === r ? (c = i[1] + d - n[0], p = i[1] + y + n[2]) : (c = i[1] + (d + y - s.displaySize[1]) / 2, p = c + s.displaySize[1]), {
                image: s,
                top: c,
                right: h,
                bottom: p,
                left: f,
                collisionPadding: o
            };
        }
        const tu = 128;
        function eu(t1, e1) {
            const { expression: r } = e1;
            if ("constant" === r.kind) return {
                kind: "constant",
                layoutSize: r.evaluate(new Qn(t1 + 1))
            };
            if ("source" === r.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: e1, interpolationType: n } = r;
                let i = 0;
                for(; i < e1.length && e1[i] <= t1;)i++;
                i = Math.max(0, i - 1);
                let a = i;
                for(; a < e1.length && e1[a] < t1 + 1;)a++;
                a = Math.min(e1.length - 1, a);
                const s = e1[i], o = e1[a];
                return "composite" === r.kind ? {
                    kind: "composite",
                    minZoom: s,
                    maxZoom: o,
                    interpolationType: n
                } : {
                    kind: "camera",
                    minZoom: s,
                    maxZoom: o,
                    minSize: r.evaluate(new Qn(s)),
                    maxSize: r.evaluate(new Qn(o)),
                    interpolationType: n
                };
            }
        }
        class ru extends S {
            clone() {
                return new ru(this.x, this.y, this.angle, this.segment);
            }
            constructor(t1, e1, r, n){
                super(t1, e1), this.angle = r, void 0 !== n && (this.segment = n);
            }
        }
        function nu(t1, e1, r, n, i) {
            if (void 0 === e1.segment) return !0;
            let a = e1, s = e1.segment + 1, o = 0;
            for(; o > -r / 2;){
                if (s--, s < 0) return !1;
                o -= t1[s].dist(a), a = t1[s];
            }
            o += t1[s].dist(t1[s + 1]), s++;
            const l = [];
            let u = 0;
            for(; o < r / 2;){
                const e1 = t1[s], r = t1[s + 1];
                if (!r) return !1;
                let a = t1[s - 1].angleTo(e1) - e1.angleTo(r);
                for(a = Math.abs((a + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: o,
                    angleDelta: a
                }), u += a; o - l[0].distance > n;)u -= l.shift().angleDelta;
                if (u > i) return !1;
                s++, o += e1.dist(r);
            }
            return !0;
        }
        function iu(t1) {
            let e1 = 0;
            for(let r = 0; r < t1.length - 1; r++)e1 += t1[r].dist(t1[r + 1]);
            return e1;
        }
        function au(t1, e1, r) {
            return t1 ? .6 * e1 * r : 0;
        }
        function su(t1, e1) {
            return Math.max(t1 ? t1.right - t1.left : 0, e1 ? e1.right - e1.left : 0);
        }
        function ou(t1, e1, r, n, i, a) {
            const s = au(r, i, a), o = su(r, n) * a;
            let l = 0;
            const u = iu(t1) / 2;
            for(let r = 0; r < t1.length - 1; r++){
                const n = t1[r], i = t1[r + 1], a = n.dist(i);
                if (l + a > u) {
                    const c = (u - l) / a, h = Se(n.x, i.x, c), p = Se(n.y, i.y, c), f = new ru(h, p, i.angleTo(n), r);
                    return f._round(), !s || nu(t1, f, o, s, e1) ? f : void 0;
                }
                l += a;
            }
        }
        function lu(t1, e1, r, n, i, a, s, o, l) {
            const u = au(n, a, s), c = su(n, i), h = c * s, p = 0 === t1[0].x || t1[0].x === l || 0 === t1[0].y || t1[0].y === l;
            return e1 - h < e1 / 4 && (e1 = h + e1 / 4), uu(t1, p ? e1 / 2 * o % e1 : (c / 2 + 2 * a) * s * o % e1, e1, u, r, h, p, !1, l);
        }
        function uu(t1, e1, r, n, i, a, s, o, l) {
            const u = a / 2, c = iu(t1);
            let h = 0, p = e1 - r, f = [];
            for(let e1 = 0; e1 < t1.length - 1; e1++){
                const s = t1[e1], o = t1[e1 + 1], d = s.dist(o), y = o.angleTo(s);
                for(; p + r < h + d;){
                    p += r;
                    const m = (p - h) / d, g = Se(s.x, o.x, m), x = Se(s.y, o.y, m);
                    if (g >= 0 && g < l && x >= 0 && x < l && p - u >= 0 && p + u <= c) {
                        const r = new ru(g, x, y, e1);
                        r._round(), n && !nu(t1, r, a, n, i) || f.push(r);
                    }
                }
                h += d;
            }
            return o || f.length || s || (f = uu(t1, h / 2, r, n, i, a, s, !0, l)), f;
        }
        function cu(t1, e1, r, n, i) {
            const a = [];
            for(let s = 0; s < t1.length; s++){
                const o = t1[s];
                let l;
                for(let t1 = 0; t1 < o.length - 1; t1++){
                    let s = o[t1], u = o[t1 + 1];
                    s.x < e1 && u.x < e1 || (s.x < e1 ? s = new S(e1, s.y + (e1 - s.x) / (u.x - s.x) * (u.y - s.y))._round() : u.x < e1 && (u = new S(e1, s.y + (e1 - s.x) / (u.x - s.x) * (u.y - s.y))._round()), s.y < r && u.y < r || (s.y < r ? s = new S(s.x + (r - s.y) / (u.y - s.y) * (u.x - s.x), r)._round() : u.y < r && (u = new S(s.x + (r - s.y) / (u.y - s.y) * (u.x - s.x), r)._round()), s.x >= n && u.x >= n || (s.x >= n ? s = new S(n, s.y + (n - s.x) / (u.x - s.x) * (u.y - s.y))._round() : u.x >= n && (u = new S(n, s.y + (n - s.x) / (u.x - s.x) * (u.y - s.y))._round()), s.y >= i && u.y >= i || (s.y >= i ? s = new S(s.x + (i - s.y) / (u.y - s.y) * (u.x - s.x), i)._round() : u.y >= i && (u = new S(s.x + (i - s.y) / (u.y - s.y) * (u.x - s.x), i)._round()), l && s.equals(l[l.length - 1]) || (l = [
                        s
                    ], a.push(l)), l.push(u)))));
                }
            }
            return a;
        }
        function hu(t1, e1, r, n) {
            const i = [], a = t1.image, s = a.pixelRatio, o = a.paddedRect.w - 2, l = a.paddedRect.h - 2, u = t1.right - t1.left, c = t1.bottom - t1.top, h = a.stretchX || [
                [
                    0,
                    o
                ]
            ], p = a.stretchY || [
                [
                    0,
                    l
                ]
            ], f = (t1, e1)=>t1 + e1[1] - e1[0], d = h.reduce(f, 0), y = p.reduce(f, 0), m = o - d, g = l - y;
            let x = 0, v = d, b = 0, w = y, _ = 0, A = m, k = 0, I = g;
            if (a.content && n) {
                const t1 = a.content;
                x = pu(h, 0, t1[0]), b = pu(p, 0, t1[1]), v = pu(h, t1[0], t1[2]), w = pu(p, t1[1], t1[3]), _ = t1[0] - x, k = t1[1] - b, A = t1[2] - t1[0] - v, I = t1[3] - t1[1] - w;
            }
            const M = (n, i, o, l)=>{
                const h = du(n.stretch - x, v, u, t1.left), p = yu(n.fixed - _, A, n.stretch, d), f = du(i.stretch - b, w, c, t1.top), m = yu(i.fixed - k, I, i.stretch, y), g = du(o.stretch - x, v, u, t1.left), M = yu(o.fixed - _, A, o.stretch, d), z = du(l.stretch - b, w, c, t1.top), B = yu(l.fixed - k, I, l.stretch, y), C = new S(h, f), P = new S(g, f), V = new S(g, z), E = new S(h, z), F = new S(p / s, m / s), T = new S(M / s, B / s), L = e1 * Math.PI / 180;
                if (L) {
                    const t1 = Math.sin(L), e1 = Math.cos(L), r = [
                        e1,
                        -t1,
                        t1,
                        e1
                    ];
                    C._matMult(r), P._matMult(r), E._matMult(r), V._matMult(r);
                }
                const D = n.stretch + n.fixed, $ = i.stretch + i.fixed;
                return {
                    tl: C,
                    tr: P,
                    bl: E,
                    br: V,
                    tex: {
                        x: a.paddedRect.x + 1 + D,
                        y: a.paddedRect.y + 1 + $,
                        w: o.stretch + o.fixed - D,
                        h: l.stretch + l.fixed - $
                    },
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: F,
                    pixelOffsetBR: T,
                    minFontScaleX: A / s / u,
                    minFontScaleY: I / s / c,
                    isSDF: r
                };
            };
            if (n && (a.stretchX || a.stretchY)) {
                const t1 = fu(h, m, d), e1 = fu(p, g, y);
                for(let r = 0; r < t1.length - 1; r++){
                    const n = t1[r], a = t1[r + 1];
                    for(let t1 = 0; t1 < e1.length - 1; t1++)i.push(M(n, e1[t1], a, e1[t1 + 1]));
                }
            } else i.push(M({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: o + 1
            }, {
                fixed: 0,
                stretch: l + 1
            }));
            return i;
        }
        function pu(t1, e1, r) {
            let n = 0;
            for (const i of t1)n += Math.max(e1, Math.min(r, i[1])) - Math.max(e1, Math.min(r, i[0]));
            return n;
        }
        function fu(t1, e1, r) {
            const n = [
                {
                    fixed: -1,
                    stretch: 0
                }
            ];
            for (const [e1, r] of t1){
                const t1 = n[n.length - 1];
                n.push({
                    fixed: e1 - t1.stretch,
                    stretch: t1.stretch
                }), n.push({
                    fixed: e1 - t1.stretch,
                    stretch: t1.stretch + (r - e1)
                });
            }
            return n.push({
                fixed: e1 + 1,
                stretch: r
            }), n;
        }
        function du(t1, e1, r, n) {
            return t1 / e1 * r + n;
        }
        function yu(t1, e1, r, n) {
            return t1 - e1 * r / n;
        }
        Mn("Anchor", ru);
        class mu {
            constructor(t1, e1, r, n, i, a, s, o, l, u){
                if (this.boxStartIndex = t1.length, l) {
                    let t1 = a.top, e1 = a.bottom;
                    const r = a.collisionPadding;
                    r && (t1 -= r[1], e1 += r[3]);
                    let n = e1 - t1;
                    n > 0 && (n = Math.max(10, n), this.circleDiameter = n);
                } else {
                    let l = a.top * s - o[0], c = a.bottom * s + o[2], h = a.left * s - o[3], p = a.right * s + o[1];
                    const f = a.collisionPadding;
                    if (f && (h -= f[0] * s, l -= f[1] * s, p += f[2] * s, c += f[3] * s), u) {
                        const t1 = new S(h, l), e1 = new S(p, l), r = new S(h, c), n = new S(p, c), i = u * Math.PI / 180;
                        t1._rotate(i), e1._rotate(i), r._rotate(i), n._rotate(i), h = Math.min(t1.x, e1.x, r.x, n.x), p = Math.max(t1.x, e1.x, r.x, n.x), l = Math.min(t1.y, e1.y, r.y, n.y), c = Math.max(t1.y, e1.y, r.y, n.y);
                    }
                    t1.emplaceBack(e1.x, e1.y, h, l, p, c, r, n, i);
                }
                this.boxEndIndex = t1.length;
            }
        }
        class gu {
            push(t1) {
                this.data.push(t1), this.length++, this._up(this.length - 1);
            }
            pop() {
                if (0 === this.length) return;
                const t1 = this.data[0], e1 = this.data.pop();
                return this.length--, this.length > 0 && (this.data[0] = e1, this._down(0)), t1;
            }
            peek() {
                return this.data[0];
            }
            _up(t1) {
                const { data: e1, compare: r } = this, n = e1[t1];
                for(; t1 > 0;){
                    const i = t1 - 1 >> 1, a = e1[i];
                    if (r(n, a) >= 0) break;
                    e1[t1] = a, t1 = i;
                }
                e1[t1] = n;
            }
            _down(t1) {
                const { data: e1, compare: r } = this, n = this.length >> 1, i = e1[t1];
                for(; t1 < n;){
                    let n = 1 + (t1 << 1), a = e1[n];
                    const s = n + 1;
                    if (s < this.length && r(e1[s], a) < 0 && (n = s, a = e1[s]), r(a, i) >= 0) break;
                    e1[t1] = a, t1 = n;
                }
                e1[t1] = i;
            }
            constructor(t1 = [], e1 = xu){
                if (this.data = t1, this.length = this.data.length, this.compare = e1, this.length > 0) for(let t1 = (this.length >> 1) - 1; t1 >= 0; t1--)this._down(t1);
            }
        }
        function xu(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function vu(t1, e1 = 1, r = !1) {
            let n = 1 / 0, i = 1 / 0, a = -1 / 0, s = -1 / 0;
            const o = t1[0];
            for(let t1 = 0; t1 < o.length; t1++){
                const e1 = o[t1];
                (!t1 || e1.x < n) && (n = e1.x), (!t1 || e1.y < i) && (i = e1.y), (!t1 || e1.x > a) && (a = e1.x), (!t1 || e1.y > s) && (s = e1.y);
            }
            const l = Math.min(a - n, s - i);
            let u = l / 2;
            const c = new gu([], bu);
            if (0 === l) return new S(n, i);
            for(let e1 = n; e1 < a; e1 += l)for(let r = i; r < s; r += l)c.push(new wu(e1 + u, r + u, u, t1));
            let h = function(t1) {
                let e1 = 0, r = 0, n = 0;
                const i = t1[0];
                for(let t1 = 0, a = i.length, s = a - 1; t1 < a; s = t1++){
                    const a = i[t1], o = i[s], l = a.x * o.y - o.x * a.y;
                    r += (a.x + o.x) * l, n += (a.y + o.y) * l, e1 += 3 * l;
                }
                return new wu(r / e1, n / e1, 0, t1);
            }(t1), p = c.length;
            for(; c.length;){
                const n = c.pop();
                (n.d > h.d || !h.d) && (h = n, r && console.log("found best %d after %d probes", Math.round(1e4 * n.d) / 1e4, p)), n.max - h.d <= e1 || (u = n.h / 2, c.push(new wu(n.p.x - u, n.p.y - u, u, t1)), c.push(new wu(n.p.x + u, n.p.y - u, u, t1)), c.push(new wu(n.p.x - u, n.p.y + u, u, t1)), c.push(new wu(n.p.x + u, n.p.y + u, u, t1)), p += 4);
            }
            return r && (console.log(`num probes: ${p}`), console.log(`best distance: ${h.d}`)), h.p;
        }
        function bu(t1, e1) {
            return e1.max - t1.max;
        }
        function wu(t1, e1, r, n) {
            this.p = new S(t1, e1), this.h = r, this.d = function(t1, e1) {
                let r = !1, n = 1 / 0;
                for(let i = 0; i < e1.length; i++){
                    const a = e1[i];
                    for(let e1 = 0, i = a.length, s = i - 1; e1 < i; s = e1++){
                        const i = a[e1], o = a[s];
                        i.y > t1.y != o.y > t1.y && t1.x < (o.x - i.x) * (t1.y - i.y) / (o.y - i.y) + i.x && (r = !r), n = Math.min(n, rs(t1, i, o));
                    }
                }
                return (r ? 1 : -1) * Math.sqrt(n);
            }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
        }
        const _u = Number.POSITIVE_INFINITY;
        function Au(t1, e1) {
            return e1[1] !== _u ? function(t1, e1, r) {
                let n = 0, i = 0;
                switch(e1 = Math.abs(e1), r = Math.abs(r), t1){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = 7 - r;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -e1;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = e1;
                }
                return [
                    n,
                    i
                ];
            }(t1, e1[0], e1[1]) : function(t1, e1) {
                let r = 0, n = 0;
                e1 < 0 && (e1 = 0);
                const i = e1 / Math.sqrt(2);
                switch(t1){
                    case "top-right":
                    case "top-left":
                        n = i - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        n = 7 - i;
                        break;
                    case "bottom":
                        n = 7 - e1;
                        break;
                    case "top":
                        n = e1 - 7;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                        r = -i;
                        break;
                    case "top-left":
                    case "bottom-left":
                        r = i;
                        break;
                    case "left":
                        r = e1;
                        break;
                    case "right":
                        r = -e1;
                }
                return [
                    r,
                    n
                ];
            }(t1, e1[0]);
        }
        function ku(t1) {
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function Su(e1, r, n, i, a, s, o, l, u, c, h) {
            let p = s.textMaxSize.evaluate(r, {});
            void 0 === p && (p = o);
            const f = e1.layers[0].layout, y = f.get("icon-offset").evaluate(r, {}, h), m = zu(n.horizontal), g = o / 24, x = e1.tilePixelRatio * g, v = e1.tilePixelRatio * p / 24, b = e1.tilePixelRatio * l, w = e1.tilePixelRatio * f.get("symbol-spacing"), _ = f.get("text-padding") * e1.tilePixelRatio, A = function(t1, e1, r, n = 1) {
                const i = t1.get("icon-padding").evaluate(e1, {}, r), a = i && i.values;
                return [
                    a[0] * n,
                    a[1] * n,
                    a[2] * n,
                    a[3] * n
                ];
            }(f, r, h, e1.tilePixelRatio), k = f.get("text-max-angle") / 180 * Math.PI, S = "viewport" !== f.get("text-rotation-alignment") && "point" !== f.get("symbol-placement"), I = "map" === f.get("icon-rotation-alignment") && "point" !== f.get("symbol-placement"), M = f.get("symbol-placement"), z = w / 2, B = f.get("icon-text-fit");
            let C;
            i && "none" !== B && (e1.allowVerticalPlacement && n.vertical && (C = Ql(i, n.vertical, B, f.get("icon-text-fit-padding"), y, g)), m && (i = Ql(i, m, B, f.get("icon-text-fit-padding"), y, g)));
            const P = (l, p)=>{
                p.x < 0 || p.x >= qa || p.y < 0 || p.y >= qa || function(e1, r, n, i, a, s, o, l, u, c, h, p, f, y, m, g, x, v, b, w, _, A, k, S, I) {
                    const M = e1.addToLineVertexArray(r, n);
                    let z, B, C, P, V = 0, E = 0, F = 0, T = 0, L = -1, D = -1;
                    const $ = {};
                    let R = xa.exports(""), O = 0, U = 0;
                    if (void 0 === l._unevaluatedLayout.getValue("text-radial-offset") ? [O, U] = l.layout.get("text-offset").evaluate(_, {}, S).map((t1)=>t1 * ll) : (O = l.layout.get("text-radial-offset").evaluate(_, {}, S) * ll, U = _u), e1.allowVerticalPlacement && i.vertical) {
                        const t1 = l.layout.get("text-rotate").evaluate(_, {}, S) + 90;
                        C = new mu(u, r, c, h, p, i.vertical, f, y, m, t1), o && (P = new mu(u, r, c, h, p, o, x, v, m, t1));
                    }
                    if (a) {
                        const n = l.layout.get("icon-rotate").evaluate(_, {}), i = "none" !== l.layout.get("icon-text-fit"), s = hu(a, n, k, i), f = o ? hu(o, n, k, i) : void 0;
                        B = new mu(u, r, c, h, p, a, x, v, !1, n), V = 4 * s.length;
                        const y = e1.iconSizeData;
                        let m = null;
                        "source" === y.kind ? (m = [
                            tu * l.layout.get("icon-size").evaluate(_, {})
                        ], m[0] > Iu && d(`${e1.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)) : "composite" === y.kind && (m = [
                            tu * A.compositeIconSizes[0].evaluate(_, {}, S),
                            tu * A.compositeIconSizes[1].evaluate(_, {}, S)
                        ], (m[0] > Iu || m[1] > Iu) && d(`${e1.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)), e1.addSymbols(e1.icon, s, m, w, b, _, t1.WritingMode.none, r, M.lineStartIndex, M.lineLength, -1, S), L = e1.icon.placedSymbolArray.length - 1, f && (E = 4 * f.length, e1.addSymbols(e1.icon, f, m, w, b, _, t1.WritingMode.vertical, r, M.lineStartIndex, M.lineLength, -1, S), D = e1.icon.placedSymbolArray.length - 1);
                    }
                    const q = Object.keys(i.horizontal);
                    for (const n of q){
                        const a = i.horizontal[n];
                        if (!z) {
                            R = xa.exports(a.text);
                            const t1 = l.layout.get("text-rotate").evaluate(_, {}, S);
                            z = new mu(u, r, c, h, p, a, f, y, m, t1);
                        }
                        const o = 1 === a.positionedLines.length;
                        if (F += Mu(e1, r, a, s, l, m, _, g, M, i.vertical ? t1.WritingMode.horizontal : t1.WritingMode.horizontalOnly, o ? q : [
                            n
                        ], $, L, A, S), o) break;
                    }
                    i.vertical && (T += Mu(e1, r, i.vertical, s, l, m, _, g, M, t1.WritingMode.vertical, [
                        "vertical"
                    ], $, D, A, S));
                    const j = z ? z.boxStartIndex : e1.collisionBoxArray.length, N = z ? z.boxEndIndex : e1.collisionBoxArray.length, Z = C ? C.boxStartIndex : e1.collisionBoxArray.length, K = C ? C.boxEndIndex : e1.collisionBoxArray.length, G = B ? B.boxStartIndex : e1.collisionBoxArray.length, J = B ? B.boxEndIndex : e1.collisionBoxArray.length, X = P ? P.boxStartIndex : e1.collisionBoxArray.length, Y = P ? P.boxEndIndex : e1.collisionBoxArray.length;
                    let H = -1;
                    const W = (t1, e1)=>t1 && t1.circleDiameter ? Math.max(t1.circleDiameter, e1) : e1;
                    H = W(z, H), H = W(C, H), H = W(B, H), H = W(P, H);
                    const Q = H > -1 ? 1 : 0;
                    Q && (H *= I / ll), e1.glyphOffsetArray.length >= Du.MAX_GLYPHS && d("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== _.sortKey && e1.addToSortKeyRanges(e1.symbolInstances.length, _.sortKey), e1.symbolInstances.emplaceBack(r.x, r.y, $.right >= 0 ? $.right : -1, $.center >= 0 ? $.center : -1, $.left >= 0 ? $.left : -1, $.vertical || -1, L, D, R, j, N, Z, K, G, J, X, Y, c, F, T, V, E, Q, 0, f, O, U, H);
                }(e1, p, l, n, i, a, C, e1.layers[0], e1.collisionBoxArray, r.index, r.sourceLayerIndex, e1.index, x, [
                    _,
                    _,
                    _,
                    _
                ], S, u, b, A, I, y, r, s, c, h, o);
            };
            if ("line" === M) for (const t1 of cu(r.geometry, 0, 0, qa, qa)){
                const r = lu(t1, w, k, n.vertical || m, i, 24, v, e1.overscaling, qa);
                for (const n of r){
                    const r = m;
                    r && Bu(e1, r.text, z, n) || P(t1, n);
                }
            }
            else if ("line-center" === M) {
                for (const t1 of r.geometry)if (t1.length > 1) {
                    const e1 = ou(t1, k, n.vertical || m, i, 24, v);
                    e1 && P(t1, e1);
                }
            } else if ("Polygon" === r.type) for (const t1 of ho(r.geometry, 0)){
                const e1 = vu(t1, 16);
                P(t1[0], new ru(e1.x, e1.y, 0));
            }
            else if ("LineString" === r.type) for (const t1 of r.geometry)P(t1, new ru(t1[0].x, t1[0].y, 0));
            else if ("Point" === r.type) for (const t1 of r.geometry)for (const e1 of t1)P([
                e1
            ], new ru(e1.x, e1.y, 0));
        }
        const Iu = 32640;
        function Mu(t1, e1, r, n, i, a, s, o, l, u, c, h, p, f, y) {
            const m = function(t1, e1, r, n, i, a, s, o) {
                const l = n.layout.get("text-rotate").evaluate(a, {}) * Math.PI / 180, u = [];
                for (const t1 of e1.positionedLines)for (const n of t1.positionedGlyphs){
                    if (!n.rect) continue;
                    const a = n.rect || {};
                    let c = 4, h = !0, p = 1, f = 0;
                    const d = (i || o) && n.vertical, y = n.metrics.advance * n.scale / 2;
                    if (o && e1.verticalizable) {
                        const e1 = (n.scale - 1) * ll, r = (ll - n.metrics.width * n.scale) / 2;
                        f = t1.lineOffset / 2 - (n.imageName ? -r : e1);
                    }
                    if (n.imageName) {
                        const t1 = s[n.imageName];
                        h = t1.sdf, p = t1.pixelRatio, c = 1 / p;
                    }
                    const m = i ? [
                        n.x + y,
                        n.y
                    ] : [
                        0,
                        0
                    ];
                    let g = i ? [
                        0,
                        0
                    ] : [
                        n.x + y + r[0],
                        n.y + r[1] - f
                    ], x = [
                        0,
                        0
                    ];
                    d && (x = g, g = [
                        0,
                        0
                    ]);
                    const v = (n.metrics.left - c) * n.scale - y + g[0], b = (-n.metrics.top - c) * n.scale + g[1], w = v + a.w * n.scale / p, _ = b + a.h * n.scale / p, A = new S(v, b), k = new S(w, b), I = new S(v, _), M = new S(w, _);
                    if (d) {
                        const t1 = new S(-y, y - $l), e1 = -Math.PI / 2, r = 12 - y, i = new S(22 - r, -(n.imageName ? r : 0)), a = new S(...x);
                        A._rotateAround(e1, t1)._add(i)._add(a), k._rotateAround(e1, t1)._add(i)._add(a), I._rotateAround(e1, t1)._add(i)._add(a), M._rotateAround(e1, t1)._add(i)._add(a);
                    }
                    if (l) {
                        const t1 = Math.sin(l), e1 = Math.cos(l), r = [
                            e1,
                            -t1,
                            t1,
                            e1
                        ];
                        A._matMult(r), k._matMult(r), I._matMult(r), M._matMult(r);
                    }
                    const z = new S(0, 0), B = new S(0, 0);
                    u.push({
                        tl: A,
                        tr: k,
                        bl: I,
                        br: M,
                        tex: a,
                        writingMode: e1.writingMode,
                        glyphOffset: m,
                        sectionIndex: n.sectionIndex,
                        isSDF: h,
                        pixelOffsetTL: z,
                        pixelOffsetBR: B,
                        minFontScaleX: 0,
                        minFontScaleY: 0
                    });
                }
                return u;
            }(0, r, o, i, a, s, n, t1.allowVerticalPlacement), g = t1.textSizeData;
            let x = null;
            "source" === g.kind ? (x = [
                tu * i.layout.get("text-size").evaluate(s, {})
            ], x[0] > Iu && d(`${t1.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)) : "composite" === g.kind && (x = [
                tu * f.compositeTextSizes[0].evaluate(s, {}, y),
                tu * f.compositeTextSizes[1].evaluate(s, {}, y)
            ], (x[0] > Iu || x[1] > Iu) && d(`${t1.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)), t1.addSymbols(t1.text, m, x, o, a, s, u, e1, l.lineStartIndex, l.lineLength, p, y);
            for (const e1 of c)h[e1] = t1.text.placedSymbolArray.length - 1;
            return 4 * m.length;
        }
        function zu(t1) {
            for(const e1 in t1)return t1[e1];
            return null;
        }
        function Bu(t1, e1, r, n) {
            const i = t1.compareText;
            if (e1 in i) {
                const t1 = i[e1];
                for(let e1 = t1.length - 1; e1 >= 0; e1--)if (n.dist(t1[e1]) < r) return !0;
            } else i[e1] = [];
            return i[e1].push(n), !1;
        }
        const Cu = _o.VectorTileFeature.types, Pu = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function Vu(t1, e1, r, n, i, a, s, o, l, u, c, h, p) {
            const f = o ? Math.min(Iu, Math.round(o[0])) : 0, d = o ? Math.min(Iu, Math.round(o[1])) : 0;
            t1.emplaceBack(e1, r, Math.round(32 * n), Math.round(32 * i), a, s, (f << 1) + (l ? 1 : 0), d, 16 * u, 16 * c, 256 * h, 256 * p);
        }
        function Eu(t1, e1, r) {
            t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r);
        }
        function Fu(t1) {
            for (const e1 of t1.sections)if (On(e1.text)) return !0;
            return !1;
        }
        class Tu {
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
            }
            upload(t1, e1, r, n) {
                this.isEmpty() || (r && (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, el.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray, e1), this.dynamicLayoutVertexBuffer = t1.createVertexBuffer(this.dynamicLayoutVertexArray, rl.members, !0), this.opacityVertexBuffer = t1.createVertexBuffer(this.opacityVertexArray, Pu, !0), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t1));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
            }
            constructor(t1){
                this.layoutVertexArray = new sa, this.indexArray = new ha, this.programConfigurations = t1, this.segments = new ya, this.dynamicLayoutVertexArray = new oa, this.opacityVertexArray = new la, this.placedSymbolArray = new Ki;
            }
        }
        Mn("SymbolBuffers", Tu);
        class Lu {
            upload(t1) {
                this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t1.createVertexBuffer(this.collisionVertexArray, nl.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
            }
            constructor(t1, e1, r){
                this.layoutVertexArray = new t1, this.layoutAttributes = e1, this.indexArray = new r, this.segments = new ya, this.collisionVertexArray = new ca;
            }
        }
        Mn("CollisionBuffers", Lu);
        class Du {
            createArrays() {
                this.text = new Tu(new Ra(this.layers, this.zoom, (t1)=>/^text/.test(t1))), this.icon = new Tu(new Ra(this.layers, this.zoom, (t1)=>/^icon/.test(t1))), this.glyphOffsetArray = new Xi, this.lineVertexArray = new Yi, this.symbolInstances = new Ji;
            }
            calculateGlyphDependencies(t1, e1, r, n, i) {
                for(let a = 0; a < t1.length; a++)if (e1[t1.charCodeAt(a)] = !0, (r || n) && i) {
                    const r = ol[t1.charAt(a)];
                    r && (e1[r.charCodeAt(0)] = !0);
                }
            }
            populate(e1, r, n) {
                const i = this.layers[0], a = i.layout, s = a.get("text-font"), o = a.get("text-field"), l = a.get("icon-image"), u = ("constant" !== o.value.kind || o.value.value instanceof Dt && !o.value.value.isEmpty() || o.value.value.toString().length > 0) && ("constant" !== s.value.kind || s.value.value.length > 0), c = "constant" !== l.value.kind || !!l.value.value || Object.keys(l.parameters).length > 0, h = a.get("symbol-sort-key");
                if (this.features = [], !u && !c) return;
                const p = r.iconDependencies, f = r.glyphDependencies, d = r.availableImages, y = new Qn(this.zoom);
                for (const { feature: r, id: o, index: l, sourceLayerIndex: m } of e1){
                    const e1 = i._featureFilter.needGeometry, g = Ka(r, e1);
                    if (!i._featureFilter.filter(y, g, n)) continue;
                    let x, v;
                    if (e1 || (g.geometry = Za(r)), u) {
                        const t1 = i.getValueAndResolveTokens("text-field", g, n, d), e1 = Dt.factory(t1);
                        Fu(e1) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === Yn() || this.hasRTLText && Wn.isParsed()) && (x = sl(e1, i, g));
                    }
                    if (c) {
                        const t1 = i.getValueAndResolveTokens("icon-image", g, n, d);
                        v = t1 instanceof Rt ? t1 : Rt.fromString(t1);
                    }
                    if (!x && !v) continue;
                    const b = this.sortFeaturesByKey ? h.evaluate(g, {}, n) : void 0;
                    if (this.features.push({
                        id: o,
                        text: x,
                        icon: v,
                        index: l,
                        sourceLayerIndex: m,
                        geometry: g.geometry,
                        properties: r.properties,
                        type: Cu[r.type],
                        sortKey: b
                    }), v && (p[v.name] = !0), x) {
                        const e1 = s.evaluate(g, {}, n).join(","), r = "viewport" !== a.get("text-rotation-alignment") && "point" !== a.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(t1.WritingMode.vertical) >= 0;
                        for (const t1 of x.sections)if (t1.image) p[t1.image.name] = !0;
                        else {
                            const n = En(x.toString()), i = t1.fontStack || e1, a = f[i] = f[i] || {};
                            this.calculateGlyphDependencies(t1.text, a, r, this.allowVerticalPlacement, n);
                        }
                    }
                }
                "line" === a.get("symbol-placement") && (this.features = function(t1) {
                    const e1 = {}, r = {}, n = [];
                    let i = 0;
                    function a(e1) {
                        n.push(t1[e1]), i++;
                    }
                    function s(t1, e1, i) {
                        const a = r[t1];
                        return delete r[t1], r[e1] = a, n[a].geometry[0].pop(), n[a].geometry[0] = n[a].geometry[0].concat(i[0]), a;
                    }
                    function o(t1, r, i) {
                        const a = e1[r];
                        return delete e1[r], e1[t1] = a, n[a].geometry[0].shift(), n[a].geometry[0] = i[0].concat(n[a].geometry[0]), a;
                    }
                    function l(t1, e1, r) {
                        const n = r ? e1[0][e1[0].length - 1] : e1[0][0];
                        return `${t1}:${n.x}:${n.y}`;
                    }
                    for(let u = 0; u < t1.length; u++){
                        const c = t1[u], h = c.geometry, p = c.text ? c.text.toString() : null;
                        if (!p) {
                            a(u);
                            continue;
                        }
                        const f = l(p, h), d = l(p, h, !0);
                        if (f in r && d in e1 && r[f] !== e1[d]) {
                            const t1 = o(f, d, h), i = s(f, d, n[t1].geometry);
                            delete e1[f], delete r[d], r[l(p, n[i].geometry, !0)] = i, n[t1].geometry = null;
                        } else f in r ? s(f, d, h) : d in e1 ? o(f, d, h) : (a(u), e1[f] = i - 1, r[d] = i - 1);
                    }
                    return n.filter((t1)=>t1.geometry);
                }(this.features)), this.sortFeaturesByKey && this.features.sort((t1, e1)=>t1.sortKey - e1.sortKey);
            }
            update(t1, e1, r) {
                this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t1, e1, this.layers, r), this.icon.programConfigurations.updatePaintArrays(t1, e1, this.layers, r));
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(t1) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t1), this.iconCollisionBox.upload(t1)), this.text.upload(t1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(t1, e1) {
                const r = this.lineVertexArray.length;
                if (void 0 !== t1.segment) {
                    let r = t1.dist(e1[t1.segment + 1]), n = t1.dist(e1[t1.segment]);
                    const i = {};
                    for(let n = t1.segment + 1; n < e1.length; n++)i[n] = {
                        x: e1[n].x,
                        y: e1[n].y,
                        tileUnitDistanceFromAnchor: r
                    }, n < e1.length - 1 && (r += e1[n + 1].dist(e1[n]));
                    for(let r = t1.segment || 0; r >= 0; r--)i[r] = {
                        x: e1[r].x,
                        y: e1[r].y,
                        tileUnitDistanceFromAnchor: n
                    }, r > 0 && (n += e1[r - 1].dist(e1[r]));
                    for(let t1 = 0; t1 < e1.length; t1++){
                        const e1 = i[t1];
                        this.lineVertexArray.emplaceBack(e1.x, e1.y, e1.tileUnitDistanceFromAnchor);
                    }
                }
                return {
                    lineStartIndex: r,
                    lineLength: this.lineVertexArray.length - r
                };
            }
            addSymbols(e1, r, n, i, a, s, o, l, u, c, h, p) {
                const f = e1.indexArray, d = e1.layoutVertexArray, y = e1.segments.prepareSegment(4 * r.length, d, f, this.canOverlap ? s.sortKey : void 0), m = this.glyphOffsetArray.length, g = y.vertexLength, x = this.allowVerticalPlacement && o === t1.WritingMode.vertical ? Math.PI / 2 : 0, v = s.text && s.text.sections;
                for(let t1 = 0; t1 < r.length; t1++){
                    const { tl: i, tr: a, bl: o, br: u, tex: c, pixelOffsetTL: h, pixelOffsetBR: m, minFontScaleX: g, minFontScaleY: b, glyphOffset: w, isSDF: _, sectionIndex: A } = r[t1], k = y.vertexLength, S = w[1];
                    Vu(d, l.x, l.y, i.x, S + i.y, c.x, c.y, n, _, h.x, h.y, g, b), Vu(d, l.x, l.y, a.x, S + a.y, c.x + c.w, c.y, n, _, m.x, h.y, g, b), Vu(d, l.x, l.y, o.x, S + o.y, c.x, c.y + c.h, n, _, h.x, m.y, g, b), Vu(d, l.x, l.y, u.x, S + u.y, c.x + c.w, c.y + c.h, n, _, m.x, m.y, g, b), Eu(e1.dynamicLayoutVertexArray, l, x), f.emplaceBack(k, k + 1, k + 2), f.emplaceBack(k + 1, k + 2, k + 3), y.vertexLength += 4, y.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(w[0]), t1 !== r.length - 1 && A === r[t1 + 1].sectionIndex || e1.programConfigurations.populatePaintArrays(d.length, s, s.index, {}, p, v && v[A]);
                }
                e1.placedSymbolArray.emplaceBack(l.x, l.y, m, this.glyphOffsetArray.length - m, g, u, c, l.segment, n ? n[0] : 0, n ? n[1] : 0, i[0], i[1], o, 0, !1, 0, h);
            }
            _addCollisionDebugVertex(t1, e1, r, n, i, a) {
                return e1.emplaceBack(0, 0), t1.emplaceBack(r.x, r.y, n, i, Math.round(a.x), Math.round(a.y));
            }
            addCollisionDebugVertices(t1, e1, r, n, i, a, s) {
                const o = i.segments.prepareSegment(4, i.layoutVertexArray, i.indexArray), l = o.vertexLength, u = i.layoutVertexArray, c = i.collisionVertexArray, h = s.anchorX, p = s.anchorY;
                this._addCollisionDebugVertex(u, c, a, h, p, new S(t1, e1)), this._addCollisionDebugVertex(u, c, a, h, p, new S(r, e1)), this._addCollisionDebugVertex(u, c, a, h, p, new S(r, n)), this._addCollisionDebugVertex(u, c, a, h, p, new S(t1, n)), o.vertexLength += 4;
                const f = i.indexArray;
                f.emplaceBack(l, l + 1), f.emplaceBack(l + 1, l + 2), f.emplaceBack(l + 2, l + 3), f.emplaceBack(l + 3, l), o.primitiveLength += 4;
            }
            addDebugCollisionBoxes(t1, e1, r, n) {
                for(let i = t1; i < e1; i++){
                    const t1 = this.collisionBoxArray.get(i);
                    this.addCollisionDebugVertices(t1.x1, t1.y1, t1.x2, t1.y2, n ? this.textCollisionBox : this.iconCollisionBox, t1.anchorPoint, r);
                }
            }
            generateCollisionDebugBuffers() {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new Lu(ua, il.members, pa), this.iconCollisionBox = new Lu(ua, il.members, pa);
                for(let t1 = 0; t1 < this.symbolInstances.length; t1++){
                    const e1 = this.symbolInstances.get(t1);
                    this.addDebugCollisionBoxes(e1.textBoxStartIndex, e1.textBoxEndIndex, e1, !0), this.addDebugCollisionBoxes(e1.verticalTextBoxStartIndex, e1.verticalTextBoxEndIndex, e1, !0), this.addDebugCollisionBoxes(e1.iconBoxStartIndex, e1.iconBoxEndIndex, e1, !1), this.addDebugCollisionBoxes(e1.verticalIconBoxStartIndex, e1.verticalIconBoxEndIndex, e1, !1);
                }
            }
            _deserializeCollisionBoxesForSymbol(t1, e1, r, n, i, a, s, o, l) {
                const u = {};
                for(let n = e1; n < r; n++){
                    const e1 = t1.get(n);
                    u.textBox = {
                        x1: e1.x1,
                        y1: e1.y1,
                        x2: e1.x2,
                        y2: e1.y2,
                        anchorPointX: e1.anchorPointX,
                        anchorPointY: e1.anchorPointY
                    }, u.textFeatureIndex = e1.featureIndex;
                    break;
                }
                for(let e1 = n; e1 < i; e1++){
                    const r = t1.get(e1);
                    u.verticalTextBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.verticalTextFeatureIndex = r.featureIndex;
                    break;
                }
                for(let e1 = a; e1 < s; e1++){
                    const r = t1.get(e1);
                    u.iconBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.iconFeatureIndex = r.featureIndex;
                    break;
                }
                for(let e1 = o; e1 < l; e1++){
                    const r = t1.get(e1);
                    u.verticalIconBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.verticalIconFeatureIndex = r.featureIndex;
                    break;
                }
                return u;
            }
            deserializeCollisionBoxes(t1) {
                this.collisionArrays = [];
                for(let e1 = 0; e1 < this.symbolInstances.length; e1++){
                    const r = this.symbolInstances.get(e1);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t1, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            addIndicesForPlacedSymbol(t1, e1) {
                const r = t1.placedSymbolArray.get(e1), n = r.vertexStartIndex + 4 * r.numGlyphs;
                for(let e1 = r.vertexStartIndex; e1 < n; e1 += 4)t1.indexArray.emplaceBack(e1, e1 + 1, e1 + 2), t1.indexArray.emplaceBack(e1 + 1, e1 + 2, e1 + 3);
            }
            getSortedSymbolIndexes(t1) {
                if (this.sortedAngle === t1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const e1 = Math.sin(t1), r = Math.cos(t1), n = [], i = [], a = [];
                for(let t1 = 0; t1 < this.symbolInstances.length; ++t1){
                    a.push(t1);
                    const s = this.symbolInstances.get(t1);
                    n.push(0 | Math.round(e1 * s.anchorX + r * s.anchorY)), i.push(s.featureIndex);
                }
                return a.sort((t1, e1)=>n[t1] - n[e1] || i[e1] - i[t1]), a;
            }
            addToSortKeyRanges(t1, e1) {
                const r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                r && r.sortKey === e1 ? r.symbolInstanceEnd = t1 + 1 : this.sortKeyRanges.push({
                    sortKey: e1,
                    symbolInstanceStart: t1,
                    symbolInstanceEnd: t1 + 1
                });
            }
            sortFeatures(t1) {
                if (this.sortFeaturesByY && this.sortedAngle !== t1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t1), this.sortedAngle = t1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                    for (const t1 of this.symbolInstanceIndexes){
                        const e1 = this.symbolInstances.get(t1);
                        this.featureSortOrder.push(e1.featureIndex), [
                            e1.rightJustifiedTextSymbolIndex,
                            e1.centerJustifiedTextSymbolIndex,
                            e1.leftJustifiedTextSymbolIndex
                        ].forEach((t1, e1, r)=>{
                            t1 >= 0 && r.indexOf(t1) === e1 && this.addIndicesForPlacedSymbol(this.text, t1);
                        }), e1.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, e1.verticalPlacedTextSymbolIndex), e1.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e1.placedIconSymbolIndex), e1.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e1.verticalPlacedIconSymbolIndex);
                    }
                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                }
            }
            constructor(e1){
                this.collisionBoxArray = e1.collisionBoxArray, this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = e1.index, this.pixelRatio = e1.pixelRatio, this.sourceLayerIndex = e1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = ds([]), this.placementViewportMatrix = ds([]);
                const r = this.layers[0]._unevaluatedLayout._values;
                this.textSizeData = eu(this.zoom, r["text-size"]), this.iconSizeData = eu(this.zoom, r["icon-size"]);
                const n = this.layers[0].layout, i = n.get("symbol-sort-key"), a = n.get("symbol-z-order");
                this.canOverlap = "never" !== qu(n, "text-overlap", "text-allow-overlap") || "never" !== qu(n, "icon-overlap", "icon-allow-overlap") || n.get("text-ignore-placement") || n.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== a && !i.isConstant(), this.sortFeaturesByY = ("viewport-y" === a || "auto" === a && !this.sortFeaturesByKey) && this.canOverlap, "point" === n.get("symbol-placement") && (this.writingModes = n.get("text-writing-mode").map((e1)=>t1.WritingMode[e1])), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.sourceID = e1.sourceID;
            }
        }
        Mn("SymbolBucket", Du, {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), Du.MAX_GLYPHS = 65535, Du.addDynamicAttributes = Eu;
        const $u = new fi({
            "symbol-placement": new li(nt.layout_symbol["symbol-placement"]),
            "symbol-spacing": new li(nt.layout_symbol["symbol-spacing"]),
            "symbol-avoid-edges": new li(nt.layout_symbol["symbol-avoid-edges"]),
            "symbol-sort-key": new ui(nt.layout_symbol["symbol-sort-key"]),
            "symbol-z-order": new li(nt.layout_symbol["symbol-z-order"]),
            "icon-allow-overlap": new li(nt.layout_symbol["icon-allow-overlap"]),
            "icon-overlap": new li(nt.layout_symbol["icon-overlap"]),
            "icon-ignore-placement": new li(nt.layout_symbol["icon-ignore-placement"]),
            "icon-optional": new li(nt.layout_symbol["icon-optional"]),
            "icon-rotation-alignment": new li(nt.layout_symbol["icon-rotation-alignment"]),
            "icon-size": new ui(nt.layout_symbol["icon-size"]),
            "icon-text-fit": new li(nt.layout_symbol["icon-text-fit"]),
            "icon-text-fit-padding": new li(nt.layout_symbol["icon-text-fit-padding"]),
            "icon-image": new ui(nt.layout_symbol["icon-image"]),
            "icon-rotate": new ui(nt.layout_symbol["icon-rotate"]),
            "icon-padding": new ui(nt.layout_symbol["icon-padding"]),
            "icon-keep-upright": new li(nt.layout_symbol["icon-keep-upright"]),
            "icon-offset": new ui(nt.layout_symbol["icon-offset"]),
            "icon-anchor": new ui(nt.layout_symbol["icon-anchor"]),
            "icon-pitch-alignment": new li(nt.layout_symbol["icon-pitch-alignment"]),
            "text-pitch-alignment": new li(nt.layout_symbol["text-pitch-alignment"]),
            "text-rotation-alignment": new li(nt.layout_symbol["text-rotation-alignment"]),
            "text-field": new ui(nt.layout_symbol["text-field"]),
            "text-font": new ui(nt.layout_symbol["text-font"]),
            "text-size": new ui(nt.layout_symbol["text-size"]),
            "text-max-width": new ui(nt.layout_symbol["text-max-width"]),
            "text-line-height": new li(nt.layout_symbol["text-line-height"]),
            "text-letter-spacing": new ui(nt.layout_symbol["text-letter-spacing"]),
            "text-justify": new ui(nt.layout_symbol["text-justify"]),
            "text-radial-offset": new ui(nt.layout_symbol["text-radial-offset"]),
            "text-variable-anchor": new li(nt.layout_symbol["text-variable-anchor"]),
            "text-anchor": new ui(nt.layout_symbol["text-anchor"]),
            "text-max-angle": new li(nt.layout_symbol["text-max-angle"]),
            "text-writing-mode": new li(nt.layout_symbol["text-writing-mode"]),
            "text-rotate": new ui(nt.layout_symbol["text-rotate"]),
            "text-padding": new li(nt.layout_symbol["text-padding"]),
            "text-keep-upright": new li(nt.layout_symbol["text-keep-upright"]),
            "text-transform": new ui(nt.layout_symbol["text-transform"]),
            "text-offset": new ui(nt.layout_symbol["text-offset"]),
            "text-allow-overlap": new li(nt.layout_symbol["text-allow-overlap"]),
            "text-overlap": new li(nt.layout_symbol["text-overlap"]),
            "text-ignore-placement": new li(nt.layout_symbol["text-ignore-placement"]),
            "text-optional": new li(nt.layout_symbol["text-optional"])
        });
        var Ru = {
            paint: new fi({
                "icon-opacity": new ui(nt.paint_symbol["icon-opacity"]),
                "icon-color": new ui(nt.paint_symbol["icon-color"]),
                "icon-halo-color": new ui(nt.paint_symbol["icon-halo-color"]),
                "icon-halo-width": new ui(nt.paint_symbol["icon-halo-width"]),
                "icon-halo-blur": new ui(nt.paint_symbol["icon-halo-blur"]),
                "icon-translate": new li(nt.paint_symbol["icon-translate"]),
                "icon-translate-anchor": new li(nt.paint_symbol["icon-translate-anchor"]),
                "text-opacity": new ui(nt.paint_symbol["text-opacity"]),
                "text-color": new ui(nt.paint_symbol["text-color"], {
                    runtimeType: yt,
                    getOverride: (t1)=>t1.textColor,
                    hasOverride: (t1)=>!!t1.textColor
                }),
                "text-halo-color": new ui(nt.paint_symbol["text-halo-color"]),
                "text-halo-width": new ui(nt.paint_symbol["text-halo-width"]),
                "text-halo-blur": new ui(nt.paint_symbol["text-halo-blur"]),
                "text-translate": new li(nt.paint_symbol["text-translate"]),
                "text-translate-anchor": new li(nt.paint_symbol["text-translate-anchor"])
            }),
            layout: $u
        };
        class Ou {
            evaluate(t1) {
                if (t1.formattedSection) {
                    const e1 = this.defaultValue.property.overrides;
                    if (e1 && e1.hasOverride(t1.formattedSection)) return e1.getOverride(t1.formattedSection);
                }
                return t1.feature && t1.featureState ? this.defaultValue.evaluate(t1.feature, t1.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(t1) {
                this.defaultValue.isConstant() || t1(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
            constructor(t1){
                if (void 0 === t1.property.overrides) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
                this.type = t1.property.overrides ? t1.property.overrides.runtimeType : ht, this.defaultValue = t1;
            }
        }
        Mn("FormatSectionOverride", Ou, {
            omit: [
                "defaultValue"
            ]
        });
        class Uu extends yi {
            recalculate(t1, e1) {
                if (super.recalculate(t1, e1), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = "map" === this.layout.get("text-rotation-alignment") ? "map" : "viewport"), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                    const t1 = this.layout.get("text-writing-mode");
                    if (t1) {
                        const e1 = [];
                        for (const r of t1)e1.indexOf(r) < 0 && e1.push(r);
                        this.layout._values["text-writing-mode"] = e1;
                    } else this.layout._values["text-writing-mode"] = [
                        "horizontal"
                    ];
                }
                this._setPaintOverrides();
            }
            getValueAndResolveTokens(t1, e1, r, n) {
                const i = this.layout.get(t1).evaluate(e1, {}, r, n), a = this._unevaluatedLayout._values[t1];
                return a.isDataDriven() || Er(a.value) || !i ? i : function(t1, e1) {
                    return e1.replace(/{([^{}]+)}/g, (e1, r)=>r in t1 ? String(t1[r]) : "");
                }(e1.properties, i);
            }
            createBucket(t1) {
                return new Du(t1);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                throw new Error("Should take a different path in FeatureIndex");
            }
            _setPaintOverrides() {
                for (const t1 of Ru.paint.overridableProperties){
                    if (!Uu.hasPaintOverride(this.layout, t1)) continue;
                    const e1 = this.paint.get(t1), r = new Ou(e1), n = new Vr(r, e1.property.specification);
                    let i = null;
                    i = "constant" === e1.value.kind || "source" === e1.value.kind ? new Tr("source", n) : new Lr("composite", n, e1.value.zoomStops), this.paint._values[t1] = new si(e1.property, i, e1.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(t1, e1, r) {
                return !(!this.layout || e1.isDataDriven() || r.isDataDriven()) && Uu.hasPaintOverride(this.layout, t1);
            }
            static hasPaintOverride(t1, e1) {
                const r = t1.get("text-field"), n = Ru.paint.properties[e1];
                let i = !1;
                const a = (t1)=>{
                    for (const e1 of t1)if (n.overrides && n.overrides.hasOverride(e1)) return void (i = !0);
                };
                if ("constant" === r.value.kind && r.value.value instanceof Dt) a(r.value.value.sections);
                else if ("source" === r.value.kind) {
                    const t1 = (e1)=>{
                        i || (e1 instanceof Nt && qt(e1.value) === vt ? a(e1.value.sections) : e1 instanceof cr ? a(e1.sections) : e1.eachChild(t1));
                    }, e1 = r.value;
                    e1._styleExpression && t1(e1._styleExpression.expression);
                }
                return i;
            }
            constructor(t1){
                super(t1, Ru);
            }
        }
        function qu(t1, e1, r) {
            let n = "never";
            const i = t1.get(e1);
            return i ? n = i : t1.get(r) && (n = "always"), n;
        }
        var ju = {
            paint: new fi({
                "background-color": new li(nt.paint_background["background-color"]),
                "background-pattern": new hi(nt.paint_background["background-pattern"]),
                "background-opacity": new li(nt.paint_background["background-opacity"])
            })
        }, Nu = {
            paint: new fi({
                "raster-opacity": new li(nt.paint_raster["raster-opacity"]),
                "raster-hue-rotate": new li(nt.paint_raster["raster-hue-rotate"]),
                "raster-brightness-min": new li(nt.paint_raster["raster-brightness-min"]),
                "raster-brightness-max": new li(nt.paint_raster["raster-brightness-max"]),
                "raster-saturation": new li(nt.paint_raster["raster-saturation"]),
                "raster-contrast": new li(nt.paint_raster["raster-contrast"]),
                "raster-resampling": new li(nt.paint_raster["raster-resampling"]),
                "raster-fade-duration": new li(nt.paint_raster["raster-fade-duration"])
            })
        };
        class Zu extends yi {
            is3D() {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {
                throw new Error("Custom layers cannot be serialized");
            }
            constructor(t1){
                super(t1, {}), this.onAdd = (t1)=>{
                    this.implementation.onAdd && this.implementation.onAdd(t1, t1.painter.context.gl);
                }, this.onRemove = (t1)=>{
                    this.implementation.onRemove && this.implementation.onRemove(t1, t1.painter.context.gl);
                }, this.implementation = t1;
            }
        }
        const Ku = {
            circle: class extends yi {
                createBucket(t1) {
                    return new Ja(t1);
                }
                queryRadius(t1) {
                    const e1 = t1;
                    return ss("circle-radius", this, e1) + ss("circle-stroke-width", this, e1) + os(this.paint.get("circle-translate"));
                }
                queryIntersectsFeature(t1, e1, r, n, i, a, s, o) {
                    const l = ls(t1, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), a.angle, s), u = this.paint.get("circle-radius").evaluate(e1, r) + this.paint.get("circle-stroke-width").evaluate(e1, r), c = "map" === this.paint.get("circle-pitch-alignment"), h = c ? l : function(t1, e1) {
                        return t1.map((t1)=>_s(t1, e1));
                    }(l, o), p = c ? u * s : u;
                    for (const t1 of n)for (const e1 of t1){
                        const t1 = c ? e1 : _s(e1, o);
                        let r = p;
                        const n = bs([], [
                            e1.x,
                            e1.y,
                            0,
                            1
                        ], o);
                        if ("viewport" === this.paint.get("circle-pitch-scale") && "map" === this.paint.get("circle-pitch-alignment") ? r *= n[3] / a.cameraToCenterDistance : "map" === this.paint.get("circle-pitch-scale") && "viewport" === this.paint.get("circle-pitch-alignment") && (r *= a.cameraToCenterDistance / n[3]), Ya(h, t1, r)) return !0;
                    }
                    return !1;
                }
                constructor(t1){
                    super(t1, cs);
                }
            },
            heatmap: class extends yi {
                createBucket(t1) {
                    return new As(t1);
                }
                _handleSpecialPaintPropertyUpdate(t1) {
                    "heatmap-color" === t1 && this._updateColorRamp();
                }
                _updateColorRamp() {
                    this.colorRamp = Cs({
                        expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                        evaluationKey: "heatmapDensity",
                        image: this.colorRamp
                    }), this.colorRampTexture = null;
                }
                resize() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                }
                queryRadius() {
                    return 0;
                }
                queryIntersectsFeature() {
                    return !1;
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                }
                constructor(t1){
                    super(t1, ks), this._updateColorRamp();
                }
            },
            hillshade: class extends yi {
                hasOffscreenPass() {
                    return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                }
                constructor(t1){
                    super(t1, Ps);
                }
            },
            fill: class extends yi {
                recalculate(t1, e1) {
                    super.recalculate(t1, e1);
                    const r = this.paint._values["fill-outline-color"];
                    "constant" === r.value.kind && void 0 === r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                }
                createBucket(t1) {
                    return new mo(t1);
                }
                queryRadius() {
                    return os(this.paint.get("fill-translate"));
                }
                queryIntersectsFeature(t1, e1, r, n, i, a, s) {
                    return Ha(ls(t1, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), a.angle, s), n);
                }
                isTileClipped() {
                    return !0;
                }
                constructor(t1){
                    super(t1, xo);
                }
            },
            "fill-extrusion": class extends yi {
                createBucket(t1) {
                    return new Do(t1);
                }
                queryRadius() {
                    return os(this.paint.get("fill-extrusion-translate"));
                }
                is3D() {
                    return !0;
                }
                queryIntersectsFeature(t1, e1, r, n, i, a, s, o) {
                    const l = ls(t1, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), a.angle, s), u = this.paint.get("fill-extrusion-height").evaluate(e1, r), c = this.paint.get("fill-extrusion-base").evaluate(e1, r), h = function(t1, e1, r, n) {
                        const i = [];
                        for (const r of t1){
                            const t1 = [
                                r.x,
                                r.y,
                                0,
                                1
                            ];
                            bs(t1, t1, e1), i.push(new S(t1[0] / t1[3], t1[1] / t1[3]));
                        }
                        return i;
                    }(l, o), p = function(t1, e1, r, n) {
                        const i = [], a = [], s = n[8] * e1, o = n[9] * e1, l = n[10] * e1, u = n[11] * e1, c = n[8] * r, h = n[9] * r, p = n[10] * r, f = n[11] * r;
                        for (const e1 of t1){
                            const t1 = [], r = [];
                            for (const i of e1){
                                const e1 = i.x, a = i.y, d = n[0] * e1 + n[4] * a + n[12], y = n[1] * e1 + n[5] * a + n[13], m = n[2] * e1 + n[6] * a + n[14], g = n[3] * e1 + n[7] * a + n[15], x = m + l, v = g + u, b = d + c, w = y + h, _ = m + p, A = g + f, k = new S((d + s) / v, (y + o) / v);
                                k.z = x / v, t1.push(k);
                                const I = new S(b / A, w / A);
                                I.z = _ / A, r.push(I);
                            }
                            i.push(t1), a.push(r);
                        }
                        return [
                            i,
                            a
                        ];
                    }(n, c, u, o);
                    return function(t1, e1, r) {
                        let n = 1 / 0;
                        Ha(r, e1) && (n = qo(r, e1[0]));
                        for(let i = 0; i < e1.length; i++){
                            const a = e1[i], s = t1[i];
                            for(let t1 = 0; t1 < a.length - 1; t1++){
                                const e1 = a[t1], i = [
                                    e1,
                                    a[t1 + 1],
                                    s[t1 + 1],
                                    s[t1],
                                    e1
                                ];
                                Xa(r, i) && (n = Math.min(n, qo(r, i)));
                            }
                        }
                        return n !== 1 / 0 && n;
                    }(p[0], p[1], h);
                }
                constructor(t1){
                    super(t1, Oo);
                }
            },
            line: class extends yi {
                _handleSpecialPaintPropertyUpdate(t1) {
                    "line-gradient" === t1 && (this.stepInterpolant = this._transitionablePaint._values["line-gradient"].value.expression._styleExpression.expression instanceof ke, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER);
                }
                gradientExpression() {
                    return this._transitionablePaint._values["line-gradient"].value.expression;
                }
                recalculate(t1, e1) {
                    super.recalculate(t1, e1), this.paint._values["line-floorwidth"] = Qo.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t1);
                }
                createBucket(t1) {
                    return new Yo(t1);
                }
                queryRadius(t1) {
                    const e1 = t1, r = tl(ss("line-width", this, e1), ss("line-gap-width", this, e1)), n = ss("line-offset", this, e1);
                    return r / 2 + Math.abs(n) + os(this.paint.get("line-translate"));
                }
                queryIntersectsFeature(t1, e1, r, n, i, a, s) {
                    const o = ls(t1, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), a.angle, s), l = s / 2 * tl(this.paint.get("line-width").evaluate(e1, r), this.paint.get("line-gap-width").evaluate(e1, r)), u = this.paint.get("line-offset").evaluate(e1, r);
                    return u && (n = function(t1, e1) {
                        const r = [];
                        for(let n = 0; n < t1.length; n++){
                            const i = t1[n], a = [];
                            for(let t1 = 0; t1 < i.length; t1++){
                                const r = i[t1 - 1], n = i[t1], s = i[t1 + 1], o = 0 === t1 ? new S(0, 0) : n.sub(r)._unit()._perp(), l = t1 === i.length - 1 ? new S(0, 0) : s.sub(n)._unit()._perp(), u = o._add(l)._unit(), c = u.x * l.x + u.y * l.y;
                                0 !== c && u._mult(1 / c), a.push(u._mult(e1)._add(n));
                            }
                            r.push(a);
                        }
                        return r;
                    }(n, u * s)), function(t1, e1, r) {
                        for(let n = 0; n < e1.length; n++){
                            const i = e1[n];
                            if (t1.length >= 3) {
                                for(let e1 = 0; e1 < i.length; e1++)if (is(t1, i[e1])) return !0;
                            }
                            if (Wa(t1, i, r)) return !0;
                        }
                        return !1;
                    }(o, n, l);
                }
                isTileClipped() {
                    return !0;
                }
                constructor(t1){
                    super(t1, Wo), this.gradientVersion = 0;
                }
            },
            symbol: Uu,
            background: class extends yi {
                constructor(t1){
                    super(t1, ju);
                }
            },
            raster: class extends yi {
                constructor(t1){
                    super(t1, Nu);
                }
            }
        };
        class Gu {
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._callback();
                }, 0));
            }
            remove() {
                delete this._channel, this._callback = ()=>{};
            }
            constructor(t1){
                this._callback = t1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._callback();
                });
            }
        }
        const Ju = 6371008.8;
        class Xu {
            wrap() {
                return new Xu(s(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(t1) {
                const e1 = Math.PI / 180, r = this.lat * e1, n = t1.lat * e1, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t1.lng - this.lng) * e1);
                return Ju * Math.acos(Math.min(i, 1));
            }
            toBounds(t1 = 0) {
                const e1 = 360 * t1 / 40075017, r = e1 / Math.cos(Math.PI / 180 * this.lat);
                return new Yu(new Xu(this.lng - r, this.lat - e1), new Xu(this.lng + r, this.lat + e1));
            }
            static convert(t1) {
                if (t1 instanceof Xu) return t1;
                if (Array.isArray(t1) && (2 === t1.length || 3 === t1.length)) return new Xu(Number(t1[0]), Number(t1[1]));
                if (!Array.isArray(t1) && "object" == typeof t1 && null !== t1) return new Xu(Number("lng" in t1 ? t1.lng : t1.lon), Number(t1.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
            constructor(t1, e1){
                if (isNaN(t1) || isNaN(e1)) throw new Error(`Invalid LngLat object: (${t1}, ${e1})`);
                if (this.lng = +t1, this.lat = +e1, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
        }
        class Yu {
            setNorthEast(t1) {
                return this._ne = t1 instanceof Xu ? new Xu(t1.lng, t1.lat) : Xu.convert(t1), this;
            }
            setSouthWest(t1) {
                return this._sw = t1 instanceof Xu ? new Xu(t1.lng, t1.lat) : Xu.convert(t1), this;
            }
            extend(t1) {
                const e1 = this._sw, r = this._ne;
                let n, i;
                if (t1 instanceof Xu) n = t1, i = t1;
                else {
                    if (!(t1 instanceof Yu)) return Array.isArray(t1) ? 4 === t1.length || t1.every(Array.isArray) ? this.extend(Yu.convert(t1)) : this.extend(Xu.convert(t1)) : this;
                    if (n = t1._sw, i = t1._ne, !n || !i) return this;
                }
                return e1 || r ? (e1.lng = Math.min(n.lng, e1.lng), e1.lat = Math.min(n.lat, e1.lat), r.lng = Math.max(i.lng, r.lng), r.lat = Math.max(i.lat, r.lat)) : (this._sw = new Xu(n.lng, n.lat), this._ne = new Xu(i.lng, i.lat)), this;
            }
            getCenter() {
                return new Xu((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new Xu(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new Xu(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(t1) {
                const { lng: e1, lat: r } = Xu.convert(t1);
                let n = this._sw.lng <= e1 && e1 <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (n = this._sw.lng >= e1 && e1 >= this._ne.lng), this._sw.lat <= r && r <= this._ne.lat && n;
            }
            static convert(t1) {
                return t1 instanceof Yu ? t1 : t1 ? new Yu(t1) : t1;
            }
            constructor(t1, e1){
                t1 && (e1 ? this.setSouthWest(t1).setNorthEast(e1) : 4 === t1.length ? this.setSouthWest([
                    t1[0],
                    t1[1]
                ]).setNorthEast([
                    t1[2],
                    t1[3]
                ]) : this.setSouthWest(t1[0]).setNorthEast(t1[1]));
            }
        }
        const Hu = 2 * Math.PI * Ju;
        function Wu(t1) {
            return Hu * Math.cos(t1 * Math.PI / 180);
        }
        function Qu(t1) {
            return (180 + t1) / 360;
        }
        function tc(t1) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1 * Math.PI / 360))) / 360;
        }
        function ec(t1, e1) {
            return t1 / Wu(e1);
        }
        function rc(t1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t1) * Math.PI / 180)) - 90;
        }
        class nc {
            static fromLngLat(t1, e1 = 0) {
                const r = Xu.convert(t1);
                return new nc(Qu(r.lng), tc(r.lat), ec(e1, r.lat));
            }
            toLngLat() {
                return new Xu(360 * this.x - 180, rc(this.y));
            }
            toAltitude() {
                return this.z * Wu(rc(this.y));
            }
            meterInMercatorCoordinateUnits() {
                var t1;
                return 1 / Hu * (t1 = rc(this.y), 1 / Math.cos(t1 * Math.PI / 180));
            }
            constructor(t1, e1, r = 0){
                this.x = +t1, this.y = +e1, this.z = +r;
            }
        }
        function ic(t1, e1, r) {
            var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
            return [
                t1 * n - 2 * Math.PI * 6378137 / 2,
                e1 * n - 2 * Math.PI * 6378137 / 2
            ];
        }
        class ac {
            equals(t1) {
                return this.z === t1.z && this.x === t1.x && this.y === t1.y;
            }
            url(t1, e1, r) {
                const n = (a = this.y, s = this.z, o = ic(256 * (i = this.x), 256 * (a = Math.pow(2, s) - a - 1), s), l = ic(256 * (i + 1), 256 * (a + 1), s), o[0] + "," + o[1] + "," + l[0] + "," + l[1]);
                var i, a, s, o, l;
                const u = function(t1, e1, r) {
                    let n, i = "";
                    for(let a = t1; a > 0; a--)n = 1 << a - 1, i += (e1 & n ? 1 : 0) + (r & n ? 2 : 0);
                    return i;
                }(this.z, this.x, this.y);
                return t1[(this.x + this.y) % t1.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === r ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, e1 > 1 ? "@2x" : "").replace(/{quadkey}/g, u).replace(/{bbox-epsg-3857}/g, n);
            }
            isChildOf(t1) {
                const e1 = this.z - t1.z;
                return e1 > 0 && t1.x === this.x >> e1 && t1.y === this.y >> e1;
            }
            getTilePoint(t1) {
                const e1 = Math.pow(2, this.z);
                return new S((t1.x * e1 - this.x) * qa, (t1.y * e1 - this.y) * qa);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
            constructor(t1, e1, r){
                if (t1 < 0 || t1 > 25 || r < 0 || r >= Math.pow(2, t1) || e1 < 0 || e1 >= Math.pow(2, t1)) throw new Error(`x=${e1}, y=${r}, z=${t1} outside of bounds. 0<=x<${Math.pow(2, t1)}, 0<=y<${Math.pow(2, t1)} 0<=z<=25 `);
                this.z = t1, this.x = e1, this.y = r, this.key = lc(0, t1, t1, e1, r);
            }
        }
        class sc {
            constructor(t1, e1){
                this.wrap = t1, this.canonical = e1, this.key = lc(t1, e1.z, e1.z, e1.x, e1.y);
            }
        }
        class oc {
            clone() {
                return new oc(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            equals(t1) {
                return this.overscaledZ === t1.overscaledZ && this.wrap === t1.wrap && this.canonical.equals(t1.canonical);
            }
            scaledTo(t1) {
                if (t1 > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t1}; overscaledZ = ${this.overscaledZ}`);
                const e1 = this.canonical.z - t1;
                return t1 > this.canonical.z ? new oc(t1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new oc(t1, this.wrap, t1, this.canonical.x >> e1, this.canonical.y >> e1);
            }
            calculateScaledKey(t1, e1) {
                if (t1 > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t1}; overscaledZ = ${this.overscaledZ}`);
                const r = this.canonical.z - t1;
                return t1 > this.canonical.z ? lc(this.wrap * +e1, t1, this.canonical.z, this.canonical.x, this.canonical.y) : lc(this.wrap * +e1, t1, t1, this.canonical.x >> r, this.canonical.y >> r);
            }
            isChildOf(t1) {
                if (t1.wrap !== this.wrap) return !1;
                const e1 = this.canonical.z - t1.canonical.z;
                return 0 === t1.overscaledZ || t1.overscaledZ < this.overscaledZ && t1.canonical.x === this.canonical.x >> e1 && t1.canonical.y === this.canonical.y >> e1;
            }
            children(t1) {
                if (this.overscaledZ >= t1) return [
                    new oc(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const e1 = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                return [
                    new oc(e1, this.wrap, e1, r, n),
                    new oc(e1, this.wrap, e1, r + 1, n),
                    new oc(e1, this.wrap, e1, r, n + 1),
                    new oc(e1, this.wrap, e1, r + 1, n + 1)
                ];
            }
            isLessThan(t1) {
                return this.wrap < t1.wrap || !(this.wrap > t1.wrap) && (this.overscaledZ < t1.overscaledZ || !(this.overscaledZ > t1.overscaledZ) && (this.canonical.x < t1.canonical.x || !(this.canonical.x > t1.canonical.x) && this.canonical.y < t1.canonical.y));
            }
            wrapped() {
                return new oc(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(t1) {
                return new oc(this.overscaledZ, t1, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new sc(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
            getTilePoint(t1) {
                return this.canonical.getTilePoint(new nc(t1.x - this.wrap, t1.y));
            }
            constructor(t1, e1, r, n, i){
                if (t1 < r) throw new Error(`overscaledZ should be >= z; overscaledZ = ${t1}; z = ${r}`);
                this.overscaledZ = t1, this.wrap = e1, this.canonical = new ac(r, +n, +i), this.key = lc(e1, t1, r, n, i);
            }
        }
        function lc(t1, e1, r, n, i) {
            (t1 *= 2) < 0 && (t1 = -1 * t1 - 1);
            const a = 1 << r;
            return (a * a * t1 + a * i + n).toString(36) + r.toString(36) + e1.toString(36);
        }
        Mn("CanonicalTileID", ac), Mn("OverscaledTileID", oc, {
            omit: [
                "posMatrix"
            ]
        });
        class uc {
            get(t1, e1) {
                const r = new Uint8Array(this.data.buffer), n = 4 * this._idx(t1, e1);
                return ("terrarium" === this.encoding ? this._unpackTerrarium : this._unpackMapbox)(r[n], r[n + 1], r[n + 2]);
            }
            getUnpackVector() {
                return "terrarium" === this.encoding ? [
                    256,
                    1,
                    1 / 256,
                    32768
                ] : [
                    6553.6,
                    25.6,
                    .1,
                    1e4
                ];
            }
            _idx(t1, e1) {
                if (t1 < -1 || t1 >= this.dim + 1 || e1 < -1 || e1 >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (e1 + 1) * this.stride + (t1 + 1);
            }
            _unpackMapbox(t1, e1, r) {
                return (256 * t1 * 256 + 256 * e1 + r) / 10 - 1e4;
            }
            _unpackTerrarium(t1, e1, r) {
                return 256 * t1 + e1 + r / 256 - 32768;
            }
            getPixels() {
                return new Bs({
                    width: this.stride,
                    height: this.stride
                }, new Uint8Array(this.data.buffer));
            }
            backfillBorder(t1, e1, r) {
                if (this.dim !== t1.dim) throw new Error("dem dimension mismatch");
                let n = e1 * this.dim, i = e1 * this.dim + this.dim, a = r * this.dim, s = r * this.dim + this.dim;
                switch(e1){
                    case -1:
                        n = i - 1;
                        break;
                    case 1:
                        i = n + 1;
                }
                switch(r){
                    case -1:
                        a = s - 1;
                        break;
                    case 1:
                        s = a + 1;
                }
                const o = -e1 * this.dim, l = -r * this.dim;
                for(let e1 = a; e1 < s; e1++)for(let r = n; r < i; r++)this.data[this._idx(r, e1)] = t1.data[this._idx(r + o, e1 + l)];
            }
            constructor(t1, e1, r){
                if (this.uid = t1, e1.height !== e1.width) throw new RangeError("DEM tiles must be square");
                if (r && "mapbox" !== r && "terrarium" !== r) return void d(`"${r}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
                this.stride = e1.height;
                const n = this.dim = e1.height - 2;
                this.data = new Uint32Array(e1.data.buffer), this.encoding = r || "mapbox";
                for(let t1 = 0; t1 < n; t1++)this.data[this._idx(-1, t1)] = this.data[this._idx(0, t1)], this.data[this._idx(n, t1)] = this.data[this._idx(n - 1, t1)], this.data[this._idx(t1, -1)] = this.data[this._idx(t1, 0)], this.data[this._idx(t1, n)] = this.data[this._idx(t1, n - 1)];
                this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(n, -1)] = this.data[this._idx(n - 1, 0)], this.data[this._idx(-1, n)] = this.data[this._idx(0, n - 1)], this.data[this._idx(n, n)] = this.data[this._idx(n - 1, n - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
                for(let t1 = 0; t1 < n; t1++)for(let e1 = 0; e1 < n; e1++){
                    const r = this.get(t1, e1);
                    r > this.max && (this.max = r), r < this.min && (this.min = r);
                }
            }
        }
        Mn("DEMData", uc);
        class cc {
            encode(t1) {
                return this._stringToNumber[t1];
            }
            decode(t1) {
                if (t1 >= this._numberToString.length) throw new Error(`Out of bounds. Index requested n=${t1} can't be >= this._numberToString.length ${this._numberToString.length}`);
                return this._numberToString[t1];
            }
            constructor(t1){
                this._stringToNumber = {}, this._numberToString = [];
                for(let e1 = 0; e1 < t1.length; e1++){
                    const r = t1[e1];
                    this._stringToNumber[r] = e1, this._numberToString[e1] = r;
                }
            }
        }
        class hc {
            get geometry() {
                return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
            }
            set geometry(t1) {
                this._geometry = t1;
            }
            toJSON() {
                const t1 = {
                    geometry: this.geometry
                };
                for(const e1 in this)"_geometry" !== e1 && "_vectorTileFeature" !== e1 && (t1[e1] = this[e1]);
                return t1;
            }
            constructor(t1, e1, r, n, i){
                this.type = "Feature", this._vectorTileFeature = t1, t1._z = e1, t1._x = r, t1._y = n, this.properties = t1.properties, this.id = i;
            }
        }
        class pc {
            insert(t1, e1, r, n, i, a) {
                const s = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(r, n, i);
                const o = a ? this.grid3D : this.grid;
                for(let t1 = 0; t1 < e1.length; t1++){
                    const r = e1[t1], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let t1 = 0; t1 < r.length; t1++){
                        const e1 = r[t1];
                        n[0] = Math.min(n[0], e1.x), n[1] = Math.min(n[1], e1.y), n[2] = Math.max(n[2], e1.x), n[3] = Math.max(n[3], e1.y);
                    }
                    n[0] < qa && n[1] < qa && n[2] >= 0 && n[3] >= 0 && o.insert(s, n[0], n[1], n[2], n[3]);
                }
            }
            loadVTLayers() {
                return this.vtLayers || (this.vtLayers = new _o.VectorTile(new ul(this.rawTileData)).layers, this.sourceLayerCoder = new cc(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                    "_geojsonTileLayer"
                ])), this.vtLayers;
            }
            query(t1, e1, r, n) {
                this.loadVTLayers();
                const i = t1.params || {}, a = qa / t1.tileSize / t1.scale, s = Jr(i.filter), o = t1.queryGeometry, l = t1.queryPadding * a, u = dc(o), c = this.grid.query(u.minX - l, u.minY - l, u.maxX + l, u.maxY + l), h = dc(t1.cameraQueryGeometry), p = this.grid3D.query(h.minX - l, h.minY - l, h.maxX + l, h.maxY + l, (e1, r, n, i)=>(function(t1, e1, r, n, i) {
                        for (const a of t1)if (e1 <= a.x && r <= a.y && n >= a.x && i >= a.y) return !0;
                        const a = [
                            new S(e1, r),
                            new S(e1, i),
                            new S(n, i),
                            new S(n, r)
                        ];
                        if (t1.length > 2) {
                            for (const e1 of a)if (is(t1, e1)) return !0;
                        }
                        for(let e1 = 0; e1 < t1.length - 1; e1++)if (as(t1[e1], t1[e1 + 1], a)) return !0;
                        return !1;
                    })(t1.cameraQueryGeometry, e1 - l, r - l, n + l, i + l));
                for (const t1 of p)c.push(t1);
                c.sort(yc);
                const f = {};
                let d;
                for(let l = 0; l < c.length; l++){
                    const u = c[l];
                    if (u === d) continue;
                    d = u;
                    const h = this.featureIndexArray.get(u);
                    let p = null;
                    this.loadMatchingFeature(f, h.bucketIndex, h.sourceLayerIndex, h.featureIndex, s, i.layers, i.availableImages, e1, r, n, (e1, r, n)=>(p || (p = Za(e1)), r.queryIntersectsFeature(o, e1, n, p, this.z, t1.transform, a, t1.pixelPosMatrix)));
                }
                return f;
            }
            loadMatchingFeature(t1, e1, r, n, i, a, s, l, u, c, h) {
                const p = this.bucketLayerIDs[e1];
                if (a && !function(t1, e1) {
                    for(let r = 0; r < t1.length; r++)if (e1.indexOf(t1[r]) >= 0) return !0;
                    return !1;
                }(a, p)) return;
                const f = this.sourceLayerCoder.decode(r), d = this.vtLayers[f].feature(n);
                if (i.needGeometry) {
                    const t1 = Ka(d, !0);
                    if (!i.filter(new Qn(this.tileID.overscaledZ), t1, this.tileID.canonical)) return;
                } else if (!i.filter(new Qn(this.tileID.overscaledZ), d)) return;
                const y = this.getId(d, f);
                for(let e1 = 0; e1 < p.length; e1++){
                    const r = p[e1];
                    if (a && a.indexOf(r) < 0) continue;
                    const i = l[r];
                    if (!i) continue;
                    let f = {};
                    y && c && (f = c.getState(i.sourceLayer || "_geojsonTileLayer", y));
                    const m = o({}, u[r]);
                    m.paint = fc(m.paint, i.paint, d, f, s), m.layout = fc(m.layout, i.layout, d, f, s);
                    const g = !h || h(d, i, f);
                    if (!g) continue;
                    const x = new hc(d, this.z, this.x, this.y, y);
                    x.layer = m;
                    let v = t1[r];
                    void 0 === v && (v = t1[r] = []), v.push({
                        featureIndex: n,
                        feature: x,
                        intersectionZ: g
                    });
                }
            }
            lookupSymbolFeatures(t1, e1, r, n, i, a, s, o) {
                const l = {};
                this.loadVTLayers();
                const u = Jr(i);
                for (const i of t1)this.loadMatchingFeature(l, r, n, i, u, a, s, o, e1);
                return l;
            }
            hasLayer(t1) {
                for (const e1 of this.bucketLayerIDs)for (const r of e1)if (t1 === r) return !0;
                return !1;
            }
            getId(t1, e1) {
                let r = t1.id;
                return this.promoteId && (r = t1.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[e1]], "boolean" == typeof r && (r = Number(r))), r;
            }
            constructor(t1, e1){
                this.tileID = t1, this.x = t1.canonical.x, this.y = t1.canonical.y, this.z = t1.canonical.z, this.grid = new Sn(qa, 16, 0), this.grid3D = new Sn(qa, 16, 0), this.featureIndexArray = new Wi, this.promoteId = e1;
            }
        }
        function fc(t1, e1, r, n, i) {
            return c(t1, (t1, a)=>{
                const s = e1 instanceof oi ? e1.get(a) : null;
                return s && s.evaluate ? s.evaluate(r, n, i) : s;
            });
        }
        function dc(t1) {
            let e1 = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
            for (const a of t1)e1 = Math.min(e1, a.x), r = Math.min(r, a.y), n = Math.max(n, a.x), i = Math.max(i, a.y);
            return {
                minX: e1,
                minY: r,
                maxX: n,
                maxY: i
            };
        }
        function yc(t1, e1) {
            return e1 - t1;
        }
        var mc;
        Mn("FeatureIndex", pc, {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        }), t1.PerformanceMarkers = void 0, (mc = t1.PerformanceMarkers || (t1.PerformanceMarkers = {})).create = "create", mc.load = "load", mc.fullLoad = "fullLoad";
        let gc = null, xc = [];
        const vc = 1e3 / 30, bc = {
            mark (t1) {
                performance.mark(t1);
            },
            frame (t1) {
                const e1 = t1;
                null != gc && xc.push(e1 - gc), gc = e1;
            },
            clearMetrics () {
                gc = null, xc = [], performance.clearMeasures("loadTime"), performance.clearMeasures("fullLoadTime");
                for(const e1 in t1.PerformanceMarkers)performance.clearMarks(t1.PerformanceMarkers[e1]);
            },
            getPerformanceMetrics () {
                performance.measure("loadTime", t1.PerformanceMarkers.create, t1.PerformanceMarkers.load), performance.measure("fullLoadTime", t1.PerformanceMarkers.create, t1.PerformanceMarkers.fullLoad);
                const e1 = performance.getEntriesByName("loadTime")[0].duration, r = performance.getEntriesByName("fullLoadTime")[0].duration, n = xc.length, i = 1 / (xc.reduce((t1, e1)=>t1 + e1, 0) / n / 1e3), a = xc.filter((t1)=>t1 > vc).reduce((t1, e1)=>t1 + (e1 - vc) / vc, 0);
                return {
                    loadTime: e1,
                    fullLoadTime: r,
                    fps: i,
                    percentDroppedFrames: a / (n + a) * 100
                };
            }
        };
        t1.AJAXError = q, t1.ARRAY_TYPE = ps, t1.Actor = class {
            send(t1, e1, r, n, i = !1) {
                const a = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                r && (this.callbacks[a] = r);
                const s = _(this.globalScope) ? void 0 : [];
                return this.target.postMessage({
                    id: a,
                    type: t1,
                    hasCallback: !!r,
                    targetMapId: n,
                    mustQueue: i,
                    sourceMapId: this.mapId,
                    data: Bn(e1, s)
                }, s), {
                    cancel: ()=>{
                        r && delete this.callbacks[a], this.target.postMessage({
                            id: a,
                            type: "<cancel>",
                            targetMapId: n,
                            sourceMapId: this.mapId
                        });
                    }
                };
            }
            receive(t1) {
                const e1 = t1.data, r = e1.id;
                if (r && (!e1.targetMapId || this.mapId === e1.targetMapId)) {
                    if ("<cancel>" === e1.type) {
                        delete this.tasks[r];
                        const t1 = this.cancelCallbacks[r];
                        delete this.cancelCallbacks[r], t1 && t1();
                    } else g() || e1.mustQueue ? (this.tasks[r] = e1, this.taskQueue.push(r), this.invoker.trigger()) : this.processTask(r, e1);
                }
            }
            process() {
                if (!this.taskQueue.length) return;
                const t1 = this.taskQueue.shift(), e1 = this.tasks[t1];
                delete this.tasks[t1], this.taskQueue.length && this.invoker.trigger(), e1 && this.processTask(t1, e1);
            }
            processTask(t1, e1) {
                if ("<response>" === e1.type) {
                    const r = this.callbacks[t1];
                    delete this.callbacks[t1], r && (e1.error ? r(Cn(e1.error)) : r(null, Cn(e1.data)));
                } else {
                    let r = !1;
                    const n = _(this.globalScope) ? void 0 : [], i = e1.hasCallback ? (e1, i)=>{
                        r = !0, delete this.cancelCallbacks[t1], this.target.postMessage({
                            id: t1,
                            type: "<response>",
                            sourceMapId: this.mapId,
                            error: e1 ? Bn(e1) : null,
                            data: Bn(i, n)
                        }, n);
                    } : (t1)=>{
                        r = !0;
                    };
                    let a = null;
                    const s = Cn(e1.data);
                    if (this.parent[e1.type]) a = this.parent[e1.type](e1.sourceMapId, s, i);
                    else if (this.parent.getWorkerSource) {
                        const t1 = e1.type.split(".");
                        a = this.parent.getWorkerSource(e1.sourceMapId, t1[0], s.source)[t1[1]](s, i);
                    } else i(new Error(`Could not find function ${e1.type}`));
                    !r && a && a.cancel && (this.cancelCallbacks[t1] = a.cancel);
                }
            }
            remove() {
                this.invoker.remove(), this.target.removeEventListener("message", this.receive, !1);
            }
            constructor(t1, e1, r){
                this.target = t1, this.parent = e1, this.mapId = r, this.callbacks = {}, this.tasks = {}, this.taskQueue = [], this.cancelCallbacks = {}, u([
                    "receive",
                    "process"
                ], this), this.invoker = new Gu(this.process), this.target.addEventListener("message", this.receive, !1), this.globalScope = g() ? t1 : window;
            }
        }, t1.AlphaImage = zs, t1.CanonicalTileID = ac, t1.CollisionBoxArray = Ni, t1.CollisionCircleLayoutArray = class extends Vi {
        }, t1.Color = Ft, t1.DEMData = uc, t1.DataConstantProperty = li, t1.DictionaryCoder = cc, t1.EXTENT = qa, t1.ErrorEvent = et, t1.EvaluationParameters = Qn, t1.Event = tt, t1.Evented = rt, t1.FeatureIndex = pc, t1.FillBucket = mo, t1.FillExtrusionBucket = Do, t1.GeoJSONFeature = hc, t1.ImageAtlas = Dl, t1.ImagePosition = Ll, t1.LineBucket = Yo, t1.LineStripIndexArray = class extends Ui {
        }, t1.LngLat = Xu, t1.LngLatBounds = Yu, t1.MercatorCoordinate = nc, t1.ONE_EM = ll, t1.OverscaledTileID = oc, t1.PerformanceUtils = bc, t1.PosArray = Qi, t1.Properties = fi, t1.QuadTriangleArray = class extends Fi {
        }, t1.RGBAImage = Bs, t1.RasterBoundsArray = class extends _i {
        }, t1.RequestPerformance = class {
            finish() {
                performance.mark(this._marks.end);
                let t1 = performance.getEntriesByName(this._marks.measure);
                return 0 === t1.length && (performance.measure(this._marks.measure, this._marks.start, this._marks.end), t1 = performance.getEntriesByName(this._marks.measure), performance.clearMarks(this._marks.start), performance.clearMarks(this._marks.end), performance.clearMeasures(this._marks.measure)), t1;
            }
            constructor(t1){
                this._marks = {
                    start: [
                        t1.url,
                        "start"
                    ].join("#"),
                    end: [
                        t1.url,
                        "end"
                    ].join("#"),
                    measure: t1.url.toString()
                }, performance.mark(this._marks.start);
            }
        }, t1.ResourceType = U, t1.SegmentVector = ya, t1.SymbolBucket = Du, t1.Transitionable = ri, t1.TriangleIndexArray = ha, t1.Uniform1f = za, t1.Uniform1i = class extends Ma {
            set(t1) {
                this.current !== t1 && (this.current = t1, this.gl.uniform1i(this.location, t1));
            }
            constructor(t1, e1){
                super(t1, e1), this.current = 0;
            }
        }, t1.Uniform2f = class extends Ma {
            set(t1) {
                t1[0] === this.current[0] && t1[1] === this.current[1] || (this.current = t1, this.gl.uniform2f(this.location, t1[0], t1[1]));
            }
            constructor(t1, e1){
                super(t1, e1), this.current = [
                    0,
                    0
                ];
            }
        }, t1.Uniform3f = class extends Ma {
            set(t1) {
                t1[0] === this.current[0] && t1[1] === this.current[1] && t1[2] === this.current[2] || (this.current = t1, this.gl.uniform3f(this.location, t1[0], t1[1], t1[2]));
            }
            constructor(t1, e1){
                super(t1, e1), this.current = [
                    0,
                    0,
                    0
                ];
            }
        }, t1.Uniform4f = Ba, t1.UniformColor = Ca, t1.UniformMatrix4f = class extends Ma {
            set(t1) {
                if (t1[12] !== this.current[12] || t1[0] !== this.current[0]) return this.current = t1, void this.gl.uniformMatrix4fv(this.location, !1, t1);
                for(let e1 = 1; e1 < 16; e1++)if (t1[e1] !== this.current[e1]) {
                    this.current = t1, this.gl.uniformMatrix4fv(this.location, !1, t1);
                    break;
                }
            }
            constructor(t1, e1){
                super(t1, e1), this.current = Pa;
            }
        }, t1.UnwrappedTileID = sc, t1.ValidationError = it, t1.ZoomHistory = Pn, t1.add = function(t1, e1, r) {
            return t1[0] = e1[0] + r[0], t1[1] = e1[1] + r[1], t1[2] = e1[2] + r[2], t1;
        }, t1.addDynamicAttributes = Eu, t1.asyncAll = function(t1, e1, r) {
            if (!t1.length) return r(null, []);
            let n = t1.length;
            const i = new Array(t1.length);
            let a = null;
            t1.forEach((t1, s)=>{
                e1(t1, (t1, e1)=>{
                    t1 && (a = t1), i[s] = e1, 0 == --n && r(a, i);
                });
            });
        }, t1.bezier = n, t1.bindAll = u, t1.cacheEntryPossiblyAdded = function(t1) {
            F++, F > V && (t1.getActor().send("enforceCacheSizeLimit", P), F = 0);
        }, t1.clamp = a, t1.clearTileCache = function(t1) {
            const e1 = caches.delete(z);
            t1 && e1.catch(t1).then(()=>t1());
        }, t1.clipLine = cu, t1.clone = function(t1) {
            var e1 = new ps(16);
            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
        }, t1.clone$1 = p, t1.clone$2 = function(t1) {
            var e1 = new ps(3);
            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1;
        }, t1.collisionCircleLayout = al, t1.config = M, t1.copy = function(t1, e1) {
            return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[4] = e1[4], t1[5] = e1[5], t1[6] = e1[6], t1[7] = e1[7], t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
        }, t1.create = function() {
            var t1 = new ps(16);
            return ps != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0), t1[0] = 1, t1[5] = 1, t1[10] = 1, t1[15] = 1, t1;
        }, t1.create$1 = fs, t1.createExpression = Fr, t1.createFilter = Jr, t1.createLayout = vi, t1.createStyleLayer = function(t1) {
            return "custom" === t1.type ? new Zu(t1) : new Ku[t1.type](t1);
        }, t1.cross = function(t1, e1, r) {
            var n = e1[0], i = e1[1], a = e1[2], s = r[0], o = r[1], l = r[2];
            return t1[0] = i * l - a * o, t1[1] = a * s - n * l, t1[2] = n * o - i * s, t1;
        }, t1.dot = function(t1, e1) {
            return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2];
        }, t1.dot$1 = function(t1, e1) {
            return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2] + t1[3] * e1[3];
        }, t1.ease = i, t1.emitValidationErrors = kn, t1.enforceCacheSizeLimit = function(t1) {
            E(), B && B.then((e1)=>{
                e1.keys().then((r)=>{
                    for(let n = 0; n < r.length - t1; n++)e1.delete(r[n]);
                });
            });
        }, t1.equals = function(t1, e1) {
            var r = t1[0], n = t1[1], i = t1[2], a = t1[3], s = t1[4], o = t1[5], l = t1[6], u = t1[7], c = t1[8], h = t1[9], p = t1[10], f = t1[11], d = t1[12], y = t1[13], m = t1[14], g = t1[15], x = e1[0], v = e1[1], b = e1[2], w = e1[3], _ = e1[4], A = e1[5], k = e1[6], S = e1[7], I = e1[8], M = e1[9], z = e1[10], B = e1[11], C = e1[12], P = e1[13], V = e1[14], E = e1[15];
            return Math.abs(r - x) <= hs * Math.max(1, Math.abs(r), Math.abs(x)) && Math.abs(n - v) <= hs * Math.max(1, Math.abs(n), Math.abs(v)) && Math.abs(i - b) <= hs * Math.max(1, Math.abs(i), Math.abs(b)) && Math.abs(a - w) <= hs * Math.max(1, Math.abs(a), Math.abs(w)) && Math.abs(s - _) <= hs * Math.max(1, Math.abs(s), Math.abs(_)) && Math.abs(o - A) <= hs * Math.max(1, Math.abs(o), Math.abs(A)) && Math.abs(l - k) <= hs * Math.max(1, Math.abs(l), Math.abs(k)) && Math.abs(u - S) <= hs * Math.max(1, Math.abs(u), Math.abs(S)) && Math.abs(c - I) <= hs * Math.max(1, Math.abs(c), Math.abs(I)) && Math.abs(h - M) <= hs * Math.max(1, Math.abs(h), Math.abs(M)) && Math.abs(p - z) <= hs * Math.max(1, Math.abs(p), Math.abs(z)) && Math.abs(f - B) <= hs * Math.max(1, Math.abs(f), Math.abs(B)) && Math.abs(d - C) <= hs * Math.max(1, Math.abs(d), Math.abs(C)) && Math.abs(y - P) <= hs * Math.max(1, Math.abs(y), Math.abs(P)) && Math.abs(m - V) <= hs * Math.max(1, Math.abs(m), Math.abs(V)) && Math.abs(g - E) <= hs * Math.max(1, Math.abs(g), Math.abs(E));
        }, t1.evaluateSizeForFeature = function(t1, { uSize: e1, uSizeT: r }, { lowerSize: n, upperSize: i }) {
            return "source" === t1.kind ? n / tu : "composite" === t1.kind ? Se(n / tu, i / tu, r) : e1;
        }, t1.evaluateSizeForZoom = function(t1, e1) {
            let r = 0, n = 0;
            if ("constant" === t1.kind) n = t1.layoutSize;
            else if ("source" !== t1.kind) {
                const { interpolationType: i, minZoom: s, maxZoom: o } = t1, l = i ? a(Ne.interpolationFactor(i, e1, s, o), 0, 1) : 0;
                "camera" === t1.kind ? n = Se(t1.minSize, t1.maxSize, l) : r = l;
            }
            return {
                uSizeT: r,
                uSize: n
            };
        }, t1.evaluateVariableOffset = Au, t1.evented = Xn, t1.exported = k, t1.exported$1 = T, t1.extend = o, t1.filterObject = h, t1.fromRotation = function(t1, e1) {
            var r = Math.sin(e1), n = Math.cos(e1);
            return t1[0] = n, t1[1] = r, t1[2] = 0, t1[3] = -r, t1[4] = n, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 1, t1;
        }, t1.fromScaling = function(t1, e1) {
            return t1[0] = e1[0], t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = e1[1], t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = e1[2], t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
        }, t1.getAnchorAlignment = Yl, t1.getAnchorJustification = ku, t1.getArrayBuffer = K, t1.getImage = H, t1.getJSON = function(t1, e1) {
            return Z(o(t1, {
                type: "json"
            }), e1);
        }, t1.getOverlapMode = qu, t1.getRTLTextPluginStatus = Yn, t1.getReferrer = j, t1.getVideo = function(t1, e1) {
            const r = window.document.createElement("video");
            r.muted = !0, r.onloadstart = function() {
                e1(null, r);
            };
            for(let e1 = 0; e1 < t1.length; e1++){
                const n = window.document.createElement("source");
                G(t1[e1]) || (r.crossOrigin = "Anonymous"), n.src = t1[e1], r.appendChild(n);
            }
            return {
                cancel: ()=>{}
            };
        }, t1.identity = ds, t1.invert = function(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], a = e1[3], s = e1[4], o = e1[5], l = e1[6], u = e1[7], c = e1[8], h = e1[9], p = e1[10], f = e1[11], d = e1[12], y = e1[13], m = e1[14], g = e1[15], x = r * o - n * s, v = r * l - i * s, b = r * u - a * s, w = n * l - i * o, _ = n * u - a * o, A = i * u - a * l, k = c * y - h * d, S = c * m - p * d, I = c * g - f * d, M = h * m - p * y, z = h * g - f * y, B = p * g - f * m, C = x * B - v * z + b * M + w * I - _ * S + A * k;
            return C ? (t1[0] = (o * B - l * z + u * M) * (C = 1 / C), t1[1] = (i * z - n * B - a * M) * C, t1[2] = (y * A - m * _ + g * w) * C, t1[3] = (p * _ - h * A - f * w) * C, t1[4] = (l * I - s * B - u * S) * C, t1[5] = (r * B - i * I + a * S) * C, t1[6] = (m * b - d * A - g * v) * C, t1[7] = (c * A - p * b + f * v) * C, t1[8] = (s * z - o * I + u * k) * C, t1[9] = (n * I - r * z - a * k) * C, t1[10] = (d * _ - y * b + g * x) * C, t1[11] = (h * b - c * _ - f * x) * C, t1[12] = (o * S - s * M - l * k) * C, t1[13] = (r * M - n * S + i * k) * C, t1[14] = (y * v - d * w - m * x) * C, t1[15] = (c * w - h * v + p * x) * C, t1) : null;
        }, t1.isImageBitmap = A, t1.isSafari = _, t1.isWorker = g, t1.keysDifference = function(t1, e1) {
            const r = [];
            for(const n in t1)n in e1 || r.push(n);
            return r;
        }, t1.lazyLoadRTLTextPlugin = function() {
            Wn.isLoading() || Wn.isLoaded() || "deferred" !== Yn() || Hn();
        }, t1.makeRequest = Z, t1.mapObject = c, t1.mercatorXfromLng = Qu, t1.mercatorYfromLat = tc, t1.mercatorZfromAltitude = ec, t1.mul = gs, t1.mul$1 = function(t1, e1, r) {
            return t1[0] = e1[0] * r[0], t1[1] = e1[1] * r[1], t1[2] = e1[2] * r[2], t1[3] = e1[3] * r[3], t1;
        }, t1.multiply = ys, t1.nextPowerOfTwo = function(t1) {
            return t1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t1) / Math.LN2));
        }, t1.normalize = function(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], a = r * r + n * n + i * i;
            return a > 0 && (a = 1 / Math.sqrt(a)), t1[0] = e1[0] * a, t1[1] = e1[1] * a, t1[2] = e1[2] * a, t1;
        }, t1.number = Se, t1.ortho = function(t1, e1, r, n, i, a, s) {
            var o = 1 / (e1 - r), l = 1 / (n - i), u = 1 / (a - s);
            return t1[0] = -2 * o, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * l, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 2 * u, t1[11] = 0, t1[12] = (e1 + r) * o, t1[13] = (i + n) * l, t1[14] = (s + a) * u, t1[15] = 1, t1;
        }, t1.parseCacheControl = x, t1.parseGlyphPbf = function(t1) {
            return new ul(t1).readFields(Vl, []);
        }, t1.pbf = ul, t1.performSymbolLayout = function(e1) {
            e1.bucket.createArrays(), e1.bucket.tilePixelRatio = qa / (512 * e1.bucket.overscaling), e1.bucket.compareText = {}, e1.bucket.iconsNeedLinear = !1;
            const r = e1.bucket.layers[0].layout, n = e1.bucket.layers[0]._unevaluatedLayout._values, i = {
                layoutIconSize: n["icon-size"].possiblyEvaluate(new Qn(e1.bucket.zoom + 1), e1.canonical),
                layoutTextSize: n["text-size"].possiblyEvaluate(new Qn(e1.bucket.zoom + 1), e1.canonical),
                textMaxSize: n["text-size"].possiblyEvaluate(new Qn(18))
            };
            if ("composite" === e1.bucket.textSizeData.kind) {
                const { minZoom: t1, maxZoom: r } = e1.bucket.textSizeData;
                i.compositeTextSizes = [
                    n["text-size"].possiblyEvaluate(new Qn(t1), e1.canonical),
                    n["text-size"].possiblyEvaluate(new Qn(r), e1.canonical)
                ];
            }
            if ("composite" === e1.bucket.iconSizeData.kind) {
                const { minZoom: t1, maxZoom: r } = e1.bucket.iconSizeData;
                i.compositeIconSizes = [
                    n["icon-size"].possiblyEvaluate(new Qn(t1), e1.canonical),
                    n["icon-size"].possiblyEvaluate(new Qn(r), e1.canonical)
                ];
            }
            const a = r.get("text-line-height") * ll, s = "viewport" !== r.get("text-rotation-alignment") && "point" !== r.get("symbol-placement"), o = r.get("text-keep-upright"), l = r.get("text-size");
            for (const n of e1.bucket.features){
                const u = r.get("text-font").evaluate(n, {}, e1.canonical).join(","), c = l.evaluate(n, {}, e1.canonical), h = i.layoutTextSize.evaluate(n, {}, e1.canonical), p = i.layoutIconSize.evaluate(n, {}, e1.canonical), f = {
                    horizontal: {},
                    vertical: void 0
                }, y = n.text;
                let m, g = [
                    0,
                    0
                ];
                if (y) {
                    const i = y.toString(), l = r.get("text-letter-spacing").evaluate(n, {}, e1.canonical) * ll, p = Fn(i) ? l : 0, d = r.get("text-anchor").evaluate(n, {}, e1.canonical), m = r.get("text-variable-anchor");
                    if (!m) {
                        const t1 = r.get("text-radial-offset").evaluate(n, {}, e1.canonical);
                        g = t1 ? Au(d, [
                            t1 * ll,
                            _u
                        ]) : r.get("text-offset").evaluate(n, {}, e1.canonical).map((t1)=>t1 * ll);
                    }
                    let x = s ? "center" : r.get("text-justify").evaluate(n, {}, e1.canonical);
                    const v = r.get("symbol-placement"), b = "point" === v ? r.get("text-max-width").evaluate(n, {}, e1.canonical) * ll : 0, w = ()=>{
                        e1.bucket.allowVerticalPlacement && En(i) && (f.vertical = Ul(y, e1.glyphMap, e1.glyphPositions, e1.imagePositions, u, b, a, d, "left", p, g, t1.WritingMode.vertical, !0, v, h, c));
                    };
                    if (!s && m) {
                        const r = "auto" === x ? m.map((t1)=>ku(t1)) : [
                            x
                        ];
                        let n = !1;
                        for(let i = 0; i < r.length; i++){
                            const s = r[i];
                            if (!f.horizontal[s]) {
                                if (n) f.horizontal[s] = f.horizontal[0];
                                else {
                                    const r = Ul(y, e1.glyphMap, e1.glyphPositions, e1.imagePositions, u, b, a, "center", s, p, g, t1.WritingMode.horizontal, !1, v, h, c);
                                    r && (f.horizontal[s] = r, n = 1 === r.positionedLines.length);
                                }
                            }
                        }
                        w();
                    } else {
                        "auto" === x && (x = ku(d));
                        const r = Ul(y, e1.glyphMap, e1.glyphPositions, e1.imagePositions, u, b, a, d, x, p, g, t1.WritingMode.horizontal, !1, v, h, c);
                        r && (f.horizontal[x] = r), w(), En(i) && s && o && (f.vertical = Ul(y, e1.glyphMap, e1.glyphPositions, e1.imagePositions, u, b, a, d, x, p, g, t1.WritingMode.vertical, !1, v, h, c));
                    }
                }
                let x = !1;
                if (n.icon && n.icon.name) {
                    const t1 = e1.imageMap[n.icon.name];
                    t1 && (m = Wl(e1.imagePositions[n.icon.name], r.get("icon-offset").evaluate(n, {}, e1.canonical), r.get("icon-anchor").evaluate(n, {}, e1.canonical)), x = !!t1.sdf, void 0 === e1.bucket.sdfIcons ? e1.bucket.sdfIcons = x : e1.bucket.sdfIcons !== x && d("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (t1.pixelRatio !== e1.bucket.pixelRatio || 0 !== r.get("icon-rotate").constantOr(1)) && (e1.bucket.iconsNeedLinear = !0));
                }
                const v = zu(f.horizontal) || f.vertical;
                e1.bucket.iconsInText = !!v && v.iconsInText, (v || m) && Su(e1.bucket, n, f, m, e1.imageMap, i, h, p, g, x, e1.canonical);
            }
            e1.showCollisionBoxes && e1.bucket.generateCollisionDebugBuffers();
        }, t1.perspective = function(t1, e1, r, n, i) {
            var a, s = 1 / Math.tan(e1 / 2);
            return t1[0] = s / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = s, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[15] = 0, null != i && i !== 1 / 0 ? (t1[10] = (i + n) * (a = 1 / (n - i)), t1[14] = 2 * i * n * a) : (t1[10] = -1, t1[14] = -2 * n), t1;
        }, t1.pick = function(t1, e1) {
            const r = {};
            for(let n = 0; n < e1.length; n++){
                const i = e1[n];
                i in t1 && (r[i] = t1[i]);
            }
            return r;
        }, t1.plugin = Wn, t1.pointGeometry = S, t1.polygonIntersectsPolygon = Xa, t1.potpack = Tl, t1.refProperties = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ], t1.register = Mn, t1.registerForPluginStateChange = function(t1) {
            return t1({
                pluginStatus: Zn,
                pluginURL: Kn
            }), Xn.on("pluginStateChange", t1), t1;
        }, t1.renderColorRamp = Cs, t1.rotateX = function(t1, e1, r) {
            var n = Math.sin(r), i = Math.cos(r), a = e1[4], s = e1[5], o = e1[6], l = e1[7], u = e1[8], c = e1[9], h = e1[10], p = e1[11];
            return e1 !== t1 && (t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[4] = a * i + u * n, t1[5] = s * i + c * n, t1[6] = o * i + h * n, t1[7] = l * i + p * n, t1[8] = u * i - a * n, t1[9] = c * i - s * n, t1[10] = h * i - o * n, t1[11] = p * i - l * n, t1;
        }, t1.rotateZ = function(t1, e1, r) {
            var n = Math.sin(r), i = Math.cos(r), a = e1[0], s = e1[1], o = e1[2], l = e1[3], u = e1[4], c = e1[5], h = e1[6], p = e1[7];
            return e1 !== t1 && (t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[0] = a * i + u * n, t1[1] = s * i + c * n, t1[2] = o * i + h * n, t1[3] = l * i + p * n, t1[4] = u * i - a * n, t1[5] = c * i - s * n, t1[6] = h * i - o * n, t1[7] = p * i - l * n, t1;
        }, t1.scale = function(t1, e1, r) {
            var n = r[0], i = r[1], a = r[2];
            return t1[0] = e1[0] * n, t1[1] = e1[1] * n, t1[2] = e1[2] * n, t1[3] = e1[3] * n, t1[4] = e1[4] * i, t1[5] = e1[5] * i, t1[6] = e1[6] * i, t1[7] = e1[7] * i, t1[8] = e1[8] * a, t1[9] = e1[9] * a, t1[10] = e1[10] * a, t1[11] = e1[11] * a, t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
        }, t1.scale$1 = function(t1, e1, r) {
            return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1;
        }, t1.setCacheLimits = function(t1, e1) {
            P = t1, V = e1;
        }, t1.setRTLTextPlugin = function(t1, e1, r = !1) {
            if (Zn === Un || Zn === qn || Zn === jn) throw new Error("setRTLTextPlugin cannot be called multiple times.");
            Kn = k.resolveURL(t1), Zn = Un, Nn = e1, Jn(), r || Hn();
        }, t1.spec = nt, t1.sphericalToCartesian = function([t1, e1, r]) {
            return e1 += 90, e1 *= Math.PI / 180, r *= Math.PI / 180, {
                x: t1 * Math.cos(e1) * Math.sin(r),
                y: t1 * Math.sin(e1) * Math.sin(r),
                z: t1 * Math.cos(r)
            };
        }, t1.sqrLen = function(t1) {
            var e1 = t1[0], r = t1[1];
            return e1 * e1 + r * r;
        }, t1.sub = function(t1, e1, r) {
            return t1[0] = e1[0] - r[0], t1[1] = e1[1] - r[1], t1[2] = e1[2] - r[2], t1;
        }, t1.toEvaluationFeature = Ka, t1.transformMat3 = function(t1, e1, r) {
            var n = e1[0], i = e1[1], a = e1[2];
            return t1[0] = n * r[0] + i * r[3] + a * r[6], t1[1] = n * r[1] + i * r[4] + a * r[7], t1[2] = n * r[2] + i * r[5] + a * r[8], t1;
        }, t1.transformMat4 = bs, t1.transformMat4$1 = function(t1, e1, r) {
            var n = e1[0], i = e1[1];
            return t1[0] = r[0] * n + r[4] * i + r[12], t1[1] = r[1] * n + r[5] * i + r[13], t1;
        }, t1.translate = function(t1, e1, r) {
            var n, i, a, s, o, l, u, c, h, p, f, d, y = r[0], m = r[1], g = r[2];
            return e1 === t1 ? (t1[12] = e1[0] * y + e1[4] * m + e1[8] * g + e1[12], t1[13] = e1[1] * y + e1[5] * m + e1[9] * g + e1[13], t1[14] = e1[2] * y + e1[6] * m + e1[10] * g + e1[14], t1[15] = e1[3] * y + e1[7] * m + e1[11] * g + e1[15]) : (i = e1[1], a = e1[2], s = e1[3], o = e1[4], l = e1[5], u = e1[6], c = e1[7], h = e1[8], p = e1[9], f = e1[10], d = e1[11], t1[0] = n = e1[0], t1[1] = i, t1[2] = a, t1[3] = s, t1[4] = o, t1[5] = l, t1[6] = u, t1[7] = c, t1[8] = h, t1[9] = p, t1[10] = f, t1[11] = d, t1[12] = n * y + o * m + h * g + e1[12], t1[13] = i * y + l * m + p * g + e1[13], t1[14] = a * y + u * m + f * g + e1[14], t1[15] = s * y + c * m + d * g + e1[15]), t1;
        }, t1.triggerPluginCompletionEvent = Gn, t1.unicodeBlockLookup = Vn, t1.uniqueId = function() {
            return l++;
        }, t1.validateCustomStyleLayer = function(t1) {
            const e1 = [], r = t1.id;
            return void 0 === r && e1.push({
                message: `layers.${r}: missing required property "id"`
            }), void 0 === t1.render && e1.push({
                message: `layers.${r}: missing required method "render"`
            }), t1.renderingMode && "2d" !== t1.renderingMode && "3d" !== t1.renderingMode && e1.push({
                message: `layers.${r}: property "renderingMode" must be either "2d" or "3d"`
            }), e1;
        }, t1.validateLight = wn, t1.validateStyle = bn, t1.vectorTile = _o, t1.warnOnce = d, t1.wrap = s;
    });
    define([
        "./shared"
    ], function(e1) {
        "use strict";
        function t1(e1) {
            const o = typeof e1;
            if ("number" === o || "boolean" === o || "string" === o || null == e1) return JSON.stringify(e1);
            if (Array.isArray(e1)) {
                let o = "[";
                for (const i of e1)o += `${t1(i)},`;
                return `${o}]`;
            }
            const i = Object.keys(e1).sort();
            let r = "{";
            for(let o = 0; o < i.length; o++)r += `${JSON.stringify(i[o])}:${t1(e1[i[o]])},`;
            return `${r}}`;
        }
        function o(o) {
            let i = "";
            for (const r of e1.refProperties)i += `/${t1(o[r])}`;
            return i;
        }
        class i {
            replace(e1) {
                this._layerConfigs = {}, this._layers = {}, this.update(e1, []);
            }
            update(t1, i) {
                for (const o of t1){
                    this._layerConfigs[o.id] = o;
                    const t1 = this._layers[o.id] = e1.createStyleLayer(o);
                    t1._featureFilter = e1.createFilter(t1.filter), this.keyCache[o.id] && delete this.keyCache[o.id];
                }
                for (const e1 of i)delete this.keyCache[e1], delete this._layerConfigs[e1], delete this._layers[e1];
                this.familiesBySource = {};
                const r = function(e1, t1) {
                    const i = {};
                    for(let r = 0; r < e1.length; r++){
                        const n = t1 && t1[e1[r].id] || o(e1[r]);
                        t1 && (t1[e1[r].id] = n);
                        let s = i[n];
                        s || (s = i[n] = []), s.push(e1[r]);
                    }
                    const r = [];
                    for(const e1 in i)r.push(i[e1]);
                    return r;
                }(Object.values(this._layerConfigs), this.keyCache);
                for (const e1 of r){
                    const t1 = e1.map((e1)=>this._layers[e1.id]), o = t1[0];
                    if ("none" === o.visibility) continue;
                    const i = o.source || "";
                    let r = this.familiesBySource[i];
                    r || (r = this.familiesBySource[i] = {});
                    const n = o.sourceLayer || "_geojsonTileLayer";
                    let s = r[n];
                    s || (s = r[n] = []), s.push(t1);
                }
            }
            constructor(e1){
                this.keyCache = {}, e1 && this.replace(e1);
            }
        }
        class r {
            constructor(t1){
                const o = {}, i = [];
                for(const e1 in t1){
                    const r = t1[e1], n = o[e1] = {};
                    for(const e1 in r){
                        const t1 = r[+e1];
                        if (!t1 || 0 === t1.bitmap.width || 0 === t1.bitmap.height) continue;
                        const o = {
                            x: 0,
                            y: 0,
                            w: t1.bitmap.width + 2,
                            h: t1.bitmap.height + 2
                        };
                        i.push(o), n[e1] = {
                            rect: o,
                            metrics: t1.metrics
                        };
                    }
                }
                const { w: r, h: n } = e1.potpack(i), s = new e1.AlphaImage({
                    width: r || 1,
                    height: n || 1
                });
                for(const i in t1){
                    const r = t1[i];
                    for(const t1 in r){
                        const n = r[+t1];
                        if (!n || 0 === n.bitmap.width || 0 === n.bitmap.height) continue;
                        const a = o[i][t1].rect;
                        e1.AlphaImage.copy(n.bitmap, s, {
                            x: 0,
                            y: 0
                        }, {
                            x: a.x + 1,
                            y: a.y + 1
                        }, n.bitmap);
                    }
                }
                this.image = s, this.positions = o;
            }
        }
        e1.register("GlyphAtlas", r);
        class n {
            parse(t1, o, i, n, a) {
                this.status = "parsing", this.data = t1, this.collisionBoxArray = new e1.CollisionBoxArray;
                const l = new e1.DictionaryCoder(Object.keys(t1.layers).sort()), c = new e1.FeatureIndex(this.tileID, this.promoteId);
                c.bucketLayerIDs = [];
                const u = {}, h = {
                    featureIndex: c,
                    iconDependencies: {},
                    patternDependencies: {},
                    glyphDependencies: {},
                    availableImages: i
                }, p = o.familiesBySource[this.source];
                for(const o in p){
                    const r = t1.layers[o];
                    if (!r) continue;
                    1 === r.version && e1.warnOnce(`Vector tile source "${this.source}" layer "${o}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                    const n = l.encode(o), a = [];
                    for(let e1 = 0; e1 < r.length; e1++){
                        const t1 = r.feature(e1), i = c.getId(t1, o);
                        a.push({
                            feature: t1,
                            id: i,
                            index: e1,
                            sourceLayerIndex: n
                        });
                    }
                    for (const t1 of p[o]){
                        const o = t1[0];
                        o.source !== this.source && e1.warnOnce(`layer.source = ${o.source} does not equal this.source = ${this.source}`), o.minzoom && this.zoom < Math.floor(o.minzoom) || o.maxzoom && this.zoom >= o.maxzoom || "none" !== o.visibility && (s(t1, this.zoom, i), (u[o.id] = o.createBucket({
                            index: c.bucketLayerIDs.length,
                            layers: t1,
                            zoom: this.zoom,
                            pixelRatio: this.pixelRatio,
                            overscaling: this.overscaling,
                            collisionBoxArray: this.collisionBoxArray,
                            sourceLayerIndex: n,
                            sourceID: this.source
                        })).populate(a, h, this.tileID.canonical), c.bucketLayerIDs.push(t1.map((e1)=>e1.id)));
                    }
                }
                let f, d, g, m;
                const y = e1.mapObject(h.glyphDependencies, (e1)=>Object.keys(e1).map(Number));
                Object.keys(y).length ? n.send("getGlyphs", {
                    uid: this.uid,
                    stacks: y
                }, (e1, t1)=>{
                    f || (f = e1, d = t1, w.call(this));
                }) : d = {};
                const v = Object.keys(h.iconDependencies);
                v.length ? n.send("getImages", {
                    icons: v,
                    source: this.source,
                    tileID: this.tileID,
                    type: "icons"
                }, (e1, t1)=>{
                    f || (f = e1, g = t1, w.call(this));
                }) : g = {};
                const x = Object.keys(h.patternDependencies);
                function w() {
                    if (f) return a(f);
                    if (d && g && m) {
                        const t1 = new r(d), o = new e1.ImageAtlas(g, m);
                        for(const r in u){
                            const n = u[r];
                            n instanceof e1.SymbolBucket ? (s(n.layers, this.zoom, i), e1.performSymbolLayout({
                                bucket: n,
                                glyphMap: d,
                                glyphPositions: t1.positions,
                                imageMap: g,
                                imagePositions: o.iconPositions,
                                showCollisionBoxes: this.showCollisionBoxes,
                                canonical: this.tileID.canonical
                            })) : n.hasPattern && (n instanceof e1.LineBucket || n instanceof e1.FillBucket || n instanceof e1.FillExtrusionBucket) && (s(n.layers, this.zoom, i), n.addFeatures(h, this.tileID.canonical, o.patternPositions));
                        }
                        this.status = "done", a(null, {
                            buckets: Object.values(u).filter((e1)=>!e1.isEmpty()),
                            featureIndex: c,
                            collisionBoxArray: this.collisionBoxArray,
                            glyphAtlasImage: t1.image,
                            imageAtlas: o,
                            glyphMap: this.returnDependencies ? d : null,
                            iconMap: this.returnDependencies ? g : null,
                            glyphPositions: this.returnDependencies ? t1.positions : null
                        });
                    }
                }
                x.length ? n.send("getImages", {
                    icons: x,
                    source: this.source,
                    tileID: this.tileID,
                    type: "patterns"
                }, (e1, t1)=>{
                    f || (f = e1, m = t1, w.call(this));
                }) : m = {}, w.call(this);
            }
            constructor(t1){
                this.tileID = new e1.OverscaledTileID(t1.tileID.overscaledZ, t1.tileID.wrap, t1.tileID.canonical.z, t1.tileID.canonical.x, t1.tileID.canonical.y), this.uid = t1.uid, this.zoom = t1.zoom, this.pixelRatio = t1.pixelRatio, this.tileSize = t1.tileSize, this.source = t1.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t1.showCollisionBoxes, this.collectResourceTiming = !!t1.collectResourceTiming, this.returnDependencies = !!t1.returnDependencies, this.promoteId = t1.promoteId;
            }
        }
        function s(t1, o, i) {
            const r = new e1.EvaluationParameters(o);
            for (const e1 of t1)e1.recalculate(r, i);
        }
        function a(t1, o) {
            const i = e1.getArrayBuffer(t1.request, (t1, i, r, n)=>{
                t1 ? o(t1) : i && o(null, {
                    vectorTile: new e1.vectorTile.VectorTile(new e1.pbf(i)),
                    rawData: i,
                    cacheControl: r,
                    expires: n
                });
            });
            return ()=>{
                i.cancel(), o();
            };
        }
        class l {
            loadTile(t1, o) {
                const i = t1.uid;
                this.loading || (this.loading = {});
                const r = !!(t1 && t1.request && t1.request.collectResourceTiming) && new e1.RequestPerformance(t1.request), s = this.loading[i] = new n(t1);
                s.abort = this.loadVectorData(t1, (t1, n)=>{
                    if (delete this.loading[i], t1 || !n) return s.status = "done", this.loaded[i] = s, o(t1);
                    const a = n.rawData, l = {};
                    n.expires && (l.expires = n.expires), n.cacheControl && (l.cacheControl = n.cacheControl);
                    const c = {};
                    if (r) {
                        const e1 = r.finish();
                        e1 && (c.resourceTiming = JSON.parse(JSON.stringify(e1)));
                    }
                    s.vectorTile = n.vectorTile, s.parse(n.vectorTile, this.layerIndex, this.availableImages, this.actor, (t1, i)=>{
                        if (t1 || !i) return o(t1);
                        o(null, e1.extend({
                            rawTileData: a.slice(0)
                        }, i, l, c));
                    }), this.loaded = this.loaded || {}, this.loaded[i] = s;
                });
            }
            reloadTile(e1, t1) {
                const o = this.loaded, i = e1.uid, r = this;
                if (o && o[i]) {
                    const n = o[i];
                    n.showCollisionBoxes = e1.showCollisionBoxes;
                    const s = (e1, o)=>{
                        const i = n.reloadCallback;
                        i && (delete n.reloadCallback, n.parse(n.vectorTile, r.layerIndex, this.availableImages, r.actor, i)), t1(e1, o);
                    };
                    "parsing" === n.status ? n.reloadCallback = s : "done" === n.status && (n.vectorTile ? n.parse(n.vectorTile, this.layerIndex, this.availableImages, this.actor, s) : s());
                }
            }
            abortTile(e1, t1) {
                const o = this.loading, i = e1.uid;
                o && o[i] && o[i].abort && (o[i].abort(), delete o[i]), t1();
            }
            removeTile(e1, t1) {
                const o = this.loaded, i = e1.uid;
                o && o[i] && delete o[i], t1();
            }
            constructor(e1, t1, o, i){
                this.actor = e1, this.layerIndex = t1, this.availableImages = o, this.loadVectorData = i || a, this.loading = {}, this.loaded = {};
            }
        }
        class c {
            loadTile(t1, o) {
                const { uid: i, encoding: r, rawImageData: n } = t1, s = e1.isImageBitmap(n) ? this.getImageData(n) : n, a = new e1.DEMData(i, s, r);
                this.loaded = this.loaded || {}, this.loaded[i] = a, o(null, a);
            }
            getImageData(t1) {
                this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(t1.width, t1.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d")), this.offscreenCanvas.width = t1.width, this.offscreenCanvas.height = t1.height, this.offscreenCanvasContext.drawImage(t1, 0, 0, t1.width, t1.height);
                const o = this.offscreenCanvasContext.getImageData(-1, -1, t1.width + 2, t1.height + 2);
                return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), new e1.RGBAImage({
                    width: o.width,
                    height: o.height
                }, o.data);
            }
            removeTile(e1) {
                const t1 = this.loaded, o = e1.uid;
                t1 && t1[o] && delete t1[o];
            }
            constructor(){
                this.loaded = {};
            }
        }
        var u = function e1(t1, o) {
            var i, r = t1 && t1.type;
            if ("FeatureCollection" === r) for(i = 0; i < t1.features.length; i++)e1(t1.features[i], o);
            else if ("GeometryCollection" === r) for(i = 0; i < t1.geometries.length; i++)e1(t1.geometries[i], o);
            else if ("Feature" === r) e1(t1.geometry, o);
            else if ("Polygon" === r) h(t1.coordinates, o);
            else if ("MultiPolygon" === r) for(i = 0; i < t1.coordinates.length; i++)h(t1.coordinates[i], o);
            return t1;
        };
        function h(e1, t1) {
            if (0 !== e1.length) {
                p(e1[0], t1);
                for(var o = 1; o < e1.length; o++)p(e1[o], !t1);
            }
        }
        function p(e1, t1) {
            for(var o = 0, i = 0, r = 0, n = e1.length, s = n - 1; r < n; s = r++){
                var a = (e1[r][0] - e1[s][0]) * (e1[s][1] + e1[r][1]), l = o + a;
                i += Math.abs(o) >= Math.abs(a) ? o - l + a : a - l + o, o = l;
            }
            o + i >= 0 != !!t1 && e1.reverse();
        }
        const f = e1.vectorTile.VectorTileFeature.prototype.toGeoJSON;
        class d {
            loadGeometry() {
                if (1 === this._feature.type) {
                    const t1 = [];
                    for (const o of this._feature.geometry)t1.push([
                        new e1.pointGeometry(o[0], o[1])
                    ]);
                    return t1;
                }
                {
                    const t1 = [];
                    for (const o of this._feature.geometry){
                        const i = [];
                        for (const t1 of o)i.push(new e1.pointGeometry(t1[0], t1[1]));
                        t1.push(i);
                    }
                    return t1;
                }
            }
            toGeoJSON(e1, t1, o) {
                return f.call(this, e1, t1, o);
            }
            constructor(t1){
                this._feature = t1, this.extent = e1.EXTENT, this.type = t1.type, this.properties = t1.tags, "id" in t1 && !isNaN(t1.id) && (this.id = parseInt(t1.id, 10));
            }
        }
        class g {
            feature(e1) {
                return new d(this._features[e1]);
            }
            constructor(t1){
                this.layers = {
                    _geojsonTileLayer: this
                }, this.name = "_geojsonTileLayer", this.extent = e1.EXTENT, this.length = t1.length, this._features = t1;
            }
        }
        var m = {
            exports: {}
        }, y = e1.pointGeometry, v = e1.vectorTile.VectorTileFeature, x = w;
        function w(e1, t1) {
            this.options = t1 || {}, this.features = e1, this.length = e1.length;
        }
        function S(e1, t1) {
            this.id = "number" == typeof e1.id ? e1.id : void 0, this.type = e1.type, this.rawGeometry = 1 === e1.type ? [
                e1.geometry
            ] : e1.geometry, this.properties = e1.tags, this.extent = t1 || 4096;
        }
        w.prototype.feature = function(e1) {
            return new S(this.features[e1], this.options.extent);
        }, S.prototype.loadGeometry = function() {
            var e1 = this.rawGeometry;
            this.geometry = [];
            for(var t1 = 0; t1 < e1.length; t1++){
                for(var o = e1[t1], i = [], r = 0; r < o.length; r++)i.push(new y(o[r][0], o[r][1]));
                this.geometry.push(i);
            }
            return this.geometry;
        }, S.prototype.bbox = function() {
            this.geometry || this.loadGeometry();
            for(var e1 = this.geometry, t1 = 1 / 0, o = -1 / 0, i = 1 / 0, r = -1 / 0, n = 0; n < e1.length; n++)for(var s = e1[n], a = 0; a < s.length; a++){
                var l = s[a];
                t1 = Math.min(t1, l.x), o = Math.max(o, l.x), i = Math.min(i, l.y), r = Math.max(r, l.y);
            }
            return [
                t1,
                i,
                o,
                r
            ];
        }, S.prototype.toGeoJSON = v.prototype.toGeoJSON;
        var M = e1.pbf, I = x;
        function b(e1) {
            var t1 = new M;
            return function(e1, t1) {
                for(var o in e1.layers)t1.writeMessage(3, k, e1.layers[o]);
            }(e1, t1), t1.finish();
        }
        function k(e1, t1) {
            var o;
            t1.writeVarintField(15, e1.version || 1), t1.writeStringField(1, e1.name || ""), t1.writeVarintField(5, e1.extent || 4096);
            var i = {
                keys: [],
                values: [],
                keycache: {},
                valuecache: {}
            };
            for(o = 0; o < e1.length; o++)i.feature = e1.feature(o), t1.writeMessage(2, P, i);
            var r = i.keys;
            for(o = 0; o < r.length; o++)t1.writeStringField(3, r[o]);
            var n = i.values;
            for(o = 0; o < n.length; o++)t1.writeMessage(4, L, n[o]);
        }
        function P(e1, t1) {
            var o = e1.feature;
            void 0 !== o.id && t1.writeVarintField(1, o.id), t1.writeMessage(2, T, e1), t1.writeVarintField(3, o.type), t1.writeMessage(4, D, o);
        }
        function T(e1, t1) {
            var o = e1.feature, i = e1.keys, r = e1.values, n = e1.keycache, s = e1.valuecache;
            for(var a in o.properties){
                var l = o.properties[a], c = n[a];
                if (null !== l) {
                    void 0 === c && (i.push(a), n[a] = c = i.length - 1), t1.writeVarint(c);
                    var u = typeof l;
                    "string" !== u && "boolean" !== u && "number" !== u && (l = JSON.stringify(l));
                    var h = u + ":" + l, p = s[h];
                    void 0 === p && (r.push(l), s[h] = p = r.length - 1), t1.writeVarint(p);
                }
            }
        }
        function C(e1, t1) {
            return (t1 << 3) + (7 & e1);
        }
        function _(e1) {
            return e1 << 1 ^ e1 >> 31;
        }
        function D(e1, t1) {
            for(var o = e1.loadGeometry(), i = e1.type, r = 0, n = 0, s = o.length, a = 0; a < s; a++){
                var l = o[a], c = 1;
                1 === i && (c = l.length), t1.writeVarint(C(1, c));
                for(var u = 3 === i ? l.length - 1 : l.length, h = 0; h < u; h++){
                    1 === h && 1 !== i && t1.writeVarint(C(2, u - 1));
                    var p = l[h].x - r, f = l[h].y - n;
                    t1.writeVarint(_(p)), t1.writeVarint(_(f)), r += p, n += f;
                }
                3 === i && t1.writeVarint(C(7, 1));
            }
        }
        function L(e1, t1) {
            var o = typeof e1;
            "string" === o ? t1.writeStringField(1, e1) : "boolean" === o ? t1.writeBooleanField(7, e1) : "number" === o && (e1 % 1 != 0 ? t1.writeDoubleField(3, e1) : e1 < 0 ? t1.writeSVarintField(6, e1) : t1.writeVarintField(5, e1));
        }
        function z(e1, t1, o, i, r, n) {
            if (r - i <= o) return;
            const s = i + r >> 1;
            O(e1, t1, s, i, r, n % 2), z(e1, t1, o, i, s - 1, n + 1), z(e1, t1, o, s + 1, r, n + 1);
        }
        function O(e1, t1, o, i, r, n) {
            for(; r > i;){
                if (r - i > 600) {
                    const s = r - i + 1, a = o - i + 1, l = Math.log(s), c = .5 * Math.exp(2 * l / 3), u = .5 * Math.sqrt(l * c * (s - c) / s) * (a - s / 2 < 0 ? -1 : 1);
                    O(e1, t1, o, Math.max(i, Math.floor(o - a * c / s + u)), Math.min(r, Math.floor(o + (s - a) * c / s + u)), n);
                }
                const s = t1[2 * o + n];
                let a = i, l = r;
                for(E(e1, t1, i, o), t1[2 * r + n] > s && E(e1, t1, i, r); a < l;){
                    for(E(e1, t1, a, l), a++, l--; t1[2 * a + n] < s;)a++;
                    for(; t1[2 * l + n] > s;)l--;
                }
                t1[2 * i + n] === s ? E(e1, t1, i, l) : (l++, E(e1, t1, l, r)), l <= o && (i = l + 1), o <= l && (r = l - 1);
            }
        }
        function E(e1, t1, o, i) {
            F(e1, o, i), F(t1, 2 * o, 2 * i), F(t1, 2 * o + 1, 2 * i + 1);
        }
        function F(e1, t1, o) {
            const i = e1[t1];
            e1[t1] = e1[o], e1[o] = i;
        }
        function N(e1, t1, o, i) {
            const r = e1 - o, n = t1 - i;
            return r * r + n * n;
        }
        m.exports = b, m.exports.fromVectorTileJs = b, m.exports.fromGeojsonVt = function(e1, t1) {
            t1 = t1 || {};
            var o = {};
            for(var i in e1)o[i] = new I(e1[i].features, t1), o[i].name = i, o[i].version = t1.version, o[i].extent = t1.extent;
            return b({
                layers: o
            });
        }, m.exports.GeoJSONWrapper = I;
        const A = (e1)=>e1[0], B = (e1)=>e1[1];
        class J {
            range(e1, t1, o, i) {
                return function(e1, t1, o, i, r, n, s) {
                    const a = [
                        0,
                        e1.length - 1,
                        0
                    ], l = [];
                    let c, u;
                    for(; a.length;){
                        const h = a.pop(), p = a.pop(), f = a.pop();
                        if (p - f <= s) {
                            for(let s = f; s <= p; s++)c = t1[2 * s], u = t1[2 * s + 1], c >= o && c <= r && u >= i && u <= n && l.push(e1[s]);
                            continue;
                        }
                        const d = Math.floor((f + p) / 2);
                        c = t1[2 * d], u = t1[2 * d + 1], c >= o && c <= r && u >= i && u <= n && l.push(e1[d]);
                        const g = (h + 1) % 2;
                        (0 === h ? o <= c : i <= u) && (a.push(f), a.push(d - 1), a.push(g)), (0 === h ? r >= c : n >= u) && (a.push(d + 1), a.push(p), a.push(g));
                    }
                    return l;
                }(this.ids, this.coords, e1, t1, o, i, this.nodeSize);
            }
            within(e1, t1, o) {
                return function(e1, t1, o, i, r, n) {
                    const s = [
                        0,
                        e1.length - 1,
                        0
                    ], a = [], l = r * r;
                    for(; s.length;){
                        const c = s.pop(), u = s.pop(), h = s.pop();
                        if (u - h <= n) {
                            for(let r = h; r <= u; r++)N(t1[2 * r], t1[2 * r + 1], o, i) <= l && a.push(e1[r]);
                            continue;
                        }
                        const p = Math.floor((h + u) / 2), f = t1[2 * p], d = t1[2 * p + 1];
                        N(f, d, o, i) <= l && a.push(e1[p]);
                        const g = (c + 1) % 2;
                        (0 === c ? o - r <= f : i - r <= d) && (s.push(h), s.push(p - 1), s.push(g)), (0 === c ? o + r >= f : i + r >= d) && (s.push(p + 1), s.push(u), s.push(g));
                    }
                    return a;
                }(this.ids, this.coords, e1, t1, o, this.nodeSize);
            }
            constructor(e1, t1 = A, o = B, i = 64, r = Float64Array){
                this.nodeSize = i, this.points = e1;
                const n = e1.length < 65536 ? Uint16Array : Uint32Array, s = this.ids = new n(e1.length), a = this.coords = new r(2 * e1.length);
                for(let i = 0; i < e1.length; i++)s[i] = i, a[2 * i] = t1(e1[i]), a[2 * i + 1] = o(e1[i]);
                z(s, a, i, 0, s.length - 1, 0);
            }
        }
        const Z = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e1)=>e1
        }, G = Math.fround || (j = new Float32Array(1), (e1)=>(j[0] = +e1, j[0]));
        var j;
        class Y {
            load(e1) {
                const { log: t1, minZoom: o, maxZoom: i, nodeSize: r } = this.options;
                t1 && console.time("total time");
                const n = `prepare ${e1.length} points`;
                t1 && console.time(n), this.points = e1;
                let s = [];
                for(let t1 = 0; t1 < e1.length; t1++)e1[t1].geometry && s.push(X(e1[t1], t1));
                this.trees[i + 1] = new J(s, K, Q, r, Float32Array), t1 && console.timeEnd(n);
                for(let e1 = i; e1 >= o; e1--){
                    const o = +Date.now();
                    s = this._cluster(s, e1), this.trees[e1] = new J(s, K, Q, r, Float32Array), t1 && console.log("z%d: %d clusters in %dms", e1, s.length, +Date.now() - o);
                }
                return t1 && console.timeEnd("total time"), this;
            }
            getClusters(e1, t1) {
                let o = ((e1[0] + 180) % 360 + 360) % 360 - 180;
                const i = Math.max(-90, Math.min(90, e1[1]));
                let r = 180 === e1[2] ? 180 : ((e1[2] + 180) % 360 + 360) % 360 - 180;
                const n = Math.max(-90, Math.min(90, e1[3]));
                if (e1[2] - e1[0] >= 360) o = -180, r = 180;
                else if (o > r) {
                    const e1 = this.getClusters([
                        o,
                        i,
                        180,
                        n
                    ], t1), s = this.getClusters([
                        -180,
                        i,
                        r,
                        n
                    ], t1);
                    return e1.concat(s);
                }
                const s = this.trees[this._limitZoom(t1)], a = s.range($(o), q(n), $(r), q(i)), l = [];
                for (const e1 of a){
                    const t1 = s.points[e1];
                    l.push(t1.numPoints ? R(t1) : this.points[t1.index]);
                }
                return l;
            }
            getChildren(e1) {
                const t1 = this._getOriginId(e1), o = this._getOriginZoom(e1), i = "No cluster with the specified id.", r = this.trees[o];
                if (!r) throw new Error(i);
                const n = r.points[t1];
                if (!n) throw new Error(i);
                const s = this.options.radius / (this.options.extent * Math.pow(2, o - 1)), a = r.within(n.x, n.y, s), l = [];
                for (const t1 of a){
                    const o = r.points[t1];
                    o.parentId === e1 && l.push(o.numPoints ? R(o) : this.points[o.index]);
                }
                if (0 === l.length) throw new Error(i);
                return l;
            }
            getLeaves(e1, t1, o) {
                const i = [];
                return this._appendLeaves(i, e1, t1 = t1 || 10, o = o || 0, 0), i;
            }
            getTile(e1, t1, o) {
                const i = this.trees[this._limitZoom(e1)], r = Math.pow(2, e1), { extent: n, radius: s } = this.options, a = s / n, l = (o - a) / r, c = (o + 1 + a) / r, u = {
                    features: []
                };
                return this._addTileFeatures(i.range((t1 - a) / r, l, (t1 + 1 + a) / r, c), i.points, t1, o, r, u), 0 === t1 && this._addTileFeatures(i.range(1 - a / r, l, 1, c), i.points, r, o, r, u), t1 === r - 1 && this._addTileFeatures(i.range(0, l, a / r, c), i.points, -1, o, r, u), u.features.length ? u : null;
            }
            getClusterExpansionZoom(e1) {
                let t1 = this._getOriginZoom(e1) - 1;
                for(; t1 <= this.options.maxZoom;){
                    const o = this.getChildren(e1);
                    if (t1++, 1 !== o.length) break;
                    e1 = o[0].properties.cluster_id;
                }
                return t1;
            }
            _appendLeaves(e1, t1, o, i, r) {
                const n = this.getChildren(t1);
                for (const t1 of n){
                    const n = t1.properties;
                    if (n && n.cluster ? r + n.point_count <= i ? r += n.point_count : r = this._appendLeaves(e1, n.cluster_id, o, i, r) : r < i ? r++ : e1.push(t1), e1.length === o) break;
                }
                return r;
            }
            _addTileFeatures(e1, t1, o, i, r, n) {
                for (const s of e1){
                    const e1 = t1[s], a = e1.numPoints;
                    let l, c, u;
                    if (a) l = W(e1), c = e1.x, u = e1.y;
                    else {
                        const t1 = this.points[e1.index];
                        l = t1.properties, c = $(t1.geometry.coordinates[0]), u = q(t1.geometry.coordinates[1]);
                    }
                    const h = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (c * r - o)),
                                Math.round(this.options.extent * (u * r - i))
                            ]
                        ],
                        tags: l
                    };
                    let p;
                    a ? p = e1.id : this.options.generateId ? p = e1.index : this.points[e1.index].id && (p = this.points[e1.index].id), void 0 !== p && (h.id = p), n.features.push(h);
                }
            }
            _limitZoom(e1) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e1), this.options.maxZoom + 1));
            }
            _cluster(e1, t1) {
                const o = [], { radius: i, extent: r, reduce: n, minPoints: s } = this.options, a = i / (r * Math.pow(2, t1));
                for(let i = 0; i < e1.length; i++){
                    const r = e1[i];
                    if (r.zoom <= t1) continue;
                    r.zoom = t1;
                    const l = this.trees[t1 + 1], c = l.within(r.x, r.y, a), u = r.numPoints || 1;
                    let h = u;
                    for (const e1 of c){
                        const o = l.points[e1];
                        o.zoom > t1 && (h += o.numPoints || 1);
                    }
                    if (h > u && h >= s) {
                        let e1 = r.x * u, s = r.y * u, a = n && u > 1 ? this._map(r, !0) : null;
                        const p = (i << 5) + (t1 + 1) + this.points.length;
                        for (const o of c){
                            const i = l.points[o];
                            if (i.zoom <= t1) continue;
                            i.zoom = t1;
                            const c = i.numPoints || 1;
                            e1 += i.x * c, s += i.y * c, i.parentId = p, n && (a || (a = this._map(r, !0)), n(a, this._map(i)));
                        }
                        r.parentId = p, o.push(V(e1 / h, s / h, p, h, a));
                    } else if (o.push(r), h > 1) for (const e1 of c){
                        const i = l.points[e1];
                        i.zoom <= t1 || (i.zoom = t1, o.push(i));
                    }
                }
                return o;
            }
            _getOriginId(e1) {
                return e1 - this.points.length >> 5;
            }
            _getOriginZoom(e1) {
                return (e1 - this.points.length) % 32;
            }
            _map(e1, t1) {
                if (e1.numPoints) return t1 ? H({}, e1.properties) : e1.properties;
                const o = this.points[e1.index].properties, i = this.options.map(o);
                return t1 && i === o ? H({}, i) : i;
            }
            constructor(e1){
                this.options = H(Object.create(Z), e1), this.trees = new Array(this.options.maxZoom + 1);
            }
        }
        function V(e1, t1, o, i, r) {
            return {
                x: G(e1),
                y: G(t1),
                zoom: 1 / 0,
                id: o,
                parentId: -1,
                numPoints: i,
                properties: r
            };
        }
        function X(e1, t1) {
            const [o, i] = e1.geometry.coordinates;
            return {
                x: G($(o)),
                y: G(q(i)),
                zoom: 1 / 0,
                index: t1,
                parentId: -1
            };
        }
        function R(e1) {
            var t1;
            return {
                type: "Feature",
                id: e1.id,
                properties: W(e1),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (t1 = e1.x, 360 * (t1 - .5)),
                        U(e1.y)
                    ]
                }
            };
        }
        function W(e1) {
            const t1 = e1.numPoints, o = t1 >= 1e4 ? `${Math.round(t1 / 1e3)}k` : t1 >= 1e3 ? Math.round(t1 / 100) / 10 + "k" : t1;
            return H(H({}, e1.properties), {
                cluster: !0,
                cluster_id: e1.id,
                point_count: t1,
                point_count_abbreviated: o
            });
        }
        function $(e1) {
            return e1 / 360 + .5;
        }
        function q(e1) {
            const t1 = Math.sin(e1 * Math.PI / 180), o = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return o < 0 ? 0 : o > 1 ? 1 : o;
        }
        function U(e1) {
            const t1 = (180 - 360 * e1) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t1)) / Math.PI - 90;
        }
        function H(e1, t1) {
            for(const o in t1)e1[o] = t1[o];
            return e1;
        }
        function K(e1) {
            return e1.x;
        }
        function Q(e1) {
            return e1.y;
        }
        function ee(e1, t1, o, i) {
            for(var r, n = i, s = o - t1 >> 1, a = o - t1, l = e1[t1], c = e1[t1 + 1], u = e1[o], h = e1[o + 1], p = t1 + 3; p < o; p += 3){
                var f = te(e1[p], e1[p + 1], l, c, u, h);
                if (f > n) r = p, n = f;
                else if (f === n) {
                    var d = Math.abs(p - s);
                    d < a && (r = p, a = d);
                }
            }
            n > i && (r - t1 > 3 && ee(e1, t1, r, i), e1[r + 2] = n, o - r > 3 && ee(e1, r, o, i));
        }
        function te(e1, t1, o, i, r, n) {
            var s = r - o, a = n - i;
            if (0 !== s || 0 !== a) {
                var l = ((e1 - o) * s + (t1 - i) * a) / (s * s + a * a);
                l > 1 ? (o = r, i = n) : l > 0 && (o += s * l, i += a * l);
            }
            return (s = e1 - o) * s + (a = t1 - i) * a;
        }
        function oe(e1, t1, o, i) {
            var r = {
                id: void 0 === e1 ? null : e1,
                type: t1,
                geometry: o,
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            return function(e1) {
                var t1 = e1.geometry, o = e1.type;
                if ("Point" === o || "MultiPoint" === o || "LineString" === o) ie(e1, t1);
                else if ("Polygon" === o || "MultiLineString" === o) for(var i = 0; i < t1.length; i++)ie(e1, t1[i]);
                else if ("MultiPolygon" === o) for(i = 0; i < t1.length; i++)for(var r = 0; r < t1[i].length; r++)ie(e1, t1[i][r]);
            }(r), r;
        }
        function ie(e1, t1) {
            for(var o = 0; o < t1.length; o += 3)e1.minX = Math.min(e1.minX, t1[o]), e1.minY = Math.min(e1.minY, t1[o + 1]), e1.maxX = Math.max(e1.maxX, t1[o]), e1.maxY = Math.max(e1.maxY, t1[o + 1]);
        }
        function re(e1, t1, o, i) {
            if (t1.geometry) {
                var r = t1.geometry.coordinates, n = t1.geometry.type, s = Math.pow(o.tolerance / ((1 << o.maxZoom) * o.extent), 2), a = [], l = t1.id;
                if (o.promoteId ? l = t1.properties[o.promoteId] : o.generateId && (l = i || 0), "Point" === n) ne(r, a);
                else if ("MultiPoint" === n) for(var c = 0; c < r.length; c++)ne(r[c], a);
                else if ("LineString" === n) se(r, a, s, !1);
                else if ("MultiLineString" === n) {
                    if (o.lineMetrics) {
                        for(c = 0; c < r.length; c++)se(r[c], a = [], s, !1), e1.push(oe(l, "LineString", a, t1.properties));
                        return;
                    }
                    ae(r, a, s, !1);
                } else if ("Polygon" === n) ae(r, a, s, !0);
                else {
                    if ("MultiPolygon" !== n) {
                        if ("GeometryCollection" === n) {
                            for(c = 0; c < t1.geometry.geometries.length; c++)re(e1, {
                                id: l,
                                geometry: t1.geometry.geometries[c],
                                properties: t1.properties
                            }, o, i);
                            return;
                        }
                        throw new Error("Input data is not a valid GeoJSON object.");
                    }
                    for(c = 0; c < r.length; c++){
                        var u = [];
                        ae(r[c], u, s, !0), a.push(u);
                    }
                }
                e1.push(oe(l, n, a, t1.properties));
            }
        }
        function ne(e1, t1) {
            t1.push(le(e1[0])), t1.push(ce(e1[1])), t1.push(0);
        }
        function se(e1, t1, o, i) {
            for(var r, n, s = 0, a = 0; a < e1.length; a++){
                var l = le(e1[a][0]), c = ce(e1[a][1]);
                t1.push(l), t1.push(c), t1.push(0), a > 0 && (s += i ? (r * c - l * n) / 2 : Math.sqrt(Math.pow(l - r, 2) + Math.pow(c - n, 2))), r = l, n = c;
            }
            var u = t1.length - 3;
            t1[2] = 1, ee(t1, 0, u, o), t1[u + 2] = 1, t1.size = Math.abs(s), t1.start = 0, t1.end = t1.size;
        }
        function ae(e1, t1, o, i) {
            for(var r = 0; r < e1.length; r++){
                var n = [];
                se(e1[r], n, o, i), t1.push(n);
            }
        }
        function le(e1) {
            return e1 / 360 + .5;
        }
        function ce(e1) {
            var t1 = Math.sin(e1 * Math.PI / 180), o = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return o < 0 ? 0 : o > 1 ? 1 : o;
        }
        function ue(e1, t1, o, i, r, n, s, a) {
            if (i /= t1, n >= (o /= t1) && s < i) return e1;
            if (s < o || n >= i) return null;
            for(var l = [], c = 0; c < e1.length; c++){
                var u = e1[c], h = u.geometry, p = u.type, f = 0 === r ? u.minX : u.minY, d = 0 === r ? u.maxX : u.maxY;
                if (f >= o && d < i) l.push(u);
                else if (!(d < o || f >= i)) {
                    var g = [];
                    if ("Point" === p || "MultiPoint" === p) he(h, g, o, i, r);
                    else if ("LineString" === p) pe(h, g, o, i, r, !1, a.lineMetrics);
                    else if ("MultiLineString" === p) de(h, g, o, i, r, !1);
                    else if ("Polygon" === p) de(h, g, o, i, r, !0);
                    else if ("MultiPolygon" === p) for(var m = 0; m < h.length; m++){
                        var y = [];
                        de(h[m], y, o, i, r, !0), y.length && g.push(y);
                    }
                    if (g.length) {
                        if (a.lineMetrics && "LineString" === p) {
                            for(m = 0; m < g.length; m++)l.push(oe(u.id, p, g[m], u.tags));
                            continue;
                        }
                        "LineString" !== p && "MultiLineString" !== p || (1 === g.length ? (p = "LineString", g = g[0]) : p = "MultiLineString"), "Point" !== p && "MultiPoint" !== p || (p = 3 === g.length ? "Point" : "MultiPoint"), l.push(oe(u.id, p, g, u.tags));
                    }
                }
            }
            return l.length ? l : null;
        }
        function he(e1, t1, o, i, r) {
            for(var n = 0; n < e1.length; n += 3){
                var s = e1[n + r];
                s >= o && s <= i && (t1.push(e1[n]), t1.push(e1[n + 1]), t1.push(e1[n + 2]));
            }
        }
        function pe(e1, t1, o, i, r, n, s) {
            for(var a, l, c = fe(e1), u = 0 === r ? me : ye, h = e1.start, p = 0; p < e1.length - 3; p += 3){
                var f = e1[p], d = e1[p + 1], g = e1[p + 2], m = e1[p + 3], y = e1[p + 4], v = 0 === r ? f : d, x = 0 === r ? m : y, w = !1;
                s && (a = Math.sqrt(Math.pow(f - m, 2) + Math.pow(d - y, 2))), v < o ? x > o && (l = u(c, f, d, m, y, o), s && (c.start = h + a * l)) : v > i ? x < i && (l = u(c, f, d, m, y, i), s && (c.start = h + a * l)) : ge(c, f, d, g), x < o && v >= o && (l = u(c, f, d, m, y, o), w = !0), x > i && v <= i && (l = u(c, f, d, m, y, i), w = !0), !n && w && (s && (c.end = h + a * l), t1.push(c), c = fe(e1)), s && (h += a);
            }
            var S = e1.length - 3;
            f = e1[S], d = e1[S + 1], g = e1[S + 2], (v = 0 === r ? f : d) >= o && v <= i && ge(c, f, d, g), S = c.length - 3, n && S >= 3 && (c[S] !== c[0] || c[S + 1] !== c[1]) && ge(c, c[0], c[1], c[2]), c.length && t1.push(c);
        }
        function fe(e1) {
            var t1 = [];
            return t1.size = e1.size, t1.start = e1.start, t1.end = e1.end, t1;
        }
        function de(e1, t1, o, i, r, n) {
            for(var s = 0; s < e1.length; s++)pe(e1[s], t1, o, i, r, n, !1);
        }
        function ge(e1, t1, o, i) {
            e1.push(t1), e1.push(o), e1.push(i);
        }
        function me(e1, t1, o, i, r, n) {
            var s = (n - t1) / (i - t1);
            return e1.push(n), e1.push(o + (r - o) * s), e1.push(1), s;
        }
        function ye(e1, t1, o, i, r, n) {
            var s = (n - o) / (r - o);
            return e1.push(t1 + (i - t1) * s), e1.push(n), e1.push(1), s;
        }
        function ve(e1, t1) {
            for(var o = [], i = 0; i < e1.length; i++){
                var r, n = e1[i], s = n.type;
                if ("Point" === s || "MultiPoint" === s || "LineString" === s) r = xe(n.geometry, t1);
                else if ("MultiLineString" === s || "Polygon" === s) {
                    r = [];
                    for(var a = 0; a < n.geometry.length; a++)r.push(xe(n.geometry[a], t1));
                } else if ("MultiPolygon" === s) for(r = [], a = 0; a < n.geometry.length; a++){
                    for(var l = [], c = 0; c < n.geometry[a].length; c++)l.push(xe(n.geometry[a][c], t1));
                    r.push(l);
                }
                o.push(oe(n.id, s, r, n.tags));
            }
            return o;
        }
        function xe(e1, t1) {
            var o = [];
            o.size = e1.size, void 0 !== e1.start && (o.start = e1.start, o.end = e1.end);
            for(var i = 0; i < e1.length; i += 3)o.push(e1[i] + t1, e1[i + 1], e1[i + 2]);
            return o;
        }
        function we(e1, t1) {
            if (e1.transformed) return e1;
            var o, i, r, n = 1 << e1.z, s = e1.x, a = e1.y;
            for(o = 0; o < e1.features.length; o++){
                var l = e1.features[o], c = l.geometry, u = l.type;
                if (l.geometry = [], 1 === u) for(i = 0; i < c.length; i += 2)l.geometry.push(Se(c[i], c[i + 1], t1, n, s, a));
                else for(i = 0; i < c.length; i++){
                    var h = [];
                    for(r = 0; r < c[i].length; r += 2)h.push(Se(c[i][r], c[i][r + 1], t1, n, s, a));
                    l.geometry.push(h);
                }
            }
            return e1.transformed = !0, e1;
        }
        function Se(e1, t1, o, i, r, n) {
            return [
                Math.round(o * (e1 * i - r)),
                Math.round(o * (t1 * i - n))
            ];
        }
        function Me(e1, t1, o, i, r) {
            for(var n = t1 === r.maxZoom ? 0 : r.tolerance / ((1 << t1) * r.extent), s = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: 0,
                source: null,
                x: o,
                y: i,
                z: t1,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            }, a = 0; a < e1.length; a++){
                s.numFeatures++, Ie(s, e1[a], n, r);
                var l = e1[a].minX, c = e1[a].minY, u = e1[a].maxX, h = e1[a].maxY;
                l < s.minX && (s.minX = l), c < s.minY && (s.minY = c), u > s.maxX && (s.maxX = u), h > s.maxY && (s.maxY = h);
            }
            return s;
        }
        function Ie(e1, t1, o, i) {
            var r = t1.geometry, n = t1.type, s = [];
            if ("Point" === n || "MultiPoint" === n) for(var a = 0; a < r.length; a += 3)s.push(r[a]), s.push(r[a + 1]), e1.numPoints++, e1.numSimplified++;
            else if ("LineString" === n) be(s, r, e1, o, !1, !1);
            else if ("MultiLineString" === n || "Polygon" === n) for(a = 0; a < r.length; a++)be(s, r[a], e1, o, "Polygon" === n, 0 === a);
            else if ("MultiPolygon" === n) for(var l = 0; l < r.length; l++){
                var c = r[l];
                for(a = 0; a < c.length; a++)be(s, c[a], e1, o, !0, 0 === a);
            }
            if (s.length) {
                var u = t1.tags || null;
                if ("LineString" === n && i.lineMetrics) {
                    for(var h in u = {}, t1.tags)u[h] = t1.tags[h];
                    u.mapbox_clip_start = r.start / r.size, u.mapbox_clip_end = r.end / r.size;
                }
                var p = {
                    geometry: s,
                    type: "Polygon" === n || "MultiPolygon" === n ? 3 : "LineString" === n || "MultiLineString" === n ? 2 : 1,
                    tags: u
                };
                null !== t1.id && (p.id = t1.id), e1.features.push(p);
            }
        }
        function be(e1, t1, o, i, r, n) {
            var s = i * i;
            if (i > 0 && t1.size < (r ? s : i)) o.numPoints += t1.length / 3;
            else {
                for(var a = [], l = 0; l < t1.length; l += 3)(0 === i || t1[l + 2] > s) && (o.numSimplified++, a.push(t1[l]), a.push(t1[l + 1])), o.numPoints++;
                r && function(e1, t1) {
                    for(var o = 0, i = 0, r = e1.length, n = r - 2; i < r; n = i, i += 2)o += (e1[i] - e1[n]) * (e1[i + 1] + e1[n + 1]);
                    if (o > 0 === t1) for(i = 0, r = e1.length; i < r / 2; i += 2){
                        var s = e1[i], a = e1[i + 1];
                        e1[i] = e1[r - 2 - i], e1[i + 1] = e1[r - 1 - i], e1[r - 2 - i] = s, e1[r - 1 - i] = a;
                    }
                }(a, n), e1.push(a);
            }
        }
        function ke(e1, t1) {
            var o = (t1 = this.options = function(e1, t1) {
                for(var o in t1)e1[o] = t1[o];
                return e1;
            }(Object.create(this.options), t1)).debug;
            if (o && console.time("preprocess data"), t1.maxZoom < 0 || t1.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
            if (t1.promoteId && t1.generateId) throw new Error("promoteId and generateId cannot be used together.");
            var i = function(e1, t1) {
                var o = [];
                if ("FeatureCollection" === e1.type) for(var i = 0; i < e1.features.length; i++)re(o, e1.features[i], t1, i);
                else re(o, "Feature" === e1.type ? e1 : {
                    geometry: e1
                }, t1);
                return o;
            }(e1, t1);
            this.tiles = {}, this.tileCoords = [], o && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t1.indexMaxZoom, t1.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), i = function(e1, t1) {
                var o = t1.buffer / t1.extent, i = e1, r = ue(e1, 1, -1 - o, o, 0, -1, 2, t1), n = ue(e1, 1, 1 - o, 2 + o, 0, -1, 2, t1);
                return (r || n) && (i = ue(e1, 1, -o, 1 + o, 0, -1, 2, t1) || [], r && (i = ve(r, 1).concat(i)), n && (i = i.concat(ve(n, -1)))), i;
            }(i, t1), i.length && this.splitTile(i, 0, 0, 0), o && (i.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
        }
        function Pe(e1, t1, o) {
            return 32 * ((1 << e1) * o + t1) + e1;
        }
        function Te(e1, t1) {
            const o = e1.tileID.canonical;
            if (!this._geoJSONIndex) return t1(null, null);
            const i = this._geoJSONIndex.getTile(o.z, o.x, o.y);
            if (!i) return t1(null, null);
            const r = new g(i.features);
            let n = m.exports(r);
            0 === n.byteOffset && n.byteLength === n.buffer.byteLength || (n = new Uint8Array(n)), t1(null, {
                vectorTile: r,
                rawData: n.buffer
            });
        }
        ke.prototype.options = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        }, ke.prototype.splitTile = function(e1, t1, o, i, r, n, s) {
            for(var a = [
                e1,
                t1,
                o,
                i
            ], l = this.options, c = l.debug; a.length;){
                i = a.pop(), o = a.pop(), t1 = a.pop(), e1 = a.pop();
                var u = 1 << t1, h = Pe(t1, o, i), p = this.tiles[h];
                if (!p && (c > 1 && console.time("creation"), p = this.tiles[h] = Me(e1, t1, o, i, l), this.tileCoords.push({
                    z: t1,
                    x: o,
                    y: i
                }), c)) {
                    c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t1, o, i, p.numFeatures, p.numPoints, p.numSimplified), console.timeEnd("creation"));
                    var f = "z" + t1;
                    this.stats[f] = (this.stats[f] || 0) + 1, this.total++;
                }
                if (p.source = e1, r) {
                    if (t1 === l.maxZoom || t1 === r) continue;
                    var d = 1 << r - t1;
                    if (o !== Math.floor(n / d) || i !== Math.floor(s / d)) continue;
                } else if (t1 === l.indexMaxZoom || p.numPoints <= l.indexMaxPoints) continue;
                if (p.source = null, 0 !== e1.length) {
                    c > 1 && console.time("clipping");
                    var g, m, y, v, x, w, S = .5 * l.buffer / l.extent, M = .5 - S, I = .5 + S, b = 1 + S;
                    g = m = y = v = null, x = ue(e1, u, o - S, o + I, 0, p.minX, p.maxX, l), w = ue(e1, u, o + M, o + b, 0, p.minX, p.maxX, l), e1 = null, x && (g = ue(x, u, i - S, i + I, 1, p.minY, p.maxY, l), m = ue(x, u, i + M, i + b, 1, p.minY, p.maxY, l), x = null), w && (y = ue(w, u, i - S, i + I, 1, p.minY, p.maxY, l), v = ue(w, u, i + M, i + b, 1, p.minY, p.maxY, l), w = null), c > 1 && console.timeEnd("clipping"), a.push(g || [], t1 + 1, 2 * o, 2 * i), a.push(m || [], t1 + 1, 2 * o, 2 * i + 1), a.push(y || [], t1 + 1, 2 * o + 1, 2 * i), a.push(v || [], t1 + 1, 2 * o + 1, 2 * i + 1);
                }
            }
        }, ke.prototype.getTile = function(e1, t1, o) {
            var i = this.options, r = i.extent, n = i.debug;
            if (e1 < 0 || e1 > 24) return null;
            var s = 1 << e1, a = Pe(e1, t1 = (t1 % s + s) % s, o);
            if (this.tiles[a]) return we(this.tiles[a], r);
            n > 1 && console.log("drilling down to z%d-%d-%d", e1, t1, o);
            for(var l, c = e1, u = t1, h = o; !l && c > 0;)c--, u = Math.floor(u / 2), h = Math.floor(h / 2), l = this.tiles[Pe(c, u, h)];
            return l && l.source ? (n > 1 && console.log("found parent tile z%d-%d-%d", c, u, h), n > 1 && console.time("drilling down"), this.splitTile(l.source, c, u, h, e1, t1, o), n > 1 && console.timeEnd("drilling down"), this.tiles[a] ? we(this.tiles[a], r) : null) : null;
        };
        class Ce extends l {
            loadData(t1, o) {
                var i;
                null === (i = this._pendingRequest) || void 0 === i || i.cancel(), this._pendingCallback && this._pendingCallback(null, {
                    abandoned: !0
                });
                const r = !!(t1 && t1.request && t1.request.collectResourceTiming) && new e1.RequestPerformance(t1.request);
                this._pendingCallback = o, this._pendingRequest = this.loadGeoJSON(t1, (i, n)=>{
                    if (delete this._pendingCallback, delete this._pendingRequest, i || !n) return o(i);
                    if ("object" != typeof n) return o(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    {
                        u(n, !0);
                        try {
                            if (t1.filter) {
                                const o = e1.createExpression(t1.filter, {
                                    type: "boolean",
                                    "property-type": "data-driven",
                                    overridable: !1,
                                    transition: !1
                                });
                                if ("error" === o.result) throw new Error(o.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                                const i = n.features.filter((e1)=>o.value.evaluate({
                                        zoom: 0
                                    }, e1));
                                n = {
                                    type: "FeatureCollection",
                                    features: i
                                };
                            }
                            this._geoJSONIndex = t1.cluster ? new Y(function({ superclusterOptions: t1, clusterProperties: o }) {
                                if (!o || !t1) return t1;
                                const i = {}, r = {}, n = {
                                    accumulated: null,
                                    zoom: 0
                                }, s = {
                                    properties: null
                                }, a = Object.keys(o);
                                for (const t1 of a){
                                    const [n, s] = o[t1], a = e1.createExpression(s), l = e1.createExpression("string" == typeof n ? [
                                        n,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            t1
                                        ]
                                    ] : n);
                                    i[t1] = a.value, r[t1] = l.value;
                                }
                                return t1.map = (e1)=>{
                                    s.properties = e1;
                                    const t1 = {};
                                    for (const e1 of a)t1[e1] = i[e1].evaluate(n, s);
                                    return t1;
                                }, t1.reduce = (e1, t1)=>{
                                    s.properties = t1;
                                    for (const t1 of a)n.accumulated = e1[t1], e1[t1] = r[t1].evaluate(n, s);
                                }, t1;
                            }(t1)).load(n.features) : function(e1, t1) {
                                return new ke(e1, t1);
                            }(n, t1.geojsonVtOptions);
                        } catch (i) {
                            return o(i);
                        }
                        this.loaded = {};
                        const s = {};
                        if (r) {
                            const e1 = r.finish();
                            e1 && (s.resourceTiming = {}, s.resourceTiming[t1.source] = JSON.parse(JSON.stringify(e1)));
                        }
                        o(null, s);
                    }
                });
            }
            reloadTile(e1, t1) {
                const o = this.loaded;
                return o && o[e1.uid] ? super.reloadTile(e1, t1) : this.loadTile(e1, t1);
            }
            loadGeoJSON(t1, o) {
                if (t1.request) return e1.getJSON(t1.request, o);
                if ("string" == typeof t1.data) try {
                    o(null, JSON.parse(t1.data));
                } catch (e1) {
                    o(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                }
                else o(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                return {
                    cancel: ()=>{}
                };
            }
            removeSource(e1, t1) {
                this._pendingCallback && this._pendingCallback(null, {
                    abandoned: !0
                }), t1();
            }
            getClusterExpansionZoom(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getClusterExpansionZoom(e1.clusterId));
                } catch (e1) {
                    t1(e1);
                }
            }
            getClusterChildren(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getChildren(e1.clusterId));
                } catch (e1) {
                    t1(e1);
                }
            }
            getClusterLeaves(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getLeaves(e1.clusterId, e1.limit, e1.offset));
                } catch (e1) {
                    t1(e1);
                }
            }
            constructor(e1, t1, o, i){
                super(e1, t1, o, Te), i && (this.loadGeoJSON = i);
            }
        }
        class _e {
            setReferrer(e1, t1) {
                this.referrer = t1;
            }
            setImages(e1, t1, o) {
                this.availableImages[e1] = t1;
                for(const o in this.workerSources[e1]){
                    const i = this.workerSources[e1][o];
                    for(const e1 in i)i[e1].availableImages = t1;
                }
                o();
            }
            setLayers(e1, t1, o) {
                this.getLayerIndex(e1).replace(t1), o();
            }
            updateLayers(e1, t1, o) {
                this.getLayerIndex(e1).update(t1.layers, t1.removedIds), o();
            }
            loadTile(e1, t1, o) {
                this.getWorkerSource(e1, t1.type, t1.source).loadTile(t1, o);
            }
            loadDEMTile(e1, t1, o) {
                this.getDEMWorkerSource(e1, t1.source).loadTile(t1, o);
            }
            reloadTile(e1, t1, o) {
                this.getWorkerSource(e1, t1.type, t1.source).reloadTile(t1, o);
            }
            abortTile(e1, t1, o) {
                this.getWorkerSource(e1, t1.type, t1.source).abortTile(t1, o);
            }
            removeTile(e1, t1, o) {
                this.getWorkerSource(e1, t1.type, t1.source).removeTile(t1, o);
            }
            removeDEMTile(e1, t1) {
                this.getDEMWorkerSource(e1, t1.source).removeTile(t1);
            }
            removeSource(e1, t1, o) {
                if (!this.workerSources[e1] || !this.workerSources[e1][t1.type] || !this.workerSources[e1][t1.type][t1.source]) return;
                const i = this.workerSources[e1][t1.type][t1.source];
                delete this.workerSources[e1][t1.type][t1.source], void 0 !== i.removeSource ? i.removeSource(t1, o) : o();
            }
            loadWorkerSource(e1, t1, o) {
                try {
                    this.self.importScripts(t1.url), o();
                } catch (e1) {
                    o(e1.toString());
                }
            }
            syncRTLPluginState(t1, o, i) {
                try {
                    e1.plugin.setState(o);
                    const t1 = e1.plugin.getPluginURL();
                    if (e1.plugin.isLoaded() && !e1.plugin.isParsed() && null != t1) {
                        this.self.importScripts(t1);
                        const o = e1.plugin.isParsed();
                        i(o ? void 0 : new Error(`RTL Text Plugin failed to import scripts from ${t1}`), o);
                    }
                } catch (e1) {
                    i(e1.toString());
                }
            }
            getAvailableImages(e1) {
                let t1 = this.availableImages[e1];
                return t1 || (t1 = []), t1;
            }
            getLayerIndex(e1) {
                let t1 = this.layerIndexes[e1];
                return t1 || (t1 = this.layerIndexes[e1] = new i), t1;
            }
            getWorkerSource(e1, t1, o) {
                if (this.workerSources[e1] || (this.workerSources[e1] = {}), this.workerSources[e1][t1] || (this.workerSources[e1][t1] = {}), !this.workerSources[e1][t1][o]) {
                    const i = {
                        send: (t1, o, i)=>{
                            this.actor.send(t1, o, i, e1);
                        }
                    };
                    this.workerSources[e1][t1][o] = new this.workerSourceTypes[t1](i, this.getLayerIndex(e1), this.getAvailableImages(e1));
                }
                return this.workerSources[e1][t1][o];
            }
            getDEMWorkerSource(e1, t1) {
                return this.demWorkerSources[e1] || (this.demWorkerSources[e1] = {}), this.demWorkerSources[e1][t1] || (this.demWorkerSources[e1][t1] = new c), this.demWorkerSources[e1][t1];
            }
            enforceCacheSizeLimit(t1, o) {
                e1.enforceCacheSizeLimit(o);
            }
            constructor(t1){
                this.self = t1, this.actor = new e1.Actor(t1, this), this.layerIndexes = {}, this.availableImages = {}, this.workerSourceTypes = {
                    vector: l,
                    geojson: Ce
                }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = (e1, t1)=>{
                    if (this.workerSourceTypes[e1]) throw new Error(`Worker source with name "${e1}" already registered.`);
                    this.workerSourceTypes[e1] = t1;
                }, this.self.registerRTLTextPlugin = (t1)=>{
                    if (e1.plugin.isParsed()) throw new Error("RTL text plugin already registered.");
                    e1.plugin.applyArabicShaping = t1.applyArabicShaping, e1.plugin.processBidirectionalText = t1.processBidirectionalText, e1.plugin.processStyledBidirectionalText = t1.processStyledBidirectionalText;
                };
            }
        }
        return e1.isWorker() && (self.worker = new _e(self)), _e;
    });
    define([
        "./shared"
    ], function(t1) {
        "use strict";
        var e1 = i;
        function i(t1) {
            return !function(t1) {
                var e1;
                return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray ? Function.prototype && Function.prototype.bind ? Object.keys && Object.create && Object.getPrototypeOf && Object.getOwnPropertyNames && Object.isSealed && Object.isFrozen && Object.isExtensible && Object.getOwnPropertyDescriptor && Object.defineProperty && Object.defineProperties && Object.seal && Object.freeze && Object.preventExtensions ? "JSON" in window && "parse" in JSON && "stringify" in JSON ? function() {
                    if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
                    var t1, e1, i = new Blob([
                        ""
                    ], {
                        type: "text/javascript"
                    }), o = URL.createObjectURL(i);
                    try {
                        e1 = new Worker(o), t1 = !0;
                    } catch (e1) {
                        t1 = !1;
                    }
                    return e1 && e1.terminate(), URL.revokeObjectURL(o), t1;
                }() ? "Uint8ClampedArray" in window ? ArrayBuffer.isView ? function() {
                    var t1 = document.createElement("canvas");
                    t1.width = t1.height = 1;
                    var e1 = t1.getContext("2d");
                    if (!e1) return !1;
                    var i = e1.getImageData(0, 0, 1, 1);
                    return i && i.width === t1.width;
                }() ? (void 0 === o[e1 = t1 && t1.failIfMajorPerformanceCaveat] && (o[e1] = function(t1) {
                    var e1, o = function(t1) {
                        var e1 = document.createElement("canvas"), o = Object.create(i.webGLContextAttributes);
                        return o.failIfMajorPerformanceCaveat = t1, e1.getContext("webgl", o) || e1.getContext("experimental-webgl", o);
                    }(t1);
                    if (!o) return !1;
                    try {
                        e1 = o.createShader(o.VERTEX_SHADER);
                    } catch (t1) {
                        return !1;
                    }
                    return !(!e1 || o.isContextLost()) && (o.shaderSource(e1, "void main() {}"), o.compileShader(e1), !0 === o.getShaderParameter(e1, o.COMPILE_STATUS));
                }(e1)), o[e1] ? document.documentMode ? "insufficient ECMAScript 6 support" : void 0 : "insufficient WebGL support") : "insufficient Canvas/getImageData support" : "insufficient ArrayBuffer support" : "insufficient Uint8ClampedArray support" : "insufficient worker support" : "insufficient JSON support" : "insufficient Object support" : "insufficient Function support" : "insufficent Array support";
            }(t1);
        }
        var o = {};
        function a(t1, e1) {
            if (Array.isArray(t1)) {
                if (!Array.isArray(e1) || t1.length !== e1.length) return !1;
                for(let i = 0; i < t1.length; i++)if (!a(t1[i], e1[i])) return !1;
                return !0;
            }
            if ("object" == typeof t1 && null !== t1 && null !== e1) {
                if ("object" != typeof e1) return !1;
                if (Object.keys(t1).length !== Object.keys(e1).length) return !1;
                for(const i in t1)if (!a(t1[i], e1[i])) return !1;
                return !0;
            }
            return t1 === e1;
        }
        i.webGLContextAttributes = {
            antialias: !1,
            alpha: !0,
            stencil: !0,
            depth: !0
        };
        class r {
            static testProp(t1) {
                if (!r.docStyle) return t1[0];
                for(let e1 = 0; e1 < t1.length; e1++)if (t1[e1] in r.docStyle) return t1[e1];
                return t1[0];
            }
            static create(t1, e1, i) {
                const o = window.document.createElement(t1);
                return void 0 !== e1 && (o.className = e1), i && i.appendChild(o), o;
            }
            static createNS(t1, e1) {
                return window.document.createElementNS(t1, e1);
            }
            static disableDrag() {
                r.docStyle && r.selectProp && (r.userSelect = r.docStyle[r.selectProp], r.docStyle[r.selectProp] = "none");
            }
            static enableDrag() {
                r.docStyle && r.selectProp && (r.docStyle[r.selectProp] = r.userSelect);
            }
            static setTransform(t1, e1) {
                t1.style[r.transformProp] = e1;
            }
            static addEventListener(t1, e1, i, o = {}) {
                t1.addEventListener(e1, i, "passive" in o ? o : o.capture);
            }
            static removeEventListener(t1, e1, i, o = {}) {
                t1.removeEventListener(e1, i, "passive" in o ? o : o.capture);
            }
            static suppressClickInternal(t1) {
                t1.preventDefault(), t1.stopPropagation(), window.removeEventListener("click", r.suppressClickInternal, !0);
            }
            static suppressClick() {
                window.addEventListener("click", r.suppressClickInternal, !0), window.setTimeout(()=>{
                    window.removeEventListener("click", r.suppressClickInternal, !0);
                }, 0);
            }
            static mousePos(e1, i) {
                const o = e1.getBoundingClientRect();
                return new t1.pointGeometry(i.clientX - o.left - e1.clientLeft, i.clientY - o.top - e1.clientTop);
            }
            static touchPos(e1, i) {
                const o = e1.getBoundingClientRect(), a = [];
                for(let r = 0; r < i.length; r++)a.push(new t1.pointGeometry(i[r].clientX - o.left - e1.clientLeft, i[r].clientY - o.top - e1.clientTop));
                return a;
            }
            static mouseButton(t1) {
                return t1.button;
            }
            static remove(t1) {
                t1.parentNode && t1.parentNode.removeChild(t1);
            }
        }
        r.docStyle = "undefined" != typeof window && window.document && window.document.documentElement.style, r.selectProp = r.testProp([
            "userSelect",
            "MozUserSelect",
            "WebkitUserSelect",
            "msUserSelect"
        ]), r.transformProp = r.testProp([
            "transform",
            "WebkitTransform"
        ]);
        class s {
            transformRequest(t1, e1) {
                return this._transformRequestFn && this._transformRequestFn(t1, e1) || {
                    url: t1
                };
            }
            normalizeSpriteURL(t1, e1, i) {
                const o = function(t1) {
                    const e1 = t1.match(n);
                    if (!e1) throw new Error(`Unable to parse URL "${t1}"`);
                    return {
                        protocol: e1[1],
                        authority: e1[2],
                        path: e1[3] || "/",
                        params: e1[4] ? e1[4].split("&") : []
                    };
                }(t1);
                return o.path += `${e1}${i}`, function(t1) {
                    const e1 = t1.params.length ? `?${t1.params.join("&")}` : "";
                    return `${t1.protocol}://${t1.authority}${t1.path}${e1}`;
                }(o);
            }
            setTransformRequest(t1) {
                this._transformRequestFn = t1;
            }
            constructor(t1){
                this._transformRequestFn = t1;
            }
        }
        const n = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        class l {
            update(e1, i, o) {
                const { width: a, height: r } = e1, s = !(this.size && this.size[0] === a && this.size[1] === r || o), { context: n } = this, { gl: l } = n;
                if (this.useMipmap = Boolean(i && i.useMipmap), l.bindTexture(l.TEXTURE_2D, this.texture), n.pixelStoreUnpackFlipY.set(!1), n.pixelStoreUnpack.set(1), n.pixelStoreUnpackPremultiplyAlpha.set(this.format === l.RGBA && (!i || !1 !== i.premultiply)), s) this.size = [
                    a,
                    r
                ], e1 instanceof HTMLImageElement || e1 instanceof HTMLCanvasElement || e1 instanceof HTMLVideoElement || e1 instanceof ImageData || t1.isImageBitmap(e1) ? l.texImage2D(l.TEXTURE_2D, 0, this.format, this.format, l.UNSIGNED_BYTE, e1) : l.texImage2D(l.TEXTURE_2D, 0, this.format, a, r, 0, this.format, l.UNSIGNED_BYTE, e1.data);
                else {
                    const { x: i, y: s } = o || {
                        x: 0,
                        y: 0
                    };
                    e1 instanceof HTMLImageElement || e1 instanceof HTMLCanvasElement || e1 instanceof HTMLVideoElement || e1 instanceof ImageData || t1.isImageBitmap(e1) ? l.texSubImage2D(l.TEXTURE_2D, 0, i, s, l.RGBA, l.UNSIGNED_BYTE, e1) : l.texSubImage2D(l.TEXTURE_2D, 0, i, s, a, r, l.RGBA, l.UNSIGNED_BYTE, e1.data);
                }
                this.useMipmap && this.isSizePowerOfTwo() && l.generateMipmap(l.TEXTURE_2D);
            }
            bind(t1, e1, i) {
                const { context: o } = this, { gl: a } = o;
                a.bindTexture(a.TEXTURE_2D, this.texture), i !== a.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (i = a.LINEAR), t1 !== this.filter && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, t1), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, i || t1), this.filter = t1), e1 !== this.wrap && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, e1), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, e1), this.wrap = e1);
            }
            isSizePowerOfTwo() {
                return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
            }
            destroy() {
                const { gl: t1 } = this.context;
                t1.deleteTexture(this.texture), this.texture = null;
            }
            constructor(t1, e1, i, o){
                this.context = t1, this.format = i, this.texture = t1.gl.createTexture(), this.update(e1, o);
            }
        }
        function c(t1) {
            const { userImage: e1 } = t1;
            return !!(e1 && e1.render && e1.render()) && (t1.data.replace(new Uint8Array(e1.data.buffer)), !0);
        }
        class h extends t1.Evented {
            isLoaded() {
                return this.loaded;
            }
            setLoaded(t1) {
                if (this.loaded !== t1 && (this.loaded = t1, t1)) {
                    for (const { ids: t1, callback: e1 } of this.requestors)this._notify(t1, e1);
                    this.requestors = [];
                }
            }
            getImage(t1) {
                return this.images[t1];
            }
            addImage(t1, e1) {
                if (this.images[t1]) throw new Error(`Image id ${t1} already exist, use updateImage instead`);
                this._validate(t1, e1) && (this.images[t1] = e1);
            }
            _validate(e1, i) {
                let o = !0;
                return this._validateStretch(i.stretchX, i.data && i.data.width) || (this.fire(new t1.ErrorEvent(new Error(`Image "${e1}" has invalid "stretchX" value`))), o = !1), this._validateStretch(i.stretchY, i.data && i.data.height) || (this.fire(new t1.ErrorEvent(new Error(`Image "${e1}" has invalid "stretchY" value`))), o = !1), this._validateContent(i.content, i) || (this.fire(new t1.ErrorEvent(new Error(`Image "${e1}" has invalid "content" value`))), o = !1), o;
            }
            _validateStretch(t1, e1) {
                if (!t1) return !0;
                let i = 0;
                for (const o of t1){
                    if (o[0] < i || o[1] < o[0] || e1 < o[1]) return !1;
                    i = o[1];
                }
                return !0;
            }
            _validateContent(t1, e1) {
                return !(t1 && (4 !== t1.length || t1[0] < 0 || e1.data.width < t1[0] || t1[1] < 0 || e1.data.height < t1[1] || t1[2] < 0 || e1.data.width < t1[2] || t1[3] < 0 || e1.data.height < t1[3] || t1[2] < t1[0] || t1[3] < t1[1]));
            }
            updateImage(t1, e1) {
                const i = this.images[t1];
                if (i.data.width !== e1.data.width || i.data.height !== e1.data.height) throw new Error(`size mismatch between old image (${i.data.width}x${i.data.height}) and new image (${e1.data.width}x${e1.data.height}).`);
                e1.version = i.version + 1, this.images[t1] = e1, this.updatedImages[t1] = !0;
            }
            removeImage(t1) {
                const e1 = this.images[t1];
                delete this.images[t1], delete this.patterns[t1], e1.userImage && e1.userImage.onRemove && e1.userImage.onRemove();
            }
            listImages() {
                return Object.keys(this.images);
            }
            getImages(t1, e1) {
                let i = !0;
                if (!this.isLoaded()) for (const e1 of t1)this.images[e1] || (i = !1);
                this.isLoaded() || i ? this._notify(t1, e1) : this.requestors.push({
                    ids: t1,
                    callback: e1
                });
            }
            _notify(e1, i) {
                const o = {};
                for (const i of e1){
                    this.images[i] || this.fire(new t1.Event("styleimagemissing", {
                        id: i
                    }));
                    const e1 = this.images[i];
                    e1 ? o[i] = {
                        data: e1.data.clone(),
                        pixelRatio: e1.pixelRatio,
                        sdf: e1.sdf,
                        version: e1.version,
                        stretchX: e1.stretchX,
                        stretchY: e1.stretchY,
                        content: e1.content,
                        hasRenderCallback: Boolean(e1.userImage && e1.userImage.render)
                    } : t1.warnOnce(`Image "${i}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                }
                i(null, o);
            }
            getPixelSize() {
                const { width: t1, height: e1 } = this.atlasImage;
                return {
                    width: t1,
                    height: e1
                };
            }
            getPattern(e1) {
                const i = this.patterns[e1], o = this.getImage(e1);
                if (!o) return null;
                if (i && i.position.version === o.version) return i.position;
                if (i) i.position.version = o.version;
                else {
                    const i = {
                        w: o.data.width + 2,
                        h: o.data.height + 2,
                        x: 0,
                        y: 0
                    }, a = new t1.ImagePosition(i, o);
                    this.patterns[e1] = {
                        bin: i,
                        position: a
                    };
                }
                return this._updatePatternAtlas(), this.patterns[e1].position;
            }
            bind(t1) {
                const e1 = t1.gl;
                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new l(t1, this.atlasImage, e1.RGBA), this.atlasTexture.bind(e1.LINEAR, e1.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas() {
                const e1 = [];
                for(const t1 in this.patterns)e1.push(this.patterns[t1].bin);
                const { w: i, h: o } = t1.potpack(e1), a = this.atlasImage;
                a.resize({
                    width: i || 1,
                    height: o || 1
                });
                for(const e1 in this.patterns){
                    const { bin: i } = this.patterns[e1], o = i.x + 1, r = i.y + 1, s = this.images[e1].data, n = s.width, l = s.height;
                    t1.RGBAImage.copy(s, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: r
                    }, {
                        width: n,
                        height: l
                    }), t1.RGBAImage.copy(s, a, {
                        x: 0,
                        y: l - 1
                    }, {
                        x: o,
                        y: r - 1
                    }, {
                        width: n,
                        height: 1
                    }), t1.RGBAImage.copy(s, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: r + l
                    }, {
                        width: n,
                        height: 1
                    }), t1.RGBAImage.copy(s, a, {
                        x: n - 1,
                        y: 0
                    }, {
                        x: o - 1,
                        y: r
                    }, {
                        width: 1,
                        height: l
                    }), t1.RGBAImage.copy(s, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: o + n,
                        y: r
                    }, {
                        width: 1,
                        height: l
                    });
                }
                this.dirty = !0;
            }
            beginFrame() {
                this.callbackDispatchedThisFrame = {};
            }
            dispatchRenderCallbacks(e1) {
                for (const i of e1){
                    if (this.callbackDispatchedThisFrame[i]) continue;
                    this.callbackDispatchedThisFrame[i] = !0;
                    const e1 = this.images[i];
                    e1 || t1.warnOnce(`Image with ID: "${i}" was not found`), c(e1) && this.updateImage(i, e1);
                }
            }
            constructor(){
                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new t1.RGBAImage({
                    width: 1,
                    height: 1
                }), this.dirty = !0;
            }
        }
        const u = 1e20;
        function d(t1, e1, i, o, a, r, s, n, l) {
            for(let c = e1; c < e1 + o; c++)m(t1, i * r + c, r, a, s, n, l);
            for(let c = i; c < i + a; c++)m(t1, c * r + e1, 1, o, s, n, l);
        }
        function m(t1, e1, i, o, a, r, s) {
            r[0] = 0, s[0] = -u, s[1] = u, a[0] = t1[e1];
            for(let n = 1, l = 0, c = 0; n < o; n++){
                a[n] = t1[e1 + n * i];
                const o = n * n;
                do {
                    const t1 = r[l];
                    c = (a[n] - a[t1] + o - t1 * t1) / (n - t1) / 2;
                }while (c <= s[l] && --l > -1);
                l++, r[l] = n, s[l] = c, s[l + 1] = u;
            }
            for(let n = 0, l = 0; n < o; n++){
                for(; s[l + 1] < n;)l++;
                const o = r[l], c = n - o;
                t1[e1 + n * i] = a[o] + c * c;
            }
        }
        class _ {
            setURL(t1) {
                this.url = t1;
            }
            getGlyphs(e1, i) {
                const o = [];
                for(const t1 in e1)for (const i of e1[t1])o.push({
                    stack: t1,
                    id: i
                });
                t1.asyncAll(o, ({ stack: t1, id: e1 }, i)=>{
                    let o = this.entries[t1];
                    o || (o = this.entries[t1] = {
                        glyphs: {},
                        requests: {},
                        ranges: {}
                    });
                    let a = o.glyphs[e1];
                    if (void 0 !== a) return void i(null, {
                        stack: t1,
                        id: e1,
                        glyph: a
                    });
                    if (a = this._tinySDF(o, t1, e1), a) return o.glyphs[e1] = a, void i(null, {
                        stack: t1,
                        id: e1,
                        glyph: a
                    });
                    const r = Math.floor(e1 / 256);
                    if (256 * r > 65535) return void i(new Error("glyphs > 65535 not supported"));
                    if (o.ranges[r]) return void i(null, {
                        stack: t1,
                        id: e1,
                        glyph: a
                    });
                    let s = o.requests[r];
                    s || (s = o.requests[r] = [], _.loadGlyphRange(t1, r, this.url, this.requestManager, (t1, e1)=>{
                        if (e1) {
                            for(const t1 in e1)this._doesCharSupportLocalGlyph(+t1) || (o.glyphs[+t1] = e1[+t1]);
                            o.ranges[r] = !0;
                        }
                        for (const i of s)i(t1, e1);
                        delete o.requests[r];
                    })), s.push((o, a)=>{
                        o ? i(o) : a && i(null, {
                            stack: t1,
                            id: e1,
                            glyph: a[e1] || null
                        });
                    });
                }, (t1, e1)=>{
                    if (t1) i(t1);
                    else if (e1) {
                        const t1 = {};
                        for (const { stack: i, id: o, glyph: a } of e1)(t1[i] || (t1[i] = {}))[o] = a && {
                            id: a.id,
                            bitmap: a.bitmap.clone(),
                            metrics: a.metrics
                        };
                        i(null, t1);
                    }
                });
            }
            _doesCharSupportLocalGlyph(e1) {
                return !!this.localIdeographFontFamily && (t1.unicodeBlockLookup["CJK Unified Ideographs"](e1) || t1.unicodeBlockLookup["Hangul Syllables"](e1) || t1.unicodeBlockLookup.Hiragana(e1) || t1.unicodeBlockLookup.Katakana(e1));
            }
            _tinySDF(e1, i, o) {
                const a = this.localIdeographFontFamily;
                if (!a) return;
                if (!this._doesCharSupportLocalGlyph(o)) return;
                let r = e1.tinySDF;
                if (!r) {
                    let t1 = "400";
                    /bold/i.test(i) ? t1 = "900" : /medium/i.test(i) ? t1 = "500" : /light/i.test(i) && (t1 = "200"), r = e1.tinySDF = new _.TinySDF({
                        fontSize: 24,
                        buffer: 3,
                        radius: 8,
                        cutoff: .25,
                        fontFamily: a,
                        fontWeight: t1
                    });
                }
                const s = r.draw(String.fromCharCode(o));
                return {
                    id: o,
                    bitmap: new t1.AlphaImage({
                        width: s.width || 30,
                        height: s.height || 30
                    }, s.data),
                    metrics: {
                        width: s.glyphWidth || 24,
                        height: s.glyphHeight || 24,
                        left: s.glyphLeft || 0,
                        top: s.glyphTop - 27 || -8,
                        advance: s.glyphAdvance || 24
                    }
                };
            }
            constructor(t1, e1){
                this.requestManager = t1, this.localIdeographFontFamily = e1, this.entries = {};
            }
        }
        _.loadGlyphRange = function(e1, i, o, a, r) {
            const s = 256 * i, n = s + 255, l = a.transformRequest(o.replace("{fontstack}", e1).replace("{range}", `${s}-${n}`), t1.ResourceType.Glyphs);
            t1.getArrayBuffer(l, (e1, i)=>{
                if (e1) r(e1);
                else if (i) {
                    const e1 = {};
                    for (const o of t1.parseGlyphPbf(i))e1[o.id] = o;
                    r(null, e1);
                }
            });
        }, _.TinySDF = class {
            _createCanvas(t1) {
                const e1 = document.createElement("canvas");
                return e1.width = e1.height = t1, e1;
            }
            draw(t1) {
                const { width: e1, actualBoundingBoxAscent: i, actualBoundingBoxDescent: o, actualBoundingBoxLeft: a, actualBoundingBoxRight: r } = this.ctx.measureText(t1), s = Math.ceil(i), n = Math.min(this.size - this.buffer, Math.ceil(r - a)), l = Math.min(this.size - this.buffer, s + Math.ceil(o)), c = n + 2 * this.buffer, h = l + 2 * this.buffer, m = Math.max(c * h, 0), _ = new Uint8ClampedArray(m), p = {
                    data: _,
                    width: c,
                    height: h,
                    glyphWidth: n,
                    glyphHeight: l,
                    glyphTop: s,
                    glyphLeft: 0,
                    glyphAdvance: e1
                };
                if (0 === n || 0 === l) return p;
                const { ctx: f, buffer: g, gridInner: x, gridOuter: v } = this;
                f.clearRect(g, g, n, l), f.fillText(t1, g, g + s);
                const y = f.getImageData(g, g, n, l);
                v.fill(u, 0, m), x.fill(0, 0, m);
                for(let t1 = 0; t1 < l; t1++)for(let e1 = 0; e1 < n; e1++){
                    const i = y.data[4 * (t1 * n + e1) + 3] / 255;
                    if (0 === i) continue;
                    const o = (t1 + g) * c + e1 + g;
                    if (1 === i) v[o] = 0, x[o] = u;
                    else {
                        const t1 = .5 - i;
                        v[o] = t1 > 0 ? t1 * t1 : 0, x[o] = t1 < 0 ? t1 * t1 : 0;
                    }
                }
                d(v, 0, 0, c, h, c, this.f, this.v, this.z), d(x, g, g, n, l, c, this.f, this.v, this.z);
                for(let t1 = 0; t1 < m; t1++){
                    const e1 = Math.sqrt(v[t1]) - Math.sqrt(x[t1]);
                    _[t1] = Math.round(255 - 255 * (e1 / this.radius + this.cutoff));
                }
                return p;
            }
            constructor({ fontSize: t1 = 24, buffer: e1 = 3, radius: i = 8, cutoff: o = .25, fontFamily: a = "sans-serif", fontWeight: r = "normal", fontStyle: s = "normal" } = {}){
                this.buffer = e1, this.cutoff = o, this.radius = i;
                const n = this.size = t1 + 4 * e1, l = this._createCanvas(n), c = this.ctx = l.getContext("2d", {
                    willReadFrequently: !0
                });
                c.font = `${s} ${r} ${t1}px ${a}`, c.textBaseline = "alphabetic", c.textAlign = "left", c.fillStyle = "black", this.gridOuter = new Float64Array(n * n), this.gridInner = new Float64Array(n * n), this.f = new Float64Array(n), this.z = new Float64Array(n + 1), this.v = new Uint16Array(n);
            }
        };
        const p = new t1.Properties({
            anchor: new t1.DataConstantProperty(t1.spec.light.anchor),
            position: new class {
                possiblyEvaluate(e1, i) {
                    return t1.sphericalToCartesian(e1.expression.evaluate(i));
                }
                interpolate(e1, i, o) {
                    return {
                        x: t1.number(e1.x, i.x, o),
                        y: t1.number(e1.y, i.y, o),
                        z: t1.number(e1.z, i.z, o)
                    };
                }
                constructor(){
                    this.specification = t1.spec.light.position;
                }
            },
            color: new t1.DataConstantProperty(t1.spec.light.color),
            intensity: new t1.DataConstantProperty(t1.spec.light.intensity)
        }), f = "-transition";
        class g extends t1.Evented {
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(e1, i = {}) {
                if (!this._validate(t1.validateLight, e1, i)) for(const t1 in e1){
                    const i = e1[t1];
                    t1.endsWith(f) ? this._transitionable.setTransition(t1.slice(0, -f.length), i) : this._transitionable.setValue(t1, i);
                }
            }
            updateTransitions(t1) {
                this._transitioning = this._transitionable.transitioned(t1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(t1) {
                this.properties = this._transitioning.possiblyEvaluate(t1);
            }
            _validate(e1, i, o) {
                return (!o || !1 !== o.validate) && t1.emitValidationErrors(this, e1.call(t1.validateStyle, t1.extend({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: t1.spec
                })));
            }
            constructor(e1){
                super(), this._transitionable = new t1.Transitionable(p), this.setLight(e1), this._transitioning = this._transitionable.untransitioned();
            }
        }
        class x {
            getDash(t1, e1) {
                const i = t1.join(",") + String(e1);
                return this.dashEntry[i] || (this.dashEntry[i] = this.addDash(t1, e1)), this.dashEntry[i];
            }
            getDashRanges(t1, e1, i) {
                const o = [];
                let a = t1.length % 2 == 1 ? -t1[t1.length - 1] * i : 0, r = t1[0] * i, s = !0;
                o.push({
                    left: a,
                    right: r,
                    isDash: s,
                    zeroLength: 0 === t1[0]
                });
                let n = t1[0];
                for(let e1 = 1; e1 < t1.length; e1++){
                    s = !s;
                    const l = t1[e1];
                    a = n * i, n += l, r = n * i, o.push({
                        left: a,
                        right: r,
                        isDash: s,
                        zeroLength: 0 === l
                    });
                }
                return o;
            }
            addRoundDash(t1, e1, i) {
                const o = e1 / 2;
                for(let e1 = -i; e1 <= i; e1++){
                    const a = this.width * (this.nextRow + i + e1);
                    let r = 0, s = t1[r];
                    for(let n = 0; n < this.width; n++){
                        n / s.right > 1 && (s = t1[++r]);
                        const l = Math.abs(n - s.left), c = Math.abs(n - s.right), h = Math.min(l, c);
                        let u;
                        const d = e1 / i * (o + 1);
                        if (s.isDash) {
                            const t1 = o - Math.abs(d);
                            u = Math.sqrt(h * h + t1 * t1);
                        } else u = o - Math.sqrt(h * h + d * d);
                        this.data[a + n] = Math.max(0, Math.min(255, u + 128));
                    }
                }
            }
            addRegularDash(t1) {
                for(let e1 = t1.length - 1; e1 >= 0; --e1){
                    const i = t1[e1], o = t1[e1 + 1];
                    i.zeroLength ? t1.splice(e1, 1) : o && o.isDash === i.isDash && (o.left = i.left, t1.splice(e1, 1));
                }
                const e1 = t1[0], i = t1[t1.length - 1];
                e1.isDash === i.isDash && (e1.left = i.left - this.width, i.right = e1.right + this.width);
                const o = this.width * this.nextRow;
                let a = 0, r = t1[a];
                for(let e1 = 0; e1 < this.width; e1++){
                    e1 / r.right > 1 && (r = t1[++a]);
                    const i = Math.abs(e1 - r.left), s = Math.abs(e1 - r.right), n = Math.min(i, s);
                    this.data[o + e1] = Math.max(0, Math.min(255, (r.isDash ? n : -n) + 128));
                }
            }
            addDash(e1, i) {
                const o = i ? 7 : 0, a = 2 * o + 1;
                if (this.nextRow + a > this.height) return t1.warnOnce("LineAtlas out of space"), null;
                let r = 0;
                for(let t1 = 0; t1 < e1.length; t1++)r += e1[t1];
                if (0 !== r) {
                    const t1 = this.width / r, a = this.getDashRanges(e1, this.width, t1);
                    i ? this.addRoundDash(a, t1, o) : this.addRegularDash(a);
                }
                const s = {
                    y: (this.nextRow + o + .5) / this.height,
                    height: 2 * o / this.height,
                    width: r
                };
                return this.nextRow += a, this.dirty = !0, s;
            }
            bind(t1) {
                const e1 = t1.gl;
                this.texture ? (e1.bindTexture(e1.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, e1.texSubImage2D(e1.TEXTURE_2D, 0, 0, 0, this.width, this.height, e1.ALPHA, e1.UNSIGNED_BYTE, this.data))) : (this.texture = e1.createTexture(), e1.bindTexture(e1.TEXTURE_2D, this.texture), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_WRAP_S, e1.REPEAT), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_WRAP_T, e1.REPEAT), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MIN_FILTER, e1.LINEAR), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MAG_FILTER, e1.LINEAR), e1.texImage2D(e1.TEXTURE_2D, 0, e1.ALPHA, this.width, this.height, 0, e1.ALPHA, e1.UNSIGNED_BYTE, this.data));
            }
            constructor(t1, e1){
                this.width = t1, this.height = e1, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
            }
        }
        class v {
            broadcast(e1, i, o) {
                t1.asyncAll(this.actors, (t1, o)=>{
                    t1.send(e1, i, o);
                }, o = o || function() {});
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove() {
                this.actors.forEach((t1)=>{
                    t1.remove();
                }), this.actors = [], this.workerPool.release(this.id);
            }
            constructor(e1, i){
                this.workerPool = e1, this.actors = [], this.currentActor = 0, this.id = t1.uniqueId();
                const o = this.workerPool.acquire(this.id);
                for(let t1 = 0; t1 < o.length; t1++){
                    const e1 = new v.Actor(o[t1], i, this.id);
                    e1.name = `Worker ${t1}`, this.actors.push(e1);
                }
                if (!this.actors.length) throw new Error("No actors found");
            }
        }
        function y(e1, i, o) {
            const a = function(i, a) {
                if (i) return o(i);
                if (a) {
                    const i = t1.pick(t1.extend(a, e1), [
                        "tiles",
                        "minzoom",
                        "maxzoom",
                        "attribution",
                        "bounds",
                        "scheme",
                        "tileSize",
                        "encoding"
                    ]);
                    a.vector_layers && (i.vectorLayers = a.vector_layers, i.vectorLayerIds = i.vectorLayers.map((t1)=>t1.id)), o(null, i);
                }
            };
            return e1.url ? t1.getJSON(i.transformRequest(e1.url, t1.ResourceType.Source), a) : t1.exported.frame(()=>a(null, e1));
        }
        v.Actor = t1.Actor;
        class b {
            validateBounds(t1) {
                return Array.isArray(t1) && 4 === t1.length ? [
                    Math.max(-180, t1[0]),
                    Math.max(-90, t1[1]),
                    Math.min(180, t1[2]),
                    Math.min(90, t1[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            contains(e1) {
                const i = Math.pow(2, e1.z), o = Math.floor(t1.mercatorXfromLng(this.bounds.getWest()) * i), a = Math.floor(t1.mercatorYfromLat(this.bounds.getNorth()) * i), r = Math.ceil(t1.mercatorXfromLng(this.bounds.getEast()) * i), s = Math.ceil(t1.mercatorYfromLat(this.bounds.getSouth()) * i);
                return e1.x >= o && e1.x < r && e1.y >= a && e1.y < s;
            }
            constructor(e1, i, o){
                this.bounds = t1.LngLatBounds.convert(this.validateBounds(e1)), this.minzoom = i || 0, this.maxzoom = o || 24;
            }
        }
        class w extends t1.Evented {
            load() {
                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this._tileJSONRequest = y(this._options, this.map._requestManager, (e1, i)=>{
                    this._tileJSONRequest = null, this._loaded = !0, this.map.style.sourceCaches[this.id].clearTiles(), e1 ? this.fire(new t1.ErrorEvent(e1)) : i && (t1.extend(this, i), i.bounds && (this.tileBounds = new b(i.bounds, this.minzoom, this.maxzoom)), this.fire(new t1.Event("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new t1.Event("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    })));
                });
            }
            loaded() {
                return this._loaded;
            }
            hasTile(t1) {
                return !this.tileBounds || this.tileBounds.contains(t1.canonical);
            }
            onAdd(t1) {
                this.map = t1, this.load();
            }
            setSourceProperty(t1) {
                this._tileJSONRequest && this._tileJSONRequest.cancel(), t1(), this.load();
            }
            setTiles(t1) {
                return this.setSourceProperty(()=>{
                    this._options.tiles = t1;
                }), this;
            }
            setUrl(t1) {
                return this.setSourceProperty(()=>{
                    this.url = t1, this._options.url = t1;
                }), this;
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
            serialize() {
                return t1.extend({}, this._options);
            }
            loadTile(e1, i) {
                const o = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), a = {
                    request: this.map._requestManager.transformRequest(o, t1.ResourceType.Tile),
                    uid: e1.uid,
                    tileID: e1.tileID,
                    zoom: e1.tileID.overscaledZ,
                    tileSize: this.tileSize * e1.tileID.overscaleFactor(),
                    type: this.type,
                    source: this.id,
                    pixelRatio: this.map.getPixelRatio(),
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId
                };
                function r(o, a) {
                    return delete e1.request, e1.aborted ? i(null) : o && 404 !== o.status ? i(o) : (a && a.resourceTiming && (e1.resourceTiming = a.resourceTiming), this.map._refreshExpiredTiles && a && e1.setExpiryData(a), e1.loadVectorData(a, this.map.painter), t1.cacheEntryPossiblyAdded(this.dispatcher), i(null), void (e1.reloadCallback && (this.loadTile(e1, e1.reloadCallback), e1.reloadCallback = null)));
                }
                a.request.collectResourceTiming = this._collectResourceTiming, e1.actor && "expired" !== e1.state ? "loading" === e1.state ? e1.reloadCallback = i : e1.request = e1.actor.send("reloadTile", a, r.bind(this)) : (e1.actor = this.dispatcher.getActor(), e1.request = e1.actor.send("loadTile", a, r.bind(this)));
            }
            abortTile(t1) {
                t1.request && (t1.request.cancel(), delete t1.request), t1.actor && t1.actor.send("abortTile", {
                    uid: t1.uid,
                    type: this.type,
                    source: this.id
                }, void 0);
            }
            unloadTile(t1) {
                t1.unloadVectorData(), t1.actor && t1.actor.send("removeTile", {
                    uid: t1.uid,
                    type: this.type,
                    source: this.id
                }, void 0);
            }
            hasTransition() {
                return !1;
            }
            constructor(e1, i, o, a){
                if (super(), this.id = e1, this.dispatcher = o, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, t1.extend(this, t1.pick(i, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = t1.extend({
                    type: "vector"
                }, i), this._collectResourceTiming = i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(a);
            }
        }
        class T extends t1.Evented {
            load() {
                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this._tileJSONRequest = y(this._options, this.map._requestManager, (e1, i)=>{
                    this._tileJSONRequest = null, this._loaded = !0, e1 ? this.fire(new t1.ErrorEvent(e1)) : i && (t1.extend(this, i), i.bounds && (this.tileBounds = new b(i.bounds, this.minzoom, this.maxzoom)), this.fire(new t1.Event("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new t1.Event("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    })));
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(t1) {
                this.map = t1, this.load();
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
            serialize() {
                return t1.extend({}, this._options);
            }
            hasTile(t1) {
                return !this.tileBounds || this.tileBounds.contains(t1.canonical);
            }
            loadTile(e1, i) {
                const o = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                e1.request = t1.getImage(this.map._requestManager.transformRequest(o, t1.ResourceType.Tile), (o, a, r)=>{
                    if (delete e1.request, e1.aborted) e1.state = "unloaded", i(null);
                    else if (o) e1.state = "errored", i(o);
                    else if (a) {
                        this.map._refreshExpiredTiles && e1.setExpiryData(r);
                        const o = this.map.painter.context, s = o.gl;
                        e1.texture = this.map.painter.getTileTexture(a.width), e1.texture ? e1.texture.update(a, {
                            useMipmap: !0
                        }) : (e1.texture = new l(o, a, s.RGBA, {
                            useMipmap: !0
                        }), e1.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE, s.LINEAR_MIPMAP_NEAREST), o.extTextureFilterAnisotropic && s.texParameterf(s.TEXTURE_2D, o.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, o.extTextureFilterAnisotropicMax)), e1.state = "loaded", t1.cacheEntryPossiblyAdded(this.dispatcher), i(null);
                    }
                });
            }
            abortTile(t1, e1) {
                t1.request && (t1.request.cancel(), delete t1.request), e1();
            }
            unloadTile(t1, e1) {
                t1.texture && this.map.painter.saveTileTexture(t1.texture), e1();
            }
            hasTransition() {
                return !1;
            }
            constructor(e1, i, o, a){
                super(), this.id = e1, this.dispatcher = o, this.setEventedParent(a), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = t1.extend({
                    type: "raster"
                }, i), t1.extend(this, t1.pick(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
        }
        let E;
        class I extends T {
            serialize() {
                return {
                    type: "raster-dem",
                    url: this.url,
                    tileSize: this.tileSize,
                    tiles: this.tiles,
                    bounds: this.bounds,
                    encoding: this.encoding
                };
            }
            loadTile(e1, i) {
                const o = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                function a(t1, o) {
                    t1 && (e1.state = "errored", i(t1)), o && (e1.dem = o, e1.needsHillshadePrepare = !0, e1.needsTerrainPrepare = !0, e1.state = "loaded", i(null));
                }
                e1.request = t1.getImage(this.map._requestManager.transformRequest(o, t1.ResourceType.Tile), (function(o, r) {
                    if (delete e1.request, e1.aborted) e1.state = "unloaded", i(null);
                    else if (o) e1.state = "errored", i(o);
                    else if (r) {
                        this.map._refreshExpiredTiles && e1.setExpiryData(r), delete r.cacheControl, delete r.expires;
                        const i = t1.isImageBitmap(r) && (null == E && (E = "undefined" != typeof OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof createImageBitmap), E) ? r : t1.exported.getImageData(r, 1), o = {
                            uid: e1.uid,
                            coord: e1.tileID,
                            source: this.id,
                            rawImageData: i,
                            encoding: this.encoding
                        };
                        e1.actor && "expired" !== e1.state || (e1.actor = this.dispatcher.getActor(), e1.actor.send("loadDEMTile", o, a.bind(this)));
                    }
                }).bind(this)), e1.neighboringTiles = this._getNeighboringTiles(e1.tileID);
            }
            _getNeighboringTiles(e1) {
                const i = e1.canonical, o = Math.pow(2, i.z), a = (i.x - 1 + o) % o, r = 0 === i.x ? e1.wrap - 1 : e1.wrap, s = (i.x + 1 + o) % o, n = i.x + 1 === o ? e1.wrap + 1 : e1.wrap, l = {};
                return l[new t1.OverscaledTileID(e1.overscaledZ, r, i.z, a, i.y).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, n, i.z, s, i.y).key] = {
                    backfilled: !1
                }, i.y > 0 && (l[new t1.OverscaledTileID(e1.overscaledZ, r, i.z, a, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, e1.wrap, i.z, i.x, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, n, i.z, s, i.y - 1).key] = {
                    backfilled: !1
                }), i.y + 1 < o && (l[new t1.OverscaledTileID(e1.overscaledZ, r, i.z, a, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, e1.wrap, i.z, i.x, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, n, i.z, s, i.y + 1).key] = {
                    backfilled: !1
                }), l;
            }
            unloadTile(t1) {
                t1.demTexture && this.map.painter.saveTileTexture(t1.demTexture), t1.fbo && (t1.fbo.destroy(), delete t1.fbo), t1.dem && delete t1.dem, delete t1.neighboringTiles, t1.state = "unloaded", t1.actor && t1.actor.send("removeDEMTile", {
                    uid: t1.uid,
                    source: this.id
                });
            }
            constructor(e1, i, o, a){
                super(e1, i, o, a), this.type = "raster-dem", this.maxzoom = 22, this._options = t1.extend({
                    type: "raster-dem"
                }, i), this.encoding = i.encoding || "mapbox";
            }
        }
        class C extends t1.Evented {
            load() {
                this._updateWorkerData("metadata");
            }
            onAdd(t1) {
                this.map = t1, this.load();
            }
            setData(t1) {
                return this._data = t1, this._updateWorkerData("content"), this;
            }
            getClusterExpansionZoom(t1, e1) {
                return this.actor.send("geojson.getClusterExpansionZoom", {
                    clusterId: t1,
                    source: this.id
                }, e1), this;
            }
            getClusterChildren(t1, e1) {
                return this.actor.send("geojson.getClusterChildren", {
                    clusterId: t1,
                    source: this.id
                }, e1), this;
            }
            getClusterLeaves(t1, e1, i, o) {
                return this.actor.send("geojson.getClusterLeaves", {
                    source: this.id,
                    clusterId: t1,
                    limit: e1,
                    offset: i
                }, o), this;
            }
            _updateWorkerData(e1) {
                const i = t1.extend({}, this.workerOptions), o = this._data;
                "string" == typeof o ? (i.request = this.map._requestManager.transformRequest(t1.exported.resolveURL(o), t1.ResourceType.Source), i.request.collectResourceTiming = this._collectResourceTiming) : i.data = JSON.stringify(o), this._pendingLoads++, this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this.actor.send(`${this.type}.loadData`, i, (i, o)=>{
                    if (this._pendingLoads--, this._removed || o && o.abandoned) return void this.fire(new t1.Event("dataabort", {
                        dataType: "source",
                        sourceDataType: e1
                    }));
                    let a = null;
                    if (o && o.resourceTiming && o.resourceTiming[this.id] && (a = o.resourceTiming[this.id].slice(0)), i) return void this.fire(new t1.ErrorEvent(i));
                    const r = {
                        dataType: "source",
                        sourceDataType: e1
                    };
                    this._collectResourceTiming && a && a.length > 0 && t1.extend(r, {
                        resourceTiming: a
                    }), this.fire(new t1.Event("data", r));
                });
            }
            loaded() {
                return 0 === this._pendingLoads;
            }
            loadTile(t1, e1) {
                const i = t1.actor ? "reloadTile" : "loadTile";
                t1.actor = this.actor;
                const o = {
                    type: this.type,
                    uid: t1.uid,
                    tileID: t1.tileID,
                    zoom: t1.tileID.overscaledZ,
                    maxZoom: this.maxzoom,
                    tileSize: this.tileSize,
                    source: this.id,
                    pixelRatio: this.map.getPixelRatio(),
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId
                };
                t1.request = this.actor.send(i, o, (o, a)=>(delete t1.request, t1.unloadVectorData(), t1.aborted ? e1(null) : o ? e1(o) : (t1.loadVectorData(a, this.map.painter, "reloadTile" === i), e1(null))));
            }
            abortTile(t1) {
                t1.request && (t1.request.cancel(), delete t1.request), t1.aborted = !0;
            }
            unloadTile(t1) {
                t1.unloadVectorData(), this.actor.send("removeTile", {
                    uid: t1.uid,
                    type: this.type,
                    source: this.id
                });
            }
            onRemove() {
                this._removed = !0, this.actor.send("removeSource", {
                    type: this.type,
                    source: this.id
                });
            }
            serialize() {
                return t1.extend({}, this._options, {
                    type: this.type,
                    data: this._data
                });
            }
            hasTransition() {
                return !1;
            }
            constructor(e1, i, o, a){
                super(), this.id = e1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._pendingLoads = 0, this.actor = o.getActor(), this.setEventedParent(a), this._data = i.data, this._options = t1.extend({}, i), this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId;
                const r = t1.EXTENT / this.tileSize;
                this.workerOptions = t1.extend({
                    source: this.id,
                    cluster: i.cluster || !1,
                    geojsonVtOptions: {
                        buffer: (void 0 !== i.buffer ? i.buffer : 128) * r,
                        tolerance: (void 0 !== i.tolerance ? i.tolerance : .375) * r,
                        extent: t1.EXTENT,
                        maxZoom: this.maxzoom,
                        lineMetrics: i.lineMetrics || !1,
                        generateId: i.generateId || !1
                    },
                    superclusterOptions: {
                        maxZoom: void 0 !== i.clusterMaxZoom ? i.clusterMaxZoom : this.maxzoom - 1,
                        minPoints: Math.max(2, i.clusterMinPoints || 2),
                        extent: t1.EXTENT,
                        radius: (i.clusterRadius || 50) * r,
                        log: !1,
                        generateId: i.generateId || !1
                    },
                    clusterProperties: i.clusterProperties,
                    filter: i.filter
                }, i.workerOptions);
            }
        }
        var S = t1.createLayout([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        class D extends t1.Evented {
            load(e1, i) {
                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this.url = this.options.url, t1.getImage(this.map._requestManager.transformRequest(this.url, t1.ResourceType.Image), (o, a)=>{
                    this._loaded = !0, o ? this.fire(new t1.ErrorEvent(o)) : a && (this.image = a, e1 && (this.coordinates = e1), i && i(), this._finishLoading());
                });
            }
            loaded() {
                return this._loaded;
            }
            updateImage(t1) {
                return this.image && t1.url ? (this.options.url = t1.url, this.load(t1.coordinates, ()=>{
                    this.texture = null;
                }), this) : this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new t1.Event("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(t1) {
                this.map = t1, this.load();
            }
            setCoordinates(e1) {
                this.coordinates = e1;
                const i = e1.map(t1.MercatorCoordinate.fromLngLat);
                this.tileID = function(e1) {
                    let i = 1 / 0, o = 1 / 0, a = -1 / 0, r = -1 / 0;
                    for (const t1 of e1)i = Math.min(i, t1.x), o = Math.min(o, t1.y), a = Math.max(a, t1.x), r = Math.max(r, t1.y);
                    const s = Math.max(a - i, r - o), n = Math.max(0, Math.floor(-Math.log(s) / Math.LN2)), l = Math.pow(2, n);
                    return new t1.CanonicalTileID(n, Math.floor((i + a) / 2 * l), Math.floor((o + r) / 2 * l));
                }(i), this.minzoom = this.maxzoom = this.tileID.z;
                const o = i.map((t1)=>this.tileID.getTilePoint(t1)._round());
                return this._boundsArray = new t1.RasterBoundsArray, this._boundsArray.emplaceBack(o[0].x, o[0].y, 0, 0), this._boundsArray.emplaceBack(o[1].x, o[1].y, t1.EXTENT, 0), this._boundsArray.emplaceBack(o[3].x, o[3].y, 0, t1.EXTENT), this._boundsArray.emplaceBack(o[2].x, o[2].y, t1.EXTENT, t1.EXTENT), this.boundsBuffer && (this.boundsBuffer.destroy(), delete this.boundsBuffer), this.fire(new t1.Event("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            prepare() {
                if (0 === Object.keys(this.tiles).length || !this.image) return;
                const e1 = this.map.painter.context, i = e1.gl;
                this.boundsBuffer || (this.boundsBuffer = e1.createVertexBuffer(this._boundsArray, S.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture || (this.texture = new l(e1, this.image, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                for(const t1 in this.tiles){
                    const e1 = this.tiles[t1];
                    "loaded" !== e1.state && (e1.state = "loaded", e1.texture = this.texture);
                }
            }
            loadTile(t1, e1) {
                this.tileID && this.tileID.equals(t1.tileID.canonical) ? (this.tiles[String(t1.tileID.wrap)] = t1, t1.buckets = {}, e1(null)) : (t1.state = "errored", e1(null));
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
            constructor(t1, e1, i, o){
                super(), this.id = t1, this.dispatcher = i, this.coordinates = e1.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(o), this.options = e1;
            }
        }
        class z extends D {
            load() {
                this._loaded = !1;
                const e1 = this.options;
                this.urls = [];
                for (const i of e1.urls)this.urls.push(this.map._requestManager.transformRequest(i, t1.ResourceType.Source).url);
                t1.getVideo(this.urls, (e1, i)=>{
                    this._loaded = !0, e1 ? this.fire(new t1.ErrorEvent(e1)) : i && (this.video = i, this.video.loop = !0, this.video.addEventListener("playing", ()=>{
                        this.map.triggerRepaint();
                    }), this.map && this.video.play(), this._finishLoading());
                });
            }
            pause() {
                this.video && this.video.pause();
            }
            play() {
                this.video && this.video.play();
            }
            seek(e1) {
                if (this.video) {
                    const i = this.video.seekable;
                    e1 < i.start(0) || e1 > i.end(0) ? this.fire(new t1.ErrorEvent(new t1.ValidationError(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = e1;
                }
            }
            getVideo() {
                return this.video;
            }
            onAdd(t1) {
                this.map || (this.map = t1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
            }
            prepare() {
                if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                const e1 = this.map.painter.context, i = e1.gl;
                this.boundsBuffer || (this.boundsBuffer = e1.createVertexBuffer(this._boundsArray, S.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new l(e1, this.video, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                for(const t1 in this.tiles){
                    const e1 = this.tiles[t1];
                    "loaded" !== e1.state && (e1.state = "loaded", e1.texture = this.texture);
                }
            }
            serialize() {
                return {
                    type: "video",
                    urls: this.urls,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return this.video && !this.video.paused;
            }
            constructor(t1, e1, i, o){
                super(t1, e1, i, o), this.roundZoom = !0, this.type = "video", this.options = e1;
            }
        }
        class P extends D {
            load() {
                this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new t1.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                    this._playing = !0, this.map.triggerRepaint();
                }, this.pause = function() {
                    this._playing && (this.prepare(), this._playing = !1);
                }, this._finishLoading());
            }
            getCanvas() {
                return this.canvas;
            }
            onAdd(t1) {
                this.map = t1, this.load(), this.canvas && this.animate && this.play();
            }
            onRemove() {
                this.pause();
            }
            prepare() {
                let e1 = !1;
                if (this.canvas.width !== this.width && (this.width = this.canvas.width, e1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e1 = !0), this._hasInvalidDimensions()) return;
                if (0 === Object.keys(this.tiles).length) return;
                const i = this.map.painter.context, o = i.gl;
                this.boundsBuffer || (this.boundsBuffer = i.createVertexBuffer(this._boundsArray, S.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? (e1 || this._playing) && this.texture.update(this.canvas, {
                    premultiply: !0
                }) : this.texture = new l(i, this.canvas, o.RGBA, {
                    premultiply: !0
                });
                for(const t1 in this.tiles){
                    const e1 = this.tiles[t1];
                    "loaded" !== e1.state && (e1.state = "loaded", e1.texture = this.texture);
                }
            }
            serialize() {
                return {
                    type: "canvas",
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return this._playing;
            }
            _hasInvalidDimensions() {
                for (const t1 of [
                    this.canvas.width,
                    this.canvas.height
                ])if (isNaN(t1) || t1 <= 0) return !0;
                return !1;
            }
            constructor(e1, i, o, a){
                super(e1, i, o, a), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((t1)=>!Array.isArray(t1) || 2 !== t1.length || t1.some((t1)=>"number" != typeof t1)) || this.fire(new t1.ErrorEvent(new t1.ValidationError(`sources.${e1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new t1.ErrorEvent(new t1.ValidationError(`sources.${e1}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new t1.ErrorEvent(new t1.ValidationError(`sources.${e1}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || this.fire(new t1.ErrorEvent(new t1.ValidationError(`sources.${e1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new t1.ErrorEvent(new t1.ValidationError(`sources.${e1}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
            }
        }
        const M = {
            vector: w,
            raster: T,
            "raster-dem": I,
            geojson: C,
            video: z,
            image: D,
            canvas: P
        };
        function A(e1, i) {
            const o = t1.create();
            return t1.translate(o, o, [
                1,
                1,
                0
            ]), t1.scale(o, o, [
                .5 * e1.width,
                .5 * e1.height,
                1
            ]), t1.multiply(o, o, e1.calculatePosMatrix(i.toUnwrapped()));
        }
        function L(t1, e1, i, o, a, r) {
            const s = function(t1, e1, i) {
                if (t1) for (const o of t1){
                    const t1 = e1[o];
                    if (t1 && t1.source === i && "fill-extrusion" === t1.type) return !0;
                }
                else for(const t1 in e1){
                    const o = e1[t1];
                    if (o.source === i && "fill-extrusion" === o.type) return !0;
                }
                return !1;
            }(a && a.layers, e1, t1.id), n = r.maxPitchScaleFactor(), l = t1.tilesIn(o, n, s);
            l.sort(R);
            const c = [];
            for (const o of l)c.push({
                wrappedTileID: o.tileID.wrapped().key,
                queryResults: o.tile.queryRenderedFeatures(e1, i, t1._state, o.queryGeometry, o.cameraQueryGeometry, o.scale, a, r, n, A(t1.transform, o.tileID))
            });
            const h = function(t1) {
                const e1 = {}, i = {};
                for (const o of t1){
                    const t1 = o.queryResults, a = o.wrappedTileID, r = i[a] = i[a] || {};
                    for(const i in t1){
                        const o = t1[i], a = r[i] = r[i] || {}, s = e1[i] = e1[i] || [];
                        for (const t1 of o)a[t1.featureIndex] || (a[t1.featureIndex] = !0, s.push(t1));
                    }
                }
                return e1;
            }(c);
            for(const e1 in h)h[e1].forEach((e1)=>{
                const i = e1.feature, o = t1.getFeatureState(i.layer["source-layer"], i.id);
                i.source = i.layer.source, i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]), i.state = o;
            });
            return h;
        }
        function R(t1, e1) {
            const i = t1.tileID, o = e1.tileID;
            return i.overscaledZ - o.overscaledZ || i.canonical.y - o.canonical.y || i.wrap - o.wrap || i.canonical.x - o.canonical.x;
        }
        class k {
            registerFadeDuration(e1) {
                const i = e1 + this.timeAdded;
                i < t1.exported.now() || this.fadeEndTime && i < this.fadeEndTime || (this.fadeEndTime = i);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            clearTextures(t1) {
                this.demTexture && t1.saveTileTexture(this.demTexture), this.textures.forEach((e1)=>t1.saveTileTexture(e1)), this.demTexture = null, this.textures = [], this.textureCoords = {};
            }
            loadVectorData(e1, i, o) {
                if (this.hasData() && this.unloadVectorData(), this.state = "loaded", e1) {
                    e1.featureIndex && (this.latestFeatureIndex = e1.featureIndex, e1.rawTileData ? (this.latestRawTileData = e1.rawTileData, this.latestFeatureIndex.rawTileData = e1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = e1.collisionBoxArray, this.buckets = function(t1, e1) {
                        const i = {};
                        if (!e1) return i;
                        for (const o of t1){
                            const t1 = o.layerIds.map((t1)=>e1.getLayer(t1)).filter(Boolean);
                            if (0 !== t1.length) {
                                o.layers = t1, o.stateDependentLayerIds && (o.stateDependentLayers = o.stateDependentLayerIds.map((e1)=>t1.filter((t1)=>t1.id === e1)[0]));
                                for (const e1 of t1)i[e1.id] = o;
                            }
                        }
                        return i;
                    }(e1.buckets, i.style), this.hasSymbolBuckets = !1;
                    for(const e1 in this.buckets){
                        const i = this.buckets[e1];
                        if (i instanceof t1.SymbolBucket) {
                            if (this.hasSymbolBuckets = !0, !o) break;
                            i.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const e1 in this.buckets){
                        const i = this.buckets[e1];
                        if (i instanceof t1.SymbolBucket && i.hasRTLText) {
                            this.hasRTLText = !0, t1.lazyLoadRTLTextPlugin();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const t1 in this.buckets){
                        const e1 = this.buckets[t1];
                        this.queryPadding = Math.max(this.queryPadding, i.style.getLayer(t1).queryRadius(e1));
                    }
                    e1.imageAtlas && (this.imageAtlas = e1.imageAtlas), e1.glyphAtlasImage && (this.glyphAtlasImage = e1.glyphAtlasImage);
                } else this.collisionBoxArray = new t1.CollisionBoxArray;
            }
            unloadVectorData() {
                for(const t1 in this.buckets)this.buckets[t1].destroy();
                this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.latestFeatureIndex = null, this.state = "unloaded";
            }
            getBucket(t1) {
                return this.buckets[t1.id];
            }
            upload(t1) {
                for(const e1 in this.buckets){
                    const i = this.buckets[e1];
                    i.uploadPending() && i.upload(t1);
                }
                const e1 = t1.gl;
                this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new l(t1, this.imageAtlas.image, e1.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new l(t1, this.glyphAtlasImage, e1.ALPHA), this.glyphAtlasImage = null);
            }
            prepare(t1) {
                this.imageAtlas && this.imageAtlas.patchUpdatedImages(t1, this.imageAtlasTexture);
            }
            queryRenderedFeatures(t1, e1, i, o, a, r, s, n, l, c) {
                return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                    queryGeometry: o,
                    cameraQueryGeometry: a,
                    scale: r,
                    tileSize: this.tileSize,
                    pixelPosMatrix: c,
                    transform: n,
                    params: s,
                    queryPadding: this.queryPadding * l
                }, t1, e1, i) : {};
            }
            querySourceFeatures(e1, i) {
                const o = this.latestFeatureIndex;
                if (!o || !o.rawTileData) return;
                const a = o.loadVTLayers(), r = i ? i.sourceLayer : "", s = a._geojsonTileLayer || a[r];
                if (!s) return;
                const n = t1.createFilter(i && i.filter), { z: l, x: c, y: h } = this.tileID.canonical, u = {
                    z: l,
                    x: c,
                    y: h
                };
                for(let i = 0; i < s.length; i++){
                    const a = s.feature(i);
                    if (n.needGeometry) {
                        const e1 = t1.toEvaluationFeature(a, !0);
                        if (!n.filter(new t1.EvaluationParameters(this.tileID.overscaledZ), e1, this.tileID.canonical)) continue;
                    } else if (!n.filter(new t1.EvaluationParameters(this.tileID.overscaledZ), a)) continue;
                    const d = o.getId(a, r), m = new t1.GeoJSONFeature(a, l, c, h, d);
                    m.tile = u, e1.push(m);
                }
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
            }
            setExpiryData(e1) {
                const i = this.expirationTime;
                if (e1.cacheControl) {
                    const i = t1.parseCacheControl(e1.cacheControl);
                    i["max-age"] && (this.expirationTime = Date.now() + 1e3 * i["max-age"]);
                } else e1.expires && (this.expirationTime = new Date(e1.expires).getTime());
                if (this.expirationTime) {
                    const t1 = Date.now();
                    let e1 = !1;
                    if (this.expirationTime > t1) e1 = !1;
                    else if (i) {
                        if (this.expirationTime < i) e1 = !0;
                        else {
                            const o = this.expirationTime - i;
                            o ? this.expirationTime = t1 + Math.max(o, 3e4) : e1 = !0;
                        }
                    } else e1 = !0;
                    e1 ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            setFeatureState(t1, e1) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || 0 === Object.keys(t1).length) return;
                const i = this.latestFeatureIndex.loadVTLayers();
                for(const o in this.buckets){
                    if (!e1.style.hasLayer(o)) continue;
                    const a = this.buckets[o], r = a.layers[0].sourceLayer || "_geojsonTileLayer", s = i[r], n = t1[r];
                    if (!s || !n || 0 === Object.keys(n).length) continue;
                    a.update(n, s, this.imageAtlas && this.imageAtlas.patternPositions || {});
                    const l = e1 && e1.style && e1.style.getLayer(o);
                    l && (this.queryPadding = Math.max(this.queryPadding, l.queryRadius(a)));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < t1.exported.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(e1) {
                this.symbolFadeHoldUntil = t1.exported.now() + e1;
            }
            setDependencies(t1, e1) {
                const i = {};
                for (const t1 of e1)i[t1] = !0;
                this.dependencies[t1] = i;
            }
            hasDependency(t1, e1) {
                for (const i of t1){
                    const t1 = this.dependencies[i];
                    if (t1) {
                        for (const i of e1)if (t1[i]) return !0;
                    }
                }
                return !1;
            }
            constructor(e1, i){
                this.tileID = e1, this.uid = t1.uniqueId(), this.uses = 0, this.tileSize = i, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.textures = [], this.textureCoords = {}, this.expiredRequestCount = 0, this.state = "loading";
            }
        }
        class B {
            reset() {
                for(const t1 in this.data)for (const e1 of this.data[t1])e1.timeout && clearTimeout(e1.timeout), this.onRemove(e1.value);
                return this.data = {}, this.order = [], this;
            }
            add(t1, e1, i) {
                const o = t1.wrapped().key;
                void 0 === this.data[o] && (this.data[o] = []);
                const a = {
                    value: e1,
                    timeout: void 0
                };
                if (void 0 !== i && (a.timeout = setTimeout(()=>{
                    this.remove(t1, a);
                }, i)), this.data[o].push(a), this.order.push(o), this.order.length > this.max) {
                    const t1 = this._getAndRemoveByKey(this.order[0]);
                    t1 && this.onRemove(t1);
                }
                return this;
            }
            has(t1) {
                return t1.wrapped().key in this.data;
            }
            getAndRemove(t1) {
                return this.has(t1) ? this._getAndRemoveByKey(t1.wrapped().key) : null;
            }
            _getAndRemoveByKey(t1) {
                const e1 = this.data[t1].shift();
                return e1.timeout && clearTimeout(e1.timeout), 0 === this.data[t1].length && delete this.data[t1], this.order.splice(this.order.indexOf(t1), 1), e1.value;
            }
            getByKey(t1) {
                const e1 = this.data[t1];
                return e1 ? e1[0].value : null;
            }
            get(t1) {
                return this.has(t1) ? this.data[t1.wrapped().key][0].value : null;
            }
            remove(t1, e1) {
                if (!this.has(t1)) return this;
                const i = t1.wrapped().key, o = void 0 === e1 ? 0 : this.data[i].indexOf(e1), a = this.data[i][o];
                return this.data[i].splice(o, 1), a.timeout && clearTimeout(a.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(a.value), this.order.splice(this.order.indexOf(i), 1), this;
            }
            setMaxSize(t1) {
                for(this.max = t1; this.order.length > this.max;){
                    const t1 = this._getAndRemoveByKey(this.order[0]);
                    t1 && this.onRemove(t1);
                }
                return this;
            }
            filter(t1) {
                const e1 = [];
                for(const i in this.data)for (const o of this.data[i])t1(o.value) || e1.push(o);
                for (const t1 of e1)this.remove(t1.value.tileID, t1);
            }
            constructor(t1, e1){
                this.max = t1, this.onRemove = e1, this.reset();
            }
        }
        class F {
            updateState(e1, i, o) {
                const a = String(i);
                if (this.stateChanges[e1] = this.stateChanges[e1] || {}, this.stateChanges[e1][a] = this.stateChanges[e1][a] || {}, t1.extend(this.stateChanges[e1][a], o), null === this.deletedStates[e1]) {
                    this.deletedStates[e1] = {};
                    for(const t1 in this.state[e1])t1 !== a && (this.deletedStates[e1][t1] = null);
                } else if (this.deletedStates[e1] && null === this.deletedStates[e1][a]) {
                    this.deletedStates[e1][a] = {};
                    for(const t1 in this.state[e1][a])o[t1] || (this.deletedStates[e1][a][t1] = null);
                } else for(const t1 in o)this.deletedStates[e1] && this.deletedStates[e1][a] && null === this.deletedStates[e1][a][t1] && delete this.deletedStates[e1][a][t1];
            }
            removeFeatureState(t1, e1, i) {
                if (null === this.deletedStates[t1]) return;
                const o = String(e1);
                if (this.deletedStates[t1] = this.deletedStates[t1] || {}, i && void 0 !== e1) null !== this.deletedStates[t1][o] && (this.deletedStates[t1][o] = this.deletedStates[t1][o] || {}, this.deletedStates[t1][o][i] = null);
                else if (void 0 !== e1) {
                    if (this.stateChanges[t1] && this.stateChanges[t1][o]) for(i in this.deletedStates[t1][o] = {}, this.stateChanges[t1][o])this.deletedStates[t1][o][i] = null;
                    else this.deletedStates[t1][o] = null;
                } else this.deletedStates[t1] = null;
            }
            getState(e1, i) {
                const o = String(i), a = t1.extend({}, (this.state[e1] || {})[o], (this.stateChanges[e1] || {})[o]);
                if (null === this.deletedStates[e1]) return {};
                if (this.deletedStates[e1]) {
                    const t1 = this.deletedStates[e1][i];
                    if (null === t1) return {};
                    for(const e1 in t1)delete a[e1];
                }
                return a;
            }
            initializeTileState(t1, e1) {
                t1.setFeatureState(this.state, e1);
            }
            coalesceChanges(e1, i) {
                const o = {};
                for(const e1 in this.stateChanges){
                    this.state[e1] = this.state[e1] || {};
                    const i = {};
                    for(const o in this.stateChanges[e1])this.state[e1][o] || (this.state[e1][o] = {}), t1.extend(this.state[e1][o], this.stateChanges[e1][o]), i[o] = this.state[e1][o];
                    o[e1] = i;
                }
                for(const e1 in this.deletedStates){
                    this.state[e1] = this.state[e1] || {};
                    const i = {};
                    if (null === this.deletedStates[e1]) for(const t1 in this.state[e1])i[t1] = {}, this.state[e1][t1] = {};
                    else for(const t1 in this.deletedStates[e1]){
                        if (null === this.deletedStates[e1][t1]) this.state[e1][t1] = {};
                        else for (const i of Object.keys(this.deletedStates[e1][t1]))delete this.state[e1][t1][i];
                        i[t1] = this.state[e1][t1];
                    }
                    o[e1] = o[e1] || {}, t1.extend(o[e1], i);
                }
                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(o).length) for(const t1 in e1)e1[t1].setFeatureState(o, i);
            }
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
        }
        class O extends t1.Evented {
            onAdd(t1) {
                this.map = t1, this._maxTileCacheSize = t1 ? t1._maxTileCacheSize : null, this._source && this._source.onAdd && this._source.onAdd(t1);
            }
            onRemove(t1) {
                this.clearTiles(), this._source && this._source.onRemove && this._source.onRemove(t1);
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                for(const t1 in this._tiles){
                    const e1 = this._tiles[t1];
                    if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
                }
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const t1 = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, t1 && this.reload(), this.transform && this.update(this.transform, this.terrain);
            }
            _loadTile(t1, e1) {
                return this._source.loadTile(t1, e1);
            }
            _unloadTile(t1) {
                if (this._source.unloadTile) return this._source.unloadTile(t1, ()=>{});
            }
            _abortTile(e1) {
                this._source.abortTile && this._source.abortTile(e1, ()=>{}), this._source.fire(new t1.Event("dataabort", {
                    tile: e1,
                    coord: e1.tileID,
                    dataType: "source"
                }));
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(t1) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for(const e1 in this._tiles){
                    const i = this._tiles[e1];
                    i.upload(t1), i.prepare(this.map.style.imageManager);
                }
            }
            getIds() {
                return Object.values(this._tiles).map((t1)=>t1.tileID).sort(U).map((t1)=>t1.key);
            }
            getRenderableIds(e1) {
                const i = [];
                for(const t1 in this._tiles)this._isIdRenderable(t1, e1) && i.push(this._tiles[t1]);
                return e1 ? i.sort((e1, i)=>{
                    const o = e1.tileID, a = i.tileID, r = new t1.pointGeometry(o.canonical.x, o.canonical.y)._rotate(this.transform.angle), s = new t1.pointGeometry(a.canonical.x, a.canonical.y)._rotate(this.transform.angle);
                    return o.overscaledZ - a.overscaledZ || s.y - r.y || s.x - r.x;
                }).map((t1)=>t1.tileID.key) : i.map((t1)=>t1.tileID).sort(U).map((t1)=>t1.key);
            }
            hasRenderableParent(t1) {
                const e1 = this.findLoadedParent(t1, 0);
                return !!e1 && this._isIdRenderable(e1.tileID.key);
            }
            _isIdRenderable(t1, e1) {
                return this._tiles[t1] && this._tiles[t1].hasData() && !this._coveredTiles[t1] && (e1 || !this._tiles[t1].holdingForFade());
            }
            reload() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const t1 in this._tiles)"errored" !== this._tiles[t1].state && this._reloadTile(t1, "reloading");
                }
            }
            _reloadTile(t1, e1) {
                const i = this._tiles[t1];
                i && ("loading" !== i.state && (i.state = e1), this._loadTile(i, this._tileLoaded.bind(this, i, t1, e1)));
            }
            _tileLoaded(e1, i, o, a) {
                if (a) return e1.state = "errored", void (404 !== a.status ? this._source.fire(new t1.ErrorEvent(a, {
                    tile: e1
                })) : this.update(this.transform, this.terrain));
                e1.timeAdded = t1.exported.now(), "expired" === o && (e1.refreshedUponExpiration = !0), this._setTileReloadTimer(i, e1), "raster-dem" === this.getSource().type && e1.dem && this._backfillDEM(e1), this._state.initializeTileState(e1, this.map ? this.map.painter : null), e1.aborted || this._source.fire(new t1.Event("data", {
                    dataType: "source",
                    tile: e1,
                    coord: e1.tileID
                }));
            }
            _backfillDEM(t1) {
                const e1 = this.getRenderableIds();
                for(let o = 0; o < e1.length; o++){
                    const a = e1[o];
                    if (t1.neighboringTiles && t1.neighboringTiles[a]) {
                        const e1 = this.getTileByID(a);
                        i(t1, e1), i(e1, t1);
                    }
                }
                function i(t1, e1) {
                    t1.needsHillshadePrepare = !0, t1.needsTerrainPrepare = !0;
                    let i = e1.tileID.canonical.x - t1.tileID.canonical.x;
                    const o = e1.tileID.canonical.y - t1.tileID.canonical.y, a = Math.pow(2, t1.tileID.canonical.z), r = e1.tileID.key;
                    0 === i && 0 === o || Math.abs(o) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + a) ? i += a : 1 === Math.abs(i - a) && (i -= a)), e1.dem && t1.dem && (t1.dem.backfillBorder(e1.dem, i, o), t1.neighboringTiles && t1.neighboringTiles[r] && (t1.neighboringTiles[r].backfilled = !0)));
                }
            }
            getTile(t1) {
                return this.getTileByID(t1.key);
            }
            getTileByID(t1) {
                return this._tiles[t1];
            }
            _retainLoadedChildren(t1, e1, i, o) {
                for(const a in this._tiles){
                    let r = this._tiles[a];
                    if (o[a] || !r.hasData() || r.tileID.overscaledZ <= e1 || r.tileID.overscaledZ > i) continue;
                    let s = r.tileID;
                    for(; r && r.tileID.overscaledZ > e1 + 1;){
                        const t1 = r.tileID.scaledTo(r.tileID.overscaledZ - 1);
                        r = this._tiles[t1.key], r && r.hasData() && (s = t1);
                    }
                    let n = s;
                    for(; n.overscaledZ > e1;)if (n = n.scaledTo(n.overscaledZ - 1), t1[n.key]) {
                        o[s.key] = s;
                        break;
                    }
                }
            }
            findLoadedParent(t1, e1) {
                if (t1.key in this._loadedParentTiles) {
                    const i = this._loadedParentTiles[t1.key];
                    return i && i.tileID.overscaledZ >= e1 ? i : null;
                }
                for(let i = t1.overscaledZ - 1; i >= e1; i--){
                    const e1 = t1.scaledTo(i), o = this._getLoadedTile(e1);
                    if (o) return o;
                }
            }
            _getLoadedTile(t1) {
                const e1 = this._tiles[t1.key];
                return e1 && e1.hasData() ? e1 : this._cache.getByKey(t1.wrapped().key);
            }
            updateCacheSize(t1) {
                const e1 = Math.ceil(t1.width / this._source.tileSize) + 1, i = Math.ceil(t1.height / this._source.tileSize) + 1, o = Math.floor(e1 * i * 5), a = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, o) : o;
                this._cache.setMaxSize(a);
            }
            handleWrapJump(t1) {
                const e1 = Math.round((t1 - (void 0 === this._prevLng ? t1 : this._prevLng)) / 360);
                if (this._prevLng = t1, e1) {
                    const t1 = {};
                    for(const i in this._tiles){
                        const o = this._tiles[i];
                        o.tileID = o.tileID.unwrapTo(o.tileID.wrap + e1), t1[o.tileID.key] = o;
                    }
                    this._tiles = t1;
                    for(const t1 in this._timers)clearTimeout(this._timers[t1]), delete this._timers[t1];
                    for(const t1 in this._tiles)this._setTileReloadTimer(t1, this._tiles[t1]);
                }
            }
            update(e1, i) {
                if (this.transform = e1, this.terrain = i, !this._sourceLoaded || this._paused) return;
                let o;
                this.updateCacheSize(e1), this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used || this.usedForTerrain ? this._source.tileID ? o = e1.getVisibleUnwrappedCoordinates(this._source.tileID).map((e1)=>new t1.OverscaledTileID(e1.canonical.z, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y)) : (o = e1.coveringTiles({
                    tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: !this.usedForTerrain && this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled,
                    terrain: i
                }), this._source.hasTile && (o = o.filter((t1)=>this._source.hasTile(t1)))) : o = [];
                const a = e1.coveringZoomLevel(this._source), r = Math.max(a - O.maxOverzooming, this._source.minzoom), s = Math.max(a + O.maxUnderzooming, this._source.minzoom);
                if (this.usedForTerrain) {
                    const t1 = {};
                    for (const e1 of o)if (e1.canonical.z > this._source.minzoom) {
                        const i = e1.scaledTo(e1.canonical.z - 1);
                        t1[i.key] = i;
                        const o = e1.scaledTo(Math.max(this._source.minzoom, Math.min(e1.canonical.z, 5)));
                        t1[o.key] = o;
                    }
                    o = o.concat(Object.values(t1));
                }
                const n = this._updateRetainedTiles(o, a);
                if (N(this._source.type)) {
                    const e1 = {}, l = {}, c = Object.keys(n);
                    for (const i of c){
                        const o = n[i], a = this._tiles[i];
                        if (!a || a.fadeEndTime && a.fadeEndTime <= t1.exported.now()) continue;
                        const s = this.findLoadedParent(o, r);
                        s && (this._addTile(s.tileID), e1[s.tileID.key] = s.tileID), l[i] = o;
                    }
                    this._retainLoadedChildren(l, a, s, n);
                    for(const t1 in e1)n[t1] || (this._coveredTiles[t1] = !0, n[t1] = e1[t1]);
                    if (i) {
                        const t1 = {}, e1 = {};
                        for (const i of o)this._tiles[i.key].hasData() ? t1[i.key] = i : e1[i.key] = i;
                        for(const i in e1){
                            const o = e1[i].children(this._source.maxzoom);
                            this._tiles[o[0].key] && this._tiles[o[1].key] && this._tiles[o[2].key] && this._tiles[o[3].key] && (t1[o[0].key] = n[o[0].key] = o[0], t1[o[1].key] = n[o[1].key] = o[1], t1[o[2].key] = n[o[2].key] = o[2], t1[o[3].key] = n[o[3].key] = o[3], delete e1[i]);
                        }
                        for(const i in e1){
                            const o = this.findLoadedParent(e1[i], this._source.minzoom);
                            if (o) {
                                t1[o.tileID.key] = n[o.tileID.key] = o.tileID;
                                for(const e1 in t1)t1[e1].isChildOf(o.tileID) && delete t1[e1];
                            }
                        }
                        for(const e1 in this._tiles)t1[e1] || (this._coveredTiles[e1] = !0);
                    }
                }
                for(const t1 in n)this._tiles[t1].clearFadeHold();
                const l = t1.keysDifference(this._tiles, n);
                for (const t1 of l){
                    const e1 = this._tiles[t1];
                    e1.hasSymbolBuckets && !e1.holdingForFade() ? e1.setHoldDuration(this.map._fadeDuration) : e1.hasSymbolBuckets && !e1.symbolFadeFinished() || this._removeTile(t1);
                }
                this._updateLoadedParentTileCache();
            }
            releaseSymbolFadeTiles() {
                for(const t1 in this._tiles)this._tiles[t1].holdingForFade() && this._removeTile(t1);
            }
            _updateRetainedTiles(t1, e1) {
                const i = {}, o = {}, a = Math.max(e1 - O.maxOverzooming, this._source.minzoom), r = Math.max(e1 + O.maxUnderzooming, this._source.minzoom), s = {};
                for (const o of t1){
                    const t1 = this._addTile(o);
                    i[o.key] = o, t1.hasData() || e1 < this._source.maxzoom && (s[o.key] = o);
                }
                this._retainLoadedChildren(s, e1, r, i);
                for (const r of t1){
                    let t1 = this._tiles[r.key];
                    if (t1.hasData()) continue;
                    if (e1 + 1 > this._source.maxzoom) {
                        const t1 = r.children(this._source.maxzoom)[0], e1 = this.getTile(t1);
                        if (e1 && e1.hasData()) {
                            i[t1.key] = t1;
                            continue;
                        }
                    } else {
                        const t1 = r.children(this._source.maxzoom);
                        if (i[t1[0].key] && i[t1[1].key] && i[t1[2].key] && i[t1[3].key]) continue;
                    }
                    let s = t1.wasRequested();
                    for(let e1 = r.overscaledZ - 1; e1 >= a; --e1){
                        const a = r.scaledTo(e1);
                        if (o[a.key]) break;
                        if (o[a.key] = !0, t1 = this.getTile(a), !t1 && s && (t1 = this._addTile(a)), t1 && (i[a.key] = a, s = t1.wasRequested(), t1.hasData())) break;
                    }
                }
                return i;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles = {};
                for(const t1 in this._tiles){
                    const e1 = [];
                    let i, o = this._tiles[t1].tileID;
                    for(; o.overscaledZ > 0;){
                        if (o.key in this._loadedParentTiles) {
                            i = this._loadedParentTiles[o.key];
                            break;
                        }
                        e1.push(o.key);
                        const t1 = o.scaledTo(o.overscaledZ - 1);
                        if (i = this._getLoadedTile(t1), i) break;
                        o = t1;
                    }
                    for (const t1 of e1)this._loadedParentTiles[t1] = i;
                }
            }
            _addTile(e1) {
                let i = this._tiles[e1.key];
                if (i) return i;
                i = this._cache.getAndRemove(e1), i && (this._setTileReloadTimer(e1.key, i), i.tileID = e1, this._state.initializeTileState(i, this.map ? this.map.painter : null), this._cacheTimers[e1.key] && (clearTimeout(this._cacheTimers[e1.key]), delete this._cacheTimers[e1.key], this._setTileReloadTimer(e1.key, i)));
                const o = i;
                return i || (i = new k(e1, this._source.tileSize * e1.overscaleFactor()), this._loadTile(i, this._tileLoaded.bind(this, i, e1.key, i.state))), i.uses++, this._tiles[e1.key] = i, o || this._source.fire(new t1.Event("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i;
            }
            _setTileReloadTimer(t1, e1) {
                t1 in this._timers && (clearTimeout(this._timers[t1]), delete this._timers[t1]);
                const i = e1.getExpiryTimeout();
                i && (this._timers[t1] = setTimeout(()=>{
                    this._reloadTile(t1, "expired"), delete this._timers[t1];
                }, i));
            }
            _removeTile(t1) {
                const e1 = this._tiles[t1];
                e1 && (e1.uses--, delete this._tiles[t1], this._timers[t1] && (clearTimeout(this._timers[t1]), delete this._timers[t1]), e1.uses > 0 || (e1.hasData() && "reloading" !== e1.state ? this._cache.add(e1.tileID, e1, e1.getExpiryTimeout()) : (e1.aborted = !0, this._abortTile(e1), this._unloadTile(e1))));
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const t1 in this._tiles)this._removeTile(t1);
                this._cache.reset();
            }
            tilesIn(e1, i, o) {
                const a = [], r = this.transform;
                if (!r) return a;
                const s = o ? r.getCameraQueryGeometry(e1) : e1, n = e1.map((t1)=>r.pointCoordinate(t1, this.terrain)), l = s.map((t1)=>r.pointCoordinate(t1, this.terrain)), c = this.getIds();
                let h = 1 / 0, u = 1 / 0, d = -1 / 0, m = -1 / 0;
                for (const t1 of l)h = Math.min(h, t1.x), u = Math.min(u, t1.y), d = Math.max(d, t1.x), m = Math.max(m, t1.y);
                for(let e1 = 0; e1 < c.length; e1++){
                    const o = this._tiles[c[e1]];
                    if (o.holdingForFade()) continue;
                    const s = o.tileID, _ = Math.pow(2, r.zoom - o.tileID.overscaledZ), p = i * o.queryPadding * t1.EXTENT / o.tileSize / _, f = [
                        s.getTilePoint(new t1.MercatorCoordinate(h, u)),
                        s.getTilePoint(new t1.MercatorCoordinate(d, m))
                    ];
                    if (f[0].x - p < t1.EXTENT && f[0].y - p < t1.EXTENT && f[1].x + p >= 0 && f[1].y + p >= 0) {
                        const t1 = n.map((t1)=>s.getTilePoint(t1)), e1 = l.map((t1)=>s.getTilePoint(t1));
                        a.push({
                            tile: o,
                            tileID: s,
                            queryGeometry: t1,
                            cameraQueryGeometry: e1,
                            scale: _
                        });
                    }
                }
                return a;
            }
            getVisibleCoordinates(t1) {
                const e1 = this.getRenderableIds(t1).map((t1)=>this._tiles[t1].tileID);
                for (const t1 of e1)t1.posMatrix = this.transform.calculatePosMatrix(t1.toUnwrapped());
                return e1;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (N(this._source.type)) for(const e1 in this._tiles){
                    const i = this._tiles[e1];
                    if (void 0 !== i.fadeEndTime && i.fadeEndTime >= t1.exported.now()) return !0;
                }
                return !1;
            }
            setFeatureState(t1, e1, i) {
                this._state.updateState(t1 = t1 || "_geojsonTileLayer", e1, i);
            }
            removeFeatureState(t1, e1, i) {
                this._state.removeFeatureState(t1 = t1 || "_geojsonTileLayer", e1, i);
            }
            getFeatureState(t1, e1) {
                return this._state.getState(t1 = t1 || "_geojsonTileLayer", e1);
            }
            setDependencies(t1, e1, i) {
                const o = this._tiles[t1];
                o && o.setDependencies(e1, i);
            }
            reloadTilesForDependencies(t1, e1) {
                for(const i in this._tiles)this._tiles[i].hasDependency(t1, e1) && this._reloadTile(i, "reloading");
                this._cache.filter((i)=>!i.hasDependency(t1, e1));
            }
            constructor(e1, i, o){
                super(), this.id = e1, this.dispatcher = o, this.on("data", (t1)=>{
                    "source" === t1.dataType && "metadata" === t1.sourceDataType && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === t1.dataType && "content" === t1.sourceDataType && (this.reload(), this.transform && this.update(this.transform, this.terrain));
                }), this.on("dataloading", ()=>{
                    this._sourceErrored = !1;
                }), this.on("error", ()=>{
                    this._sourceErrored = this._source.loaded();
                }), this._source = function(e1, i, o, a) {
                    const r = new M[i.type](e1, i, o, a);
                    if (r.id !== e1) throw new Error(`Expected Source id to be ${e1} instead of ${r.id}`);
                    return t1.bindAll([
                        "load",
                        "abort",
                        "unload",
                        "serialize",
                        "prepare"
                    ], r), r;
                }(e1, i, o, this), this._tiles = {}, this._cache = new B(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._maxTileCacheSize = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new F;
            }
        }
        function U(t1, e1) {
            const i = Math.abs(2 * t1.wrap) - +(t1.wrap < 0), o = Math.abs(2 * e1.wrap) - +(e1.wrap < 0);
            return t1.overscaledZ - e1.overscaledZ || o - i || e1.canonical.y - t1.canonical.y || e1.canonical.x - t1.canonical.x;
        }
        function N(t1) {
            return "raster" === t1 || "image" === t1 || "video" === t1;
        }
        O.maxOverzooming = 10, O.maxUnderzooming = 3;
        const G = "mapboxgl_preloaded_worker_pool";
        class Z {
            acquire(t1) {
                if (!this.workers) for(this.workers = []; this.workers.length < Z.workerCount;)this.workers.push(new Worker(ba.workerUrl));
                return this.active[t1] = !0, this.workers.slice();
            }
            release(t1) {
                delete this.active[t1], 0 === this.numActive() && (this.workers.forEach((t1)=>{
                    t1.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[G];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
            constructor(){
                this.active = {};
            }
        }
        const V = Math.floor(t1.exported.hardwareConcurrency / 2);
        let q;
        function j() {
            return q || (q = new Z), q;
        }
        function $(e1, i) {
            const o = {};
            for(const t1 in e1)"ref" !== t1 && (o[t1] = e1[t1]);
            return t1.refProperties.forEach((t1)=>{
                t1 in i && (o[t1] = i[t1]);
            }), o;
        }
        function X(t1) {
            t1 = t1.slice();
            const e1 = Object.create(null);
            for(let i = 0; i < t1.length; i++)e1[t1[i].id] = t1[i];
            for(let i = 0; i < t1.length; i++)"ref" in t1[i] && (t1[i] = $(t1[i], e1[t1[i].ref]));
            return t1;
        }
        Z.workerCount = Math.max(Math.min(V, 6), 1);
        const W = {
            setStyle: "setStyle",
            addLayer: "addLayer",
            removeLayer: "removeLayer",
            setPaintProperty: "setPaintProperty",
            setLayoutProperty: "setLayoutProperty",
            setFilter: "setFilter",
            addSource: "addSource",
            removeSource: "removeSource",
            setGeoJSONSourceData: "setGeoJSONSourceData",
            setLayerZoomRange: "setLayerZoomRange",
            setLayerProperty: "setLayerProperty",
            setCenter: "setCenter",
            setZoom: "setZoom",
            setBearing: "setBearing",
            setPitch: "setPitch",
            setSprite: "setSprite",
            setGlyphs: "setGlyphs",
            setTransition: "setTransition",
            setLight: "setLight"
        };
        function H(t1, e1, i) {
            i.push({
                command: W.addSource,
                args: [
                    t1,
                    e1[t1]
                ]
            });
        }
        function K(t1, e1, i) {
            e1.push({
                command: W.removeSource,
                args: [
                    t1
                ]
            }), i[t1] = !0;
        }
        function Y(t1, e1, i, o) {
            K(t1, i, o), H(t1, e1, i);
        }
        function J(t1, e1, i) {
            let o;
            for(o in t1[i])if (Object.prototype.hasOwnProperty.call(t1[i], o) && "data" !== o && !a(t1[i][o], e1[i][o])) return !1;
            for(o in e1[i])if (Object.prototype.hasOwnProperty.call(e1[i], o) && "data" !== o && !a(t1[i][o], e1[i][o])) return !1;
            return !0;
        }
        function Q(t1, e1, i, o, r, s) {
            let n;
            for(n in e1 = e1 || {}, t1 = t1 || {})Object.prototype.hasOwnProperty.call(t1, n) && (a(t1[n], e1[n]) || i.push({
                command: s,
                args: [
                    o,
                    n,
                    e1[n],
                    r
                ]
            }));
            for(n in e1)Object.prototype.hasOwnProperty.call(e1, n) && !Object.prototype.hasOwnProperty.call(t1, n) && (a(t1[n], e1[n]) || i.push({
                command: s,
                args: [
                    o,
                    n,
                    e1[n],
                    r
                ]
            }));
        }
        function tt(t1) {
            return t1.id;
        }
        function et(t1, e1) {
            return t1[e1.id] = e1, t1;
        }
        class it {
            reset(t1, e1) {
                this.points = t1 || [], this._distances = [
                    0
                ];
                for(let t1 = 1; t1 < this.points.length; t1++)this._distances[t1] = this._distances[t1 - 1] + this.points[t1].dist(this.points[t1 - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(e1 || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(e1) {
                if (1 === this.points.length) return this.points[0];
                e1 = t1.clamp(e1, 0, 1);
                let i = 1, o = this._distances[i];
                const a = e1 * this.paddedLength + this.padding;
                for(; o < a && i < this._distances.length;)o = this._distances[++i];
                const r = i - 1, s = this._distances[r], n = o - s, l = n > 0 ? (a - s) / n : 0;
                return this.points[r].mult(1 - l).add(this.points[i].mult(l));
            }
            constructor(t1, e1){
                this.reset(t1, e1);
            }
        }
        function ot(t1, e1) {
            let i = !0;
            return "always" === t1 || "never" !== t1 && "never" !== e1 || (i = !1), i;
        }
        class at {
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(t1, e1, i, o, a) {
                this._forEachCell(e1, i, o, a, this._insertBoxCell, this.boxUid++), this.boxKeys.push(t1), this.bboxes.push(e1), this.bboxes.push(i), this.bboxes.push(o), this.bboxes.push(a);
            }
            insertCircle(t1, e1, i, o) {
                this._forEachCell(e1 - o, i - o, e1 + o, i + o, this._insertCircleCell, this.circleUid++), this.circleKeys.push(t1), this.circles.push(e1), this.circles.push(i), this.circles.push(o);
            }
            _insertBoxCell(t1, e1, i, o, a, r) {
                this.boxCells[a].push(r);
            }
            _insertCircleCell(t1, e1, i, o, a, r) {
                this.circleCells[a].push(r);
            }
            _query(t1, e1, i, o, a, r, s) {
                if (i < 0 || t1 > this.width || o < 0 || e1 > this.height) return [];
                const n = [];
                if (t1 <= 0 && e1 <= 0 && this.width <= i && this.height <= o) {
                    if (a) return [
                        {
                            key: null,
                            x1: t1,
                            y1: e1,
                            x2: i,
                            y2: o
                        }
                    ];
                    for(let t1 = 0; t1 < this.boxKeys.length; t1++)n.push({
                        key: this.boxKeys[t1],
                        x1: this.bboxes[4 * t1],
                        y1: this.bboxes[4 * t1 + 1],
                        x2: this.bboxes[4 * t1 + 2],
                        y2: this.bboxes[4 * t1 + 3]
                    });
                    for(let t1 = 0; t1 < this.circleKeys.length; t1++){
                        const e1 = this.circles[3 * t1], i = this.circles[3 * t1 + 1], o = this.circles[3 * t1 + 2];
                        n.push({
                            key: this.circleKeys[t1],
                            x1: e1 - o,
                            y1: i - o,
                            x2: e1 + o,
                            y2: i + o
                        });
                    }
                } else this._forEachCell(t1, e1, i, o, this._queryCell, n, {
                    hitTest: a,
                    overlapMode: r,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, s);
                return n;
            }
            query(t1, e1, i, o) {
                return this._query(t1, e1, i, o, !1, null);
            }
            hitTest(t1, e1, i, o, a, r) {
                return this._query(t1, e1, i, o, !0, a, r).length > 0;
            }
            hitTestCircle(t1, e1, i, o, a) {
                const r = t1 - i, s = t1 + i, n = e1 - i, l = e1 + i;
                if (s < 0 || r > this.width || l < 0 || n > this.height) return !1;
                const c = [];
                return this._forEachCell(r, n, s, l, this._queryCellCircle, c, {
                    hitTest: !0,
                    overlapMode: o,
                    circle: {
                        x: t1,
                        y: e1,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, a), c.length > 0;
            }
            _queryCell(t1, e1, i, o, a, r, s, n) {
                const { seenUids: l, hitTest: c, overlapMode: h } = s, u = this.boxCells[a];
                if (null !== u) {
                    const a = this.bboxes;
                    for (const s of u)if (!l.box[s]) {
                        l.box[s] = !0;
                        const u = 4 * s, d = this.boxKeys[s];
                        if (t1 <= a[u + 2] && e1 <= a[u + 3] && i >= a[u + 0] && o >= a[u + 1] && (!n || n(d)) && (!c || !ot(h, d.overlapMode)) && (r.push({
                            key: d,
                            x1: a[u],
                            y1: a[u + 1],
                            x2: a[u + 2],
                            y2: a[u + 3]
                        }), c)) return !0;
                    }
                }
                const d = this.circleCells[a];
                if (null !== d) {
                    const a = this.circles;
                    for (const s of d)if (!l.circle[s]) {
                        l.circle[s] = !0;
                        const u = 3 * s, d = this.circleKeys[s];
                        if (this._circleAndRectCollide(a[u], a[u + 1], a[u + 2], t1, e1, i, o) && (!n || n(d)) && (!c || !ot(h, d.overlapMode))) {
                            const t1 = a[u], e1 = a[u + 1], i = a[u + 2];
                            if (r.push({
                                key: d,
                                x1: t1 - i,
                                y1: e1 - i,
                                x2: t1 + i,
                                y2: e1 + i
                            }), c) return !0;
                        }
                    }
                }
                return !1;
            }
            _queryCellCircle(t1, e1, i, o, a, r, s, n) {
                const { circle: l, seenUids: c, overlapMode: h } = s, u = this.boxCells[a];
                if (null !== u) {
                    const t1 = this.bboxes;
                    for (const e1 of u)if (!c.box[e1]) {
                        c.box[e1] = !0;
                        const i = 4 * e1, o = this.boxKeys[e1];
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, t1[i + 0], t1[i + 1], t1[i + 2], t1[i + 3]) && (!n || n(o)) && !ot(h, o.overlapMode)) return r.push(!0), !0;
                    }
                }
                const d = this.circleCells[a];
                if (null !== d) {
                    const t1 = this.circles;
                    for (const e1 of d)if (!c.circle[e1]) {
                        c.circle[e1] = !0;
                        const i = 3 * e1, o = this.circleKeys[e1];
                        if (this._circlesCollide(t1[i], t1[i + 1], t1[i + 2], l.x, l.y, l.radius) && (!n || n(o)) && !ot(h, o.overlapMode)) return r.push(!0), !0;
                    }
                }
            }
            _forEachCell(t1, e1, i, o, a, r, s, n) {
                const l = this._convertToXCellCoord(t1), c = this._convertToYCellCoord(e1), h = this._convertToXCellCoord(i), u = this._convertToYCellCoord(o);
                for(let d = l; d <= h; d++)for(let l = c; l <= u; l++)if (a.call(this, t1, e1, i, o, this.xCellCount * l + d, r, s, n)) return;
            }
            _convertToXCellCoord(t1) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(t1 * this.xScale)));
            }
            _convertToYCellCoord(t1) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(t1 * this.yScale)));
            }
            _circlesCollide(t1, e1, i, o, a, r) {
                const s = o - t1, n = a - e1, l = i + r;
                return l * l > s * s + n * n;
            }
            _circleAndRectCollide(t1, e1, i, o, a, r, s) {
                const n = (r - o) / 2, l = Math.abs(t1 - (o + n));
                if (l > n + i) return !1;
                const c = (s - a) / 2, h = Math.abs(e1 - (a + c));
                if (h > c + i) return !1;
                if (l <= n || h <= c) return !0;
                const u = l - n, d = h - c;
                return u * u + d * d <= i * i;
            }
            constructor(t1, e1, i){
                const o = this.boxCells = [], a = this.circleCells = [];
                this.xCellCount = Math.ceil(t1 / i), this.yCellCount = Math.ceil(e1 / i);
                for(let t1 = 0; t1 < this.xCellCount * this.yCellCount; t1++)o.push([]), a.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = t1, this.height = e1, this.xScale = this.xCellCount / t1, this.yScale = this.yCellCount / e1, this.boxUid = 0, this.circleUid = 0;
            }
        }
        function rt(e1, i, o, a, r) {
            const s = t1.create();
            return i ? (t1.scale(s, s, [
                1 / r,
                1 / r,
                1
            ]), o || t1.rotateZ(s, s, a.angle)) : t1.multiply(s, a.labelPlaneMatrix, e1), s;
        }
        function st(e1, i, o, a, r) {
            if (i) {
                const i = t1.clone(e1);
                return t1.scale(i, i, [
                    r,
                    r,
                    1
                ]), o || t1.rotateZ(i, i, -a.angle), i;
            }
            return a.glCoordMatrix;
        }
        function nt(e1, i, o) {
            let a;
            o ? (a = [
                e1.x,
                e1.y,
                o(e1.x, e1.y),
                1
            ], t1.transformMat4(a, a, i)) : (a = [
                e1.x,
                e1.y,
                0,
                1
            ], xt(a, a, i));
            const r = a[3];
            return {
                point: new t1.pointGeometry(a[0] / r, a[1] / r),
                signedDistanceFromCamera: r
            };
        }
        function lt(t1, e1) {
            return .5 + t1 / e1 * .5;
        }
        function ct(t1, e1) {
            const i = t1[0] / t1[3], o = t1[1] / t1[3];
            return i >= -e1[0] && i <= e1[0] && o >= -e1[1] && o <= e1[1];
        }
        function ht(e1, i, o, a, r, s, n, l, c, h) {
            const u = a ? e1.textSizeData : e1.iconSizeData, d = t1.evaluateSizeForZoom(u, o.transform.zoom), m = [
                256 / o.width * 2 + 1,
                256 / o.height * 2 + 1
            ], _ = a ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
            _.clear();
            const p = e1.lineVertexArray, f = a ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, g = o.transform.width / o.transform.height;
            let x = !1;
            for(let a = 0; a < f.length; a++){
                const v = f.get(a);
                if (v.hidden || v.writingMode === t1.WritingMode.vertical && !x) {
                    gt(v.numGlyphs, _);
                    continue;
                }
                let y;
                if (x = !1, h ? (y = [
                    v.anchorX,
                    v.anchorY,
                    h(v.anchorX, v.anchorY),
                    1
                ], t1.transformMat4(y, y, i)) : (y = [
                    v.anchorX,
                    v.anchorY,
                    0,
                    1
                ], xt(y, y, i)), !ct(y, m)) {
                    gt(v.numGlyphs, _);
                    continue;
                }
                const b = lt(o.transform.cameraToCenterDistance, y[3]), w = t1.evaluateSizeForFeature(u, d, v), T = n ? w / b : w * b, E = new t1.pointGeometry(v.anchorX, v.anchorY), I = nt(E, r, h).point, C = {}, S = mt(v, T, !1, l, i, r, s, e1.glyphOffsetArray, p, _, I, E, C, g, c, h);
                x = S.useVertical, (S.notEnoughRoom || x || S.needsFlipping && mt(v, T, !0, l, i, r, s, e1.glyphOffsetArray, p, _, I, E, C, g, c, h).notEnoughRoom) && gt(v.numGlyphs, _);
            }
            a ? e1.text.dynamicLayoutVertexBuffer.updateData(_) : e1.icon.dynamicLayoutVertexBuffer.updateData(_);
        }
        function ut(t1, e1, i, o, a, r, s, n, l, c, h, u, d) {
            const m = n.glyphStartIndex + n.numGlyphs, _ = n.lineStartIndex, p = n.lineStartIndex + n.lineLength, f = e1.getoffsetX(n.glyphStartIndex), g = e1.getoffsetX(m - 1), x = pt(t1 * f, i, o, a, r, s, n.segment, _, p, l, c, h, u, d);
            if (!x) return null;
            const v = pt(t1 * g, i, o, a, r, s, n.segment, _, p, l, c, h, u, d);
            return v ? {
                first: x,
                last: v
            } : null;
        }
        function dt(e1, i, o, a) {
            return e1 === t1.WritingMode.horizontal && Math.abs(o.y - i.y) > Math.abs(o.x - i.x) * a ? {
                useVertical: !0
            } : (e1 === t1.WritingMode.vertical ? i.y < o.y : i.x > o.x) ? {
                needsFlipping: !0
            } : null;
        }
        function mt(e1, i, o, a, r, s, n, l, c, h, u, d, m, _, p, f) {
            const g = i / 24, x = e1.lineOffsetX * g, v = e1.lineOffsetY * g;
            let y;
            if (e1.numGlyphs > 1) {
                const t1 = e1.glyphStartIndex + e1.numGlyphs, i = e1.lineStartIndex, r = e1.lineStartIndex + e1.lineLength, h = ut(g, l, x, v, o, u, d, e1, c, s, m, p, f);
                if (!h) return {
                    notEnoughRoom: !0
                };
                const b = nt(h.first.point, n, f).point, w = nt(h.last.point, n, f).point;
                if (a && !o) {
                    const t1 = dt(e1.writingMode, b, w, _);
                    if (t1) return t1;
                }
                y = [
                    h.first
                ];
                for(let a = e1.glyphStartIndex + 1; a < t1 - 1; a++)y.push(pt(g * l.getoffsetX(a), x, v, o, u, d, e1.segment, i, r, c, s, m, p, f));
                y.push(h.last);
            } else {
                if (a && !o) {
                    const i = nt(d, r, f).point, o = e1.lineStartIndex + e1.segment + 1, a = new t1.pointGeometry(c.getx(o), c.gety(o)), s = nt(a, r, f), n = s.signedDistanceFromCamera > 0 ? s.point : _t(d, a, i, 1, r, f), l = dt(e1.writingMode, i, n, _);
                    if (l) return l;
                }
                const i = pt(g * l.getoffsetX(e1.glyphStartIndex), x, v, o, u, d, e1.segment, e1.lineStartIndex, e1.lineStartIndex + e1.lineLength, c, s, m, p, f);
                if (!i) return {
                    notEnoughRoom: !0
                };
                y = [
                    i
                ];
            }
            for (const e1 of y)t1.addDynamicAttributes(h, e1.point, e1.angle);
            return {};
        }
        function _t(t1, e1, i, o, a, r) {
            const s = nt(t1.add(t1.sub(e1)._unit()), a, r).point, n = i.sub(s);
            return i.add(n._mult(o / n.mag()));
        }
        function pt(e1, i, o, a, r, s, n, l, c, h, u, d, m, _) {
            const p = a ? e1 - i : e1 + i;
            let f = p > 0 ? 1 : -1, g = 0;
            a && (f *= -1, g = Math.PI), f < 0 && (g += Math.PI);
            let x = f > 0 ? l + n : l + n + 1, v = r, y = r, b = 0, w = 0;
            const T = Math.abs(p), E = [];
            for(; b + w <= T;){
                if (x += f, x < l || x >= c) return null;
                if (y = v, E.push(v), v = d[x], void 0 === v) {
                    const e1 = new t1.pointGeometry(h.getx(x), h.gety(x)), i = nt(e1, u, _);
                    if (i.signedDistanceFromCamera > 0) v = d[x] = i.point;
                    else {
                        const i = x - f;
                        v = _t(0 === b ? s : new t1.pointGeometry(h.getx(i), h.gety(i)), e1, y, T - b + 1, u, _);
                    }
                }
                b += w, w = y.dist(v);
            }
            const I = (T - b) / w, C = v.sub(y), S = C.mult(I)._add(y);
            S._add(C._unit()._perp()._mult(o * f));
            const D = g + Math.atan2(v.y - y.y, v.x - y.x);
            return E.push(S), {
                point: S,
                angle: m ? D : 0,
                path: E
            };
        }
        const ft = new Float32Array([
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0
        ]);
        function gt(t1, e1) {
            for(let i = 0; i < t1; i++){
                const t1 = e1.length;
                e1.resize(t1 + 4), e1.float32.set(ft, 3 * t1);
            }
        }
        function xt(t1, e1, i) {
            const o = e1[0], a = e1[1];
            return t1[0] = i[0] * o + i[4] * a + i[12], t1[1] = i[1] * o + i[5] * a + i[13], t1[3] = i[3] * o + i[7] * a + i[15], t1;
        }
        const vt = 100;
        class yt {
            placeCollisionBox(t1, e1, i, o, a, r) {
                const s = this.projectAndGetPerspectiveRatio(o, t1.anchorPointX, t1.anchorPointY, r), n = i * s.perspectiveRatio, l = t1.x1 * n + s.point.x, c = t1.y1 * n + s.point.y, h = t1.x2 * n + s.point.x, u = t1.y2 * n + s.point.y;
                return !this.isInsideGrid(l, c, h, u) || "always" !== e1 && this.grid.hitTest(l, c, h, u, e1, a) || s.perspectiveRatio < this.perspectiveRatioCutoff ? {
                    box: [],
                    offscreen: !1
                } : {
                    box: [
                        l,
                        c,
                        h,
                        u
                    ],
                    offscreen: this.isOffscreen(l, c, h, u)
                };
            }
            placeCollisionCircles(e1, i, o, a, r, s, n, l, c, h, u, d, m, _) {
                const p = [], f = new t1.pointGeometry(i.anchorX, i.anchorY), g = nt(f, s, _), x = lt(this.transform.cameraToCenterDistance, g.signedDistanceFromCamera), v = (h ? r / x : r * x) / t1.ONE_EM, y = nt(f, n, _).point, b = ut(v, a, i.lineOffsetX * v, i.lineOffsetY * v, !1, y, f, i, o, n, {}, !1, _);
                let w = !1, T = !1, E = !0;
                if (b) {
                    const i = .5 * d * x + m, o = new t1.pointGeometry(-100, -100), a = new t1.pointGeometry(this.screenRightBoundary, this.screenBottomBoundary), r = new it, s = b.first, n = b.last;
                    let h = [];
                    for(let t1 = s.path.length - 1; t1 >= 1; t1--)h.push(s.path[t1]);
                    for(let t1 = 1; t1 < n.path.length; t1++)h.push(n.path[t1]);
                    const f = 2.5 * i;
                    if (l) {
                        const t1 = h.map((t1)=>nt(t1, l, _));
                        h = t1.some((t1)=>t1.signedDistanceFromCamera <= 0) ? [] : t1.map((t1)=>t1.point);
                    }
                    let g = [];
                    if (h.length > 0) {
                        const e1 = h[0].clone(), i = h[0].clone();
                        for(let t1 = 1; t1 < h.length; t1++)e1.x = Math.min(e1.x, h[t1].x), e1.y = Math.min(e1.y, h[t1].y), i.x = Math.max(i.x, h[t1].x), i.y = Math.max(i.y, h[t1].y);
                        g = e1.x >= o.x && i.x <= a.x && e1.y >= o.y && i.y <= a.y ? [
                            h
                        ] : i.x < o.x || e1.x > a.x || i.y < o.y || e1.y > a.y ? [] : t1.clipLine([
                            h
                        ], o.x, o.y, a.x, a.y);
                    }
                    for (const t1 of g){
                        r.reset(t1, .25 * i);
                        let o = 0;
                        o = r.length <= .5 * i ? 1 : Math.ceil(r.paddedLength / f) + 1;
                        for(let t1 = 0; t1 < o; t1++){
                            const a = t1 / Math.max(o - 1, 1), s = r.lerp(a), n = s.x + vt, l = s.y + vt;
                            p.push(n, l, i, 0);
                            const h = n - i, d = l - i, m = n + i, _ = l + i;
                            if (E = E && this.isOffscreen(h, d, m, _), T = T || this.isInsideGrid(h, d, m, _), "always" !== e1 && this.grid.hitTestCircle(n, l, i, e1, u) && (w = !0, !c)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: w
                            };
                        }
                    }
                }
                return {
                    circles: !c && w || !T || x < this.perspectiveRatioCutoff ? [] : p,
                    offscreen: E,
                    collisionDetected: w
                };
            }
            queryRenderedSymbols(e1) {
                if (0 === e1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [];
                let o = 1 / 0, a = 1 / 0, r = -1 / 0, s = -1 / 0;
                for (const n of e1){
                    const e1 = new t1.pointGeometry(n.x + vt, n.y + vt);
                    o = Math.min(o, e1.x), a = Math.min(a, e1.y), r = Math.max(r, e1.x), s = Math.max(s, e1.y), i.push(e1);
                }
                const n = this.grid.query(o, a, r, s).concat(this.ignoredGrid.query(o, a, r, s)), l = {}, c = {};
                for (const e1 of n){
                    const o = e1.key;
                    if (void 0 === l[o.bucketInstanceId] && (l[o.bucketInstanceId] = {}), l[o.bucketInstanceId][o.featureIndex]) continue;
                    const a = [
                        new t1.pointGeometry(e1.x1, e1.y1),
                        new t1.pointGeometry(e1.x2, e1.y1),
                        new t1.pointGeometry(e1.x2, e1.y2),
                        new t1.pointGeometry(e1.x1, e1.y2)
                    ];
                    t1.polygonIntersectsPolygon(i, a) && (l[o.bucketInstanceId][o.featureIndex] = !0, void 0 === c[o.bucketInstanceId] && (c[o.bucketInstanceId] = []), c[o.bucketInstanceId].push(o.featureIndex));
                }
                return c;
            }
            insertCollisionBox(t1, e1, i, o, a, r) {
                (i ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: o,
                    featureIndex: a,
                    collisionGroupID: r,
                    overlapMode: e1
                }, t1[0], t1[1], t1[2], t1[3]);
            }
            insertCollisionCircles(t1, e1, i, o, a, r) {
                const s = i ? this.ignoredGrid : this.grid, n = {
                    bucketInstanceId: o,
                    featureIndex: a,
                    collisionGroupID: r,
                    overlapMode: e1
                };
                for(let e1 = 0; e1 < t1.length; e1 += 4)s.insertCircle(n, t1[e1], t1[e1 + 1], t1[e1 + 2]);
            }
            projectAndGetPerspectiveRatio(e1, i, o, a) {
                let r;
                return a ? (r = [
                    i,
                    o,
                    a(i, o),
                    1
                ], t1.transformMat4(r, r, e1)) : (r = [
                    i,
                    o,
                    0,
                    1
                ], xt(r, r, e1)), {
                    point: new t1.pointGeometry((r[0] / r[3] + 1) / 2 * this.transform.width + vt, (-r[1] / r[3] + 1) / 2 * this.transform.height + vt),
                    perspectiveRatio: .5 + this.transform.cameraToCenterDistance / r[3] * .5
                };
            }
            isOffscreen(t1, e1, i, o) {
                return i < vt || t1 >= this.screenRightBoundary || o < vt || e1 > this.screenBottomBoundary;
            }
            isInsideGrid(t1, e1, i, o) {
                return i >= 0 && t1 < this.gridRightBoundary && o >= 0 && e1 < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const e1 = t1.identity([]);
                return t1.translate(e1, e1, [
                    -100,
                    -100,
                    0
                ]), e1;
            }
            constructor(t1, e1 = new at(t1.width + 200, t1.height + 200, 25), i = new at(t1.width + 200, t1.height + 200, 25)){
                this.transform = t1, this.grid = e1, this.ignoredGrid = i, this.pitchfactor = Math.cos(t1._pitch) * t1.cameraToCenterDistance, this.screenRightBoundary = t1.width + vt, this.screenBottomBoundary = t1.height + vt, this.gridRightBoundary = t1.width + 200, this.gridBottomBoundary = t1.height + 200, this.perspectiveRatioCutoff = .6;
            }
        }
        function bt(e1, i, o) {
            return i * (t1.EXTENT / (e1.tileSize * Math.pow(2, o - e1.tileID.overscaledZ)));
        }
        class wt {
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
            constructor(t1, e1, i, o){
                this.opacity = t1 ? Math.max(0, Math.min(1, t1.opacity + (t1.placed ? e1 : -e1))) : o && i ? 1 : 0, this.placed = i;
            }
        }
        class Tt {
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
            constructor(t1, e1, i, o, a){
                this.text = new wt(t1 ? t1.text : null, e1, i, a), this.icon = new wt(t1 ? t1.icon : null, e1, o, a);
            }
        }
        class Et {
            constructor(t1, e1, i){
                this.text = t1, this.icon = e1, this.skipFade = i;
            }
        }
        class It {
            constructor(){
                this.invProjMatrix = t1.create(), this.viewportMatrix = t1.create(), this.circles = [];
            }
        }
        class Ct {
            constructor(t1, e1, i, o, a){
                this.bucketInstanceId = t1, this.featureIndex = e1, this.sourceLayerIndex = i, this.bucketIndex = o, this.tileID = a;
            }
        }
        class St {
            get(t1) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[t1]) {
                    const e1 = ++this.maxGroupID;
                    this.collisionGroups[t1] = {
                        ID: e1,
                        predicate: (t1)=>t1.collisionGroupID === e1
                    };
                }
                return this.collisionGroups[t1];
            }
            constructor(t1){
                this.crossSourceCollisions = t1, this.maxGroupID = 0, this.collisionGroups = {};
            }
        }
        function Dt(e1, i, o, a, r) {
            const { horizontalAlign: s, verticalAlign: n } = t1.getAnchorAlignment(e1), l = -(s - .5) * i, c = -(n - .5) * o, h = t1.evaluateVariableOffset(e1, a);
            return new t1.pointGeometry(l + h[0] * r, c + h[1] * r);
        }
        function zt(e1, i, o, a, r, s) {
            const { x1: n, x2: l, y1: c, y2: h, anchorPointX: u, anchorPointY: d } = e1, m = new t1.pointGeometry(i, o);
            return a && m._rotate(r ? s : -s), {
                x1: n + m.x,
                y1: c + m.y,
                x2: l + m.x,
                y2: h + m.y,
                anchorPointX: u,
                anchorPointY: d
            };
        }
        class Pt {
            getBucketParts(e1, i, o, a) {
                const r = o.getBucket(i), s = o.latestFeatureIndex;
                if (!r || !s || i.id !== r.layerIds[0]) return;
                const n = o.collisionBoxArray, l = r.layers[0].layout, c = Math.pow(2, this.transform.zoom - o.tileID.overscaledZ), h = o.tileSize / t1.EXTENT, u = this.transform.calculatePosMatrix(o.tileID.toUnwrapped()), d = "map" === l.get("text-pitch-alignment"), m = "map" === l.get("text-rotation-alignment"), _ = bt(o, 1, this.transform.zoom), p = rt(u, d, m, this.transform, _);
                let f = null;
                if (d) {
                    const e1 = st(u, d, m, this.transform, _);
                    f = t1.multiply([], this.transform.labelPlaneMatrix, e1);
                }
                this.retainedQueryData[r.bucketInstanceId] = new Ct(r.bucketInstanceId, s, r.sourceLayerIndex, r.index, o.tileID);
                const g = {
                    bucket: r,
                    layout: l,
                    posMatrix: u,
                    textLabelPlaneMatrix: p,
                    labelToScreenMatrix: f,
                    scale: c,
                    textPixelRatio: h,
                    holdingForFade: o.holdingForFade(),
                    collisionBoxArray: n,
                    partiallyEvaluatedTextSize: t1.evaluateSizeForZoom(r.textSizeData, this.transform.zoom),
                    collisionGroup: this.collisionGroups.get(r.sourceID)
                };
                if (a) for (const t1 of r.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: o, symbolInstanceEnd: a } = t1;
                    e1.push({
                        sortKey: i,
                        symbolInstanceStart: o,
                        symbolInstanceEnd: a,
                        parameters: g
                    });
                }
                else e1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: r.symbolInstances.length,
                    parameters: g
                });
            }
            attemptAnchorPlacement(t1, e1, i, o, a, r, s, n, l, c, h, u, d, m, _, p) {
                const f = [
                    u.textOffset0,
                    u.textOffset1
                ], g = Dt(t1, i, o, f, a), x = this.collisionIndex.placeCollisionBox(zt(e1, g.x, g.y, r, s, this.transform.angle), h, n, l, c.predicate, p);
                if ((!_ || 0 !== this.collisionIndex.placeCollisionBox(zt(_, g.x, g.y, r, s, this.transform.angle), h, n, l, c.predicate, p).box.length) && x.box.length > 0) {
                    let e1;
                    if (this.prevPlacement && this.prevPlacement.variableOffsets[u.crossTileID] && this.prevPlacement.placements[u.crossTileID] && this.prevPlacement.placements[u.crossTileID].text && (e1 = this.prevPlacement.variableOffsets[u.crossTileID].anchor), 0 === u.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                    return this.variableOffsets[u.crossTileID] = {
                        textOffset: f,
                        width: i,
                        height: o,
                        anchor: t1,
                        textBoxScale: a,
                        prevAnchor: e1
                    }, this.markUsedJustification(d, t1, u, m), d.allowVerticalPlacement && (this.markUsedOrientation(d, m, u), this.placedOrientations[u.crossTileID] = m), {
                        shift: g,
                        placedGlyphBoxes: x
                    };
                }
            }
            placeLayerBucketPart(e1, i, o) {
                const { bucket: a, layout: r, posMatrix: s, textLabelPlaneMatrix: n, labelToScreenMatrix: l, textPixelRatio: c, holdingForFade: h, collisionBoxArray: u, partiallyEvaluatedTextSize: d, collisionGroup: m } = e1.parameters, _ = r.get("text-optional"), p = r.get("icon-optional"), f = t1.getOverlapMode(r, "text-overlap", "text-allow-overlap"), g = "always" === f, x = t1.getOverlapMode(r, "icon-overlap", "icon-allow-overlap"), v = "always" === x, y = "map" === r.get("text-rotation-alignment"), b = "map" === r.get("text-pitch-alignment"), w = "none" !== r.get("icon-text-fit"), T = "viewport-y" === r.get("symbol-z-order"), E = g && (v || !a.hasIconData() || p), I = v && (g || !a.hasTextData() || _);
                !a.collisionArrays && u && a.deserializeCollisionBoxes(u);
                const C = (e1, u)=>{
                    if (i[e1.crossTileID]) return;
                    if (h) return void (this.placements[e1.crossTileID] = new Et(!1, !1, !1));
                    let v = !1, T = !1, C = !0, S = null, D = {
                        box: null,
                        offscreen: null
                    }, z = {
                        box: null,
                        offscreen: null
                    }, P = null, M = null, A = null, L = 0, R = 0, k = 0;
                    u.textFeatureIndex ? L = u.textFeatureIndex : e1.useRuntimeCollisionCircles && (L = e1.featureIndex), u.verticalTextFeatureIndex && (R = u.verticalTextFeatureIndex);
                    const B = this.retainedQueryData[a.bucketInstanceId].tileID, F = this.terrain ? (t1, e1)=>this.terrain.getElevation(B, t1, e1) : null;
                    for (const t1 of [
                        "textBox",
                        "verticalTextBox",
                        "iconBox",
                        "verticalIconBox"
                    ]){
                        const e1 = u[t1];
                        e1 && (e1.elevation = F ? F(e1.anchorPointX, e1.anchorPointY) : 0);
                    }
                    const O = u.textBox;
                    if (O) {
                        const i = (i)=>{
                            let o = t1.WritingMode.horizontal;
                            if (a.allowVerticalPlacement && !i && this.prevPlacement) {
                                const t1 = this.prevPlacement.placedOrientations[e1.crossTileID];
                                t1 && (this.placedOrientations[e1.crossTileID] = t1, o = t1, this.markUsedOrientation(a, o, e1));
                            }
                            return o;
                        }, o = (i, o)=>{
                            if (a.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && u.verticalTextBox) {
                                for (const e1 of a.writingModes)if (e1 === t1.WritingMode.vertical ? (D = o(), z = D) : D = i(), D && D.box && D.box.length) break;
                            } else D = i();
                        };
                        if (r.get("text-variable-anchor")) {
                            let n = r.get("text-variable-anchor");
                            if (this.prevPlacement && this.prevPlacement.variableOffsets[e1.crossTileID]) {
                                const t1 = this.prevPlacement.variableOffsets[e1.crossTileID];
                                n.indexOf(t1.anchor) > 0 && (n = n.filter((e1)=>e1 !== t1.anchor), n.unshift(t1.anchor));
                            }
                            const l = (t1, i, o)=>{
                                const r = t1.x2 - t1.x1, l = t1.y2 - t1.y1, h = e1.textBoxScale, u = w && "never" === x ? i : null;
                                let d = {
                                    box: [],
                                    offscreen: !1
                                };
                                const _ = "never" !== f ? 2 * n.length : n.length;
                                for(let i = 0; i < _; ++i){
                                    const _ = this.attemptAnchorPlacement(n[i % n.length], t1, r, l, h, y, b, c, s, m, i >= n.length ? f : "never", e1, a, o, u, F);
                                    if (_ && (d = _.placedGlyphBoxes, d && d.box && d.box.length)) {
                                        v = !0, S = _.shift;
                                        break;
                                    }
                                }
                                return d;
                            };
                            o(()=>l(O, u.iconBox, t1.WritingMode.horizontal), ()=>{
                                const i = u.verticalTextBox;
                                return a.allowVerticalPlacement && !(D && D.box && D.box.length) && e1.numVerticalGlyphVertices > 0 && i ? l(i, u.verticalIconBox, t1.WritingMode.vertical) : {
                                    box: null,
                                    offscreen: null
                                };
                            }), D && (v = D.box, C = D.offscreen);
                            const h = i(D && D.box);
                            if (!v && this.prevPlacement) {
                                const t1 = this.prevPlacement.variableOffsets[e1.crossTileID];
                                t1 && (this.variableOffsets[e1.crossTileID] = t1, this.markUsedJustification(a, t1.anchor, e1, h));
                            }
                        } else {
                            const r = (t1, i)=>{
                                const o = this.collisionIndex.placeCollisionBox(t1, f, c, s, m.predicate, F);
                                return o && o.box && o.box.length && (this.markUsedOrientation(a, i, e1), this.placedOrientations[e1.crossTileID] = i), o;
                            };
                            o(()=>r(O, t1.WritingMode.horizontal), ()=>{
                                const i = u.verticalTextBox;
                                return a.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && i ? r(i, t1.WritingMode.vertical) : {
                                    box: null,
                                    offscreen: null
                                };
                            }), i(D && D.box && D.box.length);
                        }
                    }
                    if (P = D, v = P && P.box && P.box.length > 0, C = P && P.offscreen, e1.useRuntimeCollisionCircles) {
                        const i = a.text.placedSymbolArray.get(e1.centerJustifiedTextSymbolIndex), c = t1.evaluateSizeForFeature(a.textSizeData, d, i), h = r.get("text-padding");
                        M = this.collisionIndex.placeCollisionCircles(f, i, a.lineVertexArray, a.glyphOffsetArray, c, s, n, l, o, b, m.predicate, e1.collisionCircleDiameter, h, F), M.circles.length && M.collisionDetected && !o && t1.warnOnce("Collisions detected, but collision boxes are not shown"), v = g || M.circles.length > 0 && !M.collisionDetected, C = C && M.offscreen;
                    }
                    if (u.iconFeatureIndex && (k = u.iconFeatureIndex), u.iconBox) {
                        const t1 = (t1)=>{
                            const e1 = w && S ? zt(t1, S.x, S.y, y, b, this.transform.angle) : t1;
                            return this.collisionIndex.placeCollisionBox(e1, x, c, s, m.predicate, F);
                        };
                        z && z.box && z.box.length && u.verticalIconBox ? (A = t1(u.verticalIconBox), T = A.box.length > 0) : (A = t1(u.iconBox), T = A.box.length > 0), C = C && A.offscreen;
                    }
                    const U = _ || 0 === e1.numHorizontalGlyphVertices && 0 === e1.numVerticalGlyphVertices, N = p || 0 === e1.numIconVertices;
                    if (U || N ? N ? U || (T = T && v) : v = T && v : T = v = T && v, v && P && P.box && this.collisionIndex.insertCollisionBox(P.box, f, r.get("text-ignore-placement"), a.bucketInstanceId, z && z.box && R ? R : L, m.ID), T && A && this.collisionIndex.insertCollisionBox(A.box, x, r.get("icon-ignore-placement"), a.bucketInstanceId, k, m.ID), M && (v && this.collisionIndex.insertCollisionCircles(M.circles, f, r.get("text-ignore-placement"), a.bucketInstanceId, L, m.ID), o)) {
                        const t1 = a.bucketInstanceId;
                        let e1 = this.collisionCircleArrays[t1];
                        void 0 === e1 && (e1 = this.collisionCircleArrays[t1] = new It);
                        for(let t1 = 0; t1 < M.circles.length; t1 += 4)e1.circles.push(M.circles[t1 + 0]), e1.circles.push(M.circles[t1 + 1]), e1.circles.push(M.circles[t1 + 2]), e1.circles.push(M.collisionDetected ? 1 : 0);
                    }
                    if (0 === e1.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                    if (0 === a.bucketInstanceId) throw new Error("bucket.bucketInstanceId can't be 0");
                    this.placements[e1.crossTileID] = new Et(v || E, T || I, C || a.justReloaded), i[e1.crossTileID] = !0;
                };
                if (T) {
                    if (0 !== e1.symbolInstanceStart) throw new Error("bucket.bucketInstanceId should be 0");
                    const t1 = a.getSortedSymbolIndexes(this.transform.angle);
                    for(let e1 = t1.length - 1; e1 >= 0; --e1){
                        const i = t1[e1];
                        C(a.symbolInstances.get(i), a.collisionArrays[i]);
                    }
                } else for(let t1 = e1.symbolInstanceStart; t1 < e1.symbolInstanceEnd; t1++)C(a.symbolInstances.get(t1), a.collisionArrays[t1]);
                if (o && a.bucketInstanceId in this.collisionCircleArrays) {
                    const e1 = this.collisionCircleArrays[a.bucketInstanceId];
                    t1.invert(e1.invProjMatrix, s), e1.viewportMatrix = this.collisionIndex.getViewportMatrix();
                }
                a.justReloaded = !1;
            }
            markUsedJustification(e1, i, o, a) {
                let r;
                r = a === t1.WritingMode.vertical ? o.verticalPlacedTextSymbolIndex : ({
                    left: o.leftJustifiedTextSymbolIndex,
                    center: o.centerJustifiedTextSymbolIndex,
                    right: o.rightJustifiedTextSymbolIndex
                })[t1.getAnchorJustification(i)];
                const s = [
                    o.leftJustifiedTextSymbolIndex,
                    o.centerJustifiedTextSymbolIndex,
                    o.rightJustifiedTextSymbolIndex,
                    o.verticalPlacedTextSymbolIndex
                ];
                for (const t1 of s)t1 >= 0 && (e1.text.placedSymbolArray.get(t1).crossTileID = r >= 0 && t1 !== r ? 0 : o.crossTileID);
            }
            markUsedOrientation(e1, i, o) {
                const a = i === t1.WritingMode.horizontal || i === t1.WritingMode.horizontalOnly ? i : 0, r = i === t1.WritingMode.vertical ? i : 0, s = [
                    o.leftJustifiedTextSymbolIndex,
                    o.centerJustifiedTextSymbolIndex,
                    o.rightJustifiedTextSymbolIndex
                ];
                for (const t1 of s)e1.text.placedSymbolArray.get(t1).placedOrientation = a;
                o.verticalPlacedTextSymbolIndex && (e1.text.placedSymbolArray.get(o.verticalPlacedTextSymbolIndex).placedOrientation = r);
            }
            commit(t1) {
                this.commitTime = t1, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const e1 = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = e1 ? e1.zoomAdjustment(this.transform.zoom) : 0;
                const o = e1 ? e1.symbolFadeChange(t1) : 1, a = e1 ? e1.opacities : {}, r = e1 ? e1.variableOffsets : {}, s = e1 ? e1.placedOrientations : {};
                for(const t1 in this.placements){
                    const e1 = this.placements[t1], r = a[t1];
                    r ? (this.opacities[t1] = new Tt(r, o, e1.text, e1.icon), i = i || e1.text !== r.text.placed || e1.icon !== r.icon.placed) : (this.opacities[t1] = new Tt(null, o, e1.text, e1.icon, e1.skipFade), i = i || e1.text || e1.icon);
                }
                for(const t1 in a){
                    const e1 = a[t1];
                    if (!this.opacities[t1]) {
                        const a = new Tt(e1, o, !1, !1);
                        a.isHidden() || (this.opacities[t1] = a, i = i || e1.text.placed || e1.icon.placed);
                    }
                }
                for(const t1 in r)this.variableOffsets[t1] || !this.opacities[t1] || this.opacities[t1].isHidden() || (this.variableOffsets[t1] = r[t1]);
                for(const t1 in s)this.placedOrientations[t1] || !this.opacities[t1] || this.opacities[t1].isHidden() || (this.placedOrientations[t1] = s[t1]);
                if (e1 && void 0 === e1.lastPlacementChangeTime) throw new Error("Last placement time for previous placement is not defined");
                i ? this.lastPlacementChangeTime = t1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = e1 ? e1.lastPlacementChangeTime : t1);
            }
            updateLayerOpacities(t1, e1) {
                const i = {};
                for (const o of e1){
                    const e1 = o.getBucket(t1);
                    e1 && o.latestFeatureIndex && t1.id === e1.layerIds[0] && this.updateBucketOpacities(e1, i, o.collisionBoxArray);
                }
            }
            updateBucketOpacities(e1, i, o) {
                e1.hasTextData() && e1.text.opacityVertexArray.clear(), e1.hasIconData() && e1.icon.opacityVertexArray.clear(), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexArray.clear(), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexArray.clear();
                const a = e1.layers[0].layout, r = new Tt(null, 0, !1, !1, !0), s = a.get("text-allow-overlap"), n = a.get("icon-allow-overlap"), l = a.get("text-variable-anchor"), c = "map" === a.get("text-rotation-alignment"), h = "map" === a.get("text-pitch-alignment"), u = "none" !== a.get("icon-text-fit"), d = new Tt(null, 0, s && (n || !e1.hasIconData() || a.get("icon-optional")), n && (s || !e1.hasTextData() || a.get("text-optional")), !0);
                !e1.collisionArrays && o && (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) && e1.deserializeCollisionBoxes(o);
                const m = (t1, e1, i)=>{
                    for(let o = 0; o < e1 / 4; o++)t1.opacityVertexArray.emplaceBack(i);
                };
                for(let o = 0; o < e1.symbolInstances.length; o++){
                    const a = e1.symbolInstances.get(o), { numHorizontalGlyphVertices: s, numVerticalGlyphVertices: n, crossTileID: _ } = a;
                    let p = this.opacities[_];
                    i[_] ? p = r : p || (p = d, this.opacities[_] = p), i[_] = !0;
                    const f = a.numIconVertices > 0, g = this.placedOrientations[a.crossTileID], x = g === t1.WritingMode.vertical, v = g === t1.WritingMode.horizontal || g === t1.WritingMode.horizontalOnly;
                    if (s > 0 || n > 0) {
                        const t1 = Ut(p.text);
                        m(e1.text, s, x ? Nt : t1), m(e1.text, n, v ? Nt : t1);
                        const i = p.text.isHidden();
                        [
                            a.rightJustifiedTextSymbolIndex,
                            a.centerJustifiedTextSymbolIndex,
                            a.leftJustifiedTextSymbolIndex
                        ].forEach((t1)=>{
                            t1 >= 0 && (e1.text.placedSymbolArray.get(t1).hidden = i || x ? 1 : 0);
                        }), a.verticalPlacedTextSymbolIndex >= 0 && (e1.text.placedSymbolArray.get(a.verticalPlacedTextSymbolIndex).hidden = i || v ? 1 : 0);
                        const o = this.variableOffsets[a.crossTileID];
                        o && this.markUsedJustification(e1, o.anchor, a, g);
                        const r = this.placedOrientations[a.crossTileID];
                        r && (this.markUsedJustification(e1, "left", a, r), this.markUsedOrientation(e1, r, a));
                    }
                    if (f) {
                        const t1 = Ut(p.icon), i = !(u && a.verticalPlacedIconSymbolIndex && x);
                        a.placedIconSymbolIndex >= 0 && (m(e1.icon, a.numIconVertices, i ? t1 : Nt), e1.icon.placedSymbolArray.get(a.placedIconSymbolIndex).hidden = p.icon.isHidden()), a.verticalPlacedIconSymbolIndex >= 0 && (m(e1.icon, a.numVerticalIconVertices, i ? Nt : t1), e1.icon.placedSymbolArray.get(a.verticalPlacedIconSymbolIndex).hidden = p.icon.isHidden());
                    }
                    if (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) {
                        const i = e1.collisionArrays[o];
                        if (i) {
                            let o = new t1.pointGeometry(0, 0);
                            if (i.textBox || i.verticalTextBox) {
                                let t1 = !0;
                                if (l) {
                                    const e1 = this.variableOffsets[_];
                                    e1 ? (o = Dt(e1.anchor, e1.width, e1.height, e1.textOffset, e1.textBoxScale), c && o._rotate(h ? this.transform.angle : -this.transform.angle)) : t1 = !1;
                                }
                                i.textBox && Mt(e1.textCollisionBox.collisionVertexArray, p.text.placed, !t1 || x, o.x, o.y), i.verticalTextBox && Mt(e1.textCollisionBox.collisionVertexArray, p.text.placed, !t1 || v, o.x, o.y);
                            }
                            const a = Boolean(!v && i.verticalIconBox);
                            i.iconBox && Mt(e1.iconCollisionBox.collisionVertexArray, p.icon.placed, a, u ? o.x : 0, u ? o.y : 0), i.verticalIconBox && Mt(e1.iconCollisionBox.collisionVertexArray, p.icon.placed, !a, u ? o.x : 0, u ? o.y : 0);
                        }
                    }
                }
                if (e1.sortFeatures(this.transform.angle), this.retainedQueryData[e1.bucketInstanceId] && (this.retainedQueryData[e1.bucketInstanceId].featureSortOrder = e1.featureSortOrder), e1.hasTextData() && e1.text.opacityVertexBuffer && e1.text.opacityVertexBuffer.updateData(e1.text.opacityVertexArray), e1.hasIconData() && e1.icon.opacityVertexBuffer && e1.icon.opacityVertexBuffer.updateData(e1.icon.opacityVertexArray), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexBuffer && e1.iconCollisionBox.collisionVertexBuffer.updateData(e1.iconCollisionBox.collisionVertexArray), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexBuffer && e1.textCollisionBox.collisionVertexBuffer.updateData(e1.textCollisionBox.collisionVertexArray), e1.text.opacityVertexArray.length !== e1.text.layoutVertexArray.length / 4) throw new Error(`bucket.text.opacityVertexArray.length (= ${e1.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${e1.text.layoutVertexArray.length}) / 4`);
                if (e1.icon.opacityVertexArray.length !== e1.icon.layoutVertexArray.length / 4) throw new Error(`bucket.icon.opacityVertexArray.length (= ${e1.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${e1.icon.layoutVertexArray.length}) / 4`);
                if (e1.bucketInstanceId in this.collisionCircleArrays) {
                    const t1 = this.collisionCircleArrays[e1.bucketInstanceId];
                    e1.placementInvProjMatrix = t1.invProjMatrix, e1.placementViewportMatrix = t1.viewportMatrix, e1.collisionCircleArray = t1.circles, delete this.collisionCircleArrays[e1.bucketInstanceId];
                }
            }
            symbolFadeChange(t1) {
                return 0 === this.fadeDuration ? 1 : (t1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(t1) {
                return Math.max(0, (this.transform.zoom - t1) / 1.5);
            }
            hasTransitions(t1) {
                return this.stale || t1 - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(t1, e1) {
                const i = this.zoomAtLastRecencyCheck === e1 ? 1 - this.zoomAdjustment(e1) : 1;
                return this.zoomAtLastRecencyCheck = e1, this.commitTime + this.fadeDuration * i > t1;
            }
            setStale() {
                this.stale = !0;
            }
            constructor(t1, e1, i, o, a){
                this.transform = t1.clone(), this.terrain = e1, this.collisionIndex = new yt(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = i, this.retainedQueryData = {}, this.collisionGroups = new St(o), this.collisionCircleArrays = {}, this.prevPlacement = a, a && (a.prevPlacement = void 0), this.placedOrientations = {};
            }
        }
        function Mt(t1, e1, i, o, a) {
            t1.emplaceBack(e1 ? 1 : 0, i ? 1 : 0, o || 0, a || 0), t1.emplaceBack(e1 ? 1 : 0, i ? 1 : 0, o || 0, a || 0), t1.emplaceBack(e1 ? 1 : 0, i ? 1 : 0, o || 0, a || 0), t1.emplaceBack(e1 ? 1 : 0, i ? 1 : 0, o || 0, a || 0);
        }
        const At = Math.pow(2, 25), Lt = Math.pow(2, 24), Rt = Math.pow(2, 17), kt = Math.pow(2, 16), Bt = Math.pow(2, 9), Ft = Math.pow(2, 8), Ot = Math.pow(2, 1);
        function Ut(t1) {
            if (0 === t1.opacity && !t1.placed) return 0;
            if (1 === t1.opacity && t1.placed) return 4294967295;
            const e1 = t1.placed ? 1 : 0, i = Math.floor(127 * t1.opacity);
            return i * At + e1 * Lt + i * Rt + e1 * kt + i * Bt + e1 * Ft + i * Ot + e1;
        }
        const Nt = 0;
        class Gt {
            continuePlacement(t1, e1, i, o, a) {
                const r = this._bucketParts;
                for(; this._currentTileIndex < t1.length;)if (e1.getBucketParts(r, o, t1[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, a()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, r.sort((t1, e1)=>t1.sortKey - e1.sortKey)); this._currentPartIndex < r.length;)if (e1.placeLayerBucketPart(r[this._currentPartIndex], this._seenCrossTileIDs, i), this._currentPartIndex++, a()) return !0;
                return !1;
            }
            constructor(t1){
                this._sortAcrossTiles = "viewport-y" !== t1.layout.get("symbol-z-order") && !t1.layout.get("symbol-sort-key").isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
            }
        }
        class Zt {
            isDone() {
                return this._done;
            }
            continuePlacement(e1, i, o) {
                const a = t1.exported.now(), r = ()=>{
                    const e1 = t1.exported.now() - a;
                    return !this._forceFullPlacement && e1 > 2;
                };
                for(; this._currentPlacementIndex >= 0;){
                    const t1 = i[e1[this._currentPlacementIndex]], a = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === t1.type && (!t1.minzoom || t1.minzoom <= a) && (!t1.maxzoom || t1.maxzoom > a)) {
                        if (this._inProgressLayer || (this._inProgressLayer = new Gt(t1)), this._inProgressLayer.continuePlacement(o[t1.source], this.placement, this._showCollisionBoxes, t1, r)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._done = !0;
            }
            commit(t1) {
                return this.placement.commit(t1), this.placement;
            }
            constructor(t1, e1, i, o, a, r, s, n){
                this.placement = new Pt(t1, e1, r, s, n), this._currentPlacementIndex = i.length - 1, this._forceFullPlacement = o, this._showCollisionBoxes = a, this._done = !1;
            }
        }
        const Vt = 512 / t1.EXTENT / 2;
        class qt {
            getScaledCoordinates(e1, i) {
                const o = Vt / Math.pow(2, i.canonical.z - this.tileID.canonical.z);
                return {
                    x: Math.floor((i.canonical.x * t1.EXTENT + e1.anchorX) * o),
                    y: Math.floor((i.canonical.y * t1.EXTENT + e1.anchorY) * o)
                };
            }
            findMatches(t1, e1, i) {
                const o = this.tileID.canonical.z < e1.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - e1.canonical.z);
                for(let a = 0; a < t1.length; a++){
                    const r = t1.get(a);
                    if (r.crossTileID) continue;
                    const s = this.indexedSymbolInstances[r.key];
                    if (!s) continue;
                    const n = this.getScaledCoordinates(r, e1);
                    for (const t1 of s)if (Math.abs(t1.coord.x - n.x) <= o && Math.abs(t1.coord.y - n.y) <= o && !i[t1.crossTileID]) {
                        i[t1.crossTileID] = !0, r.crossTileID = t1.crossTileID;
                        break;
                    }
                }
            }
            constructor(t1, e1, i){
                this.tileID = t1, this.indexedSymbolInstances = {}, this.bucketInstanceId = i;
                for(let i = 0; i < e1.length; i++){
                    const o = e1.get(i), a = o.key;
                    this.indexedSymbolInstances[a] || (this.indexedSymbolInstances[a] = []), this.indexedSymbolInstances[a].push({
                        crossTileID: o.crossTileID,
                        coord: this.getScaledCoordinates(o, t1)
                    });
                }
            }
        }
        class jt {
            generate() {
                return ++this.maxCrossTileID;
            }
            constructor(){
                this.maxCrossTileID = 0;
            }
        }
        class $t {
            handleWrapJump(t1) {
                const e1 = Math.round((t1 - this.lng) / 360);
                if (0 !== e1) for(const t1 in this.indexes){
                    const i = this.indexes[t1], o = {};
                    for(const t1 in i){
                        const a = i[t1];
                        a.tileID = a.tileID.unwrapTo(a.tileID.wrap + e1), o[a.tileID.key] = a;
                    }
                    this.indexes[t1] = o;
                }
                this.lng = t1;
            }
            addBucket(t1, e1, i) {
                if (this.indexes[t1.overscaledZ] && this.indexes[t1.overscaledZ][t1.key]) {
                    if (this.indexes[t1.overscaledZ][t1.key].bucketInstanceId === e1.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(t1.overscaledZ, this.indexes[t1.overscaledZ][t1.key]);
                }
                for(let t1 = 0; t1 < e1.symbolInstances.length; t1++)e1.symbolInstances.get(t1).crossTileID = 0;
                this.usedCrossTileIDs[t1.overscaledZ] || (this.usedCrossTileIDs[t1.overscaledZ] = {});
                const o = this.usedCrossTileIDs[t1.overscaledZ];
                for(const i in this.indexes){
                    const a = this.indexes[i];
                    if (Number(i) > t1.overscaledZ) for(const i in a){
                        const r = a[i];
                        r.tileID.isChildOf(t1) && r.findMatches(e1.symbolInstances, t1, o);
                    }
                    else {
                        const r = a[t1.scaledTo(Number(i)).key];
                        r && r.findMatches(e1.symbolInstances, t1, o);
                    }
                }
                for(let t1 = 0; t1 < e1.symbolInstances.length; t1++){
                    const a = e1.symbolInstances.get(t1);
                    a.crossTileID || (a.crossTileID = i.generate(), o[a.crossTileID] = !0);
                }
                return void 0 === this.indexes[t1.overscaledZ] && (this.indexes[t1.overscaledZ] = {}), this.indexes[t1.overscaledZ][t1.key] = new qt(t1, e1.symbolInstances, e1.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(t1, e1) {
                for(const i in e1.indexedSymbolInstances)for (const o of e1.indexedSymbolInstances[i])delete this.usedCrossTileIDs[t1][o.crossTileID];
            }
            removeStaleBuckets(t1) {
                let e1 = !1;
                for(const i in this.indexes){
                    const o = this.indexes[i];
                    for(const a in o)t1[o[a].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, o[a]), delete o[a], e1 = !0);
                }
                return e1;
            }
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
        }
        class Xt {
            addLayer(t1, e1, i) {
                let o = this.layerIndexes[t1.id];
                void 0 === o && (o = this.layerIndexes[t1.id] = new $t);
                let a = !1;
                const r = {};
                o.handleWrapJump(i);
                for (const i of e1){
                    const e1 = i.getBucket(t1);
                    e1 && t1.id === e1.layerIds[0] && (e1.bucketInstanceId || (e1.bucketInstanceId = ++this.maxBucketInstanceId), o.addBucket(i.tileID, e1, this.crossTileIDs) && (a = !0), r[e1.bucketInstanceId] = !0);
                }
                return o.removeStaleBuckets(r) && (a = !0), a;
            }
            pruneUnusedLayers(t1) {
                const e1 = {};
                t1.forEach((t1)=>{
                    e1[t1] = !0;
                });
                for(const t1 in this.layerIndexes)e1[t1] || delete this.layerIndexes[t1];
            }
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new jt, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
        }
        var Wt = t1.createLayout([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]);
        class Ht extends t1.Evented {
            destruct() {
                this.sourceCache.usedForTerrain = !1, this.sourceCache.tileSize = null;
                for(const t1 in this._tiles){
                    const e1 = this._tiles[t1];
                    e1.textures.forEach((t1)=>t1.destroy()), e1.textures = [];
                }
            }
            update(e1, i) {
                this.sourceCache.update(e1, i), this._renderableTilesKeys = [];
                for (const o of e1.coveringTiles({
                    tileSize: this.tileSize,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    reparseOverscaled: !1,
                    terrain: i
                }))this._renderableTilesKeys.push(o.key), this._tiles[o.key] || (o.posMatrix = new Float64Array(16), t1.ortho(o.posMatrix, 0, t1.EXTENT, 0, t1.EXTENT, 0, 1), this._tiles[o.key] = new k(o, this.tileSize));
            }
            removeOutdated(t1) {
                const e1 = {};
                this.renderHistory = this.renderHistory.filter((t1, e1)=>this.renderHistory.indexOf(t1) === e1).slice(0, this.renderHistorySize);
                for (const t1 of this._renderableTilesKeys)e1[t1] = !0;
                for (const t1 of this.renderHistory)e1[t1] = !0;
                for(const i in this._tiles)e1[i] || (this._tiles[i].clearTextures(t1), delete this._tiles[i]);
            }
            getRenderableTiles() {
                return this._renderableTilesKeys.map((t1)=>this.getTileByID(t1));
            }
            getTileByID(t1) {
                return this._tiles[t1];
            }
            getTerrainCoords(e1) {
                const i = {};
                for (const o of this._renderableTilesKeys){
                    const a = this._tiles[o].tileID;
                    if (a.canonical.equals(e1.canonical)) {
                        const a = e1.clone();
                        a.posMatrix = new Float64Array(16), t1.ortho(a.posMatrix, 0, t1.EXTENT, 0, t1.EXTENT, 0, 1), i[o] = a;
                    } else if (a.canonical.isChildOf(e1.canonical)) {
                        const r = e1.clone();
                        r.posMatrix = new Float64Array(16);
                        const s = a.canonical.z - e1.canonical.z, n = a.canonical.x - (a.canonical.x >> s << s), l = a.canonical.y - (a.canonical.y >> s << s), c = t1.EXTENT >> s;
                        t1.ortho(r.posMatrix, 0, c, 0, c, 0, 1), t1.translate(r.posMatrix, r.posMatrix, [
                            -n * c,
                            -l * c,
                            0
                        ]), i[o] = r;
                    } else if (e1.canonical.isChildOf(a.canonical)) {
                        const r = e1.clone();
                        r.posMatrix = new Float64Array(16);
                        const s = e1.canonical.z - a.canonical.z, n = e1.canonical.x - (e1.canonical.x >> s << s), l = e1.canonical.y - (e1.canonical.y >> s << s), c = t1.EXTENT >> s;
                        t1.ortho(r.posMatrix, 0, t1.EXTENT, 0, t1.EXTENT, 0, 1), t1.translate(r.posMatrix, r.posMatrix, [
                            n * c,
                            l * c,
                            0
                        ]), t1.scale(r.posMatrix, r.posMatrix, [
                            1 / 2 ** s,
                            1 / 2 ** s,
                            0
                        ]), i[o] = r;
                    }
                }
                return i;
            }
            getSourceTile(t1, e1) {
                const i = this.sourceCache._source;
                let o = t1.overscaledZ - this.deltaZoom;
                if (o > i.maxzoom && (o = i.maxzoom), o < i.minzoom) return null;
                this._sourceTileCache[t1.key] || (this._sourceTileCache[t1.key] = t1.scaledTo(o).key);
                let a = this.sourceCache.getTileByID(this._sourceTileCache[t1.key]);
                if ((!a || !a.dem) && e1) for(; o >= i.minzoom && (!a || !a.dem);)a = this.sourceCache.getTileByID(t1.scaledTo(o--).key);
                return a;
            }
            tilesAfterTime(t1 = Date.now()) {
                return Object.values(this._tiles).filter((e1)=>e1.timeLoaded >= t1);
            }
            constructor(t1){
                super(), this.sourceCache = t1, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.renderHistory = [], this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.deltaZoom = 1, this.renderHistorySize = t1._cache.max, t1.usedForTerrain = !0, t1.tileSize = this.tileSize * 2 ** this.deltaZoom;
            }
        }
        class Kt {
            getDEMElevation(e1, i, o, a = t1.EXTENT) {
                if (!(i >= 0 && i < a && o >= 0 && o < a)) return this.elevationOffset;
                let r = 0;
                const s = this.getTerrainData(e1);
                if (s.tile && s.tile.dem) {
                    const e1 = t1.transformMat4$1([], [
                        i / a * t1.EXTENT,
                        o / a * t1.EXTENT
                    ], s.u_terrain_matrix), n = [
                        e1[0] * s.tile.dem.dim,
                        e1[1] * s.tile.dem.dim
                    ], l = [
                        Math.floor(n[0]),
                        Math.floor(n[1])
                    ], c = s.tile.dem.get(l[0], l[1]), h = s.tile.dem.get(l[0], l[1] + 1), u = s.tile.dem.get(l[0] + 1, l[1]), d = s.tile.dem.get(l[0] + 1, l[1] + 1);
                    r = t1.number(t1.number(c, h, n[0] - l[0]), t1.number(u, d, n[0] - l[0]), n[1] - l[1]);
                }
                return r;
            }
            rememberForRerender(t1, e1) {
                for(const i in this.sourceCache._tiles){
                    const o = this.sourceCache._tiles[i];
                    (o.tileID.equals(e1) || o.tileID.isChildOf(e1)) && (t1 === this.sourceCache.sourceCache.id && (o.timeLoaded = Date.now()), this._rerender[t1] = this._rerender[t1] || {}, this._rerender[t1][o.tileID.key] = !0);
                }
            }
            needsRerender(t1, e1) {
                return this._rerender[t1] && this._rerender[t1][e1.key];
            }
            clearRerenderCache() {
                this._rerender = {};
            }
            getElevation(e1, i, o, a = t1.EXTENT) {
                return (this.getDEMElevation(e1, i, o, a) + this.elevationOffset) * this.exaggeration;
            }
            getTerrainData(e1) {
                if (!this._emptyDemTexture) {
                    const e1 = this.style.map.painter.context, i = new t1.RGBAImage({
                        width: 1,
                        height: 1
                    }, new Uint8Array(4));
                    this._emptyDepthTexture = new l(e1, i, e1.gl.RGBA, {
                        premultiply: !1
                    }), this._emptyDemUnpack = [
                        0,
                        0,
                        0,
                        0
                    ], this._emptyDemTexture = new l(e1, new t1.RGBAImage({
                        width: 1,
                        height: 1
                    }), e1.gl.RGBA, {
                        premultiply: !1
                    }), this._emptyDemTexture.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = t1.identity([]);
                }
                const i = this.sourceCache.getSourceTile(e1, !0);
                if (i && i.dem && (!i.demTexture || i.needsTerrainPrepare)) {
                    const t1 = this.style.map.painter.context;
                    i.demTexture = this.style.map.painter.getTileTexture(i.dem.stride), i.demTexture ? i.demTexture.update(i.dem.getPixels(), {
                        premultiply: !1
                    }) : i.demTexture = new l(t1, i.dem.getPixels(), t1.gl.RGBA, {
                        premultiply: !1
                    }), i.demTexture.bind(t1.gl.NEAREST, t1.gl.CLAMP_TO_EDGE), i.needsTerrainPrepare = !1;
                }
                const o = i && i + i.tileID.key + e1.key;
                if (o && !this._demMatrixCache[o]) {
                    const o = this.sourceCache.sourceCache._source.maxzoom;
                    let a = e1.canonical.z - i.tileID.canonical.z;
                    e1.overscaledZ > e1.canonical.z && (e1.canonical.z >= o ? a = e1.canonical.z - o : t1.warnOnce("cannot calculate elevation if elevation maxzoom > source.maxzoom"));
                    const r = e1.canonical.x - (e1.canonical.x >> a << a), s = e1.canonical.y - (e1.canonical.y >> a << a), n = t1.fromScaling(new Float64Array(16), [
                        1 / (t1.EXTENT << a),
                        1 / (t1.EXTENT << a),
                        0
                    ]);
                    t1.translate(n, n, [
                        r * t1.EXTENT,
                        s * t1.EXTENT,
                        0
                    ]), this._demMatrixCache[e1.key] = {
                        matrix: n,
                        coord: e1
                    };
                }
                return {
                    u_depth: 2,
                    u_terrain: 3,
                    u_terrain_dim: i && i.dem && i.dem.dim || 1,
                    u_terrain_matrix: o ? this._demMatrixCache[e1.key].matrix : this._emptyDemMatrix,
                    u_terrain_unpack: i && i.dem && i.dem.getUnpackVector() || this._emptyDemUnpack,
                    u_terrain_offset: this.elevationOffset,
                    u_terrain_exaggeration: this.exaggeration,
                    texture: (i && i.demTexture || this._emptyDemTexture).texture,
                    depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
                    tile: i
                };
            }
            getRTTFramebuffer() {
                const t1 = this.style.map.painter;
                if (!this._rttFramebuffer) {
                    const e1 = this.sourceCache.tileSize * this.qualityFactor;
                    this._rttFramebuffer = t1.context.createFramebuffer(e1, e1, !0), this._rttFramebuffer.depthAttachment.set(t1.context.createRenderbuffer(t1.context.gl.DEPTH_COMPONENT16, e1, e1));
                }
                return this._rttFramebuffer;
            }
            getFramebuffer(t1) {
                const e1 = this.style.map.painter, i = e1.width / devicePixelRatio, o = e1.height / devicePixelRatio;
                return !this._fbo || this._fbo.width === i && this._fbo.height === o || (this._fbo.destroy(), this._fboCoordsTexture.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture, delete this._fboCoordsTexture), this._fboCoordsTexture || (this._fboCoordsTexture = new l(e1.context, {
                    width: i,
                    height: o,
                    data: null
                }, e1.context.gl.RGBA, {
                    premultiply: !1
                }), this._fboCoordsTexture.bind(e1.context.gl.NEAREST, e1.context.gl.CLAMP_TO_EDGE)), this._fboDepthTexture || (this._fboDepthTexture = new l(e1.context, {
                    width: i,
                    height: o,
                    data: null
                }, e1.context.gl.RGBA, {
                    premultiply: !1
                }), this._fboDepthTexture.bind(e1.context.gl.NEAREST, e1.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = e1.context.createFramebuffer(i, o, !0), this._fbo.depthAttachment.set(e1.context.createRenderbuffer(e1.context.gl.DEPTH_COMPONENT16, i, o))), this._fbo.colorAttachment.set("coords" === t1 ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture), this._fbo;
            }
            getCoordsTexture() {
                const e1 = this.style.map.painter.context;
                if (this._coordsTexture) return this._coordsTexture;
                const i = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
                for(let t1 = 0, e1 = 0; t1 < this._coordsTextureSize; t1++)for(let o = 0; o < this._coordsTextureSize; o++, e1 += 4)i[e1 + 0] = 255 & o, i[e1 + 1] = 255 & t1, i[e1 + 2] = o >> 8 << 4 | t1 >> 8, i[e1 + 3] = 0;
                const o = new t1.RGBAImage({
                    width: this._coordsTextureSize,
                    height: this._coordsTextureSize
                }, new Uint8Array(i.buffer)), a = new l(e1, o, e1.gl.RGBA, {
                    premultiply: !1
                });
                return a.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), this._coordsTexture = a, a;
            }
            pointCoordinate(e1) {
                const i = new Uint8Array(4), o = this.style.map.painter, a = o.context, r = a.gl;
                a.bindFramebuffer.set(this.getFramebuffer("coords").framebuffer), r.readPixels(e1.x, o.height / devicePixelRatio - e1.y - 1, 1, 1, r.RGBA, r.UNSIGNED_BYTE, i), a.bindFramebuffer.set(null);
                const s = i[0] + (i[2] >> 4 << 8), n = i[1] + ((15 & i[2]) << 8), l = this.coordsIndex[255 - i[3]], c = l && this.sourceCache.getTileByID(l);
                if (!c) return null;
                const h = this._coordsTextureSize, u = (1 << c.tileID.canonical.z) * h;
                return new t1.MercatorCoordinate((c.tileID.canonical.x * h + s) / u, (c.tileID.canonical.y * h + n) / u, this.getElevation(c.tileID, s, n, h));
            }
            getTerrainMesh() {
                if (this._mesh) return this._mesh;
                const e1 = this.style.map.painter.context, i = new t1.PosArray, o = new t1.TriangleIndexArray, a = this.meshSize, r = t1.EXTENT / a, s = a * a;
                for(let t1 = 0; t1 <= a; t1++)for(let e1 = 0; e1 <= a; e1++)i.emplaceBack(e1 * r, t1 * r);
                for(let t1 = 0; t1 < s; t1 += a + 1)for(let e1 = 0; e1 < a; e1++)o.emplaceBack(e1 + t1, a + e1 + t1 + 1, a + e1 + t1 + 2), o.emplaceBack(e1 + t1, a + e1 + t1 + 2, e1 + t1 + 1);
                return this._mesh = {
                    indexBuffer: e1.createIndexBuffer(o),
                    vertexBuffer: e1.createVertexBuffer(i, Wt.members),
                    segments: t1.SegmentVector.simpleSegment(0, 0, i.length, o.length)
                }, this._mesh;
            }
            getMinMaxElevation(t1) {
                const e1 = this.getTerrainData(t1).tile, i = {
                    minElevation: null,
                    maxElevation: null
                };
                return e1 && e1.dem && (i.minElevation = (e1.dem.min + this.elevationOffset) * this.exaggeration, i.maxElevation = (e1.dem.max + this.elevationOffset) * this.exaggeration), i;
            }
            constructor(t1, e1, i){
                this.style = t1, this.sourceCache = new Ht(e1), this.options = i, this.exaggeration = "number" == typeof i.exaggeration ? i.exaggeration : 1, this.elevationOffset = "number" == typeof i.elevationOffset ? i.elevationOffset : 450, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = {}, this.coordsIndex = [], this._coordsTextureSize = 1024, this.clearRerenderCache();
            }
        }
        const Yt = (e1, i)=>t1.emitValidationErrors(e1, i && i.filter((t1)=>"source.canvas" !== t1.identifier)), Jt = t1.pick(W, [
            "addLayer",
            "removeLayer",
            "setPaintProperty",
            "setLayoutProperty",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData"
        ]), Qt = t1.pick(W, [
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), te = function() {
            const e1 = {}, i = t1.spec.$version;
            for(const o in t1.spec.$root){
                const a = t1.spec.$root[o];
                if (a.required) {
                    let t1 = null;
                    t1 = "version" === o ? i : "array" === a.type ? [] : {}, null != t1 && (e1[o] = t1);
                }
            }
            return e1;
        }();
        class ee extends t1.Evented {
            loadURL(e1, i = {}) {
                this.fire(new t1.Event("dataloading", {
                    dataType: "style"
                }));
                const o = "boolean" != typeof i.validate || i.validate, a = this.map._requestManager.transformRequest(e1, t1.ResourceType.Style);
                this._request = t1.getJSON(a, (e1, i)=>{
                    this._request = null, e1 ? this.fire(new t1.ErrorEvent(e1)) : i && this._load(i, o);
                });
            }
            loadJSON(e1, i = {}) {
                this.fire(new t1.Event("dataloading", {
                    dataType: "style"
                })), this._request = t1.exported.frame(()=>{
                    this._request = null, this._load(e1, !1 !== i.validate);
                });
            }
            loadEmpty() {
                this.fire(new t1.Event("dataloading", {
                    dataType: "style"
                })), this._load(te, !1);
            }
            _load(e1, i) {
                if (i && Yt(this, t1.validateStyle(e1))) return;
                this._loaded = !0, this.stylesheet = e1;
                for(const t1 in e1.sources)this.addSource(t1, e1.sources[t1], {
                    validate: !1
                });
                e1.sprite ? this._loadSprite(e1.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(e1.glyphs);
                const o = X(this.stylesheet.layers);
                this._order = o.map((t1)=>t1.id), this._layers = {}, this._serializedLayers = {};
                for (let e1 of o)e1 = t1.createStyleLayer(e1), e1.setEventedParent(this, {
                    layer: {
                        id: e1.id
                    }
                }), this._layers[e1.id] = e1, this._serializedLayers[e1.id] = e1.serialize();
                this.dispatcher.broadcast("setLayers", this._serializeLayers(this._order)), this.light = new g(this.stylesheet.light), this.setTerrain(this.stylesheet.terrain), this.fire(new t1.Event("data", {
                    dataType: "style"
                })), this.fire(new t1.Event("style.load"));
            }
            _loadSprite(e1) {
                this._spriteRequest = function(e1, i, o, a) {
                    let r, s, n;
                    const l = o > 1 ? "@2x" : "";
                    let c = t1.getJSON(i.transformRequest(i.normalizeSpriteURL(e1, l, ".json"), t1.ResourceType.SpriteJSON), (t1, e1)=>{
                        c = null, n || (n = t1, r = e1, u());
                    }), h = t1.getImage(i.transformRequest(i.normalizeSpriteURL(e1, l, ".png"), t1.ResourceType.SpriteImage), (t1, e1)=>{
                        h = null, n || (n = t1, s = e1, u());
                    });
                    function u() {
                        if (n) a(n);
                        else if (r && s) {
                            const e1 = t1.exported.getImageData(s), i = {};
                            for(const o in r){
                                const { width: a, height: s, x: n, y: l, sdf: c, pixelRatio: h, stretchX: u, stretchY: d, content: m } = r[o], _ = new t1.RGBAImage({
                                    width: a,
                                    height: s
                                });
                                t1.RGBAImage.copy(e1, _, {
                                    x: n,
                                    y: l
                                }, {
                                    x: 0,
                                    y: 0
                                }, {
                                    width: a,
                                    height: s
                                }), i[o] = {
                                    data: _,
                                    pixelRatio: h,
                                    sdf: c,
                                    stretchX: u,
                                    stretchY: d,
                                    content: m
                                };
                            }
                            a(null, i);
                        }
                    }
                    return {
                        cancel () {
                            c && (c.cancel(), c = null), h && (h.cancel(), h = null);
                        }
                    };
                }(e1, this.map._requestManager, this.map.getPixelRatio(), (e1, i)=>{
                    if (this._spriteRequest = null, e1) this.fire(new t1.ErrorEvent(e1));
                    else if (i) for(const t1 in i)this.imageManager.addImage(t1, i[t1]);
                    this.imageManager.setLoaded(!0), this._availableImages = this.imageManager.listImages(), this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t1.Event("data", {
                        dataType: "style"
                    }));
                });
            }
            _validateLayer(e1) {
                const i = this.sourceCaches[e1.source];
                if (!i) return;
                const o = e1.sourceLayer;
                if (!o) return;
                const a = i.getSource();
                ("geojson" === a.type || a.vectorLayerIds && -1 === a.vectorLayerIds.indexOf(o)) && this.fire(new t1.ErrorEvent(new Error(`Source layer "${o}" does not exist on source "${a.id}" as specified by style layer "${e1.id}".`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._updatedSources).length) return !1;
                for(const t1 in this.sourceCaches)if (!this.sourceCaches[t1].loaded()) return !1;
                return !!this.imageManager.isLoaded();
            }
            _serializeLayers(t1) {
                const e1 = [];
                for (const i of t1){
                    const t1 = this._layers[i];
                    "custom" !== t1.type && e1.push(t1.serialize());
                }
                return e1;
            }
            hasTransitions() {
                if (this.light && this.light.hasTransition()) return !0;
                for(const t1 in this.sourceCaches)if (this.sourceCaches[t1].hasTransition()) return !0;
                for(const t1 in this._layers)if (this._layers[t1].hasTransition()) return !0;
                return !1;
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading.");
            }
            update(e1) {
                if (!this._loaded) return;
                const i = this._changed;
                if (this._changed) {
                    const t1 = Object.keys(this._updatedLayers), i = Object.keys(this._removedLayers);
                    (t1.length || i.length) && this._updateWorkerLayers(t1, i);
                    for(const t1 in this._updatedSources){
                        const e1 = this._updatedSources[t1];
                        if ("reload" === e1) this._reloadSource(t1);
                        else {
                            if ("clear" !== e1) throw new Error(`Invalid action ${e1}`);
                            this._clearSource(t1);
                        }
                    }
                    this._updateTilesForChangedImages();
                    for(const t1 in this._updatedPaintProps)this._layers[t1].updateTransitions(e1);
                    this.light.updateTransitions(e1), this._resetUpdates();
                }
                const o = {};
                for(const t1 in this.sourceCaches){
                    const e1 = this.sourceCaches[t1];
                    o[t1] = e1.used, e1.used = !1;
                }
                for (const t1 of this._order){
                    const i = this._layers[t1];
                    i.recalculate(e1, this._availableImages), !i.isHidden(e1.zoom) && i.source && (this.sourceCaches[i.source].used = !0);
                }
                for(const e1 in o){
                    const i = this.sourceCaches[e1];
                    o[e1] !== i.used && i.fire(new t1.Event("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: e1
                    }));
                }
                this.light.recalculate(e1), this.z = e1.zoom, i && this.fire(new t1.Event("data", {
                    dataType: "style"
                }));
            }
            _updateTilesForChangedImages() {
                const t1 = Object.keys(this._changedImages);
                if (t1.length) {
                    for(const e1 in this.sourceCaches)this.sourceCaches[e1].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], t1);
                    this._changedImages = {};
                }
            }
            _updateWorkerLayers(t1, e1) {
                this.dispatcher.broadcast("updateLayers", {
                    layers: this._serializeLayers(t1),
                    removedIds: e1
                });
            }
            _resetUpdates() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {};
            }
            setTerrain(e1) {
                if (this._checkLoaded(), this._terrainDataCallback && this.off("data", this._terrainDataCallback), this._terrainfreezeElevationCallback && this.map.off("freezeElevation", this._terrainfreezeElevationCallback), e1) {
                    const t1 = this.sourceCaches[e1.source];
                    if (!t1) throw new Error(`cannot load terrain, because there exists no source with ID: ${e1.source}`);
                    this.terrain = new Kt(this, t1, e1), this.map.transform.updateElevation(this.terrain), this._terrainfreezeElevationCallback = (t1)=>{
                        t1.freeze ? this.map.transform.freezeElevation = !0 : (this.map.transform.freezeElevation = !1, this.map.transform.recalculateZoom(this.terrain));
                    }, this._terrainDataCallback = (t1)=>{
                        t1.tile && (t1.sourceId === e1.source ? (this.map.transform.updateElevation(this.terrain), this.terrain.rememberForRerender(t1.sourceId, t1.tile.tileID)) : "geojson" === t1.source.type && this.terrain.rememberForRerender(t1.sourceId, t1.tile.tileID));
                    }, this.on("data", this._terrainDataCallback), this.map.on("freezeElevation", this._terrainfreezeElevationCallback);
                } else this.terrain && this.terrain.sourceCache.destruct(), this.terrain = null, this.map.transform.updateElevation(this.terrain);
                this.map.fire(new t1.Event("terrain", {
                    terrain: e1
                }));
            }
            setState(e1) {
                if (this._checkLoaded(), Yt(this, t1.validateStyle(e1))) return !1;
                (e1 = t1.clone$1(e1)).layers = X(e1.layers);
                const i = (function(t1, e1) {
                    if (!t1) return [
                        {
                            command: W.setStyle,
                            args: [
                                e1
                            ]
                        }
                    ];
                    let i = [];
                    try {
                        if (!a(t1.version, e1.version)) return [
                            {
                                command: W.setStyle,
                                args: [
                                    e1
                                ]
                            }
                        ];
                        a(t1.center, e1.center) || i.push({
                            command: W.setCenter,
                            args: [
                                e1.center
                            ]
                        }), a(t1.zoom, e1.zoom) || i.push({
                            command: W.setZoom,
                            args: [
                                e1.zoom
                            ]
                        }), a(t1.bearing, e1.bearing) || i.push({
                            command: W.setBearing,
                            args: [
                                e1.bearing
                            ]
                        }), a(t1.pitch, e1.pitch) || i.push({
                            command: W.setPitch,
                            args: [
                                e1.pitch
                            ]
                        }), a(t1.sprite, e1.sprite) || i.push({
                            command: W.setSprite,
                            args: [
                                e1.sprite
                            ]
                        }), a(t1.glyphs, e1.glyphs) || i.push({
                            command: W.setGlyphs,
                            args: [
                                e1.glyphs
                            ]
                        }), a(t1.transition, e1.transition) || i.push({
                            command: W.setTransition,
                            args: [
                                e1.transition
                            ]
                        }), a(t1.light, e1.light) || i.push({
                            command: W.setLight,
                            args: [
                                e1.light
                            ]
                        });
                        const o = {}, r = [];
                        !function(t1, e1, i, o) {
                            let r;
                            for(r in e1 = e1 || {}, t1 = t1 || {})Object.prototype.hasOwnProperty.call(t1, r) && (Object.prototype.hasOwnProperty.call(e1, r) || K(r, i, o));
                            for(r in e1)Object.prototype.hasOwnProperty.call(e1, r) && (Object.prototype.hasOwnProperty.call(t1, r) ? a(t1[r], e1[r]) || ("geojson" === t1[r].type && "geojson" === e1[r].type && J(t1, e1, r) ? i.push({
                                command: W.setGeoJSONSourceData,
                                args: [
                                    r,
                                    e1[r].data
                                ]
                            }) : Y(r, e1, i, o)) : H(r, e1, i));
                        }(t1.sources, e1.sources, r, o);
                        const s = [];
                        t1.layers && t1.layers.forEach((t1)=>{
                            o[t1.source] ? i.push({
                                command: W.removeLayer,
                                args: [
                                    t1.id
                                ]
                            }) : s.push(t1);
                        }), i = i.concat(r), function(t1, e1, i) {
                            e1 = e1 || [];
                            const o = (t1 = t1 || []).map(tt), r = e1.map(tt), s = t1.reduce(et, {}), n = e1.reduce(et, {}), l = o.slice(), c = Object.create(null);
                            let h, u, d, m, _, p, f;
                            for(h = 0, u = 0; h < o.length; h++)d = o[h], Object.prototype.hasOwnProperty.call(n, d) ? u++ : (i.push({
                                command: W.removeLayer,
                                args: [
                                    d
                                ]
                            }), l.splice(l.indexOf(d, u), 1));
                            for(h = 0, u = 0; h < r.length; h++)d = r[r.length - 1 - h], l[l.length - 1 - h] !== d && (Object.prototype.hasOwnProperty.call(s, d) ? (i.push({
                                command: W.removeLayer,
                                args: [
                                    d
                                ]
                            }), l.splice(l.lastIndexOf(d, l.length - u), 1)) : u++, p = l[l.length - h], i.push({
                                command: W.addLayer,
                                args: [
                                    n[d],
                                    p
                                ]
                            }), l.splice(l.length - h, 0, d), c[d] = !0);
                            for(h = 0; h < r.length; h++)if (d = r[h], m = s[d], _ = n[d], !c[d] && !a(m, _)) {
                                if (a(m.source, _.source) && a(m["source-layer"], _["source-layer"]) && a(m.type, _.type)) {
                                    for(f in Q(m.layout, _.layout, i, d, null, W.setLayoutProperty), Q(m.paint, _.paint, i, d, null, W.setPaintProperty), a(m.filter, _.filter) || i.push({
                                        command: W.setFilter,
                                        args: [
                                            d,
                                            _.filter
                                        ]
                                    }), a(m.minzoom, _.minzoom) && a(m.maxzoom, _.maxzoom) || i.push({
                                        command: W.setLayerZoomRange,
                                        args: [
                                            d,
                                            _.minzoom,
                                            _.maxzoom
                                        ]
                                    }), m)Object.prototype.hasOwnProperty.call(m, f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && (0 === f.indexOf("paint.") ? Q(m[f], _[f], i, d, f.slice(6), W.setPaintProperty) : a(m[f], _[f]) || i.push({
                                        command: W.setLayerProperty,
                                        args: [
                                            d,
                                            f,
                                            _[f]
                                        ]
                                    }));
                                    for(f in _)Object.prototype.hasOwnProperty.call(_, f) && !Object.prototype.hasOwnProperty.call(m, f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && (0 === f.indexOf("paint.") ? Q(m[f], _[f], i, d, f.slice(6), W.setPaintProperty) : a(m[f], _[f]) || i.push({
                                        command: W.setLayerProperty,
                                        args: [
                                            d,
                                            f,
                                            _[f]
                                        ]
                                    }));
                                } else i.push({
                                    command: W.removeLayer,
                                    args: [
                                        d
                                    ]
                                }), p = l[l.lastIndexOf(d) + 1], i.push({
                                    command: W.addLayer,
                                    args: [
                                        _,
                                        p
                                    ]
                                });
                            }
                        }(s, e1.layers, i);
                    } catch (t1) {
                        console.warn("Unable to compute style diff:", t1), i = [
                            {
                                command: W.setStyle,
                                args: [
                                    e1
                                ]
                            }
                        ];
                    }
                    return i;
                })(this.serialize(), e1).filter((t1)=>!(t1.command in Qt));
                if (0 === i.length) return !1;
                const o = i.filter((t1)=>!(t1.command in Jt));
                if (o.length > 0) throw new Error(`Unimplemented: ${o.map((t1)=>t1.command).join(", ")}.`);
                return i.forEach((t1)=>{
                    "setTransition" !== t1.command && this[t1.command].apply(this, t1.args);
                }), this.stylesheet = e1, !0;
            }
            addImage(e1, i) {
                if (this.getImage(e1)) return this.fire(new t1.ErrorEvent(new Error(`An image named "${e1}" already exists.`)));
                this.imageManager.addImage(e1, i), this._afterImageUpdated(e1);
            }
            updateImage(t1, e1) {
                this.imageManager.updateImage(t1, e1);
            }
            getImage(t1) {
                return this.imageManager.getImage(t1);
            }
            removeImage(e1) {
                if (!this.getImage(e1)) return this.fire(new t1.ErrorEvent(new Error(`An image named "${e1}" does not exist.`)));
                this.imageManager.removeImage(e1), this._afterImageUpdated(e1);
            }
            _afterImageUpdated(e1) {
                this._availableImages = this.imageManager.listImages(), this._changedImages[e1] = !0, this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t1.Event("data", {
                    dataType: "style"
                }));
            }
            listImages() {
                return this._checkLoaded(), this.imageManager.listImages();
            }
            addSource(e1, i, o = {}) {
                if (this._checkLoaded(), void 0 !== this.sourceCaches[e1]) throw new Error(`Source "${e1}" already exists.`);
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(i.type) >= 0 && this._validate(t1.validateStyle.source, `sources.${e1}`, i, null, o)) return;
                this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                const a = this.sourceCaches[e1] = new O(e1, i, this.dispatcher);
                a.style = this, a.setEventedParent(this, ()=>({
                        isSourceLoaded: this.loaded(),
                        source: a.serialize(),
                        sourceId: e1
                    })), a.onAdd(this.map), this._changed = !0;
            }
            removeSource(e1) {
                if (this._checkLoaded(), void 0 === this.sourceCaches[e1]) throw new Error("There is no source with this ID");
                for(const i in this._layers)if (this._layers[i].source === e1) return this.fire(new t1.ErrorEvent(new Error(`Source "${e1}" cannot be removed while layer "${i}" is using it.`)));
                const i = this.sourceCaches[e1];
                delete this.sourceCaches[e1], delete this._updatedSources[e1], i.fire(new t1.Event("data", {
                    sourceDataType: "metadata",
                    dataType: "source",
                    sourceId: e1
                })), i.setEventedParent(null), i.onRemove(this.map), this._changed = !0;
            }
            setGeoJSONSourceData(t1, e1) {
                if (this._checkLoaded(), void 0 === this.sourceCaches[t1]) throw new Error(`There is no source with this ID=${t1}`);
                const i = this.sourceCaches[t1].getSource();
                if ("geojson" !== i.type) throw new Error(`geojsonSource.type is ${i.type}, which is !== 'geojson`);
                i.setData(e1), this._changed = !0;
            }
            getSource(t1) {
                return this.sourceCaches[t1] && this.sourceCaches[t1].getSource();
            }
            addLayer(e1, i, o = {}) {
                this._checkLoaded();
                const a = e1.id;
                if (this.getLayer(a)) return void this.fire(new t1.ErrorEvent(new Error(`Layer "${a}" already exists on this map.`)));
                let r;
                if ("custom" === e1.type) {
                    if (Yt(this, t1.validateCustomStyleLayer(e1))) return;
                    r = t1.createStyleLayer(e1);
                } else {
                    if ("object" == typeof e1.source && (this.addSource(a, e1.source), e1 = t1.clone$1(e1), e1 = t1.extend(e1, {
                        source: a
                    })), this._validate(t1.validateStyle.layer, `layers.${a}`, e1, {
                        arrayIndex: -1
                    }, o)) return;
                    r = t1.createStyleLayer(e1), this._validateLayer(r), r.setEventedParent(this, {
                        layer: {
                            id: a
                        }
                    }), this._serializedLayers[r.id] = r.serialize();
                }
                const s = i ? this._order.indexOf(i) : this._order.length;
                if (i && -1 === s) this.fire(new t1.ErrorEvent(new Error(`Cannot add layer "${a}" before non-existing layer "${i}".`)));
                else {
                    if (this._order.splice(s, 0, a), this._layerOrderChanged = !0, this._layers[a] = r, this._removedLayers[a] && r.source && "custom" !== r.type) {
                        const t1 = this._removedLayers[a];
                        delete this._removedLayers[a], t1.type !== r.type ? this._updatedSources[r.source] = "clear" : (this._updatedSources[r.source] = "reload", this.sourceCaches[r.source].pause());
                    }
                    this._updateLayer(r), r.onAdd && r.onAdd(this.map);
                }
            }
            moveLayer(e1, i) {
                if (this._checkLoaded(), this._changed = !0, !this._layers[e1]) return void this.fire(new t1.ErrorEvent(new Error(`The layer '${e1}' does not exist in the map's style and cannot be moved.`)));
                if (e1 === i) return;
                const o = this._order.indexOf(e1);
                this._order.splice(o, 1);
                const a = i ? this._order.indexOf(i) : this._order.length;
                i && -1 === a ? this.fire(new t1.ErrorEvent(new Error(`Cannot move layer "${e1}" before non-existing layer "${i}".`))) : (this._order.splice(a, 0, e1), this._layerOrderChanged = !0);
            }
            removeLayer(e1) {
                this._checkLoaded();
                const i = this._layers[e1];
                if (!i) return void this.fire(new t1.ErrorEvent(new Error(`Cannot remove non-existing layer "${e1}".`)));
                i.setEventedParent(null);
                const o = this._order.indexOf(e1);
                this._order.splice(o, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e1] = i, delete this._layers[e1], delete this._serializedLayers[e1], delete this._updatedLayers[e1], delete this._updatedPaintProps[e1], i.onRemove && i.onRemove(this.map);
            }
            getLayer(t1) {
                return this._layers[t1];
            }
            hasLayer(t1) {
                return t1 in this._layers;
            }
            setLayerZoomRange(e1, i, o) {
                this._checkLoaded();
                const a = this.getLayer(e1);
                a ? a.minzoom === i && a.maxzoom === o || (null != i && (a.minzoom = i), null != o && (a.maxzoom = o), this._updateLayer(a)) : this.fire(new t1.ErrorEvent(new Error(`Cannot set the zoom range of non-existing layer "${e1}".`)));
            }
            setFilter(e1, i, o = {}) {
                this._checkLoaded();
                const r = this.getLayer(e1);
                if (r) {
                    if (!a(r.filter, i)) return null == i ? (r.filter = void 0, void this._updateLayer(r)) : void (this._validate(t1.validateStyle.filter, `layers.${r.id}.filter`, i, null, o) || (r.filter = t1.clone$1(i), this._updateLayer(r)));
                } else this.fire(new t1.ErrorEvent(new Error(`Cannot filter non-existing layer "${e1}".`)));
            }
            getFilter(e1) {
                return t1.clone$1(this.getLayer(e1).filter);
            }
            setLayoutProperty(e1, i, o, r = {}) {
                this._checkLoaded();
                const s = this.getLayer(e1);
                s ? a(s.getLayoutProperty(i), o) || (s.setLayoutProperty(i, o, r), this._updateLayer(s)) : this.fire(new t1.ErrorEvent(new Error(`Cannot style non-existing layer "${e1}".`)));
            }
            getLayoutProperty(e1, i) {
                const o = this.getLayer(e1);
                if (o) return o.getLayoutProperty(i);
                this.fire(new t1.ErrorEvent(new Error(`Cannot get style of non-existing layer "${e1}".`)));
            }
            setPaintProperty(e1, i, o, r = {}) {
                this._checkLoaded();
                const s = this.getLayer(e1);
                s ? a(s.getPaintProperty(i), o) || (s.setPaintProperty(i, o, r) && this._updateLayer(s), this._changed = !0, this._updatedPaintProps[e1] = !0) : this.fire(new t1.ErrorEvent(new Error(`Cannot style non-existing layer "${e1}".`)));
            }
            getPaintProperty(t1, e1) {
                return this.getLayer(t1).getPaintProperty(e1);
            }
            setFeatureState(e1, i) {
                this._checkLoaded();
                const o = e1.source, a = e1.sourceLayer, r = this.sourceCaches[o];
                if (void 0 === r) return void this.fire(new t1.ErrorEvent(new Error(`The source '${o}' does not exist in the map's style.`)));
                const s = r.getSource().type;
                "geojson" === s && a ? this.fire(new t1.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== s || a ? (void 0 === e1.id && this.fire(new t1.ErrorEvent(new Error("The feature id parameter must be provided."))), r.setFeatureState(a, e1.id, i)) : this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
            removeFeatureState(e1, i) {
                this._checkLoaded();
                const o = e1.source, a = this.sourceCaches[o];
                if (void 0 === a) return void this.fire(new t1.ErrorEvent(new Error(`The source '${o}' does not exist in the map's style.`)));
                const r = a.getSource().type, s = "vector" === r ? e1.sourceLayer : void 0;
                "vector" !== r || s ? i && "string" != typeof e1.id && "number" != typeof e1.id ? this.fire(new t1.ErrorEvent(new Error("A feature id is required to remove its specific state property."))) : a.removeFeatureState(s, e1.id, i) : this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
            getFeatureState(e1) {
                this._checkLoaded();
                const i = e1.source, o = e1.sourceLayer, a = this.sourceCaches[i];
                if (void 0 !== a) return "vector" !== a.getSource().type || o ? (void 0 === e1.id && this.fire(new t1.ErrorEvent(new Error("The feature id parameter must be provided."))), a.getFeatureState(o, e1.id)) : void this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                this.fire(new t1.ErrorEvent(new Error(`The source '${i}' does not exist in the map's style.`)));
            }
            getTransition() {
                return t1.extend({
                    duration: 300,
                    delay: 0
                }, this.stylesheet && this.stylesheet.transition);
            }
            serialize() {
                return t1.filterObject({
                    version: this.stylesheet.version,
                    name: this.stylesheet.name,
                    metadata: this.stylesheet.metadata,
                    light: this.stylesheet.light,
                    center: this.stylesheet.center,
                    zoom: this.stylesheet.zoom,
                    bearing: this.stylesheet.bearing,
                    pitch: this.stylesheet.pitch,
                    sprite: this.stylesheet.sprite,
                    glyphs: this.stylesheet.glyphs,
                    transition: this.stylesheet.transition,
                    sources: t1.mapObject(this.sourceCaches, (t1)=>t1.serialize()),
                    layers: this._serializeLayers(this._order)
                }, (t1)=>void 0 !== t1);
            }
            _updateLayer(t1) {
                this._updatedLayers[t1.id] = !0, t1.source && !this._updatedSources[t1.source] && "raster" !== this.sourceCaches[t1.source].getSource().type && (this._updatedSources[t1.source] = "reload", this.sourceCaches[t1.source].pause()), this._changed = !0;
            }
            _flattenAndSortRenderedFeatures(t1) {
                const e1 = (t1)=>"fill-extrusion" === this._layers[t1].type, i = {}, o = [];
                for(let a = this._order.length - 1; a >= 0; a--){
                    const r = this._order[a];
                    if (e1(r)) {
                        i[r] = a;
                        for (const e1 of t1){
                            const t1 = e1[r];
                            if (t1) for (const e1 of t1)o.push(e1);
                        }
                    }
                }
                o.sort((t1, e1)=>e1.intersectionZ - t1.intersectionZ);
                const a = [];
                for(let r = this._order.length - 1; r >= 0; r--){
                    const s = this._order[r];
                    if (e1(s)) for(let t1 = o.length - 1; t1 >= 0; t1--){
                        const e1 = o[t1].feature;
                        if (i[e1.layer.id] < r) break;
                        a.push(e1), o.pop();
                    }
                    else for (const e1 of t1){
                        const t1 = e1[s];
                        if (t1) for (const e1 of t1)a.push(e1.feature);
                    }
                }
                return a;
            }
            queryRenderedFeatures(e1, i, o) {
                i && i.filter && this._validate(t1.validateStyle.filter, "queryRenderedFeatures.filter", i.filter, null, i);
                const a = {};
                if (i && i.layers) {
                    if (!Array.isArray(i.layers)) return this.fire(new t1.ErrorEvent(new Error("parameters.layers must be an Array."))), [];
                    for (const e1 of i.layers){
                        const i = this._layers[e1];
                        if (!i) return this.fire(new t1.ErrorEvent(new Error(`The layer '${e1}' does not exist in the map's style and cannot be queried for features.`))), [];
                        a[i.source] = !0;
                    }
                }
                const r = [];
                i.availableImages = this._availableImages;
                for(const t1 in this.sourceCaches)i.layers && !a[t1] || r.push(L(this.sourceCaches[t1], this._layers, this._serializedLayers, e1, i, o));
                return this.placement && r.push(function(t1, e1, i, o, a, r, s) {
                    const n = {}, l = r.queryRenderedSymbols(o), c = [];
                    for (const t1 of Object.keys(l).map(Number))c.push(s[t1]);
                    c.sort(R);
                    for (const i of c){
                        const o = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], e1, i.bucketIndex, i.sourceLayerIndex, a.filter, a.layers, a.availableImages, t1);
                        for(const t1 in o){
                            const e1 = n[t1] = n[t1] || [], a = o[t1];
                            a.sort((t1, e1)=>{
                                const o = i.featureSortOrder;
                                if (o) {
                                    const i = o.indexOf(t1.featureIndex);
                                    return o.indexOf(e1.featureIndex) - i;
                                }
                                return e1.featureIndex - t1.featureIndex;
                            });
                            for (const t1 of a)e1.push(t1);
                        }
                    }
                    for(const e1 in n)n[e1].forEach((o)=>{
                        const a = o.feature, r = i[t1[e1].source].getFeatureState(a.layer["source-layer"], a.id);
                        a.source = a.layer.source, a.layer["source-layer"] && (a.sourceLayer = a.layer["source-layer"]), a.state = r;
                    });
                    return n;
                }(this._layers, this._serializedLayers, this.sourceCaches, e1, i, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(r);
            }
            querySourceFeatures(e1, i) {
                i && i.filter && this._validate(t1.validateStyle.filter, "querySourceFeatures.filter", i.filter, null, i);
                const o = this.sourceCaches[e1];
                return o ? function(t1, e1) {
                    const i = t1.getRenderableIds().map((e1)=>t1.getTileByID(e1)), o = [], a = {};
                    for(let t1 = 0; t1 < i.length; t1++){
                        const r = i[t1], s = r.tileID.canonical.key;
                        a[s] || (a[s] = !0, r.querySourceFeatures(o, e1));
                    }
                    return o;
                }(o, i) : [];
            }
            addSourceType(t1, e1, i) {
                return ee.getSourceType(t1) ? i(new Error(`A source type called "${t1}" already exists.`)) : (ee.setSourceType(t1, e1), e1.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                    name: t1,
                    url: e1.workerSourceURL
                }, i) : i(null, null));
            }
            getLight() {
                return this.light.getLight();
            }
            setLight(e1, i = {}) {
                this._checkLoaded();
                const o = this.light.getLight();
                let r = !1;
                for(const t1 in e1)if (!a(e1[t1], o[t1])) {
                    r = !0;
                    break;
                }
                if (!r) return;
                const s = {
                    now: t1.exported.now(),
                    transition: t1.extend({
                        duration: 300,
                        delay: 0
                    }, this.stylesheet.transition)
                };
                this.light.setLight(e1, i), this.light.updateTransitions(s);
            }
            _validate(e1, i, o, a, r = {}) {
                return (!r || !1 !== r.validate) && Yt(this, e1.call(t1.validateStyle, t1.extend({
                    key: i,
                    style: this.serialize(),
                    value: o,
                    styleSpec: t1.spec
                }, a)));
            }
            _remove() {
                this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), t1.evented.off("pluginStateChange", this._rtlTextPluginCallback);
                for(const t1 in this._layers)this._layers[t1].setEventedParent(null);
                for(const t1 in this.sourceCaches){
                    const e1 = this.sourceCaches[t1];
                    e1.setEventedParent(null), e1.onRemove(this.map);
                }
                this.imageManager.setEventedParent(null), this.setEventedParent(null), this.dispatcher.remove();
            }
            _clearSource(t1) {
                this.sourceCaches[t1].clearTiles();
            }
            _reloadSource(t1) {
                this.sourceCaches[t1].resume(), this.sourceCaches[t1].reload();
            }
            _updateSources(t1) {
                for(const e1 in this.sourceCaches)this.sourceCaches[e1].update(t1, this.terrain);
            }
            _generateCollisionBoxes() {
                for(const t1 in this.sourceCaches)this._reloadSource(t1);
            }
            _updatePlacement(e1, i, o, a, r = !1) {
                let s = !1, n = !1;
                const l = {};
                for (const t1 of this._order){
                    const i = this._layers[t1];
                    if ("symbol" !== i.type) continue;
                    if (!l[i.source]) {
                        const t1 = this.sourceCaches[i.source];
                        l[i.source] = t1.getRenderableIds(!0).map((e1)=>t1.getTileByID(e1)).sort((t1, e1)=>e1.tileID.overscaledZ - t1.tileID.overscaledZ || (t1.tileID.isLessThan(e1.tileID) ? -1 : 1));
                    }
                    const o = this.crossTileSymbolIndex.addLayer(i, l[i.source], e1.center.lng);
                    s = s || o;
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((r = r || this._layerOrderChanged || 0 === o) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(t1.exported.now(), e1.zoom)) && (this.pauseablePlacement = new Zt(e1, this.terrain, this._order, r, i, o, a, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, l), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(t1.exported.now()), n = !0), s && this.pauseablePlacement.placement.setStale()), n || s) for (const t1 of this._order){
                    const e1 = this._layers[t1];
                    "symbol" === e1.type && this.placement.updateLayerOpacities(e1, l[e1.source]);
                }
                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(t1.exported.now());
            }
            _releaseSymbolFadeTiles() {
                for(const t1 in this.sourceCaches)this.sourceCaches[t1].releaseSymbolFadeTiles();
            }
            getImages(t1, e1, i) {
                this.imageManager.getImages(e1.icons, i), this._updateTilesForChangedImages();
                const o = this.sourceCaches[e1.source];
                o && o.setDependencies(e1.tileID.key, e1.type, e1.icons);
            }
            getGlyphs(t1, e1, i) {
                this.glyphManager.getGlyphs(e1.stacks, i);
            }
            getResource(e1, i, o) {
                return t1.makeRequest(i, o);
            }
            constructor(e1, i = {}){
                super(), this.map = e1, this.dispatcher = new v(j(), this), this.imageManager = new h, this.imageManager.setEventedParent(this), this.glyphManager = new _(e1._requestManager, i.localIdeographFontFamily), this.lineAtlas = new x(256, 512), this.crossTileSymbolIndex = new Xt, this._layers = {}, this._serializedLayers = {}, this._order = [], this.sourceCaches = {}, this.zoomHistory = new t1.ZoomHistory, this._loaded = !1, this._availableImages = [], this._resetUpdates(), this.dispatcher.broadcast("setReferrer", t1.getReferrer());
                const o = this;
                this._rtlTextPluginCallback = ee.registerForPluginStateChange((e1)=>{
                    o.dispatcher.broadcast("syncRTLPluginState", {
                        pluginStatus: e1.pluginStatus,
                        pluginURL: e1.pluginURL
                    }, (e1, i)=>{
                        if (t1.triggerPluginCompletionEvent(e1), i && i.every((t1)=>t1)) for(const t1 in o.sourceCaches)o.sourceCaches[t1].reload();
                    });
                }), this.on("data", (t1)=>{
                    if ("source" !== t1.dataType || "metadata" !== t1.sourceDataType) return;
                    const e1 = this.sourceCaches[t1.sourceId];
                    if (!e1) return;
                    const i = e1.getSource();
                    if (i && i.vectorLayerIds) for(const t1 in this._layers){
                        const e1 = this._layers[t1];
                        e1.source === i.id && this._validateLayer(e1);
                    }
                });
            }
        }
        ee.getSourceType = function(t1) {
            return M[t1];
        }, ee.setSourceType = function(t1, e1) {
            M[t1] = e1;
        }, ee.registerForPluginStateChange = t1.registerForPluginStateChange;
        var ie = "attribute vec2 a_pos;uniform mat4 u_matrix;varying vec2 v_texture_pos;varying float v_depth;void main() {v_texture_pos=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos,get_elevation(a_pos),1.0);v_depth=gl_Position.z/gl_Position.w;}";
        const oe = {
            prelude: ae("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}\n#ifdef TERRAIN3D\nuniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_offset;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;\n#endif\nconst highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {\n#ifdef TERRAIN3D\nhighp float d=unpack(texture2D(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));\n#else\nreturn 1.0;\n#endif\n}float calculate_visibility(vec4 pos) {\n#ifdef TERRAIN3D\nvec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;\n#else\nreturn 1.0;\n#endif\n}float ele(vec2 pos) {\n#ifdef TERRAIN3D\nvec4 rgb=(texture2D(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;\n#else\nreturn 0.0;\n#endif\n}float get_elevation(vec2 pos) {\n#ifdef TERRAIN3D\nvec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return (elevation+u_terrain_offset)*u_terrain_exaggeration;\n#else\nreturn 0.0;\n#endif\n}"),
            background: ae("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            backgroundPattern: ae("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),
            circle: ae("varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);float ele=get_elevation(circle_center);v_visibility=calculate_visibility(u_matrix*vec4(circle_center,ele,1.0));if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,ele,1);} else {gl_Position=u_matrix*vec4(circle_center,ele,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),
            clippingMask: ae("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            heatmap: ae("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}"),
            heatmapTexture: ae("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),
            collisionBox: ae("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}", "attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,get_elevation(a_pos),1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
            collisionCircle: ae("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", "attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            debug: ae("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", "attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,get_elevation(a_pos),1);}"),
            fill: ae("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}"),
            fillOutline: ae("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),
            fillOutlinePattern: ae("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),
            fillPattern: ae("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),
            fillExtrusion: ae("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;\n#ifdef TERRAIN3D\nattribute vec2 a_centroid;\n#endif\nvarying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;\n#ifdef TERRAIN3D\nfloat baseDelta=10.0;float ele=get_elevation(a_centroid);\n#else\nfloat baseDelta=0.0;float ele=0.0;\n#endif\nbase=max(0.0,ele+base-baseDelta);height=max(0.0,ele+height);float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),
            fillExtrusionPattern: ae("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;\n#ifdef TERRAIN3D\nattribute vec2 a_centroid;\n#endif\nvarying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;\n#ifdef TERRAIN3D\nfloat baseDelta=10.0;float ele=get_elevation(a_centroid);\n#else\nfloat baseDelta=0.0;float ele=0.0;\n#endif\nbase=max(0.0,ele+base-baseDelta);height=max(0.0,ele+height);float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),
            hillshadePrepare: ae("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: ae("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"),
            line: ae("uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            lineGradient: ae("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,v_uv);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_uv_x;attribute float a_split_index;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            linePattern: ae("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"),
            lineSDF: ae("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"),
            raster: ae("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),
            symbolIcon: ae("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,ele,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),ele,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,ele,1.0);float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0),z,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));}"),
            symbolSDF: ae("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,ele,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),ele,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,ele,1.0);float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset),z,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"),
            symbolTextAndIcon: ae("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,ele,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),ele,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,ele,1.0);float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),z,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}"),
            terrain: ae("uniform sampler2D u_texture;varying vec2 v_texture_pos;void main() {gl_FragColor=texture2D(u_texture,v_texture_pos);}", ie),
            terrainDepth: ae("varying float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {gl_FragColor=pack(v_depth);}", ie),
            terrainCoords: ae("precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;varying vec2 v_texture_pos;void main() {vec4 rgba=texture2D(u_texture,v_texture_pos);gl_FragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}", ie)
        };
        function ae(t1, e1) {
            const i = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, o = e1.match(/attribute ([\w]+) ([\w]+)/g), a = t1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), r = e1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), s = r ? r.concat(a) : a, n = {};
            return {
                fragmentSource: t1 = t1.replace(i, (t1, e1, i, o, a)=>(n[a] = !0, "define" === e1 ? `\n#ifndef HAS_UNIFORM_u_${a}\nvarying ${i} ${o} ${a};\n#else\nuniform ${i} ${o} u_${a};\n#endif\n` : `\n#ifdef HAS_UNIFORM_u_${a}\n    ${i} ${o} ${a} = u_${a};\n#endif\n`)),
                vertexSource: e1 = e1.replace(i, (t1, e1, i, o, a)=>{
                    const r = "float" === o ? "vec2" : "vec4", s = a.match(/color/) ? "color" : r;
                    return n[a] ? "define" === e1 ? `\n#ifndef HAS_UNIFORM_u_${a}\nuniform lowp float u_${a}_t;\nattribute ${i} ${r} a_${a};\nvarying ${i} ${o} ${a};\n#else\nuniform ${i} ${o} u_${a};\n#endif\n` : "vec4" === s ? `\n#ifndef HAS_UNIFORM_u_${a}\n    ${a} = a_${a};\n#else\n    ${i} ${o} ${a} = u_${a};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${a}\n    ${a} = unpack_mix_${s}(a_${a}, u_${a}_t);\n#else\n    ${i} ${o} ${a} = u_${a};\n#endif\n` : "define" === e1 ? `\n#ifndef HAS_UNIFORM_u_${a}\nuniform lowp float u_${a}_t;\nattribute ${i} ${r} a_${a};\n#else\nuniform ${i} ${o} u_${a};\n#endif\n` : "vec4" === s ? `\n#ifndef HAS_UNIFORM_u_${a}\n    ${i} ${o} ${a} = a_${a};\n#else\n    ${i} ${o} ${a} = u_${a};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${a}\n    ${i} ${o} ${a} = unpack_mix_${s}(a_${a}, u_${a}_t);\n#else\n    ${i} ${o} ${a} = u_${a};\n#endif\n`;
                }),
                staticAttributes: o,
                staticUniforms: s
            };
        }
        class re {
            bind(t1, e1, i, o, a, r, s, n, l) {
                this.context = t1;
                let c = this.boundPaintVertexBuffers.length !== o.length;
                for(let t1 = 0; !c && t1 < o.length; t1++)this.boundPaintVertexBuffers[t1] !== o[t1] && (c = !0);
                t1.extVertexArrayObject && this.vao && this.boundProgram === e1 && this.boundLayoutVertexBuffer === i && !c && this.boundIndexBuffer === a && this.boundVertexOffset === r && this.boundDynamicVertexBuffer === s && this.boundDynamicVertexBuffer2 === n && this.boundDynamicVertexBuffer3 === l ? (t1.bindVertexArrayOES.set(this.vao), s && s.bind(), a && a.dynamicDraw && a.bind(), n && n.bind(), l && l.bind()) : this.freshBind(e1, i, o, a, r, s, n, l);
            }
            freshBind(t1, e1, i, o, a, r, s, n) {
                let l;
                const c = t1.numAttributes, h = this.context, u = h.gl;
                if (h.extVertexArrayObject) this.vao && this.destroy(), this.vao = h.extVertexArrayObject.createVertexArrayOES(), h.bindVertexArrayOES.set(this.vao), l = 0, this.boundProgram = t1, this.boundLayoutVertexBuffer = e1, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = o, this.boundVertexOffset = a, this.boundDynamicVertexBuffer = r, this.boundDynamicVertexBuffer2 = s, this.boundDynamicVertexBuffer3 = n;
                else {
                    l = h.currentNumAttributes || 0;
                    for(let t1 = c; t1 < l; t1++)u.disableVertexAttribArray(t1);
                }
                e1.enableAttributes(u, t1);
                for (const e1 of i)e1.enableAttributes(u, t1);
                r && r.enableAttributes(u, t1), s && s.enableAttributes(u, t1), n && n.enableAttributes(u, t1), e1.bind(), e1.setVertexAttribPointers(u, t1, a);
                for (const e1 of i)e1.bind(), e1.setVertexAttribPointers(u, t1, a);
                r && (r.bind(), r.setVertexAttribPointers(u, t1, a)), o && o.bind(), s && (s.bind(), s.setVertexAttribPointers(u, t1, a)), n && (n.bind(), n.setVertexAttribPointers(u, t1, a)), h.currentNumAttributes = c;
            }
            destroy() {
                this.vao && (this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao), this.vao = null);
            }
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
            }
        }
        function se(t1) {
            const e1 = [];
            for(let i = 0; i < t1.length; i++){
                if (null === t1[i]) continue;
                const o = t1[i].split(" ");
                e1.push(o.pop());
            }
            return e1;
        }
        class ne {
            draw(t1, e1, i, o, a, r, s, n, l, c, h, u, d, m, _, p, f, g) {
                const x = t1.gl;
                if (this.failedToCreate) return;
                if (t1.program.set(this.program), t1.setDepthMode(i), t1.setStencilMode(o), t1.setColorMode(a), t1.setCullFace(r), n) {
                    t1.activeTexture.set(x.TEXTURE2), x.bindTexture(x.TEXTURE_2D, n.depthTexture), t1.activeTexture.set(x.TEXTURE3), x.bindTexture(x.TEXTURE_2D, n.texture);
                    for(const t1 in this.terrainUniforms)this.terrainUniforms[t1].set(n[t1]);
                }
                for(const t1 in this.fixedUniforms)this.fixedUniforms[t1].set(s[t1]);
                _ && _.setUniforms(t1, this.binderUniforms, d, {
                    zoom: m
                });
                let v = 0;
                switch(e1){
                    case x.LINES:
                        v = 2;
                        break;
                    case x.TRIANGLES:
                        v = 3;
                        break;
                    case x.LINE_STRIP:
                        v = 1;
                }
                for (const i of u.get()){
                    const o = i.vaos || (i.vaos = {});
                    (o[l] || (o[l] = new re)).bind(t1, this, c, _ ? _.getPaintVertexBuffers() : [], h, i.vertexOffset, p, f, g), x.drawElements(e1, i.primitiveLength * v, x.UNSIGNED_SHORT, i.primitiveOffset * v * 2);
                }
            }
            constructor(e1, i, o, a, r, s, n){
                const l = e1.gl;
                this.program = l.createProgram();
                const c = se(o.staticAttributes), h = a ? a.getBinderAttributes() : [], u = c.concat(h), d = oe.prelude.staticUniforms ? se(oe.prelude.staticUniforms) : [], m = o.staticUniforms ? se(o.staticUniforms) : [], _ = a ? a.getBinderUniforms() : [], p = d.concat(m).concat(_), f = [];
                for (const t1 of p)f.indexOf(t1) < 0 && f.push(t1);
                const g = a ? a.defines() : [];
                s && g.push("#define OVERDRAW_INSPECTOR;"), n && g.push("#define TERRAIN3D;");
                const x = g.concat(oe.prelude.fragmentSource, o.fragmentSource).join("\n"), v = g.concat(oe.prelude.vertexSource, o.vertexSource).join("\n"), y = l.createShader(l.FRAGMENT_SHADER);
                if (l.isContextLost()) return void (this.failedToCreate = !0);
                l.shaderSource(y, x), l.compileShader(y), l.attachShader(this.program, y);
                const b = l.createShader(l.VERTEX_SHADER);
                if (l.isContextLost()) return void (this.failedToCreate = !0);
                l.shaderSource(b, v), l.compileShader(b), l.attachShader(this.program, b), this.attributes = {};
                const w = {};
                this.numAttributes = u.length;
                for(let t1 = 0; t1 < this.numAttributes; t1++)u[t1] && (l.bindAttribLocation(this.program, t1, u[t1]), this.attributes[u[t1]] = t1);
                l.linkProgram(this.program), l.deleteShader(b), l.deleteShader(y);
                for(let t1 = 0; t1 < f.length; t1++){
                    const e1 = f[t1];
                    if (e1 && !w[e1]) {
                        const t1 = l.getUniformLocation(this.program, e1);
                        t1 && (w[e1] = t1);
                    }
                }
                this.fixedUniforms = r(e1, w), this.terrainUniforms = ((e1, i)=>({
                        u_depth: new t1.Uniform1i(e1, i.u_depth),
                        u_terrain: new t1.Uniform1i(e1, i.u_terrain),
                        u_terrain_dim: new t1.Uniform1f(e1, i.u_terrain_dim),
                        u_terrain_matrix: new t1.UniformMatrix4f(e1, i.u_terrain_matrix),
                        u_terrain_unpack: new t1.Uniform4f(e1, i.u_terrain_unpack),
                        u_terrain_offset: new t1.Uniform1f(e1, i.u_terrain_offset),
                        u_terrain_exaggeration: new t1.Uniform1f(e1, i.u_terrain_exaggeration)
                    }))(e1, w), this.binderUniforms = a ? a.getUniforms(e1, w) : [];
            }
        }
        function le(t1, e1, i) {
            const o = 1 / bt(i, 1, e1.transform.tileZoom), a = Math.pow(2, i.tileID.overscaledZ), r = i.tileSize * Math.pow(2, e1.transform.tileZoom) / a, s = r * (i.tileID.canonical.x + i.tileID.wrap * a), n = r * i.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: i.imageAtlasTexture.size,
                u_scale: [
                    o,
                    t1.fromScale,
                    t1.toScale
                ],
                u_fade: t1.t,
                u_pixel_coord_upper: [
                    s >> 16,
                    n >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & s,
                    65535 & n
                ]
            };
        }
        const ce = (e1, i, o, a)=>{
            const r = i.style.light, s = r.properties.get("position"), n = [
                s.x,
                s.y,
                s.z
            ], l = t1.create$1();
            "viewport" === r.properties.get("anchor") && t1.fromRotation(l, -i.transform.angle), t1.transformMat3(n, n, l);
            const c = r.properties.get("color");
            return {
                u_matrix: e1,
                u_lightpos: n,
                u_lightintensity: r.properties.get("intensity"),
                u_lightcolor: [
                    c.r,
                    c.g,
                    c.b
                ],
                u_vertical_gradient: +o,
                u_opacity: a
            };
        }, he = (e1, i, o, a, r, s, n)=>t1.extend(ce(e1, i, o, a), le(s, i, n), {
                u_height_factor: -Math.pow(2, r.overscaledZ) / n.tileSize / 8
            }), ue = (t1)=>({
                u_matrix: t1
            }), de = (e1, i, o, a)=>t1.extend(ue(e1), le(o, i, a)), me = (t1, e1)=>({
                u_matrix: t1,
                u_world: e1
            }), _e = (e1, i, o, a, r)=>t1.extend(de(e1, i, o, a), {
                u_world: r
            }), pe = (t1, e1, i, o)=>{
            const a = t1.transform;
            let r, s;
            if ("map" === o.paint.get("circle-pitch-alignment")) {
                const t1 = bt(i, 1, a.zoom);
                r = !0, s = [
                    t1,
                    t1
                ];
            } else r = !1, s = a.pixelsToGLUnits;
            return {
                u_camera_to_center_distance: a.cameraToCenterDistance,
                u_scale_with_map: +("map" === o.paint.get("circle-pitch-scale")),
                u_matrix: t1.translatePosMatrix(e1.posMatrix, i, o.paint.get("circle-translate"), o.paint.get("circle-translate-anchor")),
                u_pitch_with_map: +r,
                u_device_pixel_ratio: t1.pixelRatio,
                u_extrude_scale: s
            };
        }, fe = (t1, e1, i)=>{
            const o = bt(i, 1, e1.zoom), a = Math.pow(2, e1.zoom - i.tileID.overscaledZ), r = i.tileID.overscaleFactor();
            return {
                u_matrix: t1,
                u_camera_to_center_distance: e1.cameraToCenterDistance,
                u_pixels_to_tile_units: o,
                u_extrude_scale: [
                    e1.pixelsToGLUnits[0] / (o * a),
                    e1.pixelsToGLUnits[1] / (o * a)
                ],
                u_overscale_factor: r
            };
        }, ge = (t1, e1, i = 1)=>({
                u_matrix: t1,
                u_color: e1,
                u_overlay: 0,
                u_overlay_scale: i
            }), xe = (t1)=>({
                u_matrix: t1
            }), ve = (t1, e1, i, o)=>({
                u_matrix: t1,
                u_extrude_scale: bt(e1, 1, i),
                u_intensity: o
            });
        function ye(e1, i) {
            const o = Math.pow(2, i.canonical.z), a = i.canonical.y;
            return [
                new t1.MercatorCoordinate(0, a / o).toLngLat().lat,
                new t1.MercatorCoordinate(0, (a + 1) / o).toLngLat().lat
            ];
        }
        const be = (t1, e1, i, o)=>{
            const a = t1.transform;
            return {
                u_matrix: Ce(t1, e1, i, o),
                u_ratio: 1 / bt(e1, 1, a.zoom),
                u_device_pixel_ratio: t1.pixelRatio,
                u_units_to_pixels: [
                    1 / a.pixelsToGLUnits[0],
                    1 / a.pixelsToGLUnits[1]
                ]
            };
        }, we = (e1, i, o, a, r)=>t1.extend(be(e1, i, o, r), {
                u_image: 0,
                u_image_height: a
            }), Te = (t1, e1, i, o, a)=>{
            const r = t1.transform, s = Ie(e1, r);
            return {
                u_matrix: Ce(t1, e1, i, a),
                u_texsize: e1.imageAtlasTexture.size,
                u_ratio: 1 / bt(e1, 1, r.zoom),
                u_device_pixel_ratio: t1.pixelRatio,
                u_image: 0,
                u_scale: [
                    s,
                    o.fromScale,
                    o.toScale
                ],
                u_fade: o.t,
                u_units_to_pixels: [
                    1 / r.pixelsToGLUnits[0],
                    1 / r.pixelsToGLUnits[1]
                ]
            };
        }, Ee = (e1, i, o, a, r, s)=>{
            const n = e1.lineAtlas, l = Ie(i, e1.transform), c = "round" === o.layout.get("line-cap"), h = n.getDash(a.from, c), u = n.getDash(a.to, c), d = h.width * r.fromScale, m = u.width * r.toScale;
            return t1.extend(be(e1, i, o, s), {
                u_patternscale_a: [
                    l / d,
                    -h.height / 2
                ],
                u_patternscale_b: [
                    l / m,
                    -u.height / 2
                ],
                u_sdfgamma: n.width / (256 * Math.min(d, m) * e1.pixelRatio) / 2,
                u_image: 0,
                u_tex_y_a: h.y,
                u_tex_y_b: u.y,
                u_mix: r.t
            });
        };
        function Ie(t1, e1) {
            return 1 / bt(t1, 1, e1.tileZoom);
        }
        function Ce(t1, e1, i, o) {
            return t1.translatePosMatrix(o ? o.posMatrix : e1.tileID.posMatrix, e1, i.paint.get("line-translate"), i.paint.get("line-translate-anchor"));
        }
        const Se = (t1, e1, i, o, a)=>{
            var r, s;
            return {
                u_matrix: t1,
                u_tl_parent: e1,
                u_scale_parent: i,
                u_buffer_scale: 1,
                u_fade_t: o.mix,
                u_opacity: o.opacity * a.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: a.paint.get("raster-brightness-min"),
                u_brightness_high: a.paint.get("raster-brightness-max"),
                u_saturation_factor: (s = a.paint.get("raster-saturation"), s > 0 ? 1 - 1 / (1.001 - s) : -s),
                u_contrast_factor: (r = a.paint.get("raster-contrast"), r > 0 ? 1 / (1 - r) : 1 + r),
                u_spin_weights: De(a.paint.get("raster-hue-rotate"))
            };
        };
        function De(t1) {
            t1 *= Math.PI / 180;
            const e1 = Math.sin(t1), i = Math.cos(t1);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * e1 - i + 1) / 3,
                (Math.sqrt(3) * e1 - i + 1) / 3
            ];
        }
        const ze = (t1, e1, i, o, a, r, s, n, l, c)=>{
            const h = a.transform;
            return {
                u_is_size_zoom_constant: +("constant" === t1 || "source" === t1),
                u_is_size_feature_constant: +("constant" === t1 || "camera" === t1),
                u_size_t: e1 ? e1.uSizeT : 0,
                u_size: e1 ? e1.uSize : 0,
                u_camera_to_center_distance: h.cameraToCenterDistance,
                u_pitch: h.pitch / 360 * 2 * Math.PI,
                u_rotate_symbol: +i,
                u_aspect_ratio: h.width / h.height,
                u_fade_change: a.options.fadeDuration ? a.symbolFadeChange : 1,
                u_matrix: r,
                u_label_plane_matrix: s,
                u_coord_matrix: n,
                u_is_text: +l,
                u_pitch_with_map: +o,
                u_texsize: c,
                u_texture: 0
            };
        }, Pe = (e1, i, o, a, r, s, n, l, c, h, u)=>{
            const d = r.transform;
            return t1.extend(ze(e1, i, o, a, r, s, n, l, c, h), {
                u_gamma_scale: a ? Math.cos(d._pitch) * d.cameraToCenterDistance : 1,
                u_device_pixel_ratio: r.pixelRatio,
                u_is_halo: +u
            });
        }, Me = (e1, i, o, a, r, s, n, l, c, h)=>t1.extend(Pe(e1, i, o, a, r, s, n, l, !0, c, !0), {
                u_texsize_icon: h,
                u_texture_icon: 1
            }), Ae = (t1, e1, i)=>({
                u_matrix: t1,
                u_opacity: e1,
                u_color: i
            }), Le = (e1, i, o, a, r, s)=>t1.extend(function(t1, e1, i, o) {
                const a = i.imageManager.getPattern(t1.from.toString()), r = i.imageManager.getPattern(t1.to.toString()), { width: s, height: n } = i.imageManager.getPixelSize(), l = Math.pow(2, o.tileID.overscaledZ), c = o.tileSize * Math.pow(2, i.transform.tileZoom) / l, h = c * (o.tileID.canonical.x + o.tileID.wrap * l), u = c * o.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl_a: a.tl,
                    u_pattern_br_a: a.br,
                    u_pattern_tl_b: r.tl,
                    u_pattern_br_b: r.br,
                    u_texsize: [
                        s,
                        n
                    ],
                    u_mix: e1.t,
                    u_pattern_size_a: a.displaySize,
                    u_pattern_size_b: r.displaySize,
                    u_scale_a: e1.fromScale,
                    u_scale_b: e1.toScale,
                    u_tile_units_to_pixels: 1 / bt(o, 1, i.transform.tileZoom),
                    u_pixel_coord_upper: [
                        h >> 16,
                        u >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & h,
                        65535 & u
                    ]
                };
            }(a, s, o, r), {
                u_matrix: e1,
                u_opacity: i
            }), Re = {
            fillExtrusion: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_lightpos: new t1.Uniform3f(e1, i.u_lightpos),
                    u_lightintensity: new t1.Uniform1f(e1, i.u_lightintensity),
                    u_lightcolor: new t1.Uniform3f(e1, i.u_lightcolor),
                    u_vertical_gradient: new t1.Uniform1f(e1, i.u_vertical_gradient),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity)
                }),
            fillExtrusionPattern: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_lightpos: new t1.Uniform3f(e1, i.u_lightpos),
                    u_lightintensity: new t1.Uniform1f(e1, i.u_lightintensity),
                    u_lightcolor: new t1.Uniform3f(e1, i.u_lightcolor),
                    u_vertical_gradient: new t1.Uniform1f(e1, i.u_vertical_gradient),
                    u_height_factor: new t1.Uniform1f(e1, i.u_height_factor),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_pixel_coord_upper: new t1.Uniform2f(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t1.Uniform2f(e1, i.u_pixel_coord_lower),
                    u_scale: new t1.Uniform3f(e1, i.u_scale),
                    u_fade: new t1.Uniform1f(e1, i.u_fade),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity)
                }),
            fill: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                }),
            fillPattern: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_pixel_coord_upper: new t1.Uniform2f(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t1.Uniform2f(e1, i.u_pixel_coord_lower),
                    u_scale: new t1.Uniform3f(e1, i.u_scale),
                    u_fade: new t1.Uniform1f(e1, i.u_fade)
                }),
            fillOutline: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_world: new t1.Uniform2f(e1, i.u_world)
                }),
            fillOutlinePattern: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_world: new t1.Uniform2f(e1, i.u_world),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_pixel_coord_upper: new t1.Uniform2f(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t1.Uniform2f(e1, i.u_pixel_coord_lower),
                    u_scale: new t1.Uniform3f(e1, i.u_scale),
                    u_fade: new t1.Uniform1f(e1, i.u_fade)
                }),
            circle: (e1, i)=>({
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_scale_with_map: new t1.Uniform1i(e1, i.u_scale_with_map),
                    u_pitch_with_map: new t1.Uniform1i(e1, i.u_pitch_with_map),
                    u_extrude_scale: new t1.Uniform2f(e1, i.u_extrude_scale),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                }),
            collisionBox: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_pixels_to_tile_units: new t1.Uniform1f(e1, i.u_pixels_to_tile_units),
                    u_extrude_scale: new t1.Uniform2f(e1, i.u_extrude_scale),
                    u_overscale_factor: new t1.Uniform1f(e1, i.u_overscale_factor)
                }),
            collisionCircle: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_inv_matrix: new t1.UniformMatrix4f(e1, i.u_inv_matrix),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_viewport_size: new t1.Uniform2f(e1, i.u_viewport_size)
                }),
            debug: (e1, i)=>({
                    u_color: new t1.UniformColor(e1, i.u_color),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_overlay: new t1.Uniform1i(e1, i.u_overlay),
                    u_overlay_scale: new t1.Uniform1f(e1, i.u_overlay_scale)
                }),
            clippingMask: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                }),
            heatmap: (e1, i)=>({
                    u_extrude_scale: new t1.Uniform1f(e1, i.u_extrude_scale),
                    u_intensity: new t1.Uniform1f(e1, i.u_intensity),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                }),
            heatmapTexture: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_world: new t1.Uniform2f(e1, i.u_world),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_color_ramp: new t1.Uniform1i(e1, i.u_color_ramp),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity)
                }),
            hillshade: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_latrange: new t1.Uniform2f(e1, i.u_latrange),
                    u_light: new t1.Uniform2f(e1, i.u_light),
                    u_shadow: new t1.UniformColor(e1, i.u_shadow),
                    u_highlight: new t1.UniformColor(e1, i.u_highlight),
                    u_accent: new t1.UniformColor(e1, i.u_accent)
                }),
            hillshadePrepare: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_dimension: new t1.Uniform2f(e1, i.u_dimension),
                    u_zoom: new t1.Uniform1f(e1, i.u_zoom),
                    u_unpack: new t1.Uniform4f(e1, i.u_unpack)
                }),
            line: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_ratio: new t1.Uniform1f(e1, i.u_ratio),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t1.Uniform2f(e1, i.u_units_to_pixels)
                }),
            lineGradient: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_ratio: new t1.Uniform1f(e1, i.u_ratio),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t1.Uniform2f(e1, i.u_units_to_pixels),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_image_height: new t1.Uniform1f(e1, i.u_image_height)
                }),
            linePattern: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_ratio: new t1.Uniform1f(e1, i.u_ratio),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_units_to_pixels: new t1.Uniform2f(e1, i.u_units_to_pixels),
                    u_scale: new t1.Uniform3f(e1, i.u_scale),
                    u_fade: new t1.Uniform1f(e1, i.u_fade)
                }),
            lineSDF: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_ratio: new t1.Uniform1f(e1, i.u_ratio),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t1.Uniform2f(e1, i.u_units_to_pixels),
                    u_patternscale_a: new t1.Uniform2f(e1, i.u_patternscale_a),
                    u_patternscale_b: new t1.Uniform2f(e1, i.u_patternscale_b),
                    u_sdfgamma: new t1.Uniform1f(e1, i.u_sdfgamma),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_tex_y_a: new t1.Uniform1f(e1, i.u_tex_y_a),
                    u_tex_y_b: new t1.Uniform1f(e1, i.u_tex_y_b),
                    u_mix: new t1.Uniform1f(e1, i.u_mix)
                }),
            raster: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_tl_parent: new t1.Uniform2f(e1, i.u_tl_parent),
                    u_scale_parent: new t1.Uniform1f(e1, i.u_scale_parent),
                    u_buffer_scale: new t1.Uniform1f(e1, i.u_buffer_scale),
                    u_fade_t: new t1.Uniform1f(e1, i.u_fade_t),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity),
                    u_image0: new t1.Uniform1i(e1, i.u_image0),
                    u_image1: new t1.Uniform1i(e1, i.u_image1),
                    u_brightness_low: new t1.Uniform1f(e1, i.u_brightness_low),
                    u_brightness_high: new t1.Uniform1f(e1, i.u_brightness_high),
                    u_saturation_factor: new t1.Uniform1f(e1, i.u_saturation_factor),
                    u_contrast_factor: new t1.Uniform1f(e1, i.u_contrast_factor),
                    u_spin_weights: new t1.Uniform3f(e1, i.u_spin_weights)
                }),
            symbolIcon: (e1, i)=>({
                    u_is_size_zoom_constant: new t1.Uniform1i(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t1.Uniform1i(e1, i.u_is_size_feature_constant),
                    u_size_t: new t1.Uniform1f(e1, i.u_size_t),
                    u_size: new t1.Uniform1f(e1, i.u_size),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_pitch: new t1.Uniform1f(e1, i.u_pitch),
                    u_rotate_symbol: new t1.Uniform1i(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t1.Uniform1f(e1, i.u_aspect_ratio),
                    u_fade_change: new t1.Uniform1f(e1, i.u_fade_change),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t1.UniformMatrix4f(e1, i.u_coord_matrix),
                    u_is_text: new t1.Uniform1i(e1, i.u_is_text),
                    u_pitch_with_map: new t1.Uniform1i(e1, i.u_pitch_with_map),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_texture: new t1.Uniform1i(e1, i.u_texture)
                }),
            symbolSDF: (e1, i)=>({
                    u_is_size_zoom_constant: new t1.Uniform1i(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t1.Uniform1i(e1, i.u_is_size_feature_constant),
                    u_size_t: new t1.Uniform1f(e1, i.u_size_t),
                    u_size: new t1.Uniform1f(e1, i.u_size),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_pitch: new t1.Uniform1f(e1, i.u_pitch),
                    u_rotate_symbol: new t1.Uniform1i(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t1.Uniform1f(e1, i.u_aspect_ratio),
                    u_fade_change: new t1.Uniform1f(e1, i.u_fade_change),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t1.UniformMatrix4f(e1, i.u_coord_matrix),
                    u_is_text: new t1.Uniform1i(e1, i.u_is_text),
                    u_pitch_with_map: new t1.Uniform1i(e1, i.u_pitch_with_map),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_texture: new t1.Uniform1i(e1, i.u_texture),
                    u_gamma_scale: new t1.Uniform1f(e1, i.u_gamma_scale),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_is_halo: new t1.Uniform1i(e1, i.u_is_halo)
                }),
            symbolTextAndIcon: (e1, i)=>({
                    u_is_size_zoom_constant: new t1.Uniform1i(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t1.Uniform1i(e1, i.u_is_size_feature_constant),
                    u_size_t: new t1.Uniform1f(e1, i.u_size_t),
                    u_size: new t1.Uniform1f(e1, i.u_size),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_pitch: new t1.Uniform1f(e1, i.u_pitch),
                    u_rotate_symbol: new t1.Uniform1i(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t1.Uniform1f(e1, i.u_aspect_ratio),
                    u_fade_change: new t1.Uniform1f(e1, i.u_fade_change),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t1.UniformMatrix4f(e1, i.u_coord_matrix),
                    u_is_text: new t1.Uniform1i(e1, i.u_is_text),
                    u_pitch_with_map: new t1.Uniform1i(e1, i.u_pitch_with_map),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_texsize_icon: new t1.Uniform2f(e1, i.u_texsize_icon),
                    u_texture: new t1.Uniform1i(e1, i.u_texture),
                    u_texture_icon: new t1.Uniform1i(e1, i.u_texture_icon),
                    u_gamma_scale: new t1.Uniform1f(e1, i.u_gamma_scale),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_is_halo: new t1.Uniform1i(e1, i.u_is_halo)
                }),
            background: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity),
                    u_color: new t1.UniformColor(e1, i.u_color)
                }),
            backgroundPattern: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_pattern_tl_a: new t1.Uniform2f(e1, i.u_pattern_tl_a),
                    u_pattern_br_a: new t1.Uniform2f(e1, i.u_pattern_br_a),
                    u_pattern_tl_b: new t1.Uniform2f(e1, i.u_pattern_tl_b),
                    u_pattern_br_b: new t1.Uniform2f(e1, i.u_pattern_br_b),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_mix: new t1.Uniform1f(e1, i.u_mix),
                    u_pattern_size_a: new t1.Uniform2f(e1, i.u_pattern_size_a),
                    u_pattern_size_b: new t1.Uniform2f(e1, i.u_pattern_size_b),
                    u_scale_a: new t1.Uniform1f(e1, i.u_scale_a),
                    u_scale_b: new t1.Uniform1f(e1, i.u_scale_b),
                    u_pixel_coord_upper: new t1.Uniform2f(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t1.Uniform2f(e1, i.u_pixel_coord_lower),
                    u_tile_units_to_pixels: new t1.Uniform1f(e1, i.u_tile_units_to_pixels)
                }),
            terrain: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_texture: new t1.Uniform1i(e1, i.u_texture)
                }),
            terrainDepth: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                }),
            terrainCoords: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_texture: new t1.Uniform1i(e1, i.u_texture),
                    u_terrain_coords_id: new t1.Uniform1f(e1, i.u_terrain_coords_id)
                })
        };
        class ke {
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(t1) {
                const e1 = this.context.gl;
                if (!this.dynamicDraw) throw new Error("Attempted to update data while not in dynamic mode.");
                this.context.unbindVAO(), this.bind(), e1.bufferSubData(e1.ELEMENT_ARRAY_BUFFER, 0, t1.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
            constructor(t1, e1, i){
                this.context = t1;
                const o = t1.gl;
                this.buffer = o.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), t1.bindElementBuffer.set(this.buffer), o.bufferData(o.ELEMENT_ARRAY_BUFFER, e1.arrayBuffer, this.dynamicDraw ? o.DYNAMIC_DRAW : o.STATIC_DRAW), this.dynamicDraw || delete e1.arrayBuffer;
            }
        }
        const Be = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class Fe {
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(t1) {
                if (t1.length !== this.length) throw new Error(`Length of new data is ${t1.length}, which doesn't match current length of ${this.length}`);
                const e1 = this.context.gl;
                this.bind(), e1.bufferSubData(e1.ARRAY_BUFFER, 0, t1.arrayBuffer);
            }
            enableAttributes(t1, e1) {
                for(let i = 0; i < this.attributes.length; i++){
                    const o = e1.attributes[this.attributes[i].name];
                    void 0 !== o && t1.enableVertexAttribArray(o);
                }
            }
            setVertexAttribPointers(t1, e1, i) {
                for(let o = 0; o < this.attributes.length; o++){
                    const a = this.attributes[o], r = e1.attributes[a.name];
                    void 0 !== r && t1.vertexAttribPointer(r, a.components, t1[Be[a.type]], !1, this.itemSize, a.offset + this.itemSize * (i || 0));
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
            constructor(t1, e1, i, o){
                this.length = e1.length, this.attributes = i, this.itemSize = e1.bytesPerElement, this.dynamicDraw = o, this.context = t1;
                const a = t1.gl;
                this.buffer = a.createBuffer(), t1.bindVertexBuffer.set(this.buffer), a.bufferData(a.ARRAY_BUFFER, e1.arrayBuffer, this.dynamicDraw ? a.DYNAMIC_DRAW : a.STATIC_DRAW), this.dynamicDraw || delete e1.arrayBuffer;
            }
        }
        class Oe {
            get() {
                return this.current;
            }
            set(t1) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
            constructor(t1){
                this.gl = t1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
        }
        class Ue extends Oe {
            getDefault() {
                return t1.Color.transparent;
            }
            set(t1) {
                const e1 = this.current;
                (t1.r !== e1.r || t1.g !== e1.g || t1.b !== e1.b || t1.a !== e1.a || this.dirty) && (this.gl.clearColor(t1.r, t1.g, t1.b, t1.a), this.current = t1, this.dirty = !1);
            }
        }
        class Ne extends Oe {
            getDefault() {
                return 1;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.clearDepth(t1), this.current = t1, this.dirty = !1);
            }
        }
        class Ge extends Oe {
            getDefault() {
                return 0;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.clearStencil(t1), this.current = t1, this.dirty = !1);
            }
        }
        class Ze extends Oe {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(t1) {
                const e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || t1[3] !== e1[3] || this.dirty) && (this.gl.colorMask(t1[0], t1[1], t1[2], t1[3]), this.current = t1, this.dirty = !1);
            }
        }
        class Ve extends Oe {
            getDefault() {
                return !0;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.depthMask(t1), this.current = t1, this.dirty = !1);
            }
        }
        class qe extends Oe {
            getDefault() {
                return 255;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.stencilMask(t1), this.current = t1, this.dirty = !1);
            }
        }
        class je extends Oe {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(t1) {
                const e1 = this.current;
                (t1.func !== e1.func || t1.ref !== e1.ref || t1.mask !== e1.mask || this.dirty) && (this.gl.stencilFunc(t1.func, t1.ref, t1.mask), this.current = t1, this.dirty = !1);
            }
        }
        class $e extends Oe {
            getDefault() {
                const t1 = this.gl;
                return [
                    t1.KEEP,
                    t1.KEEP,
                    t1.KEEP
                ];
            }
            set(t1) {
                const e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || this.dirty) && (this.gl.stencilOp(t1[0], t1[1], t1[2]), this.current = t1, this.dirty = !1);
            }
        }
        class Xe extends Oe {
            getDefault() {
                return !1;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                t1 ? e1.enable(e1.STENCIL_TEST) : e1.disable(e1.STENCIL_TEST), this.current = t1, this.dirty = !1;
            }
        }
        class We extends Oe {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(t1) {
                const e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || this.dirty) && (this.gl.depthRange(t1[0], t1[1]), this.current = t1, this.dirty = !1);
            }
        }
        class He extends Oe {
            getDefault() {
                return !1;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                t1 ? e1.enable(e1.DEPTH_TEST) : e1.disable(e1.DEPTH_TEST), this.current = t1, this.dirty = !1;
            }
        }
        class Ke extends Oe {
            getDefault() {
                return this.gl.LESS;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.depthFunc(t1), this.current = t1, this.dirty = !1);
            }
        }
        class Ye extends Oe {
            getDefault() {
                return !1;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                t1 ? e1.enable(e1.BLEND) : e1.disable(e1.BLEND), this.current = t1, this.dirty = !1;
            }
        }
        class Je extends Oe {
            getDefault() {
                const t1 = this.gl;
                return [
                    t1.ONE,
                    t1.ZERO
                ];
            }
            set(t1) {
                const e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || this.dirty) && (this.gl.blendFunc(t1[0], t1[1]), this.current = t1, this.dirty = !1);
            }
        }
        class Qe extends Oe {
            getDefault() {
                return t1.Color.transparent;
            }
            set(t1) {
                const e1 = this.current;
                (t1.r !== e1.r || t1.g !== e1.g || t1.b !== e1.b || t1.a !== e1.a || this.dirty) && (this.gl.blendColor(t1.r, t1.g, t1.b, t1.a), this.current = t1, this.dirty = !1);
            }
        }
        class ti extends Oe {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.blendEquation(t1), this.current = t1, this.dirty = !1);
            }
        }
        class ei extends Oe {
            getDefault() {
                return !1;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                t1 ? e1.enable(e1.CULL_FACE) : e1.disable(e1.CULL_FACE), this.current = t1, this.dirty = !1;
            }
        }
        class ii extends Oe {
            getDefault() {
                return this.gl.BACK;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.cullFace(t1), this.current = t1, this.dirty = !1);
            }
        }
        class oi extends Oe {
            getDefault() {
                return this.gl.CCW;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.frontFace(t1), this.current = t1, this.dirty = !1);
            }
        }
        class ai extends Oe {
            getDefault() {
                return null;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.useProgram(t1), this.current = t1, this.dirty = !1);
            }
        }
        class ri extends Oe {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.activeTexture(t1), this.current = t1, this.dirty = !1);
            }
        }
        class si extends Oe {
            getDefault() {
                const t1 = this.gl;
                return [
                    0,
                    0,
                    t1.drawingBufferWidth,
                    t1.drawingBufferHeight
                ];
            }
            set(t1) {
                const e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || t1[3] !== e1[3] || this.dirty) && (this.gl.viewport(t1[0], t1[1], t1[2], t1[3]), this.current = t1, this.dirty = !1);
            }
        }
        class ni extends Oe {
            getDefault() {
                return null;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                e1.bindFramebuffer(e1.FRAMEBUFFER, t1), this.current = t1, this.dirty = !1;
            }
        }
        class li extends Oe {
            getDefault() {
                return null;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                e1.bindRenderbuffer(e1.RENDERBUFFER, t1), this.current = t1, this.dirty = !1;
            }
        }
        class ci extends Oe {
            getDefault() {
                return null;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                e1.bindTexture(e1.TEXTURE_2D, t1), this.current = t1, this.dirty = !1;
            }
        }
        class hi extends Oe {
            getDefault() {
                return null;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                e1.bindBuffer(e1.ARRAY_BUFFER, t1), this.current = t1, this.dirty = !1;
            }
        }
        class ui extends Oe {
            getDefault() {
                return null;
            }
            set(t1) {
                const e1 = this.gl;
                e1.bindBuffer(e1.ELEMENT_ARRAY_BUFFER, t1), this.current = t1, this.dirty = !1;
            }
        }
        class di extends Oe {
            getDefault() {
                return null;
            }
            set(t1) {
                this.vao && (t1 !== this.current || this.dirty) && (this.vao.bindVertexArrayOES(t1), this.current = t1, this.dirty = !1);
            }
            constructor(t1){
                super(t1), this.vao = t1.extVertexArrayObject;
            }
        }
        class mi extends Oe {
            getDefault() {
                return 4;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                e1.pixelStorei(e1.UNPACK_ALIGNMENT, t1), this.current = t1, this.dirty = !1;
            }
        }
        class _i extends Oe {
            getDefault() {
                return !1;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                e1.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t1), this.current = t1, this.dirty = !1;
            }
        }
        class pi extends Oe {
            getDefault() {
                return !1;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                e1.pixelStorei(e1.UNPACK_FLIP_Y_WEBGL, t1), this.current = t1, this.dirty = !1;
            }
        }
        class fi extends Oe {
            getDefault() {
                return null;
            }
            constructor(t1, e1){
                super(t1), this.context = t1, this.parent = e1;
            }
        }
        class gi extends fi {
            setDirty() {
                this.dirty = !0;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const e1 = this.gl;
                e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, t1, 0), this.current = t1, this.dirty = !1;
            }
        }
        class xi extends fi {
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const e1 = this.gl;
                e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.DEPTH_ATTACHMENT, e1.RENDERBUFFER, t1), this.current = t1, this.dirty = !1;
            }
        }
        class vi {
            destroy() {
                const t1 = this.context.gl, e1 = this.colorAttachment.get();
                if (e1 && t1.deleteTexture(e1), this.depthAttachment) {
                    const e1 = this.depthAttachment.get();
                    e1 && t1.deleteRenderbuffer(e1);
                }
                t1.deleteFramebuffer(this.framebuffer);
            }
            constructor(t1, e1, i, o){
                this.context = t1, this.width = e1, this.height = i;
                const a = t1.gl, r = this.framebuffer = a.createFramebuffer();
                if (this.colorAttachment = new gi(t1, r), o && (this.depthAttachment = new xi(t1, r)), a.checkFramebufferStatus(a.FRAMEBUFFER) !== a.FRAMEBUFFER_COMPLETE) throw new Error("Framebuffer is not complete");
            }
        }
        class yi {
            constructor(t1, e1, i){
                this.blendFunction = t1, this.blendColor = e1, this.mask = i;
            }
        }
        yi.Replace = [
            1,
            0
        ], yi.disabled = new yi(yi.Replace, t1.Color.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), yi.unblended = new yi(yi.Replace, t1.Color.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), yi.alphaBlended = new yi([
            1,
            771
        ], t1.Color.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        class bi {
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.extVertexArrayObject && (this.bindVertexArrayOES.dirty = !0), this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(t1, e1) {
                return new ke(this, t1, e1);
            }
            createVertexBuffer(t1, e1, i) {
                return new Fe(this, t1, e1, i);
            }
            createRenderbuffer(t1, e1, i) {
                const o = this.gl, a = o.createRenderbuffer();
                return this.bindRenderbuffer.set(a), o.renderbufferStorage(o.RENDERBUFFER, t1, e1, i), this.bindRenderbuffer.set(null), a;
            }
            createFramebuffer(t1, e1, i) {
                return new vi(this, t1, e1, i);
            }
            clear({ color: t1, depth: e1 }) {
                const i = this.gl;
                let o = 0;
                t1 && (o |= i.COLOR_BUFFER_BIT, this.clearColor.set(t1), this.colorMask.set([
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== e1 && (o |= i.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(e1), this.depthMask.set(!0)), i.clear(o);
            }
            setCullFace(t1) {
                !1 === t1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(t1.mode), this.frontFace.set(t1.frontFace));
            }
            setDepthMode(t1) {
                t1.func !== this.gl.ALWAYS || t1.mask ? (this.depthTest.set(!0), this.depthFunc.set(t1.func), this.depthMask.set(t1.mask), this.depthRange.set(t1.range)) : this.depthTest.set(!1);
            }
            setStencilMode(t1) {
                t1.test.func !== this.gl.ALWAYS || t1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(t1.mask), this.stencilOp.set([
                    t1.fail,
                    t1.depthFail,
                    t1.pass
                ]), this.stencilFunc.set({
                    func: t1.test.func,
                    ref: t1.ref,
                    mask: t1.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(t1) {
                a(t1.blendFunction, yi.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(t1.blendFunction), this.blendColor.set(t1.blendColor)), this.colorMask.set(t1.mask);
            }
            unbindVAO() {
                this.extVertexArrayObject && this.bindVertexArrayOES.set(null);
            }
            constructor(t1){
                this.gl = t1, this.extVertexArrayObject = this.gl.getExtension("OES_vertex_array_object"), this.clearColor = new Ue(this), this.clearDepth = new Ne(this), this.clearStencil = new Ge(this), this.colorMask = new Ze(this), this.depthMask = new Ve(this), this.stencilMask = new qe(this), this.stencilFunc = new je(this), this.stencilOp = new $e(this), this.stencilTest = new Xe(this), this.depthRange = new We(this), this.depthTest = new He(this), this.depthFunc = new Ke(this), this.blend = new Ye(this), this.blendFunc = new Je(this), this.blendColor = new Qe(this), this.blendEquation = new ti(this), this.cullFace = new ei(this), this.cullFaceSide = new ii(this), this.frontFace = new oi(this), this.program = new ai(this), this.activeTexture = new ri(this), this.viewport = new si(this), this.bindFramebuffer = new ni(this), this.bindRenderbuffer = new li(this), this.bindTexture = new ci(this), this.bindVertexBuffer = new hi(this), this.bindElementBuffer = new ui(this), this.bindVertexArrayOES = this.extVertexArrayObject && new di(this), this.pixelStoreUnpack = new mi(this), this.pixelStoreUnpackPremultiplyAlpha = new _i(this), this.pixelStoreUnpackFlipY = new pi(this), this.extTextureFilterAnisotropic = t1.getExtension("EXT_texture_filter_anisotropic") || t1.getExtension("MOZ_EXT_texture_filter_anisotropic") || t1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = t1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.extTextureHalfFloat = t1.getExtension("OES_texture_half_float"), this.extTextureHalfFloat && (t1.getExtension("OES_texture_half_float_linear"), this.extRenderToTextureHalfFloat = t1.getExtension("EXT_color_buffer_half_float")), this.extTimerQuery = t1.getExtension("EXT_disjoint_timer_query"), this.maxTextureSize = t1.getParameter(t1.MAX_TEXTURE_SIZE);
            }
        }
        class wi {
            constructor(t1, e1, i){
                this.func = t1, this.mask = e1, this.range = i;
            }
        }
        wi.ReadOnly = !1, wi.ReadWrite = !0, wi.disabled = new wi(519, wi.ReadOnly, [
            0,
            1
        ]);
        const Ti = 7680;
        class Ei {
            constructor(t1, e1, i, o, a, r){
                this.test = t1, this.ref = e1, this.mask = i, this.fail = o, this.depthFail = a, this.pass = r;
            }
        }
        Ei.disabled = new Ei({
            func: 519,
            mask: 0
        }, 0, 0, Ti, Ti, Ti);
        class Ii {
            constructor(t1, e1, i){
                this.enable = t1, this.mode = e1, this.frontFace = i;
            }
        }
        let Ci;
        function Si(e1, i, o, a, r, s, n) {
            const l = e1.context, c = l.gl, h = e1.useProgram("collisionBox"), u = [];
            let d = 0, m = 0;
            for(let _ = 0; _ < a.length; _++){
                const p = a[_], f = i.getTile(p), g = f.getBucket(o);
                if (!g) continue;
                let x = p.posMatrix;
                0 === r[0] && 0 === r[1] || (x = e1.translatePosMatrix(p.posMatrix, f, r, s));
                const v = n ? g.textCollisionBox : g.iconCollisionBox, y = g.collisionCircleArray;
                if (y.length > 0) {
                    const i = t1.create(), o = x;
                    t1.mul(i, g.placementInvProjMatrix, e1.transform.glCoordMatrix), t1.mul(i, i, g.placementViewportMatrix), u.push({
                        circleArray: y,
                        circleOffset: m,
                        transform: o,
                        invTransform: i,
                        coord: p
                    }), d += y.length / 4, m = d;
                }
                v && h.draw(l, c.LINES, wi.disabled, Ei.disabled, e1.colorModeForRenderPass(), Ii.disabled, fe(x, e1.transform, f), e1.style.terrain && e1.style.terrain.getTerrainData(p), o.id, v.layoutVertexBuffer, v.indexBuffer, v.segments, null, e1.transform.zoom, null, null, v.collisionVertexBuffer);
            }
            if (!n || !u.length) return;
            const _ = e1.useProgram("collisionCircle"), p = new t1.CollisionCircleLayoutArray;
            p.resize(4 * d), p._trim();
            let f = 0;
            for (const t1 of u)for(let e1 = 0; e1 < t1.circleArray.length / 4; e1++){
                const i = 4 * e1, o = t1.circleArray[i + 0], a = t1.circleArray[i + 1], r = t1.circleArray[i + 2], s = t1.circleArray[i + 3];
                p.emplace(f++, o, a, r, s, 0), p.emplace(f++, o, a, r, s, 1), p.emplace(f++, o, a, r, s, 2), p.emplace(f++, o, a, r, s, 3);
            }
            (!Ci || Ci.length < 2 * d) && (Ci = function(e1) {
                const i = 2 * e1, o = new t1.QuadTriangleArray;
                o.resize(i), o._trim();
                for(let t1 = 0; t1 < i; t1++){
                    const e1 = 6 * t1;
                    o.uint16[e1 + 0] = 4 * t1 + 0, o.uint16[e1 + 1] = 4 * t1 + 1, o.uint16[e1 + 2] = 4 * t1 + 2, o.uint16[e1 + 3] = 4 * t1 + 2, o.uint16[e1 + 4] = 4 * t1 + 3, o.uint16[e1 + 5] = 4 * t1 + 0;
                }
                return o;
            }(d));
            const g = l.createIndexBuffer(Ci, !0), x = l.createVertexBuffer(p, t1.collisionCircleLayout.members, !0);
            for (const i of u){
                const a = {
                    u_matrix: i.transform,
                    u_inv_matrix: i.invTransform,
                    u_camera_to_center_distance: (v = e1.transform).cameraToCenterDistance,
                    u_viewport_size: [
                        v.width,
                        v.height
                    ]
                };
                _.draw(l, c.TRIANGLES, wi.disabled, Ei.disabled, e1.colorModeForRenderPass(), Ii.disabled, a, e1.style.terrain && e1.style.terrain.getTerrainData(i.coord), o.id, x, g, t1.SegmentVector.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, e1.transform.zoom, null, null, null);
            }
            var v;
            x.destroy(), g.destroy();
        }
        Ii.disabled = new Ii(!1, 1029, 2305), Ii.backCCW = new Ii(!0, 1029, 2305);
        const Di = t1.identity(new Float32Array(16));
        function zi(e1, i, o, a, r, s) {
            const { horizontalAlign: n, verticalAlign: l } = t1.getAnchorAlignment(e1), c = -(n - .5) * i, h = -(l - .5) * o, u = t1.evaluateVariableOffset(e1, a);
            return new t1.pointGeometry((c / r + u[0]) * s, (h / r + u[1]) * s);
        }
        function Pi(e1, i, o, a, r, s, n, l, c, h, u) {
            const d = e1.text.placedSymbolArray, m = e1.text.dynamicLayoutVertexArray, _ = e1.icon.dynamicLayoutVertexArray, p = {};
            m.clear();
            for(let _ = 0; _ < d.length; _++){
                const f = d.get(_), g = e1.allowVerticalPlacement && !f.placedOrientation, x = f.hidden || !f.crossTileID || g ? null : a[f.crossTileID];
                if (x) {
                    const a = new t1.pointGeometry(f.anchorX, f.anchorY), d = nt(a, o ? n : s, u), _ = lt(r.cameraToCenterDistance, d.signedDistanceFromCamera);
                    let g = t1.evaluateSizeForFeature(e1.textSizeData, c, f) * _ / t1.ONE_EM;
                    o && (g *= e1.tilePixelRatio / l);
                    const { width: v, height: y, anchor: b, textOffset: w, textBoxScale: T } = x, E = zi(b, v, y, w, T, g), I = o ? nt(a.add(E), s, u).point : d.point.add(i ? E.rotate(-r.angle) : E), C = e1.allowVerticalPlacement && f.placedOrientation === t1.WritingMode.vertical ? Math.PI / 2 : 0;
                    for(let e1 = 0; e1 < f.numGlyphs; e1++)t1.addDynamicAttributes(m, I, C);
                    h && f.associatedIconIndex >= 0 && (p[f.associatedIconIndex] = {
                        shiftedAnchor: I,
                        angle: C
                    });
                } else gt(f.numGlyphs, m);
            }
            if (h) {
                _.clear();
                const i = e1.icon.placedSymbolArray;
                for(let e1 = 0; e1 < i.length; e1++){
                    const o = i.get(e1);
                    if (o.hidden) gt(o.numGlyphs, _);
                    else {
                        const i = p[e1];
                        if (i) for(let e1 = 0; e1 < o.numGlyphs; e1++)t1.addDynamicAttributes(_, i.shiftedAnchor, i.angle);
                        else gt(o.numGlyphs, _);
                    }
                }
                e1.icon.dynamicLayoutVertexBuffer.updateData(_);
            }
            e1.text.dynamicLayoutVertexBuffer.updateData(m);
        }
        function Mi(t1, e1, i) {
            return i.iconsInText && e1 ? "symbolTextAndIcon" : t1 ? "symbolSDF" : "symbolIcon";
        }
        function Ai(e1, i, o, a, r, s, n, l, c, h, u, d) {
            const m = e1.context, _ = m.gl, p = e1.transform, f = "map" === l, g = "map" === c, x = "viewport" !== l && "point" !== o.layout.get("symbol-placement"), v = f && !g && !x, y = !o.layout.get("symbol-sort-key").isConstant();
            let b = !1;
            const w = e1.depthModeForSublayer(0, wi.ReadOnly), T = o.layout.get("text-variable-anchor"), E = [];
            for (const l of a){
                const a = i.getTile(l), c = a.getBucket(o);
                if (!c) continue;
                const u = r ? c.text : c.icon;
                if (!u || !u.segments.get().length) continue;
                const d = u.programConfigurations.get(o.id), m = r || c.sdfIcons, w = r ? c.textSizeData : c.iconSizeData, I = g || 0 !== p.pitch, C = e1.useProgram(Mi(m, r, c), d), S = t1.evaluateSizeForZoom(w, p.zoom), D = e1.style.terrain && e1.style.terrain.getTerrainData(l);
                let z, P, M, A, L = [
                    0,
                    0
                ], R = null;
                if (r) {
                    if (P = a.glyphAtlasTexture, M = _.LINEAR, z = a.glyphAtlasTexture.size, c.iconsInText) {
                        L = a.imageAtlasTexture.size, R = a.imageAtlasTexture;
                        const t1 = "composite" === w.kind || "camera" === w.kind;
                        A = I || e1.options.rotating || e1.options.zooming || t1 ? _.LINEAR : _.NEAREST;
                    }
                } else {
                    const t1 = 1 !== o.layout.get("icon-size").constantOr(0) || c.iconsNeedLinear;
                    P = a.imageAtlasTexture, M = m || e1.options.rotating || e1.options.zooming || t1 || I ? _.LINEAR : _.NEAREST, z = a.imageAtlasTexture.size;
                }
                const k = bt(a, 1, e1.transform.zoom), B = rt(l.posMatrix, g, f, e1.transform, k), F = st(l.posMatrix, g, f, e1.transform, k), O = T && c.hasTextData(), U = "none" !== o.layout.get("icon-text-fit") && O && c.hasIconData();
                if (x) {
                    const t1 = e1.style.terrain ? (t1, i)=>e1.style.terrain.getElevation(l, t1, i) : null, i = "map" === o.layout.get("text-rotation-alignment");
                    ht(c, l.posMatrix, e1, r, B, F, g, h, i, t1);
                }
                const N = e1.translatePosMatrix(l.posMatrix, a, s, n), G = x || r && T || U ? Di : B, Z = e1.translatePosMatrix(F, a, s, n, !0), V = m && 0 !== o.paint.get(r ? "text-halo-width" : "icon-halo-width").constantOr(1);
                let q;
                q = m ? c.iconsInText ? Me(w.kind, S, v, g, e1, N, G, Z, z, L) : Pe(w.kind, S, v, g, e1, N, G, Z, r, z, !0) : ze(w.kind, S, v, g, e1, N, G, Z, r, z);
                const j = {
                    program: C,
                    buffers: u,
                    uniformValues: q,
                    atlasTexture: P,
                    atlasTextureIcon: R,
                    atlasInterpolation: M,
                    atlasInterpolationIcon: A,
                    isSDF: m,
                    hasHalo: V
                };
                if (y && c.canOverlap) {
                    b = !0;
                    const e1 = u.segments.get();
                    for (const i of e1)E.push({
                        segments: new t1.SegmentVector([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: j,
                        terrainData: D
                    });
                } else E.push({
                    segments: u.segments,
                    sortKey: 0,
                    state: j,
                    terrainData: D
                });
            }
            b && E.sort((t1, e1)=>t1.sortKey - e1.sortKey);
            for (const t1 of E){
                const i = t1.state;
                if (m.activeTexture.set(_.TEXTURE0), i.atlasTexture.bind(i.atlasInterpolation, _.CLAMP_TO_EDGE), i.atlasTextureIcon && (m.activeTexture.set(_.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, _.CLAMP_TO_EDGE)), i.isSDF) {
                    const a = i.uniformValues;
                    i.hasHalo && (a.u_is_halo = 1, Li(i.buffers, t1.segments, o, e1, i.program, w, u, d, a, t1.terrainData)), a.u_is_halo = 0;
                }
                Li(i.buffers, t1.segments, o, e1, i.program, w, u, d, i.uniformValues, t1.terrainData);
            }
        }
        function Li(t1, e1, i, o, a, r, s, n, l, c) {
            const h = o.context;
            a.draw(h, h.gl.TRIANGLES, r, s, n, Ii.disabled, l, c, i.id, t1.layoutVertexBuffer, t1.indexBuffer, e1, i.paint, o.transform.zoom, t1.programConfigurations.get(i.id), t1.dynamicLayoutVertexBuffer, t1.opacityVertexBuffer);
        }
        function Ri(t1, e1, i, o, a, r, s) {
            const n = t1.context.gl, l = i.paint.get("fill-pattern"), c = l && l.constantOr(1), h = i.getCrossfadeParameters();
            let u, d, m, _, p;
            s ? (d = c && !i.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", u = n.LINES) : (d = c ? "fillPattern" : "fill", u = n.TRIANGLES);
            for (const f of o){
                const o = e1.getTile(f);
                if (c && !o.patternsLoaded()) continue;
                const g = o.getBucket(i);
                if (!g) continue;
                const x = g.programConfigurations.get(i.id), v = t1.useProgram(d, x), y = t1.style.terrain && t1.style.terrain.getTerrainData(f);
                c && (t1.context.activeTexture.set(n.TEXTURE0), o.imageAtlasTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE), x.updatePaintBuffers(h));
                const b = l.constantOr(null);
                if (b && o.imageAtlas) {
                    const t1 = o.imageAtlas, e1 = t1.patternPositions[b.to.toString()], i = t1.patternPositions[b.from.toString()];
                    e1 && i && x.setConstantPatternPositions(e1, i);
                }
                const w = y ? f : null, T = t1.translatePosMatrix(w ? w.posMatrix : f.posMatrix, o, i.paint.get("fill-translate"), i.paint.get("fill-translate-anchor"));
                if (s) {
                    _ = g.indexBuffer2, p = g.segments2;
                    const e1 = [
                        n.drawingBufferWidth,
                        n.drawingBufferHeight
                    ];
                    m = "fillOutlinePattern" === d && c ? _e(T, t1, h, o, e1) : me(T, e1);
                } else _ = g.indexBuffer, p = g.segments, m = c ? de(T, t1, h, o) : ue(T);
                v.draw(t1.context, u, a, t1.stencilModeForClipping(f), r, Ii.disabled, m, y, i.id, g.layoutVertexBuffer, _, p, i.paint, t1.transform.zoom, x);
            }
        }
        function ki(t1, e1, i, o, a, r, s) {
            const n = t1.context, l = n.gl, c = i.paint.get("fill-extrusion-pattern"), h = c.constantOr(1), u = i.getCrossfadeParameters(), d = i.paint.get("fill-extrusion-opacity");
            for (const m of o){
                const o = e1.getTile(m), _ = o.getBucket(i);
                if (!_) continue;
                const p = t1.style.terrain && t1.style.terrain.getTerrainData(m), f = _.programConfigurations.get(i.id), g = t1.useProgram(h ? "fillExtrusionPattern" : "fillExtrusion", f);
                h && (t1.context.activeTexture.set(l.TEXTURE0), o.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), f.updatePaintBuffers(u));
                const x = c.constantOr(null);
                if (x && o.imageAtlas) {
                    const t1 = o.imageAtlas, e1 = t1.patternPositions[x.to.toString()], i = t1.patternPositions[x.from.toString()];
                    e1 && i && f.setConstantPatternPositions(e1, i);
                }
                const v = t1.translatePosMatrix(m.posMatrix, o, i.paint.get("fill-extrusion-translate"), i.paint.get("fill-extrusion-translate-anchor")), y = i.paint.get("fill-extrusion-vertical-gradient"), b = h ? he(v, t1, y, d, m, u, o) : ce(v, t1, y, d);
                g.draw(n, n.gl.TRIANGLES, a, r, s, Ii.backCCW, b, p, i.id, _.layoutVertexBuffer, _.indexBuffer, _.segments, i.paint, t1.transform.zoom, f, t1.style.terrain && _.centroidVertexBuffer);
            }
        }
        function Bi(t1, e1, i, o, a, r, s) {
            const n = t1.context, l = n.gl, c = i.fbo;
            if (!c) return;
            const h = t1.useProgram("hillshade"), u = t1.style.terrain && t1.style.terrain.getTerrainData(e1);
            n.activeTexture.set(l.TEXTURE0), l.bindTexture(l.TEXTURE_2D, c.colorAttachment.get()), h.draw(n, l.TRIANGLES, a, r, s, Ii.disabled, ((t1, e1, i, o)=>{
                const a = i.paint.get("hillshade-shadow-color"), r = i.paint.get("hillshade-highlight-color"), s = i.paint.get("hillshade-accent-color");
                let n = i.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
                "viewport" === i.paint.get("hillshade-illumination-anchor") && (n -= t1.transform.angle);
                const l = !t1.options.moving;
                return {
                    u_matrix: o ? o.posMatrix : t1.transform.calculatePosMatrix(e1.tileID.toUnwrapped(), l),
                    u_image: 0,
                    u_latrange: ye(0, e1.tileID),
                    u_light: [
                        i.paint.get("hillshade-exaggeration"),
                        n
                    ],
                    u_shadow: a,
                    u_highlight: r,
                    u_accent: s
                };
            })(t1, i, o, u ? e1 : null), u, o.id, t1.rasterBoundsBuffer, t1.quadTriangleIndexBuffer, t1.rasterBoundsSegments);
        }
        function Fi(e1, i, o, a, r, s) {
            const n = e1.context, c = n.gl, h = i.dem;
            if (h && h.data) {
                const u = h.dim, d = h.stride, m = h.getPixels();
                if (n.activeTexture.set(c.TEXTURE1), n.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || e1.getTileTexture(d), i.demTexture) {
                    const t1 = i.demTexture;
                    t1.update(m, {
                        premultiply: !1
                    }), t1.bind(c.NEAREST, c.CLAMP_TO_EDGE);
                } else i.demTexture = new l(n, m, c.RGBA, {
                    premultiply: !1
                }), i.demTexture.bind(c.NEAREST, c.CLAMP_TO_EDGE);
                n.activeTexture.set(c.TEXTURE0);
                let _ = i.fbo;
                if (!_) {
                    const t1 = new l(n, {
                        width: u,
                        height: u,
                        data: null
                    }, c.RGBA);
                    t1.bind(c.LINEAR, c.CLAMP_TO_EDGE), _ = i.fbo = n.createFramebuffer(u, u, !0), _.colorAttachment.set(t1.texture);
                }
                n.bindFramebuffer.set(_.framebuffer), n.viewport.set([
                    0,
                    0,
                    u,
                    u
                ]), e1.useProgram("hillshadePrepare").draw(n, c.TRIANGLES, a, r, s, Ii.disabled, ((e1, i)=>{
                    const o = i.stride, a = t1.create();
                    return t1.ortho(a, 0, t1.EXTENT, -t1.EXTENT, 0, 0, 1), t1.translate(a, a, [
                        0,
                        -t1.EXTENT,
                        0
                    ]), {
                        u_matrix: a,
                        u_image: 1,
                        u_dimension: [
                            o,
                            o
                        ],
                        u_zoom: e1.overscaledZ,
                        u_unpack: i.getUnpackVector()
                    };
                })(i.tileID, h), null, o.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments), i.needsHillshadePrepare = !1;
            }
        }
        function Oi(e1, i, o, a, r, s) {
            const n = a.paint.get("raster-fade-duration");
            if (!s && n > 0) {
                const a = t1.exported.now(), s = (a - e1.timeAdded) / n, l = i ? (a - i.timeAdded) / n : -1, c = o.getSource(), h = r.coveringZoomLevel({
                    tileSize: c.tileSize,
                    roundZoom: c.roundZoom
                }), u = !i || Math.abs(i.tileID.overscaledZ - h) > Math.abs(e1.tileID.overscaledZ - h), d = u && e1.refreshedUponExpiration ? 1 : t1.clamp(u ? s : 1 - l, 0, 1);
                return e1.refreshedUponExpiration && s >= 1 && (e1.refreshedUponExpiration = !1), i ? {
                    opacity: 1,
                    mix: 1 - d
                } : {
                    opacity: d,
                    mix: 0
                };
            }
            return {
                opacity: 1,
                mix: 0
            };
        }
        const Ui = new t1.Color(1, 0, 0, 1), Ni = new t1.Color(0, 1, 0, 1), Gi = new t1.Color(0, 0, 1, 1), Zi = new t1.Color(1, 0, 1, 1), Vi = new t1.Color(0, 1, 1, 1);
        function qi(t1, e1, i, o) {
            $i(t1, 0, e1 + i / 2, t1.transform.width, i, o);
        }
        function ji(t1, e1, i, o) {
            $i(t1, e1 - i / 2, 0, i, t1.transform.height, o);
        }
        function $i(t1, e1, i, o, a, r) {
            const s = t1.context, n = s.gl;
            n.enable(n.SCISSOR_TEST), n.scissor(e1 * t1.pixelRatio, i * t1.pixelRatio, o * t1.pixelRatio, a * t1.pixelRatio), s.clear({
                color: r
            }), n.disable(n.SCISSOR_TEST);
        }
        function Xi(e1, i, o) {
            const a = e1.context, r = a.gl, s = o.posMatrix, n = e1.useProgram("debug"), l = wi.disabled, c = Ei.disabled, h = e1.colorModeForRenderPass(), u = "$debug", d = e1.style.terrain && e1.style.terrain.getTerrainData(o);
            a.activeTexture.set(r.TEXTURE0), e1.emptyTexture.bind(r.LINEAR, r.CLAMP_TO_EDGE);
            const m = i.getTileByID(o.key).latestRawTileData, _ = Math.floor((m && m.byteLength || 0) / 1024), p = i.getTile(o).tileSize, f = 512 / Math.min(p, 512) * (o.overscaledZ / e1.transform.zoom) * .5;
            let g = o.canonical.toString();
            o.overscaledZ !== o.canonical.z && (g += ` => ${o.overscaledZ}`), function(t1, e1) {
                t1.initDebugOverlayCanvas();
                const i = t1.debugOverlayCanvas, o = t1.context.gl, a = t1.debugOverlayCanvas.getContext("2d");
                a.clearRect(0, 0, i.width, i.height), a.shadowColor = "white", a.shadowBlur = 2, a.lineWidth = 1.5, a.strokeStyle = "white", a.textBaseline = "top", a.font = "bold 36px Open Sans, sans-serif", a.fillText(e1, 5, 5), a.strokeText(e1, 5, 5), t1.debugOverlayTexture.update(i), t1.debugOverlayTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE);
            }(e1, `${g} ${_}kB`), n.draw(a, r.TRIANGLES, l, c, yi.alphaBlended, Ii.disabled, ge(s, t1.Color.transparent, f), null, u, e1.debugBuffer, e1.quadTriangleIndexBuffer, e1.debugSegments), n.draw(a, r.LINE_STRIP, l, c, h, Ii.disabled, ge(s, t1.Color.red), d, u, e1.debugBuffer, e1.tileBorderIndexBuffer, e1.debugSegments);
        }
        function Wi(t1, e1, i) {
            const o = t1.context, a = o.gl, r = t1.colorModeForRenderPass(), s = new wi(a.LEQUAL, wi.ReadWrite, t1.depthRangeFor3D), n = t1.useProgram("terrain"), l = e1.getTerrainMesh(), c = e1.getTerrainData(i.tileID);
            o.bindFramebuffer.set(null), o.viewport.set([
                0,
                0,
                t1.width,
                t1.height
            ]), o.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, e1.getRTTFramebuffer().colorAttachment.get());
            const h = t1.transform.calculatePosMatrix(i.tileID.toUnwrapped());
            n.draw(o, a.TRIANGLES, s, Ei.disabled, r, Ii.backCCW, {
                u_matrix: h,
                u_texture: 0
            }, c, "terrain", l.vertexBuffer, l.indexBuffer, l.segments);
        }
        function Hi(t1, e1, i, o) {
            const a = t1.context, r = i.tileSize * e1.qualityFactor;
            i.textures[o] || (i.textures[o] = t1.getTileTexture(r) || new l(a, {
                width: r,
                height: r,
                data: null
            }, a.gl.RGBA), i.textures[o].bind(a.gl.LINEAR, a.gl.CLAMP_TO_EDGE), 0 === o && e1.sourceCache.renderHistory.unshift(i.tileID.key));
            const s = e1.getRTTFramebuffer();
            s.colorAttachment.set(i.textures[o].texture), a.bindFramebuffer.set(s.framebuffer), a.viewport.set([
                0,
                0,
                r,
                r
            ]);
        }
        class Ki {
            _init() {
                const t1 = this.painter.style, e1 = t1.terrain;
                for(const i in t1.sourceCaches){
                    this._coordsDescendingInv[i] = {};
                    const o = t1.sourceCaches[i].getVisibleCoordinates();
                    for (const t1 of o){
                        const o = e1.sourceCache.getTerrainCoords(t1);
                        for(const t1 in o)this._coordsDescendingInv[i][t1] || (this._coordsDescendingInv[i][t1] = []), this._coordsDescendingInv[i][t1].push(o[t1]);
                    }
                }
                for (const e1 of t1._order){
                    const i = t1._layers[e1], o = i.source;
                    if (this._renderToTexture[i.type] && !this._coordsDescendingInvStr[o]) {
                        this._coordsDescendingInvStr[o] = {};
                        for(const t1 in this._coordsDescendingInv[o])this._coordsDescendingInvStr[o][t1] = this._coordsDescendingInv[o][t1].map((t1)=>t1.key).sort().join();
                    }
                }
                return this._renderableTiles.forEach((t1)=>{
                    for(const i in this._coordsDescendingInvStr){
                        const o = this._coordsDescendingInvStr[i][t1.tileID.key];
                        o && o !== t1.textureCoords[i] && t1.clearTextures(this.painter), e1.needsRerender(i, t1.tileID) && t1.clearTextures(this.painter);
                    }
                    this._rerender[t1.tileID.key] = !t1.textures.length;
                }), e1.clearRerenderCache(), e1.sourceCache.removeOutdated(this.painter), this;
            }
            renderLayer(e1) {
                const i = e1.type, o = this.painter, a = o.style._order, r = o.currentLayer, s = r + 1 === a.length;
                if (this._renderToTexture[i] && (this._prevType && this._renderToTexture[this._prevType] || this._stacks.push([]), this._prevType = i, this._stacks[this._stacks.length - 1].push(a[r]), !s)) return !0;
                if (this._renderToTexture[this._prevType] || "hillshade" === i || this._renderToTexture[i] && s) {
                    this._prevType = i;
                    const s = this._stacks.length - 1, n = this._stacks[s] || [];
                    for (const e1 of this._renderableTiles){
                        if (Hi(o, o.style.terrain, e1, s), this._rerender[e1.tileID.key]) {
                            o.context.clear({
                                color: t1.Color.transparent
                            });
                            for(let t1 = 0; t1 < n.length; t1++){
                                const i = o.style._layers[n[t1]], a = i.source ? this._coordsDescendingInv[i.source][e1.tileID.key] : [
                                    e1.tileID
                                ];
                                o._renderTileClippingMasks(i, a), o.renderLayer(o, o.style.sourceCaches[i.source], i, a), i.source && (e1.textureCoords[i.source] = this._coordsDescendingInvStr[i.source][e1.tileID.key]);
                            }
                        }
                        Wi(o, o.style.terrain, e1);
                    }
                    if ("hillshade" === i) {
                        this._stacks.push([
                            a[r]
                        ]);
                        for (const i of this._renderableTiles){
                            const a = this._coordsDescendingInv[e1.source][i.tileID.key];
                            Hi(o, o.style.terrain, i, this._stacks.length - 1), o.context.clear({
                                color: t1.Color.transparent
                            }), o._renderTileClippingMasks(e1, a), o.renderLayer(o, o.style.sourceCaches[e1.source], e1, a), Wi(o, o.style.terrain, i);
                        }
                        return !0;
                    }
                    return this._renderToTexture[i];
                }
                return !1;
            }
            constructor(t1){
                this._coordsDescendingInv = {}, this._coordsDescendingInvStr = {}, this.painter = t1, this._renderToTexture = {
                    background: !0,
                    fill: !0,
                    line: !0,
                    raster: !0
                }, this._coordsDescendingInv = {}, this._coordsDescendingInvStr = {}, this._stacks = [], this._prevType = null, this._rerender = {}, this._renderableTiles = t1.style.terrain.sourceCache.getRenderableTiles(), this._init();
            }
        }
        const Yi = {
            symbol: function(e1, i, o, a, r) {
                if ("translucent" !== e1.renderPass) return;
                const s = Ei.disabled, n = e1.colorModeForRenderPass();
                o.layout.get("text-variable-anchor") && function(e1, i, o, a, r, s, n) {
                    const l = i.transform, c = "map" === r, h = "map" === s;
                    for (const r of e1){
                        const e1 = a.getTile(r), s = e1.getBucket(o);
                        if (!s || !s.text || !s.text.segments.get().length) continue;
                        const u = t1.evaluateSizeForZoom(s.textSizeData, l.zoom), d = bt(e1, 1, i.transform.zoom), m = rt(r.posMatrix, h, c, i.transform, d), _ = "none" !== o.layout.get("icon-text-fit") && s.hasIconData();
                        if (u) {
                            const t1 = Math.pow(2, l.zoom - e1.tileID.overscaledZ);
                            Pi(s, c, h, n, l, m, r.posMatrix, t1, u, _, i.style.terrain ? (t1, e1)=>i.style.terrain.getElevation(r, t1, e1) : null);
                        }
                    }
                }(a, e1, o, i, o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), r), 0 !== o.paint.get("icon-opacity").constantOr(1) && Ai(e1, i, o, a, !1, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), o.layout.get("icon-rotation-alignment"), o.layout.get("icon-pitch-alignment"), o.layout.get("icon-keep-upright"), s, n), 0 !== o.paint.get("text-opacity").constantOr(1) && Ai(e1, i, o, a, !0, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), o.layout.get("text-keep-upright"), s, n), i.map.showCollisionBoxes && (Si(e1, i, o, a, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), !0), Si(e1, i, o, a, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), !1));
            },
            circle: function(e1, i, o, a) {
                if ("translucent" !== e1.renderPass) return;
                const r = o.paint.get("circle-opacity"), s = o.paint.get("circle-stroke-width"), n = o.paint.get("circle-stroke-opacity"), l = !o.layout.get("circle-sort-key").isConstant();
                if (0 === r.constantOr(1) && (0 === s.constantOr(1) || 0 === n.constantOr(1))) return;
                const c = e1.context, h = c.gl, u = e1.depthModeForSublayer(0, wi.ReadOnly), d = Ei.disabled, m = e1.colorModeForRenderPass(), _ = [];
                for(let r = 0; r < a.length; r++){
                    const s = a[r], n = i.getTile(s), c = n.getBucket(o);
                    if (!c) continue;
                    const h = c.programConfigurations.get(o.id), u = e1.useProgram("circle", h), d = c.layoutVertexBuffer, m = c.indexBuffer, p = e1.style.terrain && e1.style.terrain.getTerrainData(s), f = {
                        programConfiguration: h,
                        program: u,
                        layoutVertexBuffer: d,
                        indexBuffer: m,
                        uniformValues: pe(e1, s, n, o),
                        terrainData: p
                    };
                    if (l) {
                        const e1 = c.segments.get();
                        for (const i of e1)_.push({
                            segments: new t1.SegmentVector([
                                i
                            ]),
                            sortKey: i.sortKey,
                            state: f
                        });
                    } else _.push({
                        segments: c.segments,
                        sortKey: 0,
                        state: f
                    });
                }
                l && _.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                for (const t1 of _){
                    const { programConfiguration: i, program: a, layoutVertexBuffer: r, indexBuffer: s, uniformValues: n, terrainData: l } = t1.state;
                    a.draw(c, h.TRIANGLES, u, d, m, Ii.disabled, n, l, o.id, r, s, t1.segments, o.paint, e1.transform.zoom, i);
                }
            },
            heatmap: function(e1, i, o, a) {
                if (0 !== o.paint.get("heatmap-opacity")) {
                    if ("offscreen" === e1.renderPass) {
                        const r = e1.context, s = r.gl, n = Ei.disabled, l = new yi([
                            s.ONE,
                            s.ONE
                        ], t1.Color.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        !function(t1, e1, i) {
                            const o = t1.gl;
                            t1.activeTexture.set(o.TEXTURE1), t1.viewport.set([
                                0,
                                0,
                                e1.width / 4,
                                e1.height / 4
                            ]);
                            let a = i.heatmapFbo;
                            if (a) o.bindTexture(o.TEXTURE_2D, a.colorAttachment.get()), t1.bindFramebuffer.set(a.framebuffer);
                            else {
                                const r = o.createTexture();
                                o.bindTexture(o.TEXTURE_2D, r), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, o.LINEAR), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MAG_FILTER, o.LINEAR), a = i.heatmapFbo = t1.createFramebuffer(e1.width / 4, e1.height / 4, !1), function(t1, e1, i, o) {
                                    const a = t1.gl;
                                    a.texImage2D(a.TEXTURE_2D, 0, a.RGBA, e1.width / 4, e1.height / 4, 0, a.RGBA, t1.extRenderToTextureHalfFloat ? t1.extTextureHalfFloat.HALF_FLOAT_OES : a.UNSIGNED_BYTE, null), o.colorAttachment.set(i);
                                }(t1, e1, r, a);
                            }
                        }(r, e1, o), r.clear({
                            color: t1.Color.transparent
                        });
                        for(let t1 = 0; t1 < a.length; t1++){
                            const c = a[t1];
                            if (i.hasRenderableParent(c)) continue;
                            const h = i.getTile(c), u = h.getBucket(o);
                            if (!u) continue;
                            const d = u.programConfigurations.get(o.id), m = e1.useProgram("heatmap", d), { zoom: _ } = e1.transform;
                            m.draw(r, s.TRIANGLES, wi.disabled, n, l, Ii.disabled, ve(c.posMatrix, h, _, o.paint.get("heatmap-intensity")), null, o.id, u.layoutVertexBuffer, u.indexBuffer, u.segments, o.paint, e1.transform.zoom, d);
                        }
                        r.viewport.set([
                            0,
                            0,
                            e1.width,
                            e1.height
                        ]);
                    } else "translucent" === e1.renderPass && (e1.context.setColorMode(e1.colorModeForRenderPass()), function(e1, i) {
                        const o = e1.context, a = o.gl, r = i.heatmapFbo;
                        if (!r) return;
                        o.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, r.colorAttachment.get()), o.activeTexture.set(a.TEXTURE1);
                        let s = i.colorRampTexture;
                        s || (s = i.colorRampTexture = new l(o, i.colorRamp, a.RGBA)), s.bind(a.LINEAR, a.CLAMP_TO_EDGE), e1.useProgram("heatmapTexture").draw(o, a.TRIANGLES, wi.disabled, Ei.disabled, e1.colorModeForRenderPass(), Ii.disabled, ((e1, i, o, a)=>{
                            const r = t1.create();
                            t1.ortho(r, 0, e1.width, e1.height, 0, 0, 1);
                            const s = e1.context.gl;
                            return {
                                u_matrix: r,
                                u_world: [
                                    s.drawingBufferWidth,
                                    s.drawingBufferHeight
                                ],
                                u_image: 0,
                                u_color_ramp: 1,
                                u_opacity: i.paint.get("heatmap-opacity")
                            };
                        })(e1, i), null, i.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, i.paint, e1.transform.zoom);
                    }(e1, o));
                }
            },
            line: function(e1, i, o, a) {
                if ("translucent" !== e1.renderPass) return;
                const r = o.paint.get("line-opacity"), s = o.paint.get("line-width");
                if (0 === r.constantOr(1) || 0 === s.constantOr(1)) return;
                const n = e1.depthModeForSublayer(0, wi.ReadOnly), c = e1.colorModeForRenderPass(), h = o.paint.get("line-dasharray"), u = o.paint.get("line-pattern"), d = u.constantOr(1), m = o.paint.get("line-gradient"), _ = o.getCrossfadeParameters(), p = d ? "linePattern" : h ? "lineSDF" : m ? "lineGradient" : "line", f = e1.context, g = f.gl;
                let x = !0;
                for (const r of a){
                    const a = i.getTile(r);
                    if (d && !a.patternsLoaded()) continue;
                    const s = a.getBucket(o);
                    if (!s) continue;
                    const v = s.programConfigurations.get(o.id), y = e1.context.program.get(), b = e1.useProgram(p, v), w = x || b.program !== y, T = e1.style.terrain && e1.style.terrain.getTerrainData(r), E = u.constantOr(null);
                    if (E && a.imageAtlas) {
                        const t1 = a.imageAtlas, e1 = t1.patternPositions[E.to.toString()], i = t1.patternPositions[E.from.toString()];
                        e1 && i && v.setConstantPatternPositions(e1, i);
                    }
                    const I = T ? r : null, C = d ? Te(e1, a, o, _, I) : h ? Ee(e1, a, o, h, _, I) : m ? we(e1, a, o, s.lineClipsArray.length, I) : be(e1, a, o, I);
                    if (d) f.activeTexture.set(g.TEXTURE0), a.imageAtlasTexture.bind(g.LINEAR, g.CLAMP_TO_EDGE), v.updatePaintBuffers(_);
                    else if (h && (w || e1.lineAtlas.dirty)) f.activeTexture.set(g.TEXTURE0), e1.lineAtlas.bind(f);
                    else if (m) {
                        const a = s.gradients[o.id];
                        let n = a.texture;
                        if (o.gradientVersion !== a.version) {
                            let c = 256;
                            if (o.stepInterpolant) {
                                const o = i.getSource().maxzoom, a = r.canonical.z === o ? Math.ceil(1 << e1.transform.maxZoom - r.canonical.z) : 1;
                                c = t1.clamp(t1.nextPowerOfTwo(s.maxLineLength / t1.EXTENT * 1024 * a), 256, f.maxTextureSize);
                            }
                            a.gradient = t1.renderColorRamp({
                                expression: o.gradientExpression(),
                                evaluationKey: "lineProgress",
                                resolution: c,
                                image: a.gradient || void 0,
                                clips: s.lineClipsArray
                            }), a.texture ? a.texture.update(a.gradient) : a.texture = new l(f, a.gradient, g.RGBA), a.version = o.gradientVersion, n = a.texture;
                        }
                        f.activeTexture.set(g.TEXTURE0), n.bind(o.stepInterpolant ? g.NEAREST : g.LINEAR, g.CLAMP_TO_EDGE);
                    }
                    b.draw(f, g.TRIANGLES, n, e1.stencilModeForClipping(r), c, Ii.disabled, C, T, o.id, s.layoutVertexBuffer, s.indexBuffer, s.segments, o.paint, e1.transform.zoom, v, s.layoutVertexBuffer2), x = !1;
                }
            },
            fill: function(e1, i, o, a) {
                const r = o.paint.get("fill-color"), s = o.paint.get("fill-opacity");
                if (0 === s.constantOr(1)) return;
                const n = e1.colorModeForRenderPass(), l = o.paint.get("fill-pattern"), c = e1.opaquePassEnabledForLayer() && !l.constantOr(1) && 1 === r.constantOr(t1.Color.transparent).a && 1 === s.constantOr(0) ? "opaque" : "translucent";
                if (e1.renderPass === c) {
                    const t1 = e1.depthModeForSublayer(1, "opaque" === e1.renderPass ? wi.ReadWrite : wi.ReadOnly);
                    Ri(e1, i, o, a, t1, n, !1);
                }
                if ("translucent" === e1.renderPass && o.paint.get("fill-antialias")) {
                    const t1 = e1.depthModeForSublayer(o.getPaintProperty("fill-outline-color") ? 2 : 0, wi.ReadOnly);
                    Ri(e1, i, o, a, t1, n, !0);
                }
            },
            "fill-extrusion": function(t1, e1, i, o) {
                const a = i.paint.get("fill-extrusion-opacity");
                if (0 !== a && "translucent" === t1.renderPass) {
                    const r = new wi(t1.context.gl.LEQUAL, wi.ReadWrite, t1.depthRangeFor3D);
                    if (1 !== a || i.paint.get("fill-extrusion-pattern").constantOr(1)) ki(t1, e1, i, o, r, Ei.disabled, yi.disabled), ki(t1, e1, i, o, r, t1.stencilModeFor3D(), t1.colorModeForRenderPass());
                    else {
                        const a = t1.colorModeForRenderPass();
                        ki(t1, e1, i, o, r, Ei.disabled, a);
                    }
                }
            },
            hillshade: function(t1, e1, i, o) {
                if ("offscreen" !== t1.renderPass && "translucent" !== t1.renderPass) return;
                const a = t1.context, r = t1.depthModeForSublayer(0, wi.ReadOnly), s = t1.colorModeForRenderPass(), [n, l] = "translucent" === t1.renderPass ? t1.stencilConfigForOverlap(o) : [
                    {},
                    o
                ];
                for (const o of l){
                    const a = e1.getTile(o);
                    void 0 !== a.needsHillshadePrepare && a.needsHillshadePrepare && "offscreen" === t1.renderPass ? Fi(t1, a, i, r, Ei.disabled, s) : "translucent" === t1.renderPass && Bi(t1, o, a, i, r, n[o.overscaledZ], s);
                }
                a.viewport.set([
                    0,
                    0,
                    t1.width,
                    t1.height
                ]);
            },
            raster: function(t1, e1, i, o) {
                if ("translucent" !== t1.renderPass) return;
                if (0 === i.paint.get("raster-opacity")) return;
                if (!o.length) return;
                const a = t1.context, r = a.gl, s = e1.getSource(), n = t1.useProgram("raster"), l = t1.colorModeForRenderPass(), [c, h] = s instanceof D ? [
                    {},
                    o
                ] : t1.stencilConfigForOverlap(o), u = h[h.length - 1].overscaledZ, d = !t1.options.moving;
                for (const o of h){
                    const h = t1.depthModeForSublayer(o.overscaledZ - u, 1 === i.paint.get("raster-opacity") ? wi.ReadWrite : wi.ReadOnly, r.LESS), m = e1.getTile(o);
                    m.registerFadeDuration(i.paint.get("raster-fade-duration"));
                    const _ = e1.findLoadedParent(o, 0), p = Oi(m, _, e1, i, t1.transform, t1.style.terrain);
                    let f, g;
                    const x = "nearest" === i.paint.get("raster-resampling") ? r.NEAREST : r.LINEAR;
                    a.activeTexture.set(r.TEXTURE0), m.texture.bind(x, r.CLAMP_TO_EDGE, r.LINEAR_MIPMAP_NEAREST), a.activeTexture.set(r.TEXTURE1), _ ? (_.texture.bind(x, r.CLAMP_TO_EDGE, r.LINEAR_MIPMAP_NEAREST), f = Math.pow(2, _.tileID.overscaledZ - m.tileID.overscaledZ), g = [
                        m.tileID.canonical.x * f % 1,
                        m.tileID.canonical.y * f % 1
                    ]) : m.texture.bind(x, r.CLAMP_TO_EDGE, r.LINEAR_MIPMAP_NEAREST);
                    const v = t1.style.terrain && t1.style.terrain.getTerrainData(o), y = v ? o : null, b = y ? y.posMatrix : t1.transform.calculatePosMatrix(o.toUnwrapped(), d), w = Se(b, g || [
                        0,
                        0
                    ], f || 1, p, i);
                    s instanceof D ? n.draw(a, r.TRIANGLES, h, Ei.disabled, l, Ii.disabled, w, v, i.id, s.boundsBuffer, t1.quadTriangleIndexBuffer, s.boundsSegments) : n.draw(a, r.TRIANGLES, h, c[o.overscaledZ], l, Ii.disabled, w, v, i.id, t1.rasterBoundsBuffer, t1.quadTriangleIndexBuffer, t1.rasterBoundsSegments);
                }
            },
            background: function(t1, e1, i, o) {
                const a = i.paint.get("background-color"), r = i.paint.get("background-opacity");
                if (0 === r) return;
                const s = t1.context, n = s.gl, l = t1.transform, c = l.tileSize, h = i.paint.get("background-pattern");
                if (t1.isPatternMissing(h)) return;
                const u = !h && 1 === a.a && 1 === r && t1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                if (t1.renderPass !== u) return;
                const d = Ei.disabled, m = t1.depthModeForSublayer(0, "opaque" === u ? wi.ReadWrite : wi.ReadOnly), _ = t1.colorModeForRenderPass(), p = t1.useProgram(h ? "backgroundPattern" : "background"), f = o || l.coveringTiles({
                    tileSize: c,
                    terrain: t1.style.terrain
                });
                h && (s.activeTexture.set(n.TEXTURE0), t1.imageManager.bind(t1.context));
                const g = i.getCrossfadeParameters();
                for (const e1 of f){
                    const l = o ? e1.posMatrix : t1.transform.calculatePosMatrix(e1.toUnwrapped()), u = h ? Le(l, r, t1, h, {
                        tileID: e1,
                        tileSize: c
                    }, g) : Ae(l, r, a), f = t1.style.terrain && t1.style.terrain.getTerrainData(e1);
                    p.draw(s, n.TRIANGLES, m, d, _, Ii.disabled, u, f, i.id, t1.tileExtentBuffer, t1.quadTriangleIndexBuffer, t1.tileExtentSegments);
                }
            },
            debug: function(t1, e1, i) {
                for(let o = 0; o < i.length; o++)Xi(t1, e1, i[o]);
            },
            custom: function(t1, e1, i) {
                const o = t1.context, a = i.implementation;
                if ("offscreen" === t1.renderPass) {
                    const e1 = a.prerender;
                    e1 && (t1.setCustomLayerDefaults(), o.setColorMode(t1.colorModeForRenderPass()), e1.call(a, o.gl, t1.transform.customLayerMatrix()), o.setDirty(), t1.setBaseState());
                } else if ("translucent" === t1.renderPass) {
                    t1.setCustomLayerDefaults(), o.setColorMode(t1.colorModeForRenderPass()), o.setStencilMode(Ei.disabled);
                    const e1 = "3d" === a.renderingMode ? new wi(t1.context.gl.LEQUAL, wi.ReadWrite, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, wi.ReadOnly);
                    o.setDepthMode(e1), a.render(o.gl, t1.transform.customLayerMatrix()), o.setDirty(), t1.setBaseState(), o.bindFramebuffer.set(null);
                }
            }
        };
        class Ji {
            resize(t1, e1, i) {
                if (this.width = t1 * i, this.height = e1 * i, this.pixelRatio = i, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const t1 of this.style._order)this.style._layers[t1].resize();
            }
            setup() {
                const e1 = this.context, i = new t1.PosArray;
                i.emplaceBack(0, 0), i.emplaceBack(t1.EXTENT, 0), i.emplaceBack(0, t1.EXTENT), i.emplaceBack(t1.EXTENT, t1.EXTENT), this.tileExtentBuffer = e1.createVertexBuffer(i, Wt.members), this.tileExtentSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
                const o = new t1.PosArray;
                o.emplaceBack(0, 0), o.emplaceBack(t1.EXTENT, 0), o.emplaceBack(0, t1.EXTENT), o.emplaceBack(t1.EXTENT, t1.EXTENT), this.debugBuffer = e1.createVertexBuffer(o, Wt.members), this.debugSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 5);
                const a = new t1.RasterBoundsArray;
                a.emplaceBack(0, 0, 0, 0), a.emplaceBack(t1.EXTENT, 0, t1.EXTENT, 0), a.emplaceBack(0, t1.EXTENT, 0, t1.EXTENT), a.emplaceBack(t1.EXTENT, t1.EXTENT, t1.EXTENT, t1.EXTENT), this.rasterBoundsBuffer = e1.createVertexBuffer(a, S.members), this.rasterBoundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
                const r = new t1.PosArray;
                r.emplaceBack(0, 0), r.emplaceBack(1, 0), r.emplaceBack(0, 1), r.emplaceBack(1, 1), this.viewportBuffer = e1.createVertexBuffer(r, Wt.members), this.viewportSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
                const s = new t1.LineStripIndexArray;
                s.emplaceBack(0), s.emplaceBack(1), s.emplaceBack(3), s.emplaceBack(2), s.emplaceBack(0), this.tileBorderIndexBuffer = e1.createIndexBuffer(s);
                const n = new t1.TriangleIndexArray;
                n.emplaceBack(0, 1, 2), n.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = e1.createIndexBuffer(n), this.emptyTexture = new l(e1, {
                    width: 1,
                    height: 1,
                    data: new Uint8Array([
                        0,
                        0,
                        0,
                        0
                    ])
                }, e1.gl.RGBA);
                const c = this.context.gl;
                this.stencilClearMode = new Ei({
                    func: c.ALWAYS,
                    mask: 0
                }, 0, 255, c.ZERO, c.ZERO, c.ZERO);
            }
            clearStencil() {
                const e1 = this.context, i = e1.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0;
                const o = t1.create();
                t1.ortho(o, 0, this.width, this.height, 0, 0, 1), t1.scale(o, o, [
                    i.drawingBufferWidth,
                    i.drawingBufferHeight,
                    0
                ]), this.useProgram("clippingMask").draw(e1, i.TRIANGLES, wi.disabled, this.stencilClearMode, yi.disabled, Ii.disabled, xe(o), null, "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            _renderTileClippingMasks(t1, e1) {
                if (this.currentStencilSource === t1.source || !t1.isTileClipped() || !e1 || !e1.length) return;
                this.currentStencilSource = t1.source;
                const i = this.context, o = i.gl;
                this.nextStencilID + e1.length > 256 && this.clearStencil(), i.setColorMode(yi.disabled), i.setDepthMode(wi.disabled);
                const a = this.useProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for (const t1 of e1){
                    const e1 = this._tileClippingMaskIDs[t1.key] = this.nextStencilID++, r = this.style.terrain && this.style.terrain.getTerrainData(t1);
                    a.draw(i, o.TRIANGLES, wi.disabled, new Ei({
                        func: o.ALWAYS,
                        mask: 0
                    }, e1, 255, o.KEEP, o.KEEP, o.REPLACE), yi.disabled, Ii.disabled, xe(t1.posMatrix), r, "$clipping", this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const t1 = this.nextStencilID++, e1 = this.context.gl;
                return new Ei({
                    func: e1.NOTEQUAL,
                    mask: 255
                }, t1, 255, e1.KEEP, e1.KEEP, e1.REPLACE);
            }
            stencilModeForClipping(t1) {
                const e1 = this.context.gl;
                return new Ei({
                    func: e1.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[t1.key], 0, e1.KEEP, e1.KEEP, e1.REPLACE);
            }
            stencilConfigForOverlap(t1) {
                const e1 = this.context.gl, i = t1.sort((t1, e1)=>e1.overscaledZ - t1.overscaledZ), o = i[i.length - 1].overscaledZ, a = i[0].overscaledZ - o + 1;
                if (a > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + a > 256 && this.clearStencil();
                    const t1 = {};
                    for(let i = 0; i < a; i++)t1[i + o] = new Ei({
                        func: e1.GEQUAL,
                        mask: 255
                    }, i + this.nextStencilID, 255, e1.KEEP, e1.KEEP, e1.REPLACE);
                    return this.nextStencilID += a, [
                        t1,
                        i
                    ];
                }
                return [
                    {
                        [o]: Ei.disabled
                    },
                    i
                ];
            }
            colorModeForRenderPass() {
                const e1 = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new yi([
                        e1.CONSTANT_COLOR,
                        e1.ONE
                    ], new t1.Color(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? yi.unblended : yi.alphaBlended;
            }
            depthModeForSublayer(t1, e1, i) {
                if (!this.opaquePassEnabledForLayer()) return wi.disabled;
                const o = 1 - ((1 + this.currentLayer) * this.numSublayers + t1) * this.depthEpsilon;
                return new wi(i || this.context.gl.LEQUAL, e1, [
                    o,
                    o
                ]);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            render(e1, i) {
                this.style = e1, this.options = i, this.lineAtlas = e1.lineAtlas, this.imageManager = e1.imageManager, this.glyphManager = e1.glyphManager, this.symbolFadeChange = e1.placement.symbolFadeChange(t1.exported.now()), this.imageManager.beginFrame();
                const o = this.style._order, a = this.style.sourceCaches, r = this.style.terrain && new Ki(this);
                for(const t1 in a){
                    const e1 = a[t1];
                    e1.used && e1.prepare(this.context);
                }
                const s = {}, n = {}, l = {};
                for(const t1 in a){
                    const e1 = a[t1];
                    s[t1] = e1.getVisibleCoordinates(), n[t1] = s[t1].slice().reverse(), l[t1] = e1.getVisibleCoordinates(!0).reverse();
                }
                this.opaquePassCutoff = 1 / 0;
                for(let t1 = 0; t1 < o.length; t1++)if (this.style._layers[o[t1]].is3D()) {
                    this.opaquePassCutoff = t1;
                    break;
                }
                if (r) {
                    this.opaquePassCutoff = 0;
                    const e1 = this.style.terrain.sourceCache.tilesAfterTime(this.terrainFacilitator.renderTime);
                    (this.terrainFacilitator.dirty || !t1.equals(this.terrainFacilitator.matrix, this.transform.projMatrix) || e1.length) && (t1.copy(this.terrainFacilitator.matrix, this.transform.projMatrix), this.terrainFacilitator.renderTime = Date.now(), this.terrainFacilitator.dirty = !1, function(e1, i) {
                        const o = e1.context, a = o.gl, r = yi.unblended, s = new wi(a.LEQUAL, wi.ReadWrite, [
                            0,
                            1
                        ]), n = i.getTerrainMesh(), l = i.sourceCache.getRenderableTiles(), c = e1.useProgram("terrainDepth");
                        o.bindFramebuffer.set(i.getFramebuffer("depth").framebuffer), o.viewport.set([
                            0,
                            0,
                            e1.width / devicePixelRatio,
                            e1.height / devicePixelRatio
                        ]), o.clear({
                            color: t1.Color.transparent,
                            depth: 1
                        });
                        for (const t1 of l){
                            const l = i.getTerrainData(t1.tileID), h = e1.transform.calculatePosMatrix(t1.tileID.toUnwrapped());
                            c.draw(o, a.TRIANGLES, s, Ei.disabled, r, Ii.backCCW, {
                                u_matrix: h
                            }, l, "terrain", n.vertexBuffer, n.indexBuffer, n.segments);
                        }
                        o.bindFramebuffer.set(null), o.viewport.set([
                            0,
                            0,
                            e1.width,
                            e1.height
                        ]);
                    }(this, this.style.terrain), function(e1, i) {
                        const o = e1.context, a = o.gl, r = yi.unblended, s = new wi(a.LEQUAL, wi.ReadWrite, [
                            0,
                            1
                        ]), n = i.getTerrainMesh(), l = i.getCoordsTexture(), c = i.sourceCache.getRenderableTiles(), h = e1.useProgram("terrainCoords");
                        o.bindFramebuffer.set(i.getFramebuffer("coords").framebuffer), o.viewport.set([
                            0,
                            0,
                            e1.width / devicePixelRatio,
                            e1.height / devicePixelRatio
                        ]), o.clear({
                            color: t1.Color.transparent,
                            depth: 1
                        }), i.coordsIndex = [];
                        for (const t1 of c){
                            const c = i.getTerrainData(t1.tileID);
                            o.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, l.texture);
                            const u = e1.transform.calculatePosMatrix(t1.tileID.toUnwrapped());
                            h.draw(o, a.TRIANGLES, s, Ei.disabled, r, Ii.backCCW, {
                                u_matrix: u,
                                u_terrain_coords_id: (255 - i.coordsIndex.length) / 255,
                                u_texture: 0
                            }, c, "terrain", n.vertexBuffer, n.indexBuffer, n.segments), i.coordsIndex.push(t1.tileID.key);
                        }
                        o.bindFramebuffer.set(null), o.viewport.set([
                            0,
                            0,
                            e1.width,
                            e1.height
                        ]);
                    }(this, this.style.terrain));
                }
                this.renderPass = "offscreen";
                for (const t1 of o){
                    const e1 = this.style._layers[t1];
                    if (!e1.hasOffscreenPass() || e1.isHidden(this.transform.zoom)) continue;
                    const i = n[e1.source];
                    ("custom" === e1.type || i.length) && this.renderLayer(this, a[e1.source], e1, i);
                }
                if (this.context.bindFramebuffer.set(null), this.context.clear({
                    color: i.showOverdrawInspector ? t1.Color.black : t1.Color.transparent,
                    depth: 1
                }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.depthRangeFor3D = [
                    0,
                    1 - (e1._order.length + 2) * this.numSublayers * this.depthEpsilon
                ], !r) for(this.renderPass = "opaque", this.currentLayer = o.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const t1 = this.style._layers[o[this.currentLayer]], e1 = a[t1.source], i = s[t1.source];
                    this._renderTileClippingMasks(t1, i), this.renderLayer(this, e1, t1, i);
                }
                for(this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < o.length; this.currentLayer++){
                    const t1 = this.style._layers[o[this.currentLayer]], e1 = a[t1.source];
                    if (r && r.renderLayer(t1)) continue;
                    const i = ("symbol" === t1.type ? l : n)[t1.source];
                    this._renderTileClippingMasks(t1, s[t1.source]), this.renderLayer(this, e1, t1, i);
                }
                if (this.options.showTileBoundaries) {
                    let t1, e1;
                    Object.values(this.style._layers).forEach((i)=>{
                        i.source && !i.isHidden(this.transform.zoom) && (i.source !== (e1 && e1.id) && (e1 = this.style.sourceCaches[i.source]), (!t1 || t1.getSource().maxzoom < e1.getSource().maxzoom) && (t1 = e1));
                    }), t1 && Yi.debug(this, t1, t1.getVisibleCoordinates());
                }
                this.options.showPadding && function(t1) {
                    const e1 = t1.transform.padding;
                    qi(t1, t1.transform.height - (e1.top || 0), 3, Ui), qi(t1, e1.bottom || 0, 3, Ni), ji(t1, e1.left || 0, 3, Gi), ji(t1, t1.transform.width - (e1.right || 0), 3, Zi);
                    const i = t1.transform.centerPoint;
                    !function(t1, e1, i, o) {
                        $i(t1, e1 - 1, i - 10, 2, 20, o), $i(t1, e1 - 10, i - 1, 20, 2, o);
                    }(t1, i.x, t1.transform.height - i.y, Vi);
                }(this), this.context.setDefault();
            }
            renderLayer(t1, e1, i, o) {
                i.isHidden(this.transform.zoom) || ("background" === i.type || "custom" === i.type || (o || []).length) && (this.id = i.id, this.gpuTimingStart(i), Yi[i.type](t1, e1, i, o, this.style.placement.variableOffsets), this.gpuTimingEnd());
            }
            gpuTimingStart(t1) {
                if (!this.options.gpuTiming) return;
                const e1 = this.context.extTimerQuery;
                let i = this.gpuTimers[t1.id];
                i || (i = this.gpuTimers[t1.id] = {
                    calls: 0,
                    cpuTime: 0,
                    query: e1.createQueryEXT()
                }), i.calls++, e1.beginQueryEXT(e1.TIME_ELAPSED_EXT, i.query);
            }
            gpuTimingEnd() {
                if (!this.options.gpuTiming) return;
                const t1 = this.context.extTimerQuery;
                t1.endQueryEXT(t1.TIME_ELAPSED_EXT);
            }
            collectGpuTimers() {
                const t1 = this.gpuTimers;
                return this.gpuTimers = {}, t1;
            }
            queryGpuTimers(t1) {
                const e1 = {};
                for(const i in t1){
                    const o = t1[i], a = this.context.extTimerQuery, r = a.getQueryObjectEXT(o.query, a.QUERY_RESULT_EXT) / 1e6;
                    a.deleteQueryEXT(o.query), e1[i] = r;
                }
                return e1;
            }
            translatePosMatrix(e1, i, o, a, r) {
                if (!o[0] && !o[1]) return e1;
                const s = r ? "map" === a ? this.transform.angle : 0 : "viewport" === a ? -this.transform.angle : 0;
                if (s) {
                    const t1 = Math.sin(s), e1 = Math.cos(s);
                    o = [
                        o[0] * e1 - o[1] * t1,
                        o[0] * t1 + o[1] * e1
                    ];
                }
                const n = [
                    r ? o[0] : bt(i, o[0], this.transform.zoom),
                    r ? o[1] : bt(i, o[1], this.transform.zoom),
                    0
                ], l = new Float32Array(16);
                return t1.translate(l, e1, n), l;
            }
            saveTileTexture(t1) {
                const e1 = this._tileTextures[t1.size[0]];
                e1 ? e1.push(t1) : this._tileTextures[t1.size[0]] = [
                    t1
                ];
            }
            getTileTexture(t1) {
                const e1 = this._tileTextures[t1];
                return e1 && e1.length > 0 ? e1.pop() : null;
            }
            isPatternMissing(t1) {
                if (!t1) return !1;
                if (!t1.from || !t1.to) return !0;
                const e1 = this.imageManager.getPattern(t1.from.toString()), i = this.imageManager.getPattern(t1.to.toString());
                return !e1 || !i;
            }
            useProgram(t1, e1) {
                this.cache = this.cache || {};
                const i = t1 + (e1 ? e1.cacheKey : "") + (this._showOverdrawInspector ? "/overdraw" : "") + (this.style.terrain ? "/terrain" : "");
                return this.cache[i] || (this.cache[i] = new ne(this.context, t1, oe[t1], e1, Re[t1], this._showOverdrawInspector, this.style.terrain)), this.cache[i];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const t1 = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(t1.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new l(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
            }
            destroy() {
                this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy();
            }
            constructor(e1, i){
                this.context = new bi(e1), this.transform = i, this._tileTextures = {}, this.terrainFacilitator = {
                    dirty: !0,
                    matrix: t1.create(),
                    renderTime: 0
                }, this.setup(), this.numSublayers = O.maxUnderzooming + O.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new Xt, this.gpuTimers = {};
            }
        }
        class Qi {
            static fromInvProjectionMatrix(e1, i, o) {
                const a = Math.pow(2, o), r = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((o)=>{
                    const r = 1 / (o = t1.transformMat4([], o, e1))[3] / i * a;
                    return t1.mul$1(o, o, [
                        r,
                        r,
                        1 / o[3],
                        r
                    ]);
                }), s = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((e1)=>{
                    const i = t1.sub([], r[e1[0]], r[e1[1]]), o = t1.sub([], r[e1[2]], r[e1[1]]), a = t1.normalize([], t1.cross([], i, o)), s = -t1.dot(a, r[e1[1]]);
                    return a.concat(s);
                });
                return new Qi(r, s);
            }
            constructor(t1, e1){
                this.points = t1, this.planes = e1;
            }
        }
        class to {
            quadrant(e1) {
                const i = [
                    e1 % 2 == 0,
                    e1 < 2
                ], o = t1.clone$2(this.min), a = t1.clone$2(this.max);
                for(let t1 = 0; t1 < i.length; t1++)o[t1] = i[t1] ? this.min[t1] : this.center[t1], a[t1] = i[t1] ? this.center[t1] : this.max[t1];
                return a[2] = this.max[2], new to(o, a);
            }
            distanceX(t1) {
                return Math.max(Math.min(this.max[0], t1[0]), this.min[0]) - t1[0];
            }
            distanceY(t1) {
                return Math.max(Math.min(this.max[1], t1[1]), this.min[1]) - t1[1];
            }
            intersects(e1) {
                const i = [
                    [
                        this.min[0],
                        this.min[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.min[0],
                        this.min[1],
                        this.max[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        this.max[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        this.max[2],
                        1
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        this.max[2],
                        1
                    ]
                ];
                let o = !0;
                for(let a = 0; a < e1.planes.length; a++){
                    const r = e1.planes[a];
                    let s = 0;
                    for(let e1 = 0; e1 < i.length; e1++)t1.dot$1(r, i[e1]) >= 0 && s++;
                    if (0 === s) return 0;
                    s !== i.length && (o = !1);
                }
                if (o) return 2;
                for(let t1 = 0; t1 < 3; t1++){
                    let i = Number.MAX_VALUE, o = -Number.MAX_VALUE;
                    for(let a = 0; a < e1.points.length; a++){
                        const r = e1.points[a][t1] - this.min[t1];
                        i = Math.min(i, r), o = Math.max(o, r);
                    }
                    if (o < 0 || i > this.max[t1] - this.min[t1]) return 0;
                }
                return 1;
            }
            constructor(e1, i){
                this.min = e1, this.max = i, this.center = t1.scale$1([], t1.add([], this.min, this.max), .5);
            }
        }
        class eo {
            interpolate(e1, i, o) {
                return null != i.top && null != e1.top && (this.top = t1.number(e1.top, i.top, o)), null != i.bottom && null != e1.bottom && (this.bottom = t1.number(e1.bottom, i.bottom, o)), null != i.left && null != e1.left && (this.left = t1.number(e1.left, i.left, o)), null != i.right && null != e1.right && (this.right = t1.number(e1.right, i.right, o)), this;
            }
            getCenter(e1, i) {
                const o = t1.clamp((this.left + e1 - this.right) / 2, 0, e1), a = t1.clamp((this.top + i - this.bottom) / 2, 0, i);
                return new t1.pointGeometry(o, a);
            }
            equals(t1) {
                return this.top === t1.top && this.bottom === t1.bottom && this.left === t1.left && this.right === t1.right;
            }
            clone() {
                return new eo(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
            constructor(t1 = 0, e1 = 0, i = 0, o = 0){
                if (isNaN(t1) || t1 < 0 || isNaN(e1) || e1 < 0 || isNaN(i) || i < 0 || isNaN(o) || o < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = t1, this.bottom = e1, this.left = i, this.right = o;
            }
        }
        class io {
            clone() {
                const t1 = new io(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
                return t1.tileSize = this.tileSize, t1.latRange = this.latRange, t1.width = this.width, t1.height = this.height, t1._center = this._center, t1._elevation = this._elevation, t1.zoom = this.zoom, t1.angle = this.angle, t1._fov = this._fov, t1._pitch = this._pitch, t1._unmodified = this._unmodified, t1._edgeInsets = this._edgeInsets.clone(), t1._calcMatrices(), t1;
            }
            get minZoom() {
                return this._minZoom;
            }
            set minZoom(t1) {
                this._minZoom !== t1 && (this._minZoom = t1, this.zoom = Math.max(this.zoom, t1));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            set maxZoom(t1) {
                this._maxZoom !== t1 && (this._maxZoom = t1, this.zoom = Math.min(this.zoom, t1));
            }
            get minPitch() {
                return this._minPitch;
            }
            set minPitch(t1) {
                this._minPitch !== t1 && (this._minPitch = t1, this.pitch = Math.max(this.pitch, t1));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            set maxPitch(t1) {
                this._maxPitch !== t1 && (this._maxPitch = t1, this.pitch = Math.min(this.pitch, t1));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies;
            }
            set renderWorldCopies(t1) {
                void 0 === t1 ? t1 = !0 : null === t1 && (t1 = !1), this._renderWorldCopies = t1;
            }
            get worldSize() {
                return this.tileSize * this.scale;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new t1.pointGeometry(this.width, this.height);
            }
            get bearing() {
                return -this.angle / Math.PI * 180;
            }
            set bearing(e1) {
                const i = -t1.wrap(e1, -180, 180) * Math.PI / 180;
                var o;
                this.angle !== i && (this._unmodified = !1, this.angle = i, this._calcMatrices(), this.rotationMatrix = (o = new t1.ARRAY_TYPE(4), t1.ARRAY_TYPE != Float32Array && (o[1] = 0, o[2] = 0), o[0] = 1, o[3] = 1, o), function(t1, e1, i) {
                    var o = e1[0], a = e1[1], r = e1[2], s = e1[3], n = Math.sin(i), l = Math.cos(i);
                    t1[0] = o * l + r * n, t1[1] = a * l + s * n, t1[2] = o * -n + r * l, t1[3] = a * -n + s * l;
                }(this.rotationMatrix, this.rotationMatrix, this.angle));
            }
            get pitch() {
                return this._pitch / Math.PI * 180;
            }
            set pitch(e1) {
                const i = t1.clamp(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitch !== i && (this._unmodified = !1, this._pitch = i, this._calcMatrices());
            }
            get fov() {
                return this._fov / Math.PI * 180;
            }
            set fov(t1) {
                t1 = Math.max(.01, Math.min(60, t1)), this._fov !== t1 && (this._unmodified = !1, this._fov = t1 / 180 * Math.PI, this._calcMatrices());
            }
            get zoom() {
                return this._zoom;
            }
            set zoom(t1) {
                const e1 = Math.min(Math.max(t1, this.minZoom), this.maxZoom);
                this._zoom !== e1 && (this._unmodified = !1, this._zoom = e1, this.scale = this.zoomScale(e1), this.tileZoom = Math.floor(e1), this.zoomFraction = e1 - this.tileZoom, this._constrain(), this._calcMatrices());
            }
            get center() {
                return this._center;
            }
            set center(t1) {
                t1.lat === this._center.lat && t1.lng === this._center.lng || (this._unmodified = !1, this._center = t1, this._constrain(), this._calcMatrices());
            }
            get elevation() {
                return this._elevation;
            }
            set elevation(t1) {
                t1 !== this._elevation && (this._elevation = t1, this._constrain(), this._calcMatrices());
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            set padding(t1) {
                this._edgeInsets.equals(t1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, t1, 1), this._calcMatrices());
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this.width, this.height);
            }
            isPaddingEqual(t1) {
                return this._edgeInsets.equals(t1);
            }
            interpolatePadding(t1, e1, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(t1, e1, i), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(t1) {
                const e1 = (t1.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / t1.tileSize));
                return Math.max(0, e1);
            }
            getVisibleUnwrappedCoordinates(e1) {
                const i = [
                    new t1.UnwrappedTileID(0, e1)
                ];
                if (this._renderWorldCopies) {
                    const o = this.pointCoordinate(new t1.pointGeometry(0, 0)), a = this.pointCoordinate(new t1.pointGeometry(this.width, 0)), r = this.pointCoordinate(new t1.pointGeometry(this.width, this.height)), s = this.pointCoordinate(new t1.pointGeometry(0, this.height)), n = Math.floor(Math.min(o.x, a.x, r.x, s.x)), l = Math.floor(Math.max(o.x, a.x, r.x, s.x)), c = 1;
                    for(let o = n - c; o <= l + c; o++)0 !== o && i.push(new t1.UnwrappedTileID(o, e1));
                }
                return i;
            }
            coveringTiles(e1) {
                var i, o;
                let a = this.coveringZoomLevel(e1);
                const r = a;
                if (void 0 !== e1.minzoom && a < e1.minzoom) return [];
                void 0 !== e1.maxzoom && a > e1.maxzoom && (a = e1.maxzoom);
                const s = this.pointCoordinate(this.getCameraPoint()), n = t1.MercatorCoordinate.fromLngLat(this.center), l = Math.pow(2, a), c = [
                    l * s.x,
                    l * s.y,
                    0
                ], h = [
                    l * n.x,
                    l * n.y,
                    0
                ], u = Qi.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, a);
                let d = e1.minzoom || 0;
                !e1.terrain && this.pitch <= 60 && this._edgeInsets.top < .1 && (d = a);
                const m = e1.terrain ? 2 / Math.min(this.tileSize, e1.tileSize) * this.tileSize : 3, _ = (t1)=>({
                        aabb: new to([
                            t1 * l,
                            0,
                            0
                        ], [
                            (t1 + 1) * l,
                            l,
                            0
                        ]),
                        zoom: 0,
                        x: 0,
                        y: 0,
                        wrap: t1,
                        fullyVisible: !1
                    }), p = [], f = [], g = a, x = e1.reparseOverscaled ? r : a;
                if (this._renderWorldCopies) for(let t1 = 1; t1 <= 3; t1++)p.push(_(-t1)), p.push(_(t1));
                for(p.push(_(0)); p.length > 0;){
                    const a = p.pop(), r = a.x, s = a.y;
                    let n = a.fullyVisible;
                    if (!n) {
                        const t1 = a.aabb.intersects(u);
                        if (0 === t1) continue;
                        n = 2 === t1;
                    }
                    const l = e1.terrain ? c : h, _ = a.aabb.distanceX(l), v = a.aabb.distanceY(l), y = Math.max(Math.abs(_), Math.abs(v)), b = m + (1 << g - a.zoom) - 2;
                    if (a.zoom === g || y > b && a.zoom >= d) {
                        const e1 = g - a.zoom, i = c[0] - .5 - (r << e1), o = c[1] - .5 - (s << e1);
                        f.push({
                            tileID: new t1.OverscaledTileID(a.zoom === g ? x : a.zoom, a.wrap, a.zoom, r, s),
                            distanceSq: t1.sqrLen([
                                h[0] - .5 - r,
                                h[1] - .5 - s
                            ]),
                            tileDistanceToCamera: Math.sqrt(i * i + o * o)
                        });
                    } else for(let l = 0; l < 4; l++){
                        const c = (r << 1) + l % 2, h = (s << 1) + (l >> 1), u = a.zoom + 1;
                        let d = a.aabb.quadrant(l);
                        if (e1.terrain) {
                            const r = new t1.OverscaledTileID(u, a.wrap, u, c, h), s = e1.terrain.getMinMaxElevation(r), n = null !== (i = s.minElevation) && void 0 !== i ? i : this.elevation, l = null !== (o = s.maxElevation) && void 0 !== o ? o : this.elevation;
                            d = new to([
                                d.min[0],
                                d.min[1],
                                n
                            ], [
                                d.max[0],
                                d.max[1],
                                l
                            ]);
                        }
                        p.push({
                            aabb: d,
                            zoom: u,
                            x: c,
                            y: h,
                            wrap: a.wrap,
                            fullyVisible: n
                        });
                    }
                }
                return f.sort((t1, e1)=>t1.distanceSq - e1.distanceSq).map((t1)=>t1.tileID);
            }
            resize(t1, e1) {
                this.width = t1, this.height = e1, this.pixelsToGLUnits = [
                    2 / t1,
                    -2 / e1
                ], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
                return this._unmodified;
            }
            zoomScale(t1) {
                return Math.pow(2, t1);
            }
            scaleZoom(t1) {
                return Math.log(t1) / Math.LN2;
            }
            project(e1) {
                const i = t1.clamp(e1.lat, -this.maxValidLatitude, this.maxValidLatitude);
                return new t1.pointGeometry(t1.mercatorXfromLng(e1.lng) * this.worldSize, t1.mercatorYfromLat(i) * this.worldSize);
            }
            unproject(e1) {
                return new t1.MercatorCoordinate(e1.x / this.worldSize, e1.y / this.worldSize).toLngLat();
            }
            get point() {
                return this.project(this.center);
            }
            updateElevation(t1) {
                this.freezeElevation || (this.elevation = t1 ? this.getElevation(this._center, t1) : 0);
            }
            getElevation(e1, i) {
                const o = t1.MercatorCoordinate.fromLngLat(e1), a = (1 << this.tileZoom) * t1.EXTENT, r = o.x * a, s = o.y * a, n = Math.floor(r / t1.EXTENT), l = Math.floor(s / t1.EXTENT), c = new t1.OverscaledTileID(this.tileZoom, 0, this.tileZoom, n, l);
                return i.getElevation(c, r % t1.EXTENT, s % t1.EXTENT, t1.EXTENT);
            }
            getCameraPosition() {
                return {
                    lngLat: this.pointLocation(this.getCameraPoint()),
                    altitude: Math.cos(this._pitch) * this.cameraToCenterDistance / this._pixelPerMeter + this.elevation
                };
            }
            recalculateZoom(e1) {
                const i = this.pointLocation(this.centerPoint, e1), o = this.getElevation(i, e1);
                if (!(this.elevation - o)) return;
                const a = this.getCameraPosition(), r = t1.MercatorCoordinate.fromLngLat(a.lngLat, a.altitude), s = t1.MercatorCoordinate.fromLngLat(i, o), n = r.x - s.x, l = r.y - s.y, c = r.z - s.z, h = Math.sqrt(n * n + l * l + c * c), u = this.scaleZoom(this.cameraToCenterDistance / h / this.tileSize);
                this._elevation = o, this._center = i, this.zoom = u;
            }
            setLocationAtPoint(e1, i) {
                const o = this.pointCoordinate(i), a = this.pointCoordinate(this.centerPoint), r = this.locationCoordinate(e1), s = new t1.MercatorCoordinate(r.x - (o.x - a.x), r.y - (o.y - a.y));
                this.center = this.coordinateLocation(s), this._renderWorldCopies && (this.center = this.center.wrap());
            }
            locationPoint(t1, e1) {
                return e1 ? this.coordinatePoint(this.locationCoordinate(t1), this.getElevation(t1, e1), this.pixelMatrix3D) : this.coordinatePoint(this.locationCoordinate(t1));
            }
            pointLocation(t1, e1) {
                return this.coordinateLocation(this.pointCoordinate(t1, e1));
            }
            locationCoordinate(e1) {
                return t1.MercatorCoordinate.fromLngLat(e1);
            }
            coordinateLocation(t1) {
                return t1 && t1.toLngLat();
            }
            pointCoordinate(e1, i) {
                if (i) {
                    const t1 = i.pointCoordinate(e1);
                    if (null != t1) return t1;
                }
                const o = [
                    e1.x,
                    e1.y,
                    0,
                    1
                ], a = [
                    e1.x,
                    e1.y,
                    1,
                    1
                ];
                t1.transformMat4(o, o, this.pixelMatrixInverse), t1.transformMat4(a, a, this.pixelMatrixInverse);
                const r = o[3], s = a[3], n = o[1] / r, l = a[1] / s, c = o[2] / r, h = a[2] / s, u = c === h ? 0 : (0 - c) / (h - c);
                return new t1.MercatorCoordinate(t1.number(o[0] / r, a[0] / s, u) / this.worldSize, t1.number(n, l, u) / this.worldSize);
            }
            coordinatePoint(e1, i = 0, o = this.pixelMatrix) {
                const a = [
                    e1.x * this.worldSize,
                    e1.y * this.worldSize,
                    i,
                    1
                ];
                return t1.transformMat4(a, a, o), new t1.pointGeometry(a[0] / a[3], a[1] / a[3]);
            }
            getBounds() {
                const e1 = Math.max(0, this.height / 2 - this.getHorizon());
                return (new t1.LngLatBounds).extend(this.pointLocation(new t1.pointGeometry(0, e1))).extend(this.pointLocation(new t1.pointGeometry(this.width, e1))).extend(this.pointLocation(new t1.pointGeometry(this.width, this.height))).extend(this.pointLocation(new t1.pointGeometry(0, this.height)));
            }
            getMaxBounds() {
                return this.latRange && 2 === this.latRange.length && this.lngRange && 2 === this.lngRange.length ? new t1.LngLatBounds([
                    this.lngRange[0],
                    this.latRange[0]
                ], [
                    this.lngRange[1],
                    this.latRange[1]
                ]) : null;
            }
            getHorizon() {
                return Math.tan(Math.PI / 2 - this._pitch) * this.cameraToCenterDistance * .85;
            }
            setMaxBounds(t1) {
                t1 ? (this.lngRange = [
                    t1.getWest(),
                    t1.getEast()
                ], this.latRange = [
                    t1.getSouth(),
                    t1.getNorth()
                ], this._constrain()) : (this.lngRange = null, this.latRange = [
                    -this.maxValidLatitude,
                    this.maxValidLatitude
                ]);
            }
            calculatePosMatrix(e1, i = !1) {
                const o = e1.key, a = i ? this._alignedPosMatrixCache : this._posMatrixCache;
                if (a[o]) return a[o];
                const r = e1.canonical, s = this.worldSize / this.zoomScale(r.z), n = r.x + Math.pow(2, r.z) * e1.wrap, l = t1.identity(new Float64Array(16));
                return t1.translate(l, l, [
                    n * s,
                    r.y * s,
                    0
                ]), t1.scale(l, l, [
                    s / t1.EXTENT,
                    s / t1.EXTENT,
                    1
                ]), t1.multiply(l, i ? this.alignedProjMatrix : this.projMatrix, l), a[o] = new Float32Array(l), a[o];
            }
            customLayerMatrix() {
                return this.mercatorMatrix.slice();
            }
            _constrain() {
                if (!this.center || !this.width || !this.height || this._constraining) return;
                this._constraining = !0;
                let e1, i, o, a, r = -90, s = 90, n = -180, l = 180;
                const c = this.size, h = this._unmodified;
                if (this.latRange) {
                    const i = this.latRange;
                    r = t1.mercatorYfromLat(i[1]) * this.worldSize, s = t1.mercatorYfromLat(i[0]) * this.worldSize, e1 = s - r < c.y ? c.y / (s - r) : 0;
                }
                if (this.lngRange) {
                    const e1 = this.lngRange;
                    n = t1.wrap(t1.mercatorXfromLng(e1[0]) * this.worldSize, 0, this.worldSize), l = t1.wrap(t1.mercatorXfromLng(e1[1]) * this.worldSize, 0, this.worldSize), l < n && (l += this.worldSize), i = l - n < c.x ? c.x / (l - n) : 0;
                }
                const u = this.point, d = Math.max(i || 0, e1 || 0);
                if (d) return this.center = this.unproject(new t1.pointGeometry(i ? (l + n) / 2 : u.x, e1 ? (s + r) / 2 : u.y)), this.zoom += this.scaleZoom(d), this._unmodified = h, void (this._constraining = !1);
                if (this.latRange) {
                    const t1 = u.y, e1 = c.y / 2;
                    t1 - e1 < r && (a = r + e1), t1 + e1 > s && (a = s - e1);
                }
                if (this.lngRange) {
                    const e1 = (n + l) / 2, i = t1.wrap(u.x, e1 - this.worldSize / 2, e1 + this.worldSize / 2), a = c.x / 2;
                    i - a < n && (o = n + a), i + a > l && (o = l - a);
                }
                void 0 === o && void 0 === a || (this.center = this.unproject(new t1.pointGeometry(void 0 !== o ? o : u.x, void 0 !== a ? a : u.y)).wrap()), this._unmodified = h, this._constraining = !1;
            }
            _calcMatrices() {
                if (!this.height) return;
                const e1 = this.centerOffset, i = this.point.x, o = this.point.y;
                this.cameraToCenterDistance = .5 / Math.tan(this._fov / 2) * this.height, this._pixelPerMeter = t1.mercatorZfromAltitude(1, this.center.lat) * this.worldSize;
                let a = t1.identity(new Float64Array(16));
                t1.scale(a, a, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), t1.translate(a, a, [
                    1,
                    -1,
                    0
                ]), this.labelPlaneMatrix = a, a = t1.identity(new Float64Array(16)), t1.scale(a, a, [
                    1,
                    -1,
                    1
                ]), t1.translate(a, a, [
                    -1,
                    -1,
                    0
                ]), t1.scale(a, a, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), this.glCoordMatrix = a, this.cameraToSeaLevelDistance = this.cameraToCenterDistance + this._elevation * this._pixelPerMeter / Math.cos(this._pitch);
                const r = Math.PI / 2 + this._pitch, s = this._fov * (.5 + e1.y / this.height), n = Math.sin(s) * this.cameraToSeaLevelDistance / Math.sin(t1.clamp(Math.PI - r - s, .01, Math.PI - .01)), l = this.getHorizon(), c = 2 * Math.atan(l / this.cameraToCenterDistance) * (.5 + e1.y / (2 * l)), h = Math.sin(c) * this.cameraToSeaLevelDistance / Math.sin(t1.clamp(Math.PI - r - c, .01, Math.PI - .01)), u = Math.cos(Math.PI / 2 - this._pitch) * n + this.cameraToSeaLevelDistance, d = Math.cos(Math.PI / 2 - this._pitch) * h + this.cameraToSeaLevelDistance, m = 1.01 * Math.min(u, d), _ = this.height / 50;
                a = new Float64Array(16), t1.perspective(a, this._fov, this.width / this.height, _, m), a[8] = 2 * -e1.x / this.width, a[9] = 2 * e1.y / this.height, t1.scale(a, a, [
                    1,
                    -1,
                    1
                ]), t1.translate(a, a, [
                    0,
                    0,
                    -this.cameraToCenterDistance
                ]), t1.rotateX(a, a, this._pitch), t1.rotateZ(a, a, this.angle), t1.translate(a, a, [
                    -i,
                    -o,
                    0
                ]), this.mercatorMatrix = t1.scale([], a, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize
                ]), t1.scale(a, a, [
                    1,
                    1,
                    this._pixelPerMeter
                ]), this.pixelMatrix = t1.multiply(new Float64Array(16), this.labelPlaneMatrix, a), t1.translate(a, a, [
                    0,
                    0,
                    -this.elevation
                ]), this.projMatrix = a, this.invProjMatrix = t1.invert([], a), this.pixelMatrix3D = t1.multiply(new Float64Array(16), this.labelPlaneMatrix, a);
                const p = this.width % 2 / 2, f = this.height % 2 / 2, g = Math.cos(this.angle), x = Math.sin(this.angle), v = i - Math.round(i) + g * p + x * f, y = o - Math.round(o) + g * f + x * p, b = new Float64Array(a);
                if (t1.translate(b, b, [
                    v > .5 ? v - 1 : v,
                    y > .5 ? y - 1 : y,
                    0
                ]), this.alignedProjMatrix = b, a = t1.invert(new Float64Array(16), this.pixelMatrix), !a) throw new Error("failed to invert matrix");
                this.pixelMatrixInverse = a, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
            }
            maxPitchScaleFactor() {
                if (!this.pixelMatrixInverse) return 1;
                const e1 = this.pointCoordinate(new t1.pointGeometry(0, 0)), i = [
                    e1.x * this.worldSize,
                    e1.y * this.worldSize,
                    0,
                    1
                ];
                return t1.transformMat4(i, i, this.pixelMatrix)[3] / this.cameraToCenterDistance;
            }
            getCameraPoint() {
                const e1 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                return this.centerPoint.add(new t1.pointGeometry(0, e1));
            }
            getCameraQueryGeometry(e1) {
                const i = this.getCameraPoint();
                if (1 === e1.length) return [
                    e1[0],
                    i
                ];
                {
                    let o = i.x, a = i.y, r = i.x, s = i.y;
                    for (const t1 of e1)o = Math.min(o, t1.x), a = Math.min(a, t1.y), r = Math.max(r, t1.x), s = Math.max(s, t1.y);
                    return [
                        new t1.pointGeometry(o, a),
                        new t1.pointGeometry(r, a),
                        new t1.pointGeometry(r, s),
                        new t1.pointGeometry(o, s),
                        new t1.pointGeometry(o, a)
                    ];
                }
            }
            constructor(e1, i, o, a, r){
                this.tileSize = 512, this.maxValidLatitude = 85.051129, this.freezeElevation = !1, this._renderWorldCopies = void 0 === r || !!r, this._minZoom = e1 || 0, this._maxZoom = i || 22, this._minPitch = null == o ? 0 : o, this._maxPitch = null == a ? 60 : a, this.setMaxBounds(), this.width = 0, this.height = 0, this._center = new t1.LngLat(0, 0), this._elevation = 0, this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._unmodified = !0, this._edgeInsets = new eo, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
            }
        }
        class oo {
            addTo(t1) {
                return this._map = t1, addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
            }
            remove() {
                return removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), delete this._map, this;
            }
            getHashString(t1) {
                const e1 = this._map.getCenter(), i = Math.round(100 * this._map.getZoom()) / 100, o = Math.ceil((i * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), a = Math.pow(10, o), r = Math.round(e1.lng * a) / a, s = Math.round(e1.lat * a) / a, n = this._map.getBearing(), l = this._map.getPitch();
                let c = "";
                if (c += t1 ? `/${r}/${s}/${i}` : `${i}/${s}/${r}`, (n || l) && (c += "/" + Math.round(10 * n) / 10), l && (c += `/${Math.round(l)}`), this._hashName) {
                    const t1 = this._hashName;
                    let e1 = !1;
                    const i = window.location.hash.slice(1).split("&").map((i)=>{
                        const o = i.split("=")[0];
                        return o === t1 ? (e1 = !0, `${o}=${c}`) : i;
                    }).filter((t1)=>t1);
                    return e1 || i.push(`${t1}=${c}`), `#${i.join("&")}`;
                }
                return `#${c}`;
            }
            _getCurrentHash() {
                const t1 = window.location.hash.replace("#", "");
                if (this._hashName) {
                    let e1;
                    return t1.split("&").map((t1)=>t1.split("=")).forEach((t1)=>{
                        t1[0] === this._hashName && (e1 = t1);
                    }), (e1 && e1[1] || "").split("/");
                }
                return t1.split("/");
            }
            _onHashChange() {
                const t1 = this._getCurrentHash();
                if (t1.length >= 3 && !t1.some((t1)=>isNaN(t1))) {
                    const e1 = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(t1[3] || 0) : this._map.getBearing();
                    return this._map.jumpTo({
                        center: [
                            +t1[2],
                            +t1[1]
                        ],
                        zoom: +t1[0],
                        bearing: e1,
                        pitch: +(t1[4] || 0)
                    }), !0;
                }
                return !1;
            }
            _updateHashUnthrottled() {
                const t1 = window.location.href.replace(/(#.+)?$/, this.getHashString());
                try {
                    window.history.replaceState(window.history.state, null, t1);
                } catch (t1) {}
            }
            constructor(e1){
                this._hashName = e1 && encodeURIComponent(e1), t1.bindAll([
                    "_getCurrentHash",
                    "_onHashChange",
                    "_updateHash"
                ], this), this._updateHash = function(t1, e1) {
                    let i = !1, o = null;
                    const a = ()=>{
                        o = null, i && (t1(), o = setTimeout(a, 300), i = !1);
                    };
                    return ()=>(i = !0, o || a(), o);
                }(this._updateHashUnthrottled.bind(this));
            }
        }
        const ao = {
            linearity: .3,
            easing: t1.bezier(0, 0, .3, 1)
        }, ro = t1.extend({
            deceleration: 2500,
            maxSpeed: 1400
        }, ao), so = t1.extend({
            deceleration: 20,
            maxSpeed: 1400
        }, ao), no = t1.extend({
            deceleration: 1e3,
            maxSpeed: 360
        }, ao), lo = t1.extend({
            deceleration: 1e3,
            maxSpeed: 90
        }, ao);
        class co {
            clear() {
                this._inertiaBuffer = [];
            }
            record(e1) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: t1.exported.now(),
                    settings: e1
                });
            }
            _drainInertiaBuffer() {
                const e1 = this._inertiaBuffer, i = t1.exported.now();
                for(; e1.length > 0 && i - e1[0].time > 160;)e1.shift();
            }
            _onMoveEnd(e1) {
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new t1.pointGeometry(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: t1 } of this._inertiaBuffer)i.zoom += t1.zoomDelta || 0, i.bearing += t1.bearingDelta || 0, i.pitch += t1.pitchDelta || 0, t1.panDelta && i.pan._add(t1.panDelta), t1.around && (i.around = t1.around), t1.pinchAround && (i.pinchAround = t1.pinchAround);
                const o = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, a = {};
                if (i.pan.mag()) {
                    const r = uo(i.pan.mag(), o, t1.extend({}, ro, e1 || {}));
                    a.offset = i.pan.mult(r.amount / i.pan.mag()), a.center = this._map.transform.center, ho(a, r);
                }
                if (i.zoom) {
                    const t1 = uo(i.zoom, o, so);
                    a.zoom = this._map.transform.zoom + t1.amount, ho(a, t1);
                }
                if (i.bearing) {
                    const e1 = uo(i.bearing, o, no);
                    a.bearing = this._map.transform.bearing + t1.clamp(e1.amount, -179, 179), ho(a, e1);
                }
                if (i.pitch) {
                    const t1 = uo(i.pitch, o, lo);
                    a.pitch = this._map.transform.pitch + t1.amount, ho(a, t1);
                }
                if (a.zoom || a.bearing) {
                    const t1 = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    a.around = t1 ? this._map.unproject(t1) : this._map.getCenter();
                }
                return this.clear(), t1.extend(a, {
                    noMoveStart: !0
                });
            }
            constructor(t1){
                this._map = t1, this.clear();
            }
        }
        function ho(t1, e1) {
            (!t1.duration || t1.duration < e1.duration) && (t1.duration = e1.duration, t1.easing = e1.easing);
        }
        function uo(e1, i, o) {
            const { maxSpeed: a, linearity: r, deceleration: s } = o, n = t1.clamp(e1 * r / (i / 1e3), -a, a), l = Math.abs(n) / (s * r);
            return {
                easing: o.easing,
                duration: 1e3 * l,
                amount: n * (l / 2)
            };
        }
        class mo extends t1.Event {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, i, o, a = {}){
                const s = r.mousePos(i.getCanvasContainer(), o), n = i.unproject(s);
                super(e1, t1.extend({
                    point: s,
                    lngLat: n,
                    originalEvent: o
                }, a)), this._defaultPrevented = !1, this.target = i;
            }
        }
        class _o extends t1.Event {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, i, o){
                const a = "touchend" === e1 ? o.changedTouches : o.touches, s = r.touchPos(i.getCanvasContainer(), a), n = s.map((t1)=>i.unproject(t1)), l = s.reduce((t1, e1, i, o)=>t1.add(e1.div(o.length)), new t1.pointGeometry(0, 0));
                super(e1, {
                    points: s,
                    point: l,
                    lngLats: n,
                    lngLat: i.unproject(l),
                    originalEvent: o
                }), this._defaultPrevented = !1;
            }
        }
        class po extends t1.Event {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t1, e1, i){
                super(t1, {
                    originalEvent: i
                }), this._defaultPrevented = !1;
            }
        }
        class fo {
            reset() {
                delete this._mousedownPos;
            }
            wheel(t1) {
                return this._firePreventable(new po(t1.type, this._map, t1));
            }
            mousedown(t1, e1) {
                return this._mousedownPos = e1, this._firePreventable(new mo(t1.type, this._map, t1));
            }
            mouseup(t1) {
                this._map.fire(new mo(t1.type, this._map, t1));
            }
            click(t1, e1) {
                this._mousedownPos && this._mousedownPos.dist(e1) >= this._clickTolerance || this._map.fire(new mo(t1.type, this._map, t1));
            }
            dblclick(t1) {
                return this._firePreventable(new mo(t1.type, this._map, t1));
            }
            mouseover(t1) {
                this._map.fire(new mo(t1.type, this._map, t1));
            }
            mouseout(t1) {
                this._map.fire(new mo(t1.type, this._map, t1));
            }
            touchstart(t1) {
                return this._firePreventable(new _o(t1.type, this._map, t1));
            }
            touchmove(t1) {
                this._map.fire(new _o(t1.type, this._map, t1));
            }
            touchend(t1) {
                this._map.fire(new _o(t1.type, this._map, t1));
            }
            touchcancel(t1) {
                this._map.fire(new _o(t1.type, this._map, t1));
            }
            _firePreventable(t1) {
                if (this._map.fire(t1), t1.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
            constructor(t1, e1){
                this._map = t1, this._clickTolerance = e1.clickTolerance;
            }
        }
        class go {
            reset() {
                this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
            }
            mousemove(t1) {
                this._map.fire(new mo(t1.type, this._map, t1));
            }
            mousedown() {
                this._delayContextMenu = !0, this._ignoreContextMenu = !1;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new mo("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(t1) {
                this._delayContextMenu ? this._contextMenuEvent = t1 : this._ignoreContextMenu || this._map.fire(new mo(t1.type, this._map, t1)), this._map.listens("contextmenu") && t1.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
            constructor(t1){
                this._map = t1;
            }
        }
        class xo {
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(t1, e1) {
                this.isEnabled() && t1.shiftKey && 0 === t1.button && (r.disableDrag(), this._startPos = this._lastPos = e1, this._active = !0);
            }
            mousemoveWindow(t1, e1) {
                if (!this._active) return;
                const i = e1;
                if (this._lastPos.equals(i) || !this._box && i.dist(this._startPos) < this._clickTolerance) return;
                const o = this._startPos;
                this._lastPos = i, this._box || (this._box = r.create("div", "maplibregl-boxzoom mapboxgl-boxzoom", this._container), this._container.classList.add("maplibregl-crosshair", "mapboxgl-crosshair"), this._fireEvent("boxzoomstart", t1));
                const a = Math.min(o.x, i.x), s = Math.max(o.x, i.x), n = Math.min(o.y, i.y), l = Math.max(o.y, i.y);
                r.setTransform(this._box, `translate(${a}px,${n}px)`), this._box.style.width = s - a + "px", this._box.style.height = l - n + "px";
            }
            mouseupWindow(e1, i) {
                if (!this._active) return;
                if (0 !== e1.button) return;
                const o = this._startPos, a = i;
                if (this.reset(), r.suppressClick(), o.x !== a.x || o.y !== a.y) return this._map.fire(new t1.Event("boxzoomend", {
                    originalEvent: e1
                })), {
                    cameraAnimation: (t1)=>t1.fitScreenCoordinates(o, a, this._map.getBearing(), {
                            linear: !0
                        })
                };
                this._fireEvent("boxzoomcancel", e1);
            }
            keydown(t1) {
                this._active && 27 === t1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", t1));
            }
            reset() {
                this._active = !1, this._container.classList.remove("maplibregl-crosshair", "mapboxgl-crosshair"), this._box && (r.remove(this._box), this._box = null), r.enableDrag(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(e1, i) {
                return this._map.fire(new t1.Event(e1, {
                    originalEvent: i
                }));
            }
            constructor(t1, e1){
                this._map = t1, this._el = t1.getCanvasContainer(), this._container = t1.getContainer(), this._clickTolerance = e1.clickTolerance || 1;
            }
        }
        function vo(t1, e1) {
            if (t1.length !== e1.length) throw new Error(`The number of touches and points are not equal - touches ${t1.length}, points ${e1.length}`);
            const i = {};
            for(let o = 0; o < t1.length; o++)i[t1[o].identifier] = e1[o];
            return i;
        }
        class yo {
            reset() {
                delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
            }
            touchstart(e1, i, o) {
                (this.centroid || o.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = e1.timeStamp), o.length === this.numTouches && (this.centroid = function(e1) {
                    const i = new t1.pointGeometry(0, 0);
                    for (const t1 of e1)i._add(t1);
                    return i.div(e1.length);
                }(i), this.touches = vo(o, i)));
            }
            touchmove(t1, e1, i) {
                if (this.aborted || !this.centroid) return;
                const o = vo(i, e1);
                for(const t1 in this.touches){
                    const e1 = this.touches[t1], i = o[t1];
                    (!i || i.dist(e1) > 30) && (this.aborted = !0);
                }
            }
            touchend(t1, e1, i) {
                if ((!this.centroid || t1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const t1 = !this.aborted && this.centroid;
                    if (this.reset(), t1) return t1;
                }
            }
            constructor(t1){
                this.reset(), this.numTouches = t1.numTouches;
            }
        }
        class bo {
            reset() {
                this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
            }
            touchstart(t1, e1, i) {
                this.singleTap.touchstart(t1, e1, i);
            }
            touchmove(t1, e1, i) {
                this.singleTap.touchmove(t1, e1, i);
            }
            touchend(t1, e1, i) {
                const o = this.singleTap.touchend(t1, e1, i);
                if (o) {
                    const e1 = t1.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(o) < 30;
                    if (e1 && i || this.reset(), this.count++, this.lastTime = t1.timeStamp, this.lastTap = o, this.count === this.numTaps) return this.reset(), o;
                }
            }
            constructor(t1){
                this.singleTap = new yo(t1), this.numTaps = t1.numTaps, this.reset();
            }
        }
        class wo {
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(t1, e1, i) {
                this._zoomIn.touchstart(t1, e1, i), this._zoomOut.touchstart(t1, e1, i);
            }
            touchmove(t1, e1, i) {
                this._zoomIn.touchmove(t1, e1, i), this._zoomOut.touchmove(t1, e1, i);
            }
            touchend(t1, e1, i) {
                const o = this._zoomIn.touchend(t1, e1, i), a = this._zoomOut.touchend(t1, e1, i);
                return o ? (this._active = !0, t1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (e1)=>e1.easeTo({
                            duration: 300,
                            zoom: e1.getZoom() + 1,
                            around: e1.unproject(o)
                        }, {
                            originalEvent: t1
                        })
                }) : a ? (this._active = !0, t1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (e1)=>e1.easeTo({
                            duration: 300,
                            zoom: e1.getZoom() - 1,
                            around: e1.unproject(a)
                        }, {
                            originalEvent: t1
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(){
                this._zoomIn = new bo({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new bo({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
        }
        const To = {
            0: 1,
            2: 2
        };
        class Eo {
            reset() {
                this._active = !1, this._moved = !1, delete this._lastPoint, delete this._eventButton;
            }
            _correctButton(t1, e1) {
                return !1;
            }
            _move(t1, e1) {
                return {};
            }
            mousedown(t1, e1) {
                if (this._lastPoint) return;
                const i = r.mouseButton(t1);
                this._correctButton(t1, i) && (this._lastPoint = e1, this._eventButton = i);
            }
            mousemoveWindow(t1, e1) {
                const i = this._lastPoint;
                if (i) {
                    if (t1.preventDefault(), function(t1, e1) {
                        const i = To[e1];
                        return void 0 === t1.buttons || (t1.buttons & i) !== i;
                    }(t1, this._eventButton)) this.reset();
                    else if (this._moved || !(e1.dist(i) < this._clickTolerance)) return this._moved = !0, this._lastPoint = e1, this._move(i, e1);
                }
            }
            mouseupWindow(t1) {
                this._lastPoint && r.mouseButton(t1) === this._eventButton && (this._moved && r.suppressClick(), this.reset());
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(t1){
                this.reset(), this._clickTolerance = t1.clickTolerance || 1;
            }
        }
        class Io extends Eo {
            mousedown(t1, e1) {
                super.mousedown(t1, e1), this._lastPoint && (this._active = !0);
            }
            _correctButton(t1, e1) {
                return 0 === e1 && !t1.ctrlKey;
            }
            _move(t1, e1) {
                return {
                    around: e1,
                    panDelta: e1.sub(t1)
                };
            }
        }
        class Co extends Eo {
            _correctButton(t1, e1) {
                return 0 === e1 && t1.ctrlKey || 2 === e1;
            }
            _move(t1, e1) {
                const i = .8 * (e1.x - t1.x);
                if (i) return this._active = !0, {
                    bearingDelta: i
                };
            }
            contextmenu(t1) {
                t1.preventDefault();
            }
        }
        class So extends Eo {
            _correctButton(t1, e1) {
                return 0 === e1 && t1.ctrlKey || 2 === e1;
            }
            _move(t1, e1) {
                const i = -0.5 * (e1.y - t1.y);
                if (i) return this._active = !0, {
                    pitchDelta: i
                };
            }
            contextmenu(t1) {
                t1.preventDefault();
            }
        }
        class Do {
            reset() {
                this._active = !1, this._touches = {}, this._sum = new t1.pointGeometry(0, 0), setTimeout(()=>{
                    this._cancelCooperativeMessage = !1;
                }, 200);
            }
            touchstart(t1, e1, i) {
                return this._calculateTransform(t1, e1, i);
            }
            touchmove(t1, e1, i) {
                if (this._map._cooperativeGestures && (2 === this._minTouches && i.length < 2 && !this._cancelCooperativeMessage ? this._map._onCooperativeGesture(t1, !1, i.length) : this._cancelCooperativeMessage || (this._cancelCooperativeMessage = !0)), this._active && !(i.length < this._minTouches)) return t1.preventDefault(), this._calculateTransform(t1, e1, i);
            }
            touchend(t1, e1, i) {
                this._calculateTransform(t1, e1, i), this._active && i.length < this._minTouches && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(e1, i, o) {
                o.length > 0 && (this._active = !0);
                const a = vo(o, i), r = new t1.pointGeometry(0, 0), s = new t1.pointGeometry(0, 0);
                let n = 0;
                for(const t1 in a){
                    const e1 = a[t1], i = this._touches[t1];
                    i && (r._add(e1), s._add(e1.sub(i)), n++, a[t1] = e1);
                }
                if (this._touches = a, n < this._minTouches || !s.mag()) return;
                const l = s.div(n);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: r.div(n),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(t1, e1){
                this._minTouches = t1.cooperativeGestures ? 2 : 1, this._clickTolerance = t1.clickTolerance || 1, this._map = e1, this.reset();
            }
        }
        class zo {
            reset() {
                this._active = !1, delete this._firstTwoTouches;
            }
            _start(t1) {}
            _move(t1, e1, i) {
                return {};
            }
            touchstart(t1, e1, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    e1[0],
                    e1[1]
                ]));
            }
            touchmove(t1, e1, i) {
                if (!this._firstTwoTouches) return;
                t1.preventDefault();
                const [o, a] = this._firstTwoTouches, r = Po(i, e1, o), s = Po(i, e1, a);
                if (!r || !s) return;
                const n = this._aroundCenter ? null : r.add(s).div(2);
                return this._move([
                    r,
                    s
                ], n, t1);
            }
            touchend(t1, e1, i) {
                if (!this._firstTwoTouches) return;
                const [o, a] = this._firstTwoTouches, s = Po(i, e1, o), n = Po(i, e1, a);
                s && n || (this._active && r.suppressClick(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(t1) {
                this._enabled = !0, this._aroundCenter = !!t1 && "center" === t1.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(){
                this.reset();
            }
        }
        function Po(t1, e1, i) {
            for(let o = 0; o < t1.length; o++)if (t1[o].identifier === i) return e1[o];
        }
        function Mo(t1, e1) {
            return Math.log(t1 / e1) / Math.LN2;
        }
        class Ao extends zo {
            reset() {
                super.reset(), delete this._distance, delete this._startDistance;
            }
            _start(t1) {
                this._startDistance = this._distance = t1[0].dist(t1[1]);
            }
            _move(t1, e1) {
                const i = this._distance;
                if (this._distance = t1[0].dist(t1[1]), this._active || !(Math.abs(Mo(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: Mo(this._distance, i),
                    pinchAround: e1
                };
            }
        }
        function Lo(t1, e1) {
            return 180 * t1.angleWith(e1) / Math.PI;
        }
        class Ro extends zo {
            reset() {
                super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
            }
            _start(t1) {
                this._startVector = this._vector = t1[0].sub(t1[1]), this._minDiameter = t1[0].dist(t1[1]);
            }
            _move(t1, e1) {
                const i = this._vector;
                if (this._vector = t1[0].sub(t1[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                    bearingDelta: Lo(this._vector, i),
                    pinchAround: e1
                };
            }
            _isBelowThreshold(t1) {
                this._minDiameter = Math.min(this._minDiameter, t1.mag());
                const e1 = 25 / (Math.PI * this._minDiameter) * 360, i = Lo(t1, this._startVector);
                return Math.abs(i) < e1;
            }
        }
        function ko(t1) {
            return Math.abs(t1.y) > Math.abs(t1.x);
        }
        class Bo extends zo {
            reset() {
                super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
            }
            touchstart(t1, e1, i) {
                super.touchstart(t1, e1, i), this._currentTouchCount = i.length;
            }
            _start(t1) {
                this._lastPoints = t1, ko(t1[0].sub(t1[1])) && (this._valid = !1);
            }
            _move(t1, e1, i) {
                if (this._map._cooperativeGestures && this._currentTouchCount < 3) return;
                const o = t1[0].sub(this._lastPoints[0]), a = t1[1].sub(this._lastPoints[1]);
                return this._valid = this.gestureBeginsVertically(o, a, i.timeStamp), this._valid ? (this._lastPoints = t1, this._active = !0, {
                    pitchDelta: (o.y + a.y) / 2 * -0.5
                }) : void 0;
            }
            gestureBeginsVertically(t1, e1, i) {
                if (void 0 !== this._valid) return this._valid;
                const o = t1.mag() >= 2, a = e1.mag() >= 2;
                if (!o && !a) return;
                if (!o || !a) return void 0 === this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const r = t1.y > 0 == e1.y > 0;
                return ko(t1) && ko(e1) && r;
            }
            constructor(t1){
                super(), this._map = t1;
            }
        }
        const Fo = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class Oo {
            reset() {
                this._active = !1;
            }
            keydown(t1) {
                if (t1.altKey || t1.ctrlKey || t1.metaKey) return;
                let e1 = 0, i = 0, o = 0, a = 0, r = 0;
                switch(t1.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        e1 = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        e1 = -1;
                        break;
                    case 37:
                        t1.shiftKey ? i = -1 : (t1.preventDefault(), a = -1);
                        break;
                    case 39:
                        t1.shiftKey ? i = 1 : (t1.preventDefault(), a = 1);
                        break;
                    case 38:
                        t1.shiftKey ? o = 1 : (t1.preventDefault(), r = -1);
                        break;
                    case 40:
                        t1.shiftKey ? o = -1 : (t1.preventDefault(), r = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, o = 0), {
                    cameraAnimation: (s)=>{
                        const n = s.getZoom();
                        s.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: Uo,
                            zoom: e1 ? Math.round(n) + e1 * (t1.shiftKey ? 2 : 1) : n,
                            bearing: s.getBearing() + i * this._bearingStep,
                            pitch: s.getPitch() + o * this._pitchStep,
                            offset: [
                                -a * this._panStep,
                                -r * this._panStep
                            ],
                            center: s.getCenter()
                        }, {
                            originalEvent: t1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
            constructor(){
                const t1 = Fo;
                this._panStep = t1.panStep, this._bearingStep = t1.bearingStep, this._pitchStep = t1.pitchStep, this._rotationDisabled = !1;
            }
        }
        function Uo(t1) {
            return t1 * (2 - t1);
        }
        const No = 4.000244140625;
        class Go {
            setZoomRate(t1) {
                this._defaultZoomRate = t1;
            }
            setWheelZoomRate(t1) {
                this._wheelZoomRate = t1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(t1) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = t1 && "center" === t1.around);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            wheel(e1) {
                if (!this.isEnabled()) return;
                if (this._map._cooperativeGestures) {
                    if (!this._map._metaPress) return;
                    e1.preventDefault();
                }
                let i = e1.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * e1.deltaY : e1.deltaY;
                const o = t1.exported.now(), a = o - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = o, 0 !== i && i % No == 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : a > 400 ? (this._type = null, this._lastValue = i, this._timeout = setTimeout(this._onTimeout, 40, e1)) : this._type || (this._type = Math.abs(a * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), e1.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = e1, this._delta -= i, this._active || this._start(e1)), e1.preventDefault();
            }
            _onTimeout(t1) {
                this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(t1);
            }
            _start(e1) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const i = r.mousePos(this._el, e1);
                this._around = t1.LngLat.convert(this._aroundCenter ? this._map.getCenter() : this._map.unproject(i)), this._aroundPoint = this._map.transform.locationPoint(this._around), this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const e1 = this._map.transform;
                if (0 !== this._delta) {
                    const t1 = "wheel" === this._type && Math.abs(this._delta) > No ? this._wheelZoomRate : this._defaultZoomRate;
                    let i = 2 / (1 + Math.exp(-Math.abs(this._delta * t1)));
                    this._delta < 0 && 0 !== i && (i = 1 / i);
                    const o = "number" == typeof this._targetZoom ? e1.zoomScale(this._targetZoom) : e1.scale;
                    this._targetZoom = Math.min(e1.maxZoom, Math.max(e1.minZoom, e1.scaleZoom(o * i))), "wheel" === this._type && (this._startZoom = e1.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                }
                const i = "number" == typeof this._targetZoom ? this._targetZoom : e1.zoom, o = this._startZoom, a = this._easing;
                let r, s = !1;
                if ("wheel" === this._type && o && a) {
                    const e1 = Math.min((t1.exported.now() - this._lastWheelEventTime) / 200, 1), n = a(e1);
                    r = t1.number(o, i, n), e1 < 1 ? this._frameId || (this._frameId = !0) : s = !0;
                } else r = i, s = !0;
                return this._active = !0, s && (this._active = !1, this._finishTimeout = setTimeout(()=>{
                    this._zooming = !1, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                }, 200)), {
                    noInertia: !0,
                    needsRenderFrame: !s,
                    zoomDelta: r - e1.zoom,
                    around: this._aroundPoint,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(e1) {
                let i = t1.ease;
                if (this._prevEase) {
                    const e1 = this._prevEase, o = (t1.exported.now() - e1.start) / e1.duration, a = e1.easing(o + .01) - e1.easing(o), r = .27 / Math.sqrt(a * a + 1e-4) * .01, s = Math.sqrt(.0729 - r * r);
                    i = t1.bezier(r, s, .25, 1);
                }
                return this._prevEase = {
                    start: t1.exported.now(),
                    duration: e1,
                    easing: i
                }, i;
            }
            reset() {
                this._active = !1;
            }
            constructor(e1, i){
                this._map = e1, this._el = e1.getCanvasContainer(), this._handler = i, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222, t1.bindAll([
                    "_onTimeout"
                ], this);
            }
        }
        class Zo {
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
            constructor(t1, e1){
                this._clickZoom = t1, this._tapZoom = e1;
            }
        }
        class Vo {
            reset() {
                this._active = !1;
            }
            dblclick(t1, e1) {
                return t1.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: i.getZoom() + (t1.shiftKey ? -1 : 1),
                            around: i.unproject(e1)
                        }, {
                            originalEvent: t1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(){
                this.reset();
            }
        }
        class qo {
            reset() {
                this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, this._tap.reset();
            }
            touchstart(t1, e1, i) {
                this._swipePoint || (this._tapTime && t1.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i.length > 0 && (this._swipePoint = e1[0], this._swipeTouch = i[0].identifier) : this._tap.touchstart(t1, e1, i));
            }
            touchmove(t1, e1, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const o = e1[0], a = o.y - this._swipePoint.y;
                        return this._swipePoint = o, t1.preventDefault(), this._active = !0, {
                            zoomDelta: a / 128
                        };
                    }
                } else this._tap.touchmove(t1, e1, i);
            }
            touchend(t1, e1, i) {
                this._tapTime ? this._swipePoint && 0 === i.length && this.reset() : this._tap.touchend(t1, e1, i) && (this._tapTime = t1.timeStamp);
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(){
                this._tap = new bo({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
        }
        class jo {
            enable(t1) {
                this._inertiaOptions = t1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("maplibregl-touch-drag-pan", "mapboxgl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("maplibregl-touch-drag-pan", "mapboxgl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
            constructor(t1, e1, i){
                this._el = t1, this._mousePan = e1, this._touchPan = i;
            }
        }
        class $o {
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
            constructor(t1, e1, i){
                this._pitchWithRotate = t1.pitchWithRotate, this._mouseRotate = e1, this._mousePitch = i;
            }
        }
        class Xo {
            enable(t1) {
                this._touchZoom.enable(t1), this._rotationDisabled || this._touchRotate.enable(t1), this._tapDragZoom.enable(), this._el.classList.add("maplibregl-touch-zoom-rotate", "mapboxgl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("maplibregl-touch-zoom-rotate", "mapboxgl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
            constructor(t1, e1, i, o){
                this._el = t1, this._touchZoom = e1, this._touchRotate = i, this._tapDragZoom = o, this._rotationDisabled = !1, this._enabled = !0;
            }
        }
        const Wo = (t1)=>t1.zoom || t1.drag || t1.pitch || t1.rotate;
        class Ho extends t1.Event {
        }
        function Ko(t1) {
            return t1.panDelta && t1.panDelta.mag() || t1.zoomDelta || t1.bearingDelta || t1.pitchDelta;
        }
        class Yo {
            destroy() {
                for (const [t1, e1, i] of this._listeners)r.removeEventListener(t1, e1, t1 === document ? this.handleWindowEvent : this.handleEvent, i);
            }
            _addDefaultHandlers(t1) {
                const e1 = this._map, i = e1.getCanvasContainer();
                this._add("mapEvent", new fo(e1, t1));
                const o = e1.boxZoom = new xo(e1, t1);
                this._add("boxZoom", o);
                const a = new wo, r = new Vo;
                e1.doubleClickZoom = new Zo(r, a), this._add("tapZoom", a), this._add("clickZoom", r);
                const s = new qo;
                this._add("tapDragZoom", s);
                const n = e1.touchPitch = new Bo(e1);
                this._add("touchPitch", n);
                const l = new Co(t1), c = new So(t1);
                e1.dragRotate = new $o(t1, l, c), this._add("mouseRotate", l, [
                    "mousePitch"
                ]), this._add("mousePitch", c, [
                    "mouseRotate"
                ]);
                const h = new Io(t1), u = new Do(t1, e1);
                e1.dragPan = new jo(i, h, u), this._add("mousePan", h), this._add("touchPan", u, [
                    "touchZoom",
                    "touchRotate"
                ]);
                const d = new Ro, m = new Ao;
                e1.touchZoomRotate = new Xo(i, m, d, s), this._add("touchRotate", d, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", m, [
                    "touchPan",
                    "touchRotate"
                ]);
                const _ = e1.scrollZoom = new Go(e1, this);
                this._add("scrollZoom", _, [
                    "mousePan"
                ]);
                const p = e1.keyboard = new Oo;
                this._add("keyboard", p), this._add("blockableMapEvent", new go(e1));
                for (const i of [
                    "boxZoom",
                    "doubleClickZoom",
                    "tapDragZoom",
                    "touchPitch",
                    "dragRotate",
                    "dragPan",
                    "touchZoomRotate",
                    "scrollZoom",
                    "keyboard"
                ])t1.interactive && t1[i] && e1[i].enable(t1[i]);
            }
            _add(t1, e1, i) {
                this._handlers.push({
                    handlerName: t1,
                    handler: e1,
                    allowed: i
                }), this._handlersById[t1] = e1;
            }
            stop(t1) {
                if (!this._updatingCamera) {
                    for (const { handler: t1 } of this._handlers)t1.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, t1), this._changes = [];
                }
            }
            isActive() {
                for (const { handler: t1 } of this._handlers)if (t1.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return Boolean(Wo(this._eventsInProgress)) || this.isZooming();
            }
            _blockedByActive(t1, e1, i) {
                for(const o in t1)if (o !== i && (!e1 || e1.indexOf(o) < 0)) return !0;
                return !1;
            }
            handleWindowEvent(t1) {
                this.handleEvent(t1, `${t1.type}Window`);
            }
            _getMapTouches(t1) {
                const e1 = [];
                for (const i of t1)this._el.contains(i.target) && e1.push(i);
                return e1;
            }
            handleEvent(t1, e1) {
                if ("blur" === t1.type) return void this.stop(!0);
                this._updatingCamera = !0;
                const i = "renderFrame" === t1.type ? void 0 : t1, o = {
                    needsRenderFrame: !1
                }, a = {}, s = {}, n = t1.touches, l = n ? this._getMapTouches(n) : void 0, c = l ? r.touchPos(this._el, l) : r.mousePos(this._el, t1);
                for (const { handlerName: r, handler: n, allowed: h } of this._handlers){
                    if (!n.isEnabled()) continue;
                    let u;
                    this._blockedByActive(s, h, r) ? n.reset() : n[e1 || t1.type] && (u = n[e1 || t1.type](t1, c, l), this.mergeHandlerResult(o, a, u, r, i), u && u.needsRenderFrame && this._triggerRenderFrame()), (u || n.isActive()) && (s[r] = n);
                }
                const h = {};
                for(const t1 in this._previousActiveHandlers)s[t1] || (h[t1] = i);
                this._previousActiveHandlers = s, (Object.keys(h).length || Ko(o)) && (this._changes.push([
                    o,
                    a,
                    h
                ]), this._triggerRenderFrame()), (Object.keys(s).length || Ko(o)) && this._map._stop(!0), this._updatingCamera = !1;
                const { cameraAnimation: u } = o;
                u && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], u(this._map));
            }
            mergeHandlerResult(e1, i, o, a, r) {
                if (!o) return;
                t1.extend(e1, o);
                const s = {
                    handlerName: a,
                    originalEvent: o.originalEvent || r
                };
                void 0 !== o.zoomDelta && (i.zoom = s), void 0 !== o.panDelta && (i.drag = s), void 0 !== o.pitchDelta && (i.pitch = s), void 0 !== o.bearingDelta && (i.rotate = s);
            }
            _applyChanges() {
                const e1 = {}, i = {}, o = {};
                for (const [a, r, s] of this._changes)a.panDelta && (e1.panDelta = (e1.panDelta || new t1.pointGeometry(0, 0))._add(a.panDelta)), a.zoomDelta && (e1.zoomDelta = (e1.zoomDelta || 0) + a.zoomDelta), a.bearingDelta && (e1.bearingDelta = (e1.bearingDelta || 0) + a.bearingDelta), a.pitchDelta && (e1.pitchDelta = (e1.pitchDelta || 0) + a.pitchDelta), void 0 !== a.around && (e1.around = a.around), void 0 !== a.pinchAround && (e1.pinchAround = a.pinchAround), a.noInertia && (e1.noInertia = a.noInertia), t1.extend(i, r), t1.extend(o, s);
                this._updateMapTransform(e1, i, o), this._changes = [];
            }
            _updateMapTransform(e1, i, o) {
                const a = this._map, r = a.transform, s = a.style && a.style.terrain;
                if (!(Ko(e1) || s && this._drag)) return this._fireEvents(i, o, !0);
                let { panDelta: n, zoomDelta: l, bearingDelta: c, pitchDelta: h, around: u, pinchAround: d } = e1;
                void 0 !== d && (u = d), a._stop(!0), u = u || a.transform.centerPoint;
                const m = r.pointLocation(n ? u.sub(n) : u);
                c && (r.bearing += c), h && (r.pitch += h), l && (r.zoom += l), s ? i.drag && !this._drag ? (this._drag = {
                    center: r.centerPoint,
                    lngLat: r.pointLocation(u),
                    point: u,
                    handlerName: i.drag.handlerName
                }, a.fire(new t1.Event("freezeElevation", {
                    freeze: !0
                }))) : this._drag && o[this._drag.handlerName] ? (a.fire(new t1.Event("freezeElevation", {
                    freeze: !1
                })), this._drag = null) : i.drag && this._drag && (r.center = r.pointLocation(r.centerPoint.sub(n))) : r.setLocationAtPoint(m, u), this._map._update(), e1.noInertia || this._inertia.record(e1), this._fireEvents(i, o, !0);
            }
            _fireEvents(e1, i, o) {
                const a = Wo(this._eventsInProgress), r = Wo(e1), s = {};
                for(const t1 in e1){
                    const { originalEvent: i } = e1[t1];
                    this._eventsInProgress[t1] || (s[`${t1}start`] = i), this._eventsInProgress[t1] = e1[t1];
                }
                !a && r && this._fireEvent("movestart", r.originalEvent);
                for(const t1 in s)this._fireEvent(t1, s[t1]);
                r && this._fireEvent("move", r.originalEvent);
                for(const t1 in e1){
                    const { originalEvent: i } = e1[t1];
                    this._fireEvent(t1, i);
                }
                const n = {};
                let l;
                for(const t1 in this._eventsInProgress){
                    const { handlerName: e1, originalEvent: o } = this._eventsInProgress[t1];
                    this._handlersById[e1].isActive() || (delete this._eventsInProgress[t1], l = i[e1] || o, n[`${t1}end`] = l);
                }
                for(const t1 in n)this._fireEvent(t1, n[t1]);
                const c = Wo(this._eventsInProgress);
                if (o && (a || r) && !c) {
                    this._updatingCamera = !0;
                    const e1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (t1)=>0 !== t1 && -this._bearingSnap < t1 && t1 < this._bearingSnap;
                    e1 ? (i(e1.bearing || this._map.getBearing()) && (e1.bearing = 0), this._map.easeTo(e1, {
                        originalEvent: l
                    })) : (this._map.fire(new t1.Event("moveend", {
                        originalEvent: l
                    })), i(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
                }
            }
            _fireEvent(e1, i) {
                this._map.fire(new t1.Event(e1, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((t1)=>{
                    delete this._frameId, this.handleEvent(new Ho("renderFrame", {
                        timeStamp: t1
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
            constructor(e1, i){
                this._map = e1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new co(e1), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(i), t1.bindAll([
                    "handleEvent",
                    "handleWindowEvent"
                ], this);
                const o = this._el;
                this._listeners = [
                    [
                        o,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        o,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "touchend",
                        void 0
                    ],
                    [
                        o,
                        "touchcancel",
                        void 0
                    ],
                    [
                        o,
                        "mousedown",
                        void 0
                    ],
                    [
                        o,
                        "mousemove",
                        void 0
                    ],
                    [
                        o,
                        "mouseup",
                        void 0
                    ],
                    [
                        document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        document,
                        "mouseup",
                        void 0
                    ],
                    [
                        o,
                        "mouseover",
                        void 0
                    ],
                    [
                        o,
                        "mouseout",
                        void 0
                    ],
                    [
                        o,
                        "dblclick",
                        void 0
                    ],
                    [
                        o,
                        "click",
                        void 0
                    ],
                    [
                        o,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        o,
                        "keyup",
                        void 0
                    ],
                    [
                        o,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "contextmenu",
                        void 0
                    ],
                    [
                        window,
                        "blur",
                        void 0
                    ]
                ];
                for (const [t1, e1, i] of this._listeners)r.addEventListener(t1, e1, t1 === document ? this.handleWindowEvent : this.handleEvent, i);
            }
        }
        const Jo = {
            extend: (e1, ...i)=>t1.extend(e1, ...i),
            run (t1) {
                t1();
            },
            logToElement (t1, e1 = !1, i = "log") {
                const o = window.document.getElementById(i);
                o && (e1 && (o.innerHTML = ""), o.innerHTML += `<br>${t1}`);
            }
        };
        class Qo extends t1.Evented {
            getCenter() {
                return new t1.LngLat(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(t1, e1) {
                return this.jumpTo({
                    center: t1
                }, e1);
            }
            panBy(e1, i, o) {
                return e1 = t1.pointGeometry.convert(e1).mult(-1), this.panTo(this.transform.center, t1.extend({
                    offset: e1
                }, i), o);
            }
            panTo(e1, i, o) {
                return this.easeTo(t1.extend({
                    center: e1
                }, i), o);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(t1, e1) {
                return this.jumpTo({
                    zoom: t1
                }, e1), this;
            }
            zoomTo(e1, i, o) {
                return this.easeTo(t1.extend({
                    zoom: e1
                }, i), o);
            }
            zoomIn(t1, e1) {
                return this.zoomTo(this.getZoom() + 1, t1, e1), this;
            }
            zoomOut(t1, e1) {
                return this.zoomTo(this.getZoom() - 1, t1, e1), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(t1, e1) {
                return this.jumpTo({
                    bearing: t1
                }, e1), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(t1, e1) {
                return this.jumpTo({
                    padding: t1
                }, e1), this;
            }
            rotateTo(e1, i, o) {
                return this.easeTo(t1.extend({
                    bearing: e1
                }, i), o);
            }
            resetNorth(e1, i) {
                return this.rotateTo(0, t1.extend({
                    duration: 1e3
                }, e1), i), this;
            }
            resetNorthPitch(e1, i) {
                return this.easeTo(t1.extend({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3
                }, e1), i), this;
            }
            snapToNorth(t1, e1) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(t1, e1) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(t1, e1) {
                return this.jumpTo({
                    pitch: t1
                }, e1), this;
            }
            cameraForBounds(e1, i) {
                e1 = t1.LngLatBounds.convert(e1);
                const o = i && i.bearing || 0;
                return this._cameraForBoxAndBearing(e1.getNorthWest(), e1.getSouthEast(), o, i);
            }
            _cameraForBoxAndBearing(e1, i, o, a) {
                const r = {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0
                };
                if ("number" == typeof (a = t1.extend({
                    padding: r,
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, a)).padding) {
                    const t1 = a.padding;
                    a.padding = {
                        top: t1,
                        bottom: t1,
                        right: t1,
                        left: t1
                    };
                }
                a.padding = t1.extend(r, a.padding);
                const s = this.transform, n = s.padding, l = s.project(t1.LngLat.convert(e1)), c = s.project(t1.LngLat.convert(i)), h = l.rotate(-o * Math.PI / 180), u = c.rotate(-o * Math.PI / 180), d = new t1.pointGeometry(Math.max(h.x, u.x), Math.max(h.y, u.y)), m = new t1.pointGeometry(Math.min(h.x, u.x), Math.min(h.y, u.y)), _ = d.sub(m), p = (s.width - (n.left + n.right + a.padding.left + a.padding.right)) / _.x, f = (s.height - (n.top + n.bottom + a.padding.top + a.padding.bottom)) / _.y;
                if (f < 0 || p < 0) return void t1.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                const g = Math.min(s.scaleZoom(s.scale * Math.min(p, f)), a.maxZoom), x = t1.pointGeometry.convert(a.offset), v = new t1.pointGeometry((a.padding.left - a.padding.right) / 2, (a.padding.top - a.padding.bottom) / 2).rotate(o * Math.PI / 180), y = x.add(v).mult(s.scale / s.zoomScale(g));
                return {
                    center: s.unproject(l.add(c).div(2).sub(y)),
                    zoom: g,
                    bearing: o
                };
            }
            fitBounds(t1, e1, i) {
                return this._fitInternal(this.cameraForBounds(t1, e1), e1, i);
            }
            fitScreenCoordinates(e1, i, o, a, r) {
                return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(t1.pointGeometry.convert(e1)), this.transform.pointLocation(t1.pointGeometry.convert(i)), o, a), a, r);
            }
            _fitInternal(e1, i, o) {
                return e1 ? (delete (i = t1.extend(e1, i)).padding, i.linear ? this.easeTo(i, o) : this.flyTo(i, o)) : this;
            }
            jumpTo(e1, i) {
                this.stop();
                const o = this.transform;
                let a = !1, r = !1, s = !1;
                return "zoom" in e1 && o.zoom !== +e1.zoom && (a = !0, o.zoom = +e1.zoom), void 0 !== e1.center && (o.center = t1.LngLat.convert(e1.center)), "bearing" in e1 && o.bearing !== +e1.bearing && (r = !0, o.bearing = +e1.bearing), "pitch" in e1 && o.pitch !== +e1.pitch && (s = !0, o.pitch = +e1.pitch), null == e1.padding || o.isPaddingEqual(e1.padding) || (o.padding = e1.padding), this.fire(new t1.Event("movestart", i)).fire(new t1.Event("move", i)), a && this.fire(new t1.Event("zoomstart", i)).fire(new t1.Event("zoom", i)).fire(new t1.Event("zoomend", i)), r && this.fire(new t1.Event("rotatestart", i)).fire(new t1.Event("rotate", i)).fire(new t1.Event("rotateend", i)), s && this.fire(new t1.Event("pitchstart", i)).fire(new t1.Event("pitch", i)).fire(new t1.Event("pitchend", i)), this.fire(new t1.Event("moveend", i));
            }
            calculateCameraOptionsFromTo(e1, i, o, a = 0) {
                const r = t1.MercatorCoordinate.fromLngLat(e1, i), s = t1.MercatorCoordinate.fromLngLat(o, a), n = s.x - r.x, l = s.y - r.y, c = s.z - r.z, h = Math.hypot(n, l, c);
                if (0 === h) throw new Error("Can't calculate camera options with same From and To");
                const u = Math.hypot(n, l), d = this.transform.scaleZoom(this.transform.cameraToCenterDistance / h / this.transform.tileSize), m = 180 * Math.atan2(n, -l) / Math.PI;
                let _ = 180 * Math.acos(u / h) / Math.PI;
                return _ = c < 0 ? 90 - _ : 90 + _, {
                    center: s.toLngLat(),
                    zoom: d,
                    pitch: _,
                    bearing: m
                };
            }
            easeTo(e1, i) {
                this._stop(!1, e1.easeId), (!1 === (e1 = t1.extend({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: t1.ease
                }, e1)).animate || !e1.essential && t1.exported.prefersReducedMotion) && (e1.duration = 0);
                const o = this.transform, a = this.getZoom(), r = this.getBearing(), s = this.getPitch(), n = this.getPadding(), l = "zoom" in e1 ? +e1.zoom : a, c = "bearing" in e1 ? this._normalizeBearing(e1.bearing, r) : r, h = "pitch" in e1 ? +e1.pitch : s, u = "padding" in e1 ? e1.padding : o.padding, d = t1.pointGeometry.convert(e1.offset);
                let m = o.centerPoint.add(d);
                const _ = o.pointLocation(m), p = t1.LngLat.convert(e1.center || _);
                this._normalizeCenter(p);
                const f = o.project(_), g = o.project(p).sub(f), x = o.zoomScale(l - a);
                let v, y;
                e1.around && (v = t1.LngLat.convert(e1.around), y = o.locationPoint(v));
                const b = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = this._zooming || l !== a, this._rotating = this._rotating || r !== c, this._pitching = this._pitching || h !== s, this._padding = !o.isPaddingEqual(u), this._easeId = e1.easeId, this._prepareEase(i, e1.noMoveStart, b), this._ease((e1)=>{
                    if (this._zooming && (o.zoom = t1.number(a, l, e1)), this._rotating && (o.bearing = t1.number(r, c, e1)), this._pitching && (o.pitch = t1.number(s, h, e1)), this._padding && (o.interpolatePadding(n, u, e1), m = o.centerPoint.add(d)), v) o.setLocationAtPoint(v, y);
                    else {
                        const t1 = o.zoomScale(o.zoom - a), i = l > a ? Math.min(2, x) : Math.max(.5, x), r = Math.pow(i, 1 - e1), s = o.unproject(f.add(g.mult(e1 * r)).mult(t1));
                        o.setLocationAtPoint(o.renderWorldCopies ? s.wrap() : s, m);
                    }
                    this._fireMoveEvents(i);
                }, (t1)=>{
                    this._afterEase(i, t1);
                }, e1), this;
            }
            _prepareEase(e1, i, o = {}) {
                this._moving = !0, this.fire(new t1.Event("freezeElevation", {
                    freeze: !0
                })), i || o.moving || this.fire(new t1.Event("movestart", e1)), this._zooming && !o.zooming && this.fire(new t1.Event("zoomstart", e1)), this._rotating && !o.rotating && this.fire(new t1.Event("rotatestart", e1)), this._pitching && !o.pitching && this.fire(new t1.Event("pitchstart", e1));
            }
            _fireMoveEvents(e1) {
                this.fire(new t1.Event("move", e1)), this._zooming && this.fire(new t1.Event("zoom", e1)), this._rotating && this.fire(new t1.Event("rotate", e1)), this._pitching && this.fire(new t1.Event("pitch", e1));
            }
            _afterEase(e1, i) {
                if (this._easeId && i && this._easeId === i) return;
                delete this._easeId, this.fire(new t1.Event("freezeElevation", {
                    freeze: !1
                }));
                const o = this._zooming, a = this._rotating, r = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, o && this.fire(new t1.Event("zoomend", e1)), a && this.fire(new t1.Event("rotateend", e1)), r && this.fire(new t1.Event("pitchend", e1)), this.fire(new t1.Event("moveend", e1));
            }
            flyTo(e1, i) {
                if (!e1.essential && t1.exported.prefersReducedMotion) {
                    const o = t1.pick(e1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "around"
                    ]);
                    return this.jumpTo(o, i);
                }
                this.stop(), e1 = t1.extend({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: t1.ease
                }, e1);
                const o = this.transform, a = this.getZoom(), r = this.getBearing(), s = this.getPitch(), n = this.getPadding(), l = "zoom" in e1 ? t1.clamp(+e1.zoom, o.minZoom, o.maxZoom) : a, c = "bearing" in e1 ? this._normalizeBearing(e1.bearing, r) : r, h = "pitch" in e1 ? +e1.pitch : s, u = "padding" in e1 ? e1.padding : o.padding, d = o.zoomScale(l - a), m = t1.pointGeometry.convert(e1.offset);
                let _ = o.centerPoint.add(m);
                const p = o.pointLocation(_), f = t1.LngLat.convert(e1.center || p);
                this._normalizeCenter(f);
                const g = o.project(p), x = o.project(f).sub(g);
                let v = e1.curve;
                const y = Math.max(o.width, o.height), b = y / d, w = x.mag();
                if ("minZoom" in e1) {
                    const i = t1.clamp(Math.min(e1.minZoom, a, l), o.minZoom, o.maxZoom), r = y / o.zoomScale(i - a);
                    v = Math.sqrt(r / w * 2);
                }
                const T = v * v;
                function E(t1) {
                    const e1 = (b * b - y * y + (t1 ? -1 : 1) * T * T * w * w) / (2 * (t1 ? b : y) * T * w);
                    return Math.log(Math.sqrt(e1 * e1 + 1) - e1);
                }
                function I(t1) {
                    return (Math.exp(t1) - Math.exp(-t1)) / 2;
                }
                function C(t1) {
                    return (Math.exp(t1) + Math.exp(-t1)) / 2;
                }
                const S = E(0);
                let D = function(t1) {
                    return C(S) / C(S + v * t1);
                }, z = function(t1) {
                    var e1;
                    return y * ((C(S) * (I(e1 = S + v * t1) / C(e1)) - I(S)) / T) / w;
                }, P = (E(1) - S) / v;
                if (Math.abs(w) < 1e-6 || !isFinite(P)) {
                    if (Math.abs(y - b) < 1e-6) return this.easeTo(e1, i);
                    const t1 = b < y ? -1 : 1;
                    P = Math.abs(Math.log(b / y)) / v, z = function() {
                        return 0;
                    }, D = function(e1) {
                        return Math.exp(t1 * v * e1);
                    };
                }
                return e1.duration = "duration" in e1 ? +e1.duration : 1e3 * P / ("screenSpeed" in e1 ? +e1.screenSpeed / v : +e1.speed), e1.maxDuration && e1.duration > e1.maxDuration && (e1.duration = 0), this._zooming = !0, this._rotating = r !== c, this._pitching = h !== s, this._padding = !o.isPaddingEqual(u), this._prepareEase(i, !1), this._ease((e1)=>{
                    const d = e1 * P, p = 1 / D(d);
                    o.zoom = 1 === e1 ? l : a + o.scaleZoom(p), this._rotating && (o.bearing = t1.number(r, c, e1)), this._pitching && (o.pitch = t1.number(s, h, e1)), this._padding && (o.interpolatePadding(n, u, e1), _ = o.centerPoint.add(m));
                    const v = 1 === e1 ? f : o.unproject(g.add(x.mult(z(d))).mult(p));
                    o.setLocationAtPoint(o.renderWorldCopies ? v.wrap() : v, _), this._fireMoveEvents(i);
                }, ()=>this._afterEase(i), e1), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _stop(t1, e1) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                    const t1 = this._onEaseEnd;
                    delete this._onEaseEnd, t1.call(this, e1);
                }
                if (!t1) {
                    const t1 = this.handlers;
                    t1 && t1.stop(!1);
                }
                return this;
            }
            _ease(e1, i, o) {
                !1 === o.animate || 0 === o.duration ? (e1(1), i()) : (this._easeStart = t1.exported.now(), this._easeOptions = o, this._onEaseFrame = e1, this._onEaseEnd = i, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _renderFrameCallback() {
                const e1 = Math.min((t1.exported.now() - this._easeStart) / this._easeOptions.duration, 1);
                this._onEaseFrame(this._easeOptions.easing(e1)), e1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }
            _normalizeBearing(e1, i) {
                e1 = t1.wrap(e1, -180, 180);
                const o = Math.abs(e1 - i);
                return Math.abs(e1 - 360 - i) < o && (e1 -= 360), Math.abs(e1 + 360 - i) < o && (e1 += 360), e1;
            }
            _normalizeCenter(t1) {
                const e1 = this.transform;
                if (!e1.renderWorldCopies || e1.lngRange) return;
                const i = t1.lng - e1.center.lng;
                t1.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
            }
            constructor(e1, i){
                super(), this._moving = !1, this._zooming = !1, this.transform = e1, this._bearingSnap = i.bearingSnap, t1.bindAll([
                    "_renderFrameCallback"
                ], this);
            }
        }
        class ta {
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(t1) {
                return this._map = t1, this._compact = this.options && this.options.compact, this._container = r.create("details", "maplibregl-ctrl maplibregl-ctrl-attrib mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = r.create("summary", "maplibregl-ctrl-attrib-button mapboxgl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = r.create("div", "maplibregl-ctrl-attrib-inner mapboxgl-ctrl-attrib-inner", this._container), this._updateAttributions(), this._updateCompact(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("terrain", this._updateData), this._map.on("resize", this._updateCompact), this._map.on("drag", this._updateCompactMinimize), this._container;
            }
            onRemove() {
                r.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("terrain", this._updateData), this._map.off("resize", this._updateCompact), this._map.off("drag", this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
            }
            _setElementTitle(t1, e1) {
                const i = this._map._getUIString(`AttributionControl.${e1}`);
                t1.title = i, t1.setAttribute("aria-label", i);
            }
            _toggleAttribution() {
                this._container.classList.contains("maplibregl-compact") && (this._container.classList.contains("maplibregl-compact-show") ? (this._container.setAttribute("open", ""), this._container.classList.remove("maplibregl-compact-show", "mapboxgl-compact-show")) : (this._container.classList.add("maplibregl-compact-show", "mapboxgl-compact-show"), this._container.removeAttribute("open")));
            }
            _updateData(t1) {
                !t1 || "metadata" !== t1.sourceDataType && "visibility" !== t1.sourceDataType && "style" !== t1.dataType && "terrain" !== t1.type || this._updateAttributions();
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let t1 = [];
                if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? t1 = t1.concat(this.options.customAttribution.map((t1)=>"string" != typeof t1 ? "" : t1)) : "string" == typeof this.options.customAttribution && t1.push(this.options.customAttribution)), this._map.style.stylesheet) {
                    const t1 = this._map.style.stylesheet;
                    this.styleOwner = t1.owner, this.styleId = t1.id;
                }
                const e1 = this._map.style.sourceCaches;
                for(const i in e1){
                    const o = e1[i];
                    if (o.used || o.usedForTerrain) {
                        const e1 = o.getSource();
                        e1.attribution && t1.indexOf(e1.attribution) < 0 && t1.push(e1.attribution);
                    }
                }
                t1 = t1.filter((t1)=>String(t1).trim()), t1.sort((t1, e1)=>t1.length - e1.length), t1 = t1.filter((e1, i)=>{
                    for(let o = i + 1; o < t1.length; o++)if (t1[o].indexOf(e1) >= 0) return !1;
                    return !0;
                });
                const i = t1.join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, t1.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("maplibregl-attrib-empty", "mapboxgl-attrib-empty")) : this._container.classList.add("maplibregl-attrib-empty", "mapboxgl-attrib-empty"), this._updateCompact(), this._editLink = null);
            }
            _updateCompact() {
                this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 === this._compact ? this._container.setAttribute("open", "") : this._container.classList.contains("maplibregl-compact") || this._container.classList.contains("maplibregl-attrib-empty") || (this._container.setAttribute("open", ""), this._container.classList.add("maplibregl-compact", "mapboxgl-compact", "maplibregl-compact-show", "mapboxgl-compact-show")) : (this._container.setAttribute("open", ""), this._container.classList.contains("maplibregl-compact") && this._container.classList.remove("maplibregl-compact", "maplibregl-compact-show", "mapboxgl-compact", "mapboxgl-compact-show"));
            }
            _updateCompactMinimize() {
                this._container.classList.contains("maplibregl-compact") && this._container.classList.contains("maplibregl-compact-show") && this._container.classList.remove("maplibregl-compact-show", "mapboxgl-compact-show");
            }
            constructor(e1 = {}){
                this.options = e1, t1.bindAll([
                    "_toggleAttribution",
                    "_updateData",
                    "_updateCompact",
                    "_updateCompactMinimize"
                ], this);
            }
        }
        class ea {
            getDefaultPosition() {
                return "bottom-left";
            }
            onAdd(t1) {
                this._map = t1, this._compact = this.options && this.options.compact, this._container = r.create("div", "maplibregl-ctrl mapboxgl-ctrl");
                const e1 = r.create("a", "maplibregl-ctrl-logo mapboxgl-ctrl-logo");
                return e1.target = "_blank", e1.rel = "noopener nofollow", e1.href = "https://maplibre.org/", e1.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), e1.setAttribute("rel", "noopener nofollow"), this._container.appendChild(e1), this._container.style.display = "block", this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                r.remove(this._container), this._map.off("resize", this._updateCompact), this._map = void 0, this._compact = void 0;
            }
            _updateCompact() {
                const t1 = this._container.children;
                if (t1.length) {
                    const e1 = t1[0];
                    this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 !== this._compact && e1.classList.add("maplibregl-compact", "mapboxgl-compact") : e1.classList.remove("maplibregl-compact", "mapboxgl-compact");
                }
            }
            constructor(e1 = {}){
                this.options = e1, t1.bindAll([
                    "_updateCompact"
                ], this);
            }
        }
        class ia {
            add(t1) {
                const e1 = ++this._id;
                return this._queue.push({
                    callback: t1,
                    id: e1,
                    cancelled: !1
                }), e1;
            }
            remove(t1) {
                const e1 = this._currentlyRunning, i = e1 ? this._queue.concat(e1) : this._queue;
                for (const e1 of i)if (e1.id === t1) return void (e1.cancelled = !0);
            }
            run(t1 = 0) {
                if (this._currentlyRunning) throw new Error("Attempting to run(), but is already running.");
                const e1 = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of e1)if (!i.cancelled && (i.callback(t1), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
        }
        const oa = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "AttributionControl.MapFeedback": "Map feedback",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox logo",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScaleControl.Feet": "ft",
            "ScaleControl.Meters": "m",
            "ScaleControl.Kilometers": "km",
            "ScaleControl.Miles": "mi",
            "ScaleControl.NauticalMiles": "nm",
            "TerrainControl.enableTerrain": "Enable terrain",
            "TerrainControl.disableTerrain": "Disable terrain"
        }, aa = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 60,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: void 0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            maplibreLogo: !1,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            maxTileCacheSize: null,
            localIdeographFontFamily: "sans-serif",
            transformRequest: null,
            fadeDuration: 300,
            crossSourceCollisions: !0
        }, ra = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        };
        class sa {
            down(t1, e1) {
                this.mouseRotate.mousedown(t1, e1), this.mousePitch && this.mousePitch.mousedown(t1, e1), r.disableDrag();
            }
            move(t1, e1) {
                const i = this.map, o = this.mouseRotate.mousemoveWindow(t1, e1);
                if (o && o.bearingDelta && i.setBearing(i.getBearing() + o.bearingDelta), this.mousePitch) {
                    const o = this.mousePitch.mousemoveWindow(t1, e1);
                    o && o.pitchDelta && i.setPitch(i.getPitch() + o.pitchDelta);
                }
            }
            off() {
                const t1 = this.element;
                r.removeEventListener(t1, "mousedown", this.mousedown), r.removeEventListener(t1, "touchstart", this.touchstart, {
                    passive: !1
                }), r.removeEventListener(t1, "touchmove", this.touchmove), r.removeEventListener(t1, "touchend", this.touchend), r.removeEventListener(t1, "touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                r.enableDrag(), r.removeEventListener(window, "mousemove", this.mousemove), r.removeEventListener(window, "mouseup", this.mouseup);
            }
            mousedown(e1) {
                this.down(t1.extend({}, e1, {
                    ctrlKey: !0,
                    preventDefault: ()=>e1.preventDefault()
                }), r.mousePos(this.element, e1)), r.addEventListener(window, "mousemove", this.mousemove), r.addEventListener(window, "mouseup", this.mouseup);
            }
            mousemove(t1) {
                this.move(t1, r.mousePos(this.element, t1));
            }
            mouseup(t1) {
                this.mouseRotate.mouseupWindow(t1), this.mousePitch && this.mousePitch.mouseupWindow(t1), this.offTemp();
            }
            touchstart(t1) {
                1 !== t1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = r.touchPos(this.element, t1.targetTouches)[0], this.down({
                    type: "mousedown",
                    button: 0,
                    ctrlKey: !0,
                    preventDefault: ()=>t1.preventDefault()
                }, this._startPos));
            }
            touchmove(t1) {
                1 !== t1.targetTouches.length ? this.reset() : (this._lastPos = r.touchPos(this.element, t1.targetTouches)[0], this.move({
                    preventDefault: ()=>t1.preventDefault()
                }, this._lastPos));
            }
            touchend(t1) {
                0 === t1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
            }
            reset() {
                this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
            }
            constructor(e1, i, o = !1){
                this._clickTolerance = 10, this.element = i, this.mouseRotate = new Co({
                    clickTolerance: e1.dragRotate._mouseRotate._clickTolerance
                }), this.map = e1, o && (this.mousePitch = new So({
                    clickTolerance: e1.dragRotate._mousePitch._clickTolerance
                })), t1.bindAll([
                    "mousedown",
                    "mousemove",
                    "mouseup",
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "reset"
                ], this), r.addEventListener(i, "mousedown", this.mousedown), r.addEventListener(i, "touchstart", this.touchstart, {
                    passive: !1
                }), r.addEventListener(i, "touchmove", this.touchmove), r.addEventListener(i, "touchend", this.touchend), r.addEventListener(i, "touchcancel", this.reset);
            }
        }
        function na(e1, i, o) {
            if (e1 = new t1.LngLat(e1.lng, e1.lat), i) {
                const a = new t1.LngLat(e1.lng - 360, e1.lat), r = new t1.LngLat(e1.lng + 360, e1.lat), s = o.locationPoint(e1).distSqr(i);
                o.locationPoint(a).distSqr(i) < s ? e1 = a : o.locationPoint(r).distSqr(i) < s && (e1 = r);
            }
            for(; Math.abs(e1.lng - o.center.lng) > 180;){
                const t1 = o.locationPoint(e1);
                if (t1.x >= 0 && t1.y >= 0 && t1.x <= o.width && t1.y <= o.height) break;
                e1.lng > o.center.lng ? e1.lng -= 360 : e1.lng += 360;
            }
            return e1;
        }
        const la = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        function ca(t1, e1, i) {
            const o = t1.classList;
            for(const t1 in la)o.remove(`maplibregl-${i}-anchor-${t1}`, `mapboxgl-${i}-anchor-${t1}`);
            o.add(`maplibregl-${i}-anchor-${e1}`, `mapboxgl-${i}-anchor-${e1}`);
        }
        class ha extends t1.Evented {
            addTo(t1) {
                return this.remove(), this._map = t1, t1.getCanvasContainer().appendChild(this._element), t1.on("move", this._update), t1.on("moveend", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
            }
            remove() {
                return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), r.remove(this._element), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(e1) {
                return this._lngLat = t1.LngLat.convert(e1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
            }
            getElement() {
                return this._element;
            }
            setPopup(t1) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), t1) {
                    if (!("offset" in t1.options)) {
                        const e1 = 38.1, i = 13.5, o = Math.sqrt(Math.pow(i, 2) / 2);
                        t1.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -e1
                            ],
                            "bottom-left": [
                                o,
                                -1 * (e1 - i + o)
                            ],
                            "bottom-right": [
                                -o,
                                -1 * (e1 - i + o)
                            ],
                            left: [
                                i,
                                -1 * (e1 - i)
                            ],
                            right: [
                                -i,
                                -1 * (e1 - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = t1, this._lngLat && this._popup.setLngLat(this._lngLat), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                }
                return this;
            }
            _onKeyPress(t1) {
                const e1 = t1.code, i = t1.charCode || t1.keyCode;
                "Space" !== e1 && "Enter" !== e1 && 32 !== i && 13 !== i || this.togglePopup();
            }
            _onMapClick(t1) {
                const e1 = t1.originalEvent.target, i = this._element;
                this._popup && (e1 === i || i.contains(e1)) && this.togglePopup();
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const t1 = this._popup;
                return t1 ? (t1.isOpen() ? t1.remove() : t1.addTo(this._map), this) : this;
            }
            _update(t1) {
                if (!this._map) return;
                this._map.transform.renderWorldCopies && (this._lngLat = na(this._lngLat, this._pos, this._map.transform)), this._pos = this._map.project(this._lngLat)._add(this._offset);
                let e1 = "";
                "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? e1 = `rotateZ(${this._rotation}deg)` : "map" === this._rotationAlignment && (e1 = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
                let i = "";
                "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? i = "rotateX(0deg)" : "map" === this._pitchAlignment && (i = `rotateX(${this._map.getPitch()}deg)`), t1 && "moveend" !== t1.type || (this._pos = this._pos.round()), r.setTransform(this._element, `${la[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${i} ${e1}`), this._map.style && this._map.style.terrain && !this._opacityTimeout && (this._opacityTimeout = setTimeout(()=>{
                    const t1 = this._map.unproject(this._pos), e1 = 40075016.686 * Math.abs(Math.cos(this._lngLat.lat * Math.PI / 180)) / Math.pow(2, this._map.transform.tileZoom + 8);
                    this._element.style.opacity = t1.distanceTo(this._lngLat) > 20 * e1 ? "0.2" : "1.0", this._opacityTimeout = null;
                }, 100));
            }
            getOffset() {
                return this._offset;
            }
            setOffset(e1) {
                return this._offset = t1.pointGeometry.convert(e1), this._update(), this;
            }
            _onMove(e1) {
                if (!this._isDragging) {
                    const t1 = this._clickTolerance || this._map._clickTolerance;
                    this._isDragging = e1.point.dist(this._pointerdownPos) >= t1;
                }
                this._isDragging && (this._pos = e1.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new t1.Event("dragstart"))), this.fire(new t1.Event("drag")));
            }
            _onUp() {
                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new t1.Event("dragend")), this._state = "inactive";
            }
            _addDragHandler(t1) {
                this._element.contains(t1.originalEvent.target) && (t1.preventDefault(), this._positionDelta = t1.point.sub(this._pos).add(this._offset), this._pointerdownPos = t1.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
            }
            setDraggable(t1) {
                return this._draggable = !!t1, this._map && (t1 ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(t1) {
                return this._rotation = t1 || 0, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(t1) {
                return this._rotationAlignment = t1 || "auto", this._update(), this;
            }
            getRotationAlignment() {
                return this._rotationAlignment;
            }
            setPitchAlignment(t1) {
                return this._pitchAlignment = t1 && "auto" !== t1 ? t1 : this._rotationAlignment, this._update(), this;
            }
            getPitchAlignment() {
                return this._pitchAlignment;
            }
            constructor(e1, i){
                if (super(), (e1 instanceof HTMLElement || i) && (e1 = t1.extend({
                    element: e1
                }, i)), t1.bindAll([
                    "_update",
                    "_onMove",
                    "_onUp",
                    "_addDragHandler",
                    "_onMapClick",
                    "_onKeyPress"
                ], this), this._anchor = e1 && e1.anchor || "center", this._color = e1 && e1.color || "#3FB1CE", this._scale = e1 && e1.scale || 1, this._draggable = e1 && e1.draggable || !1, this._clickTolerance = e1 && e1.clickTolerance || 0, this._isDragging = !1, this._state = "inactive", this._rotation = e1 && e1.rotation || 0, this._rotationAlignment = e1 && e1.rotationAlignment || "auto", this._pitchAlignment = e1 && e1.pitchAlignment && "auto" !== e1.pitchAlignment ? e1.pitchAlignment : this._rotationAlignment, e1 && e1.element) this._element = e1.element, this._offset = t1.pointGeometry.convert(e1 && e1.offset || [
                    0,
                    0
                ]);
                else {
                    this._defaultMarker = !0, this._element = r.create("div"), this._element.setAttribute("aria-label", "Map marker");
                    const i = r.createNS("http://www.w3.org/2000/svg", "svg"), o = 41, a = 27;
                    i.setAttributeNS(null, "display", "block"), i.setAttributeNS(null, "height", `${o}px`), i.setAttributeNS(null, "width", `${a}px`), i.setAttributeNS(null, "viewBox", `0 0 ${a} ${o}`);
                    const s = r.createNS("http://www.w3.org/2000/svg", "g");
                    s.setAttributeNS(null, "stroke", "none"), s.setAttributeNS(null, "stroke-width", "1"), s.setAttributeNS(null, "fill", "none"), s.setAttributeNS(null, "fill-rule", "evenodd");
                    const n = r.createNS("http://www.w3.org/2000/svg", "g");
                    n.setAttributeNS(null, "fill-rule", "nonzero");
                    const l = r.createNS("http://www.w3.org/2000/svg", "g");
                    l.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), l.setAttributeNS(null, "fill", "#000000");
                    const c = [
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "9.5",
                            ry: "4.77275007"
                        },
                        {
                            rx: "8.5",
                            ry: "4.29549936"
                        },
                        {
                            rx: "7.5",
                            ry: "3.81822308"
                        },
                        {
                            rx: "6.5",
                            ry: "3.34094679"
                        },
                        {
                            rx: "5.5",
                            ry: "2.86367051"
                        },
                        {
                            rx: "4.5",
                            ry: "2.38636864"
                        }
                    ];
                    for (const t1 of c){
                        const e1 = r.createNS("http://www.w3.org/2000/svg", "ellipse");
                        e1.setAttributeNS(null, "opacity", "0.04"), e1.setAttributeNS(null, "cx", "10.5"), e1.setAttributeNS(null, "cy", "5.80029008"), e1.setAttributeNS(null, "rx", t1.rx), e1.setAttributeNS(null, "ry", t1.ry), l.appendChild(e1);
                    }
                    const h = r.createNS("http://www.w3.org/2000/svg", "g");
                    h.setAttributeNS(null, "fill", this._color);
                    const u = r.createNS("http://www.w3.org/2000/svg", "path");
                    u.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), h.appendChild(u);
                    const d = r.createNS("http://www.w3.org/2000/svg", "g");
                    d.setAttributeNS(null, "opacity", "0.25"), d.setAttributeNS(null, "fill", "#000000");
                    const m = r.createNS("http://www.w3.org/2000/svg", "path");
                    m.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), d.appendChild(m);
                    const _ = r.createNS("http://www.w3.org/2000/svg", "g");
                    _.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), _.setAttributeNS(null, "fill", "#FFFFFF");
                    const p = r.createNS("http://www.w3.org/2000/svg", "g");
                    p.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                    const f = r.createNS("http://www.w3.org/2000/svg", "circle");
                    f.setAttributeNS(null, "fill", "#000000"), f.setAttributeNS(null, "opacity", "0.25"), f.setAttributeNS(null, "cx", "5.5"), f.setAttributeNS(null, "cy", "5.5"), f.setAttributeNS(null, "r", "5.4999962");
                    const g = r.createNS("http://www.w3.org/2000/svg", "circle");
                    g.setAttributeNS(null, "fill", "#FFFFFF"), g.setAttributeNS(null, "cx", "5.5"), g.setAttributeNS(null, "cy", "5.5"), g.setAttributeNS(null, "r", "5.4999962"), p.appendChild(f), p.appendChild(g), n.appendChild(l), n.appendChild(h), n.appendChild(d), n.appendChild(_), n.appendChild(p), i.appendChild(n), i.setAttributeNS(null, "height", o * this._scale + "px"), i.setAttributeNS(null, "width", a * this._scale + "px"), this._element.appendChild(i), this._offset = t1.pointGeometry.convert(e1 && e1.offset || [
                        0,
                        -14
                    ]);
                }
                this._element.classList.add("maplibregl-marker", "mapboxgl-marker"), this._element.addEventListener("dragstart", (t1)=>{
                    t1.preventDefault();
                }), this._element.addEventListener("mousedown", (t1)=>{
                    t1.preventDefault();
                }), ca(this._element, this._anchor, "marker"), this._popup = null;
            }
        }
        const ua = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0
        };
        let da, ma = 0, _a = !1;
        const pa = {
            maxWidth: 100,
            unit: "metric"
        };
        function fa(t1, e1, i) {
            const o = i && i.maxWidth || 100, a = t1._container.clientHeight / 2, r = t1.unproject([
                0,
                a
            ]), s = t1.unproject([
                o,
                a
            ]), n = r.distanceTo(s);
            if (i && "imperial" === i.unit) {
                const i = 3.2808 * n;
                i > 5280 ? ga(e1, o, i / 5280, t1._getUIString("ScaleControl.Miles")) : ga(e1, o, i, t1._getUIString("ScaleControl.Feet"));
            } else i && "nautical" === i.unit ? ga(e1, o, n / 1852, t1._getUIString("ScaleControl.NauticalMiles")) : n >= 1e3 ? ga(e1, o, n / 1e3, t1._getUIString("ScaleControl.Kilometers")) : ga(e1, o, n, t1._getUIString("ScaleControl.Meters"));
        }
        function ga(t1, e1, i, o) {
            const a = function(t1) {
                const e1 = Math.pow(10, `${Math.floor(t1)}`.length - 1);
                let i = t1 / e1;
                return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(t1) {
                    const e1 = Math.pow(10, Math.ceil(-Math.log(t1) / Math.LN10));
                    return Math.round(t1 * e1) / e1;
                }(i), e1 * i;
            }(i);
            t1.style.width = e1 * (a / i) + "px", t1.innerHTML = `${a}&nbsp;${o}`;
        }
        const xa = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px"
        }, va = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function ya(e1) {
            if (e1) {
                if ("number" == typeof e1) {
                    const i = Math.round(Math.sqrt(.5 * Math.pow(e1, 2)));
                    return {
                        center: new t1.pointGeometry(0, 0),
                        top: new t1.pointGeometry(0, e1),
                        "top-left": new t1.pointGeometry(i, i),
                        "top-right": new t1.pointGeometry(-i, i),
                        bottom: new t1.pointGeometry(0, -e1),
                        "bottom-left": new t1.pointGeometry(i, -i),
                        "bottom-right": new t1.pointGeometry(-i, -i),
                        left: new t1.pointGeometry(e1, 0),
                        right: new t1.pointGeometry(-e1, 0)
                    };
                }
                if (e1 instanceof t1.pointGeometry || Array.isArray(e1)) {
                    const i = t1.pointGeometry.convert(e1);
                    return {
                        center: i,
                        top: i,
                        "top-left": i,
                        "top-right": i,
                        bottom: i,
                        "bottom-left": i,
                        "bottom-right": i,
                        left: i,
                        right: i
                    };
                }
                return {
                    center: t1.pointGeometry.convert(e1.center || [
                        0,
                        0
                    ]),
                    top: t1.pointGeometry.convert(e1.top || [
                        0,
                        0
                    ]),
                    "top-left": t1.pointGeometry.convert(e1["top-left"] || [
                        0,
                        0
                    ]),
                    "top-right": t1.pointGeometry.convert(e1["top-right"] || [
                        0,
                        0
                    ]),
                    bottom: t1.pointGeometry.convert(e1.bottom || [
                        0,
                        0
                    ]),
                    "bottom-left": t1.pointGeometry.convert(e1["bottom-left"] || [
                        0,
                        0
                    ]),
                    "bottom-right": t1.pointGeometry.convert(e1["bottom-right"] || [
                        0,
                        0
                    ]),
                    left: t1.pointGeometry.convert(e1.left || [
                        0,
                        0
                    ]),
                    right: t1.pointGeometry.convert(e1.right || [
                        0,
                        0
                    ])
                };
            }
            return ya(new t1.pointGeometry(0, 0));
        }
        const ba = {
            supported: e1,
            setRTLTextPlugin: t1.setRTLTextPlugin,
            getRTLTextPluginStatus: t1.getRTLTextPluginStatus,
            Map: class extends Qo {
                _getMapId() {
                    return this._mapId;
                }
                addControl(e1, i) {
                    if (void 0 === i && (i = e1.getDefaultPosition ? e1.getDefaultPosition() : "top-right"), !e1 || !e1.onAdd) return this.fire(new t1.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const o = e1.onAdd(this);
                    this._controls.push(e1);
                    const a = this._controlPositions[i];
                    return -1 !== i.indexOf("bottom") ? a.insertBefore(o, a.firstChild) : a.appendChild(o), this;
                }
                removeControl(e1) {
                    if (!e1 || !e1.onRemove) return this.fire(new t1.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const i = this._controls.indexOf(e1);
                    return i > -1 && this._controls.splice(i, 1), e1.onRemove(this), this;
                }
                hasControl(t1) {
                    return this._controls.indexOf(t1) > -1;
                }
                calculateCameraOptionsFromTo(t1, e1, i, o) {
                    return null == o && this.style.terrain && (o = this.transform.getElevation(i, this.style.terrain)), super.calculateCameraOptionsFromTo(t1, e1, i, o);
                }
                resize(e1) {
                    const i = this._containerDimensions(), o = i[0], a = i[1];
                    this._resizeCanvas(o, a, this.getPixelRatio()), this.transform.resize(o, a), this.painter.resize(o, a, this.getPixelRatio());
                    const r = !this._moving;
                    return r && (this.stop(), this.fire(new t1.Event("movestart", e1)).fire(new t1.Event("move", e1))), this.fire(new t1.Event("resize", e1)), r && this.fire(new t1.Event("moveend", e1)), this;
                }
                getPixelRatio() {
                    return this._pixelRatio;
                }
                setPixelRatio(t1) {
                    const [e1, i] = this._containerDimensions();
                    this._pixelRatio = t1, this._resizeCanvas(e1, i, t1), this.painter.resize(e1, i, t1);
                }
                getBounds() {
                    return this.transform.getBounds();
                }
                getMaxBounds() {
                    return this.transform.getMaxBounds();
                }
                setMaxBounds(e1) {
                    return this.transform.setMaxBounds(t1.LngLatBounds.convert(e1)), this._update();
                }
                setMinZoom(t1) {
                    if ((t1 = null == t1 ? -2 : t1) >= -2 && t1 <= this.transform.maxZoom) return this.transform.minZoom = t1, this._update(), this.getZoom() < t1 && this.setZoom(t1), this;
                    throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                }
                getMinZoom() {
                    return this.transform.minZoom;
                }
                setMaxZoom(t1) {
                    if ((t1 = null == t1 ? 22 : t1) >= this.transform.minZoom) return this.transform.maxZoom = t1, this._update(), this.getZoom() > t1 && this.setZoom(t1), this;
                    throw new Error("maxZoom must be greater than the current minZoom");
                }
                getMaxZoom() {
                    return this.transform.maxZoom;
                }
                setMinPitch(t1) {
                    if ((t1 = null == t1 ? 0 : t1) < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (t1 >= 0 && t1 <= this.transform.maxPitch) return this.transform.minPitch = t1, this._update(), this.getPitch() < t1 && this.setPitch(t1), this;
                    throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                }
                getMinPitch() {
                    return this.transform.minPitch;
                }
                setMaxPitch(t1) {
                    if ((t1 = null == t1 ? 60 : t1) > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1 >= this.transform.minPitch) return this.transform.maxPitch = t1, this._update(), this.getPitch() > t1 && this.setPitch(t1), this;
                    throw new Error("maxPitch must be greater than the current minPitch");
                }
                getMaxPitch() {
                    return this.transform.maxPitch;
                }
                getRenderWorldCopies() {
                    return this.transform.renderWorldCopies;
                }
                setRenderWorldCopies(t1) {
                    return this.transform.renderWorldCopies = t1, this._update();
                }
                project(e1) {
                    return this.transform.locationPoint(t1.LngLat.convert(e1), this.style && this.style.terrain);
                }
                unproject(e1) {
                    return this.transform.pointLocation(t1.pointGeometry.convert(e1), this.style && this.style.terrain);
                }
                isMoving() {
                    return this._moving || this.handlers.isMoving();
                }
                isZooming() {
                    return this._zooming || this.handlers.isZooming();
                }
                isRotating() {
                    return this._rotating || this.handlers.isRotating();
                }
                _createDelegatedListener(t1, e1, i) {
                    if ("mouseenter" === t1 || "mouseover" === t1) {
                        let o = !1;
                        const a = (a)=>{
                            const r = this.getLayer(e1) ? this.queryRenderedFeatures(a.point, {
                                layers: [
                                    e1
                                ]
                            }) : [];
                            r.length ? o || (o = !0, i.call(this, new mo(t1, this, a.originalEvent, {
                                features: r
                            }))) : o = !1;
                        };
                        return {
                            layer: e1,
                            listener: i,
                            delegates: {
                                mousemove: a,
                                mouseout: ()=>{
                                    o = !1;
                                }
                            }
                        };
                    }
                    if ("mouseleave" === t1 || "mouseout" === t1) {
                        let o = !1;
                        const a = (a)=>{
                            (this.getLayer(e1) ? this.queryRenderedFeatures(a.point, {
                                layers: [
                                    e1
                                ]
                            }) : []).length ? o = !0 : o && (o = !1, i.call(this, new mo(t1, this, a.originalEvent)));
                        }, r = (e1)=>{
                            o && (o = !1, i.call(this, new mo(t1, this, e1.originalEvent)));
                        };
                        return {
                            layer: e1,
                            listener: i,
                            delegates: {
                                mousemove: a,
                                mouseout: r
                            }
                        };
                    }
                    {
                        const o = (t1)=>{
                            const o = this.getLayer(e1) ? this.queryRenderedFeatures(t1.point, {
                                layers: [
                                    e1
                                ]
                            }) : [];
                            o.length && (t1.features = o, i.call(this, t1), delete t1.features);
                        };
                        return {
                            layer: e1,
                            listener: i,
                            delegates: {
                                [t1]: o
                            }
                        };
                    }
                }
                on(t1, e1, i) {
                    if (void 0 === i) return super.on(t1, e1);
                    const o = this._createDelegatedListener(t1, e1, i);
                    this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[t1] = this._delegatedListeners[t1] || [], this._delegatedListeners[t1].push(o);
                    for(const t1 in o.delegates)this.on(t1, o.delegates[t1]);
                    return this;
                }
                once(t1, e1, i) {
                    if (void 0 === i) return super.once(t1, e1);
                    const o = this._createDelegatedListener(t1, e1, i);
                    for(const t1 in o.delegates)this.once(t1, o.delegates[t1]);
                    return this;
                }
                off(t1, e1, i) {
                    return void 0 === i ? super.off(t1, e1) : (this._delegatedListeners && this._delegatedListeners[t1] && ((o)=>{
                        const a = this._delegatedListeners[t1];
                        for(let t1 = 0; t1 < a.length; t1++){
                            const o = a[t1];
                            if (o.layer === e1 && o.listener === i) {
                                for(const t1 in o.delegates)this.off(t1, o.delegates[t1]);
                                return a.splice(t1, 1), this;
                            }
                        }
                    })(), this);
                }
                queryRenderedFeatures(e1, i) {
                    if (!this.style) return [];
                    let o;
                    if (void 0 !== i || void 0 === e1 || e1 instanceof t1.pointGeometry || Array.isArray(e1) || (i = e1, e1 = void 0), i = i || {}, (e1 = e1 || [
                        [
                            0,
                            0
                        ],
                        [
                            this.transform.width,
                            this.transform.height
                        ]
                    ]) instanceof t1.pointGeometry || "number" == typeof e1[0]) o = [
                        t1.pointGeometry.convert(e1)
                    ];
                    else {
                        const i = t1.pointGeometry.convert(e1[0]), a = t1.pointGeometry.convert(e1[1]);
                        o = [
                            i,
                            new t1.pointGeometry(a.x, i.y),
                            a,
                            new t1.pointGeometry(i.x, a.y),
                            i
                        ];
                    }
                    return this.style.queryRenderedFeatures(o, i, this.transform);
                }
                querySourceFeatures(t1, e1) {
                    return this.style.querySourceFeatures(t1, e1);
                }
                setStyle(e1, i) {
                    return !1 !== (i = t1.extend({}, {
                        localIdeographFontFamily: this._localIdeographFontFamily
                    }, i)).diff && i.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e1 ? (this._diffStyle(e1, i), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._updateStyle(e1, i));
                }
                setTransformRequest(t1) {
                    return this._requestManager.setTransformRequest(t1), this;
                }
                _getUIString(t1) {
                    const e1 = this._locale[t1];
                    if (null == e1) throw new Error(`Missing UI string '${t1}'`);
                    return e1;
                }
                _updateStyle(t1, e1) {
                    return this.style && (this.style.setEventedParent(null), this.style._remove()), t1 ? (this.style = new ee(this, e1 || {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), "string" == typeof t1 ? this.style.loadURL(t1) : this.style.loadJSON(t1), this) : (delete this.style, this);
                }
                _lazyInitEmptyStyle() {
                    this.style || (this.style = new ee(this, {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), this.style.loadEmpty());
                }
                _diffStyle(e1, i) {
                    if ("string" == typeof e1) {
                        const o = this._requestManager.transformRequest(e1, t1.ResourceType.Style);
                        t1.getJSON(o, (e1, o)=>{
                            e1 ? this.fire(new t1.ErrorEvent(e1)) : o && this._updateDiff(o, i);
                        });
                    } else "object" == typeof e1 && this._updateDiff(e1, i);
                }
                _updateDiff(e1, i) {
                    try {
                        this.style.setState(e1) && this._update(!0);
                    } catch (o) {
                        t1.warnOnce(`Unable to perform style diff: ${o.message || o.error || o}.  Rebuilding the style from scratch.`), this._updateStyle(e1, i);
                    }
                }
                getStyle() {
                    if (this.style) return this.style.serialize();
                }
                isStyleLoaded() {
                    return this.style ? this.style.loaded() : t1.warnOnce("There is no style added to the map.");
                }
                addSource(t1, e1) {
                    return this._lazyInitEmptyStyle(), this.style.addSource(t1, e1), this._update(!0);
                }
                isSourceLoaded(e1) {
                    const i = this.style && this.style.sourceCaches[e1];
                    if (void 0 !== i) return i.loaded();
                    this.fire(new t1.ErrorEvent(new Error(`There is no source with ID '${e1}'`)));
                }
                setTerrain(t1) {
                    return this.style.setTerrain(t1), this;
                }
                getTerrain() {
                    return this.style.terrain && this.style.terrain.options;
                }
                areTilesLoaded() {
                    const t1 = this.style && this.style.sourceCaches;
                    for(const e1 in t1){
                        const i = t1[e1]._tiles;
                        for(const t1 in i){
                            const e1 = i[t1];
                            if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
                        }
                    }
                    return !0;
                }
                addSourceType(t1, e1, i) {
                    return this._lazyInitEmptyStyle(), this.style.addSourceType(t1, e1, i);
                }
                removeSource(t1) {
                    return this.style.removeSource(t1), this._update(!0);
                }
                getSource(t1) {
                    return this.style.getSource(t1);
                }
                addImage(e1, i, { pixelRatio: o = 1, sdf: a = !1, stretchX: r, stretchY: s, content: n } = {}) {
                    if (this._lazyInitEmptyStyle(), i instanceof HTMLImageElement || t1.isImageBitmap(i)) {
                        const { width: l, height: c, data: h } = t1.exported.getImageData(i);
                        this.style.addImage(e1, {
                            data: new t1.RGBAImage({
                                width: l,
                                height: c
                            }, h),
                            pixelRatio: o,
                            stretchX: r,
                            stretchY: s,
                            content: n,
                            sdf: a,
                            version: 0
                        });
                    } else {
                        if (void 0 === i.width || void 0 === i.height) return this.fire(new t1.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                        {
                            const { width: l, height: c, data: h } = i, u = i;
                            this.style.addImage(e1, {
                                data: new t1.RGBAImage({
                                    width: l,
                                    height: c
                                }, new Uint8Array(h)),
                                pixelRatio: o,
                                stretchX: r,
                                stretchY: s,
                                content: n,
                                sdf: a,
                                version: 0,
                                userImage: u
                            }), u.onAdd && u.onAdd(this, e1);
                        }
                    }
                }
                updateImage(e1, i) {
                    const o = this.style.getImage(e1);
                    if (!o) return this.fire(new t1.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                    const a = i instanceof HTMLImageElement || t1.isImageBitmap(i) ? t1.exported.getImageData(i) : i, { width: r, height: s, data: n } = a;
                    if (void 0 === r || void 0 === s) return this.fire(new t1.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    if (r !== o.data.width || s !== o.data.height) return this.fire(new t1.ErrorEvent(new Error("The width and height of the updated image must be that same as the previous version of the image")));
                    const l = !(i instanceof HTMLImageElement || t1.isImageBitmap(i));
                    o.data.replace(n, l), this.style.updateImage(e1, o);
                }
                hasImage(e1) {
                    return e1 ? !!this.style.getImage(e1) : (this.fire(new t1.ErrorEvent(new Error("Missing required image id"))), !1);
                }
                removeImage(t1) {
                    this.style.removeImage(t1);
                }
                loadImage(e1, i) {
                    t1.getImage(this._requestManager.transformRequest(e1, t1.ResourceType.Image), i);
                }
                listImages() {
                    return this.style.listImages();
                }
                addLayer(t1, e1) {
                    return this._lazyInitEmptyStyle(), this.style.addLayer(t1, e1), this._update(!0);
                }
                moveLayer(t1, e1) {
                    return this.style.moveLayer(t1, e1), this._update(!0);
                }
                removeLayer(t1) {
                    return this.style.removeLayer(t1), this._update(!0);
                }
                getLayer(t1) {
                    return this.style.getLayer(t1);
                }
                setLayerZoomRange(t1, e1, i) {
                    return this.style.setLayerZoomRange(t1, e1, i), this._update(!0);
                }
                setFilter(t1, e1, i = {}) {
                    return this.style.setFilter(t1, e1, i), this._update(!0);
                }
                getFilter(t1) {
                    return this.style.getFilter(t1);
                }
                setPaintProperty(t1, e1, i, o = {}) {
                    return this.style.setPaintProperty(t1, e1, i, o), this._update(!0);
                }
                getPaintProperty(t1, e1) {
                    return this.style.getPaintProperty(t1, e1);
                }
                setLayoutProperty(t1, e1, i, o = {}) {
                    return this.style.setLayoutProperty(t1, e1, i, o), this._update(!0);
                }
                getLayoutProperty(t1, e1) {
                    return this.style.getLayoutProperty(t1, e1);
                }
                setLight(t1, e1 = {}) {
                    return this._lazyInitEmptyStyle(), this.style.setLight(t1, e1), this._update(!0);
                }
                getLight() {
                    return this.style.getLight();
                }
                setFeatureState(t1, e1) {
                    return this.style.setFeatureState(t1, e1), this._update();
                }
                removeFeatureState(t1, e1) {
                    return this.style.removeFeatureState(t1, e1), this._update();
                }
                getFeatureState(t1) {
                    return this.style.getFeatureState(t1);
                }
                getContainer() {
                    return this._container;
                }
                getCanvasContainer() {
                    return this._canvasContainer;
                }
                getCanvas() {
                    return this._canvas;
                }
                _containerDimensions() {
                    let t1 = 0, e1 = 0;
                    return this._container && (t1 = this._container.clientWidth || 400, e1 = this._container.clientHeight || 300), [
                        t1,
                        e1
                    ];
                }
                _setupContainer() {
                    const t1 = this._container;
                    t1.classList.add("maplibregl-map", "mapboxgl-map");
                    const e1 = this._canvasContainer = r.create("div", "maplibregl-canvas-container mapboxgl-canvas-container", t1);
                    this._interactive && e1.classList.add("maplibregl-interactive", "mapboxgl-interactive"), this._canvas = r.create("canvas", "maplibregl-canvas mapboxgl-canvas", e1), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", "0"), this._canvas.setAttribute("aria-label", "Map"), this._canvas.setAttribute("role", "region");
                    const i = this._containerDimensions();
                    this._resizeCanvas(i[0], i[1], this.getPixelRatio());
                    const o = this._controlContainer = r.create("div", "maplibregl-control-container mapboxgl-control-container", t1), a = this._controlPositions = {};
                    [
                        "top-left",
                        "top-right",
                        "bottom-left",
                        "bottom-right"
                    ].forEach((t1)=>{
                        a[t1] = r.create("div", `maplibregl-ctrl-${t1} mapboxgl-ctrl-${t1}`, o);
                    }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                }
                _setupCooperativeGestures() {
                    const t1 = this._container;
                    this._metaPress = !1, this._cooperativeGesturesScreen = r.create("div", "maplibregl-cooperative-gesture-screen", t1);
                    let e1 = "Control", i = "boolean" != typeof this._cooperativeGestures && this._cooperativeGestures.windowsHelpText ? this._cooperativeGestures.windowsHelpText : "Use Ctrl + scroll to zoom the map";
                    0 === navigator.platform.indexOf("Mac") && (i = "boolean" != typeof this._cooperativeGestures && this._cooperativeGestures.macHelpText ? this._cooperativeGestures.macHelpText : "Use \u2318 + scroll to zoom the map", e1 = "Meta"), this._cooperativeGesturesScreen.innerHTML = `\n            <div class="maplibregl-desktop-message">${i}</div>\n            <div class="maplibregl-mobile-message">${"boolean" != typeof this._cooperativeGestures && this._cooperativeGestures.mobileHelpText ? this._cooperativeGestures.mobileHelpText : "Use two fingers to move the map"}</div>\n        `, document.addEventListener("keydown", (t1)=>{
                        t1.key === e1 && (this._metaPress = !0);
                    }), document.addEventListener("keyup", (t1)=>{
                        t1.key === e1 && (this._metaPress = !1);
                    }), this._canvasContainer.addEventListener("wheel", (t1)=>{
                        this._onCooperativeGesture(t1, this._metaPress, 1);
                    }, !1), this._canvasContainer.classList.remove("mapboxgl-touch-drag-pan", "maplibregl-touch-drag-pan");
                }
                _resizeCanvas(t1, e1, i) {
                    this._canvas.width = i * t1, this._canvas.height = i * e1, this._canvas.style.width = `${t1}px`, this._canvas.style.height = `${e1}px`;
                }
                _setupPainter() {
                    const i = t1.extend({}, e1.webGLContextAttributes, {
                        failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                        preserveDrawingBuffer: this._preserveDrawingBuffer,
                        antialias: this._antialias || !1
                    }), o = this._canvas.getContext("webgl", i) || this._canvas.getContext("experimental-webgl", i);
                    o ? (this.painter = new Ji(o, this.transform), t1.exported$1.testSupport(o)) : this.fire(new t1.ErrorEvent(new Error("Failed to initialize WebGL")));
                }
                _contextLost(e1) {
                    e1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new t1.Event("webglcontextlost", {
                        originalEvent: e1
                    }));
                }
                _contextRestored(e1) {
                    this._setupPainter(), this.resize(), this._update(), this.fire(new t1.Event("webglcontextrestored", {
                        originalEvent: e1
                    }));
                }
                _onMapScroll(t1) {
                    if (t1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }
                _onCooperativeGesture(t1, e1, i) {
                    return !e1 && i < 2 && (this._cooperativeGesturesScreen.classList.add("maplibregl-show"), setTimeout(()=>{
                        this._cooperativeGesturesScreen.classList.remove("maplibregl-show");
                    }, 100)), !1;
                }
                loaded() {
                    return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                }
                _update(t1) {
                    return this.style ? (this._styleDirty = this._styleDirty || t1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                }
                _requestRenderFrame(t1) {
                    return this._update(), this._renderTaskQueue.add(t1);
                }
                _cancelRenderFrame(t1) {
                    this._renderTaskQueue.remove(t1);
                }
                _render(e1) {
                    let i, o = 0;
                    const a = this.painter.context.extTimerQuery;
                    if (this.listens("gpu-timing-frame") && (i = a.createQueryEXT(), a.beginQueryEXT(a.TIME_ELAPSED_EXT, i), o = t1.exported.now()), this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e1), this._removed) return;
                    let r = !1;
                    if (this.style && this._styleDirty) {
                        this._styleDirty = !1;
                        const e1 = this.transform.zoom, i = t1.exported.now();
                        this.style.zoomHistory.update(e1, i);
                        const o = new t1.EvaluationParameters(e1, {
                            now: i,
                            fadeDuration: this._fadeDuration,
                            zoomHistory: this.style.zoomHistory,
                            transition: this.style.getTransition()
                        }), a = o.crossFadingFactor();
                        1 === a && a === this._crossFadingFactor || (r = !0, this._crossFadingFactor = a), this.style.update(o);
                    }
                    if (this.style && this._sourcesDirty && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this.style.terrain && this.style.terrain.sourceCache.update(this.transform, this.style.terrain), this.transform.updateElevation(this.style.terrain), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, this._fadeDuration, this._crossSourceCollisions), this.painter.render(this.style, {
                        showTileBoundaries: this.showTileBoundaries,
                        showOverdrawInspector: this._showOverdrawInspector,
                        rotating: this.isRotating(),
                        zooming: this.isZooming(),
                        moving: this.isMoving(),
                        fadeDuration: this._fadeDuration,
                        showPadding: this.showPadding,
                        gpuTiming: !!this.listens("gpu-timing-layer")
                    }), this.fire(new t1.Event("render")), this.loaded() && !this._loaded && (this._loaded = !0, t1.PerformanceUtils.mark(t1.PerformanceMarkers.load), this.fire(new t1.Event("load"))), this.style && (this.style.hasTransitions() || r) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), this.listens("gpu-timing-frame")) {
                        const e1 = t1.exported.now() - o;
                        a.endQueryEXT(a.TIME_ELAPSED_EXT, i), setTimeout(()=>{
                            const o = a.getQueryObjectEXT(i, a.QUERY_RESULT_EXT) / 1e6;
                            a.deleteQueryEXT(i), this.fire(new t1.Event("gpu-timing-frame", {
                                cpuTime: e1,
                                gpuTime: o
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-layer")) {
                        const e1 = this.painter.collectGpuTimers();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimers(e1);
                            this.fire(new t1.Event("gpu-timing-layer", {
                                layerTimes: i
                            }));
                        }, 50);
                    }
                    const s = this._sourcesDirty || this._styleDirty || this._placementDirty;
                    return s || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new t1.Event("idle")), !this._loaded || this._fullyLoaded || s || (this._fullyLoaded = !0, t1.PerformanceUtils.mark(t1.PerformanceMarkers.fullLoad)), this;
                }
                redraw() {
                    return this.style && (this._frame && (this._frame.cancel(), this._frame = null), this._render(0)), this;
                }
                remove() {
                    this._hash && this._hash.remove();
                    for (const t1 of this._controls)t1.onRemove(this);
                    this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), "undefined" != typeof window && (removeEventListener("resize", this._onWindowResize, !1), removeEventListener("orientationchange", this._onWindowResize, !1), removeEventListener("online", this._onWindowOnline, !1));
                    const e1 = this.painter.context.gl.getExtension("WEBGL_lose_context");
                    e1 && e1.loseContext(), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), r.remove(this._canvasContainer), r.remove(this._controlContainer), this._cooperativeGestures && r.remove(this._cooperativeGesturesScreen), this._container.classList.remove("maplibregl-map", "mapboxgl-map"), t1.PerformanceUtils.clearMetrics(), this._removed = !0, this.fire(new t1.Event("remove"));
                }
                triggerRepaint() {
                    this.style && !this._frame && (this._frame = t1.exported.frame((e1)=>{
                        t1.PerformanceUtils.frame(e1), this._frame = null, this._render(e1);
                    }));
                }
                _onWindowOnline() {
                    this._update();
                }
                _onWindowResize(t1) {
                    this._trackResize && this.resize({
                        originalEvent: t1
                    })._update();
                }
                get showTileBoundaries() {
                    return !!this._showTileBoundaries;
                }
                set showTileBoundaries(t1) {
                    this._showTileBoundaries !== t1 && (this._showTileBoundaries = t1, this._update());
                }
                get showPadding() {
                    return !!this._showPadding;
                }
                set showPadding(t1) {
                    this._showPadding !== t1 && (this._showPadding = t1, this._update());
                }
                get showCollisionBoxes() {
                    return !!this._showCollisionBoxes;
                }
                set showCollisionBoxes(t1) {
                    this._showCollisionBoxes !== t1 && (this._showCollisionBoxes = t1, t1 ? this.style._generateCollisionBoxes() : this._update());
                }
                get showOverdrawInspector() {
                    return !!this._showOverdrawInspector;
                }
                set showOverdrawInspector(t1) {
                    this._showOverdrawInspector !== t1 && (this._showOverdrawInspector = t1, this._update());
                }
                get repaint() {
                    return !!this._repaint;
                }
                set repaint(t1) {
                    this._repaint !== t1 && (this._repaint = t1, this.triggerRepaint());
                }
                get vertices() {
                    return !!this._vertices;
                }
                set vertices(t1) {
                    this._vertices = t1, this._update();
                }
                _setCacheLimits(e1, i) {
                    t1.setCacheLimits(e1, i);
                }
                get version() {
                    return "2.4.0";
                }
                constructor(e1){
                    var i;
                    if (t1.PerformanceUtils.mark(t1.PerformanceMarkers.create), null != (e1 = t1.extend({}, aa, e1)).minZoom && null != e1.maxZoom && e1.minZoom > e1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                    if (null != e1.minPitch && null != e1.maxPitch && e1.minPitch > e1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                    if (null != e1.minPitch && e1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (null != e1.maxPitch && e1.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (super(new io(e1.minZoom, e1.maxZoom, e1.minPitch, e1.maxPitch, e1.renderWorldCopies), {
                        bearingSnap: e1.bearingSnap
                    }), this._interactive = e1.interactive, this._cooperativeGestures = e1.cooperativeGestures, this._maxTileCacheSize = e1.maxTileCacheSize, this._failIfMajorPerformanceCaveat = e1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = e1.preserveDrawingBuffer, this._antialias = e1.antialias, this._trackResize = e1.trackResize, this._bearingSnap = e1.bearingSnap, this._refreshExpiredTiles = e1.refreshExpiredTiles, this._fadeDuration = e1.fadeDuration, this._crossSourceCollisions = e1.crossSourceCollisions, this._crossFadingFactor = 1, this._collectResourceTiming = e1.collectResourceTiming, this._renderTaskQueue = new ia, this._controls = [], this._mapId = t1.uniqueId(), this._locale = t1.extend({}, oa, e1.locale), this._clickTolerance = e1.clickTolerance, this._pixelRatio = null !== (i = e1.pixelRatio) && void 0 !== i ? i : devicePixelRatio, this._requestManager = new s(e1.transformRequest), "string" == typeof e1.container) {
                        if (this._container = document.getElementById(e1.container), !this._container) throw new Error(`Container '${e1.container}' not found.`);
                    } else {
                        if (!(e1.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                        this._container = e1.container;
                    }
                    if (e1.maxBounds && this.setMaxBounds(e1.maxBounds), t1.bindAll([
                        "_onWindowOnline",
                        "_onWindowResize",
                        "_onMapScroll",
                        "_contextLost",
                        "_contextRestored"
                    ], this), this._setupContainer(), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
                    this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this.on("terrain", ()=>{
                        this.painter.terrainFacilitator.dirty = !0, this._update(!0);
                    }), "undefined" != typeof window && (addEventListener("online", this._onWindowOnline, !1), addEventListener("resize", this._onWindowResize, !1), addEventListener("orientationchange", this._onWindowResize, !1)), this.handlers = new Yo(this, e1), this._cooperativeGestures && this._setupCooperativeGestures(), this._hash = e1.hash && new oo("string" == typeof e1.hash && e1.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                        center: e1.center,
                        zoom: e1.zoom,
                        bearing: e1.bearing,
                        pitch: e1.pitch
                    }), e1.bounds && (this.resize(), this.fitBounds(e1.bounds, t1.extend({}, e1.fitBoundsOptions, {
                        duration: 0
                    })))), this.resize(), this._localIdeographFontFamily = e1.localIdeographFontFamily, e1.style && this.setStyle(e1.style, {
                        localIdeographFontFamily: e1.localIdeographFontFamily
                    }), e1.attributionControl && this.addControl(new ta({
                        customAttribution: e1.customAttribution
                    })), e1.maplibreLogo && this.addControl(new ea, e1.logoPosition), this.on("style.load", ()=>{
                        this.transform.unmodified && this.jumpTo(this.style.stylesheet);
                    }), this.on("data", (e1)=>{
                        this._update("style" === e1.dataType), this.fire(new t1.Event(`${e1.dataType}data`, e1));
                    }), this.on("dataloading", (e1)=>{
                        this.fire(new t1.Event(`${e1.dataType}dataloading`, e1));
                    }), this.on("dataabort", (e1)=>{
                        this.fire(new t1.Event("sourcedataabort", e1));
                    });
                }
            },
            NavigationControl: class {
                _updateZoomButtons() {
                    const t1 = this._map.getZoom(), e1 = t1 === this._map.getMaxZoom(), i = t1 === this._map.getMinZoom();
                    this._zoomInButton.disabled = e1, this._zoomOutButton.disabled = i, this._zoomInButton.setAttribute("aria-disabled", e1.toString()), this._zoomOutButton.setAttribute("aria-disabled", i.toString());
                }
                _rotateCompassArrow() {
                    const t1 = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${this._map.transform.pitch}deg) rotateZ(${this._map.transform.angle * (180 / Math.PI)}deg)` : `rotate(${this._map.transform.angle * (180 / Math.PI)}deg)`;
                    this._compassIcon.style.transform = t1;
                }
                onAdd(t1) {
                    return this._map = t1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new sa(this._map, this._compass, this.options.visualizePitch)), this._container;
                }
                onRemove() {
                    r.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
                }
                _createButton(t1, e1) {
                    const i = r.create("button", t1, this._container);
                    return i.type = "button", i.addEventListener("click", e1), i;
                }
                _setButtonTitle(t1, e1) {
                    const i = this._map._getUIString(`NavigationControl.${e1}`);
                    t1.title = i, t1.setAttribute("aria-label", i);
                }
                constructor(e1){
                    this.options = t1.extend({}, ra, e1), this._container = r.create("div", "maplibregl-ctrl maplibregl-ctrl-group mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (t1)=>t1.preventDefault()), this.options.showZoom && (t1.bindAll([
                        "_setButtonTitle",
                        "_updateZoomButtons"
                    ], this), this._zoomInButton = this._createButton("maplibregl-ctrl-zoom-in mapboxgl-ctrl-zoom-in", (t1)=>this._map.zoomIn({}, {
                            originalEvent: t1
                        })), r.create("span", "maplibregl-ctrl-icon mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("maplibregl-ctrl-zoom-out mapboxgl-ctrl-zoom-out", (t1)=>this._map.zoomOut({}, {
                            originalEvent: t1
                        })), r.create("span", "maplibregl-ctrl-icon mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (t1.bindAll([
                        "_rotateCompassArrow"
                    ], this), this._compass = this._createButton("maplibregl-ctrl-compass mapboxgl-ctrl-compass", (t1)=>{
                        this.options.visualizePitch ? this._map.resetNorthPitch({}, {
                            originalEvent: t1
                        }) : this._map.resetNorth({}, {
                            originalEvent: t1
                        });
                    }), this._compassIcon = r.create("span", "maplibregl-ctrl-icon mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                }
            },
            GeolocateControl: class extends t1.Evented {
                onAdd(t1) {
                    var e1;
                    return this._map = t1, this._container = r.create("div", "maplibregl-ctrl maplibregl-ctrl-group mapboxgl-ctrl mapboxgl-ctrl-group"), e1 = this._setupUI, void 0 !== da ? e1(da) : void 0 !== window.navigator.permissions ? window.navigator.permissions.query({
                        name: "geolocation"
                    }).then((t1)=>{
                        da = "denied" !== t1.state, e1(da);
                    }) : (da = !!window.navigator.geolocation, e1(da)), this._container;
                }
                onRemove() {
                    void 0 !== this._geolocationWatchID && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), r.remove(this._container), this._map.off("zoom", this._onZoom), this._map = void 0, ma = 0, _a = !1;
                }
                _isOutOfMapMaxBounds(t1) {
                    const e1 = this._map.getMaxBounds(), i = t1.coords;
                    return e1 && (i.longitude < e1.getWest() || i.longitude > e1.getEast() || i.latitude < e1.getSouth() || i.latitude > e1.getNorth());
                }
                _setErrorState() {
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active", "mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error", "mapboxgl-ctrl-geolocate-active-error");
                            break;
                        case "ACTIVE_LOCK":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active", "mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error", "mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting", "mapboxgl-ctrl-geolocate-waiting");
                            break;
                        case "BACKGROUND":
                            this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background", "mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background-error", "mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting", "mapboxgl-ctrl-geolocate-waiting");
                            break;
                        case "ACTIVE_ERROR":
                            break;
                        default:
                            throw new Error(`Unexpected watchState ${this._watchState}`);
                    }
                }
                _onSuccess(e1) {
                    if (this._map) {
                        if (this._isOutOfMapMaxBounds(e1)) return this._setErrorState(), this.fire(new t1.Event("outofmaxbounds", e1)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = e1, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting", "mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error", "mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active", "mapboxgl-ctrl-geolocate-active");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting", "mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error", "mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background", "mapboxgl-ctrl-geolocate-background");
                                break;
                            default:
                                throw new Error(`Unexpected watchState ${this._watchState}`);
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(e1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(e1), this.options.showUserLocation && this._dotElement.classList.remove("maplibregl-user-location-dot-stale", "mapboxgl-user-location-dot-stale"), this.fire(new t1.Event("geolocate", e1)), this._finish();
                    }
                }
                _updateCamera(e1) {
                    const i = new t1.LngLat(e1.coords.longitude, e1.coords.latitude), o = e1.coords.accuracy, a = this._map.getBearing(), r = t1.extend({
                        bearing: a
                    }, this.options.fitBoundsOptions);
                    this._map.fitBounds(i.toBounds(o), r, {
                        geolocateSource: !0
                    });
                }
                _updateMarker(e1) {
                    if (e1) {
                        const i = new t1.LngLat(e1.coords.longitude, e1.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = e1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }
                _updateCircleRadius() {
                    const t1 = this._map._container.clientHeight / 2, e1 = this._map.unproject([
                        0,
                        t1
                    ]), i = this._map.unproject([
                        1,
                        t1
                    ]), o = e1.distanceTo(i), a = Math.ceil(2 * this._accuracy / o);
                    this._circleElement.style.width = `${a}px`, this._circleElement.style.height = `${a}px`;
                }
                _onZoom() {
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }
                _onError(e1) {
                    if (this._map) {
                        if (this.options.trackUserLocation) {
                            if (1 === e1.code) {
                                this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting", "mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active", "mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error", "mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background", "mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error", "mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                const t1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                this._geolocateButton.title = t1, this._geolocateButton.setAttribute("aria-label", t1), void 0 !== this._geolocationWatchID && this._clearWatch();
                            } else {
                                if (3 === e1.code && _a) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("maplibregl-user-location-dot-stale", "mapboxgl-user-location-dot-stale"), this.fire(new t1.Event("error", e1)), this._finish();
                    }
                }
                _finish() {
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }
                _setupUI(e1) {
                    if (this._container.addEventListener("contextmenu", (t1)=>t1.preventDefault()), this._geolocateButton = r.create("button", "maplibregl-ctrl-geolocate mapboxgl-ctrl-geolocate", this._container), r.create("span", "maplibregl-ctrl-icon mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", !1 === e1) {
                        t1.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");
                        const e1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                        this._geolocateButton.disabled = !0, this._geolocateButton.title = e1, this._geolocateButton.setAttribute("aria-label", e1);
                    } else {
                        const t1 = this._map._getUIString("GeolocateControl.FindMyLocation");
                        this._geolocateButton.title = t1, this._geolocateButton.setAttribute("aria-label", t1);
                    }
                    this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = r.create("div", "maplibregl-user-location-dot mapboxgl-user-location-dot"), this._userLocationDotMarker = new ha(this._dotElement), this._circleElement = r.create("div", "maplibregl-user-location-accuracy-circle mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new ha({
                        element: this._circleElement,
                        pitchAlignment: "map"
                    }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (e1)=>{
                        e1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || e1.originalEvent && "resize" === e1.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background", "mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active", "mapboxgl-ctrl-geolocate-active"), this.fire(new t1.Event("trackuserlocationend")));
                    });
                }
                trigger() {
                    if (!this._setup) return t1.warnOnce("Geolocate control triggered before added to a map"), !1;
                    if (this.options.trackUserLocation) {
                        switch(this._watchState){
                            case "OFF":
                                this._watchState = "WAITING_ACTIVE", this.fire(new t1.Event("trackuserlocationstart"));
                                break;
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                            case "BACKGROUND_ERROR":
                                ma--, _a = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting", "mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active", "mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error", "mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background", "mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error", "mapboxgl-ctrl-geolocate-background-error"), this.fire(new t1.Event("trackuserlocationend"));
                                break;
                            case "BACKGROUND":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background", "mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new t1.Event("trackuserlocationstart"));
                                break;
                            default:
                                throw new Error(`Unexpected watchState ${this._watchState}`);
                        }
                        switch(this._watchState){
                            case "WAITING_ACTIVE":
                                this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting", "mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active", "mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_LOCK":
                                this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active", "mapboxgl-ctrl-geolocate-active");
                                break;
                            case "OFF":
                                break;
                            default:
                                throw new Error(`Unexpected watchState ${this._watchState}`);
                        }
                        if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                        else if (void 0 === this._geolocationWatchID) {
                            let t1;
                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting", "mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), ma++, ma > 1 ? (t1 = {
                                maximumAge: 6e5,
                                timeout: 0
                            }, _a = !0) : (t1 = this.options.positionOptions, _a = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, t1);
                        }
                    } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                    return !0;
                }
                _clearWatch() {
                    window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting", "mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                }
                constructor(e1){
                    super(), this.options = t1.extend({}, ua, e1), t1.bindAll([
                        "_onSuccess",
                        "_onError",
                        "_onZoom",
                        "_finish",
                        "_setupUI",
                        "_updateCamera",
                        "_updateMarker"
                    ], this);
                }
            },
            AttributionControl: ta,
            LogoControl: ea,
            ScaleControl: class {
                getDefaultPosition() {
                    return "bottom-left";
                }
                _onMove() {
                    fa(this._map, this._container, this.options);
                }
                onAdd(t1) {
                    return this._map = t1, this._container = r.create("div", "maplibregl-ctrl maplibregl-ctrl-scale mapboxgl-ctrl mapboxgl-ctrl-scale", t1.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
                }
                onRemove() {
                    r.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
                }
                setUnit(t1) {
                    this.options.unit = t1, fa(this._map, this._container, this.options);
                }
                constructor(e1){
                    this.options = t1.extend({}, pa, e1), t1.bindAll([
                        "_onMove",
                        "setUnit"
                    ], this);
                }
            },
            FullscreenControl: class {
                onAdd(e1) {
                    return this._map = e1, this._container || (this._container = this._map.getContainer()), this._controlContainer = r.create("div", "maplibregl-ctrl maplibregl-ctrl-group mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", t1.warnOnce("This device does not support fullscreen mode.")), this._controlContainer;
                }
                onRemove() {
                    r.remove(this._controlContainer), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._changeIcon);
                }
                _checkFullscreenSupport() {
                    return !!(document.fullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitFullscreenEnabled);
                }
                _setupUI() {
                    const t1 = this._fullscreenButton = r.create("button", "maplibregl-ctrl-fullscreen mapboxgl-ctrl-fullscreen", this._controlContainer);
                    r.create("span", "maplibregl-ctrl-icon mapboxgl-ctrl-icon", t1).setAttribute("aria-hidden", "true"), t1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._changeIcon);
                }
                _updateTitle() {
                    const t1 = this._getTitle();
                    this._fullscreenButton.setAttribute("aria-label", t1), this._fullscreenButton.title = t1;
                }
                _getTitle() {
                    return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                }
                _isFullscreen() {
                    return this._fullscreen;
                }
                _changeIcon() {
                    (window.document.fullscreenElement || window.document.mozFullScreenElement || window.document.webkitFullscreenElement || window.document.msFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("maplibregl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("maplibregl-ctrl-fullscreen"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
                }
                _onClickFullscreen() {
                    this._isFullscreen() ? window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.mozCancelFullScreen ? window.document.mozCancelFullScreen() : window.document.msExitFullscreen ? window.document.msExitFullscreen() : window.document.webkitCancelFullScreen && window.document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
                }
                constructor(e1){
                    this._fullscreen = !1, e1 && e1.container && (e1.container instanceof HTMLElement ? this._container = e1.container : t1.warnOnce("Full screen control 'container' must be a DOM element.")), t1.bindAll([
                        "_onClickFullscreen",
                        "_changeIcon"
                    ], this), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (this._fullscreenchange = "MSFullscreenChange");
                }
            },
            TerrainControl: class {
                onAdd(t1) {
                    return this._map = t1, this._container = r.create("div", "maplibregl-ctrl maplibregl-ctrl-group mapboxgl-ctrl mapboxgl-ctrl-group"), this._terrainButton = r.create("button", "maplibregl-ctrl-terrain mapboxgl-ctrl-terrain", this._container), r.create("span", "maplibregl-ctrl-icon mapboxgl-ctrl-icon", this._terrainButton).setAttribute("aria-hidden", "true"), this._terrainButton.type = "button", this._terrainButton.addEventListener("click", this._toggleTerrain), this._updateTerrainIcon(), this._map.on("terrain", this._updateTerrainIcon), this._container;
                }
                onRemove() {
                    r.remove(this._container), this._map.off("terrain", this._updateTerrainIcon), this._map = void 0;
                }
                _toggleTerrain() {
                    this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
                }
                _updateTerrainIcon() {
                    this._terrainButton.classList.remove("maplibregl-ctrl-terrain", "mapboxgl-ctrl-terrain"), this._terrainButton.classList.remove("maplibregl-ctrl-terrain-enabled", "mapboxgl-ctrl-terrain-enabled"), this._map.style.terrain ? (this._terrainButton.classList.add("maplibregl-ctrl-terrain-enabled", "mapboxgl-ctrl-terrain-enabled"), this._terrainButton.title = this._map._getUIString("TerrainControl.disableTerrain")) : (this._terrainButton.classList.add("maplibregl-ctrl-terrain", "mapboxgl-ctrl-terrain"), this._terrainButton.title = this._map._getUIString("TerrainControl.enableTerrain"));
                }
                constructor(e1){
                    this.options = e1, t1.bindAll([
                        "_toggleTerrain",
                        "_updateTerrainIcon"
                    ], this);
                }
            },
            Popup: class extends t1.Evented {
                addTo(e1) {
                    return this._map && this.remove(), this._map = e1, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("maplibregl-popup-track-pointer", "mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer", "mapboxgl-track-pointer")) : this._map.on("move", this._update), this.fire(new t1.Event("open")), this;
                }
                isOpen() {
                    return !!this._map;
                }
                remove() {
                    return this._content && r.remove(this._content), this._container && (r.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), delete this._map), this.fire(new t1.Event("close")), this;
                }
                getLngLat() {
                    return this._lngLat;
                }
                setLngLat(e1) {
                    return this._lngLat = t1.LngLat.convert(e1), this._pos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("maplibregl-popup-track-pointer", "mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.remove("maplibregl-track-pointer", "mapboxgl-track-pointer")), this;
                }
                trackPointer() {
                    return this._trackPointer = !0, this._pos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("maplibregl-popup-track-pointer", "mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer", "mapboxgl-track-pointer")), this;
                }
                getElement() {
                    return this._container;
                }
                setText(t1) {
                    return this.setDOMContent(document.createTextNode(t1));
                }
                setHTML(t1) {
                    const e1 = document.createDocumentFragment(), i = document.createElement("body");
                    let o;
                    for(i.innerHTML = t1; o = i.firstChild, o;)e1.appendChild(o);
                    return this.setDOMContent(e1);
                }
                getMaxWidth() {
                    return this._container && this._container.style.maxWidth;
                }
                setMaxWidth(t1) {
                    return this.options.maxWidth = t1, this._update(), this;
                }
                setDOMContent(t1) {
                    if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                    else this._content = r.create("div", "maplibregl-popup-content mapboxgl-popup-content", this._container);
                    return this._content.appendChild(t1), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
                }
                addClassName(t1) {
                    this._container && this._container.classList.add(t1);
                }
                removeClassName(t1) {
                    this._container && this._container.classList.remove(t1);
                }
                setOffset(t1) {
                    return this.options.offset = t1, this._update(), this;
                }
                toggleClassName(t1) {
                    if (this._container) return this._container.classList.toggle(t1);
                }
                _createCloseButton() {
                    this.options.closeButton && (this._closeButton = r.create("button", "maplibregl-popup-close-button mapboxgl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.setAttribute("aria-label", "Close popup"), this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
                }
                _onMouseUp(t1) {
                    this._update(t1.point);
                }
                _onMouseMove(t1) {
                    this._update(t1.point);
                }
                _onDrag(t1) {
                    this._update(t1.point);
                }
                _update(t1) {
                    if (!this._map || !this._lngLat && !this._trackPointer || !this._content) return;
                    if (this._container || (this._container = r.create("div", "maplibregl-popup mapboxgl-popup", this._map.getContainer()), this._tip = r.create("div", "maplibregl-popup-tip mapboxgl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className && this.options.className.split(" ").forEach((t1)=>this._container.classList.add(t1)), this._trackPointer && this._container.classList.add("maplibregl-popup-track-pointer", "mapboxgl-popup-track-pointer")), this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._map.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = na(this._lngLat, this._pos, this._map.transform)), this._trackPointer && !t1) return;
                    const e1 = this._pos = this._trackPointer && t1 ? t1 : this._map.project(this._lngLat);
                    let i = this.options.anchor;
                    const o = ya(this.options.offset);
                    if (!i) {
                        const t1 = this._container.offsetWidth, a = this._container.offsetHeight;
                        let r;
                        r = e1.y + o.bottom.y < a ? [
                            "top"
                        ] : e1.y > this._map.transform.height - a ? [
                            "bottom"
                        ] : [], e1.x < t1 / 2 ? r.push("left") : e1.x > this._map.transform.width - t1 / 2 && r.push("right"), i = 0 === r.length ? "bottom" : r.join("-");
                    }
                    const a = e1.add(o[i]).round();
                    r.setTransform(this._container, `${la[i]} translate(${a.x}px,${a.y}px)`), ca(this._container, i, "popup");
                }
                _focusFirstElement() {
                    if (!this.options.focusAfterOpen || !this._container) return;
                    const t1 = this._container.querySelector(va);
                    t1 && t1.focus();
                }
                _onClose() {
                    this.remove();
                }
                constructor(e1){
                    super(), this.options = t1.extend(Object.create(xa), e1), t1.bindAll([
                        "_update",
                        "_onClose",
                        "remove",
                        "_onMouseMove",
                        "_onMouseUp",
                        "_onDrag"
                    ], this);
                }
            },
            Marker: ha,
            Style: ee,
            LngLat: t1.LngLat,
            LngLatBounds: t1.LngLatBounds,
            Point: t1.pointGeometry,
            MercatorCoordinate: t1.MercatorCoordinate,
            Evented: t1.Evented,
            AJAXError: t1.AJAXError,
            config: t1.config,
            CanvasSource: P,
            GeoJSONSource: C,
            ImageSource: D,
            RasterDEMTileSource: I,
            RasterTileSource: T,
            VectorTileSource: w,
            VideoSource: z,
            prewarm: function() {
                j().acquire(G);
            },
            clearPrewarmedResources: function() {
                const t1 = q;
                t1 && (t1.isPreloaded() && 1 === t1.numActive() ? (t1.release(G), q = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
            },
            get version () {
                return "2.4.0";
            },
            get workerCount () {
                return Z.workerCount;
            },
            set workerCount (t){
                Z.workerCount = t;
            },
            get maxParallelImageRequests () {
                return t1.config.MAX_PARALLEL_IMAGE_REQUESTS;
            },
            set maxParallelImageRequests (e){
                t1.config.MAX_PARALLEL_IMAGE_REQUESTS = e;
            },
            clearStorage (e1) {
                t1.clearTileCache(e1);
            },
            workerUrl: "",
            addProtocol (e1, i) {
                t1.config.REGISTERED_PROTOCOLS[e1] = i;
            },
            removeProtocol (e1) {
                delete t1.config.REGISTERED_PROTOCOLS[e1];
            }
        };
        return Jo.extend(ba, {
            isSafari: t1.isSafari,
            getPerformanceMetrics: t1.PerformanceUtils.getPerformanceMetrics
        }), ba;
    });
    //
    var maplibregl$1 = maplibregl;
    return maplibregl$1;
});

},{}],"PZsMs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
class MapboxPitchToggleControl {
    onAdd(map) {
        this._map = map;
        let _this = this;
        this._btn = document.createElement('button');
        this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-3d';
        this._btn.type = 'button';
        this._btn['aria-label'] = 'Toggle Pitch';
        this._btn.onclick = function() {
            if (map.getPitch() === 0) {
                let options = {
                    pitch: _this._pitch,
                    bearing: 0,
                    zoom: map.getZoom()
                };
                if (!_this._bearing) options.bearing = map.getBearing();
                else options.bearing = _this._bearing;
                if (_this._minpitchzoom && map.getZoom() > _this._minpitchzoom) options.zoom = _this._minpitchzoom;
                map.easeTo(options);
                _this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-2d';
            } else {
                map.easeTo({
                    pitch: 0,
                    bearing: map.getBearing()
                });
                _this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-3d';
            }
        };
        this._map.on('pitchend', function() {
            if (!_this._map) return;
            if (_this._map.getPitch() === 0) _this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-3d';
            else _this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-2d';
        });
        this._container = document.createElement('div');
        this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
        this._container.appendChild(this._btn);
        return this._container;
    }
    onRemove() {
        if (!this._container || !this._container.parentNode || !this._map) return;
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
    constructor(options){
        this._pitch = options.pitch || 70;
        this._bearing = options.bearing || null;
        this._minpitchzoom = options.minpitchzoom || null;
    }
}
exports.default = MapboxPitchToggleControl;

},{}],"i2suf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class BuildingControl {
    onAdd(map) {
        this.setupData(map);
        this._container = document.createElement('div');
        this._container.setAttribute('x-bind', 'mapBuildingControl');
        map.on('move', this.onMove.bind(this));
        return this._container;
    }
    setupData(map) {
        const state = this._state;
        state.buildings = map.getSource(this._sourceId)._data.features.reduce((buildings, feature)=>{
            if (!feature.properties.building) return buildings;
            let { properties } = feature, buildingId = properties.building || properties.id;
            if (!buildings.has(buildingId)) buildings.set(buildingId, {
                levels: new Map(),
                focus () {
                    state.activeBuilding = this.properties.id;
                    map.fitBounds(this.properties.extent, {
                        padding: 20
                    });
                }
            });
            let building = buildings.get(buildingId);
            switch(properties.type){
                case 'building':
                    buildings.set(properties.id, Object.assign(feature, building));
                    break;
                case 'level':
                    building.levels.set(feature.properties.id, feature);
                    break;
            }
            if (properties.isInitial && !building.activeLevel) building.activeLevel = feature.properties.id;
            return buildings;
        }, new Map());
        Alpine.effect(()=>{
            const levelFilter = Array.from(state.buildings.values()).map(({ activeLevel, properties: { id } })=>`${id}_${activeLevel}`);
            Object.values(map.style._layers).filter(({ filter })=>filter && filter[1] == 'activeLevels').forEach(({ id })=>{
                let filter = map.getFilter(id);
                filter[2] = [
                    'literal',
                    levelFilter
                ];
                map.setFilter(id, filter);
            });
        });
    }
    clearActiveBuilding() {
        this._state.activeBuilding = null;
    }
    setActiveBuilding(buildingId) {
        let building = this._state.buildings.get(buildingId);
        if (building) {
            this._state.activeBuilding = buildingId;
            return building;
        }
    }
    setLevel(buildingId, levelId) {
        let building = this.setActiveBuilding(buildingId);
        if (building && building.levels.has(levelId)) {
            building.activeLevel = levelId;
            return building;
        }
    }
    onMove({ target: map }) {
        Alpine.nextTick(()=>{
            if (map._moving || map._zooming) return;
            const buildingsInViewport = Array.from(map.queryRenderedFeatures({
                layers: [
                    'qagomaBase'
                ]
            }).reduce((acc, { id })=>acc.add(id), new Set()));
            if (map.getZoom() <= 17) this.clearActiveBuilding();
            else if (buildingsInViewport.length === 1) this.setActiveBuilding(buildingsInViewport[0]);
        });
    }
    onRemove() {
        this._container.parentNode.removeChild(this._container);
    }
    constructor(sourceId){
        this._state = Alpine.reactive({
            buildings: new Map(),
            activeBuilding: null
        });
        this._sourceId = sourceId;
        const state = this._state;
        Alpine.bind('mapBuildingControl', ()=>({
                [':class']: `'maplibregl-ctrl maplibregl-ctrl-buildings'`,
                ['x-init'] () {
                    this.$el.append(...[
                        'buildingControl',
                        'levelControl'
                    ].map((control)=>{
                        let el = document.createElement('div');
                        el.setAttribute('x-bind', control);
                        return el;
                    }));
                },
                ['x-data'] () {
                    return {
                        state,
                        control: {
                            [':class']: `'maplibregl-ctrl-group'`,
                            ['x-data'] () {
                                return {
                                    buildingLoop: {
                                        ['x-for']: `building in Array.from(state.buildings.values())`
                                    }
                                };
                            }
                        },
                        levelControl: {
                            ['x-bind']: `control`,
                            ['x-show']: `state.activeBuilding`,
                            ['x-data'] () {
                                return {
                                    init () {
                                        this.$el.innerHTML = `<template x-bind="buildingLoop">
                    <label x-bind="label">
                      <span x-bind="labelText"></span>
                      <select x-bind="select">
                        <template x-for="level in levels">
                          <option x-bind="option"></option>
                        </template>
                      </select>
                    </label>
                  </template>`;
                                    },
                                    label: {
                                        ['x-data']: `{
                    levels: Array.from(building.levels.values()).reverse(),
                    title: \`Select a level for the $\{building.properties.name}\`
                  }`,
                                        ['x-show']: `state.activeBuilding === building.properties.id`,
                                        [':aria-label']: 'title',
                                        [':title']: 'title'
                                    },
                                    labelText: {
                                        ['x-text'] () {
                                            const { building } = this;
                                            try {
                                                return building.levels.get(building.activeLevel).properties.name.match(/(\d|\b\w(?=\w+ level))/i)[0];
                                            } catch  {}
                                        }
                                    },
                                    select: {
                                        ['x-model']: `building.activeLevel`
                                    },
                                    option: {
                                        ['x-text']: `level.properties.name`,
                                        [':value']: `level.properties.id`,
                                        [':selected']: 'building.activeLevel == level.properties.id'
                                    }
                                };
                            }
                        },
                        buildingControl: {
                            ['x-bind']: `control`,
                            ['x-data'] () {
                                return {
                                    init () {
                                        this.$el.innerHTML = `<template x-bind="buildingLoop">
                    <button x-bind="button"></button>
                  </template>`;
                                    },
                                    button: {
                                        [':title']: '`Focus on the ${building.properties.name} building`',
                                        ['@click']: `building.focus()`,
                                        ['x-text']: `building.properties.id.toUpperCase()`,
                                        [':class']: `state.activeBuilding === building.properties.id && 'active'`
                                    }
                                };
                            }
                        }
                    };
                }
            }));
    }
}
exports.default = BuildingControl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"68Hdb"}],"aexFM":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"type\":\"FeatureCollection\",\"id\":\"qagoma\",\"properties\":{\"name\":\"Queensland Art Gallery | Gallery of Modern Art\",\"extent\":[153.016375171,-27.47327518,153.01929664407442,-27.469927]},\"features\":[{\"type\":\"Feature\",\"properties\":{\"type\":\"interBuildingPathwayPoint\"},\"geometry\":{\"coordinates\":[[153.01807336768803,-27.471884900637455],[153.01794350787077,-27.471955500637456]],\"type\":\"LineString\"}},{\"type\":\"Feature\",\"properties\":{\"type\":\"interBuildingPathwayPoint\"},\"geometry\":{\"coordinates\":[[153.01723449046105,-27.47102469364228],[153.01737924246106,-27.47091305064228]],\"type\":\"LineString\"}},{\"type\":\"Feature\",\"properties\":{\"type\":\"interBuildingPathway\",\"detail\":\"high\"},\"geometry\":{\"coordinates\":[[153.01800217123872,-27.47192183271443],[153.0176617306493,-27.471587307091063],[153.0172869186735,-27.471141813049876],[153.01737876464858,-27.471076025320933],[153.01734046408234,-27.47102091978072],[153.01730232102943,-27.47097010093072]],\"type\":\"LineString\"}},{\"type\":\"Feature\",\"properties\":{\"type\":\"interBuildingPathway\",\"detail\":\"low\"},\"geometry\":{\"coordinates\":[[153.01730232102943,-27.47097010093072],[153.01800217123872,-27.47192183271443]],\"type\":\"LineString\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017793255,-27.472102223],[153.017863964,-27.472204594],[153.017885042,-27.472193135],[153.018564833,-27.473177306],[153.018543756,-27.473188765],[153.018603954,-27.47327518],[153.018765585,-27.473187306],[153.018757607,-27.473175757],[153.018814016,-27.47314509],[153.018821993,-27.473156638],[153.018978199,-27.473071713],[153.018921584,-27.472989747],[153.019177509,-27.472850609],[153.019144957,-27.472803481],[153.019173241,-27.472788103],[153.019106194,-27.472691035],[153.019068226,-27.472711676],[153.018719899,-27.472207383],[153.018731831,-27.472200896],[153.018426046,-27.471758194],[153.017793255,-27.472102223]]]},\"properties\":{\"building\":\"qag\",\"id\":\"qag\",\"name\":\"Queensland Art Gallery\",\"type\":\"building\",\"extent\":[153.017793255,-27.47327518,153.019177509,-27.471758194]}},{\"type\":\"Feature\",\"properties\":{\"building\":\"qag\",\"id\":\"qag_buildingLabel\",\"name\":\"Queensland Art Gallery\",\"type\":\"buildingLabel\",\"extent\":[153.017793255,-27.47327518,153.019177509,-27.471758194]},\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.018485382,-27.472516687000002]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.0178335,-27.470487082],[153.0178335,-27.470487082],[153.017286147,-27.469928426],[153.016375171,-27.47063103],[153.016922524,-27.471189686],[153.0178335,-27.470487082]]]},\"properties\":{\"building\":\"goma\",\"id\":\"goma\",\"name\":\"Gallery of Modern Art\",\"type\":\"building\",\"extent\":[153.016375171,-27.471189686,153.0178335,-27.469928426]}},{\"type\":\"Feature\",\"properties\":{\"building\":\"goma\",\"id\":\"goma_buildingLabel\",\"name\":\"Gallery of Modern Art\",\"type\":\"buildingLabel\",\"extent\":[153.016375171,-27.471189686,153.0178335,-27.469928426]},\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.0171043355,-27.470559056]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017953671,-27.472015011],[153.017793255,-27.472102223],[153.017863964,-27.472204594],[153.017885042,-27.472193135],[153.018564833,-27.473177306],[153.018543756,-27.473188765],[153.018603954,-27.47327518],[153.018765585,-27.473187306],[153.018757607,-27.473175757],[153.018814016,-27.47314509],[153.018821993,-27.473156638],[153.018978199,-27.473071713],[153.018921584,-27.472989747],[153.019177509,-27.472850609],[153.019144957,-27.472803481],[153.019173241,-27.472788103],[153.019106194,-27.472691035],[153.019068226,-27.472711676],[153.018719899,-27.472207383],[153.018731831,-27.472200896],[153.018426046,-27.471758194],[153.018049631,-27.47196284],[153.017994252,-27.471992947],[153.017953671,-27.472015011]]]},\"properties\":{\"building\":\"qag\",\"id\":\"level_1\",\"isInitial\":true,\"level\":\"level_1\",\"name\":\"Level 1\",\"type\":\"level\",\"extent\":[153.017793255,-27.47327518,153.019177509,-27.471758194],\"outline\":false}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018678128,-27.473060469],[153.018541045,-27.472862007],[153.018888555,-27.472673102],[153.018792276,-27.472533714],[153.018903526,-27.472473231],[153.01901235,-27.472630781],[153.019037653,-27.472667413],[153.019068227,-27.472711677],[153.019106194,-27.472691035],[153.019174842,-27.472790421],[153.019146558,-27.472805798],[153.019177509,-27.472850609],[153.019082109,-27.472902475],[153.019051157,-27.472857665]]]},\"properties\":{\"building\":\"qag\",\"id\":\"level_2\",\"isInitial\":false,\"level\":\"level_2\",\"name\":\"Level 2\",\"type\":\"level\",\"extent\":[153.018541045,-27.473060469,153.019177509,-27.472473231],\"outline\":false}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[153.017323638,-27.470096882],[153.017481289,-27.470257789],[153.017394746,-27.470324537],[153.017637007,-27.470571801],[153.017796066,-27.470449125],[153.017396292,-27.470040847],[153.017323638,-27.470096882]]],[[[153.017337483,-27.470171322],[153.017264179,-27.470227859],[153.017232499,-27.470195524],[153.017031161,-27.47035081],[153.017062841,-27.470383144],[153.016951317,-27.470469158],[153.016919637,-27.470436824],[153.016914661,-27.470440661],[153.016840932,-27.470365398],[153.016906304,-27.470314979],[153.016910748,-27.470319514],[153.017016311,-27.470238097],[153.017011867,-27.470233562],[153.017232067,-27.470063729],[153.017337483,-27.470171322]]]]},\"properties\":{\"building\":\"goma\",\"id\":\"park_level\",\"isInitial\":false,\"level\":\"park_level\",\"name\":\"Park Level\",\"type\":\"level\",\"extent\":[153.016840932,-27.470571801,153.017796066,-27.470040847],\"outline\":true}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017341024,-27.470866911],[153.01730373,-27.470828847],[153.017723551,-27.470505054],[153.017561695,-27.470339856],[153.017634349,-27.47028382],[153.017396292,-27.470040847],[153.017289982,-27.47012284],[153.017232068,-27.470063729],[153.017011867,-27.470233562],[153.01701631,-27.470238097],[153.016910748,-27.470319514],[153.016906304,-27.470314979],[153.016840931,-27.470365398],[153.01689441,-27.470419982],[153.016875195,-27.470434801],[153.0167695,-27.470326897],[153.016602106,-27.470456002],[153.016675312,-27.470530721],[153.016588058,-27.470598018],[153.016776259,-27.470790106],[153.016803508,-27.470769089],[153.016863112,-27.470829922],[153.01681414,-27.470867694],[153.017040481,-27.471098709],[153.017196272,-27.470978553]]]},\"properties\":{\"building\":\"goma\",\"id\":\"level_1\",\"isInitial\":true,\"level\":\"level_1\",\"name\":\"Level 1\",\"type\":\"level\",\"extent\":[153.016588058,-27.471098709,153.017723551,-27.470040847],\"outline\":false}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.016944326,-27.47029355],[153.016910709,-27.470319474],[153.016906304,-27.470314977],[153.01684107,-27.470365291],[153.016894627,-27.470419955],[153.016875287,-27.470434871],[153.0167695,-27.470326897],[153.016602106,-27.470456002],[153.016675312,-27.470530721],[153.016588058,-27.470598018],[153.016776259,-27.470790106],[153.016803508,-27.470769089],[153.016863112,-27.470829922],[153.01681414,-27.470867694],[153.017040481,-27.47109871],[153.017196272,-27.470978553],[153.017144243,-27.47092545],[153.017288995,-27.470813807],[153.017263013,-27.470787289],[153.017155506,-27.470870204],[153.017125736,-27.470839819],[153.017157377,-27.470815416],[153.017130696,-27.470788222],[153.017099091,-27.470812598],[153.016900831,-27.470610268],[153.016864309,-27.470572993],[153.016936152,-27.470517583],[153.016885962,-27.470466358],[153.016962675,-27.470407192],[153.016948142,-27.470392359],[153.017001086,-27.470351526],[153.016944326,-27.47029355],[153.016944326,-27.47029355]]]},\"properties\":{\"building\":\"goma\",\"id\":\"level_2\",\"isInitial\":false,\"level\":\"level_2\",\"name\":\"Level 2\",\"type\":\"level\",\"extent\":[153.016588058,-27.47109871,153.017288995,-27.47029355],\"outline\":true}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.016776258,-27.470790106],[153.016588058,-27.470598018],[153.016675313,-27.470530722],[153.016602106,-27.470456002],[153.016769499,-27.470326898],[153.016875287,-27.470434871],[153.016894627,-27.470419955],[153.01684107,-27.470365292],[153.016906303,-27.470314978],[153.01691071,-27.470319476],[153.017016276,-27.470238055],[153.017011871,-27.470233559],[153.0172321,-27.470063704],[153.017289982,-27.47012284],[153.017396292,-27.470040847],[153.017634349,-27.47028382],[153.017604733,-27.470306662],[153.017803882,-27.470509925],[153.01730536,-27.470894417],[153.017253331,-27.470841314],[153.017144243,-27.47092545],[153.017196272,-27.470978553],[153.017040481,-27.471098709],[153.01681414,-27.470867694],[153.016863112,-27.470829923],[153.016803509,-27.470769088],[153.016776258,-27.470790106]],[[153.016936151,-27.470517584],[153.016864309,-27.470572993],[153.016939371,-27.470649604],[153.016971011,-27.470625201],[153.016951366,-27.47060515],[153.016991567,-27.470574144],[153.016936151,-27.470517584]],[[153.017053472,-27.470637327],[153.017227349,-27.470814795],[153.017155507,-27.470870204],[153.017125736,-27.470839819],[153.017157377,-27.470815416],[153.017130696,-27.470788222],[153.017099091,-27.470812598],[153.01698163,-27.470692737],[153.017053472,-27.470637327]],[[153.017432977,-27.47037772],[153.017439717,-27.470384623],[153.017180034,-27.470584908],[153.017154651,-27.470558976],[153.017414345,-27.470358716],[153.017432977,-27.47037772]]]},\"properties\":{\"building\":\"goma\",\"id\":\"level_3\",\"isInitial\":false,\"level\":\"level_3\",\"name\":\"Level 3\",\"type\":\"level\",\"extent\":[153.016588058,-27.471098709,153.017803882,-27.470040847],\"outline\":true}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018564402,-27.472250602],[153.018622164,-27.472219199],[153.018546148,-27.472109146],[153.018488386,-27.472140549],[153.018564402,-27.472250602],[153.018564402,-27.472250602]]]},\"properties\":{\"building\":\"qag\",\"id\":\"d72f32b6-a74a-4001-b93a-8777887e27cf\",\"isClosed\":false,\"level\":\"level_1\",\"name\":\"QAG Cafe\",\"type\":\"internal_venue\",\"venue\":{\"_id\":\"d72f32b6-a74a-4001-b93a-8777887e27cf\",\"description\":[{\"_key\":\"992923d2dd7e\",\"_type\":\"block\",\"children\":[{\"_key\":\"f4a651cce3e70\",\"_type\":\"span\",\"marks\":[],\"text\":\"A tranquil haven to refresh and recharge. Retreat to the secluded, leafy courtyard, or take a seat inside with an artist-created mural as a calming backdrop to your dining.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"18c1fe3e00d3\",\"_type\":\"block\",\"children\":[{\"_key\":\"74ef2d8115890\",\"_type\":\"span\",\"marks\":[],\"text\":\"Walk-ins welcome. No bookings required.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"07ce949fe1da\",\"_type\":\"block\",\"children\":[{\"_key\":\"e4ff7a4e90ee\",\"_type\":\"span\",\"marks\":[\"strong\"],\"text\":\"Sat 19 Apr - Mon 21 Apr:\"},{\"_key\":\"d124d919fca8\",\"_type\":\"span\",\"marks\":[],\"text\":\" 10.00am - 3.00pm\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"4e5c179579ae\",\"_type\":\"block\",\"children\":[{\"_key\":\"8e425eeba5fc0\",\"_type\":\"span\",\"marks\":[],\"text\":\"Closed Good Friday, Christmas Day & Boxing Day.\"}],\"markDefs\":[],\"style\":\"small\"}],\"emailAddress\":null,\"hours\":[{\"close\":\"16:00\",\"days\":[0,1,2,3,4,5,6],\"open\":\"10:00\"}],\"phone\":\"+61 (0)7 3840 7145\",\"type\":\"foodAndBeverage\",\"url\":\"https://www.qagoma.qld.gov.au/visit/eat-and-drink/\"},\"extent\":[153.018488386,-27.472250602,153.018622164,-27.472109146]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.0181695348,-27.4722836457],[153.0181695348,-27.4722836457],[153.0181037646,-27.4721884908],[153.0180272304,-27.4722300719],[153.0180930006,-27.4723252268],[153.0181695348,-27.4722836457]]]},\"properties\":{\"building\":\"qag\",\"id\":\"5a6c3181-7691-4efa-b17a-1f46e9715216\",\"isClosed\":false,\"level\":\"level_1\",\"name\":\"Artists & Writers Store\",\"type\":\"internal_venue\",\"venue\":{\"_id\":\"5a6c3181-7691-4efa-b17a-1f46e9715216\",\"description\":[{\"_key\":\"23443e14e340\",\"_type\":\"block\",\"children\":[{\"_key\":\"045628d4809d\",\"_type\":\"span\",\"marks\":[],\"text\":\"The second QAG Store is located at the Stanley Place entrance and features books and products from leading Australian and First Nations artists and makers. Shop here for the best locally made items including jewellery, ceramics, textiles and delicious food products. Featured brands include Better World Arts, Town Camp Designs, Tjanpi Desert Weavers, Mabu Mabu, Native Oz Bushfoods, Fink and Earth Greetings.\\n\"}],\"markDefs\":[],\"style\":\"normal\"}],\"emailAddress\":null,\"hours\":[{\"close\":\"17:00\",\"days\":[0,1,2,3,4,5,6],\"open\":\"10:00\"}],\"phone\":\"+61 (0)7 3840 7667\",\"type\":\"retail\",\"url\":\"https://qagoma.store\"},\"extent\":[153.0180272304,-27.4723252268,153.0181695348,-27.4721884908]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018509249,-27.472376403],[153.018385119,-27.472196692],[153.018220684,-27.472286089],[153.018344814,-27.472465801]]]},\"properties\":{\"building\":\"qag\",\"id\":\"47a1f91e-337f-447f-90f1-1a661caaeef5\",\"level\":\"level_1\",\"name\":\"Gallery 3\",\"type\":\"gallery_space\",\"extent\":[153.018220684,-27.472465801,153.018509249,-27.472196692],\"markerLabel\":\"3\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.01870245,-27.472656111],[153.01870245,-27.472656111],[153.018509249,-27.472376403],[153.018344814,-27.472465801],[153.018538015,-27.472745508]]]},\"properties\":{\"building\":\"qag\",\"id\":\"97cea17a-ff72-4982-a7bf-ca1de7aaa639\",\"level\":\"level_1\",\"name\":\"Gallery 4\",\"type\":\"gallery_space\",\"extent\":[153.018344814,-27.472745508,153.01870245,-27.472376403],\"markerLabel\":\"4\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018810986,-27.472813245],[153.01870242,-27.472656067],[153.018537985,-27.472745465],[153.018646552,-27.472902643]]]},\"properties\":{\"building\":\"qag\",\"id\":\"d8f9242d-a09f-4d65-a15c-34cfe42a82f1\",\"level\":\"level_1\",\"name\":\"Gallery 5\",\"type\":\"gallery_space\",\"extent\":[153.018537985,-27.472902643,153.018810986,-27.472656067],\"markerLabel\":\"5\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.01889886,-27.472940464],[153.018810986,-27.472813245],[153.018646552,-27.472902643],[153.018734425,-27.473029861]]]},\"properties\":{\"building\":\"qag\",\"id\":\"163c97ae-6be7-4e59-8afc-2ea663f8cb16\",\"level\":\"level_1\",\"name\":\"Gallery 6\",\"type\":\"gallery_space\",\"extent\":[153.018646552,-27.473029861,153.01889886,-27.472813245],\"markerLabel\":\"6\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018821959,-27.473156657],[153.018978199,-27.473071713],[153.018921584,-27.472989747],[153.01892972,-27.472985141],[153.01889886,-27.472940464],[153.018734425,-27.473029861]]]},\"properties\":{\"building\":\"qag\",\"id\":\"82bbfb6a-82c2-4eec-8e8a-06244c40848b\",\"level\":\"level_1\",\"name\":\"Gallery 7\",\"type\":\"gallery_space\",\"extent\":[153.018734425,-27.473156657,153.018978199,-27.472940464],\"markerLabel\":\"7\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018814016,-27.47314509],[153.018734425,-27.473029861],[153.018678128,-27.473060469],[153.018757718,-27.473175697]]]},\"properties\":{\"building\":\"qag\",\"id\":\"c68a587a-af1d-4be2-9c22-5dff17d3e3f8\",\"level\":\"level_1\",\"name\":\"Gallery 8\",\"type\":\"gallery_space\",\"extent\":[153.018678128,-27.473175697,153.018814016,-27.473029861],\"markerLabel\":\"8\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018627456,-27.473056301],[153.018521166,-27.473114087],[153.018564833,-27.473177306],[153.018543756,-27.473188765],[153.018603954,-27.47327518],[153.018765585,-27.473187306],[153.018678128,-27.473060469],[153.018643401,-27.473079348]]]},\"properties\":{\"building\":\"qag\",\"id\":\"4da7855b-9dac-4f01-8286-20d5a986086f\",\"level\":\"level_1\",\"name\":\"Gallery 9\",\"type\":\"gallery_space\",\"extent\":[153.018521166,-27.47327518,153.018765585,-27.473056301],\"markerLabel\":\"9\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018665234,-27.473042021],[153.018572264,-27.472907424],[153.018431339,-27.47298404],[153.018521166,-27.473114087],[153.018627456,-27.473056301],[153.018630617,-27.47306084]]]},\"properties\":{\"building\":\"qag\",\"id\":\"80247da5-29cc-4b66-b0d0-70bddb312988\",\"level\":\"level_1\",\"name\":\"Gallery 10\",\"type\":\"gallery_space\",\"extent\":[153.018431339,-27.473114087,153.018665234,-27.472907424],\"markerLabel\":\"10\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018572264,-27.472907424],[153.018514947,-27.472824225],[153.018520163,-27.472821388],[153.018486904,-27.472773237],[153.018481688,-27.472776072],[153.018477628,-27.472770448],[153.018336704,-27.472847064],[153.018431339,-27.47298404]]]},\"properties\":{\"building\":\"qag\",\"id\":\"bb29fd41-9e65-48c4-ae62-53b0106db0b0\",\"level\":\"level_1\",\"name\":\"Gallery 11\",\"type\":\"gallery_space\",\"extent\":[153.018336704,-27.47298404,153.018572264,-27.472770448],\"markerLabel\":\"11\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018477628,-27.472770448],[153.018382994,-27.472633472],[153.018242068,-27.472710088],[153.018336704,-27.472847064]]]},\"properties\":{\"building\":\"qag\",\"id\":\"b0df16bf-fdc9-402f-bbe1-dc2d421cf559\",\"level\":\"level_1\",\"name\":\"Gallery 12\",\"type\":\"gallery_space\",\"extent\":[153.018242068,-27.472847064,153.018477628,-27.472633472],\"markerLabel\":\"12\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018382994,-27.472633472],[153.018321805,-27.4725446],[153.018327019,-27.472541765],[153.018293733,-27.472493573],[153.018147433,-27.472573111],[153.018242068,-27.472710088]]]},\"properties\":{\"building\":\"qag\",\"id\":\"3101fbdc-d9ee-4c6a-807f-c8760b189295\",\"level\":\"level_1\",\"name\":\"Gallery 13\",\"type\":\"gallery_space\",\"extent\":[153.018147433,-27.472710088,153.018382994,-27.472493573],\"markerLabel\":\"13\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018258033,-27.472453294],[153.018176935,-27.472331698],[153.018034309,-27.472409238],[153.01811751,-27.472529692]]]},\"properties\":{\"building\":\"qag\",\"id\":\"f27a6cc5-16f0-468b-b55b-f63e4d15c498\",\"level\":\"level_1\",\"name\":\"Gallery 14\",\"type\":\"gallery_space\",\"extent\":[153.018034309,-27.472529692,153.018258033,-27.472331698],\"markerLabel\":\"14\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.019006255,-27.472744954],[153.018940495,-27.47264975],[153.018898467,-27.472672599],[153.018864088,-27.472622825],[153.018833126,-27.472639658],[153.018867414,-27.472689299],[153.018764152,-27.47274544],[153.018830004,-27.472840776]]]},\"properties\":{\"building\":\"qag\",\"id\":\"5bef8035-d482-4b26-b46d-730105ffbb03\",\"level\":\"level_1\",\"name\":\"Pelican Lounge\",\"type\":\"gallery_space\",\"extent\":[153.018764152,-27.472840776,153.019006255,-27.472622825]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018831038,-27.472574977],[153.01884344,-27.472568245],[153.018607663,-27.4722269],[153.018461042,-27.472306613],[153.01854261,-27.472424701],[153.018645696,-27.472368511],[153.018765375,-27.472541571],[153.018662111,-27.472597712],[153.018729864,-27.472695799],[153.018864088,-27.472622825]]]},\"properties\":{\"building\":\"qag\",\"id\":\"946bb479-b237-4776-b13f-027d2cc2cec1\",\"level\":\"level_1\",\"name\":\"Watermall\",\"type\":\"gallery_space\",\"extent\":[153.018461042,-27.472695799,153.018864088,-27.4722269]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018106163,-27.471931923],[153.018106896,-27.47193791],[153.018111181,-27.471965691],[153.018116572,-27.471993338],[153.018124319,-27.472025561],[153.018134701,-27.472060023],[153.018144387,-27.472085933],[153.018151815,-27.472102689],[153.01816006,-27.47211869],[153.018169157,-27.472133645],[153.018174036,-27.472140639],[153.018184957,-27.472155009],[153.018206319,-27.472180275],[153.018226515,-27.472201134],[153.018244915,-27.472217851],[153.01826089,-27.472230694],[153.018273809,-27.472239928],[153.018286081,-27.472247599],[153.018288605,-27.47224898],[153.018636619,-27.472059777],[153.0184276,-27.471757168],[153.018106163,-27.471931923]]]},\"properties\":{\"building\":\"qag\",\"id\":\"25b43fe6-a060-4ff6-9d58-b8eccafd72f9\",\"level\":\"level_1\",\"name\":\"QAG Sculpture Courtyard\",\"type\":\"gallery_space\",\"terrain\":\"grass\",\"extent\":[153.018106163,-27.47224898,153.018636619,-27.471757168]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018843396,-27.472568183],[153.018934792,-27.472518494],[153.018868962,-27.472423188],[153.018777566,-27.472472877],[153.018843396,-27.472568183],[153.018843396,-27.472568183]]]},\"properties\":{\"building\":\"qag\",\"id\":\"c6b9da53-fedc-4e36-b5ed-676e1c9451e9\",\"isClosed\":false,\"level\":\"level_1\",\"name\":\"Lecture Theatre\",\"type\":\"internal_venue\",\"venue\":{\"_id\":\"c6b9da53-fedc-4e36-b5ed-676e1c9451e9\",\"description\":null,\"hours\":null,\"type\":null,\"url\":null},\"extent\":[153.018777566,-27.472568183,153.018934792,-27.472423188]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.0190102,-27.472743223],[153.018941766,-27.472644147],[153.018761777,-27.472742001],[153.018830212,-27.472841078]]]},\"properties\":{\"building\":\"qag\",\"id\":\"2de5e310-da02-4f5b-9068-90257e137afe\",\"level\":\"level_2\",\"name\":\"Gallery 1\",\"type\":\"gallery_space\",\"extent\":[153.018761777,-27.472841078,153.0190102,-27.472644147],\"markerLabel\":\"1\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.01889886,-27.472940464],[153.018761777,-27.472742001],[153.018597342,-27.472831399],[153.018734425,-27.473029861]]]},\"properties\":{\"building\":\"qag\",\"id\":\"319e23a6-23ba-4301-ab54-95cc1a01e57c\",\"level\":\"level_2\",\"name\":\"Gallery 2\",\"type\":\"gallery_space\",\"extent\":[153.018597342,-27.473029861,153.01889886,-27.472742001],\"markerLabel\":\"2\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.019118901,-27.472820834],[153.019174841,-27.472790421],[153.019106194,-27.472691035],[153.0190102,-27.472743223],[153.019060427,-27.472815941],[153.01910048,-27.472794165]]]},\"properties\":{\"building\":\"qag\",\"id\":\"b4a8f79f-0cd8-4975-a460-bec5ab5cb904\",\"isClosed\":false,\"level\":\"level_2\",\"name\":\"QAG Store\",\"type\":\"internal_venue\",\"venue\":{\"_id\":\"b4a8f79f-0cd8-4975-a460-bec5ab5cb904\",\"description\":[{\"_key\":\"eadfc9c200be\",\"_type\":\"block\",\"children\":[{\"_key\":\"42da37495eb5\",\"_type\":\"span\",\"marks\":[],\"text\":\"The QAG Store is home to some of the world's finest publications on art and culture, with a focus on Australian and Indigenous art, history and self-development and non-fiction titles. The Store also stocks a stunning range of jewellery and ceramics by Australian designers, Indigenous craft, greeting cards and art merchandise.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"emailAddress\":null,\"hours\":[{\"close\":\"17:00\",\"days\":[0,1,2,3,4,5,6],\"open\":\"10:00\"}],\"phone\":\"+61 (0)7 3840 7290\",\"type\":\"retail\",\"url\":\"https://qagoma.store\"},\"extent\":[153.0190102,-27.472820834,153.019174841,-27.472691035]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018999771,-27.472612612],[153.018903527,-27.472473231],[153.018792277,-27.472533714],[153.018888555,-27.472673102]]]},\"properties\":{\"building\":\"qag\",\"id\":\"c3659365-171c-40f1-afca-f04567b1ad4d\",\"isClosed\":false,\"level\":\"level_2\",\"name\":\"Member's Lounge\",\"type\":\"internal_venue\",\"venue\":{\"_id\":\"c3659365-171c-40f1-afca-f04567b1ad4d\",\"description\":null,\"emailAddress\":\"members@qagoma.qld.gov.au\",\"hours\":null,\"phone\":\"+61 (0)7 3840 7278\",\"type\":null,\"url\":null},\"extent\":[153.018792277,-27.472673102,153.018999771,-27.472473231]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017085603,-27.47030882],[153.017232499,-27.470195525],[153.017264179,-27.470227859],[153.017337484,-27.470171322],[153.017232068,-27.470063729],[153.017011867,-27.470233562]]]},\"properties\":{\"building\":\"goma\",\"id\":\"8edb6f1b-1d60-48d0-b864-089ce40a6a38\",\"level\":\"park_level\",\"name\":\"Children's Art Centre\",\"type\":\"gallery_space\",\"extent\":[153.017011867,-27.47030882,153.017337484,-27.470063729]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.0173920467496,-27.470322984520827],[153.01763394847512,-27.47057003615516],[153.01768236802462,-27.4705326126321],[153.01768241101104,-27.470532656533646],[153.01775265133574,-27.470478367690976],[153.01791173980382,-27.47035536246084],[153.01772448800284,-27.4701639380872],[153.017473869098,-27.4701639380872],[153.01751048868073,-27.470201317708714],[153.01742540672421,-27.470201317708714],[153.01747888326645,-27.470255904180142],[153.01746514619202,-27.470266615043982],[153.01744050917682,-27.470285604899313],[153.01744052340362,-27.470285619428996],[153.0173920467496,-27.470322984520827]]]},\"properties\":{\"building\":\"goma\",\"id\":\"a1f981ec-fa3c-4303-ac2d-b1b023790916\",\"isClosed\":true,\"level\":\"park_level\",\"name\":\"GOMA Bistro\",\"type\":\"internal_venue\",\"venue\":{\"_id\":\"a1f981ec-fa3c-4303-ac2d-b1b023790916\",\"closureMessage\":[{\"_key\":\"66e465bc5fea\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"GOMA Bistro is temporarily closed as Tony Albert and Nell’s \"},{\"_key\":\"3d1aac20f4c9\",\"_type\":\"span\",\"marks\":[\"em\"],\"text\":\"The BIG HOSE\"},{\"_key\":\"3d1aac20f4c10\",\"_type\":\"span\",\"marks\":[],\"text\":\" artwork is installed on the Bistro lawn.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"66e465bc5fea1\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"Please instead visit GOMA Cafe on Level 1 during this time.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"description\":[{\"_key\":\"66e465bc5fea\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"Boasting a genuine riverfront location and a commitment to fresh and local produce, the GOMA Bistro is a relaxed alfresco setting for all to enjoy.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"24bb2b1d9a1a\",\"_type\":\"block\",\"children\":[{\"_key\":\"e9a2af7e1d13\",\"_type\":\"span\",\"marks\":[],\"text\":\"Walk-ins welcome. No bookings required.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"ba2eb699ac38\",\"_type\":\"block\",\"children\":[{\"_key\":\"aeb3d76f64e10\",\"_type\":\"span\",\"marks\":[],\"text\":\"Closed Good Friday, Christmas Day & Boxing Day.\\nNew Year's Day: 10.00am - 3.00pm.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"emailAddress\":\"gomabistro@qagoma.qld.gov.au\",\"hours\":null,\"phone\":\"+61 (0)7 3842 9906\",\"type\":\"foodAndBeverage\",\"url\":\"https://www.qagoma.qld.gov.au/visit/eat-and-drink/\"},\"hidden\":true,\"ignoreVisibility\":true,\"fill-sort-key\":10,\"extent\":[153.0173920467496,-27.47057003615516,153.01791173980382,-27.4701639380872]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017321,-27.470095],[153.017321,-27.470095],[153.017479,-27.470256],[153.017392,-27.470323],[153.017634,-27.47057],[153.017793,-27.470447],[153.017394,-27.470039],[153.017321,-27.470095]]]},\"properties\":{\"building\":\"goma\",\"id\":\"a1f981ec-fa3c-4303-ac2d-b1b023790916_1\",\"isClosed\":true,\"level\":\"park_level\",\"name\":\"GOMA Bistro\",\"type\":\"internal_venue_fill\",\"venue\":{\"_id\":\"a1f981ec-fa3c-4303-ac2d-b1b023790916\",\"closureMessage\":[{\"_key\":\"66e465bc5fea\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"GOMA Bistro is temporarily closed as Tony Albert and Nell’s \"},{\"_key\":\"3d1aac20f4c9\",\"_type\":\"span\",\"marks\":[\"em\"],\"text\":\"The BIG HOSE\"},{\"_key\":\"3d1aac20f4c10\",\"_type\":\"span\",\"marks\":[],\"text\":\" artwork is installed on the Bistro lawn.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"66e465bc5fea1\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"Please instead visit GOMA Cafe on Level 1 during this time.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"description\":[{\"_key\":\"66e465bc5fea\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"Boasting a genuine riverfront location and a commitment to fresh and local produce, the GOMA Bistro is a relaxed alfresco setting for all to enjoy.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"24bb2b1d9a1a\",\"_type\":\"block\",\"children\":[{\"_key\":\"e9a2af7e1d13\",\"_type\":\"span\",\"marks\":[],\"text\":\"Walk-ins welcome. No bookings required.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"ba2eb699ac38\",\"_type\":\"block\",\"children\":[{\"_key\":\"aeb3d76f64e10\",\"_type\":\"span\",\"marks\":[],\"text\":\"Closed Good Friday, Christmas Day & Boxing Day.\\nNew Year's Day: 10.00am - 3.00pm.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"emailAddress\":\"gomabistro@qagoma.qld.gov.au\",\"hours\":null,\"phone\":\"+61 (0)7 3842 9906\",\"type\":\"foodAndBeverage\",\"url\":\"https://www.qagoma.qld.gov.au/visit/eat-and-drink/\"},\"extent\":[153.017321,-27.47057,153.017793,-27.470039]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01766529679298,-27.47024683122629]},\"properties\":{\"building\":\"goma\",\"id\":\"a1f981ec-fa3c-4303-ac2d-b1b023790916_2\",\"isClosed\":true,\"level\":\"park_level\",\"name\":\"GOMA Bistro\",\"type\":\"internal_venue_label\",\"venue\":{\"_id\":\"a1f981ec-fa3c-4303-ac2d-b1b023790916\",\"closureMessage\":[{\"_key\":\"66e465bc5fea\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"GOMA Bistro is temporarily closed as Tony Albert and Nell’s \"},{\"_key\":\"3d1aac20f4c9\",\"_type\":\"span\",\"marks\":[\"em\"],\"text\":\"The BIG HOSE\"},{\"_key\":\"3d1aac20f4c10\",\"_type\":\"span\",\"marks\":[],\"text\":\" artwork is installed on the Bistro lawn.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"66e465bc5fea1\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"Please instead visit GOMA Cafe on Level 1 during this time.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"description\":[{\"_key\":\"66e465bc5fea\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"Boasting a genuine riverfront location and a commitment to fresh and local produce, the GOMA Bistro is a relaxed alfresco setting for all to enjoy.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"24bb2b1d9a1a\",\"_type\":\"block\",\"children\":[{\"_key\":\"e9a2af7e1d13\",\"_type\":\"span\",\"marks\":[],\"text\":\"Walk-ins welcome. No bookings required.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"ba2eb699ac38\",\"_type\":\"block\",\"children\":[{\"_key\":\"aeb3d76f64e10\",\"_type\":\"span\",\"marks\":[],\"text\":\"Closed Good Friday, Christmas Day & Boxing Day.\\nNew Year's Day: 10.00am - 3.00pm.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"emailAddress\":\"gomabistro@qagoma.qld.gov.au\",\"hours\":null,\"phone\":\"+61 (0)7 3842 9906\",\"type\":\"foodAndBeverage\",\"url\":\"https://www.qagoma.qld.gov.au/visit/eat-and-drink/\"},\"inverseVisibility\":true}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[153.017689895,-27.470531011],[153.017500854,-27.470338055],[153.01751096,-27.470330261]],[[153.017524536,-27.47031979],[153.017534503,-27.470312103],[153.017723551,-27.470505054]]]},\"properties\":{\"building\":\"goma\",\"id\":\"a1f981ec-fa3c-4303-ac2d-b1b023790916_3\",\"isClosed\":true,\"level\":\"park_level\",\"name\":\"GOMA Bistro\",\"type\":\"internalWalls\",\"venue\":{\"_id\":\"a1f981ec-fa3c-4303-ac2d-b1b023790916\",\"closureMessage\":[{\"_key\":\"66e465bc5fea\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"GOMA Bistro is temporarily closed as Tony Albert and Nell’s \"},{\"_key\":\"3d1aac20f4c9\",\"_type\":\"span\",\"marks\":[\"em\"],\"text\":\"The BIG HOSE\"},{\"_key\":\"3d1aac20f4c10\",\"_type\":\"span\",\"marks\":[],\"text\":\" artwork is installed on the Bistro lawn.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"66e465bc5fea1\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"Please instead visit GOMA Cafe on Level 1 during this time.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"description\":[{\"_key\":\"66e465bc5fea\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"Boasting a genuine riverfront location and a commitment to fresh and local produce, the GOMA Bistro is a relaxed alfresco setting for all to enjoy.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"24bb2b1d9a1a\",\"_type\":\"block\",\"children\":[{\"_key\":\"e9a2af7e1d13\",\"_type\":\"span\",\"marks\":[],\"text\":\"Walk-ins welcome. No bookings required.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"ba2eb699ac38\",\"_type\":\"block\",\"children\":[{\"_key\":\"aeb3d76f64e10\",\"_type\":\"span\",\"marks\":[],\"text\":\"Closed Good Friday, Christmas Day & Boxing Day.\\nNew Year's Day: 10.00am - 3.00pm.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"emailAddress\":\"gomabistro@qagoma.qld.gov.au\",\"hours\":null,\"phone\":\"+61 (0)7 3842 9906\",\"type\":\"foodAndBeverage\",\"url\":\"https://www.qagoma.qld.gov.au/visit/eat-and-drink/\"},\"extent\":[153.017500854,-27.470531011,153.017723551,-27.470312103]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01757007837296,-27.47039527060722]},\"properties\":{\"building\":\"goma\",\"id\":\"a1f981ec-fa3c-4303-ac2d-b1b023790916_4\",\"isClosed\":true,\"level\":\"park_level\",\"name\":\"GOMA Bistro\",\"type\":\"amenity\",\"venue\":{\"_id\":\"a1f981ec-fa3c-4303-ac2d-b1b023790916\",\"closureMessage\":[{\"_key\":\"66e465bc5fea\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"GOMA Bistro is temporarily closed as Tony Albert and Nell’s \"},{\"_key\":\"3d1aac20f4c9\",\"_type\":\"span\",\"marks\":[\"em\"],\"text\":\"The BIG HOSE\"},{\"_key\":\"3d1aac20f4c10\",\"_type\":\"span\",\"marks\":[],\"text\":\" artwork is installed on the Bistro lawn.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"66e465bc5fea1\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"Please instead visit GOMA Cafe on Level 1 during this time.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"description\":[{\"_key\":\"66e465bc5fea\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"Boasting a genuine riverfront location and a commitment to fresh and local produce, the GOMA Bistro is a relaxed alfresco setting for all to enjoy.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"24bb2b1d9a1a\",\"_type\":\"block\",\"children\":[{\"_key\":\"e9a2af7e1d13\",\"_type\":\"span\",\"marks\":[],\"text\":\"Walk-ins welcome. No bookings required.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"ba2eb699ac38\",\"_type\":\"block\",\"children\":[{\"_key\":\"aeb3d76f64e10\",\"_type\":\"span\",\"marks\":[],\"text\":\"Closed Good Friday, Christmas Day & Boxing Day.\\nNew Year's Day: 10.00am - 3.00pm.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"emailAddress\":\"gomabistro@qagoma.qld.gov.au\",\"hours\":null,\"phone\":\"+61 (0)7 3842 9906\",\"type\":\"foodAndBeverage\",\"url\":\"https://www.qagoma.qld.gov.au/visit/eat-and-drink/\"},\"amenity\":\"toilet\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01744602620602,-27.47025069838703]},\"properties\":{\"building\":\"goma\",\"id\":\"a1f981ec-fa3c-4303-ac2d-b1b023790916_5\",\"isClosed\":true,\"level\":\"park_level\",\"name\":\"GOMA Bistro\",\"type\":\"traversal\",\"venue\":{\"_id\":\"a1f981ec-fa3c-4303-ac2d-b1b023790916\",\"closureMessage\":[{\"_key\":\"66e465bc5fea\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"GOMA Bistro is temporarily closed as Tony Albert and Nell’s \"},{\"_key\":\"3d1aac20f4c9\",\"_type\":\"span\",\"marks\":[\"em\"],\"text\":\"The BIG HOSE\"},{\"_key\":\"3d1aac20f4c10\",\"_type\":\"span\",\"marks\":[],\"text\":\" artwork is installed on the Bistro lawn.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"66e465bc5fea1\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"Please instead visit GOMA Cafe on Level 1 during this time.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"description\":[{\"_key\":\"66e465bc5fea\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"Boasting a genuine riverfront location and a commitment to fresh and local produce, the GOMA Bistro is a relaxed alfresco setting for all to enjoy.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"24bb2b1d9a1a\",\"_type\":\"block\",\"children\":[{\"_key\":\"e9a2af7e1d13\",\"_type\":\"span\",\"marks\":[],\"text\":\"Walk-ins welcome. No bookings required.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"ba2eb699ac38\",\"_type\":\"block\",\"children\":[{\"_key\":\"aeb3d76f64e10\",\"_type\":\"span\",\"marks\":[],\"text\":\"Closed Good Friday, Christmas Day & Boxing Day.\\nNew Year's Day: 10.00am - 3.00pm.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"emailAddress\":\"gomabistro@qagoma.qld.gov.au\",\"hours\":null,\"phone\":\"+61 (0)7 3842 9906\",\"type\":\"foodAndBeverage\",\"url\":\"https://www.qagoma.qld.gov.au/visit/eat-and-drink/\"},\"traversal\":\"elevator\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01735044264,-27.470106072344855]},\"properties\":{\"building\":\"goma\",\"id\":\"a1f981ec-fa3c-4303-ac2d-b1b023790916_6\",\"isClosed\":true,\"level\":\"park_level\",\"name\":\"GOMA Bistro\",\"type\":\"traversal\",\"venue\":{\"_id\":\"a1f981ec-fa3c-4303-ac2d-b1b023790916\",\"closureMessage\":[{\"_key\":\"66e465bc5fea\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"GOMA Bistro is temporarily closed as Tony Albert and Nell’s \"},{\"_key\":\"3d1aac20f4c9\",\"_type\":\"span\",\"marks\":[\"em\"],\"text\":\"The BIG HOSE\"},{\"_key\":\"3d1aac20f4c10\",\"_type\":\"span\",\"marks\":[],\"text\":\" artwork is installed on the Bistro lawn.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"66e465bc5fea1\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"Please instead visit GOMA Cafe on Level 1 during this time.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"description\":[{\"_key\":\"66e465bc5fea\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"Boasting a genuine riverfront location and a commitment to fresh and local produce, the GOMA Bistro is a relaxed alfresco setting for all to enjoy.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"24bb2b1d9a1a\",\"_type\":\"block\",\"children\":[{\"_key\":\"e9a2af7e1d13\",\"_type\":\"span\",\"marks\":[],\"text\":\"Walk-ins welcome. No bookings required.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"ba2eb699ac38\",\"_type\":\"block\",\"children\":[{\"_key\":\"aeb3d76f64e10\",\"_type\":\"span\",\"marks\":[],\"text\":\"Closed Good Friday, Christmas Day & Boxing Day.\\nNew Year's Day: 10.00am - 3.00pm.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"emailAddress\":\"gomabistro@qagoma.qld.gov.au\",\"hours\":null,\"phone\":\"+61 (0)7 3842 9906\",\"type\":\"foodAndBeverage\",\"url\":\"https://www.qagoma.qld.gov.au/visit/eat-and-drink/\"},\"traversal\":\"stairs\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"Polygon\",\"coordinates\":[[[153.017341408,-27.470115047],[153.017341408,-27.470115047],[153.017390903,-27.470165564],[153.017410618,-27.470150358],[153.017361123,-27.470099842],[153.017341408,-27.470115047]]]},{\"type\":\"LineString\",\"coordinates\":[[153.017386778,-27.470161354],[153.017406493,-27.470146148]]},{\"type\":\"LineString\",\"coordinates\":[[153.017382653,-27.470157144],[153.017402368,-27.470141938]]},{\"type\":\"LineString\",\"coordinates\":[[153.017378529,-27.470152934],[153.017398244,-27.470137729]]},{\"type\":\"LineString\",\"coordinates\":[[153.017374404,-27.470148724],[153.017394119,-27.470133519]]},{\"type\":\"LineString\",\"coordinates\":[[153.01737028,-27.470144515],[153.017389995,-27.470129309]]},{\"type\":\"LineString\",\"coordinates\":[[153.017366155,-27.470140305],[153.01738587,-27.4701251]]},{\"type\":\"LineString\",\"coordinates\":[[153.017362031,-27.470136095],[153.017381746,-27.47012089]]},{\"type\":\"LineString\",\"coordinates\":[[153.017357906,-27.470131886],[153.017377621,-27.47011668]]},{\"type\":\"LineString\",\"coordinates\":[[153.017353782,-27.470127676],[153.017373497,-27.47011247]]},{\"type\":\"LineString\",\"coordinates\":[[153.017349657,-27.470123466],[153.017369372,-27.470108261]]},{\"type\":\"LineString\",\"coordinates\":[[153.017345533,-27.470119257],[153.017365248,-27.470104051]]}]},\"properties\":{\"building\":\"goma\",\"id\":\"a1f981ec-fa3c-4303-ac2d-b1b023790916_7\",\"isClosed\":true,\"level\":\"park_level\",\"name\":\"GOMA Bistro\",\"type\":\"traversal\",\"venue\":{\"_id\":\"a1f981ec-fa3c-4303-ac2d-b1b023790916\",\"closureMessage\":[{\"_key\":\"66e465bc5fea\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"GOMA Bistro is temporarily closed as Tony Albert and Nell’s \"},{\"_key\":\"3d1aac20f4c9\",\"_type\":\"span\",\"marks\":[\"em\"],\"text\":\"The BIG HOSE\"},{\"_key\":\"3d1aac20f4c10\",\"_type\":\"span\",\"marks\":[],\"text\":\" artwork is installed on the Bistro lawn.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"66e465bc5fea1\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"Please instead visit GOMA Cafe on Level 1 during this time.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"description\":[{\"_key\":\"66e465bc5fea\",\"_type\":\"block\",\"children\":[{\"_key\":\"3d1aac20f4c8\",\"_type\":\"span\",\"marks\":[],\"text\":\"Boasting a genuine riverfront location and a commitment to fresh and local produce, the GOMA Bistro is a relaxed alfresco setting for all to enjoy.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"24bb2b1d9a1a\",\"_type\":\"block\",\"children\":[{\"_key\":\"e9a2af7e1d13\",\"_type\":\"span\",\"marks\":[],\"text\":\"Walk-ins welcome. No bookings required.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"ba2eb699ac38\",\"_type\":\"block\",\"children\":[{\"_key\":\"aeb3d76f64e10\",\"_type\":\"span\",\"marks\":[],\"text\":\"Closed Good Friday, Christmas Day & Boxing Day.\\nNew Year's Day: 10.00am - 3.00pm.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"emailAddress\":\"gomabistro@qagoma.qld.gov.au\",\"hours\":null,\"phone\":\"+61 (0)7 3842 9906\",\"type\":\"foodAndBeverage\",\"url\":\"https://www.qagoma.qld.gov.au/visit/eat-and-drink/\"},\"extent\":[153.017341408,-27.470165564,153.017410618,-27.470099842]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01700684738734,-27.470647940174175]},\"properties\":{\"building\":\"goma\",\"id\":\"dadd315a-86a5-4b09-8b84-6bf9a067b0dc\",\"level\":\"level_1\",\"name\":\"Foyer\",\"type\":\"gallery_space\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017500848,-27.47033806],[153.017500848,-27.47033806],[153.017449785,-27.470377443],[153.017478981,-27.470407046],[153.017213551,-27.470611764],[153.017184474,-27.470582067],[153.017114681,-27.470635896],[153.01730373,-27.470828847],[153.017689895,-27.470531011]]]},\"properties\":{\"building\":\"goma\",\"id\":\"fb1d0388-4e0f-4157-9eda-3bb0cfbb73c2\",\"level\":\"level_1\",\"name\":\"Gallery 1.1\",\"type\":\"gallery_space\",\"extent\":[153.017114681,-27.470828847,153.017689895,-27.47033806],\"markerLabel\":\"1.1\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017114681,-27.470635896],[153.017046861,-27.470566675],[153.017466682,-27.470242881],[153.017534503,-27.470312102]]]},\"properties\":{\"building\":\"goma\",\"id\":\"63904a5d-b3bc-442e-9cc7-580655fce414\",\"level\":\"level_1\",\"name\":\"Gallery 1.2\",\"type\":\"gallery_space\",\"extent\":[153.017046861,-27.470635896,153.017534503,-27.470242881],\"markerLabel\":\"1.2\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017433027,-27.470268838],[153.017070872,-27.470548156],[153.017046861,-27.470566675],[153.016950427,-27.470468249],[153.017079648,-27.470368586],[153.017050857,-27.470339181],[153.017100242,-27.470301091],[153.017129172,-27.470330477],[153.017285531,-27.470209796],[153.017256729,-27.470180399],[153.017307791,-27.470141016]]]},\"properties\":{\"building\":\"goma\",\"id\":\"8a0a7a89-4d21-4960-8294-8480cc48102b\",\"level\":\"level_1\",\"name\":\"Gallery 1.3\",\"type\":\"gallery_space\",\"extent\":[153.016950427,-27.470566675,153.017433027,-27.470141016],\"markerLabel\":\"1.3\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.01723892,-27.470162222],[153.01723892,-27.470162222],[153.017181004,-27.470103112],[153.017011867,-27.470233562],[153.017069781,-27.470292672],[153.017106606,-27.470264272],[153.017096739,-27.470254192],[153.017201392,-27.47017353],[153.017211199,-27.470183549]]]},\"properties\":{\"building\":\"goma\",\"id\":\"82fea7ab-0e82-48e9-91d3-01c59636bf8c\",\"level\":\"level_1\",\"name\":\"Gallery 1.4\",\"type\":\"gallery_space\",\"extent\":[153.017011867,-27.470292672,153.01723892,-27.470103112],\"markerLabel\":\"1.4\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.016929031,-27.470779082],[153.016909726,-27.470793972],[153.016942026,-27.470826938],[153.016846439,-27.470900661],[153.016962279,-27.471018841],[153.017077141,-27.470930251]]]},\"properties\":{\"building\":\"goma\",\"id\":\"a1da2c43-338c-44b2-914a-cf5269e9bd27\",\"isClosed\":false,\"level\":\"level_1\",\"name\":\"Cinema A\",\"type\":\"internal_venue\",\"venue\":{\"_id\":\"a1da2c43-338c-44b2-914a-cf5269e9bd27\",\"description\":[{\"_key\":\"6a72b705395c\",\"_type\":\"block\",\"children\":[{\"_key\":\"366d313886210\",\"_type\":\"span\",\"marks\":[],\"text\":\"The Australian Cinémathèque at GOMA provides an ongoing program of film and video that you're unlikely to see elsewhere. Screenings take place Wednesday and Friday nights and Saturday and Sundays matinees.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"1f42de1ff28f\",\"_type\":\"block\",\"children\":[{\"_key\":\"4e7811b5548a\",\"_type\":\"span\",\"marks\":[],\"text\":\"We offer a rich and diverse experience of the moving image, showcasing the work of influential filmmakers and international cinema, rare 35mm prints, recent restorations and silent films with live musical \"},{\"_key\":\"4f5aa0ebdbbf\",\"_type\":\"span\",\"marks\":[],\"text\":\"accompaniment\"},{\"_key\":\"7d26e0356d40\",\"_type\":\"span\",\"marks\":[],\"text\":\".\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"5c4651890282\",\"_type\":\"block\",\"children\":[{\"_key\":\"7836edddbaf6\",\"_type\":\"span\",\"marks\":[],\"text\":\"Most screenings are free; however for ticketed film programs the Cinémathèque Box Office opens one hour prior to screenings and you are able to purchase snacks and refreshments during this time. You are more than welcome to take your drinks into the cinema. As we do not screen trailers prior to films we suggest you arrive early to allow plenty of time to enter and find a seat.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"334f61f43e1b\",\"_type\":\"block\",\"children\":[{\"_key\":\"dccf9a89f0a3\",\"_type\":\"span\",\"marks\":[],\"text\":\"QAGOMA is the only Australian art gallery with purpose-built facilities dedicated to film and the moving image. The Australian Cinémathèque is an Associate Member of the International Federation of Film Archives (FIAF), an organisation of the world's leading film archives dedicated to the preservation and exhibition of film.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"hours\":null,\"type\":\"cinema\",\"url\":\"https://www.qagoma.qld.gov.au/cinema/\"},\"extent\":[153.016846439,-27.471018841,153.017077141,-27.470779082]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.016869427,-27.470718248],[153.016732375,-27.470578365],[153.016639119,-27.47065029],[153.016776259,-27.470790106],[153.016850122,-27.470733137]]]},\"properties\":{\"building\":\"goma\",\"id\":\"778d98d3-fa64-4afd-bf2b-7950196ed8f6\",\"isClosed\":false,\"level\":\"level_1\",\"name\":\"Cinema B\",\"type\":\"internal_venue\",\"venue\":{\"_id\":\"778d98d3-fa64-4afd-bf2b-7950196ed8f6\",\"description\":[{\"_key\":\"6a72b705395c\",\"_type\":\"block\",\"children\":[{\"_key\":\"366d313886210\",\"_type\":\"span\",\"marks\":[],\"text\":\"The Australian Cinémathèque at GOMA provides an ongoing program of film and video that you're unlikely to see elsewhere. Screenings take place Wednesday and Friday nights and Saturday and Sundays matinees.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"1f42de1ff28f\",\"_type\":\"block\",\"children\":[{\"_key\":\"4e7811b5548a\",\"_type\":\"span\",\"marks\":[],\"text\":\"We offer a rich and diverse experience of the moving image, showcasing the work of influential filmmakers and international cinema, rare 35mm prints, recent restorations and silent films with live musical \"},{\"_key\":\"4f5aa0ebdbbf\",\"_type\":\"span\",\"marks\":[],\"text\":\"accompaniment\"},{\"_key\":\"7d26e0356d40\",\"_type\":\"span\",\"marks\":[],\"text\":\".\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"5c4651890282\",\"_type\":\"block\",\"children\":[{\"_key\":\"7836edddbaf6\",\"_type\":\"span\",\"marks\":[],\"text\":\"Most screenings are free; however for ticketed film programs the Cinémathèque Box Office opens one hour prior to screenings and you are able to purchase snacks and refreshments during this time. You are more than welcome to take your drinks into the cinema. As we do not screen trailers prior to films we suggest you arrive early to allow plenty of time to enter and find a seat.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"334f61f43e1b\",\"_type\":\"block\",\"children\":[{\"_key\":\"dccf9a89f0a3\",\"_type\":\"span\",\"marks\":[],\"text\":\"QAGOMA is the only Australian art gallery with purpose-built facilities dedicated to film and the moving image. The Australian Cinémathèque is an Associate Member of the International Federation of Film Archives (FIAF), an organisation of the world's leading film archives dedicated to the preservation and exhibition of film.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"hours\":null,\"type\":\"cinema\",\"url\":\"https://www.qagoma.qld.gov.au/cinema/\"},\"extent\":[153.016639119,-27.470790106,153.016869427,-27.470578365]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017124698,-27.470893572],[153.016962279,-27.471018841],[153.017040493,-27.471098721],[153.017196283,-27.470978565],[153.017144243,-27.47092545],[153.017150909,-27.470920324]]]},\"properties\":{\"building\":\"goma\",\"id\":\"12ff6364-8bcf-4431-8c69-80677de83588\",\"isClosed\":false,\"level\":\"level_1\",\"name\":\"GOMA Store\",\"type\":\"internal_venue\",\"venue\":{\"_id\":\"12ff6364-8bcf-4431-8c69-80677de83588\",\"description\":[{\"_key\":\"f655aa4e782d\",\"_type\":\"block\",\"children\":[{\"_key\":\"6ad1c75dd4a8\",\"_type\":\"span\",\"marks\":[],\"text\":\"This striking store, located at the entrance to GOMA, specialises in a broad range of books on today’s most exciting, challenging and influential contemporary artists and designers. A sophisticated selection of design objects, contemporary jewellery and art merchandise and gifts is also available. The Store features a large selection of kids' books and products – inspiring creative living for all ages. Featured brands include Dinosaur Designs, Fink, Third Drawer Down, Yippy Whippy and Bianca Mavrick.\"}],\"markDefs\":[],\"style\":\"normal\"}],\"emailAddress\":\"qagomastore@qagoma.qld.gov.au\",\"hours\":[{\"close\":\"17:00\",\"days\":[0,1,2,3,4,5,6],\"open\":\"10:00\"}],\"phone\":\"+61 (0)7 3842 9900\",\"type\":\"retail\",\"url\":\"https://qagoma.store\"},\"extent\":[153.016962279,-27.471098721,153.017196283,-27.470893572]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.016735416,-27.470484366],[153.016765683,-27.470461023],[153.016730042,-27.470424646],[153.016746688,-27.470411807],[153.016795792,-27.470461927],[153.016779147,-27.470474764],[153.016798264,-27.470494276],[153.016875274,-27.470434881],[153.0167695,-27.470326897],[153.016601956,-27.470456117],[153.016675312,-27.470530721],[153.016705406,-27.470507512]]]},\"properties\":{\"building\":\"goma\",\"id\":\"4abce85b-ac54-40fc-a2ef-8e1779e4c844\",\"isClosed\":false,\"level\":\"level_1\",\"name\":\"GOMA Cafe\",\"type\":\"internal_venue\",\"venue\":{\"_id\":\"4abce85b-ac54-40fc-a2ef-8e1779e4c844\",\"description\":[{\"_key\":\"64dc79138367\",\"_type\":\"block\",\"children\":[{\"_key\":\"99b94b6ae241\",\"_type\":\"span\",\"marks\":[],\"text\":\"The welcoming GOMA Cafe offers casual indoor and terrace dining, conveniently located on GOMA Level 1.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"d4c37b98acc2\",\"_type\":\"block\",\"children\":[{\"_key\":\"aa7918f95930\",\"_type\":\"span\",\"marks\":[],\"text\":\"Enjoy a delicious lunch, barista coffee or indulgent treat. GOMA Cafe is the perfect place to relax, reflect and connect.\"}],\"markDefs\":[],\"style\":\"normal\"},{\"_key\":\"0dcca690db52\",\"_type\":\"block\",\"children\":[{\"_key\":\"a06ddb07cb5a\",\"_type\":\"span\",\"marks\":[],\"text\":\"GOMA Bistro is temporarily closed as Tony Albert and Nell’s \"},{\"_key\":\"33edb97980b8\",\"_type\":\"span\",\"marks\":[\"em\"],\"text\":\"The BIG HOSE\"},{\"_key\":\"0082f7fda04b\",\"_type\":\"span\",\"marks\":[],\"text\":\" artwork is installed on the Bistro lawn.\"}],\"markDefs\":[],\"style\":\"small\"}],\"emailAddress\":\"goma.dining@qagoma.qld.gov.au\",\"hours\":[{\"close\":\"16:00\",\"days\":[0,1,2,3,4,5,6],\"open\":\"10:00\"}],\"phone\":\"+61 (0)7 3842 9916\",\"type\":\"foodAndBeverage\",\"url\":\"https://www.qagoma.qld.gov.au/visit/eat-and-drink/\"},\"extent\":[153.016601956,-27.470530721,153.016875274,-27.470326897]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.0176316742,-27.4702818664],[153.0173938964,-27.4700391785],[153.0173211692,-27.4700952716],[153.0173387662,-27.4701131099],[153.0173584811,-27.470097903],[153.0174079773,-27.4701484182],[153.0173882624,-27.4701636239],[153.017558947,-27.4703379594],[153.0176316742,-27.4702818664]]]},\"properties\":{\"building\":\"goma\",\"id\":\"f6adfd48-2455-4eae-a201-69c086e4452b\",\"level\":\"level_1\",\"name\":\"River Room\",\"type\":\"gallery_space\",\"extent\":[153.0173211692,-27.4703379594,153.0176316742,-27.4700391785]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017196272,-27.470978553],[153.01711826,-27.470898931],[153.01696247,-27.471019087],[153.017040481,-27.47109871]]]},\"properties\":{\"building\":\"goma\",\"id\":\"46358ff9-f4b5-42a4-9593-27478c26c221\",\"level\":\"level_2\",\"name\":\"Gallery 2.1\",\"type\":\"gallery_space\",\"extent\":[153.01696247,-27.47109871,153.017196272,-27.470898931],\"markerLabel\":\"2.1\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017001086,-27.470351526],[153.016944326,-27.47029355],[153.016910709,-27.470319474],[153.016906304,-27.470314977],[153.01684092,-27.470365408],[153.016916721,-27.470442634],[153.016962675,-27.470407192],[153.016948142,-27.470392359]]]},\"properties\":{\"building\":\"goma\",\"id\":\"1343f6b7-e5fa-43d0-a0ac-e20884ea2e78\",\"isClosed\":false,\"level\":\"level_2\",\"name\":\"Seminar Room\",\"type\":\"internal_venue\",\"venue\":{\"_id\":\"1343f6b7-e5fa-43d0-a0ac-e20884ea2e78\",\"description\":null,\"hours\":null,\"type\":null,\"url\":null},\"extent\":[153.01684092,-27.470442634,153.017001086,-27.47029355]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.016631469,-27.47048624],[153.016675164,-27.470530837],[153.016765683,-27.470461023],[153.016721989,-27.470416426]]]},\"properties\":{\"building\":\"goma\",\"id\":\"4badd8d3-b72b-45a3-8da8-d699441a48b4\",\"isClosed\":false,\"level\":\"level_2\",\"name\":\"Lounge\",\"type\":\"internal_venue\",\"venue\":{\"_id\":\"4badd8d3-b72b-45a3-8da8-d699441a48b4\",\"description\":null,\"hours\":null,\"type\":null,\"url\":null},\"extent\":[153.016631469,-27.470530837,153.016765683,-27.470416426]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017196272,-27.470978553],[153.017144243,-27.47092545],[153.017151071,-27.470919819],[153.017110392,-27.470878299],[153.016947428,-27.471003736],[153.017040481,-27.47109871]]]},\"properties\":{\"building\":\"goma\",\"id\":\"9edf128a-dd03-4c32-8af0-a7774739c85c\",\"level\":\"level_3\",\"name\":\"Gallery 3.1\",\"type\":\"gallery_space\",\"extent\":[153.016947428,-27.47109871,153.017196272,-27.470878299],\"markerLabel\":\"3.1\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017062712,-27.470914822],[153.017029262,-27.47088068],[153.017076942,-27.470844159],[153.017054112,-27.470820858],[153.017006573,-27.470857523],[153.016963624,-27.470813687],[153.016848341,-27.470902601],[153.016947428,-27.471003736]]]},\"properties\":{\"building\":\"goma\",\"id\":\"e9dd99a3-5e6c-4709-8034-10642868976f\",\"level\":\"level_3\",\"name\":\"Gallery 3.2\",\"type\":\"gallery_space\",\"extent\":[153.016848341,-27.471003736,153.017076942,-27.470813687],\"markerLabel\":\"3.2\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017329007,-27.470504264],[153.017184067,-27.47061605],[153.017165278,-27.470596873],[153.017114681,-27.470635896],[153.01730373,-27.470828847],[153.017499264,-27.470678037],[153.017329007,-27.470504264],[153.017329007,-27.470504264]]]},\"properties\":{\"building\":\"goma\",\"id\":\"3b0e9fe9-fc07-4d34-95dd-eb03dd0fa06b\",\"level\":\"level_3\",\"name\":\"Gallery 3.3\",\"type\":\"gallery_space\",\"extent\":[153.017114681,-27.470828847,153.017499264,-27.470504264],\"markerLabel\":\"3.3\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017455149,-27.470373306],[153.017473945,-27.470392478],[153.017329007,-27.470504264],[153.017499264,-27.470678037],[153.017689895,-27.470531011],[153.017500848,-27.47033806],[153.017455149,-27.470373306],[153.017455149,-27.470373306]]]},\"properties\":{\"building\":\"goma\",\"id\":\"d2c7859e-0152-4d41-b04b-9b9f829ebf83\",\"level\":\"level_3\",\"name\":\"Gallery 3.4\",\"type\":\"gallery_space\",\"extent\":[153.017329007,-27.470678037,153.017689895,-27.47033806],\"markerLabel\":\"3.4\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017432926,-27.470268735],[153.017432926,-27.470268735],[153.017337523,-27.470171292],[153.016951852,-27.470468716],[153.017047427,-27.470566264],[153.017432926,-27.470268735]]]},\"properties\":{\"building\":\"goma\",\"id\":\"58605e4d-c611-4961-ae64-c006563c4005\",\"level\":\"level_3\",\"name\":\"Gallery 3.5\",\"type\":\"gallery_space\",\"extent\":[153.016951852,-27.470566264,153.017432926,-27.470171292],\"markerLabel\":\"3.5\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.017160428,-27.470204635],[153.017229549,-27.470151324],[153.017287149,-27.470210114],[153.017337523,-27.470171292],[153.017232101,-27.470063703],[153.017112629,-27.470155849],[153.017160428,-27.470204635],[153.017160428,-27.470204635]]]},\"properties\":{\"building\":\"goma\",\"id\":\"37c2faa3-5ff2-4716-90d7-fc1ef18f1d16\",\"level\":\"level_3\",\"name\":\"Gallery 3.6\",\"type\":\"gallery_space\",\"extent\":[153.017112629,-27.470210114,153.017337523,-27.470063703],\"markerLabel\":\"3.6\"}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.0167735838,-27.4707881524],[153.016867145,-27.470715992],[153.0168437604,-27.4706921245],[153.0168941208,-27.4706532833],[153.0167759055,-27.4705326267],[153.0168096092,-27.4705066322],[153.0167630084,-27.470459069],[153.0165853831,-27.4705960652],[153.0167735838,-27.4707881524],[153.0167735838,-27.4707881524]]]},\"properties\":{\"building\":\"goma\",\"id\":\"831c465a-698c-4397-855c-aa75e84beb69\",\"isClosed\":false,\"level\":\"level_3\",\"name\":\"Research Library\",\"type\":\"internal_venue\",\"venue\":{\"_id\":\"831c465a-698c-4397-855c-aa75e84beb69\",\"description\":null,\"hours\":[{\"close\":\"16:45\",\"days\":[2,3,4,5],\"open\":\"10:00\"}],\"type\":null,\"url\":null},\"extent\":[153.0165853831,-27.4707881524,153.0168941208,-27.470459069]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.0173209611,-27.4700949269],[153.0173209611,-27.4700949269],[153.0175318288,-27.4703101493],[153.0176044831,-27.4702541137],[153.0173936176,-27.4700388936],[153.0173209611,-27.4700949269]]]},\"properties\":{\"building\":\"goma\",\"id\":\"2a4e5005-76c1-4f9b-bada-64945381d571\",\"level\":\"level_3\",\"name\":\"River Lounge\",\"type\":\"gallery_space\",\"extent\":[153.0173209611,-27.4703101493,153.0176044831,-27.4700388936]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.016924189,-27.470634109],[153.016846435,-27.470694078],[153.016869819,-27.470717945],[153.016803508,-27.470769089],[153.016863112,-27.470829922],[153.016976962,-27.470742114],[153.017151071,-27.470919819],[153.017181489,-27.470896723]]]},\"properties\":{\"building\":\"goma\",\"id\":\"e929ecb5-ff09-4b4f-95e3-55bd064b8aec\",\"level\":\"level_3\",\"name\":\"Media Lounge\",\"type\":\"gallery_space\",\"extent\":[153.016803508,-27.470919819,153.017181489,-27.470634109]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.0175318288,-27.4703101493],[153.0175318288,-27.4703101493],[153.0174639538,-27.4702408725],[153.0170442011,-27.4705647366],[153.0170864605,-27.4706078687],[153.0174116701,-27.4703567626],[153.017437375,-27.4703829983],[153.0175318288,-27.4703101493]]]},\"properties\":{\"building\":\"goma\",\"id\":\"5c0d507b-c42f-40d9-ae40-f3c34b8747de\",\"level\":\"level_3\",\"name\":\"Pavilion Walk\",\"type\":\"gallery_space\",\"extent\":[153.0170442011,-27.4706078687,153.0175318288,-27.4702408725]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.0175178695406,-27.470694214935747]},\"properties\":{\"building\":\"goma\",\"id\":\"49614bc8-0ac7-4e5c-8e73-0006859dc84e\",\"isClosed\":false,\"level\":\"level_3\",\"name\":\"Pavilion Balcony\",\"type\":\"internal_venue\",\"venue\":{\"_id\":\"49614bc8-0ac7-4e5c-8e73-0006859dc84e\",\"description\":null,\"hours\":null,\"type\":null,\"url\":null}}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"cloakroom\",\"building\":\"qag\",\"id\":\"52176e6d348ee3aec535fb87fe51db1e\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01786243915555,-27.472147970583855]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"information_desk\",\"building\":\"qag\",\"id\":\"c4a7cd9ed80f145ef75b760ffdd9e510\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01794290542603,-27.47210632494711]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"toilet\",\"building\":\"qag\",\"id\":\"37f98d4641b380daca006ea2765a4677\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01797844469547,-27.47216433136542]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"parents_room\",\"building\":\"qag\",\"id\":\"dcd08d5c34ae93ece6491dd59ff8d279\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01800057291985,-27.47219437570341]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"first_aid\",\"building\":\"qag\",\"id\":\"9fe66406daa9018cba384a17f5345f49\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01909290254116,-27.47286784267455]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"toilet\",\"building\":\"qag\",\"id\":\"fdff70362a9479afe5a948dad06e9d21\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01896750926971,-27.47283333651635]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"parents_room\",\"building\":\"qag\",\"id\":\"4db0d9008f62a82b02dcaee96507a147\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01899265497923,-27.472869032541873]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"qag\",\"id\":\"aff5101e7cbe50cfa76a05798b03a38c\",\"level\":\"level_1\",\"traversal\":\"elevator\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.0189212411642,-27.472665565041492]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"qag\",\"id\":\"c576a93ac62b50e14d0aeb2be9ba6654\",\"level\":\"level_1\",\"traversal\":\"elevator\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01863256841898,-27.47225595169727]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"toilet\",\"building\":\"qag\",\"id\":\"556ff7ea520a153b57bfdd4cfbebded6\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01856450736523,-27.47212119839062]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"qag\",\"id\":\"d7a6c6e91788e5c66b841d17440e3cb1\",\"level\":\"level_1\",\"traversal\":\"stairs\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01865204276106,-27.473061854177516]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"qag\",\"id\":\"a9ccf129f5f5679350156ff8a77947c1\",\"level\":\"level_1\",\"traversal\":\"stairs\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01856806974416,-27.472879230299483]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"qag\",\"id\":\"d88e32ea8e9c5566cf79743a31de6c17\",\"level\":\"level_1\",\"traversal\":\"stairs\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01851329600538,-27.472793719205683]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"qag\",\"id\":\"4e5cc9c9a0eea795594a51854705ec8d\",\"level\":\"level_1\",\"traversal\":\"stairs\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.018320381205,-27.472513545828207]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"qag\",\"id\":\"92690b82d3fac41562767bc5c3b70906\",\"level\":\"level_1\",\"traversal\":\"escalator\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01879910549377,-27.472693649148958]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"information_desk\",\"building\":\"qag\",\"id\":\"51d15aa9eb25feb1dfe79d498c519aa1\",\"level\":\"level_2\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01899548142154,-27.472671984378096]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"cloakroom\",\"building\":\"qag\",\"id\":\"5782a2064d5676b69c3f92e88f64df48\",\"level\":\"level_2\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.0189272761345,-27.472572755179698]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"qag\",\"id\":\"aff5101e7cbe50cfa76a05798b03a38c\",\"level\":\"level_2\",\"traversal\":\"elevator\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.0189212411642,-27.472665565041492]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"qag\",\"id\":\"c4484aad0367d76ee1fe171fe1306669\",\"level\":\"level_2\",\"traversal\":\"escalator\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01879910549377,-27.472693649148958]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"qag\",\"id\":\"090205d6650adecd81c7590ae97489ba\",\"level\":\"level_2\",\"traversal\":\"stairs\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01856903220596,-27.472880794531207]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"0aec954d6a1fc5632ddeff1945bbfb86\",\"level\":\"park_level\",\"traversal\":\"elevator\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.0169628933072,-27.470328041573687]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"toilet\",\"building\":\"goma\",\"id\":\"c18f5fb45d6b043f14737b4c4d39d886\",\"level\":\"park_level\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.016991391778,-27.47039110597802]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"f7c7d96f5626e512c39fec1e5ada7912\",\"level\":\"park_level\",\"traversal\":\"stairs\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01697454199018,-27.470284418517508]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"cinema_box_office\",\"building\":\"goma\",\"id\":\"3a432d992003721e0bf296ce6905fe8a\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.0169587432942,-27.470767309396702]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"cloakroom\",\"building\":\"goma\",\"id\":\"f19ea88d63c4662f1ff0681c3f947154\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01718518137932,-27.470704642622277]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"fb38ddd669799960071d6a83f8696f8c\",\"level\":\"level_1\",\"traversal\":\"elevator\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.0169628933072,-27.470328041573687]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"6a92970d5d3a934e509fa68c92c10fc7\",\"level\":\"level_1\",\"traversal\":\"elevator\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01744602620602,-27.47025069838703]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"76ae9502e028c76f278945c1d1139848\",\"level\":\"level_1\",\"traversal\":\"elevator\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.0168767273426,-27.47066061665776]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"first_aid\",\"building\":\"goma\",\"id\":\"c3426ec7cdc2291bc03191a789ed1b15\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01685191690922,-27.470640983451688]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"information_desk\",\"building\":\"goma\",\"id\":\"62c3e7170228448b2c2b760c819fcd2a\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01710736648786,-27.47078140476937]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"parents_room\",\"building\":\"goma\",\"id\":\"a7715a2a638ab0385a56720a04632e58\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01685091108084,-27.4708444546903]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"toilet\",\"building\":\"goma\",\"id\":\"1ca16b8244a9bee8a7b11a8f65d8d482\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01757007837296,-27.47039527060722]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"toilet\",\"building\":\"goma\",\"id\":\"b7218c076a7e9d656b6f5a5f5f9cbde4\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01667355000973,-27.4706231350795]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"toilet\",\"building\":\"goma\",\"id\":\"db1bdde25d87e841c7cbb0a702077e99\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.016991391778,-27.47039110597802]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"toilet_mens\",\"building\":\"goma\",\"id\":\"0eec5e004ff18d692ca36b24d10952c3\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01678854972124,-27.470777225930792]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"toilet_womens\",\"building\":\"goma\",\"id\":\"ec4917de0e0d0c281af0aecbaed6d3d1\",\"level\":\"level_1\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01683247089386,-27.47085754347058]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"df56301ad0a69fd0717d70b233af1b83\",\"level\":\"level_1\",\"traversal\":\"escalator\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.0169117704383,-27.470586246741043]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"9e89d07a58975247b143745511ad90ff\",\"level\":\"level_1\",\"traversal\":\"stairs\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01705359796654,-27.470291569324914]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"81d57fc054521f8ce5fb16c373bc7649\",\"level\":\"level_1\",\"traversal\":\"stairs\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01707013657057,-27.470745828038446]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"6a35e869166b23b97631c5e32d0ea2d5\",\"level\":\"level_1\",\"traversal\":\"stairs\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01737443529822,-27.470131702340474]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"208cd1ee0036bba4b6f4e41f9d5c75d5\",\"level\":\"level_1\",\"traversal\":\"stairs\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.016739886114,-27.47041885854223]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"76ae9502e028c76f278945c1d1139848\",\"level\":\"level_2\",\"traversal\":\"elevator\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.0168767273426,-27.47066061665776]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"toilet\",\"building\":\"goma\",\"id\":\"2d6a96605e14df75e51311ef2f420d55\",\"level\":\"level_2\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01667355000973,-27.4706231350795]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"4125379b24c922adce204d514a849d5a\",\"level\":\"level_2\",\"traversal\":\"stairs\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01709214003995,-27.470767261963005]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"499061a54d77e03c8fb21e27ffc201ae\",\"level\":\"level_2\",\"traversal\":\"stairs\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01737443529822,-27.470131702340474]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"575e57ab42d3bb733ff69ff3f1be8ff3\",\"level\":\"level_2\",\"traversal\":\"stairs\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.016739886114,-27.47041885854223]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"37798d8b95815f7c33bc8357961d91f9\",\"level\":\"level_2\",\"traversal\":\"escalator\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.0169117704383,-27.470586246741043]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"6a92970d5d3a934e509fa68c92c10fc7\",\"level\":\"level_3\",\"traversal\":\"elevator\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01744602620602,-27.47025069838703]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"76ae9502e028c76f278945c1d1139848\",\"level\":\"level_3\",\"traversal\":\"elevator\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.0168767273426,-27.47066061665776]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"toilet\",\"building\":\"goma\",\"id\":\"2212d6896c91fb0d1c049cfad471c449\",\"level\":\"level_3\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01683247089386,-27.47085754347058]}},{\"properties\":{\"_type\":\"geopoint\",\"amenity\":\"toilet\",\"building\":\"goma\",\"id\":\"bad57ae84ed3e343a973432f80c73de1\",\"level\":\"level_3\",\"type\":\"amenity\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01757007837296,-27.47039527060722]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"73ed2d3355bbcade9109ad7776374dbf\",\"level\":\"level_3\",\"traversal\":\"stairs\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01709214003995,-27.470767261963005]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"56c32e108af2f36063776a2dd8894932\",\"level\":\"level_3\",\"traversal\":\"stairs\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01737443529822,-27.470131702340474]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"e7d418f3f64c529e21c09d4ec99400b5\",\"level\":\"level_3\",\"traversal\":\"escalator\",\"type\":\"traversal\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.0169450169766,-27.470561970552545]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"ec0cc2c92553359a8fa5765911e4e6af\",\"name\":\"tow row\",\"type\":\"artwork\",\"icon\":\"tow-row\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01734747680456,-27.47093766674745]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"415e6ccf657417aab76767bd3ad8d9a6\",\"name\":\"The World Turns\",\"type\":\"artwork\",\"icon\":\"the-world-turns\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01791457150142,-27.47045210473258]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"d67a351e5329deb5268516f39ba88917\",\"name\":\"We are shipwrecked and landlocked\",\"type\":\"artwork\",\"icon\":\"we-are-shipwrecked-and-landlocked\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.0167339427013,-27.470154990282246]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"e926e05f0cf4\",\"name\":\"Bodhi Tree\",\"type\":\"artwork\",\"icon\":\"bodhi-tree\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01712483167648,-27.47115917993054]}},{\"properties\":{\"_type\":\"geopoint\",\"building\":\"goma\",\"id\":\"0cca77ad59bb\",\"name\":\"The High/ Perpetual Xmas, No Abstractions\",\"type\":\"artwork\",\"icon\":\"the-high-perpetual-xmas-no-abstractions\"},\"type\":\"Feature\",\"geometry\":{\"type\":\"Point\",\"coordinates\":[153.01702424883842,-27.471265079714737]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.01791088655594,-27.47053657043339],[153.01801482215524,-27.47045655013303],[153.0179179273546,-27.470357491465133],[153.01781382411724,-27.47043751183741],[153.01791088655594,-27.47053657043339],[153.01791088655594,-27.47053657043339]]]},\"properties\":{\"building\":\"goma\",\"id\":\"8557d0e1-6987-4c3c-aebb-df564031c3e2\",\"name\":\"GOMA Bistro Lawn\",\"type\":\"gallery_space\",\"terrain\":\"grass\",\"extent\":[153.01781382411724,-27.47053657043339,153.01801482215524,-27.470357491465133]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.01736,-27.47089],[153.017486,-27.471018],[153.017557,-27.470986],[153.017574,-27.471011],[153.0176,-27.470996],[153.017605,-27.470963],[153.017643,-27.470953],[153.017648,-27.47097],[153.017698,-27.470941],[153.017724,-27.470903],[153.017725,-27.470896],[153.017776,-27.470886],[153.017778,-27.470894],[153.017817,-27.470872],[153.017823,-27.470834],[153.017852,-27.470824],[153.017861,-27.47085],[153.017903,-27.470827],[153.017899,-27.470819],[153.017917,-27.470806],[153.017895,-27.470768],[153.017874,-27.470779],[153.017868,-27.470774],[153.017891,-27.47076],[153.017839,-27.470686],[153.017823,-27.470692],[153.017793,-27.470613],[153.017787,-27.470612],[153.017767,-27.470587],[153.017758,-27.470583],[153.01736,-27.47089],[153.01736,-27.47089]]]},\"properties\":{\"building\":\"goma\",\"id\":\"ac312f6a-0a34-4870-920a-95046f75437b\",\"name\":\"Maiwar Green\",\"type\":\"gallery_space\",\"terrain\":\"grass\",\"extent\":[153.01736,-27.471018,153.017917,-27.470583]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.01705408841372,-27.47129601671115],[153.01707554608583,-27.47127935832955],[153.0170678347349,-27.471258832820197],[153.0170879513025,-27.471241876961752],[153.01711075007915,-27.471248718799664],[153.01721602678296,-27.471178813044286],[153.01713153719902,-27.471067558686798],[153.0169129371643,-27.47123533259463],[153.01705408841372,-27.47129601671115]]]},\"properties\":{\"building\":\"goma\",\"id\":\"55b8e663-c7b4-4a5b-b4d0-30b5347267e2\",\"name\":\"Bodhi Tree Terrace\",\"type\":\"gallery_space\",\"terrain\":\"grass\",\"extent\":[153.0169129371643,-27.47129601671115,153.01721602678296,-27.471067558686798]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.01719792187214,-27.470979507030133],[153.01730386912823,-27.471077672723936],[153.01745608448982,-27.47095630421701],[153.01734678447244,-27.470866467638036],[153.01719792187214,-27.470979507030133]]]},\"properties\":{\"building\":\"goma\",\"id\":\"bd9417a2-60b2-4cc6-8572-edf4884aa80c\",\"name\":\"GOMA Forecourt\",\"type\":\"gallery_space\",\"hidden\":true,\"extent\":[153.01719792187214,-27.471077672723936,153.01745608448982,-27.470866467638036]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.016503,-27.470302],[153.016615,-27.470416],[153.016726,-27.470331],[153.016709,-27.470313],[153.016878,-27.470183],[153.016888,-27.470194],[153.016924,-27.470166],[153.016931,-27.470173],[153.017102,-27.470041],[153.01699,-27.469927],[153.016503,-27.470302],[153.016503,-27.470302]]]},\"properties\":{\"building\":\"goma\",\"id\":\"731835b9-09ea-4105-a079-754d854d2708\",\"name\":\"Kurilpa Lawn\",\"type\":\"gallery_space\",\"terrain\":\"grass\",\"extent\":[153.016503,-27.470416,153.017102,-27.469927]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.016503,-27.470302],[153.016615,-27.470416],[153.016726,-27.470331],[153.016709,-27.470313],[153.016878,-27.470183],[153.016888,-27.470194],[153.016924,-27.470166],[153.016931,-27.470173],[153.017102,-27.470041],[153.01699,-27.469927],[153.016503,-27.470302],[153.016503,-27.470302]]]},\"properties\":{\"building\":\"goma\",\"id\":\"f12c1cac-7de2-4e88-88af-b825650a7269-other\",\"name\":\"Gallery of Modern Art\",\"type\":\"other\",\"terrain\":\"grass\",\"extent\":[153.016503,-27.470416,153.017102,-27.469927]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"Polygon\",\"coordinates\":[[[153.018622164,-27.472219199],[153.018607755,-27.472227033],[153.018777566,-27.472472877],[153.018868962,-27.472423188],[153.018719899,-27.472207383],[153.018731831,-27.472200896],[153.018635067,-27.472060804],[153.018546148,-27.472109146],[153.018622164,-27.472219199],[153.018622164,-27.472219199]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.018934791,-27.472518495],[153.018882091,-27.472547183],[153.018831037,-27.472574977],[153.018898467,-27.472672599],[153.018940495,-27.47264975],[153.019006255,-27.472744954],[153.018964227,-27.472767803],[153.019031483,-27.472865173],[153.019173241,-27.472788103],[153.019105986,-27.472690734],[153.019068019,-27.472711375],[153.018934791,-27.472518495]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.017793255,-27.472102223],[153.017863964,-27.472204594],[153.017885042,-27.472193135],[153.018034309,-27.472409238],[153.018176935,-27.472331698],[153.018241992,-27.472425885],[153.018296683,-27.472396152],[153.018205619,-27.472264315],[153.01809298,-27.472325493],[153.017900213,-27.472046413],[153.017793255,-27.472102223],[153.017793255,-27.472102223]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.01866511,-27.47298285],[153.01866511,-27.47298285],[153.01860381,-27.472894101],[153.018574296,-27.472910147],[153.018635598,-27.472998895],[153.01866511,-27.47298285]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.01866511,-27.47298285],[153.01866511,-27.47298285],[153.01860381,-27.472894101],[153.018574296,-27.472910147],[153.018635598,-27.472998895],[153.01866511,-27.47298285]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.018652534,-27.473023416],[153.018652534,-27.473023416],[153.018678128,-27.473060469],[153.018734425,-27.473029861],[153.018708831,-27.472992808],[153.018652534,-27.473023416]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.018652534,-27.473023416],[153.018652534,-27.473023416],[153.018678128,-27.473060469],[153.018734425,-27.473029861],[153.018708831,-27.472992808],[153.018652534,-27.473023416]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.018537985,-27.472745465],[153.018537985,-27.472745465],[153.018378102,-27.472513992],[153.018321805,-27.4725446],[153.018481688,-27.472776072],[153.018537985,-27.472745465]]]}]},\"properties\":{\"building\":\"qag\",\"id\":\"fb42a7e15ba3-inaccessibleAreas\",\"level\":\"level_1\",\"name\":\"Level 1\",\"type\":\"inaccessibleAreas\",\"extent\":[153.017793255,-27.473060469,153.019173241,-27.472046413]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[153.018843396,-27.472568183],[153.018777566,-27.472472877]],[[153.018156089,-27.472538215],[153.018273393,-27.472474513],[153.018288517,-27.472496408]],[[153.018321804,-27.4725446]],[[153.018481688,-27.472776072],[153.018541045,-27.472862007],[153.018514948,-27.472824224]],[[153.018545385,-27.472108041],[153.018622164,-27.472219198],[153.018591672,-27.472235795]],[[153.01811751,-27.472529692],[153.018234686,-27.472465973]],[[153.018866995,-27.472957788],[153.018768665,-27.473011247]],[[153.018640899,-27.472689573],[153.01870245,-27.47265611]],[[153.018596822,-27.472713537],[153.018537985,-27.472745465],[153.018378102,-27.472513993]],[[153.018361929,-27.472456497],[153.018489644,-27.472387062]],[[153.018147482,-27.472573085],[153.018264665,-27.472509376]],[[153.01868032,-27.472624071],[153.018662112,-27.472597711]],[[153.018521166,-27.473114087],[153.018627456,-27.473056301]]]},\"properties\":{\"building\":\"qag\",\"id\":\"fb42a7e15ba3-internalWalls\",\"level\":\"level_1\",\"name\":\"Level 1\",\"type\":\"internalWalls\",\"extent\":[153.01811751,-27.473114087,153.018866995,-27.472108041]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"Polygon\",\"coordinates\":[[[153.018867414,-27.472689299],[153.018833126,-27.472639658],[153.018729864,-27.472695799],[153.018764152,-27.47274544],[153.018867414,-27.472689299],[153.018867414,-27.472689299]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.018488295,-27.472140416],[153.018488295,-27.472140416],[153.018385026,-27.47219656],[153.018461042,-27.472306613],[153.018564311,-27.47225047],[153.018488295,-27.472140416]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.019032982,-27.472929001],[153.018933266,-27.472784637],[153.018830004,-27.472840776],[153.01892972,-27.472985141],[153.019032982,-27.472929001],[153.019032982,-27.472929001]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.01854261,-27.472424701],[153.018662111,-27.472597712],[153.018765375,-27.472541571],[153.018645696,-27.472368511],[153.01854261,-27.472424701],[153.01854261,-27.472424701]]]}]},\"properties\":{\"building\":\"qag\",\"id\":\"fb42a7e15ba3-other\",\"level\":\"level_1\",\"name\":\"Level 1\",\"type\":\"water\",\"extent\":[153.018385026,-27.472985141,153.019032982,-27.472140416]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.018867414,-27.472689299],[153.018833126,-27.472639658],[153.018729864,-27.472695799],[153.018764152,-27.47274544],[153.018867414,-27.472689299]],[[153.018488294,-27.472140416],[153.018564311,-27.472250469],[153.018461043,-27.472306612],[153.018385027,-27.472196559],[153.018488294,-27.472140416]],[[153.019032982,-27.472929001],[153.018929719,-27.472985142],[153.018830003,-27.472840777],[153.018933266,-27.472784636],[153.019032982,-27.472929001]],[[153.01854261,-27.472424701],[153.018645696,-27.47236851],[153.018765375,-27.472541571],[153.018662112,-27.472597711],[153.01854261,-27.472424701]]]},\"properties\":{\"building\":\"qag\",\"id\":\"fb42a7e15ba3-other_1\",\"level\":\"level_1\",\"name\":\"Level 1\",\"type\":\"other\",\"extent\":[153.018385027,-27.472985142,153.019032982,-27.472140416]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"LineString\",\"coordinates\":[[153.018104611,-27.471932949],[153.01797475118275,-27.472003549]]},\"properties\":{\"building\":\"qag\",\"id\":\"fb42a7e15ba3-other_2\",\"level\":\"level_1\",\"name\":\"Level 1\",\"type\":\"entrance\",\"extent\":[153.01797475118275,-27.472003549,153.018104611,-27.471932949]}},{\"type\":\"Feature\",\"properties\":{\"building\":\"qag\",\"id\":\"fb42a7e15ba3-other_2_entranceLabel\",\"level\":\"level_1\",\"name\":\"Level 1\",\"type\":\"entranceLabel\",\"extent\":[153.01797475118275,-27.472003549,153.018104611,-27.471932949],\"visibility\":true,\"bearing\":-121.49833327926046},\"geometry\":{\"type\":\"LineString\",\"coordinates\":[[153.01825574790968,-27.471850781025026],[153.01782361385403,-27.472085716671597]]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[153.018488294,-27.472140416],[153.018564402,-27.472250602],[153.018461043,-27.472306612],[153.018384935,-27.472196427],[153.018286557,-27.472250277],[153.018284053,-27.472248883],[153.018271875,-27.472241162],[153.018259043,-27.47223188],[153.018243161,-27.472218987],[153.018224847,-27.472202223],[153.01820472,-27.472181327],[153.018183399,-27.472156038],[153.018172483,-27.472141665],[153.018167604,-27.472134672],[153.018158507,-27.472119717],[153.018150262,-27.472103715],[153.018142835,-27.472086959],[153.018133149,-27.472061049],[153.018122766,-27.472026588],[153.01811502,-27.471994365],[153.018109629,-27.471966718],[153.018105343,-27.471938937],[153.018104611,-27.471932949]],[[153.018635066,-27.472060803],[153.018529743,-27.472118064]]]},\"properties\":{\"building\":\"qag\",\"id\":\"fb42a7e15ba3-level_outline\",\"level\":\"level_1\",\"name\":\"Level 1\",\"type\":\"level_outline\",\"extent\":[153.018104611,-27.472306612,153.018635066,-27.471932949]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"Polygon\",\"coordinates\":[[[153.018759331,-27.472670164],[153.018759331,-27.472670164],[153.01880325,-27.472733746],[153.018819069,-27.472725146],[153.018775152,-27.472661564],[153.018759331,-27.472670164]]]},{\"type\":\"LineString\",\"coordinates\":[[153.018799871,-27.472728855],[153.018815691,-27.472720254]]},{\"type\":\"LineString\",\"coordinates\":[[153.018796493,-27.472723964],[153.018812312,-27.472715364]]},{\"type\":\"LineString\",\"coordinates\":[[153.018793114,-27.472719073],[153.018808934,-27.472710473]]},{\"type\":\"LineString\",\"coordinates\":[[153.018789736,-27.472714182],[153.018805556,-27.472705582]]},{\"type\":\"LineString\",\"coordinates\":[[153.018786358,-27.472709292],[153.018802178,-27.472700691]]},{\"type\":\"LineString\",\"coordinates\":[[153.01878298,-27.472704401],[153.018798799,-27.4726958]]},{\"type\":\"LineString\",\"coordinates\":[[153.018779601,-27.47269951],[153.018795421,-27.472690909]]},{\"type\":\"LineString\",\"coordinates\":[[153.018776223,-27.472694619],[153.018792043,-27.472686018]]},{\"type\":\"LineString\",\"coordinates\":[[153.018772845,-27.472689728],[153.018788665,-27.472681127]]},{\"type\":\"LineString\",\"coordinates\":[[153.018769467,-27.472684837],[153.018785286,-27.472676236]]},{\"type\":\"LineString\",\"coordinates\":[[153.018766088,-27.472679946],[153.018781908,-27.472671345]]},{\"type\":\"LineString\",\"coordinates\":[[153.01876271,-27.472675055],[153.01877853,-27.472666455]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.018778214,-27.47265995],[153.018778214,-27.47265995],[153.018822131,-27.472723532],[153.018837951,-27.472714931],[153.018794034,-27.472651349],[153.018778214,-27.47265995]]]},{\"type\":\"LineString\",\"coordinates\":[[153.018818753,-27.472718641],[153.018834573,-27.47271004]]},{\"type\":\"LineString\",\"coordinates\":[[153.018815375,-27.47271375],[153.018831195,-27.472705149]]},{\"type\":\"LineString\",\"coordinates\":[[153.018811997,-27.472708859],[153.018827816,-27.472700258]]},{\"type\":\"LineString\",\"coordinates\":[[153.018808618,-27.472703968],[153.018824438,-27.472695367]]},{\"type\":\"LineString\",\"coordinates\":[[153.01880524,-27.472699077],[153.01882106,-27.472690476]]},{\"type\":\"LineString\",\"coordinates\":[[153.018801862,-27.472694186],[153.018817682,-27.472685586]]},{\"type\":\"LineString\",\"coordinates\":[[153.018798484,-27.472689295],[153.018814303,-27.472680695]]},{\"type\":\"LineString\",\"coordinates\":[[153.018795105,-27.472684404],[153.018810925,-27.472675804]]},{\"type\":\"LineString\",\"coordinates\":[[153.018791727,-27.472679514],[153.018807547,-27.472670913]]},{\"type\":\"LineString\",\"coordinates\":[[153.018788349,-27.472674623],[153.018804169,-27.472666022]]},{\"type\":\"LineString\",\"coordinates\":[[153.018784971,-27.472669732],[153.01880079,-27.472661131]]},{\"type\":\"LineString\",\"coordinates\":[[153.018781592,-27.472664841],[153.018797412,-27.47265624]]},{\"type\":\"LineString\",\"coordinates\":[[153.018567082,-27.472847852],[153.018597325,-27.472831409],[153.018708831,-27.472992808]]},{\"type\":\"LineString\",\"coordinates\":[[153.018600341,-27.472896004],[153.018574304,-27.472910159],[153.018541045,-27.472862006],[153.018567082,-27.472847852]]},{\"type\":\"LineString\",\"coordinates\":[[153.018595166,-27.472898817],[153.018561906,-27.472850665]]},{\"type\":\"LineString\",\"coordinates\":[[153.018589951,-27.472901652],[153.018556691,-27.4728535]]},{\"type\":\"LineString\",\"coordinates\":[[153.018584735,-27.472904488],[153.018551476,-27.472856336]]},{\"type\":\"LineString\",\"coordinates\":[[153.01857952,-27.472907323],[153.01854626,-27.472859171]]},{\"type\":\"LineString\",\"coordinates\":[[153.018481688,-27.472776072],[153.018507666,-27.472761925],[153.018540984,-27.47281007],[153.018514947,-27.472824225]]},{\"type\":\"LineString\",\"coordinates\":[[153.018535809,-27.472812883],[153.018502549,-27.47276473]]},{\"type\":\"LineString\",\"coordinates\":[[153.018530594,-27.472815718],[153.018497334,-27.472767566]]},{\"type\":\"LineString\",\"coordinates\":[[153.018525378,-27.472818553],[153.018492119,-27.472770401]]},{\"type\":\"LineString\",\"coordinates\":[[153.018520163,-27.472821389],[153.018486903,-27.472773237]]},{\"type\":\"LineString\",\"coordinates\":[[153.018288517,-27.472496408],[153.018314553,-27.472482254],[153.01834784,-27.472530445],[153.018321805,-27.4725446],[153.018288517,-27.472496408]]},{\"type\":\"LineString\",\"coordinates\":[[153.018342666,-27.472533258],[153.018309379,-27.472485066]]},{\"type\":\"LineString\",\"coordinates\":[[153.01833745,-27.472536094],[153.018304163,-27.472487902]]},{\"type\":\"LineString\",\"coordinates\":[[153.018332235,-27.472538929],[153.018298948,-27.472490737]]},{\"type\":\"LineString\",\"coordinates\":[[153.01832702,-27.472541765],[153.018293733,-27.472493573]]},{\"type\":\"LineString\",\"coordinates\":[[153.018662172,-27.47303737],[153.018678128,-27.473060469],[153.018643401,-27.473079348],[153.018627456,-27.473056301]]},{\"type\":\"LineString\",\"coordinates\":[[153.018665344,-27.473041961],[153.018630617,-27.473060841]]},{\"type\":\"LineString\",\"coordinates\":[[153.01866854,-27.473046588],[153.018633813,-27.473065468]]},{\"type\":\"LineString\",\"coordinates\":[[153.018671736,-27.473051215],[153.018637009,-27.473070095]]},{\"type\":\"LineString\",\"coordinates\":[[153.018674932,-27.473055842],[153.018640205,-27.473074722]]}]},\"properties\":{\"building\":\"qag\",\"id\":\"fb42a7e15ba3-traversal\",\"level\":\"level_1\",\"name\":\"Level 1\",\"type\":\"traversal\",\"extent\":[153.018288517,-27.473079348,153.018837951,-27.472482254]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"Polygon\",\"coordinates\":[[[153.01866511,-27.47298285],[153.01866511,-27.47298285],[153.01860381,-27.472894101],[153.018574296,-27.472910147],[153.018635598,-27.472998895],[153.01866511,-27.47298285]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.01866511,-27.47298285],[153.01866511,-27.47298285],[153.01860381,-27.472894101],[153.018574296,-27.472910147],[153.018635598,-27.472998895],[153.01866511,-27.47298285]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.018734407,-27.473029872],[153.018734407,-27.473029872],[153.018708814,-27.472992818],[153.018652424,-27.473023476],[153.018678018,-27.473060529],[153.018734407,-27.473029872]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.018734407,-27.473029872],[153.018734407,-27.473029872],[153.018708814,-27.472992818],[153.018652424,-27.473023476],[153.018678018,-27.473060529],[153.018734407,-27.473029872]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.019078767,-27.472842654],[153.019078767,-27.472842654],[153.0190102,-27.472743223],[153.018830293,-27.472841034],[153.01889886,-27.472940464],[153.019078767,-27.472842654]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.019078767,-27.472842654],[153.019078767,-27.472842654],[153.0190102,-27.472743223],[153.018830293,-27.472841034],[153.01889886,-27.472940464],[153.019078767,-27.472842654]]]}]},\"properties\":{\"building\":\"qag\",\"id\":\"48570ff0d2a2-inaccessibleAreas\",\"level\":\"level_2\",\"name\":\"Level 2\",\"type\":\"inaccessibleAreas\",\"extent\":[153.018574296,-27.473060529,153.019078767,-27.472743223]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"LineString\",\"coordinates\":[[153.018630796,-27.472879832],[153.018708831,-27.472992808],[153.018650432,-27.473024558]]},\"properties\":{\"building\":\"qag\",\"id\":\"48570ff0d2a2-internalWalls\",\"level\":\"level_2\",\"name\":\"Level 2\",\"type\":\"internalWalls\",\"extent\":[153.018630796,-27.473024558,153.018708831,-27.472879832]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"LineString\",\"coordinates\":[[153.019037653,-27.472667413],[153.01901235,-27.472630781]]},\"properties\":{\"building\":\"qag\",\"id\":\"48570ff0d2a2-other\",\"level\":\"level_2\",\"name\":\"Level 2\",\"type\":\"entrance\",\"extent\":[153.01901235,-27.472667413,153.019037653,-27.472630781]}},{\"type\":\"Feature\",\"properties\":{\"building\":\"qag\",\"id\":\"48570ff0d2a2-other_entranceLabel\",\"level\":\"level_2\",\"name\":\"Level 2\",\"type\":\"entranceLabel\",\"extent\":[153.01901235,-27.472667413,153.019037653,-27.472630781],\"visibility\":true,\"bearing\":-31.501701668927804},\"geometry\":{\"type\":\"LineString\",\"coordinates\":[[153.01915741264807,-27.47284079261462],[153.01889259080843,-27.47245740126128]]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"LineString\",\"coordinates\":[[153.019069417,-27.472811054],[153.019091742,-27.472798916]]},\"properties\":{\"building\":\"qag\",\"id\":\"48570ff0d2a2-other_1\",\"level\":\"level_2\",\"name\":\"Level 2\",\"type\":\"entrance\",\"extent\":[153.019069417,-27.472811054,153.019091742,-27.472798916]}},{\"type\":\"Feature\",\"properties\":{\"building\":\"qag\",\"id\":\"48570ff0d2a2-other_1_entranceLabel\",\"level\":\"level_2\",\"name\":\"Level 2\",\"type\":\"entranceLabel\",\"extent\":[153.019069417,-27.472811054,153.019091742,-27.472798916],\"visibility\":true,\"bearing\":58.49999444149595},\"geometry\":{\"type\":\"LineString\",\"coordinates\":[[153.0188645144662,-27.47292245825211],[153.01929664407442,-27.47268751141528]]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[153.019091742,-27.472798916],[153.019100481,-27.472794165],[153.019118901,-27.472820834],[153.019174842,-27.472790421],[153.019106194,-27.472691035],[153.019068227,-27.472711677],[153.019037653,-27.472667413]],[[153.019069417,-27.472811054],[153.019060428,-27.472815941],[153.019078849,-27.47284261],[153.018678128,-27.473060469],[153.018541045,-27.472862007],[153.018888555,-27.472673102],[153.018792276,-27.472533714],[153.018903526,-27.472473231],[153.01901235,-27.472630781]]]},\"properties\":{\"building\":\"qag\",\"id\":\"48570ff0d2a2-level_outline\",\"level\":\"level_2\",\"name\":\"Level 2\",\"type\":\"level_outline\",\"extent\":[153.018541045,-27.473060469,153.019174842,-27.472473231]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"LineString\",\"coordinates\":[[153.018600341,-27.472896004],[153.018574304,-27.472910159],[153.018541045,-27.472862006],[153.018567082,-27.472847852],[153.018600341,-27.472896004]]},{\"type\":\"LineString\",\"coordinates\":[[153.018595166,-27.472898817],[153.018561906,-27.472850665]]},{\"type\":\"LineString\",\"coordinates\":[[153.018589951,-27.472901652],[153.018556691,-27.4728535]]},{\"type\":\"LineString\",\"coordinates\":[[153.018584735,-27.472904488],[153.018551476,-27.472856336]]},{\"type\":\"LineString\",\"coordinates\":[[153.01857952,-27.472907323],[153.01854626,-27.472859171]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.018759331,-27.472670164],[153.018759331,-27.472670164],[153.01880325,-27.472733746],[153.018819069,-27.472725146],[153.018775152,-27.472661564],[153.018759331,-27.472670164]]]},{\"type\":\"LineString\",\"coordinates\":[[153.018799871,-27.472728855],[153.018815691,-27.472720254]]},{\"type\":\"LineString\",\"coordinates\":[[153.018796493,-27.472723964],[153.018812312,-27.472715364]]},{\"type\":\"LineString\",\"coordinates\":[[153.018793114,-27.472719073],[153.018808934,-27.472710473]]},{\"type\":\"LineString\",\"coordinates\":[[153.018789736,-27.472714182],[153.018805556,-27.472705582]]},{\"type\":\"LineString\",\"coordinates\":[[153.018786358,-27.472709292],[153.018802178,-27.472700691]]},{\"type\":\"LineString\",\"coordinates\":[[153.01878298,-27.472704401],[153.018798799,-27.4726958]]},{\"type\":\"LineString\",\"coordinates\":[[153.018779601,-27.47269951],[153.018795421,-27.472690909]]},{\"type\":\"LineString\",\"coordinates\":[[153.018776223,-27.472694619],[153.018792043,-27.472686018]]},{\"type\":\"LineString\",\"coordinates\":[[153.018772845,-27.472689728],[153.018788665,-27.472681127]]},{\"type\":\"LineString\",\"coordinates\":[[153.018769467,-27.472684837],[153.018785286,-27.472676236]]},{\"type\":\"LineString\",\"coordinates\":[[153.018766088,-27.472679946],[153.018781908,-27.472671345]]},{\"type\":\"LineString\",\"coordinates\":[[153.01876271,-27.472675055],[153.01877853,-27.472666455]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.018778214,-27.47265995],[153.018778214,-27.47265995],[153.018822131,-27.472723532],[153.018837951,-27.472714931],[153.018794034,-27.472651349],[153.018778214,-27.47265995]]]},{\"type\":\"LineString\",\"coordinates\":[[153.018818753,-27.472718641],[153.018834573,-27.47271004]]},{\"type\":\"LineString\",\"coordinates\":[[153.018815375,-27.47271375],[153.018831195,-27.472705149]]},{\"type\":\"LineString\",\"coordinates\":[[153.018811997,-27.472708859],[153.018827816,-27.472700258]]},{\"type\":\"LineString\",\"coordinates\":[[153.018808618,-27.472703968],[153.018824438,-27.472695367]]},{\"type\":\"LineString\",\"coordinates\":[[153.01880524,-27.472699077],[153.01882106,-27.472690476]]},{\"type\":\"LineString\",\"coordinates\":[[153.018801862,-27.472694186],[153.018817682,-27.472685586]]},{\"type\":\"LineString\",\"coordinates\":[[153.018798484,-27.472689295],[153.018814303,-27.472680695]]},{\"type\":\"LineString\",\"coordinates\":[[153.018795105,-27.472684404],[153.018810925,-27.472675804]]},{\"type\":\"LineString\",\"coordinates\":[[153.018791727,-27.472679514],[153.018807547,-27.472670913]]},{\"type\":\"LineString\",\"coordinates\":[[153.018788349,-27.472674623],[153.018804169,-27.472666022]]},{\"type\":\"LineString\",\"coordinates\":[[153.018784971,-27.472669732],[153.01880079,-27.472661131]]},{\"type\":\"LineString\",\"coordinates\":[[153.018781592,-27.472664841],[153.018797412,-27.47265624]]}]},\"properties\":{\"building\":\"qag\",\"id\":\"48570ff0d2a2-traversal\",\"level\":\"level_2\",\"name\":\"Level 2\",\"type\":\"traversal\",\"extent\":[153.018541045,-27.472910159,153.018837951,-27.472651349]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[153.016967312,-27.470400054],[153.016919637,-27.470436824]],[[153.017231758,-27.470158834],[153.017101637,-27.470259192]],[[153.016910234,-27.47031899],[153.016963719,-27.470373579],[153.016931989,-27.470398052]],[[153.016917761,-27.470409026],[153.016898346,-27.470423999]],[[153.01701139,-27.470233076],[153.017064869,-27.470287659]],[[153.017031161,-27.47035081],[153.016983534,-27.470387543]]]},\"properties\":{\"building\":\"goma\",\"id\":\"8b822dc41326-internalWalls\",\"level\":\"park_level\",\"name\":\"Park Level\",\"type\":\"internalWalls\",\"extent\":[153.016898346,-27.470436824,153.017231758,-27.470158834]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"LineString\",\"coordinates\":[[153.016983564,-27.470292977],[153.017016052,-27.470267943],[153.017048531,-27.470301092],[153.017016067,-27.470326152],[153.016967174,-27.47027625],[153.016983564,-27.470292977]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.017016052,-27.470267943],[153.017016052,-27.470267943],[153.017048531,-27.470301092],[153.017065346,-27.470288145],[153.017032843,-27.470254971],[153.017016052,-27.470267943]]]},{\"type\":\"LineString\",\"coordinates\":[[153.017044535,-27.470297013],[153.017061349,-27.470284066]]},{\"type\":\"LineString\",\"coordinates\":[[153.017040502,-27.470292897],[153.017057316,-27.47027995]]},{\"type\":\"LineString\",\"coordinates\":[[153.017036469,-27.470288781],[153.017053283,-27.470275834]]},{\"type\":\"LineString\",\"coordinates\":[[153.017032436,-27.470284664],[153.01704925,-27.470271717]]},{\"type\":\"LineString\",\"coordinates\":[[153.017028403,-27.470280548],[153.017045217,-27.470267601]]},{\"type\":\"LineString\",\"coordinates\":[[153.01702437,-27.470276432],[153.017041184,-27.470263485]]},{\"type\":\"LineString\",\"coordinates\":[[153.017020355,-27.470272329],[153.01703717,-27.470259382]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.016983706,-27.470293123],[153.016983706,-27.470293123],[153.017016183,-27.470268076],[153.016999651,-27.470251202],[153.016967174,-27.47027625],[153.016983706,-27.470293123]]]},{\"type\":\"LineString\",\"coordinates\":[[153.017011543,-27.470271654],[153.016995011,-27.47025478]]},{\"type\":\"LineString\",\"coordinates\":[[153.017006904,-27.470275232],[153.016990372,-27.470258359]]},{\"type\":\"LineString\",\"coordinates\":[[153.017002265,-27.470278811],[153.016985732,-27.470261937]]},{\"type\":\"LineString\",\"coordinates\":[[153.016997625,-27.470282389],[153.016981093,-27.470265515]]},{\"type\":\"LineString\",\"coordinates\":[[153.016992986,-27.470285967],[153.016976453,-27.470269093]]},{\"type\":\"LineString\",\"coordinates\":[[153.016988346,-27.470289545],[153.016971814,-27.470272671]]}]},\"properties\":{\"building\":\"goma\",\"id\":\"8b822dc41326-traversal\",\"level\":\"park_level\",\"name\":\"Park Level\",\"type\":\"traversal\",\"extent\":[153.016967174,-27.470326152,153.017065346,-27.470251202]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"Polygon\",\"coordinates\":[[[153.017232101,-27.470063703],[153.017181004,-27.470103112],[153.01723892,-27.470162222],[153.017289982,-27.47012284],[153.017232101,-27.470063703]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.01744994,-27.470377386],[153.017184509,-27.470582104],[153.017213551,-27.470611764],[153.017478981,-27.470407046],[153.01744994,-27.470377386]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.017307791,-27.470141016],[153.017433027,-27.470268838],[153.01746673,-27.47024293],[153.017341446,-27.470115058],[153.017307791,-27.470141016]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.017285654,-27.470209765],[153.017256613,-27.470180103],[153.017100129,-27.470300817],[153.017129181,-27.47033047],[153.017285654,-27.470209765]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.01699047,-27.470346097],[153.016941356,-27.47029597],[153.016910833,-27.470319444],[153.016906439,-27.470314794],[153.016841193,-27.47036526],[153.01689475,-27.470419922],[153.01699047,-27.470346097]]]}]},\"properties\":{\"building\":\"goma\",\"id\":\"553be026c873-inaccessibleAreas\",\"level\":\"level_1\",\"name\":\"Level 1\",\"type\":\"inaccessibleAreas\",\"extent\":[153.016841193,-27.470611764,153.017478981,-27.470063703]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"MultiLineString\",\"coordinates\":[[[153.017138693,-27.470617377],[153.017114683,-27.470635895],[153.017341024,-27.470866911]],[[153.017524536,-27.47031979],[153.017534503,-27.470312103],[153.017561695,-27.470339856]],[[153.016983564,-27.470292978],[153.017016052,-27.470267943],[153.017048531,-27.470301092],[153.017016067,-27.470326152],[153.016967174,-27.47027625]],[[153.017011867,-27.470233562],[153.017069782,-27.470292673]],[[153.017106576,-27.470264241],[153.017096768,-27.470254222],[153.017201392,-27.470173529],[153.0172112,-27.470183548]],[[153.016994312,-27.470382792],[153.017050857,-27.470339181],[153.017079648,-27.470368586],[153.016950427,-27.47046825],[153.016921625,-27.470438852],[153.016979135,-27.470394497]],[[153.016782874,-27.470539417],[153.016890713,-27.470649483],[153.016856041,-27.470676224],[153.016748202,-27.470566158],[153.016782874,-27.470539417]],[[153.017116579,-27.470512929],[153.017381964,-27.470308221]],[[153.017070887,-27.470548171],[153.017046861,-27.470566675],[153.016950427,-27.47046825]],[[153.016962278,-27.47101884],[153.017124698,-27.470893572]],[[153.016705406,-27.470507512],[153.016675313,-27.470530722]],[[153.016735416,-27.470484366],[153.016765683,-27.470461022],[153.016730042,-27.470424645],[153.016746687,-27.470411808],[153.016795792,-27.470461927],[153.016779147,-27.470474764],[153.016798264,-27.470494276],[153.016875274,-27.470434881]],[[153.01692903,-27.470779082],[153.016976962,-27.470742114],[153.017125293,-27.470893508],[153.016962278,-27.47101884]],[[153.016863112,-27.470829923],[153.016909726,-27.470793972]],[[153.016850122,-27.470733137],[153.016803509,-27.470769088]],[[153.016639119,-27.47065029],[153.016732374,-27.470578365],[153.016869427,-27.470718248]],[[153.017689895,-27.470531011],[153.017500848,-27.47033806],[153.01751096,-27.470330261]]]},\"properties\":{\"building\":\"goma\",\"id\":\"553be026c873-internalWalls\",\"level\":\"level_1\",\"name\":\"Level 1\",\"type\":\"internalWalls\",\"extent\":[153.016639119,-27.47101884,153.017689895,-27.470173529]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"LineString\",\"coordinates\":[[153.017144243,-27.47092545],[153.017288995,-27.470813807]]},\"properties\":{\"building\":\"goma\",\"id\":\"553be026c873-other\",\"level\":\"level_1\",\"name\":\"Level 1\",\"type\":\"entrance\",\"extent\":[153.017144243,-27.47092545,153.017288995,-27.470813807]}},{\"type\":\"Feature\",\"properties\":{\"building\":\"goma\",\"id\":\"553be026c873-other_entranceLabel\",\"level\":\"level_1\",\"name\":\"Level 1\",\"type\":\"entranceLabel\",\"extent\":[153.017144243,-27.47092545,153.017288995,-27.470813807],\"visibility\":true,\"bearing\":49.000028483867766},\"geometry\":{\"type\":\"LineString\",\"coordinates\":[[153.017025373516,-27.471017130114863],[153.01740786404534,-27.470722126661293]]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"LineString\",\"coordinates\":[[153.017177065,-27.470900151],[153.017144243,-27.47092545],[153.017196272,-27.470978553],[153.017040481,-27.471098709],[153.01681414,-27.470867694],[153.016863112,-27.470829922],[153.016803508,-27.470769089],[153.016776259,-27.470790106],[153.016588058,-27.470598018],[153.016675312,-27.470530721],[153.016602106,-27.470456002],[153.0167695,-27.470326897],[153.016875195,-27.470434801],[153.01689441,-27.470419982],[153.016840931,-27.470365398],[153.016906304,-27.470314979],[153.016910748,-27.470319514],[153.01701631,-27.470238097],[153.017011867,-27.470233562],[153.017232068,-27.470063729],[153.017289982,-27.47012284],[153.017396292,-27.470040847],[153.017634349,-27.47028382],[153.017561695,-27.470339856],[153.017723551,-27.470505054],[153.01730373,-27.470828847],[153.017288995,-27.470813807],[153.017253331,-27.470841313]]},\"properties\":{\"building\":\"goma\",\"id\":\"553be026c873-level_outline\",\"level\":\"level_1\",\"name\":\"Level 1\",\"type\":\"level_outline\",\"extent\":[153.016588058,-27.471098709,153.017723551,-27.470040847]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"Polygon\",\"coordinates\":[[[153.017341443,-27.470115061],[153.017390937,-27.470165577],[153.017410652,-27.470150371],[153.017361158,-27.470099855],[153.017341443,-27.470115061]]]},{\"type\":\"LineString\",\"coordinates\":[[153.017386813,-27.470161367],[153.017406528,-27.470146161]]},{\"type\":\"LineString\",\"coordinates\":[[153.017382688,-27.470157157],[153.017402403,-27.470141952]]},{\"type\":\"LineString\",\"coordinates\":[[153.017378564,-27.470152948],[153.017398279,-27.470137742]]},{\"type\":\"LineString\",\"coordinates\":[[153.017374439,-27.470148738],[153.017394154,-27.470133532]]},{\"type\":\"LineString\",\"coordinates\":[[153.017370315,-27.470144528],[153.01739003,-27.470129323]]},{\"type\":\"LineString\",\"coordinates\":[[153.01736619,-27.470140319],[153.017385905,-27.470125113]]},{\"type\":\"LineString\",\"coordinates\":[[153.017362066,-27.470136109],[153.017381781,-27.470120903]]},{\"type\":\"LineString\",\"coordinates\":[[153.017357941,-27.470131899],[153.017377656,-27.470116694]]},{\"type\":\"LineString\",\"coordinates\":[[153.017353817,-27.470127689],[153.017373532,-27.470112484]]},{\"type\":\"LineString\",\"coordinates\":[[153.017349692,-27.47012348],[153.017369407,-27.470108274]]},{\"type\":\"LineString\",\"coordinates\":[[153.017345568,-27.47011927],[153.017365283,-27.470104064]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.016868762,-27.470569552],[153.016924182,-27.470626116],[153.016938255,-27.470615262],[153.016882835,-27.470558699],[153.016868762,-27.470569552]]]},{\"type\":\"LineString\",\"coordinates\":[[153.016919919,-27.470621765],[153.016933992,-27.470610911]]},{\"type\":\"LineString\",\"coordinates\":[[153.016915656,-27.470617414],[153.016929729,-27.47060656]]},{\"type\":\"LineString\",\"coordinates\":[[153.016911393,-27.470613063],[153.016925466,-27.470602209]]},{\"type\":\"LineString\",\"coordinates\":[[153.01690713,-27.470608712],[153.016921203,-27.470597858]]},{\"type\":\"LineString\",\"coordinates\":[[153.016902867,-27.470604361],[153.01691694,-27.470593507]]},{\"type\":\"LineString\",\"coordinates\":[[153.016898604,-27.47060001],[153.016912677,-27.470589156]]},{\"type\":\"LineString\",\"coordinates\":[[153.016894341,-27.470595659],[153.016908414,-27.470584805]]},{\"type\":\"LineString\",\"coordinates\":[[153.016890078,-27.470591308],[153.016904151,-27.470580454]]},{\"type\":\"LineString\",\"coordinates\":[[153.016885815,-27.470586957],[153.016899888,-27.470576103]]},{\"type\":\"LineString\",\"coordinates\":[[153.016881552,-27.470582606],[153.016895625,-27.470571752]]},{\"type\":\"LineString\",\"coordinates\":[[153.016877289,-27.470578255],[153.016891362,-27.470567401]]},{\"type\":\"LineString\",\"coordinates\":[[153.016873026,-27.470573903],[153.016887099,-27.47056305]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.01688557,-27.470556649],[153.016940988,-27.470613212],[153.016955061,-27.470602358],[153.016899643,-27.470545795],[153.01688557,-27.470556649]]]},{\"type\":\"LineString\",\"coordinates\":[[153.016936726,-27.470608861],[153.016950798,-27.470598007]]},{\"type\":\"LineString\",\"coordinates\":[[153.016932463,-27.47060451],[153.016946535,-27.470593656]]},{\"type\":\"LineString\",\"coordinates\":[[153.0169282,-27.470600159],[153.016942272,-27.470589305]]},{\"type\":\"LineString\",\"coordinates\":[[153.016923937,-27.470595808],[153.016938009,-27.470584954]]},{\"type\":\"LineString\",\"coordinates\":[[153.016919674,-27.470591457],[153.016933746,-27.470580603]]},{\"type\":\"LineString\",\"coordinates\":[[153.016915411,-27.470587106],[153.016929483,-27.470576252]]},{\"type\":\"LineString\",\"coordinates\":[[153.016911148,-27.470582755],[153.01692522,-27.470571901]]},{\"type\":\"LineString\",\"coordinates\":[[153.016906885,-27.470578404],[153.016920957,-27.47056755]]},{\"type\":\"LineString\",\"coordinates\":[[153.016902622,-27.470574052],[153.016916694,-27.470563199]]},{\"type\":\"LineString\",\"coordinates\":[[153.016898359,-27.470569701],[153.016912431,-27.470558848]]},{\"type\":\"LineString\",\"coordinates\":[[153.016894096,-27.47056535],[153.016908168,-27.470554497]]},{\"type\":\"LineString\",\"coordinates\":[[153.016889833,-27.470560999],[153.016903905,-27.470550146]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.016730042,-27.470424646],[153.016762306,-27.470457576],[153.016778951,-27.470444738],[153.016746688,-27.470411807],[153.016730042,-27.470424646]]]},{\"type\":\"LineString\",\"coordinates\":[[153.016758273,-27.470453459],[153.016774918,-27.470440622]]},{\"type\":\"LineString\",\"coordinates\":[[153.01675424,-27.470449343],[153.016770885,-27.470436505]]},{\"type\":\"LineString\",\"coordinates\":[[153.016750207,-27.470445227],[153.016766852,-27.470432389]]},{\"type\":\"LineString\",\"coordinates\":[[153.016746174,-27.470441111],[153.016762819,-27.470428273]]},{\"type\":\"LineString\",\"coordinates\":[[153.016742141,-27.470436994],[153.016758786,-27.470424157]]},{\"type\":\"LineString\",\"coordinates\":[[153.016738108,-27.470432878],[153.016754753,-27.47042004]]},{\"type\":\"LineString\",\"coordinates\":[[153.016734075,-27.470428762],[153.01675072,-27.470415924]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.017016052,-27.470267943],[153.017048531,-27.470301092],[153.017065346,-27.470288145],[153.017032843,-27.470254971]]]},{\"type\":\"LineString\",\"coordinates\":[[153.017044535,-27.470297013],[153.017061349,-27.470284066]]},{\"type\":\"LineString\",\"coordinates\":[[153.017040502,-27.470292897],[153.017057316,-27.47027995]]},{\"type\":\"LineString\",\"coordinates\":[[153.017036469,-27.470288781],[153.017053283,-27.470275834]]},{\"type\":\"LineString\",\"coordinates\":[[153.017032436,-27.470284664],[153.01704925,-27.470271717]]},{\"type\":\"LineString\",\"coordinates\":[[153.017028403,-27.470280548],[153.017045217,-27.470267601]]},{\"type\":\"LineString\",\"coordinates\":[[153.01702437,-27.470276432],[153.017041184,-27.470263485]]},{\"type\":\"LineString\",\"coordinates\":[[153.017020355,-27.470272329],[153.01703717,-27.470259382]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.016983706,-27.470293123],[153.017016183,-27.470268076],[153.016999651,-27.470251202],[153.016967174,-27.47027625],[153.016983706,-27.470293123]]]},{\"type\":\"LineString\",\"coordinates\":[[153.017011543,-27.470271654],[153.016995011,-27.47025478]]},{\"type\":\"LineString\",\"coordinates\":[[153.017006904,-27.470275232],[153.016990372,-27.470258359]]},{\"type\":\"LineString\",\"coordinates\":[[153.017002265,-27.470278811],[153.016985732,-27.470261937]]},{\"type\":\"LineString\",\"coordinates\":[[153.016997625,-27.470282389],[153.016981093,-27.470265515]]},{\"type\":\"LineString\",\"coordinates\":[[153.016992986,-27.470285967],[153.016976453,-27.470269093]]},{\"type\":\"LineString\",\"coordinates\":[[153.016988346,-27.470289545],[153.016971814,-27.470272671]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.017058651,-27.470750015],[153.017086777,-27.470778721],[153.017106492,-27.470763516],[153.017078367,-27.470734809]]]},{\"type\":\"LineString\",\"coordinates\":[[153.01708285,-27.470774712],[153.017102565,-27.470759507]]},{\"type\":\"LineString\",\"coordinates\":[[153.017078817,-27.470770596],[153.017098532,-27.47075539]]},{\"type\":\"LineString\",\"coordinates\":[[153.017074784,-27.47076648],[153.017094499,-27.470751274]]},{\"type\":\"LineString\",\"coordinates\":[[153.017070751,-27.470762363],[153.017090466,-27.470747158]]},{\"type\":\"LineString\",\"coordinates\":[[153.017066718,-27.470758247],[153.017086433,-27.470743041]]},{\"type\":\"LineString\",\"coordinates\":[[153.017062685,-27.470754131],[153.0170824,-27.470738925]]}]},\"properties\":{\"building\":\"goma\",\"id\":\"553be026c873-traversal\",\"level\":\"level_1\",\"name\":\"Level 1\",\"type\":\"traversal\",\"extent\":[153.016730042,-27.470778721,153.017410652,-27.470099855]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.016640827,-27.47065186],[153.016640827,-27.47065186],[153.016776259,-27.470790106],[153.016803508,-27.470769089],[153.016863112,-27.470829922],[153.01681414,-27.470867694],[153.01696247,-27.471019087],[153.017125292,-27.470893507],[153.016781919,-27.470543042],[153.016640827,-27.47065186]]]},\"properties\":{\"building\":\"goma\",\"id\":\"3412f3d0a9e2-inaccessibleAreas\",\"level\":\"level_2\",\"name\":\"Level 2\",\"type\":\"inaccessibleAreas\",\"extent\":[153.016640827,-27.471019087,153.017125292,-27.470543042]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.016721989,-27.470416426],[153.016631469,-27.47048624],[153.016675163,-27.470530837],[153.016765683,-27.470461022],[153.016721989,-27.470416426]],[[153.016875274,-27.470434881],[153.016798264,-27.470494276],[153.016779147,-27.470474764],[153.016795792,-27.470461927],[153.016746687,-27.470411808]]]},\"properties\":{\"building\":\"goma\",\"id\":\"3412f3d0a9e2-internalWalls\",\"level\":\"level_2\",\"name\":\"Level 2\",\"type\":\"internalWalls\",\"extent\":[153.016631469,-27.470530837,153.016875274,-27.470411808]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"Polygon\",\"coordinates\":[[[153.017341408,-27.470115047],[153.017341408,-27.470115047],[153.017390903,-27.470165564],[153.017410618,-27.470150358],[153.017361123,-27.470099842],[153.017341408,-27.470115047]]]},{\"type\":\"LineString\",\"coordinates\":[[153.017386778,-27.470161354],[153.017406493,-27.470146148]]},{\"type\":\"LineString\",\"coordinates\":[[153.017382653,-27.470157144],[153.017402368,-27.470141938]]},{\"type\":\"LineString\",\"coordinates\":[[153.017378529,-27.470152934],[153.017398244,-27.470137729]]},{\"type\":\"LineString\",\"coordinates\":[[153.017374404,-27.470148724],[153.017394119,-27.470133519]]},{\"type\":\"LineString\",\"coordinates\":[[153.01737028,-27.470144515],[153.017389995,-27.470129309]]},{\"type\":\"LineString\",\"coordinates\":[[153.017366155,-27.470140305],[153.01738587,-27.4701251]]},{\"type\":\"LineString\",\"coordinates\":[[153.017362031,-27.470136095],[153.017381746,-27.47012089]]},{\"type\":\"LineString\",\"coordinates\":[[153.017357906,-27.470131886],[153.017377621,-27.47011668]]},{\"type\":\"LineString\",\"coordinates\":[[153.017353782,-27.470127676],[153.017373497,-27.47011247]]},{\"type\":\"LineString\",\"coordinates\":[[153.017349657,-27.470123466],[153.017369372,-27.470108261]]},{\"type\":\"LineString\",\"coordinates\":[[153.017345533,-27.470119257],[153.017365248,-27.470104051]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.016730042,-27.470424646],[153.016730042,-27.470424646],[153.016762306,-27.470457576],[153.016778951,-27.470444738],[153.016746688,-27.470411807],[153.016730042,-27.470424646]]]},{\"type\":\"LineString\",\"coordinates\":[[153.016758273,-27.470453459],[153.016774918,-27.470440622]]},{\"type\":\"LineString\",\"coordinates\":[[153.01675424,-27.470449343],[153.016770885,-27.470436505]]},{\"type\":\"LineString\",\"coordinates\":[[153.016750207,-27.470445227],[153.016766852,-27.470432389]]},{\"type\":\"LineString\",\"coordinates\":[[153.016746174,-27.470441111],[153.016762819,-27.470428273]]},{\"type\":\"LineString\",\"coordinates\":[[153.016742141,-27.470436994],[153.016758786,-27.470424157]]},{\"type\":\"LineString\",\"coordinates\":[[153.016738108,-27.470432878],[153.016754753,-27.47042004]]},{\"type\":\"LineString\",\"coordinates\":[[153.016734075,-27.470428762],[153.01675072,-27.470415924]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.017082856,-27.470774721],[153.017082856,-27.470774721],[153.017110981,-27.470803428],[153.017130696,-27.470788222],[153.017102571,-27.470759515],[153.017082856,-27.470774721]]]},{\"type\":\"LineString\",\"coordinates\":[[153.017107053,-27.470799419],[153.017126768,-27.470784213]]},{\"type\":\"LineString\",\"coordinates\":[[153.01710302,-27.470795302],[153.017122735,-27.470780097]]},{\"type\":\"LineString\",\"coordinates\":[[153.017098987,-27.470791186],[153.017118702,-27.470775981]]},{\"type\":\"LineString\",\"coordinates\":[[153.017094954,-27.47078707],[153.017114669,-27.470771864]]},{\"type\":\"LineString\",\"coordinates\":[[153.017090921,-27.470782954],[153.017110636,-27.470767748]]},{\"type\":\"LineString\",\"coordinates\":[[153.017086888,-27.470778837],[153.017106603,-27.470763632]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.016868762,-27.470569552],[153.016868762,-27.470569552],[153.016924182,-27.470626116],[153.016938255,-27.470615262],[153.016882835,-27.470558699],[153.016868762,-27.470569552]]]},{\"type\":\"LineString\",\"coordinates\":[[153.016919919,-27.470621765],[153.016933992,-27.470610911]]},{\"type\":\"LineString\",\"coordinates\":[[153.016915656,-27.470617414],[153.016929729,-27.47060656]]},{\"type\":\"LineString\",\"coordinates\":[[153.016911393,-27.470613063],[153.016925466,-27.470602209]]},{\"type\":\"LineString\",\"coordinates\":[[153.01690713,-27.470608712],[153.016921203,-27.470597858]]},{\"type\":\"LineString\",\"coordinates\":[[153.016902867,-27.470604361],[153.01691694,-27.470593507]]},{\"type\":\"LineString\",\"coordinates\":[[153.016898604,-27.47060001],[153.016912677,-27.470589156]]},{\"type\":\"LineString\",\"coordinates\":[[153.016894341,-27.470595659],[153.016908414,-27.470584805]]},{\"type\":\"LineString\",\"coordinates\":[[153.016890078,-27.470591308],[153.016904151,-27.470580454]]},{\"type\":\"LineString\",\"coordinates\":[[153.016885815,-27.470586957],[153.016899888,-27.470576103]]},{\"type\":\"LineString\",\"coordinates\":[[153.016881552,-27.470582606],[153.016895625,-27.470571752]]},{\"type\":\"LineString\",\"coordinates\":[[153.016877289,-27.470578255],[153.016891362,-27.470567401]]},{\"type\":\"LineString\",\"coordinates\":[[153.016873026,-27.470573903],[153.016887099,-27.47056305]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.01688557,-27.470556649],[153.01688557,-27.470556649],[153.016940988,-27.470613212],[153.016955061,-27.470602358],[153.016899643,-27.470545795],[153.01688557,-27.470556649]]]},{\"type\":\"LineString\",\"coordinates\":[[153.016936726,-27.470608861],[153.016950798,-27.470598007]]},{\"type\":\"LineString\",\"coordinates\":[[153.016932463,-27.47060451],[153.016946535,-27.470593656]]},{\"type\":\"LineString\",\"coordinates\":[[153.0169282,-27.470600159],[153.016942272,-27.470589305]]},{\"type\":\"LineString\",\"coordinates\":[[153.016923937,-27.470595808],[153.016938009,-27.470584954]]},{\"type\":\"LineString\",\"coordinates\":[[153.016919674,-27.470591457],[153.016933746,-27.470580603]]},{\"type\":\"LineString\",\"coordinates\":[[153.016915411,-27.470587106],[153.016929483,-27.470576252]]},{\"type\":\"LineString\",\"coordinates\":[[153.016911148,-27.470582755],[153.01692522,-27.470571901]]},{\"type\":\"LineString\",\"coordinates\":[[153.016906885,-27.470578404],[153.016920957,-27.47056755]]},{\"type\":\"LineString\",\"coordinates\":[[153.016902622,-27.470574052],[153.016916694,-27.470563199]]},{\"type\":\"LineString\",\"coordinates\":[[153.016898359,-27.470569701],[153.016912431,-27.470558848]]},{\"type\":\"LineString\",\"coordinates\":[[153.016894096,-27.47056535],[153.016908168,-27.470554497]]},{\"type\":\"LineString\",\"coordinates\":[[153.016889833,-27.470560999],[153.016903905,-27.470550146]]}]},\"properties\":{\"building\":\"goma\",\"id\":\"3412f3d0a9e2-traversal\",\"level\":\"level_2\",\"name\":\"Level 2\",\"type\":\"traversal\",\"extent\":[153.016730042,-27.470803428,153.017410618,-27.470099842]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"Polygon\",\"coordinates\":[[[153.017110392,-27.470878299],[153.017110392,-27.470878299],[153.017076942,-27.470844159],[153.017029262,-27.47088068],[153.017062712,-27.470914822],[153.017110392,-27.470878299]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.017013464,-27.470234005],[153.017018799,-27.470239449],[153.016910709,-27.470319474],[153.016906304,-27.470314979],[153.01684107,-27.470365291],[153.016894627,-27.470419955],[153.016940509,-27.470384568],[153.016962675,-27.470407192],[153.016885962,-27.470466358],[153.017011213,-27.470594196],[153.017047427,-27.470566264],[153.016951852,-27.470468716],[153.017287149,-27.470210114],[153.017229549,-27.470151324],[153.017160428,-27.470204635],[153.017113312,-27.470156545],[153.017013464,-27.470234005],[153.017013464,-27.470234005]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.0167695,-27.470326897],[153.0167695,-27.470326897],[153.016601956,-27.470456117],[153.016675312,-27.470530721],[153.016765683,-27.470461023],[153.016798264,-27.470494276],[153.016875287,-27.470434871],[153.0167695,-27.470326897]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.017473945,-27.470392478],[153.017473945,-27.470392478],[153.017455149,-27.470373306],[153.017165278,-27.470596873],[153.017184067,-27.47061605],[153.017473945,-27.470392478]]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.017432926,-27.470268735],[153.017466629,-27.470242826],[153.017323636,-27.47009688],[153.01728998,-27.470122837],[153.017432926,-27.470268735],[153.017432926,-27.470268735]]]}]},\"properties\":{\"building\":\"goma\",\"id\":\"debafc1d0f2e-inaccessibleAreas\",\"level\":\"level_3\",\"name\":\"Level 3\",\"type\":\"inaccessibleAreas\",\"extent\":[153.016601956,-27.470914822,153.017473945,-27.47009688]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"LineString\",\"coordinates\":[[153.01681414,-27.470867694],[153.016976962,-27.470742114],[153.017054112,-27.470820858],[153.017006573,-27.470857523],[153.016963624,-27.470813687],[153.016848341,-27.470902601]]},{\"type\":\"LineString\",\"coordinates\":[[153.017097573,-27.47052777],[153.017387053,-27.470304504]]},{\"type\":\"LineString\",\"coordinates\":[[153.01677858,-27.47053458],[153.016812283,-27.470508586],[153.016798264,-27.470494276]]},{\"type\":\"LineString\",\"coordinates\":[[153.016869819,-27.470717945],[153.016846435,-27.470694078],[153.016896796,-27.470655237],[153.016778575,-27.470534574]]},{\"type\":\"LineString\",\"coordinates\":[[153.016948744,-27.471002553],[153.017040308,-27.470931933]]},{\"type\":\"LineString\",\"coordinates\":[[153.017389322,-27.470566039],[153.017474877,-27.47065336]]},{\"type\":\"LineString\",\"coordinates\":[[153.017723551,-27.470505054],[153.017534503,-27.470312102],[153.017524536,-27.470319789]]},{\"type\":\"LineString\",\"coordinates\":[[153.017510961,-27.470330261],[153.017500848,-27.47033806],[153.017689895,-27.470531011]]},{\"type\":\"LineString\",\"coordinates\":[[153.017114681,-27.470635896],[153.01730373,-27.470828847],[153.017723551,-27.470505054]]}]},\"properties\":{\"building\":\"goma\",\"id\":\"debafc1d0f2e-internalWalls\",\"level\":\"level_3\",\"name\":\"Level 3\",\"type\":\"internalWalls\",\"extent\":[153.016778575,-27.471002553,153.017723551,-27.470304504]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"Polygon\",\"coordinates\":[[[153.017341443,-27.470115061],[153.017341443,-27.470115061],[153.017390937,-27.470165577],[153.017410652,-27.470150371],[153.017361158,-27.470099855],[153.017341443,-27.470115061]]]},{\"type\":\"LineString\",\"coordinates\":[[153.017386813,-27.470161367],[153.017406528,-27.470146161]]},{\"type\":\"LineString\",\"coordinates\":[[153.017382688,-27.470157157],[153.017402403,-27.470141952]]},{\"type\":\"LineString\",\"coordinates\":[[153.017378564,-27.470152948],[153.017398279,-27.470137742]]},{\"type\":\"LineString\",\"coordinates\":[[153.017374439,-27.470148738],[153.017394154,-27.470133532]]},{\"type\":\"LineString\",\"coordinates\":[[153.017370315,-27.470144528],[153.01739003,-27.470129323]]},{\"type\":\"LineString\",\"coordinates\":[[153.01736619,-27.470140319],[153.017385905,-27.470125113]]},{\"type\":\"LineString\",\"coordinates\":[[153.017362066,-27.470136109],[153.017381781,-27.470120903]]},{\"type\":\"LineString\",\"coordinates\":[[153.017357941,-27.470131899],[153.017377656,-27.470116694]]},{\"type\":\"LineString\",\"coordinates\":[[153.017353817,-27.470127689],[153.017373532,-27.470112484]]},{\"type\":\"LineString\",\"coordinates\":[[153.017349692,-27.47012348],[153.017369407,-27.470108274]]},{\"type\":\"LineString\",\"coordinates\":[[153.017345568,-27.47011927],[153.017365283,-27.470104064]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.016900586,-27.470545007],[153.016900586,-27.470545007],[153.016956006,-27.470601572],[153.016970079,-27.470590718],[153.016914659,-27.470534153],[153.016900586,-27.470545007]]]},{\"type\":\"LineString\",\"coordinates\":[[153.016951743,-27.47059722],[153.016965816,-27.470586366]]},{\"type\":\"LineString\",\"coordinates\":[[153.01694748,-27.470592869],[153.016961553,-27.470582015]]},{\"type\":\"LineString\",\"coordinates\":[[153.016943217,-27.470588518],[153.01695729,-27.470577664]]},{\"type\":\"LineString\",\"coordinates\":[[153.016938954,-27.470584167],[153.016953027,-27.470573313]]},{\"type\":\"LineString\",\"coordinates\":[[153.016934691,-27.470579816],[153.016948764,-27.470568962]]},{\"type\":\"LineString\",\"coordinates\":[[153.016930428,-27.470575465],[153.016944501,-27.470564611]]},{\"type\":\"LineString\",\"coordinates\":[[153.016926165,-27.470571114],[153.016940238,-27.47056026]]},{\"type\":\"LineString\",\"coordinates\":[[153.016921902,-27.470566763],[153.016935975,-27.470555909]]},{\"type\":\"LineString\",\"coordinates\":[[153.016917639,-27.470562412],[153.016931712,-27.470551558]]},{\"type\":\"LineString\",\"coordinates\":[[153.016913376,-27.470558061],[153.016927449,-27.470547207]]},{\"type\":\"LineString\",\"coordinates\":[[153.016909113,-27.47055371],[153.016923186,-27.470542856]]},{\"type\":\"LineString\",\"coordinates\":[[153.01690485,-27.470549359],[153.016918923,-27.470538505]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.016917386,-27.470532095],[153.016917386,-27.470532095],[153.016972806,-27.470588659],[153.016986878,-27.470577805],[153.016931459,-27.470521242],[153.016917386,-27.470532095]]]},{\"type\":\"LineString\",\"coordinates\":[[153.016968542,-27.470584308],[153.016982615,-27.470573454]]},{\"type\":\"LineString\",\"coordinates\":[[153.016964279,-27.470579957],[153.016978352,-27.470569103]]},{\"type\":\"LineString\",\"coordinates\":[[153.016960016,-27.470575606],[153.016974089,-27.470564752]]},{\"type\":\"LineString\",\"coordinates\":[[153.016955753,-27.470571255],[153.016969826,-27.470560401]]},{\"type\":\"LineString\",\"coordinates\":[[153.01695149,-27.470566904],[153.016965563,-27.47055605]]},{\"type\":\"LineString\",\"coordinates\":[[153.016947227,-27.470562553],[153.0169613,-27.470551699]]},{\"type\":\"LineString\",\"coordinates\":[[153.016942964,-27.470558202],[153.016957037,-27.470547348]]},{\"type\":\"LineString\",\"coordinates\":[[153.016938701,-27.470553851],[153.016952774,-27.470542997]]},{\"type\":\"LineString\",\"coordinates\":[[153.016934438,-27.4705495],[153.016948511,-27.470538646]]},{\"type\":\"LineString\",\"coordinates\":[[153.016930175,-27.470545149],[153.016944248,-27.470534295]]},{\"type\":\"LineString\",\"coordinates\":[[153.016925912,-27.470540798],[153.016939985,-27.470529944]]},{\"type\":\"LineString\",\"coordinates\":[[153.016921649,-27.470536447],[153.016935722,-27.470525593]]},{\"type\":\"Polygon\",\"coordinates\":[[[153.017082856,-27.470774721],[153.017082856,-27.470774721],[153.017110981,-27.470803428],[153.017130696,-27.470788222],[153.017102571,-27.470759515],[153.017082856,-27.470774721]]]},{\"type\":\"LineString\",\"coordinates\":[[153.017107053,-27.470799419],[153.017126768,-27.470784213]]},{\"type\":\"LineString\",\"coordinates\":[[153.01710302,-27.470795302],[153.017122735,-27.470780097]]},{\"type\":\"LineString\",\"coordinates\":[[153.017098987,-27.470791186],[153.017118702,-27.470775981]]},{\"type\":\"LineString\",\"coordinates\":[[153.017094954,-27.47078707],[153.017114669,-27.470771864]]},{\"type\":\"LineString\",\"coordinates\":[[153.017090921,-27.470782954],[153.017110636,-27.470767748]]},{\"type\":\"LineString\",\"coordinates\":[[153.017086888,-27.470778837],[153.017106603,-27.470763632]]}]},\"properties\":{\"building\":\"goma\",\"id\":\"debafc1d0f2e-traversal\",\"level\":\"level_3\",\"name\":\"Level 3\",\"type\":\"traversal\",\"extent\":[153.016900586,-27.470803428,153.017410652,-27.470099855]}},{\"type\":\"Feature\",\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[153.016863796,-27.470443733],[153.01676174,-27.470522446],[153.017125292,-27.470893507],[153.017155506,-27.470870204],[153.016864309,-27.470572993],[153.016936152,-27.470517583]]]},\"properties\":{\"building\":\"goma\",\"id\":\"46358ff9-f4b5-42a4-9593-27478c26c221-other\",\"level\":\"level_2\",\"name\":\"Gallery 2.1\",\"type\":\"other\",\"extent\":[153.01676174,-27.470893507,153.017155506,-27.470443733]}}]}");
},{}]},["eTHmp","llR9X"], "llR9X", "parcelRequire94c2")

//# sourceMappingURL=scripts.5c699123.js.map
